(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire130b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire130b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gKWsR", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c32e4b0ba829ddb2$export$ae55be85d98224ed; }, function (v) { return $c32e4b0ba829ddb2$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $c32e4b0ba829ddb2$export$d39a5bbd09211389; }, function (v) { return $c32e4b0ba829ddb2$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $c32e4b0ba829ddb2$export$882461b6382ed46c; }, function (v) { return $c32e4b0ba829ddb2$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $c32e4b0ba829ddb2$export$466bfc07425424d5; }, function (v) { return $c32e4b0ba829ddb2$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $c32e4b0ba829ddb2$export$cd75ccfd720a3cd4; }, function (v) { return $c32e4b0ba829ddb2$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $c32e4b0ba829ddb2$export$fa8d919ba61d84db; }, function (v) { return $c32e4b0ba829ddb2$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $c32e4b0ba829ddb2$export$757ceba2d55c277e; }, function (v) { return $c32e4b0ba829ddb2$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $c32e4b0ba829ddb2$export$b3890eb0ae9dca99; }, function (v) { return $c32e4b0ba829ddb2$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $c32e4b0ba829ddb2$export$502457920280e6be; }, function (v) { return $c32e4b0ba829ddb2$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $c32e4b0ba829ddb2$export$c78a37762a8d58e1; }, function (v) { return $c32e4b0ba829ddb2$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $c32e4b0ba829ddb2$export$dc54d992c10e8a18; }, function (v) { return $c32e4b0ba829ddb2$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $c32e4b0ba829ddb2$export$83d89fbfd8236492; }, function (v) { return $c32e4b0ba829ddb2$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $2bfPH = parcelRequire("2bfPH");
var $c32e4b0ba829ddb2$export$ae55be85d98224ed;
var $c32e4b0ba829ddb2$export$d39a5bbd09211389;
var $c32e4b0ba829ddb2$export$882461b6382ed46c;
var $c32e4b0ba829ddb2$export$466bfc07425424d5;
var $c32e4b0ba829ddb2$export$cd75ccfd720a3cd4;
var $c32e4b0ba829ddb2$export$fa8d919ba61d84db;
var $c32e4b0ba829ddb2$export$757ceba2d55c277e;
var $c32e4b0ba829ddb2$export$b3890eb0ae9dca99;
var $c32e4b0ba829ddb2$export$502457920280e6be;
var $c32e4b0ba829ddb2$export$c78a37762a8d58e1;
var $c32e4b0ba829ddb2$export$dc54d992c10e8a18;
var $c32e4b0ba829ddb2$export$83d89fbfd8236492;
'use strict';

var $eHaBZ = parcelRequire("eHaBZ");

var $5t8wa = parcelRequire("5t8wa");
function $c32e4b0ba829ddb2$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $c32e4b0ba829ddb2$var$da = new Set, $c32e4b0ba829ddb2$var$ea = {};
function $c32e4b0ba829ddb2$var$fa(a, b) {
    $c32e4b0ba829ddb2$var$ha(a, b);
    $c32e4b0ba829ddb2$var$ha(a + "Capture", b);
}
function $c32e4b0ba829ddb2$var$ha(a, b) {
    $c32e4b0ba829ddb2$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$c32e4b0ba829ddb2$var$da.add(b[a]);
}
var $c32e4b0ba829ddb2$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c32e4b0ba829ddb2$var$ja = Object.prototype.hasOwnProperty, $c32e4b0ba829ddb2$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $c32e4b0ba829ddb2$var$la = {}, $c32e4b0ba829ddb2$var$ma = {};
function $c32e4b0ba829ddb2$var$oa(a) {
    if ($c32e4b0ba829ddb2$var$ja.call($c32e4b0ba829ddb2$var$ma, a)) return !0;
    if ($c32e4b0ba829ddb2$var$ja.call($c32e4b0ba829ddb2$var$la, a)) return !1;
    if ($c32e4b0ba829ddb2$var$ka.test(a)) return $c32e4b0ba829ddb2$var$ma[a] = !0;
    $c32e4b0ba829ddb2$var$la[a] = !0;
    return !1;
}
function $c32e4b0ba829ddb2$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $2bfPH._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $c32e4b0ba829ddb2$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $c32e4b0ba829ddb2$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $c32e4b0ba829ddb2$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $c32e4b0ba829ddb2$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $c32e4b0ba829ddb2$var$z[a] = new $c32e4b0ba829ddb2$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $c32e4b0ba829ddb2$var$z[b] = new $c32e4b0ba829ddb2$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $c32e4b0ba829ddb2$var$z[a] = new $c32e4b0ba829ddb2$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $c32e4b0ba829ddb2$var$z[a] = new $c32e4b0ba829ddb2$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $c32e4b0ba829ddb2$var$z[a] = new $c32e4b0ba829ddb2$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $c32e4b0ba829ddb2$var$z[a] = new $c32e4b0ba829ddb2$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $c32e4b0ba829ddb2$var$z[a] = new $c32e4b0ba829ddb2$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $c32e4b0ba829ddb2$var$z[a] = new $c32e4b0ba829ddb2$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $c32e4b0ba829ddb2$var$z[a] = new $c32e4b0ba829ddb2$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $c32e4b0ba829ddb2$var$ra = /[\-:]([a-z])/g;
function $c32e4b0ba829ddb2$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($c32e4b0ba829ddb2$var$ra, $c32e4b0ba829ddb2$var$sa);
    $c32e4b0ba829ddb2$var$z[b] = new $c32e4b0ba829ddb2$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($c32e4b0ba829ddb2$var$ra, $c32e4b0ba829ddb2$var$sa);
    $c32e4b0ba829ddb2$var$z[b] = new $c32e4b0ba829ddb2$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($c32e4b0ba829ddb2$var$ra, $c32e4b0ba829ddb2$var$sa);
    $c32e4b0ba829ddb2$var$z[b] = new $c32e4b0ba829ddb2$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $c32e4b0ba829ddb2$var$z[a] = new $c32e4b0ba829ddb2$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$c32e4b0ba829ddb2$var$z.xlinkHref = new $c32e4b0ba829ddb2$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $c32e4b0ba829ddb2$var$z[a] = new $c32e4b0ba829ddb2$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $c32e4b0ba829ddb2$var$ta(a, b, c, d) {
    var e = $c32e4b0ba829ddb2$var$z.hasOwnProperty(b) ? $c32e4b0ba829ddb2$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $c32e4b0ba829ddb2$var$qa(b, c, e, d) && (c = null), d || null === e ? $c32e4b0ba829ddb2$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $c32e4b0ba829ddb2$var$ua = $eHaBZ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $c32e4b0ba829ddb2$var$va = Symbol.for("react.element"), $c32e4b0ba829ddb2$var$wa = Symbol.for("react.portal"), $c32e4b0ba829ddb2$var$ya = Symbol.for("react.fragment"), $c32e4b0ba829ddb2$var$za = Symbol.for("react.strict_mode"), $c32e4b0ba829ddb2$var$Aa = Symbol.for("react.profiler"), $c32e4b0ba829ddb2$var$Ba = Symbol.for("react.provider"), $c32e4b0ba829ddb2$var$Ca = Symbol.for("react.context"), $c32e4b0ba829ddb2$var$Da = Symbol.for("react.forward_ref"), $c32e4b0ba829ddb2$var$Ea = Symbol.for("react.suspense"), $c32e4b0ba829ddb2$var$Fa = Symbol.for("react.suspense_list"), $c32e4b0ba829ddb2$var$Ga = Symbol.for("react.memo"), $c32e4b0ba829ddb2$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $c32e4b0ba829ddb2$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $c32e4b0ba829ddb2$var$Ja = Symbol.iterator;
function $c32e4b0ba829ddb2$var$Ka(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, $2bfPH._)(a))) return null;
    a = $c32e4b0ba829ddb2$var$Ja && a[$c32e4b0ba829ddb2$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c32e4b0ba829ddb2$var$A = Object.assign, $c32e4b0ba829ddb2$var$La;
function $c32e4b0ba829ddb2$var$Ma(a) {
    if (void 0 === $c32e4b0ba829ddb2$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $c32e4b0ba829ddb2$var$La = b && b[1] || "";
    }
    return "\n" + $c32e4b0ba829ddb2$var$La + a;
}
var $c32e4b0ba829ddb2$var$Na = !1;
function $c32e4b0ba829ddb2$var$Oa(a, b) {
    if (!a || $c32e4b0ba829ddb2$var$Na) return "";
    $c32e4b0ba829ddb2$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === (typeof Reflect === "undefined" ? "undefined" : (0, $2bfPH._)(Reflect)) && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $c32e4b0ba829ddb2$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $c32e4b0ba829ddb2$var$Ma(a) : "";
}
function $c32e4b0ba829ddb2$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $c32e4b0ba829ddb2$var$Ma(a.type);
        case 16:
            return $c32e4b0ba829ddb2$var$Ma("Lazy");
        case 13:
            return $c32e4b0ba829ddb2$var$Ma("Suspense");
        case 19:
            return $c32e4b0ba829ddb2$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $c32e4b0ba829ddb2$var$Oa(a.type, !1), a;
        case 11:
            return a = $c32e4b0ba829ddb2$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $c32e4b0ba829ddb2$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $c32e4b0ba829ddb2$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $c32e4b0ba829ddb2$var$ya:
            return "Fragment";
        case $c32e4b0ba829ddb2$var$wa:
            return "Portal";
        case $c32e4b0ba829ddb2$var$Aa:
            return "Profiler";
        case $c32e4b0ba829ddb2$var$za:
            return "StrictMode";
        case $c32e4b0ba829ddb2$var$Ea:
            return "Suspense";
        case $c32e4b0ba829ddb2$var$Fa:
            return "SuspenseList";
    }
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, $2bfPH._)(a))) switch(a.$$typeof){
        case $c32e4b0ba829ddb2$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $c32e4b0ba829ddb2$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $c32e4b0ba829ddb2$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $c32e4b0ba829ddb2$var$Ga:
            return b = a.displayName || null, null !== b ? b : $c32e4b0ba829ddb2$var$Qa(a.type) || "Memo";
        case $c32e4b0ba829ddb2$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $c32e4b0ba829ddb2$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $c32e4b0ba829ddb2$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $c32e4b0ba829ddb2$var$Qa(b);
        case 8:
            return b === $c32e4b0ba829ddb2$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $c32e4b0ba829ddb2$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $2bfPH._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $c32e4b0ba829ddb2$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $c32e4b0ba829ddb2$var$Ua(a) {
    var b = $c32e4b0ba829ddb2$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $c32e4b0ba829ddb2$var$Va(a) {
    a._valueTracker || (a._valueTracker = $c32e4b0ba829ddb2$var$Ua(a));
}
function $c32e4b0ba829ddb2$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $c32e4b0ba829ddb2$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $c32e4b0ba829ddb2$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $c32e4b0ba829ddb2$var$Ya(a, b) {
    var c = b.checked;
    return $c32e4b0ba829ddb2$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $c32e4b0ba829ddb2$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $c32e4b0ba829ddb2$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $c32e4b0ba829ddb2$var$ab(a, b) {
    b = b.checked;
    null != b && $c32e4b0ba829ddb2$var$ta(a, "checked", b, !1);
}
function $c32e4b0ba829ddb2$var$bb(a, b) {
    $c32e4b0ba829ddb2$var$ab(a, b);
    var c = $c32e4b0ba829ddb2$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $c32e4b0ba829ddb2$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $c32e4b0ba829ddb2$var$cb(a, b.type, $c32e4b0ba829ddb2$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $c32e4b0ba829ddb2$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $c32e4b0ba829ddb2$var$cb(a, b, c) {
    if ("number" !== b || $c32e4b0ba829ddb2$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $c32e4b0ba829ddb2$var$eb = Array.isArray;
function $c32e4b0ba829ddb2$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $c32e4b0ba829ddb2$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $c32e4b0ba829ddb2$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($c32e4b0ba829ddb2$var$p(91));
    return $c32e4b0ba829ddb2$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $c32e4b0ba829ddb2$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($c32e4b0ba829ddb2$var$p(92));
            if ($c32e4b0ba829ddb2$var$eb(c)) {
                if (1 < c.length) throw Error($c32e4b0ba829ddb2$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $c32e4b0ba829ddb2$var$Sa(c)
    };
}
function $c32e4b0ba829ddb2$var$ib(a, b) {
    var c = $c32e4b0ba829ddb2$var$Sa(b.value), d = $c32e4b0ba829ddb2$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $c32e4b0ba829ddb2$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $c32e4b0ba829ddb2$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $c32e4b0ba829ddb2$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $c32e4b0ba829ddb2$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $c32e4b0ba829ddb2$var$mb, $c32e4b0ba829ddb2$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $c32e4b0ba829ddb2$var$mb = $c32e4b0ba829ddb2$var$mb || document.createElement("div");
        $c32e4b0ba829ddb2$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $c32e4b0ba829ddb2$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $c32e4b0ba829ddb2$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $c32e4b0ba829ddb2$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $c32e4b0ba829ddb2$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($c32e4b0ba829ddb2$var$pb).forEach(function(a) {
    $c32e4b0ba829ddb2$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $c32e4b0ba829ddb2$var$pb[b] = $c32e4b0ba829ddb2$var$pb[a];
    });
});
function $c32e4b0ba829ddb2$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $c32e4b0ba829ddb2$var$pb.hasOwnProperty(a) && $c32e4b0ba829ddb2$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $c32e4b0ba829ddb2$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $c32e4b0ba829ddb2$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $c32e4b0ba829ddb2$var$tb = $c32e4b0ba829ddb2$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $c32e4b0ba829ddb2$var$ub(a, b) {
    if (b) {
        if ($c32e4b0ba829ddb2$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($c32e4b0ba829ddb2$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($c32e4b0ba829ddb2$var$p(60));
            if ("object" !== (0, $2bfPH._)(b.dangerouslySetInnerHTML) || !("__html" in b.dangerouslySetInnerHTML)) throw Error($c32e4b0ba829ddb2$var$p(61));
        }
        if (null != b.style && "object" !== (0, $2bfPH._)(b.style)) throw Error($c32e4b0ba829ddb2$var$p(62));
    }
}
function $c32e4b0ba829ddb2$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c32e4b0ba829ddb2$var$wb = null;
function $c32e4b0ba829ddb2$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $c32e4b0ba829ddb2$var$yb = null, $c32e4b0ba829ddb2$var$zb = null, $c32e4b0ba829ddb2$var$Ab = null;
function $c32e4b0ba829ddb2$var$Bb(a) {
    if (a = $c32e4b0ba829ddb2$var$Cb(a)) {
        if ("function" !== typeof $c32e4b0ba829ddb2$var$yb) throw Error($c32e4b0ba829ddb2$var$p(280));
        var b = a.stateNode;
        b && (b = $c32e4b0ba829ddb2$var$Db(b), $c32e4b0ba829ddb2$var$yb(a.stateNode, a.type, b));
    }
}
function $c32e4b0ba829ddb2$var$Eb(a) {
    $c32e4b0ba829ddb2$var$zb ? $c32e4b0ba829ddb2$var$Ab ? $c32e4b0ba829ddb2$var$Ab.push(a) : $c32e4b0ba829ddb2$var$Ab = [
        a
    ] : $c32e4b0ba829ddb2$var$zb = a;
}
function $c32e4b0ba829ddb2$var$Fb() {
    if ($c32e4b0ba829ddb2$var$zb) {
        var a = $c32e4b0ba829ddb2$var$zb, b = $c32e4b0ba829ddb2$var$Ab;
        $c32e4b0ba829ddb2$var$Ab = $c32e4b0ba829ddb2$var$zb = null;
        $c32e4b0ba829ddb2$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$c32e4b0ba829ddb2$var$Bb(b[a]);
    }
}
function $c32e4b0ba829ddb2$var$Gb(a, b) {
    return a(b);
}
function $c32e4b0ba829ddb2$var$Hb() {}
var $c32e4b0ba829ddb2$var$Ib = !1;
function $c32e4b0ba829ddb2$var$Jb(a, b, c) {
    if ($c32e4b0ba829ddb2$var$Ib) return a(b, c);
    $c32e4b0ba829ddb2$var$Ib = !0;
    try {
        return $c32e4b0ba829ddb2$var$Gb(a, b, c);
    } finally{
        if ($c32e4b0ba829ddb2$var$Ib = !1, null !== $c32e4b0ba829ddb2$var$zb || null !== $c32e4b0ba829ddb2$var$Ab) $c32e4b0ba829ddb2$var$Hb(), $c32e4b0ba829ddb2$var$Fb();
    }
}
function $c32e4b0ba829ddb2$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $c32e4b0ba829ddb2$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($c32e4b0ba829ddb2$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $2bfPH._)(c)));
    return c;
}
var $c32e4b0ba829ddb2$var$Lb = !1;
if ($c32e4b0ba829ddb2$var$ia) try {
    var $c32e4b0ba829ddb2$var$Mb = {};
    Object.defineProperty($c32e4b0ba829ddb2$var$Mb, "passive", {
        get: function get() {
            $c32e4b0ba829ddb2$var$Lb = !0;
        }
    });
    window.addEventListener("test", $c32e4b0ba829ddb2$var$Mb, $c32e4b0ba829ddb2$var$Mb);
    window.removeEventListener("test", $c32e4b0ba829ddb2$var$Mb, $c32e4b0ba829ddb2$var$Mb);
} catch (a) {
    $c32e4b0ba829ddb2$var$Lb = !1;
}
function $c32e4b0ba829ddb2$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $c32e4b0ba829ddb2$var$Ob = !1, $c32e4b0ba829ddb2$var$Pb = null, $c32e4b0ba829ddb2$var$Qb = !1, $c32e4b0ba829ddb2$var$Rb = null, $c32e4b0ba829ddb2$var$Sb = {
    onError: function onError(a) {
        $c32e4b0ba829ddb2$var$Ob = !0;
        $c32e4b0ba829ddb2$var$Pb = a;
    }
};
function $c32e4b0ba829ddb2$var$Tb(a, b, c, d, e, f, g, h, k) {
    $c32e4b0ba829ddb2$var$Ob = !1;
    $c32e4b0ba829ddb2$var$Pb = null;
    $c32e4b0ba829ddb2$var$Nb.apply($c32e4b0ba829ddb2$var$Sb, arguments);
}
function $c32e4b0ba829ddb2$var$Ub(a, b, c, d, e, f, g, h, k) {
    $c32e4b0ba829ddb2$var$Tb.apply(this, arguments);
    if ($c32e4b0ba829ddb2$var$Ob) {
        if ($c32e4b0ba829ddb2$var$Ob) {
            var l = $c32e4b0ba829ddb2$var$Pb;
            $c32e4b0ba829ddb2$var$Ob = !1;
            $c32e4b0ba829ddb2$var$Pb = null;
        } else throw Error($c32e4b0ba829ddb2$var$p(198));
        $c32e4b0ba829ddb2$var$Qb || ($c32e4b0ba829ddb2$var$Qb = !0, $c32e4b0ba829ddb2$var$Rb = l);
    }
}
function $c32e4b0ba829ddb2$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $c32e4b0ba829ddb2$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $c32e4b0ba829ddb2$var$Xb(a) {
    if ($c32e4b0ba829ddb2$var$Vb(a) !== a) throw Error($c32e4b0ba829ddb2$var$p(188));
}
function $c32e4b0ba829ddb2$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $c32e4b0ba829ddb2$var$Vb(a);
        if (null === b) throw Error($c32e4b0ba829ddb2$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $c32e4b0ba829ddb2$var$Xb(e), a;
                if (f === d) return $c32e4b0ba829ddb2$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($c32e4b0ba829ddb2$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($c32e4b0ba829ddb2$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($c32e4b0ba829ddb2$var$p(190));
    }
    if (3 !== c.tag) throw Error($c32e4b0ba829ddb2$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $c32e4b0ba829ddb2$var$Zb(a) {
    a = $c32e4b0ba829ddb2$var$Yb(a);
    return null !== a ? $c32e4b0ba829ddb2$var$$b(a) : null;
}
function $c32e4b0ba829ddb2$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $c32e4b0ba829ddb2$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $c32e4b0ba829ddb2$var$ac = $5t8wa.unstable_scheduleCallback, $c32e4b0ba829ddb2$var$bc = $5t8wa.unstable_cancelCallback, $c32e4b0ba829ddb2$var$cc = $5t8wa.unstable_shouldYield, $c32e4b0ba829ddb2$var$dc = $5t8wa.unstable_requestPaint, $c32e4b0ba829ddb2$var$B = $5t8wa.unstable_now, $c32e4b0ba829ddb2$var$ec = $5t8wa.unstable_getCurrentPriorityLevel, $c32e4b0ba829ddb2$var$fc = $5t8wa.unstable_ImmediatePriority, $c32e4b0ba829ddb2$var$gc = $5t8wa.unstable_UserBlockingPriority, $c32e4b0ba829ddb2$var$hc = $5t8wa.unstable_NormalPriority, $c32e4b0ba829ddb2$var$ic = $5t8wa.unstable_LowPriority, $c32e4b0ba829ddb2$var$jc = $5t8wa.unstable_IdlePriority, $c32e4b0ba829ddb2$var$kc = null, $c32e4b0ba829ddb2$var$lc = null;
function $c32e4b0ba829ddb2$var$mc(a) {
    if ($c32e4b0ba829ddb2$var$lc && "function" === typeof $c32e4b0ba829ddb2$var$lc.onCommitFiberRoot) try {
        $c32e4b0ba829ddb2$var$lc.onCommitFiberRoot($c32e4b0ba829ddb2$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $c32e4b0ba829ddb2$var$oc = Math.clz32 ? Math.clz32 : $c32e4b0ba829ddb2$var$nc, $c32e4b0ba829ddb2$var$pc = Math.log, $c32e4b0ba829ddb2$var$qc = Math.LN2;
function $c32e4b0ba829ddb2$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($c32e4b0ba829ddb2$var$pc(a) / $c32e4b0ba829ddb2$var$qc | 0) | 0;
}
var $c32e4b0ba829ddb2$var$rc = 64, $c32e4b0ba829ddb2$var$sc = 4194304;
function $c32e4b0ba829ddb2$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $c32e4b0ba829ddb2$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $c32e4b0ba829ddb2$var$tc(h) : (f &= g, 0 !== f && (d = $c32e4b0ba829ddb2$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $c32e4b0ba829ddb2$var$tc(g) : 0 !== f && (d = $c32e4b0ba829ddb2$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $c32e4b0ba829ddb2$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $c32e4b0ba829ddb2$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c32e4b0ba829ddb2$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $c32e4b0ba829ddb2$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $c32e4b0ba829ddb2$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $c32e4b0ba829ddb2$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $c32e4b0ba829ddb2$var$yc() {
    var a = $c32e4b0ba829ddb2$var$rc;
    $c32e4b0ba829ddb2$var$rc <<= 1;
    0 === ($c32e4b0ba829ddb2$var$rc & 4194240) && ($c32e4b0ba829ddb2$var$rc = 64);
    return a;
}
function $c32e4b0ba829ddb2$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c32e4b0ba829ddb2$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $c32e4b0ba829ddb2$var$oc(b);
    a[b] = c;
}
function $c32e4b0ba829ddb2$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $c32e4b0ba829ddb2$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $c32e4b0ba829ddb2$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $c32e4b0ba829ddb2$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $c32e4b0ba829ddb2$var$C = 0;
function $c32e4b0ba829ddb2$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $c32e4b0ba829ddb2$var$Ec, $c32e4b0ba829ddb2$var$Fc, $c32e4b0ba829ddb2$var$Gc, $c32e4b0ba829ddb2$var$Hc, $c32e4b0ba829ddb2$var$Ic, $c32e4b0ba829ddb2$var$Jc = !1, $c32e4b0ba829ddb2$var$Kc = [], $c32e4b0ba829ddb2$var$Lc = null, $c32e4b0ba829ddb2$var$Mc = null, $c32e4b0ba829ddb2$var$Nc = null, $c32e4b0ba829ddb2$var$Oc = new Map, $c32e4b0ba829ddb2$var$Pc = new Map, $c32e4b0ba829ddb2$var$Qc = [], $c32e4b0ba829ddb2$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $c32e4b0ba829ddb2$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $c32e4b0ba829ddb2$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $c32e4b0ba829ddb2$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $c32e4b0ba829ddb2$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $c32e4b0ba829ddb2$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c32e4b0ba829ddb2$var$Pc.delete(b.pointerId);
    }
}
function $c32e4b0ba829ddb2$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $c32e4b0ba829ddb2$var$Cb(b), null !== b && $c32e4b0ba829ddb2$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $c32e4b0ba829ddb2$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $c32e4b0ba829ddb2$var$Lc = $c32e4b0ba829ddb2$var$Tc($c32e4b0ba829ddb2$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $c32e4b0ba829ddb2$var$Mc = $c32e4b0ba829ddb2$var$Tc($c32e4b0ba829ddb2$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $c32e4b0ba829ddb2$var$Nc = $c32e4b0ba829ddb2$var$Tc($c32e4b0ba829ddb2$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $c32e4b0ba829ddb2$var$Oc.set(f, $c32e4b0ba829ddb2$var$Tc($c32e4b0ba829ddb2$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $c32e4b0ba829ddb2$var$Pc.set(f, $c32e4b0ba829ddb2$var$Tc($c32e4b0ba829ddb2$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $c32e4b0ba829ddb2$var$Vc(a) {
    var b = $c32e4b0ba829ddb2$var$Wc(a.target);
    if (null !== b) {
        var c = $c32e4b0ba829ddb2$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $c32e4b0ba829ddb2$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $c32e4b0ba829ddb2$var$Ic(a.priority, function() {
                        $c32e4b0ba829ddb2$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $c32e4b0ba829ddb2$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $c32e4b0ba829ddb2$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $c32e4b0ba829ddb2$var$wb = d;
            c.target.dispatchEvent(d);
            $c32e4b0ba829ddb2$var$wb = null;
        } else return b = $c32e4b0ba829ddb2$var$Cb(c), null !== b && $c32e4b0ba829ddb2$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $c32e4b0ba829ddb2$var$Zc(a, b, c) {
    $c32e4b0ba829ddb2$var$Xc(a) && c.delete(b);
}
function $c32e4b0ba829ddb2$var$$c() {
    $c32e4b0ba829ddb2$var$Jc = !1;
    null !== $c32e4b0ba829ddb2$var$Lc && $c32e4b0ba829ddb2$var$Xc($c32e4b0ba829ddb2$var$Lc) && ($c32e4b0ba829ddb2$var$Lc = null);
    null !== $c32e4b0ba829ddb2$var$Mc && $c32e4b0ba829ddb2$var$Xc($c32e4b0ba829ddb2$var$Mc) && ($c32e4b0ba829ddb2$var$Mc = null);
    null !== $c32e4b0ba829ddb2$var$Nc && $c32e4b0ba829ddb2$var$Xc($c32e4b0ba829ddb2$var$Nc) && ($c32e4b0ba829ddb2$var$Nc = null);
    $c32e4b0ba829ddb2$var$Oc.forEach($c32e4b0ba829ddb2$var$Zc);
    $c32e4b0ba829ddb2$var$Pc.forEach($c32e4b0ba829ddb2$var$Zc);
}
function $c32e4b0ba829ddb2$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $c32e4b0ba829ddb2$var$Jc || ($c32e4b0ba829ddb2$var$Jc = !0, $5t8wa.unstable_scheduleCallback($5t8wa.unstable_NormalPriority, $c32e4b0ba829ddb2$var$$c)));
}
function $c32e4b0ba829ddb2$var$bd(a) {
    function b(b) {
        return $c32e4b0ba829ddb2$var$ad(b, a);
    }
    if (0 < $c32e4b0ba829ddb2$var$Kc.length) {
        $c32e4b0ba829ddb2$var$ad($c32e4b0ba829ddb2$var$Kc[0], a);
        for(var c = 1; c < $c32e4b0ba829ddb2$var$Kc.length; c++){
            var d = $c32e4b0ba829ddb2$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $c32e4b0ba829ddb2$var$Lc && $c32e4b0ba829ddb2$var$ad($c32e4b0ba829ddb2$var$Lc, a);
    null !== $c32e4b0ba829ddb2$var$Mc && $c32e4b0ba829ddb2$var$ad($c32e4b0ba829ddb2$var$Mc, a);
    null !== $c32e4b0ba829ddb2$var$Nc && $c32e4b0ba829ddb2$var$ad($c32e4b0ba829ddb2$var$Nc, a);
    $c32e4b0ba829ddb2$var$Oc.forEach(b);
    $c32e4b0ba829ddb2$var$Pc.forEach(b);
    for(c = 0; c < $c32e4b0ba829ddb2$var$Qc.length; c++)d = $c32e4b0ba829ddb2$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $c32e4b0ba829ddb2$var$Qc.length && (c = $c32e4b0ba829ddb2$var$Qc[0], null === c.blockedOn);)$c32e4b0ba829ddb2$var$Vc(c), null === c.blockedOn && $c32e4b0ba829ddb2$var$Qc.shift();
}
var $c32e4b0ba829ddb2$var$cd = $c32e4b0ba829ddb2$var$ua.ReactCurrentBatchConfig, $c32e4b0ba829ddb2$var$dd = !0;
function $c32e4b0ba829ddb2$var$ed(a, b, c, d) {
    var e = $c32e4b0ba829ddb2$var$C, f = $c32e4b0ba829ddb2$var$cd.transition;
    $c32e4b0ba829ddb2$var$cd.transition = null;
    try {
        $c32e4b0ba829ddb2$var$C = 1, $c32e4b0ba829ddb2$var$fd(a, b, c, d);
    } finally{
        $c32e4b0ba829ddb2$var$C = e, $c32e4b0ba829ddb2$var$cd.transition = f;
    }
}
function $c32e4b0ba829ddb2$var$gd(a, b, c, d) {
    var e = $c32e4b0ba829ddb2$var$C, f = $c32e4b0ba829ddb2$var$cd.transition;
    $c32e4b0ba829ddb2$var$cd.transition = null;
    try {
        $c32e4b0ba829ddb2$var$C = 4, $c32e4b0ba829ddb2$var$fd(a, b, c, d);
    } finally{
        $c32e4b0ba829ddb2$var$C = e, $c32e4b0ba829ddb2$var$cd.transition = f;
    }
}
function $c32e4b0ba829ddb2$var$fd(a, b, c, d) {
    if ($c32e4b0ba829ddb2$var$dd) {
        var e = $c32e4b0ba829ddb2$var$Yc(a, b, c, d);
        if (null === e) $c32e4b0ba829ddb2$var$hd(a, b, d, $c32e4b0ba829ddb2$var$id, c), $c32e4b0ba829ddb2$var$Sc(a, d);
        else if ($c32e4b0ba829ddb2$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($c32e4b0ba829ddb2$var$Sc(a, d), b & 4 && -1 < $c32e4b0ba829ddb2$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $c32e4b0ba829ddb2$var$Cb(e);
                null !== f && $c32e4b0ba829ddb2$var$Ec(f);
                f = $c32e4b0ba829ddb2$var$Yc(a, b, c, d);
                null === f && $c32e4b0ba829ddb2$var$hd(a, b, d, $c32e4b0ba829ddb2$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $c32e4b0ba829ddb2$var$hd(a, b, d, null, c);
    }
}
var $c32e4b0ba829ddb2$var$id = null;
function $c32e4b0ba829ddb2$var$Yc(a, b, c, d) {
    $c32e4b0ba829ddb2$var$id = null;
    a = $c32e4b0ba829ddb2$var$xb(d);
    a = $c32e4b0ba829ddb2$var$Wc(a);
    if (null !== a) {
        if (b = $c32e4b0ba829ddb2$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $c32e4b0ba829ddb2$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $c32e4b0ba829ddb2$var$id = a;
    return null;
}
function $c32e4b0ba829ddb2$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($c32e4b0ba829ddb2$var$ec()){
                case $c32e4b0ba829ddb2$var$fc:
                    return 1;
                case $c32e4b0ba829ddb2$var$gc:
                    return 4;
                case $c32e4b0ba829ddb2$var$hc:
                case $c32e4b0ba829ddb2$var$ic:
                    return 16;
                case $c32e4b0ba829ddb2$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $c32e4b0ba829ddb2$var$kd = null, $c32e4b0ba829ddb2$var$ld = null, $c32e4b0ba829ddb2$var$md = null;
function $c32e4b0ba829ddb2$var$nd() {
    if ($c32e4b0ba829ddb2$var$md) return $c32e4b0ba829ddb2$var$md;
    var a, b = $c32e4b0ba829ddb2$var$ld, c = b.length, d, e = "value" in $c32e4b0ba829ddb2$var$kd ? $c32e4b0ba829ddb2$var$kd.value : $c32e4b0ba829ddb2$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $c32e4b0ba829ddb2$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $c32e4b0ba829ddb2$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $c32e4b0ba829ddb2$var$pd() {
    return !0;
}
function $c32e4b0ba829ddb2$var$qd() {
    return !1;
}
function $c32e4b0ba829ddb2$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $c32e4b0ba829ddb2$var$pd : $c32e4b0ba829ddb2$var$qd;
        this.isPropagationStopped = $c32e4b0ba829ddb2$var$qd;
        return this;
    }
    $c32e4b0ba829ddb2$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $2bfPH._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $c32e4b0ba829ddb2$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $2bfPH._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $c32e4b0ba829ddb2$var$pd);
        },
        persist: function persist() {},
        isPersistent: $c32e4b0ba829ddb2$var$pd
    });
    return b;
}
var $c32e4b0ba829ddb2$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c32e4b0ba829ddb2$var$td = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$sd), $c32e4b0ba829ddb2$var$ud = $c32e4b0ba829ddb2$var$A({}, $c32e4b0ba829ddb2$var$sd, {
    view: 0,
    detail: 0
}), $c32e4b0ba829ddb2$var$vd = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$ud), $c32e4b0ba829ddb2$var$wd, $c32e4b0ba829ddb2$var$xd, $c32e4b0ba829ddb2$var$yd, $c32e4b0ba829ddb2$var$Ad = $c32e4b0ba829ddb2$var$A({}, $c32e4b0ba829ddb2$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c32e4b0ba829ddb2$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $c32e4b0ba829ddb2$var$yd && ($c32e4b0ba829ddb2$var$yd && "mousemove" === a.type ? ($c32e4b0ba829ddb2$var$wd = a.screenX - $c32e4b0ba829ddb2$var$yd.screenX, $c32e4b0ba829ddb2$var$xd = a.screenY - $c32e4b0ba829ddb2$var$yd.screenY) : $c32e4b0ba829ddb2$var$xd = $c32e4b0ba829ddb2$var$wd = 0, $c32e4b0ba829ddb2$var$yd = a);
        return $c32e4b0ba829ddb2$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $c32e4b0ba829ddb2$var$xd;
    }
}), $c32e4b0ba829ddb2$var$Bd = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$Ad), $c32e4b0ba829ddb2$var$Cd = $c32e4b0ba829ddb2$var$A({}, $c32e4b0ba829ddb2$var$Ad, {
    dataTransfer: 0
}), $c32e4b0ba829ddb2$var$Dd = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$Cd), $c32e4b0ba829ddb2$var$Ed = $c32e4b0ba829ddb2$var$A({}, $c32e4b0ba829ddb2$var$ud, {
    relatedTarget: 0
}), $c32e4b0ba829ddb2$var$Fd = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$Ed), $c32e4b0ba829ddb2$var$Gd = $c32e4b0ba829ddb2$var$A({}, $c32e4b0ba829ddb2$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c32e4b0ba829ddb2$var$Hd = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$Gd), $c32e4b0ba829ddb2$var$Id = $c32e4b0ba829ddb2$var$A({}, $c32e4b0ba829ddb2$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $c32e4b0ba829ddb2$var$Jd = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$Id), $c32e4b0ba829ddb2$var$Kd = $c32e4b0ba829ddb2$var$A({}, $c32e4b0ba829ddb2$var$sd, {
    data: 0
}), $c32e4b0ba829ddb2$var$Ld = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$Kd), $c32e4b0ba829ddb2$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c32e4b0ba829ddb2$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c32e4b0ba829ddb2$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c32e4b0ba829ddb2$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $c32e4b0ba829ddb2$var$Od[a]) ? !!b[a] : !1;
}
function $c32e4b0ba829ddb2$var$zd() {
    return $c32e4b0ba829ddb2$var$Pd;
}
var $c32e4b0ba829ddb2$var$Qd = $c32e4b0ba829ddb2$var$A({}, $c32e4b0ba829ddb2$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $c32e4b0ba829ddb2$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $c32e4b0ba829ddb2$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $c32e4b0ba829ddb2$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c32e4b0ba829ddb2$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $c32e4b0ba829ddb2$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $c32e4b0ba829ddb2$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $c32e4b0ba829ddb2$var$Rd = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$Qd), $c32e4b0ba829ddb2$var$Sd = $c32e4b0ba829ddb2$var$A({}, $c32e4b0ba829ddb2$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c32e4b0ba829ddb2$var$Td = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$Sd), $c32e4b0ba829ddb2$var$Ud = $c32e4b0ba829ddb2$var$A({}, $c32e4b0ba829ddb2$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c32e4b0ba829ddb2$var$zd
}), $c32e4b0ba829ddb2$var$Vd = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$Ud), $c32e4b0ba829ddb2$var$Wd = $c32e4b0ba829ddb2$var$A({}, $c32e4b0ba829ddb2$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c32e4b0ba829ddb2$var$Xd = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$Wd), $c32e4b0ba829ddb2$var$Yd = $c32e4b0ba829ddb2$var$A({}, $c32e4b0ba829ddb2$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c32e4b0ba829ddb2$var$Zd = $c32e4b0ba829ddb2$var$rd($c32e4b0ba829ddb2$var$Yd), $c32e4b0ba829ddb2$var$$d = [
    9,
    13,
    27,
    32
], $c32e4b0ba829ddb2$var$ae = $c32e4b0ba829ddb2$var$ia && "CompositionEvent" in window, $c32e4b0ba829ddb2$var$be = null;
$c32e4b0ba829ddb2$var$ia && "documentMode" in document && ($c32e4b0ba829ddb2$var$be = document.documentMode);
var $c32e4b0ba829ddb2$var$ce = $c32e4b0ba829ddb2$var$ia && "TextEvent" in window && !$c32e4b0ba829ddb2$var$be, $c32e4b0ba829ddb2$var$de = $c32e4b0ba829ddb2$var$ia && (!$c32e4b0ba829ddb2$var$ae || $c32e4b0ba829ddb2$var$be && 8 < $c32e4b0ba829ddb2$var$be && 11 >= $c32e4b0ba829ddb2$var$be), $c32e4b0ba829ddb2$var$ee = String.fromCharCode(32), $c32e4b0ba829ddb2$var$fe = !1;
function $c32e4b0ba829ddb2$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $c32e4b0ba829ddb2$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c32e4b0ba829ddb2$var$he(a) {
    a = a.detail;
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $2bfPH._)(a)) && "data" in a ? a.data : null;
}
var $c32e4b0ba829ddb2$var$ie = !1;
function $c32e4b0ba829ddb2$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $c32e4b0ba829ddb2$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $c32e4b0ba829ddb2$var$fe = !0;
            return $c32e4b0ba829ddb2$var$ee;
        case "textInput":
            return a = b.data, a === $c32e4b0ba829ddb2$var$ee && $c32e4b0ba829ddb2$var$fe ? null : a;
        default:
            return null;
    }
}
function $c32e4b0ba829ddb2$var$ke(a, b) {
    if ($c32e4b0ba829ddb2$var$ie) return "compositionend" === a || !$c32e4b0ba829ddb2$var$ae && $c32e4b0ba829ddb2$var$ge(a, b) ? (a = $c32e4b0ba829ddb2$var$nd(), $c32e4b0ba829ddb2$var$md = $c32e4b0ba829ddb2$var$ld = $c32e4b0ba829ddb2$var$kd = null, $c32e4b0ba829ddb2$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $c32e4b0ba829ddb2$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $c32e4b0ba829ddb2$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c32e4b0ba829ddb2$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$c32e4b0ba829ddb2$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $c32e4b0ba829ddb2$var$ne(a, b, c, d) {
    $c32e4b0ba829ddb2$var$Eb(d);
    b = $c32e4b0ba829ddb2$var$oe(b, "onChange");
    0 < b.length && (c = new $c32e4b0ba829ddb2$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $c32e4b0ba829ddb2$var$pe = null, $c32e4b0ba829ddb2$var$qe = null;
function $c32e4b0ba829ddb2$var$re(a) {
    $c32e4b0ba829ddb2$var$se(a, 0);
}
function $c32e4b0ba829ddb2$var$te(a) {
    var b = $c32e4b0ba829ddb2$var$ue(a);
    if ($c32e4b0ba829ddb2$var$Wa(b)) return a;
}
function $c32e4b0ba829ddb2$var$ve(a, b) {
    if ("change" === a) return b;
}
var $c32e4b0ba829ddb2$var$we = !1;
if ($c32e4b0ba829ddb2$var$ia) {
    var $c32e4b0ba829ddb2$var$xe;
    if ($c32e4b0ba829ddb2$var$ia) {
        var $c32e4b0ba829ddb2$var$ye = "oninput" in document;
        if (!$c32e4b0ba829ddb2$var$ye) {
            var $c32e4b0ba829ddb2$var$ze = document.createElement("div");
            $c32e4b0ba829ddb2$var$ze.setAttribute("oninput", "return;");
            $c32e4b0ba829ddb2$var$ye = "function" === typeof $c32e4b0ba829ddb2$var$ze.oninput;
        }
        $c32e4b0ba829ddb2$var$xe = $c32e4b0ba829ddb2$var$ye;
    } else $c32e4b0ba829ddb2$var$xe = !1;
    $c32e4b0ba829ddb2$var$we = $c32e4b0ba829ddb2$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $c32e4b0ba829ddb2$var$Ae() {
    $c32e4b0ba829ddb2$var$pe && ($c32e4b0ba829ddb2$var$pe.detachEvent("onpropertychange", $c32e4b0ba829ddb2$var$Be), $c32e4b0ba829ddb2$var$qe = $c32e4b0ba829ddb2$var$pe = null);
}
function $c32e4b0ba829ddb2$var$Be(a) {
    if ("value" === a.propertyName && $c32e4b0ba829ddb2$var$te($c32e4b0ba829ddb2$var$qe)) {
        var b = [];
        $c32e4b0ba829ddb2$var$ne(b, $c32e4b0ba829ddb2$var$qe, a, $c32e4b0ba829ddb2$var$xb(a));
        $c32e4b0ba829ddb2$var$Jb($c32e4b0ba829ddb2$var$re, b);
    }
}
function $c32e4b0ba829ddb2$var$Ce(a, b, c) {
    "focusin" === a ? ($c32e4b0ba829ddb2$var$Ae(), $c32e4b0ba829ddb2$var$pe = b, $c32e4b0ba829ddb2$var$qe = c, $c32e4b0ba829ddb2$var$pe.attachEvent("onpropertychange", $c32e4b0ba829ddb2$var$Be)) : "focusout" === a && $c32e4b0ba829ddb2$var$Ae();
}
function $c32e4b0ba829ddb2$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $c32e4b0ba829ddb2$var$te($c32e4b0ba829ddb2$var$qe);
}
function $c32e4b0ba829ddb2$var$Ee(a, b) {
    if ("click" === a) return $c32e4b0ba829ddb2$var$te(b);
}
function $c32e4b0ba829ddb2$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $c32e4b0ba829ddb2$var$te(b);
}
function $c32e4b0ba829ddb2$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c32e4b0ba829ddb2$var$He = "function" === typeof Object.is ? Object.is : $c32e4b0ba829ddb2$var$Ge;
function $c32e4b0ba829ddb2$var$Ie(a, b) {
    if ($c32e4b0ba829ddb2$var$He(a, b)) return !0;
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, $2bfPH._)(a)) || null === a || "object" !== (typeof b === "undefined" ? "undefined" : (0, $2bfPH._)(b)) || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$c32e4b0ba829ddb2$var$ja.call(b, e) || !$c32e4b0ba829ddb2$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $c32e4b0ba829ddb2$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $c32e4b0ba829ddb2$var$Ke(a, b) {
    var c = $c32e4b0ba829ddb2$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $c32e4b0ba829ddb2$var$Je(c);
    }
}
function $c32e4b0ba829ddb2$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $c32e4b0ba829ddb2$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $c32e4b0ba829ddb2$var$Me() {
    for(var a = window, b = $c32e4b0ba829ddb2$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $c32e4b0ba829ddb2$var$Xa(a.document);
    }
    return b;
}
function $c32e4b0ba829ddb2$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $c32e4b0ba829ddb2$var$Oe(a) {
    var b = $c32e4b0ba829ddb2$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $c32e4b0ba829ddb2$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $c32e4b0ba829ddb2$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $c32e4b0ba829ddb2$var$Ke(c, f);
                var g = $c32e4b0ba829ddb2$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $c32e4b0ba829ddb2$var$Pe = $c32e4b0ba829ddb2$var$ia && "documentMode" in document && 11 >= document.documentMode, $c32e4b0ba829ddb2$var$Qe = null, $c32e4b0ba829ddb2$var$Re = null, $c32e4b0ba829ddb2$var$Se = null, $c32e4b0ba829ddb2$var$Te = !1;
function $c32e4b0ba829ddb2$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $c32e4b0ba829ddb2$var$Te || null == $c32e4b0ba829ddb2$var$Qe || $c32e4b0ba829ddb2$var$Qe !== $c32e4b0ba829ddb2$var$Xa(d) || (d = $c32e4b0ba829ddb2$var$Qe, "selectionStart" in d && $c32e4b0ba829ddb2$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $c32e4b0ba829ddb2$var$Se && $c32e4b0ba829ddb2$var$Ie($c32e4b0ba829ddb2$var$Se, d) || ($c32e4b0ba829ddb2$var$Se = d, d = $c32e4b0ba829ddb2$var$oe($c32e4b0ba829ddb2$var$Re, "onSelect"), 0 < d.length && (b = new $c32e4b0ba829ddb2$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $c32e4b0ba829ddb2$var$Qe)));
}
function $c32e4b0ba829ddb2$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $c32e4b0ba829ddb2$var$We = {
    animationend: $c32e4b0ba829ddb2$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $c32e4b0ba829ddb2$var$Ve("Animation", "AnimationIteration"),
    animationstart: $c32e4b0ba829ddb2$var$Ve("Animation", "AnimationStart"),
    transitionend: $c32e4b0ba829ddb2$var$Ve("Transition", "TransitionEnd")
}, $c32e4b0ba829ddb2$var$Xe = {}, $c32e4b0ba829ddb2$var$Ye = {};
$c32e4b0ba829ddb2$var$ia && ($c32e4b0ba829ddb2$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $c32e4b0ba829ddb2$var$We.animationend.animation, delete $c32e4b0ba829ddb2$var$We.animationiteration.animation, delete $c32e4b0ba829ddb2$var$We.animationstart.animation), "TransitionEvent" in window || delete $c32e4b0ba829ddb2$var$We.transitionend.transition);
function $c32e4b0ba829ddb2$var$Ze(a) {
    if ($c32e4b0ba829ddb2$var$Xe[a]) return $c32e4b0ba829ddb2$var$Xe[a];
    if (!$c32e4b0ba829ddb2$var$We[a]) return a;
    var b = $c32e4b0ba829ddb2$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $c32e4b0ba829ddb2$var$Ye) return $c32e4b0ba829ddb2$var$Xe[a] = b[c];
    return a;
}
var $c32e4b0ba829ddb2$var$$e = $c32e4b0ba829ddb2$var$Ze("animationend"), $c32e4b0ba829ddb2$var$af = $c32e4b0ba829ddb2$var$Ze("animationiteration"), $c32e4b0ba829ddb2$var$bf = $c32e4b0ba829ddb2$var$Ze("animationstart"), $c32e4b0ba829ddb2$var$cf = $c32e4b0ba829ddb2$var$Ze("transitionend"), $c32e4b0ba829ddb2$var$df = new Map, $c32e4b0ba829ddb2$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $c32e4b0ba829ddb2$var$ff(a, b) {
    $c32e4b0ba829ddb2$var$df.set(a, b);
    $c32e4b0ba829ddb2$var$fa(b, [
        a
    ]);
}
for(var $c32e4b0ba829ddb2$var$gf = 0; $c32e4b0ba829ddb2$var$gf < $c32e4b0ba829ddb2$var$ef.length; $c32e4b0ba829ddb2$var$gf++){
    var $c32e4b0ba829ddb2$var$hf = $c32e4b0ba829ddb2$var$ef[$c32e4b0ba829ddb2$var$gf], $c32e4b0ba829ddb2$var$jf = $c32e4b0ba829ddb2$var$hf.toLowerCase(), $c32e4b0ba829ddb2$var$kf = $c32e4b0ba829ddb2$var$hf[0].toUpperCase() + $c32e4b0ba829ddb2$var$hf.slice(1);
    $c32e4b0ba829ddb2$var$ff($c32e4b0ba829ddb2$var$jf, "on" + $c32e4b0ba829ddb2$var$kf);
}
$c32e4b0ba829ddb2$var$ff($c32e4b0ba829ddb2$var$$e, "onAnimationEnd");
$c32e4b0ba829ddb2$var$ff($c32e4b0ba829ddb2$var$af, "onAnimationIteration");
$c32e4b0ba829ddb2$var$ff($c32e4b0ba829ddb2$var$bf, "onAnimationStart");
$c32e4b0ba829ddb2$var$ff("dblclick", "onDoubleClick");
$c32e4b0ba829ddb2$var$ff("focusin", "onFocus");
$c32e4b0ba829ddb2$var$ff("focusout", "onBlur");
$c32e4b0ba829ddb2$var$ff($c32e4b0ba829ddb2$var$cf, "onTransitionEnd");
$c32e4b0ba829ddb2$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c32e4b0ba829ddb2$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c32e4b0ba829ddb2$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c32e4b0ba829ddb2$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c32e4b0ba829ddb2$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c32e4b0ba829ddb2$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c32e4b0ba829ddb2$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c32e4b0ba829ddb2$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c32e4b0ba829ddb2$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c32e4b0ba829ddb2$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c32e4b0ba829ddb2$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c32e4b0ba829ddb2$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($c32e4b0ba829ddb2$var$lf));
function $c32e4b0ba829ddb2$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $c32e4b0ba829ddb2$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $c32e4b0ba829ddb2$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c32e4b0ba829ddb2$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c32e4b0ba829ddb2$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($c32e4b0ba829ddb2$var$Qb) throw a = $c32e4b0ba829ddb2$var$Rb, $c32e4b0ba829ddb2$var$Qb = !1, $c32e4b0ba829ddb2$var$Rb = null, a;
}
function $c32e4b0ba829ddb2$var$D(a, b) {
    var c = b[$c32e4b0ba829ddb2$var$of];
    void 0 === c && (c = b[$c32e4b0ba829ddb2$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($c32e4b0ba829ddb2$var$pf(b, a, 2, !1), c.add(d));
}
function $c32e4b0ba829ddb2$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $c32e4b0ba829ddb2$var$pf(c, a, d, b);
}
var $c32e4b0ba829ddb2$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $c32e4b0ba829ddb2$var$sf(a) {
    if (!a[$c32e4b0ba829ddb2$var$rf]) {
        a[$c32e4b0ba829ddb2$var$rf] = !0;
        $c32e4b0ba829ddb2$var$da.forEach(function(b) {
            "selectionchange" !== b && ($c32e4b0ba829ddb2$var$mf.has(b) || $c32e4b0ba829ddb2$var$qf(b, !1, a), $c32e4b0ba829ddb2$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$c32e4b0ba829ddb2$var$rf] || (b[$c32e4b0ba829ddb2$var$rf] = !0, $c32e4b0ba829ddb2$var$qf("selectionchange", !1, b));
    }
}
function $c32e4b0ba829ddb2$var$pf(a, b, c, d) {
    switch($c32e4b0ba829ddb2$var$jd(b)){
        case 1:
            var e = $c32e4b0ba829ddb2$var$ed;
            break;
        case 4:
            e = $c32e4b0ba829ddb2$var$gd;
            break;
        default:
            e = $c32e4b0ba829ddb2$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$c32e4b0ba829ddb2$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $c32e4b0ba829ddb2$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $c32e4b0ba829ddb2$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $c32e4b0ba829ddb2$var$Jb(function() {
        var _$d = f, _$e = $c32e4b0ba829ddb2$var$xb(c), g = [];
        a: {
            var h = $c32e4b0ba829ddb2$var$df.get(a);
            if (void 0 !== h) {
                var k = $c32e4b0ba829ddb2$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $c32e4b0ba829ddb2$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $c32e4b0ba829ddb2$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $c32e4b0ba829ddb2$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $c32e4b0ba829ddb2$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $c32e4b0ba829ddb2$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $c32e4b0ba829ddb2$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $c32e4b0ba829ddb2$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $c32e4b0ba829ddb2$var$Vd;
                        break;
                    case $c32e4b0ba829ddb2$var$$e:
                    case $c32e4b0ba829ddb2$var$af:
                    case $c32e4b0ba829ddb2$var$bf:
                        k = $c32e4b0ba829ddb2$var$Hd;
                        break;
                    case $c32e4b0ba829ddb2$var$cf:
                        k = $c32e4b0ba829ddb2$var$Xd;
                        break;
                    case "scroll":
                        k = $c32e4b0ba829ddb2$var$vd;
                        break;
                    case "wheel":
                        k = $c32e4b0ba829ddb2$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $c32e4b0ba829ddb2$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $c32e4b0ba829ddb2$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $c32e4b0ba829ddb2$var$Kb(w, x), null != F && t.push($c32e4b0ba829ddb2$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $c32e4b0ba829ddb2$var$wb && (n = c.relatedTarget || c.fromElement) && ($c32e4b0ba829ddb2$var$Wc(n) || n[$c32e4b0ba829ddb2$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $c32e4b0ba829ddb2$var$Wc(n) : null, null !== n && (J = $c32e4b0ba829ddb2$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $c32e4b0ba829ddb2$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $c32e4b0ba829ddb2$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $c32e4b0ba829ddb2$var$ue(k);
                        u = null == n ? h : $c32e4b0ba829ddb2$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $c32e4b0ba829ddb2$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $c32e4b0ba829ddb2$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $c32e4b0ba829ddb2$var$vf(F))u++;
                            for(; 0 < w - u;)t = $c32e4b0ba829ddb2$var$vf(t), w--;
                            for(; 0 < u - w;)x = $c32e4b0ba829ddb2$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $c32e4b0ba829ddb2$var$vf(t);
                                x = $c32e4b0ba829ddb2$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $c32e4b0ba829ddb2$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $c32e4b0ba829ddb2$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $c32e4b0ba829ddb2$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $c32e4b0ba829ddb2$var$ve;
                else if ($c32e4b0ba829ddb2$var$me(h)) {
                    if ($c32e4b0ba829ddb2$var$we) na = $c32e4b0ba829ddb2$var$Fe;
                    else {
                        na = $c32e4b0ba829ddb2$var$De;
                        var xa = $c32e4b0ba829ddb2$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $c32e4b0ba829ddb2$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $c32e4b0ba829ddb2$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $c32e4b0ba829ddb2$var$cb(h, "number", h.value);
            }
            xa = _$d ? $c32e4b0ba829ddb2$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($c32e4b0ba829ddb2$var$me(xa) || "true" === xa.contentEditable) $c32e4b0ba829ddb2$var$Qe = xa, $c32e4b0ba829ddb2$var$Re = _$d, $c32e4b0ba829ddb2$var$Se = null;
                    break;
                case "focusout":
                    $c32e4b0ba829ddb2$var$Se = $c32e4b0ba829ddb2$var$Re = $c32e4b0ba829ddb2$var$Qe = null;
                    break;
                case "mousedown":
                    $c32e4b0ba829ddb2$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c32e4b0ba829ddb2$var$Te = !1;
                    $c32e4b0ba829ddb2$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($c32e4b0ba829ddb2$var$Pe) break;
                case "keydown":
                case "keyup":
                    $c32e4b0ba829ddb2$var$Ue(g, c, _$e);
            }
            var $a;
            if ($c32e4b0ba829ddb2$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $c32e4b0ba829ddb2$var$ie ? $c32e4b0ba829ddb2$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($c32e4b0ba829ddb2$var$de && "ko" !== c.locale && ($c32e4b0ba829ddb2$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $c32e4b0ba829ddb2$var$ie && ($a = $c32e4b0ba829ddb2$var$nd()) : ($c32e4b0ba829ddb2$var$kd = _$e, $c32e4b0ba829ddb2$var$ld = "value" in $c32e4b0ba829ddb2$var$kd ? $c32e4b0ba829ddb2$var$kd.value : $c32e4b0ba829ddb2$var$kd.textContent, $c32e4b0ba829ddb2$var$ie = !0)), xa = $c32e4b0ba829ddb2$var$oe(_$d, ba), 0 < xa.length && (ba = new $c32e4b0ba829ddb2$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $c32e4b0ba829ddb2$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $c32e4b0ba829ddb2$var$ce ? $c32e4b0ba829ddb2$var$je(a, c) : $c32e4b0ba829ddb2$var$ke(a, c)) _$d = $c32e4b0ba829ddb2$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $c32e4b0ba829ddb2$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $c32e4b0ba829ddb2$var$se(g, b);
    });
}
function $c32e4b0ba829ddb2$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $c32e4b0ba829ddb2$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $c32e4b0ba829ddb2$var$Kb(a, c), null != f && d.unshift($c32e4b0ba829ddb2$var$tf(a, f, e)), f = $c32e4b0ba829ddb2$var$Kb(a, b), null != f && d.push($c32e4b0ba829ddb2$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $c32e4b0ba829ddb2$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $c32e4b0ba829ddb2$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $c32e4b0ba829ddb2$var$Kb(c, f), null != k && g.unshift($c32e4b0ba829ddb2$var$tf(c, k, h))) : e || (k = $c32e4b0ba829ddb2$var$Kb(c, f), null != k && g.push($c32e4b0ba829ddb2$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $c32e4b0ba829ddb2$var$xf = /\r\n?/g, $c32e4b0ba829ddb2$var$yf = /\u0000|\uFFFD/g;
function $c32e4b0ba829ddb2$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($c32e4b0ba829ddb2$var$xf, "\n").replace($c32e4b0ba829ddb2$var$yf, "");
}
function $c32e4b0ba829ddb2$var$Af(a, b, c) {
    b = $c32e4b0ba829ddb2$var$zf(b);
    if ($c32e4b0ba829ddb2$var$zf(a) !== b && c) throw Error($c32e4b0ba829ddb2$var$p(425));
}
function $c32e4b0ba829ddb2$var$Bf() {}
var $c32e4b0ba829ddb2$var$Cf = null, $c32e4b0ba829ddb2$var$Df = null;
function $c32e4b0ba829ddb2$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === (0, $2bfPH._)(b.dangerouslySetInnerHTML) && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $c32e4b0ba829ddb2$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $c32e4b0ba829ddb2$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $c32e4b0ba829ddb2$var$Hf = "function" === typeof Promise ? Promise : void 0, $c32e4b0ba829ddb2$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c32e4b0ba829ddb2$var$Hf ? function Jf(a) {
    return $c32e4b0ba829ddb2$var$Hf.resolve(null).then(a).catch($c32e4b0ba829ddb2$var$If);
} : $c32e4b0ba829ddb2$var$Ff;
function $c32e4b0ba829ddb2$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $c32e4b0ba829ddb2$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $c32e4b0ba829ddb2$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $c32e4b0ba829ddb2$var$bd(b);
}
function $c32e4b0ba829ddb2$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $c32e4b0ba829ddb2$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $c32e4b0ba829ddb2$var$Nf = Math.random().toString(36).slice(2), $c32e4b0ba829ddb2$var$Of = "__reactFiber$" + $c32e4b0ba829ddb2$var$Nf, $c32e4b0ba829ddb2$var$Pf = "__reactProps$" + $c32e4b0ba829ddb2$var$Nf, $c32e4b0ba829ddb2$var$uf = "__reactContainer$" + $c32e4b0ba829ddb2$var$Nf, $c32e4b0ba829ddb2$var$of = "__reactEvents$" + $c32e4b0ba829ddb2$var$Nf, $c32e4b0ba829ddb2$var$Qf = "__reactListeners$" + $c32e4b0ba829ddb2$var$Nf, $c32e4b0ba829ddb2$var$Rf = "__reactHandles$" + $c32e4b0ba829ddb2$var$Nf;
function $c32e4b0ba829ddb2$var$Wc(a) {
    var b = a[$c32e4b0ba829ddb2$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$c32e4b0ba829ddb2$var$uf] || c[$c32e4b0ba829ddb2$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $c32e4b0ba829ddb2$var$Mf(a); null !== a;){
                if (c = a[$c32e4b0ba829ddb2$var$Of]) return c;
                a = $c32e4b0ba829ddb2$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $c32e4b0ba829ddb2$var$Cb(a) {
    a = a[$c32e4b0ba829ddb2$var$Of] || a[$c32e4b0ba829ddb2$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $c32e4b0ba829ddb2$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($c32e4b0ba829ddb2$var$p(33));
}
function $c32e4b0ba829ddb2$var$Db(a) {
    return a[$c32e4b0ba829ddb2$var$Pf] || null;
}
var $c32e4b0ba829ddb2$var$Sf = [], $c32e4b0ba829ddb2$var$Tf = -1;
function $c32e4b0ba829ddb2$var$Uf(a) {
    return {
        current: a
    };
}
function $c32e4b0ba829ddb2$var$E(a) {
    0 > $c32e4b0ba829ddb2$var$Tf || (a.current = $c32e4b0ba829ddb2$var$Sf[$c32e4b0ba829ddb2$var$Tf], $c32e4b0ba829ddb2$var$Sf[$c32e4b0ba829ddb2$var$Tf] = null, $c32e4b0ba829ddb2$var$Tf--);
}
function $c32e4b0ba829ddb2$var$G(a, b) {
    $c32e4b0ba829ddb2$var$Tf++;
    $c32e4b0ba829ddb2$var$Sf[$c32e4b0ba829ddb2$var$Tf] = a.current;
    a.current = b;
}
var $c32e4b0ba829ddb2$var$Vf = {}, $c32e4b0ba829ddb2$var$H = $c32e4b0ba829ddb2$var$Uf($c32e4b0ba829ddb2$var$Vf), $c32e4b0ba829ddb2$var$Wf = $c32e4b0ba829ddb2$var$Uf(!1), $c32e4b0ba829ddb2$var$Xf = $c32e4b0ba829ddb2$var$Vf;
function $c32e4b0ba829ddb2$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $c32e4b0ba829ddb2$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $c32e4b0ba829ddb2$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $c32e4b0ba829ddb2$var$$f() {
    $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$Wf);
    $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$H);
}
function $c32e4b0ba829ddb2$var$ag(a, b, c) {
    if ($c32e4b0ba829ddb2$var$H.current !== $c32e4b0ba829ddb2$var$Vf) throw Error($c32e4b0ba829ddb2$var$p(168));
    $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$H, b);
    $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$Wf, c);
}
function $c32e4b0ba829ddb2$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($c32e4b0ba829ddb2$var$p(108, $c32e4b0ba829ddb2$var$Ra(a) || "Unknown", e));
    return $c32e4b0ba829ddb2$var$A({}, c, d);
}
function $c32e4b0ba829ddb2$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $c32e4b0ba829ddb2$var$Vf;
    $c32e4b0ba829ddb2$var$Xf = $c32e4b0ba829ddb2$var$H.current;
    $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$H, a);
    $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$Wf, $c32e4b0ba829ddb2$var$Wf.current);
    return !0;
}
function $c32e4b0ba829ddb2$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($c32e4b0ba829ddb2$var$p(169));
    c ? (a = $c32e4b0ba829ddb2$var$bg(a, b, $c32e4b0ba829ddb2$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$Wf), $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$H), $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$H, a)) : $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$Wf);
    $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$Wf, c);
}
var $c32e4b0ba829ddb2$var$eg = null, $c32e4b0ba829ddb2$var$fg = !1, $c32e4b0ba829ddb2$var$gg = !1;
function $c32e4b0ba829ddb2$var$hg(a) {
    null === $c32e4b0ba829ddb2$var$eg ? $c32e4b0ba829ddb2$var$eg = [
        a
    ] : $c32e4b0ba829ddb2$var$eg.push(a);
}
function $c32e4b0ba829ddb2$var$ig(a) {
    $c32e4b0ba829ddb2$var$fg = !0;
    $c32e4b0ba829ddb2$var$hg(a);
}
function $c32e4b0ba829ddb2$var$jg() {
    if (!$c32e4b0ba829ddb2$var$gg && null !== $c32e4b0ba829ddb2$var$eg) {
        $c32e4b0ba829ddb2$var$gg = !0;
        var a = 0, b = $c32e4b0ba829ddb2$var$C;
        try {
            var c = $c32e4b0ba829ddb2$var$eg;
            for($c32e4b0ba829ddb2$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $c32e4b0ba829ddb2$var$eg = null;
            $c32e4b0ba829ddb2$var$fg = !1;
        } catch (e) {
            throw null !== $c32e4b0ba829ddb2$var$eg && ($c32e4b0ba829ddb2$var$eg = $c32e4b0ba829ddb2$var$eg.slice(a + 1)), $c32e4b0ba829ddb2$var$ac($c32e4b0ba829ddb2$var$fc, $c32e4b0ba829ddb2$var$jg), e;
        } finally{
            $c32e4b0ba829ddb2$var$C = b, $c32e4b0ba829ddb2$var$gg = !1;
        }
    }
    return null;
}
var $c32e4b0ba829ddb2$var$kg = [], $c32e4b0ba829ddb2$var$lg = 0, $c32e4b0ba829ddb2$var$mg = null, $c32e4b0ba829ddb2$var$ng = 0, $c32e4b0ba829ddb2$var$og = [], $c32e4b0ba829ddb2$var$pg = 0, $c32e4b0ba829ddb2$var$qg = null, $c32e4b0ba829ddb2$var$rg = 1, $c32e4b0ba829ddb2$var$sg = "";
function $c32e4b0ba829ddb2$var$tg(a, b) {
    $c32e4b0ba829ddb2$var$kg[$c32e4b0ba829ddb2$var$lg++] = $c32e4b0ba829ddb2$var$ng;
    $c32e4b0ba829ddb2$var$kg[$c32e4b0ba829ddb2$var$lg++] = $c32e4b0ba829ddb2$var$mg;
    $c32e4b0ba829ddb2$var$mg = a;
    $c32e4b0ba829ddb2$var$ng = b;
}
function $c32e4b0ba829ddb2$var$ug(a, b, c) {
    $c32e4b0ba829ddb2$var$og[$c32e4b0ba829ddb2$var$pg++] = $c32e4b0ba829ddb2$var$rg;
    $c32e4b0ba829ddb2$var$og[$c32e4b0ba829ddb2$var$pg++] = $c32e4b0ba829ddb2$var$sg;
    $c32e4b0ba829ddb2$var$og[$c32e4b0ba829ddb2$var$pg++] = $c32e4b0ba829ddb2$var$qg;
    $c32e4b0ba829ddb2$var$qg = a;
    var d = $c32e4b0ba829ddb2$var$rg;
    a = $c32e4b0ba829ddb2$var$sg;
    var e = 32 - $c32e4b0ba829ddb2$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $c32e4b0ba829ddb2$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $c32e4b0ba829ddb2$var$rg = 1 << 32 - $c32e4b0ba829ddb2$var$oc(b) + e | c << e | d;
        $c32e4b0ba829ddb2$var$sg = f + a;
    } else $c32e4b0ba829ddb2$var$rg = 1 << f | c << e | d, $c32e4b0ba829ddb2$var$sg = a;
}
function $c32e4b0ba829ddb2$var$vg(a) {
    null !== a.return && ($c32e4b0ba829ddb2$var$tg(a, 1), $c32e4b0ba829ddb2$var$ug(a, 1, 0));
}
function $c32e4b0ba829ddb2$var$wg(a) {
    for(; a === $c32e4b0ba829ddb2$var$mg;)$c32e4b0ba829ddb2$var$mg = $c32e4b0ba829ddb2$var$kg[--$c32e4b0ba829ddb2$var$lg], $c32e4b0ba829ddb2$var$kg[$c32e4b0ba829ddb2$var$lg] = null, $c32e4b0ba829ddb2$var$ng = $c32e4b0ba829ddb2$var$kg[--$c32e4b0ba829ddb2$var$lg], $c32e4b0ba829ddb2$var$kg[$c32e4b0ba829ddb2$var$lg] = null;
    for(; a === $c32e4b0ba829ddb2$var$qg;)$c32e4b0ba829ddb2$var$qg = $c32e4b0ba829ddb2$var$og[--$c32e4b0ba829ddb2$var$pg], $c32e4b0ba829ddb2$var$og[$c32e4b0ba829ddb2$var$pg] = null, $c32e4b0ba829ddb2$var$sg = $c32e4b0ba829ddb2$var$og[--$c32e4b0ba829ddb2$var$pg], $c32e4b0ba829ddb2$var$og[$c32e4b0ba829ddb2$var$pg] = null, $c32e4b0ba829ddb2$var$rg = $c32e4b0ba829ddb2$var$og[--$c32e4b0ba829ddb2$var$pg], $c32e4b0ba829ddb2$var$og[$c32e4b0ba829ddb2$var$pg] = null;
}
var $c32e4b0ba829ddb2$var$xg = null, $c32e4b0ba829ddb2$var$yg = null, $c32e4b0ba829ddb2$var$I = !1, $c32e4b0ba829ddb2$var$zg = null;
function $c32e4b0ba829ddb2$var$Ag(a, b) {
    var c = $c32e4b0ba829ddb2$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $c32e4b0ba829ddb2$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $c32e4b0ba829ddb2$var$xg = a, $c32e4b0ba829ddb2$var$yg = $c32e4b0ba829ddb2$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $c32e4b0ba829ddb2$var$xg = a, $c32e4b0ba829ddb2$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $c32e4b0ba829ddb2$var$qg ? {
                id: $c32e4b0ba829ddb2$var$rg,
                overflow: $c32e4b0ba829ddb2$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $c32e4b0ba829ddb2$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $c32e4b0ba829ddb2$var$xg = a, $c32e4b0ba829ddb2$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $c32e4b0ba829ddb2$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $c32e4b0ba829ddb2$var$Eg(a) {
    if ($c32e4b0ba829ddb2$var$I) {
        var b = $c32e4b0ba829ddb2$var$yg;
        if (b) {
            var c = b;
            if (!$c32e4b0ba829ddb2$var$Cg(a, b)) {
                if ($c32e4b0ba829ddb2$var$Dg(a)) throw Error($c32e4b0ba829ddb2$var$p(418));
                b = $c32e4b0ba829ddb2$var$Lf(c.nextSibling);
                var d = $c32e4b0ba829ddb2$var$xg;
                b && $c32e4b0ba829ddb2$var$Cg(a, b) ? $c32e4b0ba829ddb2$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $c32e4b0ba829ddb2$var$I = !1, $c32e4b0ba829ddb2$var$xg = a);
            }
        } else {
            if ($c32e4b0ba829ddb2$var$Dg(a)) throw Error($c32e4b0ba829ddb2$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $c32e4b0ba829ddb2$var$I = !1;
            $c32e4b0ba829ddb2$var$xg = a;
        }
    }
}
function $c32e4b0ba829ddb2$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $c32e4b0ba829ddb2$var$xg = a;
}
function $c32e4b0ba829ddb2$var$Gg(a) {
    if (a !== $c32e4b0ba829ddb2$var$xg) return !1;
    if (!$c32e4b0ba829ddb2$var$I) return $c32e4b0ba829ddb2$var$Fg(a), $c32e4b0ba829ddb2$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$c32e4b0ba829ddb2$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $c32e4b0ba829ddb2$var$yg)) {
        if ($c32e4b0ba829ddb2$var$Dg(a)) throw $c32e4b0ba829ddb2$var$Hg(), Error($c32e4b0ba829ddb2$var$p(418));
        for(; b;)$c32e4b0ba829ddb2$var$Ag(a, b), b = $c32e4b0ba829ddb2$var$Lf(b.nextSibling);
    }
    $c32e4b0ba829ddb2$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($c32e4b0ba829ddb2$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $c32e4b0ba829ddb2$var$yg = $c32e4b0ba829ddb2$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $c32e4b0ba829ddb2$var$yg = null;
        }
    } else $c32e4b0ba829ddb2$var$yg = $c32e4b0ba829ddb2$var$xg ? $c32e4b0ba829ddb2$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $c32e4b0ba829ddb2$var$Hg() {
    for(var a = $c32e4b0ba829ddb2$var$yg; a;)a = $c32e4b0ba829ddb2$var$Lf(a.nextSibling);
}
function $c32e4b0ba829ddb2$var$Ig() {
    $c32e4b0ba829ddb2$var$yg = $c32e4b0ba829ddb2$var$xg = null;
    $c32e4b0ba829ddb2$var$I = !1;
}
function $c32e4b0ba829ddb2$var$Jg(a) {
    null === $c32e4b0ba829ddb2$var$zg ? $c32e4b0ba829ddb2$var$zg = [
        a
    ] : $c32e4b0ba829ddb2$var$zg.push(a);
}
var $c32e4b0ba829ddb2$var$Kg = $c32e4b0ba829ddb2$var$ua.ReactCurrentBatchConfig;
function $c32e4b0ba829ddb2$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== (typeof a === "undefined" ? "undefined" : (0, $2bfPH._)(a))) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($c32e4b0ba829ddb2$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($c32e4b0ba829ddb2$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($c32e4b0ba829ddb2$var$p(284));
        if (!c._owner) throw Error($c32e4b0ba829ddb2$var$p(290, a));
    }
    return a;
}
function $c32e4b0ba829ddb2$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($c32e4b0ba829ddb2$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $c32e4b0ba829ddb2$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $c32e4b0ba829ddb2$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $c32e4b0ba829ddb2$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $c32e4b0ba829ddb2$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $c32e4b0ba829ddb2$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === (typeof f === "undefined" ? "undefined" : (0, $2bfPH._)(f)) && null !== f && f.$$typeof === $c32e4b0ba829ddb2$var$Ha && $c32e4b0ba829ddb2$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $c32e4b0ba829ddb2$var$Lg(a, b, c), d.return = a, d;
        d = $c32e4b0ba829ddb2$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $c32e4b0ba829ddb2$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $c32e4b0ba829ddb2$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $c32e4b0ba829ddb2$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $c32e4b0ba829ddb2$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === (typeof b === "undefined" ? "undefined" : (0, $2bfPH._)(b)) && null !== b) {
            switch(b.$$typeof){
                case $c32e4b0ba829ddb2$var$va:
                    return c = $c32e4b0ba829ddb2$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $c32e4b0ba829ddb2$var$Lg(a, null, b), c.return = a, c;
                case $c32e4b0ba829ddb2$var$wa:
                    return b = $c32e4b0ba829ddb2$var$Sg(b, a.mode, c), b.return = a, b;
                case $c32e4b0ba829ddb2$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($c32e4b0ba829ddb2$var$eb(b) || $c32e4b0ba829ddb2$var$Ka(b)) return b = $c32e4b0ba829ddb2$var$Tg(b, a.mode, c, null), b.return = a, b;
            $c32e4b0ba829ddb2$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === (typeof c === "undefined" ? "undefined" : (0, $2bfPH._)(c)) && null !== c) {
            switch(c.$$typeof){
                case $c32e4b0ba829ddb2$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $c32e4b0ba829ddb2$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $c32e4b0ba829ddb2$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($c32e4b0ba829ddb2$var$eb(c) || $c32e4b0ba829ddb2$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $c32e4b0ba829ddb2$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === (typeof d === "undefined" ? "undefined" : (0, $2bfPH._)(d)) && null !== d) {
            switch(d.$$typeof){
                case $c32e4b0ba829ddb2$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $c32e4b0ba829ddb2$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $c32e4b0ba829ddb2$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($c32e4b0ba829ddb2$var$eb(d) || $c32e4b0ba829ddb2$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $c32e4b0ba829ddb2$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $c32e4b0ba829ddb2$var$I && $c32e4b0ba829ddb2$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $c32e4b0ba829ddb2$var$I && $c32e4b0ba829ddb2$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $c32e4b0ba829ddb2$var$I && $c32e4b0ba829ddb2$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $c32e4b0ba829ddb2$var$Ka(h);
        if ("function" !== typeof l) throw Error($c32e4b0ba829ddb2$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($c32e4b0ba829ddb2$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $c32e4b0ba829ddb2$var$I && $c32e4b0ba829ddb2$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $c32e4b0ba829ddb2$var$I && $c32e4b0ba829ddb2$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $c32e4b0ba829ddb2$var$I && $c32e4b0ba829ddb2$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === (typeof f === "undefined" ? "undefined" : (0, $2bfPH._)(f)) && null !== f && f.type === $c32e4b0ba829ddb2$var$ya && null === f.key && (f = f.props.children);
        if ("object" === (typeof f === "undefined" ? "undefined" : (0, $2bfPH._)(f)) && null !== f) {
            switch(f.$$typeof){
                case $c32e4b0ba829ddb2$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $c32e4b0ba829ddb2$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === (typeof k === "undefined" ? "undefined" : (0, $2bfPH._)(k)) && null !== k && k.$$typeof === $c32e4b0ba829ddb2$var$Ha && $c32e4b0ba829ddb2$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $c32e4b0ba829ddb2$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $c32e4b0ba829ddb2$var$ya ? (d = $c32e4b0ba829ddb2$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $c32e4b0ba829ddb2$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $c32e4b0ba829ddb2$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $c32e4b0ba829ddb2$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $c32e4b0ba829ddb2$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $c32e4b0ba829ddb2$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($c32e4b0ba829ddb2$var$eb(f)) return n(a, d, f, h);
            if ($c32e4b0ba829ddb2$var$Ka(f)) return t(a, d, f, h);
            $c32e4b0ba829ddb2$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $c32e4b0ba829ddb2$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $c32e4b0ba829ddb2$var$Ug = $c32e4b0ba829ddb2$var$Og(!0), $c32e4b0ba829ddb2$var$Vg = $c32e4b0ba829ddb2$var$Og(!1), $c32e4b0ba829ddb2$var$Wg = $c32e4b0ba829ddb2$var$Uf(null), $c32e4b0ba829ddb2$var$Xg = null, $c32e4b0ba829ddb2$var$Yg = null, $c32e4b0ba829ddb2$var$Zg = null;
function $c32e4b0ba829ddb2$var$$g() {
    $c32e4b0ba829ddb2$var$Zg = $c32e4b0ba829ddb2$var$Yg = $c32e4b0ba829ddb2$var$Xg = null;
}
function $c32e4b0ba829ddb2$var$ah(a) {
    var b = $c32e4b0ba829ddb2$var$Wg.current;
    $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$Wg);
    a._currentValue = b;
}
function $c32e4b0ba829ddb2$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $c32e4b0ba829ddb2$var$ch(a, b) {
    $c32e4b0ba829ddb2$var$Xg = a;
    $c32e4b0ba829ddb2$var$Zg = $c32e4b0ba829ddb2$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($c32e4b0ba829ddb2$var$dh = !0), a.firstContext = null);
}
function $c32e4b0ba829ddb2$var$eh(a) {
    var b = a._currentValue;
    if ($c32e4b0ba829ddb2$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $c32e4b0ba829ddb2$var$Yg) {
            if (null === $c32e4b0ba829ddb2$var$Xg) throw Error($c32e4b0ba829ddb2$var$p(308));
            $c32e4b0ba829ddb2$var$Yg = a;
            $c32e4b0ba829ddb2$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $c32e4b0ba829ddb2$var$Yg = $c32e4b0ba829ddb2$var$Yg.next = a;
    }
    return b;
}
var $c32e4b0ba829ddb2$var$fh = null;
function $c32e4b0ba829ddb2$var$gh(a) {
    null === $c32e4b0ba829ddb2$var$fh ? $c32e4b0ba829ddb2$var$fh = [
        a
    ] : $c32e4b0ba829ddb2$var$fh.push(a);
}
function $c32e4b0ba829ddb2$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $c32e4b0ba829ddb2$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $c32e4b0ba829ddb2$var$ih(a, d);
}
function $c32e4b0ba829ddb2$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $c32e4b0ba829ddb2$var$jh = !1;
function $c32e4b0ba829ddb2$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $c32e4b0ba829ddb2$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $c32e4b0ba829ddb2$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c32e4b0ba829ddb2$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($c32e4b0ba829ddb2$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $c32e4b0ba829ddb2$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $c32e4b0ba829ddb2$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $c32e4b0ba829ddb2$var$ih(a, c);
}
function $c32e4b0ba829ddb2$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c32e4b0ba829ddb2$var$Cc(a, c);
    }
}
function $c32e4b0ba829ddb2$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $c32e4b0ba829ddb2$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $c32e4b0ba829ddb2$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $c32e4b0ba829ddb2$var$A({}, q, r);
                            break a;
                        case 2:
                            $c32e4b0ba829ddb2$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $c32e4b0ba829ddb2$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $c32e4b0ba829ddb2$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($c32e4b0ba829ddb2$var$p(191, e));
            e.call(d);
        }
    }
}
var $c32e4b0ba829ddb2$var$th = {}, $c32e4b0ba829ddb2$var$uh = $c32e4b0ba829ddb2$var$Uf($c32e4b0ba829ddb2$var$th), $c32e4b0ba829ddb2$var$vh = $c32e4b0ba829ddb2$var$Uf($c32e4b0ba829ddb2$var$th), $c32e4b0ba829ddb2$var$wh = $c32e4b0ba829ddb2$var$Uf($c32e4b0ba829ddb2$var$th);
function $c32e4b0ba829ddb2$var$xh(a) {
    if (a === $c32e4b0ba829ddb2$var$th) throw Error($c32e4b0ba829ddb2$var$p(174));
    return a;
}
function $c32e4b0ba829ddb2$var$yh(a, b) {
    $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$wh, b);
    $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$vh, a);
    $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$uh, $c32e4b0ba829ddb2$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $c32e4b0ba829ddb2$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $c32e4b0ba829ddb2$var$lb(b, a);
    }
    $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$uh);
    $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$uh, b);
}
function $c32e4b0ba829ddb2$var$zh() {
    $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$uh);
    $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$vh);
    $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$wh);
}
function $c32e4b0ba829ddb2$var$Ah(a) {
    $c32e4b0ba829ddb2$var$xh($c32e4b0ba829ddb2$var$wh.current);
    var b = $c32e4b0ba829ddb2$var$xh($c32e4b0ba829ddb2$var$uh.current);
    var c = $c32e4b0ba829ddb2$var$lb(b, a.type);
    b !== c && ($c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$vh, a), $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$uh, c));
}
function $c32e4b0ba829ddb2$var$Bh(a) {
    $c32e4b0ba829ddb2$var$vh.current === a && ($c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$uh), $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$vh));
}
var $c32e4b0ba829ddb2$var$L = $c32e4b0ba829ddb2$var$Uf(0);
function $c32e4b0ba829ddb2$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $c32e4b0ba829ddb2$var$Dh = [];
function $c32e4b0ba829ddb2$var$Eh() {
    for(var a = 0; a < $c32e4b0ba829ddb2$var$Dh.length; a++)$c32e4b0ba829ddb2$var$Dh[a]._workInProgressVersionPrimary = null;
    $c32e4b0ba829ddb2$var$Dh.length = 0;
}
var $c32e4b0ba829ddb2$var$Fh = $c32e4b0ba829ddb2$var$ua.ReactCurrentDispatcher, $c32e4b0ba829ddb2$var$Gh = $c32e4b0ba829ddb2$var$ua.ReactCurrentBatchConfig, $c32e4b0ba829ddb2$var$Hh = 0, $c32e4b0ba829ddb2$var$M = null, $c32e4b0ba829ddb2$var$N = null, $c32e4b0ba829ddb2$var$O = null, $c32e4b0ba829ddb2$var$Ih = !1, $c32e4b0ba829ddb2$var$Jh = !1, $c32e4b0ba829ddb2$var$Kh = 0, $c32e4b0ba829ddb2$var$Lh = 0;
function $c32e4b0ba829ddb2$var$P() {
    throw Error($c32e4b0ba829ddb2$var$p(321));
}
function $c32e4b0ba829ddb2$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$c32e4b0ba829ddb2$var$He(a[c], b[c])) return !1;
    return !0;
}
function $c32e4b0ba829ddb2$var$Nh(a, b, c, d, e, f) {
    $c32e4b0ba829ddb2$var$Hh = f;
    $c32e4b0ba829ddb2$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $c32e4b0ba829ddb2$var$Fh.current = null === a || null === a.memoizedState ? $c32e4b0ba829ddb2$var$Oh : $c32e4b0ba829ddb2$var$Ph;
    a = c(d, e);
    if ($c32e4b0ba829ddb2$var$Jh) {
        f = 0;
        do {
            $c32e4b0ba829ddb2$var$Jh = !1;
            $c32e4b0ba829ddb2$var$Kh = 0;
            if (25 <= f) throw Error($c32e4b0ba829ddb2$var$p(301));
            f += 1;
            $c32e4b0ba829ddb2$var$O = $c32e4b0ba829ddb2$var$N = null;
            b.updateQueue = null;
            $c32e4b0ba829ddb2$var$Fh.current = $c32e4b0ba829ddb2$var$Qh;
            a = c(d, e);
        }while ($c32e4b0ba829ddb2$var$Jh);
    }
    $c32e4b0ba829ddb2$var$Fh.current = $c32e4b0ba829ddb2$var$Rh;
    b = null !== $c32e4b0ba829ddb2$var$N && null !== $c32e4b0ba829ddb2$var$N.next;
    $c32e4b0ba829ddb2$var$Hh = 0;
    $c32e4b0ba829ddb2$var$O = $c32e4b0ba829ddb2$var$N = $c32e4b0ba829ddb2$var$M = null;
    $c32e4b0ba829ddb2$var$Ih = !1;
    if (b) throw Error($c32e4b0ba829ddb2$var$p(300));
    return a;
}
function $c32e4b0ba829ddb2$var$Sh() {
    var a = 0 !== $c32e4b0ba829ddb2$var$Kh;
    $c32e4b0ba829ddb2$var$Kh = 0;
    return a;
}
function $c32e4b0ba829ddb2$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c32e4b0ba829ddb2$var$O ? $c32e4b0ba829ddb2$var$M.memoizedState = $c32e4b0ba829ddb2$var$O = a : $c32e4b0ba829ddb2$var$O = $c32e4b0ba829ddb2$var$O.next = a;
    return $c32e4b0ba829ddb2$var$O;
}
function $c32e4b0ba829ddb2$var$Uh() {
    if (null === $c32e4b0ba829ddb2$var$N) {
        var a = $c32e4b0ba829ddb2$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $c32e4b0ba829ddb2$var$N.next;
    var b = null === $c32e4b0ba829ddb2$var$O ? $c32e4b0ba829ddb2$var$M.memoizedState : $c32e4b0ba829ddb2$var$O.next;
    if (null !== b) $c32e4b0ba829ddb2$var$O = b, $c32e4b0ba829ddb2$var$N = a;
    else {
        if (null === a) throw Error($c32e4b0ba829ddb2$var$p(310));
        $c32e4b0ba829ddb2$var$N = a;
        a = {
            memoizedState: $c32e4b0ba829ddb2$var$N.memoizedState,
            baseState: $c32e4b0ba829ddb2$var$N.baseState,
            baseQueue: $c32e4b0ba829ddb2$var$N.baseQueue,
            queue: $c32e4b0ba829ddb2$var$N.queue,
            next: null
        };
        null === $c32e4b0ba829ddb2$var$O ? $c32e4b0ba829ddb2$var$M.memoizedState = $c32e4b0ba829ddb2$var$O = a : $c32e4b0ba829ddb2$var$O = $c32e4b0ba829ddb2$var$O.next = a;
    }
    return $c32e4b0ba829ddb2$var$O;
}
function $c32e4b0ba829ddb2$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $c32e4b0ba829ddb2$var$Wh(a) {
    var b = $c32e4b0ba829ddb2$var$Uh(), c = b.queue;
    if (null === c) throw Error($c32e4b0ba829ddb2$var$p(311));
    c.lastRenderedReducer = a;
    var d = $c32e4b0ba829ddb2$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($c32e4b0ba829ddb2$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $c32e4b0ba829ddb2$var$M.lanes |= m;
                $c32e4b0ba829ddb2$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $c32e4b0ba829ddb2$var$He(d, b.memoizedState) || ($c32e4b0ba829ddb2$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $c32e4b0ba829ddb2$var$M.lanes |= f, $c32e4b0ba829ddb2$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $c32e4b0ba829ddb2$var$Xh(a) {
    var b = $c32e4b0ba829ddb2$var$Uh(), c = b.queue;
    if (null === c) throw Error($c32e4b0ba829ddb2$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $c32e4b0ba829ddb2$var$He(f, b.memoizedState) || ($c32e4b0ba829ddb2$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $c32e4b0ba829ddb2$var$Yh() {}
function $c32e4b0ba829ddb2$var$Zh(a, b) {
    var c = $c32e4b0ba829ddb2$var$M, d = $c32e4b0ba829ddb2$var$Uh(), e = b(), f = !$c32e4b0ba829ddb2$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $c32e4b0ba829ddb2$var$dh = !0);
    d = d.queue;
    $c32e4b0ba829ddb2$var$$h($c32e4b0ba829ddb2$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $c32e4b0ba829ddb2$var$O && $c32e4b0ba829ddb2$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $c32e4b0ba829ddb2$var$bi(9, $c32e4b0ba829ddb2$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $c32e4b0ba829ddb2$var$Q) throw Error($c32e4b0ba829ddb2$var$p(349));
        0 !== ($c32e4b0ba829ddb2$var$Hh & 30) || $c32e4b0ba829ddb2$var$di(c, b, e);
    }
    return e;
}
function $c32e4b0ba829ddb2$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $c32e4b0ba829ddb2$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c32e4b0ba829ddb2$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $c32e4b0ba829ddb2$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $c32e4b0ba829ddb2$var$ei(b) && $c32e4b0ba829ddb2$var$fi(a);
}
function $c32e4b0ba829ddb2$var$ai(a, b, c) {
    return c(function() {
        $c32e4b0ba829ddb2$var$ei(b) && $c32e4b0ba829ddb2$var$fi(a);
    });
}
function $c32e4b0ba829ddb2$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$c32e4b0ba829ddb2$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $c32e4b0ba829ddb2$var$fi(a) {
    var b = $c32e4b0ba829ddb2$var$ih(a, 1);
    null !== b && $c32e4b0ba829ddb2$var$gi(b, a, 1, -1);
}
function $c32e4b0ba829ddb2$var$hi(a) {
    var b = $c32e4b0ba829ddb2$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c32e4b0ba829ddb2$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $c32e4b0ba829ddb2$var$ii.bind(null, $c32e4b0ba829ddb2$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $c32e4b0ba829ddb2$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $c32e4b0ba829ddb2$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c32e4b0ba829ddb2$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $c32e4b0ba829ddb2$var$ji() {
    return $c32e4b0ba829ddb2$var$Uh().memoizedState;
}
function $c32e4b0ba829ddb2$var$ki(a, b, c, d) {
    var e = $c32e4b0ba829ddb2$var$Th();
    $c32e4b0ba829ddb2$var$M.flags |= a;
    e.memoizedState = $c32e4b0ba829ddb2$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $c32e4b0ba829ddb2$var$li(a, b, c, d) {
    var e = $c32e4b0ba829ddb2$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $c32e4b0ba829ddb2$var$N) {
        var g = $c32e4b0ba829ddb2$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $c32e4b0ba829ddb2$var$Mh(d, g.deps)) {
            e.memoizedState = $c32e4b0ba829ddb2$var$bi(b, c, f, d);
            return;
        }
    }
    $c32e4b0ba829ddb2$var$M.flags |= a;
    e.memoizedState = $c32e4b0ba829ddb2$var$bi(1 | b, c, f, d);
}
function $c32e4b0ba829ddb2$var$mi(a, b) {
    return $c32e4b0ba829ddb2$var$ki(8390656, 8, a, b);
}
function $c32e4b0ba829ddb2$var$$h(a, b) {
    return $c32e4b0ba829ddb2$var$li(2048, 8, a, b);
}
function $c32e4b0ba829ddb2$var$ni(a, b) {
    return $c32e4b0ba829ddb2$var$li(4, 2, a, b);
}
function $c32e4b0ba829ddb2$var$oi(a, b) {
    return $c32e4b0ba829ddb2$var$li(4, 4, a, b);
}
function $c32e4b0ba829ddb2$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $c32e4b0ba829ddb2$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $c32e4b0ba829ddb2$var$li(4, 4, $c32e4b0ba829ddb2$var$pi.bind(null, b, a), c);
}
function $c32e4b0ba829ddb2$var$ri() {}
function $c32e4b0ba829ddb2$var$si(a, b) {
    var c = $c32e4b0ba829ddb2$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c32e4b0ba829ddb2$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c32e4b0ba829ddb2$var$ti(a, b) {
    var c = $c32e4b0ba829ddb2$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c32e4b0ba829ddb2$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c32e4b0ba829ddb2$var$ui(a, b, c) {
    if (0 === ($c32e4b0ba829ddb2$var$Hh & 21)) return a.baseState && (a.baseState = !1, $c32e4b0ba829ddb2$var$dh = !0), a.memoizedState = c;
    $c32e4b0ba829ddb2$var$He(c, b) || (c = $c32e4b0ba829ddb2$var$yc(), $c32e4b0ba829ddb2$var$M.lanes |= c, $c32e4b0ba829ddb2$var$rh |= c, a.baseState = !0);
    return b;
}
function $c32e4b0ba829ddb2$var$vi(a, b) {
    var c = $c32e4b0ba829ddb2$var$C;
    $c32e4b0ba829ddb2$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $c32e4b0ba829ddb2$var$Gh.transition;
    $c32e4b0ba829ddb2$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $c32e4b0ba829ddb2$var$C = c, $c32e4b0ba829ddb2$var$Gh.transition = d;
    }
}
function $c32e4b0ba829ddb2$var$wi() {
    return $c32e4b0ba829ddb2$var$Uh().memoizedState;
}
function $c32e4b0ba829ddb2$var$xi(a, b, c) {
    var d = $c32e4b0ba829ddb2$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c32e4b0ba829ddb2$var$zi(a)) $c32e4b0ba829ddb2$var$Ai(b, c);
    else if (c = $c32e4b0ba829ddb2$var$hh(a, b, c, d), null !== c) {
        var e = $c32e4b0ba829ddb2$var$R();
        $c32e4b0ba829ddb2$var$gi(c, a, d, e);
        $c32e4b0ba829ddb2$var$Bi(c, b, d);
    }
}
function $c32e4b0ba829ddb2$var$ii(a, b, c) {
    var d = $c32e4b0ba829ddb2$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c32e4b0ba829ddb2$var$zi(a)) $c32e4b0ba829ddb2$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($c32e4b0ba829ddb2$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $c32e4b0ba829ddb2$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $c32e4b0ba829ddb2$var$hh(a, b, e, d);
        null !== c && (e = $c32e4b0ba829ddb2$var$R(), $c32e4b0ba829ddb2$var$gi(c, a, d, e), $c32e4b0ba829ddb2$var$Bi(c, b, d));
    }
}
function $c32e4b0ba829ddb2$var$zi(a) {
    var b = a.alternate;
    return a === $c32e4b0ba829ddb2$var$M || null !== b && b === $c32e4b0ba829ddb2$var$M;
}
function $c32e4b0ba829ddb2$var$Ai(a, b) {
    $c32e4b0ba829ddb2$var$Jh = $c32e4b0ba829ddb2$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $c32e4b0ba829ddb2$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c32e4b0ba829ddb2$var$Cc(a, c);
    }
}
var $c32e4b0ba829ddb2$var$Rh = {
    readContext: $c32e4b0ba829ddb2$var$eh,
    useCallback: $c32e4b0ba829ddb2$var$P,
    useContext: $c32e4b0ba829ddb2$var$P,
    useEffect: $c32e4b0ba829ddb2$var$P,
    useImperativeHandle: $c32e4b0ba829ddb2$var$P,
    useInsertionEffect: $c32e4b0ba829ddb2$var$P,
    useLayoutEffect: $c32e4b0ba829ddb2$var$P,
    useMemo: $c32e4b0ba829ddb2$var$P,
    useReducer: $c32e4b0ba829ddb2$var$P,
    useRef: $c32e4b0ba829ddb2$var$P,
    useState: $c32e4b0ba829ddb2$var$P,
    useDebugValue: $c32e4b0ba829ddb2$var$P,
    useDeferredValue: $c32e4b0ba829ddb2$var$P,
    useTransition: $c32e4b0ba829ddb2$var$P,
    useMutableSource: $c32e4b0ba829ddb2$var$P,
    useSyncExternalStore: $c32e4b0ba829ddb2$var$P,
    useId: $c32e4b0ba829ddb2$var$P,
    unstable_isNewReconciler: !1
}, $c32e4b0ba829ddb2$var$Oh = {
    readContext: $c32e4b0ba829ddb2$var$eh,
    useCallback: function useCallback(a, b) {
        $c32e4b0ba829ddb2$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $c32e4b0ba829ddb2$var$eh,
    useEffect: $c32e4b0ba829ddb2$var$mi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $c32e4b0ba829ddb2$var$ki(4194308, 4, $c32e4b0ba829ddb2$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $c32e4b0ba829ddb2$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $c32e4b0ba829ddb2$var$ki(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $c32e4b0ba829ddb2$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $c32e4b0ba829ddb2$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $c32e4b0ba829ddb2$var$xi.bind(null, $c32e4b0ba829ddb2$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $c32e4b0ba829ddb2$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $c32e4b0ba829ddb2$var$hi,
    useDebugValue: $c32e4b0ba829ddb2$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        return $c32e4b0ba829ddb2$var$Th().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $c32e4b0ba829ddb2$var$hi(!1), b = a[0];
        a = $c32e4b0ba829ddb2$var$vi.bind(null, a[1]);
        $c32e4b0ba829ddb2$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $c32e4b0ba829ddb2$var$M, e = $c32e4b0ba829ddb2$var$Th();
        if ($c32e4b0ba829ddb2$var$I) {
            if (void 0 === c) throw Error($c32e4b0ba829ddb2$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $c32e4b0ba829ddb2$var$Q) throw Error($c32e4b0ba829ddb2$var$p(349));
            0 !== ($c32e4b0ba829ddb2$var$Hh & 30) || $c32e4b0ba829ddb2$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $c32e4b0ba829ddb2$var$mi($c32e4b0ba829ddb2$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $c32e4b0ba829ddb2$var$bi(9, $c32e4b0ba829ddb2$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $c32e4b0ba829ddb2$var$Th(), b = $c32e4b0ba829ddb2$var$Q.identifierPrefix;
        if ($c32e4b0ba829ddb2$var$I) {
            var c = $c32e4b0ba829ddb2$var$sg;
            var d = $c32e4b0ba829ddb2$var$rg;
            c = (d & ~(1 << 32 - $c32e4b0ba829ddb2$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $c32e4b0ba829ddb2$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $c32e4b0ba829ddb2$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $c32e4b0ba829ddb2$var$Ph = {
    readContext: $c32e4b0ba829ddb2$var$eh,
    useCallback: $c32e4b0ba829ddb2$var$si,
    useContext: $c32e4b0ba829ddb2$var$eh,
    useEffect: $c32e4b0ba829ddb2$var$$h,
    useImperativeHandle: $c32e4b0ba829ddb2$var$qi,
    useInsertionEffect: $c32e4b0ba829ddb2$var$ni,
    useLayoutEffect: $c32e4b0ba829ddb2$var$oi,
    useMemo: $c32e4b0ba829ddb2$var$ti,
    useReducer: $c32e4b0ba829ddb2$var$Wh,
    useRef: $c32e4b0ba829ddb2$var$ji,
    useState: function useState() {
        return $c32e4b0ba829ddb2$var$Wh($c32e4b0ba829ddb2$var$Vh);
    },
    useDebugValue: $c32e4b0ba829ddb2$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $c32e4b0ba829ddb2$var$Uh();
        return $c32e4b0ba829ddb2$var$ui(b, $c32e4b0ba829ddb2$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $c32e4b0ba829ddb2$var$Wh($c32e4b0ba829ddb2$var$Vh)[0], b = $c32e4b0ba829ddb2$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c32e4b0ba829ddb2$var$Yh,
    useSyncExternalStore: $c32e4b0ba829ddb2$var$Zh,
    useId: $c32e4b0ba829ddb2$var$wi,
    unstable_isNewReconciler: !1
}, $c32e4b0ba829ddb2$var$Qh = {
    readContext: $c32e4b0ba829ddb2$var$eh,
    useCallback: $c32e4b0ba829ddb2$var$si,
    useContext: $c32e4b0ba829ddb2$var$eh,
    useEffect: $c32e4b0ba829ddb2$var$$h,
    useImperativeHandle: $c32e4b0ba829ddb2$var$qi,
    useInsertionEffect: $c32e4b0ba829ddb2$var$ni,
    useLayoutEffect: $c32e4b0ba829ddb2$var$oi,
    useMemo: $c32e4b0ba829ddb2$var$ti,
    useReducer: $c32e4b0ba829ddb2$var$Xh,
    useRef: $c32e4b0ba829ddb2$var$ji,
    useState: function useState() {
        return $c32e4b0ba829ddb2$var$Xh($c32e4b0ba829ddb2$var$Vh);
    },
    useDebugValue: $c32e4b0ba829ddb2$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $c32e4b0ba829ddb2$var$Uh();
        return null === $c32e4b0ba829ddb2$var$N ? b.memoizedState = a : $c32e4b0ba829ddb2$var$ui(b, $c32e4b0ba829ddb2$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $c32e4b0ba829ddb2$var$Xh($c32e4b0ba829ddb2$var$Vh)[0], b = $c32e4b0ba829ddb2$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c32e4b0ba829ddb2$var$Yh,
    useSyncExternalStore: $c32e4b0ba829ddb2$var$Zh,
    useId: $c32e4b0ba829ddb2$var$wi,
    unstable_isNewReconciler: !1
};
function $c32e4b0ba829ddb2$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $c32e4b0ba829ddb2$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $c32e4b0ba829ddb2$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $c32e4b0ba829ddb2$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $c32e4b0ba829ddb2$var$Ei = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $c32e4b0ba829ddb2$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $c32e4b0ba829ddb2$var$R(), e = $c32e4b0ba829ddb2$var$yi(a), f = $c32e4b0ba829ddb2$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c32e4b0ba829ddb2$var$nh(a, f, e);
        null !== b && ($c32e4b0ba829ddb2$var$gi(b, a, e, d), $c32e4b0ba829ddb2$var$oh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $c32e4b0ba829ddb2$var$R(), e = $c32e4b0ba829ddb2$var$yi(a), f = $c32e4b0ba829ddb2$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c32e4b0ba829ddb2$var$nh(a, f, e);
        null !== b && ($c32e4b0ba829ddb2$var$gi(b, a, e, d), $c32e4b0ba829ddb2$var$oh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $c32e4b0ba829ddb2$var$R(), d = $c32e4b0ba829ddb2$var$yi(a), e = $c32e4b0ba829ddb2$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $c32e4b0ba829ddb2$var$nh(a, e, d);
        null !== b && ($c32e4b0ba829ddb2$var$gi(b, a, d, c), $c32e4b0ba829ddb2$var$oh(b, a, d));
    }
};
function $c32e4b0ba829ddb2$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$c32e4b0ba829ddb2$var$Ie(c, d) || !$c32e4b0ba829ddb2$var$Ie(e, f) : !0;
}
function $c32e4b0ba829ddb2$var$Gi(a, b, c) {
    var d = !1, e = $c32e4b0ba829ddb2$var$Vf;
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, $2bfPH._)(f)) && null !== f ? f = $c32e4b0ba829ddb2$var$eh(f) : (e = $c32e4b0ba829ddb2$var$Zf(b) ? $c32e4b0ba829ddb2$var$Xf : $c32e4b0ba829ddb2$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $c32e4b0ba829ddb2$var$Yf(a, e) : $c32e4b0ba829ddb2$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $c32e4b0ba829ddb2$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $c32e4b0ba829ddb2$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $c32e4b0ba829ddb2$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $c32e4b0ba829ddb2$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $c32e4b0ba829ddb2$var$kh(a);
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, $2bfPH._)(f)) && null !== f ? e.context = $c32e4b0ba829ddb2$var$eh(f) : (f = $c32e4b0ba829ddb2$var$Zf(b) ? $c32e4b0ba829ddb2$var$Xf : $c32e4b0ba829ddb2$var$H.current, e.context = $c32e4b0ba829ddb2$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($c32e4b0ba829ddb2$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $c32e4b0ba829ddb2$var$Ei.enqueueReplaceState(e, e.state, null), $c32e4b0ba829ddb2$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $c32e4b0ba829ddb2$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $c32e4b0ba829ddb2$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $c32e4b0ba829ddb2$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $c32e4b0ba829ddb2$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $c32e4b0ba829ddb2$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $c32e4b0ba829ddb2$var$Ni(a, b, c) {
    c = $c32e4b0ba829ddb2$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $c32e4b0ba829ddb2$var$Oi || ($c32e4b0ba829ddb2$var$Oi = !0, $c32e4b0ba829ddb2$var$Pi = d);
        $c32e4b0ba829ddb2$var$Li(a, b);
    };
    return c;
}
function $c32e4b0ba829ddb2$var$Qi(a, b, c) {
    c = $c32e4b0ba829ddb2$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $c32e4b0ba829ddb2$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $c32e4b0ba829ddb2$var$Li(a, b);
        "function" !== typeof d && (null === $c32e4b0ba829ddb2$var$Ri ? $c32e4b0ba829ddb2$var$Ri = new Set([
            this
        ]) : $c32e4b0ba829ddb2$var$Ri.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $c32e4b0ba829ddb2$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $c32e4b0ba829ddb2$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $c32e4b0ba829ddb2$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $c32e4b0ba829ddb2$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $c32e4b0ba829ddb2$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $c32e4b0ba829ddb2$var$mh(-1, 1), b.tag = 2, $c32e4b0ba829ddb2$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $c32e4b0ba829ddb2$var$Wi = $c32e4b0ba829ddb2$var$ua.ReactCurrentOwner, $c32e4b0ba829ddb2$var$dh = !1;
function $c32e4b0ba829ddb2$var$Xi(a, b, c, d) {
    b.child = null === a ? $c32e4b0ba829ddb2$var$Vg(b, null, c, d) : $c32e4b0ba829ddb2$var$Ug(b, a.child, c, d);
}
function $c32e4b0ba829ddb2$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $c32e4b0ba829ddb2$var$ch(b, e);
    d = $c32e4b0ba829ddb2$var$Nh(a, b, c, d, f, e);
    c = $c32e4b0ba829ddb2$var$Sh();
    if (null !== a && !$c32e4b0ba829ddb2$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c32e4b0ba829ddb2$var$Zi(a, b, e);
    $c32e4b0ba829ddb2$var$I && c && $c32e4b0ba829ddb2$var$vg(b);
    b.flags |= 1;
    $c32e4b0ba829ddb2$var$Xi(a, b, d, e);
    return b.child;
}
function $c32e4b0ba829ddb2$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$c32e4b0ba829ddb2$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $c32e4b0ba829ddb2$var$bj(a, b, f, d, e);
        a = $c32e4b0ba829ddb2$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $c32e4b0ba829ddb2$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $c32e4b0ba829ddb2$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $c32e4b0ba829ddb2$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $c32e4b0ba829ddb2$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($c32e4b0ba829ddb2$var$Ie(f, d) && a.ref === b.ref) {
            if ($c32e4b0ba829ddb2$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($c32e4b0ba829ddb2$var$dh = !0);
            else return b.lanes = a.lanes, $c32e4b0ba829ddb2$var$Zi(a, b, e);
        }
    }
    return $c32e4b0ba829ddb2$var$cj(a, b, c, d, e);
}
function $c32e4b0ba829ddb2$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$ej, $c32e4b0ba829ddb2$var$fj), $c32e4b0ba829ddb2$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$ej, $c32e4b0ba829ddb2$var$fj), $c32e4b0ba829ddb2$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$ej, $c32e4b0ba829ddb2$var$fj);
            $c32e4b0ba829ddb2$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$ej, $c32e4b0ba829ddb2$var$fj), $c32e4b0ba829ddb2$var$fj |= d;
    $c32e4b0ba829ddb2$var$Xi(a, b, e, c);
    return b.child;
}
function $c32e4b0ba829ddb2$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $c32e4b0ba829ddb2$var$cj(a, b, c, d, e) {
    var f = $c32e4b0ba829ddb2$var$Zf(c) ? $c32e4b0ba829ddb2$var$Xf : $c32e4b0ba829ddb2$var$H.current;
    f = $c32e4b0ba829ddb2$var$Yf(b, f);
    $c32e4b0ba829ddb2$var$ch(b, e);
    c = $c32e4b0ba829ddb2$var$Nh(a, b, c, d, f, e);
    d = $c32e4b0ba829ddb2$var$Sh();
    if (null !== a && !$c32e4b0ba829ddb2$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c32e4b0ba829ddb2$var$Zi(a, b, e);
    $c32e4b0ba829ddb2$var$I && d && $c32e4b0ba829ddb2$var$vg(b);
    b.flags |= 1;
    $c32e4b0ba829ddb2$var$Xi(a, b, c, e);
    return b.child;
}
function $c32e4b0ba829ddb2$var$hj(a, b, c, d, e) {
    if ($c32e4b0ba829ddb2$var$Zf(c)) {
        var f = !0;
        $c32e4b0ba829ddb2$var$cg(b);
    } else f = !1;
    $c32e4b0ba829ddb2$var$ch(b, e);
    if (null === b.stateNode) $c32e4b0ba829ddb2$var$ij(a, b), $c32e4b0ba829ddb2$var$Gi(b, c, d), $c32e4b0ba829ddb2$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === (typeof l === "undefined" ? "undefined" : (0, $2bfPH._)(l)) && null !== l ? l = $c32e4b0ba829ddb2$var$eh(l) : (l = $c32e4b0ba829ddb2$var$Zf(c) ? $c32e4b0ba829ddb2$var$Xf : $c32e4b0ba829ddb2$var$H.current, l = $c32e4b0ba829ddb2$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $c32e4b0ba829ddb2$var$Hi(b, g, d, l);
        $c32e4b0ba829ddb2$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $c32e4b0ba829ddb2$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $c32e4b0ba829ddb2$var$Wf.current || $c32e4b0ba829ddb2$var$jh ? ("function" === typeof m && ($c32e4b0ba829ddb2$var$Di(b, c, m, d), k = b.memoizedState), (h = $c32e4b0ba829ddb2$var$jh || $c32e4b0ba829ddb2$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $c32e4b0ba829ddb2$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $c32e4b0ba829ddb2$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === (typeof k === "undefined" ? "undefined" : (0, $2bfPH._)(k)) && null !== k ? k = $c32e4b0ba829ddb2$var$eh(k) : (k = $c32e4b0ba829ddb2$var$Zf(c) ? $c32e4b0ba829ddb2$var$Xf : $c32e4b0ba829ddb2$var$H.current, k = $c32e4b0ba829ddb2$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $c32e4b0ba829ddb2$var$Hi(b, g, d, k);
        $c32e4b0ba829ddb2$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $c32e4b0ba829ddb2$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $c32e4b0ba829ddb2$var$Wf.current || $c32e4b0ba829ddb2$var$jh ? ("function" === typeof y && ($c32e4b0ba829ddb2$var$Di(b, c, y, d), n = b.memoizedState), (l = $c32e4b0ba829ddb2$var$jh || $c32e4b0ba829ddb2$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $c32e4b0ba829ddb2$var$jj(a, b, c, d, f, e);
}
function $c32e4b0ba829ddb2$var$jj(a, b, c, d, e, f) {
    $c32e4b0ba829ddb2$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $c32e4b0ba829ddb2$var$dg(b, c, !1), $c32e4b0ba829ddb2$var$Zi(a, b, f);
    d = b.stateNode;
    $c32e4b0ba829ddb2$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $c32e4b0ba829ddb2$var$Ug(b, a.child, null, f), b.child = $c32e4b0ba829ddb2$var$Ug(b, null, h, f)) : $c32e4b0ba829ddb2$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $c32e4b0ba829ddb2$var$dg(b, c, !0);
    return b.child;
}
function $c32e4b0ba829ddb2$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $c32e4b0ba829ddb2$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $c32e4b0ba829ddb2$var$ag(a, b.context, !1);
    $c32e4b0ba829ddb2$var$yh(a, b.containerInfo);
}
function $c32e4b0ba829ddb2$var$lj(a, b, c, d, e) {
    $c32e4b0ba829ddb2$var$Ig();
    $c32e4b0ba829ddb2$var$Jg(e);
    b.flags |= 256;
    $c32e4b0ba829ddb2$var$Xi(a, b, c, d);
    return b.child;
}
var $c32e4b0ba829ddb2$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $c32e4b0ba829ddb2$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $c32e4b0ba829ddb2$var$oj(a, b, c) {
    var d = b.pendingProps, e = $c32e4b0ba829ddb2$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$L, e & 1);
    if (null === a) {
        $c32e4b0ba829ddb2$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $c32e4b0ba829ddb2$var$pj(g, d, 0, null), a = $c32e4b0ba829ddb2$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $c32e4b0ba829ddb2$var$nj(c), b.memoizedState = $c32e4b0ba829ddb2$var$mj, a) : $c32e4b0ba829ddb2$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $c32e4b0ba829ddb2$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $c32e4b0ba829ddb2$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $c32e4b0ba829ddb2$var$Pg(h, f) : (f = $c32e4b0ba829ddb2$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $c32e4b0ba829ddb2$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $c32e4b0ba829ddb2$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $c32e4b0ba829ddb2$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $c32e4b0ba829ddb2$var$qj(a, b) {
    b = $c32e4b0ba829ddb2$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $c32e4b0ba829ddb2$var$sj(a, b, c, d) {
    null !== d && $c32e4b0ba829ddb2$var$Jg(d);
    $c32e4b0ba829ddb2$var$Ug(b, a.child, null, c);
    a = $c32e4b0ba829ddb2$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $c32e4b0ba829ddb2$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $c32e4b0ba829ddb2$var$Ki(Error($c32e4b0ba829ddb2$var$p(422))), $c32e4b0ba829ddb2$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $c32e4b0ba829ddb2$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $c32e4b0ba829ddb2$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $c32e4b0ba829ddb2$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $c32e4b0ba829ddb2$var$nj(g);
        b.memoizedState = $c32e4b0ba829ddb2$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $c32e4b0ba829ddb2$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($c32e4b0ba829ddb2$var$p(419));
        d = $c32e4b0ba829ddb2$var$Ki(f, d, void 0);
        return $c32e4b0ba829ddb2$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($c32e4b0ba829ddb2$var$dh || h) {
        d = $c32e4b0ba829ddb2$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $c32e4b0ba829ddb2$var$ih(a, e), $c32e4b0ba829ddb2$var$gi(d, a, e, -1));
        }
        $c32e4b0ba829ddb2$var$tj();
        d = $c32e4b0ba829ddb2$var$Ki(Error($c32e4b0ba829ddb2$var$p(421)));
        return $c32e4b0ba829ddb2$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $c32e4b0ba829ddb2$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $c32e4b0ba829ddb2$var$yg = $c32e4b0ba829ddb2$var$Lf(e.nextSibling);
    $c32e4b0ba829ddb2$var$xg = b;
    $c32e4b0ba829ddb2$var$I = !0;
    $c32e4b0ba829ddb2$var$zg = null;
    null !== a && ($c32e4b0ba829ddb2$var$og[$c32e4b0ba829ddb2$var$pg++] = $c32e4b0ba829ddb2$var$rg, $c32e4b0ba829ddb2$var$og[$c32e4b0ba829ddb2$var$pg++] = $c32e4b0ba829ddb2$var$sg, $c32e4b0ba829ddb2$var$og[$c32e4b0ba829ddb2$var$pg++] = $c32e4b0ba829ddb2$var$qg, $c32e4b0ba829ddb2$var$rg = a.id, $c32e4b0ba829ddb2$var$sg = a.overflow, $c32e4b0ba829ddb2$var$qg = b);
    b = $c32e4b0ba829ddb2$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $c32e4b0ba829ddb2$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $c32e4b0ba829ddb2$var$bh(a.return, b, c);
}
function $c32e4b0ba829ddb2$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $c32e4b0ba829ddb2$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $c32e4b0ba829ddb2$var$Xi(a, b, d.children, c);
    d = $c32e4b0ba829ddb2$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $c32e4b0ba829ddb2$var$vj(a, c, b);
            else if (19 === a.tag) $c32e4b0ba829ddb2$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $c32e4b0ba829ddb2$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $c32e4b0ba829ddb2$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $c32e4b0ba829ddb2$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $c32e4b0ba829ddb2$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $c32e4b0ba829ddb2$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $c32e4b0ba829ddb2$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $c32e4b0ba829ddb2$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $c32e4b0ba829ddb2$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($c32e4b0ba829ddb2$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $c32e4b0ba829ddb2$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $c32e4b0ba829ddb2$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $c32e4b0ba829ddb2$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $c32e4b0ba829ddb2$var$kj(b);
            $c32e4b0ba829ddb2$var$Ig();
            break;
        case 5:
            $c32e4b0ba829ddb2$var$Ah(b);
            break;
        case 1:
            $c32e4b0ba829ddb2$var$Zf(b.type) && $c32e4b0ba829ddb2$var$cg(b);
            break;
        case 4:
            $c32e4b0ba829ddb2$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$L, $c32e4b0ba829ddb2$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $c32e4b0ba829ddb2$var$oj(a, b, c);
                $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$L, $c32e4b0ba829ddb2$var$L.current & 1);
                a = $c32e4b0ba829ddb2$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$L, $c32e4b0ba829ddb2$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $c32e4b0ba829ddb2$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$L, $c32e4b0ba829ddb2$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $c32e4b0ba829ddb2$var$dj(a, b, c);
    }
    return $c32e4b0ba829ddb2$var$Zi(a, b, c);
}
var $c32e4b0ba829ddb2$var$zj, $c32e4b0ba829ddb2$var$Aj, $c32e4b0ba829ddb2$var$Bj, $c32e4b0ba829ddb2$var$Cj;
$c32e4b0ba829ddb2$var$zj = function zj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$c32e4b0ba829ddb2$var$Aj = function Aj() {};
$c32e4b0ba829ddb2$var$Bj = function Bj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $c32e4b0ba829ddb2$var$xh($c32e4b0ba829ddb2$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $c32e4b0ba829ddb2$var$Ya(a, e);
                d = $c32e4b0ba829ddb2$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $c32e4b0ba829ddb2$var$A({}, e, {
                    value: void 0
                });
                d = $c32e4b0ba829ddb2$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $c32e4b0ba829ddb2$var$gb(a, e);
                d = $c32e4b0ba829ddb2$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $c32e4b0ba829ddb2$var$Bf);
        }
        $c32e4b0ba829ddb2$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($c32e4b0ba829ddb2$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($c32e4b0ba829ddb2$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $c32e4b0ba829ddb2$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$c32e4b0ba829ddb2$var$Cj = function Cj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $c32e4b0ba829ddb2$var$Dj(a, b) {
    if (!$c32e4b0ba829ddb2$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $c32e4b0ba829ddb2$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $c32e4b0ba829ddb2$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $c32e4b0ba829ddb2$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c32e4b0ba829ddb2$var$S(b), null;
        case 1:
            return $c32e4b0ba829ddb2$var$Zf(b.type) && $c32e4b0ba829ddb2$var$$f(), $c32e4b0ba829ddb2$var$S(b), null;
        case 3:
            d = b.stateNode;
            $c32e4b0ba829ddb2$var$zh();
            $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$Wf);
            $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$H);
            $c32e4b0ba829ddb2$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $c32e4b0ba829ddb2$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $c32e4b0ba829ddb2$var$zg && ($c32e4b0ba829ddb2$var$Fj($c32e4b0ba829ddb2$var$zg), $c32e4b0ba829ddb2$var$zg = null));
            $c32e4b0ba829ddb2$var$Aj(a, b);
            $c32e4b0ba829ddb2$var$S(b);
            return null;
        case 5:
            $c32e4b0ba829ddb2$var$Bh(b);
            var e = $c32e4b0ba829ddb2$var$xh($c32e4b0ba829ddb2$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $c32e4b0ba829ddb2$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($c32e4b0ba829ddb2$var$p(166));
                    $c32e4b0ba829ddb2$var$S(b);
                    return null;
                }
                a = $c32e4b0ba829ddb2$var$xh($c32e4b0ba829ddb2$var$uh.current);
                if ($c32e4b0ba829ddb2$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$c32e4b0ba829ddb2$var$Of] = b;
                    d[$c32e4b0ba829ddb2$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $c32e4b0ba829ddb2$var$D("cancel", d);
                            $c32e4b0ba829ddb2$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $c32e4b0ba829ddb2$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $c32e4b0ba829ddb2$var$lf.length; e++)$c32e4b0ba829ddb2$var$D($c32e4b0ba829ddb2$var$lf[e], d);
                            break;
                        case "source":
                            $c32e4b0ba829ddb2$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $c32e4b0ba829ddb2$var$D("error", d);
                            $c32e4b0ba829ddb2$var$D("load", d);
                            break;
                        case "details":
                            $c32e4b0ba829ddb2$var$D("toggle", d);
                            break;
                        case "input":
                            $c32e4b0ba829ddb2$var$Za(d, f);
                            $c32e4b0ba829ddb2$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $c32e4b0ba829ddb2$var$D("invalid", d);
                            break;
                        case "textarea":
                            $c32e4b0ba829ddb2$var$hb(d, f), $c32e4b0ba829ddb2$var$D("invalid", d);
                    }
                    $c32e4b0ba829ddb2$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $c32e4b0ba829ddb2$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $c32e4b0ba829ddb2$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $c32e4b0ba829ddb2$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $c32e4b0ba829ddb2$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $c32e4b0ba829ddb2$var$Va(d);
                            $c32e4b0ba829ddb2$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $c32e4b0ba829ddb2$var$Va(d);
                            $c32e4b0ba829ddb2$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $c32e4b0ba829ddb2$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $c32e4b0ba829ddb2$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$c32e4b0ba829ddb2$var$Of] = b;
                    a[$c32e4b0ba829ddb2$var$Pf] = d;
                    $c32e4b0ba829ddb2$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $c32e4b0ba829ddb2$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $c32e4b0ba829ddb2$var$D("cancel", a);
                                $c32e4b0ba829ddb2$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $c32e4b0ba829ddb2$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $c32e4b0ba829ddb2$var$lf.length; e++)$c32e4b0ba829ddb2$var$D($c32e4b0ba829ddb2$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $c32e4b0ba829ddb2$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $c32e4b0ba829ddb2$var$D("error", a);
                                $c32e4b0ba829ddb2$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $c32e4b0ba829ddb2$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $c32e4b0ba829ddb2$var$Za(a, d);
                                e = $c32e4b0ba829ddb2$var$Ya(a, d);
                                $c32e4b0ba829ddb2$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $c32e4b0ba829ddb2$var$A({}, d, {
                                    value: void 0
                                });
                                $c32e4b0ba829ddb2$var$D("invalid", a);
                                break;
                            case "textarea":
                                $c32e4b0ba829ddb2$var$hb(a, d);
                                e = $c32e4b0ba829ddb2$var$gb(a, d);
                                $c32e4b0ba829ddb2$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $c32e4b0ba829ddb2$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $c32e4b0ba829ddb2$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $c32e4b0ba829ddb2$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $c32e4b0ba829ddb2$var$ob(a, k) : "number" === typeof k && $c32e4b0ba829ddb2$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($c32e4b0ba829ddb2$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $c32e4b0ba829ddb2$var$D("scroll", a) : null != k && $c32e4b0ba829ddb2$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $c32e4b0ba829ddb2$var$Va(a);
                                $c32e4b0ba829ddb2$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $c32e4b0ba829ddb2$var$Va(a);
                                $c32e4b0ba829ddb2$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $c32e4b0ba829ddb2$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $c32e4b0ba829ddb2$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $c32e4b0ba829ddb2$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $c32e4b0ba829ddb2$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $c32e4b0ba829ddb2$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $c32e4b0ba829ddb2$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($c32e4b0ba829ddb2$var$p(166));
                c = $c32e4b0ba829ddb2$var$xh($c32e4b0ba829ddb2$var$wh.current);
                $c32e4b0ba829ddb2$var$xh($c32e4b0ba829ddb2$var$uh.current);
                if ($c32e4b0ba829ddb2$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$c32e4b0ba829ddb2$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $c32e4b0ba829ddb2$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $c32e4b0ba829ddb2$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $c32e4b0ba829ddb2$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$c32e4b0ba829ddb2$var$Of] = b, b.stateNode = d;
            }
            $c32e4b0ba829ddb2$var$S(b);
            return null;
        case 13:
            $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($c32e4b0ba829ddb2$var$I && null !== $c32e4b0ba829ddb2$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $c32e4b0ba829ddb2$var$Hg(), $c32e4b0ba829ddb2$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $c32e4b0ba829ddb2$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($c32e4b0ba829ddb2$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($c32e4b0ba829ddb2$var$p(317));
                        f[$c32e4b0ba829ddb2$var$Of] = b;
                    } else $c32e4b0ba829ddb2$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $c32e4b0ba829ddb2$var$S(b);
                    f = !1;
                } else null !== $c32e4b0ba829ddb2$var$zg && ($c32e4b0ba829ddb2$var$Fj($c32e4b0ba829ddb2$var$zg), $c32e4b0ba829ddb2$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($c32e4b0ba829ddb2$var$L.current & 1) ? 0 === $c32e4b0ba829ddb2$var$T && ($c32e4b0ba829ddb2$var$T = 3) : $c32e4b0ba829ddb2$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $c32e4b0ba829ddb2$var$S(b);
            return null;
        case 4:
            return $c32e4b0ba829ddb2$var$zh(), $c32e4b0ba829ddb2$var$Aj(a, b), null === a && $c32e4b0ba829ddb2$var$sf(b.stateNode.containerInfo), $c32e4b0ba829ddb2$var$S(b), null;
        case 10:
            return $c32e4b0ba829ddb2$var$ah(b.type._context), $c32e4b0ba829ddb2$var$S(b), null;
        case 17:
            return $c32e4b0ba829ddb2$var$Zf(b.type) && $c32e4b0ba829ddb2$var$$f(), $c32e4b0ba829ddb2$var$S(b), null;
        case 19:
            $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$L);
            f = b.memoizedState;
            if (null === f) return $c32e4b0ba829ddb2$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $c32e4b0ba829ddb2$var$Dj(f, !1);
                else {
                    if (0 !== $c32e4b0ba829ddb2$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $c32e4b0ba829ddb2$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $c32e4b0ba829ddb2$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$L, $c32e4b0ba829ddb2$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $c32e4b0ba829ddb2$var$B() > $c32e4b0ba829ddb2$var$Gj && (b.flags |= 128, d = !0, $c32e4b0ba829ddb2$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $c32e4b0ba829ddb2$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $c32e4b0ba829ddb2$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$c32e4b0ba829ddb2$var$I) return $c32e4b0ba829ddb2$var$S(b), null;
                    } else 2 * $c32e4b0ba829ddb2$var$B() - f.renderingStartTime > $c32e4b0ba829ddb2$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $c32e4b0ba829ddb2$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $c32e4b0ba829ddb2$var$B(), b.sibling = null, c = $c32e4b0ba829ddb2$var$L.current, $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$L, d ? c & 1 | 2 : c & 1), b;
            $c32e4b0ba829ddb2$var$S(b);
            return null;
        case 22:
        case 23:
            return $c32e4b0ba829ddb2$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($c32e4b0ba829ddb2$var$fj & 1073741824) && ($c32e4b0ba829ddb2$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $c32e4b0ba829ddb2$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($c32e4b0ba829ddb2$var$p(156, b.tag));
}
function $c32e4b0ba829ddb2$var$Ij(a, b) {
    $c32e4b0ba829ddb2$var$wg(b);
    switch(b.tag){
        case 1:
            return $c32e4b0ba829ddb2$var$Zf(b.type) && $c32e4b0ba829ddb2$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $c32e4b0ba829ddb2$var$zh(), $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$Wf), $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$H), $c32e4b0ba829ddb2$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $c32e4b0ba829ddb2$var$Bh(b), null;
        case 13:
            $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($c32e4b0ba829ddb2$var$p(340));
                $c32e4b0ba829ddb2$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$L), null;
        case 4:
            return $c32e4b0ba829ddb2$var$zh(), null;
        case 10:
            return $c32e4b0ba829ddb2$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $c32e4b0ba829ddb2$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $c32e4b0ba829ddb2$var$Jj = !1, $c32e4b0ba829ddb2$var$U = !1, $c32e4b0ba829ddb2$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $c32e4b0ba829ddb2$var$V = null;
function $c32e4b0ba829ddb2$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $c32e4b0ba829ddb2$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $c32e4b0ba829ddb2$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $c32e4b0ba829ddb2$var$W(a, b, d);
    }
}
var $c32e4b0ba829ddb2$var$Nj = !1;
function $c32e4b0ba829ddb2$var$Oj(a, b) {
    $c32e4b0ba829ddb2$var$Cf = $c32e4b0ba829ddb2$var$dd;
    a = $c32e4b0ba829ddb2$var$Me();
    if ($c32e4b0ba829ddb2$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $c32e4b0ba829ddb2$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $c32e4b0ba829ddb2$var$dd = !1;
    for($c32e4b0ba829ddb2$var$V = b; null !== $c32e4b0ba829ddb2$var$V;)if (b = $c32e4b0ba829ddb2$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $c32e4b0ba829ddb2$var$V = a;
    else for(; null !== $c32e4b0ba829ddb2$var$V;){
        b = $c32e4b0ba829ddb2$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $c32e4b0ba829ddb2$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($c32e4b0ba829ddb2$var$p(163));
            }
        } catch (F) {
            $c32e4b0ba829ddb2$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $c32e4b0ba829ddb2$var$V = a;
            break;
        }
        $c32e4b0ba829ddb2$var$V = b.return;
    }
    n = $c32e4b0ba829ddb2$var$Nj;
    $c32e4b0ba829ddb2$var$Nj = !1;
    return n;
}
function $c32e4b0ba829ddb2$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $c32e4b0ba829ddb2$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $c32e4b0ba829ddb2$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $c32e4b0ba829ddb2$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $c32e4b0ba829ddb2$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $c32e4b0ba829ddb2$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$c32e4b0ba829ddb2$var$Of], delete b[$c32e4b0ba829ddb2$var$Pf], delete b[$c32e4b0ba829ddb2$var$of], delete b[$c32e4b0ba829ddb2$var$Qf], delete b[$c32e4b0ba829ddb2$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $c32e4b0ba829ddb2$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $c32e4b0ba829ddb2$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $c32e4b0ba829ddb2$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $c32e4b0ba829ddb2$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $c32e4b0ba829ddb2$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($c32e4b0ba829ddb2$var$Vj(a, b, c), a = a.sibling; null !== a;)$c32e4b0ba829ddb2$var$Vj(a, b, c), a = a.sibling;
}
function $c32e4b0ba829ddb2$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($c32e4b0ba829ddb2$var$Wj(a, b, c), a = a.sibling; null !== a;)$c32e4b0ba829ddb2$var$Wj(a, b, c), a = a.sibling;
}
var $c32e4b0ba829ddb2$var$X = null, $c32e4b0ba829ddb2$var$Xj = !1;
function $c32e4b0ba829ddb2$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$c32e4b0ba829ddb2$var$Zj(a, b, c), c = c.sibling;
}
function $c32e4b0ba829ddb2$var$Zj(a, b, c) {
    if ($c32e4b0ba829ddb2$var$lc && "function" === typeof $c32e4b0ba829ddb2$var$lc.onCommitFiberUnmount) try {
        $c32e4b0ba829ddb2$var$lc.onCommitFiberUnmount($c32e4b0ba829ddb2$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $c32e4b0ba829ddb2$var$U || $c32e4b0ba829ddb2$var$Lj(c, b);
        case 6:
            var d = $c32e4b0ba829ddb2$var$X, e = $c32e4b0ba829ddb2$var$Xj;
            $c32e4b0ba829ddb2$var$X = null;
            $c32e4b0ba829ddb2$var$Yj(a, b, c);
            $c32e4b0ba829ddb2$var$X = d;
            $c32e4b0ba829ddb2$var$Xj = e;
            null !== $c32e4b0ba829ddb2$var$X && ($c32e4b0ba829ddb2$var$Xj ? (a = $c32e4b0ba829ddb2$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $c32e4b0ba829ddb2$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $c32e4b0ba829ddb2$var$X && ($c32e4b0ba829ddb2$var$Xj ? (a = $c32e4b0ba829ddb2$var$X, c = c.stateNode, 8 === a.nodeType ? $c32e4b0ba829ddb2$var$Kf(a.parentNode, c) : 1 === a.nodeType && $c32e4b0ba829ddb2$var$Kf(a, c), $c32e4b0ba829ddb2$var$bd(a)) : $c32e4b0ba829ddb2$var$Kf($c32e4b0ba829ddb2$var$X, c.stateNode));
            break;
        case 4:
            d = $c32e4b0ba829ddb2$var$X;
            e = $c32e4b0ba829ddb2$var$Xj;
            $c32e4b0ba829ddb2$var$X = c.stateNode.containerInfo;
            $c32e4b0ba829ddb2$var$Xj = !0;
            $c32e4b0ba829ddb2$var$Yj(a, b, c);
            $c32e4b0ba829ddb2$var$X = d;
            $c32e4b0ba829ddb2$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$c32e4b0ba829ddb2$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $c32e4b0ba829ddb2$var$Mj(c, b, g) : 0 !== (f & 4) && $c32e4b0ba829ddb2$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $c32e4b0ba829ddb2$var$Yj(a, b, c);
            break;
        case 1:
            if (!$c32e4b0ba829ddb2$var$U && ($c32e4b0ba829ddb2$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $c32e4b0ba829ddb2$var$W(c, b, h);
            }
            $c32e4b0ba829ddb2$var$Yj(a, b, c);
            break;
        case 21:
            $c32e4b0ba829ddb2$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($c32e4b0ba829ddb2$var$U = (d = $c32e4b0ba829ddb2$var$U) || null !== c.memoizedState, $c32e4b0ba829ddb2$var$Yj(a, b, c), $c32e4b0ba829ddb2$var$U = d) : $c32e4b0ba829ddb2$var$Yj(a, b, c);
            break;
        default:
            $c32e4b0ba829ddb2$var$Yj(a, b, c);
    }
}
function $c32e4b0ba829ddb2$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $c32e4b0ba829ddb2$var$Kj);
        b.forEach(function(b) {
            var d = $c32e4b0ba829ddb2$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $c32e4b0ba829ddb2$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $c32e4b0ba829ddb2$var$X = h.stateNode;
                        $c32e4b0ba829ddb2$var$Xj = !1;
                        break a;
                    case 3:
                        $c32e4b0ba829ddb2$var$X = h.stateNode.containerInfo;
                        $c32e4b0ba829ddb2$var$Xj = !0;
                        break a;
                    case 4:
                        $c32e4b0ba829ddb2$var$X = h.stateNode.containerInfo;
                        $c32e4b0ba829ddb2$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $c32e4b0ba829ddb2$var$X) throw Error($c32e4b0ba829ddb2$var$p(160));
            $c32e4b0ba829ddb2$var$Zj(f, g, e);
            $c32e4b0ba829ddb2$var$X = null;
            $c32e4b0ba829ddb2$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $c32e4b0ba829ddb2$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$c32e4b0ba829ddb2$var$dk(b, a), b = b.sibling;
}
function $c32e4b0ba829ddb2$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c32e4b0ba829ddb2$var$ck(b, a);
            $c32e4b0ba829ddb2$var$ek(a);
            if (d & 4) {
                try {
                    $c32e4b0ba829ddb2$var$Pj(3, a, a.return), $c32e4b0ba829ddb2$var$Qj(3, a);
                } catch (t) {
                    $c32e4b0ba829ddb2$var$W(a, a.return, t);
                }
                try {
                    $c32e4b0ba829ddb2$var$Pj(5, a, a.return);
                } catch (t) {
                    $c32e4b0ba829ddb2$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $c32e4b0ba829ddb2$var$ck(b, a);
            $c32e4b0ba829ddb2$var$ek(a);
            d & 512 && null !== c && $c32e4b0ba829ddb2$var$Lj(c, c.return);
            break;
        case 5:
            $c32e4b0ba829ddb2$var$ck(b, a);
            $c32e4b0ba829ddb2$var$ek(a);
            d & 512 && null !== c && $c32e4b0ba829ddb2$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $c32e4b0ba829ddb2$var$ob(e, "");
                } catch (t) {
                    $c32e4b0ba829ddb2$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $c32e4b0ba829ddb2$var$ab(e, f);
                    $c32e4b0ba829ddb2$var$vb(h, g);
                    var l = $c32e4b0ba829ddb2$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $c32e4b0ba829ddb2$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $c32e4b0ba829ddb2$var$nb(e, q) : "children" === m ? $c32e4b0ba829ddb2$var$ob(e, q) : $c32e4b0ba829ddb2$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $c32e4b0ba829ddb2$var$bb(e, f);
                            break;
                        case "textarea":
                            $c32e4b0ba829ddb2$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $c32e4b0ba829ddb2$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $c32e4b0ba829ddb2$var$fb(e, !!f.multiple, f.defaultValue, !0) : $c32e4b0ba829ddb2$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$c32e4b0ba829ddb2$var$Pf] = f;
                } catch (t) {
                    $c32e4b0ba829ddb2$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $c32e4b0ba829ddb2$var$ck(b, a);
            $c32e4b0ba829ddb2$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($c32e4b0ba829ddb2$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $c32e4b0ba829ddb2$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $c32e4b0ba829ddb2$var$ck(b, a);
            $c32e4b0ba829ddb2$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $c32e4b0ba829ddb2$var$bd(b.containerInfo);
            } catch (t) {
                $c32e4b0ba829ddb2$var$W(a, a.return, t);
            }
            break;
        case 4:
            $c32e4b0ba829ddb2$var$ck(b, a);
            $c32e4b0ba829ddb2$var$ek(a);
            break;
        case 13:
            $c32e4b0ba829ddb2$var$ck(b, a);
            $c32e4b0ba829ddb2$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($c32e4b0ba829ddb2$var$fk = $c32e4b0ba829ddb2$var$B()));
            d & 4 && $c32e4b0ba829ddb2$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($c32e4b0ba829ddb2$var$U = (l = $c32e4b0ba829ddb2$var$U) || m, $c32e4b0ba829ddb2$var$ck(b, a), $c32e4b0ba829ddb2$var$U = l) : $c32e4b0ba829ddb2$var$ck(b, a);
            $c32e4b0ba829ddb2$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($c32e4b0ba829ddb2$var$V = a, m = a.child; null !== m;){
                    for(q = $c32e4b0ba829ddb2$var$V = m; null !== $c32e4b0ba829ddb2$var$V;){
                        r = $c32e4b0ba829ddb2$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $c32e4b0ba829ddb2$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $c32e4b0ba829ddb2$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $c32e4b0ba829ddb2$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $c32e4b0ba829ddb2$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $c32e4b0ba829ddb2$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $c32e4b0ba829ddb2$var$V = y) : $c32e4b0ba829ddb2$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $c32e4b0ba829ddb2$var$rb("display", g));
                            } catch (t) {
                                $c32e4b0ba829ddb2$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $c32e4b0ba829ddb2$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $c32e4b0ba829ddb2$var$ck(b, a);
            $c32e4b0ba829ddb2$var$ek(a);
            d & 4 && $c32e4b0ba829ddb2$var$ak(a);
            break;
        case 21:
            break;
        default:
            $c32e4b0ba829ddb2$var$ck(b, a), $c32e4b0ba829ddb2$var$ek(a);
    }
}
function $c32e4b0ba829ddb2$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($c32e4b0ba829ddb2$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($c32e4b0ba829ddb2$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($c32e4b0ba829ddb2$var$ob(e, ""), d.flags &= -33);
                    var f = $c32e4b0ba829ddb2$var$Uj(a);
                    $c32e4b0ba829ddb2$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $c32e4b0ba829ddb2$var$Uj(a);
                    $c32e4b0ba829ddb2$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($c32e4b0ba829ddb2$var$p(161));
            }
        } catch (k) {
            $c32e4b0ba829ddb2$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $c32e4b0ba829ddb2$var$hk(a, b, c) {
    $c32e4b0ba829ddb2$var$V = a;
    $c32e4b0ba829ddb2$var$ik(a, b, c);
}
function $c32e4b0ba829ddb2$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $c32e4b0ba829ddb2$var$V;){
        var e = $c32e4b0ba829ddb2$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $c32e4b0ba829ddb2$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $c32e4b0ba829ddb2$var$U;
                h = $c32e4b0ba829ddb2$var$Jj;
                var l = $c32e4b0ba829ddb2$var$U;
                $c32e4b0ba829ddb2$var$Jj = g;
                if (($c32e4b0ba829ddb2$var$U = k) && !l) for($c32e4b0ba829ddb2$var$V = e; null !== $c32e4b0ba829ddb2$var$V;)g = $c32e4b0ba829ddb2$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $c32e4b0ba829ddb2$var$jk(e) : null !== k ? (k.return = g, $c32e4b0ba829ddb2$var$V = k) : $c32e4b0ba829ddb2$var$jk(e);
                for(; null !== f;)$c32e4b0ba829ddb2$var$V = f, $c32e4b0ba829ddb2$var$ik(f, b, c), f = f.sibling;
                $c32e4b0ba829ddb2$var$V = e;
                $c32e4b0ba829ddb2$var$Jj = h;
                $c32e4b0ba829ddb2$var$U = l;
            }
            $c32e4b0ba829ddb2$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $c32e4b0ba829ddb2$var$V = f) : $c32e4b0ba829ddb2$var$kk(a, b, c);
    }
}
function $c32e4b0ba829ddb2$var$kk(a) {
    for(; null !== $c32e4b0ba829ddb2$var$V;){
        var b = $c32e4b0ba829ddb2$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $c32e4b0ba829ddb2$var$U || $c32e4b0ba829ddb2$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$c32e4b0ba829ddb2$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $c32e4b0ba829ddb2$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $c32e4b0ba829ddb2$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $c32e4b0ba829ddb2$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $c32e4b0ba829ddb2$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($c32e4b0ba829ddb2$var$p(163));
                }
                $c32e4b0ba829ddb2$var$U || b.flags & 512 && $c32e4b0ba829ddb2$var$Rj(b);
            } catch (r) {
                $c32e4b0ba829ddb2$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $c32e4b0ba829ddb2$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c32e4b0ba829ddb2$var$V = c;
            break;
        }
        $c32e4b0ba829ddb2$var$V = b.return;
    }
}
function $c32e4b0ba829ddb2$var$gk(a) {
    for(; null !== $c32e4b0ba829ddb2$var$V;){
        var b = $c32e4b0ba829ddb2$var$V;
        if (b === a) {
            $c32e4b0ba829ddb2$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c32e4b0ba829ddb2$var$V = c;
            break;
        }
        $c32e4b0ba829ddb2$var$V = b.return;
    }
}
function $c32e4b0ba829ddb2$var$jk(a) {
    for(; null !== $c32e4b0ba829ddb2$var$V;){
        var b = $c32e4b0ba829ddb2$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $c32e4b0ba829ddb2$var$Qj(4, b);
                    } catch (k) {
                        $c32e4b0ba829ddb2$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $c32e4b0ba829ddb2$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $c32e4b0ba829ddb2$var$Rj(b);
                    } catch (k) {
                        $c32e4b0ba829ddb2$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $c32e4b0ba829ddb2$var$Rj(b);
                    } catch (k) {
                        $c32e4b0ba829ddb2$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $c32e4b0ba829ddb2$var$W(b, b.return, k);
        }
        if (b === a) {
            $c32e4b0ba829ddb2$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $c32e4b0ba829ddb2$var$V = h;
            break;
        }
        $c32e4b0ba829ddb2$var$V = b.return;
    }
}
var $c32e4b0ba829ddb2$var$lk = Math.ceil, $c32e4b0ba829ddb2$var$mk = $c32e4b0ba829ddb2$var$ua.ReactCurrentDispatcher, $c32e4b0ba829ddb2$var$nk = $c32e4b0ba829ddb2$var$ua.ReactCurrentOwner, $c32e4b0ba829ddb2$var$ok = $c32e4b0ba829ddb2$var$ua.ReactCurrentBatchConfig, $c32e4b0ba829ddb2$var$K = 0, $c32e4b0ba829ddb2$var$Q = null, $c32e4b0ba829ddb2$var$Y = null, $c32e4b0ba829ddb2$var$Z = 0, $c32e4b0ba829ddb2$var$fj = 0, $c32e4b0ba829ddb2$var$ej = $c32e4b0ba829ddb2$var$Uf(0), $c32e4b0ba829ddb2$var$T = 0, $c32e4b0ba829ddb2$var$pk = null, $c32e4b0ba829ddb2$var$rh = 0, $c32e4b0ba829ddb2$var$qk = 0, $c32e4b0ba829ddb2$var$rk = 0, $c32e4b0ba829ddb2$var$sk = null, $c32e4b0ba829ddb2$var$tk = null, $c32e4b0ba829ddb2$var$fk = 0, $c32e4b0ba829ddb2$var$Gj = Infinity, $c32e4b0ba829ddb2$var$uk = null, $c32e4b0ba829ddb2$var$Oi = !1, $c32e4b0ba829ddb2$var$Pi = null, $c32e4b0ba829ddb2$var$Ri = null, $c32e4b0ba829ddb2$var$vk = !1, $c32e4b0ba829ddb2$var$wk = null, $c32e4b0ba829ddb2$var$xk = 0, $c32e4b0ba829ddb2$var$yk = 0, $c32e4b0ba829ddb2$var$zk = null, $c32e4b0ba829ddb2$var$Ak = -1, $c32e4b0ba829ddb2$var$Bk = 0;
function $c32e4b0ba829ddb2$var$R() {
    return 0 !== ($c32e4b0ba829ddb2$var$K & 6) ? $c32e4b0ba829ddb2$var$B() : -1 !== $c32e4b0ba829ddb2$var$Ak ? $c32e4b0ba829ddb2$var$Ak : $c32e4b0ba829ddb2$var$Ak = $c32e4b0ba829ddb2$var$B();
}
function $c32e4b0ba829ddb2$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($c32e4b0ba829ddb2$var$K & 2) && 0 !== $c32e4b0ba829ddb2$var$Z) return $c32e4b0ba829ddb2$var$Z & -$c32e4b0ba829ddb2$var$Z;
    if (null !== $c32e4b0ba829ddb2$var$Kg.transition) return 0 === $c32e4b0ba829ddb2$var$Bk && ($c32e4b0ba829ddb2$var$Bk = $c32e4b0ba829ddb2$var$yc()), $c32e4b0ba829ddb2$var$Bk;
    a = $c32e4b0ba829ddb2$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $c32e4b0ba829ddb2$var$jd(a.type);
    return a;
}
function $c32e4b0ba829ddb2$var$gi(a, b, c, d) {
    if (50 < $c32e4b0ba829ddb2$var$yk) throw $c32e4b0ba829ddb2$var$yk = 0, $c32e4b0ba829ddb2$var$zk = null, Error($c32e4b0ba829ddb2$var$p(185));
    $c32e4b0ba829ddb2$var$Ac(a, c, d);
    if (0 === ($c32e4b0ba829ddb2$var$K & 2) || a !== $c32e4b0ba829ddb2$var$Q) a === $c32e4b0ba829ddb2$var$Q && (0 === ($c32e4b0ba829ddb2$var$K & 2) && ($c32e4b0ba829ddb2$var$qk |= c), 4 === $c32e4b0ba829ddb2$var$T && $c32e4b0ba829ddb2$var$Ck(a, $c32e4b0ba829ddb2$var$Z)), $c32e4b0ba829ddb2$var$Dk(a, d), 1 === c && 0 === $c32e4b0ba829ddb2$var$K && 0 === (b.mode & 1) && ($c32e4b0ba829ddb2$var$Gj = $c32e4b0ba829ddb2$var$B() + 500, $c32e4b0ba829ddb2$var$fg && $c32e4b0ba829ddb2$var$jg());
}
function $c32e4b0ba829ddb2$var$Dk(a, b) {
    var c = a.callbackNode;
    $c32e4b0ba829ddb2$var$wc(a, b);
    var d = $c32e4b0ba829ddb2$var$uc(a, a === $c32e4b0ba829ddb2$var$Q ? $c32e4b0ba829ddb2$var$Z : 0);
    if (0 === d) null !== c && $c32e4b0ba829ddb2$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $c32e4b0ba829ddb2$var$bc(c);
        if (1 === b) 0 === a.tag ? $c32e4b0ba829ddb2$var$ig($c32e4b0ba829ddb2$var$Ek.bind(null, a)) : $c32e4b0ba829ddb2$var$hg($c32e4b0ba829ddb2$var$Ek.bind(null, a)), $c32e4b0ba829ddb2$var$Jf(function() {
            0 === ($c32e4b0ba829ddb2$var$K & 6) && $c32e4b0ba829ddb2$var$jg();
        }), c = null;
        else {
            switch($c32e4b0ba829ddb2$var$Dc(d)){
                case 1:
                    c = $c32e4b0ba829ddb2$var$fc;
                    break;
                case 4:
                    c = $c32e4b0ba829ddb2$var$gc;
                    break;
                case 16:
                    c = $c32e4b0ba829ddb2$var$hc;
                    break;
                case 536870912:
                    c = $c32e4b0ba829ddb2$var$jc;
                    break;
                default:
                    c = $c32e4b0ba829ddb2$var$hc;
            }
            c = $c32e4b0ba829ddb2$var$Fk(c, $c32e4b0ba829ddb2$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $c32e4b0ba829ddb2$var$Gk(a, b) {
    $c32e4b0ba829ddb2$var$Ak = -1;
    $c32e4b0ba829ddb2$var$Bk = 0;
    if (0 !== ($c32e4b0ba829ddb2$var$K & 6)) throw Error($c32e4b0ba829ddb2$var$p(327));
    var c = a.callbackNode;
    if ($c32e4b0ba829ddb2$var$Hk() && a.callbackNode !== c) return null;
    var d = $c32e4b0ba829ddb2$var$uc(a, a === $c32e4b0ba829ddb2$var$Q ? $c32e4b0ba829ddb2$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $c32e4b0ba829ddb2$var$Ik(a, d);
    else {
        b = d;
        var e = $c32e4b0ba829ddb2$var$K;
        $c32e4b0ba829ddb2$var$K |= 2;
        var f = $c32e4b0ba829ddb2$var$Jk();
        if ($c32e4b0ba829ddb2$var$Q !== a || $c32e4b0ba829ddb2$var$Z !== b) $c32e4b0ba829ddb2$var$uk = null, $c32e4b0ba829ddb2$var$Gj = $c32e4b0ba829ddb2$var$B() + 500, $c32e4b0ba829ddb2$var$Kk(a, b);
        for(;;)try {
            $c32e4b0ba829ddb2$var$Lk();
            break;
        } catch (h) {
            $c32e4b0ba829ddb2$var$Mk(a, h);
        }
        $c32e4b0ba829ddb2$var$$g();
        $c32e4b0ba829ddb2$var$mk.current = f;
        $c32e4b0ba829ddb2$var$K = e;
        null !== $c32e4b0ba829ddb2$var$Y ? b = 0 : ($c32e4b0ba829ddb2$var$Q = null, $c32e4b0ba829ddb2$var$Z = 0, b = $c32e4b0ba829ddb2$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $c32e4b0ba829ddb2$var$xc(a), 0 !== e && (d = e, b = $c32e4b0ba829ddb2$var$Nk(a, e)));
        if (1 === b) throw c = $c32e4b0ba829ddb2$var$pk, $c32e4b0ba829ddb2$var$Kk(a, 0), $c32e4b0ba829ddb2$var$Ck(a, d), $c32e4b0ba829ddb2$var$Dk(a, $c32e4b0ba829ddb2$var$B()), c;
        if (6 === b) $c32e4b0ba829ddb2$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$c32e4b0ba829ddb2$var$Ok(e) && (b = $c32e4b0ba829ddb2$var$Ik(a, d), 2 === b && (f = $c32e4b0ba829ddb2$var$xc(a), 0 !== f && (d = f, b = $c32e4b0ba829ddb2$var$Nk(a, f))), 1 === b)) throw c = $c32e4b0ba829ddb2$var$pk, $c32e4b0ba829ddb2$var$Kk(a, 0), $c32e4b0ba829ddb2$var$Ck(a, d), $c32e4b0ba829ddb2$var$Dk(a, $c32e4b0ba829ddb2$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($c32e4b0ba829ddb2$var$p(345));
                case 2:
                    $c32e4b0ba829ddb2$var$Pk(a, $c32e4b0ba829ddb2$var$tk, $c32e4b0ba829ddb2$var$uk);
                    break;
                case 3:
                    $c32e4b0ba829ddb2$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $c32e4b0ba829ddb2$var$fk + 500 - $c32e4b0ba829ddb2$var$B(), 10 < b)) {
                        if (0 !== $c32e4b0ba829ddb2$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $c32e4b0ba829ddb2$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $c32e4b0ba829ddb2$var$Ff($c32e4b0ba829ddb2$var$Pk.bind(null, a, $c32e4b0ba829ddb2$var$tk, $c32e4b0ba829ddb2$var$uk), b);
                        break;
                    }
                    $c32e4b0ba829ddb2$var$Pk(a, $c32e4b0ba829ddb2$var$tk, $c32e4b0ba829ddb2$var$uk);
                    break;
                case 4:
                    $c32e4b0ba829ddb2$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $c32e4b0ba829ddb2$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $c32e4b0ba829ddb2$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $c32e4b0ba829ddb2$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $c32e4b0ba829ddb2$var$Ff($c32e4b0ba829ddb2$var$Pk.bind(null, a, $c32e4b0ba829ddb2$var$tk, $c32e4b0ba829ddb2$var$uk), d);
                        break;
                    }
                    $c32e4b0ba829ddb2$var$Pk(a, $c32e4b0ba829ddb2$var$tk, $c32e4b0ba829ddb2$var$uk);
                    break;
                case 5:
                    $c32e4b0ba829ddb2$var$Pk(a, $c32e4b0ba829ddb2$var$tk, $c32e4b0ba829ddb2$var$uk);
                    break;
                default:
                    throw Error($c32e4b0ba829ddb2$var$p(329));
            }
        }
    }
    $c32e4b0ba829ddb2$var$Dk(a, $c32e4b0ba829ddb2$var$B());
    return a.callbackNode === c ? $c32e4b0ba829ddb2$var$Gk.bind(null, a) : null;
}
function $c32e4b0ba829ddb2$var$Nk(a, b) {
    var c = $c32e4b0ba829ddb2$var$sk;
    a.current.memoizedState.isDehydrated && ($c32e4b0ba829ddb2$var$Kk(a, b).flags |= 256);
    a = $c32e4b0ba829ddb2$var$Ik(a, b);
    2 !== a && (b = $c32e4b0ba829ddb2$var$tk, $c32e4b0ba829ddb2$var$tk = c, null !== b && $c32e4b0ba829ddb2$var$Fj(b));
    return a;
}
function $c32e4b0ba829ddb2$var$Fj(a) {
    null === $c32e4b0ba829ddb2$var$tk ? $c32e4b0ba829ddb2$var$tk = a : $c32e4b0ba829ddb2$var$tk.push.apply($c32e4b0ba829ddb2$var$tk, a);
}
function $c32e4b0ba829ddb2$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$c32e4b0ba829ddb2$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $c32e4b0ba829ddb2$var$Ck(a, b) {
    b &= ~$c32e4b0ba829ddb2$var$rk;
    b &= ~$c32e4b0ba829ddb2$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $c32e4b0ba829ddb2$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $c32e4b0ba829ddb2$var$Ek(a) {
    if (0 !== ($c32e4b0ba829ddb2$var$K & 6)) throw Error($c32e4b0ba829ddb2$var$p(327));
    $c32e4b0ba829ddb2$var$Hk();
    var b = $c32e4b0ba829ddb2$var$uc(a, 0);
    if (0 === (b & 1)) return $c32e4b0ba829ddb2$var$Dk(a, $c32e4b0ba829ddb2$var$B()), null;
    var c = $c32e4b0ba829ddb2$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $c32e4b0ba829ddb2$var$xc(a);
        0 !== d && (b = d, c = $c32e4b0ba829ddb2$var$Nk(a, d));
    }
    if (1 === c) throw c = $c32e4b0ba829ddb2$var$pk, $c32e4b0ba829ddb2$var$Kk(a, 0), $c32e4b0ba829ddb2$var$Ck(a, b), $c32e4b0ba829ddb2$var$Dk(a, $c32e4b0ba829ddb2$var$B()), c;
    if (6 === c) throw Error($c32e4b0ba829ddb2$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $c32e4b0ba829ddb2$var$Pk(a, $c32e4b0ba829ddb2$var$tk, $c32e4b0ba829ddb2$var$uk);
    $c32e4b0ba829ddb2$var$Dk(a, $c32e4b0ba829ddb2$var$B());
    return null;
}
function $c32e4b0ba829ddb2$var$Qk(a, b) {
    var c = $c32e4b0ba829ddb2$var$K;
    $c32e4b0ba829ddb2$var$K |= 1;
    try {
        return a(b);
    } finally{
        $c32e4b0ba829ddb2$var$K = c, 0 === $c32e4b0ba829ddb2$var$K && ($c32e4b0ba829ddb2$var$Gj = $c32e4b0ba829ddb2$var$B() + 500, $c32e4b0ba829ddb2$var$fg && $c32e4b0ba829ddb2$var$jg());
    }
}
function $c32e4b0ba829ddb2$var$Rk(a) {
    null !== $c32e4b0ba829ddb2$var$wk && 0 === $c32e4b0ba829ddb2$var$wk.tag && 0 === ($c32e4b0ba829ddb2$var$K & 6) && $c32e4b0ba829ddb2$var$Hk();
    var b = $c32e4b0ba829ddb2$var$K;
    $c32e4b0ba829ddb2$var$K |= 1;
    var c = $c32e4b0ba829ddb2$var$ok.transition, d = $c32e4b0ba829ddb2$var$C;
    try {
        if ($c32e4b0ba829ddb2$var$ok.transition = null, $c32e4b0ba829ddb2$var$C = 1, a) return a();
    } finally{
        $c32e4b0ba829ddb2$var$C = d, $c32e4b0ba829ddb2$var$ok.transition = c, $c32e4b0ba829ddb2$var$K = b, 0 === ($c32e4b0ba829ddb2$var$K & 6) && $c32e4b0ba829ddb2$var$jg();
    }
}
function $c32e4b0ba829ddb2$var$Hj() {
    $c32e4b0ba829ddb2$var$fj = $c32e4b0ba829ddb2$var$ej.current;
    $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$ej);
}
function $c32e4b0ba829ddb2$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $c32e4b0ba829ddb2$var$Gf(c));
    if (null !== $c32e4b0ba829ddb2$var$Y) for(c = $c32e4b0ba829ddb2$var$Y.return; null !== c;){
        var d = c;
        $c32e4b0ba829ddb2$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $c32e4b0ba829ddb2$var$$f();
                break;
            case 3:
                $c32e4b0ba829ddb2$var$zh();
                $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$Wf);
                $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$H);
                $c32e4b0ba829ddb2$var$Eh();
                break;
            case 5:
                $c32e4b0ba829ddb2$var$Bh(d);
                break;
            case 4:
                $c32e4b0ba829ddb2$var$zh();
                break;
            case 13:
                $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$L);
                break;
            case 19:
                $c32e4b0ba829ddb2$var$E($c32e4b0ba829ddb2$var$L);
                break;
            case 10:
                $c32e4b0ba829ddb2$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $c32e4b0ba829ddb2$var$Hj();
        }
        c = c.return;
    }
    $c32e4b0ba829ddb2$var$Q = a;
    $c32e4b0ba829ddb2$var$Y = a = $c32e4b0ba829ddb2$var$Pg(a.current, null);
    $c32e4b0ba829ddb2$var$Z = $c32e4b0ba829ddb2$var$fj = b;
    $c32e4b0ba829ddb2$var$T = 0;
    $c32e4b0ba829ddb2$var$pk = null;
    $c32e4b0ba829ddb2$var$rk = $c32e4b0ba829ddb2$var$qk = $c32e4b0ba829ddb2$var$rh = 0;
    $c32e4b0ba829ddb2$var$tk = $c32e4b0ba829ddb2$var$sk = null;
    if (null !== $c32e4b0ba829ddb2$var$fh) {
        for(b = 0; b < $c32e4b0ba829ddb2$var$fh.length; b++)if (c = $c32e4b0ba829ddb2$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $c32e4b0ba829ddb2$var$fh = null;
    }
    return a;
}
function $c32e4b0ba829ddb2$var$Mk(a, b) {
    do {
        var c = $c32e4b0ba829ddb2$var$Y;
        try {
            $c32e4b0ba829ddb2$var$$g();
            $c32e4b0ba829ddb2$var$Fh.current = $c32e4b0ba829ddb2$var$Rh;
            if ($c32e4b0ba829ddb2$var$Ih) {
                for(var d = $c32e4b0ba829ddb2$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $c32e4b0ba829ddb2$var$Ih = !1;
            }
            $c32e4b0ba829ddb2$var$Hh = 0;
            $c32e4b0ba829ddb2$var$O = $c32e4b0ba829ddb2$var$N = $c32e4b0ba829ddb2$var$M = null;
            $c32e4b0ba829ddb2$var$Jh = !1;
            $c32e4b0ba829ddb2$var$Kh = 0;
            $c32e4b0ba829ddb2$var$nk.current = null;
            if (null === c || null === c.return) {
                $c32e4b0ba829ddb2$var$T = 1;
                $c32e4b0ba829ddb2$var$pk = b;
                $c32e4b0ba829ddb2$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $c32e4b0ba829ddb2$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === (typeof k === "undefined" ? "undefined" : (0, $2bfPH._)(k)) && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $c32e4b0ba829ddb2$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $c32e4b0ba829ddb2$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $c32e4b0ba829ddb2$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $c32e4b0ba829ddb2$var$Si(f, l, b);
                            $c32e4b0ba829ddb2$var$tj();
                            break a;
                        }
                        k = Error($c32e4b0ba829ddb2$var$p(426));
                    }
                } else if ($c32e4b0ba829ddb2$var$I && h.mode & 1) {
                    var J = $c32e4b0ba829ddb2$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $c32e4b0ba829ddb2$var$Vi(J, g, h, f, b);
                        $c32e4b0ba829ddb2$var$Jg($c32e4b0ba829ddb2$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $c32e4b0ba829ddb2$var$Ji(k, h);
                4 !== $c32e4b0ba829ddb2$var$T && ($c32e4b0ba829ddb2$var$T = 2);
                null === $c32e4b0ba829ddb2$var$sk ? $c32e4b0ba829ddb2$var$sk = [
                    f
                ] : $c32e4b0ba829ddb2$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $c32e4b0ba829ddb2$var$Ni(f, k, b);
                            $c32e4b0ba829ddb2$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $c32e4b0ba829ddb2$var$Ri || !$c32e4b0ba829ddb2$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $c32e4b0ba829ddb2$var$Qi(f, h, b);
                                $c32e4b0ba829ddb2$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $c32e4b0ba829ddb2$var$Sk(c);
        } catch (na) {
            b = na;
            $c32e4b0ba829ddb2$var$Y === c && null !== c && ($c32e4b0ba829ddb2$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $c32e4b0ba829ddb2$var$Jk() {
    var a = $c32e4b0ba829ddb2$var$mk.current;
    $c32e4b0ba829ddb2$var$mk.current = $c32e4b0ba829ddb2$var$Rh;
    return null === a ? $c32e4b0ba829ddb2$var$Rh : a;
}
function $c32e4b0ba829ddb2$var$tj() {
    if (0 === $c32e4b0ba829ddb2$var$T || 3 === $c32e4b0ba829ddb2$var$T || 2 === $c32e4b0ba829ddb2$var$T) $c32e4b0ba829ddb2$var$T = 4;
    null === $c32e4b0ba829ddb2$var$Q || 0 === ($c32e4b0ba829ddb2$var$rh & 268435455) && 0 === ($c32e4b0ba829ddb2$var$qk & 268435455) || $c32e4b0ba829ddb2$var$Ck($c32e4b0ba829ddb2$var$Q, $c32e4b0ba829ddb2$var$Z);
}
function $c32e4b0ba829ddb2$var$Ik(a, b) {
    var c = $c32e4b0ba829ddb2$var$K;
    $c32e4b0ba829ddb2$var$K |= 2;
    var d = $c32e4b0ba829ddb2$var$Jk();
    if ($c32e4b0ba829ddb2$var$Q !== a || $c32e4b0ba829ddb2$var$Z !== b) $c32e4b0ba829ddb2$var$uk = null, $c32e4b0ba829ddb2$var$Kk(a, b);
    for(;;)try {
        $c32e4b0ba829ddb2$var$Tk();
        break;
    } catch (e) {
        $c32e4b0ba829ddb2$var$Mk(a, e);
    }
    $c32e4b0ba829ddb2$var$$g();
    $c32e4b0ba829ddb2$var$K = c;
    $c32e4b0ba829ddb2$var$mk.current = d;
    if (null !== $c32e4b0ba829ddb2$var$Y) throw Error($c32e4b0ba829ddb2$var$p(261));
    $c32e4b0ba829ddb2$var$Q = null;
    $c32e4b0ba829ddb2$var$Z = 0;
    return $c32e4b0ba829ddb2$var$T;
}
function $c32e4b0ba829ddb2$var$Tk() {
    for(; null !== $c32e4b0ba829ddb2$var$Y;)$c32e4b0ba829ddb2$var$Uk($c32e4b0ba829ddb2$var$Y);
}
function $c32e4b0ba829ddb2$var$Lk() {
    for(; null !== $c32e4b0ba829ddb2$var$Y && !$c32e4b0ba829ddb2$var$cc();)$c32e4b0ba829ddb2$var$Uk($c32e4b0ba829ddb2$var$Y);
}
function $c32e4b0ba829ddb2$var$Uk(a) {
    var b = $c32e4b0ba829ddb2$var$Vk(a.alternate, a, $c32e4b0ba829ddb2$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $c32e4b0ba829ddb2$var$Sk(a) : $c32e4b0ba829ddb2$var$Y = b;
    $c32e4b0ba829ddb2$var$nk.current = null;
}
function $c32e4b0ba829ddb2$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $c32e4b0ba829ddb2$var$Ej(c, b, $c32e4b0ba829ddb2$var$fj), null !== c) {
                $c32e4b0ba829ddb2$var$Y = c;
                return;
            }
        } else {
            c = $c32e4b0ba829ddb2$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $c32e4b0ba829ddb2$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $c32e4b0ba829ddb2$var$T = 6;
                $c32e4b0ba829ddb2$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $c32e4b0ba829ddb2$var$Y = b;
            return;
        }
        $c32e4b0ba829ddb2$var$Y = b = a;
    }while (null !== b);
    0 === $c32e4b0ba829ddb2$var$T && ($c32e4b0ba829ddb2$var$T = 5);
}
function $c32e4b0ba829ddb2$var$Pk(a, b, c) {
    var d = $c32e4b0ba829ddb2$var$C, e = $c32e4b0ba829ddb2$var$ok.transition;
    try {
        $c32e4b0ba829ddb2$var$ok.transition = null, $c32e4b0ba829ddb2$var$C = 1, $c32e4b0ba829ddb2$var$Wk(a, b, c, d);
    } finally{
        $c32e4b0ba829ddb2$var$ok.transition = e, $c32e4b0ba829ddb2$var$C = d;
    }
    return null;
}
function $c32e4b0ba829ddb2$var$Wk(a, b, c, d) {
    do $c32e4b0ba829ddb2$var$Hk();
    while (null !== $c32e4b0ba829ddb2$var$wk);
    if (0 !== ($c32e4b0ba829ddb2$var$K & 6)) throw Error($c32e4b0ba829ddb2$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($c32e4b0ba829ddb2$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $c32e4b0ba829ddb2$var$Bc(a, f);
    a === $c32e4b0ba829ddb2$var$Q && ($c32e4b0ba829ddb2$var$Y = $c32e4b0ba829ddb2$var$Q = null, $c32e4b0ba829ddb2$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $c32e4b0ba829ddb2$var$vk || ($c32e4b0ba829ddb2$var$vk = !0, $c32e4b0ba829ddb2$var$Fk($c32e4b0ba829ddb2$var$hc, function() {
        $c32e4b0ba829ddb2$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $c32e4b0ba829ddb2$var$ok.transition;
        $c32e4b0ba829ddb2$var$ok.transition = null;
        var g = $c32e4b0ba829ddb2$var$C;
        $c32e4b0ba829ddb2$var$C = 1;
        var h = $c32e4b0ba829ddb2$var$K;
        $c32e4b0ba829ddb2$var$K |= 4;
        $c32e4b0ba829ddb2$var$nk.current = null;
        $c32e4b0ba829ddb2$var$Oj(a, c);
        $c32e4b0ba829ddb2$var$dk(c, a);
        $c32e4b0ba829ddb2$var$Oe($c32e4b0ba829ddb2$var$Df);
        $c32e4b0ba829ddb2$var$dd = !!$c32e4b0ba829ddb2$var$Cf;
        $c32e4b0ba829ddb2$var$Df = $c32e4b0ba829ddb2$var$Cf = null;
        a.current = c;
        $c32e4b0ba829ddb2$var$hk(c, a, e);
        $c32e4b0ba829ddb2$var$dc();
        $c32e4b0ba829ddb2$var$K = h;
        $c32e4b0ba829ddb2$var$C = g;
        $c32e4b0ba829ddb2$var$ok.transition = f;
    } else a.current = c;
    $c32e4b0ba829ddb2$var$vk && ($c32e4b0ba829ddb2$var$vk = !1, $c32e4b0ba829ddb2$var$wk = a, $c32e4b0ba829ddb2$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($c32e4b0ba829ddb2$var$Ri = null);
    $c32e4b0ba829ddb2$var$mc(c.stateNode, d);
    $c32e4b0ba829ddb2$var$Dk(a, $c32e4b0ba829ddb2$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($c32e4b0ba829ddb2$var$Oi) throw $c32e4b0ba829ddb2$var$Oi = !1, a = $c32e4b0ba829ddb2$var$Pi, $c32e4b0ba829ddb2$var$Pi = null, a;
    0 !== ($c32e4b0ba829ddb2$var$xk & 1) && 0 !== a.tag && $c32e4b0ba829ddb2$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $c32e4b0ba829ddb2$var$zk ? $c32e4b0ba829ddb2$var$yk++ : ($c32e4b0ba829ddb2$var$yk = 0, $c32e4b0ba829ddb2$var$zk = a) : $c32e4b0ba829ddb2$var$yk = 0;
    $c32e4b0ba829ddb2$var$jg();
    return null;
}
function $c32e4b0ba829ddb2$var$Hk() {
    if (null !== $c32e4b0ba829ddb2$var$wk) {
        var a = $c32e4b0ba829ddb2$var$Dc($c32e4b0ba829ddb2$var$xk), b = $c32e4b0ba829ddb2$var$ok.transition, c = $c32e4b0ba829ddb2$var$C;
        try {
            $c32e4b0ba829ddb2$var$ok.transition = null;
            $c32e4b0ba829ddb2$var$C = 16 > a ? 16 : a;
            if (null === $c32e4b0ba829ddb2$var$wk) var d = !1;
            else {
                a = $c32e4b0ba829ddb2$var$wk;
                $c32e4b0ba829ddb2$var$wk = null;
                $c32e4b0ba829ddb2$var$xk = 0;
                if (0 !== ($c32e4b0ba829ddb2$var$K & 6)) throw Error($c32e4b0ba829ddb2$var$p(331));
                var e = $c32e4b0ba829ddb2$var$K;
                $c32e4b0ba829ddb2$var$K |= 4;
                for($c32e4b0ba829ddb2$var$V = a.current; null !== $c32e4b0ba829ddb2$var$V;){
                    var f = $c32e4b0ba829ddb2$var$V, g = f.child;
                    if (0 !== ($c32e4b0ba829ddb2$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($c32e4b0ba829ddb2$var$V = l; null !== $c32e4b0ba829ddb2$var$V;){
                                    var m = $c32e4b0ba829ddb2$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $c32e4b0ba829ddb2$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $c32e4b0ba829ddb2$var$V = q;
                                    else for(; null !== $c32e4b0ba829ddb2$var$V;){
                                        m = $c32e4b0ba829ddb2$var$V;
                                        var r = m.sibling, y = m.return;
                                        $c32e4b0ba829ddb2$var$Sj(m);
                                        if (m === l) {
                                            $c32e4b0ba829ddb2$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $c32e4b0ba829ddb2$var$V = r;
                                            break;
                                        }
                                        $c32e4b0ba829ddb2$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $c32e4b0ba829ddb2$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $c32e4b0ba829ddb2$var$V = g;
                    else b: for(; null !== $c32e4b0ba829ddb2$var$V;){
                        f = $c32e4b0ba829ddb2$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $c32e4b0ba829ddb2$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $c32e4b0ba829ddb2$var$V = x;
                            break b;
                        }
                        $c32e4b0ba829ddb2$var$V = f.return;
                    }
                }
                var w = a.current;
                for($c32e4b0ba829ddb2$var$V = w; null !== $c32e4b0ba829ddb2$var$V;){
                    g = $c32e4b0ba829ddb2$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $c32e4b0ba829ddb2$var$V = u;
                    else b: for(g = w; null !== $c32e4b0ba829ddb2$var$V;){
                        h = $c32e4b0ba829ddb2$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $c32e4b0ba829ddb2$var$Qj(9, h);
                            }
                        } catch (na) {
                            $c32e4b0ba829ddb2$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $c32e4b0ba829ddb2$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $c32e4b0ba829ddb2$var$V = F;
                            break b;
                        }
                        $c32e4b0ba829ddb2$var$V = h.return;
                    }
                }
                $c32e4b0ba829ddb2$var$K = e;
                $c32e4b0ba829ddb2$var$jg();
                if ($c32e4b0ba829ddb2$var$lc && "function" === typeof $c32e4b0ba829ddb2$var$lc.onPostCommitFiberRoot) try {
                    $c32e4b0ba829ddb2$var$lc.onPostCommitFiberRoot($c32e4b0ba829ddb2$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $c32e4b0ba829ddb2$var$C = c, $c32e4b0ba829ddb2$var$ok.transition = b;
        }
    }
    return !1;
}
function $c32e4b0ba829ddb2$var$Xk(a, b, c) {
    b = $c32e4b0ba829ddb2$var$Ji(c, b);
    b = $c32e4b0ba829ddb2$var$Ni(a, b, 1);
    a = $c32e4b0ba829ddb2$var$nh(a, b, 1);
    b = $c32e4b0ba829ddb2$var$R();
    null !== a && ($c32e4b0ba829ddb2$var$Ac(a, 1, b), $c32e4b0ba829ddb2$var$Dk(a, b));
}
function $c32e4b0ba829ddb2$var$W(a, b, c) {
    if (3 === a.tag) $c32e4b0ba829ddb2$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $c32e4b0ba829ddb2$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $c32e4b0ba829ddb2$var$Ri || !$c32e4b0ba829ddb2$var$Ri.has(d))) {
                a = $c32e4b0ba829ddb2$var$Ji(c, a);
                a = $c32e4b0ba829ddb2$var$Qi(b, a, 1);
                b = $c32e4b0ba829ddb2$var$nh(b, a, 1);
                a = $c32e4b0ba829ddb2$var$R();
                null !== b && ($c32e4b0ba829ddb2$var$Ac(b, 1, a), $c32e4b0ba829ddb2$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $c32e4b0ba829ddb2$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $c32e4b0ba829ddb2$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $c32e4b0ba829ddb2$var$Q === a && ($c32e4b0ba829ddb2$var$Z & c) === c && (4 === $c32e4b0ba829ddb2$var$T || 3 === $c32e4b0ba829ddb2$var$T && ($c32e4b0ba829ddb2$var$Z & 130023424) === $c32e4b0ba829ddb2$var$Z && 500 > $c32e4b0ba829ddb2$var$B() - $c32e4b0ba829ddb2$var$fk ? $c32e4b0ba829ddb2$var$Kk(a, 0) : $c32e4b0ba829ddb2$var$rk |= c);
    $c32e4b0ba829ddb2$var$Dk(a, b);
}
function $c32e4b0ba829ddb2$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $c32e4b0ba829ddb2$var$sc, $c32e4b0ba829ddb2$var$sc <<= 1, 0 === ($c32e4b0ba829ddb2$var$sc & 130023424) && ($c32e4b0ba829ddb2$var$sc = 4194304)));
    var c = $c32e4b0ba829ddb2$var$R();
    a = $c32e4b0ba829ddb2$var$ih(a, b);
    null !== a && ($c32e4b0ba829ddb2$var$Ac(a, b, c), $c32e4b0ba829ddb2$var$Dk(a, c));
}
function $c32e4b0ba829ddb2$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $c32e4b0ba829ddb2$var$Yk(a, c);
}
function $c32e4b0ba829ddb2$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($c32e4b0ba829ddb2$var$p(314));
    }
    null !== d && d.delete(b);
    $c32e4b0ba829ddb2$var$Yk(a, c);
}
var $c32e4b0ba829ddb2$var$Vk;
$c32e4b0ba829ddb2$var$Vk = function Vk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $c32e4b0ba829ddb2$var$Wf.current) $c32e4b0ba829ddb2$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $c32e4b0ba829ddb2$var$dh = !1, $c32e4b0ba829ddb2$var$yj(a, b, c);
            $c32e4b0ba829ddb2$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $c32e4b0ba829ddb2$var$dh = !1, $c32e4b0ba829ddb2$var$I && 0 !== (b.flags & 1048576) && $c32e4b0ba829ddb2$var$ug(b, $c32e4b0ba829ddb2$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $c32e4b0ba829ddb2$var$ij(a, b);
            a = b.pendingProps;
            var e = $c32e4b0ba829ddb2$var$Yf(b, $c32e4b0ba829ddb2$var$H.current);
            $c32e4b0ba829ddb2$var$ch(b, c);
            e = $c32e4b0ba829ddb2$var$Nh(null, b, d, a, e, c);
            var f = $c32e4b0ba829ddb2$var$Sh();
            b.flags |= 1;
            "object" === (typeof e === "undefined" ? "undefined" : (0, $2bfPH._)(e)) && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $c32e4b0ba829ddb2$var$Zf(d) ? (f = !0, $c32e4b0ba829ddb2$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $c32e4b0ba829ddb2$var$kh(b), e.updater = $c32e4b0ba829ddb2$var$Ei, b.stateNode = e, e._reactInternals = b, $c32e4b0ba829ddb2$var$Ii(b, d, a, c), b = $c32e4b0ba829ddb2$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $c32e4b0ba829ddb2$var$I && f && $c32e4b0ba829ddb2$var$vg(b), $c32e4b0ba829ddb2$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $c32e4b0ba829ddb2$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $c32e4b0ba829ddb2$var$Zk(d);
                a = $c32e4b0ba829ddb2$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $c32e4b0ba829ddb2$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $c32e4b0ba829ddb2$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $c32e4b0ba829ddb2$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $c32e4b0ba829ddb2$var$$i(null, b, d, $c32e4b0ba829ddb2$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($c32e4b0ba829ddb2$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c32e4b0ba829ddb2$var$Ci(d, e), $c32e4b0ba829ddb2$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c32e4b0ba829ddb2$var$Ci(d, e), $c32e4b0ba829ddb2$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $c32e4b0ba829ddb2$var$kj(b);
                if (null === a) throw Error($c32e4b0ba829ddb2$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $c32e4b0ba829ddb2$var$lh(a, b);
                $c32e4b0ba829ddb2$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $c32e4b0ba829ddb2$var$Ji(Error($c32e4b0ba829ddb2$var$p(423)), b);
                        b = $c32e4b0ba829ddb2$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $c32e4b0ba829ddb2$var$Ji(Error($c32e4b0ba829ddb2$var$p(424)), b);
                        b = $c32e4b0ba829ddb2$var$lj(a, b, d, c, e);
                        break a;
                    } else for($c32e4b0ba829ddb2$var$yg = $c32e4b0ba829ddb2$var$Lf(b.stateNode.containerInfo.firstChild), $c32e4b0ba829ddb2$var$xg = b, $c32e4b0ba829ddb2$var$I = !0, $c32e4b0ba829ddb2$var$zg = null, c = $c32e4b0ba829ddb2$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $c32e4b0ba829ddb2$var$Ig();
                    if (d === e) {
                        b = $c32e4b0ba829ddb2$var$Zi(a, b, c);
                        break a;
                    }
                    $c32e4b0ba829ddb2$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $c32e4b0ba829ddb2$var$Ah(b), null === a && $c32e4b0ba829ddb2$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $c32e4b0ba829ddb2$var$Ef(d, e) ? g = null : null !== f && $c32e4b0ba829ddb2$var$Ef(d, f) && (b.flags |= 32), $c32e4b0ba829ddb2$var$gj(a, b), $c32e4b0ba829ddb2$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $c32e4b0ba829ddb2$var$Eg(b), null;
        case 13:
            return $c32e4b0ba829ddb2$var$oj(a, b, c);
        case 4:
            return $c32e4b0ba829ddb2$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $c32e4b0ba829ddb2$var$Ug(b, null, d, c) : $c32e4b0ba829ddb2$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c32e4b0ba829ddb2$var$Ci(d, e), $c32e4b0ba829ddb2$var$Yi(a, b, d, e, c);
        case 7:
            return $c32e4b0ba829ddb2$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $c32e4b0ba829ddb2$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $c32e4b0ba829ddb2$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $c32e4b0ba829ddb2$var$G($c32e4b0ba829ddb2$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($c32e4b0ba829ddb2$var$He(f.value, g)) {
                        if (f.children === e.children && !$c32e4b0ba829ddb2$var$Wf.current) {
                            b = $c32e4b0ba829ddb2$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $c32e4b0ba829ddb2$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $c32e4b0ba829ddb2$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($c32e4b0ba829ddb2$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $c32e4b0ba829ddb2$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $c32e4b0ba829ddb2$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $c32e4b0ba829ddb2$var$ch(b, c), e = $c32e4b0ba829ddb2$var$eh(e), d = d(e), b.flags |= 1, $c32e4b0ba829ddb2$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $c32e4b0ba829ddb2$var$Ci(d, b.pendingProps), e = $c32e4b0ba829ddb2$var$Ci(d.type, e), $c32e4b0ba829ddb2$var$$i(a, b, d, e, c);
        case 15:
            return $c32e4b0ba829ddb2$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c32e4b0ba829ddb2$var$Ci(d, e), $c32e4b0ba829ddb2$var$ij(a, b), b.tag = 1, $c32e4b0ba829ddb2$var$Zf(d) ? (a = !0, $c32e4b0ba829ddb2$var$cg(b)) : a = !1, $c32e4b0ba829ddb2$var$ch(b, c), $c32e4b0ba829ddb2$var$Gi(b, d, e), $c32e4b0ba829ddb2$var$Ii(b, d, e, c), $c32e4b0ba829ddb2$var$jj(null, b, d, !0, a, c);
        case 19:
            return $c32e4b0ba829ddb2$var$xj(a, b, c);
        case 22:
            return $c32e4b0ba829ddb2$var$dj(a, b, c);
    }
    throw Error($c32e4b0ba829ddb2$var$p(156, b.tag));
};
function $c32e4b0ba829ddb2$var$Fk(a, b) {
    return $c32e4b0ba829ddb2$var$ac(a, b);
}
function $c32e4b0ba829ddb2$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c32e4b0ba829ddb2$var$Bg(a, b, c, d) {
    return new $c32e4b0ba829ddb2$var$$k(a, b, c, d);
}
function $c32e4b0ba829ddb2$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $c32e4b0ba829ddb2$var$Zk(a) {
    if ("function" === typeof a) return $c32e4b0ba829ddb2$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $c32e4b0ba829ddb2$var$Da) return 11;
        if (a === $c32e4b0ba829ddb2$var$Ga) return 14;
    }
    return 2;
}
function $c32e4b0ba829ddb2$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $c32e4b0ba829ddb2$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $c32e4b0ba829ddb2$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $c32e4b0ba829ddb2$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $c32e4b0ba829ddb2$var$ya:
            return $c32e4b0ba829ddb2$var$Tg(c.children, e, f, b);
        case $c32e4b0ba829ddb2$var$za:
            g = 8;
            e |= 8;
            break;
        case $c32e4b0ba829ddb2$var$Aa:
            return a = $c32e4b0ba829ddb2$var$Bg(12, c, b, e | 2), a.elementType = $c32e4b0ba829ddb2$var$Aa, a.lanes = f, a;
        case $c32e4b0ba829ddb2$var$Ea:
            return a = $c32e4b0ba829ddb2$var$Bg(13, c, b, e), a.elementType = $c32e4b0ba829ddb2$var$Ea, a.lanes = f, a;
        case $c32e4b0ba829ddb2$var$Fa:
            return a = $c32e4b0ba829ddb2$var$Bg(19, c, b, e), a.elementType = $c32e4b0ba829ddb2$var$Fa, a.lanes = f, a;
        case $c32e4b0ba829ddb2$var$Ia:
            return $c32e4b0ba829ddb2$var$pj(c, e, f, b);
        default:
            if ("object" === (typeof a === "undefined" ? "undefined" : (0, $2bfPH._)(a)) && null !== a) switch(a.$$typeof){
                case $c32e4b0ba829ddb2$var$Ba:
                    g = 10;
                    break a;
                case $c32e4b0ba829ddb2$var$Ca:
                    g = 9;
                    break a;
                case $c32e4b0ba829ddb2$var$Da:
                    g = 11;
                    break a;
                case $c32e4b0ba829ddb2$var$Ga:
                    g = 14;
                    break a;
                case $c32e4b0ba829ddb2$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($c32e4b0ba829ddb2$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $2bfPH._)(a), ""));
    }
    b = $c32e4b0ba829ddb2$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $c32e4b0ba829ddb2$var$Tg(a, b, c, d) {
    a = $c32e4b0ba829ddb2$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $c32e4b0ba829ddb2$var$pj(a, b, c, d) {
    a = $c32e4b0ba829ddb2$var$Bg(22, a, d, b);
    a.elementType = $c32e4b0ba829ddb2$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $c32e4b0ba829ddb2$var$Qg(a, b, c) {
    a = $c32e4b0ba829ddb2$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $c32e4b0ba829ddb2$var$Sg(a, b, c) {
    b = $c32e4b0ba829ddb2$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $c32e4b0ba829ddb2$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $c32e4b0ba829ddb2$var$zc(0);
    this.expirationTimes = $c32e4b0ba829ddb2$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c32e4b0ba829ddb2$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $c32e4b0ba829ddb2$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $c32e4b0ba829ddb2$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $c32e4b0ba829ddb2$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $c32e4b0ba829ddb2$var$kh(f);
    return a;
}
function $c32e4b0ba829ddb2$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c32e4b0ba829ddb2$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $c32e4b0ba829ddb2$var$dl(a) {
    if (!a) return $c32e4b0ba829ddb2$var$Vf;
    a = a._reactInternals;
    a: {
        if ($c32e4b0ba829ddb2$var$Vb(a) !== a || 1 !== a.tag) throw Error($c32e4b0ba829ddb2$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($c32e4b0ba829ddb2$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($c32e4b0ba829ddb2$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($c32e4b0ba829ddb2$var$Zf(c)) return $c32e4b0ba829ddb2$var$bg(a, c, b);
    }
    return b;
}
function $c32e4b0ba829ddb2$var$el(a, b, c, d, e, f, g, h, k) {
    a = $c32e4b0ba829ddb2$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $c32e4b0ba829ddb2$var$dl(null);
    c = a.current;
    d = $c32e4b0ba829ddb2$var$R();
    e = $c32e4b0ba829ddb2$var$yi(c);
    f = $c32e4b0ba829ddb2$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $c32e4b0ba829ddb2$var$nh(c, f, e);
    a.current.lanes = e;
    $c32e4b0ba829ddb2$var$Ac(a, e, d);
    $c32e4b0ba829ddb2$var$Dk(a, d);
    return a;
}
function $c32e4b0ba829ddb2$var$fl(a, b, c, d) {
    var e = b.current, f = $c32e4b0ba829ddb2$var$R(), g = $c32e4b0ba829ddb2$var$yi(e);
    c = $c32e4b0ba829ddb2$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $c32e4b0ba829ddb2$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $c32e4b0ba829ddb2$var$nh(e, b, g);
    null !== a && ($c32e4b0ba829ddb2$var$gi(a, e, g, f), $c32e4b0ba829ddb2$var$oh(a, e, g));
    return g;
}
function $c32e4b0ba829ddb2$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $c32e4b0ba829ddb2$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $c32e4b0ba829ddb2$var$il(a, b) {
    $c32e4b0ba829ddb2$var$hl(a, b);
    (a = a.alternate) && $c32e4b0ba829ddb2$var$hl(a, b);
}
function $c32e4b0ba829ddb2$var$jl() {
    return null;
}
var $c32e4b0ba829ddb2$var$kl = "function" === typeof reportError ? reportError : function kl(a) {
    console.error(a);
};
function $c32e4b0ba829ddb2$var$ll(a) {
    this._internalRoot = a;
}
$c32e4b0ba829ddb2$var$ml.prototype.render = $c32e4b0ba829ddb2$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($c32e4b0ba829ddb2$var$p(409));
    $c32e4b0ba829ddb2$var$fl(a, b, null, null);
};
$c32e4b0ba829ddb2$var$ml.prototype.unmount = $c32e4b0ba829ddb2$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $c32e4b0ba829ddb2$var$Rk(function() {
            $c32e4b0ba829ddb2$var$fl(null, a, null, null);
        });
        b[$c32e4b0ba829ddb2$var$uf] = null;
    }
};
function $c32e4b0ba829ddb2$var$ml(a) {
    this._internalRoot = a;
}
$c32e4b0ba829ddb2$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $c32e4b0ba829ddb2$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $c32e4b0ba829ddb2$var$Qc.length && 0 !== b && b < $c32e4b0ba829ddb2$var$Qc[c].priority; c++);
        $c32e4b0ba829ddb2$var$Qc.splice(c, 0, a);
        0 === c && $c32e4b0ba829ddb2$var$Vc(a);
    }
};
function $c32e4b0ba829ddb2$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $c32e4b0ba829ddb2$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $c32e4b0ba829ddb2$var$pl() {}
function $c32e4b0ba829ddb2$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $c32e4b0ba829ddb2$var$gl(g);
                f.call(_$a);
            };
        }
        var g = $c32e4b0ba829ddb2$var$el(b, d, a, 0, null, !1, !1, "", $c32e4b0ba829ddb2$var$pl);
        a._reactRootContainer = g;
        a[$c32e4b0ba829ddb2$var$uf] = g.current;
        $c32e4b0ba829ddb2$var$sf(8 === a.nodeType ? a.parentNode : a);
        $c32e4b0ba829ddb2$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $c32e4b0ba829ddb2$var$gl(k);
            h.call(_$a);
        };
    }
    var k = $c32e4b0ba829ddb2$var$bl(a, 0, !1, null, null, !1, !1, "", $c32e4b0ba829ddb2$var$pl);
    a._reactRootContainer = k;
    a[$c32e4b0ba829ddb2$var$uf] = k.current;
    $c32e4b0ba829ddb2$var$sf(8 === a.nodeType ? a.parentNode : a);
    $c32e4b0ba829ddb2$var$Rk(function() {
        $c32e4b0ba829ddb2$var$fl(b, k, c, d);
    });
    return k;
}
function $c32e4b0ba829ddb2$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $c32e4b0ba829ddb2$var$gl(g);
                h.call(_$a);
            };
        }
        $c32e4b0ba829ddb2$var$fl(b, g, a, e);
    } else g = $c32e4b0ba829ddb2$var$ql(c, b, a, e, d);
    return $c32e4b0ba829ddb2$var$gl(g);
}
$c32e4b0ba829ddb2$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $c32e4b0ba829ddb2$var$tc(b.pendingLanes);
                0 !== c && ($c32e4b0ba829ddb2$var$Cc(b, c | 1), $c32e4b0ba829ddb2$var$Dk(b, $c32e4b0ba829ddb2$var$B()), 0 === ($c32e4b0ba829ddb2$var$K & 6) && ($c32e4b0ba829ddb2$var$Gj = $c32e4b0ba829ddb2$var$B() + 500, $c32e4b0ba829ddb2$var$jg()));
            }
            break;
        case 13:
            $c32e4b0ba829ddb2$var$Rk(function() {
                var b = $c32e4b0ba829ddb2$var$ih(a, 1);
                if (null !== b) {
                    var c = $c32e4b0ba829ddb2$var$R();
                    $c32e4b0ba829ddb2$var$gi(b, a, 1, c);
                }
            }), $c32e4b0ba829ddb2$var$il(a, 1);
    }
};
$c32e4b0ba829ddb2$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $c32e4b0ba829ddb2$var$ih(a, 134217728);
        if (null !== b) {
            var c = $c32e4b0ba829ddb2$var$R();
            $c32e4b0ba829ddb2$var$gi(b, a, 134217728, c);
        }
        $c32e4b0ba829ddb2$var$il(a, 134217728);
    }
};
$c32e4b0ba829ddb2$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $c32e4b0ba829ddb2$var$yi(a), c = $c32e4b0ba829ddb2$var$ih(a, b);
        if (null !== c) {
            var d = $c32e4b0ba829ddb2$var$R();
            $c32e4b0ba829ddb2$var$gi(c, a, b, d);
        }
        $c32e4b0ba829ddb2$var$il(a, b);
    }
};
$c32e4b0ba829ddb2$var$Hc = function Hc() {
    return $c32e4b0ba829ddb2$var$C;
};
$c32e4b0ba829ddb2$var$Ic = function Ic(a, b) {
    var c = $c32e4b0ba829ddb2$var$C;
    try {
        return $c32e4b0ba829ddb2$var$C = a, b();
    } finally{
        $c32e4b0ba829ddb2$var$C = c;
    }
};
$c32e4b0ba829ddb2$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $c32e4b0ba829ddb2$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $c32e4b0ba829ddb2$var$Db(d);
                        if (!e) throw Error($c32e4b0ba829ddb2$var$p(90));
                        $c32e4b0ba829ddb2$var$Wa(d);
                        $c32e4b0ba829ddb2$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $c32e4b0ba829ddb2$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $c32e4b0ba829ddb2$var$fb(a, !!c.multiple, b, !1);
    }
};
$c32e4b0ba829ddb2$var$Gb = $c32e4b0ba829ddb2$var$Qk;
$c32e4b0ba829ddb2$var$Hb = $c32e4b0ba829ddb2$var$Rk;
var $c32e4b0ba829ddb2$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $c32e4b0ba829ddb2$var$Cb,
        $c32e4b0ba829ddb2$var$ue,
        $c32e4b0ba829ddb2$var$Db,
        $c32e4b0ba829ddb2$var$Eb,
        $c32e4b0ba829ddb2$var$Fb,
        $c32e4b0ba829ddb2$var$Qk
    ]
}, $c32e4b0ba829ddb2$var$tl = {
    findFiberByHostInstance: $c32e4b0ba829ddb2$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $c32e4b0ba829ddb2$var$ul = {
    bundleType: $c32e4b0ba829ddb2$var$tl.bundleType,
    version: $c32e4b0ba829ddb2$var$tl.version,
    rendererPackageName: $c32e4b0ba829ddb2$var$tl.rendererPackageName,
    rendererConfig: $c32e4b0ba829ddb2$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $c32e4b0ba829ddb2$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $c32e4b0ba829ddb2$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $c32e4b0ba829ddb2$var$tl.findFiberByHostInstance || $c32e4b0ba829ddb2$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c32e4b0ba829ddb2$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c32e4b0ba829ddb2$var$vl.isDisabled && $c32e4b0ba829ddb2$var$vl.supportsFiber) try {
        $c32e4b0ba829ddb2$var$kc = $c32e4b0ba829ddb2$var$vl.inject($c32e4b0ba829ddb2$var$ul), $c32e4b0ba829ddb2$var$lc = $c32e4b0ba829ddb2$var$vl;
    } catch (a) {}
}
$c32e4b0ba829ddb2$export$ae55be85d98224ed = $c32e4b0ba829ddb2$var$sl;
$c32e4b0ba829ddb2$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$c32e4b0ba829ddb2$var$nl(b)) throw Error($c32e4b0ba829ddb2$var$p(200));
    return $c32e4b0ba829ddb2$var$cl(a, b, null, c);
};
$c32e4b0ba829ddb2$export$882461b6382ed46c = function(a, b) {
    if (!$c32e4b0ba829ddb2$var$nl(a)) throw Error($c32e4b0ba829ddb2$var$p(299));
    var c = !1, d = "", e = $c32e4b0ba829ddb2$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $c32e4b0ba829ddb2$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$c32e4b0ba829ddb2$var$uf] = b.current;
    $c32e4b0ba829ddb2$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $c32e4b0ba829ddb2$var$ll(b);
};
$c32e4b0ba829ddb2$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($c32e4b0ba829ddb2$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($c32e4b0ba829ddb2$var$p(268, a));
    }
    a = $c32e4b0ba829ddb2$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$c32e4b0ba829ddb2$export$cd75ccfd720a3cd4 = function(a) {
    return $c32e4b0ba829ddb2$var$Rk(a);
};
$c32e4b0ba829ddb2$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$c32e4b0ba829ddb2$var$ol(b)) throw Error($c32e4b0ba829ddb2$var$p(200));
    return $c32e4b0ba829ddb2$var$rl(null, a, b, !0, c);
};
$c32e4b0ba829ddb2$export$757ceba2d55c277e = function(a, b, c) {
    if (!$c32e4b0ba829ddb2$var$nl(a)) throw Error($c32e4b0ba829ddb2$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $c32e4b0ba829ddb2$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $c32e4b0ba829ddb2$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$c32e4b0ba829ddb2$var$uf] = b.current;
    $c32e4b0ba829ddb2$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $c32e4b0ba829ddb2$var$ml(b);
};
$c32e4b0ba829ddb2$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$c32e4b0ba829ddb2$var$ol(b)) throw Error($c32e4b0ba829ddb2$var$p(200));
    return $c32e4b0ba829ddb2$var$rl(null, a, b, !1, c);
};
$c32e4b0ba829ddb2$export$502457920280e6be = function(a) {
    if (!$c32e4b0ba829ddb2$var$ol(a)) throw Error($c32e4b0ba829ddb2$var$p(40));
    return a._reactRootContainer ? ($c32e4b0ba829ddb2$var$Rk(function() {
        $c32e4b0ba829ddb2$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$c32e4b0ba829ddb2$var$uf] = null;
        });
    }), !0) : !1;
};
$c32e4b0ba829ddb2$export$c78a37762a8d58e1 = $c32e4b0ba829ddb2$var$Qk;
$c32e4b0ba829ddb2$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$c32e4b0ba829ddb2$var$ol(c)) throw Error($c32e4b0ba829ddb2$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($c32e4b0ba829ddb2$var$p(38));
    return $c32e4b0ba829ddb2$var$rl(a, b, c, !1, d);
};
$c32e4b0ba829ddb2$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("2bfPH", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1968e3edfc5cfc11$export$71511d61b312f219; });
function $1968e3edfc5cfc11$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRegister("eHaBZ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("luEM2"));

});
parcelRegister("luEM2", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $fa5c07254b0b0f21$export$dca3b0875bd9a954; }, function (v) { return $fa5c07254b0b0f21$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $fa5c07254b0b0f21$export$16fa2f45be04daa8; }, function (v) { return $fa5c07254b0b0f21$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $fa5c07254b0b0f21$export$ffb0004e005737fa; }, function (v) { return $fa5c07254b0b0f21$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $fa5c07254b0b0f21$export$e2c29f18771995cb; }, function (v) { return $fa5c07254b0b0f21$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $fa5c07254b0b0f21$export$221d75b3f55bb0bd; }, function (v) { return $fa5c07254b0b0f21$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $fa5c07254b0b0f21$export$5f8d39834fd61797; }, function (v) { return $fa5c07254b0b0f21$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $fa5c07254b0b0f21$export$74bf444e3cd11ea5; }, function (v) { return $fa5c07254b0b0f21$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $fa5c07254b0b0f21$export$ae55be85d98224ed; }, function (v) { return $fa5c07254b0b0f21$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $fa5c07254b0b0f21$export$3ba232387fd5d6dd; }, function (v) { return $fa5c07254b0b0f21$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $fa5c07254b0b0f21$export$e530037191fcd5d7; }, function (v) { return $fa5c07254b0b0f21$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $fa5c07254b0b0f21$export$fd42f52fd3ae1109; }, function (v) { return $fa5c07254b0b0f21$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $fa5c07254b0b0f21$export$c8a8987d4410bf2d; }, function (v) { return $fa5c07254b0b0f21$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $fa5c07254b0b0f21$export$d38cd72104c1f0e9; }, function (v) { return $fa5c07254b0b0f21$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $fa5c07254b0b0f21$export$7d1e3a5e95ceca43; }, function (v) { return $fa5c07254b0b0f21$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $fa5c07254b0b0f21$export$257a8862b851cb5b; }, function (v) { return $fa5c07254b0b0f21$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $fa5c07254b0b0f21$export$a8257692ac88316c; }, function (v) { return $fa5c07254b0b0f21$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $fa5c07254b0b0f21$export$488013bae63b21da; }, function (v) { return $fa5c07254b0b0f21$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $fa5c07254b0b0f21$export$7c73462e0d25e514; }, function (v) { return $fa5c07254b0b0f21$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $fa5c07254b0b0f21$export$7568632d0d33d16d; }, function (v) { return $fa5c07254b0b0f21$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $fa5c07254b0b0f21$export$88948ce120ea2619; }, function (v) { return $fa5c07254b0b0f21$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $fa5c07254b0b0f21$export$35808ee640e87ca7; }, function (v) { return $fa5c07254b0b0f21$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $fa5c07254b0b0f21$export$fae74005e78b1a27; }, function (v) { return $fa5c07254b0b0f21$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $fa5c07254b0b0f21$export$dc8fbce3eb94dc1e; }, function (v) { return $fa5c07254b0b0f21$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $fa5c07254b0b0f21$export$6a7bc4e911dc01cf; }, function (v) { return $fa5c07254b0b0f21$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $fa5c07254b0b0f21$export$6d9c69b0de29b591; }, function (v) { return $fa5c07254b0b0f21$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $fa5c07254b0b0f21$export$f680877a34711e37; }, function (v) { return $fa5c07254b0b0f21$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $fa5c07254b0b0f21$export$d5a552a76deda3c2; }, function (v) { return $fa5c07254b0b0f21$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $fa5c07254b0b0f21$export$aaabe4eda9ed9969; }, function (v) { return $fa5c07254b0b0f21$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $fa5c07254b0b0f21$export$e5c5a5f917a5871c; }, function (v) { return $fa5c07254b0b0f21$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $fa5c07254b0b0f21$export$1538c33de8887b59; }, function (v) { return $fa5c07254b0b0f21$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $fa5c07254b0b0f21$export$13e3392192263954; }, function (v) { return $fa5c07254b0b0f21$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $fa5c07254b0b0f21$export$b8f5890fc79d6aca; }, function (v) { return $fa5c07254b0b0f21$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $fa5c07254b0b0f21$export$60241385465d0a34; }, function (v) { return $fa5c07254b0b0f21$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $fa5c07254b0b0f21$export$306c0aa65ff9ec16; }, function (v) { return $fa5c07254b0b0f21$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $fa5c07254b0b0f21$export$7b286972b8d8ccbf; }, function (v) { return $fa5c07254b0b0f21$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $fa5c07254b0b0f21$export$83d89fbfd8236492; }, function (v) { return $fa5c07254b0b0f21$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $2bfPH = parcelRequire("2bfPH");
var $fa5c07254b0b0f21$export$dca3b0875bd9a954;
var $fa5c07254b0b0f21$export$16fa2f45be04daa8;
var $fa5c07254b0b0f21$export$ffb0004e005737fa;
var $fa5c07254b0b0f21$export$e2c29f18771995cb;
var $fa5c07254b0b0f21$export$221d75b3f55bb0bd;
var $fa5c07254b0b0f21$export$5f8d39834fd61797;
var $fa5c07254b0b0f21$export$74bf444e3cd11ea5;
var $fa5c07254b0b0f21$export$ae55be85d98224ed;
var $fa5c07254b0b0f21$export$3ba232387fd5d6dd;
var $fa5c07254b0b0f21$export$e530037191fcd5d7;
var $fa5c07254b0b0f21$export$fd42f52fd3ae1109;
var $fa5c07254b0b0f21$export$c8a8987d4410bf2d;
var $fa5c07254b0b0f21$export$d38cd72104c1f0e9;
var $fa5c07254b0b0f21$export$7d1e3a5e95ceca43;
var $fa5c07254b0b0f21$export$257a8862b851cb5b;
var $fa5c07254b0b0f21$export$a8257692ac88316c;
var $fa5c07254b0b0f21$export$488013bae63b21da;
var $fa5c07254b0b0f21$export$7c73462e0d25e514;
var $fa5c07254b0b0f21$export$7568632d0d33d16d;
var $fa5c07254b0b0f21$export$88948ce120ea2619;
var $fa5c07254b0b0f21$export$35808ee640e87ca7;
var $fa5c07254b0b0f21$export$fae74005e78b1a27;
var $fa5c07254b0b0f21$export$dc8fbce3eb94dc1e;
var $fa5c07254b0b0f21$export$6a7bc4e911dc01cf;
var $fa5c07254b0b0f21$export$6d9c69b0de29b591;
var $fa5c07254b0b0f21$export$f680877a34711e37;
var $fa5c07254b0b0f21$export$d5a552a76deda3c2;
var $fa5c07254b0b0f21$export$aaabe4eda9ed9969;
var $fa5c07254b0b0f21$export$e5c5a5f917a5871c;
var $fa5c07254b0b0f21$export$1538c33de8887b59;
var $fa5c07254b0b0f21$export$13e3392192263954;
var $fa5c07254b0b0f21$export$b8f5890fc79d6aca;
var $fa5c07254b0b0f21$export$60241385465d0a34;
var $fa5c07254b0b0f21$export$306c0aa65ff9ec16;
var $fa5c07254b0b0f21$export$7b286972b8d8ccbf;
var $fa5c07254b0b0f21$export$83d89fbfd8236492;
'use strict';
var $fa5c07254b0b0f21$var$l = Symbol.for("react.element"), $fa5c07254b0b0f21$var$n = Symbol.for("react.portal"), $fa5c07254b0b0f21$var$p = Symbol.for("react.fragment"), $fa5c07254b0b0f21$var$q = Symbol.for("react.strict_mode"), $fa5c07254b0b0f21$var$r = Symbol.for("react.profiler"), $fa5c07254b0b0f21$var$t = Symbol.for("react.provider"), $fa5c07254b0b0f21$var$u = Symbol.for("react.context"), $fa5c07254b0b0f21$var$v = Symbol.for("react.forward_ref"), $fa5c07254b0b0f21$var$w = Symbol.for("react.suspense"), $fa5c07254b0b0f21$var$x = Symbol.for("react.memo"), $fa5c07254b0b0f21$var$y = Symbol.for("react.lazy"), $fa5c07254b0b0f21$var$z = Symbol.iterator;
function $fa5c07254b0b0f21$var$A(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, $2bfPH._)(a))) return null;
    a = $fa5c07254b0b0f21$var$z && a[$fa5c07254b0b0f21$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $fa5c07254b0b0f21$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $fa5c07254b0b0f21$var$C = Object.assign, $fa5c07254b0b0f21$var$D = {};
function $fa5c07254b0b0f21$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $fa5c07254b0b0f21$var$D;
    this.updater = e || $fa5c07254b0b0f21$var$B;
}
$fa5c07254b0b0f21$var$E.prototype.isReactComponent = {};
$fa5c07254b0b0f21$var$E.prototype.setState = function(a, b) {
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, $2bfPH._)(a)) && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$fa5c07254b0b0f21$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $fa5c07254b0b0f21$var$F() {}
$fa5c07254b0b0f21$var$F.prototype = $fa5c07254b0b0f21$var$E.prototype;
function $fa5c07254b0b0f21$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $fa5c07254b0b0f21$var$D;
    this.updater = e || $fa5c07254b0b0f21$var$B;
}
var $fa5c07254b0b0f21$var$H = $fa5c07254b0b0f21$var$G.prototype = new $fa5c07254b0b0f21$var$F;
$fa5c07254b0b0f21$var$H.constructor = $fa5c07254b0b0f21$var$G;
$fa5c07254b0b0f21$var$C($fa5c07254b0b0f21$var$H, $fa5c07254b0b0f21$var$E.prototype);
$fa5c07254b0b0f21$var$H.isPureReactComponent = !0;
var $fa5c07254b0b0f21$var$I = Array.isArray, $fa5c07254b0b0f21$var$J = Object.prototype.hasOwnProperty, $fa5c07254b0b0f21$var$K = {
    current: null
}, $fa5c07254b0b0f21$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $fa5c07254b0b0f21$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$fa5c07254b0b0f21$var$J.call(b, d) && !$fa5c07254b0b0f21$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $fa5c07254b0b0f21$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $fa5c07254b0b0f21$var$K.current
    };
}
function $fa5c07254b0b0f21$var$N(a, b) {
    return {
        $$typeof: $fa5c07254b0b0f21$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $fa5c07254b0b0f21$var$O(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $2bfPH._)(a)) && null !== a && a.$$typeof === $fa5c07254b0b0f21$var$l;
}
function $fa5c07254b0b0f21$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $fa5c07254b0b0f21$var$P = /\/+/g;
function $fa5c07254b0b0f21$var$Q(a, b) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $2bfPH._)(a)) && null !== a && null != a.key ? $fa5c07254b0b0f21$var$escape("" + a.key) : b.toString(36);
}
function $fa5c07254b0b0f21$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $2bfPH._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $fa5c07254b0b0f21$var$l:
                case $fa5c07254b0b0f21$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $fa5c07254b0b0f21$var$Q(h, 0) : d, $fa5c07254b0b0f21$var$I(c) ? (e = "", null != a && (e = a.replace($fa5c07254b0b0f21$var$P, "$&/") + "/"), $fa5c07254b0b0f21$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($fa5c07254b0b0f21$var$O(c) && (c = $fa5c07254b0b0f21$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($fa5c07254b0b0f21$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($fa5c07254b0b0f21$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $fa5c07254b0b0f21$var$Q(k, g);
        h += $fa5c07254b0b0f21$var$R(k, b, e, f, c);
    }
    else if (f = $fa5c07254b0b0f21$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $fa5c07254b0b0f21$var$Q(k, g++), h += $fa5c07254b0b0f21$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $fa5c07254b0b0f21$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $fa5c07254b0b0f21$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $fa5c07254b0b0f21$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $fa5c07254b0b0f21$var$U = {
    current: null
}, $fa5c07254b0b0f21$var$V = {
    transition: null
}, $fa5c07254b0b0f21$var$W = {
    ReactCurrentDispatcher: $fa5c07254b0b0f21$var$U,
    ReactCurrentBatchConfig: $fa5c07254b0b0f21$var$V,
    ReactCurrentOwner: $fa5c07254b0b0f21$var$K
};
function $fa5c07254b0b0f21$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$fa5c07254b0b0f21$export$dca3b0875bd9a954 = {
    map: $fa5c07254b0b0f21$var$S,
    forEach: function forEach(a, b, e) {
        $fa5c07254b0b0f21$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $fa5c07254b0b0f21$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $fa5c07254b0b0f21$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$fa5c07254b0b0f21$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$fa5c07254b0b0f21$export$16fa2f45be04daa8 = $fa5c07254b0b0f21$var$E;
$fa5c07254b0b0f21$export$ffb0004e005737fa = $fa5c07254b0b0f21$var$p;
$fa5c07254b0b0f21$export$e2c29f18771995cb = $fa5c07254b0b0f21$var$r;
$fa5c07254b0b0f21$export$221d75b3f55bb0bd = $fa5c07254b0b0f21$var$G;
$fa5c07254b0b0f21$export$5f8d39834fd61797 = $fa5c07254b0b0f21$var$q;
$fa5c07254b0b0f21$export$74bf444e3cd11ea5 = $fa5c07254b0b0f21$var$w;
$fa5c07254b0b0f21$export$ae55be85d98224ed = $fa5c07254b0b0f21$var$W;
$fa5c07254b0b0f21$export$3ba232387fd5d6dd = $fa5c07254b0b0f21$var$X;
$fa5c07254b0b0f21$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $fa5c07254b0b0f21$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $fa5c07254b0b0f21$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$fa5c07254b0b0f21$var$J.call(b, f) && !$fa5c07254b0b0f21$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $fa5c07254b0b0f21$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$fa5c07254b0b0f21$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $fa5c07254b0b0f21$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $fa5c07254b0b0f21$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$fa5c07254b0b0f21$export$c8a8987d4410bf2d = $fa5c07254b0b0f21$var$M;
$fa5c07254b0b0f21$export$d38cd72104c1f0e9 = function(a) {
    var b = $fa5c07254b0b0f21$var$M.bind(null, a);
    b.type = a;
    return b;
};
$fa5c07254b0b0f21$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$fa5c07254b0b0f21$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $fa5c07254b0b0f21$var$v,
        render: a
    };
};
$fa5c07254b0b0f21$export$a8257692ac88316c = $fa5c07254b0b0f21$var$O;
$fa5c07254b0b0f21$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $fa5c07254b0b0f21$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $fa5c07254b0b0f21$var$T
    };
};
$fa5c07254b0b0f21$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $fa5c07254b0b0f21$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$fa5c07254b0b0f21$export$7568632d0d33d16d = function(a) {
    var b = $fa5c07254b0b0f21$var$V.transition;
    $fa5c07254b0b0f21$var$V.transition = {};
    try {
        a();
    } finally{
        $fa5c07254b0b0f21$var$V.transition = b;
    }
};
$fa5c07254b0b0f21$export$88948ce120ea2619 = $fa5c07254b0b0f21$var$X;
$fa5c07254b0b0f21$export$35808ee640e87ca7 = function(a, b) {
    return $fa5c07254b0b0f21$var$U.current.useCallback(a, b);
};
$fa5c07254b0b0f21$export$fae74005e78b1a27 = function(a) {
    return $fa5c07254b0b0f21$var$U.current.useContext(a);
};
$fa5c07254b0b0f21$export$dc8fbce3eb94dc1e = function() {};
$fa5c07254b0b0f21$export$6a7bc4e911dc01cf = function(a) {
    return $fa5c07254b0b0f21$var$U.current.useDeferredValue(a);
};
$fa5c07254b0b0f21$export$6d9c69b0de29b591 = function(a, b) {
    return $fa5c07254b0b0f21$var$U.current.useEffect(a, b);
};
$fa5c07254b0b0f21$export$f680877a34711e37 = function() {
    return $fa5c07254b0b0f21$var$U.current.useId();
};
$fa5c07254b0b0f21$export$d5a552a76deda3c2 = function(a, b, e) {
    return $fa5c07254b0b0f21$var$U.current.useImperativeHandle(a, b, e);
};
$fa5c07254b0b0f21$export$aaabe4eda9ed9969 = function(a, b) {
    return $fa5c07254b0b0f21$var$U.current.useInsertionEffect(a, b);
};
$fa5c07254b0b0f21$export$e5c5a5f917a5871c = function(a, b) {
    return $fa5c07254b0b0f21$var$U.current.useLayoutEffect(a, b);
};
$fa5c07254b0b0f21$export$1538c33de8887b59 = function(a, b) {
    return $fa5c07254b0b0f21$var$U.current.useMemo(a, b);
};
$fa5c07254b0b0f21$export$13e3392192263954 = function(a, b, e) {
    return $fa5c07254b0b0f21$var$U.current.useReducer(a, b, e);
};
$fa5c07254b0b0f21$export$b8f5890fc79d6aca = function(a) {
    return $fa5c07254b0b0f21$var$U.current.useRef(a);
};
$fa5c07254b0b0f21$export$60241385465d0a34 = function(a) {
    return $fa5c07254b0b0f21$var$U.current.useState(a);
};
$fa5c07254b0b0f21$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $fa5c07254b0b0f21$var$U.current.useSyncExternalStore(a, b, e);
};
$fa5c07254b0b0f21$export$7b286972b8d8ccbf = function() {
    return $fa5c07254b0b0f21$var$U.current.useTransition();
};
$fa5c07254b0b0f21$export$83d89fbfd8236492 = "18.3.1";

});


parcelRegister("5t8wa", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3but8"));

});
parcelRegister("3but8", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $251a08a6d9ef527f$export$c4744153514ff05d; }, function (v) { return $251a08a6d9ef527f$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $251a08a6d9ef527f$export$3e506c1ccc9cc1a7; }, function (v) { return $251a08a6d9ef527f$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $251a08a6d9ef527f$export$e26fe2ed2fa76875; }, function (v) { return $251a08a6d9ef527f$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $251a08a6d9ef527f$export$502329bbf4b505b1; }, function (v) { return $251a08a6d9ef527f$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $251a08a6d9ef527f$export$6e3807111c4874c4; }, function (v) { return $251a08a6d9ef527f$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $251a08a6d9ef527f$export$c27134553091fb3a; }, function (v) { return $251a08a6d9ef527f$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $251a08a6d9ef527f$export$33ee1acdc04fd2a2; }, function (v) { return $251a08a6d9ef527f$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $251a08a6d9ef527f$export$b00a404bbd5edef2; }, function (v) { return $251a08a6d9ef527f$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $251a08a6d9ef527f$export$8352ce38b91d0c62; }, function (v) { return $251a08a6d9ef527f$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $251a08a6d9ef527f$export$d66a1c1c77bd778b; }, function (v) { return $251a08a6d9ef527f$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $251a08a6d9ef527f$export$d3dfb8e4810cb555; }, function (v) { return $251a08a6d9ef527f$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $251a08a6d9ef527f$export$839f9183b0465a69; }, function (v) { return $251a08a6d9ef527f$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $251a08a6d9ef527f$export$72fdf0e06517287b; }, function (v) { return $251a08a6d9ef527f$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $251a08a6d9ef527f$export$4b844e58a3e414b4; }, function (v) { return $251a08a6d9ef527f$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $251a08a6d9ef527f$export$816d2913ae6b83b1; }, function (v) { return $251a08a6d9ef527f$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $251a08a6d9ef527f$export$61bcfe829111a1d0; }, function (v) { return $251a08a6d9ef527f$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $251a08a6d9ef527f$export$7ee8c9beb337bc3f; }, function (v) { return $251a08a6d9ef527f$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $251a08a6d9ef527f$export$b5836b71941fa3ed; }, function (v) { return $251a08a6d9ef527f$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $251a08a6d9ef527f$export$cf845f2c119da08a; }, function (v) { return $251a08a6d9ef527f$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $2bfPH = parcelRequire("2bfPH");
var $251a08a6d9ef527f$export$c4744153514ff05d;
var $251a08a6d9ef527f$export$3e506c1ccc9cc1a7;
var $251a08a6d9ef527f$export$e26fe2ed2fa76875;
var $251a08a6d9ef527f$export$502329bbf4b505b1;
var $251a08a6d9ef527f$export$6e3807111c4874c4;
var $251a08a6d9ef527f$export$c27134553091fb3a;
var $251a08a6d9ef527f$export$33ee1acdc04fd2a2;
var $251a08a6d9ef527f$export$b00a404bbd5edef2;
var $251a08a6d9ef527f$export$8352ce38b91d0c62;
var $251a08a6d9ef527f$export$d66a1c1c77bd778b;
var $251a08a6d9ef527f$export$d3dfb8e4810cb555;
var $251a08a6d9ef527f$export$839f9183b0465a69;
var $251a08a6d9ef527f$export$72fdf0e06517287b;
var $251a08a6d9ef527f$export$4b844e58a3e414b4;
var $251a08a6d9ef527f$export$816d2913ae6b83b1;
var $251a08a6d9ef527f$export$61bcfe829111a1d0;
var $251a08a6d9ef527f$export$7ee8c9beb337bc3f;
var $251a08a6d9ef527f$export$b5836b71941fa3ed;
var $251a08a6d9ef527f$export$cf845f2c119da08a;
'use strict';
function $251a08a6d9ef527f$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $251a08a6d9ef527f$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $251a08a6d9ef527f$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $251a08a6d9ef527f$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $251a08a6d9ef527f$var$g(C, c)) n < e && 0 > $251a08a6d9ef527f$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $251a08a6d9ef527f$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $251a08a6d9ef527f$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === (typeof performance === "undefined" ? "undefined" : (0, $2bfPH._)(performance)) && "function" === typeof performance.now) {
    var $251a08a6d9ef527f$var$l = performance;
    $251a08a6d9ef527f$export$c4744153514ff05d = function() {
        return $251a08a6d9ef527f$var$l.now();
    };
} else {
    var $251a08a6d9ef527f$var$p = Date, $251a08a6d9ef527f$var$q = $251a08a6d9ef527f$var$p.now();
    $251a08a6d9ef527f$export$c4744153514ff05d = function() {
        return $251a08a6d9ef527f$var$p.now() - $251a08a6d9ef527f$var$q;
    };
}
var $251a08a6d9ef527f$var$r = [], $251a08a6d9ef527f$var$t = [], $251a08a6d9ef527f$var$u = 1, $251a08a6d9ef527f$var$v = null, $251a08a6d9ef527f$var$y = 3, $251a08a6d9ef527f$var$z = !1, $251a08a6d9ef527f$var$A = !1, $251a08a6d9ef527f$var$B = !1, $251a08a6d9ef527f$var$D = "function" === typeof setTimeout ? setTimeout : null, $251a08a6d9ef527f$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $251a08a6d9ef527f$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $251a08a6d9ef527f$var$G(a) {
    for(var b = $251a08a6d9ef527f$var$h($251a08a6d9ef527f$var$t); null !== b;){
        if (null === b.callback) $251a08a6d9ef527f$var$k($251a08a6d9ef527f$var$t);
        else if (b.startTime <= a) $251a08a6d9ef527f$var$k($251a08a6d9ef527f$var$t), b.sortIndex = b.expirationTime, $251a08a6d9ef527f$var$f($251a08a6d9ef527f$var$r, b);
        else break;
        b = $251a08a6d9ef527f$var$h($251a08a6d9ef527f$var$t);
    }
}
function $251a08a6d9ef527f$var$H(a) {
    $251a08a6d9ef527f$var$B = !1;
    $251a08a6d9ef527f$var$G(a);
    if (!$251a08a6d9ef527f$var$A) {
        if (null !== $251a08a6d9ef527f$var$h($251a08a6d9ef527f$var$r)) $251a08a6d9ef527f$var$A = !0, $251a08a6d9ef527f$var$I($251a08a6d9ef527f$var$J);
        else {
            var b = $251a08a6d9ef527f$var$h($251a08a6d9ef527f$var$t);
            null !== b && $251a08a6d9ef527f$var$K($251a08a6d9ef527f$var$H, b.startTime - a);
        }
    }
}
function $251a08a6d9ef527f$var$J(a, b) {
    $251a08a6d9ef527f$var$A = !1;
    $251a08a6d9ef527f$var$B && ($251a08a6d9ef527f$var$B = !1, $251a08a6d9ef527f$var$E($251a08a6d9ef527f$var$L), $251a08a6d9ef527f$var$L = -1);
    $251a08a6d9ef527f$var$z = !0;
    var c = $251a08a6d9ef527f$var$y;
    try {
        $251a08a6d9ef527f$var$G(b);
        for($251a08a6d9ef527f$var$v = $251a08a6d9ef527f$var$h($251a08a6d9ef527f$var$r); null !== $251a08a6d9ef527f$var$v && (!($251a08a6d9ef527f$var$v.expirationTime > b) || a && !$251a08a6d9ef527f$var$M());){
            var d = $251a08a6d9ef527f$var$v.callback;
            if ("function" === typeof d) {
                $251a08a6d9ef527f$var$v.callback = null;
                $251a08a6d9ef527f$var$y = $251a08a6d9ef527f$var$v.priorityLevel;
                var e = d($251a08a6d9ef527f$var$v.expirationTime <= b);
                b = $251a08a6d9ef527f$export$c4744153514ff05d();
                "function" === typeof e ? $251a08a6d9ef527f$var$v.callback = e : $251a08a6d9ef527f$var$v === $251a08a6d9ef527f$var$h($251a08a6d9ef527f$var$r) && $251a08a6d9ef527f$var$k($251a08a6d9ef527f$var$r);
                $251a08a6d9ef527f$var$G(b);
            } else $251a08a6d9ef527f$var$k($251a08a6d9ef527f$var$r);
            $251a08a6d9ef527f$var$v = $251a08a6d9ef527f$var$h($251a08a6d9ef527f$var$r);
        }
        if (null !== $251a08a6d9ef527f$var$v) var w = !0;
        else {
            var m = $251a08a6d9ef527f$var$h($251a08a6d9ef527f$var$t);
            null !== m && $251a08a6d9ef527f$var$K($251a08a6d9ef527f$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $251a08a6d9ef527f$var$v = null, $251a08a6d9ef527f$var$y = c, $251a08a6d9ef527f$var$z = !1;
    }
}
var $251a08a6d9ef527f$var$N = !1, $251a08a6d9ef527f$var$O = null, $251a08a6d9ef527f$var$L = -1, $251a08a6d9ef527f$var$P = 5, $251a08a6d9ef527f$var$Q = -1;
function $251a08a6d9ef527f$var$M() {
    return $251a08a6d9ef527f$export$c4744153514ff05d() - $251a08a6d9ef527f$var$Q < $251a08a6d9ef527f$var$P ? !1 : !0;
}
function $251a08a6d9ef527f$var$R() {
    if (null !== $251a08a6d9ef527f$var$O) {
        var a = $251a08a6d9ef527f$export$c4744153514ff05d();
        $251a08a6d9ef527f$var$Q = a;
        var b = !0;
        try {
            b = $251a08a6d9ef527f$var$O(!0, a);
        } finally{
            b ? $251a08a6d9ef527f$var$S() : ($251a08a6d9ef527f$var$N = !1, $251a08a6d9ef527f$var$O = null);
        }
    } else $251a08a6d9ef527f$var$N = !1;
}
var $251a08a6d9ef527f$var$S;
if ("function" === typeof $251a08a6d9ef527f$var$F) $251a08a6d9ef527f$var$S = function S() {
    $251a08a6d9ef527f$var$F($251a08a6d9ef527f$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $251a08a6d9ef527f$var$T = new MessageChannel, $251a08a6d9ef527f$var$U = $251a08a6d9ef527f$var$T.port2;
    $251a08a6d9ef527f$var$T.port1.onmessage = $251a08a6d9ef527f$var$R;
    $251a08a6d9ef527f$var$S = function S() {
        $251a08a6d9ef527f$var$U.postMessage(null);
    };
} else $251a08a6d9ef527f$var$S = function S() {
    $251a08a6d9ef527f$var$D($251a08a6d9ef527f$var$R, 0);
};
function $251a08a6d9ef527f$var$I(a) {
    $251a08a6d9ef527f$var$O = a;
    $251a08a6d9ef527f$var$N || ($251a08a6d9ef527f$var$N = !0, $251a08a6d9ef527f$var$S());
}
function $251a08a6d9ef527f$var$K(a, b) {
    $251a08a6d9ef527f$var$L = $251a08a6d9ef527f$var$D(function() {
        a($251a08a6d9ef527f$export$c4744153514ff05d());
    }, b);
}
$251a08a6d9ef527f$export$3e506c1ccc9cc1a7 = 5;
$251a08a6d9ef527f$export$e26fe2ed2fa76875 = 1;
$251a08a6d9ef527f$export$502329bbf4b505b1 = 4;
$251a08a6d9ef527f$export$6e3807111c4874c4 = 3;
$251a08a6d9ef527f$export$c27134553091fb3a = null;
$251a08a6d9ef527f$export$33ee1acdc04fd2a2 = 2;
$251a08a6d9ef527f$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$251a08a6d9ef527f$export$8352ce38b91d0c62 = function() {
    $251a08a6d9ef527f$var$A || $251a08a6d9ef527f$var$z || ($251a08a6d9ef527f$var$A = !0, $251a08a6d9ef527f$var$I($251a08a6d9ef527f$var$J));
};
$251a08a6d9ef527f$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $251a08a6d9ef527f$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$251a08a6d9ef527f$export$d3dfb8e4810cb555 = function() {
    return $251a08a6d9ef527f$var$y;
};
$251a08a6d9ef527f$export$839f9183b0465a69 = function() {
    return $251a08a6d9ef527f$var$h($251a08a6d9ef527f$var$r);
};
$251a08a6d9ef527f$export$72fdf0e06517287b = function(a) {
    switch($251a08a6d9ef527f$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $251a08a6d9ef527f$var$y;
    }
    var c = $251a08a6d9ef527f$var$y;
    $251a08a6d9ef527f$var$y = b;
    try {
        return a();
    } finally{
        $251a08a6d9ef527f$var$y = c;
    }
};
$251a08a6d9ef527f$export$4b844e58a3e414b4 = function() {};
$251a08a6d9ef527f$export$816d2913ae6b83b1 = function() {};
$251a08a6d9ef527f$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $251a08a6d9ef527f$var$y;
    $251a08a6d9ef527f$var$y = a;
    try {
        return b();
    } finally{
        $251a08a6d9ef527f$var$y = c;
    }
};
$251a08a6d9ef527f$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $251a08a6d9ef527f$export$c4744153514ff05d();
    "object" === (typeof c === "undefined" ? "undefined" : (0, $2bfPH._)(c)) && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $251a08a6d9ef527f$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $251a08a6d9ef527f$var$f($251a08a6d9ef527f$var$t, a), null === $251a08a6d9ef527f$var$h($251a08a6d9ef527f$var$r) && a === $251a08a6d9ef527f$var$h($251a08a6d9ef527f$var$t) && ($251a08a6d9ef527f$var$B ? ($251a08a6d9ef527f$var$E($251a08a6d9ef527f$var$L), $251a08a6d9ef527f$var$L = -1) : $251a08a6d9ef527f$var$B = !0, $251a08a6d9ef527f$var$K($251a08a6d9ef527f$var$H, c - d))) : (a.sortIndex = e, $251a08a6d9ef527f$var$f($251a08a6d9ef527f$var$r, a), $251a08a6d9ef527f$var$A || $251a08a6d9ef527f$var$z || ($251a08a6d9ef527f$var$A = !0, $251a08a6d9ef527f$var$I($251a08a6d9ef527f$var$J)));
    return a;
};
$251a08a6d9ef527f$export$b5836b71941fa3ed = $251a08a6d9ef527f$var$M;
$251a08a6d9ef527f$export$cf845f2c119da08a = function(a) {
    var b = $251a08a6d9ef527f$var$y;
    return function() {
        var c = $251a08a6d9ef527f$var$y;
        $251a08a6d9ef527f$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $251a08a6d9ef527f$var$y = c;
        }
    };
};

});



parcelRegister("azwTY", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $7b26b1dce1949a02$export$ffb0004e005737fa; }, function (v) { return $7b26b1dce1949a02$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $7b26b1dce1949a02$export$34b9dba7ce09269b; }, function (v) { return $7b26b1dce1949a02$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $7b26b1dce1949a02$export$25062201e9e25d76; }, function (v) { return $7b26b1dce1949a02$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7b26b1dce1949a02$export$ffb0004e005737fa;
var $7b26b1dce1949a02$export$34b9dba7ce09269b;
var $7b26b1dce1949a02$export$25062201e9e25d76;
'use strict';

var $eHaBZ = parcelRequire("eHaBZ");
var $7b26b1dce1949a02$var$k = Symbol.for("react.element"), $7b26b1dce1949a02$var$l = Symbol.for("react.fragment"), $7b26b1dce1949a02$var$m = Object.prototype.hasOwnProperty, $7b26b1dce1949a02$var$n = $eHaBZ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $7b26b1dce1949a02$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $7b26b1dce1949a02$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$7b26b1dce1949a02$var$m.call(a, b) && !$7b26b1dce1949a02$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $7b26b1dce1949a02$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $7b26b1dce1949a02$var$n.current
    };
}
$7b26b1dce1949a02$export$ffb0004e005737fa = $7b26b1dce1949a02$var$l;
$7b26b1dce1949a02$export$34b9dba7ce09269b = $7b26b1dce1949a02$var$q;
$7b26b1dce1949a02$export$25062201e9e25d76 = $7b26b1dce1949a02$var$q;

});

parcelRegister("fOJyi", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $eDsRw = parcelRequire("eDsRw");
function $b83edc36be0efe6f$var$emptyFunction() {}
function $b83edc36be0efe6f$var$emptyFunctionWithReset() {}
$b83edc36be0efe6f$var$emptyFunctionWithReset.resetWarningCache = $b83edc36be0efe6f$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $eDsRw) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $b83edc36be0efe6f$var$emptyFunctionWithReset,
        resetWarningCache: $b83edc36be0efe6f$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("eDsRw", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $aa7b18ab7f899a3f$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $aa7b18ab7f899a3f$var$ReactPropTypesSecret;

});


parcelRegister("5XYIU", function(module, exports) {

$parcel$export(module.exports, "useLocation", function () { return useLocation; });
$parcel$export(module.exports, "useMatch", function () { return useMatch; });
$parcel$export(module.exports, "useNavigate", function () { return useNavigate; });
$parcel$export(module.exports, "useParams", function () { return useParams; });
$parcel$export(module.exports, "Navigate", function () { return Navigate; });
$parcel$export(module.exports, "Route", function () { return Route; });
$parcel$export(module.exports, "Routes", function () { return Routes; });
$parcel$export(module.exports, "BrowserRouter", function () { return BrowserRouter; });
$parcel$export(module.exports, "Link", function () { return Link; });
/**
 * react-router v7.9.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $1Mz1E = parcelRequire("1Mz1E");

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $khBmn = parcelRequire("khBmn");

var $NBk0Y = parcelRequire("NBk0Y");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $aRv4I = parcelRequire("aRv4I");

var $21h22 = parcelRequire("21h22");

var $ggKxj = parcelRequire("ggKxj");

var $6zk1M = parcelRequire("6zk1M");

var $2bfPH = parcelRequire("2bfPH");

var $dHaQg = parcelRequire("dHaQg");

var $6PS3Z = parcelRequire("6PS3Z");

var $6PS3Z = parcelRequire("6PS3Z");

var $eHaBZ = parcelRequire("eHaBZ");
var $9c12a20ed8e485b1$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-OIYGIGL5.mjs"
});
var __typeError = function(msg) {
    throw TypeError(msg);
};
var __accessCheck = function(obj, member, msg) {
    return member.has(obj) || __typeError("Cannot " + msg);
};
var __privateGet = function(obj, member, getter) {
    return __accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = function(obj, member, value) {
    return member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
// lib/router/history.ts
var Action = /* @__PURE__ */ function(Action2) {
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
}(Action || {});
var PopStateEventType = "popstate";
function createMemoryHistory() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries;
    entries = initialEntries.map(function(entry, index2) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = "POP" /* Pop */ ;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to) {
        var state = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, key = arguments.length > 2 ? arguments[2] : void 0;
        var location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: ".concat(JSON.stringify(to)));
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL: function(to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = "PUSH" /* Push */ ;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = "REPLACE" /* Replace */ ;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = "POP" /* Pop */ ;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
function createBrowserHistory() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    function createBrowserLocation(window2, globalHistory) {
        var _window2_location = window2.location, pathname = _window2_location.pathname, search = _window2_location.search, hash = _window2_location.hash;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function createHashHistory() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    function createHashLocation(window2, globalHistory) {
        var _parsePath = parsePath(window2.location.hash.substring(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        var base = window2.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window2.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(".concat(JSON.stringify(to), ")"));
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function createLocation(current, to) {
    var state = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, key = arguments.length > 3 ? arguments[3] : void 0;
    var location = (0, $9Jpjh._)((0, $lvTkn._)({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to), {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
function createPath(param) {
    var _param_pathname = param.pathname, pathname = _param_pathname === void 0 ? "/" : _param_pathname, _param_search = param.search, search = _param_search === void 0 ? "" : _param_search, _param_hash = param.hash, hash = _param_hash === void 0 ? "" : _param_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function parsePath(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref2, validateLocation) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var tmp = options.window, window2 = tmp === void 0 ? document.defaultView : tmp, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window2.history;
    var action = "POP" /* Pop */ ;
    var listener = null;
    var index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $9Jpjh._)((0, $lvTkn._)({}, globalHistory.state), {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        var location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        var location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return createBrowserURLImpl(to);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window2.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function createBrowserURLImpl(to) {
    var isAbsolute = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    invariant(base, "No window.location.(origin|href) available to create URL");
    var href = typeof to === "string" ? to : createPath(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function createContext(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var _map;
var RouterContextProvider = /*#__PURE__*/ function() {
    "use strict";
    function RouterContextProvider(init) {
        (0, $gd0sY._)(this, RouterContextProvider);
        __privateAdd(this, _map, /* @__PURE__ */ new Map());
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (init) try {
            for(var _iterator = init[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $21h22._)(_step.value, 2), context = _step_value[0], value = _step_value[1];
                this.set(context, value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    (0, $7cSld._)(RouterContextProvider, [
        {
            /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ key: "get",
            value: function get(context) {
                if (__privateGet(this, _map).has(context)) return __privateGet(this, _map).get(context);
                if (context.defaultValue !== void 0) return context.defaultValue;
                throw new Error("No value found for context");
            }
        },
        {
            /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ key: "set",
            value: function set(context, value) {
                __privateGet(this, _map).set(context, value);
            }
        }
    ]);
    return RouterContextProvider;
}();
_map = new WeakMap();
var unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isUnsupportedLazyRouteObjectKey(key) {
    return unsupportedLazyRouteObjectKeys.has(key);
}
var unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function isUnsupportedLazyRouteFunctionKey(key) {
    return unsupportedLazyRouteFunctionKeys.has(key);
}
function isIndexRoute(route) {
    return route.index === true;
}
function convertRoutesToDataRoutes(routes, mapRouteProperties2) {
    var parentPath = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], manifest = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, allowInPlaceMutations = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    return routes.map(function(route, index) {
        var treePath = (0, $6zk1M._)(parentPath).concat([
            String(index)
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(allowInPlaceMutations || !manifest[id], 'Found a route id collision on id "'.concat(id, "\".  Route id's must be globally unique within Data Router usages"));
        if (isIndexRoute(route)) {
            var indexRoute = (0, $9Jpjh._)((0, $lvTkn._)({}, route, mapRouteProperties2(route)), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = (0, $9Jpjh._)((0, $lvTkn._)({}, route, mapRouteProperties2(route)), {
                id: id,
                children: void 0
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function matchRoutes(routes, locationArg) {
    var basename = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "/";
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    var location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    var pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i){
        var decoded = decodePath(pathname);
        matches = matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes) {
    var branches = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], parentsMeta = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], parentPath = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", _hasParentOptionalSegments = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var flattenRoute = function(route, index) {
        var hasParentOptionalSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _hasParentOptionalSegments, relativePath = arguments.length > 3 ? arguments[3] : void 0;
        var meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            invariant(meta.relativePath.startsWith(parentPath), 'Absolute route path "'.concat(meta.relativePath, '" nested under path "').concat(parentPath, '" is not valid. An absolute child route path must start with the combined path of all its parent routes.'));
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, 'Index routes must not have child routes. Please remove all child routes from route path "'.concat(path, '".'));
            flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route_path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (route.path === "" || !((_route_path = route.path) === null || _route_path === void 0 ? void 0 : _route_path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, true, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
function explodeOptionalSegments(path) {
    var _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $ggKxj._)(segments), first = _segments[0], rest = _segments.slice(1);
    var isOptional = first.endsWith("?");
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $6zk1M._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $6zk1M._)(restExploded));
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score : compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var paramRe = /^:[\w-]+$/;
var dynamicSegmentValue = 3;
var indexRouteValue = 2;
var emptySegmentValue = 1;
var staticSegmentValue = 10;
var splatPenalty = -2;
var isSplat = function(s) {
    return s === "*";
};
function computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter(function(s) {
        return !isSplat(s);
    }).reduce(function(score, segment) {
        return score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue);
    }, initialScore);
}
function compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname) {
    var allowPartial = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        var route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function generatePath(originalPath) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, 'Route path "'.concat(path, '" will be treated as if it were "').concat(path.replace(/\*$/, "/*"), '" because the `*` character must always follow a `/` in the pattern. To get rid of this warning, please change the route path to "').concat(path.replace(/\*$/, "/*"), '".'));
        path = path.replace(/\*$/, "/*");
    }
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify2 = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            var star = "*";
            return stringify2(params[star]);
        }
        var keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $21h22._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            invariant(optional === "?" || param != null, 'Missing ":'.concat(key, '" param'));
            return encodeURIComponent(stringify2(param));
        }
        return segment.replace(/\?$/g, "");
    }).filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $21h22._)(compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], compiledParams = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = compiledParams.reduce(function(memo2, param, index) {
        var paramName = param.paramName, isOptional = param.isOptional;
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        var value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function compilePath(path) {
    var caseSensitive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "'.concat(path, '" will be treated as if it were "').concat(path.replace(/\*$/, "/*"), '" because the `*` character must always follow a `/` in the pattern. To get rid of this warning, please change the route path to "').concat(path.replace(/\*$/, "/*"), '".'));
    var params = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, function(_, paramName, isOptional) {
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map(function(v) {
            return decodeURIComponent(v).replace(/\//g, "%2F");
        }).join("/");
    } catch (error) {
        warning(false, 'The URL path "'.concat(value, '" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (').concat(error, ")."));
        return value;
    }
}
function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function prependBasename(param) {
    var basename = param.basename, pathname = param.pathname;
    return pathname === "/" ? basename : joinPaths([
        basename,
        pathname
    ]);
}
function resolvePath(to) {
    var fromPathname = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "/";
    var _ref = typeof to === "string" ? parsePath(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '".concat(char, "' character in a manually specified `to.").concat(field, "` field [").concat(JSON.stringify(path), "].  Please separate it out to the `to.").concat(dest, '` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.');
}
function getPathContributingMatches(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
function getResolveToMatches(matches) {
    var pathMatches = getPathContributingMatches(matches);
    return pathMatches.map(function(match, idx) {
        return idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase;
    });
}
function resolveTo(toArg, routePathnames, locationPathname) {
    var isPathRelative = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = (0, $lvTkn._)({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    if (toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = resolvePath(to, from);
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var joinPaths = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
var normalizePathname = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
var normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
var normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
var DataWithResponseInit = function DataWithResponseInit(data2, init) {
    "use strict";
    (0, $gd0sY._)(this, DataWithResponseInit);
    this.type = "DataWithResponseInit";
    this.data = data2;
    this.init = init || null;
};
function data(data2, init) {
    return new DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var redirect = function(url) {
    var init = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, (0, $9Jpjh._)((0, $lvTkn._)({}, responseInit), {
        headers: headers
    }));
};
var redirectDocument = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var replace = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var ErrorResponseImpl = function ErrorResponseImpl(status, statusText, data2) {
    "use strict";
    var internal = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    (0, $gd0sY._)(this, ErrorResponseImpl);
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data2 instanceof Error) {
        this.data = data2.toString();
        this.error = data2;
    } else this.data = data2;
};
function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
// lib/router/router.ts
var validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var validMutationMethods = new Set(validMutationMethodsArr);
var validRequestMethodsArr = [
    "GET"
].concat((0, $6zk1M._)(validMutationMethodsArr));
var validRequestMethods = new Set(validRequestMethodsArr);
var redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var IDLE_NAVIGATION = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var IDLE_FETCHER = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var IDLE_BLOCKER = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var isAbsoluteUrl = function(url) {
    return ABSOLUTE_URL_REGEX.test(url);
};
var defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
var TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function createRouter(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    var isBrowser2 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    var mapRouteProperties2 = init.mapRouteProperties || defaultMapRouteProperties;
    var manifest = {};
    var dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties2, void 0, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = "/".concat(basename);
    var dataStrategyImpl = init.dataStrategy || defaultDataStrategyWithMiddleware;
    var future = (0, $lvTkn._)({}, init.future);
    var unlistenHistory = null;
    var subscribers = /* @__PURE__ */ new Set();
    var savedScrollPositions2 = null;
    var getScrollRestorationKey2 = null;
    var getScrollPosition = null;
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    var initialMatchesIsFOW = false;
    var initialErrors = null;
    var initialized;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        var error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialized = true;
        initialMatches = matches;
        initialErrors = (0, $khBmn._)({}, route.id, error);
    } else {
        if (initialMatches && !init.hydrationData) {
            var fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            initialMatches = [];
            var fogOfWar1 = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar1.active && fogOfWar1.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar1.matches;
            }
        } else if (initialMatches.some(function(m) {
            return m.route.lazy;
        })) initialized = false;
        else if (!initialMatches.some(function(m) {
            return routeHasLoaderOrMiddleware(m.route);
        })) initialized = true;
        else {
            var loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            var errors = init.hydrationData ? init.hydrationData.errors : null;
            if (errors) {
                var idx = initialMatches.findIndex(function(m) {
                    return errors[m.route.id] !== void 0;
                });
                initialized = initialMatches.slice(0, idx + 1).every(function(m) {
                    return !shouldLoadRouteOnHydration(m.route, loaderData, errors);
                });
            } else initialized = initialMatches.every(function(m) {
                return !shouldLoadRouteOnHydration(m.route, loaderData, errors);
            });
        }
    }
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    var pendingAction = "POP" /* Pop */ ;
    var pendingPreventScrollReset = false;
    var pendingNavigationController;
    var pendingViewTransitionEnabled = false;
    var appliedViewTransitions = /* @__PURE__ */ new Map();
    var removePageHideEventListener = null;
    var isUninterruptedRevalidation = false;
    var isRevalidationRequired = false;
    var cancelledFetcherLoads = /* @__PURE__ */ new Set();
    var fetchControllers = /* @__PURE__ */ new Map();
    var incrementingLoadId = 0;
    var pendingNavigationLoadId = -1;
    var fetchReloadIds = /* @__PURE__ */ new Map();
    var fetchRedirectIds = /* @__PURE__ */ new Set();
    var fetchLoadMatches = /* @__PURE__ */ new Map();
    var activeFetchers = /* @__PURE__ */ new Map();
    var fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    var blockerFunctions = /* @__PURE__ */ new Map();
    var unblockBlockerHistoryUpdate = void 0;
    var pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(function(param) {
            var historyAction = param.action, location = param.location, delta = param.delta;
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                var nextHistoryUpdatePromise = new Promise(function(resolve) {
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(function() {
                            return init.history.go(delta);
                        });
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser2) {
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    }
    function updateState(newState) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (newState.matches) newState.matches = newState.matches.map(function(m) {
            var route = manifest[m.route.id];
            var matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return (0, $9Jpjh._)((0, $lvTkn._)({}, m), {
                route: route
            });
            return m;
        });
        state = (0, $lvTkn._)({}, state, newState);
        var unmountedFetchers = [];
        var mountedFetchers = [];
        state.fetchers.forEach(function(fetcher, key) {
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach(function(key) {
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        (0, $6zk1M._)(subscribers).forEach(function(subscriber) {
            return subscriber(state, {
                deletedFetchers: unmountedFetchers,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            });
        });
        unmountedFetchers.forEach(function(key) {
            return deleteFetcher(key);
        });
        mountedFetchers.forEach(function(key) {
            return state.fetchers.delete(key);
        });
    }
    function completeNavigation(location, newState) {
        var flushSync = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).flushSync;
        var _location_state, _location_state1;
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        var loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, IDLE_BLOCKER);
            });
        }
        var restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location_state1 = location.state) === null || _location_state1 === void 0 ? void 0 : _location_state1._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        var viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState((0, $9Jpjh._)((0, $lvTkn._)({}, newState), {
            // matches, errors, fetchers go through as-is
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingRevalidationDfd === null || pendingRevalidationDfd === void 0 ? void 0 : pendingRevalidationDfd.resolve();
        pendingRevalidationDfd = null;
    }
    function navigate(to, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, flushSync, blockerKey;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = normalizeTo(state.location, state.matches, basename, to, opts === null || opts === void 0 ? void 0 : opts.fromRouteId, opts === null || opts === void 0 ? void 0 : opts.relative);
                        _normalizeNavigateOptions = normalizeNavigateOptions(false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = createLocation(state.location, path, opts && opts.state);
                        nextLocation = (0, $lvTkn._)({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : void 0;
                        historyAction = "PUSH" /* Push */ ;
                        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
                        else if (userReplace === false) ;
                        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
                        flushSync = (opts && opts.flushSync) === true;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: void 0,
                                        reset: void 0,
                                        location: nextLocation
                                    });
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, IDLE_BLOCKER);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.viewTransition,
                                flushSync: flushSync
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        var promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    function startNavigation(historyAction, location, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var routesToUse, loadingNavigation, matches, flushSync, fogOfWar, _handleNavigational404, error, notFoundMatches, route, request, scopedContext, _tmp, pendingActionResult, actionResult, _actionResult_pendingActionResult, routeId, result, _ref, shortCircuited, updatedMatches, loaderData, errors;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = (opts === null || opts === void 0 ? void 0 : opts.initialHydration) && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
                        state.matches : matchRoutes(routesToUse, location, basename);
                        flushSync = (opts && opts.flushSync) === true;
                        if (matches && state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
                        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
                        if (!matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $khBmn._)({}, route.id, error)
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        pendingNavigationController = new AbortController();
                        request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!init.getContext) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            init.getContext()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = new RouterContextProvider();
                        _state.label = 3;
                    case 3:
                        scopedContext = _tmp;
                        if (!(opts && opts.pendingError)) return [
                            3,
                            4
                        ];
                        pendingActionResult = [
                            findNearestBoundary(matches).route.id,
                            {
                                type: "error" /* error */ ,
                                error: opts.pendingError
                            }
                        ];
                        return [
                            3,
                            6
                        ];
                    case 4:
                        if (!(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                                replace: opts.replace,
                                flushSync: flushSync
                            })
                        ];
                    case 5:
                        actionResult = _state.sent();
                        if (actionResult.shortCircuited) return [
                            2
                        ];
                        if (actionResult.pendingActionResult) {
                            _actionResult_pendingActionResult = (0, $21h22._)(actionResult.pendingActionResult, 2), routeId = _actionResult_pendingActionResult[0], result = _actionResult_pendingActionResult[1];
                            if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                                pendingNavigationController = null;
                                completeNavigation(location, {
                                    matches: actionResult.matches,
                                    loaderData: {},
                                    errors: (0, $khBmn._)({}, routeId, result.error)
                                });
                                return [
                                    2
                                ];
                            }
                        }
                        matches = actionResult.matches || matches;
                        pendingActionResult = actionResult.pendingActionResult;
                        loadingNavigation = getLoadingNavigation(location, opts.submission);
                        flushSync = false;
                        fogOfWar.active = false;
                        request = createClientSideRequest(init.history, request.url, request.signal);
                        _state.label = 6;
                    case 6:
                        return [
                            4,
                            handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult)
                        ];
                    case 7:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, updatedMatches = _ref.matches, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        pendingNavigationController = null;
                        completeNavigation(location, (0, $9Jpjh._)((0, $lvTkn._)({
                            matches: updatedMatches || matches
                        }, getActionDataForCommit(pendingActionResult)), {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function handleAction(_0, _1, _2, _3, _4, _5, _6) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration) {
            var opts, navigation, discoverResult, _getShortCircuitMatches, matches2, route, boundaryId, _handleNavigational404, notFoundMatches, error, route1, result, actionMatch, dsMatches, results, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, match, replace2, location2, boundaryMatch;
            var _arguments = arguments;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        opts = _arguments.length > 7 && _arguments[7] !== void 0 ? _arguments[7] : {};
                        interruptActiveLoads();
                        navigation = getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        }, {
                            flushSync: opts.flushSync === true
                        });
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            if (discoverResult.partialMatches.length === 0) {
                                _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), matches2 = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                                return [
                                    2,
                                    {
                                        matches: matches2,
                                        pendingActionResult: [
                                            route.id,
                                            {
                                                type: "error" /* error */ ,
                                                error: discoverResult.error
                                            }
                                        ]
                                    }
                                ];
                            }
                            boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    pendingActionResult: [
                                        boundaryId,
                                        {
                                            type: "error" /* error */ ,
                                            error: discoverResult.error
                                        }
                                    ]
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), notFoundMatches = _handleNavigational404.notFoundMatches, error = _handleNavigational404.error, route1 = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    pendingActionResult: [
                                        route1.id,
                                        {
                                            type: "error" /* error */ ,
                                            error: error
                                        }
                                    ]
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        actionMatch = getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            3
                        ];
                        result = {
                            type: "error" /* error */ ,
                            error: getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            5
                        ];
                    case 3:
                        dsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
                        return [
                            4,
                            callDataStrategy(request, dsMatches, scopedContext, null)
                        ];
                    case 4:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (!result) {
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = matches[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    match = _step.value;
                                    if (results[match.route.id]) {
                                        result = results[match.route.id];
                                        break;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 5;
                    case 5:
                        if (!isRedirectResult(result)) return [
                            3,
                            7
                        ];
                        if (opts && opts.replace != null) replace2 = opts.replace;
                        else {
                            location2 = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                            replace2 = location2 === state.location.pathname + state.location.search;
                        }
                        return [
                            4,
                            startRedirectNavigation(request, result, true, {
                                submission: submission,
                                replace: replace2
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        if (isErrorResult(result)) {
                            boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
                            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
                            return [
                                2,
                                {
                                    matches: matches,
                                    pendingActionResult: [
                                        boundaryMatch.route.id,
                                        result,
                                        actionMatch.route.id
                                    ]
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                matches: matches,
                                pendingActionResult: [
                                    actionMatch.route.id,
                                    result
                                ]
                            }
                        ];
                }
            });
        }).apply(this, arguments);
    }
    function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var loadingNavigation, activeSubmission, shouldUpdateNavigationState, actionData, discoverResult, _getShortCircuitMatches, matches2, route, boundaryId, _handleNavigational404, error, notFoundMatches, route1, routesToUse, _getMatchesToLoad, dsMatches, revalidatingFetchers, updatedFetchers2, updates, actionData1, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect2, _processLoaderData, loaderData, errors, updatedFetchers, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
                        activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
                        shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        if (shouldUpdateNavigationState) {
                            actionData = getUpdatedActionData(pendingActionResult);
                            updateState((0, $lvTkn._)({
                                navigation: loadingNavigation
                            }, actionData !== void 0 ? {
                                actionData: actionData
                            } : {}), {
                                flushSync: flushSync
                            });
                        }
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            if (discoverResult.partialMatches.length === 0) {
                                _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), matches2 = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                                return [
                                    2,
                                    {
                                        matches: matches2,
                                        loaderData: {},
                                        errors: (0, $khBmn._)({}, route.id, discoverResult.error)
                                    }
                                ];
                            }
                            boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    loaderData: {},
                                    errors: (0, $khBmn._)({}, boundaryId, discoverResult.error)
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route1 = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    errors: (0, $khBmn._)({}, route1.id, error)
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, pendingActionResult), dsMatches = _getMatchesToLoad.dsMatches, revalidatingFetchers = _getMatchesToLoad.revalidatingFetchers;
                        pendingNavigationLoadId = ++incrementingLoadId;
                        if (!init.dataStrategy && !dsMatches.some(function(m) {
                            return m.shouldLoad;
                        }) && !dsMatches.some(function(m) {
                            return m.route.middleware && m.route.middleware.length > 0;
                        }) && revalidatingFetchers.length === 0) {
                            updatedFetchers2 = markFetchRedirectsDone();
                            completeNavigation(location, (0, $lvTkn._)({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, $khBmn._)({}, pendingActionResult[0], pendingActionResult[1].error) : null
                            }, getActionDataForCommit(pendingActionResult), updatedFetchers2 ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        if (shouldUpdateNavigationState) {
                            updates = {};
                            if (!isFogOfWar) {
                                updates.navigation = loadingNavigation;
                                actionData1 = getUpdatedActionData(pendingActionResult);
                                if (actionData1 !== void 0) updates.actionData = actionData1;
                            }
                            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
                            updateState(updates, {
                                flushSync: flushSync
                            });
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            abortFetcher(rf.key);
                            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, scopedContext)
                        ];
                    case 3:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        redirect2 = findRedirect(loaderResults);
                        if (!redirect2) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            startRedirectNavigation(request, redirect2.result, true, {
                                replace: replace2
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        redirect2 = findRedirect(fetcherResults);
                        if (!redirect2) return [
                            3,
                            7
                        ];
                        fetchRedirectIds.add(redirect2.key);
                        return [
                            4,
                            startRedirectNavigation(request, redirect2.result, true, {
                                replace: replace2
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        _processLoaderData = processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        if (initialHydration && state.errors) errors = (0, $lvTkn._)({}, state.errors, errors);
                        updatedFetchers = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            (0, $lvTkn._)({
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        })();
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) return (0, $khBmn._)({}, pendingActionResult[0], pendingActionResult[1].data);
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach(function(rf) {
            var fetcher = state.fetchers.get(rf.key);
            var revalidatingFetcher = getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    function fetch2(key, routeId, href, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var flushSync, routesToUse, normalizedPath, matches, fogOfWar, _normalizeNavigateOptions, path, submission, error, scopedContext, _tmp, preventScrollReset;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        abortFetcher(key);
                        flushSync = (opts && opts.flushSync) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        normalizedPath = normalizeTo(state.location, state.matches, basename, href, routeId, opts === null || opts === void 0 ? void 0 : opts.relative);
                        matches = matchRoutes(routesToUse, normalizedPath, basename);
                        fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
                        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
                        if (!matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: normalizedPath
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        _normalizeNavigateOptions = normalizeNavigateOptions(true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        if (error) {
                            setFetcherError(key, routeId, error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        if (!init.getContext) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            init.getContext()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = new RouterContextProvider();
                        _state.label = 3;
                    case 3:
                        scopedContext = _tmp;
                        preventScrollReset = (opts && opts.preventScrollReset) === true;
                        if (!(submission && isMutationMethod(submission.formMethod))) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission)
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2
                        ];
                    case 5:
                        fetchLoadMatches.set(key, {
                            routeId: routeId,
                            path: path
                        });
                        return [
                            4,
                            handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission)
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var existingFetcher, abortController, fetchRequest, discoverResult, match, error, originatingLoadId, fetchMatches, actionResults, actionResult, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, dsMatches, revalidatingFetchers, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, doneFetcher, redirect2, _processLoaderData, loaderData, errors;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else requestMatches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        match = getTargetMatch(requestMatches, path);
                        if (!match.route.action && !match.route.lazy) {
                            error = getInternalRouterError(405, {
                                method: submission.formMethod,
                                pathname: path,
                                routeId: routeId
                            });
                            setFetcherError(key, routeId, error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        fetchMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, requestMatches, match, hydrationRouteProperties2, scopedContext);
                        return [
                            4,
                            callDataStrategy(fetchRequest, fetchMatches, scopedContext, key)
                        ];
                    case 3:
                        actionResults = _state.sent();
                        actionResult = actionResults[match.route.id];
                        if (fetchRequest.signal.aborted) {
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        if (fetchersQueuedForDeletion.has(key)) {
                            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                                updateFetcherState(key, getDoneFetcher(void 0));
                                return [
                                    2
                                ];
                            }
                        } else {
                            if (isRedirectResult(actionResult)) {
                                fetchControllers.delete(key);
                                if (pendingNavigationLoadId > originatingLoadId) {
                                    updateFetcherState(key, getDoneFetcher(void 0));
                                    return [
                                        2
                                    ];
                                } else {
                                    fetchRedirectIds.add(key);
                                    updateFetcherState(key, getLoadingFetcher(submission));
                                    return [
                                        2,
                                        startRedirectNavigation(fetchRequest, actionResult, false, {
                                            fetcherSubmission: submission,
                                            preventScrollReset: preventScrollReset
                                        })
                                    ];
                                }
                            }
                            if (isErrorResult(actionResult)) {
                                setFetcherError(key, routeId, actionResult.error);
                                return [
                                    2
                                ];
                            }
                        }
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
                        invariant(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, [
                            match.route.id,
                            actionResult
                        ]), dsMatches = _getMatchesToLoad.dsMatches, revalidatingFetchers = _getMatchesToLoad.revalidatingFetchers;
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher2 = state.fetchers.get(staleKey);
                            var revalidatingFetcher = getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, scopedContext)
                        ];
                    case 4:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        if (state.fetchers.has(key)) {
                            doneFetcher = getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher);
                        }
                        redirect2 = findRedirect(loaderResults);
                        if (redirect2) return [
                            2,
                            startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                                preventScrollReset: preventScrollReset
                            })
                        ];
                        redirect2 = findRedirect(fetcherResults);
                        if (redirect2) {
                            fetchRedirectIds.add(redirect2.key);
                            return [
                                2,
                                startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                                    preventScrollReset: preventScrollReset
                                })
                            ];
                        }
                        _processLoaderData = processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        abortStaleFetchLoads(loadId);
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            invariant(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            updateState({
                                errors: errors,
                                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                                fetchers: new Map(state.fetchers)
                            });
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var existingFetcher, abortController, fetchRequest, discoverResult, match, originatingLoadId, dsMatches, results, result;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        match = getTargetMatch(matches, path);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        dsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, matches, match, hydrationRouteProperties2, scopedContext);
                        return [
                            4,
                            callDataStrategy(fetchRequest, dsMatches, scopedContext, key)
                        ];
                    case 3:
                        results = _state.sent();
                        result = results[match.route.id];
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        if (fetchersQueuedForDeletion.has(key)) {
                            updateFetcherState(key, getDoneFetcher(void 0));
                            return [
                                2
                            ];
                        }
                        if (!isRedirectResult(result)) return [
                            3,
                            6
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            4
                        ];
                        updateFetcherState(key, getDoneFetcher(void 0));
                        return [
                            2
                        ];
                    case 4:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(fetchRequest, result, false, {
                                preventScrollReset: preventScrollReset
                            })
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2
                        ];
                    case 6:
                        if (isErrorResult(result)) {
                            setFetcherError(key, routeId, result.error);
                            return [
                                2
                            ];
                        }
                        updateFetcherState(key, getDoneFetcher(result.data));
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function startRedirectNavigation(_0, _1, _2) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function(request, redirect2, isNavigation) {
            var _ref, submission, fetcherSubmission, preventScrollReset, replace2, location, redirectLocation, isDocumentReload, url, redirectNavigationType, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            var _arguments = arguments;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : {}, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, preventScrollReset = _ref.preventScrollReset, replace2 = _ref.replace;
                        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
                        location = redirect2.response.headers.get("Location");
                        invariant(location, "Expected a Location header on the redirect Response");
                        location = normalizeRedirectLocation(location, new URL(request.url), basename);
                        redirectLocation = createLocation(state.location, location, {
                            _isRedirect: true
                        });
                        if (isBrowser2) {
                            isDocumentReload = false;
                            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
                            else if (isAbsoluteUrl(location)) {
                                url = createBrowserURLImpl(location, true);
                                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                stripBasename(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace2) routerWindow.location.replace(location);
                                else routerWindow.location.assign(location);
                                return [
                                    2
                                ];
                            }
                        }
                        pendingNavigationController = null;
                        redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
                        activeSubmission = submission || fetcherSubmission;
                        if (!(redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectNavigationType, redirectLocation, {
                                submission: (0, $9Jpjh._)((0, $lvTkn._)({}, activeSubmission), {
                                    formAction: location
                                }),
                                // Preserve these flags across redirects
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        overrideNavigation = getLoadingNavigation(redirectLocation, submission);
                        return [
                            4,
                            startNavigation(redirectNavigationType, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve these flags across redirects
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }).apply(this, arguments);
    }
    function callDataStrategy(request, matches, scopedContext, fetcherKey) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var results, dataResults, e, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, routeId, result, response, err;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dataResults = {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, false)
                        ];
                    case 2:
                        results = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        matches.filter(function(m) {
                            return m.shouldLoad;
                        }).forEach(function(m) {
                            dataResults[m.route.id] = {
                                type: "error" /* error */ ,
                                error: e
                            };
                        });
                        return [
                            2,
                            dataResults
                        ];
                    case 4:
                        if (request.signal.aborted) return [
                            2,
                            dataResults
                        ];
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            11,
                            12,
                            13
                        ]);
                        _iterator = Object.entries(results)[Symbol.iterator]();
                        _state.label = 6;
                    case 6:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            10
                        ];
                        _step_value = (0, $21h22._)(_step.value, 2), routeId = _step_value[0], result = _step_value[1];
                        if (!isRedirectDataStrategyResult(result)) return [
                            3,
                            7
                        ];
                        response = result.result;
                        dataResults[routeId] = {
                            type: "redirect" /* redirect */ ,
                            response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
                        };
                        return [
                            3,
                            9
                        ];
                    case 7:
                        return [
                            4,
                            convertDataStrategyResultToDataResult(result)
                        ];
                    case 8:
                        dataResults[routeId] = _state.sent();
                        _state.label = 9;
                    case 9:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            6
                        ];
                    case 10:
                        return [
                            3,
                            13
                        ];
                    case 11:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 12:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        })();
    }
    function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, scopedContext) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var loaderResultsPromise, fetcherResultsPromise, loaderResults, fetcherResults;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        loaderResultsPromise = callDataStrategy(request, matches, scopedContext, null);
                        fetcherResultsPromise = Promise.all(fetchersToLoad.map(function(f) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                var results, result;
                                return (0, $6PS3Z.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(f.matches && f.match && f.request && f.controller)) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                callDataStrategy(f.request, f.matches, scopedContext, f.key)
                                            ];
                                        case 1:
                                            results = _state.sent();
                                            result = results[f.match.route.id];
                                            return [
                                                2,
                                                (0, $khBmn._)({}, f.key, result)
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                Promise.resolve((0, $khBmn._)({}, f.key, {
                                                    type: "error" /* error */ ,
                                                    error: getInternalRouterError(404, {
                                                        pathname: f.path
                                                    })
                                                }))
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        }));
                        return [
                            4,
                            loaderResultsPromise
                        ];
                    case 1:
                        loaderResults = _state.sent();
                        return [
                            4,
                            fetcherResultsPromise
                        ];
                    case 2:
                        fetcherResults = _state.sent().reduce(function(acc, r) {
                            return Object.assign(acc, r);
                        }, {});
                        return [
                            2,
                            {
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        })();
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher) {
        var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error) {
        var opts = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        var boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $khBmn._)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts === null || opts === void 0 ? void 0 : opts.reason);
        updateFetcherState(key, getDoneFetcher(null));
    }
    function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        var count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        var controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                invariant(fetcher, "Expected fetcher: ".concat(key));
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $21h22._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    invariant(fetcher, "Expected fetcher: ".concat(key));
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: ".concat(blocker.state, " -> ").concat(newBlocker.state));
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(param) {
        var currentLocation = param.currentLocation, nextLocation = param.nextLocation, historyAction = param.historyAction;
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $21h22._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        var error = getInternalRouterError(404, {
            pathname: pathname
        });
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var _getShortCircuitMatches = getShortCircuitMatches(routesToUse), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            var key = getScrollRestorationKey2(location, matches.map(function(m) {
                return convertRouteMatchToUiMatch(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                var fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                var partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    function discoverRoutes(matches, pathname, signal, fetcherKey) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var _loop, partialMatches, _ret;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _loop = function() {
                            var isNonHMR, routesToUse, localManifest, e, newMatches, newPartialMatches;
                            return (0, $6PS3Z.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        isNonHMR = inFlightDataRoutes == null;
                                        routesToUse = inFlightDataRoutes || dataRoutes;
                                        localManifest = manifest;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            4,
                                            5
                                        ]);
                                        return [
                                            4,
                                            init.patchRoutesOnNavigation({
                                                signal: signal,
                                                path: pathname,
                                                matches: partialMatches,
                                                fetcherKey: fetcherKey,
                                                patch: function(routeId, children) {
                                                    if (signal.aborted) return;
                                                    patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2, false);
                                                }
                                            })
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                v: {
                                                    type: "error",
                                                    error: e,
                                                    partialMatches: partialMatches
                                                }
                                            }
                                        ];
                                    case 4:
                                        if (isNonHMR && !signal.aborted) dataRoutes = (0, $6zk1M._)(dataRoutes);
                                        return [
                                            7
                                        ];
                                    case 5:
                                        if (signal.aborted) return [
                                            2,
                                            {
                                                v: {
                                                    type: "aborted"
                                                }
                                            }
                                        ];
                                        newMatches = matchRoutes(routesToUse, pathname, basename);
                                        if (newMatches) return [
                                            2,
                                            {
                                                v: {
                                                    type: "success",
                                                    matches: newMatches
                                                }
                                            }
                                        ];
                                        newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                                        if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every(function(m, i) {
                                            return m.route.id === newPartialMatches[i].route.id;
                                        })) return [
                                            2,
                                            {
                                                v: {
                                                    type: "success",
                                                    matches: null
                                                }
                                            }
                                        ];
                                        partialMatches = newPartialMatches;
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        if (!init.patchRoutesOnNavigation) return [
                            2,
                            {
                                type: "success",
                                matches: matches
                            }
                        ];
                        partialMatches = matches;
                        _state.label = 1;
                    case 1:
                        if (!true) return [
                            3,
                            3
                        ];
                        return [
                            5,
                            (0, $6PS3Z.__values)(_loop())
                        ];
                    case 2:
                        _ret = _state.sent();
                        if ((0, $2bfPH._)(_ret) === "object") return [
                            2,
                            _ret.v
                        ];
                        return [
                            3,
                            1
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children) {
        var unstable_allowElementMutations = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        var isNonHMR = inFlightDataRoutes == null;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (isNonHMR) {
            dataRoutes = (0, $6zk1M._)(dataRoutes);
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp: function(newState) {
            updateState(newState);
        }
    };
    return router;
}
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties2 = (opts === null || opts === void 0 ? void 0 : opts.mapRouteProperties) || defaultMapRouteProperties;
    var dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties2, void 0, manifest);
    function query(_0) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function(request) {
            var _ref, requestContext, filterMatchesToLoad, skipLoaderErrorBubbling, skipRevalidation, dataStrategy, generateMiddlewareResponse, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, staticContext, error1, _getShortCircuitMatches1, notFoundMatches, route1, staticContext1, renderedStaticContext, response, e, result;
            var _arguments = arguments;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, requestContext = _ref.requestContext, filterMatchesToLoad = _ref.filterMatchesToLoad, skipLoaderErrorBubbling = _ref.skipLoaderErrorBubbling, skipRevalidation = _ref.skipRevalidation, dataStrategy = _ref.dataStrategy, generateMiddlewareResponse = _ref.generateMiddlewareResponse;
                        url = new URL(request.url);
                        method = request.method;
                        location = createLocation("", createPath(url), null, "default");
                        matches = matchRoutes(dataRoutes, location, basename);
                        requestContext = requestContext != null ? requestContext : new RouterContextProvider();
                        if (!isValidMethod(method) && method !== "HEAD") {
                            error = getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            staticContext = {
                                basename: basename,
                                location: location,
                                matches: methodNotAllowedMatches,
                                loaderData: {},
                                actionData: null,
                                errors: (0, $khBmn._)({}, route.id, error),
                                statusCode: error.status,
                                loaderHeaders: {},
                                actionHeaders: {}
                            };
                            return [
                                2,
                                generateMiddlewareResponse ? generateMiddlewareResponse(function() {
                                    return Promise.resolve(staticContext);
                                }) : staticContext
                            ];
                        } else if (!matches) {
                            error1 = getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            staticContext1 = {
                                basename: basename,
                                location: location,
                                matches: notFoundMatches,
                                loaderData: {},
                                actionData: null,
                                errors: (0, $khBmn._)({}, route1.id, error1),
                                statusCode: error1.status,
                                loaderHeaders: {},
                                actionHeaders: {}
                            };
                            return [
                                2,
                                generateMiddlewareResponse ? generateMiddlewareResponse(function() {
                                    return Promise.resolve(staticContext1);
                                }) : staticContext1
                            ];
                        }
                        if (!generateMiddlewareResponse) return [
                            3,
                            5
                        ];
                        invariant(requestContext instanceof RouterContextProvider, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            runServerMiddlewarePipeline({
                                request: request,
                                matches: matches,
                                params: matches[0].params,
                                // If we're calling middleware then it must be enabled so we can cast
                                // this to the proper type knowing it's not an `AppLoadContext`
                                context: requestContext
                            }, function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                    var res;
                                    return (0, $6PS3Z.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    generateMiddlewareResponse(function(revalidationRequest) {
                                                        var opts2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                                            var _opts2_filterMatchesToLoad, result2;
                                                            return (0, $6PS3Z.__generator)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? (_opts2_filterMatchesToLoad = opts2.filterMatchesToLoad) !== null && _opts2_filterMatchesToLoad !== void 0 ? _opts2_filterMatchesToLoad : null : filterMatchesToLoad !== null && filterMatchesToLoad !== void 0 ? filterMatchesToLoad : null, skipRevalidation === true)
                                                                        ];
                                                                    case 1:
                                                                        result2 = _state.sent();
                                                                        if (isResponse(result2)) return [
                                                                            2,
                                                                            result2
                                                                        ];
                                                                        renderedStaticContext = (0, $lvTkn._)({
                                                                            location: location,
                                                                            basename: basename
                                                                        }, result2);
                                                                        return [
                                                                            2,
                                                                            renderedStaticContext
                                                                        ];
                                                                }
                                                            });
                                                        })();
                                                    })
                                                ];
                                            case 1:
                                                res = _state.sent();
                                                return [
                                                    2,
                                                    res
                                                ];
                                        }
                                    });
                                })();
                            }, function(error, routeId) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                    var _, _tmp, e, staticContext, _matches_find, boundaryRouteId, staticContext1;
                                    return (0, $6PS3Z.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (isRedirectResponse(error)) return [
                                                    2,
                                                    error
                                                ];
                                                if (!isResponse(error)) return [
                                                    3,
                                                    4
                                                ];
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    3,
                                                    ,
                                                    4
                                                ]);
                                                _ = ErrorResponseImpl.bind;
                                                _tmp = [
                                                    void 0,
                                                    error.status,
                                                    error.statusText
                                                ];
                                                return [
                                                    4,
                                                    parseResponseBody(error)
                                                ];
                                            case 2:
                                                error = new (_.apply(ErrorResponseImpl, _tmp.concat([
                                                    _state.sent()
                                                ])));
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 3:
                                                e = _state.sent();
                                                error = e;
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 4:
                                                if (isDataWithResponseInit(error)) error = dataWithResponseInitToErrorResponse(error);
                                                if (renderedStaticContext) {
                                                    if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                                                    staticContext = getStaticContextFromError(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : findNearestBoundary(matches, routeId).route.id);
                                                    return [
                                                        2,
                                                        generateMiddlewareResponse(function() {
                                                            return Promise.resolve(staticContext);
                                                        })
                                                    ];
                                                } else {
                                                    ;
                                                    boundaryRouteId = skipLoaderErrorBubbling ? routeId : findNearestBoundary(matches, ((_matches_find = matches.find(function(m) {
                                                        return m.route.id === routeId || m.route.loader;
                                                    })) === null || _matches_find === void 0 ? void 0 : _matches_find.route.id) || routeId).route.id;
                                                    staticContext1 = {
                                                        matches: matches,
                                                        location: location,
                                                        basename: basename,
                                                        loaderData: {},
                                                        actionData: null,
                                                        errors: (0, $khBmn._)({}, boundaryRouteId, error),
                                                        statusCode: isRouteErrorResponse(error) ? error.status : 500,
                                                        actionHeaders: {},
                                                        loaderHeaders: {}
                                                    };
                                                    return [
                                                        2,
                                                        generateMiddlewareResponse(function() {
                                                            return Promise.resolve(staticContext1);
                                                        })
                                                    ];
                                                }
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            })
                        ];
                    case 3:
                        response = _state.sent();
                        invariant(isResponse(response), "Expected a response in query()");
                        return [
                            2,
                            response
                        ];
                    case 4:
                        e = _state.sent();
                        if (isResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 5:
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true)
                        ];
                    case 6:
                        result = _state.sent();
                        if (isResponse(result)) return [
                            2,
                            result
                        ];
                        return [
                            2,
                            (0, $lvTkn._)({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        }).apply(this, arguments);
    }
    function queryRoute(_0) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function(request) {
            var _ref, routeId, requestContext, dataStrategy, generateMiddlewareResponse, url, method, location, matches, match, response, result;
            var _arguments = arguments;
            function handleQueryResult(result2) {
                if (isResponse(result2)) return result2;
                var error = result2.errors ? Object.values(result2.errors)[0] : void 0;
                if (error !== void 0) throw error;
                if (result2.actionData) return Object.values(result2.actionData)[0];
                if (result2.loaderData) return Object.values(result2.loaderData)[0];
                return void 0;
            }
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, routeId = _ref.routeId, requestContext = _ref.requestContext, dataStrategy = _ref.dataStrategy, generateMiddlewareResponse = _ref.generateMiddlewareResponse;
                        url = new URL(request.url);
                        method = request.method;
                        location = createLocation("", createPath(url), null, "default");
                        matches = matchRoutes(dataRoutes, location, basename);
                        requestContext = requestContext != null ? requestContext : new RouterContextProvider();
                        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : getTargetMatch(matches, location);
                        if (routeId && !match) throw getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        if (!generateMiddlewareResponse) return [
                            3,
                            3
                        ];
                        invariant(requestContext instanceof RouterContextProvider, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
                        return [
                            4,
                            loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            runServerMiddlewarePipeline({
                                request: request,
                                matches: matches,
                                params: matches[0].params,
                                // If we're calling middleware then it must be enabled so we can cast
                                // this to the proper type knowing it's not an `AppLoadContext`
                                context: requestContext
                            }, function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                    var res;
                                    return (0, $6PS3Z.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    generateMiddlewareResponse(function(innerRequest) {
                                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                                            var result2, processed;
                                                            return (0, $6PS3Z.__generator)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false)
                                                                        ];
                                                                    case 1:
                                                                        result2 = _state.sent();
                                                                        processed = handleQueryResult(result2);
                                                                        return [
                                                                            2,
                                                                            isResponse(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed)
                                                                        ];
                                                                }
                                                            });
                                                        })();
                                                    })
                                                ];
                                            case 1:
                                                res = _state.sent();
                                                return [
                                                    2,
                                                    res
                                                ];
                                        }
                                    });
                                })();
                            }, function(error) {
                                if (isDataWithResponseInit(error)) return Promise.resolve(dataWithResponseInitToResponse(error));
                                if (isResponse(error)) return Promise.resolve(error);
                                throw error;
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            2,
                            response
                        ];
                    case 3:
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false)
                        ];
                    case 4:
                        result = _state.sent();
                        return [
                            2,
                            handleQueryResult(result)
                        ];
                }
            });
        }).apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var result2, result, e;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!isMutationMethod(request.method)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation)
                        ];
                    case 2:
                        result2 = _state.sent();
                        return [
                            2,
                            result2
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad)
                        ];
                    case 4:
                        result = _state.sent();
                        return [
                            2,
                            isResponse(result) ? result : (0, $9Jpjh._)((0, $lvTkn._)({}, result), {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        if (isDataStrategyResult(e) && isResponse(e.result)) {
                            if (e.type === "error" /* error */ ) throw e.result;
                            return [
                                2,
                                e.result
                            ];
                        }
                        if (isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var result, error, dsMatches, results, boundaryMatch, loaderRequest, boundaryMatch1, handlerContext2, handlerContext;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: "error" /* error */ ,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        dsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, [], requestContext);
                        return [
                            4,
                            callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 2:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest);
                        _state.label = 3;
                    case 3:
                        if (isRedirectResult(result)) throw new Response(null, {
                            status: result.response.status,
                            headers: {
                                Location: result.response.headers.get("Location")
                            }
                        });
                        if (isRouteRequest) {
                            if (isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $khBmn._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {}
                                }
                            ];
                        }
                        if (skipRevalidation) {
                            if (isErrorResult(result)) {
                                boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
                                return [
                                    2,
                                    {
                                        statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                                        actionData: null,
                                        actionHeaders: (0, $lvTkn._)({}, result.headers ? (0, $khBmn._)({}, actionMatch.route.id, result.headers) : {}),
                                        matches: matches,
                                        loaderData: {},
                                        errors: (0, $khBmn._)({}, boundaryMatch.route.id, result.error),
                                        loaderHeaders: {}
                                    }
                                ];
                            } else return [
                                2,
                                {
                                    actionData: (0, $khBmn._)({}, actionMatch.route.id, result.data),
                                    actionHeaders: result.headers ? (0, $khBmn._)({}, actionMatch.route.id, result.headers) : {},
                                    matches: matches,
                                    loaderData: {},
                                    errors: null,
                                    statusCode: result.statusCode || 200,
                                    loaderHeaders: {}
                                }
                            ];
                        }
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        if (!isErrorResult(result)) return [
                            3,
                            5
                        ];
                        boundaryMatch1 = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                                boundaryMatch1.route.id,
                                result
                            ])
                        ];
                    case 4:
                        handlerContext2 = _state.sent();
                        return [
                            2,
                            (0, $9Jpjh._)((0, $lvTkn._)({}, handlerContext2), {
                                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                                actionData: null,
                                actionHeaders: (0, $lvTkn._)({}, result.headers ? (0, $khBmn._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad)
                        ];
                    case 6:
                        handlerContext = _state.sent();
                        return [
                            2,
                            (0, $9Jpjh._)((0, $lvTkn._)((0, $9Jpjh._)((0, $lvTkn._)({}, handlerContext), {
                                actionData: (0, $khBmn._)({}, actionMatch.route.id, result.data)
                            }), result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}), {
                                actionHeaders: result.headers ? (0, $khBmn._)({}, actionMatch.route.id, result.headers) : {}
                            })
                        ];
                }
            });
        })();
    }
    function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var isRouteRequest, dsMatches, maxIdx, results, handlerContext;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        if (isRouteRequest && !(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.loader) && !(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.lazy)) throw getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.id
                        });
                        if (routeMatch) dsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, routeMatch, [], requestContext);
                        else {
                            maxIdx = pendingActionResult && isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
                            matches.findIndex(function(m) {
                                return m.route.id === pendingActionResult[0];
                            }) - 1 : void 0;
                            dsMatches = matches.map(function(match, index) {
                                if (maxIdx != null && index > maxIdx) return getDataStrategyMatch(mapRouteProperties2, manifest, request, match, [], requestContext, false);
                                return getDataStrategyMatch(mapRouteProperties2, manifest, request, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
                            });
                        }
                        if (!dataStrategy && !dsMatches.some(function(m) {
                            return m.shouldLoad;
                        })) return [
                            2,
                            {
                                matches: matches,
                                loaderData: {},
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, $khBmn._)({}, pendingActionResult[0], pendingActionResult[1].error) : null,
                                statusCode: 200,
                                loaderHeaders: {}
                            }
                        ];
                        return [
                            4,
                            callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest);
                        handlerContext = processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
                        return [
                            2,
                            (0, $9Jpjh._)((0, $lvTkn._)({}, handlerContext), {
                                matches: matches
                            })
                        ];
                }
            });
        })();
    }
    function callDataStrategy(request, matches, isRouteRequest, requestContext, dataStrategy) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var results, dataResults;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            callDataStrategyImpl(dataStrategy || defaultDataStrategy, request, matches, null, requestContext, true)
                        ];
                    case 1:
                        results = _state.sent();
                        dataResults = {};
                        return [
                            4,
                            Promise.all(matches.map(function(match) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                    var result, response, _;
                                    return (0, $6PS3Z.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!(match.route.id in results)) return [
                                                    2
                                                ];
                                                result = results[match.route.id];
                                                if (isRedirectDataStrategyResult(result)) {
                                                    response = result.result;
                                                    throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
                                                }
                                                if (isRouteRequest) {
                                                    if (isResponse(result.result)) throw result;
                                                    else if (isDataWithResponseInit(result.result)) throw dataWithResponseInitToResponse(result.result);
                                                }
                                                _ = match.route.id;
                                                return [
                                                    4,
                                                    convertDataStrategyResultToDataResult(result)
                                                ];
                                            case 1:
                                                dataResults[_] = _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            }))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        })();
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function getStaticContextFromError(routes, handlerContext, error, boundaryId) {
    var errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return (0, $9Jpjh._)((0, $lvTkn._)({}, handlerContext), {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: (0, $khBmn._)({}, errorBoundaryId, error)
    });
}
function throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    var method = isRouteRequest ? "queryRoute" : "query";
    throw new Error("".concat(method, "() call aborted without an `AbortSignal.reason`: ").concat(request.method, " ").concat(request.url));
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    var path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        var nakedIndex = hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            var params = new URLSearchParams(path.search);
            var indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?".concat(qs) : "";
        }
    }
    if (basename !== "/") path.pathname = prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return createPath(path);
}
function normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path: path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = rawFormMethod.toUpperCase();
    var formAction = stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, param) {
                var _param = (0, $21h22._)(param, 2), name = _param[0], value = _param[1];
                return "".concat(acc).concat(name, "=").concat(value, "\n");
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if (isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    var parsedPath = parsePath(path);
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?".concat(searchParams);
    return {
        path: createPath(parsedPath),
        submission: submission
    };
}
function getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, pendingActionResult) {
    var _state_matches_;
    var actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    var maxIdx;
    if (initialHydration && state.errors) {
        var boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex(function(m) {
            return m.route.id === boundaryId;
        });
    } else if (pendingActionResult && isErrorResult(pendingActionResult[1])) {
        var boundaryId1 = pendingActionResult[0];
        maxIdx = matches.findIndex(function(m) {
            return m.route.id === boundaryId1;
        }) - 1;
    }
    var actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    var shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    var baseShouldRevalidateArgs = (0, $9Jpjh._)((0, $lvTkn._)({
        currentUrl: currentUrl,
        currentParams: ((_state_matches_ = state.matches[0]) === null || _state_matches_ === void 0 ? void 0 : _state_matches_.params) || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params
    }, submission), {
        actionResult: actionResult,
        actionStatus: actionStatus
    });
    var dsMatches = matches.map(function(match, index) {
        var route = match.route;
        var forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) forceShouldLoad = shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        else if (isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        var defaultShouldRevalidate = shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
        currentUrl.search !== nextUrl.search || isNewRouteInstance(state.matches[index], match);
        var shouldRevalidateArgs = (0, $9Jpjh._)((0, $lvTkn._)({}, baseShouldRevalidateArgs), {
            defaultShouldRevalidate: defaultShouldRevalidate
        });
        var shouldLoad = shouldRevalidateLoader(match, shouldRevalidateArgs);
        return getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs);
    });
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        if (initialHydration || !matches.some(function(m) {
            return m.route.id === f.routeId;
        }) || fetchersQueuedForDeletion.has(key)) return;
        var fetcher = state.fetchers.get(key);
        var isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        var fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        var fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        var fetchController = new AbortController();
        var fetchRequest = createClientSideRequest(history, f.path, fetchController.signal);
        var fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            var shouldRevalidateArgs = (0, $9Jpjh._)((0, $lvTkn._)({}, baseShouldRevalidateArgs), {
                defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
            });
            if (shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!routeHasLoaderOrMiddleware(route)) return false;
    var hasData = loaderData != null && route.id in loaderData;
    var hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    var isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, allowElementMutations) {
    var childrenToPatch;
    if (routeId) {
        var route = manifest[routeId];
        invariant(route, "No route found to patch children into: routeId = ".concat(routeId));
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    var uniqueChildren = [];
    var existingChildren = [];
    children.forEach(function(newRoute) {
        var existingRoute = childrenToPatch.find(function(existingRoute2) {
            return isSameRoute(newRoute, existingRoute2);
        });
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        var _childrenToPatch;
        var newRoutes = convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String((childrenToPatch === null || childrenToPatch === void 0 ? void 0 : childrenToPatch.length) || "0")
        ], manifest);
        (_childrenToPatch = childrenToPatch).push.apply(_childrenToPatch, (0, $6zk1M._)(newRoutes));
    }
    if (allowElementMutations && existingChildren.length > 0) for(var i = 0; i < existingChildren.length; i++){
        var _existingChildren_i = existingChildren[i], existingRoute = _existingChildren_i.existingRoute, newRoute = _existingChildren_i.newRoute;
        var existingRouteTyped = existingRoute;
        var _convertRoutesToDataRoutes = (0, $21h22._)(convertRoutesToDataRoutes([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true), 1), newRouteTyped = _convertRoutesToDataRoutes[0];
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
}
function isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every(function(aChild, i) {
        var _existingRoute_children;
        return (_existingRoute_children = existingRoute.children) === null || _existingRoute_children === void 0 ? void 0 : _existingRoute_children.some(function(bChild) {
            return isSameRoute(aChild, bChild);
        });
    });
}
var lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var loadLazyRouteProperty = function(param) {
    var key = param.key, route = param.route, manifest = param.manifest, mapRouteProperties2 = param.mapRouteProperties;
    var routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || (0, $2bfPH._)(routeToUpdate.lazy) !== "object") return;
    var lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    var cache = lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    var cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    var propertyPromise = function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var isUnsupported, staticRouteValue, isStaticallyDefined, value;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isUnsupported = isUnsupportedLazyRouteObjectKey(key);
                        staticRouteValue = routeToUpdate[key];
                        isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
                        if (!isUnsupported) return [
                            3,
                            1
                        ];
                        warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
                        cache[key] = Promise.resolve();
                        return [
                            3,
                            4
                        ];
                    case 1:
                        if (!isStaticallyDefined) return [
                            3,
                            2
                        ];
                        warning(false, 'Route "'.concat(routeToUpdate.id, '" has a static property "').concat(key, '" defined. The lazy property will be ignored.'));
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            lazyFn()
                        ];
                    case 3:
                        value = _state.sent();
                        if (value != null) {
                            Object.assign(routeToUpdate, (0, $khBmn._)({}, key, value));
                            Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
                        }
                        _state.label = 4;
                    case 4:
                        if ((0, $2bfPH._)(routeToUpdate.lazy) === "object") {
                            routeToUpdate.lazy[key] = void 0;
                            if (Object.values(routeToUpdate.lazy).every(function(value) {
                                return value === void 0;
                            })) routeToUpdate.lazy = void 0;
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    var routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        var cachedPromise = lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        var lazyRoutePromise2 = function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                var lazyRoute, routeUpdates, lazyRouteProperty, lazyValue, isUnsupported, staticRouteValue, isStaticallyDefined;
                return (0, $6PS3Z.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            invariant(typeof route.lazy === "function", "No lazy route function found");
                            return [
                                4,
                                route.lazy()
                            ];
                        case 1:
                            lazyRoute = _state.sent();
                            routeUpdates = {};
                            for(var lazyRouteProperty in lazyRoute){
                                lazyValue = lazyRoute[lazyRouteProperty];
                                if (lazyValue === void 0) continue;
                                isUnsupported = isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                                staticRouteValue = routeToUpdate[lazyRouteProperty];
                                isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                                // on the route updates
                                lazyRouteProperty !== "hasErrorBoundary";
                                if (isUnsupported) warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                                else if (isStaticallyDefined) warning(!isStaticallyDefined, 'Route "'.concat(routeToUpdate.id, '" has a static property "').concat(lazyRouteProperty, '" defined but its lazy function is also returning a value for this property. The lazy route property "').concat(lazyRouteProperty, '" will be ignored.'));
                                else routeUpdates[lazyRouteProperty] = lazyValue;
                            }
                            Object.assign(routeToUpdate, routeUpdates);
                            Object.assign(routeToUpdate, (0, $9Jpjh._)((0, $lvTkn._)({}, mapRouteProperties2(routeToUpdate)), {
                                lazy: void 0
                            }));
                            return [
                                2
                            ];
                    }
                });
            })();
        }();
        lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(function() {});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    var lazyKeys = Object.keys(route.lazy);
    var lazyPropertyPromises = [];
    var lazyHandlerPromise = void 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = lazyKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
            var promise = loadLazyRouteProperty({
                key: key,
                route: route,
                manifest: manifest,
                mapRouteProperties: mapRouteProperties2
            });
            if (promise) {
                lazyPropertyPromises.push(promise);
                if (key === type) lazyHandlerPromise = promise;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(function() {}) : void 0;
    lazyRoutePromise === null || lazyRoutePromise === void 0 ? void 0 : lazyRoutePromise.catch(function() {});
    lazyHandlerPromise === null || lazyHandlerPromise === void 0 ? void 0 : lazyHandlerPromise.catch(function() {});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function isNonNullable(value) {
    return value !== void 0;
}
function loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    var promises = matches.map(function(param) {
        var route = param.route;
        if ((0, $2bfPH._)(route.lazy) !== "object" || !route.lazy.middleware) return void 0;
        return loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter(isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
function defaultDataStrategy(args) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var matchesToLoad, keyedResults, results;
        return (0, $6PS3Z.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    matchesToLoad = args.matches.filter(function(m) {
                        return m.shouldLoad;
                    });
                    keyedResults = {};
                    return [
                        4,
                        Promise.all(matchesToLoad.map(function(m) {
                            return m.resolve();
                        }))
                    ];
                case 1:
                    results = _state.sent();
                    results.forEach(function(result, i) {
                        keyedResults[matchesToLoad[i].route.id] = result;
                    });
                    return [
                        2,
                        keyedResults
                    ];
            }
        });
    })();
}
function defaultDataStrategyWithMiddleware(args) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        return (0, $6PS3Z.__generator)(this, function(_state) {
            if (!args.matches.some(function(m) {
                return m.route.middleware;
            })) return [
                2,
                defaultDataStrategy(args)
            ];
            return [
                2,
                runClientMiddlewarePipeline(args, function() {
                    return defaultDataStrategy(args);
                })
            ];
        });
    })();
}
function runServerMiddlewarePipeline(args, handler, errorHandler) {
    return runMiddlewarePipeline(args, handler, processResult, isResponse, errorHandler);
    function processResult(result) {
        return isDataWithResponseInit(result) ? dataWithResponseInitToResponse(result) : result;
    }
}
function runClientMiddlewarePipeline(args, handler) {
    return runMiddlewarePipeline(args, handler, function(r) {
        return r;
    }, // No post-processing needed on the client
    isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, (0, $khBmn._)({}, routeId, {
            type: "error",
            result: error
        })));
        else {
            var matches = args.matches;
            var maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex(function(m) {
                return m.route.id === routeId;
            }), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex(function(m) {
                return m.unstable_shouldCallHandler();
            }), 0));
            var boundaryRouteId = findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve((0, $khBmn._)({}, boundaryRouteId, {
                type: "error",
                result: error
            }));
        }
    }
}
function runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var matches, request, params, context, tuples, result;
        return (0, $6PS3Z.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    matches = args.matches, request = args.request, params = args.params, context = args.context;
                    tuples = matches.flatMap(function(m) {
                        return m.route.middleware ? m.route.middleware.map(function(fn) {
                            return [
                                m.route.id,
                                fn
                            ];
                        }) : [];
                    });
                    return [
                        4,
                        callRouteMiddleware({
                            request: request,
                            params: params,
                            context: context
                        }, tuples, handler, processResult, isResult, errorHandler)
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    })();
}
function callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler) {
    var idx = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 0;
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var request, _request_signal_reason, tuple, result, _tuple, routeId, middleware, nextResult, next, value, result1, _tmp, error, response;
        return (0, $6PS3Z.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = args.request;
                    if (request.signal.aborted) throw (_request_signal_reason = request.signal.reason) !== null && _request_signal_reason !== void 0 ? _request_signal_reason : new Error("Request aborted: ".concat(request.method, " ").concat(request.url));
                    tuple = middlewares[idx];
                    if (!!tuple) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        handler()
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
                case 2:
                    _tuple = (0, $21h22._)(tuple, 2), routeId = _tuple[0], middleware = _tuple[1];
                    next = function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                            var result, error, _tmp;
                            return (0, $6PS3Z.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (nextResult) throw new Error("You may only call `next()` once per middleware");
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            5
                                        ]);
                                        return [
                                            4,
                                            callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1)
                                        ];
                                    case 2:
                                        result = _state.sent();
                                        nextResult = {
                                            value: result
                                        };
                                        return [
                                            2,
                                            nextResult.value
                                        ];
                                    case 3:
                                        error = _state.sent();
                                        _tmp = {};
                                        return [
                                            4,
                                            errorHandler(error, routeId, nextResult)
                                        ];
                                    case 4:
                                        nextResult = (_tmp.value = _state.sent(), _tmp);
                                        return [
                                            2,
                                            nextResult.value
                                        ];
                                    case 5:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    };
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        9,
                        ,
                        11
                    ]);
                    return [
                        4,
                        middleware(args, next)
                    ];
                case 4:
                    value = _state.sent();
                    result1 = value != null ? processResult(value) : void 0;
                    if (!isResult(result1)) return [
                        3,
                        5
                    ];
                    return [
                        2,
                        result1
                    ];
                case 5:
                    if (!nextResult) return [
                        3,
                        6
                    ];
                    return [
                        2,
                        result1 !== null && result1 !== void 0 ? result1 : nextResult.value
                    ];
                case 6:
                    _tmp = {};
                    return [
                        4,
                        next()
                    ];
                case 7:
                    nextResult = (_tmp.value = _state.sent(), _tmp);
                    return [
                        2,
                        nextResult.value
                    ];
                case 8:
                    return [
                        3,
                        11
                    ];
                case 9:
                    error = _state.sent();
                    return [
                        4,
                        errorHandler(error, routeId, nextResult)
                    ];
                case 10:
                    response = _state.sent();
                    return [
                        2,
                        response
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    })();
}
function getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    var lazyMiddlewarePromise = loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    var lazyRoutePromises = loadLazyRoute(match.route, isMutationMethod(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad) {
    var unstable_shouldRevalidateArgs = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null;
    var isUsingNewApi = false;
    var _lazyPromises = getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return (0, $9Jpjh._)((0, $lvTkn._)({}, match), {
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        unstable_shouldRevalidateArgs: unstable_shouldRevalidateArgs,
        unstable_shouldCallHandler: function(defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!unstable_shouldRevalidateArgs) return shouldLoad;
            if (typeof defaultShouldRevalidate === "boolean") return shouldRevalidateLoader(match, (0, $9Jpjh._)((0, $lvTkn._)({}, unstable_shouldRevalidateArgs), {
                defaultShouldRevalidate: defaultShouldRevalidate
            }));
            return shouldRevalidateLoader(match, unstable_shouldRevalidateArgs);
        },
        resolve: function(handlerOverride) {
            var _match_route = match.route, lazy = _match_route.lazy, loader = _match_route.loader, middleware = _match_route.middleware;
            var callHandler = isUsingNewApi || shouldLoad || handlerOverride && !isMutationMethod(request.method) && (lazy || loader);
            var isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && !isMiddlewareOnlyRoute) return callLoaderOrAction({
                request: request,
                match: match,
                lazyHandlerPromise: _lazyPromises === null || _lazyPromises === void 0 ? void 0 : _lazyPromises.handler,
                lazyRoutePromise: _lazyPromises === null || _lazyPromises === void 0 ? void 0 : _lazyPromises.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    });
}
function getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext) {
    var shouldRevalidateArgs = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null;
    return matches.map(function(match) {
        if (match.route.id !== targetMatch.route.id) return (0, $9Jpjh._)((0, $lvTkn._)({}, match), {
            shouldLoad: false,
            unstable_shouldRevalidateArgs: shouldRevalidateArgs,
            unstable_shouldCallHandler: function() {
                return false;
            },
            _lazyPromises: getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: function() {
                return Promise.resolve({
                    type: "data",
                    result: void 0
                });
            }
        });
        return getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
function callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, isStaticHandler) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var dataStrategyArgs, runClientMiddleware, results, e;
        return (0, $6PS3Z.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!matches.some(function(m) {
                        var _m__lazyPromises;
                        return (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.middleware;
                    })) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        Promise.all(matches.map(function(m) {
                            var _m__lazyPromises;
                            return (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.middleware;
                        }))
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    dataStrategyArgs = {
                        request: request,
                        params: matches[0].params,
                        context: scopedContext,
                        matches: matches
                    };
                    runClientMiddleware = isStaticHandler ? function() {
                        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
                    } : function(cb) {
                        var typedDataStrategyArgs = dataStrategyArgs;
                        return runClientMiddlewarePipeline(typedDataStrategyArgs, function() {
                            return cb((0, $9Jpjh._)((0, $lvTkn._)({}, typedDataStrategyArgs), {
                                fetcherKey: fetcherKey,
                                runClientMiddleware: function() {
                                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                                }
                            }));
                        });
                    };
                    return [
                        4,
                        dataStrategyImpl((0, $9Jpjh._)((0, $lvTkn._)({}, dataStrategyArgs), {
                            fetcherKey: fetcherKey,
                            runClientMiddleware: runClientMiddleware
                        }))
                    ];
                case 3:
                    results = _state.sent();
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        6,
                        ,
                        7
                    ]);
                    return [
                        4,
                        Promise.all(matches.flatMap(function(m) {
                            var _m__lazyPromises, _m__lazyPromises1;
                            return [
                                (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.handler,
                                (_m__lazyPromises1 = m._lazyPromises) === null || _m__lazyPromises1 === void 0 ? void 0 : _m__lazyPromises1.route
                            ];
                        }))
                    ];
                case 5:
                    _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    e = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        2,
                        results
                    ];
            }
        });
    })();
}
function callLoaderOrAction(_0) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function(param) {
        var request, match, lazyHandlerPromise, lazyRoutePromise, handlerOverride, scopedContext, result, onReject, isAction, type, runHandler, handler, handlerError, _ref, value, handler2, ref, url, pathname, url1, pathname1, e;
        return (0, $6PS3Z.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = param.request, match = param.match, lazyHandlerPromise = param.lazyHandlerPromise, lazyRoutePromise = param.lazyRoutePromise, handlerOverride = param.handlerOverride, scopedContext = param.scopedContext;
                    isAction = isMutationMethod(request.method);
                    type = isAction ? "action" : "loader";
                    runHandler = function(handler) {
                        var reject;
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        var actualHandler = function(ctx) {
                            if (typeof handler !== "function") return Promise.reject(new Error('You cannot call the handler for a route which defines a boolean "'.concat(type, '" [routeId: ').concat(match.route.id, "]")));
                            return handler.apply(void 0, [
                                {
                                    request: request,
                                    params: match.params,
                                    context: scopedContext
                                }
                            ].concat((0, $6zk1M._)(ctx !== void 0 ? [
                                ctx
                            ] : [])));
                        };
                        var handlerPromise = function() {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                var val, e;
                                return (0, $6PS3Z.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _state.trys.push([
                                                0,
                                                2,
                                                ,
                                                3
                                            ]);
                                            return [
                                                4,
                                                handlerOverride ? handlerOverride(function(ctx) {
                                                    return actualHandler(ctx);
                                                }) : actualHandler()
                                            ];
                                        case 1:
                                            val = _state.sent();
                                            return [
                                                2,
                                                {
                                                    type: "data",
                                                    result: val
                                                }
                                            ];
                                        case 2:
                                            e = _state.sent();
                                            return [
                                                2,
                                                {
                                                    type: "error",
                                                    result: e
                                                }
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        }();
                        return Promise.race([
                            handlerPromise,
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = isAction ? match.route.action : match.route.loader;
                    if (!(lazyHandlerPromise || lazyRoutePromise)) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler).catch(function(e) {
                                handlerError = e;
                            }),
                            // Ensure all lazy route promises are resolved before continuing
                            lazyHandlerPromise,
                            lazyRoutePromise
                        ])
                    ];
                case 2:
                    _ref = (0, $21h22._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), value = _ref[0];
                    if (handlerError !== void 0) throw handlerError;
                    result = value;
                    return [
                        3,
                        7
                    ];
                case 3:
                    return [
                        4,
                        lazyHandlerPromise
                    ];
                case 4:
                    _state.sent();
                    handler2 = isAction ? match.route.action : match.route.loader;
                    if (!handler2) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        Promise.all([
                            runHandler(handler2),
                            lazyRoutePromise
                        ])
                    ];
                case 5:
                    ref = (0, $21h22._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), result = ref[0], ref;
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else return [
                        2,
                        {
                            type: "data" /* data */ ,
                            result: void 0
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    return [
                        2,
                        {
                            type: "error" /* error */ ,
                            result: e
                        }
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).apply(this, arguments);
}
function parseResponseBody(response) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var contentType;
        return (0, $6PS3Z.__generator)(this, function(_state) {
            contentType = response.headers.get("Content-Type");
            if (contentType && /\bapplication\/json\b/.test(contentType)) return [
                2,
                response.body == null ? null : response.json()
            ];
            return [
                2,
                response.text()
            ];
        });
    })();
}
function convertDataStrategyResultToDataResult(dataStrategyResult) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var _result_init, _result_init1, result, type, data2, e, _result_init2, _result_init3, _result_init4, _result_init5;
        return (0, $6PS3Z.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    result = dataStrategyResult.result, type = dataStrategyResult.type;
                    if (!isResponse(result)) return [
                        3,
                        5
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        parseResponseBody(result)
                    ];
                case 2:
                    data2 = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        2,
                        {
                            type: "error" /* error */ ,
                            error: e
                        }
                    ];
                case 4:
                    if (type === "error" /* error */ ) return [
                        2,
                        {
                            type: "error" /* error */ ,
                            error: new ErrorResponseImpl(result.status, result.statusText, data2),
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: "data" /* data */ ,
                            data: data2,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 5:
                    if (type === "error" /* error */ ) {
                        if (isDataWithResponseInit(result)) {
                            ;
                            if (result.data instanceof Error) return [
                                2,
                                {
                                    type: "error" /* error */ ,
                                    error: result.data,
                                    statusCode: (_result_init2 = result.init) === null || _result_init2 === void 0 ? void 0 : _result_init2.status,
                                    headers: ((_result_init3 = result.init) === null || _result_init3 === void 0 ? void 0 : _result_init3.headers) ? new Headers(result.init.headers) : void 0
                                }
                            ];
                            return [
                                2,
                                {
                                    type: "error" /* error */ ,
                                    error: new ErrorResponseImpl(((_result_init4 = result.init) === null || _result_init4 === void 0 ? void 0 : _result_init4.status) || 500, void 0, result.data),
                                    statusCode: isRouteErrorResponse(result) ? result.status : void 0,
                                    headers: ((_result_init5 = result.init) === null || _result_init5 === void 0 ? void 0 : _result_init5.headers) ? new Headers(result.init.headers) : void 0
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                type: "error" /* error */ ,
                                error: result,
                                statusCode: isRouteErrorResponse(result) ? result.status : void 0
                            }
                        ];
                    }
                    if (isDataWithResponseInit(result)) return [
                        2,
                        {
                            type: "data" /* data */ ,
                            data: result.data,
                            statusCode: (_result_init = result.init) === null || _result_init === void 0 ? void 0 : _result_init.status,
                            headers: ((_result_init1 = result.init) === null || _result_init1 === void 0 ? void 0 : _result_init1.headers) ? new Headers(result.init.headers) : void 0
                        }
                    ];
                    return [
                        2,
                        {
                            type: "data" /* data */ ,
                            data: result
                        }
                    ];
            }
        });
    })();
}
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    var location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!isAbsoluteUrl(location)) {
        var trimmedMatches = matches.slice(0, matches.findIndex(function(m) {
            return m.route.id === routeId;
        }) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function normalizeRedirectLocation(location, currentUrl, basename) {
    if (isAbsoluteUrl(location)) {
        var normalizedLocation = location;
        var url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        var isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
function createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL(stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $21h22._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $21h22._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult) {
    var isStaticHandler = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, skipLoaderErrorBubbling = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    var pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach(function(match) {
        if (!(match.route.id in results)) return;
        var id = match.route.id;
        var result = results[id];
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            var error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                var boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = (0, $khBmn._)({}, pendingActionResult[0], pendingError);
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    var _processRouteLoaderData = processRouteLoaderData(matches, results, pendingActionResult), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    revalidatingFetchers.filter(function(f) {
        return !f.matches || f.matches.some(function(m) {
            return m.shouldLoad;
        });
    }).forEach(function(rf) {
        var key = rf.key, match = rf.match, controller = rf.controller;
        if (controller && controller.signal.aborted) return;
        var result = fetcherResults[key];
        invariant(result, "Did not find corresponding fetcher result");
        if (isErrorResult(result)) {
            var boundaryMatch = findNearestBoundary(state.matches, match === null || match === void 0 ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = (0, $9Jpjh._)((0, $lvTkn._)({}, errors), (0, $khBmn._)({}, boundaryMatch.route.id, result.error));
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) invariant(false, "Unhandled fetcher revalidation redirect");
        else {
            var doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = Object.entries(newLoaderData).filter(function(param) {
        var _param = (0, $21h22._)(param, 2), v = _param[1];
        return v !== ResetLoaderDataSymbol;
    }).reduce(function(merged, param) {
        var _param = (0, $21h22._)(param, 2), k = _param[0], v = _param[1];
        merged[k] = v;
        return merged;
    }, {});
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: (0, $khBmn._)({}, pendingActionResult[0], pendingActionResult[1].data)
    };
}
function findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $6zk1M._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function getShortCircuitMatches(routes) {
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function getInternalRouterError(status) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type, message = _ref.message;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a ".concat(method, ' request to "').concat(pathname, '" but did not provide a `loader` for route "').concat(routeId, '", so there is no way to handle the request.');
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "'.concat(routeId, '" does not match URL "').concat(pathname, '"');
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "'.concat(pathname, '"');
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a ".concat(method.toUpperCase(), ' request to "').concat(pathname, '" but did not provide an `action` for route "').concat(routeId, '", so there is no way to handle the request.');
        else if (method) errorMessage = 'Invalid request method "'.concat(method.toUpperCase(), '"');
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
function findRedirect(results) {
    var entries = Object.entries(results);
    for(var i = entries.length - 1; i >= 0; i--){
        var _entries_i = (0, $21h22._)(entries[i], 2), key = _entries_i[0], result = _entries_i[1];
        if (isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath((0, $9Jpjh._)((0, $lvTkn._)({}, parsedPath), {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function dataWithResponseInitToResponse(data2) {
    var _data2_init;
    return Response.json(data2.data, (_data2_init = data2.init) !== null && _data2_init !== void 0 ? _data2_init : void 0);
}
function dataWithResponseInitToErrorResponse(data2) {
    var _data2_init, _data2_init1;
    var _data2_init_status, _data2_init_statusText;
    return new ErrorResponseImpl((_data2_init_status = (_data2_init = data2.init) === null || _data2_init === void 0 ? void 0 : _data2_init.status) !== null && _data2_init_status !== void 0 ? _data2_init_status : 500, (_data2_init_statusText = (_data2_init1 = data2.init) === null || _data2_init1 === void 0 ? void 0 : _data2_init1.statusText) !== null && _data2_init_statusText !== void 0 ? _data2_init_statusText : "Internal Server Error", data2.data);
}
function isDataStrategyResults(result) {
    return result != null && (typeof result === "undefined" ? "undefined" : (0, $2bfPH._)(result)) === "object" && Object.entries(result).every(function(param) {
        var _param = (0, $21h22._)(param, 2), key = _param[0], value = _param[1];
        return typeof key === "string" && isDataStrategyResult(value);
    });
}
function isDataStrategyResult(result) {
    return result != null && (typeof result === "undefined" ? "undefined" : (0, $2bfPH._)(result)) === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function isRedirectDataStrategyResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function isDataWithResponseInit(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && (0, $2bfPH._)(value.headers) === "object" && typeof value.body !== "undefined";
}
function isRedirectStatusCode(statusCode) {
    return redirectStatusCodes.has(statusCode);
}
function isRedirectResponse(result) {
    return isResponse(result) && isRedirectStatusCode(result.status) && result.headers.has("Location");
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toUpperCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toUpperCase());
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function getTargetMatch(matches, location) {
    var search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    var pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation1;
    }
}
function getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data2) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher1;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function getDoneFetcher(data2) {
    var fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $21h22._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {}
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $21h22._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, $6zk1M._)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (".concat(error, ")."));
        }
    }
}
function createDeferred() {
    var resolve;
    var reject;
    var promise = new Promise(function(res, rej) {
        resolve = function(val) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                var e;
                return (0, $6PS3Z.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            res(val);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        reject = function(error) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                var e;
                return (0, $6PS3Z.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rej(error);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
    });
    return {
        promise: promise,
        //@ts-ignore
        resolve: resolve,
        //@ts-ignore
        reject: reject
    };
}
var DataRouterContext = $eHaBZ.createContext(null);
DataRouterContext.displayName = "DataRouter";
var DataRouterStateContext = $eHaBZ.createContext(null);
DataRouterStateContext.displayName = "DataRouterState";
var RSCRouterContext = $eHaBZ.createContext(false);
function useIsRSCRouterContext() {
    return $eHaBZ.useContext(RSCRouterContext);
}
var ViewTransitionContext = $eHaBZ.createContext({
    isTransitioning: false
});
ViewTransitionContext.displayName = "ViewTransition";
var FetchersContext = $eHaBZ.createContext(/* @__PURE__ */ new Map());
FetchersContext.displayName = "Fetchers";
var AwaitContext = $eHaBZ.createContext(null);
AwaitContext.displayName = "Await";
var AwaitContextProvider = function(props) {
    return $eHaBZ.createElement(AwaitContext.Provider, props);
};
var NavigationContext = $eHaBZ.createContext(null);
NavigationContext.displayName = "Navigation";
var LocationContext = $eHaBZ.createContext(null);
LocationContext.displayName = "Location";
var RouteContext = $eHaBZ.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
RouteContext.displayName = "Route";
var RouteErrorContext = $eHaBZ.createContext(null);
RouteErrorContext.displayName = "RouteError";
var ENABLE_DEV_WARNINGS = true;
function useHref(to) {
    var relative = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).relative;
    invariant(useInRouterContext(), "useHref() may be used only in the context of a <Router> component.");
    var _React2_useContext = $eHaBZ.useContext(NavigationContext), basename = _React2_useContext.basename, navigator = _React2_useContext.navigator;
    var _useResolvedPath = useResolvedPath(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function useInRouterContext() {
    return $eHaBZ.useContext(LocationContext) != null;
}
function useLocation() {
    invariant(useInRouterContext(), "useLocation() may be used only in the context of a <Router> component.");
    return $eHaBZ.useContext(LocationContext).location;
}
function useNavigationType() {
    return $eHaBZ.useContext(LocationContext).navigationType;
}
function useMatch(pattern) {
    invariant(useInRouterContext(), "useMatch() may be used only in the context of a <Router> component.");
    var pathname = useLocation().pathname;
    return $eHaBZ.useMemo(function() {
        return matchPath(pattern, decodePath(pathname));
    }, [
        pathname,
        pattern
    ]);
}
var navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function useIsomorphicLayoutEffect(cb) {
    var isStatic = $eHaBZ.useContext(NavigationContext).static;
    if (!isStatic) $eHaBZ.useLayoutEffect(cb);
}
function useNavigate() {
    var isDataRoute = $eHaBZ.useContext(RouteContext).isDataRoute;
    return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
    invariant(useInRouterContext(), "useNavigate() may be used only in the context of a <Router> component.");
    var dataRouterContext = $eHaBZ.useContext(DataRouterContext);
    var _React2_useContext = $eHaBZ.useContext(NavigationContext), basename = _React2_useContext.basename, navigator = _React2_useContext.navigator;
    var matches = $eHaBZ.useContext(RouteContext).matches;
    var _useLocation = useLocation(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify(getResolveToMatches(matches));
    var activeRef = $eHaBZ.useRef(false);
    useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $eHaBZ.useCallback(function(to) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        warning(activeRef.current, navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var OutletContext = $eHaBZ.createContext(null);
function useOutletContext() {
    return $eHaBZ.useContext(OutletContext);
}
function useOutlet(context) {
    var outlet = $eHaBZ.useContext(RouteContext).outlet;
    return $eHaBZ.useMemo(function() {
        return outlet && /* @__PURE__ */ $eHaBZ.createElement(OutletContext.Provider, {
            value: context
        }, outlet);
    }, [
        outlet,
        context
    ]);
}
function useParams() {
    var matches = $eHaBZ.useContext(RouteContext).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function useResolvedPath(to) {
    var relative = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).relative;
    var matches = $eHaBZ.useContext(RouteContext).matches;
    var _useLocation = useLocation(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify(getResolveToMatches(matches));
    return $eHaBZ.useMemo(function() {
        return resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function useRoutes(routes, locationArg) {
    return useRoutesImpl(routes, locationArg);
}
function useRoutesImpl(routes, locationArg, dataRouterState, unstable_onError, future) {
    invariant(useInRouterContext(), "useRoutes() may be used only in the context of a <Router> component.");
    var navigator = $eHaBZ.useContext(NavigationContext).navigator;
    var _React2_useContext = $eHaBZ.useContext(RouteContext), parentMatches = _React2_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    if (ENABLE_DEV_WARNINGS) {
        var parentPath = parentRoute && parentRoute.path || "";
        warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), 'You rendered descendant <Routes> (or called `useRoutes()`) at "'.concat(parentPathname, '" (under <Route path="').concat(parentPath, '">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won\'t match anymore and therefore the child routes will never render.\n\nPlease change the parent <Route path="').concat(parentPath, '"> to <Route path="').concat(parentPath === "/" ? "*" : "".concat(parentPath, "/*"), '">.'));
    }
    var locationFromContext = useLocation();
    var location;
    if (locationArg) {
        var _parsedLocationArg_pathname;
        var parsedLocationArg = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
        invariant(parentPathnameBase === "/" || ((_parsedLocationArg_pathname = parsedLocationArg.pathname) === null || _parsedLocationArg_pathname === void 0 ? void 0 : _parsedLocationArg_pathname.startsWith(parentPathnameBase)), 'When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "'.concat(parentPathnameBase, '" but pathname "').concat(parsedLocationArg.pathname, '" was given in the `location` prop.'));
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        var parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        var segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    var matches = matchRoutes(routes, {
        pathname: remainingPathname
    });
    if (ENABLE_DEV_WARNINGS) {
        warning(parentRoute || matches != null, 'No routes matched location "'.concat(location.pathname).concat(location.search).concat(location.hash, '" '));
        warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, 'Matched leaf route at location "'.concat(location.pathname).concat(location.search).concat(location.hash, '" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.'));
    }
    var renderedMatches = _renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState, unstable_onError, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $eHaBZ.createElement(LocationContext.Provider, {
        value: {
            location: (0, $lvTkn._)({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorComponent() {
    var error = useRouteError();
    var message = isRouteErrorResponse(error) ? "".concat(error.status, " ").concat(error.statusText) : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    if (ENABLE_DEV_WARNINGS) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, /* @__PURE__ */ $eHaBZ.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $eHaBZ.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $eHaBZ.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $eHaBZ.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, /* @__PURE__ */ $eHaBZ.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $eHaBZ.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $eHaBZ.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var defaultErrorElement = /* @__PURE__ */ $eHaBZ.createElement(DefaultErrorComponent, null);
var RenderErrorBoundary = /*#__PURE__*/ function(_React2_Component) {
    "use strict";
    (0, $NBk0Y._)(RenderErrorBoundary, _React2_Component);
    function RenderErrorBoundary(props) {
        (0, $gd0sY._)(this, RenderErrorBoundary);
        var _this;
        _this = (0, $8xMIM._)(this, RenderErrorBoundary, [
            props
        ]);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $7cSld._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                if (this.props.unstable_onError) this.props.unstable_onError(error, errorInfo);
                else console.error("React Router caught the following error during render", error);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error !== void 0 ? /* @__PURE__ */ $eHaBZ.createElement(RouteContext.Provider, {
                    value: this.props.routeContext
                }, /* @__PURE__ */ $eHaBZ.createElement(RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                return {
                    error: props.error !== void 0 ? props.error : state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($eHaBZ.Component);
function RenderedRoute(param) {
    var routeContext = param.routeContext, match = param.match, children = param.children;
    var dataRouterContext = $eHaBZ.useContext(DataRouterContext);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $eHaBZ.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches) {
    var parentMatches = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], dataRouterState = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, unstable_onError = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, future = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    var errors = dataRouterState === null || dataRouterState === void 0 ? void 0 : dataRouterState.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors === null || errors === void 0 ? void 0 : errors[m.route.id]) !== void 0;
        });
        invariant(errorIndex >= 0, "Could not find a matching route for errors on route IDs: ".concat(Object.keys(errors).join(",")));
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    var renderFallback = false;
    var fallbackIndex = -1;
    if (dataRouterState) for(var i = 0; i < renderedMatches.length; i++){
        var match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            var loaderData = dataRouterState.loaderData, errors2 = dataRouterState.errors;
            var needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        var error;
        var shouldRenderHydrateFallback = false;
        var errorElement = null;
        var hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        var matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $eHaBZ.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $eHaBZ.createElement(RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $eHaBZ.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            unstable_onError: unstable_onError
        }) : getChildren();
    }, null);
}
function getDataRouterConsoleError(hookName) {
    return "".concat(hookName, " must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.");
}
function useDataRouterContext(hookName) {
    var ctx = $eHaBZ.useContext(DataRouterContext);
    invariant(ctx, getDataRouterConsoleError(hookName));
    return ctx;
}
function useDataRouterState(hookName) {
    var state = $eHaBZ.useContext(DataRouterStateContext);
    invariant(state, getDataRouterConsoleError(hookName));
    return state;
}
function useRouteContext(hookName) {
    var route = $eHaBZ.useContext(RouteContext);
    invariant(route, getDataRouterConsoleError(hookName));
    return route;
}
function useCurrentRouteId(hookName) {
    var route = useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    invariant(thisRoute.route.id, "".concat(hookName, ' can only be used on routes that contain a unique "id"'));
    return thisRoute.route.id;
}
function useRouteId() {
    return useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function useNavigation() {
    var state = useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function useRevalidator() {
    var dataRouterContext = useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    var state = useDataRouterState("useRevalidator" /* UseRevalidator */ );
    var revalidate = $eHaBZ.useCallback(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dataRouterContext.router.revalidate()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        dataRouterContext.router
    ]);
    return $eHaBZ.useMemo(function() {
        return {
            revalidate: revalidate,
            state: state.revalidation
        };
    }, [
        revalidate,
        state.revalidation
    ]);
}
function useMatches() {
    var _useDataRouterState = useDataRouterState("useMatches" /* UseMatches */ ), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $eHaBZ.useMemo(function() {
        return matches.map(function(m) {
            return convertRouteMatchToUiMatch(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
function useLoaderData() {
    var state = useDataRouterState("useLoaderData" /* UseLoaderData */ );
    var routeId = useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function useRouteLoaderData(routeId) {
    var state = useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function useActionData() {
    var state = useDataRouterState("useActionData" /* UseActionData */ );
    var routeId = useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function useRouteError() {
    var _state_errors;
    var error = $eHaBZ.useContext(RouteErrorContext);
    var state = useDataRouterState("useRouteError" /* UseRouteError */ );
    var routeId = useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return (_state_errors = state.errors) === null || _state_errors === void 0 ? void 0 : _state_errors[routeId];
}
function useAsyncValue() {
    var value = $eHaBZ.useContext(AwaitContext);
    return value === null || value === void 0 ? void 0 : value._data;
}
function useAsyncError() {
    var value = $eHaBZ.useContext(AwaitContext);
    return value === null || value === void 0 ? void 0 : value._error;
}
var blockerId = 0;
function useBlocker(shouldBlock) {
    var _useDataRouterContext = useDataRouterContext("useBlocker" /* UseBlocker */ ), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = useDataRouterState("useBlocker" /* UseBlocker */ );
    var _React2_useState = (0, $21h22._)($eHaBZ.useState(""), 2), blockerKey = _React2_useState[0], setBlockerKey = _React2_useState[1];
    var blockerFunction = $eHaBZ.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: (0, $9Jpjh._)((0, $lvTkn._)({}, currentLocation), {
                pathname: stripBasename(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: (0, $9Jpjh._)((0, $lvTkn._)({}, nextLocation), {
                pathname: stripBasename(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $eHaBZ.useEffect(function() {
        var key = String(++blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    $eHaBZ.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : IDLE_BLOCKER;
}
function useNavigateStable() {
    var router = useDataRouterContext("useNavigate" /* UseNavigateStable */ ).router;
    var id = useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    var activeRef = $eHaBZ.useRef(false);
    useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $eHaBZ.useCallback(function(to) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        warning(activeRef.current, navigateEffectWarning);
                        if (!activeRef.current) return [
                            2
                        ];
                        if (!(typeof to === "number")) return [
                            3,
                            1
                        ];
                        router.navigate(to);
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            router.navigate(to, (0, $lvTkn._)({
                                fromRouteId: id
                            }, options))
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        router,
        id
    ]);
    return navigate;
}
var alreadyWarned = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned[key]) {
        alreadyWarned[key] = true;
        warning(false, message);
    }
}
function useRoute() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _state_actionData;
    var currentRouteId = useCurrentRouteId("useRoute" /* UseRoute */ );
    var _args_;
    var id = (_args_ = args[0]) !== null && _args_ !== void 0 ? _args_ : currentRouteId;
    var state = useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    var route = state.matches.find(function(param) {
        var route2 = param.route;
        return route2.id === id;
    });
    if (route === void 0) return void 0;
    return {
        loaderData: state.loaderData[id],
        actionData: (_state_actionData = state.actionData) === null || _state_actionData === void 0 ? void 0 : _state_actionData[id]
    };
}
// lib/server-runtime/warnings.ts
var alreadyWarned2 = {};
function warnOnce(condition, message) {
    if (!condition && !alreadyWarned2[message]) {
        alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
function mapRouteProperties(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if (ENABLE_DEV_WARNINGS) {
            if (route.element) warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $eHaBZ.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if (ENABLE_DEV_WARNINGS) {
            if (route.hydrateFallbackElement) warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $eHaBZ.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if (ENABLE_DEV_WARNINGS) {
            if (route.errorElement) warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $eHaBZ.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var hydrationRouteProperties = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function createMemoryRouter(routes, opts) {
    return createRouter({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: createMemoryHistory({
            initialEntries: opts === null || opts === void 0 ? void 0 : opts.initialEntries,
            initialIndex: opts === null || opts === void 0 ? void 0 : opts.initialIndex
        }),
        hydrationData: opts === null || opts === void 0 ? void 0 : opts.hydrationData,
        routes: routes,
        hydrationRouteProperties: hydrationRouteProperties,
        mapRouteProperties: mapRouteProperties,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}
var Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, $gd0sY._)(this, Deferred);
    this.status = "pending";
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
function shallowDiff(a, b) {
    if (a === b) return false;
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return true;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = aKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (a[key] !== b[key]) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function UNSTABLE_TransitionEnabledRouterProvider(param) {
    var router = param.router, reactDomFlushSyncImpl = param.flushSync, unstable_onError = param.unstable_onError;
    var fetcherData = $eHaBZ.useRef(/* @__PURE__ */ new Map());
    var _React3_useTransition = (0, $21h22._)($eHaBZ.useTransition(), 2), revalidating = _React3_useTransition[0], startRevalidation = _React3_useTransition[1];
    var _React3_useState = (0, $21h22._)($eHaBZ.useState(router.state), 2), state = _React3_useState[0], setState = _React3_useState[1];
    router.__setPendingRerender = function(promise) {
        return startRevalidation(// @ts-expect-error - need react 19 types for this to be async
        function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                var rerender;
                return (0, $6PS3Z.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                promise
                            ];
                        case 1:
                            rerender = _state.sent();
                            startRevalidation(function() {
                                rerender();
                            });
                            return [
                                2
                            ];
                    }
                });
            })();
        });
    };
    var navigator = $eHaBZ.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state2, opts) {
                return router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state2, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $eHaBZ.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            unstable_onError: unstable_onError
        };
    }, [
        router,
        navigator,
        basename,
        unstable_onError
    ]);
    $eHaBZ.useLayoutEffect(function() {
        return router.subscribe(function(newState, param) {
            var deletedFetchers = param.deletedFetchers, flushSync = param.flushSync, viewTransitionOpts = param.viewTransitionOpts;
            newState.fetchers.forEach(function(fetcher, key) {
                if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
            });
            deletedFetchers.forEach(function(key) {
                return fetcherData.current.delete(key);
            });
            var diff = shallowDiff(state, newState);
            if (!diff) return;
            if (flushSync) {
                if (reactDomFlushSyncImpl) reactDomFlushSyncImpl(function() {
                    return setState(newState);
                });
                else setState(newState);
            } else $eHaBZ.startTransition(function() {
                setState(newState);
            });
        });
    }, [
        router,
        reactDomFlushSyncImpl,
        state
    ]);
    return /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, /* @__PURE__ */ $eHaBZ.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $eHaBZ.createElement(DataRouterStateContext.Provider, {
        value: (0, $9Jpjh._)((0, $lvTkn._)({}, state), {
            revalidation: revalidating ? "loading" : state.revalidation
        })
    }, /* @__PURE__ */ $eHaBZ.createElement(FetchersContext.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $eHaBZ.createElement(Router, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, /* @__PURE__ */ $eHaBZ.createElement(MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        unstable_onError: unstable_onError
    }))))), null);
}
function RouterProvider(param) {
    var router = param.router, reactDomFlushSyncImpl = param.flushSync, unstable_onError = param.unstable_onError;
    var _React3_useState = (0, $21h22._)($eHaBZ.useState(router.state), 2), state = _React3_useState[0], setStateImpl = _React3_useState[1];
    var _React3_useState1 = (0, $21h22._)($eHaBZ.useState(), 2), pendingState = _React3_useState1[0], setPendingState = _React3_useState1[1];
    var _React3_useState2 = (0, $21h22._)($eHaBZ.useState({
        isTransitioning: false
    }), 2), vtContext = _React3_useState2[0], setVtContext = _React3_useState2[1];
    var _React3_useState3 = (0, $21h22._)($eHaBZ.useState(), 2), renderDfd = _React3_useState3[0], setRenderDfd = _React3_useState3[1];
    var _React3_useState4 = (0, $21h22._)($eHaBZ.useState(), 2), transition = _React3_useState4[0], setTransition = _React3_useState4[1];
    var _React3_useState5 = (0, $21h22._)($eHaBZ.useState(), 2), interruption = _React3_useState5[0], setInterruption = _React3_useState5[1];
    var fetcherData = $eHaBZ.useRef(/* @__PURE__ */ new Map());
    var logErrorsAndSetState = $eHaBZ.useCallback(function(newState) {
        setStateImpl(function(prevState) {
            if (newState.errors && unstable_onError) Object.entries(newState.errors).forEach(function(param) {
                var _param = (0, $21h22._)(param, 2), routeId = _param[0], error = _param[1];
                var _prevState_errors;
                if (((_prevState_errors = prevState.errors) === null || _prevState_errors === void 0 ? void 0 : _prevState_errors[routeId]) !== error) unstable_onError(error);
            });
            return newState;
        });
    }, [
        unstable_onError
    ]);
    var setState = $eHaBZ.useCallback(function(newState, param) {
        var deletedFetchers = param.deletedFetchers, flushSync = param.flushSync, viewTransitionOpts = param.viewTransitionOpts;
        newState.fetchers.forEach(function(fetcher, key) {
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach(function(key) {
            return fetcherData.current.delete(key);
        });
        warnOnce(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        var isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        warnOnce(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(function() {
                return logErrorsAndSetState(newState);
            });
            else $eHaBZ.startTransition(function() {
                return logErrorsAndSetState(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(function() {
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            var t = router.window.document.startViewTransition(function() {
                reactDomFlushSyncImpl(function() {
                    return logErrorsAndSetState(newState);
                });
            });
            t.finished.finally(function() {
                reactDomFlushSyncImpl(function() {
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(function() {
                return setTransition(t);
            });
            return;
        }
        if (transition) {
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        logErrorsAndSetState
    ]);
    $eHaBZ.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    $eHaBZ.useEffect(function() {
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new Deferred());
    }, [
        vtContext
    ]);
    $eHaBZ.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition2 = router.window.document.startViewTransition(function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                    return (0, $6PS3Z.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                $eHaBZ.startTransition(function() {
                                    return logErrorsAndSetState(newState);
                                });
                                return [
                                    4,
                                    renderPromise
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            });
            transition2.finished.finally(function() {
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        logErrorsAndSetState
    ]);
    $eHaBZ.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $eHaBZ.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    var navigator = $eHaBZ.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state2, opts) {
                return router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state2, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $eHaBZ.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            unstable_onError: unstable_onError
        };
    }, [
        router,
        navigator,
        basename,
        unstable_onError
    ]);
    return /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, /* @__PURE__ */ $eHaBZ.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $eHaBZ.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /* @__PURE__ */ $eHaBZ.createElement(FetchersContext.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $eHaBZ.createElement(ViewTransitionContext.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $eHaBZ.createElement(Router, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, /* @__PURE__ */ $eHaBZ.createElement(MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        unstable_onError: unstable_onError
    })))))), null);
}
var MemoizedDataRoutes = $eHaBZ.memo(DataRoutes);
function DataRoutes(param) {
    var routes = param.routes, future = param.future, state = param.state, unstable_onError = param.unstable_onError;
    return useRoutesImpl(routes, void 0, state, unstable_onError, future);
}
function MemoryRouter(param) {
    var basename = param.basename, children = param.children, initialEntries = param.initialEntries, initialIndex = param.initialIndex;
    var historyRef = $eHaBZ.useRef();
    if (historyRef.current == null) historyRef.current = createMemoryHistory({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React3_useState = (0, $21h22._)($eHaBZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React3_useState[0], setStateImpl = _React3_useState[1];
    var setState = $eHaBZ.useCallback(function(newState) {
        $eHaBZ.startTransition(function() {
            return setStateImpl(newState);
        });
    }, [
        setStateImpl
    ]);
    $eHaBZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /* @__PURE__ */ $eHaBZ.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function Navigate(param) {
    var to = param.to, replace2 = param.replace, state = param.state, relative = param.relative;
    invariant(useInRouterContext(), "<Navigate> may be used only in the context of a <Router> component.");
    var _React3_useContext = $eHaBZ.useContext(NavigationContext), isStatic = _React3_useContext.static;
    warning(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    var matches = $eHaBZ.useContext(RouteContext).matches;
    var _useLocation = useLocation(), locationPathname = _useLocation.pathname;
    var navigate = useNavigate();
    var path = resolveTo(to, getResolveToMatches(matches), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $eHaBZ.useEffect(function() {
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function Outlet(props) {
    return useOutlet(props.context);
}
function Route(props) {
    invariant(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
function Router(param) {
    var tmp = param.basename, basenameProp = tmp === void 0 ? "/" : tmp, _param_children = param.children, children = _param_children === void 0 ? null : _param_children, locationProp = param.location, _param_navigationType = param.navigationType, navigationType = _param_navigationType === void 0 ? "POP" /* Pop */  : _param_navigationType, navigator = param.navigator, tmp1 = param.static, staticProp = tmp1 === void 0 ? false : tmp1;
    invariant(!useInRouterContext(), "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $eHaBZ.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: {}
        };
    }, [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = parsePath(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $eHaBZ.useMemo(function() {
        var trailingPathname = stripBasename(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    warning(locationContext != null, '<Router basename="'.concat(basename, '"> is not able to match the URL "').concat(pathname).concat(search).concat(hash, "\" because it does not start with the basename, so the <Router> won't render anything."));
    if (locationContext == null) return null;
    return /* @__PURE__ */ $eHaBZ.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $eHaBZ.createElement(LocationContext.Provider, {
        children: children,
        value: locationContext
    }));
}
function Routes(param) {
    var children = param.children, location = param.location;
    return useRoutes(createRoutesFromChildren(children), location);
}
function Await(param) {
    var children = param.children, errorElement = param.errorElement, resolve = param.resolve;
    var dataRouterContext = $eHaBZ.useContext(DataRouterContext);
    return /* @__PURE__ */ $eHaBZ.createElement(AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        unstable_onError: dataRouterContext === null || dataRouterContext === void 0 ? void 0 : dataRouterContext.unstable_onError
    }, /* @__PURE__ */ $eHaBZ.createElement(ResolveAwait, null, children));
}
var AwaitErrorBoundary = /*#__PURE__*/ function(_React3_Component) {
    "use strict";
    (0, $NBk0Y._)(AwaitErrorBoundary, _React3_Component);
    function AwaitErrorBoundary(props) {
        (0, $gd0sY._)(this, AwaitErrorBoundary);
        var _this;
        _this = (0, $8xMIM._)(this, AwaitErrorBoundary, [
            props
        ]);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $7cSld._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                if (this.props.unstable_onError) this.props.unstable_onError(error, errorInfo);
                else console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = 0 /* pending */ ;
                if (!(resolve instanceof Promise)) {
                    status = 1 /* success */ ;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    status = 2 /* error */ ;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {});
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    promise = resolve;
                    status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
                } else {
                    status = 0 /* pending */ ;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data2) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data2;
                            }
                        });
                    }, function(error) {
                        var _this_props_unstable_onError, _this_props;
                        (_this_props_unstable_onError = (_this_props = _this.props).unstable_onError) === null || _this_props_unstable_onError === void 0 ? void 0 : _this_props_unstable_onError.call(_this_props, error);
                        Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === 2 /* error */  && !errorElement) throw promise._error;
                if (status === 2 /* error */ ) return /* @__PURE__ */ $eHaBZ.createElement(AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === 1 /* success */ ) return /* @__PURE__ */ $eHaBZ.createElement(AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($eHaBZ.Component);
function ResolveAwait(param) {
    var children = param.children;
    var data2 = useAsyncValue();
    var toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, toRender);
}
function createRoutesFromChildren(children) {
    var parentPath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var routes = [];
    $eHaBZ.Children.forEach(children, function(element, index) {
        if (!$eHaBZ.isValidElement(element)) return;
        var treePath = (0, $6zk1M._)(parentPath).concat([
            index
        ]);
        if (element.type === $eHaBZ.Fragment) {
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
            return;
        }
        invariant(element.type === Route, "[".concat(typeof element.type === "string" ? element.type : element.type.name, "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>"));
        invariant(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var createRoutesFromElements = createRoutesFromChildren;
function renderMatches(matches) {
    return _renderMatches(matches);
}
function useRouteComponentProps() {
    return {
        params: useParams(),
        loaderData: useLoaderData(),
        actionData: useActionData(),
        matches: useMatches()
    };
}
function WithComponentProps(param) {
    var children = param.children;
    var props = useRouteComponentProps();
    return $eHaBZ.cloneElement(children, props);
}
function withComponentProps(Component4) {
    return function WithComponentProps2() {
        var props = useRouteComponentProps();
        return $eHaBZ.createElement(Component4, props);
    };
}
function useHydrateFallbackProps() {
    return {
        params: useParams(),
        loaderData: useLoaderData(),
        actionData: useActionData()
    };
}
function WithHydrateFallbackProps(param) {
    var children = param.children;
    var props = useHydrateFallbackProps();
    return $eHaBZ.cloneElement(children, props);
}
function withHydrateFallbackProps(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        var props = useHydrateFallbackProps();
        return $eHaBZ.createElement(HydrateFallback, props);
    };
}
function useErrorBoundaryProps() {
    return {
        params: useParams(),
        loaderData: useLoaderData(),
        actionData: useActionData(),
        error: useRouteError()
    };
}
function WithErrorBoundaryProps(param) {
    var children = param.children;
    var props = useErrorBoundaryProps();
    return $eHaBZ.cloneElement(children, props);
}
function withErrorBoundaryProps(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        var props = useErrorBoundaryProps();
        return $eHaBZ.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var defaultMethod = "get";
var defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event);
}
function createSearchParams() {
    var init = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo2, key) {
        var value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = createSearchParams(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
    if (_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        _formDataSupportsSubmitter = false;
    } catch (e) {
        _formDataSupportsSubmitter = true;
    }
    return _formDataSupportsSubmitter;
}
var supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function getFormEncType(encType) {
    if (encType != null && !supportedFormEncTypes.has(encType)) {
        warning(false, '"'.concat(encType, '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` and will default to "').concat(defaultEncType, '"'));
        return null;
    }
    return encType;
}
function getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if (isFormElement(target)) {
        var attr = target.getAttribute("action");
        action = attr ? stripBasename(attr, basename) : null;
        method = target.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(target);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? stripBasename(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(form, target);
        if (!isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? "".concat(name, ".") : "";
                formData.append("".concat(prefix, "x"), "0");
                formData.append("".concat(prefix, "y"), "0");
            } else if (name) formData.append(name, value);
        }
    } else if (isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = defaultMethod;
        action = null;
        encType = defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var HOLE = -1;
var NAN = -2;
var NEGATIVE_INFINITY = -3;
var NEGATIVE_ZERO = -4;
var NULL = -5;
var POSITIVE_INFINITY = -6;
var UNDEFINED = -7;
var TYPE_BIGINT = "B";
var TYPE_DATE = "D";
var TYPE_ERROR = "E";
var TYPE_MAP = "M";
var TYPE_NULL_OBJECT = "N";
var TYPE_PROMISE = "P";
var TYPE_REGEXP = "R";
var TYPE_SET = "S";
var TYPE_SYMBOL = "Y";
var TYPE_URL = "U";
var TYPE_PREVIOUS_RESOLVED = "Z";
var Deferred2 = function Deferred2() {
    "use strict";
    var _this = this;
    (0, $gd0sY._)(this, Deferred2);
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = resolve;
        _this.reject = reject;
    });
};
function createLineSplittingTransform() {
    var decoder = new TextDecoder();
    var leftover = "";
    return new TransformStream({
        transform: function(chunk, controller) {
            var str = decoder.decode(chunk, {
                stream: true
            });
            var parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var part = _step.value;
                    controller.enqueue(part);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        flush: function(controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
function flatten(input) {
    var indices = this.indices;
    var existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return UNDEFINED;
    if (input === null) return NULL;
    if (Number.isNaN(input)) return NAN;
    if (input === Number.POSITIVE_INFINITY) return POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return NEGATIVE_ZERO;
    var index = this.index++;
    indices.set(input, index);
    stringify.call(this, input, index);
    return index;
}
function stringify(input, index) {
    var _this = this;
    var _this1 = this, deferred = _this1.deferred, plugins = _this1.plugins, postPlugins = _this1.postPlugins;
    var str = this.stringified;
    var stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        var _stack_pop = (0, $21h22._)(stack.pop(), 2), input2 = _stack_pop[0], index2 = _stack_pop[1];
        var partsForObj = function(obj) {
            return Object.keys(obj).map(function(k) {
                return '"_'.concat(flatten.call(_this, k), '":').concat(flatten.call(_this, obj[k]));
            }).join(",");
        };
        var error = null;
        switch(typeof input2 === "undefined" ? "undefined" : (0, $2bfPH._)(input2)){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = '["'.concat(TYPE_BIGINT, '","').concat(input2, '"]');
                break;
            case "symbol":
                {
                    var keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = '["'.concat(TYPE_SYMBOL, '",').concat(JSON.stringify(keyFor), "]");
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = "".concat(NULL);
                        break;
                    }
                    var isArray = Array.isArray(input2);
                    var pluginHandled = false;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (!isArray && plugins) try {
                        for(var _iterator = plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var plugin = _step.value;
                            var pluginResult = plugin(input2);
                            if (Array.isArray(pluginResult)) {
                                pluginHandled = true;
                                var _pluginResult = (0, $ggKxj._)(pluginResult), pluginIdentifier = _pluginResult[0], rest = _pluginResult.slice(1);
                                str[index2] = "[".concat(JSON.stringify(pluginIdentifier));
                                if (rest.length > 0) str[index2] += ",".concat(rest.map(function(v) {
                                    return flatten.call(_this, v);
                                }).join(","));
                                str[index2] += "]";
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (!pluginHandled) {
                        var result = isArray ? "[" : "{";
                        if (isArray) {
                            for(var i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? flatten.call(this, input2[i]) : HOLE);
                            str[index2] = "".concat(result, "]");
                        } else if (input2 instanceof Date) {
                            var dateTime = input2.getTime();
                            str[index2] = '["'.concat(TYPE_DATE, '",').concat(Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime, "]");
                        } else if (input2 instanceof URL) str[index2] = '["'.concat(TYPE_URL, '",').concat(JSON.stringify(input2.href), "]");
                        else if (input2 instanceof RegExp) str[index2] = '["'.concat(TYPE_REGEXP, '",').concat(JSON.stringify(input2.source), ",").concat(JSON.stringify(input2.flags), "]");
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = '["'.concat(TYPE_SET, '",').concat((0, $6zk1M._)(input2).map(function(val) {
                                return flatten.call(_this, val);
                            }).join(","), "]");
                            else str[index2] = '["'.concat(TYPE_SET, '"]');
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = '["'.concat(TYPE_MAP, '",').concat((0, $6zk1M._)(input2).flatMap(function(param) {
                                var _param = (0, $21h22._)(param, 2), k = _param[0], v = _param[1];
                                return [
                                    flatten.call(_this, k),
                                    flatten.call(_this, v)
                                ];
                            }).join(","), "]");
                            else str[index2] = '["'.concat(TYPE_MAP, '"]');
                        } else if (input2 instanceof Promise) {
                            str[index2] = '["'.concat(TYPE_PROMISE, '",').concat(index2, "]");
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = '["'.concat(TYPE_ERROR, '",').concat(JSON.stringify(input2.message));
                            if (input2.name !== "Error") str[index2] += ",".concat(JSON.stringify(input2.name));
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = '["'.concat(TYPE_NULL_OBJECT, '",{').concat(partsForObj(input2), "}]");
                        else if (isPlainObject(input2)) str[index2] = "{".concat(partsForObj(input2), "}");
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    var isArray1 = Array.isArray(input2);
                    var pluginHandled1 = false;
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    if (!isArray1 && plugins) try {
                        for(var _iterator1 = plugins[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var plugin1 = _step1.value;
                            var pluginResult1 = plugin1(input2);
                            if (Array.isArray(pluginResult1)) {
                                pluginHandled1 = true;
                                var _pluginResult1 = (0, $ggKxj._)(pluginResult1), pluginIdentifier1 = _pluginResult1[0], rest1 = _pluginResult1.slice(1);
                                str[index2] = "[".concat(JSON.stringify(pluginIdentifier1));
                                if (rest1.length > 0) str[index2] += ",".concat(rest1.map(function(v) {
                                    return flatten.call(_this, v);
                                }).join(","));
                                str[index2] += "]";
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    if (!pluginHandled1) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            var pluginHandled2 = false;
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            if (postPlugins) try {
                for(var _iterator2 = postPlugins[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var plugin2 = _step2.value;
                    var pluginResult2 = plugin2(input2);
                    if (Array.isArray(pluginResult2)) {
                        pluginHandled2 = true;
                        var _pluginResult2 = (0, $ggKxj._)(pluginResult2), pluginIdentifier2 = _pluginResult2[0], rest2 = _pluginResult2.slice(1);
                        str[index2] = "[".concat(JSON.stringify(pluginIdentifier2));
                        if (rest2.length > 0) str[index2] += ",".concat(rest2.map(function(v) {
                            return flatten.call(_this, v);
                        }).join(","));
                        str[index2] += "]";
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            if (!pluginHandled2) throw error;
        }
    }
}
var objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function isPlainObject(thing) {
    var proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === objectProtoNames;
}
// vendor/turbo-stream-v2/unflatten.ts
var globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function unflatten(parsed) {
    var _this = this, hydrated = _this.hydrated, values = _this.values;
    if (typeof parsed === "number") return hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    var startIndex = values.length;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = parsed[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            values.push(value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    hydrated.length = values.length;
    return hydrate.call(this, startIndex);
}
function hydrate(index) {
    var _loop = function() {
        var _stack_pop = (0, $21h22._)(stack.pop(), 2), index2 = _stack_pop[0], set = _stack_pop[1];
        switch(index2){
            case UNDEFINED:
                set(void 0);
                return "continue";
            case NULL:
                set(null);
                return "continue";
            case NAN:
                set(NaN);
                return "continue";
            case POSITIVE_INFINITY:
                set(Infinity);
                return "continue";
            case NEGATIVE_INFINITY:
                set(-Infinity);
                return "continue";
            case NEGATIVE_ZERO:
                set(-0);
                return "continue";
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            return "continue";
        }
        var value = values[index2];
        if (!value || (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) !== "object") {
            hydrated[index2] = value;
            set(value);
            return "continue";
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                var _value = (0, $21h22._)(value, 3), type = _value[0], b = _value[1], c = _value[2];
                switch(type){
                    case TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        return "continue";
                    case TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        return "continue";
                    case TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        return "continue";
                    case TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        return "continue";
                    case TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        return "continue";
                    case TYPE_SET:
                        var newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(var i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            function(v) {
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        return "continue";
                    case TYPE_MAP:
                        var _loop = function(i1) {
                            var r = [];
                            stack.push([
                                value[i1 + 1],
                                function(v) {
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i1],
                                function(k) {
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(function() {
                                map.set(r[0], r[1]);
                            });
                        };
                        var map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(var i1 = value.length - 2; i1 > 0; i1 -= 2)_loop(i1);
                        set(map);
                        return "continue";
                    case TYPE_NULL_OBJECT:
                        var obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            var _loop1 = function() {
                                var key = _step.value;
                                var r = [];
                                stack.push([
                                    b[key],
                                    function(v) {
                                        r[1] = v;
                                    }
                                ]);
                                stack.push([
                                    Number(key.slice(1)),
                                    function(k) {
                                        r[0] = k;
                                    }
                                ]);
                                postRun.push(function() {
                                    obj[r[0]] = r[1];
                                });
                            };
                            for(var _iterator = Object.keys(b).reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop1();
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        set(obj);
                        return "continue";
                    case TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            var d = new Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        return "continue";
                    case TYPE_ERROR:
                        var _value1 = (0, $21h22._)(value, 3), message = _value1[1], errorType = _value1[2];
                        var error = errorType && globalObj && globalObj[errorType] ? new globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        return "continue";
                    case TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        return "continue";
                    default:
                        if (Array.isArray(plugins)) {
                            var _loop2 = function(i2) {
                                var v = vals[i2];
                                stack.push([
                                    v,
                                    function(v2) {
                                        r[i2] = v2;
                                    }
                                ]);
                            };
                            var r = [];
                            var vals = value.slice(1);
                            for(var i2 = 0; i2 < vals.length; i2++)_loop2(i2);
                            postRun.push(function() {
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var plugin = _step.value;
                                        var result2 = plugin.apply(void 0, [
                                            value[0]
                                        ].concat((0, $6zk1M._)(r)));
                                        if (result2) {
                                            set(hydrated[index2] = result2.value);
                                            return;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                throw new SyntaxError();
                            });
                            return "continue";
                        }
                        throw new SyntaxError();
                }
            } else {
                var _loop3 = function(i3) {
                    var n = value[i3];
                    if (n !== HOLE) stack.push([
                        n,
                        function(v) {
                            array[i3] = v;
                        }
                    ]);
                };
                var array = [];
                hydrated[index2] = array;
                for(var i3 = 0; i3 < value.length; i3++)_loop3(i3);
                set(array);
                return "continue";
            }
        } else {
            var object = {};
            hydrated[index2] = object;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                var _loop4 = function() {
                    var key = _step1.value;
                    var r = [];
                    stack.push([
                        value[key],
                        function(v) {
                            r[1] = v;
                        }
                    ]);
                    stack.push([
                        Number(key.slice(1)),
                        function(k) {
                            r[0] = k;
                        }
                    ]);
                    postRun.push(function() {
                        object[r[0]] = r[1];
                    });
                };
                for(var _iterator1 = Object.keys(value).reverse()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop4();
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            set(object);
            return "continue";
        }
    };
    var _this = this, hydrated = _this.hydrated, values = _this.values, deferred = _this.deferred, plugins = _this.plugins;
    var result;
    var stack = [
        [
            index,
            function(v) {
                result = v;
            }
        ]
    ];
    var postRun = [];
    while(stack.length > 0)_loop();
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
function decode(readable, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var plugins, done, reader, decoder, decoded, donePromise;
        return (0, $6PS3Z.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    plugins = (options !== null && options !== void 0 ? options : {}).plugins;
                    done = new Deferred2();
                    reader = readable.pipeThrough(createLineSplittingTransform()).getReader();
                    decoder = {
                        values: [],
                        hydrated: [],
                        deferred: {},
                        plugins: plugins
                    };
                    return [
                        4,
                        decodeInitial.call(decoder, reader)
                    ];
                case 1:
                    decoded = _state.sent();
                    donePromise = done.promise;
                    if (decoded.done) done.resolve();
                    else donePromise = decodeDeferred.call(decoder, reader).then(done.resolve).catch(function(reason) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.values(decoder.deferred)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var deferred = _step.value;
                                deferred.reject(reason);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        done.reject(reason);
                    });
                    return [
                        2,
                        {
                            done: donePromise.then(function() {
                                return reader.closed;
                            }),
                            value: decoded.value
                        }
                    ];
            }
        });
    })();
}
function decodeInitial(reader) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var read, line;
        return (0, $6PS3Z.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        reader.read()
                    ];
                case 1:
                    read = _state.sent();
                    if (!read.value) throw new SyntaxError();
                    try {
                        line = JSON.parse(read.value);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    return [
                        2,
                        {
                            done: read.done,
                            value: unflatten.call(this, line)
                        }
                    ];
            }
        });
    }).call(this);
}
function decodeDeferred(reader) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var read, line, colonIndex, deferredId, deferred, lineData, jsonLine, value, colonIndex1, deferredId1, deferred1, lineData1, jsonLine1, value1;
        return (0, $6PS3Z.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        reader.read()
                    ];
                case 1:
                    read = _state.sent();
                    _state.label = 2;
                case 2:
                    if (!!read.done) return [
                        3,
                        4
                    ];
                    if (!read.value) return [
                        3,
                        2
                    ];
                    line = read.value;
                    switch(line[0]){
                        case TYPE_PROMISE:
                            {
                                colonIndex = line.indexOf(":");
                                deferredId = Number(line.slice(1, colonIndex));
                                deferred = this.deferred[deferredId];
                                if (!deferred) throw new Error("Deferred ID ".concat(deferredId, " not found in stream"));
                                lineData = line.slice(colonIndex + 1);
                                jsonLine = void 0;
                                try {
                                    jsonLine = JSON.parse(lineData);
                                } catch (reason) {
                                    throw new SyntaxError();
                                }
                                value = unflatten.call(this, jsonLine);
                                deferred.resolve(value);
                                break;
                            }
                        case TYPE_ERROR:
                            {
                                colonIndex1 = line.indexOf(":");
                                deferredId1 = Number(line.slice(1, colonIndex1));
                                deferred1 = this.deferred[deferredId1];
                                if (!deferred1) throw new Error("Deferred ID ".concat(deferredId1, " not found in stream"));
                                lineData1 = line.slice(colonIndex1 + 1);
                                jsonLine1 = void 0;
                                try {
                                    jsonLine1 = JSON.parse(lineData1);
                                } catch (reason) {
                                    throw new SyntaxError();
                                }
                                value1 = unflatten.call(this, jsonLine1);
                                deferred1.reject(value1);
                                break;
                            }
                        default:
                            throw new SyntaxError();
                    }
                    return [
                        4,
                        reader.read()
                    ];
                case 3:
                    read = _state.sent();
                    return [
                        3,
                        2
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function encode(input, options) {
    var _ref = options !== null && options !== void 0 ? options : {}, plugins = _ref.plugins, postPlugins = _ref.postPlugins, signal = _ref.signal;
    var encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    var textEncoder = new TextEncoder();
    var lastSentIndex = 0;
    var readable = new ReadableStream({
        start: function(controller) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                var id, seenPromises, raceDone, racePromise, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step;
                return (0, $6PS3Z.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            id = flatten.call(encoder, input);
                            if (Array.isArray(id)) throw new Error("This should never happen");
                            if (id < 0) controller.enqueue(textEncoder.encode("".concat(id, "\n")));
                            else {
                                controller.enqueue(textEncoder.encode("[".concat(encoder.stringified.join(","), "]\n")));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                            seenPromises = /* @__PURE__ */ new WeakSet();
                            if (!Object.keys(encoder.deferred).length) return [
                                3,
                                4
                            ];
                            racePromise = new Promise(function(resolve, reject) {
                                raceDone = resolve;
                                if (signal) {
                                    var rejectPromise = function() {
                                        return reject(signal.reason || new Error("Signal was aborted."));
                                    };
                                    if (signal.aborted) rejectPromise();
                                    else signal.addEventListener("abort", function(event) {
                                        rejectPromise();
                                    });
                                }
                            });
                            _state.label = 1;
                        case 1:
                            if (!(Object.keys(encoder.deferred).length > 0)) return [
                                3,
                                3
                            ];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                _loop = function() {
                                    var _step_value = (0, $21h22._)(_step.value, 2), deferredId = _step_value[0], deferred = _step_value[1];
                                    if (seenPromises.has(deferred)) return "continue";
                                    seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                                    encoder.deferred[Number(deferredId)] = Promise.race([
                                        racePromise,
                                        deferred
                                    ]).then(function(resolved) {
                                        var id2 = flatten.call(encoder, resolved);
                                        if (Array.isArray(id2)) {
                                            controller.enqueue(textEncoder.encode("".concat(TYPE_PROMISE).concat(deferredId, ':[["').concat(TYPE_PREVIOUS_RESOLVED, '",').concat(id2[0], "]]\n")));
                                            encoder.index++;
                                            lastSentIndex++;
                                        } else if (id2 < 0) controller.enqueue(textEncoder.encode("".concat(TYPE_PROMISE).concat(deferredId, ":").concat(id2, "\n")));
                                        else {
                                            var values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                            controller.enqueue(textEncoder.encode("".concat(TYPE_PROMISE).concat(deferredId, ":[").concat(values, "]\n")));
                                            lastSentIndex = encoder.stringified.length - 1;
                                        }
                                    }, function(reason) {
                                        if (!reason || (typeof reason === "undefined" ? "undefined" : (0, $2bfPH._)(reason)) !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                        var id2 = flatten.call(encoder, reason);
                                        if (Array.isArray(id2)) {
                                            controller.enqueue(textEncoder.encode("".concat(TYPE_ERROR).concat(deferredId, ':[["').concat(TYPE_PREVIOUS_RESOLVED, '",').concat(id2[0], "]]\n")));
                                            encoder.index++;
                                            lastSentIndex++;
                                        } else if (id2 < 0) controller.enqueue(textEncoder.encode("".concat(TYPE_ERROR).concat(deferredId, ":").concat(id2, "\n")));
                                        else {
                                            var values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                            controller.enqueue(textEncoder.encode("".concat(TYPE_ERROR).concat(deferredId, ":[").concat(values, "]\n")));
                                            lastSentIndex = encoder.stringified.length - 1;
                                        }
                                    }).finally(function() {
                                        delete encoder.deferred[Number(deferredId)];
                                    }));
                                };
                                for(_iterator = Object.entries(encoder.deferred)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return [
                                4,
                                Promise.race(Object.values(encoder.deferred))
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                1
                            ];
                        case 3:
                            raceDone();
                            _state.label = 4;
                        case 4:
                            return [
                                4,
                                Promise.all(Object.values(encoder.deferred))
                            ];
                        case 5:
                            _state.sent();
                            controller.close();
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
function createRequestInit(request) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var init, contentType, _, _1;
        return (0, $6PS3Z.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    init = {
                        signal: request.signal
                    };
                    if (!(request.method !== "GET")) return [
                        3,
                        8
                    ];
                    init.method = request.method;
                    contentType = request.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        2
                    ];
                    init.headers = {
                        "Content-Type": contentType
                    };
                    _ = JSON.stringify;
                    return [
                        4,
                        request.json()
                    ];
                case 1:
                    init.body = _.apply(JSON, [
                        _state.sent()
                    ]);
                    return [
                        3,
                        8
                    ];
                case 2:
                    if (!(contentType && /\btext\/plain\b/.test(contentType))) return [
                        3,
                        4
                    ];
                    init.headers = {
                        "Content-Type": contentType
                    };
                    return [
                        4,
                        request.text()
                    ];
                case 3:
                    init.body = _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!(contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType))) return [
                        3,
                        6
                    ];
                    _1 = URLSearchParams.bind;
                    return [
                        4,
                        request.text()
                    ];
                case 5:
                    init.body = new (_1.apply(URLSearchParams, [
                        void 0,
                        _state.sent()
                    ]));
                    return [
                        3,
                        8
                    ];
                case 6:
                    return [
                        4,
                        request.formData()
                    ];
                case 7:
                    init.body = _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        2,
                        init
                    ];
            }
        });
    })();
}
// lib/dom/ssr/markup.ts
var ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function escapeHtml(html) {
    return html.replace(ESCAPE_REGEX, function(match) {
        return ESCAPE_LOOKUP[match];
    });
}
// lib/dom/ssr/invariant.ts
function invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var SingleFetchRedirectSymbol = Symbol("SingleFetchRedirect");
var SingleFetchNoResultError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $NBk0Y._)(SingleFetchNoResultError, Error1);
    function SingleFetchNoResultError() {
        (0, $gd0sY._)(this, SingleFetchNoResultError);
        return (0, $8xMIM._)(this, SingleFetchNoResultError, arguments);
    }
    return SingleFetchNoResultError;
}((0, $dHaQg._)(Error));
var SINGLE_FETCH_REDIRECT_STATUS = 202;
var NO_BODY_STATUS_CODES = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function StreamTransfer(param) {
    var context = param.context, identifier = param.identifier, reader = param.reader, textDecoder = param.textDecoder, nonce = param.nonce;
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    var streamCache = context.renderMeta.streamCache;
    var promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then(function(result) {
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch(function(e) {
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    var _promise_result = promise.result, done = _promise_result.done, value = _promise_result.value;
    var scriptTag = value ? /* @__PURE__ */ $eHaBZ.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: "window.__reactRouterContext.streamController.enqueue(".concat(escapeHtml(JSON.stringify(value)), ");")
        }
    }) : null;
    if (done) return /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, scriptTag, /* @__PURE__ */ $eHaBZ.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: "window.__reactRouterContext.streamController.close();"
        }
    }));
    else return /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, scriptTag, /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Suspense, null, /* @__PURE__ */ $eHaBZ.createElement(StreamTransfer, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function getTurboStreamSingleFetchDataStrategy(getRouter, manifest, routeModules, ssr, basename) {
    var dataStrategy = getSingleFetchDataStrategyImpl(getRouter, function(match) {
        var manifestRoute = manifest.routes[match.route.id];
        invariant2(manifestRoute, "Route not found in manifest");
        var routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule === null || routeModule === void 0 ? void 0 : routeModule.shouldRevalidate)
        };
    }, fetchAndDecodeViaTurboStream, ssr, basename);
    return function(args) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            return (0, $6PS3Z.__generator)(this, function(_state) {
                return [
                    2,
                    args.runClientMiddleware(dataStrategy)
                ];
            });
        })();
    };
}
function getSingleFetchDataStrategyImpl(getRouter, getRouteInfo, fetchAndDecode, ssr, basename) {
    var shouldAllowOptOut = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : function() {
        return true;
    };
    return function(args) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var request, matches, fetcherKey, router, foundRevalidatingServerLoader;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                request = args.request, matches = args.matches, fetcherKey = args.fetcherKey;
                router = getRouter();
                if (request.method !== "GET") return [
                    2,
                    singleFetchActionStrategy(args, fetchAndDecode, basename)
                ];
                foundRevalidatingServerLoader = matches.some(function(m) {
                    var _getRouteInfo = getRouteInfo(m), hasLoader = _getRouteInfo.hasLoader, hasClientLoader = _getRouteInfo.hasClientLoader;
                    return m.unstable_shouldCallHandler() && hasLoader && !hasClientLoader;
                });
                if (!ssr && !foundRevalidatingServerLoader) return [
                    2,
                    nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename)
                ];
                if (fetcherKey) return [
                    2,
                    singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename)
                ];
                return [
                    2,
                    singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut)
                ];
            });
        })();
    };
}
function singleFetchActionStrategy(args, fetchAndDecode, basename) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var actionMatch, actionStatus, result;
        return (0, $6PS3Z.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    actionMatch = args.matches.find(function(m) {
                        return m.unstable_shouldCallHandler();
                    });
                    invariant2(actionMatch, "No action match found");
                    actionStatus = void 0;
                    return [
                        4,
                        actionMatch.resolve(function(handler) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                var result2;
                                return (0, $6PS3Z.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                handler(function() {
                                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                                        var _ref, data2, status;
                                                        return (0, $6PS3Z.__generator)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    return [
                                                                        4,
                                                                        fetchAndDecode(args, basename, [
                                                                            actionMatch.route.id
                                                                        ])
                                                                    ];
                                                                case 1:
                                                                    _ref = _state.sent(), data2 = _ref.data, status = _ref.status;
                                                                    actionStatus = status;
                                                                    return [
                                                                        2,
                                                                        unwrapSingleFetchResult(data2, actionMatch.route.id)
                                                                    ];
                                                            }
                                                        });
                                                    })();
                                                })
                                            ];
                                        case 1:
                                            result2 = _state.sent();
                                            return [
                                                2,
                                                result2
                                            ];
                                    }
                                });
                            })();
                        })
                    ];
                case 1:
                    result = _state.sent();
                    if (isResponse(result.result) || isRouteErrorResponse(result.result) || isDataWithResponseInit(result.result)) return [
                        2,
                        (0, $khBmn._)({}, actionMatch.route.id, result)
                    ];
                    return [
                        2,
                        (0, $khBmn._)({}, actionMatch.route.id, {
                            type: result.type,
                            result: data(result.result, actionStatus)
                        })
                    ];
            }
        });
    })();
}
function nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var matchesToLoad, results;
        return (0, $6PS3Z.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    matchesToLoad = args.matches.filter(function(m) {
                        return m.unstable_shouldCallHandler();
                    });
                    results = {};
                    return [
                        4,
                        Promise.all(matchesToLoad.map(function(m) {
                            return m.resolve(function(handler) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                    var hasClientLoader, routeId, result, _tmp, e;
                                    return (0, $6PS3Z.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _state.trys.push([
                                                    0,
                                                    5,
                                                    ,
                                                    6
                                                ]);
                                                hasClientLoader = getRouteInfo(m).hasClientLoader;
                                                routeId = m.route.id;
                                                if (!hasClientLoader) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    handler(function() {
                                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                                            var _ref, data2;
                                                            return (0, $6PS3Z.__generator)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            fetchAndDecode(args, basename, [
                                                                                routeId
                                                                            ])
                                                                        ];
                                                                    case 1:
                                                                        _ref = _state.sent(), data2 = _ref.data;
                                                                        return [
                                                                            2,
                                                                            unwrapSingleFetchResult(data2, routeId)
                                                                        ];
                                                                }
                                                            });
                                                        })();
                                                    })
                                                ];
                                            case 1:
                                                _tmp = _state.sent();
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 2:
                                                return [
                                                    4,
                                                    handler()
                                                ];
                                            case 3:
                                                _tmp = _state.sent();
                                                _state.label = 4;
                                            case 4:
                                                result = _tmp;
                                                results[m.route.id] = {
                                                    type: "data",
                                                    result: result
                                                };
                                                return [
                                                    3,
                                                    6
                                                ];
                                            case 5:
                                                e = _state.sent();
                                                results[m.route.id] = {
                                                    type: "error",
                                                    result: e
                                                };
                                                return [
                                                    3,
                                                    6
                                                ];
                                            case 6:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            });
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        results
                    ];
            }
        });
    })();
}
function singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename) {
    var shouldAllowOptOut = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : function() {
        return true;
    };
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var routesParams, foundOptOutRoute, routeDfds, singleFetchDfd, results, resolvePromise, isInitialLoad, targetRoutes, data2, e;
        return (0, $6PS3Z.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    routesParams = /* @__PURE__ */ new Set();
                    foundOptOutRoute = false;
                    routeDfds = args.matches.map(function() {
                        return createDeferred2();
                    });
                    singleFetchDfd = createDeferred2();
                    results = {};
                    resolvePromise = Promise.all(args.matches.map(function(m, i) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                            return (0, $6PS3Z.__generator)(this, function(_state) {
                                return [
                                    2,
                                    m.resolve(function(handler) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                            var routeId, _getRouteInfo, hasLoader, hasClientLoader, hasShouldRevalidate, defaultShouldRevalidate, shouldCall, result, e, result1, e1;
                                            return (0, $6PS3Z.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        routeDfds[i].resolve();
                                                        routeId = m.route.id;
                                                        _getRouteInfo = getRouteInfo(m), hasLoader = _getRouteInfo.hasLoader, hasClientLoader = _getRouteInfo.hasClientLoader, hasShouldRevalidate = _getRouteInfo.hasShouldRevalidate;
                                                        defaultShouldRevalidate = !m.unstable_shouldRevalidateArgs || m.unstable_shouldRevalidateArgs.actionStatus == null || m.unstable_shouldRevalidateArgs.actionStatus < 400;
                                                        shouldCall = m.unstable_shouldCallHandler(defaultShouldRevalidate);
                                                        if (!shouldCall) {
                                                            foundOptOutRoute || (foundOptOutRoute = m.unstable_shouldRevalidateArgs != null && // This is a revalidation,
                                                            hasLoader && // for a route with a server loader,
                                                            hasShouldRevalidate === true);
                                                            return [
                                                                2
                                                            ];
                                                        }
                                                        if (!(shouldAllowOptOut(m) && hasClientLoader)) return [
                                                            3,
                                                            5
                                                        ];
                                                        if (hasLoader) foundOptOutRoute = true;
                                                        _state.label = 1;
                                                    case 1:
                                                        _state.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4,
                                                            handler(function() {
                                                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                                                    var _ref, data2;
                                                                    return (0, $6PS3Z.__generator)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                return [
                                                                                    4,
                                                                                    fetchAndDecode(args, basename, [
                                                                                        routeId
                                                                                    ])
                                                                                ];
                                                                            case 1:
                                                                                _ref = _state.sent(), data2 = _ref.data;
                                                                                return [
                                                                                    2,
                                                                                    unwrapSingleFetchResult(data2, routeId)
                                                                                ];
                                                                        }
                                                                    });
                                                                })();
                                                            })
                                                        ];
                                                    case 2:
                                                        result = _state.sent();
                                                        results[routeId] = {
                                                            type: "data",
                                                            result: result
                                                        };
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 3:
                                                        e = _state.sent();
                                                        results[routeId] = {
                                                            type: "error",
                                                            result: e
                                                        };
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 4:
                                                        return [
                                                            2
                                                        ];
                                                    case 5:
                                                        if (hasLoader) routesParams.add(routeId);
                                                        _state.label = 6;
                                                    case 6:
                                                        _state.trys.push([
                                                            6,
                                                            8,
                                                            ,
                                                            9
                                                        ]);
                                                        return [
                                                            4,
                                                            handler(function() {
                                                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                                                    var data2;
                                                                    return (0, $6PS3Z.__generator)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                return [
                                                                                    4,
                                                                                    singleFetchDfd.promise
                                                                                ];
                                                                            case 1:
                                                                                data2 = _state.sent();
                                                                                return [
                                                                                    2,
                                                                                    unwrapSingleFetchResult(data2, routeId)
                                                                                ];
                                                                        }
                                                                    });
                                                                })();
                                                            })
                                                        ];
                                                    case 7:
                                                        result1 = _state.sent();
                                                        results[routeId] = {
                                                            type: "data",
                                                            result: result1
                                                        };
                                                        return [
                                                            3,
                                                            9
                                                        ];
                                                    case 8:
                                                        e1 = _state.sent();
                                                        results[routeId] = {
                                                            type: "error",
                                                            result: e1
                                                        };
                                                        return [
                                                            3,
                                                            9
                                                        ];
                                                    case 9:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        })();
                                    })
                                ];
                            });
                        })();
                    }));
                    return [
                        4,
                        Promise.all(routeDfds.map(function(d) {
                            return d.promise;
                        }))
                    ];
                case 1:
                    _state.sent();
                    isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
                    if (!((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive)) return [
                        3,
                        2
                    ];
                    singleFetchDfd.resolve({
                        routes: {}
                    });
                    return [
                        3,
                        6
                    ];
                case 2:
                    targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? (0, $6zk1M._)(routesParams.keys()) : void 0;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        fetchAndDecode(args, basename, targetRoutes)
                    ];
                case 4:
                    data2 = _state.sent();
                    singleFetchDfd.resolve(data2.data);
                    return [
                        3,
                        6
                    ];
                case 5:
                    e = _state.sent();
                    singleFetchDfd.reject(e);
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        4,
                        resolvePromise
                    ];
                case 7:
                    _state.sent();
                    return [
                        4,
                        bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results)
                    ];
                case 8:
                    _state.sent();
                    return [
                        2,
                        results
                    ];
            }
        });
    })();
}
function bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var middlewareError, fetchedData, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, match, routeResult, _results_match_route_id, e;
        return (0, $6PS3Z.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        singleFetchPromise
                    ];
                case 1:
                    fetchedData = _state.sent();
                    if ("routes" in fetchedData) {
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = matches[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                match = _step.value;
                                if (match.route.id in fetchedData.routes) {
                                    routeResult = fetchedData.routes[match.route.id];
                                    if ("error" in routeResult) {
                                        ;
                                        middlewareError = routeResult.error;
                                        if (((_results_match_route_id = results[match.route.id]) === null || _results_match_route_id === void 0 ? void 0 : _results_match_route_id.result) == null) results[match.route.id] = {
                                            type: "error",
                                            result: middlewareError
                                        };
                                        break;
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                    if (middlewareError !== void 0) Array.from(routesParams.values()).forEach(function(routeId) {
                        if (results[routeId].result instanceof SingleFetchNoResultError) results[routeId].result = middlewareError;
                    });
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
}
function singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var fetcherMatch, routeId, result;
        return (0, $6PS3Z.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    fetcherMatch = args.matches.find(function(m) {
                        return m.unstable_shouldCallHandler();
                    });
                    invariant2(fetcherMatch, "No fetcher match found");
                    routeId = fetcherMatch.route.id;
                    return [
                        4,
                        fetcherMatch.resolve(function(handler) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                return (0, $6PS3Z.__generator)(this, function(_state) {
                                    return [
                                        2,
                                        handler(function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                                var _ref, data2;
                                                return (0, $6PS3Z.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            return [
                                                                4,
                                                                fetchAndDecode(args, basename, [
                                                                    routeId
                                                                ])
                                                            ];
                                                        case 1:
                                                            _ref = _state.sent(), data2 = _ref.data;
                                                            return [
                                                                2,
                                                                unwrapSingleFetchResult(data2, routeId)
                                                            ];
                                                    }
                                                });
                                            })();
                                        })
                                    ];
                                });
                            })();
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        (0, $khBmn._)({}, fetcherMatch.route.id, result)
                    ];
            }
        });
    })();
}
function stripIndexParam(url) {
    var indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    var indexValuesToKeep = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = indexValues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var indexValue = _step.value;
            if (indexValue) indexValuesToKeep.push(indexValue);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = indexValuesToKeep[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var toKeep = _step1.value;
            url.searchParams.append("index", toKeep);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return url;
}
function singleFetchUrl(reqUrl, basename, extension) {
    var url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname === "/") url.pathname = "_root.".concat(extension);
    else if (basename && stripBasename(url.pathname, basename) === "/") url.pathname = "".concat(basename.replace(/\/$/, ""), "/_root.").concat(extension);
    else url.pathname = "".concat(url.pathname.replace(/\/$/, ""), ".").concat(extension);
    return url;
}
function fetchAndDecodeViaTurboStream(args, basename, targetRoutes) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var request, url, res, _tmp, _, _tmp1, routes, decoded, data2, typed, typed1, routeId, e;
        return (0, $6PS3Z.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = args.request;
                    url = singleFetchUrl(request.url, basename, "data");
                    if (request.method === "GET") {
                        url = stripIndexParam(url);
                        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
                    }
                    _tmp = [
                        url
                    ];
                    return [
                        4,
                        createRequestInit(request)
                    ];
                case 1:
                    return [
                        4,
                        fetch.apply(void 0, _tmp.concat([
                            _state.sent()
                        ]))
                    ];
                case 2:
                    res = _state.sent();
                    if (!(res.status >= 400 && !res.headers.has("X-Remix-Response"))) return [
                        3,
                        4
                    ];
                    _ = ErrorResponseImpl.bind;
                    _tmp1 = [
                        void 0,
                        res.status,
                        res.statusText
                    ];
                    return [
                        4,
                        res.text()
                    ];
                case 3:
                    throw new (_.apply(ErrorResponseImpl, _tmp1.concat([
                        _state.sent()
                    ])));
                case 4:
                    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return [
                        2,
                        {
                            status: SINGLE_FETCH_REDIRECT_STATUS,
                            data: {
                                redirect: {
                                    redirect: res.headers.get("X-Remix-Redirect"),
                                    status: Number(res.headers.get("X-Remix-Status") || "302"),
                                    revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                                    reload: res.headers.get("X-Remix-Reload-Document") === "true",
                                    replace: res.headers.get("X-Remix-Replace") === "true"
                                }
                            }
                        }
                    ];
                    if (NO_BODY_STATUS_CODES.has(res.status)) {
                        routes = {};
                        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
                            data: void 0
                        };
                        return [
                            2,
                            {
                                status: res.status,
                                data: {
                                    routes: routes
                                }
                            }
                        ];
                    }
                    invariant2(res.body, "No response body to decode");
                    _state.label = 5;
                case 5:
                    _state.trys.push([
                        5,
                        7,
                        ,
                        8
                    ]);
                    return [
                        4,
                        decodeViaTurboStream(res.body, window)
                    ];
                case 6:
                    decoded = _state.sent();
                    if (request.method === "GET") {
                        typed = decoded.value;
                        if (SingleFetchRedirectSymbol in typed) data2 = {
                            redirect: typed[SingleFetchRedirectSymbol]
                        };
                        else data2 = {
                            routes: typed
                        };
                    } else {
                        typed1 = decoded.value;
                        routeId = targetRoutes === null || targetRoutes === void 0 ? void 0 : targetRoutes[0];
                        invariant2(routeId, "No routeId found for single fetch call decoding");
                        if ("redirect" in typed1) data2 = {
                            redirect: typed1
                        };
                        else data2 = {
                            routes: (0, $khBmn._)({}, routeId, typed1)
                        };
                    }
                    return [
                        2,
                        {
                            status: res.status,
                            data: data2
                        }
                    ];
                case 7:
                    e = _state.sent();
                    throw new Error("Unable to decode turbo-stream response");
                case 8:
                    return [
                        2
                    ];
            }
        });
    })();
}
function decodeViaTurboStream(body, global) {
    return decode(body, {
        plugins: [
            function(type) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    rest[_key - 1] = arguments[_key];
                }
                if (type === "SanitizedError") {
                    var _rest = (0, $21h22._)(rest, 3), name = _rest[0], message = _rest[1], stack = _rest[2];
                    var Constructor = Error;
                    if (name && name in global && typeof global[name] === "function") Constructor = global[name];
                    var error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    var _rest1 = (0, $21h22._)(rest, 3), data2 = _rest1[0], status = _rest1[1], statusText = _rest1[2];
                    return {
                        value: new ErrorResponseImpl(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: (0, $khBmn._)({}, SingleFetchRedirectSymbol, rest[0])
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        var _result_redirect = result.redirect, location = _result_redirect.redirect, revalidate = _result_redirect.revalidate, reload = _result_redirect.reload, replace2 = _result_redirect.replace, status = _result_redirect.status;
        throw redirect(location, {
            status: status,
            headers: (0, $lvTkn._)({}, revalidate ? {
                "X-Remix-Revalidate": "yes"
            } : null, reload ? {
                "X-Remix-Reload-Document": "yes"
            } : null, replace2 ? {
                "X-Remix-Replace": "yes"
            } : null)
        });
    }
    var routeResult = result.routes[routeId];
    if (routeResult == null) throw new SingleFetchNoResultError('No result found for routeId "'.concat(routeId, '"'));
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error('Invalid response found for routeId "'.concat(routeId, '"'));
}
function createDeferred2() {
    var resolve;
    var reject;
    var promise = new Promise(function(res, rej) {
        resolve = function(val) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                var e;
                return (0, $6PS3Z.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            res(val);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        reject = function(error) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                var e;
                return (0, $6PS3Z.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rej(error);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
    });
    return {
        promise: promise,
        //@ts-ignore
        resolve: resolve,
        //@ts-ignore
        reject: reject
    };
}
// lib/dom/ssr/routeModules.ts
function loadRouteModule(route, routeModulesCache) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var routeModule, error;
        return (0, $6PS3Z.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (route.id in routeModulesCache) return [
                        2,
                        routeModulesCache[route.id]
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        import(/* @vite-ignore */ /* webpackIgnore: true */ route.module)
                    ];
                case 2:
                    routeModule = _state.sent();
                    routeModulesCache[route.id] = routeModule;
                    return [
                        2,
                        routeModule
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Error loading route module `".concat(route.module, "`, reloading page..."));
                    console.error(error);
                    if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
                    $9c12a20ed8e485b1$import_meta.hot) throw error;
                    window.location.reload();
                    return [
                        2,
                        new Promise(function() {})
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
// lib/dom/ssr/links.ts
function getKeyedLinksForMatches(matches, routeModules, manifest) {
    var descriptors = matches.map(function(match) {
        var _module_links;
        var module = routeModules[match.route.id];
        var route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map(function(href) {
                return {
                    rel: "stylesheet",
                    href: href
                };
            }) : [],
            (module === null || module === void 0 ? void 0 : (_module_links = module.links) === null || _module_links === void 0 ? void 0 : _module_links.call(module)) || []
        ];
    }).flat(2);
    var preloads = getModuleLinkHrefs(matches, manifest);
    return dedupeLinkDescriptors(descriptors, preloads);
}
function getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map(function(href) {
        return {
            rel: "stylesheet",
            href: href
        };
    });
}
function prefetchRouteCss(route) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var descriptors;
        return (0, $6PS3Z.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.css) return [
                        2
                    ];
                    descriptors = getRouteCssDescriptors(route);
                    return [
                        4,
                        Promise.all(descriptors.map(prefetchStyleLink))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function prefetchStyleLinks(route, routeModule) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var _descriptors, _descriptors1, descriptors, styleLinks, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, descriptor;
        return (0, $6PS3Z.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.css && !routeModule.links || !isPreloadSupported()) return [
                        2
                    ];
                    descriptors = [];
                    if (route.css) (_descriptors = descriptors).push.apply(_descriptors, (0, $6zk1M._)(getRouteCssDescriptors(route)));
                    if (routeModule.links) (_descriptors1 = descriptors).push.apply(_descriptors1, (0, $6zk1M._)(routeModule.links()));
                    if (descriptors.length === 0) return [
                        2
                    ];
                    styleLinks = [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = descriptors[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            descriptor = _step.value;
                            if (!isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push((0, $9Jpjh._)((0, $lvTkn._)({}, descriptor), {
                                rel: "preload",
                                as: "style"
                            }));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        4,
                        Promise.all(styleLinks.map(prefetchStyleLink))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function prefetchStyleLink(descriptor) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        return (0, $6PS3Z.__generator)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve) {
                    var removeLink = function removeLink() {
                        if (document.head.contains(link)) document.head.removeChild(link);
                    };
                    if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector('link[rel="stylesheet"][href="'.concat(descriptor.href, '"]'))) return resolve();
                    var link = document.createElement("link");
                    Object.assign(link, descriptor);
                    link.onload = function() {
                        removeLink();
                        resolve();
                    };
                    link.onerror = function() {
                        removeLink();
                        resolve();
                    };
                    document.head.appendChild(link);
                })
            ];
        });
    })();
}
function isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
function getKeyedPrefetchLinks(matches, manifest, routeModules) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var links;
        return (0, $6PS3Z.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all(matches.map(function(match) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                var route, mod;
                                return (0, $6PS3Z.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            route = manifest.routes[match.route.id];
                                            if (!route) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                loadRouteModule(route, routeModules)
                                            ];
                                        case 1:
                                            mod = _state.sent();
                                            return [
                                                2,
                                                mod.links ? mod.links() : []
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                []
                                            ];
                                    }
                                });
                            })();
                        }))
                    ];
                case 1:
                    links = _state.sent();
                    return [
                        2,
                        dedupeLinkDescriptors(links.flat(1).filter(isHtmlLinkDescriptor).filter(function(link) {
                            return link.rel === "stylesheet" || link.rel === "preload";
                        }).map(function(link) {
                            return link.rel === "stylesheet" ? (0, $9Jpjh._)((0, $lvTkn._)({}, link), {
                                rel: "prefetch",
                                as: "style"
                            }) : (0, $9Jpjh._)((0, $lvTkn._)({}, link), {
                                rel: "prefetch"
                            });
                        }))
                    ];
            }
        });
    })();
}
function getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    var isNew = function(match, index) {
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    var matchPathChanged = function(match, index) {
        var // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        _currentMatches_index_route_path;
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || ((_currentMatches_index_route_path = currentMatches[index].route.path) === null || _currentMatches_index_route_path === void 0 ? void 0 : _currentMatches_index_route_path.endsWith("*")) && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter(function(match, index) {
        return isNew(match, index) || matchPathChanged(match, index);
    });
    if (mode === "data") return nextMatches.filter(function(match, index) {
        var manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            var _currentMatches_;
            var routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: ((_currentMatches_ = currentMatches[0]) === null || _currentMatches_ === void 0 ? void 0 : _currentMatches_.params) || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function getModuleLinkHrefs(matches, manifest) {
    var includeHydrateFallback = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).includeHydrateFallback;
    return dedupeHrefs(matches.map(function(match) {
        var route = manifest.routes[match.route.id];
        if (!route) return [];
        var hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function dedupeHrefs(hrefs) {
    return (0, $6zk1M._)(new Set(hrefs));
}
function sortKeys(obj) {
    var sorted = {};
    var keys = Object.keys(obj).sort();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            sorted[key] = obj[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return sorted;
}
function dedupeLinkDescriptors(descriptors, preloads) {
    var set = /* @__PURE__ */ new Set();
    var preloadsSet = new Set(preloads);
    return descriptors.reduce(function(deduped, descriptor) {
        var alreadyModulePreload = preloads && !isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        var key = JSON.stringify(sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var _isPreloadSupported;
function isPreloadSupported() {
    if (_isPreloadSupported !== void 0) return _isPreloadSupported;
    var el = document.createElement("link");
    _isPreloadSupported = el.relList.supports("preload");
    el = null;
    return _isPreloadSupported;
}
function RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $eHaBZ.createElement(BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, ENABLE_DEV_WARNINGS ? /* @__PURE__ */ $eHaBZ.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: '\n              console.log(\n                "\uD83D\uDCBF Hey developer \uD83D\uDC4B. You can provide a way better UX than this " +\n                "when your app is loading JS modules and/or running `clientLoader` " +\n                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +\n                "for more information."\n              );\n            '
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function groupRoutesByParentId(manifest) {
    var routes = {};
    Object.values(manifest).forEach(function(route) {
        if (route) {
            var parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function getRouteComponents(route, routeModule, isSpaMode) {
    var Component4 = getRouteModuleComponent(routeModule);
    var HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? RemixRootDefaultHydrateFallback : void 0;
    var ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? function() {
        return /* @__PURE__ */ $eHaBZ.createElement(RemixRootDefaultErrorBoundary, {
            error: useRouteError()
        });
    } : void 0;
    if (route.id === "root" && routeModule.Layout) return (0, $lvTkn._)({}, Component4 ? {
        element: /* @__PURE__ */ $eHaBZ.createElement(routeModule.Layout, null, /* @__PURE__ */ $eHaBZ.createElement(Component4, null))
    } : {
        Component: Component4
    }, ErrorBoundary ? {
        errorElement: /* @__PURE__ */ $eHaBZ.createElement(routeModule.Layout, null, /* @__PURE__ */ $eHaBZ.createElement(ErrorBoundary, null))
    } : {
        ErrorBoundary: ErrorBoundary
    }, HydrateFallback ? {
        hydrateFallbackElement: /* @__PURE__ */ $eHaBZ.createElement(routeModule.Layout, null, /* @__PURE__ */ $eHaBZ.createElement(HydrateFallback, null))
    } : {
        HydrateFallback: HydrateFallback
    });
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function createServerRoutes(manifest, routeModules, future, isSpaMode) {
    var parentId = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", routesByParentId = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : groupRoutesByParentId(manifest), spaModeLazyPromise = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : Promise.resolve({
        Component: function() {
            return null;
        }
    });
    return (routesByParentId[parentId] || []).map(function(route) {
        var routeModule = routeModules[route.id];
        invariant2(routeModule, "No `routeModule` available to create server routes");
        var dataRoute = (0, $9Jpjh._)((0, $lvTkn._)({}, getRouteComponents(route, routeModule, isSpaMode)), {
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? function() {
                return spaModeLazyPromise;
            } : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? function() {
                return null;
            } : void 0
        });
        var children = createServerRoutes(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function createClientRoutesWithHMRRevalidationOptOut(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return createClientRoutes(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", groupRoutesByParentId(manifest), needsRevalidation);
}
function preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        var fn = type === "action" ? "serverAction()" : "serverLoader()";
        var msg = "You are trying to call ".concat(fn, " on a route that does not have a server ").concat(type, ' (routeId: "').concat(route.id, '")');
        console.error(msg);
        throw new ErrorResponseImpl(400, "Bad Request", new Error(msg), true);
    }
}
function noActionDefinedError(type, routeId) {
    var article = type === "clientAction" ? "a" : "an";
    var msg = 'Route "'.concat(routeId, '" does not have ').concat(article, " ").concat(type, ", but you are trying to submit to it. To fix this, please add ").concat(article, " `").concat(type, "` function to the route");
    console.error(msg);
    throw new ErrorResponseImpl(405, "Method Not Allowed", new Error(msg), true);
}
function createClientRoutes(manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    var parentId = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", routesByParentId = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : groupRoutesByParentId(manifest), needsRevalidation = arguments.length > 7 ? arguments[7] : void 0;
    return (routesByParentId[parentId] || []).map(function(route) {
        var fetchServerHandler = function fetchServerHandler(singleFetch) {
            invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        };
        var fetchServerLoader = function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        };
        var fetchServerAction = function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw noActionDefinedError("action", route.id);
            return fetchServerHandler(singleFetch);
        };
        var prefetchModule = function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        };
        var prefetchRouteModuleChunks = function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        };
        var prefetchStylesAndCallHandler = function prefetchStylesAndCallHandler(handler) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                var cachedModule, linkPrefetchPromise;
                return (0, $6PS3Z.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            cachedModule = routeModulesCache[route.id];
                            linkPrefetchPromise = cachedModule ? prefetchStyleLinks(route, cachedModule) : Promise.resolve();
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                ,
                                2,
                                4
                            ]);
                            return [
                                2,
                                handler()
                            ];
                        case 2:
                            return [
                                4,
                                linkPrefetchPromise
                            ];
                        case 3:
                            _state.sent();
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        var routeModule = routeModulesCache[route.id];
        var dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            var _initialState_loaderData, _initialState_errors, _routeModule_clientLoader;
            Object.assign(dataRoute, (0, $9Jpjh._)((0, $lvTkn._)({}, dataRoute, getRouteComponents(route, routeModule, isSpaMode)), {
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            }));
            var hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            var initialData = hasInitialData ? initialState === null || initialState === void 0 ? void 0 : (_initialState_loaderData = initialState.loaderData) === null || _initialState_loaderData === void 0 ? void 0 : _initialState_loaderData[route.id] : void 0;
            var hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            var initialError = hasInitialError ? initialState === null || initialState === void 0 ? void 0 : (_initialState_errors = initialState.errors) === null || _initialState_errors === void 0 ? void 0 : _initialState_errors[route.id] : void 0;
            var isHydrationRequest = needsRevalidation == null && (((_routeModule_clientLoader = routeModule.clientLoader) === null || _routeModule_clientLoader === void 0 ? void 0 : _routeModule_clientLoader.hydrate) === true || !route.hasLoader);
            dataRoute.loader = function(param, singleFetch) {
                var request = param.request, params = param.params, context = param.context;
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                    var result;
                    return (0, $6PS3Z.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    ,
                                    2,
                                    3
                                ]);
                                return [
                                    4,
                                    prefetchStylesAndCallHandler(function() {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                            return (0, $6PS3Z.__generator)(this, function(_state) {
                                                invariant2(routeModule, "No `routeModule` available for critical-route loader");
                                                if (!routeModule.clientLoader) return [
                                                    2,
                                                    fetchServerLoader(singleFetch)
                                                ];
                                                return [
                                                    2,
                                                    routeModule.clientLoader({
                                                        request: request,
                                                        params: params,
                                                        context: context,
                                                        serverLoader: function() {
                                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                                                return (0, $6PS3Z.__generator)(this, function(_state) {
                                                                    preventInvalidServerHandlerCall("loader", route);
                                                                    if (isHydrationRequest) {
                                                                        if (hasInitialData) return [
                                                                            2,
                                                                            initialData
                                                                        ];
                                                                        if (hasInitialError) throw initialError;
                                                                    }
                                                                    return [
                                                                        2,
                                                                        fetchServerLoader(singleFetch)
                                                                    ];
                                                                });
                                                            })();
                                                        }
                                                    })
                                                ];
                                            });
                                        })();
                                    })
                                ];
                            case 1:
                                result = _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 2:
                                isHydrationRequest = false;
                                return [
                                    7
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            dataRoute.loader.hydrate = shouldHydrateRouteLoader(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = function(param, singleFetch) {
                var request = param.request, params = param.params, context = param.context;
                return prefetchStylesAndCallHandler(function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                        return (0, $6PS3Z.__generator)(this, function(_state) {
                            invariant2(routeModule, "No `routeModule` available for critical-route action");
                            if (!routeModule.clientAction) {
                                if (isSpaMode) throw noActionDefinedError("clientAction", route.id);
                                return [
                                    2,
                                    fetchServerAction(singleFetch)
                                ];
                            }
                            return [
                                2,
                                routeModule.clientAction({
                                    request: request,
                                    params: params,
                                    context: context,
                                    serverAction: function() {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                            return (0, $6PS3Z.__generator)(this, function(_state) {
                                                preventInvalidServerHandlerCall("action", route);
                                                return [
                                                    2,
                                                    fetchServerAction(singleFetch)
                                                ];
                                            });
                                        })();
                                    }
                                })
                            ];
                        });
                    })();
                });
            };
        } else {
            var getLazyRoute = function getLazyRoute() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                    return (0, $6PS3Z.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!lazyRoutePromise) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    lazyRoutePromise
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                lazyRoutePromise = function() {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                        var routeModulePromise;
                                        return (0, $6PS3Z.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!(route.clientLoaderModule || route.clientActionModule)) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        new Promise(function(resolve) {
                                                            return setTimeout(resolve, 0);
                                                        })
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    _state.label = 2;
                                                case 2:
                                                    routeModulePromise = loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                                                    prefetchRouteModuleChunks(route);
                                                    return [
                                                        4,
                                                        routeModulePromise
                                                    ];
                                                case 3:
                                                    return [
                                                        2,
                                                        _state.sent()
                                                    ];
                                            }
                                        });
                                    })();
                                }();
                                return [
                                    4,
                                    lazyRoutePromise
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            };
            if (!route.hasClientLoader) dataRoute.loader = function(_, singleFetch) {
                return prefetchStylesAndCallHandler(function() {
                    return fetchServerLoader(singleFetch);
                });
            };
            if (!route.hasClientAction) dataRoute.action = function(_, singleFetch) {
                return prefetchStylesAndCallHandler(function() {
                    if (isSpaMode) throw noActionDefinedError("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            };
            var lazyRoutePromise;
            dataRoute.lazy = {
                loader: route.hasClientLoader ? function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                        var clientLoader, _tmp;
                        return (0, $6PS3Z.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!route.clientLoaderModule) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule)
                                    ];
                                case 1:
                                    _tmp = _state.sent();
                                    return [
                                        3,
                                        4
                                    ];
                                case 2:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 3:
                                    _tmp = _state.sent();
                                    _state.label = 4;
                                case 4:
                                    clientLoader = _tmp.clientLoader;
                                    invariant2(clientLoader, "No `clientLoader` export found");
                                    return [
                                        2,
                                        function(args, singleFetch) {
                                            return clientLoader((0, $9Jpjh._)((0, $lvTkn._)({}, args), {
                                                serverLoader: function() {
                                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                                        return (0, $6PS3Z.__generator)(this, function(_state) {
                                                            preventInvalidServerHandlerCall("loader", route);
                                                            return [
                                                                2,
                                                                fetchServerLoader(singleFetch)
                                                            ];
                                                        });
                                                    })();
                                                }
                                            }));
                                        }
                                    ];
                            }
                        });
                    })();
                } : void 0,
                action: route.hasClientAction ? function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                        var clientActionPromise, clientAction;
                        return (0, $6PS3Z.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                                    prefetchRouteModuleChunks(route);
                                    return [
                                        4,
                                        clientActionPromise
                                    ];
                                case 1:
                                    clientAction = _state.sent().clientAction;
                                    invariant2(clientAction, "No `clientAction` export found");
                                    return [
                                        2,
                                        function(args, singleFetch) {
                                            return clientAction((0, $9Jpjh._)((0, $lvTkn._)({}, args), {
                                                serverAction: function() {
                                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                                        return (0, $6PS3Z.__generator)(this, function(_state) {
                                                            preventInvalidServerHandlerCall("action", route);
                                                            return [
                                                                2,
                                                                fetchServerAction(singleFetch)
                                                            ];
                                                        });
                                                    })();
                                                }
                                            }));
                                        }
                                    ];
                            }
                        });
                    })();
                } : void 0,
                middleware: route.hasClientMiddleware ? function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                        var clientMiddleware, _tmp;
                        return (0, $6PS3Z.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!route.clientMiddlewareModule) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule)
                                    ];
                                case 1:
                                    _tmp = _state.sent();
                                    return [
                                        3,
                                        4
                                    ];
                                case 2:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 3:
                                    _tmp = _state.sent();
                                    _state.label = 4;
                                case 4:
                                    clientMiddleware = _tmp.clientMiddleware;
                                    invariant2(clientMiddleware, "No `clientMiddleware` export found");
                                    return [
                                        2,
                                        clientMiddleware
                                    ];
                            }
                        });
                    })();
                } : void 0,
                shouldRevalidate: function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                        var lazyRoute;
                        return (0, $6PS3Z.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 1:
                                    lazyRoute = _state.sent();
                                    return [
                                        2,
                                        getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation)
                                    ];
                            }
                        });
                    })();
                },
                handle: function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                        return (0, $6PS3Z.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent().handle
                                    ];
                            }
                        });
                    })();
                },
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                        return (0, $6PS3Z.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent().Component
                                    ];
                            }
                        });
                    })();
                },
                ErrorBoundary: route.hasErrorBoundary ? function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                        return (0, $6PS3Z.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent().ErrorBoundary
                                    ];
                            }
                        });
                    })();
                } : void 0
            };
        }
        var children = createClientRoutes(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        var myParams = path ? compilePath(path)[1].map(function(p) {
            return p.paramName;
        }) : [];
        var didParamsChange = function(opts) {
            return myParams.some(function(p) {
                return opts.currentParams[p] !== opts.nextParams[p];
            });
        };
        if (route.shouldRevalidate) {
            var fn = route.shouldRevalidate;
            return function(opts) {
                return fn((0, $9Jpjh._)((0, $lvTkn._)({}, opts), {
                    defaultShouldRevalidate: didParamsChange(opts)
                }));
            };
        } else return function(opts) {
            return didParamsChange(opts);
        };
    }
    if (ssr && route.shouldRevalidate) {
        var fn1 = route.shouldRevalidate;
        return function(opts) {
            return fn1((0, $9Jpjh._)((0, $lvTkn._)({}, opts), {
                defaultShouldRevalidate: true
            }));
        };
    }
    return route.shouldRevalidate;
}
function wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    var handledRevalidation = false;
    return function(arg) {
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
function loadRouteModuleWithBlockingLinks(route, routeModules) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var routeModulePromise, prefetchRouteCssPromise, routeModule;
        return (0, $6PS3Z.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    routeModulePromise = loadRouteModule(route, routeModules);
                    prefetchRouteCssPromise = prefetchRouteCss(route);
                    return [
                        4,
                        routeModulePromise
                    ];
                case 1:
                    routeModule = _state.sent();
                    return [
                        4,
                        Promise.all([
                            prefetchRouteCssPromise,
                            prefetchStyleLinks(route, routeModule)
                        ])
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        {
                            Component: getRouteModuleComponent(routeModule),
                            ErrorBoundary: routeModule.ErrorBoundary,
                            clientMiddleware: routeModule.clientMiddleware,
                            clientAction: routeModule.clientAction,
                            clientLoader: routeModule.clientLoader,
                            handle: routeModule.handle,
                            links: routeModule.links,
                            meta: routeModule.meta,
                            shouldRevalidate: routeModule.shouldRevalidate
                        }
                    ];
            }
        });
    })();
}
function getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    var isEmptyObject = (0, $2bfPH._)(routeModule.default) === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function shouldHydrateRouteLoader(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var nextPaths = /* @__PURE__ */ new Set();
var discoveredPathsMaxSize = 1e3;
var discoveredPaths = /* @__PURE__ */ new Set();
var URL_LIMIT = 7680;
function isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function getPartialManifest(_param, router) {
    var sri = _param.sri, manifest = (0, $aRv4I._)(_param, [
        "sri"
    ]);
    var routeIds = new Set(router.state.matches.map(function(m) {
        return m.route.id;
    }));
    var segments = router.state.location.pathname.split("/").filter(Boolean);
    var paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push("/".concat(segments.join("/")));
        segments.pop();
    }
    paths.forEach(function(path) {
        var matches = matchRoutes(router.routes, path, router.basename);
        if (matches) matches.forEach(function(m) {
            return routeIds.add(m.route.id);
        });
    });
    var initialRoutes = (0, $6zk1M._)(routeIds).reduce(function(acc, id) {
        return Object.assign(acc, (0, $khBmn._)({}, id, manifest.routes[id]));
    }, {});
    return (0, $9Jpjh._)((0, $lvTkn._)({}, manifest), {
        routes: initialRoutes,
        sri: sri ? true : void 0
    });
}
function getPatchRoutesOnNavigationFunction(manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return function(param) {
        var path = param.path, patch = param.patch, signal = param.signal, fetcherKey = param.fetcherKey;
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (discoveredPaths.has(path)) return [
                            2
                        ];
                        return [
                            4,
                            fetchAndApplyManifestPatches([
                                path
                            ], fetcherKey ? window.location.href : path, manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
}
function useFogOFWarDiscovery(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $eHaBZ.useEffect(function() {
        var registerElement = function registerElement(el) {
            var path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            var pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!discoveredPaths.has(pathname)) nextPaths.add(pathname);
        };
        var fetchPatches = function fetchPatches() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                var lazyPaths, e;
                return (0, $6PS3Z.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
                            lazyPaths = Array.from(nextPaths.keys()).filter(function(path) {
                                if (discoveredPaths.has(path)) {
                                    nextPaths.delete(path);
                                    return false;
                                }
                                return true;
                            });
                            if (lazyPaths.length === 0) return [
                                2
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            console.error("Failed to fetch manifest patches", e);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        var // @ts-expect-error - TS doesn't know about this yet
        _window_navigator_connection, _window_navigator;
        if (!isFogOfWarEnabled(routeDiscovery, ssr) || ((_window_navigator = window.navigator) === null || _window_navigator === void 0 ? void 0 : (_window_navigator_connection = _window_navigator.connection) === null || _window_navigator_connection === void 0 ? void 0 : _window_navigator_connection.saveData) === true) return;
        var debouncedFetchPatches = debounce(fetchPatches, 100);
        fetchPatches();
        var observer = new MutationObserver(function() {
            return debouncedFetchPatches();
        });
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return function() {
            return observer.disconnect();
        };
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function getManifestPath(_manifestPath, basename) {
    var manifestPath = _manifestPath || "/__manifest";
    if (basename == null) return manifestPath;
    return "".concat(basename).concat(manifestPath).replace(/\/+/g, "/");
}
var MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
function fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
        var searchParams, url, serverPatches, res, _, e, knownRoutes, patches, parentIds;
        return (0, $6PS3Z.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    searchParams = new URLSearchParams();
                    searchParams.set("paths", paths.sort().join(","));
                    searchParams.set("version", manifest.version);
                    url = new URL(getManifestPath(manifestPath, basename), window.location.origin);
                    url.search = searchParams.toString();
                    if (url.toString().length > URL_LIMIT) {
                        nextPaths.clear();
                        return [
                            2
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        9,
                        ,
                        10
                    ]);
                    return [
                        4,
                        fetch(url, {
                            signal: signal
                        })
                    ];
                case 2:
                    res = _state.sent();
                    if (!!res.ok) return [
                        3,
                        3
                    ];
                    throw new Error("".concat(res.status, " ").concat(res.statusText));
                case 3:
                    if (!(res.status === 204 && res.headers.has("X-Remix-Reload-Document"))) return [
                        3,
                        5
                    ];
                    if (!errorReloadPath) {
                        console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                        return [
                            2
                        ];
                    }
                    try {
                        if (sessionStorage.getItem(MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                            console.error("Unable to discover routes due to manifest version mismatch.");
                            return [
                                2
                            ];
                        }
                        sessionStorage.setItem(MANIFEST_VERSION_STORAGE_KEY, manifest.version);
                    } catch (e) {}
                    window.location.href = errorReloadPath;
                    console.warn("Detected manifest version mismatch, reloading...");
                    return [
                        4,
                        new Promise(function() {})
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        7
                    ];
                case 5:
                    if (!(res.status >= 400)) return [
                        3,
                        7
                    ];
                    _ = Error.bind;
                    return [
                        4,
                        res.text()
                    ];
                case 6:
                    throw new (_.apply(Error, [
                        void 0,
                        _state.sent()
                    ]));
                case 7:
                    try {
                        sessionStorage.removeItem(MANIFEST_VERSION_STORAGE_KEY);
                    } catch (e) {}
                    return [
                        4,
                        res.json()
                    ];
                case 8:
                    serverPatches = _state.sent();
                    return [
                        3,
                        10
                    ];
                case 9:
                    e = _state.sent();
                    if (signal === null || signal === void 0 ? void 0 : signal.aborted) return [
                        2
                    ];
                    throw e;
                case 10:
                    knownRoutes = new Set(Object.keys(manifest.routes));
                    patches = Object.values(serverPatches).reduce(function(acc, route) {
                        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
                        return acc;
                    }, {});
                    Object.assign(manifest.routes, patches);
                    paths.forEach(function(p) {
                        return addToFifoQueue(p, discoveredPaths);
                    });
                    parentIds = /* @__PURE__ */ new Set();
                    Object.values(patches).forEach(function(patch) {
                        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
                    });
                    parentIds.forEach(function(parentId) {
                        return patchRoutes(parentId || null, createClientRoutes(patches, routeModules, null, ssr, isSpaMode, parentId));
                    });
                    return [
                        2
                    ];
            }
        });
    })();
}
function addToFifoQueue(path, queue) {
    if (queue.size >= discoveredPathsMaxSize) {
        var first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function debounce(callback, wait) {
    var timeoutId;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(function() {
            return callback.apply(void 0, (0, $6zk1M._)(args));
        }, wait);
    };
}
// lib/dom/ssr/components.tsx
function useDataRouterContext2() {
    var context = $eHaBZ.useContext(DataRouterContext);
    invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function useDataRouterStateContext() {
    var context = $eHaBZ.useContext(DataRouterStateContext);
    invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var FrameworkContext = $eHaBZ.createContext(void 0);
FrameworkContext.displayName = "FrameworkContext";
function useFrameworkContext() {
    var context = $eHaBZ.useContext(FrameworkContext);
    invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function usePrefetchBehavior(prefetch, theirElementProps) {
    var frameworkContext = $eHaBZ.useContext(FrameworkContext);
    var _React8_useState = (0, $21h22._)($eHaBZ.useState(false), 2), maybePrefetch = _React8_useState[0], setMaybePrefetch = _React8_useState[1];
    var _React8_useState1 = (0, $21h22._)($eHaBZ.useState(false), 2), shouldPrefetch = _React8_useState1[0], setShouldPrefetch = _React8_useState1[1];
    var onFocus = theirElementProps.onFocus, onBlur = theirElementProps.onBlur, onMouseEnter = theirElementProps.onMouseEnter, onMouseLeave = theirElementProps.onMouseLeave, onTouchStart = theirElementProps.onTouchStart;
    var ref = $eHaBZ.useRef(null);
    $eHaBZ.useEffect(function() {
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            var callback = function(entries) {
                entries.forEach(function(entry) {
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            var observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return function() {
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $eHaBZ.useEffect(function() {
        if (maybePrefetch) {
            var id = setTimeout(function() {
                setShouldPrefetch(true);
            }, 100);
            return function() {
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    var setIntent = function() {
        setMaybePrefetch(true);
    };
    var cancelIntent = function() {
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: composeEventHandlers(onFocus, setIntent),
            onBlur: composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function composeEventHandlers(theirHandler, ourHandler) {
    return function(event) {
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !isHydrated) return [
        matches[0]
    ];
    if (errors) {
        var errorIdx = matches.findIndex(function(m) {
            return errors[m.route.id] !== void 0;
        });
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var CRITICAL_CSS_DATA_ATTRIBUTE = "data-react-router-critical-css";
function Links(param) {
    var nonce = param.nonce;
    var _useFrameworkContext = useFrameworkContext(), isSpaMode = _useFrameworkContext.isSpaMode, manifest = _useFrameworkContext.manifest, routeModules = _useFrameworkContext.routeModules, criticalCss = _useFrameworkContext.criticalCss;
    var _useDataRouterStateContext = useDataRouterStateContext(), errors = _useDataRouterStateContext.errors, routerMatches = _useDataRouterStateContext.matches;
    var matches = getActiveMatches(routerMatches, errors, isSpaMode);
    var keyedLinks = $eHaBZ.useMemo(function() {
        return getKeyedLinksForMatches(matches, routeModules, manifest);
    }, [
        matches,
        routeModules,
        manifest
    ]);
    var _obj, _obj1;
    return /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $eHaBZ.createElement("style", (_obj = {}, (0, $khBmn._)(_obj, CRITICAL_CSS_DATA_ATTRIBUTE, ""), (0, $khBmn._)(_obj, "dangerouslySetInnerHTML", {
        __html: criticalCss
    }), _obj)) : null, (typeof criticalCss === "undefined" ? "undefined" : (0, $2bfPH._)(criticalCss)) === "object" ? /* @__PURE__ */ $eHaBZ.createElement("link", (_obj1 = {}, (0, $khBmn._)(_obj1, CRITICAL_CSS_DATA_ATTRIBUTE, ""), (0, $khBmn._)(_obj1, "rel", "stylesheet"), (0, $khBmn._)(_obj1, "href", criticalCss.href), (0, $khBmn._)(_obj1, "nonce", nonce), _obj1)) : null, keyedLinks.map(function(param) {
        var key = param.key, link = param.link;
        return isPageLinkDescriptor(link) ? /* @__PURE__ */ $eHaBZ.createElement(PrefetchPageLinks, (0, $lvTkn._)({
            key: key,
            nonce: nonce
        }, link)) : /* @__PURE__ */ $eHaBZ.createElement("link", (0, $lvTkn._)({
            key: key,
            nonce: nonce
        }, link));
    }));
}
function PrefetchPageLinks(_param) {
    var page = _param.page, linkProps = (0, $aRv4I._)(_param, [
        "page"
    ]);
    var router = useDataRouterContext2().router;
    var matches = $eHaBZ.useMemo(function() {
        return matchRoutes(router.routes, page, router.basename);
    }, [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $eHaBZ.createElement(PrefetchPageLinksImpl, (0, $lvTkn._)({
        page: page,
        matches: matches
    }, linkProps));
}
function useKeyedPrefetchLinks(matches) {
    var _useFrameworkContext = useFrameworkContext(), manifest = _useFrameworkContext.manifest, routeModules = _useFrameworkContext.routeModules;
    var _React8_useState = (0, $21h22._)($eHaBZ.useState([]), 2), keyedPrefetchLinks = _React8_useState[0], setKeyedPrefetchLinks = _React8_useState[1];
    $eHaBZ.useEffect(function() {
        var interrupted = false;
        getKeyedPrefetchLinks(matches, manifest, routeModules).then(function(links) {
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return function() {
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function PrefetchPageLinksImpl(_param) {
    var page = _param.page, nextMatches = _param.matches, linkProps = (0, $aRv4I._)(_param, [
        "page",
        "matches"
    ]);
    var location = useLocation();
    var _useFrameworkContext = useFrameworkContext(), manifest = _useFrameworkContext.manifest, routeModules = _useFrameworkContext.routeModules;
    var basename = useDataRouterContext2().basename;
    var _useDataRouterStateContext = useDataRouterStateContext(), loaderData = _useDataRouterStateContext.loaderData, matches = _useDataRouterStateContext.matches;
    var newMatchesForData = $eHaBZ.useMemo(function() {
        return getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data");
    }, [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    var newMatchesForAssets = $eHaBZ.useMemo(function() {
        return getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets");
    }, [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    var dataHrefs = $eHaBZ.useMemo(function() {
        if (page === location.pathname + location.search + location.hash) return [];
        var routesParams = /* @__PURE__ */ new Set();
        var foundOptOutRoute = false;
        nextMatches.forEach(function(m) {
            var _routeModules_m_route_id;
            var manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some(function(m2) {
                return m2.route.id === m.route.id;
            }) && m.route.id in loaderData && ((_routeModules_m_route_id = routeModules[m.route.id]) === null || _routeModules_m_route_id === void 0 ? void 0 : _routeModules_m_route_id.shouldRevalidate)) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        var url = singleFetchUrl(page, basename, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter(function(m) {
            return routesParams.has(m.route.id);
        }).map(function(m) {
            return m.route.id;
        }).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    var moduleHrefs = $eHaBZ.useMemo(function() {
        return getModuleLinkHrefs(newMatchesForAssets, manifest);
    }, [
        newMatchesForAssets,
        manifest
    ]);
    var keyedPrefetchLinks = useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, dataHrefs.map(function(href) {
        return /* @__PURE__ */ $eHaBZ.createElement("link", (0, $lvTkn._)({
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href
        }, linkProps));
    }), moduleHrefs.map(function(href) {
        return /* @__PURE__ */ $eHaBZ.createElement("link", (0, $lvTkn._)({
            key: href,
            rel: "modulepreload",
            href: href
        }, linkProps));
    }), keyedPrefetchLinks.map(function(param) {
        var key = param.key, link = param.link;
        return(// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $eHaBZ.createElement("link", (0, $lvTkn._)({
            key: key,
            nonce: linkProps.nonce
        }, link)));
    }));
}
function Meta() {
    var _useFrameworkContext = useFrameworkContext(), isSpaMode = _useFrameworkContext.isSpaMode, routeModules = _useFrameworkContext.routeModules;
    var _useDataRouterStateContext = useDataRouterStateContext(), errors = _useDataRouterStateContext.errors, routerMatches = _useDataRouterStateContext.matches, loaderData = _useDataRouterStateContext.loaderData;
    var location = useLocation();
    var _matches = getActiveMatches(routerMatches, errors, isSpaMode);
    var error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    var meta = [];
    var leafMeta = null;
    var matches = [];
    for(var i = 0; i < _matches.length; i++){
        var _match = _matches[i];
        var routeId = _match.route.id;
        var data2 = loaderData[routeId];
        var params = _match.params;
        var routeModule = routeModules[routeId];
        var routeMeta = [];
        var match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule === null || routeModule === void 0 ? void 0 : routeModule.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? (0, $6zk1M._)(routeModule.meta) : routeModule.meta;
        else if (leafMeta) routeMeta = (0, $6zk1M._)(leafMeta);
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = (0, $6zk1M._)(routeMeta);
        leafMeta = meta;
    }
    return /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, meta.flat().map(function(metaProps) {
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            var tagName = metaProps.tagName, rest = (0, $aRv4I._)(metaProps, [
                "tagName"
            ]);
            if (!isValidMetaTag(tagName)) {
                console.warn("A meta object uses an invalid tagName: ".concat(tagName, ". Expected either 'link' or 'meta'"));
                return null;
            }
            var Comp = tagName;
            return /* @__PURE__ */ $eHaBZ.createElement(Comp, (0, $lvTkn._)({
                key: JSON.stringify(rest)
            }, rest));
        }
        if ("title" in metaProps) return /* @__PURE__ */ $eHaBZ.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            var _metaProps_charSet;
            (_metaProps_charSet = metaProps.charSet) !== null && _metaProps_charSet !== void 0 ? _metaProps_charSet : metaProps.charSet = metaProps.charset;
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $eHaBZ.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            var json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $eHaBZ.createElement("script", {
                key: "script:ld+json:".concat(json),
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: escapeHtml(json)
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $eHaBZ.createElement("meta", (0, $lvTkn._)({
            key: JSON.stringify(metaProps)
        }, metaProps));
    }));
}
function isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var isHydrated = false;
function setIsHydrated() {
    isHydrated = true;
}
function Scripts(scriptProps) {
    var _useFrameworkContext = useFrameworkContext(), manifest = _useFrameworkContext.manifest, serverHandoffString = _useFrameworkContext.serverHandoffString, isSpaMode = _useFrameworkContext.isSpaMode, renderMeta = _useFrameworkContext.renderMeta, routeDiscovery = _useFrameworkContext.routeDiscovery, ssr = _useFrameworkContext.ssr;
    var _useDataRouterContext2 = useDataRouterContext2(), router = _useDataRouterContext2.router, isStatic = _useDataRouterContext2.static, staticContext = _useDataRouterContext2.staticContext;
    var _useDataRouterStateContext = useDataRouterStateContext(), routerMatches = _useDataRouterStateContext.matches;
    var isRSCRouterContext = useIsRSCRouterContext();
    var enableFogOfWar = isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    var matches = getActiveMatches(routerMatches, null, isSpaMode);
    $eHaBZ.useEffect(function() {
        setIsHydrated();
    }, []);
    var initialScripts = $eHaBZ.useMemo(function() {
        var _manifest_hmr;
        if (isRSCRouterContext) return null;
        var streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        var contextScript = staticContext ? "window.__reactRouterContext = ".concat(serverHandoffString, ";").concat(streamScript) : " ";
        var routeModulesScript = !isStatic ? " " : "".concat(((_manifest_hmr = manifest.hmr) === null || _manifest_hmr === void 0 ? void 0 : _manifest_hmr.runtime) ? "import ".concat(JSON.stringify(manifest.hmr.runtime), ";") : "").concat(!enableFogOfWar ? "import ".concat(JSON.stringify(manifest.url)) : "", ";\n").concat(matches.map(function(match, routeIndex) {
            var routeVarName = "route".concat(routeIndex);
            var manifestEntry = manifest.routes[match.route.id];
            invariant2(manifestEntry, "Route ".concat(match.route.id, " not found in manifest"));
            var clientActionModule = manifestEntry.clientActionModule, clientLoaderModule = manifestEntry.clientLoaderModule, clientMiddlewareModule = manifestEntry.clientMiddlewareModule, hydrateFallbackModule = manifestEntry.hydrateFallbackModule, module = manifestEntry.module;
            var chunks = (0, $6zk1M._)(clientActionModule ? [
                {
                    module: clientActionModule,
                    varName: "".concat(routeVarName, "_clientAction")
                }
            ] : []).concat((0, $6zk1M._)(clientLoaderModule ? [
                {
                    module: clientLoaderModule,
                    varName: "".concat(routeVarName, "_clientLoader")
                }
            ] : []), (0, $6zk1M._)(clientMiddlewareModule ? [
                {
                    module: clientMiddlewareModule,
                    varName: "".concat(routeVarName, "_clientMiddleware")
                }
            ] : []), (0, $6zk1M._)(hydrateFallbackModule ? [
                {
                    module: hydrateFallbackModule,
                    varName: "".concat(routeVarName, "_HydrateFallback")
                }
            ] : []), [
                {
                    module: module,
                    varName: "".concat(routeVarName, "_main")
                }
            ]);
            if (chunks.length === 1) return "import * as ".concat(routeVarName, " from ").concat(JSON.stringify(module), ";");
            var chunkImportsSnippet = chunks.map(function(chunk) {
                return "import * as ".concat(chunk.varName, ' from "').concat(chunk.module, '";');
            }).join("\n");
            var mergedChunksSnippet = "const ".concat(routeVarName, " = {").concat(chunks.map(function(chunk) {
                return "...".concat(chunk.varName);
            }).join(","), "};");
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n"), "\n  ").concat(enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        "window.__reactRouterManifest = ".concat(JSON.stringify(getPartialManifest(manifest, router), null, 2), ";") : "", "\n  window.__reactRouterRouteModules = {").concat(matches.map(function(match, index) {
            return "".concat(JSON.stringify(match.route.id), ":route").concat(index);
        }).join(","), "};\n\nimport(").concat(JSON.stringify(manifest.entry.module), ");");
        return /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, /* @__PURE__ */ $eHaBZ.createElement("script", (0, $9Jpjh._)((0, $lvTkn._)({}, scriptProps), {
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        })), /* @__PURE__ */ $eHaBZ.createElement("script", (0, $9Jpjh._)((0, $lvTkn._)({}, scriptProps), {
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        })));
    }, []);
    var preloads = isHydrated || isRSCRouterContext ? [] : dedupe(manifest.entry.imports.concat(getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    var sri = (0, $2bfPH._)(manifest.sri) === "object" ? manifest.sri : {};
    warnOnce(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, (0, $2bfPH._)(manifest.sri) === "object" ? /* @__PURE__ */ $eHaBZ.createElement("script", {
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $eHaBZ.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $eHaBZ.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map(function(path) {
        return /* @__PURE__ */ $eHaBZ.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        });
    }), initialScripts);
}
function dedupe(array) {
    return (0, $6zk1M._)(new Set(array));
}
function mergeRefs() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var RemixErrorBoundary = /*#__PURE__*/ function(_React9_Component) {
    "use strict";
    (0, $NBk0Y._)(RemixErrorBoundary, _React9_Component);
    function RemixErrorBoundary(props) {
        (0, $gd0sY._)(this, RemixErrorBoundary);
        var _this;
        _this = (0, $8xMIM._)(this, RemixErrorBoundary, [
            props
        ]);
        _this.state = {
            error: props.error || null,
            location: props.location
        };
        return _this;
    }
    (0, $7cSld._)(RemixErrorBoundary, [
        {
            key: "render",
            value: function render() {
                if (this.state.error) return /* @__PURE__ */ $eHaBZ.createElement(RemixRootDefaultErrorBoundary, {
                    error: this.state.error,
                    isOutsideRemixApp: true
                });
                else return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                if (state.location !== props.location) return {
                    error: props.error || null,
                    location: props.location
                };
                return {
                    error: props.error || state.error,
                    location: state.location
                };
            }
        }
    ]);
    return RemixErrorBoundary;
}($eHaBZ.Component);
function RemixRootDefaultErrorBoundary(param) {
    var error = param.error, isOutsideRemixApp = param.isOutsideRemixApp;
    console.error(error);
    var heyDeveloper = /* @__PURE__ */ $eHaBZ.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: '\n        console.log(\n          "\uD83D\uDCBF Hey developer \uD83D\uDC4B. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."\n        );\n      '
        }
    });
    if (isRouteErrorResponse(error)) return /* @__PURE__ */ $eHaBZ.createElement(BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $eHaBZ.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), ENABLE_DEV_WARNINGS ? heyDeveloper : null);
    var errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        var errorString = error == null ? "Unknown Error" : (typeof error === "undefined" ? "undefined" : (0, $2bfPH._)(error)) === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $eHaBZ.createElement(BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $eHaBZ.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $eHaBZ.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function BoundaryShell(param) {
    var title = param.title, renderScripts = param.renderScripts, isOutsideRemixApp = param.isOutsideRemixApp, children = param.children;
    var _routeModules_root;
    var routeModules = useFrameworkContext().routeModules;
    if (((_routeModules_root = routeModules.root) === null || _routeModules_root === void 0 ? void 0 : _routeModules_root.Layout) && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $eHaBZ.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $eHaBZ.createElement("head", null, /* @__PURE__ */ $eHaBZ.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $eHaBZ.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $eHaBZ.createElement("title", null, title)), /* @__PURE__ */ $eHaBZ.createElement("body", null, /* @__PURE__ */ $eHaBZ.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $eHaBZ.createElement(Scripts, null) : null)));
}
var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if (isBrowser) window.__reactRouterVersion = "7.9.4";
} catch (e) {}
function createBrowserRouter(routes, opts) {
    return createRouter({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: createBrowserHistory({
            window: opts === null || opts === void 0 ? void 0 : opts.window
        }),
        hydrationData: (opts === null || opts === void 0 ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes: routes,
        mapRouteProperties: mapRouteProperties,
        hydrationRouteProperties: hydrationRouteProperties,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        window: opts === null || opts === void 0 ? void 0 : opts.window
    }).initialize();
}
function createHashRouter(routes, opts) {
    return createRouter({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: createHashHistory({
            window: opts === null || opts === void 0 ? void 0 : opts.window
        }),
        hydrationData: (opts === null || opts === void 0 ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes: routes,
        mapRouteProperties: mapRouteProperties,
        hydrationRouteProperties: hydrationRouteProperties,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        window: opts === null || opts === void 0 ? void 0 : opts.window
    }).initialize();
}
function parseHydrationData() {
    var _window;
    var state = (_window = window) === null || _window === void 0 ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = (0, $9Jpjh._)((0, $lvTkn._)({}, state), {
        errors: deserializeErrors(state.errors)
    });
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $21h22._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new ErrorResponseImpl(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        var error = new ErrorConstructor(val.message);
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {}
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
function BrowserRouter(param) {
    var basename = param.basename, children = param.children, window2 = param.window;
    var historyRef = $eHaBZ.useRef();
    if (historyRef.current == null) historyRef.current = createBrowserHistory({
        window: window2,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React10_useState = (0, $21h22._)($eHaBZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React10_useState[0], setStateImpl = _React10_useState[1];
    var setState = $eHaBZ.useCallback(function(newState) {
        $eHaBZ.startTransition(function() {
            return setStateImpl(newState);
        });
    }, [
        setStateImpl
    ]);
    $eHaBZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /* @__PURE__ */ $eHaBZ.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function HashRouter(param) {
    var basename = param.basename, children = param.children, window2 = param.window;
    var historyRef = $eHaBZ.useRef();
    if (historyRef.current == null) historyRef.current = createHashHistory({
        window: window2,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React10_useState = (0, $21h22._)($eHaBZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React10_useState[0], setStateImpl = _React10_useState[1];
    var setState = $eHaBZ.useCallback(function(newState) {
        $eHaBZ.startTransition(function() {
            return setStateImpl(newState);
        });
    }, [
        setStateImpl
    ]);
    $eHaBZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /* @__PURE__ */ $eHaBZ.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function HistoryRouter(param) {
    var basename = param.basename, children = param.children, history = param.history;
    var _React10_useState = (0, $21h22._)($eHaBZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React10_useState[0], setStateImpl = _React10_useState[1];
    var setState = $eHaBZ.useCallback(function(newState) {
        $eHaBZ.startTransition(function() {
            return setStateImpl(newState);
        });
    }, [
        setStateImpl
    ]);
    $eHaBZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /* @__PURE__ */ $eHaBZ.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
HistoryRouter.displayName = "unstable_HistoryRouter";
var ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var Link = $eHaBZ.forwardRef(function LinkWithRef(_param, forwardedRef) {
    var onClick = _param.onClick, _param_discover = _param.discover, discover = _param_discover === void 0 ? "render" : _param_discover, _param_prefetch = _param.prefetch, prefetch = _param_prefetch === void 0 ? "none" : _param_prefetch, relative = _param.relative, reloadDocument = _param.reloadDocument, replace2 = _param.replace, state = _param.state, target = _param.target, to = _param.to, preventScrollReset = _param.preventScrollReset, viewTransition = _param.viewTransition, rest = (0, $aRv4I._)(_param, [
        "onClick",
        "discover",
        "prefetch",
        "relative",
        "reloadDocument",
        "replace",
        "state",
        "target",
        "to",
        "preventScrollReset",
        "viewTransition"
    ]);
    var basename = $eHaBZ.useContext(NavigationContext).basename;
    var isAbsolute = typeof to === "string" && ABSOLUTE_URL_REGEX2.test(to);
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && isAbsolute) {
        absoluteHref = to;
        if (isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = stripBasename(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            warning(false, '<Link to="'.concat(to, '"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.'));
        }
    }
    var href = useHref(to, {
        relative: relative
    });
    var _usePrefetchBehavior = (0, $21h22._)(usePrefetchBehavior(prefetch, rest), 3), shouldPrefetch = _usePrefetchBehavior[0], prefetchRef = _usePrefetchBehavior[1], prefetchHandlers = _usePrefetchBehavior[2];
    var internalOnClick = useLinkClickHandler(to, {
        replace: replace2,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    var link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $eHaBZ.createElement("a", (0, $9Jpjh._)((0, $lvTkn._)({}, rest, prefetchHandlers), {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    }));
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, link, /* @__PURE__ */ $eHaBZ.createElement(PrefetchPageLinks, {
        page: href
    })) : link;
});
Link.displayName = "Link";
var NavLink = $eHaBZ.forwardRef(function NavLinkWithRef(_param, ref) {
    var tmp = _param["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _param_caseSensitive = _param.caseSensitive, caseSensitive = _param_caseSensitive === void 0 ? false : _param_caseSensitive, tmp1 = _param.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _param_end = _param.end, end = _param_end === void 0 ? false : _param_end, styleProp = _param.style, to = _param.to, viewTransition = _param.viewTransition, children = _param.children, rest = (0, $aRv4I._)(_param, [
        "aria-current",
        "caseSensitive",
        "className",
        "end",
        "style",
        "to",
        "viewTransition",
        "children"
    ]);
    var path = useResolvedPath(to, {
        relative: rest.relative
    });
    var location = useLocation();
    var routerState = $eHaBZ.useContext(DataRouterStateContext);
    var _React10_useContext = $eHaBZ.useContext(NavigationContext), navigator = _React10_useContext.navigator, basename = _React10_useContext.basename;
    var isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useViewTransitionState(path) && viewTransition === true;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = stripBasename(nextLocationPathname, basename) || nextLocationPathname;
    var endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : void 0;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $eHaBZ.createElement(Link, (0, $9Jpjh._)((0, $lvTkn._)({}, rest), {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
NavLink.displayName = "NavLink";
var Form = $eHaBZ.forwardRef(function(_param, forwardedRef) {
    var _param_discover = _param.discover, discover = _param_discover === void 0 ? "render" : _param_discover, fetcherKey = _param.fetcherKey, navigate = _param.navigate, reloadDocument = _param.reloadDocument, replace2 = _param.replace, state = _param.state, _param_method = _param.method, method = _param_method === void 0 ? defaultMethod : _param_method, action = _param.action, onSubmit = _param.onSubmit, relative = _param.relative, preventScrollReset = _param.preventScrollReset, viewTransition = _param.viewTransition, props = (0, $aRv4I._)(_param, [
        "discover",
        "fetcherKey",
        "navigate",
        "reloadDocument",
        "replace",
        "state",
        "method",
        "action",
        "onSubmit",
        "relative",
        "preventScrollReset",
        "viewTransition"
    ]);
    var submit = useSubmit();
    var formAction = useFormAction(action, {
        relative: relative
    });
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var isAbsolute = typeof action === "string" && ABSOLUTE_URL_REGEX2.test(action);
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace2,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /* @__PURE__ */ $eHaBZ.createElement("form", (0, $9Jpjh._)((0, $lvTkn._)({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props), {
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    }));
});
Form.displayName = "Form";
function ScrollRestoration(_param) {
    var getKey = _param.getKey, storageKey = _param.storageKey, props = (0, $aRv4I._)(_param, [
        "getKey",
        "storageKey"
    ]);
    var remixContext = $eHaBZ.useContext(FrameworkContext);
    var basename = $eHaBZ.useContext(NavigationContext).basename;
    var location = useLocation();
    var matches = useMatches();
    useScrollRestoration({
        getKey: getKey,
        storageKey: storageKey
    });
    var ssrKey = $eHaBZ.useMemo(function() {
        if (!remixContext || !getKey) return null;
        var userKey = getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    var restoreScroll = (function(storageKey2, restoreKey) {
        if (!window.history.state || !window.history.state.key) {
            var key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            var positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            var storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $eHaBZ.createElement("script", (0, $9Jpjh._)((0, $lvTkn._)({}, props), {
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: "(".concat(restoreScroll, ")(").concat(JSON.stringify(storageKey || SCROLL_RESTORATION_STORAGE_KEY), ", ").concat(JSON.stringify(ssrKey), ")")
        }
    }));
}
ScrollRestoration.displayName = "ScrollRestoration";
function getDataRouterConsoleError2(hookName) {
    return "".concat(hookName, " must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.");
}
function useDataRouterContext3(hookName) {
    var ctx = $eHaBZ.useContext(DataRouterContext);
    invariant(ctx, getDataRouterConsoleError2(hookName));
    return ctx;
}
function useDataRouterState2(hookName) {
    var state = $eHaBZ.useContext(DataRouterStateContext);
    invariant(state, getDataRouterConsoleError2(hookName));
    return state;
}
function useLinkClickHandler(to) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, viewTransition = _ref.viewTransition;
    var navigate = useNavigate();
    var location = useLocation();
    var path = useResolvedPath(to, {
        relative: relative
    });
    return $eHaBZ.useCallback(function(event) {
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            var replace2 = replaceProp !== void 0 ? replaceProp : createPath(location) === createPath(path);
            navigate(to, {
                replace: replace2,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
function useSearchParams(defaultInit) {
    warning(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
    var defaultSearchParamsRef = $eHaBZ.useRef(createSearchParams(defaultInit));
    var hasSetSearchParamsRef = $eHaBZ.useRef(false);
    var location = useLocation();
    var searchParams = $eHaBZ.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = useNavigate();
    var setSearchParams = $eHaBZ.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var fetcherId = 0;
var getUniqueFetcherId = function() {
    return "__".concat(String(++fetcherId), "__");
};
function useSubmit() {
    var router = useDataRouterContext3("useSubmit" /* UseSubmit */ ).router;
    var basename = $eHaBZ.useContext(NavigationContext).basename;
    var currentRouteId = useRouteId();
    return $eHaBZ.useCallback(function(target) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var _getFormSubmissionInfo, action, method, encType, formData, body, key;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _getFormSubmissionInfo = getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
                        if (!(options.navigate === false)) return [
                            3,
                            2
                        ];
                        key = options.fetcherKey || getUniqueFetcherId();
                        return [
                            4,
                            router.fetch(key, currentRouteId, options.action || action, {
                                preventScrollReset: options.preventScrollReset,
                                formData: formData,
                                body: body,
                                formMethod: options.method || method,
                                formEncType: options.encType || encType,
                                flushSync: options.flushSync
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            router.navigate(options.action || action, {
                                preventScrollReset: options.preventScrollReset,
                                formData: formData,
                                body: body,
                                formMethod: options.method || method,
                                formEncType: options.encType || encType,
                                replace: options.replace,
                                state: options.state,
                                fromRouteId: currentRouteId,
                                flushSync: options.flushSync,
                                viewTransition: options.viewTransition
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
function useFormAction(action) {
    var relative = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).relative;
    var basename = $eHaBZ.useContext(NavigationContext).basename;
    var routeContext = $eHaBZ.useContext(RouteContext);
    invariant(routeContext, "useFormAction must be used inside a RouteContext");
    var _routeContext_matches_slice = (0, $21h22._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    var path = (0, $lvTkn._)({}, useResolvedPath(action ? action : ".", {
        relative: relative
    }));
    var location = useLocation();
    if (action == null) {
        path.search = location.search;
        var params = new URLSearchParams(path.search);
        var indexValues = params.getAll("index");
        var hasNakedIndexParam = indexValues.some(function(v) {
            return v === "";
        });
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?".concat(qs) : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
function useFetcher() {
    var key = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).key;
    var _route_matches_;
    var router = useDataRouterContext3("useFetcher" /* UseFetcher */ ).router;
    var state = useDataRouterState2("useFetcher" /* UseFetcher */ );
    var fetcherData = $eHaBZ.useContext(FetchersContext);
    var route = $eHaBZ.useContext(RouteContext);
    var routeId = (_route_matches_ = route.matches[route.matches.length - 1]) === null || _route_matches_ === void 0 ? void 0 : _route_matches_.route.id;
    invariant(fetcherData, "useFetcher must be used inside a FetchersContext");
    invariant(route, "useFetcher must be used inside a RouteContext");
    invariant(routeId != null, 'useFetcher can only be used on routes that contain a unique "id"');
    var defaultKey = $eHaBZ.useId();
    var _React10_useState = (0, $21h22._)($eHaBZ.useState(key || defaultKey), 2), fetcherKey = _React10_useState[0], setFetcherKey = _React10_useState[1];
    if (key && key !== fetcherKey) setFetcherKey(key);
    $eHaBZ.useEffect(function() {
        router.getFetcher(fetcherKey);
        return function() {
            return router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    var load = $eHaBZ.useCallback(function(href, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        invariant(routeId, "No routeId available for fetcher.load()");
                        return [
                            4,
                            router.fetch(fetcherKey, routeId, href, opts)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    var submitImpl = useSubmit();
    var submit = $eHaBZ.useCallback(function(target, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            submitImpl(target, (0, $9Jpjh._)((0, $lvTkn._)({}, opts), {
                                navigate: false,
                                fetcherKey: fetcherKey
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        fetcherKey,
        submitImpl
    ]);
    var unstable_reset = $eHaBZ.useCallback(function(opts) {
        return router.resetFetcher(fetcherKey, opts);
    }, [
        router,
        fetcherKey
    ]);
    var FetcherForm = $eHaBZ.useMemo(function() {
        var FetcherForm2 = $eHaBZ.forwardRef(function(props, ref) {
            return /* @__PURE__ */ $eHaBZ.createElement(Form, (0, $9Jpjh._)((0, $lvTkn._)({}, props), {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    var fetcher = state.fetchers.get(fetcherKey) || IDLE_FETCHER;
    var data2 = fetcherData.get(fetcherKey);
    var fetcherWithComponents = $eHaBZ.useMemo(function() {
        return (0, $9Jpjh._)((0, $lvTkn._)({
            Form: FetcherForm,
            submit: submit,
            load: load,
            unstable_reset: unstable_reset
        }, fetcher), {
            data: data2
        });
    }, [
        FetcherForm,
        submit,
        load,
        unstable_reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function useFetchers() {
    var state = useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(function(param) {
        var _param = (0, $21h22._)(param, 2), key = _param[0], fetcher = _param[1];
        return (0, $9Jpjh._)((0, $lvTkn._)({}, fetcher), {
            key: key
        });
    });
}
var SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var savedScrollPositions = {};
function getScrollRestorationKey(location, matches, basename, getKey) {
    var key = null;
    if (getKey) {
        if (basename !== "/") key = getKey((0, $9Jpjh._)((0, $lvTkn._)({}, location), {
            pathname: stripBasename(location.pathname, basename) || location.pathname
        }), matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function useScrollRestoration() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ ).router;
    var _useDataRouterState2 = useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ ), restoreScrollPosition = _useDataRouterState2.restoreScrollPosition, preventScrollReset = _useDataRouterState2.preventScrollReset;
    var basename = $eHaBZ.useContext(NavigationContext).basename;
    var location = useLocation();
    var matches = useMatches();
    var navigation = useNavigation();
    $eHaBZ.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    usePageHide($eHaBZ.useCallback(function() {
        if (navigation.state === "idle") {
            var key = getScrollRestorationKey(location, matches, basename, getKey);
            savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        } catch (error) {
            warning(false, "Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (".concat(error, ")."));
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $eHaBZ.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $eHaBZ.useLayoutEffect(function() {
            var disableScrollRestoration = router === null || router === void 0 ? void 0 : router.enableScrollRestoration(savedScrollPositions, function() {
                return window.scrollY;
            }, getKey ? function(location2, matches2) {
                return getScrollRestorationKey(location2, matches2, basename, getKey);
            } : void 0);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        $eHaBZ.useLayoutEffect(function() {
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch (e) {
                warning(false, '"'.concat(location.hash.slice(1), '" is not a decodable element ID. The view will not scroll to it.'));
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function useBeforeUnload(callback, options) {
    var capture = (options || {}).capture;
    $eHaBZ.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $eHaBZ.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function usePrompt(param) {
    var when = param.when, message = param.message;
    var blocker = useBlocker(when);
    $eHaBZ.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $eHaBZ.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function useViewTransitionState(to) {
    var relative = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).relative;
    var vtContext = $eHaBZ.useContext(ViewTransitionContext);
    invariant(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    var basename = useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ ).basename;
    var path = useResolvedPath(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = stripBasename(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = stripBasename(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return matchPath(path.pathname, nextPath) != null || matchPath(path.pathname, currentPath) != null;
}
function StaticRouter(param) {
    var basename = param.basename, children = param.children, tmp = param.location, locationProp = tmp === void 0 ? "/" : tmp;
    if (typeof locationProp === "string") locationProp = parsePath(locationProp);
    var action = "POP" /* Pop */ ;
    var location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    var staticNavigator = getStatelessNavigator();
    return /* @__PURE__ */ $eHaBZ.createElement(Router, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true
    });
}
function StaticRouterProvider(param) {
    var context = param.context, router = param.router, tmp = param.hydrate, hydrate2 = tmp === void 0 ? true : tmp, nonce = param.nonce;
    invariant(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    var dataRouterContext = {
        router: router,
        navigator: getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    var fetchersContext = /* @__PURE__ */ new Map();
    var hydrateScript = "";
    if (hydrate2 !== false) {
        var data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: serializeErrors(context.errors)
        };
        var json = htmlEscape(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = "window.__staticRouterHydrationData = JSON.parse(".concat(json, ");");
    }
    var state = dataRouterContext.router.state;
    return /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, /* @__PURE__ */ $eHaBZ.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $eHaBZ.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /* @__PURE__ */ $eHaBZ.createElement(FetchersContext.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $eHaBZ.createElement(ViewTransitionContext.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $eHaBZ.createElement(Router, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static
    }, /* @__PURE__ */ $eHaBZ.createElement(DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /* @__PURE__ */ $eHaBZ.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function DataRoutes2(param) {
    var routes = param.routes, future = param.future, state = param.state;
    return useRoutesImpl(routes, void 0, state, void 0, future);
}
function serializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $21h22._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            if (isRouteErrorResponse(val)) serialized[key] = (0, $9Jpjh._)((0, $lvTkn._)({}, val), {
                __type: "RouteErrorResponse"
            });
            else if (val instanceof Error) serialized[key] = (0, $lvTkn._)({
                message: val.message,
                __type: "Error"
            }, val.name !== "Error" ? {
                __subType: val.name
            } : {});
            else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
function getStatelessNavigator() {
    return {
        createHref: createHref,
        encodeLocation: encodeLocation,
        push: function(to) {
            throw new Error("You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a `navigate(".concat(JSON.stringify(to), ")` somewhere in your app."));
        },
        replace: function(to) {
            throw new Error("You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a `navigate(".concat(JSON.stringify(to), ", { replace: true })` somewhere in your app."));
        },
        go: function(delta) {
            throw new Error("You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a `navigate(".concat(delta, ")` somewhere in your app."));
        },
        back: function() {
            throw new Error("You cannot use navigator.back() on the server because it is a stateless environment.");
        },
        forward: function() {
            throw new Error("You cannot use navigator.forward() on the server because it is a stateless environment.");
        }
    };
}
function createStaticHandler2(routes, opts) {
    return createStaticHandler(routes, (0, $9Jpjh._)((0, $lvTkn._)({}, opts), {
        mapRouteProperties: mapRouteProperties
    }));
}
function createStaticRouter(routes, context) {
    var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var manifest = {};
    var dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, void 0, manifest);
    var matches = context.matches.map(function(match) {
        var route = manifest[match.route.id] || match.route;
        return (0, $9Jpjh._)((0, $lvTkn._)({}, match), {
            route: route
        });
    });
    var msg = function(method) {
        return "You cannot use router.".concat(method, "() on the server because it is a stateless environment");
    };
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return (0, $lvTkn._)({
                v8_middleware: false
            }, opts === null || opts === void 0 ? void 0 : opts.future);
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: IDLE_NAVIGATION,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize: function() {
            throw msg("initialize");
        },
        subscribe: function() {
            throw msg("subscribe");
        },
        enableScrollRestoration: function() {
            throw msg("enableScrollRestoration");
        },
        navigate: function() {
            throw msg("navigate");
        },
        fetch: function() {
            throw msg("fetch");
        },
        revalidate: function() {
            throw msg("revalidate");
        },
        createHref: createHref,
        encodeLocation: encodeLocation,
        getFetcher: function() {
            return IDLE_FETCHER;
        },
        deleteFetcher: function() {
            throw msg("deleteFetcher");
        },
        resetFetcher: function() {
            throw msg("resetFetcher");
        },
        dispose: function() {
            throw msg("dispose");
        },
        getBlocker: function() {
            return IDLE_BLOCKER;
        },
        deleteBlocker: function() {
            throw msg("deleteBlocker");
        },
        patchRoutes: function() {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes: function() {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp: function() {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function createHref(to) {
    return typeof to === "string" ? to : createPath(to);
}
function encodeLocation(to) {
    var href = typeof to === "string" ? to : createPath(to);
    href = href.replace(/ $/, "%20");
    var encoded = ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var ESCAPE_LOOKUP2 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var ESCAPE_REGEX2 = /[&><\u2028\u2029]/g;
function htmlEscape(str) {
    return str.replace(ESCAPE_REGEX2, function(match) {
        return ESCAPE_LOOKUP2[match];
    });
}

});
parcelRegister("1Mz1E", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $14c571840e589f0e$export$71511d61b312f219; });
function $14c571840e589f0e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $14c571840e589f0e$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $14c571840e589f0e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $14c571840e589f0e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("8xMIM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $638732d3362fdd56$export$71511d61b312f219; });

var $7GsX9 = parcelRequire("7GsX9");

var $jf0Y3 = parcelRequire("jf0Y3");

var $cRssL = parcelRequire("cRssL");
function $638732d3362fdd56$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $7GsX9._)(derived);
    return (0, $cRssL._)(_this, (0, $jf0Y3._)() ? Reflect.construct(derived, args || [], (0, $7GsX9._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("7GsX9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5982ea1ba8b4c6e7$export$71511d61b312f219; });
function $5982ea1ba8b4c6e7$export$71511d61b312f219(o) {
    $5982ea1ba8b4c6e7$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5982ea1ba8b4c6e7$export$71511d61b312f219(o);
}

});

parcelRegister("jf0Y3", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e0202b2b0021476d$export$71511d61b312f219; });
function $e0202b2b0021476d$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($e0202b2b0021476d$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("cRssL", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $95d08371c2c4ef4e$export$71511d61b312f219; });

var $krJqD = parcelRequire("krJqD");

var $2bfPH = parcelRequire("2bfPH");
function $95d08371c2c4ef4e$export$71511d61b312f219(self, call) {
    if (call && ((0, $2bfPH._)(call) === "object" || typeof call === "function")) return call;
    return (0, $krJqD._)(self);
}

});
parcelRegister("krJqD", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ee29917471fa094f$export$71511d61b312f219; });
function $ee29917471fa094f$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("gd0sY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bcce38db0d2b4516$export$71511d61b312f219; });
function $bcce38db0d2b4516$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("7cSld", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $53f3ce6e74f6aaad$export$71511d61b312f219; });
function $53f3ce6e74f6aaad$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $53f3ce6e74f6aaad$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $53f3ce6e74f6aaad$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $53f3ce6e74f6aaad$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("khBmn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ec426015f75d7738$export$71511d61b312f219; });
function $ec426015f75d7738$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("NBk0Y", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0951870dac564cbc$export$71511d61b312f219; });

var $9dlnr = parcelRequire("9dlnr");
function $0951870dac564cbc$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $9dlnr._)(subClass, superClass);
}

});
parcelRegister("9dlnr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6b55e905aa672e6c$export$71511d61b312f219; });
function $6b55e905aa672e6c$export$71511d61b312f219(o, p) {
    $6b55e905aa672e6c$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6b55e905aa672e6c$export$71511d61b312f219(o, p);
}

});


parcelRegister("lvTkn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fa9769297b8a68c8$export$71511d61b312f219; });

var $khBmn = parcelRequire("khBmn");
function $fa9769297b8a68c8$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $khBmn._)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("9Jpjh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $715bf31211e65705$export$71511d61b312f219; });
function $715bf31211e65705$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $715bf31211e65705$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $715bf31211e65705$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("aRv4I", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7e86f5813bbb0f77$export$71511d61b312f219; });

var $gCwzj = parcelRequire("gCwzj");
function $7e86f5813bbb0f77$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $gCwzj._)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("gCwzj", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c19975616f0f5e3a$export$71511d61b312f219; });
function $c19975616f0f5e3a$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("21h22", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1788e2ed61915b1e$export$71511d61b312f219; });

var $cMcR0 = parcelRequire("cMcR0");

var $dSjL4 = parcelRequire("dSjL4");

var $3HRhO = parcelRequire("3HRhO");

var $isiou = parcelRequire("isiou");
function $1788e2ed61915b1e$export$71511d61b312f219(arr, i) {
    return (0, $cMcR0._)(arr) || (0, $dSjL4._)(arr, i) || (0, $isiou._)(arr, i) || (0, $3HRhO._)();
}

});
parcelRegister("cMcR0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $94d3f045916e0583$export$71511d61b312f219; });
function $94d3f045916e0583$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("dSjL4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a19fa517098223d7$export$71511d61b312f219; });
function $a19fa517098223d7$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("3HRhO", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2b2eb8ca3633154b$export$71511d61b312f219; });
function $2b2eb8ca3633154b$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("isiou", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d6f91c356a8197fd$export$71511d61b312f219; });

var $azbvf = parcelRequire("azbvf");
function $d6f91c356a8197fd$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $azbvf._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $azbvf._)(o, minLen);
}

});
parcelRegister("azbvf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7b161889ca248e24$export$71511d61b312f219; });
function $7b161889ca248e24$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("ggKxj", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bd823d1c24941985$export$71511d61b312f219; });

var $cMcR0 = parcelRequire("cMcR0");

var $faXM9 = parcelRequire("faXM9");

var $3HRhO = parcelRequire("3HRhO");

var $isiou = parcelRequire("isiou");
function $bd823d1c24941985$export$71511d61b312f219(arr) {
    return (0, $cMcR0._)(arr) || (0, $faXM9._)(arr) || (0, $isiou._)(arr) || (0, $3HRhO._)();
}

});
parcelRegister("faXM9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b0c62864eda90b51$export$71511d61b312f219; });
function $b0c62864eda90b51$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});


parcelRegister("6zk1M", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4c858c0d999a5b9b$export$71511d61b312f219; });

var $lltIQ = parcelRequire("lltIQ");

var $faXM9 = parcelRequire("faXM9");

var $hMl05 = parcelRequire("hMl05");

var $isiou = parcelRequire("isiou");
function $4c858c0d999a5b9b$export$71511d61b312f219(arr) {
    return (0, $lltIQ._)(arr) || (0, $faXM9._)(arr) || (0, $isiou._)(arr) || (0, $hMl05._)();
}

});
parcelRegister("lltIQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f8a29d58f287cd3d$export$71511d61b312f219; });

var $azbvf = parcelRequire("azbvf");
function $f8a29d58f287cd3d$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $azbvf._)(arr);
}

});

parcelRegister("hMl05", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cf17359bdd687909$export$71511d61b312f219; });
function $cf17359bdd687909$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("dHaQg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9f87b386401b733e$export$71511d61b312f219; });

var $i3yDq = parcelRequire("i3yDq");

var $7GsX9 = parcelRequire("7GsX9");

var $BtLVK = parcelRequire("BtLVK");

var $9dlnr = parcelRequire("9dlnr");
function $9f87b386401b733e$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $9f87b386401b733e$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $BtLVK._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $i3yDq._)(Class, arguments, (0, $7GsX9._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $9dlnr._)(Wrapper, Class);
    };
    return $9f87b386401b733e$export$71511d61b312f219(Class);
}

});
parcelRegister("i3yDq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d2535f9282d6afd9$export$71511d61b312f219; });

var $jf0Y3 = parcelRequire("jf0Y3");

var $9dlnr = parcelRequire("9dlnr");
function $d2535f9282d6afd9$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $jf0Y3._)()) $d2535f9282d6afd9$export$71511d61b312f219 = Reflect.construct;
    else $d2535f9282d6afd9$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $9dlnr._)(instance, Class.prototype);
        return instance;
    };
    return $d2535f9282d6afd9$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("BtLVK", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $070a8cede0f67609$export$71511d61b312f219; });
function $070a8cede0f67609$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("6PS3Z", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $4fa1715f971c561b$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $4fa1715f971c561b$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $2bfPH = parcelRequire("2bfPH");
var $4fa1715f971c561b$var$extendStatics = function extendStatics1(d, b) {
    $4fa1715f971c561b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $4fa1715f971c561b$var$extendStatics(d, b);
};
function $4fa1715f971c561b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $4fa1715f971c561b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $4fa1715f971c561b$export$18ce0697a983be9b = function __assign1() {
    $4fa1715f971c561b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4fa1715f971c561b$export$18ce0697a983be9b.apply(this, arguments);
};
function $4fa1715f971c561b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $4fa1715f971c561b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $2bfPH._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $4fa1715f971c561b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $4fa1715f971c561b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $2bfPH._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $4fa1715f971c561b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $4fa1715f971c561b$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $2bfPH._)(x)) === "symbol" ? x : "".concat(x);
}
function $4fa1715f971c561b$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $2bfPH._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $4fa1715f971c561b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $2bfPH._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $4fa1715f971c561b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $4fa1715f971c561b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $4fa1715f971c561b$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $4fa1715f971c561b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $4fa1715f971c561b$export$45d3717a4c69092e(o, m, p);
}
function $4fa1715f971c561b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $4fa1715f971c561b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $4fa1715f971c561b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($4fa1715f971c561b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $4fa1715f971c561b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $4fa1715f971c561b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $4fa1715f971c561b$export$10c90e4f7922046c(v) {
    return this instanceof $4fa1715f971c561b$export$10c90e4f7922046c ? (this.v = v, this) : new $4fa1715f971c561b$export$10c90e4f7922046c(v);
}
function $4fa1715f971c561b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $4fa1715f971c561b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $4fa1715f971c561b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $4fa1715f971c561b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $4fa1715f971c561b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $4fa1715f971c561b$export$19a8beecd37a4c45 === "function" ? $4fa1715f971c561b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $4fa1715f971c561b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $4fa1715f971c561b$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $4fa1715f971c561b$var$ownKeys = function ownKeys1(o) {
    $4fa1715f971c561b$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $4fa1715f971c561b$var$ownKeys(o);
};
function $4fa1715f971c561b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $4fa1715f971c561b$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $4fa1715f971c561b$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $4fa1715f971c561b$var$__setModuleDefault(result, mod);
    return result;
}
function $4fa1715f971c561b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $4fa1715f971c561b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $4fa1715f971c561b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $4fa1715f971c561b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $2bfPH._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $4fa1715f971c561b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $4fa1715f971c561b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $4fa1715f971c561b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $4fa1715f971c561b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $4fa1715f971c561b$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $4fa1715f971c561b$export$2e2bcd8739ae039 = {
    __extends: $4fa1715f971c561b$export$a8ba968b8961cb8a,
    __assign: $4fa1715f971c561b$export$18ce0697a983be9b,
    __rest: $4fa1715f971c561b$export$3c9a16f847548506,
    __decorate: $4fa1715f971c561b$export$29e00dfd3077644b,
    __param: $4fa1715f971c561b$export$d5ad3fd78186038f,
    __esDecorate: $4fa1715f971c561b$export$3a84e1ae4e97e9b0,
    __runInitializers: $4fa1715f971c561b$export$d831c04e792af3d,
    __propKey: $4fa1715f971c561b$export$6a2a36740a146cb8,
    __setFunctionName: $4fa1715f971c561b$export$d1a06452d3489bc7,
    __metadata: $4fa1715f971c561b$export$f1db080c865becb9,
    __awaiter: $4fa1715f971c561b$export$1050f835b63b671e,
    __generator: $4fa1715f971c561b$export$67ebef60e6f28a6,
    __createBinding: $4fa1715f971c561b$export$45d3717a4c69092e,
    __exportStar: $4fa1715f971c561b$export$f33643c0debef087,
    __values: $4fa1715f971c561b$export$19a8beecd37a4c45,
    __read: $4fa1715f971c561b$export$8d051b38c9118094,
    __spread: $4fa1715f971c561b$export$afc72e2116322959,
    __spreadArrays: $4fa1715f971c561b$export$6388937ca91ccae8,
    __spreadArray: $4fa1715f971c561b$export$1216008129fb82ed,
    __await: $4fa1715f971c561b$export$10c90e4f7922046c,
    __asyncGenerator: $4fa1715f971c561b$export$e427f37a30a4de9b,
    __asyncDelegator: $4fa1715f971c561b$export$bbd80228419bb833,
    __asyncValues: $4fa1715f971c561b$export$e3b29a3d6162315f,
    __makeTemplateObject: $4fa1715f971c561b$export$4fb47efe1390b86f,
    __importStar: $4fa1715f971c561b$export$c21735bcef00d192,
    __importDefault: $4fa1715f971c561b$export$da59b14a69baef04,
    __classPrivateFieldGet: $4fa1715f971c561b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $4fa1715f971c561b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $4fa1715f971c561b$export$81fdc39f203e4e04,
    __addDisposableResource: $4fa1715f971c561b$export$88ac25d8e944e405,
    __disposeResources: $4fa1715f971c561b$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $4fa1715f971c561b$export$889dfb5d17574b0b
};

});


parcelRegister("ep3JT", function(module, exports) {
module.exports = JSON.parse("{\"description\":\"The iconic font, CSS, and SVG framework\",\"keywords\":[\"font\",\"awesome\",\"fontawesome\",\"icon\",\"svg\",\"bootstrap\"],\"homepage\":\"https://fontawesome.com\",\"bugs\":{\"url\":\"https://github.com/FortAwesome/Font-Awesome/issues\"},\"author\":\"The Font Awesome Team (https://github.com/orgs/FortAwesome/people)\",\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/FortAwesome/Font-Awesome\"},\"engines\":{\"node\":\">=6\"},\"dependencies\":{\"@fortawesome/fontawesome-common-types\":\"7.1.0\"},\"version\":\"7.1.0\",\"name\":\"@fortawesome/fontawesome-svg-core\",\"main\":\"index.js\",\"module\":\"index.mjs\",\"jsnext:main\":\"index.mjs\",\"style\":\"styles.css\",\"license\":\"MIT\",\"types\":\"./index.d.ts\",\"exports\":{\".\":{\"types\":\"./index.d.ts\",\"module\":\"./index.mjs\",\"import\":\"./index.mjs\",\"require\":\"./index.js\",\"style\":\"./styles.css\",\"default\":\"./index.js\"},\"./index\":{\"types\":\"./index.d.ts\",\"module\":\"./index.mjs\",\"import\":\"./index.mjs\",\"require\":\"./index.js\",\"default\":\"./index.js\"},\"./index.js\":{\"types\":\"./index.d.ts\",\"module\":\"./index.mjs\",\"import\":\"./index.mjs\",\"require\":\"./index.js\",\"default\":\"./index.js\"},\"./plugins\":{\"types\":\"./index.d.ts\",\"module\":\"./plugins.mjs\",\"import\":\"./plugins.mjs\",\"default\":\"./plugins.mjs\"},\"./import.macro\":\"./import.macro.js\",\"./import.macro.js\":\"./import.macro.js\",\"./styles\":\"./styles.css\",\"./styles.css\":\"./styles.css\",\"./package.json\":\"./package.json\"},\"sideEffects\":[\"./index.js\",\"./index.mjs\",\"./styles.css\"]}");

});

parcelRegister("7XifO", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $5cac33f39ab217c5$export$306c0aa65ff9ec16; }, function (v) { return $5cac33f39ab217c5$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5cac33f39ab217c5$export$306c0aa65ff9ec16;
"use strict";

var $eHaBZ = parcelRequire("eHaBZ");
function $5cac33f39ab217c5$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $5cac33f39ab217c5$var$objectIs = "function" === typeof Object.is ? Object.is : $5cac33f39ab217c5$var$is, $5cac33f39ab217c5$var$useState = $eHaBZ.useState, $5cac33f39ab217c5$var$useEffect = $eHaBZ.useEffect, $5cac33f39ab217c5$var$useLayoutEffect = $eHaBZ.useLayoutEffect, $5cac33f39ab217c5$var$useDebugValue = $eHaBZ.useDebugValue;
function $5cac33f39ab217c5$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $5cac33f39ab217c5$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $5cac33f39ab217c5$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $5cac33f39ab217c5$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $5cac33f39ab217c5$var$useEffect(function() {
        $5cac33f39ab217c5$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $5cac33f39ab217c5$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $5cac33f39ab217c5$var$useDebugValue(value);
    return value;
}
function $5cac33f39ab217c5$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$5cac33f39ab217c5$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $5cac33f39ab217c5$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $5cac33f39ab217c5$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $5cac33f39ab217c5$var$useSyncExternalStore$1 : $5cac33f39ab217c5$var$useSyncExternalStore$2;
$5cac33f39ab217c5$export$306c0aa65ff9ec16 = void 0 !== $eHaBZ.useSyncExternalStore ? $eHaBZ.useSyncExternalStore : $5cac33f39ab217c5$var$shim;

});

var $2a29cf9a57c0a933$exports = {};
$parcel$extendImportMap({
    "ktkk8": "selfoss-sw-offline.js"
});

var $61e8f293f375c170$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $2bfPH = parcelRequire("2bfPH");
var $61e8f293f375c170$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError((typeof iterable === "undefined" ? "undefined" : (0, $2bfPH._)(iterable)) + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function stop() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $61e8f293f375c170$exports));
try {
    regeneratorRuntime = $61e8f293f375c170$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if ((typeof globalThis === "undefined" ? "undefined" : (0, $2bfPH._)(globalThis)) === "object") globalThis.regeneratorRuntime = $61e8f293f375c170$var$runtime;
    else Function("r", "regeneratorRuntime = r")($61e8f293f375c170$var$runtime);
}



var $1Mz1E = parcelRequire("1Mz1E");

var $6PS3Z = parcelRequire("6PS3Z");
var $59e7dcc9c52865c1$export$882461b6382ed46c;
var $59e7dcc9c52865c1$export$757ceba2d55c277e;
'use strict';
var $8afcda7f6e55ccf7$exports = {};
'use strict';
function $8afcda7f6e55ccf7$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($8afcda7f6e55ccf7$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$8afcda7f6e55ccf7$var$checkDCE();

$8afcda7f6e55ccf7$exports = (parcelRequire("gKWsR"));


var $59e7dcc9c52865c1$var$i;
$59e7dcc9c52865c1$export$882461b6382ed46c = $8afcda7f6e55ccf7$exports.createRoot;
$59e7dcc9c52865c1$export$757ceba2d55c277e = $8afcda7f6e55ccf7$exports.hydrateRoot;



var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $NBk0Y = parcelRequire("NBk0Y");

var $dHaQg = parcelRequire("dHaQg");

var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $NBk0Y = parcelRequire("NBk0Y");

var $dHaQg = parcelRequire("dHaQg");
var $0d06257c362dc1a1$export$1871035840b7f83a = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $NBk0Y._)(OfflineStorageNotAvailableError, Error1);
    function OfflineStorageNotAvailableError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'Offline storage is not available';
        (0, $gd0sY._)(this, OfflineStorageNotAvailableError);
        var _this;
        _this = (0, $8xMIM._)(this, OfflineStorageNotAvailableError, [
            message
        ]);
        _this.name = 'OfflineStorageNotAvailableError';
        return _this;
    }
    return OfflineStorageNotAvailableError;
}((0, $dHaQg._)(Error));
var $0d06257c362dc1a1$export$66d311bf29d5c89c = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $NBk0Y._)(TimeoutError, Error1);
    function TimeoutError(message) {
        (0, $gd0sY._)(this, TimeoutError);
        var _this;
        _this = (0, $8xMIM._)(this, TimeoutError, [
            message
        ]);
        _this.name = 'TimeoutError';
        return _this;
    }
    return TimeoutError;
}((0, $dHaQg._)(Error));
var $0d06257c362dc1a1$export$65bd6083489bd8bb = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $NBk0Y._)(HttpError, Error1);
    function HttpError(message) {
        (0, $gd0sY._)(this, HttpError);
        var _this;
        _this = (0, $8xMIM._)(this, HttpError, [
            message
        ]);
        _this.name = 'HttpError';
        return _this;
    }
    return HttpError;
}((0, $dHaQg._)(Error));
var $0d06257c362dc1a1$export$5e64a9683d127ef6 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $NBk0Y._)(LoginError, Error1);
    function LoginError(message) {
        (0, $gd0sY._)(this, LoginError);
        var _this;
        _this = (0, $8xMIM._)(this, LoginError, [
            message
        ]);
        _this.name = 'LoginError';
        return _this;
    }
    return LoginError;
}((0, $dHaQg._)(Error));
var $0d06257c362dc1a1$export$4511c7da58e2d9c2 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $NBk0Y._)(UnexpectedStateError, Error1);
    function UnexpectedStateError(message) {
        (0, $gd0sY._)(this, UnexpectedStateError);
        var _this;
        _this = (0, $8xMIM._)(this, UnexpectedStateError, [
            message
        ]);
        _this.name = 'UnexpectedStateError';
        return _this;
    }
    return UnexpectedStateError;
}((0, $dHaQg._)(Error));


var $32ae13b741542474$exports = {};

$parcel$export($32ae13b741542474$exports, "rejectUnless", function () { return $32ae13b741542474$export$8d90b058a02656d9; });
$parcel$export($32ae13b741542474$exports, "rejectIfNotOkay", function () { return $32ae13b741542474$export$3a2f576a374b4dda; });
$parcel$export($32ae13b741542474$exports, "options", function () { return $32ae13b741542474$export$41c562ebe57d11e2; });
$parcel$export($32ae13b741542474$exports, "option", function () { return $32ae13b741542474$export$a75d1723e6bda2ec; });
$parcel$export($32ae13b741542474$exports, "headers", function () { return $32ae13b741542474$export$838e2a576d4d6ff6; });
$parcel$export($32ae13b741542474$exports, "header", function () { return $32ae13b741542474$export$38e42c68cf43b5d4; });
$parcel$export($32ae13b741542474$exports, "liftToPromiseField", function () { return $32ae13b741542474$export$e39d76e25ce37988; });
$parcel$export($32ae13b741542474$exports, "makeAbortableFetch", function () { return $32ae13b741542474$export$9c77439751b4390b; });
$parcel$export($32ae13b741542474$exports, "makeFetchWithTimeout", function () { return $32ae13b741542474$export$e9a8372937ef7f1; });
$parcel$export($32ae13b741542474$exports, "makeFetchFailOnHttpErrors", function () { return $32ae13b741542474$export$fe633c745f42b5cd; });
$parcel$export($32ae13b741542474$exports, "makeFetchSupportGetBody", function () { return $32ae13b741542474$export$f4ba43f659d5549c; });
$parcel$export($32ae13b741542474$exports, "fetch", function () { return $32ae13b741542474$export$e7aa7bc5c1b3cfb3; });
$parcel$export($32ae13b741542474$exports, "get", function () { return $32ae13b741542474$export$3988ae62b71be9a3; });
$parcel$export($32ae13b741542474$exports, "post", function () { return $32ae13b741542474$export$299ba2dee77727e9; });
$parcel$export($32ae13b741542474$exports, "delete_", function () { return $32ae13b741542474$export$38dab5a9fea42f39; });
$parcel$export($32ae13b741542474$exports, "makeSearchParams", function () { return $32ae13b741542474$export$92871f7982deaf9f; });

var $khBmn = parcelRequire("khBmn");

var $lvTkn = parcelRequire("lvTkn");

var $aRv4I = parcelRequire("aRv4I");

var $ggKxj = parcelRequire("ggKxj");

var $6zk1M = parcelRequire("6zk1M");
var $16bf04b797257b4a$exports = {};

var $2bfPH = parcelRequire("2bfPH");
$16bf04b797257b4a$exports = function(data) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var sorted = opts.sorted, ignorenull = opts.ignorenull, ignoreEmptyArray = opts.ignoreEmptyArray, useDot = opts.useDot, skipIndex = opts.skipIndex, skipBracket = opts.skipBracket, _opts_whitespace = opts.whitespace, whitespace = _opts_whitespace === void 0 ? '+' : _opts_whitespace;
    var encode = function(value) {
        return String(value).replace(RegExp("[^ !'()~*]", "gu"), encodeURIComponent).replace(/ /g, whitespace).replace(/[!'()~*]/g, function(ch) {
            return "%".concat(ch.charCodeAt().toString(16).slice(-2).toUpperCase());
        });
    };
    var keys = function(obj) {
        var keyarr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Object.keys(obj);
        return sorted ? keyarr.sort() : keyarr;
    };
    var filterjoin = function(arr) {
        return arr.filter(function(e) {
            return e;
        }).join('&');
    };
    var objnest = function(name, obj) {
        return filterjoin(keys(obj).map(function(key) {
            return useDot ? nest("".concat(name, ".").concat(key), obj[key]) : nest("".concat(name, "[").concat(key, "]"), obj[key]);
        }));
    };
    var arrnest = function(name, arr) {
        var brackets = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : skipBracket ? '' : '[]';
        return arr.length ? filterjoin(arr.map(function(elem, index) {
            return skipIndex ? nest(name + brackets, elem) : nest(name + '[' + index + ']', elem);
        })) : ignoreEmptyArray ? null : encode(name + brackets);
    };
    var setnest = function(name, set) {
        return filterjoin(Array.from(set).map(function(elem) {
            return nest(name, elem);
        }));
    };
    var nest = function(name, value) {
        var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value), f = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
        if (value === f) f = ignorenull ? f : encode(name) + '=' + f;
        else if (/string|number|boolean/.test(type)) f = encode(name) + '=' + encode(value);
        else if (Array.isArray(value)) f = arrnest(name, value);
        else if (value instanceof Set) f = setnest(name, value);
        else if (type === 'object') f = objnest(name, value);
        return f;
    };
    return data && filterjoin(keys(data).map(function(key) {
        return nest(key, data[key]);
    }));
};


var $c41432d844932dcf$exports = {};
var $16cdbc498258dabf$exports = {};
var $7e9ffa7fa815703c$exports = {};
var $f6709ecef4b253a2$exports = {};

var $2bfPH = parcelRequire("2bfPH");
function $f6709ecef4b253a2$var$_isPlaceholder(a) {
    return a != null && (typeof a === "undefined" ? "undefined" : (0, $2bfPH._)(a)) === 'object' && a['@@functional/placeholder'] === true;
}
$f6709ecef4b253a2$exports = $f6709ecef4b253a2$var$_isPlaceholder;


/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $7e9ffa7fa815703c$var$_curry1(fn) {
    return function f1(a) {
        if (arguments.length === 0 || $f6709ecef4b253a2$exports(a)) return f1;
        else return fn.apply(this, arguments);
    };
}
$7e9ffa7fa815703c$exports = $7e9ffa7fa815703c$var$_curry1;



/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $16cdbc498258dabf$var$_curry2(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return $f6709ecef4b253a2$exports(a) ? f2 : $7e9ffa7fa815703c$exports(function(_b) {
                    return fn(a, _b);
                });
            default:
                return $f6709ecef4b253a2$exports(a) && $f6709ecef4b253a2$exports(b) ? f2 : $f6709ecef4b253a2$exports(a) ? $7e9ffa7fa815703c$exports(function(_a) {
                    return fn(_a, b);
                }) : $f6709ecef4b253a2$exports(b) ? $7e9ffa7fa815703c$exports(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}
$16cdbc498258dabf$exports = $16cdbc498258dabf$var$_curry2;


var $c1dff8cdd11e90ef$exports = {};
var $80cb0262fd5157fd$exports = {};



/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $80cb0262fd5157fd$var$_curry3(fn) {
    return function f3(a, b, c) {
        switch(arguments.length){
            case 0:
                return f3;
            case 1:
                return $f6709ecef4b253a2$exports(a) ? f3 : $16cdbc498258dabf$exports(function(_b, _c) {
                    return fn(a, _b, _c);
                });
            case 2:
                return $f6709ecef4b253a2$exports(a) && $f6709ecef4b253a2$exports(b) ? f3 : $f6709ecef4b253a2$exports(a) ? $16cdbc498258dabf$exports(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : $f6709ecef4b253a2$exports(b) ? $16cdbc498258dabf$exports(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : $7e9ffa7fa815703c$exports(function(_c) {
                    return fn(a, b, _c);
                });
            default:
                return $f6709ecef4b253a2$exports(a) && $f6709ecef4b253a2$exports(b) && $f6709ecef4b253a2$exports(c) ? f3 : $f6709ecef4b253a2$exports(a) && $f6709ecef4b253a2$exports(b) ? $16cdbc498258dabf$exports(function(_a, _b) {
                    return fn(_a, _b, c);
                }) : $f6709ecef4b253a2$exports(a) && $f6709ecef4b253a2$exports(c) ? $16cdbc498258dabf$exports(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : $f6709ecef4b253a2$exports(b) && $f6709ecef4b253a2$exports(c) ? $16cdbc498258dabf$exports(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : $f6709ecef4b253a2$exports(a) ? $7e9ffa7fa815703c$exports(function(_a) {
                    return fn(_a, b, c);
                }) : $f6709ecef4b253a2$exports(b) ? $7e9ffa7fa815703c$exports(function(_b) {
                    return fn(a, _b, c);
                }) : $f6709ecef4b253a2$exports(c) ? $7e9ffa7fa815703c$exports(function(_c) {
                    return fn(a, b, _c);
                }) : fn(a, b, c);
        }
    };
}
$80cb0262fd5157fd$exports = $80cb0262fd5157fd$var$_curry3;


var $db378aa7becbce1c$exports = {};
function $db378aa7becbce1c$var$_isObject(x) {
    return Object.prototype.toString.call(x) === '[object Object]';
}
$db378aa7becbce1c$exports = $db378aa7becbce1c$var$_isObject;


var $5b93c9afa1b3d914$exports = {};

var $8659c368bdbba7be$exports = {};
function $8659c368bdbba7be$var$_has(prop, obj) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
$8659c368bdbba7be$exports = $8659c368bdbba7be$var$_has;


/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result being
 * used as the value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWithKey, R.mergeWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeWithKey(concatValues,
 *                     { a: true, thing: 'foo', values: [10, 20] },
 *                     { b: true, thing: 'bar', values: [15, 35] });
 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
 */ var $5b93c9afa1b3d914$var$mergeWithKey = /*#__PURE__*/ $80cb0262fd5157fd$exports(function mergeWithKey(fn, l, r) {
    var result = {};
    var k;
    l = l || {};
    r = r || {};
    for(k in l)if ($8659c368bdbba7be$exports(k, l)) result[k] = $8659c368bdbba7be$exports(k, r) ? fn(k, l[k], r[k]) : l[k];
    for(k in r)if ($8659c368bdbba7be$exports(k, r) && !$8659c368bdbba7be$exports(k, result)) result[k] = r[k];
    return result;
});
$5b93c9afa1b3d914$exports = $5b93c9afa1b3d914$var$mergeWithKey;


/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to the key and associated values
 *   using the resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWithKey, R.mergeDeepWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeDeepWithKey(concatValues,
 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */ var $c1dff8cdd11e90ef$var$mergeDeepWithKey = /*#__PURE__*/ $80cb0262fd5157fd$exports(function mergeDeepWithKey(fn, lObj, rObj) {
    return $5b93c9afa1b3d914$exports(function(k, lVal, rVal) {
        if ($db378aa7becbce1c$exports(lVal) && $db378aa7becbce1c$exports(rVal)) return mergeDeepWithKey(fn, lVal, rVal);
        else return fn(k, lVal, rVal);
    }, lObj, rObj);
});
$c1dff8cdd11e90ef$exports = $c1dff8cdd11e90ef$var$mergeDeepWithKey;


/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeDeepRight, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepLeft({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                      { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 10, contact: { email: 'moo@example.com' }}
 */ var $c41432d844932dcf$var$mergeDeepLeft = /*#__PURE__*/ $16cdbc498258dabf$exports(function mergeDeepLeft(lObj, rObj) {
    return $c1dff8cdd11e90ef$exports(function(k, lVal, rVal) {
        return lVal;
    }, lObj, rObj);
});
$c41432d844932dcf$exports = $c41432d844932dcf$var$mergeDeepLeft;


var $d260ff7ca3ce6993$exports = {};
var $7629ad89266bbe6b$exports = {};
function $7629ad89266bbe6b$var$_arity(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
    }
}
$7629ad89266bbe6b$exports = $7629ad89266bbe6b$var$_arity;


var $b5790e78e290f7f4$exports = {};
function $b5790e78e290f7f4$var$_pipe(f, g) {
    return function() {
        return g.call(this, f.apply(this, arguments));
    };
}
$b5790e78e290f7f4$exports = $b5790e78e290f7f4$var$_pipe;


var $c4fccbe08b9f0fad$exports = {};

var $bdafe3f0d791dda7$exports = {};
var $f02a59ea5dc135be$exports = {};
var $67c81c8b457540e6$exports = {};

var $2bfPH = parcelRequire("2bfPH");

var $73fb5ea04d9dead1$exports = {};
/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */ $73fb5ea04d9dead1$exports = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
};


var $04e2efa5ca25c0f3$exports = {};
function $04e2efa5ca25c0f3$var$_isString(x) {
    return Object.prototype.toString.call(x) === '[object String]';
}
$04e2efa5ca25c0f3$exports = $04e2efa5ca25c0f3$var$_isString;


/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 *      _isArrayLike({nodeType: 1, length: 1}) // => false
 */ var $67c81c8b457540e6$var$_isArrayLike = /*#__PURE__*/ $7e9ffa7fa815703c$exports(function isArrayLike(x) {
    if ($73fb5ea04d9dead1$exports(x)) return true;
    if (!x) return false;
    if ((typeof x === "undefined" ? "undefined" : (0, $2bfPH._)(x)) !== 'object') return false;
    if ($04e2efa5ca25c0f3$exports(x)) return false;
    if (x.length === 0) return true;
    if (x.length > 0) return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
    return false;
});
$67c81c8b457540e6$exports = $67c81c8b457540e6$var$_isArrayLike;


var $f02a59ea5dc135be$var$symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
function $f02a59ea5dc135be$var$_createReduce(arrayReduce, methodReduce, iterableReduce) {
    return function _reduce(xf, acc, list) {
        if ($67c81c8b457540e6$exports(list)) return arrayReduce(xf, acc, list);
        if (list == null) return acc;
        if (typeof list['fantasy-land/reduce'] === 'function') return methodReduce(xf, acc, list, 'fantasy-land/reduce');
        if (list[$f02a59ea5dc135be$var$symIterator] != null) return iterableReduce(xf, acc, list[$f02a59ea5dc135be$var$symIterator]());
        if (typeof list.next === 'function') return iterableReduce(xf, acc, list);
        if (typeof list.reduce === 'function') return methodReduce(xf, acc, list, 'reduce');
        throw new TypeError('reduce: list must be array or iterable');
    };
}
$f02a59ea5dc135be$exports = $f02a59ea5dc135be$var$_createReduce;


var $4b2ec1de5112b3cd$exports = {};
function $4b2ec1de5112b3cd$var$_xArrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        acc = xf['@@transducer/step'](acc, list[idx]);
        if (acc && acc['@@transducer/reduced']) {
            acc = acc['@@transducer/value'];
            break;
        }
        idx += 1;
    }
    return xf['@@transducer/result'](acc);
}
$4b2ec1de5112b3cd$exports = $4b2ec1de5112b3cd$var$_xArrayReduce;


var $367e3100760e4974$exports = {};


/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      const log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */ var $367e3100760e4974$var$bind = /*#__PURE__*/ $16cdbc498258dabf$exports(function bind(fn, thisObj) {
    return $7629ad89266bbe6b$exports(fn.length, function() {
        return fn.apply(thisObj, arguments);
    });
});
$367e3100760e4974$exports = $367e3100760e4974$var$bind;


function $bdafe3f0d791dda7$var$_xIterableReduce(xf, acc, iter) {
    var step = iter.next();
    while(!step.done){
        acc = xf['@@transducer/step'](acc, step.value);
        if (acc && acc['@@transducer/reduced']) {
            acc = acc['@@transducer/value'];
            break;
        }
        step = iter.next();
    }
    return xf['@@transducer/result'](acc);
}
function $bdafe3f0d791dda7$var$_xMethodReduce(xf, acc, obj, methodName) {
    return xf['@@transducer/result'](obj[methodName]($367e3100760e4974$exports(xf['@@transducer/step'], xf), acc));
}
var $bdafe3f0d791dda7$var$_xReduce = /*#__PURE__*/ $f02a59ea5dc135be$exports($4b2ec1de5112b3cd$exports, $bdafe3f0d791dda7$var$_xMethodReduce, $bdafe3f0d791dda7$var$_xIterableReduce);
$bdafe3f0d791dda7$exports = $bdafe3f0d791dda7$var$_xReduce;


var $fcc04a1cf53b4b80$exports = {};
var $fcc04a1cf53b4b80$var$XWrap = /*#__PURE__*/ function() {
    function XWrap(fn) {
        this.f = fn;
    }
    XWrap.prototype['@@transducer/init'] = function() {
        throw new Error('init not implemented on XWrap');
    };
    XWrap.prototype['@@transducer/result'] = function(acc) {
        return acc;
    };
    XWrap.prototype['@@transducer/step'] = function(acc, x) {
        return this.f(acc, x);
    };
    return XWrap;
}();
function $fcc04a1cf53b4b80$var$_xwrap(fn) {
    return new $fcc04a1cf53b4b80$var$XWrap(fn);
}
$fcc04a1cf53b4b80$exports = $fcc04a1cf53b4b80$var$_xwrap;


/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Be cautious of mutating and returning the accumulator. If you reuse it across
 * invocations, it will continue to accumulate onto the same value. The general
 * recommendation is to always return a new value. If you can't do so for
 * performance reasons, then be sure to reinitialize the accumulator on each
 * invocation.
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */ var $c4fccbe08b9f0fad$var$reduce = /*#__PURE__*/ $80cb0262fd5157fd$exports(function(xf, acc, list) {
    return $bdafe3f0d791dda7$exports(typeof xf === 'function' ? $fcc04a1cf53b4b80$exports(xf) : xf, acc, list);
});
$c4fccbe08b9f0fad$exports = $c4fccbe08b9f0fad$var$reduce;


var $9b7ae0ca44597272$exports = {};
var $9c866f84cc2fbcff$exports = {};

/**
 * This checks whether a function has a [methodname] function. If it isn't an
 * array it will execute that function otherwise it will default to the ramda
 * implementation.
 *
 * @private
 * @param {Function} fn ramda implementation
 * @param {String} methodname property to check for a custom implementation
 * @return {Object} Whatever the return value of the method is.
 */ function $9c866f84cc2fbcff$var$_checkForMethod(methodname, fn) {
    return function() {
        var length = arguments.length;
        if (length === 0) return fn();
        var obj = arguments[length - 1];
        return $73fb5ea04d9dead1$exports(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
}
$9c866f84cc2fbcff$exports = $9c866f84cc2fbcff$var$_checkForMethod;



var $b62da072c6a6f6e5$exports = {};


/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */ var $b62da072c6a6f6e5$var$slice = /*#__PURE__*/ $80cb0262fd5157fd$exports(/*#__PURE__*/ $9c866f84cc2fbcff$exports('slice', function slice(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
}));
$b62da072c6a6f6e5$exports = $b62da072c6a6f6e5$var$slice;


/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */ var $9b7ae0ca44597272$var$tail = /*#__PURE__*/ $7e9ffa7fa815703c$exports(/*#__PURE__*/ $9c866f84cc2fbcff$exports('tail', /*#__PURE__*/ $b62da072c6a6f6e5$exports(1, Infinity)));
$9b7ae0ca44597272$exports = $9b7ae0ca44597272$var$tail;


/**
 * Performs left-to-right function composition. The first argument may have
 * any arity; the remaining arguments must be unary.
 *
 * In some libraries this function is named `sequence`.
 *
 * **Note:** The result of pipe is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.compose
 * @example
 *
 *      const f = R.pipe(Math.pow, R.negate, R.inc);
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
 * @symb R.pipe(f, g, h)(a)(b) = h(g(f(a)))(b)
 */ function $d260ff7ca3ce6993$var$pipe() {
    if (arguments.length === 0) throw new Error('pipe requires at least one argument');
    return $7629ad89266bbe6b$exports(arguments[0].length, $c4fccbe08b9f0fad$exports($b5790e78e290f7f4$exports, arguments[0], $9b7ae0ca44597272$exports(arguments)));
}
$d260ff7ca3ce6993$exports = $d260ff7ca3ce6993$var$pipe;



var $32ae13b741542474$var$_this = undefined;
var $32ae13b741542474$export$8d90b058a02656d9 = function(pred) {
    return function(response) {
        if (pred(response)) return response;
        else {
            var err = new (0, $0d06257c362dc1a1$export$65bd6083489bd8bb)(response.statusText);
            err.response = response;
            throw err;
        }
    };
};
var $32ae13b741542474$export$3a2f576a374b4dda = function(response) {
    return $32ae13b741542474$export$8d90b058a02656d9(function(response) {
        return response.ok;
    })(response);
};
var $32ae13b741542474$export$41c562ebe57d11e2 = function(newOpts) {
    return function(fetch) {
        return function(url) {
            var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return fetch(url, (0, (/*@__PURE__*/$parcel$interopDefault($c41432d844932dcf$exports)))(opts, newOpts));
        };
    };
};
var $32ae13b741542474$export$a75d1723e6bda2ec = function(name, value) {
    return $32ae13b741542474$export$41c562ebe57d11e2((0, $khBmn._)({}, name, value));
};
var $32ae13b741542474$export$838e2a576d4d6ff6 = function(value) {
    return $32ae13b741542474$export$a75d1723e6bda2ec('headers', value);
};
var $32ae13b741542474$export$38e42c68cf43b5d4 = function(name, value) {
    return $32ae13b741542474$export$838e2a576d4d6ff6((0, $khBmn._)({}, name, value));
};
var $32ae13b741542474$export$e39d76e25ce37988 = function(wrapper) {
    return function(f) {
        var _this1 = $32ae13b741542474$var$_this;
        return function() {
            for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
                params[_key] = arguments[_key];
            }
            var rest;
            var promise = wrapper(function() {
                for(var _len = arguments.length, innerParams = new Array(_len), _key = 0; _key < _len; _key++){
                    innerParams[_key] = arguments[_key];
                }
                var _f = f.apply(void 0, (0, $6zk1M._)(innerParams)), promise = _f.promise, innerRest = (0, $aRv4I._)(_f, [
                    "promise"
                ]);
                rest = innerRest;
                return promise;
            }).apply(_this1, (0, $6zk1M._)(params));
            return (0, $lvTkn._)({
                promise: promise
            }, rest);
        };
    };
};
var $32ae13b741542474$export$9c77439751b4390b = function(fetch) {
    return function(url) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var controller = opts.abortController || new AbortController();
        var promise = fetch(url, (0, $lvTkn._)({
            signal: controller.signal
        }, opts));
        return {
            controller: controller,
            promise: promise
        };
    };
};
var $32ae13b741542474$export$e9a8372937ef7f1 = function(abortableFetch) {
    return function(url) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // offline db consistency requires ajax calls to fail reliably,
        // so we enforce a default timeout on ajax calls
        var _opts_timeout = opts.timeout, timeout = _opts_timeout === void 0 ? 60000 : _opts_timeout, rest = (0, $aRv4I._)(opts, [
            "timeout"
        ]);
        var _abortableFetch = abortableFetch(url, rest), controller = _abortableFetch.controller, promise = _abortableFetch.promise;
        if (timeout !== 0) {
            var newPromise = promise.catch(function(error) {
                // Change error name in case of time out so that we can
                // distinguish it from explicit abort.
                if (error.name === 'AbortError' && promise.timedOut) error = new (0, $0d06257c362dc1a1$export$66d311bf29d5c89c)("Request timed out after ".concat(timeout / 1000, " seconds"));
                throw error;
            });
            setTimeout(function() {
                promise.timedOut = true;
                controller.abort();
            }, timeout);
            return {
                controller: controller,
                promise: newPromise
            };
        }
        return {
            controller: controller,
            promise: promise
        };
    };
};
var $32ae13b741542474$export$fe633c745f42b5cd = function(fetch) {
    return function(url) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _opts_failOnHttpErrors = opts.failOnHttpErrors, failOnHttpErrors = _opts_failOnHttpErrors === void 0 ? true : _opts_failOnHttpErrors, rest = (0, $aRv4I._)(opts, [
            "failOnHttpErrors"
        ]);
        var promise = fetch(url, rest);
        if (failOnHttpErrors) return promise.then($32ae13b741542474$export$3a2f576a374b4dda);
        return promise;
    };
};
var $32ae13b741542474$export$f4ba43f659d5549c = function(fetch) {
    return function(url) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var body = opts.body, method = opts.method, rest = (0, $aRv4I._)(opts, [
            "body",
            "method"
        ]);
        var newUrl = url;
        var newOpts = opts;
        if (Object.keys(opts).includes('method') && Object.keys(opts).includes('body') && method.toUpperCase() === 'GET' && body instanceof URLSearchParams) {
            var _newUrl_split = (0, $ggKxj._)(newUrl.split('#')), main = _newUrl_split[0], fragments = _newUrl_split.slice(1);
            var separator = main.includes('?') ? '&' : '?';
            // append the body to the query string
            newUrl = "".concat(main).concat(separator).concat(body.toString(), "#").concat(fragments.join('#'));
            // remove the body since it has been moved to URL
            newOpts = {
                method: method,
                rest: rest
            };
        }
        return fetch(newUrl, newOpts);
    };
};
var $32ae13b741542474$export$e7aa7bc5c1b3cfb3 = (0, (/*@__PURE__*/$parcel$interopDefault($d260ff7ca3ce6993$exports)))(// Same as jQuery.ajax
$32ae13b741542474$export$a75d1723e6bda2ec('credentials', 'same-origin'), $32ae13b741542474$export$38e42c68cf43b5d4('X-Requested-With', 'XMLHttpRequest'), $32ae13b741542474$export$fe633c745f42b5cd, $32ae13b741542474$export$f4ba43f659d5549c, $32ae13b741542474$export$9c77439751b4390b, $32ae13b741542474$export$e9a8372937ef7f1)(window.fetch);
var $32ae13b741542474$export$3988ae62b71be9a3 = $32ae13b741542474$export$e39d76e25ce37988($32ae13b741542474$export$a75d1723e6bda2ec('method', 'GET'))($32ae13b741542474$export$e7aa7bc5c1b3cfb3);
var $32ae13b741542474$export$299ba2dee77727e9 = $32ae13b741542474$export$e39d76e25ce37988($32ae13b741542474$export$a75d1723e6bda2ec('method', 'POST'))($32ae13b741542474$export$e7aa7bc5c1b3cfb3);
var $32ae13b741542474$export$38dab5a9fea42f39 = $32ae13b741542474$export$e39d76e25ce37988($32ae13b741542474$export$a75d1723e6bda2ec('method', 'DELETE'))($32ae13b741542474$export$e7aa7bc5c1b3cfb3);
var $32ae13b741542474$export$92871f7982deaf9f = function(data) {
    return new URLSearchParams((0, (/*@__PURE__*/$parcel$interopDefault($16bf04b797257b4a$exports)))(data, {
        ignorenull: true
    }));
};


var $5be8e377f991f791$export$1a748576aa07f99b = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $NBk0Y._)(PasswordHashingError, Error1);
    function PasswordHashingError(message) {
        (0, $gd0sY._)(this, PasswordHashingError);
        var _this;
        _this = (0, $8xMIM._)(this, PasswordHashingError, [
            message
        ]);
        _this.name = 'PasswordHashingError';
        return _this;
    }
    return PasswordHashingError;
}((0, $dHaQg._)(Error));
function $5be8e377f991f791$export$1d2e6bc0307ffd89() {
    return $32ae13b741542474$export$3988ae62b71be9a3('api/about', {
        // we want fresh configuration each time
        cache: 'no-store'
    }).promise.then(function(response) {
        return response.json();
    });
}
function $5be8e377f991f791$export$596d806903d1f59e(credentials) {
    return $32ae13b741542474$export$299ba2dee77727e9('login', {
        body: new URLSearchParams(credentials)
    }).promise.then(function(response) {
        return response.json();
    }).then(function(data) {
        if (data.success) return Promise.resolve();
        else return Promise.reject(new (0, $0d06257c362dc1a1$export$5e64a9683d127ef6)(data.error));
    });
}
function $5be8e377f991f791$export$708be5cd94908894(password) {
    return $32ae13b741542474$export$299ba2dee77727e9('api/private/hash-password', {
        body: new URLSearchParams({
            password: password
        })
    }).promise.then(function(response) {
        return response.json();
    }).then(function(data) {
        if (data.success) return Promise.resolve(data.hash);
        else return Promise.reject(new $5be8e377f991f791$export$1a748576aa07f99b(data.error));
    });
}
function $5be8e377f991f791$export$b3b4cde15a96b715(file) {
    var data = new FormData();
    data.append('opml', file);
    return $32ae13b741542474$export$299ba2dee77727e9('opml', {
        body: data,
        failOnHttpErrors: false
    }).promise.then($32ae13b741542474$export$8d90b058a02656d9(function(response) {
        return response.status === 200 || response.status === 202 || response.status === 400;
    })).then(function(response) {
        return response.json().then(function(data) {
            return {
                response: response,
                data: data
            };
        });
    });
}
function $5be8e377f991f791$export$a0973bcfe11b05c9() {
    return $32ae13b741542474$export$38dab5a9fea42f39('api/session/current').promise;
}



function $bcc58ea15e13e580$export$c36f611d5eb39a7() {
    return $32ae13b741542474$export$3988ae62b71be9a3('tags').promise.then(function(response) {
        return response.json();
    });
}
function $bcc58ea15e13e580$export$6f3c7c74c4b252bb(tag, color) {
    return $32ae13b741542474$export$299ba2dee77727e9('tags/color', {
        body: $32ae13b741542474$export$92871f7982deaf9f({
            tag: tag,
            color: color
        })
    }).promise;
}




var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");

var $dHaQg = parcelRequire("dHaQg");
var $e721f0b5888adce1$export$5521c47db270880f = /*#__PURE__*/ function(Event1) {
    "use strict";
    (0, $NBk0Y._)(ValueChangeEvent, Event1);
    function ValueChangeEvent(value) {
        (0, $gd0sY._)(this, ValueChangeEvent);
        var _this;
        _this = (0, $8xMIM._)(this, ValueChangeEvent, [
            'change'
        ]);
        _this.value = value;
        return _this;
    }
    return ValueChangeEvent;
}((0, $dHaQg._)(Event));
var $e721f0b5888adce1$export$8fa6ce44b7b131e9 = /*#__PURE__*/ function(EventTarget1) {
    "use strict";
    (0, $NBk0Y._)(ValueListenable, EventTarget1);
    function ValueListenable(value) {
        (0, $gd0sY._)(this, ValueListenable);
        var _this;
        _this = (0, $8xMIM._)(this, ValueListenable);
        _this.value = value;
        return _this;
    }
    (0, $7cSld._)(ValueListenable, [
        {
            key: "update",
            value: function update(value) {
                if (this.value !== value) {
                    this.value = value;
                    var event = new $e721f0b5888adce1$export$5521c47db270880f(value);
                    this.dispatchEvent(event);
                }
            }
        }
    ]);
    return ValueListenable;
}((0, $dHaQg._)(EventTarget));



/**
 * Object describing what state a request is in.
 * @enum {string}
 */ var $d2d3ee75176c5e4c$export$62aa48085237e36f = {
    INITIAL: 'initial',
    LOADING: 'loading',
    SUCCESS: 'success',
    FAILURE: 'failure'
};



var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $NBk0Y = parcelRequire("NBk0Y");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $21h22 = parcelRequire("21h22");
var $f171543c027e46e7$exports = {};
'use strict';

$f171543c027e46e7$exports = (parcelRequire("azwTY"));



var $eHaBZ = parcelRequire("eHaBZ");
var $35e9123a2e6f4e90$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $35e9123a2e6f4e90$var$ReactIs, $35e9123a2e6f4e90$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$35e9123a2e6f4e90$exports = (parcelRequire("fOJyi"))();


var $cff7e9a474db95c7$exports = {};

var $6zk1M = parcelRequire("6zk1M");
function $cff7e9a474db95c7$var$nullable(subRequirement) {
    var check = function(required, props, key) {
        for(var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
            rest[_key - 3] = arguments[_key];
        }
        if (props[key] === null) return null;
        var sub = required ? subRequirement.isRequired : subRequirement;
        return sub.apply(void 0, [
            props,
            key
        ].concat((0, $6zk1M._)(rest)));
    };
    var fn = check.bind(null, false);
    fn.isRequired = check.bind(null, true);
    return fn;
}
Object.defineProperty($cff7e9a474db95c7$exports, '__esModule', {
    value: true
});
$cff7e9a474db95c7$exports.default = $cff7e9a474db95c7$var$nullable;
$cff7e9a474db95c7$exports = Object.assign($cff7e9a474db95c7$exports.default, $cff7e9a474db95c7$exports);
$cff7e9a474db95c7$exports.default.default = $cff7e9a474db95c7$exports;



var $5XYIU = parcelRequire("5XYIU");

var $6zk1M = parcelRequire("6zk1M");

var $eHaBZ = parcelRequire("eHaBZ");
var $b61d1ee6783329c7$var$context = (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createContext(!0);
function $b61d1ee6783329c7$var$forbiddenInRender() {
    throw new Error("A function wrapped in useEffectEvent can't be called during rendering.");
}
var $b61d1ee6783329c7$var$isInvalidExecutionContextForEventFunction = "use" in (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))) ? function() {
    try {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).use($b61d1ee6783329c7$var$context);
    } catch (e) {
        return !1;
    }
} : function() {
    return !1;
};
function $b61d1ee6783329c7$export$7f54fc3180508a52(fn) {
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).useRef($b61d1ee6783329c7$var$forbiddenInRender);
    return (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).useInsertionEffect(function() {
        ref.current = fn;
    }, [
        fn
    ]), function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        $b61d1ee6783329c7$var$isInvalidExecutionContextForEventFunction() && $b61d1ee6783329c7$var$forbiddenInRender();
        var latestFn = ref.current;
        return latestFn.apply(void 0, (0, $6zk1M._)(args));
    };
}



var $2bfPH = parcelRequire("2bfPH");
/*!
 * Font Awesome Free 7.1.0 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2025 Fonticons, Inc.
 */ 
var $2bfPH = parcelRequire("2bfPH");
function $39c5346b7e5f0f6d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $39c5346b7e5f0f6d$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $39c5346b7e5f0f6d$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $39c5346b7e5f0f6d$var$_arrayLikeToArray(r);
}
function $39c5346b7e5f0f6d$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $39c5346b7e5f0f6d$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $39c5346b7e5f0f6d$var$_toPropertyKey(o.key), o);
    }
}
function $39c5346b7e5f0f6d$var$_createClass(e, r, t) {
    return r && $39c5346b7e5f0f6d$var$_defineProperties(e.prototype, r), t && $39c5346b7e5f0f6d$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $39c5346b7e5f0f6d$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $39c5346b7e5f0f6d$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var n = 0, F = function F() {};
            return {
                s: F,
                n: function n1() {
                    return n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var _$r = t.next();
            return a = _$r.done, _$r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $39c5346b7e5f0f6d$var$_defineProperty(e, r, t) {
    return (r = $39c5346b7e5f0f6d$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $39c5346b7e5f0f6d$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $39c5346b7e5f0f6d$var$_setPrototypeOf(t, e);
}
function $39c5346b7e5f0f6d$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $39c5346b7e5f0f6d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $39c5346b7e5f0f6d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $39c5346b7e5f0f6d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $39c5346b7e5f0f6d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $39c5346b7e5f0f6d$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $39c5346b7e5f0f6d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $39c5346b7e5f0f6d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $39c5346b7e5f0f6d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $39c5346b7e5f0f6d$var$_setPrototypeOf(t, e) {
    return $39c5346b7e5f0f6d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
    }, $39c5346b7e5f0f6d$var$_setPrototypeOf(t, e);
}
function $39c5346b7e5f0f6d$var$_slicedToArray(r, e) {
    return $39c5346b7e5f0f6d$var$_arrayWithHoles(r) || $39c5346b7e5f0f6d$var$_iterableToArrayLimit(r, e) || $39c5346b7e5f0f6d$var$_unsupportedIterableToArray(r, e) || $39c5346b7e5f0f6d$var$_nonIterableRest();
}
function $39c5346b7e5f0f6d$var$_toConsumableArray(r) {
    return $39c5346b7e5f0f6d$var$_arrayWithoutHoles(r) || $39c5346b7e5f0f6d$var$_iterableToArray(r) || $39c5346b7e5f0f6d$var$_unsupportedIterableToArray(r) || $39c5346b7e5f0f6d$var$_nonIterableSpread();
}
function $39c5346b7e5f0f6d$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $2bfPH._)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $2bfPH._)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $39c5346b7e5f0f6d$var$_toPropertyKey(t) {
    var i = $39c5346b7e5f0f6d$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $2bfPH._)(i)) ? i : i + "";
}
function $39c5346b7e5f0f6d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $39c5346b7e5f0f6d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $39c5346b7e5f0f6d$var$_typeof(o);
}
function $39c5346b7e5f0f6d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $39c5346b7e5f0f6d$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $39c5346b7e5f0f6d$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $39c5346b7e5f0f6d$var$_wrapRegExp() {
    $39c5346b7e5f0f6d$var$_wrapRegExp = function _wrapRegExp(e, r) {
        return new BabelRegExp(e, void 0, r);
    };
    var e = RegExp.prototype, r = new WeakMap();
    function BabelRegExp(e, t, p) {
        var o = RegExp(e, t);
        return r.set(o, p || r.get(e)), $39c5346b7e5f0f6d$var$_setPrototypeOf(o, BabelRegExp.prototype);
    }
    function buildGroups(e, t) {
        var p = r.get(t);
        return Object.keys(p).reduce(function(r, t) {
            var o = p[t];
            if ("number" == typeof o) r[t] = e[o];
            else {
                for(var i = 0; void 0 === e[o[i]] && i + 1 < o.length;)i++;
                r[t] = e[o[i]];
            }
            return r;
        }, Object.create(null));
    }
    return $39c5346b7e5f0f6d$var$_inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(r) {
        var t = e.exec.call(this, r);
        if (t) {
            t.groups = buildGroups(t, this);
            var p = t.indices;
            p && (p.groups = buildGroups(p, this));
        }
        return t;
    }, BabelRegExp.prototype[Symbol.replace] = function(t, p) {
        if ("string" == typeof p) {
            var o = r.get(this);
            return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)(>|$)/g, function(e, r, t) {
                if ("" === t) return e;
                var _$p = o[r];
                return Array.isArray(_$p) ? "$" + _$p.join("$") : "number" == typeof _$p ? "$" + _$p : "";
            }));
        }
        if ("function" == typeof p) {
            var i = this;
            return e[Symbol.replace].call(this, t, function() {
                var e = arguments;
                return "object" != (0, $2bfPH._)(e[e.length - 1]) && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e);
            });
        }
        return e[Symbol.replace].call(this, t, p);
    }, $39c5346b7e5f0f6d$var$_wrapRegExp.apply(this, arguments);
}
var $39c5346b7e5f0f6d$var$noop = function noop() {};
var $39c5346b7e5f0f6d$var$_WINDOW = {};
var $39c5346b7e5f0f6d$var$_DOCUMENT = {};
var $39c5346b7e5f0f6d$var$_MUTATION_OBSERVER = null;
var $39c5346b7e5f0f6d$var$_PERFORMANCE = {
    mark: $39c5346b7e5f0f6d$var$noop,
    measure: $39c5346b7e5f0f6d$var$noop
};
try {
    if (typeof window !== 'undefined') $39c5346b7e5f0f6d$var$_WINDOW = window;
    if (typeof document !== 'undefined') $39c5346b7e5f0f6d$var$_DOCUMENT = document;
    if (typeof MutationObserver !== 'undefined') $39c5346b7e5f0f6d$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== 'undefined') $39c5346b7e5f0f6d$var$_PERFORMANCE = performance;
} catch (e) {} // eslint-disable-line no-empty
var $39c5346b7e5f0f6d$var$_ref = $39c5346b7e5f0f6d$var$_WINDOW.navigator || {}, $39c5346b7e5f0f6d$var$_ref$userAgent = $39c5346b7e5f0f6d$var$_ref.userAgent, $39c5346b7e5f0f6d$var$userAgent = $39c5346b7e5f0f6d$var$_ref$userAgent === void 0 ? '' : $39c5346b7e5f0f6d$var$_ref$userAgent;
var $39c5346b7e5f0f6d$var$WINDOW = $39c5346b7e5f0f6d$var$_WINDOW;
var $39c5346b7e5f0f6d$var$DOCUMENT = $39c5346b7e5f0f6d$var$_DOCUMENT;
var $39c5346b7e5f0f6d$var$MUTATION_OBSERVER = $39c5346b7e5f0f6d$var$_MUTATION_OBSERVER;
var $39c5346b7e5f0f6d$var$PERFORMANCE = $39c5346b7e5f0f6d$var$_PERFORMANCE;
var $39c5346b7e5f0f6d$var$IS_BROWSER = !!$39c5346b7e5f0f6d$var$WINDOW.document;
var $39c5346b7e5f0f6d$var$IS_DOM = !!$39c5346b7e5f0f6d$var$DOCUMENT.documentElement && !!$39c5346b7e5f0f6d$var$DOCUMENT.head && typeof $39c5346b7e5f0f6d$var$DOCUMENT.addEventListener === 'function' && typeof $39c5346b7e5f0f6d$var$DOCUMENT.createElement === 'function';
var $39c5346b7e5f0f6d$var$IS_IE = ~$39c5346b7e5f0f6d$var$userAgent.indexOf('MSIE') || ~$39c5346b7e5f0f6d$var$userAgent.indexOf('Trident/');
var $39c5346b7e5f0f6d$var$_dt;
var $39c5346b7e5f0f6d$var$E = /fa(k|kd|s|r|l|t|d|dr|dl|dt|b|slr|slpr|wsb|tl|ns|nds|es|jr|jfr|jdr|usb|ufsb|udsb|cr|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, $39c5346b7e5f0f6d$var$_ = /Font ?Awesome ?([567 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit|Notdog Duo|Notdog|Chisel|Etch|Thumbprint|Jelly Fill|Jelly Duo|Jelly|Utility|Utility Fill|Utility Duo|Slab Press|Slab|Whiteboard)?.*/i;
var $39c5346b7e5f0f6d$var$q = {
    classic: {
        fa: "solid",
        fas: "solid",
        "fa-solid": "solid",
        far: "regular",
        "fa-regular": "regular",
        fal: "light",
        "fa-light": "light",
        fat: "thin",
        "fa-thin": "thin",
        fab: "brands",
        "fa-brands": "brands"
    },
    duotone: {
        fa: "solid",
        fad: "solid",
        "fa-solid": "solid",
        "fa-duotone": "solid",
        fadr: "regular",
        "fa-regular": "regular",
        fadl: "light",
        "fa-light": "light",
        fadt: "thin",
        "fa-thin": "thin"
    },
    sharp: {
        fa: "solid",
        fass: "solid",
        "fa-solid": "solid",
        fasr: "regular",
        "fa-regular": "regular",
        fasl: "light",
        "fa-light": "light",
        fast: "thin",
        "fa-thin": "thin"
    },
    "sharp-duotone": {
        fa: "solid",
        fasds: "solid",
        "fa-solid": "solid",
        fasdr: "regular",
        "fa-regular": "regular",
        fasdl: "light",
        "fa-light": "light",
        fasdt: "thin",
        "fa-thin": "thin"
    },
    slab: {
        "fa-regular": "regular",
        faslr: "regular"
    },
    "slab-press": {
        "fa-regular": "regular",
        faslpr: "regular"
    },
    thumbprint: {
        "fa-light": "light",
        fatl: "light"
    },
    whiteboard: {
        "fa-semibold": "semibold",
        fawsb: "semibold"
    },
    notdog: {
        "fa-solid": "solid",
        fans: "solid"
    },
    "notdog-duo": {
        "fa-solid": "solid",
        fands: "solid"
    },
    etch: {
        "fa-solid": "solid",
        faes: "solid"
    },
    jelly: {
        "fa-regular": "regular",
        fajr: "regular"
    },
    "jelly-fill": {
        "fa-regular": "regular",
        fajfr: "regular"
    },
    "jelly-duo": {
        "fa-regular": "regular",
        fajdr: "regular"
    },
    chisel: {
        "fa-regular": "regular",
        facr: "regular"
    },
    utility: {
        "fa-semibold": "semibold",
        fausb: "semibold"
    },
    "utility-duo": {
        "fa-semibold": "semibold",
        faudsb: "semibold"
    },
    "utility-fill": {
        "fa-semibold": "semibold",
        faufsb: "semibold"
    }
}, $39c5346b7e5f0f6d$var$H = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
}, $39c5346b7e5f0f6d$var$Q = [
    "fa-classic",
    "fa-duotone",
    "fa-sharp",
    "fa-sharp-duotone",
    "fa-thumbprint",
    "fa-whiteboard",
    "fa-notdog",
    "fa-notdog-duo",
    "fa-chisel",
    "fa-etch",
    "fa-jelly",
    "fa-jelly-fill",
    "fa-jelly-duo",
    "fa-slab",
    "fa-slab-press",
    "fa-utility",
    "fa-utility-duo",
    "fa-utility-fill"
];
var $39c5346b7e5f0f6d$var$i = "classic", $39c5346b7e5f0f6d$var$t = "duotone", $39c5346b7e5f0f6d$var$d = "sharp", $39c5346b7e5f0f6d$var$l = "sharp-duotone", $39c5346b7e5f0f6d$var$f = "chisel", $39c5346b7e5f0f6d$var$n = "etch", $39c5346b7e5f0f6d$var$h = "jelly", $39c5346b7e5f0f6d$var$o = "jelly-duo", $39c5346b7e5f0f6d$var$u = "jelly-fill", $39c5346b7e5f0f6d$var$g = "notdog", $39c5346b7e5f0f6d$var$s = "notdog-duo", $39c5346b7e5f0f6d$var$y = "slab", $39c5346b7e5f0f6d$var$m = "slab-press", $39c5346b7e5f0f6d$var$e = "thumbprint", $39c5346b7e5f0f6d$var$p = "utility", $39c5346b7e5f0f6d$var$a = "utility-duo", $39c5346b7e5f0f6d$var$w = "utility-fill", $39c5346b7e5f0f6d$var$x = "whiteboard", $39c5346b7e5f0f6d$var$b = "Classic", $39c5346b7e5f0f6d$var$c = "Duotone", $39c5346b7e5f0f6d$var$I = "Sharp", $39c5346b7e5f0f6d$var$F = "Sharp Duotone", $39c5346b7e5f0f6d$var$v = "Chisel", $39c5346b7e5f0f6d$var$S = "Etch", $39c5346b7e5f0f6d$var$A = "Jelly", $39c5346b7e5f0f6d$var$P = "Jelly Duo", $39c5346b7e5f0f6d$var$j = "Jelly Fill", $39c5346b7e5f0f6d$var$B = "Notdog", $39c5346b7e5f0f6d$var$N = "Notdog Duo", $39c5346b7e5f0f6d$var$k = "Slab", $39c5346b7e5f0f6d$var$D = "Slab Press", $39c5346b7e5f0f6d$var$T = "Thumbprint", $39c5346b7e5f0f6d$var$C = "Utility", $39c5346b7e5f0f6d$var$W = "Utility Duo", $39c5346b7e5f0f6d$var$K = "Utility Fill", $39c5346b7e5f0f6d$var$R = "Whiteboard", $39c5346b7e5f0f6d$var$rt = [
    $39c5346b7e5f0f6d$var$i,
    $39c5346b7e5f0f6d$var$t,
    $39c5346b7e5f0f6d$var$d,
    $39c5346b7e5f0f6d$var$l,
    $39c5346b7e5f0f6d$var$f,
    $39c5346b7e5f0f6d$var$n,
    $39c5346b7e5f0f6d$var$h,
    $39c5346b7e5f0f6d$var$o,
    $39c5346b7e5f0f6d$var$u,
    $39c5346b7e5f0f6d$var$g,
    $39c5346b7e5f0f6d$var$s,
    $39c5346b7e5f0f6d$var$y,
    $39c5346b7e5f0f6d$var$m,
    $39c5346b7e5f0f6d$var$e,
    $39c5346b7e5f0f6d$var$p,
    $39c5346b7e5f0f6d$var$a,
    $39c5346b7e5f0f6d$var$w,
    $39c5346b7e5f0f6d$var$x
], $39c5346b7e5f0f6d$var$dt = ($39c5346b7e5f0f6d$var$_dt = {}, $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_dt, $39c5346b7e5f0f6d$var$i, $39c5346b7e5f0f6d$var$b), $39c5346b7e5f0f6d$var$t, $39c5346b7e5f0f6d$var$c), $39c5346b7e5f0f6d$var$d, $39c5346b7e5f0f6d$var$I), $39c5346b7e5f0f6d$var$l, $39c5346b7e5f0f6d$var$F), $39c5346b7e5f0f6d$var$f, $39c5346b7e5f0f6d$var$v), $39c5346b7e5f0f6d$var$n, $39c5346b7e5f0f6d$var$S), $39c5346b7e5f0f6d$var$h, $39c5346b7e5f0f6d$var$A), $39c5346b7e5f0f6d$var$o, $39c5346b7e5f0f6d$var$P), $39c5346b7e5f0f6d$var$u, $39c5346b7e5f0f6d$var$j), $39c5346b7e5f0f6d$var$g, $39c5346b7e5f0f6d$var$B), $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_dt, $39c5346b7e5f0f6d$var$s, $39c5346b7e5f0f6d$var$N), $39c5346b7e5f0f6d$var$y, $39c5346b7e5f0f6d$var$k), $39c5346b7e5f0f6d$var$m, $39c5346b7e5f0f6d$var$D), $39c5346b7e5f0f6d$var$e, $39c5346b7e5f0f6d$var$T), $39c5346b7e5f0f6d$var$p, $39c5346b7e5f0f6d$var$C), $39c5346b7e5f0f6d$var$a, $39c5346b7e5f0f6d$var$W), $39c5346b7e5f0f6d$var$w, $39c5346b7e5f0f6d$var$K), $39c5346b7e5f0f6d$var$x, $39c5346b7e5f0f6d$var$R));
var $39c5346b7e5f0f6d$var$gt = {
    classic: {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
    },
    duotone: {
        900: "fad",
        400: "fadr",
        300: "fadl",
        100: "fadt"
    },
    sharp: {
        900: "fass",
        400: "fasr",
        300: "fasl",
        100: "fast"
    },
    "sharp-duotone": {
        900: "fasds",
        400: "fasdr",
        300: "fasdl",
        100: "fasdt"
    },
    slab: {
        400: "faslr"
    },
    "slab-press": {
        400: "faslpr"
    },
    whiteboard: {
        600: "fawsb"
    },
    thumbprint: {
        300: "fatl"
    },
    notdog: {
        900: "fans"
    },
    "notdog-duo": {
        900: "fands"
    },
    etch: {
        900: "faes"
    },
    chisel: {
        400: "facr"
    },
    jelly: {
        400: "fajr"
    },
    "jelly-fill": {
        400: "fajfr"
    },
    "jelly-duo": {
        400: "fajdr"
    },
    utility: {
        600: "fausb"
    },
    "utility-duo": {
        600: "faudsb"
    },
    "utility-fill": {
        600: "faufsb"
    }
};
var $39c5346b7e5f0f6d$var$Ct = {
    "Font Awesome 7 Free": {
        900: "fas",
        400: "far"
    },
    "Font Awesome 7 Pro": {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
    },
    "Font Awesome 7 Brands": {
        400: "fab",
        normal: "fab"
    },
    "Font Awesome 7 Duotone": {
        900: "fad",
        400: "fadr",
        normal: "fadr",
        300: "fadl",
        100: "fadt"
    },
    "Font Awesome 7 Sharp": {
        900: "fass",
        400: "fasr",
        normal: "fasr",
        300: "fasl",
        100: "fast"
    },
    "Font Awesome 7 Sharp Duotone": {
        900: "fasds",
        400: "fasdr",
        normal: "fasdr",
        300: "fasdl",
        100: "fasdt"
    },
    "Font Awesome 7 Jelly": {
        400: "fajr",
        normal: "fajr"
    },
    "Font Awesome 7 Jelly Fill": {
        400: "fajfr",
        normal: "fajfr"
    },
    "Font Awesome 7 Jelly Duo": {
        400: "fajdr",
        normal: "fajdr"
    },
    "Font Awesome 7 Slab": {
        400: "faslr",
        normal: "faslr"
    },
    "Font Awesome 7 Slab Press": {
        400: "faslpr",
        normal: "faslpr"
    },
    "Font Awesome 7 Thumbprint": {
        300: "fatl",
        normal: "fatl"
    },
    "Font Awesome 7 Notdog": {
        900: "fans",
        normal: "fans"
    },
    "Font Awesome 7 Notdog Duo": {
        900: "fands",
        normal: "fands"
    },
    "Font Awesome 7 Etch": {
        900: "faes",
        normal: "faes"
    },
    "Font Awesome 7 Chisel": {
        400: "facr",
        normal: "facr"
    },
    "Font Awesome 7 Whiteboard": {
        600: "fawsb",
        normal: "fawsb"
    },
    "Font Awesome 7 Utility": {
        600: "fausb",
        normal: "fausb"
    },
    "Font Awesome 7 Utility Duo": {
        600: "faudsb",
        normal: "faudsb"
    },
    "Font Awesome 7 Utility Fill": {
        600: "faufsb",
        normal: "faufsb"
    }
};
var $39c5346b7e5f0f6d$var$Ut = new Map([
    [
        "classic",
        {
            defaultShortPrefixId: "fas",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin",
                "brands"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "duotone",
        {
            defaultShortPrefixId: "fad",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "sharp",
        {
            defaultShortPrefixId: "fass",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "sharp-duotone",
        {
            defaultShortPrefixId: "fasds",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "chisel",
        {
            defaultShortPrefixId: "facr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "etch",
        {
            defaultShortPrefixId: "faes",
            defaultStyleId: "solid",
            styleIds: [
                "solid"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "jelly",
        {
            defaultShortPrefixId: "fajr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "jelly-duo",
        {
            defaultShortPrefixId: "fajdr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "jelly-fill",
        {
            defaultShortPrefixId: "fajfr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "notdog",
        {
            defaultShortPrefixId: "fans",
            defaultStyleId: "solid",
            styleIds: [
                "solid"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "notdog-duo",
        {
            defaultShortPrefixId: "fands",
            defaultStyleId: "solid",
            styleIds: [
                "solid"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "slab",
        {
            defaultShortPrefixId: "faslr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "slab-press",
        {
            defaultShortPrefixId: "faslpr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "thumbprint",
        {
            defaultShortPrefixId: "fatl",
            defaultStyleId: "light",
            styleIds: [
                "light"
            ],
            futureStyleIds: [],
            defaultFontWeight: 300
        }
    ],
    [
        "utility",
        {
            defaultShortPrefixId: "fausb",
            defaultStyleId: "semibold",
            styleIds: [
                "semibold"
            ],
            futureStyleIds: [],
            defaultFontWeight: 600
        }
    ],
    [
        "utility-duo",
        {
            defaultShortPrefixId: "faudsb",
            defaultStyleId: "semibold",
            styleIds: [
                "semibold"
            ],
            futureStyleIds: [],
            defaultFontWeight: 600
        }
    ],
    [
        "utility-fill",
        {
            defaultShortPrefixId: "faufsb",
            defaultStyleId: "semibold",
            styleIds: [
                "semibold"
            ],
            futureStyleIds: [],
            defaultFontWeight: 600
        }
    ],
    [
        "whiteboard",
        {
            defaultShortPrefixId: "fawsb",
            defaultStyleId: "semibold",
            styleIds: [
                "semibold"
            ],
            futureStyleIds: [],
            defaultFontWeight: 600
        }
    ]
]), $39c5346b7e5f0f6d$var$_t = {
    chisel: {
        regular: "facr"
    },
    classic: {
        brands: "fab",
        light: "fal",
        regular: "far",
        solid: "fas",
        thin: "fat"
    },
    duotone: {
        light: "fadl",
        regular: "fadr",
        solid: "fad",
        thin: "fadt"
    },
    etch: {
        solid: "faes"
    },
    jelly: {
        regular: "fajr"
    },
    "jelly-duo": {
        regular: "fajdr"
    },
    "jelly-fill": {
        regular: "fajfr"
    },
    notdog: {
        solid: "fans"
    },
    "notdog-duo": {
        solid: "fands"
    },
    sharp: {
        light: "fasl",
        regular: "fasr",
        solid: "fass",
        thin: "fast"
    },
    "sharp-duotone": {
        light: "fasdl",
        regular: "fasdr",
        solid: "fasds",
        thin: "fasdt"
    },
    slab: {
        regular: "faslr"
    },
    "slab-press": {
        regular: "faslpr"
    },
    thumbprint: {
        light: "fatl"
    },
    utility: {
        semibold: "fausb"
    },
    "utility-duo": {
        semibold: "faudsb"
    },
    "utility-fill": {
        semibold: "faufsb"
    },
    whiteboard: {
        semibold: "fawsb"
    }
};
var $39c5346b7e5f0f6d$var$Yt = [
    "fak",
    "fa-kit",
    "fakd",
    "fa-kit-duotone"
], $39c5346b7e5f0f6d$var$qt = {
    kit: {
        fak: "kit",
        "fa-kit": "kit"
    },
    "kit-duotone": {
        fakd: "kit-duotone",
        "fa-kit-duotone": "kit-duotone"
    }
}, $39c5346b7e5f0f6d$var$Ht = [
    "kit"
];
var $39c5346b7e5f0f6d$var$L = "kit", $39c5346b7e5f0f6d$var$r = "kit-duotone", $39c5346b7e5f0f6d$var$U = "Kit", $39c5346b7e5f0f6d$var$J = "Kit Duotone", $39c5346b7e5f0f6d$var$$t = $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty({}, $39c5346b7e5f0f6d$var$L, $39c5346b7e5f0f6d$var$U), $39c5346b7e5f0f6d$var$r, $39c5346b7e5f0f6d$var$J);
var $39c5346b7e5f0f6d$var$ol = {
    kit: {
        "fa-kit": "fak"
    },
    "kit-duotone": {
        "fa-kit-duotone": "fakd"
    }
};
var $39c5346b7e5f0f6d$var$dl = {
    "Font Awesome Kit": {
        400: "fak",
        normal: "fak"
    },
    "Font Awesome Kit Duotone": {
        400: "fakd",
        normal: "fakd"
    }
}, $39c5346b7e5f0f6d$var$fl = {
    kit: {
        fak: "fa-kit"
    },
    "kit-duotone": {
        fakd: "fa-kit-duotone"
    }
};
var $39c5346b7e5f0f6d$var$ul = {
    kit: {
        kit: "fak"
    },
    "kit-duotone": {
        "kit-duotone": "fakd"
    }
};
var $39c5346b7e5f0f6d$var$_ml;
var $39c5346b7e5f0f6d$var$l$1 = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
}, $39c5346b7e5f0f6d$var$f$1 = [
    "fa-classic",
    "fa-duotone",
    "fa-sharp",
    "fa-sharp-duotone",
    "fa-thumbprint",
    "fa-whiteboard",
    "fa-notdog",
    "fa-notdog-duo",
    "fa-chisel",
    "fa-etch",
    "fa-jelly",
    "fa-jelly-fill",
    "fa-jelly-duo",
    "fa-slab",
    "fa-slab-press",
    "fa-utility",
    "fa-utility-duo",
    "fa-utility-fill"
];
var $39c5346b7e5f0f6d$var$n$1 = "classic", $39c5346b7e5f0f6d$var$o$1 = "duotone", $39c5346b7e5f0f6d$var$u$1 = "sharp", $39c5346b7e5f0f6d$var$s$1 = "sharp-duotone", $39c5346b7e5f0f6d$var$h$1 = "chisel", $39c5346b7e5f0f6d$var$g$1 = "etch", $39c5346b7e5f0f6d$var$y$1 = "jelly", $39c5346b7e5f0f6d$var$e$1 = "jelly-duo", $39c5346b7e5f0f6d$var$m$1 = "jelly-fill", $39c5346b7e5f0f6d$var$p$1 = "notdog", $39c5346b7e5f0f6d$var$a$1 = "notdog-duo", $39c5346b7e5f0f6d$var$w$1 = "slab", $39c5346b7e5f0f6d$var$b$1 = "slab-press", $39c5346b7e5f0f6d$var$r$1 = "thumbprint", $39c5346b7e5f0f6d$var$c$1 = "utility", $39c5346b7e5f0f6d$var$i$1 = "utility-duo", $39c5346b7e5f0f6d$var$x$1 = "utility-fill", $39c5346b7e5f0f6d$var$I$1 = "whiteboard", $39c5346b7e5f0f6d$var$F$1 = "Classic", $39c5346b7e5f0f6d$var$v$1 = "Duotone", $39c5346b7e5f0f6d$var$S$1 = "Sharp", $39c5346b7e5f0f6d$var$A$1 = "Sharp Duotone", $39c5346b7e5f0f6d$var$P$1 = "Chisel", $39c5346b7e5f0f6d$var$j$1 = "Etch", $39c5346b7e5f0f6d$var$B$1 = "Jelly", $39c5346b7e5f0f6d$var$N$1 = "Jelly Duo", $39c5346b7e5f0f6d$var$k$1 = "Jelly Fill", $39c5346b7e5f0f6d$var$D$1 = "Notdog", $39c5346b7e5f0f6d$var$C$1 = "Notdog Duo", $39c5346b7e5f0f6d$var$T$1 = "Slab", $39c5346b7e5f0f6d$var$L$1 = "Slab Press", $39c5346b7e5f0f6d$var$W$1 = "Thumbprint", $39c5346b7e5f0f6d$var$R$1 = "Utility", $39c5346b7e5f0f6d$var$K$1 = "Utility Duo", $39c5346b7e5f0f6d$var$U$1 = "Utility Fill", $39c5346b7e5f0f6d$var$J$1 = "Whiteboard", $39c5346b7e5f0f6d$var$ml$1 = ($39c5346b7e5f0f6d$var$_ml = {}, $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_ml, $39c5346b7e5f0f6d$var$n$1, $39c5346b7e5f0f6d$var$F$1), $39c5346b7e5f0f6d$var$o$1, $39c5346b7e5f0f6d$var$v$1), $39c5346b7e5f0f6d$var$u$1, $39c5346b7e5f0f6d$var$S$1), $39c5346b7e5f0f6d$var$s$1, $39c5346b7e5f0f6d$var$A$1), $39c5346b7e5f0f6d$var$h$1, $39c5346b7e5f0f6d$var$P$1), $39c5346b7e5f0f6d$var$g$1, $39c5346b7e5f0f6d$var$j$1), $39c5346b7e5f0f6d$var$y$1, $39c5346b7e5f0f6d$var$B$1), $39c5346b7e5f0f6d$var$e$1, $39c5346b7e5f0f6d$var$N$1), $39c5346b7e5f0f6d$var$m$1, $39c5346b7e5f0f6d$var$k$1), $39c5346b7e5f0f6d$var$p$1, $39c5346b7e5f0f6d$var$D$1), $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_ml, $39c5346b7e5f0f6d$var$a$1, $39c5346b7e5f0f6d$var$C$1), $39c5346b7e5f0f6d$var$w$1, $39c5346b7e5f0f6d$var$T$1), $39c5346b7e5f0f6d$var$b$1, $39c5346b7e5f0f6d$var$L$1), $39c5346b7e5f0f6d$var$r$1, $39c5346b7e5f0f6d$var$W$1), $39c5346b7e5f0f6d$var$c$1, $39c5346b7e5f0f6d$var$R$1), $39c5346b7e5f0f6d$var$i$1, $39c5346b7e5f0f6d$var$K$1), $39c5346b7e5f0f6d$var$x$1, $39c5346b7e5f0f6d$var$U$1), $39c5346b7e5f0f6d$var$I$1, $39c5346b7e5f0f6d$var$J$1));
var $39c5346b7e5f0f6d$var$E$1 = "kit", $39c5346b7e5f0f6d$var$d$1 = "kit-duotone", $39c5346b7e5f0f6d$var$_$1 = "Kit", $39c5346b7e5f0f6d$var$M$1 = "Kit Duotone", $39c5346b7e5f0f6d$var$rt$1 = $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty({}, $39c5346b7e5f0f6d$var$E$1, $39c5346b7e5f0f6d$var$_$1), $39c5346b7e5f0f6d$var$d$1, $39c5346b7e5f0f6d$var$M$1);
var $39c5346b7e5f0f6d$var$$t$1 = {
    classic: {
        "fa-brands": "fab",
        "fa-duotone": "fad",
        "fa-light": "fal",
        "fa-regular": "far",
        "fa-solid": "fas",
        "fa-thin": "fat"
    },
    duotone: {
        "fa-regular": "fadr",
        "fa-light": "fadl",
        "fa-thin": "fadt"
    },
    sharp: {
        "fa-solid": "fass",
        "fa-regular": "fasr",
        "fa-light": "fasl",
        "fa-thin": "fast"
    },
    "sharp-duotone": {
        "fa-solid": "fasds",
        "fa-regular": "fasdr",
        "fa-light": "fasdl",
        "fa-thin": "fasdt"
    },
    slab: {
        "fa-regular": "faslr"
    },
    "slab-press": {
        "fa-regular": "faslpr"
    },
    whiteboard: {
        "fa-semibold": "fawsb"
    },
    thumbprint: {
        "fa-light": "fatl"
    },
    notdog: {
        "fa-solid": "fans"
    },
    "notdog-duo": {
        "fa-solid": "fands"
    },
    etch: {
        "fa-solid": "faes"
    },
    jelly: {
        "fa-regular": "fajr"
    },
    "jelly-fill": {
        "fa-regular": "fajfr"
    },
    "jelly-duo": {
        "fa-regular": "fajdr"
    },
    chisel: {
        "fa-regular": "facr"
    },
    utility: {
        "fa-semibold": "fausb"
    },
    "utility-duo": {
        "fa-semibold": "faudsb"
    },
    "utility-fill": {
        "fa-semibold": "faufsb"
    }
}, $39c5346b7e5f0f6d$var$z = {
    classic: [
        "fas",
        "far",
        "fal",
        "fat",
        "fad"
    ],
    duotone: [
        "fadr",
        "fadl",
        "fadt"
    ],
    sharp: [
        "fass",
        "fasr",
        "fasl",
        "fast"
    ],
    "sharp-duotone": [
        "fasds",
        "fasdr",
        "fasdl",
        "fasdt"
    ],
    slab: [
        "faslr"
    ],
    "slab-press": [
        "faslpr"
    ],
    whiteboard: [
        "fawsb"
    ],
    thumbprint: [
        "fatl"
    ],
    notdog: [
        "fans"
    ],
    "notdog-duo": [
        "fands"
    ],
    etch: [
        "faes"
    ],
    jelly: [
        "fajr"
    ],
    "jelly-fill": [
        "fajfr"
    ],
    "jelly-duo": [
        "fajdr"
    ],
    chisel: [
        "facr"
    ],
    utility: [
        "fausb"
    ],
    "utility-duo": [
        "faudsb"
    ],
    "utility-fill": [
        "faufsb"
    ]
}, $39c5346b7e5f0f6d$var$Ht$1 = {
    classic: {
        fab: "fa-brands",
        fad: "fa-duotone",
        fal: "fa-light",
        far: "fa-regular",
        fas: "fa-solid",
        fat: "fa-thin"
    },
    duotone: {
        fadr: "fa-regular",
        fadl: "fa-light",
        fadt: "fa-thin"
    },
    sharp: {
        fass: "fa-solid",
        fasr: "fa-regular",
        fasl: "fa-light",
        fast: "fa-thin"
    },
    "sharp-duotone": {
        fasds: "fa-solid",
        fasdr: "fa-regular",
        fasdl: "fa-light",
        fasdt: "fa-thin"
    },
    slab: {
        faslr: "fa-regular"
    },
    "slab-press": {
        faslpr: "fa-regular"
    },
    whiteboard: {
        fawsb: "fa-semibold"
    },
    thumbprint: {
        fatl: "fa-light"
    },
    notdog: {
        fans: "fa-solid"
    },
    "notdog-duo": {
        fands: "fa-solid"
    },
    etch: {
        faes: "fa-solid"
    },
    jelly: {
        fajr: "fa-regular"
    },
    "jelly-fill": {
        fajfr: "fa-regular"
    },
    "jelly-duo": {
        fajdr: "fa-regular"
    },
    chisel: {
        facr: "fa-regular"
    },
    utility: {
        fausb: "fa-semibold"
    },
    "utility-duo": {
        faudsb: "fa-semibold"
    },
    "utility-fill": {
        faufsb: "fa-semibold"
    }
}, $39c5346b7e5f0f6d$var$Y$1 = [
    "fa-solid",
    "fa-regular",
    "fa-light",
    "fa-thin",
    "fa-duotone",
    "fa-brands",
    "fa-semibold"
], $39c5346b7e5f0f6d$var$Zt$1 = [
    "fa",
    "fas",
    "far",
    "fal",
    "fat",
    "fad",
    "fadr",
    "fadl",
    "fadt",
    "fab",
    "fass",
    "fasr",
    "fasl",
    "fast",
    "fasds",
    "fasdr",
    "fasdl",
    "fasdt",
    "faslr",
    "faslpr",
    "fawsb",
    "fatl",
    "fans",
    "fands",
    "faes",
    "fajr",
    "fajfr",
    "fajdr",
    "facr",
    "fausb",
    "faudsb",
    "faufsb"
].concat($39c5346b7e5f0f6d$var$f$1, $39c5346b7e5f0f6d$var$Y$1), $39c5346b7e5f0f6d$var$G$1 = [
    "solid",
    "regular",
    "light",
    "thin",
    "duotone",
    "brands",
    "semibold"
], $39c5346b7e5f0f6d$var$O$1 = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
], $39c5346b7e5f0f6d$var$V$1 = $39c5346b7e5f0f6d$var$O$1.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]), $39c5346b7e5f0f6d$var$$$1 = [
    "aw",
    "fw",
    "pull-left",
    "pull-right"
], $39c5346b7e5f0f6d$var$to = [].concat($39c5346b7e5f0f6d$var$_toConsumableArray(Object.keys($39c5346b7e5f0f6d$var$z)), $39c5346b7e5f0f6d$var$G$1, $39c5346b7e5f0f6d$var$$$1, [
    "2xs",
    "xs",
    "sm",
    "lg",
    "xl",
    "2xl",
    "beat",
    "border",
    "fade",
    "beat-fade",
    "bounce",
    "flip-both",
    "flip-horizontal",
    "flip-vertical",
    "flip",
    "inverse",
    "layers",
    "layers-bottom-left",
    "layers-bottom-right",
    "layers-counter",
    "layers-text",
    "layers-top-left",
    "layers-top-right",
    "li",
    "pull-end",
    "pull-start",
    "pulse",
    "rotate-180",
    "rotate-270",
    "rotate-90",
    "rotate-by",
    "shake",
    "spin-pulse",
    "spin-reverse",
    "spin",
    "stack-1x",
    "stack-2x",
    "stack",
    "ul",
    "width-auto",
    "width-fixed",
    $39c5346b7e5f0f6d$var$l$1.GROUP,
    $39c5346b7e5f0f6d$var$l$1.SWAP_OPACITY,
    $39c5346b7e5f0f6d$var$l$1.PRIMARY,
    $39c5346b7e5f0f6d$var$l$1.SECONDARY
]).concat($39c5346b7e5f0f6d$var$O$1.map(function(t) {
    return "".concat(t, "x");
})).concat($39c5346b7e5f0f6d$var$V$1.map(function(t) {
    return "w-".concat(t);
}));
var $39c5346b7e5f0f6d$var$ro = {
    "Font Awesome 5 Free": {
        900: "fas",
        400: "far"
    },
    "Font Awesome 5 Pro": {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal"
    },
    "Font Awesome 5 Brands": {
        400: "fab",
        normal: "fab"
    },
    "Font Awesome 5 Duotone": {
        900: "fad"
    }
};
var $39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var $39c5346b7e5f0f6d$var$UNITS_IN_GRID = 16;
var $39c5346b7e5f0f6d$var$DEFAULT_CSS_PREFIX = 'fa';
var $39c5346b7e5f0f6d$var$DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var $39c5346b7e5f0f6d$var$DATA_FA_I2SVG = 'data-fa-i2svg';
var $39c5346b7e5f0f6d$var$DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
var $39c5346b7e5f0f6d$var$DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
var $39c5346b7e5f0f6d$var$DATA_PREFIX = 'data-prefix';
var $39c5346b7e5f0f6d$var$DATA_ICON = 'data-icon';
var $39c5346b7e5f0f6d$var$HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
var $39c5346b7e5f0f6d$var$MUTATION_APPROACH_ASYNC = 'async';
var $39c5346b7e5f0f6d$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    'HTML',
    'HEAD',
    'STYLE',
    'SCRIPT'
];
var $39c5346b7e5f0f6d$var$PSEUDO_ELEMENTS = [
    '::before',
    '::after',
    ':before',
    ':after'
];
var $39c5346b7e5f0f6d$var$PRODUCTION = function() {
    try {
        return true;
    } catch (e$$1) {
        return false;
    }
}();
function $39c5346b7e5f0f6d$var$familyProxy(obj) {
    // Defaults to the classic family if family is not available
    return new Proxy(obj, {
        get: function get(target, prop) {
            return prop in target ? target[prop] : target[$39c5346b7e5f0f6d$var$i];
        }
    });
}
var $39c5346b7e5f0f6d$var$_PREFIX_TO_STYLE = $39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$q);
// We changed FACSSClassesToStyleId in the icons repo to be canonical and as such, "classic" family does not have any
// duotone styles.  But we do still need duotone in _PREFIX_TO_STYLE below, so we are manually adding
// {'fa-duotone': 'duotone'}
$39c5346b7e5f0f6d$var$_PREFIX_TO_STYLE[$39c5346b7e5f0f6d$var$i] = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, {
    'fa-duotone': 'duotone'
}), $39c5346b7e5f0f6d$var$q[$39c5346b7e5f0f6d$var$i]), $39c5346b7e5f0f6d$var$qt['kit']), $39c5346b7e5f0f6d$var$qt['kit-duotone']);
var $39c5346b7e5f0f6d$var$PREFIX_TO_STYLE = $39c5346b7e5f0f6d$var$familyProxy($39c5346b7e5f0f6d$var$_PREFIX_TO_STYLE);
var $39c5346b7e5f0f6d$var$_STYLE_TO_PREFIX = $39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$_t);
// We changed FAStyleIdToShortPrefixId in the icons repo to be canonical and as such, "classic" family does not have any
// duotone styles.  But we do still need duotone in _STYLE_TO_PREFIX below, so we are manually adding {duotone: 'fad'}
$39c5346b7e5f0f6d$var$_STYLE_TO_PREFIX[$39c5346b7e5f0f6d$var$i] = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, {
    duotone: 'fad'
}), $39c5346b7e5f0f6d$var$_STYLE_TO_PREFIX[$39c5346b7e5f0f6d$var$i]), $39c5346b7e5f0f6d$var$ul['kit']), $39c5346b7e5f0f6d$var$ul['kit-duotone']);
var $39c5346b7e5f0f6d$var$STYLE_TO_PREFIX = $39c5346b7e5f0f6d$var$familyProxy($39c5346b7e5f0f6d$var$_STYLE_TO_PREFIX);
var $39c5346b7e5f0f6d$var$_PREFIX_TO_LONG_STYLE = $39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$Ht$1);
$39c5346b7e5f0f6d$var$_PREFIX_TO_LONG_STYLE[$39c5346b7e5f0f6d$var$i] = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$_PREFIX_TO_LONG_STYLE[$39c5346b7e5f0f6d$var$i]), $39c5346b7e5f0f6d$var$fl['kit']);
var $39c5346b7e5f0f6d$var$PREFIX_TO_LONG_STYLE = $39c5346b7e5f0f6d$var$familyProxy($39c5346b7e5f0f6d$var$_PREFIX_TO_LONG_STYLE);
var $39c5346b7e5f0f6d$var$_LONG_STYLE_TO_PREFIX = $39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$$t$1);
$39c5346b7e5f0f6d$var$_LONG_STYLE_TO_PREFIX[$39c5346b7e5f0f6d$var$i] = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$_LONG_STYLE_TO_PREFIX[$39c5346b7e5f0f6d$var$i]), $39c5346b7e5f0f6d$var$ol['kit']);
var $39c5346b7e5f0f6d$var$LONG_STYLE_TO_PREFIX = $39c5346b7e5f0f6d$var$familyProxy($39c5346b7e5f0f6d$var$_LONG_STYLE_TO_PREFIX);
var $39c5346b7e5f0f6d$var$ICON_SELECTION_SYNTAX_PATTERN = $39c5346b7e5f0f6d$var$E;
var $39c5346b7e5f0f6d$var$LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
var $39c5346b7e5f0f6d$var$FONT_FAMILY_PATTERN = $39c5346b7e5f0f6d$var$_;
var $39c5346b7e5f0f6d$var$_FONT_WEIGHT_TO_PREFIX = $39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$gt);
var $39c5346b7e5f0f6d$var$FONT_WEIGHT_TO_PREFIX = $39c5346b7e5f0f6d$var$familyProxy($39c5346b7e5f0f6d$var$_FONT_WEIGHT_TO_PREFIX);
var $39c5346b7e5f0f6d$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    'class',
    'data-prefix',
    'data-icon',
    'data-fa-transform',
    'data-fa-mask'
];
var $39c5346b7e5f0f6d$var$DUOTONE_CLASSES = $39c5346b7e5f0f6d$var$H;
var $39c5346b7e5f0f6d$var$RESERVED_CLASSES = [].concat($39c5346b7e5f0f6d$var$_toConsumableArray($39c5346b7e5f0f6d$var$Ht), $39c5346b7e5f0f6d$var$_toConsumableArray($39c5346b7e5f0f6d$var$to));
var $39c5346b7e5f0f6d$var$initial = $39c5346b7e5f0f6d$var$WINDOW.FontAwesomeConfig || {};
function $39c5346b7e5f0f6d$var$getAttrConfig(attr) {
    var element = $39c5346b7e5f0f6d$var$DOCUMENT.querySelector('script[' + attr + ']');
    if (element) return element.getAttribute(attr);
}
function $39c5346b7e5f0f6d$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    if (val === '') return true;
    if (val === 'false') return false;
    if (val === 'true') return true;
    return val;
}
if ($39c5346b7e5f0f6d$var$DOCUMENT && typeof $39c5346b7e5f0f6d$var$DOCUMENT.querySelector === 'function') {
    var $39c5346b7e5f0f6d$var$attrs = [
        [
            'data-family-prefix',
            'familyPrefix'
        ],
        [
            'data-css-prefix',
            'cssPrefix'
        ],
        [
            'data-family-default',
            'familyDefault'
        ],
        [
            'data-style-default',
            'styleDefault'
        ],
        [
            'data-replacement-class',
            'replacementClass'
        ],
        [
            'data-auto-replace-svg',
            'autoReplaceSvg'
        ],
        [
            'data-auto-add-css',
            'autoAddCss'
        ],
        [
            'data-search-pseudo-elements',
            'searchPseudoElements'
        ],
        [
            'data-search-pseudo-elements-warnings',
            'searchPseudoElementsWarnings'
        ],
        [
            'data-search-pseudo-elements-full-scan',
            'searchPseudoElementsFullScan'
        ],
        [
            'data-observe-mutations',
            'observeMutations'
        ],
        [
            'data-mutate-approach',
            'mutateApproach'
        ],
        [
            'data-keep-original-source',
            'keepOriginalSource'
        ],
        [
            'data-measure-performance',
            'measurePerformance'
        ],
        [
            'data-show-missing-icons',
            'showMissingIcons'
        ]
    ];
    $39c5346b7e5f0f6d$var$attrs.forEach(function(_ref) {
        var _ref2 = $39c5346b7e5f0f6d$var$_slicedToArray(_ref, 2), attr = _ref2[0], key = _ref2[1];
        var val = $39c5346b7e5f0f6d$var$coerce($39c5346b7e5f0f6d$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $39c5346b7e5f0f6d$var$initial[key] = val;
    });
}
var $39c5346b7e5f0f6d$var$_default = {
    styleDefault: 'solid',
    familyDefault: $39c5346b7e5f0f6d$var$i,
    cssPrefix: $39c5346b7e5f0f6d$var$DEFAULT_CSS_PREFIX,
    replacementClass: $39c5346b7e5f0f6d$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    searchPseudoElements: false,
    searchPseudoElementsWarnings: true,
    searchPseudoElementsFullScan: false,
    observeMutations: true,
    mutateApproach: 'async',
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
};
// familyPrefix is deprecated but we must still support it if present
if ($39c5346b7e5f0f6d$var$initial.familyPrefix) $39c5346b7e5f0f6d$var$initial.cssPrefix = $39c5346b7e5f0f6d$var$initial.familyPrefix;
var $39c5346b7e5f0f6d$var$_config = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$_default), $39c5346b7e5f0f6d$var$initial);
if (!$39c5346b7e5f0f6d$var$_config.autoReplaceSvg) $39c5346b7e5f0f6d$var$_config.observeMutations = false;
var $39c5346b7e5f0f6d$var$config = {};
Object.keys($39c5346b7e5f0f6d$var$_default).forEach(function(key) {
    Object.defineProperty($39c5346b7e5f0f6d$var$config, key, {
        enumerable: true,
        set: function set(val) {
            $39c5346b7e5f0f6d$var$_config[key] = val;
            $39c5346b7e5f0f6d$var$_onChangeCb.forEach(function(cb) {
                return cb($39c5346b7e5f0f6d$var$config);
            });
        },
        get: function get() {
            return $39c5346b7e5f0f6d$var$_config[key];
        }
    });
});
// familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0
Object.defineProperty($39c5346b7e5f0f6d$var$config, 'familyPrefix', {
    enumerable: true,
    set: function set(val) {
        $39c5346b7e5f0f6d$var$_config.cssPrefix = val;
        $39c5346b7e5f0f6d$var$_onChangeCb.forEach(function(cb) {
            return cb($39c5346b7e5f0f6d$var$config);
        });
    },
    get: function get() {
        return $39c5346b7e5f0f6d$var$_config.cssPrefix;
    }
});
$39c5346b7e5f0f6d$var$WINDOW.FontAwesomeConfig = $39c5346b7e5f0f6d$var$config;
var $39c5346b7e5f0f6d$var$_onChangeCb = [];
function $39c5346b7e5f0f6d$var$onChange(cb) {
    $39c5346b7e5f0f6d$var$_onChangeCb.push(cb);
    return function() {
        $39c5346b7e5f0f6d$var$_onChangeCb.splice($39c5346b7e5f0f6d$var$_onChangeCb.indexOf(cb), 1);
    };
}
var $39c5346b7e5f0f6d$var$d$2 = $39c5346b7e5f0f6d$var$UNITS_IN_GRID;
var $39c5346b7e5f0f6d$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $39c5346b7e5f0f6d$var$insertCss(css) {
    if (!css || !$39c5346b7e5f0f6d$var$IS_DOM) return;
    var style = $39c5346b7e5f0f6d$var$DOCUMENT.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    var headChildren = $39c5346b7e5f0f6d$var$DOCUMENT.head.childNodes;
    var beforeChild = null;
    for(var i = headChildren.length - 1; i > -1; i--){
        var child = headChildren[i];
        var tagName = (child.tagName || '').toUpperCase();
        if ([
            'STYLE',
            'LINK'
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $39c5346b7e5f0f6d$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
var $39c5346b7e5f0f6d$var$idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function $39c5346b7e5f0f6d$var$nextUniqueId() {
    var size = 12;
    var id = '';
    while(size-- > 0)id += $39c5346b7e5f0f6d$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $39c5346b7e5f0f6d$var$toArray(obj) {
    var array = [];
    for(var i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $39c5346b7e5f0f6d$var$classArray(node) {
    if (node.classList) return $39c5346b7e5f0f6d$var$toArray(node.classList);
    else return (node.getAttribute('class') || '').split(' ').filter(function(i) {
        return i;
    });
}
function $39c5346b7e5f0f6d$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function $39c5346b7e5f0f6d$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
        return acc + "".concat(attributeName, "=\"").concat($39c5346b7e5f0f6d$var$htmlEscape(attributes[attributeName]), "\" ");
    }, '').trim();
}
function $39c5346b7e5f0f6d$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce(function(acc, styleName) {
        return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
    }, '');
}
function $39c5346b7e5f0f6d$var$transformIsMeaningful(transform) {
    return transform.size !== $39c5346b7e5f0f6d$var$meaninglessTransform.size || transform.x !== $39c5346b7e5f0f6d$var$meaninglessTransform.x || transform.y !== $39c5346b7e5f0f6d$var$meaninglessTransform.y || transform.rotate !== $39c5346b7e5f0f6d$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $39c5346b7e5f0f6d$var$transformForSvg(_ref) {
    var transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
    var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $39c5346b7e5f0f6d$var$transformForCss(_ref2) {
    var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? $39c5346b7e5f0f6d$var$UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? $39c5346b7e5f0f6d$var$UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
    var val = '';
    if (startCentered && $39c5346b7e5f0f6d$var$IS_IE) val += "translate(".concat(transform.x / $39c5346b7e5f0f6d$var$d$2 - width / 2, "em, ").concat(transform.y / $39c5346b7e5f0f6d$var$d$2 - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $39c5346b7e5f0f6d$var$d$2, "em), calc(-50% + ").concat(transform.y / $39c5346b7e5f0f6d$var$d$2, "em)) ");
    else val += "translate(".concat(transform.x / $39c5346b7e5f0f6d$var$d$2, "em, ").concat(transform.y / $39c5346b7e5f0f6d$var$d$2, "em) ");
    val += "scale(".concat(transform.size / $39c5346b7e5f0f6d$var$d$2 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $39c5346b7e5f0f6d$var$d$2 * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $39c5346b7e5f0f6d$var$baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 7 Free\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 7 Free\";\n  --fa-font-light: normal 300 1em/1 \"Font Awesome 7 Pro\";\n  --fa-font-thin: normal 100 1em/1 \"Font Awesome 7 Pro\";\n  --fa-font-duotone: normal 900 1em/1 \"Font Awesome 7 Duotone\";\n  --fa-font-duotone-regular: normal 400 1em/1 \"Font Awesome 7 Duotone\";\n  --fa-font-duotone-light: normal 300 1em/1 \"Font Awesome 7 Duotone\";\n  --fa-font-duotone-thin: normal 100 1em/1 \"Font Awesome 7 Duotone\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 7 Brands\";\n  --fa-font-sharp-solid: normal 900 1em/1 \"Font Awesome 7 Sharp\";\n  --fa-font-sharp-regular: normal 400 1em/1 \"Font Awesome 7 Sharp\";\n  --fa-font-sharp-light: normal 300 1em/1 \"Font Awesome 7 Sharp\";\n  --fa-font-sharp-thin: normal 100 1em/1 \"Font Awesome 7 Sharp\";\n  --fa-font-sharp-duotone-solid: normal 900 1em/1 \"Font Awesome 7 Sharp Duotone\";\n  --fa-font-sharp-duotone-regular: normal 400 1em/1 \"Font Awesome 7 Sharp Duotone\";\n  --fa-font-sharp-duotone-light: normal 300 1em/1 \"Font Awesome 7 Sharp Duotone\";\n  --fa-font-sharp-duotone-thin: normal 100 1em/1 \"Font Awesome 7 Sharp Duotone\";\n  --fa-font-slab-regular: normal 400 1em/1 \"Font Awesome 7 Slab\";\n  --fa-font-slab-press-regular: normal 400 1em/1 \"Font Awesome 7 Slab Press\";\n  --fa-font-whiteboard-semibold: normal 600 1em/1 \"Font Awesome 7 Whiteboard\";\n  --fa-font-thumbprint-light: normal 300 1em/1 \"Font Awesome 7 Thumbprint\";\n  --fa-font-notdog-solid: normal 900 1em/1 \"Font Awesome 7 Notdog\";\n  --fa-font-notdog-duo-solid: normal 900 1em/1 \"Font Awesome 7 Notdog Duo\";\n  --fa-font-etch-solid: normal 900 1em/1 \"Font Awesome 7 Etch\";\n  --fa-font-jelly-regular: normal 400 1em/1 \"Font Awesome 7 Jelly\";\n  --fa-font-jelly-fill-regular: normal 400 1em/1 \"Font Awesome 7 Jelly Fill\";\n  --fa-font-jelly-duo-regular: normal 400 1em/1 \"Font Awesome 7 Jelly Duo\";\n  --fa-font-chisel-regular: normal 400 1em/1 \"Font Awesome 7 Chisel\";\n  --fa-font-utility-semibold: normal 600 1em/1 \"Font Awesome 7 Utility\";\n  --fa-font-utility-duo-semibold: normal 600 1em/1 \"Font Awesome 7 Utility Duo\";\n  --fa-font-utility-fill-semibold: normal 600 1em/1 \"Font Awesome 7 Utility Fill\";\n}\n\n.svg-inline--fa {\n  box-sizing: content-box;\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n  width: var(--fa-width, 1.25em);\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285714em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left,\n.svg-inline--fa .fa-pull-start {\n  float: inline-start;\n  margin-inline-end: var(--fa-pull-margin, 0.3em);\n}\n.svg-inline--fa.fa-pull-right,\n.svg-inline--fa .fa-pull-end {\n  float: inline-end;\n  margin-inline-start: var(--fa-pull-margin, 0.3em);\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  inset-inline-start: calc(-1 * var(--fa-li-width, 2em));\n  inset-block-start: 0.25em; /* syncing vertical alignment with Web Font rendering */\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: var(--fa-width, 1.25em);\n}\n.fa-layers .svg-inline--fa {\n  inset: 0;\n  margin: auto;\n  position: absolute;\n  transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-counter-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: calc(10 / 16 * 1em); /* converts a 10px size into an em-based value that's relative to the scale's 16px base */\n  line-height: calc(1 / 10 * 1em); /* sets the line-height of the icon back to that of it's parent */\n  vertical-align: calc((6 / 10 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */\n}\n\n.fa-xs {\n  font-size: calc(12 / 16 * 1em); /* converts a 12px size into an em-based value that's relative to the scale's 16px base */\n  line-height: calc(1 / 12 * 1em); /* sets the line-height of the icon back to that of it's parent */\n  vertical-align: calc((6 / 12 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */\n}\n\n.fa-sm {\n  font-size: calc(14 / 16 * 1em); /* converts a 14px size into an em-based value that's relative to the scale's 16px base */\n  line-height: calc(1 / 14 * 1em); /* sets the line-height of the icon back to that of it's parent */\n  vertical-align: calc((6 / 14 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */\n}\n\n.fa-lg {\n  font-size: calc(20 / 16 * 1em); /* converts a 20px size into an em-based value that's relative to the scale's 16px base */\n  line-height: calc(1 / 20 * 1em); /* sets the line-height of the icon back to that of it's parent */\n  vertical-align: calc((6 / 20 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */\n}\n\n.fa-xl {\n  font-size: calc(24 / 16 * 1em); /* converts a 24px size into an em-based value that's relative to the scale's 16px base */\n  line-height: calc(1 / 24 * 1em); /* sets the line-height of the icon back to that of it's parent */\n  vertical-align: calc((6 / 24 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */\n}\n\n.fa-2xl {\n  font-size: calc(32 / 16 * 1em); /* converts a 32px size into an em-based value that's relative to the scale's 16px base */\n  line-height: calc(1 / 32 * 1em); /* sets the line-height of the icon back to that of it's parent */\n  vertical-align: calc((6 / 32 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */\n}\n\n.fa-width-auto {\n  --fa-width: auto;\n}\n\n.fa-fw,\n.fa-width-fixed {\n  --fa-width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-inline-start: var(--fa-li-margin, 2.5em);\n  padding-inline-start: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  inset-inline-start: calc(-1 * var(--fa-li-width, 2em));\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n/* Heads Up: Bordered Icons will not be supported in the future!\n  - This feature will be deprecated in the next major release of Font Awesome (v8)!\n  - You may continue to use it in this version *v7), but it will not be supported in Font Awesome v8.\n*/\n/* Notes:\n* --@{v.$css-prefix}-border-width = 1/16 by default (to render as ~1px based on a 16px default font-size)\n* --@{v.$css-prefix}-border-padding =\n  ** 3/16 for vertical padding (to give ~2px of vertical whitespace around an icon considering it's vertical alignment)\n  ** 4/16 for horizontal padding (to give ~4px of horizontal whitespace around an icon)\n*/\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.0625em);\n  box-sizing: var(--fa-border-box-sizing, content-box);\n  padding: var(--fa-border-padding, 0.1875em 0.25em);\n}\n\n.fa-pull-left,\n.fa-pull-start {\n  float: inline-start;\n  margin-inline-end: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right,\n.fa-pull-end {\n  float: inline-end;\n  margin-inline-start: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  animation-name: fa-beat;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  animation-name: fa-bounce;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  animation-name: fa-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  animation-name: fa-beat-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  animation-name: fa-flip;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  animation-name: fa-shake;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  animation-name: fa-spin;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 2s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  animation-name: fa-spin;\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n  .fa-bounce,\n  .fa-fade,\n  .fa-beat-fade,\n  .fa-flip,\n  .fa-pulse,\n  .fa-shake,\n  .fa-spin,\n  .fa-spin-pulse {\n    animation: none !important;\n    transition: none !important;\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    transform: scale(1);\n  }\n  45% {\n    transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-shake {\n  0% {\n    transform: rotate(-15deg);\n  }\n  4% {\n    transform: rotate(15deg);\n  }\n  8%, 24% {\n    transform: rotate(-18deg);\n  }\n  12%, 28% {\n    transform: rotate(18deg);\n  }\n  16% {\n    transform: rotate(-22deg);\n  }\n  20% {\n    transform: rotate(22deg);\n  }\n  32% {\n    transform: rotate(-12deg);\n  }\n  36% {\n    transform: rotate(12deg);\n  }\n  40%, 100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  transform: rotate(var(--fa-rotate-angle, 0));\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.svg-inline--fa.fa-inverse {\n  fill: var(--fa-inverse, #fff);\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  line-height: 2em;\n  position: relative;\n  vertical-align: middle;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  --fa-width: 1.25em;\n  height: 1em;\n  width: var(--fa-width);\n}\n.svg-inline--fa.fa-stack-2x {\n  --fa-width: 2.5em;\n  height: 2em;\n  width: var(--fa-width);\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  inset: 0;\n  margin: auto;\n  position: absolute;\n  z-index: var(--fa-stack-z-index, auto);\n}";
function $39c5346b7e5f0f6d$var$css() {
    var dcp = $39c5346b7e5f0f6d$var$DEFAULT_CSS_PREFIX;
    var drc = $39c5346b7e5f0f6d$var$DEFAULT_REPLACEMENT_CLASS;
    var fp = $39c5346b7e5f0f6d$var$config.cssPrefix;
    var rc = $39c5346b7e5f0f6d$var$config.replacementClass;
    var s = $39c5346b7e5f0f6d$var$baseStyles;
    if (fp !== dcp || rc !== drc) {
        var dPatt = new RegExp("\\.".concat(dcp, "\\-"), 'g');
        var customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), 'g');
        var rPatt = new RegExp("\\.".concat(drc), 'g');
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
var $39c5346b7e5f0f6d$var$_cssInserted = false;
function $39c5346b7e5f0f6d$var$ensureCss() {
    if ($39c5346b7e5f0f6d$var$config.autoAddCss && !$39c5346b7e5f0f6d$var$_cssInserted) {
        $39c5346b7e5f0f6d$var$insertCss($39c5346b7e5f0f6d$var$css());
        $39c5346b7e5f0f6d$var$_cssInserted = true;
    }
}
var $39c5346b7e5f0f6d$var$InjectCSS = {
    mixout: function mixout() {
        return {
            dom: {
                css: $39c5346b7e5f0f6d$var$css,
                insertCss: $39c5346b7e5f0f6d$var$ensureCss
            }
        };
    },
    hooks: function hooks() {
        return {
            beforeDOMElementCreation: function beforeDOMElementCreation() {
                $39c5346b7e5f0f6d$var$ensureCss();
            },
            beforeI2svg: function beforeI2svg() {
                $39c5346b7e5f0f6d$var$ensureCss();
            }
        };
    }
};
var $39c5346b7e5f0f6d$var$w$2 = $39c5346b7e5f0f6d$var$WINDOW || {};
if (!$39c5346b7e5f0f6d$var$w$2[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER]) $39c5346b7e5f0f6d$var$w$2[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER] = {};
if (!$39c5346b7e5f0f6d$var$w$2[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER].styles) $39c5346b7e5f0f6d$var$w$2[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$39c5346b7e5f0f6d$var$w$2[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER].hooks) $39c5346b7e5f0f6d$var$w$2[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$39c5346b7e5f0f6d$var$w$2[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER].shims) $39c5346b7e5f0f6d$var$w$2[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER].shims = [];
var $39c5346b7e5f0f6d$var$namespace = $39c5346b7e5f0f6d$var$w$2[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER];
var $39c5346b7e5f0f6d$var$functions = [];
var $39c5346b7e5f0f6d$var$_listener = function listener() {
    $39c5346b7e5f0f6d$var$DOCUMENT.removeEventListener('DOMContentLoaded', $39c5346b7e5f0f6d$var$_listener);
    $39c5346b7e5f0f6d$var$loaded = 1;
    $39c5346b7e5f0f6d$var$functions.map(function(fn) {
        return fn();
    });
};
var $39c5346b7e5f0f6d$var$loaded = false;
if ($39c5346b7e5f0f6d$var$IS_DOM) {
    $39c5346b7e5f0f6d$var$loaded = ($39c5346b7e5f0f6d$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($39c5346b7e5f0f6d$var$DOCUMENT.readyState);
    if (!$39c5346b7e5f0f6d$var$loaded) $39c5346b7e5f0f6d$var$DOCUMENT.addEventListener('DOMContentLoaded', $39c5346b7e5f0f6d$var$_listener);
}
function $39c5346b7e5f0f6d$var$domready(fn) {
    if (!$39c5346b7e5f0f6d$var$IS_DOM) return;
    $39c5346b7e5f0f6d$var$loaded ? setTimeout(fn, 0) : $39c5346b7e5f0f6d$var$functions.push(fn);
}
function $39c5346b7e5f0f6d$var$toHtml(abstractNodes) {
    var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
    if (typeof abstractNodes === 'string') return $39c5346b7e5f0f6d$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($39c5346b7e5f0f6d$var$joinAttributes(attributes), ">").concat(children.map($39c5346b7e5f0f6d$var$toHtml).join(''), "</").concat(tag, ">");
}
function $39c5346b7e5f0f6d$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $39c5346b7e5f0f6d$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $39c5346b7e5f0f6d$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $39c5346b7e5f0f6d$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
/**
 * Return hexadecimal string for a unicode character
 * Returns `null` when more than one character (not bytes!) are passed
 * For example: 'K' → '7B'
 */ function $39c5346b7e5f0f6d$var$toHex(unicode) {
    if ($39c5346b7e5f0f6d$var$_toConsumableArray(unicode).length !== 1) return null;
    return unicode.codePointAt(0).toString(16);
}
function $39c5346b7e5f0f6d$var$normalizeIcons(icons) {
    return Object.keys(icons).reduce(function(acc, iconName) {
        var icon = icons[iconName];
        var expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
}
function $39c5346b7e5f0f6d$var$defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = $39c5346b7e5f0f6d$var$normalizeIcons(icons);
    if (typeof $39c5346b7e5f0f6d$var$namespace.hooks.addPack === 'function' && !skipHooks) $39c5346b7e5f0f6d$var$namespace.hooks.addPack(prefix, $39c5346b7e5f0f6d$var$normalizeIcons(icons));
    else $39c5346b7e5f0f6d$var$namespace.styles[prefix] = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$namespace.styles[prefix] || {}), normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === 'fas') $39c5346b7e5f0f6d$var$defineIcons('fa', icons);
}
var $39c5346b7e5f0f6d$var$MONO = 0x1;
var $39c5346b7e5f0f6d$var$DUO = 0x2;
// New v7 compatible matchers using the style attribute to determine layer membership
var $39c5346b7e5f0f6d$var$modernMatches = [
    [
        $39c5346b7e5f0f6d$var$DUO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path opacity="([^"]*)".*d="([^"]*)".*path.*d="([^"]*)"/, {
            d2: 2,
            d1: 3
        })
    ],
    [
        $39c5346b7e5f0f6d$var$DUO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path opacity="([^"]*)".*d="([^"]*)"/, {
            d2: 2
        })
    ],
    [
        $39c5346b7e5f0f6d$var$MONO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path fill="currentColor".*d="([^"]+)"/, {
            d1: 1
        })
    ]
];
// Old <= v6 matchers, these should rarely get used.
//
// Why are there so many? Over the lifecycle of version 5 and 6 we modified the
// syntax for our source SVG files several times. These patterns match the
// historical record and attempt to handle backwards-compatibility in rare edge
// cases (loading version 6 SVG source files using the version 7 SVG parser)
var $39c5346b7e5f0f6d$var$legacyMatches = [
    [
        $39c5346b7e5f0f6d$var$DUO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path class="([^"]*secondary[^"]*)".*d="([^"]+)".*path class="([^"]*primary[^"]*)".*d="([^"]+)"/, {
            attr2: 1,
            d2: 2,
            attr1: 3,
            d1: 4
        })
    ],
    [
        $39c5346b7e5f0f6d$var$DUO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path class="([^"]*primary[^"]*)".*d="([^"]+)".*path class="([^"]*secondary[^"]*)".*d="([^"]+)"/, {
            attr1: 1,
            d1: 2,
            attr2: 3,
            d2: 4
        })
    ],
    [
        $39c5346b7e5f0f6d$var$DUO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path class="([^"]*primary[^"]*)".*d="([^"]+)"/, {
            attr1: 1,
            d1: 2
        })
    ],
    [
        $39c5346b7e5f0f6d$var$DUO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path class="([^"]*secondary[^"]*)".*d="([^"]+)"/, {
            attr2: 1,
            d2: 2
        })
    ],
    [
        $39c5346b7e5f0f6d$var$DUO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path d="([^"]+)".*class="([^"]*secondary[^"]*)".*path d="([^"]+)".*class="([^"]*primary[^"]*)"/, {
            d2: 1,
            attr2: 2,
            d1: 3,
            attr1: 4
        })
    ],
    [
        $39c5346b7e5f0f6d$var$DUO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path d="([^"]+)".*class="([^"]*primary[^"]*)".*path d="([^"]+)".*class="([^"]*secondary[^"]*)"/, {
            d1: 1,
            attr1: 2,
            d2: 3,
            attr2: 4
        })
    ],
    [
        $39c5346b7e5f0f6d$var$DUO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path d="([^"]+)".*class="([^"]*primary[^"]*)"/, {
            d1: 1,
            attr1: 2
        })
    ],
    [
        $39c5346b7e5f0f6d$var$DUO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path d="([^"]+)".*class="([^"]*secondary[^"]*)"/, {
            d2: 1,
            attr2: 2
        })
    ],
    [
        $39c5346b7e5f0f6d$var$DUO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path d="([^"]+)".*path d="([^"]+)"/, {
            d1: 1,
            d2: 2
        })
    ],
    [
        $39c5346b7e5f0f6d$var$MONO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path d="([^"]+)"/, {
            d1: 1
        })
    ],
    [
        $39c5346b7e5f0f6d$var$MONO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path style="([^"]+)".*d="([^"]+)"/, {
            attr1: 1,
            d1: 2
        })
    ]
];
var $39c5346b7e5f0f6d$var$styles = $39c5346b7e5f0f6d$var$namespace.styles, $39c5346b7e5f0f6d$var$shims = $39c5346b7e5f0f6d$var$namespace.shims;
var $39c5346b7e5f0f6d$var$FAMILY_NAMES = Object.keys($39c5346b7e5f0f6d$var$PREFIX_TO_LONG_STYLE);
var $39c5346b7e5f0f6d$var$PREFIXES_FOR_FAMILY = $39c5346b7e5f0f6d$var$FAMILY_NAMES.reduce(function(acc, familyId) {
    acc[familyId] = Object.keys($39c5346b7e5f0f6d$var$PREFIX_TO_LONG_STYLE[familyId]);
    return acc;
}, {});
var $39c5346b7e5f0f6d$var$_defaultUsablePrefix = null;
var $39c5346b7e5f0f6d$var$_byUnicode = {};
var $39c5346b7e5f0f6d$var$_byLigature = {};
var $39c5346b7e5f0f6d$var$_byOldName = {};
var $39c5346b7e5f0f6d$var$_byOldUnicode = {};
var $39c5346b7e5f0f6d$var$_byAlias = {};
function $39c5346b7e5f0f6d$var$isReserved(name) {
    return ~$39c5346b7e5f0f6d$var$RESERVED_CLASSES.indexOf(name);
}
function $39c5346b7e5f0f6d$var$getIconName(cssPrefix, cls) {
    var parts = cls.split('-');
    var prefix = parts[0];
    var iconName = parts.slice(1).join('-');
    if (prefix === cssPrefix && iconName !== '' && !$39c5346b7e5f0f6d$var$isReserved(iconName)) return iconName;
    else return null;
}
var $39c5346b7e5f0f6d$var$build = function build() {
    var lookup = function lookup(reducer) {
        return $39c5346b7e5f0f6d$var$reduce($39c5346b7e5f0f6d$var$styles, function(o$$1, style, prefix) {
            o$$1[prefix] = $39c5346b7e5f0f6d$var$reduce(style, reducer, {});
            return o$$1;
        }, {});
    };
    $39c5346b7e5f0f6d$var$_byUnicode = lookup(function(acc, icon, iconName) {
        if (icon[3]) acc[icon[3]] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a$$1) {
                return typeof a$$1 === 'number';
            });
            aliases.forEach(function(alias) {
                acc[alias.toString(16)] = iconName;
            });
        }
        return acc;
    });
    $39c5346b7e5f0f6d$var$_byLigature = lookup(function(acc, icon, iconName) {
        acc[iconName] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a$$1) {
                return typeof a$$1 === 'string';
            });
            aliases.forEach(function(alias) {
                acc[alias] = iconName;
            });
        }
        return acc;
    });
    $39c5346b7e5f0f6d$var$_byAlias = lookup(function(acc, icon, iconName) {
        var aliases = icon[2];
        acc[iconName] = iconName;
        aliases.forEach(function(alias) {
            acc[alias] = iconName;
        });
        return acc;
    });
    // If we have a Kit, we can't determine if regular is available since we
    // could be auto-fetching it. We'll have to assume that it is available.
    var hasRegular = 'far' in $39c5346b7e5f0f6d$var$styles || $39c5346b7e5f0f6d$var$config.autoFetchSvg;
    var shimLookups = $39c5346b7e5f0f6d$var$reduce($39c5346b7e5f0f6d$var$shims, function(acc, shim) {
        var maybeNameMaybeUnicode = shim[0];
        var prefix = shim[1];
        var iconName = shim[2];
        if (prefix === 'far' && !hasRegular) prefix = 'fas';
        if (typeof maybeNameMaybeUnicode === 'string') acc.names[maybeNameMaybeUnicode] = {
            prefix: prefix,
            iconName: iconName
        };
        if (typeof maybeNameMaybeUnicode === 'number') acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {
        names: {},
        unicodes: {}
    });
    $39c5346b7e5f0f6d$var$_byOldName = shimLookups.names;
    $39c5346b7e5f0f6d$var$_byOldUnicode = shimLookups.unicodes;
    $39c5346b7e5f0f6d$var$_defaultUsablePrefix = $39c5346b7e5f0f6d$var$getCanonicalPrefix($39c5346b7e5f0f6d$var$config.styleDefault, {
        family: $39c5346b7e5f0f6d$var$config.familyDefault
    });
};
$39c5346b7e5f0f6d$var$onChange(function(c$$1) {
    $39c5346b7e5f0f6d$var$_defaultUsablePrefix = $39c5346b7e5f0f6d$var$getCanonicalPrefix(c$$1.styleDefault, {
        family: $39c5346b7e5f0f6d$var$config.familyDefault
    });
});
$39c5346b7e5f0f6d$var$build();
function $39c5346b7e5f0f6d$var$byUnicode(prefix, unicode) {
    return ($39c5346b7e5f0f6d$var$_byUnicode[prefix] || {})[unicode];
}
function $39c5346b7e5f0f6d$var$byLigature(prefix, ligature) {
    return ($39c5346b7e5f0f6d$var$_byLigature[prefix] || {})[ligature];
}
function $39c5346b7e5f0f6d$var$byAlias(prefix, alias) {
    return ($39c5346b7e5f0f6d$var$_byAlias[prefix] || {})[alias];
}
function $39c5346b7e5f0f6d$var$byOldName(name) {
    return $39c5346b7e5f0f6d$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
function $39c5346b7e5f0f6d$var$byOldUnicode(unicode) {
    var oldUnicode = $39c5346b7e5f0f6d$var$_byOldUnicode[unicode];
    var newUnicode = $39c5346b7e5f0f6d$var$byUnicode('fas', unicode);
    return oldUnicode || (newUnicode ? {
        prefix: 'fas',
        iconName: newUnicode
    } : null) || {
        prefix: null,
        iconName: null
    };
}
function $39c5346b7e5f0f6d$var$getDefaultUsablePrefix() {
    return $39c5346b7e5f0f6d$var$_defaultUsablePrefix;
}
var $39c5346b7e5f0f6d$var$emptyCanonicalIcon = function emptyCanonicalIcon() {
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $39c5346b7e5f0f6d$var$getFamilyId(values) {
    var family = $39c5346b7e5f0f6d$var$i;
    var famProps = $39c5346b7e5f0f6d$var$FAMILY_NAMES.reduce(function(acc, familyId) {
        acc[familyId] = "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-").concat(familyId);
        return acc;
    }, {});
    $39c5346b7e5f0f6d$var$rt.forEach(function(familyId) {
        if (values.includes(famProps[familyId]) || values.some(function(v$$1) {
            return $39c5346b7e5f0f6d$var$PREFIXES_FOR_FAMILY[familyId].includes(v$$1);
        })) family = familyId;
    });
    return family;
}
function $39c5346b7e5f0f6d$var$getCanonicalPrefix(styleOrPrefix) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$family = params.family, family = _params$family === void 0 ? $39c5346b7e5f0f6d$var$i : _params$family;
    var style = $39c5346b7e5f0f6d$var$PREFIX_TO_STYLE[family][styleOrPrefix];
    // handles the exception of passing in only a family of 'duotone' with no style
    if (family === $39c5346b7e5f0f6d$var$t && !styleOrPrefix) return 'fad';
    var prefix = $39c5346b7e5f0f6d$var$STYLE_TO_PREFIX[family][styleOrPrefix] || $39c5346b7e5f0f6d$var$STYLE_TO_PREFIX[family][style];
    var defined = styleOrPrefix in $39c5346b7e5f0f6d$var$namespace.styles ? styleOrPrefix : null;
    var result = prefix || defined || null;
    return result;
}
function $39c5346b7e5f0f6d$var$moveNonFaClassesToRest(classNames) {
    var rest = [];
    var iconName = null;
    classNames.forEach(function(cls) {
        var result = $39c5346b7e5f0f6d$var$getIconName($39c5346b7e5f0f6d$var$config.cssPrefix, cls);
        if (result) iconName = result;
        else if (cls) rest.push(cls);
    });
    return {
        iconName: iconName,
        rest: rest
    };
}
function $39c5346b7e5f0f6d$var$sortedUniqueValues(arr) {
    return arr.sort().filter(function(value, index, arr) {
        return arr.indexOf(value) === index;
    });
}
var $39c5346b7e5f0f6d$var$_faCombinedClasses = $39c5346b7e5f0f6d$var$Zt$1.concat($39c5346b7e5f0f6d$var$Yt);
function $39c5346b7e5f0f6d$var$getCanonicalIcon(values) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$skipLookups = params.skipLookups, skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
    var givenPrefix = null;
    var faStyleOrFamilyClasses = $39c5346b7e5f0f6d$var$sortedUniqueValues(values.filter(function(cls) {
        return $39c5346b7e5f0f6d$var$_faCombinedClasses.includes(cls);
    }));
    var nonStyleOrFamilyClasses = $39c5346b7e5f0f6d$var$sortedUniqueValues(values.filter(function(cls) {
        return !$39c5346b7e5f0f6d$var$_faCombinedClasses.includes(cls);
    }));
    var faStyles = faStyleOrFamilyClasses.filter(function(cls) {
        givenPrefix = cls;
        return !$39c5346b7e5f0f6d$var$Q.includes(cls);
    });
    var _faStyles = $39c5346b7e5f0f6d$var$_slicedToArray(faStyles, 1), _faStyles$ = _faStyles[0], styleFromValues = _faStyles$ === void 0 ? null : _faStyles$;
    var family = $39c5346b7e5f0f6d$var$getFamilyId(faStyleOrFamilyClasses);
    var canonical = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$moveNonFaClassesToRest(nonStyleOrFamilyClasses)), {}, {
        prefix: $39c5346b7e5f0f6d$var$getCanonicalPrefix(styleFromValues, {
            family: family
        })
    });
    return $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, canonical), $39c5346b7e5f0f6d$var$getDefaultCanonicalPrefix({
        values: values,
        family: family,
        styles: $39c5346b7e5f0f6d$var$styles,
        config: $39c5346b7e5f0f6d$var$config,
        canonical: canonical,
        givenPrefix: givenPrefix
    })), $39c5346b7e5f0f6d$var$applyShimAndAlias(skipLookups, givenPrefix, canonical));
}
function $39c5346b7e5f0f6d$var$applyShimAndAlias(skipLookups, givenPrefix, canonical) {
    var prefix = canonical.prefix, iconName = canonical.iconName;
    if (skipLookups || !prefix || !iconName) return {
        prefix: prefix,
        iconName: iconName
    };
    var shim = givenPrefix === 'fa' ? $39c5346b7e5f0f6d$var$byOldName(iconName) : {};
    var aliasIconName = $39c5346b7e5f0f6d$var$byAlias(prefix, iconName);
    iconName = shim.iconName || aliasIconName || iconName;
    prefix = shim.prefix || prefix;
    if (prefix === 'far' && !$39c5346b7e5f0f6d$var$styles['far'] && $39c5346b7e5f0f6d$var$styles['fas'] && !$39c5346b7e5f0f6d$var$config.autoFetchSvg) // Allow a fallback from the regular style to solid if regular is not available
    // but only if we aren't auto-fetching SVGs
    prefix = 'fas';
    return {
        prefix: prefix,
        iconName: iconName
    };
}
var $39c5346b7e5f0f6d$var$newCanonicalFamilies = $39c5346b7e5f0f6d$var$rt.filter(function(familyId) {
    return familyId !== $39c5346b7e5f0f6d$var$i || familyId !== $39c5346b7e5f0f6d$var$t;
});
var $39c5346b7e5f0f6d$var$newCanonicalStyles = Object.keys($39c5346b7e5f0f6d$var$Ht$1).filter(function(key) {
    return key !== $39c5346b7e5f0f6d$var$i;
}).map(function(key) {
    return Object.keys($39c5346b7e5f0f6d$var$Ht$1[key]);
}).flat();
function $39c5346b7e5f0f6d$var$getDefaultCanonicalPrefix(prefixOptions) {
    var values = prefixOptions.values, family = prefixOptions.family, canonical = prefixOptions.canonical, _prefixOptions$givenP = prefixOptions.givenPrefix, givenPrefix = _prefixOptions$givenP === void 0 ? '' : _prefixOptions$givenP, _prefixOptions$styles = prefixOptions.styles, styles = _prefixOptions$styles === void 0 ? {} : _prefixOptions$styles, _prefixOptions$config = prefixOptions.config, config$$1 = _prefixOptions$config === void 0 ? {} : _prefixOptions$config;
    var isDuotoneFamily = family === $39c5346b7e5f0f6d$var$t;
    var valuesHasDuotone = values.includes('fa-duotone') || values.includes('fad');
    var defaultFamilyIsDuotone = config$$1.familyDefault === 'duotone';
    var canonicalPrefixIsDuotone = canonical.prefix === 'fad' || canonical.prefix === 'fa-duotone';
    if (!isDuotoneFamily && (valuesHasDuotone || defaultFamilyIsDuotone || canonicalPrefixIsDuotone)) canonical.prefix = 'fad';
    if (values.includes('fa-brands') || values.includes('fab')) canonical.prefix = 'fab';
    if (!canonical.prefix && $39c5346b7e5f0f6d$var$newCanonicalFamilies.includes(family)) {
        var validPrefix = Object.keys(styles).find(function(key) {
            return $39c5346b7e5f0f6d$var$newCanonicalStyles.includes(key);
        });
        if (validPrefix || config$$1.autoFetchSvg) {
            var defaultPrefix = $39c5346b7e5f0f6d$var$Ut.get(family).defaultShortPrefixId;
            canonical.prefix = defaultPrefix;
            canonical.iconName = $39c5346b7e5f0f6d$var$byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
        }
    }
    if (canonical.prefix === 'fa' || givenPrefix === 'fa') // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = $39c5346b7e5f0f6d$var$getDefaultUsablePrefix() || 'fas';
    return canonical;
}
var $39c5346b7e5f0f6d$var$Library = /*#__PURE__*/ function() {
    function Library() {
        $39c5346b7e5f0f6d$var$_classCallCheck(this, Library);
        this.definitions = {};
    }
    return $39c5346b7e5f0f6d$var$_createClass(Library, [
        {
            key: "add",
            value: function add() {
                var _this = this;
                for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
                var additions = definitions.reduce(this._pullDefinitions, {});
                Object.keys(additions).forEach(function(key) {
                    _this.definitions[key] = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
                    $39c5346b7e5f0f6d$var$defineIcons(key, additions[key]);
                    // To keep support for older Classic styles, also add longer prefixes
                    var longPrefix = $39c5346b7e5f0f6d$var$PREFIX_TO_LONG_STYLE[$39c5346b7e5f0f6d$var$i][key];
                    if (longPrefix) $39c5346b7e5f0f6d$var$defineIcons(longPrefix, additions[key]);
                    $39c5346b7e5f0f6d$var$build();
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.definitions = {};
            }
        },
        {
            key: "_pullDefinitions",
            value: function _pullDefinitions(additions, definition) {
                var normalized = definition.prefix && definition.iconName && definition.icon ? {
                    0: definition
                } : definition;
                Object.keys(normalized).map(function(key) {
                    var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon = _normalized$key.icon;
                    var aliases = icon[2];
                    if (!additions[prefix]) additions[prefix] = {};
                    if (aliases.length > 0) aliases.forEach(function(alias) {
                        if (typeof alias === 'string') additions[prefix][alias] = icon;
                    });
                    additions[prefix][iconName] = icon;
                });
                return additions;
            }
        }
    ]);
}();
var $39c5346b7e5f0f6d$var$_plugins = [];
var $39c5346b7e5f0f6d$var$_hooks = {};
var $39c5346b7e5f0f6d$var$providers = {};
var $39c5346b7e5f0f6d$var$defaultProviderKeys = Object.keys($39c5346b7e5f0f6d$var$providers);
function $39c5346b7e5f0f6d$var$registerPlugins(nextPlugins, _ref) {
    var obj = _ref.mixoutsTo;
    $39c5346b7e5f0f6d$var$_plugins = nextPlugins;
    $39c5346b7e5f0f6d$var$_hooks = {};
    Object.keys($39c5346b7e5f0f6d$var$providers).forEach(function(k) {
        if ($39c5346b7e5f0f6d$var$defaultProviderKeys.indexOf(k) === -1) delete $39c5346b7e5f0f6d$var$providers[k];
    });
    $39c5346b7e5f0f6d$var$_plugins.forEach(function(plugin) {
        var mixout = plugin.mixout ? plugin.mixout() : {};
        Object.keys(mixout).forEach(function(tk) {
            if (typeof mixout[tk] === 'function') obj[tk] = mixout[tk];
            if ($39c5346b7e5f0f6d$var$_typeof(mixout[tk]) === 'object') Object.keys(mixout[tk]).forEach(function(sk) {
                if (!obj[tk]) obj[tk] = {};
                obj[tk][sk] = mixout[tk][sk];
            });
        });
        if (plugin.hooks) {
            var hooks = plugin.hooks();
            Object.keys(hooks).forEach(function(hook) {
                if (!$39c5346b7e5f0f6d$var$_hooks[hook]) $39c5346b7e5f0f6d$var$_hooks[hook] = [];
                $39c5346b7e5f0f6d$var$_hooks[hook].push(hooks[hook]);
            });
        }
        if (plugin.provides) plugin.provides($39c5346b7e5f0f6d$var$providers);
    });
    return obj;
}
function $39c5346b7e5f0f6d$var$chainHooks(hook, accumulator) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var hookFns = $39c5346b7e5f0f6d$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        accumulator = hookFn.apply(null, [
            accumulator
        ].concat(args));
    });
    return accumulator;
}
function $39c5346b7e5f0f6d$var$callHooks(hook) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    var hookFns = $39c5346b7e5f0f6d$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        hookFn.apply(null, args);
    });
    return undefined;
}
function $39c5346b7e5f0f6d$var$callProvided() {
    var hook = arguments[0];
    var args = Array.prototype.slice.call(arguments, 1);
    return $39c5346b7e5f0f6d$var$providers[hook] ? $39c5346b7e5f0f6d$var$providers[hook].apply(null, args) : undefined;
}
function $39c5346b7e5f0f6d$var$findIconDefinition(iconLookup) {
    if (iconLookup.prefix === 'fa') iconLookup.prefix = 'fas';
    var iconName = iconLookup.iconName;
    var prefix = iconLookup.prefix || $39c5346b7e5f0f6d$var$getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = $39c5346b7e5f0f6d$var$byAlias(prefix, iconName) || iconName;
    return $39c5346b7e5f0f6d$var$iconFromMapping($39c5346b7e5f0f6d$var$library.definitions, prefix, iconName) || $39c5346b7e5f0f6d$var$iconFromMapping($39c5346b7e5f0f6d$var$namespace.styles, prefix, iconName);
}
var $39c5346b7e5f0f6d$var$library = new $39c5346b7e5f0f6d$var$Library();
var $39c5346b7e5f0f6d$var$noAuto = function noAuto() {
    $39c5346b7e5f0f6d$var$config.autoReplaceSvg = false;
    $39c5346b7e5f0f6d$var$config.observeMutations = false;
    $39c5346b7e5f0f6d$var$callHooks('noAuto');
};
var $39c5346b7e5f0f6d$var$dom = {
    i2svg: function i2svg() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($39c5346b7e5f0f6d$var$IS_DOM) {
            $39c5346b7e5f0f6d$var$callHooks('beforeI2svg', params);
            $39c5346b7e5f0f6d$var$callProvided('pseudoElements2svg', params);
            return $39c5346b7e5f0f6d$var$callProvided('i2svg', params);
        } else return Promise.reject(new Error('Operation requires a DOM of some kind.'));
    },
    watch: function watch() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var autoReplaceSvgRoot = params.autoReplaceSvgRoot;
        if ($39c5346b7e5f0f6d$var$config.autoReplaceSvg === false) $39c5346b7e5f0f6d$var$config.autoReplaceSvg = true;
        $39c5346b7e5f0f6d$var$config.observeMutations = true;
        $39c5346b7e5f0f6d$var$domready(function() {
            $39c5346b7e5f0f6d$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $39c5346b7e5f0f6d$var$callHooks('watch', params);
        });
    }
};
var $39c5346b7e5f0f6d$var$parse = {
    icon: function icon(_icon) {
        if (_icon === null) return null;
        if ($39c5346b7e5f0f6d$var$_typeof(_icon) === 'object' && _icon.prefix && _icon.iconName) return {
            prefix: _icon.prefix,
            iconName: $39c5346b7e5f0f6d$var$byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
        };
        if (Array.isArray(_icon) && _icon.length === 2) {
            var iconName = _icon[1].indexOf('fa-') === 0 ? _icon[1].slice(3) : _icon[1];
            var prefix = $39c5346b7e5f0f6d$var$getCanonicalPrefix(_icon[0]);
            return {
                prefix: prefix,
                iconName: $39c5346b7e5f0f6d$var$byAlias(prefix, iconName) || iconName
            };
        }
        if (typeof _icon === 'string' && (_icon.indexOf("".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-")) > -1 || _icon.match($39c5346b7e5f0f6d$var$ICON_SELECTION_SYNTAX_PATTERN))) {
            var canonicalIcon = $39c5346b7e5f0f6d$var$getCanonicalIcon(_icon.split(' '), {
                skipLookups: true
            });
            return {
                prefix: canonicalIcon.prefix || $39c5346b7e5f0f6d$var$getDefaultUsablePrefix(),
                iconName: $39c5346b7e5f0f6d$var$byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
            };
        }
        if (typeof _icon === 'string') {
            var _prefix = $39c5346b7e5f0f6d$var$getDefaultUsablePrefix();
            return {
                prefix: _prefix,
                iconName: $39c5346b7e5f0f6d$var$byAlias(_prefix, _icon) || _icon
            };
        }
    }
};
var $39c5346b7e5f0f6d$export$644d8ea042df96a6 = {
    noAuto: $39c5346b7e5f0f6d$var$noAuto,
    config: $39c5346b7e5f0f6d$var$config,
    dom: $39c5346b7e5f0f6d$var$dom,
    parse: $39c5346b7e5f0f6d$var$parse,
    library: $39c5346b7e5f0f6d$var$library,
    findIconDefinition: $39c5346b7e5f0f6d$var$findIconDefinition,
    toHtml: $39c5346b7e5f0f6d$var$toHtml
};
var $39c5346b7e5f0f6d$var$autoReplace = function autoReplace() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? $39c5346b7e5f0f6d$var$DOCUMENT : _params$autoReplaceSv;
    if ((Object.keys($39c5346b7e5f0f6d$var$namespace.styles).length > 0 || $39c5346b7e5f0f6d$var$config.autoFetchSvg) && $39c5346b7e5f0f6d$var$IS_DOM && $39c5346b7e5f0f6d$var$config.autoReplaceSvg) $39c5346b7e5f0f6d$export$644d8ea042df96a6.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};
function $39c5346b7e5f0f6d$var$domVariants(val, abstractCreator) {
    Object.defineProperty(val, 'abstract', {
        get: abstractCreator
    });
    Object.defineProperty(val, 'html', {
        get: function get() {
            return val.abstract.map(function(a) {
                return $39c5346b7e5f0f6d$var$toHtml(a);
            });
        }
    });
    Object.defineProperty(val, 'node', {
        get: function get() {
            if (!$39c5346b7e5f0f6d$var$IS_DOM) return undefined;
            var container = $39c5346b7e5f0f6d$var$DOCUMENT.createElement('div');
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $39c5346b7e5f0f6d$var$asIcon(_ref) {
    var children = _ref.children, main = _ref.main, mask = _ref.mask, attributes = _ref.attributes, styles = _ref.styles, transform = _ref.transform;
    if ($39c5346b7e5f0f6d$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        var width = main.width, height = main.height;
        var offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes['style'] = $39c5346b7e5f0f6d$var$joinStyles($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, styles), {}, {
            'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: 'svg',
            attributes: attributes,
            children: children
        }
    ];
}
function $39c5346b7e5f0f6d$var$asSymbol(_ref) {
    var prefix = _ref.prefix, iconName = _ref.iconName, children = _ref.children, attributes = _ref.attributes, symbol = _ref.symbol;
    var id = symbol === true ? "".concat(prefix, "-").concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: 'svg',
            attributes: {
                style: 'display: none;'
            },
            children: [
                {
                    tag: 'symbol',
                    attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, attributes), {}, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
// If any of these attributes are present, don't assume the icon is decorative
function $39c5346b7e5f0f6d$var$isLabeled(attributes) {
    var labels = [
        'aria-label',
        'aria-labelledby',
        'title',
        'role'
    ];
    return labels.some(function(label) {
        return label in attributes;
    });
}
function $39c5346b7e5f0f6d$var$makeInlineSvgAbstract(params) {
    var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, maskId = params.maskId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
    var _ref = mask.found ? mask : main, width = _ref.width, height = _ref.height;
    var attrClass = [
        $39c5346b7e5f0f6d$var$config.replacementClass,
        iconName ? "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-").concat(iconName) : ''
    ].filter(function(c) {
        return extra.classes.indexOf(c) === -1;
    }).filter(function(c) {
        return c !== '' || !!c;
    }).concat(extra.classes).join(' ');
    var content = {
        children: [],
        attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, extra.attributes), {}, {
            'data-prefix': prefix,
            'data-icon': iconName,
            'class': attrClass,
            'role': extra.attributes.role || 'img',
            'viewBox': "0 0 ".concat(width, " ").concat(height)
        })
    };
    if (!$39c5346b7e5f0f6d$var$isLabeled(extra.attributes) && !extra.attributes['aria-hidden']) content.attributes['aria-hidden'] = 'true';
    if (watchable) content.attributes[$39c5346b7e5f0f6d$var$DATA_FA_I2SVG] = '';
    var args = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, content), {}, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: $39c5346b7e5f0f6d$var$_objectSpread2({}, extra.styles)
    });
    var _ref2 = mask.found && main.found ? $39c5346b7e5f0f6d$var$callProvided('generateAbstractMask', args) || {
        children: [],
        attributes: {}
    } : $39c5346b7e5f0f6d$var$callProvided('generateAbstractIcon', args) || {
        children: [],
        attributes: {}
    }, children = _ref2.children, attributes = _ref2.attributes;
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $39c5346b7e5f0f6d$var$asSymbol(args);
    else return $39c5346b7e5f0f6d$var$asIcon(args);
}
function $39c5346b7e5f0f6d$var$makeLayersTextAbstract(params) {
    var content = params.content, width = params.width, height = params.height, transform = params.transform, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
    var attributes = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, extra.attributes), {}, {
        class: extra.classes.join(' ')
    });
    if (watchable) attributes[$39c5346b7e5f0f6d$var$DATA_FA_I2SVG] = '';
    var styles = $39c5346b7e5f0f6d$var$_objectSpread2({}, extra.styles);
    if ($39c5346b7e5f0f6d$var$transformIsMeaningful(transform)) {
        styles['transform'] = $39c5346b7e5f0f6d$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles['-webkit-transform'] = styles['transform'];
    }
    var styleString = $39c5346b7e5f0f6d$var$joinStyles(styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    var val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    return val;
}
function $39c5346b7e5f0f6d$var$makeLayersCounterAbstract(params) {
    var content = params.content, extra = params.extra;
    var attributes = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, extra.attributes), {}, {
        class: extra.classes.join(' ')
    });
    var styleString = $39c5346b7e5f0f6d$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    var val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    return val;
}
var $39c5346b7e5f0f6d$var$styles$1 = $39c5346b7e5f0f6d$var$namespace.styles;
function $39c5346b7e5f0f6d$var$asFoundIcon(icon) {
    var width = icon[0];
    var height = icon[1];
    var _icon$slice = icon.slice(4), _icon$slice2 = $39c5346b7e5f0f6d$var$_slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
    var element = null;
    if (Array.isArray(vectorData)) element = {
        tag: 'g',
        attributes: {
            class: "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-").concat($39c5346b7e5f0f6d$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: 'path',
                attributes: {
                    class: "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-").concat($39c5346b7e5f0f6d$var$DUOTONE_CLASSES.SECONDARY),
                    fill: 'currentColor',
                    d: vectorData[0]
                }
            },
            {
                tag: 'path',
                attributes: {
                    class: "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-").concat($39c5346b7e5f0f6d$var$DUOTONE_CLASSES.PRIMARY),
                    fill: 'currentColor',
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: 'path',
        attributes: {
            fill: 'currentColor',
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
var $39c5346b7e5f0f6d$var$missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
};
function $39c5346b7e5f0f6d$var$maybeNotifyMissing(iconName, prefix) {
    if (!$39c5346b7e5f0f6d$var$PRODUCTION && !$39c5346b7e5f0f6d$var$config.showMissingIcons && iconName) console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
}
function $39c5346b7e5f0f6d$var$findIcon(iconName, prefix) {
    var givenPrefix = prefix;
    if (prefix === 'fa' && $39c5346b7e5f0f6d$var$config.styleDefault !== null) prefix = $39c5346b7e5f0f6d$var$getDefaultUsablePrefix();
    return new Promise(function(resolve, reject) {
        if (givenPrefix === 'fa') {
            var shim = $39c5346b7e5f0f6d$var$byOldName(iconName) || {};
            iconName = shim.iconName || iconName;
            prefix = shim.prefix || prefix;
        }
        if (iconName && prefix && $39c5346b7e5f0f6d$var$styles$1[prefix] && $39c5346b7e5f0f6d$var$styles$1[prefix][iconName]) {
            var icon = $39c5346b7e5f0f6d$var$styles$1[prefix][iconName];
            return resolve($39c5346b7e5f0f6d$var$asFoundIcon(icon));
        }
        $39c5346b7e5f0f6d$var$maybeNotifyMissing(iconName, prefix);
        resolve($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$missingIconResolutionMixin), {}, {
            icon: $39c5346b7e5f0f6d$var$config.showMissingIcons && iconName ? $39c5346b7e5f0f6d$var$callProvided('missingIconAbstract') || {} : {}
        }));
    });
}
var $39c5346b7e5f0f6d$var$noop$1 = function noop() {};
var $39c5346b7e5f0f6d$var$p$2 = $39c5346b7e5f0f6d$var$config.measurePerformance && $39c5346b7e5f0f6d$var$PERFORMANCE && $39c5346b7e5f0f6d$var$PERFORMANCE.mark && $39c5346b7e5f0f6d$var$PERFORMANCE.measure ? $39c5346b7e5f0f6d$var$PERFORMANCE : {
    mark: $39c5346b7e5f0f6d$var$noop$1,
    measure: $39c5346b7e5f0f6d$var$noop$1
};
var $39c5346b7e5f0f6d$var$preamble = "FA \"7.1.0\"";
var $39c5346b7e5f0f6d$var$begin = function begin(name) {
    $39c5346b7e5f0f6d$var$p$2.mark("".concat($39c5346b7e5f0f6d$var$preamble, " ").concat(name, " begins"));
    return function() {
        return $39c5346b7e5f0f6d$var$end(name);
    };
};
var $39c5346b7e5f0f6d$var$end = function end(name) {
    $39c5346b7e5f0f6d$var$p$2.mark("".concat($39c5346b7e5f0f6d$var$preamble, " ").concat(name, " ends"));
    $39c5346b7e5f0f6d$var$p$2.measure("".concat($39c5346b7e5f0f6d$var$preamble, " ").concat(name), "".concat($39c5346b7e5f0f6d$var$preamble, " ").concat(name, " begins"), "".concat($39c5346b7e5f0f6d$var$preamble, " ").concat(name, " ends"));
};
var $39c5346b7e5f0f6d$var$perf = {
    begin: $39c5346b7e5f0f6d$var$begin,
    end: $39c5346b7e5f0f6d$var$end
};
var $39c5346b7e5f0f6d$var$noop$2 = function noop() {};
function $39c5346b7e5f0f6d$var$isWatched(node) {
    var i2svg = node.getAttribute ? node.getAttribute($39c5346b7e5f0f6d$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === 'string';
}
function $39c5346b7e5f0f6d$var$hasPrefixAndIcon(node) {
    var prefix = node.getAttribute ? node.getAttribute($39c5346b7e5f0f6d$var$DATA_PREFIX) : null;
    var icon = node.getAttribute ? node.getAttribute($39c5346b7e5f0f6d$var$DATA_ICON) : null;
    return prefix && icon;
}
function $39c5346b7e5f0f6d$var$hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains($39c5346b7e5f0f6d$var$config.replacementClass);
}
function $39c5346b7e5f0f6d$var$getMutator() {
    if ($39c5346b7e5f0f6d$var$config.autoReplaceSvg === true) return $39c5346b7e5f0f6d$var$mutators.replace;
    var mutator = $39c5346b7e5f0f6d$var$mutators[$39c5346b7e5f0f6d$var$config.autoReplaceSvg];
    return mutator || $39c5346b7e5f0f6d$var$mutators.replace;
}
function $39c5346b7e5f0f6d$var$createElementNS(tag) {
    return $39c5346b7e5f0f6d$var$DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}
function $39c5346b7e5f0f6d$var$createElement(tag) {
    return $39c5346b7e5f0f6d$var$DOCUMENT.createElement(tag);
}
function $39c5346b7e5f0f6d$var$convertSVG(abstractObj) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$ceFn = params.ceFn, ceFn = _params$ceFn === void 0 ? abstractObj.tag === 'svg' ? $39c5346b7e5f0f6d$var$createElementNS : $39c5346b7e5f0f6d$var$createElement : _params$ceFn;
    if (typeof abstractObj === 'string') return $39c5346b7e5f0f6d$var$DOCUMENT.createTextNode(abstractObj);
    var tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function(key) {
        tag.setAttribute(key, abstractObj.attributes[key]);
    });
    var children = abstractObj.children || [];
    children.forEach(function(child) {
        tag.appendChild($39c5346b7e5f0f6d$var$convertSVG(child, {
            ceFn: ceFn
        }));
    });
    return tag;
}
function $39c5346b7e5f0f6d$var$nodeAsComment(node) {
    var comment = " ".concat(node.outerHTML, " ");
    /* BEGIN.ATTRIBUTION */ comment = "".concat(comment, "Font Awesome fontawesome.com ");
    /* END.ATTRIBUTION */ return comment;
}
var $39c5346b7e5f0f6d$var$mutators = {
    replace: function replace(mutation) {
        var node = mutation[0];
        if (node.parentNode) {
            mutation[1].forEach(function(abstract) {
                node.parentNode.insertBefore($39c5346b7e5f0f6d$var$convertSVG(abstract), node);
            });
            if (node.getAttribute($39c5346b7e5f0f6d$var$DATA_FA_I2SVG) === null && $39c5346b7e5f0f6d$var$config.keepOriginalSource) {
                var comment = $39c5346b7e5f0f6d$var$DOCUMENT.createComment($39c5346b7e5f0f6d$var$nodeAsComment(node));
                node.parentNode.replaceChild(comment, node);
            } else node.remove();
        }
    },
    nest: function nest(mutation) {
        var node = mutation[0];
        var abstract = mutation[1];
        // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$39c5346b7e5f0f6d$var$classArray(node).indexOf($39c5346b7e5f0f6d$var$config.replacementClass)) return $39c5346b7e5f0f6d$var$mutators.replace(mutation);
        var forSvg = new RegExp("".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-.*"));
        delete abstract[0].attributes.id;
        if (abstract[0].attributes.class) {
            var splitClasses = abstract[0].attributes.class.split(' ').reduce(function(acc, cls) {
                if (cls === $39c5346b7e5f0f6d$var$config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            abstract[0].attributes.class = splitClasses.toSvg.join(' ');
            if (splitClasses.toNode.length === 0) node.removeAttribute('class');
            else node.setAttribute('class', splitClasses.toNode.join(' '));
        }
        var newInnerHTML = abstract.map(function(a) {
            return $39c5346b7e5f0f6d$var$toHtml(a);
        }).join('\n');
        node.setAttribute($39c5346b7e5f0f6d$var$DATA_FA_I2SVG, '');
        node.innerHTML = newInnerHTML;
    }
};
function $39c5346b7e5f0f6d$var$performOperationSync(op) {
    op();
}
function $39c5346b7e5f0f6d$var$perform(mutations, callback) {
    var callbackFunction = typeof callback === 'function' ? callback : $39c5346b7e5f0f6d$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        var frame = $39c5346b7e5f0f6d$var$performOperationSync;
        if ($39c5346b7e5f0f6d$var$config.mutateApproach === $39c5346b7e5f0f6d$var$MUTATION_APPROACH_ASYNC) frame = $39c5346b7e5f0f6d$var$WINDOW.requestAnimationFrame || $39c5346b7e5f0f6d$var$performOperationSync;
        frame(function() {
            var mutator = $39c5346b7e5f0f6d$var$getMutator();
            var mark = $39c5346b7e5f0f6d$var$perf.begin('mutate');
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
var $39c5346b7e5f0f6d$var$disabled = false;
function $39c5346b7e5f0f6d$var$disableObservation() {
    $39c5346b7e5f0f6d$var$disabled = true;
}
function $39c5346b7e5f0f6d$var$enableObservation() {
    $39c5346b7e5f0f6d$var$disabled = false;
}
var $39c5346b7e5f0f6d$var$mo = null;
function $39c5346b7e5f0f6d$var$observe(options) {
    if (!$39c5346b7e5f0f6d$var$MUTATION_OBSERVER) return;
    if (!$39c5346b7e5f0f6d$var$config.observeMutations) return;
    var _options$treeCallback = options.treeCallback, treeCallback = _options$treeCallback === void 0 ? $39c5346b7e5f0f6d$var$noop$2 : _options$treeCallback, _options$nodeCallback = options.nodeCallback, nodeCallback = _options$nodeCallback === void 0 ? $39c5346b7e5f0f6d$var$noop$2 : _options$nodeCallback, _options$pseudoElemen = options.pseudoElementsCallback, pseudoElementsCallback = _options$pseudoElemen === void 0 ? $39c5346b7e5f0f6d$var$noop$2 : _options$pseudoElemen, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? $39c5346b7e5f0f6d$var$DOCUMENT : _options$observeMutat;
    $39c5346b7e5f0f6d$var$mo = new $39c5346b7e5f0f6d$var$MUTATION_OBSERVER(function(objects) {
        if ($39c5346b7e5f0f6d$var$disabled) return;
        var defaultPrefix = $39c5346b7e5f0f6d$var$getDefaultUsablePrefix();
        $39c5346b7e5f0f6d$var$toArray(objects).forEach(function(mutationRecord) {
            if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !$39c5346b7e5f0f6d$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($39c5346b7e5f0f6d$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && $39c5346b7e5f0f6d$var$config.searchPseudoElements) pseudoElementsCallback([
                mutationRecord.target
            ], true);
            if (mutationRecord.type === 'attributes' && $39c5346b7e5f0f6d$var$isWatched(mutationRecord.target) && ~$39c5346b7e5f0f6d$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === 'class' && $39c5346b7e5f0f6d$var$hasPrefixAndIcon(mutationRecord.target)) {
                    var _getCanonicalIcon = $39c5346b7e5f0f6d$var$getCanonicalIcon($39c5346b7e5f0f6d$var$classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
                    mutationRecord.target.setAttribute($39c5346b7e5f0f6d$var$DATA_PREFIX, prefix || defaultPrefix);
                    if (iconName) mutationRecord.target.setAttribute($39c5346b7e5f0f6d$var$DATA_ICON, iconName);
                } else if ($39c5346b7e5f0f6d$var$hasBeenReplaced(mutationRecord.target)) nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$39c5346b7e5f0f6d$var$IS_DOM) return;
    $39c5346b7e5f0f6d$var$mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $39c5346b7e5f0f6d$var$disconnect() {
    if (!$39c5346b7e5f0f6d$var$mo) return;
    $39c5346b7e5f0f6d$var$mo.disconnect();
}
function $39c5346b7e5f0f6d$var$styleParser(node) {
    var style = node.getAttribute('style');
    var val = [];
    if (style) val = style.split(';').reduce(function(acc, style) {
        var styles = style.split(':');
        var prop = styles[0];
        var value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(':').trim();
        return acc;
    }, {});
    return val;
}
function $39c5346b7e5f0f6d$var$classParser(node) {
    var existingPrefix = node.getAttribute('data-prefix');
    var existingIconName = node.getAttribute('data-icon');
    var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
    var val = $39c5346b7e5f0f6d$var$getCanonicalIcon($39c5346b7e5f0f6d$var$classArray(node));
    if (!val.prefix) val.prefix = $39c5346b7e5f0f6d$var$getDefaultUsablePrefix();
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.iconName && val.prefix) return val;
    if (val.prefix && innerText.length > 0) val.iconName = $39c5346b7e5f0f6d$var$byLigature(val.prefix, node.innerText) || $39c5346b7e5f0f6d$var$byUnicode(val.prefix, $39c5346b7e5f0f6d$var$toHex(node.innerText));
    if (!val.iconName && $39c5346b7e5f0f6d$var$config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) val.iconName = node.firstChild.data;
    return val;
}
function $39c5346b7e5f0f6d$var$attributesParser(node) {
    var extraAttributes = $39c5346b7e5f0f6d$var$toArray(node.attributes).reduce(function(acc, attr) {
        if (acc.name !== 'class' && acc.name !== 'style') acc[attr.name] = attr.value;
        return acc;
    }, {});
    return extraAttributes;
}
function $39c5346b7e5f0f6d$var$blankMeta() {
    return {
        iconName: null,
        prefix: null,
        transform: $39c5346b7e5f0f6d$var$meaninglessTransform,
        symbol: false,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $39c5346b7e5f0f6d$var$parseMeta(node) {
    var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        styleParser: true
    };
    var _classParser = $39c5346b7e5f0f6d$var$classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
    var extraAttributes = $39c5346b7e5f0f6d$var$attributesParser(node);
    var pluginMeta = $39c5346b7e5f0f6d$var$chainHooks('parseNodeAttributes', {}, node);
    var extraStyles = parser.styleParser ? $39c5346b7e5f0f6d$var$styleParser(node) : [];
    return $39c5346b7e5f0f6d$var$_objectSpread2({
        iconName: iconName,
        prefix: prefix,
        transform: $39c5346b7e5f0f6d$var$meaninglessTransform,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: false,
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    }, pluginMeta);
}
var $39c5346b7e5f0f6d$var$styles$2 = $39c5346b7e5f0f6d$var$namespace.styles;
function $39c5346b7e5f0f6d$var$generateMutation(node) {
    var nodeMeta = $39c5346b7e5f0f6d$var$config.autoReplaceSvg === 'nest' ? $39c5346b7e5f0f6d$var$parseMeta(node, {
        styleParser: false
    }) : $39c5346b7e5f0f6d$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($39c5346b7e5f0f6d$var$LAYERS_TEXT_CLASSNAME)) return $39c5346b7e5f0f6d$var$callProvided('generateLayersText', node, nodeMeta);
    else return $39c5346b7e5f0f6d$var$callProvided('generateSvgReplacementMutation', node, nodeMeta);
}
function $39c5346b7e5f0f6d$var$getKnownPrefixes() {
    return [].concat($39c5346b7e5f0f6d$var$_toConsumableArray($39c5346b7e5f0f6d$var$Yt), $39c5346b7e5f0f6d$var$_toConsumableArray($39c5346b7e5f0f6d$var$Zt$1));
}
function $39c5346b7e5f0f6d$var$onTree(root) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$39c5346b7e5f0f6d$var$IS_DOM) return Promise.resolve();
    var htmlClassList = $39c5346b7e5f0f6d$var$DOCUMENT.documentElement.classList;
    var hclAdd = function hclAdd(suffix) {
        return htmlClassList.add("".concat($39c5346b7e5f0f6d$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var hclRemove = function hclRemove(suffix) {
        return htmlClassList.remove("".concat($39c5346b7e5f0f6d$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var prefixes = $39c5346b7e5f0f6d$var$config.autoFetchSvg ? $39c5346b7e5f0f6d$var$getKnownPrefixes() : $39c5346b7e5f0f6d$var$Q.concat(Object.keys($39c5346b7e5f0f6d$var$styles$2));
    if (!prefixes.includes('fa')) prefixes.push('fa');
    var prefixesDomQuery = [
        ".".concat($39c5346b7e5f0f6d$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($39c5346b7e5f0f6d$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map(function(p$$1) {
        return ".".concat(p$$1, ":not([").concat($39c5346b7e5f0f6d$var$DATA_FA_I2SVG, "])");
    })).join(', ');
    if (prefixesDomQuery.length === 0) return Promise.resolve();
    var candidates = [];
    try {
        candidates = $39c5346b7e5f0f6d$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e$$1) {
    // noop
    }
    if (candidates.length > 0) {
        hclAdd('pending');
        hclRemove('complete');
    } else return Promise.resolve();
    var mark = $39c5346b7e5f0f6d$var$perf.begin('onTree');
    var mutations = candidates.reduce(function(acc, node) {
        try {
            var mutation = $39c5346b7e5f0f6d$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e$$1) {
            if (!$39c5346b7e5f0f6d$var$PRODUCTION) {
                if (e$$1.name === 'MissingIcon') console.error(e$$1);
            }
        }
        return acc;
    }, []);
    return new Promise(function(resolve, reject) {
        Promise.all(mutations).then(function(resolvedMutations) {
            $39c5346b7e5f0f6d$var$perform(resolvedMutations, function() {
                hclAdd('active');
                hclAdd('complete');
                hclRemove('pending');
                if (typeof callback === 'function') callback();
                mark();
                resolve();
            });
        }).catch(function(e$$1) {
            mark();
            reject(e$$1);
        });
    });
}
function $39c5346b7e5f0f6d$var$onNode(node) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $39c5346b7e5f0f6d$var$generateMutation(node).then(function(mutation) {
        if (mutation) $39c5346b7e5f0f6d$var$perform([
            mutation
        ], callback);
    });
}
function $39c5346b7e5f0f6d$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $39c5346b7e5f0f6d$var$findIconDefinition(maybeIconDefinition || {});
        var mask = params.mask;
        if (mask) mask = (mask || {}).icon ? mask : $39c5346b7e5f0f6d$var$findIconDefinition(mask || {});
        return next(iconDefinition, $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, params), {}, {
            mask: mask
        }));
    };
}
var $39c5346b7e5f0f6d$var$render = function render(iconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform = params.transform, transform = _params$transform === void 0 ? $39c5346b7e5f0f6d$var$meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon = iconDefinition.icon;
    return $39c5346b7e5f0f6d$var$domVariants($39c5346b7e5f0f6d$var$_objectSpread2({
        type: 'icon'
    }, iconDefinition), function() {
        $39c5346b7e5f0f6d$var$callHooks('beforeDOMElementCreation', {
            iconDefinition: iconDefinition,
            params: params
        });
        return $39c5346b7e5f0f6d$var$makeInlineSvgAbstract({
            icons: {
                main: $39c5346b7e5f0f6d$var$asFoundIcon(icon),
                mask: mask ? $39c5346b7e5f0f6d$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$meaninglessTransform), transform),
            symbol: symbol,
            maskId: maskId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
};
var $39c5346b7e5f0f6d$var$ReplaceElements = {
    mixout: function mixout() {
        return {
            icon: $39c5346b7e5f0f6d$var$resolveIcons($39c5346b7e5f0f6d$var$render)
        };
    },
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.treeCallback = $39c5346b7e5f0f6d$var$onTree;
                accumulator.nodeCallback = $39c5346b7e5f0f6d$var$onNode;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.i2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $39c5346b7e5f0f6d$var$DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function callback() {} : _params$callback;
            return $39c5346b7e5f0f6d$var$onTree(node, callback);
        };
        providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
            var iconName = nodeMeta.iconName, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
            return new Promise(function(resolve, reject) {
                Promise.all([
                    $39c5346b7e5f0f6d$var$findIcon(iconName, prefix),
                    mask.iconName ? $39c5346b7e5f0f6d$var$findIcon(mask.iconName, mask.prefix) : Promise.resolve({
                        found: false,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then(function(_ref) {
                    var _ref2 = $39c5346b7e5f0f6d$var$_slicedToArray(_ref, 2), main = _ref2[0], mask = _ref2[1];
                    resolve([
                        node,
                        $39c5346b7e5f0f6d$var$makeInlineSvgAbstract({
                            icons: {
                                main: main,
                                mask: mask
                            },
                            prefix: prefix,
                            iconName: iconName,
                            transform: transform,
                            symbol: symbol,
                            maskId: maskId,
                            extra: extra,
                            watchable: true
                        })
                    ]);
                }).catch(reject);
            });
        };
        providers$$1.generateAbstractIcon = function(_ref3) {
            var children = _ref3.children, attributes = _ref3.attributes, main = _ref3.main, transform = _ref3.transform, styles = _ref3.styles;
            var styleString = $39c5346b7e5f0f6d$var$joinStyles(styles);
            if (styleString.length > 0) attributes['style'] = styleString;
            var nextChild;
            if ($39c5346b7e5f0f6d$var$transformIsMeaningful(transform)) nextChild = $39c5346b7e5f0f6d$var$callProvided('generateAbstractTransformGrouping', {
                main: main,
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push(nextChild || main.icon);
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $39c5346b7e5f0f6d$var$Layers = {
    mixout: function mixout() {
        return {
            layer: function layer(assembler) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes;
                return $39c5346b7e5f0f6d$var$domVariants({
                    type: 'layer'
                }, function() {
                    $39c5346b7e5f0f6d$var$callHooks('beforeDOMElementCreation', {
                        assembler: assembler,
                        params: params
                    });
                    var children = [];
                    assembler(function(args) {
                        Array.isArray(args) ? args.map(function(a) {
                            children = children.concat(a.abstract);
                        }) : children = children.concat(args.abstract);
                    });
                    return [
                        {
                            tag: 'span',
                            attributes: {
                                class: [
                                    "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-layers")
                                ].concat($39c5346b7e5f0f6d$var$_toConsumableArray(classes)).join(' ')
                            },
                            children: children
                        }
                    ];
                });
            }
        };
    }
};
var $39c5346b7e5f0f6d$var$LayersCounter = {
    mixout: function mixout() {
        return {
            counter: function counter(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $39c5346b7e5f0f6d$var$domVariants({
                    type: 'counter',
                    content: content
                }, function() {
                    $39c5346b7e5f0f6d$var$callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return $39c5346b7e5f0f6d$var$makeLayersCounterAbstract({
                        content: content.toString(),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-layers-counter")
                            ].concat($39c5346b7e5f0f6d$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    }
};
var $39c5346b7e5f0f6d$var$LayersText = {
    mixout: function mixout() {
        return {
            text: function text(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$transform = params.transform, transform = _params$transform === void 0 ? $39c5346b7e5f0f6d$var$meaninglessTransform : _params$transform, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $39c5346b7e5f0f6d$var$domVariants({
                    type: 'text',
                    content: content
                }, function() {
                    $39c5346b7e5f0f6d$var$callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return $39c5346b7e5f0f6d$var$makeLayersTextAbstract({
                        content: content,
                        transform: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$meaninglessTransform), transform),
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-layers-text")
                            ].concat($39c5346b7e5f0f6d$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.generateLayersText = function(node, nodeMeta) {
            var transform = nodeMeta.transform, extra = nodeMeta.extra;
            var width = null;
            var height = null;
            if ($39c5346b7e5f0f6d$var$IS_IE) {
                var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
                var boundingClientRect = node.getBoundingClientRect();
                width = boundingClientRect.width / computedFontSize;
                height = boundingClientRect.height / computedFontSize;
            }
            return Promise.resolve([
                node,
                $39c5346b7e5f0f6d$var$makeLayersTextAbstract({
                    content: node.innerHTML,
                    width: width,
                    height: height,
                    transform: transform,
                    extra: extra,
                    watchable: true
                })
            ]);
        };
    }
};
var $39c5346b7e5f0f6d$var$CLEAN_CONTENT_PATTERN = new RegExp("\"", 'ug');
var $39c5346b7e5f0f6d$var$SECONDARY_UNICODE_RANGE = [
    1105920,
    1112319
];
var $39c5346b7e5f0f6d$var$_FONT_FAMILY_WEIGHT_TO_PREFIX = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, {
    FontAwesome: {
        normal: 'fas',
        400: 'fas'
    }
}), $39c5346b7e5f0f6d$var$Ct), $39c5346b7e5f0f6d$var$ro), $39c5346b7e5f0f6d$var$dl);
var $39c5346b7e5f0f6d$var$FONT_FAMILY_WEIGHT_TO_PREFIX = Object.keys($39c5346b7e5f0f6d$var$_FONT_FAMILY_WEIGHT_TO_PREFIX).reduce(function(acc, key) {
    acc[key.toLowerCase()] = $39c5346b7e5f0f6d$var$_FONT_FAMILY_WEIGHT_TO_PREFIX[key];
    return acc;
}, {});
var $39c5346b7e5f0f6d$var$FONT_FAMILY_WEIGHT_FALLBACK = Object.keys($39c5346b7e5f0f6d$var$FONT_FAMILY_WEIGHT_TO_PREFIX).reduce(function(acc, fontFamily) {
    var weights = $39c5346b7e5f0f6d$var$FONT_FAMILY_WEIGHT_TO_PREFIX[fontFamily];
    acc[fontFamily] = weights[900] || $39c5346b7e5f0f6d$var$_toConsumableArray(Object.entries(weights))[0][1];
    return acc;
}, {});
// Return hex value of *first* character in `content`
function $39c5346b7e5f0f6d$var$hexValueFromContent(content) {
    var cleaned = content.replace($39c5346b7e5f0f6d$var$CLEAN_CONTENT_PATTERN, '');
    return $39c5346b7e5f0f6d$var$toHex($39c5346b7e5f0f6d$var$_toConsumableArray(cleaned)[0] || '');
}
// Check if it's a secondary Duotone layer, by checking if:
// - Unicode value in `content` is repeated
// - Unicode value in `content` is above 0x10000
// - The "ss01" font feature is enabled on the `content`
function $39c5346b7e5f0f6d$var$isSecondaryLayer(styles) {
    var hasStylisticSet = styles.getPropertyValue('font-feature-settings').includes('ss01');
    var content = styles.getPropertyValue('content');
    var cleaned = content.replace($39c5346b7e5f0f6d$var$CLEAN_CONTENT_PATTERN, '');
    var codePoint = cleaned.codePointAt(0);
    var isPrependTen = codePoint >= $39c5346b7e5f0f6d$var$SECONDARY_UNICODE_RANGE[0] && codePoint <= $39c5346b7e5f0f6d$var$SECONDARY_UNICODE_RANGE[1];
    var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return isPrependTen || isDoubled || hasStylisticSet;
}
function $39c5346b7e5f0f6d$var$getPrefix(fontFamily, fontWeight) {
    var fontFamilySanitized = fontFamily.replace(/^['"]|['"]$/g, '').toLowerCase();
    var fontWeightInteger = parseInt(fontWeight);
    var fontWeightSanitized = isNaN(fontWeightInteger) ? 'normal' : fontWeightInteger;
    return ($39c5346b7e5f0f6d$var$FONT_FAMILY_WEIGHT_TO_PREFIX[fontFamilySanitized] || {})[fontWeightSanitized] || $39c5346b7e5f0f6d$var$FONT_FAMILY_WEIGHT_FALLBACK[fontFamilySanitized];
}
function $39c5346b7e5f0f6d$var$replaceForPosition(node, position) {
    var pendingAttribute = "".concat($39c5346b7e5f0f6d$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
    return new Promise(function(resolve, reject) {
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        var children = $39c5346b7e5f0f6d$var$toArray(node.children);
        var alreadyProcessedPseudoElement = children.filter(function(c$$1) {
            return c$$1.getAttribute($39c5346b7e5f0f6d$var$DATA_FA_PSEUDO_ELEMENT) === position;
        })[0];
        var styles = $39c5346b7e5f0f6d$var$WINDOW.getComputedStyle(node, position);
        var fontFamily = styles.getPropertyValue('font-family');
        var fontFamilyMatch = fontFamily.match($39c5346b7e5f0f6d$var$FONT_FAMILY_PATTERN);
        var fontWeight = styles.getPropertyValue('font-weight');
        var content = styles.getPropertyValue('content');
        if (alreadyProcessedPseudoElement && !fontFamilyMatch) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamilyMatch && content !== 'none' && content !== '') {
            var _content = styles.getPropertyValue('content');
            var prefix = $39c5346b7e5f0f6d$var$getPrefix(fontFamily, fontWeight);
            var hexValue = $39c5346b7e5f0f6d$var$hexValueFromContent(_content);
            var isV4 = fontFamilyMatch[0].startsWith('FontAwesome');
            var isSecondary = $39c5346b7e5f0f6d$var$isSecondaryLayer(styles);
            var iconName = $39c5346b7e5f0f6d$var$byUnicode(prefix, hexValue);
            var iconIdentifier = iconName;
            if (isV4) {
                var iconName4 = $39c5346b7e5f0f6d$var$byOldUnicode(hexValue);
                if (iconName4.iconName && iconName4.prefix) {
                    iconName = iconName4.iconName;
                    prefix = iconName4.prefix;
                }
            }
            // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($39c5346b7e5f0f6d$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($39c5346b7e5f0f6d$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                var meta = $39c5346b7e5f0f6d$var$blankMeta();
                var extra = meta.extra;
                extra.attributes[$39c5346b7e5f0f6d$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $39c5346b7e5f0f6d$var$findIcon(iconName, prefix).then(function(main) {
                    var abstract = $39c5346b7e5f0f6d$var$makeInlineSvgAbstract($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, meta), {}, {
                        icons: {
                            main: main,
                            mask: $39c5346b7e5f0f6d$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    var element = $39c5346b7e5f0f6d$var$DOCUMENT.createElementNS('http://www.w3.org/2000/svg', 'svg');
                    if (position === '::before') node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = abstract.map(function(a$$1) {
                        return $39c5346b7e5f0f6d$var$toHtml(a$$1);
                    }).join('\n');
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function $39c5346b7e5f0f6d$var$replace(node) {
    return Promise.all([
        $39c5346b7e5f0f6d$var$replaceForPosition(node, '::before'),
        $39c5346b7e5f0f6d$var$replaceForPosition(node, '::after')
    ]);
}
function $39c5346b7e5f0f6d$var$processable(node) {
    return node.parentNode !== document.head && !~$39c5346b7e5f0f6d$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($39c5346b7e5f0f6d$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}
var $39c5346b7e5f0f6d$var$hasPseudoElement = function hasPseudoElement(selector) {
    return !!selector && $39c5346b7e5f0f6d$var$PSEUDO_ELEMENTS.some(function(pseudoSelector) {
        return selector.includes(pseudoSelector);
    });
};
// Return selectors from all available stylesheets that have
// pseudo-elements defined.
var $39c5346b7e5f0f6d$var$parseCSSRuleForPseudos = function parseCSSRuleForPseudos(selectorText) {
    if (!selectorText) return [];
    var selectorSet = new Set();
    var selectors = selectorText.split(/,(?![^()]*\))/).map(function(s$$1) {
        return s$$1.trim();
    });
    selectors = selectors.flatMap(function(selector) {
        return selector.includes('(') ? selector : selector.split(',').map(function(s$$1) {
            return s$$1.trim();
        });
    });
    var _iterator = $39c5346b7e5f0f6d$var$_createForOfIteratorHelper(selectors), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var selector = _step.value;
            if ($39c5346b7e5f0f6d$var$hasPseudoElement(selector)) {
                // Remove pseudo-elements from the selector
                var selectorWithoutPseudo = $39c5346b7e5f0f6d$var$PSEUDO_ELEMENTS.reduce(function(acc, pseudoSelector) {
                    return acc.replace(pseudoSelector, '');
                }, selector);
                if (selectorWithoutPseudo !== '' && selectorWithoutPseudo !== '*') selectorSet.add(selectorWithoutPseudo);
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return selectorSet;
};
function $39c5346b7e5f0f6d$var$searchPseudoElements(root) {
    var useAsNodeList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!$39c5346b7e5f0f6d$var$IS_DOM) return;
    var nodeList;
    if (useAsNodeList) nodeList = root;
    else if ($39c5346b7e5f0f6d$var$config.searchPseudoElementsFullScan) nodeList = root.querySelectorAll('*');
    else {
        // Get elements that have pseudo elements defined in the CSS
        var selectorSet = new Set();
        var _iterator2 = $39c5346b7e5f0f6d$var$_createForOfIteratorHelper(document.styleSheets), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var stylesheet = _step2.value;
                try {
                    var _iterator3 = $39c5346b7e5f0f6d$var$_createForOfIteratorHelper(stylesheet.cssRules), _step3;
                    try {
                        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                            var rule = _step3.value;
                            var parsedSelectors = $39c5346b7e5f0f6d$var$parseCSSRuleForPseudos(rule.selectorText);
                            var _iterator4 = $39c5346b7e5f0f6d$var$_createForOfIteratorHelper(parsedSelectors), _step4;
                            try {
                                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                    var selector = _step4.value;
                                    selectorSet.add(selector);
                                }
                            } catch (err) {
                                _iterator4.e(err);
                            } finally{
                                _iterator4.f();
                            }
                        }
                    } catch (err) {
                        _iterator3.e(err);
                    } finally{
                        _iterator3.f();
                    }
                } catch (e$$1) {
                    if ($39c5346b7e5f0f6d$var$config.searchPseudoElementsWarnings) console.warn("Font Awesome: cannot parse stylesheet: ".concat(stylesheet.href, " (").concat(e$$1.message, ")\nIf it declares any Font Awesome CSS pseudo-elements, they will not be rendered as SVG icons. Add crossorigin=\"anonymous\" to the <link>, enable searchPseudoElementsFullScan for slower but more thorough DOM parsing, or suppress this warning by setting searchPseudoElementsWarnings to false."));
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        if (!selectorSet.size) return;
        var cleanSelectors = Array.from(selectorSet).join(', ');
        try {
            nodeList = root.querySelectorAll(cleanSelectors);
        } catch (_unused) {} // eslint-disable-line no-empty
    }
    return new Promise(function(resolve, reject) {
        var operations = $39c5346b7e5f0f6d$var$toArray(nodeList).filter($39c5346b7e5f0f6d$var$processable).map($39c5346b7e5f0f6d$var$replace);
        var end = $39c5346b7e5f0f6d$var$perf.begin('searchPseudoElements');
        $39c5346b7e5f0f6d$var$disableObservation();
        Promise.all(operations).then(function() {
            end();
            $39c5346b7e5f0f6d$var$enableObservation();
            resolve();
        }).catch(function() {
            end();
            $39c5346b7e5f0f6d$var$enableObservation();
            reject();
        });
    });
}
var $39c5346b7e5f0f6d$var$PseudoElements = {
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.pseudoElementsCallback = $39c5346b7e5f0f6d$var$searchPseudoElements;
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.pseudoElements2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $39c5346b7e5f0f6d$var$DOCUMENT : _params$node;
            if ($39c5346b7e5f0f6d$var$config.searchPseudoElements) $39c5346b7e5f0f6d$var$searchPseudoElements(node);
        };
    }
};
var $39c5346b7e5f0f6d$var$_unwatched = false;
var $39c5346b7e5f0f6d$var$MutationObserver$1 = {
    mixout: function mixout() {
        return {
            dom: {
                unwatch: function unwatch() {
                    $39c5346b7e5f0f6d$var$disableObservation();
                    $39c5346b7e5f0f6d$var$_unwatched = true;
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            bootstrap: function bootstrap() {
                $39c5346b7e5f0f6d$var$observe($39c5346b7e5f0f6d$var$chainHooks('mutationObserverCallbacks', {}));
            },
            noAuto: function noAuto() {
                $39c5346b7e5f0f6d$var$disconnect();
            },
            watch: function watch(params) {
                var observeMutationsRoot = params.observeMutationsRoot;
                if ($39c5346b7e5f0f6d$var$_unwatched) $39c5346b7e5f0f6d$var$enableObservation();
                else $39c5346b7e5f0f6d$var$observe($39c5346b7e5f0f6d$var$chainHooks('mutationObserverCallbacks', {
                    observeMutationsRoot: observeMutationsRoot
                }));
            }
        };
    }
};
var $39c5346b7e5f0f6d$var$parseTransformString = function parseTransformString(transformString) {
    var transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    return transformString.toLowerCase().split(' ').reduce(function(acc, n) {
        var parts = n.toLowerCase().split('-');
        var first = parts[0];
        var rest = parts.slice(1).join('-');
        if (first && rest === 'h') {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === 'v') {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case 'grow':
                acc.size = acc.size + rest;
                break;
            case 'shrink':
                acc.size = acc.size - rest;
                break;
            case 'left':
                acc.x = acc.x - rest;
                break;
            case 'right':
                acc.x = acc.x + rest;
                break;
            case 'up':
                acc.y = acc.y - rest;
                break;
            case 'down':
                acc.y = acc.y + rest;
                break;
            case 'rotate':
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
var $39c5346b7e5f0f6d$var$PowerTransforms = {
    mixout: function mixout() {
        return {
            parse: {
                transform: function transform(transformString) {
                    return $39c5346b7e5f0f6d$var$parseTransformString(transformString);
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var transformString = node.getAttribute('data-fa-transform');
                if (transformString) accumulator.transform = $39c5346b7e5f0f6d$var$parseTransformString(transformString);
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractTransformGrouping = function(_ref) {
            var main = _ref.main, transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
            var outer = {
                transform: "translate(".concat(containerWidth / 2, " 256)")
            };
            var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
            var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
            var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
            var inner = {
                transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
            };
            var path = {
                transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
            };
            var operations = {
                outer: outer,
                inner: inner,
                path: path
            };
            return {
                tag: 'g',
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2({}, operations.outer),
                children: [
                    {
                        tag: 'g',
                        attributes: $39c5346b7e5f0f6d$var$_objectSpread2({}, operations.inner),
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, main.icon.attributes), operations.path)
                            }
                        ]
                    }
                ]
            };
        };
    }
};
var $39c5346b7e5f0f6d$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: '100%',
    height: '100%'
};
function $39c5346b7e5f0f6d$var$fillBlack(abstract) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (abstract.attributes && (abstract.attributes.fill || force)) abstract.attributes.fill = 'black';
    return abstract;
}
function $39c5346b7e5f0f6d$var$deGroup(abstract) {
    if (abstract.tag === 'g') return abstract.children;
    else return [
        abstract
    ];
}
var $39c5346b7e5f0f6d$var$Masks = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var maskData = node.getAttribute('data-fa-mask');
                var mask = !maskData ? $39c5346b7e5f0f6d$var$emptyCanonicalIcon() : $39c5346b7e5f0f6d$var$getCanonicalIcon(maskData.split(' ').map(function(i) {
                    return i.trim();
                }));
                if (!mask.prefix) mask.prefix = $39c5346b7e5f0f6d$var$getDefaultUsablePrefix();
                accumulator.mask = mask;
                accumulator.maskId = node.getAttribute('data-fa-mask-id');
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractMask = function(_ref) {
            var children = _ref.children, attributes = _ref.attributes, main = _ref.main, mask = _ref.mask, explicitMaskId = _ref.maskId, transform = _ref.transform;
            var mainWidth = main.width, mainPath = main.icon;
            var maskWidth = mask.width, maskPath = mask.icon;
            var trans = $39c5346b7e5f0f6d$var$transformForSvg({
                transform: transform,
                containerWidth: maskWidth,
                iconWidth: mainWidth
            });
            var maskRect = {
                tag: 'rect',
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$ALL_SPACE), {}, {
                    fill: 'white'
                })
            };
            var maskInnerGroupChildrenMixin = mainPath.children ? {
                children: mainPath.children.map($39c5346b7e5f0f6d$var$fillBlack)
            } : {};
            var maskInnerGroup = {
                tag: 'g',
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2({}, trans.inner),
                children: [
                    $39c5346b7e5f0f6d$var$fillBlack($39c5346b7e5f0f6d$var$_objectSpread2({
                        tag: mainPath.tag,
                        attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, mainPath.attributes), trans.path)
                    }, maskInnerGroupChildrenMixin))
                ]
            };
            var maskOuterGroup = {
                tag: 'g',
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2({}, trans.outer),
                children: [
                    maskInnerGroup
                ]
            };
            var maskId = "mask-".concat(explicitMaskId || $39c5346b7e5f0f6d$var$nextUniqueId());
            var clipId = "clip-".concat(explicitMaskId || $39c5346b7e5f0f6d$var$nextUniqueId());
            var maskTag = {
                tag: 'mask',
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$ALL_SPACE), {}, {
                    id: maskId,
                    maskUnits: 'userSpaceOnUse',
                    maskContentUnits: 'userSpaceOnUse'
                }),
                children: [
                    maskRect,
                    maskOuterGroup
                ]
            };
            var defs = {
                tag: 'defs',
                children: [
                    {
                        tag: 'clipPath',
                        attributes: {
                            id: clipId
                        },
                        children: $39c5346b7e5f0f6d$var$deGroup(maskPath)
                    },
                    maskTag
                ]
            };
            children.push(defs, {
                tag: 'rect',
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2({
                    'fill': 'currentColor',
                    'clip-path': "url(#".concat(clipId, ")"),
                    'mask': "url(#".concat(maskId, ")")
                }, $39c5346b7e5f0f6d$var$ALL_SPACE)
            });
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $39c5346b7e5f0f6d$var$MissingIconIndicator = {
    provides: function provides(providers) {
        var reduceMotion = false;
        if ($39c5346b7e5f0f6d$var$WINDOW.matchMedia) reduceMotion = $39c5346b7e5f0f6d$var$WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
        providers.missingIconAbstract = function() {
            var gChildren = [];
            var FILL = {
                fill: 'currentColor'
            };
            var ANIMATION_BASE = {
                attributeType: 'XML',
                repeatCount: 'indefinite',
                dur: '2s'
            };
            // Ring
            gChildren.push({
                tag: 'path',
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, FILL), {}, {
                    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
                })
            });
            var OPACITY_ANIMATE = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                attributeName: 'opacity'
            });
            var dot = {
                tag: 'circle',
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, FILL), {}, {
                    cx: '256',
                    cy: '364',
                    r: '28'
                }),
                children: []
            };
            if (!reduceMotion) dot.children.push({
                tag: 'animate',
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                    attributeName: 'r',
                    values: '28;14;28;28;14;28;'
                })
            }, {
                tag: 'animate',
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                    values: '1;0;1;1;0;1;'
                })
            });
            gChildren.push(dot);
            gChildren.push({
                tag: 'path',
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, FILL), {}, {
                    opacity: '1',
                    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
                }),
                children: reduceMotion ? [] : [
                    {
                        tag: 'animate',
                        attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '1;0;0;0;0;1;'
                        })
                    }
                ]
            });
            if (!reduceMotion) // Exclamation
            gChildren.push({
                tag: 'path',
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, FILL), {}, {
                    opacity: '0',
                    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
                }),
                children: [
                    {
                        tag: 'animate',
                        attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '0;0;1;1;0;0;'
                        })
                    }
                ]
            });
            return {
                tag: 'g',
                attributes: {
                    class: 'missing'
                },
                children: gChildren
            };
        };
    }
};
var $39c5346b7e5f0f6d$var$SvgSymbols = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var symbolData = node.getAttribute('data-fa-symbol');
                var symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
                accumulator['symbol'] = symbol;
                return accumulator;
            }
        };
    }
};
var $39c5346b7e5f0f6d$var$plugins = [
    $39c5346b7e5f0f6d$var$InjectCSS,
    $39c5346b7e5f0f6d$var$ReplaceElements,
    $39c5346b7e5f0f6d$var$Layers,
    $39c5346b7e5f0f6d$var$LayersCounter,
    $39c5346b7e5f0f6d$var$LayersText,
    $39c5346b7e5f0f6d$var$PseudoElements,
    $39c5346b7e5f0f6d$var$MutationObserver$1,
    $39c5346b7e5f0f6d$var$PowerTransforms,
    $39c5346b7e5f0f6d$var$Masks,
    $39c5346b7e5f0f6d$var$MissingIconIndicator,
    $39c5346b7e5f0f6d$var$SvgSymbols
];
$39c5346b7e5f0f6d$var$registerPlugins($39c5346b7e5f0f6d$var$plugins, {
    mixoutsTo: $39c5346b7e5f0f6d$export$644d8ea042df96a6
});
var $39c5346b7e5f0f6d$export$4f8e844b2782642c = $39c5346b7e5f0f6d$export$644d8ea042df96a6.noAuto;
var $39c5346b7e5f0f6d$export$e506a1d27d1eaa20 = $39c5346b7e5f0f6d$export$644d8ea042df96a6.config;
var $39c5346b7e5f0f6d$export$b839f963c7dc0e34 = $39c5346b7e5f0f6d$export$644d8ea042df96a6.library;
var $39c5346b7e5f0f6d$export$df3a06d6289f983e = $39c5346b7e5f0f6d$export$644d8ea042df96a6.dom;
var $39c5346b7e5f0f6d$export$98e6a39c04603d36 = $39c5346b7e5f0f6d$export$644d8ea042df96a6.parse;
var $39c5346b7e5f0f6d$export$221fed4a47f597a5 = $39c5346b7e5f0f6d$export$644d8ea042df96a6.findIconDefinition;
var $39c5346b7e5f0f6d$export$a10125c086a4df16 = $39c5346b7e5f0f6d$export$644d8ea042df96a6.toHtml;
var $39c5346b7e5f0f6d$export$1ca1ec8b29a4ce27 = $39c5346b7e5f0f6d$export$644d8ea042df96a6.icon;
var $39c5346b7e5f0f6d$export$50a222d9023da98b = $39c5346b7e5f0f6d$export$644d8ea042df96a6.layer;
var $39c5346b7e5f0f6d$export$6f093cfa640b7166 = $39c5346b7e5f0f6d$export$644d8ea042df96a6.text;
var $39c5346b7e5f0f6d$export$e575061ef2a070eb = $39c5346b7e5f0f6d$export$644d8ea042df96a6.counter;




var $eHaBZ = parcelRequire("eHaBZ");
function $2ca1a35d7f3a323d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $2ca1a35d7f3a323d$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $2ca1a35d7f3a323d$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $2ca1a35d7f3a323d$var$_arrayLikeToArray(r);
}
function $2ca1a35d7f3a323d$var$_defineProperty(e, r, t) {
    return (r = $2ca1a35d7f3a323d$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2ca1a35d7f3a323d$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $2ca1a35d7f3a323d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $2ca1a35d7f3a323d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2ca1a35d7f3a323d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2ca1a35d7f3a323d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2ca1a35d7f3a323d$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2ca1a35d7f3a323d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2ca1a35d7f3a323d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2ca1a35d7f3a323d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2ca1a35d7f3a323d$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $2ca1a35d7f3a323d$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $2ca1a35d7f3a323d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $2ca1a35d7f3a323d$var$_slicedToArray(r, e) {
    return $2ca1a35d7f3a323d$var$_arrayWithHoles(r) || $2ca1a35d7f3a323d$var$_iterableToArrayLimit(r, e) || $2ca1a35d7f3a323d$var$_unsupportedIterableToArray(r, e) || $2ca1a35d7f3a323d$var$_nonIterableRest();
}
function $2ca1a35d7f3a323d$var$_toConsumableArray(r) {
    return $2ca1a35d7f3a323d$var$_arrayWithoutHoles(r) || $2ca1a35d7f3a323d$var$_iterableToArray(r) || $2ca1a35d7f3a323d$var$_unsupportedIterableToArray(r) || $2ca1a35d7f3a323d$var$_nonIterableSpread();
}
function $2ca1a35d7f3a323d$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $2bfPH._)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $2bfPH._)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2ca1a35d7f3a323d$var$_toPropertyKey(t) {
    var i = $2ca1a35d7f3a323d$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $2bfPH._)(i)) ? i : i + "";
}
function $2ca1a35d7f3a323d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2ca1a35d7f3a323d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2ca1a35d7f3a323d$var$_typeof(o);
}
function $2ca1a35d7f3a323d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2ca1a35d7f3a323d$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2ca1a35d7f3a323d$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $2ca1a35d7f3a323d$var$ICON_PACKS_STARTING_VERSION = '7.0.0';
// Try to get version from installed package first, fallback to env var, then default
var $2ca1a35d7f3a323d$var$SVG_CORE_VERSION;

try {
    var $2ca1a35d7f3a323d$var$svgCorePackageJson = (parcelRequire("ep3JT"));
    $2ca1a35d7f3a323d$var$SVG_CORE_VERSION = $2ca1a35d7f3a323d$var$svgCorePackageJson.version;
} catch (e) {
    // If package.json can't be loaded, try environment variable
    $2ca1a35d7f3a323d$var$SVG_CORE_VERSION = '7.0.0';
}
// Get CSS class list from a props object
function $2ca1a35d7f3a323d$var$classList(props) {
    var beat = props.beat, fade = props.fade, beatFade = props.beatFade, bounce = props.bounce, shake = props.shake, flash = props.flash, spin = props.spin, spinPulse = props.spinPulse, spinReverse = props.spinReverse, pulse = props.pulse, fixedWidth = props.fixedWidth, inverse = props.inverse, border = props.border, listItem = props.listItem, flip = props.flip, size = props.size, rotation = props.rotation, pull = props.pull, swapOpacity = props.swapOpacity, rotateBy = props.rotateBy, widthAuto = props.widthAuto;
    // Check if we're using version 7 or later
    var isVersion7OrLater = $2ca1a35d7f3a323d$var$versionCheckGte($2ca1a35d7f3a323d$var$SVG_CORE_VERSION, $2ca1a35d7f3a323d$var$ICON_PACKS_STARTING_VERSION);
    // map of CSS class names to properties
    var classes = $2ca1a35d7f3a323d$var$_defineProperty($2ca1a35d7f3a323d$var$_defineProperty($2ca1a35d7f3a323d$var$_defineProperty($2ca1a35d7f3a323d$var$_defineProperty($2ca1a35d7f3a323d$var$_defineProperty($2ca1a35d7f3a323d$var$_defineProperty({
        'fa-beat': beat,
        'fa-fade': fade,
        'fa-beat-fade': beatFade,
        'fa-bounce': bounce,
        'fa-shake': shake,
        'fa-flash': flash,
        'fa-spin': spin,
        'fa-spin-reverse': spinReverse,
        'fa-spin-pulse': spinPulse,
        'fa-pulse': pulse,
        'fa-fw': fixedWidth,
        'fa-inverse': inverse,
        'fa-border': border,
        'fa-li': listItem,
        'fa-flip': flip === true,
        'fa-flip-horizontal': flip === 'horizontal' || flip === 'both',
        'fa-flip-vertical': flip === 'vertical' || flip === 'both'
    }, "fa-".concat(size), typeof size !== 'undefined' && size !== null), "fa-rotate-".concat(rotation), typeof rotation !== 'undefined' && rotation !== null && rotation !== 0), "fa-pull-".concat(pull), typeof pull !== 'undefined' && pull !== null), 'fa-swap-opacity', swapOpacity), 'fa-rotate-by', isVersion7OrLater && rotateBy), 'fa-width-auto', isVersion7OrLater && widthAuto);
    // map over all the keys in the classes object
    // return an array of the keys where the value for the key is not null
    return Object.keys(classes).map(function(key) {
        return classes[key] ? key : null;
    }).filter(function(key) {
        return key;
    });
}
// check if verion1 is greater than or equal to version2
function $2ca1a35d7f3a323d$var$versionCheckGte(version1, version2) {
    var _version1$split = version1.split('-'), _version1$split2 = $2ca1a35d7f3a323d$var$_slicedToArray(_version1$split, 2), v1Base = _version1$split2[0], v1PreRelease = _version1$split2[1];
    var _version2$split = version2.split('-'), _version2$split2 = $2ca1a35d7f3a323d$var$_slicedToArray(_version2$split, 2), v2Base = _version2$split2[0], v2PreRelease = _version2$split2[1];
    var v1Parts = v1Base.split('.');
    var v2Parts = v2Base.split('.');
    // Compare version numbers first
    for(var i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++){
        var v1Part = v1Parts[i] || '0';
        var v2Part = v2Parts[i] || '0';
        // Compare numeric values
        var v1Num = parseInt(v1Part, 10);
        var v2Num = parseInt(v2Part, 10);
        if (v1Num !== v2Num) return v1Num > v2Num;
    }
    // If numeric values are equal, look for any remaining parts
    // that would make one version greater than the other
    for(var _i = 0; _i < Math.max(v1Parts.length, v2Parts.length); _i++){
        var _v1Part = v1Parts[_i] || '0';
        var _v2Part = v2Parts[_i] || '0';
        if (_v1Part !== _v2Part) {
            // When numeric values are equal but strings differ,
            // the one without leading zeros is greater
            if (_v1Part.length !== _v2Part.length) return _v1Part.length < _v2Part.length;
        }
    }
    // If version numbers are equal, compare pre-release identifiers
    // A version with a pre-release identifier is less than one without
    if (v1PreRelease && !v2PreRelease) return false;
    if (!v1PreRelease && v2PreRelease) return true;
    return true;
}
// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function $2ca1a35d7f3a323d$var$_isNumerical(obj) {
    obj = obj - 0;
    // eslint-disable-next-line no-self-compare
    return obj === obj;
}
function $2ca1a35d7f3a323d$var$camelize(string) {
    if ($2ca1a35d7f3a323d$var$_isNumerical(string)) return string;
    // eslint-disable-next-line no-useless-escape
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
        return chr ? chr.toUpperCase() : '';
    });
    // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
}
var $2ca1a35d7f3a323d$var$_excluded = [
    "style"
];
function $2ca1a35d7f3a323d$var$capitalize(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
}
function $2ca1a35d7f3a323d$var$styleToObject(style) {
    return style.split(';').map(function(s) {
        return s.trim();
    }).filter(function(s) {
        return s;
    }).reduce(function(acc, pair) {
        var i = pair.indexOf(':');
        var prop = $2ca1a35d7f3a323d$var$camelize(pair.slice(0, i));
        var value = pair.slice(i + 1).trim();
        prop.startsWith('webkit') ? acc[$2ca1a35d7f3a323d$var$capitalize(prop)] = value : acc[prop] = value;
        return acc;
    }, {});
}
function $2ca1a35d7f3a323d$var$convert(createElement, element) {
    var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (typeof element === 'string') return element;
    var children = (element.children || []).map(function(child) {
        return $2ca1a35d7f3a323d$var$convert(createElement, child);
    });
    /* eslint-disable dot-notation */ var mixins = Object.keys(element.attributes || {}).reduce(function(acc, key) {
        var val = element.attributes[key];
        switch(key){
            case 'class':
                acc.attrs['className'] = val;
                delete element.attributes['class'];
                break;
            case 'style':
                acc.attrs['style'] = $2ca1a35d7f3a323d$var$styleToObject(val);
                break;
            default:
                if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) acc.attrs[key.toLowerCase()] = val;
                else acc.attrs[$2ca1a35d7f3a323d$var$camelize(key)] = val;
        }
        return acc;
    }, {
        attrs: {}
    });
    var _extraProps$style = extraProps.style, existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style, remaining = $2ca1a35d7f3a323d$var$_objectWithoutProperties(extraProps, $2ca1a35d7f3a323d$var$_excluded);
    mixins.attrs['style'] = $2ca1a35d7f3a323d$var$_objectSpread2($2ca1a35d7f3a323d$var$_objectSpread2({}, mixins.attrs['style']), existingStyle);
    /* eslint-enable */ return createElement.apply(void 0, [
        element.tag,
        $2ca1a35d7f3a323d$var$_objectSpread2($2ca1a35d7f3a323d$var$_objectSpread2({}, mixins.attrs), remaining)
    ].concat($2ca1a35d7f3a323d$var$_toConsumableArray(children)));
}
var $2ca1a35d7f3a323d$var$PRODUCTION = false;
try {
    $2ca1a35d7f3a323d$var$PRODUCTION = true;
} catch (e) {}
function $2ca1a35d7f3a323d$var$log() {
    if (!$2ca1a35d7f3a323d$var$PRODUCTION && console && typeof console.error === 'function') {
        var _console;
        (_console = console).error.apply(_console, arguments);
    }
}
// Normalize icon arguments
function $2ca1a35d7f3a323d$var$normalizeIconArgs(icon) {
    // this has everything that it needs to be rendered which means it was probably imported
    // directly from an icon svg package
    if (icon && $2ca1a35d7f3a323d$var$_typeof(icon) === 'object' && icon.prefix && icon.iconName && icon.icon) return icon;
    if ((0, $39c5346b7e5f0f6d$export$98e6a39c04603d36).icon) return (0, $39c5346b7e5f0f6d$export$98e6a39c04603d36).icon(icon);
    // if the icon is null, there's nothing to do
    if (icon === null) return null;
    // if the icon is an object and has a prefix and an icon name, return it
    if (icon && $2ca1a35d7f3a323d$var$_typeof(icon) === 'object' && icon.prefix && icon.iconName) return icon;
    // if it's an array with length of two
    if (Array.isArray(icon) && icon.length === 2) // use the first item as prefix, second as icon name
    return {
        prefix: icon[0],
        iconName: icon[1]
    };
    // if it's a string, use it as the icon name
    if (typeof icon === 'string') return {
        prefix: 'fas',
        iconName: icon
    };
}
// creates an object with a key of key
// and a value of value
// if certain conditions are met
function $2ca1a35d7f3a323d$var$objectWithKey(key, value) {
    // if the value is a non-empty array
    // or it's not an array but it is truthy
    // then create the object with the key and the value
    // if not, return an empty array
    return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? $2ca1a35d7f3a323d$var$_defineProperty({}, key, value) : {};
}
var $2ca1a35d7f3a323d$var$defaultProps = {
    border: false,
    className: '',
    mask: null,
    maskId: null,
    // the fixedWidth property has been deprecated as of version 7
    fixedWidth: false,
    inverse: false,
    flip: false,
    icon: null,
    listItem: false,
    pull: null,
    pulse: false,
    rotation: null,
    rotateBy: false,
    size: null,
    spin: false,
    spinPulse: false,
    spinReverse: false,
    beat: false,
    fade: false,
    beatFade: false,
    bounce: false,
    shake: false,
    symbol: false,
    title: '',
    titleId: null,
    transform: null,
    swapOpacity: false,
    widthAuto: false
};
var $2ca1a35d7f3a323d$export$2b9260d4a45c8710 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).forwardRef(function(props, ref) {
    var allProps = $2ca1a35d7f3a323d$var$_objectSpread2($2ca1a35d7f3a323d$var$_objectSpread2({}, $2ca1a35d7f3a323d$var$defaultProps), props);
    var iconArgs = allProps.icon, maskArgs = allProps.mask, symbol = allProps.symbol, className = allProps.className, title = allProps.title, titleId = allProps.titleId, maskId = allProps.maskId;
    var iconLookup = $2ca1a35d7f3a323d$var$normalizeIconArgs(iconArgs);
    var classes = $2ca1a35d7f3a323d$var$objectWithKey('classes', [].concat($2ca1a35d7f3a323d$var$_toConsumableArray($2ca1a35d7f3a323d$var$classList(allProps)), $2ca1a35d7f3a323d$var$_toConsumableArray((className || '').split(' '))));
    var transform = $2ca1a35d7f3a323d$var$objectWithKey('transform', typeof allProps.transform === 'string' ? (0, $39c5346b7e5f0f6d$export$98e6a39c04603d36).transform(allProps.transform) : allProps.transform);
    var mask = $2ca1a35d7f3a323d$var$objectWithKey('mask', $2ca1a35d7f3a323d$var$normalizeIconArgs(maskArgs));
    var renderedIcon = (0, $39c5346b7e5f0f6d$export$1ca1ec8b29a4ce27)(iconLookup, $2ca1a35d7f3a323d$var$_objectSpread2($2ca1a35d7f3a323d$var$_objectSpread2($2ca1a35d7f3a323d$var$_objectSpread2($2ca1a35d7f3a323d$var$_objectSpread2({}, classes), transform), mask), {}, {
        symbol: symbol,
        title: title,
        titleId: titleId,
        maskId: maskId
    }));
    if (!renderedIcon) {
        $2ca1a35d7f3a323d$var$log('Could not find icon', iconLookup);
        return null;
    }
    var abstract = renderedIcon.abstract;
    var extraProps = {
        ref: ref
    };
    Object.keys(allProps).forEach(function(key) {
        // eslint-disable-next-line no-prototype-builtins
        if (!$2ca1a35d7f3a323d$var$defaultProps.hasOwnProperty(key)) extraProps[key] = allProps[key];
    });
    return $2ca1a35d7f3a323d$var$convertCurry(abstract[0], extraProps);
});
$2ca1a35d7f3a323d$export$2b9260d4a45c8710.displayName = 'FontAwesomeIcon';
$2ca1a35d7f3a323d$export$2b9260d4a45c8710.propTypes = {
    beat: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    border: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    beatFade: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    bounce: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string,
    fade: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    flash: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    mask: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string
    ]),
    maskId: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string,
    // the fixedWidth property has been deprecated as of version 7
    fixedWidth: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    inverse: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    flip: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOf([
        true,
        false,
        'horizontal',
        'vertical',
        'both'
    ]),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string
    ]),
    listItem: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    pull: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOf([
        'right',
        'left'
    ]),
    pulse: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    rotation: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOf([
        0,
        90,
        180,
        270
    ]),
    rotateBy: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    shake: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOf([
        '2xs',
        'xs',
        'sm',
        'lg',
        'xl',
        '2xl',
        '1x',
        '2x',
        '3x',
        '4x',
        '5x',
        '6x',
        '7x',
        '8x',
        '9x',
        '10x'
    ]),
    spin: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    spinPulse: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    spinReverse: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    symbol: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string,
    titleId: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string,
    transform: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object
    ]),
    swapOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool,
    widthAuto: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool
};
var $2ca1a35d7f3a323d$var$convertCurry = $2ca1a35d7f3a323d$var$convert.bind(null, (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement);



var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $aRv4I = parcelRequire("aRv4I");

var $21h22 = parcelRequire("21h22");


var $eHaBZ = parcelRequire("eHaBZ");
var $8929b96d30942b2d$var$w = "collapsed", $8929b96d30942b2d$var$p = "collapsing", $8929b96d30942b2d$var$r = "expanding", $8929b96d30942b2d$var$a = "expanded", $8929b96d30942b2d$var$K = "collapse-css-transition", $8929b96d30942b2d$var$M = "div", $8929b96d30942b2d$var$Q = "0px";
function $8929b96d30942b2d$var$N(o) {
    requestAnimationFrame(function() {
        requestAnimationFrame(o);
    });
}
var $8929b96d30942b2d$export$78768a9af065a7b = function(_param) {
    var C = function C() {
        i.current && (e.collapse = $8929b96d30942b2d$var$w, e.style = {
            height: s,
            visibility: m()
        }, u(), setTimeout(function() {
            return l(Date.now);
        }, 0));
    };
    var $ = function $() {
        if (i.current) {
            if (h) return C();
            e.collapse = $8929b96d30942b2d$var$p, e.style = {
                height: x(),
                visibility: void 0
            }, u(), $8929b96d30942b2d$var$N(function() {
                i.current && e.collapse === $8929b96d30942b2d$var$p && (e.style = {
                    height: s,
                    visibility: void 0
                }, l(Date.now));
            });
        }
    };
    var q = function q() {
        if (i.current) {
            if (h) return E();
            e.collapse = $8929b96d30942b2d$var$r, $8929b96d30942b2d$var$N(function() {
                i.current && e.collapse === $8929b96d30942b2d$var$r && (e.style = {
                    height: x(),
                    visibility: void 0
                }, l(Date.now));
            });
        }
    };
    var E = function E() {
        i.current && (e.collapse = $8929b96d30942b2d$var$a, e.style = {
            height: void 0,
            visibility: void 0
        }, u(), setTimeout(function() {
            return l(Date.now);
        }, 0));
    };
    var x = function x() {
        return "".concat(i.current.scrollHeight, "px");
    };
    var G = function G(param) {
        var t = param.target, f = param.propertyName;
        if (t === i.current && f === "height") {
            var c = t.style.height;
            switch(e.collapse){
                case $8929b96d30942b2d$var$r:
                    c === void 0 || c === s || E();
                    break;
                case $8929b96d30942b2d$var$p:
                    c === void 0 || c !== s || C();
                    break;
            }
        }
    };
    var o = _param.children, T = _param.transition, A = _param.style, d = _param.render, tmp = _param.elementType, y = tmp === void 0 ? $8929b96d30942b2d$var$M : tmp, n = _param.isOpen, tmp1 = _param.collapseHeight, s = tmp1 === void 0 ? $8929b96d30942b2d$var$Q : tmp1, L = _param.onInit, P = _param.onChange, tmp2 = _param.className, v = tmp2 === void 0 ? $8929b96d30942b2d$var$K : tmp2, R = _param.addState, h = _param.noAnim, S = _param.overflowOnExpanded, F = (0, $aRv4I._)(_param, [
        "children",
        "transition",
        "style",
        "render",
        "elementType",
        "isOpen",
        "collapseHeight",
        "onInit",
        "onChange",
        "className",
        "addState",
        "noAnim",
        "overflowOnExpanded"
    ]);
    var m = function() {
        return s === "0px" ? "hidden" : void 0;
    }, _$_ = (0, $21h22._)((0, $eHaBZ.useReducer)(function(t) {
        return t + 1;
    }, 0), 2), W = _$_[0], u = _$_[1], i = (0, $eHaBZ.useRef)(), _z = (0, $21h22._)((0, $eHaBZ.useState)(0), 2), b = _z[0], l = _z[1], e = (0, $eHaBZ.useRef)({
        collapse: n ? $8929b96d30942b2d$var$a : $8929b96d30942b2d$var$w,
        style: {
            height: n ? void 0 : s,
            visibility: n ? void 0 : m()
        }
    }).current;
    (0, $eHaBZ.useEffect)(function() {
        b && g(P);
    }, [
        b
    ]);
    var g = function(t) {
        var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        t && t((0, $lvTkn._)({
            state: e.collapse,
            style: e.style
        }, f));
    };
    var k = e.collapse === $8929b96d30942b2d$var$a || e.collapse === $8929b96d30942b2d$var$r;
    !k && n && q(), k && !n && $();
    var I = (0, $lvTkn._)({
        overflow: e.collapse === $8929b96d30942b2d$var$a && S ? void 0 : "hidden",
        transition: T
    }, A, e.style), X = y, j = (0, $eHaBZ.useCallback)(function(t) {
        t && (i.current = t, g(L, {
            node: t
        }));
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        y
    ]), U = R ? "".concat(v, " --c-").concat(e.collapse) : v;
    return(// @ts-ignore
    /* @__PURE__ */ (0, $f171543c027e46e7$exports.jsx)(X, (0, $9Jpjh._)((0, $lvTkn._)({
        ref: j,
        style: I,
        onTransitionEnd: G,
        className: U
    }, F), {
        children: typeof o == "function" ? o(e.collapse) : typeof d == "function" ? d(e.collapse) : o
    })));
};


var $c31009cc66f4e9b8$exports = {};

var $2bfPH = parcelRequire("2bfPH");
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if ((typeof arg === "undefined" ? "undefined" : (0, $2bfPH._)(arg)) !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($c31009cc66f4e9b8$exports) {
        classNames.default = classNames;
        $c31009cc66f4e9b8$exports = classNames;
    } else if (typeof define === 'function' && (0, $2bfPH._)(define.amd) === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $lvTkn = parcelRequire("lvTkn");

var $21h22 = parcelRequire("21h22");



var $eHaBZ = parcelRequire("eHaBZ");

var $5XYIU = parcelRequire("5XYIU");

var $1Mz1E = parcelRequire("1Mz1E");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $khBmn = parcelRequire("khBmn");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $21h22 = parcelRequire("21h22");

var $ggKxj = parcelRequire("ggKxj");

var $6zk1M = parcelRequire("6zk1M");

var $2bfPH = parcelRequire("2bfPH");

var $6PS3Z = parcelRequire("6PS3Z");


var $eHaBZ = parcelRequire("eHaBZ");
var $2ba76da8a3028b95$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ 
var $2bfPH = parcelRequire("2bfPH");
var $2ba76da8a3028b95$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $2ba76da8a3028b95$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $2ba76da8a3028b95$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $2ba76da8a3028b95$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $2ba76da8a3028b95$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $2ba76da8a3028b95$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $2ba76da8a3028b95$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $2ba76da8a3028b95$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $2ba76da8a3028b95$var$freeGlobal = (typeof $parcel$global === "undefined" ? "undefined" : (0, $2bfPH._)($parcel$global)) == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $2ba76da8a3028b95$var$freeSelf = (typeof self === "undefined" ? "undefined" : (0, $2bfPH._)(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $2ba76da8a3028b95$var$root = $2ba76da8a3028b95$var$freeGlobal || $2ba76da8a3028b95$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $2ba76da8a3028b95$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $2ba76da8a3028b95$var$objectToString = $2ba76da8a3028b95$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2ba76da8a3028b95$var$nativeMax = Math.max, $2ba76da8a3028b95$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $2ba76da8a3028b95$var$now = function now() {
    return $2ba76da8a3028b95$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $2ba76da8a3028b95$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($2ba76da8a3028b95$var$FUNC_ERROR_TEXT);
    wait = $2ba76da8a3028b95$var$toNumber(wait) || 0;
    if ($2ba76da8a3028b95$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $2ba76da8a3028b95$var$nativeMax($2ba76da8a3028b95$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $2ba76da8a3028b95$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $2ba76da8a3028b95$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($2ba76da8a3028b95$var$now());
    }
    function debounced() {
        var time = $2ba76da8a3028b95$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $2ba76da8a3028b95$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value);
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $2ba76da8a3028b95$var$isObjectLike(value) {
    return !!value && (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $2ba76da8a3028b95$var$isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) == 'symbol' || $2ba76da8a3028b95$var$isObjectLike(value) && $2ba76da8a3028b95$var$objectToString.call(value) == $2ba76da8a3028b95$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $2ba76da8a3028b95$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($2ba76da8a3028b95$var$isSymbol(value)) return $2ba76da8a3028b95$var$NAN;
    if ($2ba76da8a3028b95$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $2ba76da8a3028b95$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($2ba76da8a3028b95$var$reTrim, '');
    var isBinary = $2ba76da8a3028b95$var$reIsBinary.test(value);
    return isBinary || $2ba76da8a3028b95$var$reIsOctal.test(value) ? $2ba76da8a3028b95$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $2ba76da8a3028b95$var$reIsBadHex.test(value) ? $2ba76da8a3028b95$var$NAN : +value;
}
$2ba76da8a3028b95$exports = $2ba76da8a3028b95$var$debounce;


var $20cb340d6b373ba4$exports = {};

var $2bfPH = parcelRequire("2bfPH");
'use strict';
// do not edit .js files directly - edit src/index.jst
$20cb340d6b373ba4$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && (typeof a === "undefined" ? "undefined" : (0, $2bfPH._)(a)) == 'object' && (typeof b === "undefined" ? "undefined" : (0, $2bfPH._)(b)) == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};


var $2065ab085cb8cea8$exports = {};
'use strict';

$2065ab085cb8cea8$exports = (parcelRequire("7XifO"));


var $cce1e94b03780a93$exports = {};
var $d93c1fbfc9073e05$exports = {};
// Generated by CoffeeScript 1.12.2
(function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) $d93c1fbfc9073e05$exports = function() {
        return performance.now();
    };
    else if (Date.now) {
        $d93c1fbfc9073e05$exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        $d93c1fbfc9073e05$exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call($d93c1fbfc9073e05$exports);


var $cce1e94b03780a93$var$root = typeof window === 'undefined' ? $parcel$global : window, $cce1e94b03780a93$var$vendors = [
    'moz',
    'webkit'
], $cce1e94b03780a93$var$suffix = 'AnimationFrame', $cce1e94b03780a93$var$raf = $cce1e94b03780a93$var$root['request' + $cce1e94b03780a93$var$suffix], $cce1e94b03780a93$var$caf = $cce1e94b03780a93$var$root['cancel' + $cce1e94b03780a93$var$suffix] || $cce1e94b03780a93$var$root['cancelRequest' + $cce1e94b03780a93$var$suffix];
for(var $cce1e94b03780a93$var$i = 0; !$cce1e94b03780a93$var$raf && $cce1e94b03780a93$var$i < $cce1e94b03780a93$var$vendors.length; $cce1e94b03780a93$var$i++){
    $cce1e94b03780a93$var$raf = $cce1e94b03780a93$var$root[$cce1e94b03780a93$var$vendors[$cce1e94b03780a93$var$i] + 'Request' + $cce1e94b03780a93$var$suffix];
    $cce1e94b03780a93$var$caf = $cce1e94b03780a93$var$root[$cce1e94b03780a93$var$vendors[$cce1e94b03780a93$var$i] + 'Cancel' + $cce1e94b03780a93$var$suffix] || $cce1e94b03780a93$var$root[$cce1e94b03780a93$var$vendors[$cce1e94b03780a93$var$i] + 'CancelRequest' + $cce1e94b03780a93$var$suffix];
}
// Some versions of FF have rAF but not cAF
if (!$cce1e94b03780a93$var$raf || !$cce1e94b03780a93$var$caf) {
    var $cce1e94b03780a93$var$last = 0, $cce1e94b03780a93$var$id = 0, $cce1e94b03780a93$var$queue = [], $cce1e94b03780a93$var$frameDuration = 1000 / 60;
    $cce1e94b03780a93$var$raf = function raf(callback) {
        if ($cce1e94b03780a93$var$queue.length === 0) {
            var _now = $d93c1fbfc9073e05$exports(), next = Math.max(0, $cce1e94b03780a93$var$frameDuration - (_now - $cce1e94b03780a93$var$last));
            $cce1e94b03780a93$var$last = next + _now;
            setTimeout(function() {
                var cp = $cce1e94b03780a93$var$queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                $cce1e94b03780a93$var$queue.length = 0;
                for(var i = 0; i < cp.length; i++){
                    if (!cp[i].cancelled) try {
                        cp[i].callback($cce1e94b03780a93$var$last);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
            }, Math.round(next));
        }
        $cce1e94b03780a93$var$queue.push({
            handle: ++$cce1e94b03780a93$var$id,
            callback: callback,
            cancelled: false
        });
        return $cce1e94b03780a93$var$id;
    };
    $cce1e94b03780a93$var$caf = function caf(handle) {
        for(var i = 0; i < $cce1e94b03780a93$var$queue.length; i++)if ($cce1e94b03780a93$var$queue[i].handle === handle) $cce1e94b03780a93$var$queue[i].cancelled = true;
    };
}
$cce1e94b03780a93$exports = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return $cce1e94b03780a93$var$raf.call($cce1e94b03780a93$var$root, fn);
};
$cce1e94b03780a93$exports.cancel = function() {
    $cce1e94b03780a93$var$caf.apply($cce1e94b03780a93$var$root, arguments);
};
$cce1e94b03780a93$exports.polyfill = function(object) {
    if (!object) object = $cce1e94b03780a93$var$root;
    object.requestAnimationFrame = $cce1e94b03780a93$var$raf;
    object.cancelAnimationFrame = $cce1e94b03780a93$var$caf;
};


var $c020e53fc27b31fb$export$363c9f3eb56bbdbe = typeof window === "undefined" ? (0, $eHaBZ.useEffect) : (0, $eHaBZ.useLayoutEffect);
// src/hooks/useFreshRef.ts
function $c020e53fc27b31fb$export$38e1734badfda8d9(value) {
    var preferLayoutEffect = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var useEffectToUse = preferLayoutEffect ? $c020e53fc27b31fb$export$363c9f3eb56bbdbe : (0, $eHaBZ.useEffect);
    var ref = (0, $eHaBZ.useRef)(value);
    useEffectToUse(function() {
        ref.current = value;
    });
    return ref;
}
// src/hooks/useFreshCallback.ts
function $c020e53fc27b31fb$export$b3553245f2c17524(callback) {
    var freshRef = $c020e53fc27b31fb$export$38e1734badfda8d9(callback);
    var tick = (0, $eHaBZ.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _freshRef;
        return (_freshRef = freshRef).current.apply(_freshRef, (0, $6zk1M._)(args));
    }, [
        freshRef
    ]);
    return tick;
}
// src/utils/noop.ts
var $c020e53fc27b31fb$var$noop = function() {};
// src/hooks/useTimeoutWhen.ts
function $c020e53fc27b31fb$export$6d974d04a2e6dd6e(callback) {
    var timeoutDelayMs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, when = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, key = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    var freshCallback = $c020e53fc27b31fb$export$b3553245f2c17524(callback);
    (0, $eHaBZ.useEffect)(function() {
        if (when) {
            var internalCallback2 = function internalCallback2() {
                freshCallback();
            };
            var internalCallback = internalCallback2;
            if (typeof window !== "undefined") {
                var timeout = window.setTimeout(internalCallback2, timeoutDelayMs);
                return function() {
                    window.clearTimeout(timeout);
                };
            } else console.warn("useTimeoutWhen: window is undefined.");
        }
        return $c020e53fc27b31fb$var$noop;
    }, [
        timeoutDelayMs,
        when,
        key,
        freshCallback
    ]);
}
// src/hooks/useOnLongHover.ts
var $c020e53fc27b31fb$export$fb63347121d3339d = function(callback) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_duration = _ref.duration, duration = _ref_duration === void 0 ? 300 : _ref_duration;
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), targetNode = _useState[0], setTargetNode = _useState[1];
    var ref = (0, $eHaBZ.useCallback)(function(node) {
        setTargetNode(node);
    }, []);
    var _useState1 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isHovering = _useState1[0], setIsHovering = _useState1[1];
    var freshCallback = $c020e53fc27b31fb$export$b3553245f2c17524(callback);
    $c020e53fc27b31fb$export$6d974d04a2e6dd6e(function() {
        freshCallback();
    }, duration, isHovering);
    var start = (0, $eHaBZ.useCallback)(function() {
        setIsHovering(true);
    }, []);
    var handleOnMouseLeave = (0, $eHaBZ.useCallback)(function(_) {
        setIsHovering(false);
    }, []);
    (0, $eHaBZ.useEffect)(function() {
        if (targetNode) {
            targetNode.addEventListener("mouseenter", start);
            targetNode.addEventListener("mouseleave", handleOnMouseLeave);
        }
        return function() {
            if (targetNode) {
                targetNode.removeEventListener("mouseenter", start);
                targetNode.removeEventListener("mouseleave", handleOnMouseLeave);
            }
        };
    }, [
        start,
        handleOnMouseLeave,
        targetNode
    ]);
    return ref;
};
var $c020e53fc27b31fb$var$defaultOnClick = function() {};
var $c020e53fc27b31fb$export$2efba5bd220821d1 = function(callback) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, onClick = _ref.onClick, _ref_duration = _ref.duration, duration = _ref_duration === void 0 ? 300 : _ref_duration;
    var _useState2 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), targetNode = _useState2[0], setTargetNode = _useState2[1];
    var ref = (0, $eHaBZ.useCallback)(function(node) {
        setTargetNode(node);
    }, []);
    var _useState21 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isPressing = _useState21[0], setIsPressing = _useState21[1];
    var freshCallback = $c020e53fc27b31fb$export$b3553245f2c17524(callback);
    var freshClick = $c020e53fc27b31fb$export$b3553245f2c17524(onClick !== null && onClick !== void 0 ? onClick : $c020e53fc27b31fb$var$defaultOnClick);
    $c020e53fc27b31fb$export$6d974d04a2e6dd6e(freshCallback, duration, isPressing);
    var start = (0, $eHaBZ.useCallback)(function(_) {
        setIsPressing(true);
    }, []);
    var handleOnClick = (0, $eHaBZ.useCallback)(function(event) {
        setIsPressing(false);
        freshClick(event);
    }, [
        freshClick
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (targetNode) {
            targetNode.addEventListener("mousedown", start);
            targetNode.addEventListener("mouseup", handleOnClick);
            targetNode.addEventListener("mouseleave", handleOnClick);
            targetNode.addEventListener("touchstart", start);
            targetNode.addEventListener("touchend", handleOnClick);
            targetNode.addEventListener("touchcancel", handleOnClick);
        }
        return function() {
            if (targetNode) {
                targetNode.removeEventListener("mousedown", start);
                targetNode.removeEventListener("mouseup", handleOnClick);
                targetNode.removeEventListener("mouseleave", handleOnClick);
                targetNode.removeEventListener("touchstart", start);
                targetNode.removeEventListener("touchend", handleOnClick);
                targetNode.removeEventListener("touchcancel", handleOnClick);
            }
        };
    }, [
        start,
        handleOnClick,
        targetNode
    ]);
    return ref;
};
function $c020e53fc27b31fb$export$a1e544cd5fbfa31(initialValue) {
    var _useState3 = (0, $21h22._)((0, $eHaBZ.useState)(initialValue), 2), map = _useState3[0], setMap = _useState3[1];
    var set = (0, $eHaBZ.useCallback)(function(key, value) {
        setMap(function(currentMap) {
            return (0, $9Jpjh._)((0, $lvTkn._)({}, currentMap), (0, $khBmn._)({}, key, value));
        });
    }, []);
    var has = (0, $eHaBZ.useCallback)(function(key) {
        return typeof map[key] !== "undefined";
    }, [
        map
    ]);
    var setMultiple = (0, $eHaBZ.useCallback)(function(nextMap) {
        setMap(function(currentMap) {
            return (0, $lvTkn._)({}, currentMap, nextMap);
        });
    }, []);
    var removeMultiple = (0, $eHaBZ.useCallback)(function() {
        for(var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++){
            keys[_key] = arguments[_key];
        }
        setMap(function(currentMap) {
            var nextMap = (0, $lvTkn._)({}, currentMap);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var key = _step.value;
                    delete nextMap[key];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return nextMap;
        });
    }, [
        setMap
    ]);
    var remove = (0, $eHaBZ.useCallback)(function(key) {
        setMap(function(currentMap) {
            var nextMap = (0, $lvTkn._)({}, currentMap);
            delete nextMap[key];
            return nextMap;
        });
    }, [
        setMap
    ]);
    var removeAll = (0, $eHaBZ.useCallback)(function() {
        setMap(function(currentMap) {
            var nextMap = (0, $lvTkn._)({}, currentMap);
            for(var key in nextMap)if (nextMap.hasOwnProperty(key)) delete nextMap[key];
            return nextMap;
        });
    }, [
        setMap
    ]);
    return [
        map,
        {
            has: has,
            remove: remove,
            removeAll: removeAll,
            removeMultiple: removeMultiple,
            set: set,
            setMultiple: setMultiple
        }
    ];
}
function $c020e53fc27b31fb$export$959143d64510bf04(initial) {
    var _useState4 = (0, $21h22._)((0, $eHaBZ.useState)(initial !== null && initial !== void 0 ? initial : []), 2), array = _useState4[0], setArray = _useState4[1];
    var push = (0, $eHaBZ.useCallback)(function(value) {
        setArray((0, $6zk1M._)(array).concat([
            value
        ]));
    }, [
        array
    ]);
    var pop = (0, $eHaBZ.useCallback)(function() {
        setArray(array.slice(0, array.length - 1));
    }, [
        array
    ]);
    var clear = (0, $eHaBZ.useCallback)(function() {
        setArray([]);
    }, []);
    var unshift = (0, $eHaBZ.useCallback)(function(value) {
        setArray([
            value
        ].concat((0, $6zk1M._)(array)));
    }, [
        array
    ]);
    var shift = (0, $eHaBZ.useCallback)(function() {
        setArray(array.slice(1));
    }, [
        array
    ]);
    var reverse = (0, $eHaBZ.useCallback)(function() {
        setArray((0, $6zk1M._)(array).reverse());
    }, [
        array
    ]);
    var concat = (0, $eHaBZ.useCallback)(function(value) {
        setArray((0, $6zk1M._)(array).concat((0, $6zk1M._)(value)));
    }, [
        array
    ]);
    var fill = (0, $eHaBZ.useCallback)(function(value, start, end) {
        setArray((0, $6zk1M._)(array).fill(value, start, end));
    }, [
        array
    ]);
    var updateItemAtIndex = (0, $eHaBZ.useCallback)(function(index, value) {
        setArray(function(prevArray) {
            var newArray = (0, $6zk1M._)(prevArray);
            newArray[index] = value;
            return newArray;
        });
    }, [
        setArray
    ]);
    var splice = (0, $eHaBZ.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        setArray(function(prevArray) {
            var _newArray;
            var newArray = (0, $6zk1M._)(prevArray);
            (_newArray = newArray).splice.apply(_newArray, (0, $6zk1M._)(args));
            return newArray;
        });
    }, [
        setArray
    ]);
    var removeItemAtIndex = (0, $eHaBZ.useCallback)(function(index) {
        setArray(function(prevArray) {
            var newArray = (0, $6zk1M._)(prevArray);
            newArray.splice(index, 1);
            return newArray;
        });
    }, [
        setArray
    ]);
    var replaceItemAtIndex = (0, $eHaBZ.useCallback)(function(index, value) {
        setArray(function(prevArray) {
            var newArray = (0, $6zk1M._)(prevArray);
            newArray.splice(index, 1, value);
            return newArray;
        });
    }, [
        setArray
    ]);
    var insertItemAtIndex = (0, $eHaBZ.useCallback)(function(index, value) {
        setArray(function(prevArray) {
            var newArray = (0, $6zk1M._)(prevArray);
            newArray.splice(index, 0, value);
            return newArray;
        });
    }, [
        setArray
    ]);
    var sort = (0, $eHaBZ.useCallback)(function(compareFn) {
        setArray((0, $6zk1M._)(array).sort(compareFn));
    }, [
        array
    ]);
    var controls = (0, $eHaBZ.useMemo)(function() {
        return {
            push: push,
            pop: pop,
            clear: clear,
            unshift: unshift,
            shift: shift,
            reverse: reverse,
            concat: concat,
            fill: fill,
            updateItemAtIndex: updateItemAtIndex,
            setArray: setArray,
            splice: splice,
            removeItemAtIndex: removeItemAtIndex,
            replaceItemAtIndex: replaceItemAtIndex,
            insertItemAtIndex: insertItemAtIndex,
            sort: sort
        };
    }, [
        push,
        pop,
        clear,
        unshift,
        shift,
        reverse,
        concat,
        fill,
        updateItemAtIndex,
        setArray,
        splice,
        removeItemAtIndex,
        replaceItemAtIndex,
        insertItemAtIndex,
        sort
    ]);
    var returnValue = (0, $eHaBZ.useMemo)(function() {
        return [
            array,
            controls
        ];
    }, [
        array,
        controls
    ]);
    return returnValue;
}
var $c020e53fc27b31fb$export$7aa0022395cd4c49 = function() {
    var isMountedRef = (0, $eHaBZ.useRef)(false);
    var get = (0, $eHaBZ.useCallback)(function() {
        return isMountedRef.current;
    }, []);
    (0, $eHaBZ.useEffect)(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    return get;
};
// src/hooks/useAsyncEffect.ts
function $c020e53fc27b31fb$export$6875e16a8bdc9a91(effect, deps, cleanup) {
    var lastCallId = (0, $eHaBZ.useRef)(0);
    var getIsMounted = $c020e53fc27b31fb$export$7aa0022395cd4c49();
    var effectRef = $c020e53fc27b31fb$export$38e1734badfda8d9(effect);
    var callback = (0, $eHaBZ.useCallback)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var callId, shouldContinueEffect, error;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        callId = ++lastCallId.current;
                        shouldContinueEffect = function() {
                            return getIsMounted() && callId === lastCallId.current;
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            effectRef.current(shouldContinueEffect)
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 3:
                        error = _state.sent();
                        throw error;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        getIsMounted
    ].concat((0, $6zk1M._)(deps)));
    (0, $eHaBZ.useEffect)(function() {
        var result;
        callback().then(function(value) {
            result = value;
        });
        return function() {
            cleanup === null || cleanup === void 0 ? void 0 : cleanup(result);
        };
    }, [
        callback,
        cleanup
    ]);
}
var $c020e53fc27b31fb$var$noop2 = function() {};
function $c020e53fc27b31fb$export$91047320af7bf70b() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, callbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _options_autoPlay = options.autoPlay, autoPlay = _options_autoPlay === void 0 ? false : _options_autoPlay, tmp = options.isMuted, initialIsMuted = tmp === void 0 ? false : tmp, tmp1 = options.volume, initialVolume = tmp1 === void 0 ? 1 : tmp1, tmp2 = options.playbackRate, initialPlaybackRate = tmp2 === void 0 ? 1 : tmp2, tmp3 = options.loop, initialLoop = tmp3 === void 0 ? false : tmp3, _options_preload = options.preload, preload = _options_preload === void 0 ? "metadata" : _options_preload;
    var _useState5 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), audioNode = _useState5[0], setAudioNode = _useState5[1];
    var _useState51 = (0, $21h22._)((0, $eHaBZ.useState)({
        isPlaying: false,
        isMuted: initialIsMuted,
        volume: initialVolume,
        currentTime: 0,
        duration: 0,
        playbackRate: initialPlaybackRate,
        isLoading: false,
        isBuffering: false,
        loop: initialLoop,
        hasError: false
    }), 2), state = _useState51[0], setState = _useState51[1];
    var _callbacks_onPlay;
    var onPlay = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onPlay = callbacks.onPlay) !== null && _callbacks_onPlay !== void 0 ? _callbacks_onPlay : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onPause;
    var onPause = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onPause = callbacks.onPause) !== null && _callbacks_onPause !== void 0 ? _callbacks_onPause : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onEnded;
    var onEnded = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onEnded = callbacks.onEnded) !== null && _callbacks_onEnded !== void 0 ? _callbacks_onEnded : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onMute;
    var onMute = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onMute = callbacks.onMute) !== null && _callbacks_onMute !== void 0 ? _callbacks_onMute : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onUnmute;
    var onUnmute = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onUnmute = callbacks.onUnmute) !== null && _callbacks_onUnmute !== void 0 ? _callbacks_onUnmute : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onLoadedMetadata;
    var onLoadedMetadata = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onLoadedMetadata = callbacks.onLoadedMetadata) !== null && _callbacks_onLoadedMetadata !== void 0 ? _callbacks_onLoadedMetadata : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onTimeUpdate;
    var onTimeUpdate = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onTimeUpdate = callbacks.onTimeUpdate) !== null && _callbacks_onTimeUpdate !== void 0 ? _callbacks_onTimeUpdate : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onDurationChange;
    var onDurationChange = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onDurationChange = callbacks.onDurationChange) !== null && _callbacks_onDurationChange !== void 0 ? _callbacks_onDurationChange : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onVolumeChange;
    var onVolumeChange = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onVolumeChange = callbacks.onVolumeChange) !== null && _callbacks_onVolumeChange !== void 0 ? _callbacks_onVolumeChange : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onRateChange;
    var onRateChange = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onRateChange = callbacks.onRateChange) !== null && _callbacks_onRateChange !== void 0 ? _callbacks_onRateChange : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onError;
    var onError = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onError = callbacks.onError) !== null && _callbacks_onError !== void 0 ? _callbacks_onError : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onLoadStart;
    var onLoadStart = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onLoadStart = callbacks.onLoadStart) !== null && _callbacks_onLoadStart !== void 0 ? _callbacks_onLoadStart : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onCanPlay;
    var onCanPlay = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onCanPlay = callbacks.onCanPlay) !== null && _callbacks_onCanPlay !== void 0 ? _callbacks_onCanPlay : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onWaiting;
    var onWaiting = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onWaiting = callbacks.onWaiting) !== null && _callbacks_onWaiting !== void 0 ? _callbacks_onWaiting : $c020e53fc27b31fb$var$noop2);
    var audioCallbackRef = function(node) {
        if (node !== null) setAudioNode(node);
    };
    (0, $eHaBZ.useEffect)(function() {
        if (!audioNode) return;
        audioNode.muted = state.isMuted;
        audioNode.volume = state.volume;
        audioNode.playbackRate = state.playbackRate;
        audioNode.loop = state.loop;
        audioNode.preload = preload;
        if (autoPlay) audioNode.autoplay = true;
    }, [
        audioNode,
        autoPlay,
        preload
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (!audioNode) return;
        var handleLoadStart = function() {
            setState(function(prev) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    isLoading: true,
                    hasError: false
                });
            });
            onLoadStart();
        };
        var handleLoadedMetadata = function() {
            setState(function(prev) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    duration: audioNode.duration,
                    isLoading: false,
                    hasError: false
                });
            });
            onLoadedMetadata();
            onDurationChange(audioNode.duration);
        };
        var handleCanPlay = function() {
            setState(function(prev) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    isBuffering: false,
                    hasError: false
                });
            });
            onCanPlay();
        };
        var handleWaiting = function() {
            setState(function(prev) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    isBuffering: true
                });
            });
            onWaiting();
        };
        var handlePlay = function() {
            setState(function(prev) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    isPlaying: true,
                    hasError: false
                });
            });
            onPlay();
        };
        var handlePause = function() {
            setState(function(prev) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    isPlaying: false
                });
            });
            onPause();
        };
        var handleEnded = function() {
            setState(function(prev) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    isPlaying: false
                });
            });
            onEnded();
        };
        var handleTimeUpdate = function() {
            var currentTime = audioNode.currentTime;
            setState(function(prev) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    currentTime: currentTime
                });
            });
            onTimeUpdate(currentTime);
        };
        var handleDurationChange = function() {
            var duration = audioNode.duration;
            setState(function(prev) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    duration: duration
                });
            });
            onDurationChange(duration);
        };
        var handleVolumeChange = function() {
            var volume = audioNode.volume;
            var isMuted = audioNode.muted;
            setState(function(prev) {
                var newState = (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    volume: volume,
                    isMuted: isMuted
                });
                if (isMuted !== prev.isMuted) {
                    if (isMuted) onMute();
                    else onUnmute();
                }
                return newState;
            });
            onVolumeChange(volume);
        };
        var handleRateChange = function() {
            var playbackRate = audioNode.playbackRate;
            setState(function(prev) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    playbackRate: playbackRate
                });
            });
            onRateChange(playbackRate);
        };
        var handleError = function() {
            var error = audioNode.error;
            var errorMessage = error ? "Audio error (".concat(error.code, "): ").concat(error.message) : "Unknown audio error occurred";
            setState(function(prev) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    hasError: true,
                    error: errorMessage,
                    isLoading: false,
                    isBuffering: false,
                    isPlaying: false
                });
            });
            onError(errorMessage);
        };
        audioNode.addEventListener("loadstart", handleLoadStart);
        audioNode.addEventListener("loadedmetadata", handleLoadedMetadata);
        audioNode.addEventListener("canplay", handleCanPlay);
        audioNode.addEventListener("waiting", handleWaiting);
        audioNode.addEventListener("play", handlePlay);
        audioNode.addEventListener("pause", handlePause);
        audioNode.addEventListener("ended", handleEnded);
        audioNode.addEventListener("timeupdate", handleTimeUpdate);
        audioNode.addEventListener("durationchange", handleDurationChange);
        audioNode.addEventListener("volumechange", handleVolumeChange);
        audioNode.addEventListener("ratechange", handleRateChange);
        audioNode.addEventListener("error", handleError);
        return function() {
            audioNode.removeEventListener("loadstart", handleLoadStart);
            audioNode.removeEventListener("loadedmetadata", handleLoadedMetadata);
            audioNode.removeEventListener("canplay", handleCanPlay);
            audioNode.removeEventListener("waiting", handleWaiting);
            audioNode.removeEventListener("play", handlePlay);
            audioNode.removeEventListener("pause", handlePause);
            audioNode.removeEventListener("ended", handleEnded);
            audioNode.removeEventListener("timeupdate", handleTimeUpdate);
            audioNode.removeEventListener("durationchange", handleDurationChange);
            audioNode.removeEventListener("volumechange", handleVolumeChange);
            audioNode.removeEventListener("ratechange", handleRateChange);
            audioNode.removeEventListener("error", handleError);
        };
    }, [
        audioNode,
        onLoadStart,
        onLoadedMetadata,
        onCanPlay,
        onWaiting,
        onPlay,
        onPause,
        onEnded,
        onTimeUpdate,
        onDurationChange,
        onVolumeChange,
        onRateChange,
        onError,
        onMute,
        onUnmute
    ]);
    var play = function() {
        if (!audioNode) return;
        audioNode.play().catch(function(error) {
            var errorMessage = error instanceof Error ? error.message : "Failed to play audio";
            setState(function(prev) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    hasError: true,
                    error: errorMessage,
                    isPlaying: false
                });
            });
            onError(errorMessage);
        });
    };
    var pause = function() {
        if (!audioNode) return;
        audioNode.pause();
    };
    var togglePlay = function() {
        if (state.isPlaying) pause();
        else play();
    };
    var mute = function() {
        if (!audioNode) return;
        audioNode.muted = true;
    };
    var unmute = function() {
        if (!audioNode) return;
        audioNode.muted = false;
    };
    var toggleMute = function() {
        if (state.isMuted) unmute();
        else mute();
    };
    var setVolume = function(volume) {
        if (!audioNode) return;
        var clampedVolume = Math.max(0, Math.min(1, volume));
        audioNode.volume = clampedVolume;
    };
    var setCurrentTime = function(time) {
        if (!audioNode) return;
        var clampedTime = Math.max(0, Math.min(state.duration || 0, time));
        audioNode.currentTime = clampedTime;
    };
    var setPlaybackRate = function(rate) {
        if (!audioNode) return;
        var clampedRate = Math.max(0.25, Math.min(4, rate));
        audioNode.playbackRate = clampedRate;
    };
    var seek = function(seconds) {
        setCurrentTime(state.currentTime + seconds);
    };
    var fastForward = function() {
        var seconds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10;
        seek(seconds);
    };
    var rewind = function() {
        var seconds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10;
        seek(-seconds);
    };
    var setLoop = function(loop) {
        if (!audioNode) return;
        audioNode.loop = loop;
        setState(function(prev) {
            return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                loop: loop
            });
        });
    };
    var controls = {
        play: play,
        pause: pause,
        togglePlay: togglePlay,
        mute: mute,
        unmute: unmute,
        toggleMute: toggleMute,
        setVolume: setVolume,
        setCurrentTime: setCurrentTime,
        setPlaybackRate: setPlaybackRate,
        seek: seek,
        fastForward: fastForward,
        rewind: rewind,
        setLoop: setLoop
    };
    return [
        audioCallbackRef,
        state,
        controls
    ];
}
function $c020e53fc27b31fb$export$4984640464733c64(callback) {
    (0, $eHaBZ.useEffect)(function() {
        if (typeof callback === "function") callback();
    }, []);
}
var $c020e53fc27b31fb$var$config = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
function $c020e53fc27b31fb$export$8ecdcf3bb089e9cd(ref, callback) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $c020e53fc27b31fb$var$config;
    (0, $eHaBZ.useEffect)(function() {
        if (ref.current) {
            var observer = new MutationObserver(callback);
            observer.observe(ref.current, options);
            return function() {
                observer.disconnect();
            };
        }
        return $c020e53fc27b31fb$var$noop;
    }, [
        callback,
        options,
        ref
    ]);
}
// src/hooks/useBoundingclientrect.ts
function $c020e53fc27b31fb$var$getBoundingClientRect(element) {
    return element.getBoundingClientRect();
}
function $c020e53fc27b31fb$export$b95e3d4f036ffdbe(ref) {
    var _useState6 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), domRect = _useState6[0], setDomRect = _useState6[1];
    var update = (0, $eHaBZ.useCallback)(function() {
        setDomRect(ref.current ? $c020e53fc27b31fb$var$getBoundingClientRect(ref.current) : null);
    }, [
        ref
    ]);
    $c020e53fc27b31fb$export$4984640464733c64(function() {
        update();
    });
    $c020e53fc27b31fb$export$8ecdcf3bb089e9cd(ref, update);
    return domRect;
}
function $c020e53fc27b31fb$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $c020e53fc27b31fb$export$ebc1e1560c2dffa5(refA, refB) {
    return (0, $eHaBZ.useMemo)(function() {
        if (refA === null && refB === null) return null;
        return function(refValue) {
            $c020e53fc27b31fb$var$setRef(refA, refValue);
            $c020e53fc27b31fb$var$setRef(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}
var $c020e53fc27b31fb$var$config2 = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
function $c020e53fc27b31fb$export$cdfcc5138d0e9570(callback) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c020e53fc27b31fb$var$config2;
    var _useState7 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), node = _useState7[0], setNode = _useState7[1];
    (0, $eHaBZ.useEffect)(function() {
        if (node) {
            var observer = new MutationObserver(callback);
            observer.observe(node, options);
            return function() {
                observer.disconnect();
            };
        }
        return $c020e53fc27b31fb$var$noop;
    }, [
        node,
        callback,
        options
    ]);
    var ref = (0, $eHaBZ.useCallback)(function(nodeElement) {
        setNode(nodeElement);
    }, []);
    return [
        ref
    ];
}
// src/hooks/useBoundingclientrectRef.ts
function $c020e53fc27b31fb$var$getBoundingClientRect2(element) {
    return element.getBoundingClientRect();
}
function $c020e53fc27b31fb$export$e44360762afe9191() {
    var _useState8 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), domRect = _useState8[0], setDomRect = _useState8[1];
    var _useState81 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), node = _useState81[0], setNode = _useState81[1];
    var update = (0, $eHaBZ.useCallback)(function() {
        setDomRect(node ? $c020e53fc27b31fb$var$getBoundingClientRect2(node) : null);
    }, [
        node
    ]);
    (0, $eHaBZ.useEffect)(function() {
        update();
    }, [
        update
    ]);
    var ref = (0, $eHaBZ.useCallback)(function(nodeElement) {
        setNode(nodeElement);
    }, []);
    var _useMutationObserverRef = (0, $21h22._)($c020e53fc27b31fb$export$cdfcc5138d0e9570(update), 1), mutationObserverRef = _useMutationObserverRef[0];
    var forkedRef = $c020e53fc27b31fb$export$ebc1e1560c2dffa5(ref, mutationObserverRef);
    return [
        forkedRef,
        domRect,
        update
    ];
}
function $c020e53fc27b31fb$export$d41d1c6c7d9f02aa(initialValue) {
    var _useState9 = (0, $21h22._)((0, $eHaBZ.useState)(initialValue), 2), checked = _useState9[0], setInternalChecked = _useState9[1];
    var setChecked = (0, $eHaBZ.useCallback)(function(newChecked) {
        setInternalChecked(newChecked);
    }, []);
    var toggle = (0, $eHaBZ.useCallback)(function() {
        setInternalChecked(function(prev) {
            return !prev;
        });
    }, []);
    var handleChange = (0, $eHaBZ.useCallback)(function(event) {
        setInternalChecked(event.target.checked);
    }, []);
    var inputProps = (0, $eHaBZ.useMemo)(function() {
        return {
            checked: checked,
            onChange: handleChange
        };
    }, [
        checked,
        handleChange
    ]);
    return {
        checked: checked,
        toggle: toggle,
        setChecked: setChecked,
        inputProps: inputProps
    };
}
function $c020e53fc27b31fb$export$88af857a8946da7e(callback) {
    var intervalDurationMs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, when = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, startImmediate = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var savedRefCallback = (0, $eHaBZ.useRef)(void 0);
    (0, $eHaBZ.useEffect)(function() {
        savedRefCallback.current = callback;
    });
    (0, $eHaBZ.useEffect)(function() {
        if (when) {
            var internalCallback2 = function internalCallback2() {
                var _savedRefCallback_current;
                (_savedRefCallback_current = savedRefCallback.current) === null || _savedRefCallback_current === void 0 ? void 0 : _savedRefCallback_current.call(savedRefCallback);
            };
            var internalCallback = internalCallback2;
            if (startImmediate) internalCallback2();
            var interval = window.setInterval(internalCallback2, intervalDurationMs);
            return function() {
                window.clearInterval(interval);
            };
        }
        return $c020e53fc27b31fb$var$noop;
    }, [
        when,
        intervalDurationMs,
        startImmediate
    ]);
}
// src/hooks/useCountdown.ts
function $c020e53fc27b31fb$export$8103f7eb37e19f7b(endTime) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _options_interval = options.interval, interval = _options_interval === void 0 ? 1e3 : _options_interval, onDown = options.onDown, onEnd = options.onEnd;
    var _useState10 = (0, $21h22._)((0, $eHaBZ.useState)(function() {
        return /* @__PURE__ */ new Date();
    }), 2), time = _useState10[0], setTime = _useState10[1];
    var restTime = endTime.getTime() - time.getTime();
    var count = restTime > 0 ? Math.ceil(restTime / interval) : 0;
    $c020e53fc27b31fb$export$88af857a8946da7e(onTick, count ? interval : void 0, true, true);
    return count;
    function onTick() {
        var newTime = /* @__PURE__ */ new Date();
        if (newTime > endTime) {
            if (onEnd) onEnd(newTime);
            setTime(endTime);
            return;
        }
        if (onDown) onDown(restTime, newTime);
        setTime(newTime);
    }
}
function $c020e53fc27b31fb$export$70c4067197c60e2d(initialValue) {
    var _useState11 = (0, $21h22._)((0, $eHaBZ.useState)(initialValue), 2), counter = _useState11[0], setCounter = _useState11[1];
    var incrementBy = (0, $eHaBZ.useCallback)(function(incrAmount) {
        setCounter(function(currentCounter) {
            return currentCounter + incrAmount;
        });
    }, []);
    var decrementBy = (0, $eHaBZ.useCallback)(function(decrAmount) {
        incrementBy(-decrAmount);
    }, [
        incrementBy
    ]);
    var increment = (0, $eHaBZ.useCallback)(function() {
        incrementBy(1);
    }, [
        incrementBy
    ]);
    var decrement = (0, $eHaBZ.useCallback)(function() {
        incrementBy(-1);
    }, [
        incrementBy
    ]);
    var reset = (0, $eHaBZ.useCallback)(function() {
        setCounter(initialValue);
    }, [
        initialValue
    ]);
    return {
        decrement: decrement,
        decrementBy: decrementBy,
        increment: increment,
        incrementBy: incrementBy,
        reset: reset,
        value: counter
    };
}
function $c020e53fc27b31fb$export$328d69a66df243d8(callback) {
    (0, $eHaBZ.useEffect)(function() {
        return callback;
    }, []);
}
// src/hooks/useDebounce.ts
function $c020e53fc27b31fb$export$21805fee57372823(callback, wait, options) {
    var createDebouncedCallback = (0, $eHaBZ.useCallback)(function(function_) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($2ba76da8a3028b95$exports)))(function_, wait, options);
    }, [
        wait,
        options
    ]);
    var freshCallback = $c020e53fc27b31fb$export$38e1734badfda8d9(callback);
    function tick() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _freshCallback_current;
        var _freshCallback_current1;
        (_freshCallback_current1 = freshCallback.current) === null || _freshCallback_current1 === void 0 ? void 0 : (_freshCallback_current = _freshCallback_current1).call.apply(_freshCallback_current, [
            freshCallback
        ].concat((0, $6zk1M._)(args)));
    }
    var debouncedCallbackRef = (0, $eHaBZ.useRef)(createDebouncedCallback(tick));
    $c020e53fc27b31fb$export$328d69a66df243d8(function() {
        var _debouncedCallbackRef_current;
        (_debouncedCallbackRef_current = debouncedCallbackRef.current) === null || _debouncedCallbackRef_current === void 0 ? void 0 : _debouncedCallbackRef_current.cancel();
    });
    return debouncedCallbackRef.current;
}
function $c020e53fc27b31fb$export$ddf8f1aa96b8ea88(func, delay) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        leading: false,
        trailing: true
    };
    var leading = options.leading, trailing = options.trailing, maxWait = options.maxWait;
    if (!leading && !trailing) throw new Error("leading and trailing cannot both be false");
    else if (typeof maxWait !== "undefined" && maxWait < delay) throw new Error("maxWait cannot be less than delay");
    var funcRef = $c020e53fc27b31fb$export$b3553245f2c17524(func);
    var _useState12 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isTimeoutEnabled = _useState12[0], setIsTimeoutEnabled = _useState12[1];
    var _useState121 = (0, $21h22._)((0, $eHaBZ.useState)(0), 2), key = _useState121[0], setKey = _useState121[1];
    var lastExecutionTimeRef = (0, $eHaBZ.useRef)(0);
    var argsRef = (0, $eHaBZ.useRef)(void 0);
    var debouncedFn = (0, $eHaBZ.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        argsRef.current = args;
        var overrideTimeout = typeof maxWait !== "undefined" && lastExecutionTimeRef.current && Date.now() - lastExecutionTimeRef.current > maxWait;
        if (leading) {
            if (isTimeoutEnabled && overrideTimeout) {
                setKey(function(prevKey) {
                    return prevKey + 1;
                });
                lastExecutionTimeRef.current = Date.now();
                try {
                    funcRef.apply(void 0, (0, $6zk1M._)(args));
                } catch (error) {
                    console.warn(error);
                }
            } else if (overrideTimeout && !isTimeoutEnabled) {
                setIsTimeoutEnabled(true);
                lastExecutionTimeRef.current = Date.now();
                try {
                    funcRef.apply(void 0, (0, $6zk1M._)(args));
                } catch (error) {
                    console.warn(error);
                }
            } else if (isTimeoutEnabled && !overrideTimeout) ;
            else {
                setIsTimeoutEnabled(true);
                lastExecutionTimeRef.current = Date.now();
                try {
                    funcRef.apply(void 0, (0, $6zk1M._)(args));
                } catch (error) {
                    console.warn(error);
                }
            }
        }
        if (trailing) {
            if (isTimeoutEnabled) setKey(function(prevKey) {
                return prevKey + 1;
            });
            else setIsTimeoutEnabled(true);
        }
    }, [
        maxWait,
        isTimeoutEnabled,
        leading,
        trailing,
        funcRef
    ]);
    $c020e53fc27b31fb$export$6d974d04a2e6dd6e(function() {
        if (typeof maxWait !== "undefined" && trailing) {
            if (!argsRef.current) return;
            lastExecutionTimeRef.current = Date.now();
            try {
                funcRef.apply(void 0, (0, $6zk1M._)(argsRef.current));
            } catch (error) {
                console.warn(error);
            }
        }
    }, maxWait !== null && maxWait !== void 0 ? maxWait : Infinity, isTimeoutEnabled && typeof maxWait !== "undefined" && trailing, key);
    $c020e53fc27b31fb$export$6d974d04a2e6dd6e(function() {
        if (trailing) {
            if (!argsRef.current) return;
            lastExecutionTimeRef.current = Date.now();
            try {
                funcRef.apply(void 0, (0, $6zk1M._)(argsRef.current));
            } catch (error) {
                console.warn(error);
            }
        }
        setIsTimeoutEnabled(false);
    }, delay, isTimeoutEnabled && trailing, key);
    var freshDebouncedFn = $c020e53fc27b31fb$export$b3553245f2c17524(debouncedFn);
    return [
        freshDebouncedFn,
        isTimeoutEnabled
    ];
}
function $c020e53fc27b31fb$export$e34ed88fef4dc107(callback, conditions) {
    var hasMountedRef = (0, $eHaBZ.useRef)(false);
    var internalConditions = (0, $eHaBZ.useMemo)(function() {
        if (typeof conditions !== "undefined" && !Array.isArray(conditions)) return [
            conditions
        ];
        else if (Array.isArray(conditions) && conditions.length === 0) console.warn("Using [] as the second argument makes useDidUpdate a noop. The second argument should either be `undefined` or an array of length greater than 0.");
        return conditions;
    }, [
        conditions
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (hasMountedRef.current) callback();
    }, internalConditions);
    $c020e53fc27b31fb$export$4984640464733c64(function() {
        hasMountedRef.current = true;
    });
    $c020e53fc27b31fb$export$328d69a66df243d8(function() {
        hasMountedRef.current = false;
    });
}
// src/hooks/useDebouncedValue.ts
var $c020e53fc27b31fb$var$defaultUseDebounceValueOptions = {
    initializeWithNull: false
};
var $c020e53fc27b31fb$export$5ab4fa7caa249e6e = function(value, timeout) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var initializeWithNull = Object.assign({}, $c020e53fc27b31fb$var$defaultUseDebounceValueOptions, options).initializeWithNull;
    var _useState13 = (0, $21h22._)((0, $eHaBZ.useState)(initializeWithNull ? null : value), 2), updatedValue = _useState13[0], setUpdatedValue = _useState13[1];
    var debouncedSetUpdatedValue = $c020e53fc27b31fb$export$21805fee57372823(setUpdatedValue, timeout);
    $c020e53fc27b31fb$export$4984640464733c64(function() {
        if (initializeWithNull) debouncedSetUpdatedValue(value);
    });
    $c020e53fc27b31fb$export$e34ed88fef4dc107(function() {
        debouncedSetUpdatedValue(value);
    }, [
        value
    ]);
    return [
        updatedValue,
        setUpdatedValue
    ];
};
// src/hooks/warning.ts
var $c020e53fc27b31fb$var$isDevelopmentEnvironment = false;
var $c020e53fc27b31fb$var$warning = function() {};
if ($c020e53fc27b31fb$var$isDevelopmentEnvironment) {
    var $c020e53fc27b31fb$var$printWarning = function(actualMessage) {
        var message = "Warning: ".concat(actualMessage);
        if (typeof console !== "undefined") console.error(message);
        try {
            throw new Error(message);
        } catch (e) {}
    };
    $c020e53fc27b31fb$var$warning = function warning(condition, actualMessage) {
        if (!condition) $c020e53fc27b31fb$var$printWarning(actualMessage);
    };
}
// src/hooks/useDeepCompareEffect.ts
function $c020e53fc27b31fb$var$isPrimitive(value) {
    var valueType = typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value);
    return valueType === "string" || valueType === "number" || valueType === "bigint" || valueType === "boolean" || valueType === "undefined" || valueType === "symbol";
}
function $c020e53fc27b31fb$export$db77f469fe79526e(callback, dependencies) {
    var previousDeps = (0, $eHaBZ.useRef)(dependencies);
    if (!Array.isArray(dependencies)) throw new Error("useDeepCompareEffect should be used with an array of dependencies");
    var hasPrimitives = dependencies.every($c020e53fc27b31fb$var$isPrimitive);
    $c020e53fc27b31fb$var$warning(!hasPrimitives, "useDeepCompareEffect should not be used with primitive values as dependencies");
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($20cb340d6b373ba4$exports)))(previousDeps.current, dependencies)) previousDeps.current = dependencies;
    (0, $eHaBZ.useEffect)(callback, previousDeps.current);
}
// src/hooks/useFreshTick.ts
function $c020e53fc27b31fb$export$699327ecb1dd6b0d(callback) {
    var freshRef = $c020e53fc27b31fb$export$38e1734badfda8d9(callback);
    function tick() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _freshRef;
        if (typeof freshRef.current === "function") (_freshRef = freshRef).current.apply(_freshRef, (0, $6zk1M._)(args));
    }
    return tick;
}
// src/hooks/useGlobalObjectEventListener.ts
function $c020e53fc27b31fb$var$useGlobalObjectEventListener(globalObject, eventName, callback) {
    var listenerOptions = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, when = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true, isLayoutEffect = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    var freshCallback = $c020e53fc27b31fb$export$699327ecb1dd6b0d(callback);
    var useEffectToRun = isLayoutEffect ? $c020e53fc27b31fb$export$363c9f3eb56bbdbe : (0, $eHaBZ.useEffect);
    useEffectToRun(function() {
        $c020e53fc27b31fb$var$warning(typeof globalObject !== "undefined", "[useGlobalObjectEventListener]: Cannot attach event handlers to undefined.");
        if (typeof globalObject !== "undefined" && when) {
            globalObject.addEventListener(eventName, freshCallback, listenerOptions);
            return function() {
                globalObject.removeEventListener(eventName, freshCallback, listenerOptions);
            };
        }
        return function() {};
    }, [
        eventName,
        listenerOptions
    ]);
}
// src/hooks/useOnWindowResize.ts
function $c020e53fc27b31fb$export$61171a90a6148cf5(callback) {
    var when = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, isLayoutEffect = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    $c020e53fc27b31fb$var$useGlobalObjectEventListener($parcel$global.window, "resize", callback, {
        passive: true
    }, when, isLayoutEffect);
}
// src/hooks/useOnWindowScroll.ts
function $c020e53fc27b31fb$export$f2fb712044277d5e(callback) {
    var when = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, isLayoutEffect = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    $c020e53fc27b31fb$var$useGlobalObjectEventListener($parcel$global.window, "scroll", callback, {
        passive: true
    }, when, isLayoutEffect);
}
// src/hooks/useDimensionsRef.ts
var $c020e53fc27b31fb$var$getDimensionObject = function(node) {
    var rect = node.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width,
        x: rect.left,
        y: rect.top
    };
};
var $c020e53fc27b31fb$var$noWindowReturnValue = [
    void 0,
    null,
    null
];
var $c020e53fc27b31fb$export$b5cb37376a215039 = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_updateOnScroll = _ref.updateOnScroll, updateOnScroll = _ref_updateOnScroll === void 0 ? true : _ref_updateOnScroll, _ref_updateOnResize = _ref.updateOnResize, updateOnResize = _ref_updateOnResize === void 0 ? true : _ref_updateOnResize;
    var _useState14 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), dimensions = _useState14[0], setDimensions = _useState14[1];
    var _useState141 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), node = _useState141[0], setNode = _useState141[1];
    var ref = (0, $eHaBZ.useCallback)(function(nodeFromCallback) {
        setNode(nodeFromCallback);
    }, []);
    var measure = (0, $eHaBZ.useCallback)(function() {
        window.requestAnimationFrame(function() {
            if (node) setDimensions($c020e53fc27b31fb$var$getDimensionObject(node));
        });
    }, [
        node
    ]);
    (0, $eHaBZ.useLayoutEffect)(function() {
        measure();
    }, [
        measure
    ]);
    $c020e53fc27b31fb$export$61171a90a6148cf5(function() {
        measure();
    }, updateOnResize, true);
    $c020e53fc27b31fb$export$f2fb712044277d5e(function() {
        measure();
    }, updateOnScroll, true);
    if (typeof window === "undefined") {
        console.warn("useDimensionsRef: window is undefined.");
        return $c020e53fc27b31fb$var$noWindowReturnValue;
    }
    return [
        ref,
        dimensions,
        node
    ];
};
// src/hooks/useDocumentEventListener.ts
function $c020e53fc27b31fb$export$3d17299e951a5198(eventName, callback) {
    var listenerOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, isLayoutEffect = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    $c020e53fc27b31fb$var$useGlobalObjectEventListener($parcel$global.document, eventName, callback, listenerOptions, true, isLayoutEffect);
}
function $c020e53fc27b31fb$export$4b208edda918084f(title) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var isBrowser = typeof window !== "undefined";
    var prevTitleRef = (0, $eHaBZ.useRef)(isBrowser ? document.title : "");
    var _options_resetOnUnmount = options.resetOnUnmount, resetOnUnmount = _options_resetOnUnmount === void 0 ? false : _options_resetOnUnmount;
    (0, $eHaBZ.useEffect)(function() {
        if (isBrowser) {
            document.title = title;
            var lastTitle = prevTitleRef.current;
            if (resetOnUnmount) return function() {
                document.title = lastTitle;
            };
        }
        return $c020e53fc27b31fb$var$noop;
    }, [
        title,
        isBrowser,
        resetOnUnmount
    ]);
}
function $c020e53fc27b31fb$var$getVisibilityStateSnapshot() {
    if (typeof document !== "undefined") return document.visibilityState;
    else return null;
}
function $c020e53fc27b31fb$var$getVisibilityStateSubscription(callback) {
    if (typeof document !== "undefined") {
        document.addEventListener("visibilitychange", callback);
        return function() {
            document.removeEventListener("visibilitychange", callback);
        };
    }
    return function() {};
}
function $c020e53fc27b31fb$var$getVisibilityStateServerSnapshot() {
    return null;
}
function $c020e53fc27b31fb$export$84b371b406ccb709() {
    return (0, $eHaBZ.useSyncExternalStore)($c020e53fc27b31fb$var$getVisibilityStateSubscription, $c020e53fc27b31fb$var$getVisibilityStateSnapshot, $c020e53fc27b31fb$var$getVisibilityStateServerSnapshot);
}
function $c020e53fc27b31fb$export$7a4c3f7300df51d9(callback) {
    var when = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var hasRunOnceRef = (0, $eHaBZ.useRef)(false);
    var callbackRef = (0, $eHaBZ.useRef)(callback);
    (0, $eHaBZ.useEffect)(function() {
        callbackRef.current = callback;
    });
    (0, $eHaBZ.useEffect)(function() {
        if (when && !hasRunOnceRef.current) {
            callbackRef.current();
            hasRunOnceRef.current = true;
        }
    }, [
        when
    ]);
}
function $c020e53fc27b31fb$export$231305e360fbdfeb() {
    var _useState15 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), refElement = _useState15[0], setRefElement = _useState15[1];
    var ref = (0, $eHaBZ.useCallback)(function(element) {
        setRefElement(element);
    }, []);
    return [
        ref,
        refElement
    ];
}
// src/hooks/useEventListenerRef.ts
function $c020e53fc27b31fb$export$f2a41a0f37ebea17(eventName, callback) {
    var listenerOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, isLayoutEffect = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var _useRefElement = (0, $21h22._)($c020e53fc27b31fb$export$231305e360fbdfeb(), 2), ref = _useRefElement[0], element = _useRefElement[1];
    var freshCallback = $c020e53fc27b31fb$export$699327ecb1dd6b0d(callback);
    var useEffectToRun = isLayoutEffect ? $c020e53fc27b31fb$export$363c9f3eb56bbdbe : (0, $eHaBZ.useEffect);
    useEffectToRun(function() {
        if (!(element === null || element === void 0 ? void 0 : element.addEventListener)) return $c020e53fc27b31fb$var$noop;
        element.addEventListener(eventName, freshCallback, listenerOptions);
        return function() {
            element.removeEventListener(eventName, freshCallback, listenerOptions);
        };
    }, [
        element,
        eventName,
        listenerOptions
    ]);
    return ref;
}
function $c020e53fc27b31fb$export$7066775237fab396() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, callbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var accept = options.accept, maxFileSize = options.maxFileSize, maxFiles = options.maxFiles;
    var _callbacks_onDrop = callbacks.onDrop, onDrop = _callbacks_onDrop === void 0 ? $c020e53fc27b31fb$var$noop : _callbacks_onDrop, _callbacks_onFileAccepted = callbacks.onFileAccepted, onFileAccepted = _callbacks_onFileAccepted === void 0 ? $c020e53fc27b31fb$var$noop : _callbacks_onFileAccepted, _callbacks_onFileRejected = callbacks.onFileRejected, onFileRejected = _callbacks_onFileRejected === void 0 ? $c020e53fc27b31fb$var$noop : _callbacks_onFileRejected, _callbacks_onDragEnter = callbacks.onDragEnter, onDragEnter = _callbacks_onDragEnter === void 0 ? $c020e53fc27b31fb$var$noop : _callbacks_onDragEnter, _callbacks_onDragLeave = callbacks.onDragLeave, onDragLeave = _callbacks_onDragLeave === void 0 ? $c020e53fc27b31fb$var$noop : _callbacks_onDragLeave;
    var _useState16 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), targetNode = _useState16[0], setTargetNode = _useState16[1];
    var freshOnDrop = $c020e53fc27b31fb$export$b3553245f2c17524(onDrop);
    var freshOnFileAccepted = $c020e53fc27b31fb$export$b3553245f2c17524(onFileAccepted);
    var freshOnFileRejected = $c020e53fc27b31fb$export$b3553245f2c17524(onFileRejected);
    var freshOnDragEnter = $c020e53fc27b31fb$export$b3553245f2c17524(onDragEnter);
    var freshOnDragLeave = $c020e53fc27b31fb$export$b3553245f2c17524(onDragLeave);
    (0, $eHaBZ.useCallback)(function(node) {
        setTargetNode(node);
    }, []);
    var fileIsValid = (0, $eHaBZ.useCallback)(function(file) {
        if (accept && !accept.includes(file.type)) return {
            valid: false,
            reason: "File type not allowed"
        };
        if (maxFileSize && file.size > maxFileSize) return {
            valid: false,
            reason: "File size exceeds the limit"
        };
        return {
            valid: true
        };
    }, [
        accept,
        maxFileSize
    ]);
    var handleDrop = (0, $eHaBZ.useCallback)(function(event) {
        var _event_dataTransfer;
        event.preventDefault();
        var files = Array.from(((_event_dataTransfer = event.dataTransfer) === null || _event_dataTransfer === void 0 ? void 0 : _event_dataTransfer.files) || []);
        var acceptedFiles = [];
        var rejectedFiles = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (maxFiles && files.length > maxFiles) try {
            for(var _iterator = files[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var file = _step.value;
                freshOnFileRejected(file, "Exceeded maximum number of files");
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        else files.forEach(function(file) {
            var validationResult = fileIsValid(file);
            if (validationResult.valid) {
                acceptedFiles.push(file);
                freshOnFileAccepted(file);
            } else {
                rejectedFiles.push(file);
                freshOnFileRejected(file, validationResult.reason || "Unknown reason");
            }
        });
        freshOnDrop(acceptedFiles, rejectedFiles);
    }, [
        fileIsValid,
        freshOnFileAccepted,
        freshOnFileRejected,
        maxFiles,
        freshOnDrop
    ]);
    var handleDragOver = (0, $eHaBZ.useCallback)(function(event) {
        event.preventDefault();
    }, []);
    (0, $eHaBZ.useEffect)(function() {
        if (targetNode) {
            targetNode.addEventListener("drop", handleDrop);
            targetNode.addEventListener("dragover", handleDragOver);
            targetNode.addEventListener("dragenter", freshOnDragEnter);
            targetNode.addEventListener("dragleave", freshOnDragLeave);
            return function() {
                targetNode.removeEventListener("drop", handleDrop);
                targetNode.removeEventListener("dragover", handleDragOver);
                targetNode.removeEventListener("dragenter", freshOnDragEnter);
                targetNode.removeEventListener("dragleave", freshOnDragLeave);
            };
        } else return function() {};
    }, [
        targetNode,
        handleDrop,
        handleDragOver,
        freshOnDragEnter,
        freshOnDragLeave
    ]);
    return (0, $eHaBZ.useCallback)(function(node) {
        setTargetNode(node);
    }, []);
}
var $c020e53fc27b31fb$var$FullscreenApi = {
    DOM_UNAVAILABLE_ERROR: "DOM is unavailable server-side. Please use this method client-side only.",
    FULLSCREEN_UNSUPPORTED_ERROR: "Your browser does not support Fullscreen API.",
    getEventsNames: function() {
        if (typeof document === "undefined") return null;
        var _document = document;
        if ("exitFullscreen" in _document) return [
            "fullscreenchange",
            "fullscreenerror"
        ];
        if ("webkitExitFullscreen" in _document) return [
            "webkitfullscreenchange",
            "webkitfullscreenerror"
        ];
        if ("webkitCancelFullScreen" in _document) return [
            "webkitfullscreenchange",
            "webkitfullscreenerror"
        ];
        if ("mozCancelFullScreen" in _document) return [
            "mozfullscreenchange",
            "mozfullscreenerror"
        ];
        if ("msExitFullscreen" in _document) return [
            "MSFullscreenChange",
            "MSFullscreenError"
        ];
        return null;
    },
    getEventName: function(eventType) {
        var eventsNames = this.getEventsNames();
        if (!eventsNames) return null;
        if (eventType === "change") return eventsNames[0];
        return eventsNames[1];
    },
    get fullscreenEnabled () {
        if (typeof document === "undefined") return false;
        var _document = document;
        return _document.fullscreenEnabled || _document.webkitFullscreenEnabled || !!_document.webkitCancelFullScreen || _document.mozFullScreenEnabled || _document.msFullscreenEnabled || false;
    },
    get fullscreenElement () {
        if (typeof document === "undefined") return null;
        var _document1 = document;
        return _document1.fullscreenElement || _document1.webkitFullscreenElement || _document1.webkitCurrentFullScreenElement || _document1.mozFullScreenElement || _document1.msFullscreenElement || null;
    },
    requestFullscreen: function(element, options) {
        if (typeof document === "undefined") throw new Error(this.DOM_UNAVAILABLE_ERROR);
        var target = element !== null && element !== void 0 ? element : document.documentElement;
        var method = target.requestFullscreen || target.webkitRequestFullscreen || target.webkitRequestFullScreen || target.mozRequestFullScreen || target.msRequestFullscreen;
        if (!method) throw new Error(this.FULLSCREEN_UNSUPPORTED_ERROR);
        return method.call(target, options);
    },
    exitFullscreen: function() {
        if (typeof document === "undefined") throw new Error(this.DOM_UNAVAILABLE_ERROR);
        var _document = document;
        var method = _document.exitFullscreen || _document.webkitExitFullscreen || _document.webkitCancelFullScreen || _document.mozCancelFullScreen || _document.msExitFullscreen;
        if (!method) throw new Error(this.FULLSCREEN_UNSUPPORTED_ERROR);
        return method.call(_document);
    },
    on: function(eventType, callback) {
        var eventName = this.getEventName(eventType);
        if (!eventName) return;
        document.addEventListener(eventName, callback);
    },
    off: function(eventType, callback) {
        var eventName = this.getEventName(eventType);
        if (!eventName) return;
        document.removeEventListener(eventName, callback);
    }
};
function $c020e53fc27b31fb$export$873ff9d3a24fe223() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var target = props.target, onChange = props.onChange, onError = props.onError, requestFullScreenOptions = props.requestFullScreenOptions;
    var _useState17 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isFullscreenAvailable = _useState17[0], setIsFullscreenAvailable = _useState17[1];
    var _useState171 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), fullscreenElement = _useState171[0], setFullscreenElement = _useState171[1];
    var _useState172 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isFullscreenEnabled = _useState172[0], setIsFullscreenEnabled = _useState172[1];
    var enableFullscreen = (0, $eHaBZ.useCallback)(function() {
        return $c020e53fc27b31fb$var$FullscreenApi.requestFullscreen((target === null || target === void 0 ? void 0 : target.current) || null, requestFullScreenOptions);
    }, [
        target,
        requestFullScreenOptions
    ]);
    var disableFullscreen = (0, $eHaBZ.useCallback)(function() {
        return $c020e53fc27b31fb$var$FullscreenApi.exitFullscreen();
    }, []);
    var toggleFullscreen = (0, $eHaBZ.useCallback)(function() {
        if ($c020e53fc27b31fb$var$FullscreenApi.fullscreenElement) return disableFullscreen();
        return enableFullscreen();
    }, [
        enableFullscreen,
        disableFullscreen
    ]);
    var onChangeHandler = (0, $eHaBZ.useCallback)(function(event) {
        var fullscreenElement2 = $c020e53fc27b31fb$var$FullscreenApi.fullscreenElement;
        setFullscreenElement(fullscreenElement2);
        setIsFullscreenEnabled(!!fullscreenElement2);
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    }, [
        onChange
    ]);
    var onErrorHandler = (0, $eHaBZ.useCallback)(function(event) {
        var fullscreenElement2 = $c020e53fc27b31fb$var$FullscreenApi.fullscreenElement;
        setFullscreenElement(fullscreenElement2);
        setIsFullscreenEnabled(!!fullscreenElement2);
        onError === null || onError === void 0 ? void 0 : onError(event);
    }, [
        onError
    ]);
    (0, $eHaBZ.useEffect)(function() {
        setIsFullscreenAvailable($c020e53fc27b31fb$var$FullscreenApi.fullscreenEnabled);
    }, []);
    (0, $eHaBZ.useEffect)(function() {
        $c020e53fc27b31fb$var$FullscreenApi.on("change", onChangeHandler);
        $c020e53fc27b31fb$var$FullscreenApi.on("error", onErrorHandler);
        return function() {
            $c020e53fc27b31fb$var$FullscreenApi.off("change", onChangeHandler);
            $c020e53fc27b31fb$var$FullscreenApi.off("error", onErrorHandler);
        };
    }, [
        onChangeHandler,
        onErrorHandler
    ]);
    return {
        isFullscreenAvailable: isFullscreenAvailable,
        fullscreenElement: fullscreenElement,
        isFullscreenEnabled: isFullscreenEnabled,
        enableFullscreen: enableFullscreen,
        disableFullscreen: disableFullscreen,
        toggleFullscreen: toggleFullscreen
    };
}
var $c020e53fc27b31fb$export$f8168d8dd8fd66e6 = function(props) {
    var propsOnBlur = props.onBlur, propsOnFocus = props.onFocus, propsOnFocusChange = props.onFocusChange;
    var onBlur = (0, $eHaBZ.useCallback)(function(e) {
        if (e.target === e.currentTarget) {
            if (propsOnBlur) propsOnBlur(e);
            if (propsOnFocusChange) propsOnFocusChange(false);
        }
    }, [
        propsOnBlur,
        propsOnFocusChange
    ]);
    var onFocus = (0, $eHaBZ.useCallback)(function(e) {
        if (e.target === e.currentTarget) {
            if (propsOnFocus) propsOnFocus(e);
            if (propsOnFocusChange) propsOnFocusChange(true);
        }
    }, [
        propsOnFocusChange,
        propsOnFocus
    ]);
    return {
        focusProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
};
var $c020e53fc27b31fb$export$420e68273165f4ec = function(props) {
    var onBlurWithin = props.onBlurWithin, onFocusWithin = props.onFocusWithin, onFocusWithinChange = props.onFocusWithinChange;
    var state = (0, $eHaBZ.useRef)({
        isFocusWithin: false
    });
    var onBlur = (0, $eHaBZ.useCallback)(function(e) {
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange
    ]);
    var onFocus = (0, $eHaBZ.useCallback)(function(e) {
        if (!state.current.isFocusWithin) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
        }
    }, [
        onFocusWithin,
        onFocusWithinChange
    ]);
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
};
function $c020e53fc27b31fb$var$getGeoLocation(options) {
    return new Promise(function(resolve, reject) {
        if (navigator.geolocation) navigator.geolocation.getCurrentPosition(function(position) {
            var coords = position.coords;
            var latitude = coords.latitude, longitude = coords.longitude;
            resolve({
                isError: false,
                lat: latitude,
                lng: longitude,
                message: ""
            });
        }, function(error) {
            resolve({
                isError: true,
                message: error && (typeof error === "undefined" ? "undefined" : (0, $2bfPH._)(error)) === "object" && "message" in error ? error.message : "Geolocation error"
            });
        }, options);
        else resolve({
            isError: true,
            message: "Geolocation is not supported for this Browser/OS."
        });
    });
}
var $c020e53fc27b31fb$var$defaultGeoLocationOptions = {
    enableHighAccuracy: false,
    maximumAge: 0,
    timeout: Number.POSITIVE_INFINITY,
    when: true
};
var $c020e53fc27b31fb$export$8c959c84e890409a = function() {
    var geoLocationOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $c020e53fc27b31fb$var$defaultGeoLocationOptions;
    var _useState18 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), geoObject = _useState18[0], setGeoObject = _useState18[1];
    var when = geoLocationOptions.when, enableHighAccuracy = geoLocationOptions.enableHighAccuracy, timeout = geoLocationOptions.timeout, maximumAge = geoLocationOptions.maximumAge;
    var getIsMounted = $c020e53fc27b31fb$export$7aa0022395cd4c49();
    (0, $eHaBZ.useEffect)(function() {
        var getGeoCode = function getGeoCode() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                var value, error;
                return (0, $6PS3Z.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                $c020e53fc27b31fb$var$getGeoLocation({
                                    enableHighAccuracy: enableHighAccuracy,
                                    maximumAge: maximumAge,
                                    timeout: timeout,
                                    when: when
                                })
                            ];
                        case 1:
                            value = _state.sent();
                            if (getIsMounted()) setGeoObject(value);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            if (getIsMounted()) setGeoObject({
                                isError: true,
                                message: error instanceof Error ? error.message : String(error)
                            });
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        if (when) getGeoCode();
    }, [
        when,
        enableHighAccuracy,
        timeout,
        maximumAge,
        getIsMounted
    ]);
    return geoObject;
};
var $c020e53fc27b31fb$var$IdlePolyfill = /*#__PURE__*/ function() {
    "use strict";
    function IdlePolyfill(threshold) {
        var _this = this;
        (0, $gd0sY._)(this, IdlePolyfill);
        (0, $khBmn._)(this, "threshold", void 0);
        (0, $khBmn._)(this, "isIdle", false);
        (0, $khBmn._)(this, "_userState", "active");
        (0, $khBmn._)(this, "_screenState", "unlocked");
        (0, $khBmn._)(this, "listeners", []);
        (0, $khBmn._)(this, "timeoutId", null);
        (0, $khBmn._)(this, "started", false);
        (0, $khBmn._)(this, "handleUserActivity", function() {
            if (_this.isIdle) {
                _this.isIdle = false;
                _this._userState = "active";
                _this.notifyListeners();
            }
            _this.resetIdleTimer();
        });
        (0, $khBmn._)(this, "handleVisibilityChange", function() {
            _this._screenState = document.hidden ? "locked" : "unlocked";
            _this.notifyListeners();
        });
        this.threshold = Math.max(threshold, 6e4);
    }
    (0, $7cSld._)(IdlePolyfill, [
        {
            key: "resetIdleTimer",
            value: function resetIdleTimer() {
                var _this = this;
                if (this.timeoutId) clearTimeout(this.timeoutId);
                this.timeoutId = window.setTimeout(function() {
                    _this.isIdle = true;
                    _this._userState = "idle";
                    _this.notifyListeners();
                }, this.threshold);
            }
        },
        {
            key: "notifyListeners",
            value: function notifyListeners() {
                this.listeners.forEach(function(listener) {
                    return listener();
                });
            }
        },
        {
            key: "userState",
            get: function get() {
                return this._userState;
            }
        },
        {
            key: "screenState",
            get: function get() {
                return this._screenState;
            }
        },
        {
            key: "isIdleState",
            get: function get() {
                return this.isIdle;
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(event, listener) {
                if (event === "change") this.listeners.push(listener);
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(event, listener) {
                if (event === "change") {
                    var index = this.listeners.indexOf(listener);
                    if (index > -1) this.listeners.splice(index, 1);
                }
            }
        },
        {
            key: "start",
            value: function start() {
                var _this = this;
                if (this.started) return;
                this.started = true;
                var events = [
                    "mousemove",
                    "keydown",
                    "click",
                    "scroll",
                    "touchstart"
                ];
                events.forEach(function(event) {
                    document.addEventListener(event, _this.handleUserActivity, true);
                });
                document.addEventListener("visibilitychange", this.handleVisibilityChange);
                this.resetIdleTimer();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this = this;
                if (!this.started) return;
                this.started = false;
                var events = [
                    "mousemove",
                    "keydown",
                    "click",
                    "scroll",
                    "touchstart"
                ];
                events.forEach(function(event) {
                    document.removeEventListener(event, _this.handleUserActivity, true);
                });
                document.removeEventListener("visibilitychange", this.handleVisibilityChange);
                if (this.timeoutId) {
                    clearTimeout(this.timeoutId);
                    this.timeoutId = null;
                }
                this.isIdle = false;
                this._userState = "active";
                this._screenState = "unlocked";
            }
        }
    ]);
    return IdlePolyfill;
}();
function $c020e53fc27b31fb$export$8c23cdf9de53b14f() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options_threshold = options.threshold, threshold = _options_threshold === void 0 ? 6e4 : _options_threshold, _options_autoStart = options.// Default 60 seconds
    autoStart, autoStart = _options_autoStart === void 0 ? false : _options_autoStart, _options_requestPermission = options.requestPermission, requestPermission = _options_requestPermission === void 0 ? false : _options_requestPermission, onIdleChange = options.onIdleChange, onError = options.onError;
    var _useState19 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isIdle = _useState19[0], setIsIdle = _useState19[1];
    var _useState191 = (0, $21h22._)((0, $eHaBZ.useState)("active"), 2), userState = _useState191[0], setUserState = _useState191[1];
    var _useState192 = (0, $21h22._)((0, $eHaBZ.useState)("unlocked"), 2), screenState = _useState192[0], setScreenState = _useState192[1];
    var _useState193 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isPermissionGranted = _useState193[0], setIsPermissionGranted = _useState193[1];
    var detectorRef = (0, $eHaBZ.useRef)(null);
    var polyfillRef = (0, $eHaBZ.useRef)(null);
    var startedRef = (0, $eHaBZ.useRef)(false);
    var isSupported = typeof window !== "undefined" && "IdleDetector" in window;
    var actualThreshold = Math.max(threshold, 6e4);
    var handleChange = (0, $eHaBZ.useCallback)(function() {
        var detector = detectorRef.current;
        var polyfill = polyfillRef.current;
        var newIsIdle = false;
        var newUserState = "active";
        var newScreenState = "unlocked";
        if (detector && detector.userState && detector.screenState) {
            newIsIdle = detector.userState === "idle";
            newUserState = detector.userState;
            newScreenState = detector.screenState;
        } else if (polyfill) {
            newIsIdle = polyfill.isIdleState;
            newUserState = polyfill.userState;
            newScreenState = polyfill.screenState;
        }
        setIsIdle(newIsIdle);
        setUserState(newUserState);
        setScreenState(newScreenState);
        onIdleChange === null || onIdleChange === void 0 ? void 0 : onIdleChange({
            isIdle: newIsIdle,
            userState: newUserState,
            screenState: newScreenState
        });
    }, [
        onIdleChange
    ]);
    var start = (0, $eHaBZ.useCallback)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var detector, permission, polyfill, error;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (startedRef.current) return [
                            2
                        ];
                        startedRef.current = true;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            ,
                            9
                        ]);
                        if (!(isSupported && window.IdleDetector)) return [
                            3,
                            6
                        ];
                        detector = new window.IdleDetector();
                        detectorRef.current = detector;
                        if (!requestPermission) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            window.IdleDetector.requestPermission()
                        ];
                    case 2:
                        permission = _state.sent();
                        setIsPermissionGranted(permission === "granted");
                        if (permission === "denied") {
                            onError === null || onError === void 0 ? void 0 : onError(new Error("Permission denied"));
                            return [
                                2
                            ];
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setIsPermissionGranted(true);
                        _state.label = 4;
                    case 4:
                        detector.addEventListener("change", handleChange);
                        return [
                            4,
                            detector.start({
                                threshold: actualThreshold
                            })
                        ];
                    case 5:
                        _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        polyfill = new $c020e53fc27b31fb$var$IdlePolyfill(actualThreshold);
                        polyfillRef.current = polyfill;
                        polyfill.addEventListener("change", handleChange);
                        polyfill.start();
                        setIsPermissionGranted(true);
                        _state.label = 7;
                    case 7:
                        return [
                            3,
                            9
                        ];
                    case 8:
                        error = _state.sent();
                        onError === null || onError === void 0 ? void 0 : onError(error instanceof Error ? error : new Error("Failed to start idle detection"));
                        return [
                            3,
                            9
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        isSupported,
        requestPermission,
        actualThreshold,
        handleChange,
        onError
    ]);
    var stop = (0, $eHaBZ.useCallback)(function() {
        if (!startedRef.current) return;
        startedRef.current = false;
        if (detectorRef.current) {
            detectorRef.current.removeEventListener("change", handleChange);
            detectorRef.current = null;
        }
        if (polyfillRef.current) {
            polyfillRef.current.removeEventListener("change", handleChange);
            polyfillRef.current.stop();
            polyfillRef.current = null;
        }
        setIsIdle(false);
        setUserState("active");
        setScreenState("unlocked");
    }, [
        handleChange
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (autoStart && !startedRef.current) start();
    }, [
        autoStart,
        start
    ]);
    (0, $eHaBZ.useEffect)(function() {
        return function() {
            stop();
        };
    }, [
        stop
    ]);
    return {
        isIdle: isIdle,
        userState: userState,
        screenState: screenState,
        isSupported: isSupported,
        isPermissionGranted: isPermissionGranted,
        start: start,
        stop: stop
    };
}
var $c020e53fc27b31fb$var$defaultOptions = {};
function $c020e53fc27b31fb$export$1e36b9f257eee5fa() {
    var initialValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c020e53fc27b31fb$var$defaultOptions;
    var _useState20 = (0, $21h22._)((0, $eHaBZ.useState)(initialValue), 2), value = _useState20[0], setValue = _useState20[1];
    var onChange = (0, $eHaBZ.useCallback)(function(event) {
        var newValue = event.target.value;
        var shouldUpdate = true;
        if (typeof options.validate === "function") shouldUpdate = options.validate(newValue, value);
        if (shouldUpdate) setValue(newValue);
    }, [
        options,
        value
    ]);
    (0, $eHaBZ.useEffect)(function() {
        setValue(initialValue);
    }, [
        initialValue
    ]);
    var handler = {
        onChange: onChange,
        value: value
    };
    return handler;
}
var $c020e53fc27b31fb$var$defaultMeasurements = {
    innerWidth: 0,
    innerHeight: 0,
    innerScrollWidth: 0,
    innerScrollHeight: 0,
    outerWidth: 0,
    outerHeight: 0,
    outerScrollWidth: 0,
    outerScrollHeight: 0
};
function $c020e53fc27b31fb$var$getMeasurements(element) {
    return {
        innerWidth: element.clientWidth,
        innerHeight: element.clientHeight,
        innerScrollWidth: element.scrollWidth,
        innerScrollHeight: element.scrollHeight,
        outerWidth: element.offsetWidth,
        outerHeight: element.offsetHeight,
        outerScrollWidth: element.scrollWidth,
        outerScrollHeight: element.scrollHeight
    };
}
function $c020e53fc27b31fb$export$e295b0c537d32d7d() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var tmp = options.debounce, debounce2 = tmp === void 0 ? 0 : tmp, _options_disabled = options.disabled, disabled = _options_disabled === void 0 ? false : _options_disabled, onMeasure = options.onMeasure;
    var _useState21 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), node = _useState21[0], setNode = _useState21[1];
    var _useState211 = (0, $21h22._)((0, $eHaBZ.useState)($c020e53fc27b31fb$var$defaultMeasurements), 2), measurements = _useState211[0], setMeasurements = _useState211[1];
    var onMeasureRef = (0, $eHaBZ.useRef)(onMeasure);
    var resizeObserverRef = (0, $eHaBZ.useRef)(null);
    (0, $eHaBZ.useEffect)(function() {
        onMeasureRef.current = onMeasure;
    });
    var measure = (0, $eHaBZ.useCallback)(function() {
        if (!node || disabled) return;
        var newMeasurements = $c020e53fc27b31fb$var$getMeasurements(node);
        setMeasurements(newMeasurements);
        if (onMeasureRef.current) onMeasureRef.current(newMeasurements);
    }, [
        node,
        disabled
    ]);
    var _useDebounceFn = (0, $21h22._)($c020e53fc27b31fb$export$ddf8f1aa96b8ea88(measure, debounce2, {
        leading: false,
        trailing: true
    }), 1), debouncedMeasure = _useDebounceFn[0];
    var measureFunction = debounce2 > 0 ? debouncedMeasure : measure;
    var handleResizeObserver = (0, $eHaBZ.useCallback)(function() {
        measureFunction();
    }, [
        measureFunction
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (!node || disabled) {
            if (resizeObserverRef.current) {
                resizeObserverRef.current.disconnect();
                resizeObserverRef.current = null;
            }
            return $c020e53fc27b31fb$var$noop;
        }
        if (typeof ResizeObserver === "undefined") {
            console.warn("useMeasure: ResizeObserver is not available in this environment");
            return $c020e53fc27b31fb$var$noop;
        }
        var observer = new ResizeObserver(handleResizeObserver);
        resizeObserverRef.current = observer;
        observer.observe(node, {
            box: "content-box"
        });
        measureFunction();
        return function() {
            observer.disconnect();
            resizeObserverRef.current = null;
        };
    }, [
        node,
        disabled,
        handleResizeObserver,
        measureFunction
    ]);
    var ref = (0, $eHaBZ.useCallback)(function(element) {
        setNode(element);
    }, []);
    (0, $eHaBZ.useEffect)(function() {
        if (typeof window === "undefined") console.warn("useMeasure: window is undefined (SSR environment)");
    }, []);
    return [
        ref,
        measurements
    ];
}
var $c020e53fc27b31fb$var$config3 = {
    root: null,
    rootMargin: "0px 0px 0px 0px",
    threshold: [
        0,
        1
    ]
};
function $c020e53fc27b31fb$export$44b5bb7485b3d5ca(callback) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c020e53fc27b31fb$var$config3;
    var _options_root = options.root, root = _options_root === void 0 ? null : _options_root, rootMargin = options.rootMargin, threshold = options.threshold;
    var _useState22 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), node = _useState22[0], setNode = _useState22[1];
    var callbackRef = (0, $eHaBZ.useRef)(callback);
    (0, $eHaBZ.useEffect)(function() {
        callbackRef.current = callback;
    });
    var handleIntersectionObserver = (0, $eHaBZ.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _callbackRef_current;
        var _callbackRef_current1;
        return (_callbackRef_current1 = callbackRef.current) === null || _callbackRef_current1 === void 0 ? void 0 : (_callbackRef_current = _callbackRef_current1).call.apply(_callbackRef_current, [
            callbackRef
        ].concat((0, $6zk1M._)(args)));
    }, []);
    (0, $eHaBZ.useEffect)(function() {
        if (node) {
            var observer = new IntersectionObserver(handleIntersectionObserver, {
                root: root,
                rootMargin: rootMargin,
                threshold: threshold
            });
            observer.observe(node);
            return function() {
                observer.disconnect();
            };
        }
        return $c020e53fc27b31fb$var$noop;
    }, [
        node,
        handleIntersectionObserver,
        root,
        rootMargin,
        threshold
    ]);
    var ref = (0, $eHaBZ.useCallback)(function(nodeElement) {
        setNode(nodeElement);
    }, []);
    return [
        ref
    ];
}
var $c020e53fc27b31fb$var$config4 = {
    root: null,
    rootMargin: "0px 0px 0px 0px",
    threshold: [
        0,
        1
    ]
};
function $c020e53fc27b31fb$export$14734974288d5830(callbackOrOptions, options) {
    var callback = typeof callbackOrOptions === "function" ? callbackOrOptions : $c020e53fc27b31fb$var$noop;
    var opts = (typeof callbackOrOptions === "undefined" ? "undefined" : (0, $2bfPH._)(callbackOrOptions)) === "object" ? callbackOrOptions : options || $c020e53fc27b31fb$var$config4;
    var _opts_root = opts.root, root = _opts_root === void 0 ? null : _opts_root, rootMargin = opts.rootMargin, threshold = opts.threshold;
    var _useState23 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), node = _useState23[0], setNode = _useState23[1];
    var _useState231 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), inView = _useState231[0], setInView = _useState231[1];
    (0, $eHaBZ.useEffect)(function() {
        if (node) {
            var observer = new IntersectionObserver(function(entries, observerRef) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var isIntersecting = _step.value.isIntersecting;
                        setInView(isIntersecting);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                callback(entries, observerRef);
            }, opts);
            observer.observe(node);
            return function() {
                observer.disconnect();
            };
        }
        return $c020e53fc27b31fb$var$noop;
    }, [
        node,
        callback,
        root,
        rootMargin,
        threshold,
        opts
    ]);
    var ref = (0, $eHaBZ.useCallback)(function(nodeElement) {
        setNode(nodeElement);
    }, []);
    return [
        ref,
        inView
    ];
}
function $c020e53fc27b31fb$export$a70fb0bde1aaaf0d() {
    var isTargetWindow = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var _useState24 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), targetNode = _useState24[0], setTargetNode = _useState24[1];
    var ref = (0, $eHaBZ.useCallback)(function(node) {
        setTargetNode(node);
    }, []);
    var _useState241 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isDroppingFiles = _useState241[0], setIsDroppingFiles = _useState241[1];
    var handleDragEnter = (0, $eHaBZ.useCallback)(function(e) {
        var _e_dataTransfer;
        e.preventDefault();
        if ((_e_dataTransfer = e.dataTransfer) === null || _e_dataTransfer === void 0 ? void 0 : _e_dataTransfer.types.includes("Files")) {
            if (!isDroppingFiles) setIsDroppingFiles(true);
        } else setIsDroppingFiles(false);
    }, [
        isDroppingFiles
    ]);
    var handleDragOver = (0, $eHaBZ.useCallback)(function(e) {
        var _e_dataTransfer;
        e.preventDefault();
        if ((_e_dataTransfer = e.dataTransfer) === null || _e_dataTransfer === void 0 ? void 0 : _e_dataTransfer.types.includes("Files")) {
            if (!isDroppingFiles) setIsDroppingFiles(true);
        } else setIsDroppingFiles(false);
    }, [
        isDroppingFiles
    ]);
    var handleDragLeave = (0, $eHaBZ.useCallback)(function(e) {
        e.preventDefault();
        setIsDroppingFiles(false);
    }, []);
    var handleDrop = (0, $eHaBZ.useCallback)(function(e) {
        e.preventDefault();
        setIsDroppingFiles(false);
    }, []);
    var freshHandleDragEnter = $c020e53fc27b31fb$export$b3553245f2c17524(handleDragEnter);
    var freshHandleDragOver = $c020e53fc27b31fb$export$b3553245f2c17524(handleDragOver);
    var freshHandleDragLeave = $c020e53fc27b31fb$export$b3553245f2c17524(handleDragLeave);
    var freshHandleDrop = $c020e53fc27b31fb$export$b3553245f2c17524(handleDrop);
    (0, $eHaBZ.useEffect)(function() {
        var target = isTargetWindow ? window : targetNode;
        if (target) {
            target.addEventListener("dragenter", freshHandleDragEnter);
            target.addEventListener("dragover", freshHandleDragOver);
            target.addEventListener("dragleave", freshHandleDragLeave);
            target.addEventListener("drop", freshHandleDrop);
        }
        return function() {
            if (target) {
                target.removeEventListener("dragenter", freshHandleDragEnter);
                target.removeEventListener("dragover", freshHandleDragOver);
                target.removeEventListener("dragleave", freshHandleDragLeave);
                target.removeEventListener("drop", freshHandleDrop);
            }
        };
    }, [
        freshHandleDragEnter,
        freshHandleDragLeave,
        freshHandleDragOver,
        freshHandleDrop,
        isDroppingFiles,
        isTargetWindow,
        targetNode
    ]);
    if (isTargetWindow) return isDroppingFiles;
    return [
        ref,
        isDroppingFiles
    ];
}
// src/utils/doesIdentifierMatchKeyboardEvent.ts
var $c020e53fc27b31fb$var$doesIdentifierMatchKeyboardEvent = function(error, identifier) {
    if (error.key === identifier || error.code === identifier || error.keyCode === identifier || error.which === identifier || error.charCode === identifier) return true;
    return false;
};
// src/hooks/useKey.ts
var $c020e53fc27b31fb$var$defaultOptions2 = {
    eventTypes: [
        "keydown"
    ],
    when: true
};
function $c020e53fc27b31fb$export$a41bc8a5485cb6b(keys, callback, options) {
    var keyList = (0, $eHaBZ.useMemo)(function() {
        if (Array.isArray(keys)) return keys;
        else return [
            keys
        ];
    }, [
        keys
    ]);
    var internalOptions = (0, $eHaBZ.useMemo)(function() {
        return (0, $lvTkn._)({}, $c020e53fc27b31fb$var$defaultOptions2, options);
    }, [
        options
    ]);
    var when = internalOptions.when, eventTypes = internalOptions.eventTypes;
    var callbackRef = (0, $eHaBZ.useRef)(callback);
    var target = internalOptions.target;
    (0, $eHaBZ.useEffect)(function() {
        callbackRef.current = callback;
    });
    var handle = (0, $eHaBZ.useCallback)(function(event) {
        if (keyList.some(function(identifier) {
            return $c020e53fc27b31fb$var$doesIdentifierMatchKeyboardEvent(event, identifier);
        })) callbackRef.current(event);
    }, [
        keyList
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (when && typeof window !== "undefined") {
            if (target) {
                var targetNode = target.current;
                if (targetNode) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = eventTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var eventType = _step.value;
                            targetNode.addEventListener(eventType, handle);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return function() {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = eventTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var eventType = _step.value;
                                targetNode.removeEventListener(eventType, handle);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    };
                }
            } else {
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = eventTypes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var eventType1 = _step1.value;
                        window.addEventListener(eventType1, handle);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return function() {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = eventTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var eventType = _step.value;
                            window.removeEventListener(eventType, handle);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                };
            }
        }
        return $c020e53fc27b31fb$var$noop;
    }, [
        when,
        eventTypes,
        keyList,
        target,
        callback,
        handle
    ]);
}
// src/hooks/useKeyBindings.ts
var $c020e53fc27b31fb$export$40f9c496c4444fe4 = function(keyBindings, options) {
    for(var key in keyBindings){
        var handler = keyBindings[key];
        if (handler) $c020e53fc27b31fb$export$a41bc8a5485cb6b(key, handler, options);
    }
};
var $c020e53fc27b31fb$var$defaultOptions3 = {
    eventTypes: [
        "keydown"
    ],
    when: true
};
function $c020e53fc27b31fb$export$26675181ca12477d(keys, callback, options) {
    var _useState25 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), targetNode = _useState25[0], setTargetNode = _useState25[1];
    var ref = (0, $eHaBZ.useCallback)(function(node) {
        setTargetNode(node);
    }, []);
    var keyList = (0, $eHaBZ.useMemo)(function() {
        if (Array.isArray(keys)) return keys;
        else return [
            keys
        ];
    }, [
        keys
    ]);
    var internalOptions = (0, $eHaBZ.useMemo)(function() {
        return (0, $lvTkn._)({}, $c020e53fc27b31fb$var$defaultOptions3, options);
    }, [
        options
    ]);
    var when = internalOptions.when, eventTypes = internalOptions.eventTypes;
    var callbackRef = (0, $eHaBZ.useRef)(callback);
    (0, $eHaBZ.useEffect)(function() {
        callbackRef.current = callback;
    });
    var handle = (0, $eHaBZ.useCallback)(function(event) {
        if (keyList.some(function(identifier) {
            return $c020e53fc27b31fb$var$doesIdentifierMatchKeyboardEvent(event, identifier);
        })) callbackRef.current(event);
    }, [
        keyList
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (when && targetNode) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = eventTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var eventType = _step.value;
                    targetNode.addEventListener(eventType, handle);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return function() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = eventTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var eventType = _step.value;
                        targetNode.removeEventListener(eventType, handle);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            };
        }
        return $c020e53fc27b31fb$var$noop;
    }, [
        targetNode,
        when,
        eventTypes,
        keyList,
        handle
    ]);
    return ref;
}
var $c020e53fc27b31fb$var$defaultOptions4 = {
    continuous: false,
    when: true
};
function $c020e53fc27b31fb$export$2006064841430665(keysList, callback, options) {
    var internalOptions = (0, $lvTkn._)({}, $c020e53fc27b31fb$var$defaultOptions4, options);
    var target = internalOptions.target, when = internalOptions.when, continuous = internalOptions.continuous, preventLostKeyup = internalOptions.preventLostKeyup;
    var savedCallback = (0, $eHaBZ.useRef)(callback);
    var pressedKeyMappingRef = (0, $eHaBZ.useRef)({});
    var PressedKeyMapping = pressedKeyMappingRef.current;
    (0, $eHaBZ.useEffect)(function() {
        savedCallback.current = callback;
    });
    var handleKeyDown = (0, $eHaBZ.useCallback)(function(event) {
        var pressedKeyIdentifier = null;
        var areAllKeysFromListPressed = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keysList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var identifier = _step.value;
                if ($c020e53fc27b31fb$var$doesIdentifierMatchKeyboardEvent(event, identifier)) {
                    PressedKeyMapping[identifier] = true;
                    pressedKeyIdentifier = identifier;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (keysList.every(function(identifier) {
            return Boolean(PressedKeyMapping[identifier]);
        })) areAllKeysFromListPressed = true;
        if (areAllKeysFromListPressed) {
            savedCallback.current(event);
            if (!continuous && pressedKeyIdentifier !== null) PressedKeyMapping[pressedKeyIdentifier] = false;
        }
    }, [
        keysList,
        PressedKeyMapping,
        continuous
    ]);
    var handleKeyUp = (0, $eHaBZ.useCallback)(function(event) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keysList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var identifier = _step.value;
                if ($c020e53fc27b31fb$var$doesIdentifierMatchKeyboardEvent(event, identifier)) PressedKeyMapping[identifier] = void 0;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }, [
        PressedKeyMapping,
        keysList
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (when && typeof window !== "undefined") {
            var targetNode = (target === null || target === void 0 ? void 0 : target.current) ? target.current : document;
            targetNode.addEventListener("keydown", handleKeyDown);
            targetNode.addEventListener("keyup", handleKeyUp);
            return function() {
                targetNode.removeEventListener("keydown", handleKeyDown);
                targetNode.removeEventListener("keyup", handleKeyUp);
            };
        }
        return $c020e53fc27b31fb$var$noop;
    }, [
        when,
        target,
        keysList,
        handleKeyDown,
        handleKeyUp
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (preventLostKeyup !== true) return $c020e53fc27b31fb$var$noop;
        if (typeof window !== "undefined") {
            var originalAlert = window.alert;
            window.alert = function(message) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keysList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var identifier = _step.value;
                        PressedKeyMapping[identifier] = void 0;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return originalAlert(message);
            };
            var originalConfirm = window.confirm;
            window.confirm = function(message) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keysList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var identifier = _step.value;
                        PressedKeyMapping[identifier] = void 0;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return originalConfirm(message);
            };
            var originalPrompt = window.prompt;
            window.prompt = function(message, _default) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keysList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var identifier = _step.value;
                        PressedKeyMapping[identifier] = void 0;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return originalPrompt(message, _default);
            };
            return function() {
                window.alert = originalAlert;
                window.confirm = originalConfirm;
                window.prompt = originalPrompt;
            };
        }
        return $c020e53fc27b31fb$var$noop;
    }, [
        PressedKeyMapping,
        keysList,
        preventLostKeyup
    ]);
}
// src/hooks/useLifecycleLogger.ts
var $c020e53fc27b31fb$export$88d6c78aac91ea11 = function() {
    var componentName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Component";
    for(var _len = arguments.length, otherArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        otherArgs[_key - 1] = arguments[_key];
    }
    $c020e53fc27b31fb$export$4984640464733c64(function() {
        var _console;
        (_console = console).log.apply(_console, [
            "".concat(componentName, " mounted")
        ].concat((0, $6zk1M._)(otherArgs)));
        return function() {
            return console.log("".concat(componentName, " unmounted"));
        };
    });
    $c020e53fc27b31fb$export$e34ed88fef4dc107(function() {
        var _console;
        (_console = console).log.apply(_console, [
            "".concat(componentName, " updated")
        ].concat((0, $6zk1M._)(otherArgs)));
    });
    $c020e53fc27b31fb$export$328d69a66df243d8(function() {
        console.log("".concat(componentName, " unmounted"));
    });
};
function $c020e53fc27b31fb$export$bd4ec12442706c3d(isLocked) {
    (0, $eHaBZ.useEffect)(function() {
        if (isLocked) {
            var originalOverflow = window.getComputedStyle(document.body).overflow;
            document.body.style.overflow = "hidden";
            return function() {
                document.body.style.overflow = originalOverflow;
            };
        } else return $c020e53fc27b31fb$var$noop;
    }, [
        isLocked
    ]);
}
function $c020e53fc27b31fb$var$getValueFromLocalStorage(key) {
    if (typeof localStorage === "undefined") return null;
    var _localStorage_getItem;
    var storedValue = (_localStorage_getItem = localStorage.getItem(key)) !== null && _localStorage_getItem !== void 0 ? _localStorage_getItem : "null";
    try {
        return JSON.parse(storedValue);
    } catch (error) {
        console.error(error);
    }
    return storedValue;
}
function $c020e53fc27b31fb$var$saveValueToLocalStorage(key, value) {
    if (typeof localStorage === "undefined") return null;
    if (value === void 0) return localStorage.removeItem(key);
    return localStorage.setItem(key, JSON.stringify(value));
}
function $c020e53fc27b31fb$var$initialize(key, initialState) {
    var valueLoadedFromLocalStorage = $c020e53fc27b31fb$var$getValueFromLocalStorage(key);
    if (valueLoadedFromLocalStorage === null) return typeof initialState === "function" ? initialState() : initialState;
    else return valueLoadedFromLocalStorage;
}
function $c020e53fc27b31fb$export$1ad8e86cf52f97f1(key, initialState) {
    var _useState26 = (0, $21h22._)((0, $eHaBZ.useState)(function() {
        return $c020e53fc27b31fb$var$initialize(key, initialState);
    }), 2), value = _useState26[0], setValue = _useState26[1];
    var isUpdateFromCrossDocumentListener = (0, $eHaBZ.useRef)(false);
    var isUpdateFromWithinDocumentListener = (0, $eHaBZ.useRef)(false);
    var customEventTypeName = (0, $eHaBZ.useMemo)(function() {
        return "rooks-".concat(key, "-localstorage-update");
    }, [
        key
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (!isUpdateFromCrossDocumentListener.current || !isUpdateFromWithinDocumentListener.current) $c020e53fc27b31fb$var$saveValueToLocalStorage(key, value);
    }, [
        key,
        value
    ]);
    var listenToCrossDocumentStorageEvents = (0, $eHaBZ.useCallback)(function(event) {
        if (event.storageArea === localStorage && event.key === key) try {
            isUpdateFromCrossDocumentListener.current = true;
            var _event_newValue;
            var newValue = JSON.parse((_event_newValue = event.newValue) !== null && _event_newValue !== void 0 ? _event_newValue : "null");
            if (value !== newValue) setValue(newValue);
        } catch (error) {
            console.log(error);
        }
    }, [
        key,
        value
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (typeof window !== "undefined") {
            window.addEventListener("storage", listenToCrossDocumentStorageEvents);
            return function() {
                window.removeEventListener("storage", listenToCrossDocumentStorageEvents);
            };
        } else {
            console.warn("useLocalstorageState: window is undefined.");
            return function() {};
        }
    }, [
        listenToCrossDocumentStorageEvents
    ]);
    var listenToCustomEventWithinDocument = (0, $eHaBZ.useCallback)(function(event) {
        try {
            isUpdateFromWithinDocumentListener.current = true;
            var newValue = event.detail.newValue;
            if (value !== newValue) setValue(newValue);
        } catch (error) {
            console.log(error);
        }
    }, [
        value
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (typeof document !== "undefined") {
            document.addEventListener(customEventTypeName, listenToCustomEventWithinDocument);
            return function() {
                document.removeEventListener(customEventTypeName, listenToCustomEventWithinDocument);
            };
        } else {
            console.warn("[useLocalstorageState] document is undefined.");
            return function() {};
        }
    }, [
        customEventTypeName,
        listenToCustomEventWithinDocument
    ]);
    var broadcastValueWithinDocument = (0, $eHaBZ.useCallback)(function(newValue) {
        if (typeof document !== "undefined") {
            var event = new CustomEvent(customEventTypeName, {
                detail: {
                    newValue: newValue
                }
            });
            document.dispatchEvent(event);
        } else console.warn("[useLocalstorageState] document is undefined.");
    }, [
        customEventTypeName
    ]);
    var currentValue = $c020e53fc27b31fb$export$38e1734badfda8d9(value, true);
    var set = (0, $eHaBZ.useCallback)(function(newValue) {
        var resolvedNewValue = typeof newValue === "function" ? newValue(currentValue.current) : newValue;
        isUpdateFromCrossDocumentListener.current = false;
        isUpdateFromWithinDocumentListener.current = false;
        setValue(resolvedNewValue);
        broadcastValueWithinDocument(resolvedNewValue);
    }, [
        broadcastValueWithinDocument,
        currentValue
    ]);
    var remove = (0, $eHaBZ.useCallback)(function() {
        localStorage.removeItem(key);
    }, [
        key
    ]);
    return [
        value,
        set,
        remove
    ];
}
function $c020e53fc27b31fb$export$1c18f7df404570ad(initialMapState) {
    var _useState27 = (0, $21h22._)((0, $eHaBZ.useState)(initialMapState || /* @__PURE__ */ new Map()), 2), map = _useState27[0], setMap = _useState27[1];
    var set = (0, $eHaBZ.useCallback)(function(key, value) {
        setMap(function(prevMap) {
            return new Map(prevMap.set(key, value));
        });
    }, []);
    var setMultiple = (0, $eHaBZ.useCallback)(function(entries) {
        setMap(function(prevMap) {
            var newMap = new Map(prevMap);
            entries.forEach(function(param) {
                var _param = (0, $21h22._)(param, 2), key = _param[0], value = _param[1];
                newMap.set(key, value);
            });
            return newMap;
        });
    }, []);
    var remove = (0, $eHaBZ.useCallback)(function(key) {
        setMap(function(prevMap) {
            var newMap = new Map(prevMap);
            newMap.delete(key);
            return newMap;
        });
    }, []);
    var removeMultiple = (0, $eHaBZ.useCallback)(function(keys) {
        setMap(function(prevMap) {
            var newMap = new Map(prevMap);
            keys.forEach(function(key) {
                newMap.delete(key);
            });
            return newMap;
        });
    }, []);
    var clear = (0, $eHaBZ.useCallback)(function() {
        setMap(/* @__PURE__ */ new Map());
    }, []);
    var has = (0, $eHaBZ.useCallback)(function(key) {
        return map.has(key);
    }, [
        map
    ]);
    var hasSome = (0, $eHaBZ.useCallback)(function(keys) {
        return keys.some(function(key) {
            return map.has(key);
        });
    }, [
        map
    ]);
    var hasEvery = (0, $eHaBZ.useCallback)(function(keys) {
        return keys.every(function(key) {
            return map.has(key);
        });
    }, [
        map
    ]);
    var get = (0, $eHaBZ.useCallback)(function(key) {
        return map.get(key);
    }, [
        map
    ]);
    var size = (0, $eHaBZ.useCallback)(function() {
        return map.size;
    }, [
        map
    ]);
    var controls = {
        set: set,
        remove: remove,
        clear: clear,
        has: has,
        get: get,
        size: size,
        setMultiple: setMultiple,
        removeMultiple: removeMultiple,
        hasSome: hasSome,
        hasEvery: hasEvery
    };
    return [
        map,
        controls
    ];
}
function $c020e53fc27b31fb$export$b1eecdc553bff745(query) {
    var defaultServerRenderedValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (typeof window === "undefined") {
        console.warn("useMediaMatch cannot function as window is undefined.");
        return defaultServerRenderedValue;
    }
    var matchMedia = (0, $eHaBZ.useMemo)(function() {
        return window.matchMedia(query);
    }, [
        query
    ]);
    var _useState28 = (0, $21h22._)((0, $eHaBZ.useState)(function() {
        return matchMedia.matches;
    }), 2), matches = _useState28[0], setMatches = _useState28[1];
    (0, $eHaBZ.useEffect)(function() {
        setMatches(matchMedia.matches);
        var listener = function(event) {
            return setMatches(event.matches);
        };
        if (matchMedia.addEventListener) {
            matchMedia.addEventListener("change", listener);
            return function() {
                return matchMedia.removeEventListener("change", listener);
            };
        } else {
            matchMedia.addListener(listener);
            return function() {
                return matchMedia.removeListener(listener);
            };
        }
    }, [
        matchMedia
    ]);
    return matches;
}
function $c020e53fc27b31fb$var$setRef2(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $c020e53fc27b31fb$export$74665b213cb5c4cf() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return (0, $eHaBZ.useMemo)(function() {
        if (refs.every(function(ref) {
            return ref === null;
        })) return null;
        return function(refValue) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = refs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var ref = _step.value;
                    $c020e53fc27b31fb$var$setRef2(ref, refValue);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
    }, [
        refs
    ]);
}
var $c020e53fc27b31fb$var$initialMouseState = {
    clientX: null,
    clientY: null,
    movementX: null,
    movementY: null,
    offsetX: null,
    offsetY: null,
    pageX: null,
    pageY: null,
    screenX: null,
    screenY: null,
    x: null,
    y: null
};
function $c020e53fc27b31fb$var$getMousePositionFromEvent(event) {
    var screenX = event.screenX, screenY = event.screenY, movementX = event.movementX, movementY = event.movementY, pageX = event.pageX, pageY = event.pageY, clientX = event.clientX, clientY = event.clientY, offsetX = event.offsetX, offsetY = event.offsetY;
    return {
        clientX: clientX,
        clientY: clientY,
        movementX: movementX,
        movementY: movementY,
        offsetX: offsetX,
        offsetY: offsetY,
        pageX: pageX,
        pageY: pageY,
        screenX: screenX,
        screenY: screenY,
        x: screenX,
        y: screenY
    };
}
function $c020e53fc27b31fb$export$70811b4970b0f258() {
    var _useState29 = (0, $21h22._)((0, $eHaBZ.useState)($c020e53fc27b31fb$var$initialMouseState), 2), mousePosition = _useState29[0], setMousePosition = _useState29[1];
    function updateMousePosition(event) {
        setMousePosition($c020e53fc27b31fb$var$getMousePositionFromEvent(event));
    }
    (0, $eHaBZ.useEffect)(function() {
        document.addEventListener("mousemove", updateMousePosition);
        return function() {
            document.removeEventListener("mousemove", updateMousePosition);
        };
    }, []);
    return mousePosition;
}
var $c020e53fc27b31fb$var$initialDelta = {
    deltaX: 0,
    deltaY: 0,
    clientX: null,
    clientY: null,
    velocityX: 0,
    velocityY: 0,
    timeStamp: Date.now()
};
function $c020e53fc27b31fb$export$7b61ea4399b4754c() {
    var _useState30 = (0, $21h22._)((0, $eHaBZ.useState)(function() {
        return (0, $9Jpjh._)((0, $lvTkn._)({}, $c020e53fc27b31fb$var$initialDelta), {
            timeStamp: Date.now()
        });
    }), 2), delta = _useState30[0], setDelta = _useState30[1];
    var lastDeltaRef = (0, $eHaBZ.useRef)(null);
    var handleMouseMove = (0, $eHaBZ.useCallback)(function(event) {
        var currentTimestamp = event.timeStamp;
        var lastDelta = lastDeltaRef.current;
        if (lastDelta && lastDelta.clientX !== null && lastDelta.clientY !== null) {
            var deltaX = event.clientX - lastDelta.clientX;
            var deltaY = event.clientY - lastDelta.clientY;
            var timeDelta = currentTimestamp - lastDelta.timeStamp;
            var velocityX = timeDelta === 0 ? 0 : deltaX / timeDelta;
            var velocityY = timeDelta === 0 ? 0 : deltaY / timeDelta;
            lastDeltaRef.current = delta;
            setDelta({
                deltaX: deltaX,
                clientX: event.clientX,
                clientY: event.clientY,
                deltaY: deltaY,
                velocityX: velocityX,
                velocityY: velocityY,
                timeStamp: currentTimestamp
            });
        } else {
            lastDeltaRef.current = (0, $9Jpjh._)((0, $lvTkn._)({}, delta), {
                clientX: event.clientX,
                clientY: event.clientY,
                timeStamp: event.timeStamp
            });
            setDelta({
                clientX: event.clientX,
                clientY: event.clientY,
                deltaX: 0,
                deltaY: 0,
                velocityX: 0,
                velocityY: 0,
                timeStamp: event.timeStamp
            });
        }
    }, [
        delta
    ]);
    var freshMouseMove = $c020e53fc27b31fb$export$b3553245f2c17524(handleMouseMove);
    (0, $eHaBZ.useEffect)(function() {
        document.addEventListener("mousemove", freshMouseMove, {
            passive: true
        });
        return function() {
            document.removeEventListener("mousemove", freshMouseMove);
        };
    }, [
        freshMouseMove
    ]);
    return (0, $eHaBZ.useMemo)(function() {
        var deltaX = delta.deltaX, deltaY = delta.deltaY, velocityX = delta.velocityX, velocityY = delta.velocityY;
        return {
            deltaX: deltaX,
            deltaY: deltaY,
            velocityX: velocityX,
            velocityY: velocityY
        };
    }, [
        delta
    ]);
}
var $c020e53fc27b31fb$var$initialDelta2 = {
    delta: 0,
    velocity: 0,
    timeStamp: Date.now()
};
function $c020e53fc27b31fb$export$145b759060b8fae5() {
    var _useState31 = (0, $21h22._)((0, $eHaBZ.useState)(function() {
        return (0, $9Jpjh._)((0, $lvTkn._)({}, $c020e53fc27b31fb$var$initialDelta2), {
            timeStamp: Date.now()
        });
    }), 2), deltaState = _useState31[0], setDeltaState = _useState31[1];
    var lastDeltaRef = (0, $eHaBZ.useRef)(null);
    var handleWheel = (0, $eHaBZ.useCallback)(function(event) {
        var currentTimestamp = event.timeStamp;
        var lastDelta = lastDeltaRef.current;
        if (lastDelta) {
            var delta = event.deltaY;
            var timeDelta = currentTimestamp - lastDelta.timeStamp;
            console.log(timeDelta);
            var velocity = timeDelta === 0 ? 0 : delta / timeDelta;
            console.log("delta", delta);
            console.log("timedelta", timeDelta);
            console.log("velocity", velocity);
            lastDeltaRef.current = deltaState;
            setDeltaState({
                delta: delta,
                velocity: velocity,
                timeStamp: currentTimestamp
            });
        } else {
            lastDeltaRef.current = {
                velocity: 0,
                delta: 0,
                timeStamp: event.timeStamp
            };
            setDeltaState({
                delta: event.deltaY,
                velocity: 0,
                timeStamp: event.timeStamp
            });
        }
    }, [
        deltaState
    ]);
    var freshWheel = $c020e53fc27b31fb$export$b3553245f2c17524(handleWheel);
    (0, $eHaBZ.useEffect)(function() {
        document.addEventListener("wheel", freshWheel);
        return function() {
            document.removeEventListener("wheel", freshWheel);
        };
    }, [
        freshWheel
    ]);
    console.log(deltaState);
    return (0, $eHaBZ.useMemo)(function() {
        var delta = deltaState.delta, velocity = deltaState.velocity;
        return {
            delta: delta,
            velocity: velocity
        };
    }, [
        deltaState
    ]);
}
function $c020e53fc27b31fb$var$warnIfBothValueAndIndexAreProvided(functionName, object) {
    if (Object.values(object).every(function(value) {
        return typeof value !== "undefined";
    })) console.warn("".concat(functionName, ". Expected either ").concat(Object.keys(object).join(" or "), " to be provided. However all were provided"));
    else if (Object.values(object).every(function(value) {
        return typeof value === "undefined";
    })) console.warn("".concat(functionName, ". ").concat(Object.keys(object).join(" , "), " are all undefined."));
}
function $c020e53fc27b31fb$export$a7f42c7977b517c0() {
    var list = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], initialSelectIndices = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
        0
    ], allowUnselected = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var _useState32 = (0, $21h22._)((0, $eHaBZ.useState)(initialSelectIndices), 2), currentIndices = _useState32[0], setCurrentIndices = _useState32[1];
    var currentValues = currentIndices.map(function(index) {
        return list[index];
    }).filter(function(value) {
        return value !== void 0;
    });
    var selection = [
        currentIndices,
        currentValues
    ];
    var updateSelections = function(param) {
        var indices = param.indices, values = param.values;
        return function() {
            $c020e53fc27b31fb$var$warnIfBothValueAndIndexAreProvided("updateSelections", {
                indices: indices,
                values: values
            });
            if (typeof indices !== "undefined") {
                if (!allowUnselected && indices.length === 0) {
                    console.warn("updateSelections failed. indices is an empty list.");
                    return;
                }
                setCurrentIndices(indices);
            } else if (typeof values !== "undefined") {
                var valueIndices = list.reduce(function(accumulator, current, index) {
                    if (values.includes(current)) {
                        var array = (0, $6zk1M._)(accumulator).concat([
                            index
                        ]);
                        return array;
                    }
                    return accumulator;
                }, []);
                if (valueIndices.length > 0) setCurrentIndices(valueIndices);
                else if (allowUnselected) setCurrentIndices(valueIndices);
                else console.warn("updateSelections failed. Do the values exist in the list?");
            }
        };
    };
    var toggleSelectionByIndex = (0, $eHaBZ.useCallback)(function(index) {
        var newIndices;
        if (!currentIndices.includes(index)) newIndices = (0, $6zk1M._)(currentIndices).concat([
            index
        ]);
        else {
            newIndices = (0, $6zk1M._)(currentIndices);
            var indexOfIndex = currentIndices.indexOf(index);
            if (indexOfIndex !== -1) newIndices.splice(indexOfIndex, 1);
        }
        if (newIndices.length > 0) setCurrentIndices(newIndices);
        else if (allowUnselected) setCurrentIndices(newIndices);
        else console.warn("toggleSelection failed. Do the values exist in the list?");
    }, [
        allowUnselected,
        currentIndices
    ]);
    var toggleSelection = (0, $eHaBZ.useCallback)(function(param) {
        var index = param.index, value = param.value;
        return function() {
            $c020e53fc27b31fb$var$warnIfBothValueAndIndexAreProvided("toggleSelection", {
                index: index,
                value: value
            });
            if (typeof index !== "undefined") toggleSelectionByIndex(index);
            else if (typeof value !== "undefined") {
                var valueIndex = list.indexOf(value);
                if (valueIndex > -1) toggleSelectionByIndex(valueIndex);
            }
        };
    }, [
        list,
        toggleSelectionByIndex
    ]);
    var matchSelection = (0, $eHaBZ.useCallback)(function(param) {
        var index = param.index, value = param.value;
        $c020e53fc27b31fb$var$warnIfBothValueAndIndexAreProvided("matchSelection", {
            index: index,
            value: value
        });
        if (typeof index !== "undefined") return currentIndices.includes(index);
        else if (typeof value !== "undefined") return currentValues.includes(value);
        return false;
    }, [
        currentIndices,
        currentValues
    ]);
    var controls = {
        matchSelection: matchSelection,
        toggleSelection: toggleSelection,
        updateSelections: updateSelections
    };
    return [
        selection,
        controls
    ];
}
function $c020e53fc27b31fb$var$getLanguageSnapshot() {
    if (typeof navigator !== "undefined") return navigator.language;
    else return null;
}
function $c020e53fc27b31fb$var$getLanguageSubscription(callback) {
    if (typeof window !== "undefined") {
        window.addEventListener("languagechange", callback);
        return function() {
            window.removeEventListener("languagechange", callback);
        };
    }
    return function() {};
}
function $c020e53fc27b31fb$var$getLanguageServerSnapshot() {
    return null;
}
function $c020e53fc27b31fb$export$64fd3a716d6bb70f() {
    return (0, $eHaBZ.useSyncExternalStore)($c020e53fc27b31fb$var$getLanguageSubscription, $c020e53fc27b31fb$var$getLanguageSnapshot, $c020e53fc27b31fb$var$getLanguageServerSnapshot);
}
function $c020e53fc27b31fb$export$1d0625984c38ae85(onClick) {
    var _useState33 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), node = _useState33[0], setNode = _useState33[1];
    var handleEvent = (0, $eHaBZ.useCallback)(function(event) {
        event.preventDefault();
        onClick();
    }, [
        onClick
    ]);
    var freshCallback = $c020e53fc27b31fb$export$b3553245f2c17524(handleEvent);
    (0, $eHaBZ.useEffect)(function() {
        if (node) {
            node.addEventListener("click", freshCallback);
            node.addEventListener("touchend", freshCallback);
            return function() {
                node.removeEventListener("click", freshCallback);
                node.removeEventListener("touchend", freshCallback);
            };
        }
        return $c020e53fc27b31fb$var$noop;
    }, [
        node,
        freshCallback
    ]);
    var ref = (0, $eHaBZ.useCallback)(function(element) {
        if (element) setNode(element);
    }, []);
    return ref;
}
function $c020e53fc27b31fb$export$a95d525b9d8df060(onMouseEnter, onMouseLeave) {
    var _useState34 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), node = _useState34[0], setNode = _useState34[1];
    var handleMouseEnter = (0, $eHaBZ.useCallback)(function(e) {
        onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter(e);
    }, [
        onMouseEnter
    ]);
    var handleMouseLeave = (0, $eHaBZ.useCallback)(function(e) {
        onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(e);
    }, [
        onMouseLeave
    ]);
    var mouseEnterCallback = $c020e53fc27b31fb$export$b3553245f2c17524(handleMouseEnter);
    var mouseLeaveCallback = $c020e53fc27b31fb$export$b3553245f2c17524(handleMouseLeave);
    (0, $eHaBZ.useEffect)(function() {
        if (node) {
            node.addEventListener("mouseenter", mouseEnterCallback);
            node.addEventListener("mouseleave", mouseLeaveCallback);
            return function() {
                node.removeEventListener("mouseenter", mouseEnterCallback);
                node.removeEventListener("mouseleave", mouseLeaveCallback);
            };
        } else return $c020e53fc27b31fb$var$noop;
    }, [
        mouseEnterCallback,
        mouseLeaveCallback,
        node
    ]);
    var ref = function(el) {
        setNode(el);
    };
    return ref;
}
function $c020e53fc27b31fb$var$getSnapshot() {
    if (typeof window === "undefined") return null;
    return navigator.onLine;
}
function $c020e53fc27b31fb$var$subscribe(onStoreChange) {
    if (typeof window !== "undefined") {
        window.addEventListener("online", onStoreChange);
        window.addEventListener("offline", onStoreChange);
        return function() {
            window.removeEventListener("online", onStoreChange);
            window.removeEventListener("offline", onStoreChange);
        };
    } else {
        console.warn("useOnline: window is undefined.");
        return $c020e53fc27b31fb$var$noop;
    }
}
function $c020e53fc27b31fb$export$6feb6ada280bcdab() {
    var isOnline = (0, $2065ab085cb8cea8$exports.useSyncExternalStore)($c020e53fc27b31fb$var$subscribe, $c020e53fc27b31fb$var$getSnapshot);
    return isOnline;
}
var $c020e53fc27b31fb$export$550084c67147f6c4 = function() {
    var _useState35 = (0, $21h22._)((0, $eHaBZ.useState)(typeof window !== "undefined" ? window.screen.orientation : null), 2), orientation = _useState35[0], setOrientation = _useState35[1];
    (0, $eHaBZ.useEffect)(function() {
        var handleOrientationChange = function() {
            setOrientation(window.screen.orientation);
        };
        window.screen.orientation.addEventListener("change", handleOrientationChange);
        return function() {
            window.screen.orientation.removeEventListener("change", handleOrientationChange);
        };
    }, []);
    return orientation;
};
function $c020e53fc27b31fb$export$246005d45236a985(videoRef) {
    var _useState36 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isPiPActive = _useState36[0], setIsPiPActive = _useState36[1];
    var _useState361 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), error = _useState361[0], setError = _useState361[1];
    var _useState362 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), pipWindow = _useState362[0], setPipWindow = _useState362[1];
    var isSupported = (0, $eHaBZ.useCallback)(function() {
        if (!videoRef.current) return false;
        if (!document.pictureInPictureEnabled) return false;
        if (!videoRef.current.requestPictureInPicture) return false;
        if (videoRef.current.disablePictureInPicture) return false;
        return true;
    }, [
        videoRef
    ]);
    var checkPiPActive = (0, $eHaBZ.useCallback)(function() {
        return document.pictureInPictureElement === videoRef.current;
    }, [
        videoRef
    ]);
    var updatePiPState = (0, $eHaBZ.useCallback)(function() {
        setIsPiPActive(checkPiPActive());
    }, [
        checkPiPActive
    ]);
    var enterPiP = (0, $eHaBZ.useCallback)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var err;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isSupported() || !videoRef.current) return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        setError(null);
                        return [
                            4,
                            videoRef.current.requestPictureInPicture()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        setError(err instanceof Error ? err : new Error(String(err)));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        isSupported,
        videoRef
    ]);
    var exitPiP = (0, $eHaBZ.useCallback)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var err;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!document.pictureInPictureElement) return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        setError(null);
                        return [
                            4,
                            document.exitPictureInPicture()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        setError(err instanceof Error ? err : new Error(String(err)));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, []);
    var toggle = (0, $eHaBZ.useCallback)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!checkPiPActive()) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            exitPiP()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            enterPiP()
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        checkPiPActive,
        exitPiP,
        enterPiP
    ]);
    var handleEnterPiP = (0, $eHaBZ.useCallback)(function(event) {
        var pipEvent = event;
        setPipWindow(pipEvent.pictureInPictureWindow);
        setIsPiPActive(true);
    }, []);
    var handleLeavePiP = (0, $eHaBZ.useCallback)(function() {
        setPipWindow(null);
        setIsPiPActive(false);
    }, []);
    (0, $eHaBZ.useEffect)(function() {
        var video = videoRef.current;
        if (!video) return;
        video.addEventListener("enterpictureinpicture", handleEnterPiP);
        video.addEventListener("leavepictureinpicture", handleLeavePiP);
        updatePiPState();
        return function() {
            video.removeEventListener("enterpictureinpicture", handleEnterPiP);
            video.removeEventListener("leavepictureinpicture", handleLeavePiP);
        };
    }, [
        videoRef.current,
        handleEnterPiP,
        handleLeavePiP,
        updatePiPState
    ]);
    return {
        isPiPActive: isPiPActive,
        isSupported: isSupported(),
        error: error,
        pipWindow: pipWindow,
        enterPiP: enterPiP,
        exitPiP: exitPiP,
        toggle: toggle
    };
}
function $c020e53fc27b31fb$export$71b2224f1ce5e08e(ref, handler) {
    var when = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var savedHandler = (0, $eHaBZ.useRef)(handler);
    var memoizedCallback = (0, $eHaBZ.useCallback)(function(event) {
        if (ref.current && !ref.current.contains(event.target)) savedHandler.current(event);
    }, [
        ref
    ]);
    (0, $eHaBZ.useEffect)(function() {
        savedHandler.current = handler;
    });
    (0, $eHaBZ.useEffect)(function() {
        if (when) {
            document.addEventListener("click", memoizedCallback, true);
            document.addEventListener("touchstart", memoizedCallback, true);
            return function() {
                document.removeEventListener("click", memoizedCallback, true);
                document.removeEventListener("touchstart", memoizedCallback, true);
            };
        }
        return $c020e53fc27b31fb$var$noop;
    }, [
        ref,
        handler,
        when,
        memoizedCallback
    ]);
}
function $c020e53fc27b31fb$export$c5f9bba475faecdf(handler) {
    var when = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var _useState37 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), node = _useState37[0], setNode = _useState37[1];
    var savedHandler = (0, $eHaBZ.useRef)(handler);
    var memoizedCallback = (0, $eHaBZ.useCallback)(function(event) {
        if (node && !node.contains(event.target)) savedHandler.current(event);
    }, [
        node
    ]);
    (0, $eHaBZ.useEffect)(function() {
        savedHandler.current = handler;
    });
    var ref = (0, $eHaBZ.useCallback)(function(nodeElement) {
        setNode(nodeElement);
    }, []);
    (0, $eHaBZ.useEffect)(function() {
        if (when) {
            document.addEventListener("click", memoizedCallback, true);
            document.addEventListener("touchstart", memoizedCallback, true);
            return function() {
                document.removeEventListener("click", memoizedCallback, true);
                document.removeEventListener("touchstart", memoizedCallback, true);
            };
        }
        return $c020e53fc27b31fb$var$noop;
    }, [
        when,
        memoizedCallback
    ]);
    return [
        ref
    ];
}
function $c020e53fc27b31fb$export$c3eac79c5e1cdf4e(currentValue) {
    var previousRef = (0, $eHaBZ.useRef)(null);
    var previousRef2 = (0, $eHaBZ.useRef)(null);
    (0, $eHaBZ.useEffect)(function() {
        previousRef2.current = previousRef.current;
        previousRef.current = currentValue;
    }, [
        currentValue
    ]);
    return currentValue === previousRef.current ? previousRef2.current : previousRef.current;
}
function $c020e53fc27b31fb$export$f6f3f74729fdd0b7(currentValue) {
    var previousRef = (0, $eHaBZ.useRef)(null);
    (0, $eHaBZ.useEffect)(function() {
        previousRef.current = currentValue;
    });
    return previousRef.current;
}
function $c020e53fc27b31fb$export$dd6b79aaabe7bc37(asyncFunction) {
    var deps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var _useState38 = (0, $21h22._)((0, $eHaBZ.useState)({
        data: null,
        loading: true,
        error: null
    }), 2), state = _useState38[0], setState = _useState38[1];
    var freshAsyncCallback = $c020e53fc27b31fb$export$b3553245f2c17524(asyncFunction);
    (0, $eHaBZ.useEffect)(function() {
        var fetchData = function fetchData() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                var data, error;
                return (0, $6PS3Z.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                freshAsyncCallback()
                            ];
                        case 1:
                            data = _state.sent();
                            if (isMounted) setState({
                                data: data,
                                loading: false,
                                error: null
                            });
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            if (isMounted) setState({
                                data: null,
                                loading: false,
                                error: error instanceof Error ? error : new Error(String(error))
                            });
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        var isMounted = true;
        fetchData();
        return function() {
            isMounted = false;
        };
    }, [
        freshAsyncCallback
    ].concat((0, $6zk1M._)(deps)));
    return state;
}
function $c020e53fc27b31fb$export$4d9119e556c12833(initialList) {
    var _useState39 = (0, $21h22._)((0, $eHaBZ.useState)((0, $6zk1M._)(initialList)), 2), list = _useState39[0], setList = _useState39[1];
    var enqueue = (0, $eHaBZ.useCallback)(function(item) {
        var newList = (0, $6zk1M._)(list).concat([
            item
        ]);
        setList(newList);
        return newList.length;
    }, [
        list
    ]);
    var dequeue = (0, $eHaBZ.useCallback)(function() {
        if (list.length > 0) {
            var firstItem = list[0];
            setList((0, $6zk1M._)(list.slice(1)));
            return firstItem;
        }
        return void 0;
    }, [
        list
    ]);
    var peek = (0, $eHaBZ.useCallback)(function() {
        if (list.length > 0) return list[0];
        return void 0;
    }, [
        list
    ]);
    var controls = {
        dequeue: dequeue,
        enqueue: enqueue,
        length: list.length,
        peek: peek
    };
    return [
        list,
        controls
    ];
}
function $c020e53fc27b31fb$export$3d0be2420b17e328(callback, isActive) {
    var savedCallback = (0, $eHaBZ.useRef)(null);
    (0, $eHaBZ.useEffect)(function() {
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $eHaBZ.useEffect)(function() {
        var tick = function tick() {
            var _savedCallback_current;
            var timeElapsed = Date.now() - startTime;
            startTime = Date.now();
            loop();
            (_savedCallback_current = savedCallback.current) === null || _savedCallback_current === void 0 ? void 0 : _savedCallback_current.call(savedCallback, timeElapsed);
        };
        var loop = function loop() {
            animationFrame = (0, (/*@__PURE__*/$parcel$interopDefault($cce1e94b03780a93$exports)))(tick);
        };
        var animationFrame;
        var startTime = Date.now();
        if (isActive) {
            startTime = Date.now();
            loop();
            return function() {
                if (animationFrame) (0, (/*@__PURE__*/$parcel$interopDefault($cce1e94b03780a93$exports))).cancel(animationFrame);
            };
        } else return $c020e53fc27b31fb$var$noop;
    }, [
        isActive
    ]);
}
var $c020e53fc27b31fb$var$config5 = {
    box: "content-box"
};
function $c020e53fc27b31fb$export$1e496cef3ab4aa33(callback) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c020e53fc27b31fb$var$config5;
    var box = options.box;
    var _useState40 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), node = _useState40[0], setNode = _useState40[1];
    var callbackRef = (0, $eHaBZ.useRef)(callback);
    (0, $eHaBZ.useEffect)(function() {
        callbackRef.current = callback;
    });
    var handleResizeObserver = (0, $eHaBZ.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _callbackRef_current;
        var _callbackRef_current1;
        (_callbackRef_current1 = callbackRef.current) === null || _callbackRef_current1 === void 0 ? void 0 : (_callbackRef_current = _callbackRef_current1).call.apply(_callbackRef_current, [
            callbackRef
        ].concat((0, $6zk1M._)(args)));
    }, []);
    (0, $eHaBZ.useEffect)(function() {
        if (node) {
            var observer = new ResizeObserver(handleResizeObserver);
            observer.observe(node, {
                box: box
            });
            return function() {
                observer.disconnect();
            };
        }
        return $c020e53fc27b31fb$var$noop;
    }, [
        node,
        handleResizeObserver,
        box
    ]);
    var ref = (0, $eHaBZ.useCallback)(function(node2) {
        setNode(node2);
    }, []);
    return [
        ref
    ];
}
function $c020e53fc27b31fb$export$894a34a32cdbdc06() {
    return ++(0, $eHaBZ.useRef)(0).current;
}
function $c020e53fc27b31fb$export$73e242da76f85109(initialState) {
    var _useState41 = (0, $21h22._)((0, $eHaBZ.useState)(initialState), 2), state = _useState41[0], setState = _useState41[1];
    var getIsMounted = $c020e53fc27b31fb$export$7aa0022395cd4c49();
    var safeSetState = (0, $eHaBZ.useCallback)(function(newState) {
        if (getIsMounted()) setState(newState);
    }, [
        getIsMounted
    ]);
    return [
        state,
        safeSetState
    ];
}
function $c020e53fc27b31fb$export$ab808b17bf61ae66() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options_requestOnMount = options.requestOnMount, requestOnMount = _options_requestOnMount === void 0 ? false : _options_requestOnMount, _options_autoRefresh = options.autoRefresh, autoRefresh = _options_autoRefresh === void 0 ? true : _options_autoRefresh;
    var _useState42 = (0, $21h22._)((0, $eHaBZ.useState)([]), 2), screens = _useState42[0], setScreens = _useState42[1];
    var _useState421 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), currentScreen = _useState421[0], setCurrentScreen = _useState421[1];
    var _useState422 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isLoading = _useState422[0], setIsLoading = _useState422[1];
    var _useState423 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), hasPermission = _useState423[0], setHasPermission = _useState423[1];
    var _useState424 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), error = _useState424[0], setError = _useState424[1];
    var screenDetailsRef = (0, $eHaBZ.useRef)(null);
    var permissionStatusRef = (0, $eHaBZ.useRef)(null);
    var isSupported = (0, $eHaBZ.useMemo)(function() {
        return typeof window !== "undefined" && typeof window.getScreenDetails === "function";
    }, []);
    var primaryScreen = (0, $eHaBZ.useMemo)(function() {
        return screens.find(function(screen) {
            return screen.isPrimary;
        }) || null;
    }, [
        screens
    ]);
    var externalScreens = (0, $eHaBZ.useMemo)(function() {
        return screens.filter(function(screen) {
            return !screen.isPrimary;
        });
    }, [
        screens
    ]);
    var fetchScreenDetails = (0, $eHaBZ.useCallback)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var screenDetails, err, errorMessage;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isSupported) return [
                            2
                        ];
                        setIsLoading(true);
                        setError(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            window.getScreenDetails()
                        ];
                    case 2:
                        screenDetails = _state.sent();
                        screenDetailsRef.current = screenDetails;
                        setScreens(screenDetails.screens);
                        setCurrentScreen(screenDetails.currentScreen);
                        setHasPermission(true);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        errorMessage = err instanceof Error ? err.message : String(err);
                        setError(errorMessage);
                        setHasPermission(false);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        isSupported
    ]);
    var requestPermission = (0, $eHaBZ.useCallback)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var permissionStatus, err, errorMessage;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isSupported) {
                            setError("Screen Details API is not supported");
                            return [
                                2
                            ];
                        }
                        setIsLoading(true);
                        setError(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            navigator.permissions.query({
                                name: "window-management"
                            })
                        ];
                    case 2:
                        permissionStatus = _state.sent();
                        permissionStatusRef.current = permissionStatus;
                        if (permissionStatus.state === "denied") {
                            setError("Permission denied for window-management");
                            setHasPermission(false);
                            setIsLoading(false);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            fetchScreenDetails()
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        err = _state.sent();
                        errorMessage = err instanceof Error ? err.message : String(err);
                        setError(errorMessage);
                        setHasPermission(false);
                        setIsLoading(false);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        isSupported,
        fetchScreenDetails
    ]);
    var refresh = (0, $eHaBZ.useCallback)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var err, errorMessage;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!hasPermission) return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fetchScreenDetails()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        errorMessage = err instanceof Error ? err.message : String(err);
                        setError(errorMessage);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        hasPermission,
        fetchScreenDetails
    ]);
    var handleScreensChange = (0, $eHaBZ.useCallback)(function() {
        if (autoRefresh) refresh();
    }, [
        autoRefresh,
        refresh
    ]);
    var handleCurrentScreenChange = (0, $eHaBZ.useCallback)(function() {
        if (autoRefresh) refresh();
    }, [
        autoRefresh,
        refresh
    ]);
    var handlePermissionChange = (0, $eHaBZ.useCallback)(function() {
        if (permissionStatusRef.current) {
            var newState = permissionStatusRef.current.state;
            if (newState === "denied") {
                setHasPermission(false);
                setScreens([]);
                setCurrentScreen(null);
                setError("Permission denied for window-management");
            } else if (newState === "granted") {
                setHasPermission(true);
                setError(null);
                if (autoRefresh) refresh();
            }
        }
    }, [
        autoRefresh,
        refresh
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (!screenDetailsRef.current) return;
        var screenDetails = screenDetailsRef.current;
        screenDetails.addEventListener("screenschange", handleScreensChange);
        screenDetails.addEventListener("currentscreenchange", handleCurrentScreenChange);
        return function() {
            screenDetails.removeEventListener("screenschange", handleScreensChange);
            screenDetails.removeEventListener("currentscreenchange", handleCurrentScreenChange);
        };
    }, [
        handleScreensChange,
        handleCurrentScreenChange
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (!permissionStatusRef.current) return;
        var permissionStatus = permissionStatusRef.current;
        permissionStatus.addEventListener("change", handlePermissionChange);
        return function() {
            permissionStatus.removeEventListener("change", handlePermissionChange);
        };
    }, [
        handlePermissionChange
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (requestOnMount && isSupported) requestPermission();
    }, [
        requestOnMount,
        isSupported,
        requestPermission
    ]);
    return {
        screens: screens,
        currentScreen: currentScreen,
        primaryScreen: primaryScreen,
        externalScreens: externalScreens,
        isSupported: isSupported,
        isLoading: isLoading,
        hasPermission: hasPermission,
        error: error,
        requestPermission: requestPermission,
        refresh: refresh
    };
}
function $c020e53fc27b31fb$export$e64b2f635402ca43(list) {
    var initialIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var _useState43 = (0, $21h22._)((0, $eHaBZ.useState)(initialIndex), 2), selectedIndex = _useState43[0], setSelectedIndex = _useState43[1];
    var setItem = (0, $eHaBZ.useCallback)(function(item) {
        setSelectedIndex(list.indexOf(item));
    }, [
        list
    ]);
    return {
        index: selectedIndex,
        item: list[selectedIndex],
        setIndex: setSelectedIndex,
        setItem: setItem
    };
}
function $c020e53fc27b31fb$var$warnIfBothValueAndIndexAreProvided2(functionName, object) {
    if (Object.values(object).every(function(value) {
        return typeof value !== "undefined";
    })) console.warn("".concat(functionName, ". Expected either ").concat(Object.keys(object).join(" or "), " to be provided. However all were provided"));
    else if (Object.values(object).every(function(value) {
        return typeof value === "undefined";
    })) console.warn("".concat(functionName, ". ").concat(Object.keys(object).join(" , "), " are all undefined."));
}
function $c020e53fc27b31fb$export$b95089534ab7c1fd() {
    var list = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], initialIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, allowUnselected = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var _useState44 = (0, $21h22._)((0, $eHaBZ.useState)(initialIndex), 2), currentIndex = _useState44[0], setCurrentIndex = _useState44[1];
    var currentValue = list[currentIndex];
    var selection = [
        currentIndex,
        currentValue
    ];
    var updateSelection = (0, $eHaBZ.useCallback)(function(param) {
        var index = param.index, value = param.value;
        return function() {
            $c020e53fc27b31fb$var$warnIfBothValueAndIndexAreProvided2("updateSelection", {
                index: index,
                value: value
            });
            if (typeof index !== "undefined") setCurrentIndex(index);
            else if (typeof value !== "undefined") {
                var valueIndex = list.indexOf(value);
                if (valueIndex > -1) setCurrentIndex(valueIndex);
                else console.warn("updateSelection failed. Does the value ".concat(value, " exist in the list?"));
            }
        };
    }, [
        list
    ]);
    var toggleSelection = (0, $eHaBZ.useCallback)(function(param) {
        var index = param.index, value = param.value;
        return function() {
            $c020e53fc27b31fb$var$warnIfBothValueAndIndexAreProvided2("toggleSelection", {
                index: index,
                value: value
            });
            if (typeof index !== "undefined") {
                if (currentIndex === index) {
                    if (allowUnselected) setCurrentIndex(-1);
                    else console.warn("allowUnselected is false. Cannot unselect item");
                } else setCurrentIndex(index);
            } else if (typeof value !== "undefined") {
                var valueIndex = list.indexOf(value);
                if (valueIndex > -1) {
                    if (currentIndex === valueIndex) {
                        if (allowUnselected) setCurrentIndex(-1);
                        else console.warn("allowUnselected is false. Cannot unselect item");
                    } else setCurrentIndex(valueIndex);
                } else {
                    console.log("as");
                    console.warn("toggleSelection failed. Does the value ".concat(value, " exist in the list?"));
                }
            }
        };
    }, [
        allowUnselected,
        currentIndex,
        list
    ]);
    var matchSelection = (0, $eHaBZ.useCallback)(function(param) {
        var index = param.index, value = param.value;
        $c020e53fc27b31fb$var$warnIfBothValueAndIndexAreProvided2("matchSelection", {
            index: index,
            value: value
        });
        if (typeof index !== "undefined") return index === currentIndex;
        else return value === currentValue;
    }, [
        currentIndex,
        currentValue
    ]);
    var controls = {
        matchSelection: matchSelection,
        toggleSelection: toggleSelection,
        updateSelection: updateSelection
    };
    return [
        selection,
        controls
    ];
}
function $c020e53fc27b31fb$var$getValueFromSessionStorage(key) {
    if (typeof sessionStorage === "undefined") return null;
    var _sessionStorage_getItem;
    var storedValue = (_sessionStorage_getItem = sessionStorage.getItem(key)) !== null && _sessionStorage_getItem !== void 0 ? _sessionStorage_getItem : "null";
    try {
        return JSON.parse(storedValue);
    } catch (error) {
        console.error(error);
    }
    return storedValue;
}
function $c020e53fc27b31fb$var$saveValueToSessionStorage(key, value) {
    if (typeof sessionStorage === "undefined") return null;
    return sessionStorage.setItem(key, JSON.stringify(value));
}
function $c020e53fc27b31fb$var$initialize2(key, initialState) {
    var valueLoadedFromSessionStorage = $c020e53fc27b31fb$var$getValueFromSessionStorage(key);
    if (valueLoadedFromSessionStorage === null) return initialState;
    else return valueLoadedFromSessionStorage;
}
function $c020e53fc27b31fb$export$ab5dd7ac86ae2916(key, initialState) {
    var _useState45 = (0, $21h22._)((0, $eHaBZ.useState)(function() {
        return $c020e53fc27b31fb$var$initialize2(key, initialState);
    }), 2), value = _useState45[0], setValue = _useState45[1];
    var isUpdateFromCrossDocumentListener = (0, $eHaBZ.useRef)(false);
    var isUpdateFromWithinDocumentListener = (0, $eHaBZ.useRef)(false);
    var customEventTypeName = (0, $eHaBZ.useMemo)(function() {
        return "rooks-".concat(key, "-sessionstorage-update");
    }, [
        key
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (!isUpdateFromCrossDocumentListener.current) $c020e53fc27b31fb$var$saveValueToSessionStorage(key, value);
    }, [
        key,
        value
    ]);
    var listenToCrossDocumentStorageEvents = (0, $eHaBZ.useCallback)(function(event) {
        if (event.storageArea === sessionStorage && event.key === key) try {
            isUpdateFromCrossDocumentListener.current = true;
            var _event_newValue;
            var newValue = JSON.parse((_event_newValue = event.newValue) !== null && _event_newValue !== void 0 ? _event_newValue : "null");
            if (value !== newValue) setValue(newValue);
        } catch (error) {
            console.log(error);
        }
    }, [
        key,
        value
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (typeof window !== "undefined") {
            window.addEventListener("storage", listenToCrossDocumentStorageEvents);
            return function() {
                window.removeEventListener("storage", listenToCrossDocumentStorageEvents);
            };
        } else {
            console.warn("[useSessionstorageState] window is undefined.");
            return function() {};
        }
    }, [
        listenToCrossDocumentStorageEvents
    ]);
    var listenToCustomEventWithinDocument = (0, $eHaBZ.useCallback)(function(event) {
        try {
            isUpdateFromWithinDocumentListener.current = true;
            var newValue = event.detail.newValue;
            if (value !== newValue) setValue(newValue);
        } catch (error) {
            console.log(error);
        }
    }, [
        value
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (typeof document !== "undefined") {
            document.addEventListener(customEventTypeName, listenToCustomEventWithinDocument);
            return function() {
                document.removeEventListener(customEventTypeName, listenToCustomEventWithinDocument);
            };
        } else {
            console.warn("[useSessionstorageState] document is undefined.");
            return function() {};
        }
    }, [
        customEventTypeName,
        listenToCustomEventWithinDocument
    ]);
    var broadcastValueWithinDocument = (0, $eHaBZ.useCallback)(function(newValue) {
        if (typeof document !== "undefined") {
            var event = new CustomEvent(customEventTypeName, {
                detail: {
                    newValue: newValue
                }
            });
            document.dispatchEvent(event);
        } else console.warn("[useSessionstorageState] document is undefined.");
    }, [
        customEventTypeName
    ]);
    var set = (0, $eHaBZ.useCallback)(function(newValue) {
        var resolvedNewValue = typeof newValue === "function" ? newValue(value) : newValue;
        isUpdateFromCrossDocumentListener.current = false;
        isUpdateFromWithinDocumentListener.current = false;
        setValue(resolvedNewValue);
        broadcastValueWithinDocument(resolvedNewValue);
    }, [
        broadcastValueWithinDocument,
        value
    ]);
    var remove = (0, $eHaBZ.useCallback)(function() {
        sessionStorage.removeItem(key);
    }, [
        key
    ]);
    return [
        value,
        set,
        remove
    ];
}
function $c020e53fc27b31fb$export$89c35abda4d6d7ba(initialSetValue) {
    var _useState46 = (0, $21h22._)((0, $eHaBZ.useState)(new Set(initialSetValue)), 2), setValue = _useState46[0], setSetValue = _useState46[1];
    var add = (0, $eHaBZ.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _setValue;
        setSetValue(new Set((_setValue = setValue).add.apply(_setValue, (0, $6zk1M._)(args))));
    }, [
        setValue,
        setSetValue
    ]);
    var deleteValue = (0, $eHaBZ.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _newSetValue;
        var newSetValue = new Set(setValue);
        (_newSetValue = newSetValue).delete.apply(_newSetValue, (0, $6zk1M._)(args));
        setSetValue(newSetValue);
    }, [
        setValue,
        setSetValue
    ]);
    var clear = (0, $eHaBZ.useCallback)(function() {
        setSetValue(/* @__PURE__ */ new Set());
    }, [
        setSetValue
    ]);
    var controls = (0, $eHaBZ.useMemo)(function() {
        return {
            add: add,
            delete: deleteValue,
            clear: clear
        };
    }, [
        add,
        deleteValue,
        clear
    ]);
    var returnValue = (0, $eHaBZ.useMemo)(function() {
        return [
            setValue,
            controls
        ];
    }, [
        setValue,
        controls
    ]);
    return returnValue;
}
function $c020e53fc27b31fb$export$d924c858c6da95fa(initialList) {
    var _useState47 = (0, $21h22._)((0, $eHaBZ.useState)((0, $6zk1M._)(initialList)), 2), list = _useState47[0], setList = _useState47[1];
    var length = list.length;
    var listInReverse = (0, $eHaBZ.useMemo)(function() {
        var reverseList = (0, $6zk1M._)(list);
        reverseList.reverse();
        return reverseList;
    }, [
        list
    ]);
    var push = (0, $eHaBZ.useCallback)(function(item) {
        var newList = (0, $6zk1M._)(list).concat([
            item
        ]);
        setList(newList);
        return newList.length;
    }, [
        list
    ]);
    var pop = (0, $eHaBZ.useCallback)(function() {
        if (list.length > 0) {
            var lastItem = list[list.length - 1];
            setList((0, $6zk1M._)(list.slice(0, list.length - 1)));
            return lastItem;
        }
        return void 0;
    }, [
        list
    ]);
    var peek = (0, $eHaBZ.useCallback)(function() {
        if (list.length > 0) return list[list.length - 1];
        return void 0;
    }, [
        list
    ]);
    var clear = function() {
        return setList([]);
    };
    var isEmpty = (0, $eHaBZ.useCallback)(function() {
        return list.length === 0;
    }, [
        list
    ]);
    var controls = {
        clear: clear,
        isEmpty: isEmpty,
        length: length,
        peek: peek,
        pop: pop,
        push: push
    };
    return [
        list,
        controls,
        listInReverse
    ];
}
function $c020e53fc27b31fb$export$57e792e009c800a0(options) {
    var text = options.text, _options_language = options.language, language = _options_language === void 0 ? "en-US" : _options_language, voiceURI = options.voiceURI, _options_onEnd = options.onEnd, onEnd = _options_onEnd === void 0 ? $c020e53fc27b31fb$var$noop : _options_onEnd, _options_volume = options.volume, volume = _options_volume === void 0 ? 1 : _options_volume, _options_pitch = options.pitch, pitch = _options_pitch === void 0 ? 1 : _options_pitch, _options_rate = options.rate, rate = _options_rate === void 0 ? 1 : _options_rate;
    var freshOnEnd = $c020e53fc27b31fb$export$b3553245f2c17524(onEnd);
    var speechRef = (0, $eHaBZ.useRef)(null);
    var _useState48 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isPlaying = _useState48[0], setIsPlaying = _useState48[1];
    (0, $eHaBZ.useEffect)(function() {
        if (speechRef.current && isPlaying) {
            speechRef.current.text = text;
            speechRef.current.lang = language;
            speechRef.current.volume = volume;
            speechRef.current.pitch = pitch;
            speechRef.current.rate = rate;
            if (voiceURI) {
                var voices = window.speechSynthesis.getVoices();
                var selectedVoice = voices.find(function(voice) {
                    return voice.voiceURI === voiceURI;
                });
                if (selectedVoice) speechRef.current.voice = selectedVoice;
            }
        }
    }, [
        text,
        isPlaying,
        language,
        voiceURI,
        volume,
        pitch,
        rate
    ]);
    var start = (0, $eHaBZ.useCallback)(function() {
        if (!("speechSynthesis" in window)) {
            console.error("Web Speech API is not supported in your browser.");
            return;
        }
        if (speechRef.current) window.speechSynthesis.cancel();
        speechRef.current = new SpeechSynthesisUtterance(text);
        speechRef.current.lang = language;
        speechRef.current.volume = volume;
        speechRef.current.pitch = pitch;
        speechRef.current.rate = rate;
        if (voiceURI) {
            var voices = window.speechSynthesis.getVoices();
            var selectedVoice = voices.find(function(voice) {
                return voice.voiceURI === voiceURI;
            });
            if (selectedVoice) speechRef.current.voice = selectedVoice;
        }
        speechRef.current.onstart = function() {
            return setIsPlaying(true);
        };
        speechRef.current.onend = function() {
            setIsPlaying(false);
            freshOnEnd();
        };
        speechRef.current.onerror = function() {
            return setIsPlaying(false);
        };
        window.speechSynthesis.speak(speechRef.current);
    }, [
        text,
        language,
        volume,
        pitch,
        rate,
        voiceURI,
        freshOnEnd
    ]);
    var pause = (0, $eHaBZ.useCallback)(function() {
        if (window.speechSynthesis && isPlaying) {
            window.speechSynthesis.pause();
            setIsPlaying(false);
        }
    }, [
        isPlaying
    ]);
    var resume = (0, $eHaBZ.useCallback)(function() {
        if (window.speechSynthesis && !isPlaying) {
            window.speechSynthesis.resume();
            setIsPlaying(true);
        }
    }, [
        isPlaying
    ]);
    var stop = (0, $eHaBZ.useCallback)(function() {
        if (window.speechSynthesis) {
            window.speechSynthesis.cancel();
            setIsPlaying(false);
        }
    }, []);
    return {
        start: start,
        pause: pause,
        resume: resume,
        stop: stop,
        isPlaying: isPlaying
    };
}
// src/utils/utils.ts
var $c020e53fc27b31fb$var$isFunction = function(value) {
    return typeof value === "function";
};
var $c020e53fc27b31fb$var$isNumber = function(value) {
    return typeof value === "number";
};
var $c020e53fc27b31fb$var$getSplitIndex = function(step, arr) {
    var index = step > 0 ? step - 1 : arr.length + step;
    if (index >= arr.length - 1) index = arr.length - 1;
    if (index < 0) index = 0;
    return index;
};
var $c020e53fc27b31fb$var$split = function(step, targetArr) {
    var index = $c020e53fc27b31fb$var$getSplitIndex(step, targetArr);
    return {
        _current: targetArr[index],
        _before: targetArr.slice(0, index),
        _after: targetArr.slice(index + 1)
    };
};
function $c020e53fc27b31fb$export$cb9753ee02b19404(initialValue) {
    var _useState49 = (0, $21h22._)((0, $eHaBZ.useState)({
        present: initialValue,
        past: [],
        future: []
    }), 2), history = _useState49[0], setHistory = _useState49[1];
    var present = history.present, past = history.past, future = history.future;
    var initialValueRef = (0, $eHaBZ.useRef)(initialValue);
    var reset = (0, $eHaBZ.useCallback)(function(resetInitialValue) {
        var newInitialValue = resetInitialValue !== null && resetInitialValue !== void 0 ? resetInitialValue : initialValueRef.current;
        initialValueRef.current = newInitialValue;
        setHistory({
            present: newInitialValue,
            future: [],
            past: []
        });
    }, [
        initialValueRef,
        setHistory
    ]);
    var updateValue = (0, $eHaBZ.useCallback)(function(val, options) {
        setHistory(function(currentHistory) {
            var past2 = currentHistory.past, present2 = currentHistory.present;
            var _ref = options || {}, _ref_overwriteLastEntry = _ref.overwriteLastEntry, overwriteLastEntry = _ref_overwriteLastEntry === void 0 ? false : _ref_overwriteLastEntry;
            var newValue = void 0;
            if ($c020e53fc27b31fb$var$isFunction(val)) newValue = val(present2);
            else newValue = val;
            if (overwriteLastEntry) return {
                present: newValue,
                past: past2,
                future: []
            };
            else return {
                present: newValue,
                future: [],
                past: (0, $6zk1M._)(past2).concat([
                    present2
                ])
            };
        });
    }, []);
    var goForwardInternal = (0, $eHaBZ.useCallback)(function() {
        var step = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
        setHistory(function(currentHistory) {
            var future2 = currentHistory.future, past2 = currentHistory.past, present2 = currentHistory.present;
            if (future2.length === 0) return currentHistory;
            var _split = $c020e53fc27b31fb$var$split(step, future2), _before = _split._before, _current = _split._current, _after = _split._after;
            return {
                past: (0, $6zk1M._)(past2).concat([
                    present2
                ], (0, $6zk1M._)(_before)),
                present: _current,
                future: _after
            };
        });
    }, []);
    var goBackwardInternal = (0, $eHaBZ.useCallback)(function() {
        var step = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : -1;
        setHistory(function(currentHistory) {
            var future2 = currentHistory.future, past2 = currentHistory.past, present2 = currentHistory.present;
            if (past2.length === 0) return currentHistory;
            var _split = $c020e53fc27b31fb$var$split(step, past2), _before = _split._before, _current = _split._current, _after = _split._after;
            return {
                past: _before,
                present: _current,
                future: (0, $6zk1M._)(_after).concat([
                    present2
                ], (0, $6zk1M._)(future2))
            };
        });
    }, []);
    var go = (0, $eHaBZ.useCallback)(function(step) {
        var stepNum = $c020e53fc27b31fb$var$isNumber(step) ? step : Number(step);
        if (stepNum === 0) return;
        if (stepNum > 0) return goForwardInternal(stepNum);
        goBackwardInternal(stepNum);
    }, [
        goBackwardInternal,
        goForwardInternal
    ]);
    var back = (0, $eHaBZ.useCallback)(function() {
        go(-1);
    }, [
        go
    ]);
    var forward = (0, $eHaBZ.useCallback)(function() {
        go(1);
    }, [
        go
    ]);
    var canUndo = (0, $eHaBZ.useMemo)(function() {
        return past.length > 0;
    }, [
        past.length
    ]);
    var canRedo = (0, $eHaBZ.useMemo)(function() {
        return future.length > 0;
    }, [
        future.length
    ]);
    var controls = (0, $eHaBZ.useMemo)(function() {
        return {
            backLength: past.length,
            forwardLength: future.length,
            go: go,
            back: back,
            forward: forward,
            reset: reset,
            undo: back,
            redo: forward,
            canUndo: canUndo,
            canRedo: canRedo
        };
    }, [
        back,
        canRedo,
        canUndo,
        forward,
        future.length,
        go,
        past.length,
        reset
    ]);
    var returnValue = (0, $eHaBZ.useMemo)(function() {
        return [
            present,
            updateValue,
            controls
        ];
    }, [
        controls,
        present,
        updateValue
    ]);
    return returnValue;
}
function $c020e53fc27b31fb$var$createFetchPromise(url) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return new Promise(function(resolve, reject) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var response, errorMessage, httpError, result, err;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fetch(url, (0, $9Jpjh._)((0, $lvTkn._)({}, options), {
                                signal: new AbortController().signal
                            }))
                        ];
                    case 1:
                        response = _state.sent();
                        if (!response.ok) {
                            errorMessage = "HTTP ".concat(response.status, ": ").concat(response.statusText);
                            httpError = new Error(errorMessage);
                            httpError.status = response.status;
                            httpError.statusText = response.statusText;
                            throw httpError;
                        }
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        result = _state.sent();
                        resolve(result);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        reject(err instanceof Error ? err : new Error(String(err)));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    });
}
function $c020e53fc27b31fb$export$d852f5f778460fa4(url) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _useState50 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), data = _useState50[0], setData = _useState50[1];
    var _useState501 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), loading = _useState501[0], setLoading = _useState501[1];
    var _useState502 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), error = _useState502[0], setError = _useState502[1];
    var mountedRef = (0, $eHaBZ.useRef)(true);
    var fetchData = (0, $eHaBZ.useCallback)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var _options_onFetch, result, _options_onSuccess, err, error2, _options_onError;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!mountedRef.current) return [
                            2
                        ];
                        setLoading(true);
                        setError(null);
                        (_options_onFetch = options.onFetch) === null || _options_onFetch === void 0 ? void 0 : _options_onFetch.call(options);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            $c020e53fc27b31fb$var$createFetchPromise(url, options)
                        ];
                    case 2:
                        result = _state.sent();
                        if (mountedRef.current) {
                            ;
                            setData(result);
                            (_options_onSuccess = options.onSuccess) === null || _options_onSuccess === void 0 ? void 0 : _options_onSuccess.call(options, result);
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        error2 = err instanceof Error ? err : new Error(String(err));
                        if (mountedRef.current) {
                            ;
                            setError(error2);
                            (_options_onError = options.onError) === null || _options_onError === void 0 ? void 0 : _options_onError.call(options, error2);
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        if (mountedRef.current) setLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        url,
        options
    ]);
    (0, $eHaBZ.useEffect)(function() {
        return function() {
            mountedRef.current = false;
        };
    }, []);
    return {
        data: data,
        loading: loading,
        error: error,
        startFetch: fetchData
    };
}
function $c020e53fc27b31fb$export$8b7b9481d6186f21(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 300;
    var _useState51 = (0, $21h22._)((0, $eHaBZ.useState)(true), 2), ready = _useState51[0], setReady = _useState51[1];
    var timerRef = (0, $eHaBZ.useRef)(void 0);
    var throttledFunction = (0, $eHaBZ.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!ready) return;
        setReady(false);
        callback.apply(void 0, (0, $6zk1M._)(args));
    }, [
        ready,
        callback
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (!ready) {
            timerRef.current = window.setTimeout(function() {
                setReady(true);
            }, timeout);
            return function() {
                return window.clearTimeout(timerRef.current);
            };
        }
        return $c020e53fc27b31fb$var$noop;
    }, [
        ready,
        timeout
    ]);
    return [
        throttledFunction,
        ready
    ];
}
var $c020e53fc27b31fb$var$defaultToggleFunction = function(value) {
    return !value;
};
function $c020e53fc27b31fb$export$cbe85ee05b554577() {
    var initialValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, toggleFunction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c020e53fc27b31fb$var$defaultToggleFunction;
    return (0, $eHaBZ.useReducer)(toggleFunction, initialValue);
}
var $c020e53fc27b31fb$var$defaultOptions5 = {
    maxSize: 100
};
var $c020e53fc27b31fb$export$99d290bffb3da24d = function(defaultValue, options) {
    var maxSize = (0, $eHaBZ.useMemo)(function() {
        return (0, $lvTkn._)({}, $c020e53fc27b31fb$var$defaultOptions5, options);
    }, [
        options
    ]).maxSize;
    var _useState52 = (0, $21h22._)((0, $eHaBZ.useState)([
        defaultValue
    ]), 2), value = _useState52[0], setValue = _useState52[1];
    var push = (0, $eHaBZ.useCallback)(function(argument) {
        return setValue(function(current) {
            var restValues = current.length >= maxSize ? current.slice(0, maxSize) : current;
            if (typeof argument === "function") return [
                argument(current[0])
            ].concat((0, $6zk1M._)(restValues));
            else return [
                argument
            ].concat((0, $6zk1M._)(restValues));
        });
    }, [
        maxSize
    ]);
    var undo = (0, $eHaBZ.useCallback)(function() {
        setValue(function(current) {
            if (current.length === 1) return current;
            var _current = (0, $ggKxj._)(current), values = _current.slice(1);
            return values;
        });
    }, []);
    var returnValue = (0, $eHaBZ.useMemo)(function() {
        return [
            value[0],
            push,
            undo
        ];
    }, [
        push,
        undo,
        value
    ]);
    return returnValue;
};
function $c020e53fc27b31fb$var$isFunctionInitializer(functionToCheck) {
    return typeof functionToCheck === "function";
}
function $c020e53fc27b31fb$export$35dec198dbda4c09(initialState, options) {
    var _useState53 = (0, $21h22._)((0, $eHaBZ.useState)(initialState), 2), state = _useState53[0], _setState = _useState53[1];
    var _useState531 = (0, $21h22._)((0, $eHaBZ.useState)([]), 2), past = _useState531[0], setPast = _useState531[1];
    var _useState532 = (0, $21h22._)((0, $eHaBZ.useState)([]), 2), future = _useState532[0], setFuture = _useState532[1];
    var _options_maxDepth;
    var maxDepth = (_options_maxDepth = options === null || options === void 0 ? void 0 : options.maxDepth) !== null && _options_maxDepth !== void 0 ? _options_maxDepth : 100;
    var undo = (0, $eHaBZ.useCallback)(function() {
        setPast(function(pastStates) {
            var newPast = (0, $6zk1M._)(pastStates);
            var previousState = newPast.pop();
            if (typeof previousState !== "undefined") {
                setFuture(function(futureStates) {
                    return [
                        state
                    ].concat((0, $6zk1M._)(futureStates));
                });
                _setState(previousState);
            }
            return newPast;
        });
    }, [
        state
    ]);
    var redo = (0, $eHaBZ.useCallback)(function() {
        setFuture(function(futureStates) {
            var newFuture = (0, $6zk1M._)(futureStates);
            var nextState = newFuture.shift();
            if (typeof nextState !== "undefined") {
                setPast(function(pastStates) {
                    return (0, $6zk1M._)(pastStates).concat([
                        state
                    ]);
                });
                _setState(nextState);
            }
            return newFuture;
        });
    }, [
        state
    ]);
    var canUndo = (0, $eHaBZ.useCallback)(function() {
        return past.length > 0;
    }, [
        past
    ]);
    var canRedo = (0, $eHaBZ.useCallback)(function() {
        return future.length > 0;
    }, [
        future
    ]);
    var isUndoPossible = (0, $eHaBZ.useMemo)(function() {
        return past.length > 0;
    }, [
        past
    ]);
    var isRedoPossible = (0, $eHaBZ.useMemo)(function() {
        return future.length > 0;
    }, [
        future
    ]);
    var setState = (0, $eHaBZ.useCallback)(function(value) {
        _setState(function(prevState) {
            var nextState = $c020e53fc27b31fb$var$isFunctionInitializer(value) ? value(prevState) : value;
            setPast(function(pastStates) {
                var newPast = (0, $6zk1M._)(pastStates).concat([
                    prevState
                ]);
                if (newPast.length > maxDepth) newPast.shift();
                return newPast;
            });
            setFuture([]);
            return nextState;
        });
    }, [
        maxDepth
    ]);
    var clearUndoStack = (0, $eHaBZ.useCallback)(function() {
        setPast([]);
    }, []);
    var clearRedoStack = (0, $eHaBZ.useCallback)(function() {
        setFuture([]);
    }, []);
    var clearAll = (0, $eHaBZ.useCallback)(function() {
        setPast([]);
        setFuture([]);
    }, []);
    var controls = (0, $eHaBZ.useMemo)(function() {
        return {
            undo: undo,
            redo: redo,
            canUndo: canUndo,
            canRedo: canRedo,
            clearUndoStack: clearUndoStack,
            clearRedoStack: clearRedoStack,
            clearAll: clearAll,
            isUndoPossible: isUndoPossible,
            isRedoPossible: isRedoPossible
        };
    }, [
        undo,
        redo,
        canUndo,
        canRedo,
        clearUndoStack,
        clearRedoStack,
        clearAll,
        isUndoPossible,
        isRedoPossible
    ]);
    return [
        state,
        setState,
        controls
    ];
}
function $c020e53fc27b31fb$export$165ce7a5158a386d(param) {
    var isEnabled = param.isEnabled, pattern = param.pattern;
    (0, $eHaBZ.useEffect)(function() {
        if (!("vibrate" in navigator) || typeof navigator.vibrate !== "function") {
            console.warn("Vibration API not supported by the current browser");
            return;
        }
        if (isEnabled) navigator.vibrate(pattern);
        else navigator.vibrate(0);
        return function() {
            navigator.vibrate(0);
        };
    }, [
        isEnabled,
        pattern
    ]);
}
var $c020e53fc27b31fb$export$5269023cd97c8c79 = function() {
    var videoRef = (0, $eHaBZ.useRef)(null);
    var _useState54 = (0, $21h22._)((0, $eHaBZ.useState)({
        currentTime: 0,
        duration: 0,
        isPaused: true,
        isMuted: false,
        volume: 1
    }), 2), state = _useState54[0], setState = _useState54[1];
    var controls = {
        play: function() {
            if (videoRef.current) {
                videoRef.current.play();
                setState((0, $9Jpjh._)((0, $lvTkn._)({}, state), {
                    isPaused: false
                }));
            }
        },
        pause: function() {
            if (videoRef.current) {
                videoRef.current.pause();
                setState((0, $9Jpjh._)((0, $lvTkn._)({}, state), {
                    isPaused: true
                }));
            }
        },
        toggleMute: function() {
            if (videoRef.current) {
                videoRef.current.muted = !videoRef.current.muted;
                setState((0, $9Jpjh._)((0, $lvTkn._)({}, state), {
                    isMuted: videoRef.current.muted
                }));
            }
        },
        setVolume: function(volume) {
            if (videoRef.current) {
                videoRef.current.volume = volume;
                setState((0, $9Jpjh._)((0, $lvTkn._)({}, state), {
                    volume: volume
                }));
            }
        },
        setCurrentTime: function(time) {
            if (videoRef.current) {
                videoRef.current.currentTime = time;
                setState((0, $9Jpjh._)((0, $lvTkn._)({}, state), {
                    currentTime: time
                }));
            }
        },
        fastForward: function(seconds) {
            if (videoRef.current) {
                videoRef.current.currentTime += seconds;
                setState((0, $9Jpjh._)((0, $lvTkn._)({}, state), {
                    currentTime: videoRef.current.currentTime
                }));
            }
        },
        rewind: function(seconds) {
            if (videoRef.current) {
                videoRef.current.currentTime -= seconds;
                setState((0, $9Jpjh._)((0, $lvTkn._)({}, state), {
                    currentTime: videoRef.current.currentTime
                }));
            }
        },
        toggleFullScreen: function() {
            if (videoRef.current) {
                if (document.fullscreenElement) document.exitFullscreen();
                else videoRef.current.requestFullscreen();
            }
        }
    };
    (0, $eHaBZ.useEffect)(function() {
        var video = videoRef.current;
        var handleTimeUpdate = function() {
            setState(function(prevState) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prevState), {
                    currentTime: video.currentTime
                });
            });
        };
        var handleDurationChange = function() {
            setState(function(prevState) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prevState), {
                    duration: video.duration
                });
            });
        };
        var handlePause = function() {
            setState(function(prevState) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prevState), {
                    isPaused: true
                });
            });
        };
        var handlePlay = function() {
            setState(function(prevState) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prevState), {
                    isPaused: false
                });
            });
        };
        if (video) {
            video.addEventListener("timeupdate", handleTimeUpdate);
            video.addEventListener("durationchange", handleDurationChange);
            video.addEventListener("pause", handlePause);
            video.addEventListener("play", handlePlay);
        }
        return function() {
            if (video) {
                video.removeEventListener("timeupdate", handleTimeUpdate);
                video.removeEventListener("durationchange", handleDurationChange);
                video.removeEventListener("pause", handlePause);
                video.removeEventListener("play", handlePlay);
            }
        };
    }, [
        videoRef
    ]);
    return [
        videoRef,
        state,
        controls
    ];
};
function $c020e53fc27b31fb$export$cb3ad10de185e7a8(resourceName) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (typeof resourceName !== "string") throw new Error("Resource name must be a string");
    var _options_periodicCheck = options.periodicCheck, periodicCheck = _options_periodicCheck === void 0 ? false : _options_periodicCheck, _options_checkInterval = options.checkInterval, checkInterval = _options_checkInterval === void 0 ? 1e3 : _options_checkInterval;
    var isSupported = (0, $eHaBZ.useMemo)(function() {
        return typeof navigator !== "undefined" && navigator.locks !== void 0 && typeof navigator.locks.request === "function";
    }, []);
    var _useState55 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isLocked = _useState55[0], setIsLocked = _useState55[1];
    var _useState551 = (0, $21h22._)((0, $eHaBZ.useState)(0), 2), waitingCount = _useState551[0], setWaitingCount = _useState551[1];
    var _useState552 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), error = _useState552[0], setError = _useState552[1];
    var abortControllerRef = (0, $eHaBZ.useRef)(null);
    var periodicCheckTimeoutRef = (0, $eHaBZ.useRef)(void 0);
    var setErrorState = (0, $eHaBZ.useCallback)(function(err) {
        setError(err);
    }, []);
    var clearError = (0, $eHaBZ.useCallback)(function() {
        setError(null);
    }, []);
    var query = (0, $eHaBZ.useCallback)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var _$err, _result_held, _result_pending, result, resourceLocks, pendingLocks, err, error2;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isSupported) {
                            _$err = new Error("Web Locks API is not supported");
                            setErrorState(_$err);
                            throw _$err;
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            navigator.locks.query()
                        ];
                    case 2:
                        result = _state.sent();
                        resourceLocks = ((_result_held = result.held) === null || _result_held === void 0 ? void 0 : _result_held.filter(function(lock) {
                            return lock.name === resourceName;
                        })) || [];
                        pendingLocks = ((_result_pending = result.pending) === null || _result_pending === void 0 ? void 0 : _result_pending.filter(function(lock) {
                            return lock.name === resourceName;
                        })) || [];
                        setIsLocked(resourceLocks.length > 0);
                        setWaitingCount(pendingLocks.length);
                        clearError();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        err = _state.sent();
                        error2 = err instanceof Error ? err : new Error("Query failed");
                        setErrorState(error2);
                        throw error2;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        isSupported,
        resourceName,
        setErrorState,
        clearError
    ]);
    var acquire = (0, $eHaBZ.useCallback)(function(callback, lockOptions) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var _$err, controller, finalOptions, result, err, error2;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isSupported) {
                            _$err = new Error("Web Locks API is not supported");
                            setErrorState(_$err);
                            throw _$err;
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        setIsLocked(true);
                        clearError();
                        controller = null;
                        if (!(lockOptions === null || lockOptions === void 0 ? void 0 : lockOptions.signal) && !(lockOptions === null || lockOptions === void 0 ? void 0 : lockOptions.ifAvailable)) {
                            controller = new AbortController();
                            abortControllerRef.current = controller;
                        }
                        finalOptions = (0, $lvTkn._)({}, lockOptions);
                        if (!(lockOptions === null || lockOptions === void 0 ? void 0 : lockOptions.ifAvailable) && !(lockOptions === null || lockOptions === void 0 ? void 0 : lockOptions.signal) && controller) finalOptions.signal = controller.signal;
                        else if (lockOptions === null || lockOptions === void 0 ? void 0 : lockOptions.signal) finalOptions.signal = lockOptions.signal;
                        return [
                            4,
                            navigator.locks.request(resourceName, finalOptions, function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
                                    var err, error2;
                                    return (0, $6PS3Z.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _state.trys.push([
                                                    0,
                                                    2,
                                                    ,
                                                    3
                                                ]);
                                                return [
                                                    4,
                                                    callback()
                                                ];
                                            case 1:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                            case 2:
                                                err = _state.sent();
                                                error2 = err instanceof Error ? err : new Error("Callback failed");
                                                setErrorState(error2);
                                                throw error2;
                                            case 3:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        err = _state.sent();
                        error2 = err instanceof Error ? err : new Error("Lock acquisition failed");
                        setErrorState(error2);
                        throw error2;
                    case 4:
                        setIsLocked(false);
                        abortControllerRef.current = null;
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        isSupported,
        resourceName,
        setErrorState,
        clearError
    ]);
    var release = (0, $eHaBZ.useCallback)(function() {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
            abortControllerRef.current = null;
        }
    }, []);
    (0, $eHaBZ.useEffect)(function() {
        if (!isSupported) return;
        query().catch(function() {});
        if (periodicCheck) {
            var setupPeriodicCheck = function() {
                periodicCheckTimeoutRef.current = window.setTimeout(function() {
                    query().catch(function() {}).finally(function() {
                        setupPeriodicCheck();
                    });
                }, checkInterval);
            };
            setupPeriodicCheck();
        }
        return function() {
            if (periodicCheckTimeoutRef.current) {
                window.clearTimeout(periodicCheckTimeoutRef.current);
                periodicCheckTimeoutRef.current = void 0;
            }
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
                abortControllerRef.current = null;
            }
        };
    }, [
        isSupported,
        resourceName,
        periodicCheck,
        checkInterval,
        query
    ]);
    return {
        isSupported: isSupported,
        isLocked: isLocked,
        waitingCount: waitingCount,
        error: error,
        resourceName: resourceName,
        acquire: acquire,
        release: release,
        query: query
    };
}
function $c020e53fc27b31fb$export$d610da56a90dcd8d(componentName, currentProps) {
    var enableLogging = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var previousProps = (0, $eHaBZ.useRef)({});
    $c020e53fc27b31fb$export$e34ed88fef4dc107(function() {
        if (previousProps.current && enableLogging) {
            var combinedKeys = Object.keys((0, $lvTkn._)({}, previousProps.current, currentProps));
            var changedProps = {};
            combinedKeys.forEach(function(key) {
                if (!Object.is(previousProps.current[key], currentProps[key])) changedProps[key] = {
                    from: previousProps.current[key],
                    to: currentProps[key]
                };
            });
            if (Object.keys(changedProps).length) console.log("[why-did-you-update]", componentName, changedProps);
        }
    }, [
        currentProps,
        componentName,
        enableLogging
    ]);
    (0, $eHaBZ.useEffect)(function() {
        previousProps.current = currentProps;
    });
}
// src/hooks/useWindowEventListener.ts
function $c020e53fc27b31fb$export$8efa3c5b6bec5fbd(eventName, callback) {
    var listenerOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, isLayoutEffect = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    $c020e53fc27b31fb$var$useGlobalObjectEventListener($parcel$global.window, eventName, callback, listenerOptions, true, isLayoutEffect);
}
function $c020e53fc27b31fb$var$computeScrollPosition() {
    if (typeof window === "undefined") return {
        scrollX: 0,
        scrollY: 0
    };
    else return {
        scrollX: window.scrollX || window.pageXOffset,
        scrollY: window.scrollY || window.pageYOffset
    };
}
function $c020e53fc27b31fb$export$46be7d46e2475cd6() {
    var _useState56 = (0, $21h22._)((0, $eHaBZ.useState)($c020e53fc27b31fb$var$computeScrollPosition), 2), scrollPosition = _useState56[0], setScrollPosition = _useState56[1];
    $c020e53fc27b31fb$export$f2fb712044277d5e(function() {
        setScrollPosition($c020e53fc27b31fb$var$computeScrollPosition());
    }, true, true);
    $c020e53fc27b31fb$export$61171a90a6148cf5(function() {
        setScrollPosition($c020e53fc27b31fb$var$computeScrollPosition());
    }, true, true);
    return scrollPosition;
}
var $c020e53fc27b31fb$var$nullDimensions = {
    innerHeight: null,
    innerWidth: null,
    outerHeight: null,
    outerWidth: null
};
function $c020e53fc27b31fb$var$getDimensions() {
    return {
        innerHeight: window.innerHeight,
        innerWidth: window.innerWidth,
        outerHeight: window.outerHeight,
        outerWidth: window.outerWidth
    };
}
function $c020e53fc27b31fb$export$42c02f33970a2afa() {
    var _useState57 = (0, $21h22._)((0, $eHaBZ.useState)(function() {
        if (typeof window === "undefined") return $c020e53fc27b31fb$var$nullDimensions;
        else return $c020e53fc27b31fb$var$getDimensions();
    }), 2), windowSize = _useState57[0], setWindowSize = _useState57[1];
    $c020e53fc27b31fb$export$363c9f3eb56bbdbe(function() {
        if (typeof window === "undefined") return function() {};
        else {
            var handleResize2 = function handleResize2() {
                setWindowSize($c020e53fc27b31fb$var$getDimensions());
            };
            var handleResize = handleResize2;
            window.addEventListener("resize", handleResize2);
            return function() {
                window.removeEventListener("resize", handleResize2);
            };
        }
    }, []);
    return windowSize;
}
function $c020e53fc27b31fb$var$isFocusedElementEditable() {
    var activeElement = document.activeElement, body = document.body;
    if (!activeElement) return false;
    if (activeElement === body) return false;
    var tag = activeElement.tagName;
    if (tag === "INPUT" || tag === "TEXTAREA") return true;
    return activeElement.hasAttribute("contenteditable");
}
function $c020e53fc27b31fb$var$isAllowedKey(event, options) {
    if (event.metaKey || event.ctrlKey || event.altKey) return false;
    var key = event.key;
    if (options.includeAZ && /^[a-zA-Z]$/.test(key)) return true;
    if (options.includeNumbers && /^[0-9]$/.test(key)) return true;
    return false;
}
function $c020e53fc27b31fb$export$906b9e7f6c564e10(callback, options) {
    var opts = (0, $lvTkn._)({
        includeAZ: true,
        includeNumbers: false
    }, options);
    var freshCallback = $c020e53fc27b31fb$export$699327ecb1dd6b0d(callback);
    var handler = (0, $eHaBZ.useCallback)(function(event) {
        if (!$c020e53fc27b31fb$var$isFocusedElementEditable() && $c020e53fc27b31fb$var$isAllowedKey(event, opts)) freshCallback(event);
    }, [
        freshCallback,
        opts.includeAZ,
        opts.includeNumbers
    ]);
    $c020e53fc27b31fb$export$363c9f3eb56bbdbe(function() {
        document.addEventListener("keydown", handler);
        return function() {
            document.removeEventListener("keydown", handler);
        };
    }, [
        handler
    ]);
}





function $ecbfc97fac1903d9$export$2e2bcd8739ae039(param) {
    var setTitle = param.setTitle;
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).INITIAL), 2), state = _useState[0], setState = _useState[1];
    var _useState1 = (0, $21h22._)((0, $eHaBZ.useState)(''), 2), hashedPassword = _useState1[0], setHashedPassword = _useState1[1];
    var _useState2 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), error = _useState2[0], setError = _useState2[1];
    var passwordEntry = (0, $c020e53fc27b31fb$export$1e36b9f257eee5fa)('');
    var navigate = (0, $5XYIU.useNavigate)();
    var submit = (0, $eHaBZ.useCallback)(function(event) {
        event.preventDefault();
        setState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING);
        (0, $5be8e377f991f791$export$708be5cd94908894)(passwordEntry.value.trim()).then(function(hashedPassword) {
            setHashedPassword(hashedPassword);
            setState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
        }).catch(function(error) {
            if (error instanceof (0, $0d06257c362dc1a1$export$65bd6083489bd8bb) && error.response.status === 403) {
                navigate('/sign/in', {
                    state: {
                        error: "Generating a new password hash requires being logged in or not setting \u201Cpassword\u201D in selfoss configuration.",
                        returnLocation: '/password'
                    }
                });
                return;
            }
            setError(error);
            setState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).FAILURE);
        });
    }, [
        navigate,
        passwordEntry.value
    ]);
    (0, $eHaBZ.useEffect)(function() {
        setTitle('selfoss password hash generator');
        return function() {
            setTitle(null);
        };
    }, [
        setTitle
    ]);
    var message = state === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("p", {
        className: "error",
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("label", {
            children: [
                "Generated Password (insert this into config.ini):",
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                    type: "text",
                    value: hashedPassword,
                    readOnly: true
                })
            ]
        })
    }) : state === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).FAILURE ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("p", {
        className: "error",
        children: [
            "Unexpected happened.",
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("details", {
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("pre", {
                    children: [
                        "$",
                        JSON.stringify(error)
                    ]
                })
            })
        ]
    }) : null;
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("form", {
        action: "",
        method: "post",
        onSubmit: submit,
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", {
            id: "login",
            children: [
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("h1", {
                        children: "hash generator"
                    })
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                            htmlFor: "password",
                            children: "Password:"
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", (0, $lvTkn._)({
                            type: "password",
                            name: "password",
                            autoComplete: "new-password",
                            accessKey: "p"
                        }, passwordEntry))
                    ]
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                    className: "message-container",
                    "aria-live": "assertive",
                    children: message
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                            className: "button",
                            type: "submit",
                            value: state === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING ? "Hashing password\u2026" : 'Compute hash',
                            accessKey: "g",
                            disabled: state === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING
                        })
                    ]
                })
            ]
        })
    });
}
$ecbfc97fac1903d9$export$2e2bcd8739ae039.propTypes = {
    setTitle: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};



var $21h22 = parcelRequire("21h22");


var $eHaBZ = parcelRequire("eHaBZ");



var $5XYIU = parcelRequire("5XYIU");



function $f343fb504b01a581$export$2e2bcd8739ae039(param) {
    var setTitle = param.setTitle;
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).INITIAL), 2), state = _useState[0], setState = _useState[1];
    var _useState1 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), message = _useState1[0], setMessage = _useState1[1];
    var fileEntry = (0, $eHaBZ.useRef)();
    var navigate = (0, $5XYIU.useNavigate)();
    var submit = (0, $eHaBZ.useCallback)(function(event) {
        event.preventDefault();
        setState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING);
        var file = fileEntry.current.files[0];
        (0, $5be8e377f991f791$export$b3b4cde15a96b715)(file).then(function(param) {
            var response = param.response, data = param.data;
            var messages = data.messages;
            if (response.status === 200) {
                setState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
                setMessage(/*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("p", {
                    className: "msg success",
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("ul", {
                            children: messages.map(function(msg, i) {
                                return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                                    children: msg
                                }, i);
                            })
                        }),
                        "You might want to",
                        ' ',
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("a", {
                            href: "update",
                            children: "update now"
                        }),
                        " or",
                        ' ',
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $5XYIU.Link), {
                            to: "/",
                            children: "view your feeds"
                        }),
                        "."
                    ]
                }));
            } else if (response.status === 202) {
                setState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).FAILURE);
                setMessage(/*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("p", {
                    className: "msg error",
                    children: [
                        "The following feeds could not be imported:",
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("ul", {
                            children: messages.map(function(msg, i) {
                                return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                                    children: msg
                                }, i);
                            })
                        })
                    ]
                }));
            } else if (response.status === 400) {
                setState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).FAILURE);
                setMessage(/*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("p", {
                    className: "msg error",
                    children: [
                        "There was a problem importing your OPML file:",
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("ul", {
                            children: messages.map(function(msg, i) {
                                return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                                    children: msg
                                }, i);
                            })
                        })
                    ]
                }));
            } else throw new (0, $0d06257c362dc1a1$export$4511c7da58e2d9c2)("OPML import handler received status ".concat(response.status, ". This should not happen."));
        }).catch(function(error) {
            if (error instanceof (0, $0d06257c362dc1a1$export$65bd6083489bd8bb) && error.response.status === 403) {
                navigate('/sign/in', {
                    state: {
                        error: "Importing OPML file requires being logged in or not setting \u201Cpassword\u201D in selfoss configuration.",
                        returnLocation: '/opml'
                    }
                });
                return;
            } else {
                setState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).FAILURE);
                setMessage(/*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                    className: "msg error",
                    children: [
                        "Unexpected error occurred.",
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("details", {
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("pre", {
                                children: error.message
                            })
                        })
                    ]
                }));
            }
        });
    }, [
        navigate
    ]);
    (0, $eHaBZ.useEffect)(function() {
        setTitle('selfoss OPML importer');
        return function() {
            setTitle(null);
        };
    }, [
        setTitle
    ]);
    var isOnline = (0, $c020e53fc27b31fb$export$6feb6ada280bcdab)();
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("form", {
        action: "",
        method: "post",
        encType: "multipart/form-data",
        onSubmit: submit,
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", {
            id: "opml",
            children: [
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("h1", {
                        children: "Upload an OPML File"
                    })
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("p", {
                        children: "Coming from a different RSS Reader? Export your subscriptions to an OPML file and upload it here. OPML export is usually located somewhere in settings, consult the reader\u2019s manual."
                    })
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    className: "message-container",
                    "aria-live": "assertive",
                    children: [
                        !isOnline && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                            className: "msg error",
                            children: "OPML import requires an internet connection. Please reconnect before proceeding."
                        }),
                        message
                    ]
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    className: "center",
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                            htmlFor: "opml",
                            children: "Opml.xml:"
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                            type: "file",
                            accessKey: "f",
                            ref: fileEntry,
                            id: "opml",
                            required: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    className: "button",
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                            type: "submit",
                            value: state === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING ? "Importing\u2026" : 'Deliver my OPML!',
                            accessKey: "d",
                            disabled: !isOnline || state === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING
                        })
                    ]
                })
            ]
        })
    });
}
$f343fb504b01a581$export$2e2bcd8739ae039.propTypes = {
    setTitle: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};



var $21h22 = parcelRequire("21h22");


var $eHaBZ = parcelRequire("eHaBZ");



parcelRequire("eHaBZ");


var $8216ee54ed5c099f$exports = {};
'use strict';
Object.defineProperty($8216ee54ed5c099f$exports, '__esModule', {
    value: true
});
var $8216ee54ed5c099f$var$prefix = 'fab';
var $8216ee54ed5c099f$var$iconName = 'diaspora';
var $8216ee54ed5c099f$var$width = 512;
var $8216ee54ed5c099f$var$height = 512;
var $8216ee54ed5c099f$var$aliases = [];
var $8216ee54ed5c099f$var$unicode = 'f791';
var $8216ee54ed5c099f$var$svgPathData = 'M251.64 354.55c-1.4 0-88 119.9-88.7 119.9S76.34 414 76 413.25s86.6-125.7 86.6-127.4c0-2.2-129.6-44-137.6-47.1-1.3-.5 31.4-101.8 31.7-102.1.6-.7 144.4 47 145.5 47 .4 0 .9-.6 1-1.3.4-2 1-148.6 1.7-149.6.8-1.2 104.5-.7 105.1-.3 1.5 1 3.5 156.1 6.1 156.1 1.4 0 138.7-47 139.3-46.3.8.9 31.9 102.2 31.5 102.6-.9.9-140.2 47.1-140.6 48.8-.3 1.4 82.8 122.1 82.5 122.9s-85.5 63.5-86.3 63.5c-1-.2-89-125.5-90.9-125.5z';
$8216ee54ed5c099f$exports.definition = {
    prefix: $8216ee54ed5c099f$var$prefix,
    iconName: $8216ee54ed5c099f$var$iconName,
    icon: [
        $8216ee54ed5c099f$var$width,
        $8216ee54ed5c099f$var$height,
        $8216ee54ed5c099f$var$aliases,
        $8216ee54ed5c099f$var$unicode,
        $8216ee54ed5c099f$var$svgPathData
    ]
};
$8216ee54ed5c099f$exports.faDiaspora = $8216ee54ed5c099f$exports.definition;
$8216ee54ed5c099f$exports.prefix = $8216ee54ed5c099f$var$prefix;
$8216ee54ed5c099f$exports.iconName = $8216ee54ed5c099f$var$iconName;
$8216ee54ed5c099f$exports.width = $8216ee54ed5c099f$var$width;
$8216ee54ed5c099f$exports.height = $8216ee54ed5c099f$var$height;
$8216ee54ed5c099f$exports.ligatures = $8216ee54ed5c099f$var$aliases;
$8216ee54ed5c099f$exports.unicode = $8216ee54ed5c099f$var$unicode;
$8216ee54ed5c099f$exports.svgPathData = $8216ee54ed5c099f$var$svgPathData;
$8216ee54ed5c099f$exports.aliases = $8216ee54ed5c099f$var$aliases;


var $a5565bc5d7aa9135$exports = {};
'use strict';
Object.defineProperty($a5565bc5d7aa9135$exports, '__esModule', {
    value: true
});
var $79ac955092d93bd6$exports = {};
'use strict';
Object.defineProperty($79ac955092d93bd6$exports, '__esModule', {
    value: true
});
var $79ac955092d93bd6$var$prefix = 'fab';
var $79ac955092d93bd6$var$iconName = 'square-facebook';
var $79ac955092d93bd6$var$width = 448;
var $79ac955092d93bd6$var$height = 512;
var $79ac955092d93bd6$var$aliases = [
    "facebook-square"
];
var $79ac955092d93bd6$var$unicode = 'f082';
var $79ac955092d93bd6$var$svgPathData = 'M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64h98.2V334.2H109.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H255V480H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z';
$79ac955092d93bd6$exports.definition = {
    prefix: $79ac955092d93bd6$var$prefix,
    iconName: $79ac955092d93bd6$var$iconName,
    icon: [
        $79ac955092d93bd6$var$width,
        $79ac955092d93bd6$var$height,
        $79ac955092d93bd6$var$aliases,
        $79ac955092d93bd6$var$unicode,
        $79ac955092d93bd6$var$svgPathData
    ]
};
$79ac955092d93bd6$exports.faSquareFacebook = $79ac955092d93bd6$exports.definition;
$79ac955092d93bd6$exports.prefix = $79ac955092d93bd6$var$prefix;
$79ac955092d93bd6$exports.iconName = $79ac955092d93bd6$var$iconName;
$79ac955092d93bd6$exports.width = $79ac955092d93bd6$var$width;
$79ac955092d93bd6$exports.height = $79ac955092d93bd6$var$height;
$79ac955092d93bd6$exports.ligatures = $79ac955092d93bd6$var$aliases;
$79ac955092d93bd6$exports.unicode = $79ac955092d93bd6$var$unicode;
$79ac955092d93bd6$exports.svgPathData = $79ac955092d93bd6$var$svgPathData;
$79ac955092d93bd6$exports.aliases = $79ac955092d93bd6$var$aliases;


$a5565bc5d7aa9135$exports.definition = {
    prefix: $79ac955092d93bd6$exports.prefix,
    iconName: $79ac955092d93bd6$exports.iconName,
    icon: [
        $79ac955092d93bd6$exports.width,
        $79ac955092d93bd6$exports.height,
        $79ac955092d93bd6$exports.aliases,
        $79ac955092d93bd6$exports.unicode,
        $79ac955092d93bd6$exports.svgPathData
    ]
};
$a5565bc5d7aa9135$exports.faFacebookSquare = $a5565bc5d7aa9135$exports.definition;
$a5565bc5d7aa9135$exports.prefix = $79ac955092d93bd6$exports.prefix;
$a5565bc5d7aa9135$exports.iconName = $79ac955092d93bd6$exports.iconName;
$a5565bc5d7aa9135$exports.width = $79ac955092d93bd6$exports.width;
$a5565bc5d7aa9135$exports.height = $79ac955092d93bd6$exports.height;
$a5565bc5d7aa9135$exports.ligatures = $79ac955092d93bd6$exports.aliases;
$a5565bc5d7aa9135$exports.unicode = $79ac955092d93bd6$exports.unicode;
$a5565bc5d7aa9135$exports.svgPathData = $79ac955092d93bd6$exports.svgPathData;
$a5565bc5d7aa9135$exports.aliases = $79ac955092d93bd6$exports.aliases;


var $acd52ab24d9744ba$exports = {};
'use strict';
Object.defineProperty($acd52ab24d9744ba$exports, '__esModule', {
    value: true
});
var $acd52ab24d9744ba$var$prefix = 'fab';
var $acd52ab24d9744ba$var$iconName = 'get-pocket';
var $acd52ab24d9744ba$var$width = 448;
var $acd52ab24d9744ba$var$height = 512;
var $acd52ab24d9744ba$var$aliases = [];
var $acd52ab24d9744ba$var$unicode = 'f265';
var $acd52ab24d9744ba$var$svgPathData = 'M407.6 64h-367C18.5 64 0 82.5 0 104.6v135.2C0 364.5 99.7 464 224.2 464c124 0 223.8-99.5 223.8-224.2V104.6c0-22.4-17.7-40.6-40.4-40.6zm-162 268.5c-12.4 11.8-31.4 11.1-42.4 0C89.5 223.6 88.3 227.4 88.3 209.3c0-16.9 13.8-30.7 30.7-30.7 17 0 16.1 3.8 105.2 89.3 90.6-86.9 88.6-89.3 105.5-89.3 16.9 0 30.7 13.8 30.7 30.7 0 17.8-2.9 15.7-114.8 123.2z';
$acd52ab24d9744ba$exports.definition = {
    prefix: $acd52ab24d9744ba$var$prefix,
    iconName: $acd52ab24d9744ba$var$iconName,
    icon: [
        $acd52ab24d9744ba$var$width,
        $acd52ab24d9744ba$var$height,
        $acd52ab24d9744ba$var$aliases,
        $acd52ab24d9744ba$var$unicode,
        $acd52ab24d9744ba$var$svgPathData
    ]
};
$acd52ab24d9744ba$exports.faGetPocket = $acd52ab24d9744ba$exports.definition;
$acd52ab24d9744ba$exports.prefix = $acd52ab24d9744ba$var$prefix;
$acd52ab24d9744ba$exports.iconName = $acd52ab24d9744ba$var$iconName;
$acd52ab24d9744ba$exports.width = $acd52ab24d9744ba$var$width;
$acd52ab24d9744ba$exports.height = $acd52ab24d9744ba$var$height;
$acd52ab24d9744ba$exports.ligatures = $acd52ab24d9744ba$var$aliases;
$acd52ab24d9744ba$exports.unicode = $acd52ab24d9744ba$var$unicode;
$acd52ab24d9744ba$exports.svgPathData = $acd52ab24d9744ba$var$svgPathData;
$acd52ab24d9744ba$exports.aliases = $acd52ab24d9744ba$var$aliases;


var $11826e5bf54ad532$exports = {};
'use strict';
Object.defineProperty($11826e5bf54ad532$exports, '__esModule', {
    value: true
});
var $11826e5bf54ad532$var$prefix = 'fab';
var $11826e5bf54ad532$var$iconName = 'twitter';
var $11826e5bf54ad532$var$width = 512;
var $11826e5bf54ad532$var$height = 512;
var $11826e5bf54ad532$var$aliases = [];
var $11826e5bf54ad532$var$unicode = 'f099';
var $11826e5bf54ad532$var$svgPathData = 'M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z';
$11826e5bf54ad532$exports.definition = {
    prefix: $11826e5bf54ad532$var$prefix,
    iconName: $11826e5bf54ad532$var$iconName,
    icon: [
        $11826e5bf54ad532$var$width,
        $11826e5bf54ad532$var$height,
        $11826e5bf54ad532$var$aliases,
        $11826e5bf54ad532$var$unicode,
        $11826e5bf54ad532$var$svgPathData
    ]
};
$11826e5bf54ad532$exports.faTwitter = $11826e5bf54ad532$exports.definition;
$11826e5bf54ad532$exports.prefix = $11826e5bf54ad532$var$prefix;
$11826e5bf54ad532$exports.iconName = $11826e5bf54ad532$var$iconName;
$11826e5bf54ad532$exports.width = $11826e5bf54ad532$var$width;
$11826e5bf54ad532$exports.height = $11826e5bf54ad532$var$height;
$11826e5bf54ad532$exports.ligatures = $11826e5bf54ad532$var$aliases;
$11826e5bf54ad532$exports.unicode = $11826e5bf54ad532$var$unicode;
$11826e5bf54ad532$exports.svgPathData = $11826e5bf54ad532$var$svgPathData;
$11826e5bf54ad532$exports.aliases = $11826e5bf54ad532$var$aliases;


var $8ebe08a4e3d0a860$exports = {};
'use strict';
Object.defineProperty($8ebe08a4e3d0a860$exports, '__esModule', {
    value: true
});
var $8ebe08a4e3d0a860$var$prefix = 'fab';
var $8ebe08a4e3d0a860$var$iconName = 'wordpress-simple';
var $8ebe08a4e3d0a860$var$width = 512;
var $8ebe08a4e3d0a860$var$height = 512;
var $8ebe08a4e3d0a860$var$aliases = [];
var $8ebe08a4e3d0a860$var$unicode = 'f411';
var $8ebe08a4e3d0a860$var$svgPathData = 'M256 8C119.3 8 8 119.2 8 256c0 136.7 111.3 248 248 248s248-111.3 248-248C504 119.2 392.7 8 256 8zM33 256c0-32.3 6.9-63 19.3-90.7l106.4 291.4C84.3 420.5 33 344.2 33 256zm223 223c-21.9 0-43-3.2-63-9.1l66.9-194.4 68.5 187.8c.5 1.1 1 2.1 1.6 3.1-23.1 8.1-48 12.6-74 12.6zm30.7-327.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-21.9 0-58.7-2.8-58.7-2.8-12-.7-13.4 17.7-1.4 18.4 0 0 11.4 1.4 23.4 2.1l34.7 95.2L200.6 393l-81.2-241.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-4.2 0-9.1-.1-14.4-.3C109.6 73 178.1 33 256 33c58 0 110.9 22.2 150.6 58.5-1-.1-1.9-.2-2.9-.2-21.9 0-37.4 19.1-37.4 39.6 0 18.4 10.6 33.9 21.9 52.3 8.5 14.8 18.4 33.9 18.4 61.5 0 19.1-7.3 41.2-17 72.1l-22.2 74.3-80.7-239.6zm81.4 297.2l68.1-196.9c12.7-31.8 17-57.2 17-79.9 0-8.2-.5-15.8-1.5-22.9 17.4 31.8 27.3 68.2 27.3 107 0 82.3-44.6 154.1-110.9 192.7z';
$8ebe08a4e3d0a860$exports.definition = {
    prefix: $8ebe08a4e3d0a860$var$prefix,
    iconName: $8ebe08a4e3d0a860$var$iconName,
    icon: [
        $8ebe08a4e3d0a860$var$width,
        $8ebe08a4e3d0a860$var$height,
        $8ebe08a4e3d0a860$var$aliases,
        $8ebe08a4e3d0a860$var$unicode,
        $8ebe08a4e3d0a860$var$svgPathData
    ]
};
$8ebe08a4e3d0a860$exports.faWordpressSimple = $8ebe08a4e3d0a860$exports.definition;
$8ebe08a4e3d0a860$exports.prefix = $8ebe08a4e3d0a860$var$prefix;
$8ebe08a4e3d0a860$exports.iconName = $8ebe08a4e3d0a860$var$iconName;
$8ebe08a4e3d0a860$exports.width = $8ebe08a4e3d0a860$var$width;
$8ebe08a4e3d0a860$exports.height = $8ebe08a4e3d0a860$var$height;
$8ebe08a4e3d0a860$exports.ligatures = $8ebe08a4e3d0a860$var$aliases;
$8ebe08a4e3d0a860$exports.unicode = $8ebe08a4e3d0a860$var$unicode;
$8ebe08a4e3d0a860$exports.svgPathData = $8ebe08a4e3d0a860$var$svgPathData;
$8ebe08a4e3d0a860$exports.aliases = $8ebe08a4e3d0a860$var$aliases;


var $b92068b2b2ac161b$exports = {};
'use strict';
Object.defineProperty($b92068b2b2ac161b$exports, '__esModule', {
    value: true
});
var $b92068b2b2ac161b$var$prefix = 'fab';
var $b92068b2b2ac161b$var$iconName = 'mastodon';
var $b92068b2b2ac161b$var$width = 448;
var $b92068b2b2ac161b$var$height = 512;
var $b92068b2b2ac161b$var$aliases = [];
var $b92068b2b2ac161b$var$unicode = 'f4f6';
var $b92068b2b2ac161b$var$svgPathData = 'M433 179.11c0-97.2-63.71-125.7-63.71-125.7-62.52-28.7-228.56-28.4-290.48 0 0 0-63.72 28.5-63.72 125.7 0 115.7-6.6 259.4 105.63 289.1 40.51 10.7 75.32 13 103.33 11.4 50.81-2.8 79.32-18.1 79.32-18.1l-1.7-36.9s-36.31 11.4-77.12 10.1c-40.41-1.4-83-4.4-89.63-54a102.54 102.54 0 0 1-.9-13.9c85.63 20.9 158.65 9.1 178.75 6.7 56.12-6.7 105-41.3 111.23-72.9 9.8-49.8 9-121.5 9-121.5zm-75.12 125.2h-46.63v-114.2c0-49.7-64-51.6-64 6.9v62.5h-46.33V197c0-58.5-64-56.6-64-6.9v114.2H90.19c0-122.1-5.2-147.9 18.41-175 25.9-28.9 79.82-30.8 103.83 6.1l11.6 19.5 11.6-19.5c24.11-37.1 78.12-34.8 103.83-6.1 23.71 27.3 18.4 53 18.4 175z';
$b92068b2b2ac161b$exports.definition = {
    prefix: $b92068b2b2ac161b$var$prefix,
    iconName: $b92068b2b2ac161b$var$iconName,
    icon: [
        $b92068b2b2ac161b$var$width,
        $b92068b2b2ac161b$var$height,
        $b92068b2b2ac161b$var$aliases,
        $b92068b2b2ac161b$var$unicode,
        $b92068b2b2ac161b$var$svgPathData
    ]
};
$b92068b2b2ac161b$exports.faMastodon = $b92068b2b2ac161b$exports.definition;
$b92068b2b2ac161b$exports.prefix = $b92068b2b2ac161b$var$prefix;
$b92068b2b2ac161b$exports.iconName = $b92068b2b2ac161b$var$iconName;
$b92068b2b2ac161b$exports.width = $b92068b2b2ac161b$var$width;
$b92068b2b2ac161b$exports.height = $b92068b2b2ac161b$var$height;
$b92068b2b2ac161b$exports.ligatures = $b92068b2b2ac161b$var$aliases;
$b92068b2b2ac161b$exports.unicode = $b92068b2b2ac161b$var$unicode;
$b92068b2b2ac161b$exports.svgPathData = $b92068b2b2ac161b$var$svgPathData;
$b92068b2b2ac161b$exports.aliases = $b92068b2b2ac161b$var$aliases;


var $60c3775e24ebf896$exports = {};
'use strict';
Object.defineProperty($60c3775e24ebf896$exports, '__esModule', {
    value: true
});
var $7e27b77be2aec1a1$exports = {};
'use strict';
Object.defineProperty($7e27b77be2aec1a1$exports, '__esModule', {
    value: true
});
var $7e27b77be2aec1a1$var$prefix = 'far';
var $7e27b77be2aec1a1$var$iconName = 'circle-check';
var $7e27b77be2aec1a1$var$width = 512;
var $7e27b77be2aec1a1$var$height = 512;
var $7e27b77be2aec1a1$var$aliases = [
    61533,
    "check-circle"
];
var $7e27b77be2aec1a1$var$unicode = 'f058';
var $7e27b77be2aec1a1$var$svgPathData = 'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z';
$7e27b77be2aec1a1$exports.definition = {
    prefix: $7e27b77be2aec1a1$var$prefix,
    iconName: $7e27b77be2aec1a1$var$iconName,
    icon: [
        $7e27b77be2aec1a1$var$width,
        $7e27b77be2aec1a1$var$height,
        $7e27b77be2aec1a1$var$aliases,
        $7e27b77be2aec1a1$var$unicode,
        $7e27b77be2aec1a1$var$svgPathData
    ]
};
$7e27b77be2aec1a1$exports.faCircleCheck = $7e27b77be2aec1a1$exports.definition;
$7e27b77be2aec1a1$exports.prefix = $7e27b77be2aec1a1$var$prefix;
$7e27b77be2aec1a1$exports.iconName = $7e27b77be2aec1a1$var$iconName;
$7e27b77be2aec1a1$exports.width = $7e27b77be2aec1a1$var$width;
$7e27b77be2aec1a1$exports.height = $7e27b77be2aec1a1$var$height;
$7e27b77be2aec1a1$exports.ligatures = $7e27b77be2aec1a1$var$aliases;
$7e27b77be2aec1a1$exports.unicode = $7e27b77be2aec1a1$var$unicode;
$7e27b77be2aec1a1$exports.svgPathData = $7e27b77be2aec1a1$var$svgPathData;
$7e27b77be2aec1a1$exports.aliases = $7e27b77be2aec1a1$var$aliases;


$60c3775e24ebf896$exports.definition = {
    prefix: $7e27b77be2aec1a1$exports.prefix,
    iconName: $7e27b77be2aec1a1$exports.iconName,
    icon: [
        $7e27b77be2aec1a1$exports.width,
        $7e27b77be2aec1a1$exports.height,
        $7e27b77be2aec1a1$exports.aliases,
        $7e27b77be2aec1a1$exports.unicode,
        $7e27b77be2aec1a1$exports.svgPathData
    ]
};
$60c3775e24ebf896$exports.faCheckCircle = $60c3775e24ebf896$exports.definition;
$60c3775e24ebf896$exports.prefix = $7e27b77be2aec1a1$exports.prefix;
$60c3775e24ebf896$exports.iconName = $7e27b77be2aec1a1$exports.iconName;
$60c3775e24ebf896$exports.width = $7e27b77be2aec1a1$exports.width;
$60c3775e24ebf896$exports.height = $7e27b77be2aec1a1$exports.height;
$60c3775e24ebf896$exports.ligatures = $7e27b77be2aec1a1$exports.aliases;
$60c3775e24ebf896$exports.unicode = $7e27b77be2aec1a1$exports.unicode;
$60c3775e24ebf896$exports.svgPathData = $7e27b77be2aec1a1$exports.svgPathData;
$60c3775e24ebf896$exports.aliases = $7e27b77be2aec1a1$exports.aliases;


var $de3818063bbfedbe$exports = {};
'use strict';
Object.defineProperty($de3818063bbfedbe$exports, '__esModule', {
    value: true
});
var $de3818063bbfedbe$var$prefix = 'far';
var $de3818063bbfedbe$var$iconName = 'star';
var $de3818063bbfedbe$var$width = 576;
var $de3818063bbfedbe$var$height = 512;
var $de3818063bbfedbe$var$aliases = [
    11088,
    61446
];
var $de3818063bbfedbe$var$unicode = 'f005';
var $de3818063bbfedbe$var$svgPathData = 'M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z';
$de3818063bbfedbe$exports.definition = {
    prefix: $de3818063bbfedbe$var$prefix,
    iconName: $de3818063bbfedbe$var$iconName,
    icon: [
        $de3818063bbfedbe$var$width,
        $de3818063bbfedbe$var$height,
        $de3818063bbfedbe$var$aliases,
        $de3818063bbfedbe$var$unicode,
        $de3818063bbfedbe$var$svgPathData
    ]
};
$de3818063bbfedbe$exports.faStar = $de3818063bbfedbe$exports.definition;
$de3818063bbfedbe$exports.prefix = $de3818063bbfedbe$var$prefix;
$de3818063bbfedbe$exports.iconName = $de3818063bbfedbe$var$iconName;
$de3818063bbfedbe$exports.width = $de3818063bbfedbe$var$width;
$de3818063bbfedbe$exports.height = $de3818063bbfedbe$var$height;
$de3818063bbfedbe$exports.ligatures = $de3818063bbfedbe$var$aliases;
$de3818063bbfedbe$exports.unicode = $de3818063bbfedbe$var$unicode;
$de3818063bbfedbe$exports.svgPathData = $de3818063bbfedbe$var$svgPathData;
$de3818063bbfedbe$exports.aliases = $de3818063bbfedbe$var$aliases;


var $ea95ad8a568dd277$exports = {};
'use strict';
Object.defineProperty($ea95ad8a568dd277$exports, '__esModule', {
    value: true
});
var $404c2ac019d45a68$exports = {};
'use strict';
Object.defineProperty($404c2ac019d45a68$exports, '__esModule', {
    value: true
});
var $404c2ac019d45a68$var$prefix = 'far';
var $404c2ac019d45a68$var$iconName = 'circle-xmark';
var $404c2ac019d45a68$var$width = 512;
var $404c2ac019d45a68$var$height = 512;
var $404c2ac019d45a68$var$aliases = [
    61532,
    "times-circle",
    "xmark-circle"
];
var $404c2ac019d45a68$var$unicode = 'f057';
var $404c2ac019d45a68$var$svgPathData = 'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z';
$404c2ac019d45a68$exports.definition = {
    prefix: $404c2ac019d45a68$var$prefix,
    iconName: $404c2ac019d45a68$var$iconName,
    icon: [
        $404c2ac019d45a68$var$width,
        $404c2ac019d45a68$var$height,
        $404c2ac019d45a68$var$aliases,
        $404c2ac019d45a68$var$unicode,
        $404c2ac019d45a68$var$svgPathData
    ]
};
$404c2ac019d45a68$exports.faCircleXmark = $404c2ac019d45a68$exports.definition;
$404c2ac019d45a68$exports.prefix = $404c2ac019d45a68$var$prefix;
$404c2ac019d45a68$exports.iconName = $404c2ac019d45a68$var$iconName;
$404c2ac019d45a68$exports.width = $404c2ac019d45a68$var$width;
$404c2ac019d45a68$exports.height = $404c2ac019d45a68$var$height;
$404c2ac019d45a68$exports.ligatures = $404c2ac019d45a68$var$aliases;
$404c2ac019d45a68$exports.unicode = $404c2ac019d45a68$var$unicode;
$404c2ac019d45a68$exports.svgPathData = $404c2ac019d45a68$var$svgPathData;
$404c2ac019d45a68$exports.aliases = $404c2ac019d45a68$var$aliases;


$ea95ad8a568dd277$exports.definition = {
    prefix: $404c2ac019d45a68$exports.prefix,
    iconName: $404c2ac019d45a68$exports.iconName,
    icon: [
        $404c2ac019d45a68$exports.width,
        $404c2ac019d45a68$exports.height,
        $404c2ac019d45a68$exports.aliases,
        $404c2ac019d45a68$exports.unicode,
        $404c2ac019d45a68$exports.svgPathData
    ]
};
$ea95ad8a568dd277$exports.faTimesCircle = $ea95ad8a568dd277$exports.definition;
$ea95ad8a568dd277$exports.prefix = $404c2ac019d45a68$exports.prefix;
$ea95ad8a568dd277$exports.iconName = $404c2ac019d45a68$exports.iconName;
$ea95ad8a568dd277$exports.width = $404c2ac019d45a68$exports.width;
$ea95ad8a568dd277$exports.height = $404c2ac019d45a68$exports.height;
$ea95ad8a568dd277$exports.ligatures = $404c2ac019d45a68$exports.aliases;
$ea95ad8a568dd277$exports.unicode = $404c2ac019d45a68$exports.unicode;
$ea95ad8a568dd277$exports.svgPathData = $404c2ac019d45a68$exports.svgPathData;
$ea95ad8a568dd277$exports.aliases = $404c2ac019d45a68$exports.aliases;


var $7417e626c64fb3c5$exports = {};
'use strict';
Object.defineProperty($7417e626c64fb3c5$exports, '__esModule', {
    value: true
});
var $76a0fa091acb188e$exports = {};
'use strict';
Object.defineProperty($76a0fa091acb188e$exports, '__esModule', {
    value: true
});
var $76a0fa091acb188e$var$prefix = 'fas';
var $76a0fa091acb188e$var$iconName = 'circle-down';
var $76a0fa091acb188e$var$width = 512;
var $76a0fa091acb188e$var$height = 512;
var $76a0fa091acb188e$var$aliases = [
    61466,
    "arrow-alt-circle-down"
];
var $76a0fa091acb188e$var$unicode = 'f358';
var $76a0fa091acb188e$var$svgPathData = 'M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM244.7 395.3l-112-112c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l64 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 64 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-112 112c-6.2 6.2-16.4 6.2-22.6 0z';
$76a0fa091acb188e$exports.definition = {
    prefix: $76a0fa091acb188e$var$prefix,
    iconName: $76a0fa091acb188e$var$iconName,
    icon: [
        $76a0fa091acb188e$var$width,
        $76a0fa091acb188e$var$height,
        $76a0fa091acb188e$var$aliases,
        $76a0fa091acb188e$var$unicode,
        $76a0fa091acb188e$var$svgPathData
    ]
};
$76a0fa091acb188e$exports.faCircleDown = $76a0fa091acb188e$exports.definition;
$76a0fa091acb188e$exports.prefix = $76a0fa091acb188e$var$prefix;
$76a0fa091acb188e$exports.iconName = $76a0fa091acb188e$var$iconName;
$76a0fa091acb188e$exports.width = $76a0fa091acb188e$var$width;
$76a0fa091acb188e$exports.height = $76a0fa091acb188e$var$height;
$76a0fa091acb188e$exports.ligatures = $76a0fa091acb188e$var$aliases;
$76a0fa091acb188e$exports.unicode = $76a0fa091acb188e$var$unicode;
$76a0fa091acb188e$exports.svgPathData = $76a0fa091acb188e$var$svgPathData;
$76a0fa091acb188e$exports.aliases = $76a0fa091acb188e$var$aliases;


$7417e626c64fb3c5$exports.definition = {
    prefix: $76a0fa091acb188e$exports.prefix,
    iconName: $76a0fa091acb188e$exports.iconName,
    icon: [
        $76a0fa091acb188e$exports.width,
        $76a0fa091acb188e$exports.height,
        $76a0fa091acb188e$exports.aliases,
        $76a0fa091acb188e$exports.unicode,
        $76a0fa091acb188e$exports.svgPathData
    ]
};
$7417e626c64fb3c5$exports.faArrowAltCircleDown = $7417e626c64fb3c5$exports.definition;
$7417e626c64fb3c5$exports.prefix = $76a0fa091acb188e$exports.prefix;
$7417e626c64fb3c5$exports.iconName = $76a0fa091acb188e$exports.iconName;
$7417e626c64fb3c5$exports.width = $76a0fa091acb188e$exports.width;
$7417e626c64fb3c5$exports.height = $76a0fa091acb188e$exports.height;
$7417e626c64fb3c5$exports.ligatures = $76a0fa091acb188e$exports.aliases;
$7417e626c64fb3c5$exports.unicode = $76a0fa091acb188e$exports.unicode;
$7417e626c64fb3c5$exports.svgPathData = $76a0fa091acb188e$exports.svgPathData;
$7417e626c64fb3c5$exports.aliases = $76a0fa091acb188e$exports.aliases;


var $67e9658d0f6c3ae3$exports = {};
'use strict';
Object.defineProperty($67e9658d0f6c3ae3$exports, '__esModule', {
    value: true
});
var $67e9658d0f6c3ae3$var$prefix = 'fas';
var $67e9658d0f6c3ae3$var$iconName = 'arrow-right';
var $67e9658d0f6c3ae3$var$width = 448;
var $67e9658d0f6c3ae3$var$height = 512;
var $67e9658d0f6c3ae3$var$aliases = [
    8594
];
var $67e9658d0f6c3ae3$var$unicode = 'f061';
var $67e9658d0f6c3ae3$var$svgPathData = 'M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z';
$67e9658d0f6c3ae3$exports.definition = {
    prefix: $67e9658d0f6c3ae3$var$prefix,
    iconName: $67e9658d0f6c3ae3$var$iconName,
    icon: [
        $67e9658d0f6c3ae3$var$width,
        $67e9658d0f6c3ae3$var$height,
        $67e9658d0f6c3ae3$var$aliases,
        $67e9658d0f6c3ae3$var$unicode,
        $67e9658d0f6c3ae3$var$svgPathData
    ]
};
$67e9658d0f6c3ae3$exports.faArrowRight = $67e9658d0f6c3ae3$exports.definition;
$67e9658d0f6c3ae3$exports.prefix = $67e9658d0f6c3ae3$var$prefix;
$67e9658d0f6c3ae3$exports.iconName = $67e9658d0f6c3ae3$var$iconName;
$67e9658d0f6c3ae3$exports.width = $67e9658d0f6c3ae3$var$width;
$67e9658d0f6c3ae3$exports.height = $67e9658d0f6c3ae3$var$height;
$67e9658d0f6c3ae3$exports.ligatures = $67e9658d0f6c3ae3$var$aliases;
$67e9658d0f6c3ae3$exports.unicode = $67e9658d0f6c3ae3$var$unicode;
$67e9658d0f6c3ae3$exports.svgPathData = $67e9658d0f6c3ae3$var$svgPathData;
$67e9658d0f6c3ae3$exports.aliases = $67e9658d0f6c3ae3$var$aliases;


var $0c96aa001209cff1$exports = {};
'use strict';
Object.defineProperty($0c96aa001209cff1$exports, '__esModule', {
    value: true
});
var $0c96aa001209cff1$var$prefix = 'fas';
var $0c96aa001209cff1$var$iconName = 'check';
var $0c96aa001209cff1$var$width = 448;
var $0c96aa001209cff1$var$height = 512;
var $0c96aa001209cff1$var$aliases = [
    10003,
    10004
];
var $0c96aa001209cff1$var$unicode = 'f00c';
var $0c96aa001209cff1$var$svgPathData = 'M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z';
$0c96aa001209cff1$exports.definition = {
    prefix: $0c96aa001209cff1$var$prefix,
    iconName: $0c96aa001209cff1$var$iconName,
    icon: [
        $0c96aa001209cff1$var$width,
        $0c96aa001209cff1$var$height,
        $0c96aa001209cff1$var$aliases,
        $0c96aa001209cff1$var$unicode,
        $0c96aa001209cff1$var$svgPathData
    ]
};
$0c96aa001209cff1$exports.faCheck = $0c96aa001209cff1$exports.definition;
$0c96aa001209cff1$exports.prefix = $0c96aa001209cff1$var$prefix;
$0c96aa001209cff1$exports.iconName = $0c96aa001209cff1$var$iconName;
$0c96aa001209cff1$exports.width = $0c96aa001209cff1$var$width;
$0c96aa001209cff1$exports.height = $0c96aa001209cff1$var$height;
$0c96aa001209cff1$exports.ligatures = $0c96aa001209cff1$var$aliases;
$0c96aa001209cff1$exports.unicode = $0c96aa001209cff1$var$unicode;
$0c96aa001209cff1$exports.svgPathData = $0c96aa001209cff1$var$svgPathData;
$0c96aa001209cff1$exports.aliases = $0c96aa001209cff1$var$aliases;


var $7214b407105f2291$exports = {};
'use strict';
Object.defineProperty($7214b407105f2291$exports, '__esModule', {
    value: true
});
var $02c0b80d7cc7c21e$exports = {};
'use strict';
Object.defineProperty($02c0b80d7cc7c21e$exports, '__esModule', {
    value: true
});
var $02c0b80d7cc7c21e$var$prefix = 'fas';
var $02c0b80d7cc7c21e$var$iconName = 'circle-check';
var $02c0b80d7cc7c21e$var$width = 512;
var $02c0b80d7cc7c21e$var$height = 512;
var $02c0b80d7cc7c21e$var$aliases = [
    61533,
    "check-circle"
];
var $02c0b80d7cc7c21e$var$unicode = 'f058';
var $02c0b80d7cc7c21e$var$svgPathData = 'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z';
$02c0b80d7cc7c21e$exports.definition = {
    prefix: $02c0b80d7cc7c21e$var$prefix,
    iconName: $02c0b80d7cc7c21e$var$iconName,
    icon: [
        $02c0b80d7cc7c21e$var$width,
        $02c0b80d7cc7c21e$var$height,
        $02c0b80d7cc7c21e$var$aliases,
        $02c0b80d7cc7c21e$var$unicode,
        $02c0b80d7cc7c21e$var$svgPathData
    ]
};
$02c0b80d7cc7c21e$exports.faCircleCheck = $02c0b80d7cc7c21e$exports.definition;
$02c0b80d7cc7c21e$exports.prefix = $02c0b80d7cc7c21e$var$prefix;
$02c0b80d7cc7c21e$exports.iconName = $02c0b80d7cc7c21e$var$iconName;
$02c0b80d7cc7c21e$exports.width = $02c0b80d7cc7c21e$var$width;
$02c0b80d7cc7c21e$exports.height = $02c0b80d7cc7c21e$var$height;
$02c0b80d7cc7c21e$exports.ligatures = $02c0b80d7cc7c21e$var$aliases;
$02c0b80d7cc7c21e$exports.unicode = $02c0b80d7cc7c21e$var$unicode;
$02c0b80d7cc7c21e$exports.svgPathData = $02c0b80d7cc7c21e$var$svgPathData;
$02c0b80d7cc7c21e$exports.aliases = $02c0b80d7cc7c21e$var$aliases;


$7214b407105f2291$exports.definition = {
    prefix: $02c0b80d7cc7c21e$exports.prefix,
    iconName: $02c0b80d7cc7c21e$exports.iconName,
    icon: [
        $02c0b80d7cc7c21e$exports.width,
        $02c0b80d7cc7c21e$exports.height,
        $02c0b80d7cc7c21e$exports.aliases,
        $02c0b80d7cc7c21e$exports.unicode,
        $02c0b80d7cc7c21e$exports.svgPathData
    ]
};
$7214b407105f2291$exports.faCheckCircle = $7214b407105f2291$exports.definition;
$7214b407105f2291$exports.prefix = $02c0b80d7cc7c21e$exports.prefix;
$7214b407105f2291$exports.iconName = $02c0b80d7cc7c21e$exports.iconName;
$7214b407105f2291$exports.width = $02c0b80d7cc7c21e$exports.width;
$7214b407105f2291$exports.height = $02c0b80d7cc7c21e$exports.height;
$7214b407105f2291$exports.ligatures = $02c0b80d7cc7c21e$exports.aliases;
$7214b407105f2291$exports.unicode = $02c0b80d7cc7c21e$exports.unicode;
$7214b407105f2291$exports.svgPathData = $02c0b80d7cc7c21e$exports.svgPathData;
$7214b407105f2291$exports.aliases = $02c0b80d7cc7c21e$exports.aliases;


var $843ec70749747e2a$exports = {};
'use strict';
Object.defineProperty($843ec70749747e2a$exports, '__esModule', {
    value: true
});
var $843ec70749747e2a$var$prefix = 'fas';
var $843ec70749747e2a$var$iconName = 'caret-down';
var $843ec70749747e2a$var$width = 320;
var $843ec70749747e2a$var$height = 512;
var $843ec70749747e2a$var$aliases = [];
var $843ec70749747e2a$var$unicode = 'f0d7';
var $843ec70749747e2a$var$svgPathData = 'M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z';
$843ec70749747e2a$exports.definition = {
    prefix: $843ec70749747e2a$var$prefix,
    iconName: $843ec70749747e2a$var$iconName,
    icon: [
        $843ec70749747e2a$var$width,
        $843ec70749747e2a$var$height,
        $843ec70749747e2a$var$aliases,
        $843ec70749747e2a$var$unicode,
        $843ec70749747e2a$var$svgPathData
    ]
};
$843ec70749747e2a$exports.faCaretDown = $843ec70749747e2a$exports.definition;
$843ec70749747e2a$exports.prefix = $843ec70749747e2a$var$prefix;
$843ec70749747e2a$exports.iconName = $843ec70749747e2a$var$iconName;
$843ec70749747e2a$exports.width = $843ec70749747e2a$var$width;
$843ec70749747e2a$exports.height = $843ec70749747e2a$var$height;
$843ec70749747e2a$exports.ligatures = $843ec70749747e2a$var$aliases;
$843ec70749747e2a$exports.unicode = $843ec70749747e2a$var$unicode;
$843ec70749747e2a$exports.svgPathData = $843ec70749747e2a$var$svgPathData;
$843ec70749747e2a$exports.aliases = $843ec70749747e2a$var$aliases;


var $809575f3b9653d01$exports = {};
'use strict';
Object.defineProperty($809575f3b9653d01$exports, '__esModule', {
    value: true
});
var $809575f3b9653d01$var$prefix = 'fas';
var $809575f3b9653d01$var$iconName = 'caret-right';
var $809575f3b9653d01$var$width = 256;
var $809575f3b9653d01$var$height = 512;
var $809575f3b9653d01$var$aliases = [];
var $809575f3b9653d01$var$unicode = 'f0da';
var $809575f3b9653d01$var$svgPathData = 'M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z';
$809575f3b9653d01$exports.definition = {
    prefix: $809575f3b9653d01$var$prefix,
    iconName: $809575f3b9653d01$var$iconName,
    icon: [
        $809575f3b9653d01$var$width,
        $809575f3b9653d01$var$height,
        $809575f3b9653d01$var$aliases,
        $809575f3b9653d01$var$unicode,
        $809575f3b9653d01$var$svgPathData
    ]
};
$809575f3b9653d01$exports.faCaretRight = $809575f3b9653d01$exports.definition;
$809575f3b9653d01$exports.prefix = $809575f3b9653d01$var$prefix;
$809575f3b9653d01$exports.iconName = $809575f3b9653d01$var$iconName;
$809575f3b9653d01$exports.width = $809575f3b9653d01$var$width;
$809575f3b9653d01$exports.height = $809575f3b9653d01$var$height;
$809575f3b9653d01$exports.ligatures = $809575f3b9653d01$var$aliases;
$809575f3b9653d01$exports.unicode = $809575f3b9653d01$var$unicode;
$809575f3b9653d01$exports.svgPathData = $809575f3b9653d01$var$svgPathData;
$809575f3b9653d01$exports.aliases = $809575f3b9653d01$var$aliases;


var $78546ca20d789f8c$exports = {};
'use strict';
Object.defineProperty($78546ca20d789f8c$exports, '__esModule', {
    value: true
});
var $b125f469bd48e450$exports = {};
'use strict';
Object.defineProperty($b125f469bd48e450$exports, '__esModule', {
    value: true
});
var $b125f469bd48e450$var$prefix = 'fas';
var $b125f469bd48e450$var$iconName = 'cloud-arrow-up';
var $b125f469bd48e450$var$width = 640;
var $b125f469bd48e450$var$height = 512;
var $b125f469bd48e450$var$aliases = [
    62338,
    "cloud-upload",
    "cloud-upload-alt"
];
var $b125f469bd48e450$var$unicode = 'f0ee';
var $b125f469bd48e450$var$svgPathData = 'M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128l-368 0zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39L296 392c0 13.3 10.7 24 24 24s24-10.7 24-24l0-134.1 39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z';
$b125f469bd48e450$exports.definition = {
    prefix: $b125f469bd48e450$var$prefix,
    iconName: $b125f469bd48e450$var$iconName,
    icon: [
        $b125f469bd48e450$var$width,
        $b125f469bd48e450$var$height,
        $b125f469bd48e450$var$aliases,
        $b125f469bd48e450$var$unicode,
        $b125f469bd48e450$var$svgPathData
    ]
};
$b125f469bd48e450$exports.faCloudArrowUp = $b125f469bd48e450$exports.definition;
$b125f469bd48e450$exports.prefix = $b125f469bd48e450$var$prefix;
$b125f469bd48e450$exports.iconName = $b125f469bd48e450$var$iconName;
$b125f469bd48e450$exports.width = $b125f469bd48e450$var$width;
$b125f469bd48e450$exports.height = $b125f469bd48e450$var$height;
$b125f469bd48e450$exports.ligatures = $b125f469bd48e450$var$aliases;
$b125f469bd48e450$exports.unicode = $b125f469bd48e450$var$unicode;
$b125f469bd48e450$exports.svgPathData = $b125f469bd48e450$var$svgPathData;
$b125f469bd48e450$exports.aliases = $b125f469bd48e450$var$aliases;


$78546ca20d789f8c$exports.definition = {
    prefix: $b125f469bd48e450$exports.prefix,
    iconName: $b125f469bd48e450$exports.iconName,
    icon: [
        $b125f469bd48e450$exports.width,
        $b125f469bd48e450$exports.height,
        $b125f469bd48e450$exports.aliases,
        $b125f469bd48e450$exports.unicode,
        $b125f469bd48e450$exports.svgPathData
    ]
};
$78546ca20d789f8c$exports.faCloudUploadAlt = $78546ca20d789f8c$exports.definition;
$78546ca20d789f8c$exports.prefix = $b125f469bd48e450$exports.prefix;
$78546ca20d789f8c$exports.iconName = $b125f469bd48e450$exports.iconName;
$78546ca20d789f8c$exports.width = $b125f469bd48e450$exports.width;
$78546ca20d789f8c$exports.height = $b125f469bd48e450$exports.height;
$78546ca20d789f8c$exports.ligatures = $b125f469bd48e450$exports.aliases;
$78546ca20d789f8c$exports.unicode = $b125f469bd48e450$exports.unicode;
$78546ca20d789f8c$exports.svgPathData = $b125f469bd48e450$exports.svgPathData;
$78546ca20d789f8c$exports.aliases = $b125f469bd48e450$exports.aliases;


var $18f640b80ac26745$exports = {};
'use strict';
Object.defineProperty($18f640b80ac26745$exports, '__esModule', {
    value: true
});
var $2a47a982851253e1$exports = {};
'use strict';
Object.defineProperty($2a47a982851253e1$exports, '__esModule', {
    value: true
});
var $2a47a982851253e1$var$prefix = 'fas';
var $2a47a982851253e1$var$iconName = 'gear';
var $2a47a982851253e1$var$width = 512;
var $2a47a982851253e1$var$height = 512;
var $2a47a982851253e1$var$aliases = [
    9881,
    "cog"
];
var $2a47a982851253e1$var$unicode = 'f013';
var $2a47a982851253e1$var$svgPathData = 'M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z';
$2a47a982851253e1$exports.definition = {
    prefix: $2a47a982851253e1$var$prefix,
    iconName: $2a47a982851253e1$var$iconName,
    icon: [
        $2a47a982851253e1$var$width,
        $2a47a982851253e1$var$height,
        $2a47a982851253e1$var$aliases,
        $2a47a982851253e1$var$unicode,
        $2a47a982851253e1$var$svgPathData
    ]
};
$2a47a982851253e1$exports.faGear = $2a47a982851253e1$exports.definition;
$2a47a982851253e1$exports.prefix = $2a47a982851253e1$var$prefix;
$2a47a982851253e1$exports.iconName = $2a47a982851253e1$var$iconName;
$2a47a982851253e1$exports.width = $2a47a982851253e1$var$width;
$2a47a982851253e1$exports.height = $2a47a982851253e1$var$height;
$2a47a982851253e1$exports.ligatures = $2a47a982851253e1$var$aliases;
$2a47a982851253e1$exports.unicode = $2a47a982851253e1$var$unicode;
$2a47a982851253e1$exports.svgPathData = $2a47a982851253e1$var$svgPathData;
$2a47a982851253e1$exports.aliases = $2a47a982851253e1$var$aliases;


$18f640b80ac26745$exports.definition = {
    prefix: $2a47a982851253e1$exports.prefix,
    iconName: $2a47a982851253e1$exports.iconName,
    icon: [
        $2a47a982851253e1$exports.width,
        $2a47a982851253e1$exports.height,
        $2a47a982851253e1$exports.aliases,
        $2a47a982851253e1$exports.unicode,
        $2a47a982851253e1$exports.svgPathData
    ]
};
$18f640b80ac26745$exports.faCog = $18f640b80ac26745$exports.definition;
$18f640b80ac26745$exports.prefix = $2a47a982851253e1$exports.prefix;
$18f640b80ac26745$exports.iconName = $2a47a982851253e1$exports.iconName;
$18f640b80ac26745$exports.width = $2a47a982851253e1$exports.width;
$18f640b80ac26745$exports.height = $2a47a982851253e1$exports.height;
$18f640b80ac26745$exports.ligatures = $2a47a982851253e1$exports.aliases;
$18f640b80ac26745$exports.unicode = $2a47a982851253e1$exports.unicode;
$18f640b80ac26745$exports.svgPathData = $2a47a982851253e1$exports.svgPathData;
$18f640b80ac26745$exports.aliases = $2a47a982851253e1$exports.aliases;


var $7f79cc0a934ae117$exports = {};
'use strict';
Object.defineProperty($7f79cc0a934ae117$exports, '__esModule', {
    value: true
});
var $7f79cc0a934ae117$var$prefix = 'fas';
var $7f79cc0a934ae117$var$iconName = 'copy';
var $7f79cc0a934ae117$var$width = 448;
var $7f79cc0a934ae117$var$height = 512;
var $7f79cc0a934ae117$var$aliases = [];
var $7f79cc0a934ae117$var$unicode = 'f0c5';
var $7f79cc0a934ae117$var$svgPathData = 'M208 0L332.1 0c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9L448 336c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48zM48 128l80 0 0 64-64 0 0 256 192 0 0-32 64 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 176c0-26.5 21.5-48 48-48z';
$7f79cc0a934ae117$exports.definition = {
    prefix: $7f79cc0a934ae117$var$prefix,
    iconName: $7f79cc0a934ae117$var$iconName,
    icon: [
        $7f79cc0a934ae117$var$width,
        $7f79cc0a934ae117$var$height,
        $7f79cc0a934ae117$var$aliases,
        $7f79cc0a934ae117$var$unicode,
        $7f79cc0a934ae117$var$svgPathData
    ]
};
$7f79cc0a934ae117$exports.faCopy = $7f79cc0a934ae117$exports.definition;
$7f79cc0a934ae117$exports.prefix = $7f79cc0a934ae117$var$prefix;
$7f79cc0a934ae117$exports.iconName = $7f79cc0a934ae117$var$iconName;
$7f79cc0a934ae117$exports.width = $7f79cc0a934ae117$var$width;
$7f79cc0a934ae117$exports.height = $7f79cc0a934ae117$var$height;
$7f79cc0a934ae117$exports.ligatures = $7f79cc0a934ae117$var$aliases;
$7f79cc0a934ae117$exports.unicode = $7f79cc0a934ae117$var$unicode;
$7f79cc0a934ae117$exports.svgPathData = $7f79cc0a934ae117$var$svgPathData;
$7f79cc0a934ae117$exports.aliases = $7f79cc0a934ae117$var$aliases;


var $5aa79799bc179db8$exports = {};
'use strict';
Object.defineProperty($5aa79799bc179db8$exports, '__esModule', {
    value: true
});
var $5aa79799bc179db8$var$prefix = 'fas';
var $5aa79799bc179db8$var$iconName = 'envelope';
var $5aa79799bc179db8$var$width = 512;
var $5aa79799bc179db8$var$height = 512;
var $5aa79799bc179db8$var$aliases = [
    128386,
    9993,
    61443
];
var $5aa79799bc179db8$var$unicode = 'f0e0';
var $5aa79799bc179db8$var$svgPathData = 'M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48L48 64zM0 176L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-208L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z';
$5aa79799bc179db8$exports.definition = {
    prefix: $5aa79799bc179db8$var$prefix,
    iconName: $5aa79799bc179db8$var$iconName,
    icon: [
        $5aa79799bc179db8$var$width,
        $5aa79799bc179db8$var$height,
        $5aa79799bc179db8$var$aliases,
        $5aa79799bc179db8$var$unicode,
        $5aa79799bc179db8$var$svgPathData
    ]
};
$5aa79799bc179db8$exports.faEnvelope = $5aa79799bc179db8$exports.definition;
$5aa79799bc179db8$exports.prefix = $5aa79799bc179db8$var$prefix;
$5aa79799bc179db8$exports.iconName = $5aa79799bc179db8$var$iconName;
$5aa79799bc179db8$exports.width = $5aa79799bc179db8$var$width;
$5aa79799bc179db8$exports.height = $5aa79799bc179db8$var$height;
$5aa79799bc179db8$exports.ligatures = $5aa79799bc179db8$var$aliases;
$5aa79799bc179db8$exports.unicode = $5aa79799bc179db8$var$unicode;
$5aa79799bc179db8$exports.svgPathData = $5aa79799bc179db8$var$svgPathData;
$5aa79799bc179db8$exports.aliases = $5aa79799bc179db8$var$aliases;


var $38e96a2b42b175e8$exports = {};
'use strict';
Object.defineProperty($38e96a2b42b175e8$exports, '__esModule', {
    value: true
});
var $8c651f8f2944f6f7$exports = {};
'use strict';
Object.defineProperty($8c651f8f2944f6f7$exports, '__esModule', {
    value: true
});
var $8c651f8f2944f6f7$var$prefix = 'fas';
var $8c651f8f2944f6f7$var$iconName = 'up-right-from-square';
var $8c651f8f2944f6f7$var$width = 512;
var $8c651f8f2944f6f7$var$height = 512;
var $8c651f8f2944f6f7$var$aliases = [
    "external-link-alt"
];
var $8c651f8f2944f6f7$var$unicode = 'f35d';
var $8c651f8f2944f6f7$var$svgPathData = 'M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-128c0-17.7-14.3-32-32-32L352 0zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z';
$8c651f8f2944f6f7$exports.definition = {
    prefix: $8c651f8f2944f6f7$var$prefix,
    iconName: $8c651f8f2944f6f7$var$iconName,
    icon: [
        $8c651f8f2944f6f7$var$width,
        $8c651f8f2944f6f7$var$height,
        $8c651f8f2944f6f7$var$aliases,
        $8c651f8f2944f6f7$var$unicode,
        $8c651f8f2944f6f7$var$svgPathData
    ]
};
$8c651f8f2944f6f7$exports.faUpRightFromSquare = $8c651f8f2944f6f7$exports.definition;
$8c651f8f2944f6f7$exports.prefix = $8c651f8f2944f6f7$var$prefix;
$8c651f8f2944f6f7$exports.iconName = $8c651f8f2944f6f7$var$iconName;
$8c651f8f2944f6f7$exports.width = $8c651f8f2944f6f7$var$width;
$8c651f8f2944f6f7$exports.height = $8c651f8f2944f6f7$var$height;
$8c651f8f2944f6f7$exports.ligatures = $8c651f8f2944f6f7$var$aliases;
$8c651f8f2944f6f7$exports.unicode = $8c651f8f2944f6f7$var$unicode;
$8c651f8f2944f6f7$exports.svgPathData = $8c651f8f2944f6f7$var$svgPathData;
$8c651f8f2944f6f7$exports.aliases = $8c651f8f2944f6f7$var$aliases;


$38e96a2b42b175e8$exports.definition = {
    prefix: $8c651f8f2944f6f7$exports.prefix,
    iconName: $8c651f8f2944f6f7$exports.iconName,
    icon: [
        $8c651f8f2944f6f7$exports.width,
        $8c651f8f2944f6f7$exports.height,
        $8c651f8f2944f6f7$exports.aliases,
        $8c651f8f2944f6f7$exports.unicode,
        $8c651f8f2944f6f7$exports.svgPathData
    ]
};
$38e96a2b42b175e8$exports.faExternalLinkAlt = $38e96a2b42b175e8$exports.definition;
$38e96a2b42b175e8$exports.prefix = $8c651f8f2944f6f7$exports.prefix;
$38e96a2b42b175e8$exports.iconName = $8c651f8f2944f6f7$exports.iconName;
$38e96a2b42b175e8$exports.width = $8c651f8f2944f6f7$exports.width;
$38e96a2b42b175e8$exports.height = $8c651f8f2944f6f7$exports.height;
$38e96a2b42b175e8$exports.ligatures = $8c651f8f2944f6f7$exports.aliases;
$38e96a2b42b175e8$exports.unicode = $8c651f8f2944f6f7$exports.unicode;
$38e96a2b42b175e8$exports.svgPathData = $8c651f8f2944f6f7$exports.svgPathData;
$38e96a2b42b175e8$exports.aliases = $8c651f8f2944f6f7$exports.aliases;


var $5a270b3b7e6b7fa8$exports = {};
'use strict';
Object.defineProperty($5a270b3b7e6b7fa8$exports, '__esModule', {
    value: true
});
var $5a270b3b7e6b7fa8$var$prefix = 'fas';
var $5a270b3b7e6b7fa8$var$iconName = 'key';
var $5a270b3b7e6b7fa8$var$width = 512;
var $5a270b3b7e6b7fa8$var$height = 512;
var $5a270b3b7e6b7fa8$var$aliases = [
    128273
];
var $5a270b3b7e6b7fa8$var$unicode = 'f084';
var $5a270b3b7e6b7fa8$var$svgPathData = 'M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17l0 80c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24l0-40 40 0c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z';
$5a270b3b7e6b7fa8$exports.definition = {
    prefix: $5a270b3b7e6b7fa8$var$prefix,
    iconName: $5a270b3b7e6b7fa8$var$iconName,
    icon: [
        $5a270b3b7e6b7fa8$var$width,
        $5a270b3b7e6b7fa8$var$height,
        $5a270b3b7e6b7fa8$var$aliases,
        $5a270b3b7e6b7fa8$var$unicode,
        $5a270b3b7e6b7fa8$var$svgPathData
    ]
};
$5a270b3b7e6b7fa8$exports.faKey = $5a270b3b7e6b7fa8$exports.definition;
$5a270b3b7e6b7fa8$exports.prefix = $5a270b3b7e6b7fa8$var$prefix;
$5a270b3b7e6b7fa8$exports.iconName = $5a270b3b7e6b7fa8$var$iconName;
$5a270b3b7e6b7fa8$exports.width = $5a270b3b7e6b7fa8$var$width;
$5a270b3b7e6b7fa8$exports.height = $5a270b3b7e6b7fa8$var$height;
$5a270b3b7e6b7fa8$exports.ligatures = $5a270b3b7e6b7fa8$var$aliases;
$5a270b3b7e6b7fa8$exports.unicode = $5a270b3b7e6b7fa8$var$unicode;
$5a270b3b7e6b7fa8$exports.svgPathData = $5a270b3b7e6b7fa8$var$svgPathData;
$5a270b3b7e6b7fa8$exports.aliases = $5a270b3b7e6b7fa8$var$aliases;


var $3d54bd244f4653d3$exports = {};
'use strict';
Object.defineProperty($3d54bd244f4653d3$exports, '__esModule', {
    value: true
});
var $ca60dd235af7334a$exports = {};
'use strict';
Object.defineProperty($ca60dd235af7334a$exports, '__esModule', {
    value: true
});
var $ca60dd235af7334a$var$prefix = 'fas';
var $ca60dd235af7334a$var$iconName = 'magnifying-glass';
var $ca60dd235af7334a$var$width = 512;
var $ca60dd235af7334a$var$height = 512;
var $ca60dd235af7334a$var$aliases = [
    128269,
    "search"
];
var $ca60dd235af7334a$var$unicode = 'f002';
var $ca60dd235af7334a$var$svgPathData = 'M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z';
$ca60dd235af7334a$exports.definition = {
    prefix: $ca60dd235af7334a$var$prefix,
    iconName: $ca60dd235af7334a$var$iconName,
    icon: [
        $ca60dd235af7334a$var$width,
        $ca60dd235af7334a$var$height,
        $ca60dd235af7334a$var$aliases,
        $ca60dd235af7334a$var$unicode,
        $ca60dd235af7334a$var$svgPathData
    ]
};
$ca60dd235af7334a$exports.faMagnifyingGlass = $ca60dd235af7334a$exports.definition;
$ca60dd235af7334a$exports.prefix = $ca60dd235af7334a$var$prefix;
$ca60dd235af7334a$exports.iconName = $ca60dd235af7334a$var$iconName;
$ca60dd235af7334a$exports.width = $ca60dd235af7334a$var$width;
$ca60dd235af7334a$exports.height = $ca60dd235af7334a$var$height;
$ca60dd235af7334a$exports.ligatures = $ca60dd235af7334a$var$aliases;
$ca60dd235af7334a$exports.unicode = $ca60dd235af7334a$var$unicode;
$ca60dd235af7334a$exports.svgPathData = $ca60dd235af7334a$var$svgPathData;
$ca60dd235af7334a$exports.aliases = $ca60dd235af7334a$var$aliases;


$3d54bd244f4653d3$exports.definition = {
    prefix: $ca60dd235af7334a$exports.prefix,
    iconName: $ca60dd235af7334a$exports.iconName,
    icon: [
        $ca60dd235af7334a$exports.width,
        $ca60dd235af7334a$exports.height,
        $ca60dd235af7334a$exports.aliases,
        $ca60dd235af7334a$exports.unicode,
        $ca60dd235af7334a$exports.svgPathData
    ]
};
$3d54bd244f4653d3$exports.faSearch = $3d54bd244f4653d3$exports.definition;
$3d54bd244f4653d3$exports.prefix = $ca60dd235af7334a$exports.prefix;
$3d54bd244f4653d3$exports.iconName = $ca60dd235af7334a$exports.iconName;
$3d54bd244f4653d3$exports.width = $ca60dd235af7334a$exports.width;
$3d54bd244f4653d3$exports.height = $ca60dd235af7334a$exports.height;
$3d54bd244f4653d3$exports.ligatures = $ca60dd235af7334a$exports.aliases;
$3d54bd244f4653d3$exports.unicode = $ca60dd235af7334a$exports.unicode;
$3d54bd244f4653d3$exports.svgPathData = $ca60dd235af7334a$exports.svgPathData;
$3d54bd244f4653d3$exports.aliases = $ca60dd235af7334a$exports.aliases;


var $5f3a6b596119c825$exports = {};
'use strict';
Object.defineProperty($5f3a6b596119c825$exports, '__esModule', {
    value: true
});
var $19ec3707a0f446bb$exports = {};
'use strict';
Object.defineProperty($19ec3707a0f446bb$exports, '__esModule', {
    value: true
});
var $19ec3707a0f446bb$var$prefix = 'fas';
var $19ec3707a0f446bb$var$iconName = 'share-nodes';
var $19ec3707a0f446bb$var$width = 448;
var $19ec3707a0f446bb$var$height = 512;
var $19ec3707a0f446bb$var$aliases = [
    "share-alt"
];
var $19ec3707a0f446bb$var$unicode = 'f1e0';
var $19ec3707a0f446bb$var$svgPathData = 'M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z';
$19ec3707a0f446bb$exports.definition = {
    prefix: $19ec3707a0f446bb$var$prefix,
    iconName: $19ec3707a0f446bb$var$iconName,
    icon: [
        $19ec3707a0f446bb$var$width,
        $19ec3707a0f446bb$var$height,
        $19ec3707a0f446bb$var$aliases,
        $19ec3707a0f446bb$var$unicode,
        $19ec3707a0f446bb$var$svgPathData
    ]
};
$19ec3707a0f446bb$exports.faShareNodes = $19ec3707a0f446bb$exports.definition;
$19ec3707a0f446bb$exports.prefix = $19ec3707a0f446bb$var$prefix;
$19ec3707a0f446bb$exports.iconName = $19ec3707a0f446bb$var$iconName;
$19ec3707a0f446bb$exports.width = $19ec3707a0f446bb$var$width;
$19ec3707a0f446bb$exports.height = $19ec3707a0f446bb$var$height;
$19ec3707a0f446bb$exports.ligatures = $19ec3707a0f446bb$var$aliases;
$19ec3707a0f446bb$exports.unicode = $19ec3707a0f446bb$var$unicode;
$19ec3707a0f446bb$exports.svgPathData = $19ec3707a0f446bb$var$svgPathData;
$19ec3707a0f446bb$exports.aliases = $19ec3707a0f446bb$var$aliases;


$5f3a6b596119c825$exports.definition = {
    prefix: $19ec3707a0f446bb$exports.prefix,
    iconName: $19ec3707a0f446bb$exports.iconName,
    icon: [
        $19ec3707a0f446bb$exports.width,
        $19ec3707a0f446bb$exports.height,
        $19ec3707a0f446bb$exports.aliases,
        $19ec3707a0f446bb$exports.unicode,
        $19ec3707a0f446bb$exports.svgPathData
    ]
};
$5f3a6b596119c825$exports.faShareAlt = $5f3a6b596119c825$exports.definition;
$5f3a6b596119c825$exports.prefix = $19ec3707a0f446bb$exports.prefix;
$5f3a6b596119c825$exports.iconName = $19ec3707a0f446bb$exports.iconName;
$5f3a6b596119c825$exports.width = $19ec3707a0f446bb$exports.width;
$5f3a6b596119c825$exports.height = $19ec3707a0f446bb$exports.height;
$5f3a6b596119c825$exports.ligatures = $19ec3707a0f446bb$exports.aliases;
$5f3a6b596119c825$exports.unicode = $19ec3707a0f446bb$exports.unicode;
$5f3a6b596119c825$exports.svgPathData = $19ec3707a0f446bb$exports.svgPathData;
$5f3a6b596119c825$exports.aliases = $19ec3707a0f446bb$exports.aliases;


var $17ddfe677f5b40f7$exports = {};
'use strict';
Object.defineProperty($17ddfe677f5b40f7$exports, '__esModule', {
    value: true
});
var $35b4a6ca5cd59a8e$exports = {};
'use strict';
Object.defineProperty($35b4a6ca5cd59a8e$exports, '__esModule', {
    value: true
});
var $35b4a6ca5cd59a8e$var$prefix = 'fas';
var $35b4a6ca5cd59a8e$var$iconName = 'right-from-bracket';
var $35b4a6ca5cd59a8e$var$width = 512;
var $35b4a6ca5cd59a8e$var$height = 512;
var $35b4a6ca5cd59a8e$var$aliases = [
    "sign-out-alt"
];
var $35b4a6ca5cd59a8e$var$unicode = 'f2f5';
var $35b4a6ca5cd59a8e$var$svgPathData = 'M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z';
$35b4a6ca5cd59a8e$exports.definition = {
    prefix: $35b4a6ca5cd59a8e$var$prefix,
    iconName: $35b4a6ca5cd59a8e$var$iconName,
    icon: [
        $35b4a6ca5cd59a8e$var$width,
        $35b4a6ca5cd59a8e$var$height,
        $35b4a6ca5cd59a8e$var$aliases,
        $35b4a6ca5cd59a8e$var$unicode,
        $35b4a6ca5cd59a8e$var$svgPathData
    ]
};
$35b4a6ca5cd59a8e$exports.faRightFromBracket = $35b4a6ca5cd59a8e$exports.definition;
$35b4a6ca5cd59a8e$exports.prefix = $35b4a6ca5cd59a8e$var$prefix;
$35b4a6ca5cd59a8e$exports.iconName = $35b4a6ca5cd59a8e$var$iconName;
$35b4a6ca5cd59a8e$exports.width = $35b4a6ca5cd59a8e$var$width;
$35b4a6ca5cd59a8e$exports.height = $35b4a6ca5cd59a8e$var$height;
$35b4a6ca5cd59a8e$exports.ligatures = $35b4a6ca5cd59a8e$var$aliases;
$35b4a6ca5cd59a8e$exports.unicode = $35b4a6ca5cd59a8e$var$unicode;
$35b4a6ca5cd59a8e$exports.svgPathData = $35b4a6ca5cd59a8e$var$svgPathData;
$35b4a6ca5cd59a8e$exports.aliases = $35b4a6ca5cd59a8e$var$aliases;


$17ddfe677f5b40f7$exports.definition = {
    prefix: $35b4a6ca5cd59a8e$exports.prefix,
    iconName: $35b4a6ca5cd59a8e$exports.iconName,
    icon: [
        $35b4a6ca5cd59a8e$exports.width,
        $35b4a6ca5cd59a8e$exports.height,
        $35b4a6ca5cd59a8e$exports.aliases,
        $35b4a6ca5cd59a8e$exports.unicode,
        $35b4a6ca5cd59a8e$exports.svgPathData
    ]
};
$17ddfe677f5b40f7$exports.faSignOutAlt = $17ddfe677f5b40f7$exports.definition;
$17ddfe677f5b40f7$exports.prefix = $35b4a6ca5cd59a8e$exports.prefix;
$17ddfe677f5b40f7$exports.iconName = $35b4a6ca5cd59a8e$exports.iconName;
$17ddfe677f5b40f7$exports.width = $35b4a6ca5cd59a8e$exports.width;
$17ddfe677f5b40f7$exports.height = $35b4a6ca5cd59a8e$exports.height;
$17ddfe677f5b40f7$exports.ligatures = $35b4a6ca5cd59a8e$exports.aliases;
$17ddfe677f5b40f7$exports.unicode = $35b4a6ca5cd59a8e$exports.unicode;
$17ddfe677f5b40f7$exports.svgPathData = $35b4a6ca5cd59a8e$exports.svgPathData;
$17ddfe677f5b40f7$exports.aliases = $35b4a6ca5cd59a8e$exports.aliases;


var $c0ffe79f8008445d$exports = {};
'use strict';
Object.defineProperty($c0ffe79f8008445d$exports, '__esModule', {
    value: true
});
var $c0ffe79f8008445d$var$prefix = 'fas';
var $c0ffe79f8008445d$var$iconName = 'slash';
var $c0ffe79f8008445d$var$width = 640;
var $c0ffe79f8008445d$var$height = 512;
var $c0ffe79f8008445d$var$aliases = [];
var $c0ffe79f8008445d$var$unicode = 'f715';
var $c0ffe79f8008445d$var$svgPathData = 'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z';
$c0ffe79f8008445d$exports.definition = {
    prefix: $c0ffe79f8008445d$var$prefix,
    iconName: $c0ffe79f8008445d$var$iconName,
    icon: [
        $c0ffe79f8008445d$var$width,
        $c0ffe79f8008445d$var$height,
        $c0ffe79f8008445d$var$aliases,
        $c0ffe79f8008445d$var$unicode,
        $c0ffe79f8008445d$var$svgPathData
    ]
};
$c0ffe79f8008445d$exports.faSlash = $c0ffe79f8008445d$exports.definition;
$c0ffe79f8008445d$exports.prefix = $c0ffe79f8008445d$var$prefix;
$c0ffe79f8008445d$exports.iconName = $c0ffe79f8008445d$var$iconName;
$c0ffe79f8008445d$exports.width = $c0ffe79f8008445d$var$width;
$c0ffe79f8008445d$exports.height = $c0ffe79f8008445d$var$height;
$c0ffe79f8008445d$exports.ligatures = $c0ffe79f8008445d$var$aliases;
$c0ffe79f8008445d$exports.unicode = $c0ffe79f8008445d$var$unicode;
$c0ffe79f8008445d$exports.svgPathData = $c0ffe79f8008445d$var$svgPathData;
$c0ffe79f8008445d$exports.aliases = $c0ffe79f8008445d$var$aliases;


var $d85e0c7e91e2ddfe$exports = {};
'use strict';
Object.defineProperty($d85e0c7e91e2ddfe$exports, '__esModule', {
    value: true
});
var $d85e0c7e91e2ddfe$var$prefix = 'fas';
var $d85e0c7e91e2ddfe$var$iconName = 'spinner';
var $d85e0c7e91e2ddfe$var$width = 512;
var $d85e0c7e91e2ddfe$var$height = 512;
var $d85e0c7e91e2ddfe$var$aliases = [];
var $d85e0c7e91e2ddfe$var$unicode = 'f110';
var $d85e0c7e91e2ddfe$var$svgPathData = 'M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z';
$d85e0c7e91e2ddfe$exports.definition = {
    prefix: $d85e0c7e91e2ddfe$var$prefix,
    iconName: $d85e0c7e91e2ddfe$var$iconName,
    icon: [
        $d85e0c7e91e2ddfe$var$width,
        $d85e0c7e91e2ddfe$var$height,
        $d85e0c7e91e2ddfe$var$aliases,
        $d85e0c7e91e2ddfe$var$unicode,
        $d85e0c7e91e2ddfe$var$svgPathData
    ]
};
$d85e0c7e91e2ddfe$exports.faSpinner = $d85e0c7e91e2ddfe$exports.definition;
$d85e0c7e91e2ddfe$exports.prefix = $d85e0c7e91e2ddfe$var$prefix;
$d85e0c7e91e2ddfe$exports.iconName = $d85e0c7e91e2ddfe$var$iconName;
$d85e0c7e91e2ddfe$exports.width = $d85e0c7e91e2ddfe$var$width;
$d85e0c7e91e2ddfe$exports.height = $d85e0c7e91e2ddfe$var$height;
$d85e0c7e91e2ddfe$exports.ligatures = $d85e0c7e91e2ddfe$var$aliases;
$d85e0c7e91e2ddfe$exports.unicode = $d85e0c7e91e2ddfe$var$unicode;
$d85e0c7e91e2ddfe$exports.svgPathData = $d85e0c7e91e2ddfe$var$svgPathData;
$d85e0c7e91e2ddfe$exports.aliases = $d85e0c7e91e2ddfe$var$aliases;


var $4e5ab4d00c078f68$exports = {};
'use strict';
Object.defineProperty($4e5ab4d00c078f68$exports, '__esModule', {
    value: true
});
var $4e5ab4d00c078f68$var$prefix = 'fas';
var $4e5ab4d00c078f68$var$iconName = 'star';
var $4e5ab4d00c078f68$var$width = 576;
var $4e5ab4d00c078f68$var$height = 512;
var $4e5ab4d00c078f68$var$aliases = [
    11088,
    61446
];
var $4e5ab4d00c078f68$var$unicode = 'f005';
var $4e5ab4d00c078f68$var$svgPathData = 'M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z';
$4e5ab4d00c078f68$exports.definition = {
    prefix: $4e5ab4d00c078f68$var$prefix,
    iconName: $4e5ab4d00c078f68$var$iconName,
    icon: [
        $4e5ab4d00c078f68$var$width,
        $4e5ab4d00c078f68$var$height,
        $4e5ab4d00c078f68$var$aliases,
        $4e5ab4d00c078f68$var$unicode,
        $4e5ab4d00c078f68$var$svgPathData
    ]
};
$4e5ab4d00c078f68$exports.faStar = $4e5ab4d00c078f68$exports.definition;
$4e5ab4d00c078f68$exports.prefix = $4e5ab4d00c078f68$var$prefix;
$4e5ab4d00c078f68$exports.iconName = $4e5ab4d00c078f68$var$iconName;
$4e5ab4d00c078f68$exports.width = $4e5ab4d00c078f68$var$width;
$4e5ab4d00c078f68$exports.height = $4e5ab4d00c078f68$var$height;
$4e5ab4d00c078f68$exports.ligatures = $4e5ab4d00c078f68$var$aliases;
$4e5ab4d00c078f68$exports.unicode = $4e5ab4d00c078f68$var$unicode;
$4e5ab4d00c078f68$exports.svgPathData = $4e5ab4d00c078f68$var$svgPathData;
$4e5ab4d00c078f68$exports.aliases = $4e5ab4d00c078f68$var$aliases;


var $468e6f5287149412$exports = {};
'use strict';
Object.defineProperty($468e6f5287149412$exports, '__esModule', {
    value: true
});
var $6f224e40d9413106$exports = {};
'use strict';
Object.defineProperty($6f224e40d9413106$exports, '__esModule', {
    value: true
});
var $6f224e40d9413106$var$prefix = 'fas';
var $6f224e40d9413106$var$iconName = 'rotate';
var $6f224e40d9413106$var$width = 512;
var $6f224e40d9413106$var$height = 512;
var $6f224e40d9413106$var$aliases = [
    128260,
    "sync-alt"
];
var $6f224e40d9413106$var$unicode = 'f2f1';
var $6f224e40d9413106$var$svgPathData = 'M142.9 142.9c-17.5 17.5-30.1 38-37.8 59.8c-5.9 16.7-24.2 25.4-40.8 19.5s-25.4-24.2-19.5-40.8C55.6 150.7 73.2 122 97.6 97.6c87.2-87.2 228.3-87.5 315.8-1L455 55c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2l0 128c0 13.3-10.7 24-24 24l-8.4 0c0 0 0 0 0 0L344 224c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l41.1-41.1c-62.6-61.5-163.1-61.2-225.3 1zM16 312c0-13.3 10.7-24 24-24l7.6 0 .7 0L168 288c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-41.1 41.1c62.6 61.5 163.1 61.2 225.3-1c17.5-17.5 30.1-38 37.8-59.8c5.9-16.7 24.2-25.4 40.8-19.5s25.4 24.2 19.5 40.8c-10.8 30.6-28.4 59.3-52.9 83.8c-87.2 87.2-228.3 87.5-315.8 1L57 457c-6.9 6.9-17.2 8.9-26.2 5.2S16 449.7 16 440l0-119.6 0-.7 0-7.6z';
$6f224e40d9413106$exports.definition = {
    prefix: $6f224e40d9413106$var$prefix,
    iconName: $6f224e40d9413106$var$iconName,
    icon: [
        $6f224e40d9413106$var$width,
        $6f224e40d9413106$var$height,
        $6f224e40d9413106$var$aliases,
        $6f224e40d9413106$var$unicode,
        $6f224e40d9413106$var$svgPathData
    ]
};
$6f224e40d9413106$exports.faRotate = $6f224e40d9413106$exports.definition;
$6f224e40d9413106$exports.prefix = $6f224e40d9413106$var$prefix;
$6f224e40d9413106$exports.iconName = $6f224e40d9413106$var$iconName;
$6f224e40d9413106$exports.width = $6f224e40d9413106$var$width;
$6f224e40d9413106$exports.height = $6f224e40d9413106$var$height;
$6f224e40d9413106$exports.ligatures = $6f224e40d9413106$var$aliases;
$6f224e40d9413106$exports.unicode = $6f224e40d9413106$var$unicode;
$6f224e40d9413106$exports.svgPathData = $6f224e40d9413106$var$svgPathData;
$6f224e40d9413106$exports.aliases = $6f224e40d9413106$var$aliases;


$468e6f5287149412$exports.definition = {
    prefix: $6f224e40d9413106$exports.prefix,
    iconName: $6f224e40d9413106$exports.iconName,
    icon: [
        $6f224e40d9413106$exports.width,
        $6f224e40d9413106$exports.height,
        $6f224e40d9413106$exports.aliases,
        $6f224e40d9413106$exports.unicode,
        $6f224e40d9413106$exports.svgPathData
    ]
};
$468e6f5287149412$exports.faSyncAlt = $468e6f5287149412$exports.definition;
$468e6f5287149412$exports.prefix = $6f224e40d9413106$exports.prefix;
$468e6f5287149412$exports.iconName = $6f224e40d9413106$exports.iconName;
$468e6f5287149412$exports.width = $6f224e40d9413106$exports.width;
$468e6f5287149412$exports.height = $6f224e40d9413106$exports.height;
$468e6f5287149412$exports.ligatures = $6f224e40d9413106$exports.aliases;
$468e6f5287149412$exports.unicode = $6f224e40d9413106$exports.unicode;
$468e6f5287149412$exports.svgPathData = $6f224e40d9413106$exports.svgPathData;
$468e6f5287149412$exports.aliases = $6f224e40d9413106$exports.aliases;


var $6c06a95c587730ec$exports = {};
'use strict';
Object.defineProperty($6c06a95c587730ec$exports, '__esModule', {
    value: true
});
var $9e310623eda7f0ec$exports = {};
'use strict';
Object.defineProperty($9e310623eda7f0ec$exports, '__esModule', {
    value: true
});
var $9e310623eda7f0ec$var$prefix = 'fas';
var $9e310623eda7f0ec$var$iconName = 'xmark';
var $9e310623eda7f0ec$var$width = 384;
var $9e310623eda7f0ec$var$height = 512;
var $9e310623eda7f0ec$var$aliases = [
    128473,
    10005,
    10006,
    10060,
    215,
    "close",
    "multiply",
    "remove",
    "times"
];
var $9e310623eda7f0ec$var$unicode = 'f00d';
var $9e310623eda7f0ec$var$svgPathData = 'M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z';
$9e310623eda7f0ec$exports.definition = {
    prefix: $9e310623eda7f0ec$var$prefix,
    iconName: $9e310623eda7f0ec$var$iconName,
    icon: [
        $9e310623eda7f0ec$var$width,
        $9e310623eda7f0ec$var$height,
        $9e310623eda7f0ec$var$aliases,
        $9e310623eda7f0ec$var$unicode,
        $9e310623eda7f0ec$var$svgPathData
    ]
};
$9e310623eda7f0ec$exports.faXmark = $9e310623eda7f0ec$exports.definition;
$9e310623eda7f0ec$exports.prefix = $9e310623eda7f0ec$var$prefix;
$9e310623eda7f0ec$exports.iconName = $9e310623eda7f0ec$var$iconName;
$9e310623eda7f0ec$exports.width = $9e310623eda7f0ec$var$width;
$9e310623eda7f0ec$exports.height = $9e310623eda7f0ec$var$height;
$9e310623eda7f0ec$exports.ligatures = $9e310623eda7f0ec$var$aliases;
$9e310623eda7f0ec$exports.unicode = $9e310623eda7f0ec$var$unicode;
$9e310623eda7f0ec$exports.svgPathData = $9e310623eda7f0ec$var$svgPathData;
$9e310623eda7f0ec$exports.aliases = $9e310623eda7f0ec$var$aliases;


$6c06a95c587730ec$exports.definition = {
    prefix: $9e310623eda7f0ec$exports.prefix,
    iconName: $9e310623eda7f0ec$exports.iconName,
    icon: [
        $9e310623eda7f0ec$exports.width,
        $9e310623eda7f0ec$exports.height,
        $9e310623eda7f0ec$exports.aliases,
        $9e310623eda7f0ec$exports.unicode,
        $9e310623eda7f0ec$exports.svgPathData
    ]
};
$6c06a95c587730ec$exports.faTimes = $6c06a95c587730ec$exports.definition;
$6c06a95c587730ec$exports.prefix = $9e310623eda7f0ec$exports.prefix;
$6c06a95c587730ec$exports.iconName = $9e310623eda7f0ec$exports.iconName;
$6c06a95c587730ec$exports.width = $9e310623eda7f0ec$exports.width;
$6c06a95c587730ec$exports.height = $9e310623eda7f0ec$exports.height;
$6c06a95c587730ec$exports.ligatures = $9e310623eda7f0ec$exports.aliases;
$6c06a95c587730ec$exports.unicode = $9e310623eda7f0ec$exports.unicode;
$6c06a95c587730ec$exports.svgPathData = $9e310623eda7f0ec$exports.svgPathData;
$6c06a95c587730ec$exports.aliases = $9e310623eda7f0ec$exports.aliases;


var $37a500ad1dcc914a$exports = {};
'use strict';
Object.defineProperty($37a500ad1dcc914a$exports, '__esModule', {
    value: true
});
var $37a500ad1dcc914a$var$prefix = 'fas';
var $37a500ad1dcc914a$var$iconName = 'wifi';
var $37a500ad1dcc914a$var$width = 640;
var $37a500ad1dcc914a$var$height = 512;
var $37a500ad1dcc914a$var$aliases = [
    "wifi-3",
    "wifi-strong"
];
var $37a500ad1dcc914a$var$unicode = 'f1eb';
var $37a500ad1dcc914a$var$svgPathData = 'M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z';
$37a500ad1dcc914a$exports.definition = {
    prefix: $37a500ad1dcc914a$var$prefix,
    iconName: $37a500ad1dcc914a$var$iconName,
    icon: [
        $37a500ad1dcc914a$var$width,
        $37a500ad1dcc914a$var$height,
        $37a500ad1dcc914a$var$aliases,
        $37a500ad1dcc914a$var$unicode,
        $37a500ad1dcc914a$var$svgPathData
    ]
};
$37a500ad1dcc914a$exports.faWifi = $37a500ad1dcc914a$exports.definition;
$37a500ad1dcc914a$exports.prefix = $37a500ad1dcc914a$var$prefix;
$37a500ad1dcc914a$exports.iconName = $37a500ad1dcc914a$var$iconName;
$37a500ad1dcc914a$exports.width = $37a500ad1dcc914a$var$width;
$37a500ad1dcc914a$exports.height = $37a500ad1dcc914a$var$height;
$37a500ad1dcc914a$exports.ligatures = $37a500ad1dcc914a$var$aliases;
$37a500ad1dcc914a$exports.unicode = $37a500ad1dcc914a$var$unicode;
$37a500ad1dcc914a$exports.svgPathData = $37a500ad1dcc914a$var$svgPathData;
$37a500ad1dcc914a$exports.aliases = $37a500ad1dcc914a$var$aliases;


var $d38ff8171a2466a8$export$2e2bcd8739ae039 = [
    124.155,
    133.529,
    [],
    null,
    // wallabag.svg: Free Art License 1.3 https://github.com/wallabag/logo
    'M108.69.004c-.241-.026-.512.083-.777.299-.572.465-5.551 1.614-8.504 3.917-4.768 3.72-7.707 10.796-9.04 14.708-.024.06-.205.603-.265.79-.62 1.499-1.857 1.495-1.857 1.495v.002c-.6-.065-1.202-.102-1.809-.102-.54 0-1.078.03-1.615.082-.012.002-.02 0-.031 0-1.581.233-2.451-1.696-2.633-2.156C80.312 13.735 75.342 3.277 64.174.463c0 0-2.028-1.554-1.41 1.074.588 2.51 1.805 5.048 1.535 8.74-.124 1.704-1.18 10.442 6.85 14.99.763.432 1.44.796 2.05 1.102-4.041 3.235-7.715 7.739-10.858 12.852 1.597-.981 10.206-5.557 24.097.177 14.29 5.897 23.155.777 24.254.08-3.454-5.678-7.561-10.62-12.103-13.943.303-.083.612-.168.939-.264 6.023-1.742 7.553-6.84 7.875-11.209.364-4.954.615-5.029 1.691-9.486.774-3.21.32-4.495-.404-4.572zM86.774 50.228a4.677 4.677 0 00-1.652.256 6.555 6.555 0 00-1.332.615 3.879 3.879 0 00-1.094.985c-.322.432-.486.901-.486 1.396v16.307c0 2.158-.362 3.75-1.078 4.73-.688.94-1.85 1.397-3.55 1.397-1.704 0-2.876-.46-3.583-1.402-.734-.98-1.108-2.57-1.108-4.725V53.73c0-.908-.383-1.727-1.144-2.437-.751-.702-1.75-1.059-2.973-1.059-1.258 0-2.297.352-3.086 1.045-.81.71-1.22 1.536-1.22 2.451v15.807c0 1.988.193 3.869.574 5.588.393 1.758 1.077 3.3 2.035 4.586.968 1.299 2.282 2.322 3.906 3.049 1.607.716 3.617 1.08 5.975 1.08 2.457 0 4.515-.457 6.115-1.356a10.678 10.678 0 003.371-2.95 10.256 10.256 0 003.295 2.95c1.58.9 3.669 1.354 6.21 1.354 2.358 0 4.358-.363 5.946-1.08 1.601-.726 2.903-1.752 3.873-3.05.96-1.29 1.644-2.832 2.033-4.585.381-1.72.577-3.6.577-5.588V53.73c0-.91-.398-1.733-1.184-2.445-.767-.697-1.82-1.05-3.121-1.05-1.181 0-2.161.356-2.912 1.058-.76.71-1.145 1.53-1.145 2.437v16.057c0 2.154-.381 3.742-1.134 4.72-.728.947-1.891 1.407-3.555 1.407-1.703 0-2.863-.458-3.549-1.397-.716-.979-1.078-2.57-1.078-4.73v-16.12c0-1.097-.501-1.997-1.45-2.597-.805-.507-1.607-.81-2.476-.842zM51.796 82.363a31.2 31.2 0 001.865 5.742c.666 3.745 1.561 12.563-2.674 20.282-3.731 6.8-22.15 16.069-49.484 10.748 0 0-1.096-.765-1.428-.135-.491.932 1.516 1.684 3.582 2.228 19.03 5.04 47.756 2.989 56.777-4.443 4.116-3.388 5.705-7.953 6.108-12.865l.002.008s.11-1.288 1.718-.32c.461.276 2.126 1.36 2.391 2.585.232 1.743.248 3.884-.652 5.383-1.287 2.144-1.302 2.45.392 3.66 1.04.742 5.289 3.865 11.2 7.416.015.01.022.02.037.028 1.25.753 2.988 2.595 2.988 2.595 2.662 3.08 8.45 9.277 10.97 8.11 1.19-.551-.05-3.033-.05-3.033s1.98 2.572 3.043 1.695c.809-.668-.473-3.23-.473-3.23s1.73 1.5 2.758.945c1.258-.68-.188-4.614-10.08-10.627-9.896-6.018-12.579-6.941-12.815-9.627 0 0-.004-.134.004-.365.077-.593.416-1.848 1.854-1.713 2.14.346 4.347.53 6.607.53 2.587 0 5.106-.236 7.535-.689l.002.002.164-.029c.284-.036.838-.019.84.67-.09.873-.331 1.752-.845 2.52-1.447 2.168-.971 2.466.54 3.859.934.859 5.212 4.622 11.07 8.264.013.009.016.016.03.023 1.25.752 3.41 2.814 3.41 2.814 2.428 2.466 6.895 6.595 9.328 6.346 1.646-.168.305-3.002.305-3.002s2.079 2.006 3.1 1.416c1.142-.659-.475-2.754-.475-2.754s1.338.708 2.283.473c.948-.236 1.187-2.643-8.654-8.736-9.842-6.098-13.154-8.244-12.947-10.577 0 0 .003-.379.1-.957.238-1.236.994-3.346 3.406-4.55.079-.04.147-.084.209-.13 7.668-4.45 13.27-11.614 15.246-20.56-1.99 4.941-16.737 8.78-34.647 8.78-17.903 0-32.65-3.839-34.64-8.78z'
];


'use strict';
var $8cad2150f94e1c78$export$a67558cb68d63c7e = {
    prefix: 'fac',
    iconName: 'wallabag',
    icon: (0, $d38ff8171a2466a8$export$2e2bcd8739ae039)
};


function $4e51d095a6eb2eac$export$7f7cbe89f1eacd2(param) {
    var label = param.label, size = param.size;
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                icon: $d85e0c7e91e2ddfe$exports.faSpinner,
                size: size,
                spin: true,
                "aria-hidden": "true",
                title: label
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                className: "visually-hidden",
                role: "alert",
                children: label
            })
        ]
    });
}
$4e51d095a6eb2eac$export$7f7cbe89f1eacd2.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string.isRequired,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string
};
function $4e51d095a6eb2eac$export$84dbad74efe95918(param) {
    var label = param.label;
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
        className: "spinner-big",
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($4e51d095a6eb2eac$export$7f7cbe89f1eacd2, {
            size: "10x",
            label: label
        })
    });
}
$4e51d095a6eb2eac$export$84dbad74efe95918.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string.isRequired
};



var $5XYIU = parcelRequire("5XYIU");


var $eHaBZ = parcelRequire("eHaBZ");
var $94046e75c3010f4f$export$326f6d1b69f1c06e = /*#__PURE__*/ (0, $eHaBZ.createContext)();



var $eHaBZ = parcelRequire("eHaBZ");
function $7e577f35f270614e$export$e51161e9fbfde80e(translated, params) {
    var formatted = '';
    var curChar;
    var buffer = '';
    var state = 'out';
    var placeholder;
    var plural;
    var pluralKeyword;
    var pluralValue;
    for(var i = 0, len = translated.length; i < len; i++){
        curChar = translated.charAt(i);
        switch(curChar){
            case '{':
                if (placeholder) {
                    if (state == 'plural') {
                        pluralKeyword = buffer.trim();
                        if ([
                            'zero',
                            'one',
                            'other'
                        ].includes(pluralKeyword)) buffer = '';
                        else pluralKeyword = undefined;
                    }
                } else {
                    formatted = formatted + buffer;
                    buffer = '';
                    placeholder = {};
                    state = 'index';
                }
                break;
            case '}':
            case ',':
                if (placeholder) {
                    if (state == 'index') {
                        var index = buffer.trim();
                        var intIndex = parseInt(index);
                        placeholder.index = Number.isNaN(intIndex) ? index : intIndex;
                        placeholder.value = params[placeholder.index];
                        buffer = '';
                    } else if (state == 'type') {
                        placeholder.type = buffer.trim();
                        buffer = '';
                        if (placeholder.type == 'plural') {
                            plural = {};
                            state = 'plural';
                        }
                    }
                    if (curChar == '}') {
                        if (state == 'plural' && pluralKeyword) {
                            plural[pluralKeyword] = buffer;
                            buffer = '';
                            pluralKeyword = undefined;
                        } else if (plural) {
                            if ('zero' in plural && placeholder.value === 0) pluralValue = plural.zero;
                            else if ('one' in plural && placeholder.value == 1) pluralValue = plural.one;
                            else pluralValue = plural.other;
                            formatted = formatted + pluralValue.replace('#', placeholder.value);
                            plural = undefined;
                            placeholder = undefined;
                            state = 'out';
                        } else {
                            formatted = formatted + placeholder.value;
                            placeholder = undefined;
                            state = 'out';
                        }
                    } else if (curChar == ',' && state == 'index') state = 'type';
                }
                break;
            default:
                buffer = buffer + curChar;
                break;
        }
    }
    if (state != 'out') return "Error formatting '" + translated + "', bug report?";
    formatted = formatted + buffer;
    return formatted;
}
var $7e577f35f270614e$export$51216bcc3983e55d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createContext();


function $374b9547e2738d1e$var$handleLogIn(param) {
    var event = param.event, configuration = param.configuration, navigate = param.navigate, setLoading = param.setLoading, username = param.username, password = param.password, enableOffline = param.enableOffline, returnLocation = param.returnLocation;
    event.preventDefault();
    setLoading(true);
    selfoss.login({
        configuration: configuration,
        username: username,
        password: password,
        enableOffline: enableOffline
    }).then(function() {
        navigate(returnLocation);
    }).catch(function(err) {
        var message = err instanceof (0, $0d06257c362dc1a1$export$5e64a9683d127ef6) ? selfoss.app._('login_invalid_credentials') : selfoss.app._('login_error_generic', {
            errorMessage: err instanceof (0, $0d06257c362dc1a1$export$65bd6083489bd8bb) ? "HTTP ".concat(err.response.status, " ").concat(err.message) : err.message
        });
        navigate('/sign/in', {
            replace: true,
            state: {
                error: message
            }
        });
    }).finally(function() {
        setLoading(false);
    });
}
function $374b9547e2738d1e$export$2e2bcd8739ae039(param) {
    var offlineEnabled = param.offlineEnabled;
    var _location_state, _location_state1;
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(''), 2), username = _useState[0], setUsername = _useState[1];
    var _useState1 = (0, $21h22._)((0, $eHaBZ.useState)(''), 2), password = _useState1[0], setPassword = _useState1[1];
    var _useState2 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), loading = _useState2[0], setLoading = _useState2[1];
    var _useState3 = (0, $21h22._)((0, $eHaBZ.useState)(offlineEnabled), 2), enableOffline = _useState3[0], setEnableOffline = _useState3[1];
    var configuration = (0, $eHaBZ.useContext)((0, $94046e75c3010f4f$export$326f6d1b69f1c06e));
    var navigate = (0, $5XYIU.useNavigate)();
    var location = (0, $5XYIU.useLocation)();
    var error = location === null || location === void 0 ? void 0 : (_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.error;
    var _location_state_returnLocation;
    var returnLocation = (_location_state_returnLocation = location === null || location === void 0 ? void 0 : (_location_state1 = location.state) === null || _location_state1 === void 0 ? void 0 : _location_state1.returnLocation) !== null && _location_state_returnLocation !== void 0 ? _location_state_returnLocation : '/';
    var formOnSubmit = (0, $eHaBZ.useCallback)(function(event) {
        return $374b9547e2738d1e$var$handleLogIn({
            event: event,
            configuration: configuration,
            navigate: navigate,
            setLoading: setLoading,
            username: username,
            password: password,
            enableOffline: enableOffline,
            returnLocation: returnLocation
        });
    }, [
        configuration,
        navigate,
        username,
        password,
        enableOffline,
        returnLocation
    ]);
    var usernameOnChange = (0, $eHaBZ.useCallback)(function(event) {
        return setUsername(event.target.value);
    }, []);
    var passwordOnChange = (0, $eHaBZ.useCallback)(function(event) {
        return setPassword(event.target.value);
    }, []);
    var offlineOnChange = (0, $eHaBZ.useCallback)(function(event) {
        return setEnableOffline(event.target.checked);
    }, [
        setEnableOffline
    ]);
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
        children: [
            loading ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $4e51d095a6eb2eac$export$84dbad74efe95918), {
                label: _('login_in_progress')
            }) : null,
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("form", {
                action: "",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                    loading: loading
                }),
                method: "post",
                onSubmit: formOnSubmit,
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", {
                    id: "login",
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("h1", {
                                children: [
                                    configuration.htmlTitle,
                                    " login"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                                    htmlFor: "username",
                                    children: _('login_username')
                                }),
                                ' ',
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                                    type: "text",
                                    name: "username",
                                    id: "username",
                                    accessKey: "u",
                                    autoComplete: "username",
                                    onChange: usernameOnChange,
                                    value: username,
                                    autoFocus: true,
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                                    htmlFor: "password",
                                    children: _('login_password')
                                }),
                                ' ',
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                                    type: "password",
                                    name: "password",
                                    id: "password",
                                    accessKey: "p",
                                    autoComplete: "current-password",
                                    onChange: passwordOnChange,
                                    value: password
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                                    htmlFor: "enableoffline",
                                    children: _('login_offline')
                                }),
                                ' ',
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                                            type: "checkbox",
                                            name: "enableoffline",
                                            id: "enableoffline",
                                            accessKey: "o",
                                            onChange: offlineOnChange,
                                            checked: enableOffline
                                        }),
                                        ' ',
                                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                            className: "badge-experimental",
                                            children: _('experimental')
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                            className: "error",
                            "aria-live": "assertive",
                            children: error
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                            className: "button",
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                                    children: "\xa0"
                                }),
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                                    type: "submit",
                                    accessKey: "l",
                                    value: _('login')
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
$374b9547e2738d1e$export$2e2bcd8739ae039.propTypes = {
    offlineEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired
};



var $lvTkn = parcelRequire("lvTkn");

var $21h22 = parcelRequire("21h22");

var $6zk1M = parcelRequire("6zk1M");


var $eHaBZ = parcelRequire("eHaBZ");

var $5XYIU = parcelRequire("5XYIU");

var $khBmn = parcelRequire("khBmn");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $aRv4I = parcelRequire("aRv4I");

var $21h22 = parcelRequire("21h22");


var $eHaBZ = parcelRequire("eHaBZ");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $aRv4I = parcelRequire("aRv4I");

var $21h22 = parcelRequire("21h22");

var $eHaBZ = parcelRequire("eHaBZ");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $aRv4I = parcelRequire("aRv4I");

var $eHaBZ = parcelRequire("eHaBZ");


var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $aRv4I = parcelRequire("aRv4I");

var $21h22 = parcelRequire("21h22");

var $eHaBZ = parcelRequire("eHaBZ");


var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $eHaBZ = parcelRequire("eHaBZ");


var $eHaBZ = parcelRequire("eHaBZ");
var $f6b66376b7c99589$export$7ae630fe844fbd1f = function(param) {
    var block = param.block, element = param.element, modifiers = param.modifiers, className = param.className;
    return (0, $eHaBZ.useMemo)(function() {
        var blockElement = element ? "".concat(block, "__").concat(element) : block;
        var classString = blockElement;
        modifiers && Object.keys(modifiers).forEach(function(name) {
            var value = modifiers[name];
            if (value) classString += " ".concat(blockElement, "--").concat(value === true ? name : "".concat(name, "-").concat(value));
        });
        var expandedClassName = typeof className === 'function' ? className(modifiers) : className;
        if (typeof expandedClassName === 'string') {
            expandedClassName = expandedClassName.trim();
            if (expandedClassName) classString += " ".concat(expandedClassName);
        }
        return classString;
    }, [
        block,
        element,
        modifiers,
        className
    ]);
};



var $6zk1M = parcelRequire("6zk1M");

var $26d9d16241653294$export$30c2dce1a652e248 = function(state) {
    return !!state && state[0] === 'o';
};
var $26d9d16241653294$export$3e3e6d241f8feb60 = (0, $8afcda7f6e55ccf7$exports.unstable_batchedUpdates);
var $26d9d16241653294$export$d5639c01d489b0c = function(transition, name) {
    return transition === true || !!(transition && transition[name]);
};
var $26d9d16241653294$export$175e60bb96229ece = function(fn, arg) {
    return typeof fn === 'function' ? fn(arg) : fn;
};
var $26d9d16241653294$var$internalKey = '_szhsinMenu';
var $26d9d16241653294$export$7d9f7e9c1c02b41e = function(component) {
    return component[$26d9d16241653294$var$internalKey];
};
var $26d9d16241653294$export$4c4bf90f1b4d3105 = function(name, component) {
    return Object.defineProperty(component, $26d9d16241653294$var$internalKey, {
        value: name
    });
};
var $26d9d16241653294$export$9d1611c77c2fe928 = function(target, source) {
    source && Object.keys(source).forEach(function(key) {
        var targetProp = target[key];
        var sourceProp = source[key];
        if (typeof sourceProp === 'function' && targetProp) target[key] = function() {
            for(var _len = arguments.length, arg = new Array(_len), _key = 0; _key < _len; _key++){
                arg[_key] = arguments[_key];
            }
            sourceProp.apply(void 0, (0, $6zk1M._)(arg));
            targetProp.apply(void 0, (0, $6zk1M._)(arg));
        };
        else target[key] = sourceProp;
    });
    return target;
};
var $26d9d16241653294$export$4bc3c325941e6f67 = function(paddingStr) {
    if (typeof paddingStr !== 'string') return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    var padding = paddingStr.trim().split(/\s+/, 4).map(parseFloat);
    var top = !isNaN(padding[0]) ? padding[0] : 0;
    var right = !isNaN(padding[1]) ? padding[1] : top;
    return {
        top: top,
        right: right,
        bottom: !isNaN(padding[2]) ? padding[2] : top,
        left: !isNaN(padding[3]) ? padding[3] : right
    };
};
var $26d9d16241653294$export$7414735161c19437 = function(node) {
    while(node){
        node = node.parentNode;
        if (!node || node === document.body || !node.parentNode) return;
        var _getComputedStyle = getComputedStyle(node), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
        if (/auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX)) return node;
    }
};
function $26d9d16241653294$export$ffb2d5922287e12(isDisabled, isHovering) {
    return {
        'aria-disabled': isDisabled || undefined,
        tabIndex: isHovering ? 0 : -1
    };
}
function $26d9d16241653294$export$a12bd5aaf0b59fa0(nodeList, node) {
    for(var i = 0; i < nodeList.length; i++){
        if (nodeList[i] === node) return i;
    }
    return -1;
}



var $eHaBZ = parcelRequire("eHaBZ");
var $58c87f0a382883df$export$ccf052fa53df1929 = 'szh-menu-container';
var $58c87f0a382883df$export$832250593589325a = 'szh-menu';
var $58c87f0a382883df$export$b3d82f113f746a0 = 'szh-menu-button';
var $58c87f0a382883df$export$3b35f0f35c840df9 = 'arrow';
var $58c87f0a382883df$export$b5a3c9a9995a8c24 = 'item';
var $58c87f0a382883df$export$10b42530e0558a83 = 'divider';
var $58c87f0a382883df$export$29e3fcfc61abbafd = 'header';
var $58c87f0a382883df$export$e4f8e9b9e6d790ae = 'group';
var $58c87f0a382883df$export$3b437b9ab85faa03 = 'submenu';
var $58c87f0a382883df$export$d6766e4ef63d0cb0 = 'radio-group';
var $58c87f0a382883df$export$15c1690330cd94e = /*#__PURE__*/ (0, $eHaBZ.createContext)();
var $58c87f0a382883df$export$7cb023214e4bda1e = /*#__PURE__*/ (0, $eHaBZ.createContext)({});
var $58c87f0a382883df$export$1c2bdfb4407fdacf = /*#__PURE__*/ (0, $eHaBZ.createContext)({});
var $58c87f0a382883df$export$ee9f2ec6c8119c2a = /*#__PURE__*/ (0, $eHaBZ.createContext)({});
var $58c87f0a382883df$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $eHaBZ.createContext)({});
var $58c87f0a382883df$export$8fa45c82eddfe270 = /*#__PURE__*/ (0, $eHaBZ.createContext)({});
var $58c87f0a382883df$export$4b0075e5ea5e1f26 = /*#__PURE__*/ Object.freeze({
    ENTER: 'Enter',
    ESC: 'Escape',
    SPACE: ' ',
    HOME: 'Home',
    END: 'End',
    LEFT: 'ArrowLeft',
    RIGHT: 'ArrowRight',
    UP: 'ArrowUp',
    DOWN: 'ArrowDown'
});
var $58c87f0a382883df$export$6db955af9e6f8fcd = /*#__PURE__*/ Object.freeze({
    RESET: 0,
    SET: 1,
    UNSET: 2,
    INCREASE: 3,
    DECREASE: 4,
    FIRST: 5,
    LAST: 6,
    SET_INDEX: 7
});
var $58c87f0a382883df$export$8fd8df51a9b835e6 = /*#__PURE__*/ Object.freeze({
    CLICK: 'click',
    CANCEL: 'cancel',
    BLUR: 'blur',
    SCROLL: 'scroll'
});
var $58c87f0a382883df$export$8c6ccba1b6ce32e9 = /*#__PURE__*/ Object.freeze({
    FIRST: 'first',
    LAST: 'last'
});
var $58c87f0a382883df$export$be1d8b0328ba66b6 = /*#__PURE__*/ Object.freeze({
    entering: 'opening',
    entered: 'open',
    exiting: 'closing',
    exited: 'closed'
});
var $58c87f0a382883df$export$f8d144aafbd3a470 = 'absolute';
var $58c87f0a382883df$export$a5a9d7469a9cc520 = 'none';
var $58c87f0a382883df$export$3e982710469daaf = 'menuitem';
var $58c87f0a382883df$export$42466afb37c6c021 = {
    preventScroll: true
};


var $e4ff2b7984f354ae$export$b286f91cddfedb5a = function(param) {
    var className = param.className, containerRef = param.containerRef, containerProps = param.containerProps, children = param.children, isOpen = param.isOpen, theming = param.theming, transition = param.transition, onClose = param.onClose;
    var itemTransition = (0, $26d9d16241653294$export$d5639c01d489b0c)(transition, 'item');
    var onKeyDown = function(param) {
        var key = param.key;
        switch(key){
            case (0, $58c87f0a382883df$export$4b0075e5ea5e1f26).ESC:
                (0, $26d9d16241653294$export$175e60bb96229ece)(onClose, {
                    key: key,
                    reason: (0, $58c87f0a382883df$export$8fd8df51a9b835e6).CANCEL
                });
                break;
        }
    };
    var onBlur = function(e) {
        if (isOpen && !e.currentTarget.contains(e.relatedTarget)) (0, $26d9d16241653294$export$175e60bb96229ece)(onClose, {
            reason: (0, $58c87f0a382883df$export$8fd8df51a9b835e6).BLUR
        });
    };
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", (0, $9Jpjh._)((0, $lvTkn._)({}, (0, $26d9d16241653294$export$9d1611c77c2fe928)({
        onKeyDown: onKeyDown,
        onBlur: onBlur
    }, containerProps)), {
        className: (0, $f6b66376b7c99589$export$7ae630fe844fbd1f)({
            block: (0, $58c87f0a382883df$export$ccf052fa53df1929),
            modifiers: (0, $eHaBZ.useMemo)(function() {
                return {
                    theme: theming,
                    itemTransition: itemTransition
                };
            }, [
                theming,
                itemTransition
            ]),
            className: className
        }),
        style: (0, $lvTkn._)({
            position: 'absolute'
        }, containerProps === null || containerProps === void 0 ? void 0 : containerProps.style),
        ref: containerRef,
        children: children
    }));
};



var $ac38d8c87becf7c6$export$fd76cd1ffdc0d698 = function() {
    var timer, count = 0;
    return {
        toggle: function(isOpen) {
            isOpen ? count++ : count--;
            count = Math.max(count, 0);
        },
        on: function(closeDelay, pending, settled) {
            if (count) {
                if (!timer) timer = setTimeout(function() {
                    timer = 0;
                    pending();
                }, closeDelay);
            } else settled === null || settled === void 0 ? void 0 : settled();
        },
        off: function() {
            if (timer) {
                clearTimeout(timer);
                timer = 0;
            }
        }
    };
};




var $21h22 = parcelRequire("21h22");

var $eHaBZ = parcelRequire("eHaBZ");


var $6e2879dc867be080$export$7bfdd97581ca93c = function(menuRef) {
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(), 2), hoverItem = _useState[0], setHoverItem = _useState[1];
    var stateRef = (0, $eHaBZ.useRef)({
        items: [],
        hoverIndex: -1,
        sorted: false
    });
    var mutableState = stateRef.current;
    var updateItems = (0, $eHaBZ.useCallback)(function(item, isMounted) {
        var items = mutableState.items;
        if (!item) mutableState.items = [];
        else if (isMounted) items.push(item);
        else {
            var index = items.indexOf(item);
            if (index > -1) {
                items.splice(index, 1);
                if (item.contains(document.activeElement)) {
                    menuRef.current.focus((0, $58c87f0a382883df$export$42466afb37c6c021));
                    setHoverItem();
                }
            }
        }
        mutableState.hoverIndex = -1;
        mutableState.sorted = false;
    }, [
        mutableState,
        menuRef
    ]);
    var dispatch = (0, $eHaBZ.useCallback)(function(actionType, item, nextIndex) {
        var items = mutableState.items, hoverIndex = mutableState.hoverIndex;
        var sortItems = function() {
            if (mutableState.sorted) return;
            var orderedNodes = menuRef.current.querySelectorAll('.szh-menu__item');
            items.sort(function(a, b) {
                return (0, $26d9d16241653294$export$a12bd5aaf0b59fa0)(orderedNodes, a) - (0, $26d9d16241653294$export$a12bd5aaf0b59fa0)(orderedNodes, b);
            });
            mutableState.sorted = true;
        };
        var index = -1, newItem = undefined;
        switch(actionType){
            case (0, $58c87f0a382883df$export$6db955af9e6f8fcd).RESET:
                break;
            case (0, $58c87f0a382883df$export$6db955af9e6f8fcd).SET:
                newItem = item;
                break;
            case (0, $58c87f0a382883df$export$6db955af9e6f8fcd).UNSET:
                newItem = function(prevItem) {
                    return prevItem === item ? undefined : prevItem;
                };
                break;
            case (0, $58c87f0a382883df$export$6db955af9e6f8fcd).FIRST:
                sortItems();
                index = 0;
                newItem = items[index];
                break;
            case (0, $58c87f0a382883df$export$6db955af9e6f8fcd).LAST:
                sortItems();
                index = items.length - 1;
                newItem = items[index];
                break;
            case (0, $58c87f0a382883df$export$6db955af9e6f8fcd).SET_INDEX:
                sortItems();
                index = nextIndex;
                newItem = items[index];
                break;
            case (0, $58c87f0a382883df$export$6db955af9e6f8fcd).INCREASE:
                sortItems();
                index = hoverIndex;
                if (index < 0) index = items.indexOf(item);
                index++;
                if (index >= items.length) index = 0;
                newItem = items[index];
                break;
            case (0, $58c87f0a382883df$export$6db955af9e6f8fcd).DECREASE:
                sortItems();
                index = hoverIndex;
                if (index < 0) index = items.indexOf(item);
                index--;
                if (index < 0) index = items.length - 1;
                newItem = items[index];
                break;
            default:
        }
        if (!newItem) index = -1;
        setHoverItem(newItem);
        mutableState.hoverIndex = index;
    }, [
        menuRef,
        mutableState
    ]);
    return {
        hoverItem: hoverItem,
        dispatch: dispatch,
        updateItems: updateItems
    };
};



var $2afa6911bbba886b$var$getNativeDimension = function(transformed, untransformed) {
    return Math.round(transformed) === untransformed ? transformed : untransformed;
};
var $2afa6911bbba886b$export$e34ab37ec351e6cb = function(element) {
    var rect = element.getBoundingClientRect();
    rect.width = $2afa6911bbba886b$var$getNativeDimension(rect.width, element.offsetWidth);
    rect.height = $2afa6911bbba886b$var$getNativeDimension(rect.height, element.offsetHeight);
    return rect;
};



var $8b929ad358cfd9d4$export$62e2806a96b09d4 = function(containerElt, menuElt, menuScroll, boundingBoxPadding) {
    var menuRect = (0, $2afa6911bbba886b$export$e34ab37ec351e6cb)(menuElt);
    var containerRect = containerElt.getBoundingClientRect();
    var boundingRect = menuScroll === window ? {
        left: 0,
        top: 0,
        right: document.documentElement.clientWidth,
        bottom: window.innerHeight
    } : menuScroll.getBoundingClientRect();
    var padding = (0, $26d9d16241653294$export$4bc3c325941e6f67)(boundingBoxPadding);
    var getLeftOverflow = function(x) {
        return x + containerRect.left - boundingRect.left - padding.left;
    };
    var getRightOverflow = function(x) {
        return x + containerRect.left + menuRect.width - boundingRect.right + padding.right;
    };
    var getTopOverflow = function(y) {
        return y + containerRect.top - boundingRect.top - padding.top;
    };
    var getBottomOverflow = function(y) {
        return y + containerRect.top + menuRect.height - boundingRect.bottom + padding.bottom;
    };
    var confineHorizontally = function(x) {
        var leftOverflow = getLeftOverflow(x);
        if (leftOverflow < 0) x -= leftOverflow;
        else {
            var rightOverflow = getRightOverflow(x);
            if (rightOverflow > 0) {
                x -= rightOverflow;
                leftOverflow = getLeftOverflow(x);
                if (leftOverflow < 0) x -= leftOverflow;
            }
        }
        return x;
    };
    var confineVertically = function(y) {
        var topOverflow = getTopOverflow(y);
        if (topOverflow < 0) y -= topOverflow;
        else {
            var bottomOverflow = getBottomOverflow(y);
            if (bottomOverflow > 0) {
                y -= bottomOverflow;
                topOverflow = getTopOverflow(y);
                if (topOverflow < 0) y -= topOverflow;
            }
        }
        return y;
    };
    return {
        menuRect: menuRect,
        containerRect: containerRect,
        getLeftOverflow: getLeftOverflow,
        getRightOverflow: getRightOverflow,
        getTopOverflow: getTopOverflow,
        getBottomOverflow: getBottomOverflow,
        confineHorizontally: confineHorizontally,
        confineVertically: confineVertically
    };
};



var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");
var $05310a17ea2b2524$export$95257ec7631d2e00 = function(param) {
    var arrowRef = param.arrowRef, menuY = param.menuY, anchorRect = param.anchorRect, containerRect = param.containerRect, menuRect = param.menuRect;
    var y = anchorRect.top - containerRect.top - menuY + anchorRect.height / 2;
    var offset = arrowRef.current.offsetHeight * 1.25;
    y = Math.max(offset, y);
    y = Math.min(y, menuRect.height - offset);
    return y;
};


var $76059ea6fcd093dd$export$f768fc0fa8f5878e = function(param) {
    var anchorRect = param.anchorRect, containerRect = param.containerRect, menuRect = param.menuRect, placeLeftorRightY = param.placeLeftorRightY, placeLeftX = param.placeLeftX, placeRightX = param.placeRightX, getLeftOverflow = param.getLeftOverflow, getRightOverflow = param.getRightOverflow, confineHorizontally = param.confineHorizontally, confineVertically = param.confineVertically, arrowRef = param.arrowRef, arrow = param.arrow, direction = param.direction, position = param.position;
    var computedDirection = direction;
    var y = placeLeftorRightY;
    if (position !== 'initial') {
        y = confineVertically(y);
        if (position === 'anchor') {
            y = Math.min(y, anchorRect.bottom - containerRect.top);
            y = Math.max(y, anchorRect.top - containerRect.top - menuRect.height);
        }
    }
    var x, leftOverflow, rightOverflow;
    if (computedDirection === 'left') {
        x = placeLeftX;
        if (position !== 'initial') {
            leftOverflow = getLeftOverflow(x);
            if (leftOverflow < 0) {
                rightOverflow = getRightOverflow(placeRightX);
                if (rightOverflow <= 0 || -leftOverflow > rightOverflow) {
                    x = placeRightX;
                    computedDirection = 'right';
                }
            }
        }
    } else {
        x = placeRightX;
        if (position !== 'initial') {
            rightOverflow = getRightOverflow(x);
            if (rightOverflow > 0) {
                leftOverflow = getLeftOverflow(placeLeftX);
                if (leftOverflow >= 0 || -leftOverflow < rightOverflow) {
                    x = placeLeftX;
                    computedDirection = 'left';
                }
            }
        }
    }
    if (position === 'auto') x = confineHorizontally(x);
    var arrowY = arrow ? (0, $05310a17ea2b2524$export$95257ec7631d2e00)({
        menuY: y,
        arrowRef: arrowRef,
        anchorRect: anchorRect,
        containerRect: containerRect,
        menuRect: menuRect
    }) : undefined;
    return {
        arrowY: arrowY,
        x: x,
        y: y,
        computedDirection: computedDirection
    };
};


var $9e8efa3f2dacf21c$export$4c9b3bcc0c46b8d3 = function(param) {
    var arrowRef = param.arrowRef, menuX = param.menuX, anchorRect = param.anchorRect, containerRect = param.containerRect, menuRect = param.menuRect;
    var x = anchorRect.left - containerRect.left - menuX + anchorRect.width / 2;
    var offset = arrowRef.current.offsetWidth * 1.25;
    x = Math.max(offset, x);
    x = Math.min(x, menuRect.width - offset);
    return x;
};


var $52c9fde4ec5d16c9$export$65848579d307fa3f = function(param) {
    var anchorRect = param.anchorRect, containerRect = param.containerRect, menuRect = param.menuRect, placeToporBottomX = param.placeToporBottomX, placeTopY = param.placeTopY, placeBottomY = param.placeBottomY, getTopOverflow = param.getTopOverflow, getBottomOverflow = param.getBottomOverflow, confineHorizontally = param.confineHorizontally, confineVertically = param.confineVertically, arrowRef = param.arrowRef, arrow = param.arrow, direction = param.direction, position = param.position;
    var computedDirection = direction === 'top' ? 'top' : 'bottom';
    var x = placeToporBottomX;
    if (position !== 'initial') {
        x = confineHorizontally(x);
        if (position === 'anchor') {
            x = Math.min(x, anchorRect.right - containerRect.left);
            x = Math.max(x, anchorRect.left - containerRect.left - menuRect.width);
        }
    }
    var y, topOverflow, bottomOverflow;
    if (computedDirection === 'top') {
        y = placeTopY;
        if (position !== 'initial') {
            topOverflow = getTopOverflow(y);
            if (topOverflow < 0) {
                bottomOverflow = getBottomOverflow(placeBottomY);
                if (bottomOverflow <= 0 || -topOverflow > bottomOverflow) {
                    y = placeBottomY;
                    computedDirection = 'bottom';
                }
            }
        }
    } else {
        y = placeBottomY;
        if (position !== 'initial') {
            bottomOverflow = getBottomOverflow(y);
            if (bottomOverflow > 0) {
                topOverflow = getTopOverflow(placeTopY);
                if (topOverflow >= 0 || -topOverflow < bottomOverflow) {
                    y = placeTopY;
                    computedDirection = 'top';
                }
            }
        }
    }
    if (position === 'auto') y = confineVertically(y);
    var arrowX = arrow ? (0, $9e8efa3f2dacf21c$export$4c9b3bcc0c46b8d3)({
        menuX: x,
        arrowRef: arrowRef,
        anchorRect: anchorRect,
        containerRect: containerRect,
        menuRect: menuRect
    }) : undefined;
    return {
        arrowX: arrowX,
        x: x,
        y: y,
        computedDirection: computedDirection
    };
};


var $b0de1945e2f0216b$export$5a6e2d3543ff3d7e = function(param) {
    var arrow = param.arrow, align = param.align, direction = param.direction, gap = param.gap, shift = param.shift, position = param.position, anchorRect = param.anchorRect, arrowRef = param.arrowRef, positionHelpers = param.positionHelpers;
    var menuRect = positionHelpers.menuRect, containerRect = positionHelpers.containerRect;
    var isHorizontal = direction === 'left' || direction === 'right';
    var horizontalOffset = isHorizontal ? gap : shift;
    var verticalOffset = isHorizontal ? shift : gap;
    if (arrow) {
        var arrowElt = arrowRef.current;
        if (isHorizontal) horizontalOffset += arrowElt.offsetWidth;
        else verticalOffset += arrowElt.offsetHeight;
    }
    var placeLeftX = anchorRect.left - containerRect.left - menuRect.width - horizontalOffset;
    var placeRightX = anchorRect.right - containerRect.left + horizontalOffset;
    var placeTopY = anchorRect.top - containerRect.top - menuRect.height - verticalOffset;
    var placeBottomY = anchorRect.bottom - containerRect.top + verticalOffset;
    var placeToporBottomX, placeLeftorRightY;
    if (align === 'end') {
        placeToporBottomX = anchorRect.right - containerRect.left - menuRect.width;
        placeLeftorRightY = anchorRect.bottom - containerRect.top - menuRect.height;
    } else if (align === 'center') {
        placeToporBottomX = anchorRect.left - containerRect.left - (menuRect.width - anchorRect.width) / 2;
        placeLeftorRightY = anchorRect.top - containerRect.top - (menuRect.height - anchorRect.height) / 2;
    } else {
        placeToporBottomX = anchorRect.left - containerRect.left;
        placeLeftorRightY = anchorRect.top - containerRect.top;
    }
    placeToporBottomX += horizontalOffset;
    placeLeftorRightY += verticalOffset;
    var options = (0, $9Jpjh._)((0, $lvTkn._)({}, positionHelpers), {
        anchorRect: anchorRect,
        placeLeftX: placeLeftX,
        placeRightX: placeRightX,
        placeLeftorRightY: placeLeftorRightY,
        placeTopY: placeTopY,
        placeBottomY: placeBottomY,
        placeToporBottomX: placeToporBottomX,
        arrowRef: arrowRef,
        arrow: arrow,
        direction: direction,
        position: position
    });
    switch(direction){
        case 'left':
        case 'right':
            return (0, $76059ea6fcd093dd$export$f768fc0fa8f5878e)(options);
        case 'top':
        case 'bottom':
        default:
            return (0, $52c9fde4ec5d16c9$export$65848579d307fa3f)(options);
    }
};



var $eHaBZ = parcelRequire("eHaBZ");
var $af284c5d86eb6f52$export$e5c5a5f917a5871c = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $eHaBZ.useLayoutEffect) : (0, $eHaBZ.useEffect);




var $eHaBZ = parcelRequire("eHaBZ");
function $f957e19c95cd0d58$var$setRef(ref, instance) {
    typeof ref === 'function' ? ref(instance) : ref.current = instance;
}
var $f957e19c95cd0d58$export$2d8be4568b07be94 = function(refA, refB) {
    return (0, $eHaBZ.useMemo)(function() {
        if (!refA) return refB;
        if (!refB) return refA;
        return function(instance) {
            $f957e19c95cd0d58$var$setRef(refA, instance);
            $f957e19c95cd0d58$var$setRef(refB, instance);
        };
    }, [
        refA,
        refB
    ]);
};


var $ae383b9f4118cf3a$var$offScreen = -9999;
var $ae383b9f4118cf3a$export$d4c4e98c5044dc8 = function(_param) {
    var ariaLabel = _param.ariaLabel, menuClassName = _param.menuClassName, menuStyle = _param.menuStyle, arrow = _param.arrow, _param_arrowProps = _param.arrowProps, arrowProps = _param_arrowProps === void 0 ? {} : _param_arrowProps, anchorPoint = _param.anchorPoint, anchorRef = _param.anchorRef, containerRef = _param.containerRef, containerProps = _param.containerProps, externalRef = _param.externalRef, parentScrollingRef = _param.parentScrollingRef, _param_align = _param.align, align = _param_align === void 0 ? 'start' : _param_align, _param_direction = _param.direction, direction = _param_direction === void 0 ? 'bottom' : _param_direction, _param_position = _param.position, position = _param_position === void 0 ? 'auto' : _param_position, _param_overflow = _param.overflow, overflow = _param_overflow === void 0 ? 'visible' : _param_overflow, setDownOverflow = _param.setDownOverflow, repositionFlag = _param.repositionFlag, _param_captureFocus = _param.captureFocus, captureFocus = _param_captureFocus === void 0 ? true : _param_captureFocus, state = _param.state, endTransition = _param.endTransition, isDisabled = _param.isDisabled, menuItemFocus = _param.menuItemFocus, _param_gap = _param.gap, gap = _param_gap === void 0 ? 0 : _param_gap, _param_shift = _param.shift, shift = _param_shift === void 0 ? 0 : _param_shift, children = _param.children, onClose = _param.onClose, _1 = _param.focusProps, restProps = (0, $aRv4I._)(_param, [
        "ariaLabel",
        "menuClassName",
        "menuStyle",
        "arrow",
        "arrowProps",
        "anchorPoint",
        "anchorRef",
        "containerRef",
        "containerProps",
        "externalRef",
        "parentScrollingRef",
        "align",
        "direction",
        "position",
        "overflow",
        "setDownOverflow",
        "repositionFlag",
        "captureFocus",
        "state",
        "endTransition",
        "isDisabled",
        "menuItemFocus",
        "gap",
        "shift",
        "children",
        "onClose",
        "focusProps"
    ]);
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)({
        x: $ae383b9f4118cf3a$var$offScreen,
        y: $ae383b9f4118cf3a$var$offScreen
    }), 2), menuPosition = _useState[0], setMenuPosition = _useState[1];
    var _useState1 = (0, $21h22._)((0, $eHaBZ.useState)({}), 2), arrowPosition = _useState1[0], setArrowPosition = _useState1[1];
    var _useState2 = (0, $21h22._)((0, $eHaBZ.useState)(), 2), overflowData = _useState2[0], setOverflowData = _useState2[1];
    var _useState3 = (0, $21h22._)((0, $eHaBZ.useState)(direction), 2), expandedDirection = _useState3[0], setExpandedDirection = _useState3[1];
    var _useState4 = (0, $21h22._)((0, $eHaBZ.useState)((0, $ac38d8c87becf7c6$export$fd76cd1ffdc0d698)), 1), submenuCtx = _useState4[0];
    var _useReducer = (0, $21h22._)((0, $eHaBZ.useReducer)(function(c) {
        return c + 1;
    }, 1), 2), reposSubmenu = _useReducer[0], forceReposSubmenu = _useReducer[1];
    var _useContext = (0, $eHaBZ.useContext)((0, $58c87f0a382883df$export$8fa45c82eddfe270)), transition = _useContext.transition, boundingBoxRef = _useContext.boundingBoxRef, boundingBoxPadding = _useContext.boundingBoxPadding, rootMenuRef = _useContext.rootMenuRef, rootAnchorRef = _useContext.rootAnchorRef, scrollNodesRef = _useContext.scrollNodesRef, reposition = _useContext.reposition, viewScroll = _useContext.viewScroll, submenuCloseDelay = _useContext.submenuCloseDelay;
    var _useContext1 = (0, $eHaBZ.useContext)((0, $58c87f0a382883df$export$1c2bdfb4407fdacf)), parentSubmenuCtx = _useContext1.submenuCtx, tmp = _useContext1.reposSubmenu, reposFlag = tmp === void 0 ? repositionFlag : tmp;
    var menuRef = (0, $eHaBZ.useRef)();
    var arrowRef = (0, $eHaBZ.useRef)();
    var prevOpen = (0, $eHaBZ.useRef)(false);
    var _useItems = (0, $6e2879dc867be080$export$7bfdd97581ca93c)(menuRef), hoverItem = _useItems.hoverItem, dispatch = _useItems.dispatch, updateItems = _useItems.updateItems;
    var isOpen = (0, $26d9d16241653294$export$30c2dce1a652e248)(state);
    var openTransition = (0, $26d9d16241653294$export$d5639c01d489b0c)(transition, 'open');
    var closeTransition = (0, $26d9d16241653294$export$d5639c01d489b0c)(transition, 'close');
    var scrollNodes = scrollNodesRef.current;
    var onKeyDown = function(e) {
        switch(e.key){
            case (0, $58c87f0a382883df$export$4b0075e5ea5e1f26).HOME:
                dispatch((0, $58c87f0a382883df$export$6db955af9e6f8fcd).FIRST);
                break;
            case (0, $58c87f0a382883df$export$4b0075e5ea5e1f26).END:
                dispatch((0, $58c87f0a382883df$export$6db955af9e6f8fcd).LAST);
                break;
            case (0, $58c87f0a382883df$export$4b0075e5ea5e1f26).UP:
                dispatch((0, $58c87f0a382883df$export$6db955af9e6f8fcd).DECREASE, hoverItem);
                break;
            case (0, $58c87f0a382883df$export$4b0075e5ea5e1f26).DOWN:
                dispatch((0, $58c87f0a382883df$export$6db955af9e6f8fcd).INCREASE, hoverItem);
                break;
            case (0, $58c87f0a382883df$export$4b0075e5ea5e1f26).SPACE:
                if (e.target && e.target.className.indexOf((0, $58c87f0a382883df$export$832250593589325a)) !== -1) e.preventDefault();
                return;
            default:
                return;
        }
        e.preventDefault();
        e.stopPropagation();
    };
    var onAnimationEnd = function() {
        if (state === 'closing') setOverflowData();
        (0, $26d9d16241653294$export$175e60bb96229ece)(endTransition);
    };
    var onPointerMove = function(e) {
        e.stopPropagation();
        submenuCtx.on(submenuCloseDelay, function() {
            dispatch((0, $58c87f0a382883df$export$6db955af9e6f8fcd).RESET);
            menuRef.current.focus((0, $58c87f0a382883df$export$42466afb37c6c021));
        });
    };
    var onPointerLeave = function(e) {
        if (e.target === e.currentTarget) submenuCtx.off();
    };
    var handlePosition = (0, $eHaBZ.useCallback)(function(noOverflowCheck) {
        var _anchorRef_current;
        var menuElt = menuRef.current;
        var containerElt = containerRef.current;
        if (!menuElt || !containerElt) return;
        var anchorRect = anchorRef ? (_anchorRef_current = anchorRef.current) === null || _anchorRef_current === void 0 ? void 0 : _anchorRef_current.getBoundingClientRect() : anchorPoint ? {
            left: anchorPoint.x,
            right: anchorPoint.x,
            top: anchorPoint.y,
            bottom: anchorPoint.y,
            width: 0,
            height: 0
        } : null;
        if (!anchorRect) return;
        if (!scrollNodes.menu) scrollNodes.menu = (boundingBoxRef ? boundingBoxRef.current : (0, $26d9d16241653294$export$7414735161c19437)(rootMenuRef.current)) || window;
        var positionHelpers = (0, $8b929ad358cfd9d4$export$62e2806a96b09d4)(containerElt, menuElt, scrollNodes.menu, boundingBoxPadding);
        var _positionMenu = (0, $b0de1945e2f0216b$export$5a6e2d3543ff3d7e)({
            arrow: arrow,
            align: align,
            direction: direction,
            gap: gap,
            shift: shift,
            position: position,
            anchorRect: anchorRect,
            arrowRef: arrowRef,
            positionHelpers: positionHelpers
        }), arrowX = _positionMenu.arrowX, arrowY = _positionMenu.arrowY, x = _positionMenu.x, y = _positionMenu.y, computedDirection = _positionMenu.computedDirection;
        var menuRect = positionHelpers.menuRect;
        var menuHeight = menuRect.height;
        if (!noOverflowCheck && overflow !== 'visible') {
            var getTopOverflow = positionHelpers.getTopOverflow, getBottomOverflow = positionHelpers.getBottomOverflow;
            var height, overflowAmt;
            var bottomOverflow = getBottomOverflow(y);
            if (bottomOverflow > 0) {
                height = menuHeight - bottomOverflow;
                overflowAmt = bottomOverflow;
            } else {
                var topOverflow = getTopOverflow(y);
                if (topOverflow < 0) {
                    height = menuHeight + topOverflow;
                    overflowAmt = 0 - topOverflow;
                    if (height >= 0) y -= topOverflow;
                }
            }
            if (height >= 0) setOverflowData({
                height: height,
                overflowAmt: overflowAmt
            });
        }
        if (arrow) setArrowPosition({
            x: arrowX,
            y: arrowY
        });
        setMenuPosition({
            x: x,
            y: y
        });
        setExpandedDirection(computedDirection);
    }, [
        arrow,
        align,
        boundingBoxPadding,
        direction,
        gap,
        shift,
        position,
        overflow,
        anchorPoint,
        anchorRef,
        containerRef,
        boundingBoxRef,
        rootMenuRef,
        scrollNodes
    ]);
    (0, $af284c5d86eb6f52$export$e5c5a5f917a5871c)(function() {
        if (isOpen) {
            handlePosition();
            if (prevOpen.current) forceReposSubmenu();
        }
        prevOpen.current = isOpen;
    }, [
        isOpen,
        handlePosition,
        reposFlag
    ]);
    (0, $af284c5d86eb6f52$export$e5c5a5f917a5871c)(function() {
        if (overflowData && !setDownOverflow) menuRef.current.scrollTop = 0;
    }, [
        overflowData,
        setDownOverflow
    ]);
    (0, $af284c5d86eb6f52$export$e5c5a5f917a5871c)(function() {
        return updateItems;
    }, [
        updateItems
    ]);
    (0, $eHaBZ.useEffect)(function() {
        var menuScroll = scrollNodes.menu;
        if (!isOpen || !menuScroll) return;
        menuScroll = menuScroll.addEventListener ? menuScroll : window;
        if (!scrollNodes.anchors) {
            scrollNodes.anchors = [];
            var anchorScroll = (0, $26d9d16241653294$export$7414735161c19437)(rootAnchorRef && rootAnchorRef.current);
            while(anchorScroll && anchorScroll !== menuScroll){
                scrollNodes.anchors.push(anchorScroll);
                anchorScroll = (0, $26d9d16241653294$export$7414735161c19437)(anchorScroll);
            }
        }
        var scroll = viewScroll;
        if (scrollNodes.anchors.length && scroll === 'initial') scroll = 'auto';
        if (scroll === 'initial') return;
        var handleScroll = function() {
            if (scroll === 'auto') (0, $26d9d16241653294$export$3e3e6d241f8feb60)(function() {
                return handlePosition(true);
            });
            else (0, $26d9d16241653294$export$175e60bb96229ece)(onClose, {
                reason: (0, $58c87f0a382883df$export$8fd8df51a9b835e6).SCROLL
            });
        };
        var scrollObservers = scrollNodes.anchors.concat(viewScroll !== 'initial' ? menuScroll : []);
        scrollObservers.forEach(function(o) {
            return o.addEventListener('scroll', handleScroll);
        });
        return function() {
            return scrollObservers.forEach(function(o) {
                return o.removeEventListener('scroll', handleScroll);
            });
        };
    }, [
        rootAnchorRef,
        scrollNodes,
        isOpen,
        onClose,
        viewScroll,
        handlePosition
    ]);
    var hasOverflow = !!overflowData && overflowData.overflowAmt > 0;
    (0, $eHaBZ.useEffect)(function() {
        if (hasOverflow || !isOpen || !parentScrollingRef) return;
        var handleScroll = function() {
            return (0, $26d9d16241653294$export$3e3e6d241f8feb60)(handlePosition);
        };
        var parentScroll = parentScrollingRef.current;
        parentScroll.addEventListener('scroll', handleScroll);
        return function() {
            return parentScroll.removeEventListener('scroll', handleScroll);
        };
    }, [
        isOpen,
        hasOverflow,
        parentScrollingRef,
        handlePosition
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (!isOpen || typeof ResizeObserver !== 'function' || reposition === 'initial') return;
        var targetList = [];
        var resizeObserver = new ResizeObserver(function(entries) {
            return entries.forEach(function(param) {
                var target = param.target;
                if (targetList.indexOf(target) < 0) targetList.push(target);
                else (0, $8afcda7f6e55ccf7$exports.flushSync)(function() {
                    handlePosition();
                    forceReposSubmenu();
                });
            });
        });
        var resizeObserverOptions = {
            box: 'border-box'
        };
        resizeObserver.observe(menuRef.current, resizeObserverOptions);
        var anchor = anchorRef === null || anchorRef === void 0 ? void 0 : anchorRef.current;
        anchor && resizeObserver.observe(anchor, resizeObserverOptions);
        return function() {
            return resizeObserver.disconnect();
        };
    }, [
        isOpen,
        reposition,
        anchorRef,
        handlePosition
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (!isOpen) {
            dispatch((0, $58c87f0a382883df$export$6db955af9e6f8fcd).RESET);
            if (!closeTransition) setOverflowData();
            return;
        }
        var _ref = menuItemFocus || {}, position = _ref.position, alwaysUpdate = _ref.alwaysUpdate;
        var setItemFocus = function() {
            if (position === (0, $58c87f0a382883df$export$8c6ccba1b6ce32e9).FIRST) dispatch((0, $58c87f0a382883df$export$6db955af9e6f8fcd).FIRST);
            else if (position === (0, $58c87f0a382883df$export$8c6ccba1b6ce32e9).LAST) dispatch((0, $58c87f0a382883df$export$6db955af9e6f8fcd).LAST);
            else if (position >= -1) dispatch((0, $58c87f0a382883df$export$6db955af9e6f8fcd).SET_INDEX, undefined, position);
        };
        if (alwaysUpdate) setItemFocus();
        else if (captureFocus) {
            var id = setTimeout(function() {
                var menuElt = menuRef.current;
                if (menuElt && !menuElt.contains(document.activeElement)) {
                    menuElt.focus((0, $58c87f0a382883df$export$42466afb37c6c021));
                    setItemFocus();
                }
            }, openTransition ? 170 : 100);
            return function() {
                return clearTimeout(id);
            };
        }
    }, [
        isOpen,
        openTransition,
        closeTransition,
        captureFocus,
        menuItemFocus,
        dispatch
    ]);
    var itemContext = (0, $eHaBZ.useMemo)(function() {
        return {
            isParentOpen: isOpen,
            submenuCtx: submenuCtx,
            dispatch: dispatch,
            updateItems: updateItems
        };
    }, [
        isOpen,
        submenuCtx,
        dispatch,
        updateItems
    ]);
    var maxHeight, overflowAmt;
    if (overflowData) setDownOverflow ? overflowAmt = overflowData.overflowAmt : maxHeight = overflowData.height;
    var listContext = (0, $eHaBZ.useMemo)(function() {
        return {
            reposSubmenu: reposSubmenu,
            submenuCtx: submenuCtx,
            overflow: overflow,
            overflowAmt: overflowAmt,
            parentMenuRef: menuRef,
            parentDir: expandedDirection
        };
    }, [
        reposSubmenu,
        submenuCtx,
        overflow,
        overflowAmt,
        expandedDirection
    ]);
    var overflowStyle = maxHeight >= 0 ? {
        maxHeight: maxHeight,
        overflow: overflow
    } : undefined;
    var modifiers = (0, $eHaBZ.useMemo)(function() {
        return {
            state: state,
            align: align,
            dir: expandedDirection
        };
    }, [
        state,
        align,
        expandedDirection
    ]);
    var arrowModifiers = (0, $eHaBZ.useMemo)(function() {
        return {
            dir: expandedDirection
        };
    }, [
        expandedDirection
    ]);
    var _arrowClassName = (0, $f6b66376b7c99589$export$7ae630fe844fbd1f)({
        block: (0, $58c87f0a382883df$export$832250593589325a),
        element: (0, $58c87f0a382883df$export$3b35f0f35c840df9),
        modifiers: arrowModifiers,
        className: arrowProps.className
    });
    var menu = /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", (0, $9Jpjh._)((0, $lvTkn._)({
        role: "menu",
        "aria-label": ariaLabel
    }, (0, $26d9d16241653294$export$ffb2d5922287e12)(isDisabled), (0, $26d9d16241653294$export$9d1611c77c2fe928)({
        onPointerEnter: parentSubmenuCtx === null || parentSubmenuCtx === void 0 ? void 0 : parentSubmenuCtx.off,
        onPointerMove: onPointerMove,
        onPointerLeave: onPointerLeave,
        onKeyDown: onKeyDown,
        onAnimationEnd: onAnimationEnd
    }, restProps)), {
        ref: (0, $f957e19c95cd0d58$export$2d8be4568b07be94)(externalRef, menuRef),
        className: (0, $f6b66376b7c99589$export$7ae630fe844fbd1f)({
            block: (0, $58c87f0a382883df$export$832250593589325a),
            modifiers: modifiers,
            className: menuClassName
        }),
        style: (0, $9Jpjh._)((0, $lvTkn._)({}, menuStyle, overflowStyle), {
            margin: 0,
            display: state === 'closed' ? 'none' : undefined,
            position: (0, $58c87f0a382883df$export$f8d144aafbd3a470),
            left: menuPosition.x,
            top: menuPosition.y
        }),
        children: [
            arrow && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", (0, $9Jpjh._)((0, $lvTkn._)({
                "aria-hidden": true
            }, arrowProps), {
                className: _arrowClassName,
                style: (0, $lvTkn._)({
                    display: 'block',
                    position: (0, $58c87f0a382883df$export$f8d144aafbd3a470),
                    left: arrowPosition.x,
                    top: arrowPosition.y
                }, arrowProps.style),
                ref: arrowRef
            })),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $58c87f0a382883df$export$1c2bdfb4407fdacf).Provider, {
                value: listContext,
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $58c87f0a382883df$export$7cb023214e4bda1e).Provider, {
                    value: itemContext,
                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $58c87f0a382883df$export$15c1690330cd94e).Provider, {
                        value: hoverItem,
                        children: (0, $26d9d16241653294$export$175e60bb96229ece)(children, modifiers)
                    })
                })
            })
        ]
    }));
    return containerProps ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $e4ff2b7984f354ae$export$b286f91cddfedb5a), (0, $9Jpjh._)((0, $lvTkn._)({}, containerProps), {
        isOpen: isOpen,
        children: menu
    })) : menu;
};





var $d50ef49fb283cf3d$export$a5a70f2f059d02ee = /*#__PURE__*/ (0, $eHaBZ.forwardRef)(function ControlledMenu(_param, externalRef) {
    var ariaLabel = _param['aria-label'], className = _param.className, containerProps = _param.containerProps, initialMounted = _param.initialMounted, unmountOnClose = _param.unmountOnClose, transition = _param.transition, transitionTimeout = _param.transitionTimeout, boundingBoxRef = _param.boundingBoxRef, boundingBoxPadding = _param.boundingBoxPadding, _param_reposition = _param.reposition, reposition = _param_reposition === void 0 ? 'auto' : _param_reposition, _param_submenuOpenDelay = _param.submenuOpenDelay, submenuOpenDelay = _param_submenuOpenDelay === void 0 ? 300 : _param_submenuOpenDelay, _param_submenuCloseDelay = _param.submenuCloseDelay, submenuCloseDelay = _param_submenuCloseDelay === void 0 ? 150 : _param_submenuCloseDelay, _param_viewScroll = _param.viewScroll, viewScroll = _param_viewScroll === void 0 ? 'initial' : _param_viewScroll, portal = _param.portal, theming = _param.theming, onItemClick = _param.onItemClick, restProps = (0, $aRv4I._)(_param, [
        'aria-label',
        "className",
        "containerProps",
        "initialMounted",
        "unmountOnClose",
        "transition",
        "transitionTimeout",
        "boundingBoxRef",
        "boundingBoxPadding",
        "reposition",
        "submenuOpenDelay",
        "submenuCloseDelay",
        "viewScroll",
        "portal",
        "theming",
        "onItemClick"
    ]);
    var containerRef = (0, $eHaBZ.useRef)(null);
    var scrollNodesRef = (0, $eHaBZ.useRef)({});
    var anchorRef = restProps.anchorRef, state = restProps.state, onClose = restProps.onClose;
    var settings = (0, $eHaBZ.useMemo)(function() {
        return {
            initialMounted: initialMounted,
            unmountOnClose: unmountOnClose,
            transition: transition,
            transitionTimeout: transitionTimeout,
            boundingBoxRef: boundingBoxRef,
            boundingBoxPadding: boundingBoxPadding,
            rootMenuRef: containerRef,
            rootAnchorRef: anchorRef,
            scrollNodesRef: scrollNodesRef,
            reposition: reposition,
            viewScroll: viewScroll,
            submenuOpenDelay: submenuOpenDelay,
            submenuCloseDelay: submenuCloseDelay
        };
    }, [
        initialMounted,
        unmountOnClose,
        transition,
        transitionTimeout,
        anchorRef,
        boundingBoxRef,
        boundingBoxPadding,
        reposition,
        viewScroll,
        submenuOpenDelay,
        submenuCloseDelay
    ]);
    var eventHandlers = (0, $eHaBZ.useMemo)(function() {
        return {
            handleClick: function(event, isCheckorRadio) {
                if (!event.stopPropagation) (0, $26d9d16241653294$export$175e60bb96229ece)(onItemClick, event);
                var keepOpen = event.keepOpen;
                if (keepOpen === undefined) keepOpen = isCheckorRadio && event.key === (0, $58c87f0a382883df$export$4b0075e5ea5e1f26).SPACE;
                if (!keepOpen) (0, $26d9d16241653294$export$175e60bb96229ece)(onClose, {
                    value: event.value,
                    key: event.key,
                    reason: (0, $58c87f0a382883df$export$8fd8df51a9b835e6).CLICK
                });
            },
            handleClose: function(key) {
                (0, $26d9d16241653294$export$175e60bb96229ece)(onClose, {
                    key: key,
                    reason: (0, $58c87f0a382883df$export$8fd8df51a9b835e6).CLICK
                });
            }
        };
    }, [
        onItemClick,
        onClose
    ]);
    if (!state) return null;
    var menuList = /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $58c87f0a382883df$export$8fa45c82eddfe270).Provider, {
        value: settings,
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $58c87f0a382883df$export$ee9f2ec6c8119c2a).Provider, {
            value: eventHandlers,
            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $ae383b9f4118cf3a$export$d4c4e98c5044dc8), (0, $9Jpjh._)((0, $lvTkn._)({}, restProps), {
                ariaLabel: ariaLabel || 'Menu',
                externalRef: externalRef,
                containerRef: containerRef,
                containerProps: {
                    className: className,
                    containerRef: containerRef,
                    containerProps: containerProps,
                    theming: theming,
                    transition: transition,
                    onClose: onClose
                }
            }))
        })
    });
    if (portal === true && typeof document !== 'undefined') return /*#__PURE__*/ (0, $8afcda7f6e55ccf7$exports.createPortal)(menuList, document.body);
    else if (portal) return portal.target ? /*#__PURE__*/ (0, $8afcda7f6e55ccf7$exports.createPortal)(menuList, portal.target) : portal.stablePosition ? null : menuList;
    return menuList;
});




var $lvTkn = parcelRequire("lvTkn");

var $21h22 = parcelRequire("21h22");

var $eHaBZ = parcelRequire("eHaBZ");

var $21h22 = parcelRequire("21h22");

var $eHaBZ = parcelRequire("eHaBZ");

var $21h22 = parcelRequire("21h22");

var $eHaBZ = parcelRequire("eHaBZ");

var $2bfPH = parcelRequire("2bfPH");
var $9e97f46350063e18$export$3a9d054b510f1baf = 0;
var $9e97f46350063e18$export$df38205c966be359 = 1;
var $9e97f46350063e18$export$78e9e6e3e014d60a = 2;
var $9e97f46350063e18$export$6f37f73bf74e3970 = 3;
var $9e97f46350063e18$export$4aacc83d4d59139f = 4;
var $9e97f46350063e18$export$84cbff306f539230 = 5;
var $9e97f46350063e18$export$bb38bb9a1161268 = 6;
var $9e97f46350063e18$export$e50006273435e7d4 = [
    'preEnter',
    'entering',
    'entered',
    'preExit',
    'exiting',
    'exited',
    'unmounted'
];
var $9e97f46350063e18$export$50fdfeece43146fd = function(status) {
    return {
        _s: status,
        status: $9e97f46350063e18$export$e50006273435e7d4[status],
        isEnter: status < $9e97f46350063e18$export$6f37f73bf74e3970,
        isMounted: status !== $9e97f46350063e18$export$bb38bb9a1161268,
        isResolved: status === $9e97f46350063e18$export$78e9e6e3e014d60a || status > $9e97f46350063e18$export$4aacc83d4d59139f
    };
};
var $9e97f46350063e18$export$eb0971344425f03e = function(unmounted) {
    return unmounted ? $9e97f46350063e18$export$bb38bb9a1161268 : $9e97f46350063e18$export$84cbff306f539230;
};
var $9e97f46350063e18$export$c9efa50dd559122e = function(status, unmountOnExit) {
    switch(status){
        case $9e97f46350063e18$export$df38205c966be359:
        case $9e97f46350063e18$export$3a9d054b510f1baf:
            return $9e97f46350063e18$export$78e9e6e3e014d60a;
        case $9e97f46350063e18$export$4aacc83d4d59139f:
        case $9e97f46350063e18$export$6f37f73bf74e3970:
            return $9e97f46350063e18$export$eb0971344425f03e(unmountOnExit);
    }
};
var $9e97f46350063e18$export$d2e3f47e67110e3a = function(timeout) {
    return (typeof timeout === "undefined" ? "undefined" : (0, $2bfPH._)(timeout)) === 'object' ? [
        timeout.enter,
        timeout.exit
    ] : [
        timeout,
        timeout
    ];
};
var $9e97f46350063e18$export$bdd553fddd433dcb = function(transitState, status) {
    return setTimeout(function() {
        // Reading document.body.offsetTop can force browser to repaint before transition to the next state
        isNaN(document.body.offsetTop) || transitState(status + 1);
    }, 0);
};


var $b71094ba6bd2b7e2$var$updateState = function(status, setState, latestState, timeoutId, onChange) {
    clearTimeout(timeoutId.current);
    var state = (0, $9e97f46350063e18$export$50fdfeece43146fd)(status);
    setState(state);
    latestState.current = state;
    onChange && onChange({
        current: state
    });
};
var $b71094ba6bd2b7e2$export$d2a0a1bc267c90f6 = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_enter = _ref.enter, enter = _ref_enter === void 0 ? true : _ref_enter, _ref_exit = _ref.exit, exit = _ref_exit === void 0 ? true : _ref_exit, preEnter = _ref.preEnter, preExit = _ref.preExit, timeout = _ref.timeout, initialEntered = _ref.initialEntered, mountOnEnter = _ref.mountOnEnter, unmountOnExit = _ref.unmountOnExit, onChange = _ref.onStateChange;
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(function() {
        return (0, $9e97f46350063e18$export$50fdfeece43146fd)(initialEntered ? (0, $9e97f46350063e18$export$78e9e6e3e014d60a) : (0, $9e97f46350063e18$export$eb0971344425f03e)(mountOnEnter));
    }), 2), state = _useState[0], setState = _useState[1];
    var latestState = (0, $eHaBZ.useRef)(state);
    var timeoutId = (0, $eHaBZ.useRef)();
    var _getTimeout = (0, $21h22._)((0, $9e97f46350063e18$export$d2e3f47e67110e3a)(timeout), 2), enterTimeout = _getTimeout[0], exitTimeout = _getTimeout[1];
    var endTransition = (0, $eHaBZ.useCallback)(function() {
        var status = (0, $9e97f46350063e18$export$c9efa50dd559122e)(latestState.current._s, unmountOnExit);
        status && $b71094ba6bd2b7e2$var$updateState(status, setState, latestState, timeoutId, onChange);
    }, [
        onChange,
        unmountOnExit
    ]);
    var toggle = (0, $eHaBZ.useCallback)(function(toEnter) {
        var transitState = function(status) {
            $b71094ba6bd2b7e2$var$updateState(status, setState, latestState, timeoutId, onChange);
            switch(status){
                case 0, $9e97f46350063e18$export$df38205c966be359:
                    if (enterTimeout >= 0) timeoutId.current = setTimeout(endTransition, enterTimeout);
                    break;
                case 0, $9e97f46350063e18$export$4aacc83d4d59139f:
                    if (exitTimeout >= 0) timeoutId.current = setTimeout(endTransition, exitTimeout);
                    break;
                case 0, $9e97f46350063e18$export$3a9d054b510f1baf:
                case 0, $9e97f46350063e18$export$6f37f73bf74e3970:
                    timeoutId.current = (0, $9e97f46350063e18$export$bdd553fddd433dcb)(transitState, status);
                    break;
            }
        };
        var enterStage = latestState.current.isEnter;
        if (typeof toEnter !== 'boolean') toEnter = !enterStage;
        if (toEnter) !enterStage && transitState(enter ? preEnter ? (0, $9e97f46350063e18$export$3a9d054b510f1baf) : (0, $9e97f46350063e18$export$df38205c966be359) : (0, $9e97f46350063e18$export$78e9e6e3e014d60a));
        else enterStage && transitState(exit ? preExit ? (0, $9e97f46350063e18$export$6f37f73bf74e3970) : (0, $9e97f46350063e18$export$4aacc83d4d59139f) : (0, $9e97f46350063e18$export$eb0971344425f03e)(unmountOnExit));
    }, [
        endTransition,
        onChange,
        enter,
        exit,
        preEnter,
        preExit,
        enterTimeout,
        exitTimeout,
        unmountOnExit
    ]);
    return [
        state,
        toggle,
        endTransition
    ];
};




var $30e9b4b14afc2f63$export$8091e3849c182a6 = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, initialOpen = _ref.initialOpen, initialMounted = _ref.initialMounted, unmountOnClose = _ref.unmountOnClose, transition = _ref.transition, _ref_transitionTimeout = _ref.transitionTimeout, transitionTimeout = _ref_transitionTimeout === void 0 ? 500 : _ref_transitionTimeout, onMenuChange = _ref.onMenuChange;
    var enter = (0, $26d9d16241653294$export$d5639c01d489b0c)(transition, 'open');
    var exit = (0, $26d9d16241653294$export$d5639c01d489b0c)(transition, 'close');
    var _useTransitionState = (0, $21h22._)((0, $b71094ba6bd2b7e2$export$d2a0a1bc267c90f6)({
        initialEntered: initialOpen,
        mountOnEnter: !initialMounted,
        unmountOnExit: unmountOnClose,
        timeout: transitionTimeout,
        enter: enter,
        exit: exit,
        onStateChange: (0, $eHaBZ.useCallback)(function(param) {
            var _param_current = param.current, isEnter = _param_current.isEnter, isResolved = _param_current.isResolved;
            if (!onMenuChange || isEnter && enter && isResolved || !isEnter && exit && isResolved) return;
            onMenuChange({
                open: isEnter
            });
        }, [
            onMenuChange,
            enter,
            exit
        ])
    }), 3), status = _useTransitionState[0].status, toggleMenu = _useTransitionState[1], endTransition = _useTransitionState[2];
    return [
        {
            state: (0, $58c87f0a382883df$export$be1d8b0328ba66b6)[status],
            endTransition: endTransition
        },
        toggleMenu
    ];
};


var $d0d1673bf8b7f4ca$export$1668883ac2d8e856 = function(options) {
    var _useMenuState = (0, $21h22._)((0, $30e9b4b14afc2f63$export$8091e3849c182a6)(options), 2), menuProps = _useMenuState[0], toggleMenu = _useMenuState[1];
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(), 2), menuItemFocus = _useState[0], setMenuItemFocus = _useState[1];
    var openMenu = function(position, alwaysUpdate) {
        setMenuItemFocus({
            position: position,
            alwaysUpdate: alwaysUpdate
        });
        toggleMenu(true);
    };
    return [
        (0, $lvTkn._)({
            menuItemFocus: menuItemFocus
        }, menuProps),
        toggleMenu,
        openMenu
    ];
};



var $21h22 = parcelRequire("21h22");

var $eHaBZ = parcelRequire("eHaBZ");
var $8bc7c70fc0c0157f$export$98524f11226063fc = function(state, onToggle) {
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)({}), 1), skipOpen = _useState[0];
    return {
        onMouseDown: function() {
            skipOpen.v = state && state !== 'closed';
        },
        onClick: function(e) {
            return skipOpen.v ? skipOpen.v = false : onToggle(true, e);
        }
    };
};





var $afcad17a77b29a48$var$isLegacyReact = parseInt((0, $eHaBZ.version)) < 19;
var $afcad17a77b29a48$export$d9b273488cd8ce6f = /*#__PURE__*/ (0, $eHaBZ.forwardRef)(function Menu(_param, externalRef) {
    var ariaLabel = _param['aria-label'], _ = _param.captureFocus, _1 = _param.initialOpen, menuButton = _param.menuButton, instanceRef = _param.instanceRef, onMenuChange = _param.onMenuChange, restProps = (0, $aRv4I._)(_param, [
        'aria-label',
        "captureFocus",
        "initialOpen",
        "menuButton",
        "instanceRef",
        "onMenuChange"
    ]);
    var _useMenuStateAndFocus = (0, $21h22._)((0, $d0d1673bf8b7f4ca$export$1668883ac2d8e856)((0, $9Jpjh._)((0, $lvTkn._)({}, restProps), {
        onMenuChange: onMenuChange
    })), 3), stateProps = _useMenuStateAndFocus[0], toggleMenu = _useMenuStateAndFocus[1], openMenu = _useMenuStateAndFocus[2];
    var state = stateProps.state;
    var isOpen = (0, $26d9d16241653294$export$30c2dce1a652e248)(state);
    var buttonRef = (0, $eHaBZ.useRef)(null);
    var anchorProps = (0, $8bc7c70fc0c0157f$export$98524f11226063fc)(state, function(_, e) {
        return openMenu(!e.detail ? (0, $58c87f0a382883df$export$8c6ccba1b6ce32e9).FIRST : undefined);
    });
    var handleClose = (0, $eHaBZ.useCallback)(function(e) {
        toggleMenu(false);
        if (e.key) buttonRef.current.focus();
    }, [
        toggleMenu
    ]);
    var onKeyDown = function(e) {
        switch(e.key){
            case (0, $58c87f0a382883df$export$4b0075e5ea5e1f26).UP:
                openMenu((0, $58c87f0a382883df$export$8c6ccba1b6ce32e9).LAST);
                break;
            case (0, $58c87f0a382883df$export$4b0075e5ea5e1f26).DOWN:
                openMenu((0, $58c87f0a382883df$export$8c6ccba1b6ce32e9).FIRST);
                break;
            default:
                return;
        }
        e.preventDefault();
    };
    var button = (0, $26d9d16241653294$export$175e60bb96229ece)(menuButton, {
        open: isOpen
    });
    if (!button || !button.type) throw new Error('Menu requires a menuButton prop.');
    var buttonProps = (0, $9Jpjh._)((0, $lvTkn._)({}, (0, $26d9d16241653294$export$9d1611c77c2fe928)((0, $lvTkn._)({
        onKeyDown: onKeyDown
    }, anchorProps), button.props)), {
        ref: (0, $f957e19c95cd0d58$export$2d8be4568b07be94)($afcad17a77b29a48$var$isLegacyReact ? button.ref : button.props.ref, buttonRef)
    });
    if ((0, $26d9d16241653294$export$7d9f7e9c1c02b41e)(button.type) === 'MenuButton') buttonProps.isOpen = isOpen;
    var renderButton = /*#__PURE__*/ (0, $eHaBZ.cloneElement)(button, buttonProps);
    (0, $eHaBZ.useImperativeHandle)(instanceRef, function() {
        return {
            openMenu: openMenu,
            closeMenu: function() {
                return toggleMenu(false);
            }
        };
    });
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $eHaBZ.Fragment), {
        children: [
            renderButton,
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $d50ef49fb283cf3d$export$a5a70f2f059d02ee), (0, $9Jpjh._)((0, $lvTkn._)({}, restProps, stateProps), {
                "aria-label": ariaLabel || (typeof button.props.children === 'string' ? button.props.children : 'Menu'),
                anchorRef: buttonRef,
                ref: externalRef,
                onClose: handleClose
            }))
        ]
    });
});


var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $aRv4I = parcelRequire("aRv4I");

var $eHaBZ = parcelRequire("eHaBZ");




var $7a4ada20cb42c4ac$export$266a769812832828 = /*#__PURE__*/ (0, $26d9d16241653294$export$4c4bf90f1b4d3105)('MenuButton', /*#__PURE__*/ (0, $eHaBZ.forwardRef)(function MenuButton(_param, ref) {
    var className = _param.className, isOpen = _param.isOpen, disabled = _param.disabled, children = _param.children, restProps = (0, $aRv4I._)(_param, [
        "className",
        "isOpen",
        "disabled",
        "children"
    ]);
    var modifiers = (0, $eHaBZ.useMemo)(function() {
        return {
            open: isOpen
        };
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", (0, $9Jpjh._)((0, $lvTkn._)({
        "aria-haspopup": true,
        "aria-expanded": isOpen,
        "aria-disabled": disabled || undefined,
        type: "button",
        disabled: disabled
    }, restProps), {
        ref: ref,
        className: (0, $f6b66376b7c99589$export$7ae630fe844fbd1f)({
            block: (0, $58c87f0a382883df$export$b3d82f113f746a0),
            modifiers: modifiers,
            className: className
        }),
        children: children
    }));
}));


var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $aRv4I = parcelRequire("aRv4I");

var $eHaBZ = parcelRequire("eHaBZ");


var $21h22 = parcelRequire("21h22");

var $eHaBZ = parcelRequire("eHaBZ");

var $1a1689b7e04c7524$export$68b1d6ee802c4a06 = function(isDisabled, itemRef, updateItems) {
    (0, $af284c5d86eb6f52$export$e5c5a5f917a5871c)(function() {
        if (isDisabled) return;
        var item = itemRef.current;
        updateItems(item, true);
        return function() {
            updateItems(item);
        };
    }, [
        isDisabled,
        itemRef,
        updateItems
    ]);
};



var $21h22 = parcelRequire("21h22");

var $eHaBZ = parcelRequire("eHaBZ");
var $a2c76f66dfdb0454$export$77d6bee280bb6d2 = function(isHovering) {
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), mouseOver = _useState[0], setMouseOver = _useState[1];
    (0, $eHaBZ.useEffect)(function() {
        !isHovering && setMouseOver(false);
    }, [
        isHovering
    ]);
    return [
        mouseOver,
        function() {
            return !mouseOver && setMouseOver(true);
        },
        function() {
            return setMouseOver(false);
        }
    ];
};



var $973c1de5fd19589d$export$c75b31607cdc621e = function(itemRef, focusRef, isHovering, isDisabled) {
    var _useMouseOver = (0, $21h22._)((0, $a2c76f66dfdb0454$export$77d6bee280bb6d2)(isHovering), 3), mouseOver = _useMouseOver[0], mouseOverStart = _useMouseOver[1], mouseOverEnd = _useMouseOver[2];
    var submenuCloseDelay = (0, $eHaBZ.useContext)((0, $58c87f0a382883df$export$8fa45c82eddfe270)).submenuCloseDelay;
    var _useContext = (0, $eHaBZ.useContext)((0, $58c87f0a382883df$export$7cb023214e4bda1e)), isParentOpen = _useContext.isParentOpen, submenuCtx = _useContext.submenuCtx, dispatch = _useContext.dispatch, updateItems = _useContext.updateItems;
    var setHover = function() {
        !isHovering && !isDisabled && dispatch((0, $58c87f0a382883df$export$6db955af9e6f8fcd).SET, itemRef.current);
    };
    var unsetHover = function() {
        !isDisabled && dispatch((0, $58c87f0a382883df$export$6db955af9e6f8fcd).UNSET, itemRef.current);
    };
    var onBlur = function(e) {
        if (isHovering && !e.currentTarget.contains(e.relatedTarget)) unsetHover();
    };
    var onPointerMove = function(e) {
        if (!isDisabled) {
            e.stopPropagation();
            mouseOverStart();
            submenuCtx.on(submenuCloseDelay, setHover, setHover);
        }
    };
    var onPointerLeave = function(_, keepHover) {
        mouseOverEnd();
        submenuCtx.off();
        !keepHover && unsetHover();
    };
    (0, $1a1689b7e04c7524$export$68b1d6ee802c4a06)(isDisabled, itemRef, updateItems);
    (0, $eHaBZ.useEffect)(function() {
        if (isHovering && isParentOpen) focusRef.current && focusRef.current.focus();
    }, [
        focusRef,
        isHovering,
        isParentOpen
    ]);
    return {
        mouseOver: mouseOver,
        setHover: setHover,
        onBlur: onBlur,
        onPointerMove: onPointerMove,
        onPointerLeave: onPointerLeave
    };
};






var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $eHaBZ = parcelRequire("eHaBZ");


var $aba9cdbf0183030f$export$9f154fa70a6daa25 = function(name, WrappedComponent) {
    var Component = /*#__PURE__*/ (0, $eHaBZ.memo)(WrappedComponent);
    var WithHovering = /*#__PURE__*/ (0, $eHaBZ.forwardRef)(function(props, ref) {
        var itemRef = (0, $eHaBZ.useRef)(null);
        return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)(Component, (0, $9Jpjh._)((0, $lvTkn._)({}, props), {
            itemRef: itemRef,
            externalRef: ref,
            isHovering: (0, $eHaBZ.useContext)((0, $58c87f0a382883df$export$15c1690330cd94e)) === itemRef.current
        }));
    });
    WithHovering.displayName = "WithHovering(".concat(name, ")");
    return WithHovering;
};



var $196651884997e353$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $aba9cdbf0183030f$export$9f154fa70a6daa25)('MenuItem', function MenuItem(_param) {
    var className = _param.className, value = _param.value, href = _param.href, type = _param.type, checked = _param.checked, disabled = _param.disabled, children = _param.children, onClick = _param.onClick, isHovering = _param.isHovering, itemRef = _param.itemRef, externalRef = _param.externalRef, restProps = (0, $aRv4I._)(_param, [
        "className",
        "value",
        "href",
        "type",
        "checked",
        "disabled",
        "children",
        "onClick",
        "isHovering",
        "itemRef",
        "externalRef"
    ]);
    var isDisabled = !!disabled;
    var _useItemState = (0, $973c1de5fd19589d$export$c75b31607cdc621e)(itemRef, itemRef, isHovering, isDisabled), mouseOver = _useItemState.mouseOver, setHover = _useItemState.setHover, restStateProps = (0, $aRv4I._)(_useItemState, [
        "mouseOver",
        "setHover"
    ]);
    var eventHandlers = (0, $eHaBZ.useContext)((0, $58c87f0a382883df$export$ee9f2ec6c8119c2a));
    var radioGroup = (0, $eHaBZ.useContext)((0, $58c87f0a382883df$export$a79eda4ff50e30b6));
    var isRadio = type === 'radio';
    var isCheckBox = type === 'checkbox';
    var isAnchor = !!href && !isDisabled && !isRadio && !isCheckBox;
    var isChecked = isRadio ? radioGroup.value === value : isCheckBox ? !!checked : false;
    var handleClick = function(e) {
        if (isDisabled) {
            e.stopPropagation();
            e.preventDefault();
            return;
        }
        var event = {
            value: value,
            syntheticEvent: e
        };
        if (e.key !== undefined) event.key = e.key;
        if (isCheckBox) event.checked = !isChecked;
        if (isRadio) event.name = radioGroup.name;
        (0, $26d9d16241653294$export$175e60bb96229ece)(onClick, event);
        if (isRadio) (0, $26d9d16241653294$export$175e60bb96229ece)(radioGroup.onRadioChange, event);
        eventHandlers.handleClick(event, isCheckBox || isRadio);
    };
    var handleKeyDown = function(e) {
        if (!isHovering) return;
        switch(e.key){
            case (0, $58c87f0a382883df$export$4b0075e5ea5e1f26).ENTER:
                e.preventDefault();
            case (0, $58c87f0a382883df$export$4b0075e5ea5e1f26).SPACE:
                isAnchor ? itemRef.current.click() : handleClick(e);
        }
    };
    var modifiers = (0, $eHaBZ.useMemo)(function() {
        return {
            type: type,
            disabled: isDisabled,
            hover: mouseOver || isHovering,
            checked: isChecked,
            anchor: isAnchor
        };
    }, [
        type,
        isDisabled,
        mouseOver,
        isHovering,
        isChecked,
        isAnchor
    ]);
    var mergedProps = (0, $26d9d16241653294$export$9d1611c77c2fe928)((0, $9Jpjh._)((0, $lvTkn._)({}, restStateProps), {
        onPointerDown: setHover,
        onKeyDown: handleKeyDown,
        onClick: handleClick
    }), restProps);
    var menuItemProps = (0, $9Jpjh._)((0, $lvTkn._)({
        role: isRadio ? 'menuitemradio' : isCheckBox ? 'menuitemcheckbox' : (0, $58c87f0a382883df$export$3e982710469daaf),
        'aria-checked': isRadio || isCheckBox ? isChecked : undefined
    }, (0, $26d9d16241653294$export$ffb2d5922287e12)(isDisabled, isHovering), mergedProps), {
        ref: (0, $f957e19c95cd0d58$export$2d8be4568b07be94)(externalRef, itemRef),
        className: (0, $f6b66376b7c99589$export$7ae630fe844fbd1f)({
            block: (0, $58c87f0a382883df$export$832250593589325a),
            element: (0, $58c87f0a382883df$export$b5a3c9a9995a8c24),
            modifiers: modifiers,
            className: className
        }),
        children: (0, $eHaBZ.useMemo)(function() {
            return (0, $26d9d16241653294$export$175e60bb96229ece)(children, modifiers);
        }, [
            children,
            modifiers
        ])
    });
    return isAnchor ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
        role: (0, $58c87f0a382883df$export$a5a9d7469a9cc520),
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("a", (0, $lvTkn._)({
            href: href
        }, menuItemProps))
    }) : /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", (0, $lvTkn._)({}, menuItemProps));
});



var $5XYIU = parcelRequire("5XYIU");
/**
 * @callback completeCallback
 */ /**
 * @typedef {Object} Options
 * @property {number} [duration]
 * @property {string} [easing]
 * @property {completeCallback} [complete]
 */ /**
 * @param {Element} element
 * @param {Object.<string, string>} properties
 * @param {completeCallback} complete
 */ function $7ef98d8c594793a5$var$fadeComplete(element, properties, complete) {
    if (properties.transition) element.style.transition = properties.transition;
    else element.style.removeProperty('transition');
    if (properties.opacity) element.style.opacity = properties.opacity;
    else element.style.removeProperty('opacity');
    if (complete) complete();
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $7ef98d8c594793a5$export$82e6205b15e6c637(element) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var o = $7ef98d8c594793a5$var$getOptions(options);
    var properties = {
        transition: element.style.transition || undefined,
        opacity: element.style.opacity || undefined
    };
    // styles necessary for the animation
    if (!element.style.opacity) element.style.opacity = 0;
    element.style.removeProperty('display');
    element.style.transition = "opacity ".concat(o.duration / 1000, "s ").concat(o.easing);
    requestAnimationFrame(function() {
        element.style.opacity = 1;
    });
    setTimeout(function() {
        $7ef98d8c594793a5$var$fadeComplete(element, properties, o.complete);
    }, o.duration);
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $7ef98d8c594793a5$export$c091916f1530334c(element) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var o = $7ef98d8c594793a5$var$getOptions(options);
    var properties = {
        transition: element.style.transition || undefined,
        opacity: element.style.opacity || undefined
    };
    // styles necessary for the animation
    if (!element.style.opacity) element.style.opacity = 1;
    element.style.transition = "opacity ".concat(o.duration / 1000, "s ").concat(o.easing);
    requestAnimationFrame(function() {
        element.style.opacity = 0;
    });
    setTimeout(function() {
        element.style.display = 'none';
        $7ef98d8c594793a5$var$fadeComplete(element, properties, o.complete);
    }, o.duration);
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $7ef98d8c594793a5$export$75d3d2c72ecccf9b(element) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var display = element.style.display || undefined;
    if (display == 'none') $7ef98d8c594793a5$export$82e6205b15e6c637(element, options);
    else $7ef98d8c594793a5$export$c091916f1530334c(element, options);
}
/**
 * @param {Options} options
 * @return {Options}
 */ function $7ef98d8c594793a5$var$getOptions(options) {
    return {
        duration: options.duration || 400,
        easing: options.easing || "ease-out",
        complete: options.complete || undefined
    };
}
/**
 * @param {Element} element
 */ function $7ef98d8c594793a5$export$fe8985bb6374093c(element) {
    element.style.display = 'none';
}
/**
 * @param {Element} element
 */ function $7ef98d8c594793a5$export$57bf213be019eeb0(element) {
    element.style.removeProperty('display');
}
/**
 * @param {Element} element
 * @param {Object.<string, string>} properties
 * @param {completeCallback} complete
 */ function $7ef98d8c594793a5$var$slideComplete(element, properties, complete) {
    if (properties.transition) element.style.transition = properties.transition;
    else element.style.removeProperty('transition');
    if (properties.overflowY) element.style.overflowY = properties.overflowY;
    else element.style.removeProperty('overflow-y');
    if (properties.marginTop) element.style.marginTop = properties.marginTop;
    else element.style.removeProperty('margin-top');
    if (properties.marginBottom) element.style.marginBottom = properties.marginBottom;
    else element.style.removeProperty('margin-bottom');
    if (properties.paddingTop) element.style.paddingTop = properties.paddingTop;
    else element.style.removeProperty('padding-top');
    if (properties.paddingBottom) element.style.paddingBottom = properties.paddingBottom;
    else element.style.removeProperty('padding-bottom');
    if (properties.height) element.style.height = properties.height;
    else element.style.removeProperty('height');
    if (complete) complete();
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $7ef98d8c594793a5$export$abdd11a06a163232(element) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var o = $7ef98d8c594793a5$var$getOptions(options);
    var properties = {
        transition: element.style.transition || undefined,
        overflowY: element.style.overflowY || undefined,
        marginTop: element.style.marginTop || undefined,
        marginBottom: element.style.marginBottom || undefined,
        paddingTop: element.style.paddingTop || undefined,
        paddingBottom: element.style.paddingBottom || undefined,
        heigth: element.style.height || undefined
    };
    var cs = window.getComputedStyle(element);
    var marginTop = cs.getPropertyValue("margin-top");
    var marginBottom = cs.getPropertyValue("margin-bottom");
    var paddingTop = cs.getPropertyValue("padding-top");
    var paddingBottom = cs.getPropertyValue("padding-bottom");
    // styles necessary for the animation
    if (!element.style.height) element.style.height = '0px';
    element.style.marginTop = '0px';
    element.style.marginBottom = '0px';
    element.style.paddingTop = '0px';
    element.style.paddingBottom = '0px';
    element.style.overflowY = 'hidden';
    element.style.removeProperty('display');
    element.style.transition = "height ".concat(o.duration / 1000, "s ").concat(o.easing, ", margin ").concat(o.duration / 1000, "s ").concat(o.easing, ", padding ").concat(o.duration / 1000, "s ").concat(o.easing);
    requestAnimationFrame(function() {
        var height = element.scrollHeight;
        if (cs.getPropertyValue("box-sizing") == "border-box") height += parseFloat(paddingTop) + parseFloat(paddingBottom);
        element.style.height = "".concat(height, "px");
        element.style.marginTop = marginTop;
        element.style.marginBottom = marginBottom;
        element.style.paddingTop = paddingTop;
        element.style.paddingBottom = paddingBottom;
    });
    setTimeout(function() {
        $7ef98d8c594793a5$var$slideComplete(element, properties, o.complete);
    }, o.duration);
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $7ef98d8c594793a5$export$715de50cedc228a8(element) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var display = element.style.display || undefined;
    if (display == 'none') $7ef98d8c594793a5$export$abdd11a06a163232(element, options);
    else $7ef98d8c594793a5$export$deed561b1a0ff1ea(element, options);
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $7ef98d8c594793a5$export$deed561b1a0ff1ea(element) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var o = $7ef98d8c594793a5$var$getOptions(options);
    var properties = {
        transition: element.style.transition || undefined,
        overflowY: element.style.overflowY || undefined,
        marginTop: element.style.marginTop || undefined,
        marginBottom: element.style.marginBottom || undefined,
        paddingTop: element.style.paddingTop || undefined,
        paddingBottom: element.style.paddingBottom || undefined,
        heigth: element.style.height || undefined
    };
    var cs = window.getComputedStyle(element);
    var marginTop = cs.getPropertyValue("margin-top");
    var marginBottom = cs.getPropertyValue("margin-bottom");
    var paddingTop = cs.getPropertyValue("padding-top");
    var paddingBottom = cs.getPropertyValue("padding-bottom");
    // styles necessary for the animation
    requestAnimationFrame(function() {
        if (!element.style.height) {
            var height = element.scrollHeight;
            if (cs.getPropertyValue("box-sizing") == "content-box") height -= parseFloat(paddingTop) + parseFloat(paddingBottom);
            element.style.height = "".concat(height, "px");
        }
        element.style.marginTop = marginTop;
        element.style.marginBottom = marginBottom;
        element.style.paddingTop = paddingTop;
        element.style.paddingBottom = paddingBottom;
        element.style.overflowY = 'hidden';
        element.style.transition = "height ".concat(o.duration / 1000, "s ").concat(o.easing, ", margin ").concat(o.duration / 1000, "s ").concat(o.easing, ", padding ").concat(o.duration / 1000, "s ").concat(o.easing);
        requestAnimationFrame(function() {
            element.style.height = '0px';
            element.style.marginTop = '0px';
            element.style.marginBottom = '0px';
            element.style.paddingTop = '0px';
            element.style.paddingBottom = '0px';
        });
    });
    setTimeout(function() {
        element.style.display = 'none';
        $7ef98d8c594793a5$var$slideComplete(element, properties, o.complete);
    }, o.duration);
}
/**
 * @param {Element} element
 */ function $7ef98d8c594793a5$export$e03c1c3201ee8bb7(element) {
    var display = element.style.display || undefined;
    if (display == 'none') $7ef98d8c594793a5$export$57bf213be019eeb0(element);
    else $7ef98d8c594793a5$export$fe8985bb6374093c(element);
}



var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $ggKxj = parcelRequire("ggKxj");

var $5XYIU = parcelRequire("5XYIU");
/**
 * Object describing how feed items are filtered in the view.
 * @enum {string}
 */ var $c311f30f92964d8a$export$c67e46de1ec7dfa6 = {
    NEWEST: 'newest',
    UNREAD: 'unread',
    STARRED: 'starred'
};


function $0be080af3052783c$export$46e843a62e9cebcc(type) {
    if (type == 'newest') return (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).NEWEST;
    else if (type == 'unread') return (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).UNREAD;
    else if (type == 'starred') return (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).STARRED;
    else throw new Error("Invalid filter type: \u201C".concat(type, "\u201D"));
}
function $0be080af3052783c$export$63b3966ca4cc85d9(type) {
    if (type == (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).NEWEST) return 'newest';
    else if (type == (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).UNREAD) return 'unread';
    else if (type == (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).STARRED) return 'starred';
}
function $0be080af3052783c$var$generatePath(param) {
    var filter = param.filter, category = param.category, id = param.id;
    return "/".concat(filter, "/").concat(category).concat(id ? "/".concat(id) : '');
}
function $0be080af3052783c$export$216385125ee84ae7() {
    var match = (0, $5XYIU.useMatch)(':filter/:category/:id?');
    if (match === null) return null;
    var params = match.params;
    var filterValid = /^(newest|unread|starred)$/.test(params.filter);
    var categoryValid = /^(all|tag-.+|source-[0-9]+)$/.test(params.category);
    var idValid = params.id === undefined || /^\d+$/.test(params.id);
    if (!filterValid || !idValid || !categoryValid) return null;
    return params;
}
function $0be080af3052783c$export$d0bb2ab5375d1521(location, param) {
    var filter = param.filter, category = param.category, id = param.id, search = param.search;
    var queryString = new URLSearchParams(location.search);
    var path;
    if (location.pathname.match(/^\/(newest|unread|starred)\//) !== null) {
        var _location_pathname_split = (0, $ggKxj._)(location.pathname.split('/')), segments = _location_pathname_split.slice(1);
        path = $0be080af3052783c$var$generatePath({
            filter: filter !== null && filter !== void 0 ? filter : segments[0],
            category: category !== null && category !== void 0 ? category : segments[1],
            id: typeof id !== 'undefined' ? id : segments[2]
        });
    } else path = $0be080af3052783c$var$generatePath({
        // TODO: change default from config
        filter: filter !== null && filter !== void 0 ? filter : 'unread',
        category: category !== null && category !== void 0 ? category : 'all',
        id: id
    });
    if (typeof search !== 'undefined') {
        if (search) queryString.set('search', search);
        else queryString.delete('search');
    }
    return {
        pathname: path,
        search: queryString.toString()
    };
}
function $0be080af3052783c$export$7f0beea2aa79e4fa(location, params) {
    var _makeEntriesLinkLocation = $0be080af3052783c$export$d0bb2ab5375d1521(location, params), pathname = _makeEntriesLinkLocation.pathname, search = _makeEntriesLinkLocation.search;
    return pathname + (search !== '' ? "?".concat(search) : '');
}
function $0be080af3052783c$export$e64cf1b9b4b3aa56(location) {
    var _location_state;
    var state = (_location_state = location.state) !== null && _location_state !== void 0 ? _location_state : {};
    var _state_forceReload;
    return (0, $9Jpjh._)((0, $lvTkn._)({}, state), {
        forceReload: ((_state_forceReload = state.forceReload) !== null && _state_forceReload !== void 0 ? _state_forceReload : 0) + 1
    });
}
function $0be080af3052783c$export$6bccca1b7088ecd7() {
    var location = (0, $5XYIU.useLocation)();
    return $0be080af3052783c$export$e64cf1b9b4b3aa56(location);
}




/**
 * Copyright (C) 2017-present by Andrea Giammarchi - @WebReflection
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $4c0cf5d996e33977$var$replace = ''.replace;
// escape
var $4c0cf5d996e33977$var$es = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34);/g;
var $4c0cf5d996e33977$var$ca = /[&<>'"]/g;
var $4c0cf5d996e33977$var$esca = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#39;',
    '"': '&quot;'
};
var $4c0cf5d996e33977$var$pe = function(m) {
    return $4c0cf5d996e33977$var$esca[m];
};
var $4c0cf5d996e33977$export$4e7f196112fea3c5 = function(es) {
    return $4c0cf5d996e33977$var$replace.call(es, $4c0cf5d996e33977$var$ca, $4c0cf5d996e33977$var$pe);
};
// unescape
var $4c0cf5d996e33977$var$unes = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"'
};
var $4c0cf5d996e33977$var$cape = function(m) {
    return $4c0cf5d996e33977$var$unes[m];
};
var $4c0cf5d996e33977$export$e8bacd2802a88316 = function(un) {
    return $4c0cf5d996e33977$var$replace.call(un, $4c0cf5d996e33977$var$es, $4c0cf5d996e33977$var$cape);
};



/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $3a0ba9181dd26b01$var$isArray = Array.isArray;
var $3a0ba9181dd26b01$export$2e2bcd8739ae039 = $3a0ba9181dd26b01$var$isArray;



var $2bfPH = parcelRequire("2bfPH");


var $2bfPH = parcelRequire("2bfPH");

var $2bfPH = parcelRequire("2bfPH");
/** Detect free variable `global` from Node.js. */ 
var $2bfPH = parcelRequire("2bfPH");
var $0f93244b35cdbbe6$var$freeGlobal = (typeof $parcel$global === "undefined" ? "undefined" : (0, $2bfPH._)($parcel$global)) == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $0f93244b35cdbbe6$export$2e2bcd8739ae039 = $0f93244b35cdbbe6$var$freeGlobal;


/** Detect free variable `self`. */ var $1fae29a71cc2d4a9$var$freeSelf = (typeof self === "undefined" ? "undefined" : (0, $2bfPH._)(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1fae29a71cc2d4a9$var$root = (0, $0f93244b35cdbbe6$export$2e2bcd8739ae039) || $1fae29a71cc2d4a9$var$freeSelf || Function('return this')();
var $1fae29a71cc2d4a9$export$2e2bcd8739ae039 = $1fae29a71cc2d4a9$var$root;


/** Built-in value references. */ var $de766450d8859b45$var$Symbol = (0, $1fae29a71cc2d4a9$export$2e2bcd8739ae039).Symbol;
var $de766450d8859b45$export$2e2bcd8739ae039 = $de766450d8859b45$var$Symbol;



/** Used for built-in method references. */ var $bba9ae3e89cf7880$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bba9ae3e89cf7880$var$hasOwnProperty = $bba9ae3e89cf7880$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $bba9ae3e89cf7880$var$nativeObjectToString = $bba9ae3e89cf7880$var$objectProto.toString;
/** Built-in value references. */ var $bba9ae3e89cf7880$var$symToStringTag = (0, $de766450d8859b45$export$2e2bcd8739ae039) ? (0, $de766450d8859b45$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $bba9ae3e89cf7880$var$getRawTag(value) {
    var isOwn = $bba9ae3e89cf7880$var$hasOwnProperty.call(value, $bba9ae3e89cf7880$var$symToStringTag), tag = value[$bba9ae3e89cf7880$var$symToStringTag];
    try {
        value[$bba9ae3e89cf7880$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $bba9ae3e89cf7880$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$bba9ae3e89cf7880$var$symToStringTag] = tag;
        else delete value[$bba9ae3e89cf7880$var$symToStringTag];
    }
    return result;
}
var $bba9ae3e89cf7880$export$2e2bcd8739ae039 = $bba9ae3e89cf7880$var$getRawTag;


/** Used for built-in method references. */ var $18b8dc93d673f987$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $18b8dc93d673f987$var$nativeObjectToString = $18b8dc93d673f987$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $18b8dc93d673f987$var$objectToString(value) {
    return $18b8dc93d673f987$var$nativeObjectToString.call(value);
}
var $18b8dc93d673f987$export$2e2bcd8739ae039 = $18b8dc93d673f987$var$objectToString;


/** `Object#toString` result references. */ var $327986fe46142e6d$var$nullTag = '[object Null]', $327986fe46142e6d$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $327986fe46142e6d$var$symToStringTag = (0, $de766450d8859b45$export$2e2bcd8739ae039) ? (0, $de766450d8859b45$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $327986fe46142e6d$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $327986fe46142e6d$var$undefinedTag : $327986fe46142e6d$var$nullTag;
    return $327986fe46142e6d$var$symToStringTag && $327986fe46142e6d$var$symToStringTag in Object(value) ? (0, $bba9ae3e89cf7880$export$2e2bcd8739ae039)(value) : (0, $18b8dc93d673f987$export$2e2bcd8739ae039)(value);
}
var $327986fe46142e6d$export$2e2bcd8739ae039 = $327986fe46142e6d$var$baseGetTag;


/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ 
var $2bfPH = parcelRequire("2bfPH");
function $d918f235875ebac8$var$isObjectLike(value) {
    return value != null && (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) == 'object';
}
var $d918f235875ebac8$export$2e2bcd8739ae039 = $d918f235875ebac8$var$isObjectLike;


/** `Object#toString` result references. */ var $d08c66e304cbe5be$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $d08c66e304cbe5be$var$isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) == 'symbol' || (0, $d918f235875ebac8$export$2e2bcd8739ae039)(value) && (0, $327986fe46142e6d$export$2e2bcd8739ae039)(value) == $d08c66e304cbe5be$var$symbolTag;
}
var $d08c66e304cbe5be$export$2e2bcd8739ae039 = $d08c66e304cbe5be$var$isSymbol;


/** Used to match property names within property paths. */ var $692761996cdc4c09$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $692761996cdc4c09$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $692761996cdc4c09$var$isKey(value, object) {
    if ((0, $3a0ba9181dd26b01$export$2e2bcd8739ae039)(value)) return false;
    var type = typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value);
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || (0, $d08c66e304cbe5be$export$2e2bcd8739ae039)(value)) return true;
    return $692761996cdc4c09$var$reIsPlainProp.test(value) || !$692761996cdc4c09$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $692761996cdc4c09$export$2e2bcd8739ae039 = $692761996cdc4c09$var$isKey;



/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ 
var $2bfPH = parcelRequire("2bfPH");
function $1d53ac6aee0c3479$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value);
    return value != null && (type == 'object' || type == 'function');
}
var $1d53ac6aee0c3479$export$2e2bcd8739ae039 = $1d53ac6aee0c3479$var$isObject;


/** `Object#toString` result references. */ var $b469d2f28a46ee34$var$asyncTag = '[object AsyncFunction]', $b469d2f28a46ee34$var$funcTag = '[object Function]', $b469d2f28a46ee34$var$genTag = '[object GeneratorFunction]', $b469d2f28a46ee34$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $b469d2f28a46ee34$var$isFunction(value) {
    if (!(0, $1d53ac6aee0c3479$export$2e2bcd8739ae039)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $327986fe46142e6d$export$2e2bcd8739ae039)(value);
    return tag == $b469d2f28a46ee34$var$funcTag || tag == $b469d2f28a46ee34$var$genTag || tag == $b469d2f28a46ee34$var$asyncTag || tag == $b469d2f28a46ee34$var$proxyTag;
}
var $b469d2f28a46ee34$export$2e2bcd8739ae039 = $b469d2f28a46ee34$var$isFunction;



/** Used to detect overreaching core-js shims. */ var $25ddc5fd1bf81599$var$coreJsData = (0, $1fae29a71cc2d4a9$export$2e2bcd8739ae039)['__core-js_shared__'];
var $25ddc5fd1bf81599$export$2e2bcd8739ae039 = $25ddc5fd1bf81599$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $6195b02856eb6bbc$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $25ddc5fd1bf81599$export$2e2bcd8739ae039) && (0, $25ddc5fd1bf81599$export$2e2bcd8739ae039).keys && (0, $25ddc5fd1bf81599$export$2e2bcd8739ae039).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $6195b02856eb6bbc$var$isMasked(func) {
    return !!$6195b02856eb6bbc$var$maskSrcKey && $6195b02856eb6bbc$var$maskSrcKey in func;
}
var $6195b02856eb6bbc$export$2e2bcd8739ae039 = $6195b02856eb6bbc$var$isMasked;



/** Used for built-in method references. */ var $eb61e83a6934f7ee$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $eb61e83a6934f7ee$var$funcToString = $eb61e83a6934f7ee$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $eb61e83a6934f7ee$var$toSource(func) {
    if (func != null) {
        try {
            return $eb61e83a6934f7ee$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $eb61e83a6934f7ee$export$2e2bcd8739ae039 = $eb61e83a6934f7ee$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $768375469bcf40b6$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $768375469bcf40b6$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $768375469bcf40b6$var$funcProto = Function.prototype, $768375469bcf40b6$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $768375469bcf40b6$var$funcToString = $768375469bcf40b6$var$funcProto.toString;
/** Used to check objects for own properties. */ var $768375469bcf40b6$var$hasOwnProperty = $768375469bcf40b6$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $768375469bcf40b6$var$reIsNative = RegExp('^' + $768375469bcf40b6$var$funcToString.call($768375469bcf40b6$var$hasOwnProperty).replace($768375469bcf40b6$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $768375469bcf40b6$var$baseIsNative(value) {
    if (!(0, $1d53ac6aee0c3479$export$2e2bcd8739ae039)(value) || (0, $6195b02856eb6bbc$export$2e2bcd8739ae039)(value)) return false;
    var pattern = (0, $b469d2f28a46ee34$export$2e2bcd8739ae039)(value) ? $768375469bcf40b6$var$reIsNative : $768375469bcf40b6$var$reIsHostCtor;
    return pattern.test((0, $eb61e83a6934f7ee$export$2e2bcd8739ae039)(value));
}
var $768375469bcf40b6$export$2e2bcd8739ae039 = $768375469bcf40b6$var$baseIsNative;


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $6cc89eccfb443b42$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $6cc89eccfb443b42$export$2e2bcd8739ae039 = $6cc89eccfb443b42$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $59eaa6cbec0d3fc3$var$getNative(object, key) {
    var value = (0, $6cc89eccfb443b42$export$2e2bcd8739ae039)(object, key);
    return (0, $768375469bcf40b6$export$2e2bcd8739ae039)(value) ? value : undefined;
}
var $59eaa6cbec0d3fc3$export$2e2bcd8739ae039 = $59eaa6cbec0d3fc3$var$getNative;


/* Built-in method references that are verified to be native. */ var $dd3b8033df9987aa$var$nativeCreate = (0, $59eaa6cbec0d3fc3$export$2e2bcd8739ae039)(Object, 'create');
var $dd3b8033df9987aa$export$2e2bcd8739ae039 = $dd3b8033df9987aa$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $00ac8f260e855625$var$hashClear() {
    this.__data__ = (0, $dd3b8033df9987aa$export$2e2bcd8739ae039) ? (0, $dd3b8033df9987aa$export$2e2bcd8739ae039)(null) : {};
    this.size = 0;
}
var $00ac8f260e855625$export$2e2bcd8739ae039 = $00ac8f260e855625$var$hashClear;


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $56d393fbe9a45007$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $56d393fbe9a45007$export$2e2bcd8739ae039 = $56d393fbe9a45007$var$hashDelete;



/** Used to stand-in for `undefined` hash values. */ var $4385544e1f1ed34e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $4385544e1f1ed34e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4385544e1f1ed34e$var$hasOwnProperty = $4385544e1f1ed34e$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $4385544e1f1ed34e$var$hashGet(key) {
    var data = this.__data__;
    if (0, $dd3b8033df9987aa$export$2e2bcd8739ae039) {
        var result = data[key];
        return result === $4385544e1f1ed34e$var$HASH_UNDEFINED ? undefined : result;
    }
    return $4385544e1f1ed34e$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $4385544e1f1ed34e$export$2e2bcd8739ae039 = $4385544e1f1ed34e$var$hashGet;



/** Used for built-in method references. */ var $e312d2d13c617aa4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e312d2d13c617aa4$var$hasOwnProperty = $e312d2d13c617aa4$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e312d2d13c617aa4$var$hashHas(key) {
    var data = this.__data__;
    return (0, $dd3b8033df9987aa$export$2e2bcd8739ae039) ? data[key] !== undefined : $e312d2d13c617aa4$var$hasOwnProperty.call(data, key);
}
var $e312d2d13c617aa4$export$2e2bcd8739ae039 = $e312d2d13c617aa4$var$hashHas;



/** Used to stand-in for `undefined` hash values. */ var $16bd1337d2ecc79c$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $16bd1337d2ecc79c$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $dd3b8033df9987aa$export$2e2bcd8739ae039) && value === undefined ? $16bd1337d2ecc79c$var$HASH_UNDEFINED : value;
    return this;
}
var $16bd1337d2ecc79c$export$2e2bcd8739ae039 = $16bd1337d2ecc79c$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $af8d3fa22e27a279$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$af8d3fa22e27a279$var$Hash.prototype.clear = (0, $00ac8f260e855625$export$2e2bcd8739ae039);
$af8d3fa22e27a279$var$Hash.prototype['delete'] = (0, $56d393fbe9a45007$export$2e2bcd8739ae039);
$af8d3fa22e27a279$var$Hash.prototype.get = (0, $4385544e1f1ed34e$export$2e2bcd8739ae039);
$af8d3fa22e27a279$var$Hash.prototype.has = (0, $e312d2d13c617aa4$export$2e2bcd8739ae039);
$af8d3fa22e27a279$var$Hash.prototype.set = (0, $16bd1337d2ecc79c$export$2e2bcd8739ae039);
var $af8d3fa22e27a279$export$2e2bcd8739ae039 = $af8d3fa22e27a279$var$Hash;


/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $170523c0b5de32c0$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $170523c0b5de32c0$export$2e2bcd8739ae039 = $170523c0b5de32c0$var$listCacheClear;


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $816c5a4323d3d01d$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $816c5a4323d3d01d$export$2e2bcd8739ae039 = $816c5a4323d3d01d$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $2bdb4002f43f913b$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $816c5a4323d3d01d$export$2e2bcd8739ae039)(array[length][0], key)) return length;
    }
    return -1;
}
var $2bdb4002f43f913b$export$2e2bcd8739ae039 = $2bdb4002f43f913b$var$assocIndexOf;


/** Used for built-in method references. */ var $ddd93fccea1551bf$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $ddd93fccea1551bf$var$splice = $ddd93fccea1551bf$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ddd93fccea1551bf$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $2bdb4002f43f913b$export$2e2bcd8739ae039)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $ddd93fccea1551bf$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $ddd93fccea1551bf$export$2e2bcd8739ae039 = $ddd93fccea1551bf$var$listCacheDelete;



/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $69389e2fb23bebb5$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $2bdb4002f43f913b$export$2e2bcd8739ae039)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $69389e2fb23bebb5$export$2e2bcd8739ae039 = $69389e2fb23bebb5$var$listCacheGet;



/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7b248c4c05d82799$var$listCacheHas(key) {
    return (0, $2bdb4002f43f913b$export$2e2bcd8739ae039)(this.__data__, key) > -1;
}
var $7b248c4c05d82799$export$2e2bcd8739ae039 = $7b248c4c05d82799$var$listCacheHas;



/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $44855652e533aee1$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $2bdb4002f43f913b$export$2e2bcd8739ae039)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $44855652e533aee1$export$2e2bcd8739ae039 = $44855652e533aee1$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a7f8cba9ad3b5764$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$a7f8cba9ad3b5764$var$ListCache.prototype.clear = (0, $170523c0b5de32c0$export$2e2bcd8739ae039);
$a7f8cba9ad3b5764$var$ListCache.prototype['delete'] = (0, $ddd93fccea1551bf$export$2e2bcd8739ae039);
$a7f8cba9ad3b5764$var$ListCache.prototype.get = (0, $69389e2fb23bebb5$export$2e2bcd8739ae039);
$a7f8cba9ad3b5764$var$ListCache.prototype.has = (0, $7b248c4c05d82799$export$2e2bcd8739ae039);
$a7f8cba9ad3b5764$var$ListCache.prototype.set = (0, $44855652e533aee1$export$2e2bcd8739ae039);
var $a7f8cba9ad3b5764$export$2e2bcd8739ae039 = $a7f8cba9ad3b5764$var$ListCache;




/* Built-in method references that are verified to be native. */ var $b5fa763546003260$var$Map = (0, $59eaa6cbec0d3fc3$export$2e2bcd8739ae039)((0, $1fae29a71cc2d4a9$export$2e2bcd8739ae039), 'Map');
var $b5fa763546003260$export$2e2bcd8739ae039 = $b5fa763546003260$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $b4b8146b8ee5b362$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $af8d3fa22e27a279$export$2e2bcd8739ae039),
        'map': new ((0, $b5fa763546003260$export$2e2bcd8739ae039) || (0, $a7f8cba9ad3b5764$export$2e2bcd8739ae039)),
        'string': new (0, $af8d3fa22e27a279$export$2e2bcd8739ae039)
    };
}
var $b4b8146b8ee5b362$export$2e2bcd8739ae039 = $b4b8146b8ee5b362$var$mapCacheClear;


/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ 
var $2bfPH = parcelRequire("2bfPH");
function $bfbbc72f6631c665$var$isKeyable(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value);
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $bfbbc72f6631c665$export$2e2bcd8739ae039 = $bfbbc72f6631c665$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $9ac8f027c9b6dd2b$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $bfbbc72f6631c665$export$2e2bcd8739ae039)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $9ac8f027c9b6dd2b$export$2e2bcd8739ae039 = $9ac8f027c9b6dd2b$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $f7f65e35c34ca3cf$var$mapCacheDelete(key) {
    var result = (0, $9ac8f027c9b6dd2b$export$2e2bcd8739ae039)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $f7f65e35c34ca3cf$export$2e2bcd8739ae039 = $f7f65e35c34ca3cf$var$mapCacheDelete;



/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f24c706a451a4356$var$mapCacheGet(key) {
    return (0, $9ac8f027c9b6dd2b$export$2e2bcd8739ae039)(this, key).get(key);
}
var $f24c706a451a4356$export$2e2bcd8739ae039 = $f24c706a451a4356$var$mapCacheGet;



/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c7f44b8791ffdc9b$var$mapCacheHas(key) {
    return (0, $9ac8f027c9b6dd2b$export$2e2bcd8739ae039)(this, key).has(key);
}
var $c7f44b8791ffdc9b$export$2e2bcd8739ae039 = $c7f44b8791ffdc9b$var$mapCacheHas;



/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $2f513f45f8c0366f$var$mapCacheSet(key, value) {
    var data = (0, $9ac8f027c9b6dd2b$export$2e2bcd8739ae039)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $2f513f45f8c0366f$export$2e2bcd8739ae039 = $2f513f45f8c0366f$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a2a8638ae47ec5ba$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$a2a8638ae47ec5ba$var$MapCache.prototype.clear = (0, $b4b8146b8ee5b362$export$2e2bcd8739ae039);
$a2a8638ae47ec5ba$var$MapCache.prototype['delete'] = (0, $f7f65e35c34ca3cf$export$2e2bcd8739ae039);
$a2a8638ae47ec5ba$var$MapCache.prototype.get = (0, $f24c706a451a4356$export$2e2bcd8739ae039);
$a2a8638ae47ec5ba$var$MapCache.prototype.has = (0, $c7f44b8791ffdc9b$export$2e2bcd8739ae039);
$a2a8638ae47ec5ba$var$MapCache.prototype.set = (0, $2f513f45f8c0366f$export$2e2bcd8739ae039);
var $a2a8638ae47ec5ba$export$2e2bcd8739ae039 = $a2a8638ae47ec5ba$var$MapCache;


/** Error message constants. */ var $5948d35389e2ef10$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $5948d35389e2ef10$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($5948d35389e2ef10$var$FUNC_ERROR_TEXT);
    var memoized = function memoized1() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($5948d35389e2ef10$var$memoize.Cache || (0, $a2a8638ae47ec5ba$export$2e2bcd8739ae039));
    return memoized;
}
// Expose `MapCache`.
$5948d35389e2ef10$var$memoize.Cache = (0, $a2a8638ae47ec5ba$export$2e2bcd8739ae039);
var $5948d35389e2ef10$export$2e2bcd8739ae039 = $5948d35389e2ef10$var$memoize;


/** Used as the maximum memoize cache size. */ var $19f3dce5adf9ec90$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $19f3dce5adf9ec90$var$memoizeCapped(func) {
    var result = (0, $5948d35389e2ef10$export$2e2bcd8739ae039)(func, function(key) {
        if (cache.size === $19f3dce5adf9ec90$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $19f3dce5adf9ec90$export$2e2bcd8739ae039 = $19f3dce5adf9ec90$var$memoizeCapped;


/** Used to match property names within property paths. */ var $23067043d0575069$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $23067043d0575069$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $23067043d0575069$var$stringToPath = (0, $19f3dce5adf9ec90$export$2e2bcd8739ae039)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($23067043d0575069$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($23067043d0575069$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $23067043d0575069$export$2e2bcd8739ae039 = $23067043d0575069$var$stringToPath;



/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $e30383e00aa0d71c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $e30383e00aa0d71c$export$2e2bcd8739ae039 = $e30383e00aa0d71c$var$arrayMap;




/** Used as references for various `Number` constants. */ var $ee9044ce1b52066f$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $ee9044ce1b52066f$var$symbolProto = (0, $de766450d8859b45$export$2e2bcd8739ae039) ? (0, $de766450d8859b45$export$2e2bcd8739ae039).prototype : undefined, $ee9044ce1b52066f$var$symbolToString = $ee9044ce1b52066f$var$symbolProto ? $ee9044ce1b52066f$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $ee9044ce1b52066f$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $3a0ba9181dd26b01$export$2e2bcd8739ae039)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $e30383e00aa0d71c$export$2e2bcd8739ae039)(value, $ee9044ce1b52066f$var$baseToString) + '';
    if ((0, $d08c66e304cbe5be$export$2e2bcd8739ae039)(value)) return $ee9044ce1b52066f$var$symbolToString ? $ee9044ce1b52066f$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$ee9044ce1b52066f$var$INFINITY ? '-0' : result;
}
var $ee9044ce1b52066f$export$2e2bcd8739ae039 = $ee9044ce1b52066f$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $c64e646827cd6466$var$toString(value) {
    return value == null ? '' : (0, $ee9044ce1b52066f$export$2e2bcd8739ae039)(value);
}
var $c64e646827cd6466$export$2e2bcd8739ae039 = $c64e646827cd6466$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $a16ace4c8189c160$var$castPath(value, object) {
    if ((0, $3a0ba9181dd26b01$export$2e2bcd8739ae039)(value)) return value;
    return (0, $692761996cdc4c09$export$2e2bcd8739ae039)(value, object) ? [
        value
    ] : (0, $23067043d0575069$export$2e2bcd8739ae039)((0, $c64e646827cd6466$export$2e2bcd8739ae039)(value));
}
var $a16ace4c8189c160$export$2e2bcd8739ae039 = $a16ace4c8189c160$var$castPath;



/** Used as references for various `Number` constants. */ var $75b8732e1e1646c2$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $75b8732e1e1646c2$var$toKey(value) {
    if (typeof value == 'string' || (0, $d08c66e304cbe5be$export$2e2bcd8739ae039)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$75b8732e1e1646c2$var$INFINITY ? '-0' : result;
}
var $75b8732e1e1646c2$export$2e2bcd8739ae039 = $75b8732e1e1646c2$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $840c55ae586509c7$var$baseGet(object, path) {
    path = (0, $a16ace4c8189c160$export$2e2bcd8739ae039)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, $75b8732e1e1646c2$export$2e2bcd8739ae039)(path[index++])];
    return index && index == length ? object : undefined;
}
var $840c55ae586509c7$export$2e2bcd8739ae039 = $840c55ae586509c7$var$baseGet;



var $518283c44f0c1802$var$defineProperty = function() {
    try {
        var func = (0, $59eaa6cbec0d3fc3$export$2e2bcd8739ae039)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $518283c44f0c1802$export$2e2bcd8739ae039 = $518283c44f0c1802$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $390f7f5614c77bb9$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $518283c44f0c1802$export$2e2bcd8739ae039)) (0, $518283c44f0c1802$export$2e2bcd8739ae039)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $390f7f5614c77bb9$export$2e2bcd8739ae039 = $390f7f5614c77bb9$var$baseAssignValue;



/** Used for built-in method references. */ var $d1616e614d60f271$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d1616e614d60f271$var$hasOwnProperty = $d1616e614d60f271$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $d1616e614d60f271$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($d1616e614d60f271$var$hasOwnProperty.call(object, key) && (0, $816c5a4323d3d01d$export$2e2bcd8739ae039)(objValue, value)) || value === undefined && !(key in object)) (0, $390f7f5614c77bb9$export$2e2bcd8739ae039)(object, key, value);
}
var $d1616e614d60f271$export$2e2bcd8739ae039 = $d1616e614d60f271$var$assignValue;



/** Used as references for various `Number` constants. */ 
var $2bfPH = parcelRequire("2bfPH");
var $d829662a7af045c8$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d829662a7af045c8$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d829662a7af045c8$var$isIndex(value, length) {
    var type = typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value);
    length = length == null ? $d829662a7af045c8$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $d829662a7af045c8$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $d829662a7af045c8$export$2e2bcd8739ae039 = $d829662a7af045c8$var$isIndex;




/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $f8f83f7fff8a5166$var$baseSet(object, path, value, customizer) {
    if (!(0, $1d53ac6aee0c3479$export$2e2bcd8739ae039)(object)) return object;
    path = (0, $a16ace4c8189c160$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = (0, $75b8732e1e1646c2$export$2e2bcd8739ae039)(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = (0, $1d53ac6aee0c3479$export$2e2bcd8739ae039)(objValue) ? objValue : (0, $d829662a7af045c8$export$2e2bcd8739ae039)(path[index + 1]) ? [] : {};
        }
        (0, $d1616e614d60f271$export$2e2bcd8739ae039)(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
var $f8f83f7fff8a5166$export$2e2bcd8739ae039 = $f8f83f7fff8a5166$var$baseSet;



/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $eda4d1e9dceb41ab$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = (0, $840c55ae586509c7$export$2e2bcd8739ae039)(object, path);
        if (predicate(value, path)) (0, $f8f83f7fff8a5166$export$2e2bcd8739ae039)(result, (0, $a16ace4c8189c160$export$2e2bcd8739ae039)(path, object), value);
    }
    return result;
}
var $eda4d1e9dceb41ab$export$2e2bcd8739ae039 = $eda4d1e9dceb41ab$var$basePickBy;


/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $06f8e3cebab0da01$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
var $06f8e3cebab0da01$export$2e2bcd8739ae039 = $06f8e3cebab0da01$var$baseHasIn;





/** `Object#toString` result references. */ var $68df74354ba9582d$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $68df74354ba9582d$var$baseIsArguments(value) {
    return (0, $d918f235875ebac8$export$2e2bcd8739ae039)(value) && (0, $327986fe46142e6d$export$2e2bcd8739ae039)(value) == $68df74354ba9582d$var$argsTag;
}
var $68df74354ba9582d$export$2e2bcd8739ae039 = $68df74354ba9582d$var$baseIsArguments;



/** Used for built-in method references. */ var $d933a4585efacd94$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d933a4585efacd94$var$hasOwnProperty = $d933a4585efacd94$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $d933a4585efacd94$var$propertyIsEnumerable = $d933a4585efacd94$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $d933a4585efacd94$var$isArguments = (0, $68df74354ba9582d$export$2e2bcd8739ae039)(function() {
    return arguments;
}()) ? (0, $68df74354ba9582d$export$2e2bcd8739ae039) : function isArguments(value) {
    return (0, $d918f235875ebac8$export$2e2bcd8739ae039)(value) && $d933a4585efacd94$var$hasOwnProperty.call(value, 'callee') && !$d933a4585efacd94$var$propertyIsEnumerable.call(value, 'callee');
};
var $d933a4585efacd94$export$2e2bcd8739ae039 = $d933a4585efacd94$var$isArguments;




/** Used as references for various `Number` constants. */ var $52c9488c28cfc0b3$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $52c9488c28cfc0b3$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $52c9488c28cfc0b3$var$MAX_SAFE_INTEGER;
}
var $52c9488c28cfc0b3$export$2e2bcd8739ae039 = $52c9488c28cfc0b3$var$isLength;



/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $47c784b0500cafd2$var$hasPath(object, path, hasFunc) {
    path = (0, $a16ace4c8189c160$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, $75b8732e1e1646c2$export$2e2bcd8739ae039)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, $52c9488c28cfc0b3$export$2e2bcd8739ae039)(length) && (0, $d829662a7af045c8$export$2e2bcd8739ae039)(key, length) && ((0, $3a0ba9181dd26b01$export$2e2bcd8739ae039)(object) || (0, $d933a4585efacd94$export$2e2bcd8739ae039)(object));
}
var $47c784b0500cafd2$export$2e2bcd8739ae039 = $47c784b0500cafd2$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $e0c5aae4b3458c3e$var$hasIn(object, path) {
    return object != null && (0, $47c784b0500cafd2$export$2e2bcd8739ae039)(object, path, (0, $06f8e3cebab0da01$export$2e2bcd8739ae039));
}
var $e0c5aae4b3458c3e$export$2e2bcd8739ae039 = $e0c5aae4b3458c3e$var$hasIn;


/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $220198508e8e10e2$var$basePick(object, paths) {
    return (0, $eda4d1e9dceb41ab$export$2e2bcd8739ae039)(object, paths, function(value, path) {
        return (0, $e0c5aae4b3458c3e$export$2e2bcd8739ae039)(object, path);
    });
}
var $220198508e8e10e2$export$2e2bcd8739ae039 = $220198508e8e10e2$var$basePick;


/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $4a7b1485b8d687d6$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $4a7b1485b8d687d6$export$2e2bcd8739ae039 = $4a7b1485b8d687d6$var$arrayPush;





/** Built-in value references. */ var $8319a1c13d04ace2$var$spreadableSymbol = (0, $de766450d8859b45$export$2e2bcd8739ae039) ? (0, $de766450d8859b45$export$2e2bcd8739ae039).isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $8319a1c13d04ace2$var$isFlattenable(value) {
    return (0, $3a0ba9181dd26b01$export$2e2bcd8739ae039)(value) || (0, $d933a4585efacd94$export$2e2bcd8739ae039)(value) || !!($8319a1c13d04ace2$var$spreadableSymbol && value && value[$8319a1c13d04ace2$var$spreadableSymbol]);
}
var $8319a1c13d04ace2$export$2e2bcd8739ae039 = $8319a1c13d04ace2$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $6990cf1083772c77$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = (0, $8319a1c13d04ace2$export$2e2bcd8739ae039));
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $6990cf1083772c77$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else (0, $4a7b1485b8d687d6$export$2e2bcd8739ae039)(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
var $6990cf1083772c77$export$2e2bcd8739ae039 = $6990cf1083772c77$var$baseFlatten;


/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $f3e296f6897581bd$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? (0, $6990cf1083772c77$export$2e2bcd8739ae039)(array, 1) : [];
}
var $f3e296f6897581bd$export$2e2bcd8739ae039 = $f3e296f6897581bd$var$flatten;


/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $8a60073bb4ff63ab$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $8a60073bb4ff63ab$export$2e2bcd8739ae039 = $8a60073bb4ff63ab$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $699693d6a2a97eac$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $699693d6a2a97eac$var$overRest(func, start, transform) {
    start = $699693d6a2a97eac$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $699693d6a2a97eac$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $8a60073bb4ff63ab$export$2e2bcd8739ae039)(func, this, otherArgs);
    };
}
var $699693d6a2a97eac$export$2e2bcd8739ae039 = $699693d6a2a97eac$var$overRest;


/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $457b93e422a0a25d$var$constant(value) {
    return function() {
        return value;
    };
}
var $457b93e422a0a25d$export$2e2bcd8739ae039 = $457b93e422a0a25d$var$constant;



/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $e6cf5f6047124b05$var$identity(value) {
    return value;
}
var $e6cf5f6047124b05$export$2e2bcd8739ae039 = $e6cf5f6047124b05$var$identity;


/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $b2ff5bbbdc5713b5$var$baseSetToString = !(0, $518283c44f0c1802$export$2e2bcd8739ae039) ? (0, $e6cf5f6047124b05$export$2e2bcd8739ae039) : function baseSetToString(func, string) {
    return (0, $518283c44f0c1802$export$2e2bcd8739ae039)(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': (0, $457b93e422a0a25d$export$2e2bcd8739ae039)(string),
        'writable': true
    });
};
var $b2ff5bbbdc5713b5$export$2e2bcd8739ae039 = $b2ff5bbbdc5713b5$var$baseSetToString;


/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $d5f7c15b7dced041$var$HOT_COUNT = 800, $d5f7c15b7dced041$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d5f7c15b7dced041$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $d5f7c15b7dced041$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $d5f7c15b7dced041$var$nativeNow(), remaining = $d5f7c15b7dced041$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $d5f7c15b7dced041$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $d5f7c15b7dced041$export$2e2bcd8739ae039 = $d5f7c15b7dced041$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $4c665559ed128371$var$setToString = (0, $d5f7c15b7dced041$export$2e2bcd8739ae039)((0, $b2ff5bbbdc5713b5$export$2e2bcd8739ae039));
var $4c665559ed128371$export$2e2bcd8739ae039 = $4c665559ed128371$var$setToString;


/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $d2b21c57bfdbd300$var$flatRest(func) {
    return (0, $4c665559ed128371$export$2e2bcd8739ae039)((0, $699693d6a2a97eac$export$2e2bcd8739ae039)(func, undefined, (0, $f3e296f6897581bd$export$2e2bcd8739ae039)), func + '');
}
var $d2b21c57bfdbd300$export$2e2bcd8739ae039 = $d2b21c57bfdbd300$var$flatRest;


/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $2b2b00f45dc8a6fe$var$pick = (0, $d2b21c57bfdbd300$export$2e2bcd8739ae039)(function(object, paths) {
    return object == null ? {} : (0, $220198508e8e10e2$export$2e2bcd8739ae039)(object, paths);
});
var $2b2b00f45dc8a6fe$export$2e2bcd8739ae039 = $2b2b00f45dc8a6fe$var$pick;



var $khBmn = parcelRequire("khBmn");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $aRv4I = parcelRequire("aRv4I");

var $21h22 = parcelRequire("21h22");


var $eHaBZ = parcelRequire("eHaBZ");


function $5101856265f93aa2$export$2e2bcd8739ae039(param) {
    var spoutParamName = param.spoutParamName, spoutParam = param.spoutParam, _param_params = param.params, params = _param_params === void 0 ? {} : _param_params, sourceErrors = param.sourceErrors, sourceId = param.sourceId, setEditedSource = param.setEditedSource, setDirty = param.setDirty;
    var updateSourceParam = (0, $eHaBZ.useCallback)(function(event) {
        setDirty(true);
        setEditedSource(function(_param) {
            var params = _param.params, restSource = (0, $aRv4I._)(_param, [
                "params"
            ]);
            return (0, $9Jpjh._)((0, $lvTkn._)({}, restSource), {
                params: (0, $9Jpjh._)((0, $lvTkn._)({}, params), (0, $khBmn._)({}, spoutParamName, event.target.value))
            });
        });
    }, [
        setEditedSource,
        setDirty,
        spoutParamName
    ]);
    var updateSourceParamBool = (0, $eHaBZ.useCallback)(function(event) {
        return updateSourceParam({
            target: {
                value: event.target.checked ? '1' : undefined
            }
        });
    }, [
        updateSourceParam
    ]);
    var value = spoutParamName in params ? params[spoutParamName] : spoutParam.default;
    var control = null;
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    if ([
        'text',
        'checkbox',
        'url'
    ].includes(spoutParam.type)) {
        var checked;
        if (spoutParam.type === 'checkbox') {
            checked = value == '1';
            // Value always has to be 1 since HTML sends [name]=[value] when a checkbox is checked
            // and omits the field altogether from HTTP request when not checked.
            value = '1';
        }
        control = /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
            id: "".concat(spoutParamName, "-").concat(sourceId),
            type: spoutParam.type,
            name: spoutParamName,
            value: value,
            checked: checked,
            onChange: spoutParam.type !== 'checkbox' ? updateSourceParam : updateSourceParamBool
        });
    } else if (spoutParam.type === 'password') control = /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
        id: "".concat(spoutParamName, "-").concat(sourceId),
        type: spoutParam.type,
        name: spoutParamName,
        placeholder: _('source_pwd_placeholder'),
        onChange: updateSourceParam
    });
    else if (spoutParam.type === 'select') control = /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("select", {
        id: "".concat(spoutParamName, "-").concat(sourceId),
        name: spoutParamName,
        size: "1",
        value: value,
        onChange: updateSourceParam,
        children: Object.entries(spoutParam.values).map(function(param) {
            var _param = (0, $21h22._)(param, 2), optionName = _param[0], optionTitle = _param[1];
            return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("option", {
                value: optionName,
                children: optionTitle
            }, optionName);
        })
    });
    else return null;
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                htmlFor: "".concat(spoutParamName, "-").concat(sourceId),
                children: spoutParam.title
            }),
            control,
            sourceErrors[spoutParamName] ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                className: "error",
                children: sourceErrors[spoutParamName]
            }) : null
        ]
    });
}
$5101856265f93aa2$export$2e2bcd8739ae039.propTypes = {
    spoutParamName: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string.isRequired,
    spoutParam: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    params: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    sourceErrors: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string).isRequired,
    sourceId: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    setEditedSource: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    setDirty: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};




function $b0e03640e062f6f9$export$722fbec263ad908a(id, values) {
    return $32ae13b741542474$export$299ba2dee77727e9("source/".concat(id), {
        headers: {
            'content-type': 'application/json; charset=utf-8'
        },
        body: JSON.stringify(values),
        failOnHttpErrors: false
    }).promise.then($32ae13b741542474$export$8d90b058a02656d9(function(response) {
        return response.ok || response.status === 400;
    })).then(function(response) {
        return response.json();
    });
}
function $b0e03640e062f6f9$export$c1f8f7c408fa54a(id) {
    return $32ae13b741542474$export$299ba2dee77727e9('source/' + id + '/update', {
        timeout: 0
    }).promise;
}
function $b0e03640e062f6f9$export$c5eb18431f66026b() {
    return $32ae13b741542474$export$3988ae62b71be9a3('update', {
        headers: {
            Accept: 'text/event-stream'
        },
        timeout: 0
    }).promise.then(function(response) {
        return response.text();
    });
}
function $b0e03640e062f6f9$export$cd7f480d6b8286c3(id) {
    return $32ae13b741542474$export$38dab5a9fea42f39("source/".concat(id)).promise;
}
function $b0e03640e062f6f9$export$316f19f1ddc6b34e(abortController) {
    return $32ae13b741542474$export$3988ae62b71be9a3('sources', {
        abortController: abortController
    }).promise.then(function(response) {
        return response.json();
    });
}
function $b0e03640e062f6f9$export$ba43f46f09336c84() {
    return $32ae13b741542474$export$3988ae62b71be9a3('sources/spouts').promise.then(function(response) {
        return response.json();
    });
}
function $b0e03640e062f6f9$export$d72d2378a998c10c(spoutClass) {
    return $32ae13b741542474$export$3988ae62b71be9a3('source/params', {
        body: $32ae13b741542474$export$92871f7982deaf9f({
            spout: spoutClass
        })
    }).promise.then(function(res) {
        return res.json();
    });
}
function $b0e03640e062f6f9$export$432f698644f45d1() {
    return $32ae13b741542474$export$3988ae62b71be9a3('sources/stats').promise.then(function(response) {
        return response.json();
    });
}




var $559aa794d8d2d8fd$var$FAST_DURATION_MS = 200;
// cancel source editing
function $559aa794d8d2d8fd$var$handleCancel(param) {
    var source = param.source, sourceElem = param.sourceElem, setSources = param.setSources, setEditedSource = param.setEditedSource;
    var id = source.id;
    if (id.toString().startsWith('new-')) (0, $7ef98d8c594793a5$export$c091916f1530334c)(sourceElem.current, {
        duration: $559aa794d8d2d8fd$var$FAST_DURATION_MS,
        complete: function() {
            // Remove the source from this page’s model.
            setSources(function(sources) {
                return sources.filter(function(source) {
                    return source.id !== id;
                });
            });
        }
    });
    else // Hide the input form.
    setEditedSource(null);
}
// save source
function $559aa794d8d2d8fd$var$handleSave(param) {
    var event = param.event, setSources = param.setSources, source = param.source, setEditedSource = param.setEditedSource, setSourceActionLoading = param.setSourceActionLoading, setJustSavedTimeout = param.setJustSavedTimeout, setSourceErrors = param.setSourceErrors;
    event.preventDefault();
    // remove old errors
    setSourceErrors({});
    setSourceActionLoading(true);
    var newSource = source;
    var id = source.id, tags = source.tags, filter = source.filter, params = source.params, restSource = (0, $aRv4I._)(source, [
        "id",
        "tags",
        "filter",
        "params"
    ]);
    // Make tags into a list.
    var tagsList = tags ? tags.split(',').map(function(tag) {
        return tag.trim();
    }).filter(function(tag) {
        return tag !== '';
    }) : [];
    var values = (0, $9Jpjh._)((0, $lvTkn._)({}, restSource, params), {
        tags: tagsList,
        filter: filter || null
    });
    $b0e03640e062f6f9$export$722fbec263ad908a(id, values).then(function(response) {
        if (!response.success) setSourceErrors(response);
        else {
            // Set justSavedTimeout state variable to a timeout.
            // The view will show “saved” text while the timeout runs.
            setJustSavedTimeout(function(oldTimeout) {
                // Only keep the most recent timeout.
                if (oldTimeout !== null) clearTimeout(oldTimeout);
                return window.setTimeout(function() {
                    setJustSavedTimeout(null);
                }, 10000);
            });
            // Hide the input form.
            setEditedSource(null);
            // Update tags and sources for navigation.
            selfoss.app.setTags(response.tags);
            selfoss.app.setTagsState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
            selfoss.app.setSources(response.sources);
            selfoss.app.setSourcesState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
            // Update sources in this page’s model.
            setSources(function(sources) {
                return sources.map(function(source) {
                    if (source.id === id) return (0, $9Jpjh._)((0, $lvTkn._)({}, newSource), {
                        id: response.id,
                        tags: tagsList,
                        // Use fetched title.
                        title: response.title
                    });
                    else return source;
                });
            });
        }
    }).catch(function(error) {
        selfoss.app.showError(selfoss.app._('error_edit_source') + ' ' + error.message);
    }).finally(function() {
        setSourceActionLoading(false);
    });
}
// delete source
function $559aa794d8d2d8fd$var$handleDelete(param) {
    var source = param.source, sourceElem = param.sourceElem, setSources = param.setSources, setSourceBeingDeleted = param.setSourceBeingDeleted, setDirty = param.setDirty;
    var answer = confirm(selfoss.app._('source_warn'));
    if (answer == false) return;
    // get id
    var id = source.id;
    setDirty(false);
    // show loading
    setSourceBeingDeleted(true);
    // delete on server
    $b0e03640e062f6f9$export$cd7f480d6b8286c3(id).then(function() {
        (0, $7ef98d8c594793a5$export$c091916f1530334c)(sourceElem.current, {
            duration: $559aa794d8d2d8fd$var$FAST_DURATION_MS,
            complete: function() {
                // Remove the source from this page’s model.
                setSources(function(sources) {
                    return sources.filter(function(source) {
                        return source.id !== id;
                    });
                });
            }
        });
        // Reload tags and remove source from navigation.
        selfoss.reloadTags();
        selfoss.app.setSources(function(sources) {
            return sources.filter(function(source) {
                return source.id !== id;
            });
        });
    }).catch(function(error) {
        setSourceBeingDeleted(false);
        selfoss.app.showError(selfoss.app._('error_delete_source') + ' ' + error.message);
    });
}
// start editing
function $559aa794d8d2d8fd$var$handleEdit(param) {
    var event = param.event, source = param.source, setEditedSource = param.setEditedSource;
    event.preventDefault();
    var id = source.id, title = source.title, tags = source.tags, filter = source.filter, spout = source.spout, params = source.params;
    setEditedSource({
        id: id,
        title: title ? (0, $4c0cf5d996e33977$export$e8bacd2802a88316)(title) : '',
        tags: tags ? tags.map((0, $4c0cf5d996e33977$export$e8bacd2802a88316)).join(',') : '',
        filter: filter,
        spout: spout,
        params: params
    });
}
// select new source spout type
function $559aa794d8d2d8fd$var$handleSpoutChange(param) {
    var event = param.event, setSpouts = param.setSpouts, updateEditedSource = param.updateEditedSource, setSourceParamsLoading = param.setSourceParamsLoading, setSourceParamsError = param.setSourceParamsError;
    var spoutClass = event.target.value;
    updateEditedSource({
        spout: spoutClass
    });
    if (spoutClass.trim().length === 0) return;
    setSourceParamsLoading(true);
    $b0e03640e062f6f9$export$d72d2378a998c10c(spoutClass).then(function(param) {
        var spout = param.spout;
        setSourceParamsLoading(false);
        setSpouts(function(spouts) {
            return (0, $9Jpjh._)((0, $lvTkn._)({}, spouts), (0, $khBmn._)({}, spoutClass, spout));
        });
        var defaults = Object.fromEntries(Object.entries(spout.params).map(function(param) {
            var _param = (0, $21h22._)(param, 2), _$param = _param[0], props = _param[1];
            var _props_default;
            return [
                _$param,
                (_props_default = props.default) !== null && _props_default !== void 0 ? _props_default : ''
            ];
        }));
        updateEditedSource(function(source) {
            var oldCompatibleParams = (0, $2b2b00f45dc8a6fe$export$2e2bcd8739ae039)(source.params, Object.keys(spout.params));
            return {
                params: (0, $lvTkn._)({}, defaults, oldCompatibleParams)
            };
        });
    }).catch(function(error) {
        setSourceParamsLoading(false);
        setSourceParamsError(error.message);
    });
}
// Taken from https://stackoverflow.com/a/15289883/160386
var $559aa794d8d2d8fd$var$MS_PER_DAY = 86400000;
function $559aa794d8d2d8fd$var$daysAgo(date) {
    // Get number of days between now and when the last entry was seen
    // Note: The time of the two dates is set to midnight
    // to get the difference of the two dates in calendar days
    // instead of a day equaling any 24 hour period which makes it
    // impossible to distinguish today and yesterday.
    var now = new Date();
    var today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    var old = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return Math.floor((today - old) / $559aa794d8d2d8fd$var$MS_PER_DAY);
}
function $559aa794d8d2d8fd$var$SourceEditForm(param) {
    var source = param.source, sourceElem = param.sourceElem, sourceError = param.sourceError, setSources = param.setSources, spouts = param.spouts, setSpouts = param.setSpouts, setEditedSource = param.setEditedSource, sourceActionLoading = param.sourceActionLoading, setSourceActionLoading = param.setSourceActionLoading, sourceParamsLoading = param.sourceParamsLoading, setSourceParamsLoading = param.setSourceParamsLoading, sourceParamsError = param.sourceParamsError, setSourceParamsError = param.setSourceParamsError, setJustSavedTimeout = param.setJustSavedTimeout, sourceErrors = param.sourceErrors, setSourceErrors = param.setSourceErrors, dirty = param.dirty, setDirty = param.setDirty;
    var sourceId = source.id;
    var updateEditedSource = (0, $eHaBZ.useCallback)(function(changes) {
        setDirty(true);
        if (typeof changes === 'function') setEditedSource(function(source) {
            return (0, $lvTkn._)({}, source, changes(source));
        });
        else setEditedSource(function(source) {
            return (0, $lvTkn._)({}, source, changes);
        });
    }, [
        setEditedSource,
        setDirty
    ]);
    var titleOnChange = (0, $eHaBZ.useCallback)(function(event) {
        return updateEditedSource({
            title: event.target.value
        });
    }, [
        updateEditedSource
    ]);
    var tagsOnChange = (0, $eHaBZ.useCallback)(function(event) {
        return updateEditedSource({
            tags: event.target.value
        });
    }, [
        updateEditedSource
    ]);
    var filterOnChange = (0, $eHaBZ.useCallback)(function(event) {
        return updateEditedSource({
            filter: event.target.value
        });
    }, [
        updateEditedSource
    ]);
    var spoutOnChange = (0, $eHaBZ.useCallback)(function(event) {
        return $559aa794d8d2d8fd$var$handleSpoutChange({
            event: event,
            setSpouts: setSpouts,
            updateEditedSource: updateEditedSource,
            setSourceParamsLoading: setSourceParamsLoading,
            setSourceParamsError: setSourceParamsError
        });
    }, [
        setSpouts,
        updateEditedSource,
        setSourceParamsLoading,
        setSourceParamsError
    ]);
    var saveOnClick = (0, $eHaBZ.useCallback)(function(event) {
        setDirty(false);
        $559aa794d8d2d8fd$var$handleSave({
            event: event,
            setSources: setSources,
            source: source,
            setEditedSource: setEditedSource,
            setSourceActionLoading: setSourceActionLoading,
            setJustSavedTimeout: setJustSavedTimeout,
            setSourceErrors: setSourceErrors
        });
    }, [
        setSources,
        source,
        setEditedSource,
        setSourceActionLoading,
        setJustSavedTimeout,
        setSourceErrors,
        setDirty
    ]);
    var cancelOnClick = (0, $eHaBZ.useCallback)(function(event) {
        event.preventDefault();
        if (dirty) {
            var answer = confirm(selfoss.app._('source_warn_cancel_dirty'));
            if (answer === false) return;
        }
        setDirty(false);
        $559aa794d8d2d8fd$var$handleCancel({
            event: event,
            source: source,
            sourceElem: sourceElem,
            setSources: setSources,
            setEditedSource: setEditedSource
        });
    }, [
        source,
        sourceElem,
        setSources,
        setEditedSource,
        dirty,
        setDirty
    ]);
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    var sourceParamsContent = sourceParamsLoading ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $4e51d095a6eb2eac$export$7f7cbe89f1eacd2), {
        size: "3x",
        label: _('source_params_loading')
    }) : sourceParamsError !== null && sourceParamsError !== void 0 ? sourceParamsError : Object.keys(spouts).includes(source.spout) && Object.keys(spouts[source.spout].params).length > 0 ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("ul", {
        children: Object.entries(spouts[source.spout].params).map(function(param) {
            var _param = (0, $21h22._)(param, 2), spoutParamName = _param[0], spoutParam = _param[1];
            return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $5101856265f93aa2$export$2e2bcd8739ae039), {
                params: source.params,
                spoutParamName: spoutParamName,
                spoutParam: spoutParam,
                sourceErrors: sourceErrors,
                sourceId: sourceId,
                setEditedSource: setEditedSource,
                setDirty: setDirty
            }, spoutParamName);
        })
    }) : null;
    var _source_title, _source_tags, _source_filter;
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("form", {
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", {
            className: "source-edit-form",
            children: [
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                            htmlFor: "title-".concat(sourceId),
                            children: _('source_title')
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                            id: "title-".concat(sourceId),
                            type: "text",
                            name: "title",
                            accessKey: "t",
                            value: (_source_title = source.title) !== null && _source_title !== void 0 ? _source_title : '',
                            placeholder: _('source_autotitle_hint'),
                            onChange: titleOnChange,
                            autoFocus: true
                        }),
                        sourceErrors.title ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                            className: "error",
                            children: sourceErrors.title
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                            htmlFor: "tags-".concat(sourceId),
                            children: _('source_tags')
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                            id: "tags-".concat(sourceId),
                            type: "text",
                            name: "tags",
                            accessKey: "g",
                            value: (_source_tags = source.tags) !== null && _source_tags !== void 0 ? _source_tags : '',
                            onChange: tagsOnChange
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("span", {
                            className: "source-edit-form-help",
                            children: [
                                ' ',
                                _('source_comma')
                            ]
                        }),
                        sourceErrors.tags ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                            className: "error",
                            children: sourceErrors.tags
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                            htmlFor: "filter-".concat(sourceId),
                            children: _('source_filter')
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                            id: "filter-".concat(sourceId),
                            type: "text",
                            name: "filter",
                            accessKey: "f",
                            value: (_source_filter = source.filter) !== null && _source_filter !== void 0 ? _source_filter : '',
                            onChange: filterOnChange
                        }),
                        sourceErrors.filter ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                            className: "error",
                            children: sourceErrors.filter
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                            htmlFor: "type-".concat(sourceId),
                            children: _('source_type')
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("select", {
                            id: "type-".concat(sourceId),
                            className: "source-spout",
                            name: "spout",
                            accessKey: "y",
                            onChange: spoutOnChange,
                            value: source.spout,
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("option", {
                                    value: "",
                                    children: _('source_select')
                                }),
                                Object.entries(spouts).map(function(param) {
                                    var _param = (0, $21h22._)(param, 2), spouttype = _param[0], spout = _param[1];
                                    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("option", {
                                        title: spout.description,
                                        value: spouttype,
                                        children: spout.name
                                    }, spouttype);
                                })
                            ]
                        }),
                        sourceErrors.spout ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                            className: "error",
                            children: sourceErrors.spout
                        }) : null
                    ]
                }),
                sourceParamsContent ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                    className: "source-params",
                    children: sourceParamsContent
                }) : null,
                sourceError ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                    className: "source-error",
                    "aria-live": "assertive",
                    children: sourceError
                }) : null,
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    className: "source-action",
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                            type: "submit",
                            className: "source-save",
                            accessKey: "s",
                            onClick: saveOnClick,
                            children: [
                                _('source_save'),
                                sourceActionLoading && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
                                    children: [
                                        ' ',
                                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $4e51d095a6eb2eac$export$7f7cbe89f1eacd2), {
                                            label: _('source_saving')
                                        })
                                    ]
                                })
                            ]
                        }),
                        " \u2022 ",
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                            type: "submit",
                            className: "source-cancel",
                            accessKey: "c",
                            onClick: cancelOnClick,
                            children: _('source_cancel')
                        })
                    ]
                })
            ]
        })
    });
}
$559aa794d8d2d8fd$var$SourceEditForm.propTypes = {
    source: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    sourceElem: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    sourceError: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string,
    setSources: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    spouts: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    setSpouts: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    setEditedSource: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    sourceActionLoading: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    setSourceActionLoading: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    sourceParamsLoading: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    setSourceParamsLoading: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    sourceParamsError: (0, (/*@__PURE__*/$parcel$interopDefault($cff7e9a474db95c7$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string).isRequired,
    setSourceParamsError: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    setJustSavedTimeout: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    sourceErrors: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string).isRequired,
    setSourceErrors: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    dirty: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    setDirty: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};
function $559aa794d8d2d8fd$export$2e2bcd8739ae039(param) {
    var source = param.source, setSources = param.setSources, spouts = param.spouts, setSpouts = param.setSpouts, dirty = param.dirty, setDirtySources = param.setDirtySources;
    var isNew = !source.title;
    var classes = {
        source: true,
        'source-new': isNew,
        error: source.error && source.error.length > 0
    };
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(isNew ? (0, $lvTkn._)({}, source) : null), 2), editedSource = _useState[0], setEditedSource = _useState[1];
    var _useState1 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), sourceActionLoading = _useState1[0], setSourceActionLoading = _useState1[1];
    var _useState2 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), sourceBeingDeleted = _useState2[0], setSourceBeingDeleted = _useState2[1];
    var _useState3 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), sourceParamsLoading = _useState3[0], setSourceParamsLoading = _useState3[1];
    var _useState4 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), justSavedTimeout = _useState4[0], setJustSavedTimeout = _useState4[1];
    var _useState5 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), sourceParamsError = _useState5[0], setSourceParamsError = _useState5[1];
    var _useState6 = (0, $21h22._)((0, $eHaBZ.useState)({}), 2), sourceErrors = _useState6[0], setSourceErrors = _useState6[1];
    (0, $eHaBZ.useEffect)(function() {
        // Prevent timeout from trying to update state after unmount.
        var oldTimeout = justSavedTimeout;
        return function() {
            if (oldTimeout !== null) clearTimeout(oldTimeout);
        };
    }, [
        justSavedTimeout
    ]);
    var editOnClick = (0, $eHaBZ.useCallback)(function(event) {
        return $559aa794d8d2d8fd$var$handleEdit({
            event: event,
            source: source,
            setEditedSource: setEditedSource
        });
    }, [
        source,
        setEditedSource
    ]);
    var setDirty = (0, $eHaBZ.useCallback)(function(dirty) {
        setDirtySources(function(dirtySources) {
            return (0, $9Jpjh._)((0, $lvTkn._)({}, dirtySources), (0, $khBmn._)({}, source.id, dirty));
        });
    }, [
        source.id,
        setDirtySources
    ]);
    var navigate = (0, $5XYIU.useNavigate)();
    var location = (0, $5XYIU.useLocation)();
    var sourceElem = (0, $eHaBZ.useRef)(null);
    var extraMenuOnSelection = (0, $eHaBZ.useCallback)(function(param) {
        var value = param.value;
        if (value === 'delete') $559aa794d8d2d8fd$var$handleDelete({
            source: source,
            sourceElem: sourceElem,
            setSources: setSources,
            setSourceBeingDeleted: setSourceBeingDeleted,
            setDirty: setDirty
        });
        else if (value === 'browse') navigate((0, $0be080af3052783c$export$d0bb2ab5375d1521)(location, {
            category: "source-".concat(source.id)
        }));
    }, [
        source,
        sourceElem,
        setSources,
        setDirty,
        location,
        navigate
    ]);
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))(classes),
        "data-id": source.id,
        id: "source-".concat(source.id),
        ref: sourceElem,
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                className: "source-icon",
                children: source.icon && source.icon != '0' ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("img", {
                    src: "favicons/".concat(source.icon),
                    "aria-hidden": "true",
                    alt: ""
                }) : null
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("h2", {
                className: "source-title",
                children: source.title ? (0, $4c0cf5d996e33977$export$e8bacd2802a88316)(source.title) : _('source_new')
            }),
            ' ',
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                className: "source-edit-delete",
                children: [
                    !editedSource && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                                type: "button",
                                accessKey: "e",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                    'source-showparams': true,
                                    saved: justSavedTimeout !== null
                                }),
                                onClick: editOnClick,
                                "aria-expanded": !!editedSource,
                                children: _(justSavedTimeout !== null ? 'source_saved' : 'source_edit')
                            }),
                            " \u2022 "
                        ]
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $afcad17a77b29a48$export$d9b273488cd8ce6f), {
                        onItemClick: extraMenuOnSelection,
                        menuButton: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $7a4ada20cb42c4ac$export$266a769812832828), {
                            className: "source-menu-button",
                            children: [
                                _('source_menu'),
                                sourceBeingDeleted && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
                                    children: [
                                        ' ',
                                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $4e51d095a6eb2eac$export$7f7cbe89f1eacd2), {
                                            label: _('source_deleting')
                                        })
                                    ]
                                })
                            ]
                        }),
                        menuClassName: "popup-menu",
                        children: [
                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $196651884997e353$export$2ce376c2cc3355c8), {
                                accessKey: "d",
                                className: "popup-menu-item source-browse",
                                value: "browse",
                                children: _('source_browse')
                            }),
                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $196651884997e353$export$2ce376c2cc3355c8), {
                                accessKey: "d",
                                className: "popup-menu-item source-delete",
                                value: "delete",
                                children: _('source_delete')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                className: "source-days",
                children: source.lastentry ? " \u2022 ".concat(_('source_last_post'), " ").concat(_('days', [
                    $559aa794d8d2d8fd$var$daysAgo(new Date(source.lastentry * 1000))
                ])) : null
            }),
            editedSource ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($559aa794d8d2d8fd$var$SourceEditForm, {
                setSources: setSources,
                spouts: spouts,
                setSpouts: setSpouts,
                setEditedSource: setEditedSource,
                sourceActionLoading: sourceActionLoading,
                setSourceActionLoading: setSourceActionLoading,
                sourceParamsLoading: sourceParamsLoading,
                setSourceParamsLoading: setSourceParamsLoading,
                sourceParamsError: sourceParamsError,
                setSourceParamsError: setSourceParamsError,
                setJustSavedTimeout: setJustSavedTimeout,
                sourceErrors: sourceErrors,
                setSourceErrors: setSourceErrors,
                dirty: dirty,
                setDirty: setDirty,
                sourceElem: sourceElem,
                sourceError: source.error,
                source: editedSource
            }) : null
        ]
    });
}
$559aa794d8d2d8fd$export$2e2bcd8739ae039.propTypes = {
    source: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    setSources: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    spouts: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    setSpouts: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    dirty: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    setDirtySources: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};






var $21h22 = parcelRequire("21h22");

var $eHaBZ = parcelRequire("eHaBZ");

var $5XYIU = parcelRequire("5XYIU");

function $c8aedc92b88eb948$export$7bcdf1c247ef07b1() {
    var _location_state;
    var location = (0, $5XYIU.useLocation)();
    var forceReload = location === null || location === void 0 ? void 0 : (_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.forceReload;
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(forceReload), 2), oldForceReload = _useState[0], setOldForceReload = _useState[1];
    if (oldForceReload !== forceReload) setOldForceReload(forceReload);
    // The location state is not persisted during navigation
    // so forceReload would change to undefined on successive navigation,
    // triggering an unwanter reload.
    // We use a separate counter to prevent that.
    var _useState1 = (0, $21h22._)((0, $eHaBZ.useState)(0), 2), reloadCounter = _useState1[0], setReloadCounter = _useState1[1];
    if (forceReload !== undefined && forceReload !== oldForceReload) {
        var newReloadCounter = reloadCounter + 1;
        setReloadCounter(newReloadCounter);
        return newReloadCounter;
    }
    return reloadCounter;
}
function $c8aedc92b88eb948$export$443718c44347a6b3() {
    return (0, $c020e53fc27b31fb$export$b1eecdc553bff745)('(max-width: 641px)');
}
function $c8aedc92b88eb948$export$96b5b894afc1d2e3(valueListenable) {
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(valueListenable.value), 2), value = _useState[0], setValue = _useState[1];
    (0, $eHaBZ.useEffect)(function() {
        var listener = function(event) {
            setValue(event.value);
        };
        // It might happen that values change between creating the component and setting up the event handlers.
        listener({
            value: valueListenable.value
        });
        valueListenable.addEventListener('change', listener);
        return function() {
            valueListenable.removeEventListener('change', listener);
        };
    }, [
        valueListenable
    ]);
    return value;
}




function $160db82a87133f5d$var$rand() {
    // https://www.php.net/manual/en/function.mt-getrandmax.php#117620
    return Math.floor(Math.random() * 2147483647);
}
function $160db82a87133f5d$var$handleAddSource(param) {
    var _param_event = param.event, event = _param_event === void 0 ? null : _param_event, setSources = param.setSources, setSpouts = param.setSpouts, _param_extraInitialData = param.extraInitialData, extraInitialData = _param_extraInitialData === void 0 ? {} : _param_extraInitialData;
    if (event) event.preventDefault();
    // Add new empty source.
    setSources(function(sources) {
        return [
            (0, $lvTkn._)({
                id: 'new-' + $160db82a87133f5d$var$rand()
            }, extraInitialData)
        ].concat((0, $6zk1M._)(sources));
    });
    // Refresh the spout datea
    $b0e03640e062f6f9$export$ba43f46f09336c84().then(function(spouts) {
        // Update spout data.
        setSpouts(spouts);
    }).catch(function() {
        console.error('Unable to update spouts, falling back to previously fetched list.');
    });
}
// load sources
function $160db82a87133f5d$var$loadSources(param) {
    var abortController = param.abortController, location = param.location, navigate = param.navigate, setSpouts = param.setSpouts, setSources = param.setSources, setLoadingState = param.setLoadingState;
    if (abortController.signal.aborted) return Promise.resolve();
    setLoadingState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING);
    return (0, $b0e03640e062f6f9$export$316f19f1ddc6b34e)(abortController).then(function(param) {
        var sources = param.sources, spouts = param.spouts;
        if (abortController.signal.aborted) return;
        setSpouts(spouts);
        setSources(sources);
        setLoadingState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
        if (location.hash.startsWith('#source-')) {
            var source = document.querySelector('.source[data-id="'.concat(location.hash.replace(/^#source-/, ''), '"]'));
            if (!source) return;
            // needs to be delayed for some reason
            requestAnimationFrame(function() {
                source.scrollIntoView();
            });
        }
    }).catch(function(error) {
        if (error.name === 'AbortError' || abortController.signal.aborted) return;
        selfoss.handleAjaxError(error, false).catch(function(error) {
            if (error instanceof (0, $0d06257c362dc1a1$export$65bd6083489bd8bb) && error.response.status === 403) {
                navigate('/sign/in', {
                    state: {
                        error: selfoss.app._('error_session_expired')
                    }
                });
                return;
            }
            selfoss.app.showError(selfoss.app._('error_loading') + ' ' + error.message);
        });
        setLoadingState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).FAILURE);
    });
}
function $160db82a87133f5d$export$2e2bcd8739ae039() {
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)([]), 2), spouts = _useState[0], setSpouts = _useState[1];
    var _useState1 = (0, $21h22._)((0, $eHaBZ.useState)([]), 2), sources = _useState1[0], setSources = _useState1[1];
    var _useState2 = (0, $21h22._)((0, $eHaBZ.useState)((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).INITIAL), 2), loadingState = _useState2[0], setLoadingState = _useState2[1];
    var forceReload = (0, $c8aedc92b88eb948$export$7bcdf1c247ef07b1)();
    var navigate = (0, $5XYIU.useNavigate)();
    var location = (0, $5XYIU.useLocation)();
    var isAdding = (0, $5XYIU.useMatch)('/manage/sources/add');
    (0, $eHaBZ.useEffect)(function() {
        var abortController = new AbortController();
        $160db82a87133f5d$var$loadSources({
            abortController: abortController,
            location: location,
            navigate: navigate,
            setSpouts: setSpouts,
            setSources: setSources,
            setLoadingState: setLoadingState
        }).then(function() {
            if (isAdding) {
                var params = new URLSearchParams(location.search);
                var _params_get;
                $160db82a87133f5d$var$handleAddSource({
                    setSources: setSources,
                    setSpouts: setSpouts,
                    extraInitialData: {
                        spout: 'spouts\\rss\\feed',
                        params: {
                            url: (_params_get = params.get('url')) !== null && _params_get !== void 0 ? _params_get : ''
                        }
                    }
                });
                // Clear the value from the state so it does not bug us forever.
                navigate('/manage/sources', {
                    replace: true
                });
            }
        });
        return function() {
            abortController.abort();
        };
    }, [
        forceReload
    ]);
    var addOnClick = (0, $eHaBZ.useCallback)(function(event) {
        return $160db82a87133f5d$var$handleAddSource({
            event: event,
            setSources: setSources,
            setSpouts: setSpouts
        });
    }, []);
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    var _useState3 = (0, $21h22._)((0, $eHaBZ.useState)({}), 2), dirtySources = _useState3[0], setDirtySources = _useState3[1];
    // eslint-disable-next-line no-unused-vars
    var isDirty = (0, $eHaBZ.useMemo)(function() {
        return Object.values(dirtySources).includes(true);
    }, [
        dirtySources
    ]);
    // TODO: Error: useBlocker must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.
    // usePrompt({
    //     when: isDirty,
    //     message: _('sources_leaving_unsaved_prompt'),
    // });
    if (loadingState === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING) return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $4e51d095a6eb2eac$export$84dbad74efe95918), {
        label: _('sources_loading')
    });
    if (loadingState !== (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS) return null;
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                className: "source-add",
                onClick: addOnClick,
                children: _('source_add')
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("a", {
                className: "source-export",
                href: "opmlexport",
                children: _('source_export')
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $5XYIU.Link), {
                className: "source-opml",
                to: "/opml",
                children: _('source_opml')
            }),
            sources ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("ul", {
                children: sources.map(function(source) {
                    var _dirtySources_source_id;
                    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $559aa794d8d2d8fd$export$2e2bcd8739ae039), {
                        dirty: (_dirtySources_source_id = dirtySources[source.id]) !== null && _dirtySources_source_id !== void 0 ? _dirtySources_source_id : false,
                        source: source,
                        setSources: setSources,
                        spouts: spouts,
                        setSpouts: setSpouts,
                        setDirtySources: setDirtySources
                    }, source.id);
                })
            }) : /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("p", {
                children: _('no_sources')
            })
        ]
    });
}



var $8xMIM = parcelRequire("8xMIM");

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $khBmn = parcelRequire("khBmn");

var $NBk0Y = parcelRequire("NBk0Y");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $21h22 = parcelRequire("21h22");

var $6zk1M = parcelRequire("6zk1M");


var $eHaBZ = parcelRequire("eHaBZ");


var $5XYIU = parcelRequire("5XYIU");

var $52218fae2790199f$exports = {};
"use strict";
Object.defineProperty($52218fae2790199f$exports, "__esModule", {
    value: true
});
$52218fae2790199f$exports.useStateWithDeps = $52218fae2790199f$var$useStateWithDeps;

var $eHaBZ = parcelRequire("eHaBZ");
var $fa3cfc9f742f9e64$exports = {};
"use strict";
Object.defineProperty($fa3cfc9f742f9e64$exports, "__esModule", {
    value: true
});
$fa3cfc9f742f9e64$exports.useForceUpdate = $fa3cfc9f742f9e64$var$useForceUpdate;

var $eHaBZ = parcelRequire("eHaBZ");
function $fa3cfc9f742f9e64$var$_slicedToArray(r, e) {
    return $fa3cfc9f742f9e64$var$_arrayWithHoles(r) || $fa3cfc9f742f9e64$var$_iterableToArrayLimit(r, e) || $fa3cfc9f742f9e64$var$_unsupportedIterableToArray(r, e) || $fa3cfc9f742f9e64$var$_nonIterableRest();
}
function $fa3cfc9f742f9e64$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fa3cfc9f742f9e64$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $fa3cfc9f742f9e64$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $fa3cfc9f742f9e64$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $fa3cfc9f742f9e64$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $fa3cfc9f742f9e64$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $fa3cfc9f742f9e64$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $fa3cfc9f742f9e64$var$useForceUpdate() {
    var _useReducer = (0, $eHaBZ.useReducer)(function() {
        return Symbol();
    }, undefined), _useReducer2 = $fa3cfc9f742f9e64$var$_slicedToArray(_useReducer, 2), forceUpdate = _useReducer2[1];
    return function() {
        return forceUpdate();
    };
}


var $686edff819e0378d$exports = {};
"use strict";
Object.defineProperty($686edff819e0378d$exports, "__esModule", {
    value: true
});
$686edff819e0378d$exports.depsAreEqual = $686edff819e0378d$var$depsAreEqual;
function $686edff819e0378d$var$depsAreEqual(prevDeps, deps) {
    return prevDeps.length === deps.length && deps.every(function(dep, index) {
        return Object.is(dep, prevDeps[index]);
    });
}


var $77b0cc4e4744fb64$exports = {};
"use strict";
Object.defineProperty($77b0cc4e4744fb64$exports, "__esModule", {
    value: true
});
$77b0cc4e4744fb64$exports.isFunction = $77b0cc4e4744fb64$var$isFunction;
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
function $77b0cc4e4744fb64$var$isFunction(input) {
    return typeof input === "function";
}


/**
 * `useState` hook with an additional dependency array that resets
 * the state to the `initialState` param when the dependencies passed
 * in the `deps` array change.
 *
 * @param initialState
 * The state that will be set when the component mounts or the
 * dependencies change.
 *
 * It can also be a function which resolves to the state. If the state
 * is reset due to a change of dependencies, this function will be called with the previous
 * state (`undefined` for the first call upon mount).
 * @param deps Dependencies for this hook that resets the state to `initialState`
 */ function $52218fae2790199f$var$useStateWithDeps(initialState, deps) {
    var isMounted = (0, $eHaBZ.useRef)(false);
    // Determine initial state
    var usableInitialState = null;
    if (!isMounted.current) {
        isMounted.current = true;
        if ((0, $77b0cc4e4744fb64$exports.isFunction)(initialState)) usableInitialState = initialState();
        else usableInitialState = initialState;
    }
    // It would be possible to use useState instead of
    // useRef to store the state, however this would
    // trigger re-renders whenever the state is reset due
    // to a change in dependencies. In order to avoid these
    // re-renders, the state is stored in a ref and an
    // update is triggered via forceUpdate below when necessary
    var state = (0, $eHaBZ.useRef)(usableInitialState);
    // Check if dependencies have changed
    var prevDeps = (0, $eHaBZ.useRef)(deps);
    if (!(0, $686edff819e0378d$exports.depsAreEqual)(prevDeps.current, deps)) {
        // Update state and deps
        var nextState;
        if ((0, $77b0cc4e4744fb64$exports.isFunction)(initialState)) nextState = initialState(state.current);
        else nextState = initialState;
        state.current = nextState;
        prevDeps.current = deps;
    }
    var forceUpdate = (0, $fa3cfc9f742f9e64$exports.useForceUpdate)();
    var updateState = (0, $eHaBZ.useCallback)(function updateState(newState) {
        var nextState;
        if ((0, $77b0cc4e4744fb64$exports.isFunction)(newState)) nextState = newState(state.current);
        else nextState = newState;
        if (!Object.is(state.current, nextState)) {
            state.current = nextState;
            forceUpdate();
        }
    }, []);
    return [
        state.current,
        updateState
    ];
}




var $21h22 = parcelRequire("21h22");


var $eHaBZ = parcelRequire("eHaBZ");


var $5XYIU = parcelRequire("5XYIU");



/*!
* focus-trap 7.6.6
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/ 
var $2bfPH = parcelRequire("2bfPH");
/*!
* tabbable 6.3.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $863eb30dd7d7e7a9$var$candidateSelectors = [
    'input:not([inert])',
    'select:not([inert])',
    'textarea:not([inert])',
    'a[href]:not([inert])',
    'button:not([inert])',
    '[tabindex]:not(slot):not([inert])',
    'audio[controls]:not([inert])',
    'video[controls]:not([inert])',
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    'details>summary:first-of-type:not([inert])',
    'details:not([inert])'
];
var $863eb30dd7d7e7a9$var$candidateSelector = /* #__PURE__ */ $863eb30dd7d7e7a9$var$candidateSelectors.join(',');
var $863eb30dd7d7e7a9$var$NoElement = typeof Element === 'undefined';
var $863eb30dd7d7e7a9$var$matches = $863eb30dd7d7e7a9$var$NoElement ? function matches() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $863eb30dd7d7e7a9$var$getRootNode = !$863eb30dd7d7e7a9$var$NoElement && Element.prototype.getRootNode ? function getRootNode(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $863eb30dd7d7e7a9$var$_isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && $863eb30dd7d7e7a9$var$_isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $863eb30dd7d7e7a9$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $863eb30dd7d7e7a9$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($863eb30dd7d7e7a9$var$_isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($863eb30dd7d7e7a9$var$candidateSelector));
    if (includeContainer && $863eb30dd7d7e7a9$var$matches.call(el, $863eb30dd7d7e7a9$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $863eb30dd7d7e7a9$var$_getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($863eb30dd7d7e7a9$var$_isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = $863eb30dd7d7e7a9$var$_getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $863eb30dd7d7e7a9$var$matches.call(element, $863eb30dd7d7e7a9$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$863eb30dd7d7e7a9$var$_isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = $863eb30dd7d7e7a9$var$_getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $863eb30dd7d7e7a9$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $863eb30dd7d7e7a9$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $863eb30dd7d7e7a9$var$isContentEditable(node)) && !$863eb30dd7d7e7a9$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $863eb30dd7d7e7a9$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $863eb30dd7d7e7a9$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$863eb30dd7d7e7a9$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $863eb30dd7d7e7a9$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $863eb30dd7d7e7a9$var$isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var $863eb30dd7d7e7a9$var$isHiddenInput = function isHiddenInput(node) {
    return $863eb30dd7d7e7a9$var$isInput(node) && node.type === 'hidden';
};
var $863eb30dd7d7e7a9$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var $863eb30dd7d7e7a9$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $863eb30dd7d7e7a9$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $863eb30dd7d7e7a9$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = $863eb30dd7d7e7a9$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $863eb30dd7d7e7a9$var$isRadio = function isRadio(node) {
    return $863eb30dd7d7e7a9$var$isInput(node) && node.type === 'radio';
};
var $863eb30dd7d7e7a9$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $863eb30dd7d7e7a9$var$isRadio(node) && !$863eb30dd7d7e7a9$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $863eb30dd7d7e7a9$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $863eb30dd7d7e7a9$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $863eb30dd7d7e7a9$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $863eb30dd7d7e7a9$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $863eb30dd7d7e7a9$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    if (displayCheck === 'full-native') {
        if ('checkVisibility' in node) {
            // Chrome >= 105, Edge >= 105, Firefox >= 106, Safari >= 17.4
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Element/checkVisibility#browser_compatibility
            var visible = node.checkVisibility({
                // Checking opacity might be desirable for some use cases, but natively,
                // opacity zero elements _are_ focusable and tabbable.
                checkOpacity: false,
                opacityProperty: false,
                contentVisibilityAuto: true,
                visibilityProperty: true,
                // This is an alias for `visibilityProperty`. Contemporary browsers
                // support both. However, this alias has wider browser support (Chrome
                // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
                // we include it anyway.
                checkVisibilityCSS: true
            });
            return !visible;
        }
    }
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === 'hidden') return true;
    var isDirectSummary = $863eb30dd7d7e7a9$var$matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($863eb30dd7d7e7a9$var$matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || // full-native can run this branch when it falls through in case
    // Element#checkVisibility is unsupported
    displayCheck === 'full-native' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $863eb30dd7d7e7a9$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $863eb30dd7d7e7a9$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($863eb30dd7d7e7a9$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $863eb30dd7d7e7a9$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $863eb30dd7d7e7a9$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $863eb30dd7d7e7a9$var$matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $863eb30dd7d7e7a9$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $863eb30dd7d7e7a9$var$_isInert(node) || $863eb30dd7d7e7a9$var$isHiddenInput(node) || $863eb30dd7d7e7a9$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $863eb30dd7d7e7a9$var$isDetailsWithSummary(node) || $863eb30dd7d7e7a9$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $863eb30dd7d7e7a9$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($863eb30dd7d7e7a9$var$isNonTabbableRadio(node) || $863eb30dd7d7e7a9$export$a4672efddb4181b8(node) < 0 || !$863eb30dd7d7e7a9$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $863eb30dd7d7e7a9$var$isShadowRootTabbable = function isShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $863eb30dd7d7e7a9$var$_sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $863eb30dd7d7e7a9$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? $863eb30dd7d7e7a9$var$_sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($863eb30dd7d7e7a9$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $863eb30dd7d7e7a9$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $863eb30dd7d7e7a9$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $863eb30dd7d7e7a9$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $863eb30dd7d7e7a9$var$isShadowRootTabbable
    });
    else candidates = $863eb30dd7d7e7a9$var$getCandidates(container, options.includeContainer, $863eb30dd7d7e7a9$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $863eb30dd7d7e7a9$var$_sortByOrder(candidates);
};
var $863eb30dd7d7e7a9$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $863eb30dd7d7e7a9$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $863eb30dd7d7e7a9$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $863eb30dd7d7e7a9$var$getCandidates(container, options.includeContainer, $863eb30dd7d7e7a9$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $863eb30dd7d7e7a9$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($863eb30dd7d7e7a9$var$matches.call(node, $863eb30dd7d7e7a9$var$candidateSelector) === false) return false;
    return $863eb30dd7d7e7a9$var$isNodeMatchingSelectorTabbable(options, node);
};
var $863eb30dd7d7e7a9$var$focusableCandidateSelector = /* #__PURE__ */ $863eb30dd7d7e7a9$var$candidateSelectors.concat('iframe').join(',');
var $863eb30dd7d7e7a9$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($863eb30dd7d7e7a9$var$matches.call(node, $863eb30dd7d7e7a9$var$focusableCandidateSelector) === false) return false;
    return $863eb30dd7d7e7a9$var$isNodeMatchingSelectorFocusable(options, node);
};


function $197853feae65c1a7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $197853feae65c1a7$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $197853feae65c1a7$var$_arrayLikeToArray(r);
}
function $197853feae65c1a7$var$_defineProperty(e, r, t) {
    return (r = $197853feae65c1a7$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function $197853feae65c1a7$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $197853feae65c1a7$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $197853feae65c1a7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $197853feae65c1a7$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $197853feae65c1a7$var$ownKeys(Object(t), true).forEach(function(r) {
            $197853feae65c1a7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $197853feae65c1a7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $197853feae65c1a7$var$_toConsumableArray(r) {
    return $197853feae65c1a7$var$_arrayWithoutHoles(r) || $197853feae65c1a7$var$_iterableToArray(r) || $197853feae65c1a7$var$_unsupportedIterableToArray(r) || $197853feae65c1a7$var$_nonIterableSpread();
}
function $197853feae65c1a7$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $2bfPH._)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $2bfPH._)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $197853feae65c1a7$var$_toPropertyKey(t) {
    var i = $197853feae65c1a7$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $2bfPH._)(i)) ? i : i + "";
}
function $197853feae65c1a7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $197853feae65c1a7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $197853feae65c1a7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $197853feae65c1a7$var$activeFocusTraps = {
    activateTrap: function activateTrap(trapStack, trap) {
        if (trapStack.length > 0) {
            var activeTrap = trapStack[trapStack.length - 1];
            if (activeTrap !== trap) activeTrap._setPausedState(true);
        }
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex === -1) trapStack.push(trap);
        else {
            // move this existing trap to the front of the queue
            trapStack.splice(trapIndex, 1);
            trapStack.push(trap);
        }
    },
    deactivateTrap: function deactivateTrap(trapStack, trap) {
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex !== -1) trapStack.splice(trapIndex, 1);
        if (trapStack.length > 0 && !trapStack[trapStack.length - 1]._isManuallyPaused()) trapStack[trapStack.length - 1]._setPausedState(false);
    }
};
var $197853feae65c1a7$var$isSelectableInput = function isSelectableInput(node) {
    return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
};
var $197853feae65c1a7$var$isEscapeEvent = function isEscapeEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === 'Escape' || (e === null || e === void 0 ? void 0 : e.key) === 'Esc' || (e === null || e === void 0 ? void 0 : e.keyCode) === 27;
};
var $197853feae65c1a7$var$isTabEvent = function isTabEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === 'Tab' || (e === null || e === void 0 ? void 0 : e.keyCode) === 9;
};
// checks for TAB by default
var $197853feae65c1a7$var$isKeyForward = function isKeyForward(e) {
    return $197853feae65c1a7$var$isTabEvent(e) && !e.shiftKey;
};
// checks for SHIFT+TAB by default
var $197853feae65c1a7$var$isKeyBackward = function isKeyBackward(e) {
    return $197853feae65c1a7$var$isTabEvent(e) && e.shiftKey;
};
var $197853feae65c1a7$var$delay = function delay(fn) {
    return setTimeout(fn, 0);
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */ var $197853feae65c1a7$var$valueOrHandler = function valueOrHandler(value) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
    return typeof value === 'function' ? value.apply(void 0, params) : value;
};
var $197853feae65c1a7$var$getActualTarget = function getActualTarget(event) {
    // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
    //  shadow host. However, event.target.composedPath() will be an array of
    //  nodes "clicked" from inner-most (the actual element inside the shadow) to
    //  outer-most (the host HTML document). If we have access to composedPath(),
    //  then use its first element; otherwise, fall back to event.target (and
    //  this only works for an _open_ shadow DOM; otherwise,
    //  composedPath()[0] === event.target always).
    return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
};
// NOTE: this must be _outside_ `createFocusTrap()` to make sure all traps in this
//  current instance use the same stack if `userOptions.trapStack` isn't specified
var $197853feae65c1a7$var$internalTrapStack = [];
var $197853feae65c1a7$export$360440dfcba94c00 = function createFocusTrap(elements, userOptions) {
    // SSR: a live trap shouldn't be created in this type of environment so this
    //  should be safe code to execute if the `document` option isn't specified
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var trapStack = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.trapStack) || $197853feae65c1a7$var$internalTrapStack;
    var config = $197853feae65c1a7$var$_objectSpread2({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true,
        isKeyForward: $197853feae65c1a7$var$isKeyForward,
        isKeyBackward: $197853feae65c1a7$var$isKeyBackward
    }, userOptions);
    var state = {
        // containers given to createFocusTrap()
        // @type {Array<HTMLElement>}
        containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        // @type {Array<{
        //   container: HTMLElement,
        //   tabbableNodes: Array<HTMLElement>, // empty if none
        //   focusableNodes: Array<HTMLElement>, // empty if none
        //   posTabIndexesFound: boolean,
        //   firstTabbableNode: HTMLElement|undefined,
        //   lastTabbableNode: HTMLElement|undefined,
        //   firstDomTabbableNode: HTMLElement|undefined,
        //   lastDomTabbableNode: HTMLElement|undefined,
        //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
        // }>}
        containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
        manuallyPaused: false,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: undefined,
        // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
        recentNavEvent: undefined
    };
    var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later
    /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */ var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
        return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @param {Event} [event] If available, and `element` isn't directly found in any container,
   *  the event's composed path is used to see if includes any known trap containers in the
   *  case where the element is inside a Shadow DOM.
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */ var findContainerIndex = function findContainerIndex(element, event) {
        var composedPath = typeof (event === null || event === void 0 ? void 0 : event.composedPath) === 'function' ? event.composedPath() : undefined;
        // NOTE: search `containerGroups` because it's possible a group contains no tabbable
        //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
        //  and we still need to find the element in there
        return state.containerGroups.findIndex(function(_ref) {
            var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
            return container.contains(element) || //  web components if the `tabbableOptions.getShadowRoot` option was used for
            //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
            //  look inside web components even if open)
            (composedPath === null || composedPath === void 0 ? void 0 : composedPath.includes(container)) || tabbableNodes.find(function(node) {
                return node === element;
            });
        });
    };
    /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @param {Object} options
   * @param {boolean} [options.hasFallback] True if the option could be a selector string
   *  and the option allows for a fallback scenario in the case where the selector is
   *  valid but does not match a node (i.e. the queried node doesn't exist in the DOM).
   * @param {Array} [options.params] Params to pass to the option if it's a function.
   * @returns {undefined | null | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `null` if the option didn't resolve
   *  to a node but `options.hasFallback=true`, `false` if the option resolved to `false`
   *  (node explicitly not given); otherwise, the resolved DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node, unless the option is a selector string and `options.hasFallback=true`.
   */ var getNodeForOption = function getNodeForOption(optionName) {
        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref2$hasFallback = _ref2.hasFallback, hasFallback = _ref2$hasFallback === void 0 ? false : _ref2$hasFallback, _ref2$params = _ref2.params, params = _ref2$params === void 0 ? [] : _ref2$params;
        var optionValue = config[optionName];
        if (typeof optionValue === 'function') optionValue = optionValue.apply(void 0, $197853feae65c1a7$var$_toConsumableArray(params));
        if (optionValue === true) optionValue = undefined; // use default value
        if (!optionValue) {
            if (optionValue === undefined || optionValue === false) return optionValue;
            // else, empty string (invalid), null (invalid), 0 (invalid)
            throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
        }
        var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point
        if (typeof optionValue === 'string') {
            try {
                node = doc.querySelector(optionValue); // resolve to node, or null if fails
            } catch (err) {
                throw new Error("`".concat(optionName, "` appears to be an invalid selector; error=\"").concat(err.message, "\""));
            }
            if (!node) {
                if (!hasFallback) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
            // else, `node` MUST be `null` because that's what `Document.querySelector()` returns
            //  if the selector is valid but doesn't match anything
            }
        }
        return node;
    };
    var getInitialFocusNode = function getInitialFocusNode() {
        var node = getNodeForOption('initialFocus', {
            hasFallback: true
        });
        // false explicitly indicates we want no initialFocus at all
        if (node === false) return false;
        if (node === undefined || node && !(0, $863eb30dd7d7e7a9$export$4c063cf1350e6fed)(node, config.tabbableOptions)) {
            // option not specified nor focusable: use fallback options
            if (findContainerIndex(doc.activeElement) >= 0) node = doc.activeElement;
            else {
                var firstTabbableGroup = state.tabbableGroups[0];
                var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
                // NOTE: `fallbackFocus` option function cannot return `false` (not supported)
                node = firstTabbableNode || getNodeForOption('fallbackFocus');
            }
        } else if (node === null) // option is a VALID selector string that doesn't yield a node: use the `fallbackFocus`
        //  option instead of the default behavior when the option isn't specified at all
        node = getNodeForOption('fallbackFocus');
        if (!node) throw new Error('Your focus-trap needs to have at least one focusable element');
        return node;
    };
    var updateTabbableNodes = function updateTabbableNodes() {
        state.containerGroups = state.containers.map(function(container) {
            var tabbableNodes = (0, $863eb30dd7d7e7a9$export$17100aea90429aa7)(container, config.tabbableOptions);
            // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
            //  are a superset of tabbable nodes since nodes with negative `tabindex` attributes
            //  are focusable but not tabbable
            var focusableNodes = (0, $863eb30dd7d7e7a9$export$ecc6d1fcdff4f700)(container, config.tabbableOptions);
            var firstTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[0] : undefined;
            var lastTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : undefined;
            var firstDomTabbableNode = focusableNodes.find(function(node) {
                return (0, $863eb30dd7d7e7a9$export$bebd5a1431fec25d)(node);
            });
            var lastDomTabbableNode = focusableNodes.slice().reverse().find(function(node) {
                return (0, $863eb30dd7d7e7a9$export$bebd5a1431fec25d)(node);
            });
            var posTabIndexesFound = !!tabbableNodes.find(function(node) {
                return (0, $863eb30dd7d7e7a9$export$a4672efddb4181b8)(node) > 0;
            });
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                /** True if at least one node with positive `tabindex` was found in this container. */ posTabIndexesFound: posTabIndexesFound,
                /** First tabbable node in container, __tabindex__ order; `undefined` if none. */ firstTabbableNode: firstTabbableNode,
                /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */ lastTabbableNode: lastTabbableNode,
                // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
                //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
                //  because that API doesn't work with Shadow DOM as well as it should (@see
                //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
                //  to address an edge case related to positive tabindex support, this seems like a much easier,
                //  "close enough most of the time" alternative for positive tabindexes which should generally
                //  be avoided anyway...
                /** First tabbable node in container, __DOM__ order; `undefined` if none. */ firstDomTabbableNode: firstDomTabbableNode,
                /** Last tabbable node in container, __DOM__ order; `undefined` if none. */ lastDomTabbableNode: lastDomTabbableNode,
                /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                    var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                    var nodeIdx = tabbableNodes.indexOf(node);
                    if (nodeIdx < 0) {
                        // either not tabbable nor focusable, or was focused but not tabbable (negative tabindex):
                        //  since `node` should at least have been focusable, we assume that's the case and mimic
                        //  what browsers do, which is set focus to the next node in __document position order__,
                        //  regardless of positive tabindexes, if any -- and for reasons explained in the NOTE
                        //  above related to `firstDomTabbable` and `lastDomTabbable` properties, we fall back to
                        //  basic DOM order
                        if (forward) return focusableNodes.slice(focusableNodes.indexOf(node) + 1).find(function(el) {
                            return (0, $863eb30dd7d7e7a9$export$bebd5a1431fec25d)(el);
                        });
                        return focusableNodes.slice(0, focusableNodes.indexOf(node)).reverse().find(function(el) {
                            return (0, $863eb30dd7d7e7a9$export$bebd5a1431fec25d)(el);
                        });
                    }
                    return tabbableNodes[nodeIdx + (forward ? 1 : -1)];
                }
            };
        });
        state.tabbableGroups = state.containerGroups.filter(function(group) {
            return group.tabbableNodes.length > 0;
        });
        // throw if no groups have tabbable nodes and we don't have a fallback focus node either
        if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus') // returning false not supported for this option
        ) throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
        // NOTE: Positive tabindexes are only properly supported in single-container traps because
        //  doing it across multiple containers where tabindexes could be all over the place
        //  would require Tabbable to support multiple containers, would require additional
        //  specialized Shadow DOM support, and would require Tabbable's multi-container support
        //  to look at those containers in document position order rather than user-provided
        //  order (as they are treated in Focus-trap, for legacy reasons). See discussion on
        //  https://github.com/focus-trap/focus-trap/issues/375 for more details.
        if (state.containerGroups.find(function(g) {
            return g.posTabIndexesFound;
        }) && state.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
    };
    /**
   * Gets the current activeElement. If it's a web-component and has open shadow-root
   * it will recursively search inside shadow roots for the "true" activeElement.
   *
   * @param {Document | ShadowRoot} el
   *
   * @returns {HTMLElement} The element that currently has the focus
   **/ var _getActiveElement = function getActiveElement(el) {
        var activeElement = el.activeElement;
        if (!activeElement) return;
        if (activeElement.shadowRoot && activeElement.shadowRoot.activeElement !== null) return _getActiveElement(activeElement.shadowRoot);
        return activeElement;
    };
    var _tryFocus = function tryFocus(node) {
        if (node === false) return;
        if (node === _getActiveElement(document)) return;
        if (!node || !node.focus) {
            _tryFocus(getInitialFocusNode());
            return;
        }
        node.focus({
            preventScroll: !!config.preventScroll
        });
        // NOTE: focus() API does not trigger focusIn event so set MRU node manually
        state.mostRecentlyFocusedNode = node;
        if ($197853feae65c1a7$var$isSelectableInput(node)) node.select();
    };
    var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
        var node = getNodeForOption('setReturnFocus', {
            params: [
                previousActiveElement
            ]
        });
        return node ? node : node === false ? false : previousActiveElement;
    };
    /**
   * Finds the next node (in either direction) where focus should move according to a
   *  keyboard focus-in event.
   * @param {Object} params
   * @param {Node} [params.target] Known target __from which__ to navigate, if any.
   * @param {KeyboardEvent|FocusEvent} [params.event] Event to use if `target` isn't known (event
   *  will be used to determine the `target`). Ignored if `target` is specified.
   * @param {boolean} [params.isBackward] True if focus should move backward.
   * @returns {Node|undefined} The next node, or `undefined` if a next node couldn't be
   *  determined given the current state of the trap.
   */ var findNextNavNode = function findNextNavNode(_ref3) {
        var target = _ref3.target, event = _ref3.event, _ref3$isBackward = _ref3.isBackward, isBackward = _ref3$isBackward === void 0 ? false : _ref3$isBackward;
        target = target || $197853feae65c1a7$var$getActualTarget(event);
        updateTabbableNodes();
        var destinationNode = null;
        if (state.tabbableGroups.length > 0) {
            // make sure the target is actually contained in a group
            // NOTE: the target may also be the container itself if it's focusable
            //  with tabIndex='-1' and was given initial focus
            var containerIndex = findContainerIndex(target, event);
            var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
            if (containerIndex < 0) {
                // target not found in any group: quite possible focus has escaped the trap,
                //  so bring it back into...
                if (isBackward) // ...the last node in the last group
                destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                else // ...the first node in the first group
                destinationNode = state.tabbableGroups[0].firstTabbableNode;
            } else if (isBackward) {
                // REVERSE
                // is the target the first tabbable node in a group?
                var startOfGroupIndex = state.tabbableGroups.findIndex(function(_ref4) {
                    var firstTabbableNode = _ref4.firstTabbableNode;
                    return target === firstTabbableNode;
                });
                if (startOfGroupIndex < 0 && (containerGroup.container === target || (0, $863eb30dd7d7e7a9$export$4c063cf1350e6fed)(target, config.tabbableOptions) && !(0, $863eb30dd7d7e7a9$export$bebd5a1431fec25d)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) // an exception case where the target is either the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle shift+tab as if focus were on the container's
                //  first tabbable node, and go to the last tabbable node of the LAST group
                startOfGroupIndex = containerIndex;
                if (startOfGroupIndex >= 0) {
                    // YES: then shift+tab should go to the last tabbable node in the
                    //  previous group (and wrap around to the last tabbable node of
                    //  the LAST group if it's the first tabbable node of the FIRST group)
                    var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                    var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                    destinationNode = (0, $863eb30dd7d7e7a9$export$a4672efddb4181b8)(target) >= 0 ? destinationGroup.lastTabbableNode : destinationGroup.lastDomTabbableNode;
                } else if (!$197853feae65c1a7$var$isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target, false);
            } else {
                // FORWARD
                // is the target the last tabbable node in a group?
                var lastOfGroupIndex = state.tabbableGroups.findIndex(function(_ref5) {
                    var lastTabbableNode = _ref5.lastTabbableNode;
                    return target === lastTabbableNode;
                });
                if (lastOfGroupIndex < 0 && (containerGroup.container === target || (0, $863eb30dd7d7e7a9$export$4c063cf1350e6fed)(target, config.tabbableOptions) && !(0, $863eb30dd7d7e7a9$export$bebd5a1431fec25d)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) // an exception case where the target is the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle tab as if focus were on the container's
                //  last tabbable node, and go to the first tabbable node of the FIRST group
                lastOfGroupIndex = containerIndex;
                if (lastOfGroupIndex >= 0) {
                    // YES: then tab should go to the first tabbable node in the next
                    //  group (and wrap around to the first tabbable node of the FIRST
                    //  group if it's the last tabbable node of the LAST group)
                    var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                    var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                    destinationNode = (0, $863eb30dd7d7e7a9$export$a4672efddb4181b8)(target) >= 0 ? _destinationGroup.firstTabbableNode : _destinationGroup.firstDomTabbableNode;
                } else if (!$197853feae65c1a7$var$isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target);
            }
        } else // no groups available
        // NOTE: the fallbackFocus option does not support returning false to opt-out
        destinationNode = getNodeForOption('fallbackFocus');
        return destinationNode;
    };
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event.
    var checkPointerDown = function checkPointerDown(e) {
        var target = $197853feae65c1a7$var$getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) // allow the click since it ocurred inside the trap
        return;
        if ($197853feae65c1a7$var$valueOrHandler(config.clickOutsideDeactivates, e)) {
            // immediately deactivate the trap
            trap.deactivate({
                // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                //  which will result in the outside click setting focus to the node
                //  that was clicked (and if not focusable, to "nothing"); by setting
                //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                //  on activation (or the configured `setReturnFocus` node), whether the
                //  outside click was on a focusable node or not
                returnFocus: config.returnFocusOnDeactivate
            });
            return;
        }
        // This is needed for mobile devices.
        // (If we'll only let `click` events through,
        // then on mobile they will be blocked anyways if `touchstart` is blocked.)
        if ($197853feae65c1a7$var$valueOrHandler(config.allowOutsideClick, e)) // allow the click outside the trap to take place
        return;
        // otherwise, prevent the click
        e.preventDefault();
    };
    // In case focus escapes the trap for some strange reason, pull it back in.
    // NOTE: the focusIn event is NOT cancelable, so if focus escapes, it may cause unexpected
    //  scrolling if the node that got focused was out of view; there's nothing we can do to
    //  prevent that from happening by the time we discover that focus escaped
    var checkFocusIn = function checkFocusIn(event) {
        var target = $197853feae65c1a7$var$getActualTarget(event);
        var targetContained = findContainerIndex(target, event) >= 0;
        // In Firefox when you Tab out of an iframe the Document is briefly focused.
        if (targetContained || target instanceof Document) {
            if (targetContained) state.mostRecentlyFocusedNode = target;
        } else {
            // escaped! pull it back in to where it just left
            event.stopImmediatePropagation();
            // focus will escape if the MRU node had a positive tab index and user tried to nav forward;
            //  it will also escape if the MRU node had a 0 tab index and user tried to nav backward
            //  toward a node with a positive tab index
            var nextNode; // next node to focus, if we find one
            var navAcrossContainers = true;
            if (state.mostRecentlyFocusedNode) {
                if ((0, $863eb30dd7d7e7a9$export$a4672efddb4181b8)(state.mostRecentlyFocusedNode) > 0) {
                    // MRU container index must be >=0 otherwise we wouldn't have it as an MRU node...
                    var mruContainerIdx = findContainerIndex(state.mostRecentlyFocusedNode);
                    // there MAY not be any tabbable nodes in the container if there are at least 2 containers
                    //  and the MRU node is focusable but not tabbable (focus-trap requires at least 1 container
                    //  with at least one tabbable node in order to function, so this could be the other container
                    //  with nothing tabbable in it)
                    var tabbableNodes = state.containerGroups[mruContainerIdx].tabbableNodes;
                    if (tabbableNodes.length > 0) {
                        // MRU tab index MAY not be found if the MRU node is focusable but not tabbable
                        var mruTabIdx = tabbableNodes.findIndex(function(node) {
                            return node === state.mostRecentlyFocusedNode;
                        });
                        if (mruTabIdx >= 0) {
                            if (config.isKeyForward(state.recentNavEvent)) {
                                if (mruTabIdx + 1 < tabbableNodes.length) {
                                    nextNode = tabbableNodes[mruTabIdx + 1];
                                    navAcrossContainers = false;
                                }
                            } else if (mruTabIdx - 1 >= 0) {
                                nextNode = tabbableNodes[mruTabIdx - 1];
                                navAcrossContainers = false;
                            }
                        // else, don't find in container order without considering direction too
                        }
                    }
                // else, no tabbable nodes in that container (which means we must have at least one other
                //  container with at least one tabbable node in it, otherwise focus-trap would've thrown
                //  an error the last time updateTabbableNodes() was run): find next node among all known
                //  containers
                } else // check to see if there's at least one tabbable node with a positive tab index inside
                //  the trap because focus seems to escape when navigating backward from a tabbable node
                //  with tabindex=0 when this is the case (instead of wrapping to the tabbable node with
                //  the greatest positive tab index like it should)
                if (!state.containerGroups.some(function(g) {
                    return g.tabbableNodes.some(function(n) {
                        return (0, $863eb30dd7d7e7a9$export$a4672efddb4181b8)(n) > 0;
                    });
                })) // no containers with tabbable nodes with positive tab indexes which means the focus
                //  escaped for some other reason and we should just execute the fallback to the
                //  MRU node or initial focus node, if any
                navAcrossContainers = false;
            } else // no MRU node means we're likely in some initial condition when the trap has just
            //  been activated and initial focus hasn't been given yet, in which case we should
            //  fall through to trying to focus the initial focus node, which is what should
            //  happen below at this point in the logic
            navAcrossContainers = false;
            if (navAcrossContainers) nextNode = findNextNavNode({
                // move FROM the MRU node, not event-related node (which will be the node that is
                //  outside the trap causing the focus escape we're trying to fix)
                target: state.mostRecentlyFocusedNode,
                isBackward: config.isKeyBackward(state.recentNavEvent)
            });
            if (nextNode) _tryFocus(nextNode);
            else _tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
        state.recentNavEvent = undefined; // clear
    };
    // Hijack key nav events on the first and last focusable nodes of the trap,
    // in order to prevent focus from escaping. If it escapes for even a
    // moment it can end up scrolling the page and causing confusion so we
    // kind of need to capture the action at the keydown phase.
    var checkKeyNav = function checkKeyNav(event) {
        var isBackward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        state.recentNavEvent = event;
        var destinationNode = findNextNavNode({
            event: event,
            isBackward: isBackward
        });
        if (destinationNode) {
            if ($197853feae65c1a7$var$isTabEvent(event)) // since tab natively moves focus, we wouldn't have a destination node unless we
            //  were on the edge of a container and had to move to the next/previous edge, in
            //  which case we want to prevent default to keep the browser from moving focus
            //  to where it normally would
            event.preventDefault();
            _tryFocus(destinationNode);
        }
    // else, let the browser take care of [shift+]tab and move the focus
    };
    var checkTabKey = function checkTabKey(event) {
        if (config.isKeyForward(event) || config.isKeyBackward(event)) checkKeyNav(event, config.isKeyBackward(event));
    };
    // we use a different event phase for the Escape key to allow canceling the event and checking for this in escapeDeactivates
    var checkEscapeKey = function checkEscapeKey(event) {
        if ($197853feae65c1a7$var$isEscapeEvent(event) && $197853feae65c1a7$var$valueOrHandler(config.escapeDeactivates, event) !== false) {
            event.preventDefault();
            trap.deactivate();
        }
    };
    var checkClick = function checkClick(e) {
        var target = $197853feae65c1a7$var$getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) return;
        if ($197853feae65c1a7$var$valueOrHandler(config.clickOutsideDeactivates, e)) return;
        if ($197853feae65c1a7$var$valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    };
    //
    // EVENT LISTENERS
    //
    var addListeners = function addListeners() {
        if (!state.active) return;
        // There can be only one listening focus trap at a time
        $197853feae65c1a7$var$activeFocusTraps.activateTrap(trapStack, trap);
        // Delay ensures that the focused element doesn't capture the event
        // that caused the focus trap activation.
        state.delayInitialFocusTimer = config.delayInitialFocus ? $197853feae65c1a7$var$delay(function() {
            _tryFocus(getInitialFocusNode());
        }) : _tryFocus(getInitialFocusNode());
        doc.addEventListener('focusin', checkFocusIn, true);
        doc.addEventListener('mousedown', checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener('touchstart', checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener('click', checkClick, {
            capture: true,
            passive: false
        });
        doc.addEventListener('keydown', checkTabKey, {
            capture: true,
            passive: false
        });
        doc.addEventListener('keydown', checkEscapeKey);
        return trap;
    };
    var removeListeners = function removeListeners() {
        if (!state.active) return;
        doc.removeEventListener('focusin', checkFocusIn, true);
        doc.removeEventListener('mousedown', checkPointerDown, true);
        doc.removeEventListener('touchstart', checkPointerDown, true);
        doc.removeEventListener('click', checkClick, true);
        doc.removeEventListener('keydown', checkTabKey, true);
        doc.removeEventListener('keydown', checkEscapeKey);
        return trap;
    };
    //
    // MUTATION OBSERVER
    //
    var checkDomRemoval = function checkDomRemoval(mutations) {
        var isFocusedNodeRemoved = mutations.some(function(mutation) {
            var removedNodes = Array.from(mutation.removedNodes);
            return removedNodes.some(function(node) {
                return node === state.mostRecentlyFocusedNode;
            });
        });
        // If the currently focused is removed then browsers will move focus to the
        // <body> element. If this happens, try to move focus back into the trap.
        if (isFocusedNodeRemoved) _tryFocus(getInitialFocusNode());
    };
    // Use MutationObserver - if supported - to detect if focused node is removed
    // from the DOM.
    var mutationObserver = typeof window !== 'undefined' && 'MutationObserver' in window ? new MutationObserver(checkDomRemoval) : undefined;
    var updateObservedNodes = function updateObservedNodes() {
        if (!mutationObserver) return;
        mutationObserver.disconnect();
        if (state.active && !state.paused) state.containers.map(function(container) {
            mutationObserver.observe(container, {
                subtree: true,
                childList: true
            });
        });
    };
    //
    // TRAP DEFINITION
    //
    trap = {
        get active () {
            return state.active;
        },
        get paused () {
            return state.paused;
        },
        activate: function activate(activateOptions) {
            if (state.active) return this;
            var onActivate = getOption(activateOptions, 'onActivate');
            var onPostActivate = getOption(activateOptions, 'onPostActivate');
            var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');
            if (!checkCanFocusTrap) updateTabbableNodes();
            state.active = true;
            state.paused = false;
            state.nodeFocusedBeforeActivation = _getActiveElement(doc);
            onActivate === null || onActivate === void 0 || onActivate();
            var finishActivation = function finishActivation() {
                if (checkCanFocusTrap) updateTabbableNodes();
                addListeners();
                updateObservedNodes();
                onPostActivate === null || onPostActivate === void 0 || onPostActivate();
            };
            if (checkCanFocusTrap) {
                checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                return this;
            }
            finishActivation();
            return this;
        },
        deactivate: function deactivate(deactivateOptions) {
            if (!state.active) return this;
            var options = $197853feae65c1a7$var$_objectSpread2({
                onDeactivate: config.onDeactivate,
                onPostDeactivate: config.onPostDeactivate,
                checkCanReturnFocus: config.checkCanReturnFocus
            }, deactivateOptions);
            clearTimeout(state.delayInitialFocusTimer); // noop if undefined
            state.delayInitialFocusTimer = undefined;
            removeListeners();
            state.active = false;
            state.paused = false;
            updateObservedNodes();
            $197853feae65c1a7$var$activeFocusTraps.deactivateTrap(trapStack, trap);
            var onDeactivate = getOption(options, 'onDeactivate');
            var onPostDeactivate = getOption(options, 'onPostDeactivate');
            var checkCanReturnFocus = getOption(options, 'checkCanReturnFocus');
            var returnFocus = getOption(options, 'returnFocus', 'returnFocusOnDeactivate');
            onDeactivate === null || onDeactivate === void 0 || onDeactivate();
            var finishDeactivation = function finishDeactivation() {
                $197853feae65c1a7$var$delay(function() {
                    if (returnFocus) _tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                    onPostDeactivate === null || onPostDeactivate === void 0 || onPostDeactivate();
                });
            };
            if (returnFocus && checkCanReturnFocus) {
                checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        },
        pause: function pause(pauseOptions) {
            if (!state.active) return this;
            state.manuallyPaused = true;
            return this._setPausedState(true, pauseOptions);
        },
        unpause: function unpause(unpauseOptions) {
            if (!state.active) return this;
            state.manuallyPaused = false;
            if (trapStack[trapStack.length - 1] !== this) return this;
            return this._setPausedState(false, unpauseOptions);
        },
        updateContainerElements: function updateContainerElements(containerElements) {
            var elementsAsArray = [].concat(containerElements).filter(Boolean);
            state.containers = elementsAsArray.map(function(element) {
                return typeof element === 'string' ? doc.querySelector(element) : element;
            });
            if (state.active) updateTabbableNodes();
            updateObservedNodes();
            return this;
        }
    };
    Object.defineProperties(trap, {
        _isManuallyPaused: {
            value: function value() {
                return state.manuallyPaused;
            }
        },
        _setPausedState: {
            value: function value(paused, options) {
                if (state.paused === paused) return this;
                state.paused = paused;
                if (paused) {
                    var onPause = getOption(options, 'onPause');
                    var onPostPause = getOption(options, 'onPostPause');
                    onPause === null || onPause === void 0 || onPause();
                    removeListeners();
                    updateObservedNodes();
                    onPostPause === null || onPostPause === void 0 || onPostPause();
                } else {
                    var onUnpause = getOption(options, 'onUnpause');
                    var onPostUnpause = getOption(options, 'onPostUnpause');
                    onUnpause === null || onUnpause === void 0 || onUnpause();
                    updateTabbableNodes();
                    addListeners();
                    updateObservedNodes();
                    onPostUnpause === null || onPostUnpause === void 0 || onPostUnpause();
                }
                return this;
            }
        }
    });
    // initialize container elements
    trap.updateContainerElements(elements);
    return trap;
};




var $eHaBZ = parcelRequire("eHaBZ");
function $bd320d0e16baa5f3$export$3b062b02b4537682() {
    return (0, $c8aedc92b88eb948$export$96b5b894afc1d2e3)(selfoss.loggedin);
}
function $bd320d0e16baa5f3$export$f5bdb3b3cec7f803() {
    var loggedIn = $bd320d0e16baa5f3$export$3b062b02b4537682();
    return (0, $eHaBZ.useMemo)(function() {
        return selfoss.isAllowedToRead();
    }, [
        loggedIn
    ]);
}
function $bd320d0e16baa5f3$export$683005ba76038aff() {
    var loggedIn = $bd320d0e16baa5f3$export$3b062b02b4537682();
    return (0, $eHaBZ.useMemo)(function() {
        return selfoss.isAllowedToUpdate();
    }, [
        loggedIn
    ]);
}
function $bd320d0e16baa5f3$export$b416b77cd328c02f() {
    var loggedIn = $bd320d0e16baa5f3$export$3b062b02b4537682();
    return (0, $eHaBZ.useMemo)(function() {
        return selfoss.isAllowedToWrite();
    }, [
        loggedIn
    ]);
}






var $b625dc2dd2df76bd$export$cacd6541cfeeb6c1 = {
    PREV: 'prev',
    NEXT: 'next'
};
function $b625dc2dd2df76bd$export$d976747ecb966cea(target) {
    var viewportHeight = document.body.clientHeight;
    var viewportScrollTop = window.scrollY;
    var targetBb = target.getBoundingClientRect();
    var targetTop = window.scrollY + targetBb.top;
    var targetHeight = targetBb.height;
    // scroll down
    if (viewportScrollTop + viewportHeight < targetTop + targetHeight + 80) {
        if (targetHeight > viewportHeight) window.scrollTo({
            top: targetTop
        });
        else {
            var marginTop = (viewportHeight - targetHeight) / 2;
            var scrollTop = targetTop - marginTop;
            window.scrollTo({
                top: scrollTop
            });
        }
    }
    // scroll up
    if (targetTop <= viewportScrollTop) window.scrollTo({
        top: targetTop
    });
}



var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");


var $eHaBZ = parcelRequire("eHaBZ");

var $419292d15b74e6e0$exports = {};
var $ef4a30588310d5d7$exports = {};
function $ef4a30588310d5d7$var$_arrayReduce(reducer, acc, list) {
    var index = 0;
    var length = list.length;
    while(index < length){
        acc = reducer(acc, list[index]);
        index += 1;
    }
    return acc;
}
$ef4a30588310d5d7$exports = $ef4a30588310d5d7$var$_arrayReduce;



var $f4091c18d79168b1$exports = {};

var $b1373d49cfb8ba69$exports = {};
function $b1373d49cfb8ba69$var$_isTransformer(obj) {
    return obj != null && typeof obj['@@transducer/step'] === 'function';
}
$b1373d49cfb8ba69$exports = $b1373d49cfb8ba69$var$_isTransformer;


/**
 * Returns a function that dispatches with different strategies based on the
 * object in list position (last argument). If it is an array, executes [fn].
 * Otherwise, if it has a function with one of the given method names, it will
 * execute that function (functor case). Otherwise, if it is a transformer,
 * uses transducer created by [transducerCreator] to return a new transformer
 * (transducer case).
 * Otherwise, it will default to executing [fn].
 *
 * @private
 * @param {Array} methodNames properties to check for a custom implementation
 * @param {Function} transducerCreator transducer factory if object is transformer
 * @param {Function} fn default ramda implementation
 * @return {Function} A function that dispatches on object in list position
 */ function $f4091c18d79168b1$var$_dispatchable(methodNames, transducerCreator, fn) {
    return function() {
        if (arguments.length === 0) return fn();
        var obj = arguments[arguments.length - 1];
        if (!$73fb5ea04d9dead1$exports(obj)) {
            var idx = 0;
            while(idx < methodNames.length){
                if (typeof obj[methodNames[idx]] === 'function') return obj[methodNames[idx]].apply(obj, Array.prototype.slice.call(arguments, 0, -1));
                idx += 1;
            }
            if ($b1373d49cfb8ba69$exports(obj)) {
                var transducer = transducerCreator.apply(null, Array.prototype.slice.call(arguments, 0, -1));
                return transducer(obj);
            }
        }
        return fn.apply(this, arguments);
    };
}
$f4091c18d79168b1$exports = $f4091c18d79168b1$var$_dispatchable;


var $8b790a9e48f0992d$exports = {};
function $8b790a9e48f0992d$var$_map(fn, functor) {
    var idx = 0;
    var len = functor.length;
    var result = Array(len);
    while(idx < len){
        result[idx] = fn(functor[idx]);
        idx += 1;
    }
    return result;
}
$8b790a9e48f0992d$exports = $8b790a9e48f0992d$var$_map;


var $2f7cea74d4afd9d8$exports = {};
var $8ad75158a6dee908$exports = {};
$8ad75158a6dee908$exports = {
    init: function init() {
        return this.xf['@@transducer/init']();
    },
    result: function result(_result) {
        return this.xf['@@transducer/result'](_result);
    }
};


var $2f7cea74d4afd9d8$var$XMap = /*#__PURE__*/ function() {
    function XMap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XMap.prototype['@@transducer/init'] = $8ad75158a6dee908$exports.init;
    XMap.prototype['@@transducer/result'] = $8ad75158a6dee908$exports.result;
    XMap.prototype['@@transducer/step'] = function(result, input) {
        return this.xf['@@transducer/step'](result, this.f(input));
    };
    return XMap;
}();
var $2f7cea74d4afd9d8$var$_xmap = function _xmap(f) {
    return function(xf) {
        return new $2f7cea74d4afd9d8$var$XMap(f, xf);
    };
};
$2f7cea74d4afd9d8$exports = $2f7cea74d4afd9d8$var$_xmap;


var $76af6f4bdc955f60$exports = {};



var $d7d932f9cbe80b4e$exports = {};


/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $d7d932f9cbe80b4e$var$_curryN(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        var hasPlaceholder = false;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!$f6709ecef4b253a2$exports(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!$f6709ecef4b253a2$exports(result)) left -= 1;
            else hasPlaceholder = true;
            combinedIdx += 1;
        }
        return !hasPlaceholder && left <= 0 ? fn.apply(this, combined) : $7629ad89266bbe6b$exports(Math.max(0, left), $d7d932f9cbe80b4e$var$_curryN(length, combined, fn));
    };
}
$d7d932f9cbe80b4e$exports = $d7d932f9cbe80b4e$var$_curryN;


/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $76af6f4bdc955f60$var$curryN = /*#__PURE__*/ $16cdbc498258dabf$exports(function curryN(length, fn) {
    if (length === 1) return $7e9ffa7fa815703c$exports(fn);
    return $7629ad89266bbe6b$exports(length, $d7d932f9cbe80b4e$exports(length, [], fn));
});
$76af6f4bdc955f60$exports = $76af6f4bdc955f60$var$curryN;


var $a97e5ea9fcd3c823$exports = {};


var $69a5e3c09611504c$exports = {};

var $69a5e3c09611504c$var$toString = Object.prototype.toString;
var $69a5e3c09611504c$var$_isArguments = /*#__PURE__*/ function() {
    return $69a5e3c09611504c$var$toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
        return $69a5e3c09611504c$var$toString.call(x) === '[object Arguments]';
    } : function _isArguments(x) {
        return $8659c368bdbba7be$exports('callee', x);
    };
}();
$69a5e3c09611504c$exports = $69a5e3c09611504c$var$_isArguments;


var $a97e5ea9fcd3c823$var$hasEnumBug = !/*#__PURE__*/ ({
    toString: null
}).propertyIsEnumerable('toString');
var $a97e5ea9fcd3c823$var$nonEnumerableProps = [
    'constructor',
    'valueOf',
    'isPrototypeOf',
    'toString',
    'propertyIsEnumerable',
    'hasOwnProperty',
    'toLocaleString'
];
// Safari bug
var $a97e5ea9fcd3c823$var$hasArgsEnumBug = /*#__PURE__*/ function() {
    'use strict';
    return arguments.propertyIsEnumerable('length');
}();
var $a97e5ea9fcd3c823$var$contains = function contains(list, item) {
    var idx = 0;
    while(idx < list.length){
        if (list[idx] === item) return true;
        idx += 1;
    }
    return false;
};
/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values, R.toPairs
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */ var $a97e5ea9fcd3c823$var$keys = typeof Object.keys === 'function' && !$a97e5ea9fcd3c823$var$hasArgsEnumBug ? /*#__PURE__*/ $7e9ffa7fa815703c$exports(function keys(obj) {
    return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /*#__PURE__*/ $7e9ffa7fa815703c$exports(function keys(obj) {
    if (Object(obj) !== obj) return [];
    var prop, nIdx;
    var ks = [];
    var checkArgsLength = $a97e5ea9fcd3c823$var$hasArgsEnumBug && $69a5e3c09611504c$exports(obj);
    for(prop in obj)if ($8659c368bdbba7be$exports(prop, obj) && (!checkArgsLength || prop !== 'length')) ks[ks.length] = prop;
    if ($a97e5ea9fcd3c823$var$hasEnumBug) {
        nIdx = $a97e5ea9fcd3c823$var$nonEnumerableProps.length - 1;
        while(nIdx >= 0){
            prop = $a97e5ea9fcd3c823$var$nonEnumerableProps[nIdx];
            if ($8659c368bdbba7be$exports(prop, obj) && !$a97e5ea9fcd3c823$var$contains(ks, prop)) ks[ks.length] = prop;
            nIdx -= 1;
        }
    }
    return ks;
});
$a97e5ea9fcd3c823$exports = $a97e5ea9fcd3c823$var$keys;


/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex, R.pluck, R.project
 * @example
 *
 *      const double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */ var $419292d15b74e6e0$var$map = /*#__PURE__*/ $16cdbc498258dabf$exports(/*#__PURE__*/ $f4091c18d79168b1$exports([
    'fantasy-land/map',
    'map'
], $2f7cea74d4afd9d8$exports, function map(fn, functor) {
    switch(Object.prototype.toString.call(functor)){
        case '[object Function]':
            return $76af6f4bdc955f60$exports(functor.length, function() {
                return fn.call(this, functor.apply(this, arguments));
            });
        case '[object Object]':
            return $ef4a30588310d5d7$exports(function(acc, key) {
                acc[key] = fn(functor[key]);
                return acc;
            }, {}, $a97e5ea9fcd3c823$exports(functor));
        default:
            return $8b790a9e48f0992d$exports(fn, functor);
    }
}));
$419292d15b74e6e0$exports = $419292d15b74e6e0$var$map;




function $8ee8a2a1e50ded87$var$materializeSharerIcon(sharer) {
    var icon = sharer.icon;
    return (0, $9Jpjh._)((0, $lvTkn._)({}, sharer), {
        icon: typeof icon === 'string' && icon.includes('<') ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: icon
            }
        }) : icon
    });
}
function $8ee8a2a1e50ded87$export$aebedbd51beb48eb(param) {
    var configuration = param.configuration, _ = param._;
    return (0, $eHaBZ.useMemo)(function() {
        var _selfoss_customSharers;
        var availableSharers = (0, $lvTkn._)({
            a: {
                label: _('share_native_label'),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $5f3a6b596119c825$exports.faShareAlt
                }),
                action: function(param) {
                    var url = param.url, title = param.title;
                    navigator.share({
                        title: title,
                        url: url
                    }).catch(function(e) {
                        if (e.name === 'AbortError') (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.showError(_('error_share_native_abort'));
                        else (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.showError(_('error_share_native'));
                    });
                },
                available: 'share' in navigator
            },
            d: {
                label: _('share_diaspora_label'),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $8216ee54ed5c099f$exports.faDiaspora
                }),
                action: function(param) {
                    var url = param.url, title = param.title;
                    window.open('https://share.diasporafoundation.org/?url=' + encodeURIComponent(url) + '&title=' + encodeURIComponent(title), undefined, 'noreferrer');
                }
            },
            t: {
                label: _('share_twitter_label'),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $11826e5bf54ad532$exports.faTwitter
                }),
                action: function(param) {
                    var url = param.url, title = param.title;
                    window.open('https://twitter.com/intent/tweet?source=webclient&text=' + encodeURIComponent(title) + ' ' + encodeURIComponent(url), undefined, 'noreferrer');
                }
            },
            f: {
                label: _('share_facebook_label'),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $a5565bc5d7aa9135$exports.faFacebookSquare
                }),
                action: function(param) {
                    var url = param.url, title = param.title;
                    window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url) + '&t=' + encodeURIComponent(title), undefined, 'noreferrer');
                }
            },
            m: {
                label: _('share_mastodon_label'),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $b92068b2b2ac161b$exports.faMastodon
                }),
                action: function(param) {
                    var url = param.url, title = param.title;
                    window.open(configuration.mastodon + '/share?text=' + encodeURIComponent('"' + title + '"\n' + url), undefined, 'noreferrer');
                },
                available: configuration.mastodon !== null
            },
            p: {
                label: _('share_pocket_label'),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $acd52ab24d9744ba$exports.faGetPocket
                }),
                action: function(param) {
                    var url = param.url, title = param.title;
                    window.open('https://getpocket.com/save?url=' + encodeURIComponent(url) + '&title=' + encodeURIComponent(title), undefined, 'noreferrer');
                }
            },
            w: {
                label: _('share_wallabag_label'),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $8cad2150f94e1c78$export$a67558cb68d63c7e
                }),
                action: function(param) {
                    var url = param.url;
                    if (configuration.wallabag.version === 2) window.open(configuration.wallabag.url + '/bookmarklet?url=' + encodeURIComponent(url), undefined, 'noreferrer');
                    else window.open(configuration.wallabag.url + '/?action=add&url=' + btoa(url), undefined, 'noreferrer');
                },
                available: configuration.wallabag !== null
            },
            s: {
                label: _('share_wordpress_label'),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $8ebe08a4e3d0a860$exports.faWordpressSimple
                }),
                action: function(param) {
                    var url = param.url, title = param.title;
                    window.open(configuration.wordpress + '/wp-admin/press-this.php?u=' + encodeURIComponent(url) + '&t=' + encodeURIComponent(title), undefined, 'noreferrer');
                },
                available: configuration.wordpress !== null
            },
            e: {
                label: _('share_mail_label'),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $5aa79799bc179db8$exports.faEnvelope
                }),
                action: function(param) {
                    var url = param.url, title = param.title;
                    document.location.href = 'mailto:?body=' + encodeURIComponent(url) + '&subject=' + encodeURIComponent(title);
                }
            },
            c: {
                label: _('share_copy_label'),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $7f79cc0a934ae117$exports.faCopy
                }),
                action: function(param) {
                    var url = param.url;
                    navigator.clipboard.writeText(url).then(function() {
                        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.showMessage(_('info_url_copied'));
                    });
                }
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($419292d15b74e6e0$exports)))($8ee8a2a1e50ded87$var$materializeSharerIcon, (_selfoss_customSharers = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).customSharers) !== null && _selfoss_customSharers !== void 0 ? _selfoss_customSharers : {}));
        var enabledSharers = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = configuration.share[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var letter = _step.value;
                var sharer = availableSharers[letter];
                var _sharer_available;
                if (sharer !== undefined && ((_sharer_available = sharer.available) !== null && _sharer_available !== void 0 ? _sharer_available : true)) {
                    var label = sharer.label, icon = sharer.icon, action = sharer.action;
                    enabledSharers.push({
                        key: letter,
                        label: label,
                        icon: icon,
                        action: action
                    });
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return enabledSharers;
    }, [
        configuration,
        _
    ]);
}



var $khBmn = parcelRequire("khBmn");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $aRv4I = parcelRequire("aRv4I");

var $21h22 = parcelRequire("21h22");

var $6zk1M = parcelRequire("6zk1M");

var $eHaBZ = parcelRequire("eHaBZ");
var $b17a7fd270a24b50$export$83fe3bee12eb51bb = "carousel";
var $b17a7fd270a24b50$export$b861c6f4d58b4c2f = "controller";
var $b17a7fd270a24b50$export$607ce719f0ec9b98 = "navigation";
var $b17a7fd270a24b50$export$52cbc29cf5406ba8 = "no-scroll";
var $b17a7fd270a24b50$export$9d2e4856063e1a22 = "portal";
var $b17a7fd270a24b50$export$62f3c66ae8dab8a3 = "root";
var $b17a7fd270a24b50$export$5414719b40b8294f = "toolbar";
var $b17a7fd270a24b50$export$a23b14c1465897d = "captions";
var $b17a7fd270a24b50$export$8ae0dbe553798d04 = "counter";
var $b17a7fd270a24b50$export$ace9d67c0f2290af = "download";
var $b17a7fd270a24b50$export$4792108761b262a9 = "fullscreen";
var $b17a7fd270a24b50$export$c21ea5a712f18fb6 = "inline";
var $b17a7fd270a24b50$export$6bbdc870e6ef9c88 = "share";
var $b17a7fd270a24b50$export$be7dc72e63e6ef2e = "slideshow";
var $b17a7fd270a24b50$export$6bf9d56640f46f01 = "thumbnails";
var $b17a7fd270a24b50$export$929980e2a2c57ecf = "zoom";
var $b17a7fd270a24b50$export$554a1415841c52a8 = "loading";
var $b17a7fd270a24b50$export$38ce62e512432ebb = "playing";
var $b17a7fd270a24b50$export$2ed3c80dbc178d91 = "error";
var $b17a7fd270a24b50$export$a195e517d37aaa33 = "complete";
var $b17a7fd270a24b50$export$e51f1c6d74b54a13 = "placeholder";
var $b17a7fd270a24b50$export$6751782e799f6445 = function(status) {
    return "active-slide-".concat(status);
};
var $b17a7fd270a24b50$export$7ab73e7383503259 = $b17a7fd270a24b50$export$6751782e799f6445($b17a7fd270a24b50$export$554a1415841c52a8);
var $b17a7fd270a24b50$export$ccb5eb0b2db52ae8 = $b17a7fd270a24b50$export$6751782e799f6445($b17a7fd270a24b50$export$38ce62e512432ebb);
var $b17a7fd270a24b50$export$817be438d1d0e4cf = $b17a7fd270a24b50$export$6751782e799f6445($b17a7fd270a24b50$export$2ed3c80dbc178d91);
var $b17a7fd270a24b50$export$2ec1d32caeb97dfe = $b17a7fd270a24b50$export$6751782e799f6445($b17a7fd270a24b50$export$a195e517d37aaa33);
var $b17a7fd270a24b50$export$37b171d829eeeaa2 = "fullsize";
var $b17a7fd270a24b50$export$974a68ef150451f5 = "flex_center";
var $b17a7fd270a24b50$export$b6426a00c33a0175 = "no_scroll";
var $b17a7fd270a24b50$export$651541414233b476 = "no_scroll_padding";
var $b17a7fd270a24b50$export$8d922915837a38d3 = "slide";
var $b17a7fd270a24b50$export$ac396c284080b10c = "slide_wrapper";
var $b17a7fd270a24b50$export$bb41c4fe76dce9db = "slide_wrapper_interactive";
var $b17a7fd270a24b50$export$a007161537026955 = "prev";
var $b17a7fd270a24b50$export$f1d7a854db833ed4 = "next";
var $b17a7fd270a24b50$export$c43bd1a4101c4078 = "swipe";
var $b17a7fd270a24b50$export$493a596486210a21 = "close";
var $b17a7fd270a24b50$export$e15fc153f45a963d = "onPointerDown";
var $b17a7fd270a24b50$export$1f8863949fbdd7e5 = "onPointerMove";
var $b17a7fd270a24b50$export$2d868b67a5791b8a = "onPointerUp";
var $b17a7fd270a24b50$export$526cafa85592f1a5 = "onPointerLeave";
var $b17a7fd270a24b50$export$22151cee048c4be9 = "onPointerCancel";
var $b17a7fd270a24b50$export$1aba4f3521686ca9 = "onKeyDown";
var $b17a7fd270a24b50$export$bdb9f99d61a6879b = "onKeyUp";
var $b17a7fd270a24b50$export$5635dc9d647242c7 = "onWheel";
var $b17a7fd270a24b50$export$e8d60d9b5ceff7c0 = "Escape";
var $b17a7fd270a24b50$export$17dec1da9b0e2eb3 = "ArrowLeft";
var $b17a7fd270a24b50$export$91898c0e7e48903 = "ArrowRight";
var $b17a7fd270a24b50$export$d62fb7722b07f2f3 = "button";
var $b17a7fd270a24b50$export$c5f5ca1963fed141 = "icon";
var $b17a7fd270a24b50$export$eff7fe5eefd707ad = "contain";
var $b17a7fd270a24b50$export$9a9f12fc3f1c1e4f = "cover";
var $b17a7fd270a24b50$export$b149fc25cb186fec = "Unknown action type";



'use client';
var $2e545d666ef3112d$var$cssPrefix$3 = "yarl__";
function $2e545d666ef3112d$export$4f5d2d50c9deca37() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return (0, $6zk1M._)(classes).filter(Boolean).join(" ");
}
function $2e545d666ef3112d$export$1283875077dc8f0a(name) {
    return "".concat($2e545d666ef3112d$var$cssPrefix$3).concat(name);
}
function $2e545d666ef3112d$export$8b4981022bd80a4e(name) {
    return "--".concat($2e545d666ef3112d$var$cssPrefix$3).concat(name);
}
function $2e545d666ef3112d$export$195c4126907dde97(base, prefix) {
    return "".concat(base).concat(prefix ? "_".concat(prefix) : "");
}
function $2e545d666ef3112d$export$3e7cd27eed1727c(base) {
    return function(prefix) {
        return $2e545d666ef3112d$export$195c4126907dde97(base, prefix);
    };
}
function $2e545d666ef3112d$export$1c4d965eb6f65dfa(labels, defaultLabel) {
    var _a;
    return (_a = labels === null || labels === void 0 ? void 0 : labels[defaultLabel]) !== null && _a !== void 0 ? _a : defaultLabel;
}
function $2e545d666ef3112d$export$1237798dc640739a(labels, defaultLabel) {
    return $2e545d666ef3112d$export$1c4d965eb6f65dfa(labels, defaultLabel);
}
function $2e545d666ef3112d$export$77152303d9076b8(labels, slides, index) {
    return $2e545d666ef3112d$export$1c4d965eb6f65dfa(labels, "{index} of {total}").replace(/\{index}/g, "".concat($2e545d666ef3112d$export$501611100333094a(index, slides.length) + 1)).replace(/\{total}/g, "".concat(slides.length));
}
function $2e545d666ef3112d$export$de863c629cb9919d() {
    for(var _len = arguments.length, cleaners = new Array(_len), _key = 0; _key < _len; _key++){
        cleaners[_key] = arguments[_key];
    }
    return function() {
        cleaners.forEach(function(cleaner) {
            cleaner();
        });
    };
}
function $2e545d666ef3112d$export$aac3e49c3c8b5cb0(name, contextName, context) {
    return function() {
        var ctx = $eHaBZ.useContext(context);
        if (!ctx) throw new Error("".concat(name, " must be used within a ").concat(contextName, ".Provider"));
        return ctx;
    };
}
function $2e545d666ef3112d$export$fef62134eea24008() {
    return typeof window !== "undefined";
}
function $2e545d666ef3112d$export$2077e0241d6afd3c(value) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var factor = Math.pow(10, decimals);
    return Math.round((value + Number.EPSILON) * factor) / factor;
}
function $2e545d666ef3112d$export$55ec18c411514c07(slide) {
    return slide.type === undefined || slide.type === "image";
}
function $2e545d666ef3112d$export$f5ba2f5b3fd12e6e(image, imageFit) {
    return image.imageFit === (0, $b17a7fd270a24b50$export$9a9f12fc3f1c1e4f) || image.imageFit !== (0, $b17a7fd270a24b50$export$eff7fe5eefd707ad) && imageFit === (0, $b17a7fd270a24b50$export$9a9f12fc3f1c1e4f);
}
function $2e545d666ef3112d$export$5f87784a266e50a4(value) {
    return typeof value === "string" ? Number.parseInt(value, 10) : value;
}
function $2e545d666ef3112d$export$7871fb532d320d99(input) {
    if (typeof input === "number") return {
        pixel: input
    };
    if (typeof input === "string") {
        var value = $2e545d666ef3112d$export$5f87784a266e50a4(input);
        return input.endsWith("%") ? {
            percent: value
        } : {
            pixel: value
        };
    }
    return {
        pixel: 0
    };
}
function $2e545d666ef3112d$export$7ff571008bce9900(containerRect, padding) {
    var paddingValue = $2e545d666ef3112d$export$7871fb532d320d99(padding);
    var paddingPixels = paddingValue.percent !== undefined ? containerRect.width / 100 * paddingValue.percent : paddingValue.pixel;
    return {
        width: Math.max(containerRect.width - 2 * paddingPixels, 0),
        height: Math.max(containerRect.height - 2 * paddingPixels, 0)
    };
}
function $2e545d666ef3112d$export$508f096bfcdaac40() {
    return ($2e545d666ef3112d$export$fef62134eea24008() ? window === null || window === void 0 ? void 0 : window.devicePixelRatio : undefined) || 1;
}
function $2e545d666ef3112d$export$501611100333094a(index, slidesCount) {
    return slidesCount > 0 ? (index % slidesCount + slidesCount) % slidesCount : 0;
}
function $2e545d666ef3112d$export$883ece934910f98d(slides) {
    return slides.length > 0;
}
function $2e545d666ef3112d$export$cdfb855c5eb3bc84(slides, index) {
    return slides[$2e545d666ef3112d$export$501611100333094a(index, slides.length)];
}
function $2e545d666ef3112d$export$9f2f3fed4fdffdfc(slides, index) {
    return $2e545d666ef3112d$export$883ece934910f98d(slides) ? $2e545d666ef3112d$export$cdfb855c5eb3bc84(slides, index) : undefined;
}
function $2e545d666ef3112d$export$b2184449b7659b5a(slide) {
    return $2e545d666ef3112d$export$55ec18c411514c07(slide) ? slide.src : undefined;
}
function $2e545d666ef3112d$export$34ce6a408311d810(toolbar, key, button) {
    if (!button) return toolbar;
    var buttons = toolbar.buttons, restToolbar = (0, $aRv4I._)(toolbar, [
        "buttons"
    ]);
    var index = buttons.findIndex(function(item) {
        return item === key;
    });
    var buttonWithKey = $eHaBZ.isValidElement(button) ? $eHaBZ.cloneElement(button, {
        key: key
    }, null) : button;
    if (index >= 0) {
        var result = (0, $6zk1M._)(buttons);
        result.splice(index, 1, buttonWithKey);
        return (0, $lvTkn._)({
            buttons: result
        }, restToolbar);
    }
    return (0, $lvTkn._)({
        buttons: [
            buttonWithKey
        ].concat((0, $6zk1M._)(buttons))
    }, restToolbar);
}
function $2e545d666ef3112d$export$e88693bab67822d1() {
    var stopPropagation = function(event) {
        event.stopPropagation();
    };
    return {
        onPointerDown: stopPropagation,
        onKeyDown: stopPropagation,
        onWheel: stopPropagation
    };
}
function $2e545d666ef3112d$export$aab7f3145c728301(carousel, slides) {
    var minimum = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    return Math.min(carousel.preload, Math.max(carousel.finite ? slides.length - 1 : Math.floor(slides.length / 2), minimum));
}
var $2e545d666ef3112d$var$isReact19 = Number($eHaBZ.version.split(".")[0]) >= 19;
function $2e545d666ef3112d$export$9c64d01b28c1f747(condition) {
    var legacyValue = condition ? "" : undefined;
    return {
        inert: $2e545d666ef3112d$var$isReact19 ? condition : legacyValue
    };
}
function $2e545d666ef3112d$export$b7a864e1eaef9de5(node) {
    node.scrollTop;
}
var $2e545d666ef3112d$export$d626463445cef3e9 = {
    open: false,
    close: function() {},
    index: 0,
    slides: [],
    render: {},
    plugins: [],
    toolbar: {
        buttons: [
            (0, $b17a7fd270a24b50$export$493a596486210a21)
        ]
    },
    labels: {},
    animation: {
        fade: 250,
        swipe: 500,
        easing: {
            fade: "ease",
            swipe: "ease-out",
            navigation: "ease-in-out"
        }
    },
    carousel: {
        finite: false,
        preload: 2,
        padding: "16px",
        spacing: "30%",
        imageFit: (0, $b17a7fd270a24b50$export$eff7fe5eefd707ad),
        imageProps: {}
    },
    controller: {
        ref: null,
        focus: true,
        aria: false,
        touchAction: "none",
        closeOnPullUp: false,
        closeOnPullDown: false,
        closeOnBackdropClick: false,
        preventDefaultWheelX: true,
        preventDefaultWheelY: false,
        disableSwipeNavigation: false
    },
    portal: {},
    noScroll: {
        disabled: false
    },
    on: {},
    styles: {},
    className: ""
};
function $2e545d666ef3112d$export$c5ba3739ffba980d(name, component) {
    return {
        name: name,
        component: component
    };
}
function $2e545d666ef3112d$export$270e7ba5936d3c48(module, children) {
    return {
        module: module,
        children: children
    };
}
function $2e545d666ef3112d$var$traverseNode(node, target, apply) {
    if (node.module.name === target) return apply(node);
    if (node.children) return [
        $2e545d666ef3112d$export$270e7ba5936d3c48(node.module, node.children.flatMap(function(n) {
            var _a;
            return (_a = $2e545d666ef3112d$var$traverseNode(n, target, apply)) !== null && _a !== void 0 ? _a : [];
        }))
    ];
    return [
        node
    ];
}
function $2e545d666ef3112d$var$traverse(nodes, target, apply) {
    return nodes.flatMap(function(node) {
        var _a;
        return (_a = $2e545d666ef3112d$var$traverseNode(node, target, apply)) !== null && _a !== void 0 ? _a : [];
    });
}
function $2e545d666ef3112d$export$bc996c07eb970c78(root) {
    var plugins = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], augmentations = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var config = root;
    var contains = function(target) {
        var nodes = (0, $6zk1M._)(config);
        while(nodes.length > 0){
            var _nodes;
            var node = nodes.pop();
            if ((node === null || node === void 0 ? void 0 : node.module.name) === target) return true;
            if (node === null || node === void 0 ? void 0 : node.children) (_nodes = nodes).push.apply(_nodes, (0, $6zk1M._)(node.children));
        }
        return false;
    };
    var addParent = function(target, module) {
        if (target === "") {
            config = [
                $2e545d666ef3112d$export$270e7ba5936d3c48(module, config)
            ];
            return;
        }
        config = $2e545d666ef3112d$var$traverse(config, target, function(node) {
            return [
                $2e545d666ef3112d$export$270e7ba5936d3c48(module, [
                    node
                ])
            ];
        });
    };
    var append = function(target, module) {
        config = $2e545d666ef3112d$var$traverse(config, target, function(node) {
            return [
                $2e545d666ef3112d$export$270e7ba5936d3c48(node.module, [
                    $2e545d666ef3112d$export$270e7ba5936d3c48(module, node.children)
                ])
            ];
        });
    };
    var addChild = function(target, module, precede) {
        config = $2e545d666ef3112d$var$traverse(config, target, function(node) {
            var _a;
            return [
                $2e545d666ef3112d$export$270e7ba5936d3c48(node.module, (0, $6zk1M._)(precede ? [
                    $2e545d666ef3112d$export$270e7ba5936d3c48(module)
                ] : []).concat((0, $6zk1M._)((_a = node.children) !== null && _a !== void 0 ? _a : []), (0, $6zk1M._)(!precede ? [
                    $2e545d666ef3112d$export$270e7ba5936d3c48(module)
                ] : [])))
            ];
        });
    };
    var addSibling = function(target, module, precede) {
        config = $2e545d666ef3112d$var$traverse(config, target, function(node) {
            return (0, $6zk1M._)(precede ? [
                $2e545d666ef3112d$export$270e7ba5936d3c48(module)
            ] : []).concat([
                node
            ], (0, $6zk1M._)(!precede ? [
                $2e545d666ef3112d$export$270e7ba5936d3c48(module)
            ] : []));
        });
    };
    var addModule = function(module) {
        append((0, $b17a7fd270a24b50$export$b861c6f4d58b4c2f), module);
    };
    var replace = function(target, module) {
        config = $2e545d666ef3112d$var$traverse(config, target, function(node) {
            return [
                $2e545d666ef3112d$export$270e7ba5936d3c48(module, node.children)
            ];
        });
    };
    var remove = function(target) {
        config = $2e545d666ef3112d$var$traverse(config, target, function(node) {
            return node.children;
        });
    };
    var augment = function(augmentation) {
        augmentations.push(augmentation);
    };
    plugins.forEach(function(plugin) {
        plugin({
            contains: contains,
            addParent: addParent,
            append: append,
            addChild: addChild,
            addSibling: addSibling,
            addModule: addModule,
            replace: replace,
            remove: remove,
            augment: augment
        });
    });
    return {
        config: config,
        augmentation: function(props) {
            return augmentations.reduce(function(acc, augmentation) {
                return augmentation(acc);
            }, props);
        }
    };
}
var $2e545d666ef3112d$export$bec71e4205979323 = $eHaBZ.createContext(null);
var $2e545d666ef3112d$export$3992c64d261ded5a = $2e545d666ef3112d$export$aac3e49c3c8b5cb0("useA11yContext", "A11yContext", $2e545d666ef3112d$export$bec71e4205979323);
function $2e545d666ef3112d$export$e41a845d3e53ea09(param) {
    var children = param.children;
    var _React_useState = (0, $21h22._)($eHaBZ.useState(false), 2), focusWithin = _React_useState[0], setFocusWithin = _React_useState[1];
    var _React_useState1 = (0, $21h22._)($eHaBZ.useState(false), 2), autoPlaying = _React_useState1[0], setAutoPlaying = _React_useState1[1];
    var context = $eHaBZ.useMemo(function() {
        var trackFocusWithin = function(onFocus, onBlur) {
            var trackAndDelegate = function(focusWithinValue) {
                return function(event) {
                    var _a;
                    if (!event.currentTarget.contains(event.relatedTarget)) setFocusWithin(focusWithinValue);
                    (_a = focusWithinValue ? onFocus : onBlur) === null || _a === void 0 || _a(event);
                };
            };
            return {
                onFocus: trackAndDelegate(true),
                onBlur: trackAndDelegate(false)
            };
        };
        return {
            focusWithin: focusWithin,
            trackFocusWithin: trackFocusWithin,
            autoPlaying: autoPlaying,
            setAutoPlaying: setAutoPlaying
        };
    }, [
        focusWithin,
        autoPlaying
    ]);
    return $eHaBZ.createElement($2e545d666ef3112d$export$bec71e4205979323.Provider, {
        value: context
    }, children);
}
var $2e545d666ef3112d$export$41b6c5189865fe72 = $eHaBZ.createContext(null);
var $2e545d666ef3112d$export$c199d36c2862b6ed = $2e545d666ef3112d$export$aac3e49c3c8b5cb0("useDocument", "DocumentContext", $2e545d666ef3112d$export$41b6c5189865fe72);
function $2e545d666ef3112d$export$30e869153d18a2e6(param) {
    var nodeRef = param.nodeRef, children = param.children;
    var context = $eHaBZ.useMemo(function() {
        var getOwnerDocument = function(node) {
            var _a;
            return ((_a = node || nodeRef.current) === null || _a === void 0 ? void 0 : _a.ownerDocument) || document;
        };
        var getOwnerWindow = function(node) {
            var _a;
            return ((_a = getOwnerDocument(node)) === null || _a === void 0 ? void 0 : _a.defaultView) || window;
        };
        return {
            getOwnerDocument: getOwnerDocument,
            getOwnerWindow: getOwnerWindow
        };
    }, [
        nodeRef
    ]);
    return $eHaBZ.createElement($2e545d666ef3112d$export$41b6c5189865fe72.Provider, {
        value: context
    }, children);
}
var $2e545d666ef3112d$export$f4208dae105d4d3 = $eHaBZ.createContext(null);
var $2e545d666ef3112d$export$91a992459f6e0f07 = $2e545d666ef3112d$export$aac3e49c3c8b5cb0("useEvents", "EventsContext", $2e545d666ef3112d$export$f4208dae105d4d3);
function $2e545d666ef3112d$export$686accdd53ac150f(param) {
    var children = param.children;
    var _React_useState = (0, $21h22._)($eHaBZ.useState({}), 1), subscriptions = _React_useState[0];
    $eHaBZ.useEffect(function() {
        return function() {
            Object.keys(subscriptions).forEach(function(topic) {
                return delete subscriptions[topic];
            });
        };
    }, [
        subscriptions
    ]);
    var context = $eHaBZ.useMemo(function() {
        var unsubscribe = function(topic, callback) {
            var _a;
            var _a1;
            (_a1 = subscriptions[topic]) === null || _a1 === void 0 || (_a = _a1).splice.apply(_a, [
                0,
                subscriptions[topic].length
            ].concat((0, $6zk1M._)(subscriptions[topic].filter(function(cb) {
                return cb !== callback;
            }))));
        };
        var subscribe = function(topic, callback) {
            if (!subscriptions[topic]) subscriptions[topic] = [];
            subscriptions[topic].push(callback);
            return function() {
                return unsubscribe(topic, callback);
            };
        };
        var publish = function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $21h22._)(_tmp, 2), topic = _tmp1[0], event = _tmp1[1];
            var _a;
            (_a = subscriptions[topic]) === null || _a === void 0 || _a.forEach(function(callback) {
                return callback(event);
            });
        };
        return {
            publish: publish,
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };
    }, [
        subscriptions
    ]);
    return $eHaBZ.createElement($2e545d666ef3112d$export$f4208dae105d4d3.Provider, {
        value: context
    }, children);
}
var $2e545d666ef3112d$export$9f6b9cbf1d54cc28 = $eHaBZ.createContext(null);
var $2e545d666ef3112d$export$d930f3536e1c64f6 = $2e545d666ef3112d$export$aac3e49c3c8b5cb0("useLightboxProps", "LightboxPropsContext", $2e545d666ef3112d$export$9f6b9cbf1d54cc28);
function $2e545d666ef3112d$export$7141a340a3dea601(_param) {
    var children = _param.children, props = (0, $aRv4I._)(_param, [
        "children"
    ]);
    return $eHaBZ.createElement($2e545d666ef3112d$export$9f6b9cbf1d54cc28.Provider, {
        value: props
    }, children);
}
var $2e545d666ef3112d$export$c24db94cf7704d3a = $eHaBZ.createContext(null);
var $2e545d666ef3112d$export$566121e2bbc52eec = $2e545d666ef3112d$export$aac3e49c3c8b5cb0("useLightboxState", "LightboxStateContext", $2e545d666ef3112d$export$c24db94cf7704d3a);
var $2e545d666ef3112d$export$42eb31c6c0f01c10 = $eHaBZ.createContext(null);
var $2e545d666ef3112d$export$9463bb14d6ba055e = $2e545d666ef3112d$export$aac3e49c3c8b5cb0("useLightboxDispatch", "LightboxDispatchContext", $2e545d666ef3112d$export$42eb31c6c0f01c10);
function $2e545d666ef3112d$var$reducer(state, action) {
    switch(action.type){
        case "swipe":
            {
                var slides = state.slides;
                var increment = (action === null || action === void 0 ? void 0 : action.increment) || 0;
                var globalIndex = state.globalIndex + increment;
                var currentIndex = $2e545d666ef3112d$export$501611100333094a(globalIndex, slides.length);
                var currentSlide = $2e545d666ef3112d$export$9f2f3fed4fdffdfc(slides, currentIndex);
                var animation = increment || action.duration !== undefined ? {
                    increment: increment,
                    duration: action.duration,
                    easing: action.easing
                } : undefined;
                return {
                    slides: slides,
                    currentIndex: currentIndex,
                    globalIndex: globalIndex,
                    currentSlide: currentSlide,
                    animation: animation
                };
            }
        case "update":
            if (action.slides !== state.slides || action.index !== state.currentIndex) return {
                slides: action.slides,
                currentIndex: action.index,
                globalIndex: action.index,
                currentSlide: $2e545d666ef3112d$export$9f2f3fed4fdffdfc(action.slides, action.index)
            };
            return state;
        default:
            throw new Error((0, $b17a7fd270a24b50$export$b149fc25cb186fec));
    }
}
function $2e545d666ef3112d$export$62d2e1d2e7609988(param) {
    var slides = param.slides, index = param.index, children = param.children;
    var _React_useReducer = (0, $21h22._)($eHaBZ.useReducer($2e545d666ef3112d$var$reducer, {
        slides: slides,
        currentIndex: index,
        globalIndex: index,
        currentSlide: $2e545d666ef3112d$export$9f2f3fed4fdffdfc(slides, index)
    }), 2), state = _React_useReducer[0], dispatch = _React_useReducer[1];
    $eHaBZ.useEffect(function() {
        dispatch({
            type: "update",
            slides: slides,
            index: index
        });
    }, [
        slides,
        index
    ]);
    var context = $eHaBZ.useMemo(function() {
        return (0, $9Jpjh._)((0, $lvTkn._)({}, state), {
            state: state,
            dispatch: dispatch
        });
    }, [
        state,
        dispatch
    ]);
    return $eHaBZ.createElement($2e545d666ef3112d$export$42eb31c6c0f01c10.Provider, {
        value: dispatch
    }, $eHaBZ.createElement($2e545d666ef3112d$export$c24db94cf7704d3a.Provider, {
        value: context
    }, children));
}
var $2e545d666ef3112d$export$e338b1178a56544e = $eHaBZ.createContext(null);
var $2e545d666ef3112d$export$1bc7162631c81b3f = $2e545d666ef3112d$export$aac3e49c3c8b5cb0("useTimeouts", "TimeoutsContext", $2e545d666ef3112d$export$e338b1178a56544e);
function $2e545d666ef3112d$export$9d9954f5885fa393(param) {
    var children = param.children;
    var _React_useState = (0, $21h22._)($eHaBZ.useState([]), 1), timeouts = _React_useState[0];
    $eHaBZ.useEffect(function() {
        return function() {
            timeouts.forEach(function(tid) {
                return window.clearTimeout(tid);
            });
            timeouts.splice(0, timeouts.length);
        };
    }, [
        timeouts
    ]);
    var context = $eHaBZ.useMemo(function() {
        var removeTimeout = function(id) {
            var _timeouts;
            (_timeouts = timeouts).splice.apply(_timeouts, [
                0,
                timeouts.length
            ].concat((0, $6zk1M._)(timeouts.filter(function(tid) {
                return tid !== id;
            }))));
        };
        var setTimeout = function(fn, delay) {
            var id = window.setTimeout(function() {
                removeTimeout(id);
                fn();
            }, delay);
            timeouts.push(id);
            return id;
        };
        var clearTimeout = function(id) {
            if (id !== undefined) {
                removeTimeout(id);
                window.clearTimeout(id);
            }
        };
        return {
            setTimeout: setTimeout,
            clearTimeout: clearTimeout
        };
    }, [
        timeouts
    ]);
    return $eHaBZ.createElement($2e545d666ef3112d$export$e338b1178a56544e.Provider, {
        value: context
    }, children);
}
var $2e545d666ef3112d$export$c25acd513dcc8062 = $eHaBZ.forwardRef(function IconButton(_param, ref) {
    var label = _param.label, className = _param.className, Icon = _param.icon, renderIcon = _param.renderIcon, onClick = _param.onClick, style = _param.style, rest = (0, $aRv4I._)(_param, [
        "label",
        "className",
        "icon",
        "renderIcon",
        "onClick",
        "style"
    ]);
    var _useLightboxProps = $2e545d666ef3112d$export$d930f3536e1c64f6(), styles = _useLightboxProps.styles, labels = _useLightboxProps.labels;
    var buttonLabel = $2e545d666ef3112d$export$1c4d965eb6f65dfa(labels, label);
    return $eHaBZ.createElement("button", (0, $lvTkn._)({
        ref: ref,
        type: "button",
        title: buttonLabel,
        "aria-label": buttonLabel,
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37($2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$d62fb7722b07f2f3)), className),
        onClick: onClick,
        style: (0, $lvTkn._)({}, style, styles.button)
    }, rest), renderIcon ? renderIcon() : $eHaBZ.createElement(Icon, {
        className: $2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$c5f5ca1963fed141)),
        style: styles.icon
    }));
});
function $2e545d666ef3112d$var$svgIcon(name, children) {
    var icon = function(props) {
        return $eHaBZ.createElement("svg", (0, $lvTkn._)({
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24",
            "aria-hidden": "true",
            focusable: "false"
        }, props), children);
    };
    icon.displayName = name;
    return icon;
}
function $2e545d666ef3112d$export$274edc73af1ae9c8(name, glyph) {
    return $2e545d666ef3112d$var$svgIcon(name, $eHaBZ.createElement("g", {
        fill: "currentColor"
    }, $eHaBZ.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), glyph));
}
function $2e545d666ef3112d$export$6b1fd58c1dc933ec(name, glyph) {
    return $2e545d666ef3112d$var$svgIcon(name, $eHaBZ.createElement($eHaBZ.Fragment, null, $eHaBZ.createElement("defs", null, $eHaBZ.createElement("mask", {
        id: "strike"
    }, $eHaBZ.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "white"
    }), $eHaBZ.createElement("path", {
        d: "M0 0L24 24",
        stroke: "black",
        strokeWidth: 4
    }))), $eHaBZ.createElement("path", {
        d: "M0.70707 2.121320L21.878680 23.292883",
        stroke: "currentColor",
        strokeWidth: 2
    }), $eHaBZ.createElement("g", {
        fill: "currentColor",
        mask: "url(#strike)"
    }, $eHaBZ.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), glyph)));
}
var $2e545d666ef3112d$export$cae179f078f4b4a4 = $2e545d666ef3112d$export$274edc73af1ae9c8("Close", $eHaBZ.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}));
var $2e545d666ef3112d$export$d05925e1c7f3f136 = $2e545d666ef3112d$export$274edc73af1ae9c8("Previous", $eHaBZ.createElement("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}));
var $2e545d666ef3112d$export$3da0e0ec94bd4ce1 = $2e545d666ef3112d$export$274edc73af1ae9c8("Next", $eHaBZ.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}));
var $2e545d666ef3112d$export$b936c55164dcf1db = $2e545d666ef3112d$export$274edc73af1ae9c8("Loading", $eHaBZ.createElement($eHaBZ.Fragment, null, Array.from({
    length: 8
}).map(function(_, index, array) {
    return $eHaBZ.createElement("line", {
        key: index,
        x1: "12",
        y1: "6.5",
        x2: "12",
        y2: "1.8",
        strokeLinecap: "round",
        strokeWidth: "2.6",
        stroke: "currentColor",
        strokeOpacity: 1 / array.length * (index + 1),
        transform: "rotate(".concat(360 / array.length * index, ", 12, 12)")
    });
})));
var $2e545d666ef3112d$export$19bc16ee58e19b3d = $2e545d666ef3112d$export$274edc73af1ae9c8("Error", $eHaBZ.createElement("path", {
    d: "M21.9,21.9l-8.49-8.49l0,0L3.59,3.59l0,0L2.1,2.1L0.69,3.51L3,5.83V19c0,1.1,0.9,2,2,2h13.17l2.31,2.31L21.9,21.9z M5,18 l3.5-4.5l2.5,3.01L12.17,15l3,3H5z M21,18.17L5.83,3H19c1.1,0,2,0.9,2,2V18.17z"
}));
var $2e545d666ef3112d$export$e5c5a5f917a5871c = $2e545d666ef3112d$export$fef62134eea24008() ? $eHaBZ.useLayoutEffect : $eHaBZ.useEffect;
function $2e545d666ef3112d$export$f3e625e1b2b31d60() {
    var _React_useState = (0, $21h22._)($eHaBZ.useState(false), 2), reduceMotion = _React_useState[0], setReduceMotion = _React_useState[1];
    $eHaBZ.useEffect(function() {
        var _a, _b;
        var mediaQuery = (_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, "(prefers-reduced-motion: reduce)");
        setReduceMotion(mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.matches);
        var listener = function(event) {
            return setReduceMotion(event.matches);
        };
        (_b = mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.addEventListener) === null || _b === void 0 || _b.call(mediaQuery, "change", listener);
        return function() {
            var _a;
            return (_a = mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.removeEventListener) === null || _a === void 0 ? void 0 : _a.call(mediaQuery, "change", listener);
        };
    }, []);
    return reduceMotion;
}
function $2e545d666ef3112d$var$currentTransformation(node) {
    var x = 0;
    var y = 0;
    var z = 0;
    var matrix = window.getComputedStyle(node).transform;
    var matcher = matrix.match(/matrix.*\((.+)\)/);
    if (matcher) {
        var values = matcher[1].split(",").map($2e545d666ef3112d$export$5f87784a266e50a4);
        if (values.length === 6) {
            x = values[4];
            y = values[5];
        } else if (values.length === 16) {
            x = values[12];
            y = values[13];
            z = values[14];
        }
    }
    return {
        x: x,
        y: y,
        z: z
    };
}
function $2e545d666ef3112d$export$9e2608686d4ad846(nodeRef, computeAnimation) {
    var snapshot = $eHaBZ.useRef(undefined);
    var animation = $eHaBZ.useRef(undefined);
    var reduceMotion = $2e545d666ef3112d$export$f3e625e1b2b31d60();
    $2e545d666ef3112d$export$e5c5a5f917a5871c(function() {
        var _a, _b, _c;
        if (nodeRef.current && snapshot.current !== undefined && !reduceMotion) {
            var _ref = computeAnimation(snapshot.current, nodeRef.current.getBoundingClientRect(), $2e545d666ef3112d$var$currentTransformation(nodeRef.current)) || {}, keyframes = _ref.keyframes, duration = _ref.duration, easing = _ref.easing, onfinish = _ref.onfinish;
            if (keyframes && duration) {
                (_a = animation.current) === null || _a === void 0 || _a.cancel();
                animation.current = undefined;
                try {
                    animation.current = (_c = (_b = nodeRef.current).animate) === null || _c === void 0 ? void 0 : _c.call(_b, keyframes, {
                        duration: duration,
                        easing: easing
                    });
                } catch (err) {
                    console.error(err);
                }
                if (animation.current) animation.current.onfinish = function() {
                    animation.current = undefined;
                    onfinish === null || onfinish === void 0 || onfinish();
                };
            }
        }
        snapshot.current = undefined;
    });
    return {
        prepareAnimation: function(currentSnapshot) {
            snapshot.current = currentSnapshot;
        },
        isAnimationPlaying: function() {
            var _a;
            return ((_a = animation.current) === null || _a === void 0 ? void 0 : _a.playState) === "running";
        }
    };
}
function $2e545d666ef3112d$export$b1d85de58d38d09d() {
    var containerRef = $eHaBZ.useRef(null);
    var observerRef = $eHaBZ.useRef(undefined);
    var _React_useState = (0, $21h22._)($eHaBZ.useState(), 2), containerRect = _React_useState[0], setContainerRect = _React_useState[1];
    var setContainerRef = $eHaBZ.useCallback(function(node) {
        containerRef.current = node;
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = undefined;
        }
        var updateContainerRect = function() {
            if (node) {
                var styles = window.getComputedStyle(node);
                var parse = function(value) {
                    return parseFloat(value) || 0;
                };
                setContainerRect({
                    width: Math.round(node.clientWidth - parse(styles.paddingLeft) - parse(styles.paddingRight)),
                    height: Math.round(node.clientHeight - parse(styles.paddingTop) - parse(styles.paddingBottom))
                });
            } else setContainerRect(undefined);
        };
        updateContainerRect();
        if (node && typeof ResizeObserver !== "undefined") {
            observerRef.current = new ResizeObserver(updateContainerRect);
            observerRef.current.observe(node);
        }
    }, []);
    return {
        setContainerRef: setContainerRef,
        containerRef: containerRef,
        containerRect: containerRect
    };
}
function $2e545d666ef3112d$export$69f38700ea0cb3b9() {
    var timeoutId = $eHaBZ.useRef(undefined);
    var _useTimeouts = $2e545d666ef3112d$export$1bc7162631c81b3f(), setTimeout = _useTimeouts.setTimeout, clearTimeout = _useTimeouts.clearTimeout;
    return $eHaBZ.useCallback(function(callback, delay) {
        clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay > 0 ? delay : 0);
    }, [
        setTimeout,
        clearTimeout
    ]);
}
function $2e545d666ef3112d$export$ee5b5d04074a389e(fn) {
    var ref = $eHaBZ.useRef(fn);
    $2e545d666ef3112d$export$e5c5a5f917a5871c(function() {
        ref.current = fn;
    });
    return $eHaBZ.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _a;
        var _a1;
        return (_a1 = ref.current) === null || _a1 === void 0 ? void 0 : (_a = _a1).call.apply(_a, [
            ref
        ].concat((0, $6zk1M._)(args)));
    }, []);
}
function $2e545d666ef3112d$export$4bb192c7cacf928f(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}
function $2e545d666ef3112d$export$ebc1e1560c2dffa5(refA, refB) {
    return $eHaBZ.useMemo(function() {
        return refA == null && refB == null ? null : function(refValue) {
            $2e545d666ef3112d$export$4bb192c7cacf928f(refA, refValue);
            $2e545d666ef3112d$export$4bb192c7cacf928f(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}
function $2e545d666ef3112d$export$2bd1c19440b9235c(focus) {
    var disabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var focused = $eHaBZ.useRef(false);
    $2e545d666ef3112d$export$e5c5a5f917a5871c(function() {
        if (disabled && focused.current) {
            focused.current = false;
            focus();
        }
    }, [
        disabled,
        focus
    ]);
    var onFocus = $eHaBZ.useCallback(function() {
        focused.current = true;
    }, []);
    var onBlur = $eHaBZ.useCallback(function() {
        focused.current = false;
    }, []);
    return {
        onFocus: onFocus,
        onBlur: onBlur
    };
}
function $2e545d666ef3112d$export$81f015b3ec5d61cf() {
    var _React_useState = (0, $21h22._)($eHaBZ.useState(false), 2), isRTL = _React_useState[0], setIsRTL = _React_useState[1];
    $2e545d666ef3112d$export$e5c5a5f917a5871c(function() {
        setIsRTL(window.getComputedStyle(window.document.documentElement).direction === "rtl");
    }, []);
    return isRTL;
}
function $2e545d666ef3112d$export$19012f58216d597f() {
    var _React_useState = (0, $21h22._)($eHaBZ.useState({}), 1), subscribers = _React_useState[0];
    var notifySubscribers = $eHaBZ.useCallback(function(type, event) {
        var _a;
        (_a = subscribers[type]) === null || _a === void 0 || _a.forEach(function(listener) {
            if (!event.isPropagationStopped()) listener(event);
        });
    }, [
        subscribers
    ]);
    var registerSensors = $eHaBZ.useMemo(function() {
        return {
            onPointerDown: function(event) {
                return notifySubscribers((0, $b17a7fd270a24b50$export$e15fc153f45a963d), event);
            },
            onPointerMove: function(event) {
                return notifySubscribers((0, $b17a7fd270a24b50$export$1f8863949fbdd7e5), event);
            },
            onPointerUp: function(event) {
                return notifySubscribers((0, $b17a7fd270a24b50$export$2d868b67a5791b8a), event);
            },
            onPointerLeave: function(event) {
                return notifySubscribers((0, $b17a7fd270a24b50$export$526cafa85592f1a5), event);
            },
            onPointerCancel: function(event) {
                return notifySubscribers((0, $b17a7fd270a24b50$export$22151cee048c4be9), event);
            },
            onKeyDown: function(event) {
                return notifySubscribers((0, $b17a7fd270a24b50$export$1aba4f3521686ca9), event);
            },
            onKeyUp: function(event) {
                return notifySubscribers((0, $b17a7fd270a24b50$export$bdb9f99d61a6879b), event);
            },
            onWheel: function(event) {
                return notifySubscribers((0, $b17a7fd270a24b50$export$5635dc9d647242c7), event);
            }
        };
    }, [
        notifySubscribers
    ]);
    var subscribeSensors = $eHaBZ.useCallback(function(type, callback) {
        if (!subscribers[type]) subscribers[type] = [];
        subscribers[type].unshift(callback);
        return function() {
            var _listeners;
            var listeners = subscribers[type];
            if (listeners) (_listeners = listeners).splice.apply(_listeners, [
                0,
                listeners.length
            ].concat((0, $6zk1M._)(listeners.filter(function(el) {
                return el !== callback;
            }))));
        };
    }, [
        subscribers
    ]);
    return {
        registerSensors: registerSensors,
        subscribeSensors: subscribeSensors
    };
}
function $2e545d666ef3112d$export$8b7b9481d6186f21(callback, delay) {
    var lastCallbackTime = $eHaBZ.useRef(0);
    var delayCallback = $2e545d666ef3112d$export$69f38700ea0cb3b9();
    var executeCallback = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        lastCallbackTime.current = Date.now();
        callback(args);
    });
    return $eHaBZ.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        delayCallback(function() {
            executeCallback(args);
        }, delay - (Date.now() - lastCallbackTime.current));
    }, [
        delay,
        executeCallback,
        delayCallback
    ]);
}
var $2e545d666ef3112d$var$slidePrefix = $2e545d666ef3112d$export$3e7cd27eed1727c("slide");
var $2e545d666ef3112d$var$slideImagePrefix = $2e545d666ef3112d$export$3e7cd27eed1727c("slide_image");
function $2e545d666ef3112d$export$ef86b1d52c77b27b(param) {
    var image = param.slide, offset = param.offset, render = param.render, rect = param.rect, imageFit = param.imageFit, imageProps = param.imageProps, onClick = param.onClick, onLoad = param.onLoad, onError = param.onError, style = param.style;
    var _Math, _Math1;
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var _React_useState = (0, $21h22._)($eHaBZ.useState((0, $b17a7fd270a24b50$export$554a1415841c52a8)), 2), status = _React_useState[0], setStatus = _React_useState[1];
    var publish = $2e545d666ef3112d$export$91a992459f6e0f07().publish;
    var setTimeout = $2e545d666ef3112d$export$1bc7162631c81b3f().setTimeout;
    var imageRef = $eHaBZ.useRef(null);
    $eHaBZ.useEffect(function() {
        if (offset === 0) publish((0, $b17a7fd270a24b50$export$6751782e799f6445)(status));
    }, [
        offset,
        status,
        publish
    ]);
    var handleLoading = $2e545d666ef3112d$export$ee5b5d04074a389e(function(img) {
        ("decode" in img ? img.decode() : Promise.resolve()).catch(function() {}).then(function() {
            if (!img.parentNode) return;
            setStatus((0, $b17a7fd270a24b50$export$a195e517d37aaa33));
            setTimeout(function() {
                onLoad === null || onLoad === void 0 || onLoad(img);
            }, 0);
        });
    });
    var setImageRef = $eHaBZ.useCallback(function(img) {
        imageRef.current = img;
        if (img === null || img === void 0 ? void 0 : img.complete) handleLoading(img);
    }, [
        handleLoading
    ]);
    var handleOnLoad = $eHaBZ.useCallback(function(event) {
        handleLoading(event.currentTarget);
    }, [
        handleLoading
    ]);
    var handleOnError = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        setStatus((0, $b17a7fd270a24b50$export$2ed3c80dbc178d91));
        onError === null || onError === void 0 || onError();
    });
    var cover = $2e545d666ef3112d$export$f5ba2f5b3fd12e6e(image, imageFit);
    var nonInfinite = function(value, fallback) {
        return Number.isFinite(value) ? value : fallback;
    };
    var maxWidth = nonInfinite((_Math = Math).max.apply(_Math, (0, $6zk1M._)(((_b = (_a = image.srcSet) === null || _a === void 0 ? void 0 : _a.map(function(x) {
        return x.width;
    })) !== null && _b !== void 0 ? _b : []).concat(image.width ? [
        image.width
    ] : []).filter(Boolean))), ((_c = imageRef.current) === null || _c === void 0 ? void 0 : _c.naturalWidth) || 0);
    var maxHeight = nonInfinite((_Math1 = Math).max.apply(_Math1, (0, $6zk1M._)(((_e = (_d = image.srcSet) === null || _d === void 0 ? void 0 : _d.map(function(x) {
        return x.height;
    })) !== null && _e !== void 0 ? _e : []).concat(image.height ? [
        image.height
    ] : []).filter(Boolean))), ((_f = imageRef.current) === null || _f === void 0 ? void 0 : _f.naturalHeight) || 0);
    var defaultStyle = maxWidth && maxHeight ? {
        maxWidth: "min(".concat(maxWidth, "px, 100%)"),
        maxHeight: "min(".concat(maxHeight, "px, 100%)")
    } : {
        maxWidth: "100%",
        maxHeight: "100%"
    };
    var srcSet = (_g = image.srcSet) === null || _g === void 0 ? void 0 : _g.sort(function(a, b) {
        return a.width - b.width;
    }).map(function(item) {
        return "".concat(item.src, " ").concat(item.width, "w");
    }).join(", ");
    var estimateActualWidth = function() {
        return rect && !cover && image.width && image.height ? rect.height / image.height * image.width : Number.MAX_VALUE;
    };
    var sizes = srcSet && rect && $2e545d666ef3112d$export$fef62134eea24008() ? "".concat(Math.round(Math.min(estimateActualWidth(), rect.width)), "px") : undefined;
    var _ref = imageProps || {}, imagePropsStyle = _ref.style, imagePropsClassName = _ref.className, restImageProps = (0, $aRv4I._)(_ref, [
        "style",
        "className"
    ]);
    return $eHaBZ.createElement($eHaBZ.Fragment, null, $eHaBZ.createElement("img", (0, $9Jpjh._)((0, $lvTkn._)({
        ref: setImageRef,
        onLoad: handleOnLoad,
        onError: handleOnError,
        onClick: onClick,
        draggable: false,
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37($2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$slideImagePrefix()), cover && $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$slideImagePrefix("cover")), status !== (0, $b17a7fd270a24b50$export$a195e517d37aaa33) && $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$slideImagePrefix("loading")), imagePropsClassName),
        style: (0, $lvTkn._)({}, defaultStyle, style, imagePropsStyle)
    }, restImageProps), {
        alt: (_h = image.alt) !== null && _h !== void 0 ? _h : "",
        sizes: sizes,
        srcSet: srcSet,
        src: image.src
    })), status !== (0, $b17a7fd270a24b50$export$a195e517d37aaa33) && $eHaBZ.createElement("div", {
        className: $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$slidePrefix((0, $b17a7fd270a24b50$export$e51f1c6d74b54a13)))
    }, status === (0, $b17a7fd270a24b50$export$554a1415841c52a8) && ((render === null || render === void 0 ? void 0 : render.iconLoading) ? render.iconLoading() : $eHaBZ.createElement($2e545d666ef3112d$export$b936c55164dcf1db, {
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37($2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$c5f5ca1963fed141)), $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$slidePrefix((0, $b17a7fd270a24b50$export$554a1415841c52a8))))
    })), status === (0, $b17a7fd270a24b50$export$2ed3c80dbc178d91) && ((render === null || render === void 0 ? void 0 : render.iconError) ? render.iconError() : $eHaBZ.createElement($2e545d666ef3112d$export$19bc16ee58e19b3d, {
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37($2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$c5f5ca1963fed141)), $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$slidePrefix((0, $b17a7fd270a24b50$export$2ed3c80dbc178d91))))
    }))));
}
var $2e545d666ef3112d$export$597a6f74cf288f82 = $eHaBZ.forwardRef(function LightboxRoot(_param, ref) {
    var className = _param.className, children = _param.children, onFocus = _param.onFocus, onBlur = _param.onBlur, rest = (0, $aRv4I._)(_param, [
        "className",
        "children",
        "onFocus",
        "onBlur"
    ]);
    var nodeRef = $eHaBZ.useRef(null);
    var trackFocusWithin = $2e545d666ef3112d$export$3992c64d261ded5a().trackFocusWithin;
    return $eHaBZ.createElement($2e545d666ef3112d$export$30e869153d18a2e6, {
        nodeRef: nodeRef
    }, $eHaBZ.createElement("div", (0, $lvTkn._)({
        ref: $2e545d666ef3112d$export$ebc1e1560c2dffa5(ref, nodeRef),
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37($2e545d666ef3112d$export$1283875077dc8f0a("root"), className)
    }, trackFocusWithin(onFocus, onBlur), rest), children));
});
var $2e545d666ef3112d$export$59f0048f451fc458;
(function(SwipeState) {
    SwipeState[SwipeState["NONE"] = 0] = "NONE";
    SwipeState[SwipeState["SWIPE"] = 1] = "SWIPE";
    SwipeState[SwipeState["PULL"] = 2] = "PULL";
    SwipeState[SwipeState["ANIMATION"] = 3] = "ANIMATION";
})($2e545d666ef3112d$export$59f0048f451fc458 || ($2e545d666ef3112d$export$59f0048f451fc458 = {}));
function $2e545d666ef3112d$export$69c48c1cbbd6dc69(subscribeSensors, onPointerDown, onPointerMove, onPointerUp, disabled) {
    $eHaBZ.useEffect(function() {
        return !disabled ? $2e545d666ef3112d$export$de863c629cb9919d(subscribeSensors((0, $b17a7fd270a24b50$export$e15fc153f45a963d), onPointerDown), subscribeSensors((0, $b17a7fd270a24b50$export$1f8863949fbdd7e5), onPointerMove), subscribeSensors((0, $b17a7fd270a24b50$export$2d868b67a5791b8a), onPointerUp), subscribeSensors((0, $b17a7fd270a24b50$export$526cafa85592f1a5), onPointerUp), subscribeSensors((0, $b17a7fd270a24b50$export$22151cee048c4be9), onPointerUp)) : function() {};
    }, [
        subscribeSensors,
        onPointerDown,
        onPointerMove,
        onPointerUp,
        disabled
    ]);
}
var $2e545d666ef3112d$var$Gesture;
(function(Gesture) {
    Gesture[Gesture["NONE"] = 0] = "NONE";
    Gesture[Gesture["SWIPE"] = 1] = "SWIPE";
    Gesture[Gesture["PULL"] = 2] = "PULL";
})($2e545d666ef3112d$var$Gesture || ($2e545d666ef3112d$var$Gesture = {}));
var $2e545d666ef3112d$var$SWIPE_THRESHOLD = 30;
function $2e545d666ef3112d$export$abaee32ee49963c1(param, subscribeSensors, isSwipeValid, containerWidth, swipeAnimationDuration, onSwipeStart, onSwipeProgress, onSwipeFinish, onSwipeCancel, pullUpEnabled, pullDownEnabled, onPullStart, onPullProgress, onPullFinish, onPullCancel, onClose) {
    var disableSwipeNavigation = param.disableSwipeNavigation, closeOnBackdropClick = param.closeOnBackdropClick;
    var offset = $eHaBZ.useRef(0);
    var pointers = $eHaBZ.useRef([]);
    var activePointer = $eHaBZ.useRef(undefined);
    var startTime = $eHaBZ.useRef(0);
    var gesture = $eHaBZ.useRef($2e545d666ef3112d$var$Gesture.NONE);
    var clearPointer = $eHaBZ.useCallback(function(event) {
        var _currentPointers;
        if (activePointer.current === event.pointerId) {
            activePointer.current = undefined;
            gesture.current = $2e545d666ef3112d$var$Gesture.NONE;
        }
        var currentPointers = pointers.current;
        (_currentPointers = currentPointers).splice.apply(_currentPointers, [
            0,
            currentPointers.length
        ].concat((0, $6zk1M._)(currentPointers.filter(function(p) {
            return p.pointerId !== event.pointerId;
        }))));
    }, []);
    var addPointer = $eHaBZ.useCallback(function(event) {
        clearPointer(event);
        event.persist();
        pointers.current.push(event);
    }, [
        clearPointer
    ]);
    var lookupPointer = $eHaBZ.useCallback(function(event) {
        return pointers.current.find(function(param) {
            var pointerId = param.pointerId;
            return event.pointerId === pointerId;
        });
    }, []);
    var onPointerDown = $2e545d666ef3112d$export$ee5b5d04074a389e(function(event) {
        addPointer(event);
    });
    var exceedsPullThreshold = function(value, threshold) {
        return pullDownEnabled && value > threshold || pullUpEnabled && value < -threshold;
    };
    var onPointerUp = $2e545d666ef3112d$export$ee5b5d04074a389e(function(event) {
        var pointer = lookupPointer(event);
        if (pointer) {
            if (activePointer.current === event.pointerId) {
                var duration = Date.now() - startTime.current;
                var currentOffset = offset.current;
                if (gesture.current === $2e545d666ef3112d$var$Gesture.SWIPE) {
                    if (Math.abs(currentOffset) > 0.3 * containerWidth || Math.abs(currentOffset) > 5 && duration < swipeAnimationDuration) onSwipeFinish(currentOffset, duration);
                    else onSwipeCancel(currentOffset);
                } else if (gesture.current === $2e545d666ef3112d$var$Gesture.PULL) {
                    if (exceedsPullThreshold(currentOffset, 2 * $2e545d666ef3112d$var$SWIPE_THRESHOLD)) onPullFinish(currentOffset, duration);
                    else onPullCancel(currentOffset);
                }
                offset.current = 0;
                gesture.current = $2e545d666ef3112d$var$Gesture.NONE;
            } else {
                var target = event.target;
                if (closeOnBackdropClick && target instanceof HTMLElement && target === pointer.target && (target.classList.contains($2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$8d922915837a38d3))) || target.classList.contains($2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$ac396c284080b10c))))) onClose();
            }
        }
        clearPointer(event);
    });
    var onPointerMove = $2e545d666ef3112d$export$ee5b5d04074a389e(function(event) {
        var pointer = lookupPointer(event);
        if (pointer) {
            var isCurrentPointer = activePointer.current === event.pointerId;
            if (event.buttons === 0) {
                if (isCurrentPointer && offset.current !== 0) onPointerUp(event);
                else clearPointer(pointer);
                return;
            }
            var deltaX = event.clientX - pointer.clientX;
            var deltaY = event.clientY - pointer.clientY;
            if (activePointer.current === undefined) {
                var startGesture = function(newGesture) {
                    addPointer(event);
                    activePointer.current = event.pointerId;
                    startTime.current = Date.now();
                    gesture.current = newGesture;
                };
                if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > $2e545d666ef3112d$var$SWIPE_THRESHOLD && isSwipeValid(deltaX)) {
                    if (!disableSwipeNavigation) {
                        startGesture($2e545d666ef3112d$var$Gesture.SWIPE);
                        onSwipeStart();
                    }
                } else if (Math.abs(deltaY) > Math.abs(deltaX) && exceedsPullThreshold(deltaY, $2e545d666ef3112d$var$SWIPE_THRESHOLD)) {
                    startGesture($2e545d666ef3112d$var$Gesture.PULL);
                    onPullStart();
                }
            } else if (isCurrentPointer) {
                if (gesture.current === $2e545d666ef3112d$var$Gesture.SWIPE) {
                    offset.current = deltaX;
                    onSwipeProgress(deltaX);
                } else if (gesture.current === $2e545d666ef3112d$var$Gesture.PULL) {
                    offset.current = deltaY;
                    onPullProgress(deltaY);
                }
            }
        }
    });
    $2e545d666ef3112d$export$69c48c1cbbd6dc69(subscribeSensors, onPointerDown, onPointerMove, onPointerUp);
}
function $2e545d666ef3112d$export$145fefb2d7286388(param) {
    var preventDefaultWheelX = param.preventDefaultWheelX, preventDefaultWheelY = param.preventDefaultWheelY;
    var ref = $eHaBZ.useRef(null);
    var listener = $2e545d666ef3112d$export$ee5b5d04074a389e(function(event) {
        var horizontal = Math.abs(event.deltaX) > Math.abs(event.deltaY);
        if (horizontal && preventDefaultWheelX || !horizontal && preventDefaultWheelY || event.ctrlKey) event.preventDefault();
    });
    return $eHaBZ.useCallback(function(node) {
        var _a;
        if (node) node.addEventListener("wheel", listener, {
            passive: false
        });
        else (_a = ref.current) === null || _a === void 0 || _a.removeEventListener("wheel", listener);
        ref.current = node;
    }, [
        listener
    ]);
}
function $2e545d666ef3112d$export$10506de8b6841445(swipeState, subscribeSensors, isSwipeValid, containerWidth, swipeAnimationDuration, onSwipeStart, onSwipeProgress, onSwipeFinish, onSwipeCancel) {
    var offset = $eHaBZ.useRef(0);
    var intent = $eHaBZ.useRef(0);
    var intentCleanup = $eHaBZ.useRef(undefined);
    var resetCleanup = $eHaBZ.useRef(undefined);
    var wheelInertia = $eHaBZ.useRef(0);
    var wheelInertiaCleanup = $eHaBZ.useRef(undefined);
    var startTime = $eHaBZ.useRef(0);
    var _useTimeouts = $2e545d666ef3112d$export$1bc7162631c81b3f(), setTimeout = _useTimeouts.setTimeout, clearTimeout = _useTimeouts.clearTimeout;
    var cancelSwipeIntentCleanup = $eHaBZ.useCallback(function() {
        if (intentCleanup.current) {
            clearTimeout(intentCleanup.current);
            intentCleanup.current = undefined;
        }
    }, [
        clearTimeout
    ]);
    var cancelSwipeResetCleanup = $eHaBZ.useCallback(function() {
        if (resetCleanup.current) {
            clearTimeout(resetCleanup.current);
            resetCleanup.current = undefined;
        }
    }, [
        clearTimeout
    ]);
    var handleCleanup = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        if (swipeState !== $2e545d666ef3112d$export$59f0048f451fc458.SWIPE) {
            offset.current = 0;
            startTime.current = 0;
            cancelSwipeIntentCleanup();
            cancelSwipeResetCleanup();
        }
    });
    $eHaBZ.useEffect(handleCleanup, [
        swipeState,
        handleCleanup
    ]);
    var handleCancelSwipe = $2e545d666ef3112d$export$ee5b5d04074a389e(function(currentSwipeOffset) {
        resetCleanup.current = undefined;
        if (offset.current === currentSwipeOffset) onSwipeCancel(offset.current);
    });
    var onWheel = $2e545d666ef3112d$export$ee5b5d04074a389e(function(event) {
        if (event.ctrlKey) return;
        if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) return;
        var setWheelInertia = function(inertia) {
            wheelInertia.current = inertia;
            clearTimeout(wheelInertiaCleanup.current);
            wheelInertiaCleanup.current = inertia > 0 ? setTimeout(function() {
                wheelInertia.current = 0;
                wheelInertiaCleanup.current = undefined;
            }, 300) : undefined;
        };
        if (swipeState === $2e545d666ef3112d$export$59f0048f451fc458.NONE) {
            if (Math.abs(event.deltaX) <= 1.2 * Math.abs(wheelInertia.current)) {
                setWheelInertia(event.deltaX);
                return;
            }
            if (!isSwipeValid(-event.deltaX)) return;
            intent.current += event.deltaX;
            cancelSwipeIntentCleanup();
            if (Math.abs(intent.current) > 30) {
                intent.current = 0;
                setWheelInertia(0);
                startTime.current = Date.now();
                onSwipeStart();
            } else {
                var currentSwipeIntent = intent.current;
                intentCleanup.current = setTimeout(function() {
                    intentCleanup.current = undefined;
                    if (currentSwipeIntent === intent.current) intent.current = 0;
                }, swipeAnimationDuration);
            }
        } else if (swipeState === $2e545d666ef3112d$export$59f0048f451fc458.SWIPE) {
            var newSwipeOffset = offset.current - event.deltaX;
            newSwipeOffset = Math.min(Math.abs(newSwipeOffset), containerWidth) * Math.sign(newSwipeOffset);
            offset.current = newSwipeOffset;
            onSwipeProgress(newSwipeOffset);
            cancelSwipeResetCleanup();
            if (Math.abs(newSwipeOffset) > 0.2 * containerWidth) {
                setWheelInertia(event.deltaX);
                onSwipeFinish(newSwipeOffset, Date.now() - startTime.current);
                return;
            }
            resetCleanup.current = setTimeout(function() {
                return handleCancelSwipe(newSwipeOffset);
            }, 2 * swipeAnimationDuration);
        } else setWheelInertia(event.deltaX);
    });
    $eHaBZ.useEffect(function() {
        return subscribeSensors((0, $b17a7fd270a24b50$export$5635dc9d647242c7), onWheel);
    }, [
        subscribeSensors,
        onWheel
    ]);
}
var $2e545d666ef3112d$var$cssContainerPrefix = $2e545d666ef3112d$export$3e7cd27eed1727c("container");
var $2e545d666ef3112d$export$e92ff191b0c59550 = $eHaBZ.createContext(null);
var $2e545d666ef3112d$export$e8c786024a2b0a79 = $2e545d666ef3112d$export$aac3e49c3c8b5cb0("useController", "ControllerContext", $2e545d666ef3112d$export$e92ff191b0c59550);
function $2e545d666ef3112d$export$bd0bf19f25da8474(_param) {
    var children = _param.children, props = (0, $aRv4I._)(_param, [
        "children"
    ]);
    var _a;
    var carousel = props.carousel, animation = props.animation, controller = props.controller, on = props.on, styles = props.styles, render = props.render;
    var closeOnPullUp = controller.closeOnPullUp, closeOnPullDown = controller.closeOnPullDown, preventDefaultWheelX = controller.preventDefaultWheelX, preventDefaultWheelY = controller.preventDefaultWheelY;
    var _React_useState = (0, $21h22._)($eHaBZ.useState(), 2), toolbarWidth = _React_useState[0], setToolbarWidth = _React_useState[1];
    var state = $2e545d666ef3112d$export$566121e2bbc52eec();
    var dispatch = $2e545d666ef3112d$export$9463bb14d6ba055e();
    var _React_useState1 = (0, $21h22._)($eHaBZ.useState($2e545d666ef3112d$export$59f0048f451fc458.NONE), 2), swipeState = _React_useState1[0], setSwipeState = _React_useState1[1];
    var swipeOffset = $eHaBZ.useRef(0);
    var pullOffset = $eHaBZ.useRef(0);
    var pullOpacity = $eHaBZ.useRef(1);
    var _useSensors = $2e545d666ef3112d$export$19012f58216d597f(), registerSensors = _useSensors.registerSensors, subscribeSensors = _useSensors.subscribeSensors;
    var _useEvents = $2e545d666ef3112d$export$91a992459f6e0f07(), subscribe = _useEvents.subscribe, publish = _useEvents.publish;
    var cleanupAnimationIncrement = $2e545d666ef3112d$export$69f38700ea0cb3b9();
    var cleanupSwipeOffset = $2e545d666ef3112d$export$69f38700ea0cb3b9();
    var cleanupPullOffset = $2e545d666ef3112d$export$69f38700ea0cb3b9();
    var _useContainerRect = $2e545d666ef3112d$export$b1d85de58d38d09d(), containerRef = _useContainerRect.containerRef, setContainerRef = _useContainerRect.setContainerRef, containerRect = _useContainerRect.containerRect;
    var handleContainerRef = $2e545d666ef3112d$export$ebc1e1560c2dffa5($2e545d666ef3112d$export$145fefb2d7286388({
        preventDefaultWheelX: preventDefaultWheelX,
        preventDefaultWheelY: preventDefaultWheelY
    }), setContainerRef);
    var carouselRef = $eHaBZ.useRef(null);
    var setCarouselRef = $2e545d666ef3112d$export$ebc1e1560c2dffa5(carouselRef, undefined);
    var getOwnerDocument = $2e545d666ef3112d$export$c199d36c2862b6ed().getOwnerDocument;
    var isRTL = $2e545d666ef3112d$export$81f015b3ec5d61cf();
    var rtl = function(value) {
        return (isRTL ? -1 : 1) * (typeof value === "number" ? value : 1);
    };
    var focus = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        var _a;
        return (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    });
    var getLightboxProps = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        return props;
    });
    var getLightboxState = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        return state;
    });
    var prev = $eHaBZ.useCallback(function(params) {
        return publish((0, $b17a7fd270a24b50$export$a007161537026955), params);
    }, [
        publish
    ]);
    var next = $eHaBZ.useCallback(function(params) {
        return publish((0, $b17a7fd270a24b50$export$f1d7a854db833ed4), params);
    }, [
        publish
    ]);
    var close = $eHaBZ.useCallback(function() {
        return publish((0, $b17a7fd270a24b50$export$493a596486210a21));
    }, [
        publish
    ]);
    var isSwipeValid = function(offset) {
        return !(carousel.finite && (rtl(offset) > 0 && state.currentIndex === 0 || rtl(offset) < 0 && state.currentIndex === state.slides.length - 1));
    };
    var setSwipeOffset = function(offset) {
        var _a;
        swipeOffset.current = offset;
        (_a = containerRef.current) === null || _a === void 0 || _a.style.setProperty($2e545d666ef3112d$export$8b4981022bd80a4e("swipe_offset"), "".concat(Math.round(offset), "px"));
    };
    var setPullOffset = function(offset) {
        var _a, _b;
        pullOffset.current = offset;
        pullOpacity.current = function() {
            var threshold = 60;
            var minOpacity = 0.5;
            var offsetValue = function() {
                if (closeOnPullDown && offset > 0) return offset;
                if (closeOnPullUp && offset < 0) return -offset;
                return 0;
            }();
            return Math.min(Math.max($2e545d666ef3112d$export$2077e0241d6afd3c(1 - offsetValue / threshold * (1 - minOpacity), 2), minOpacity), 1);
        }();
        (_a = containerRef.current) === null || _a === void 0 || _a.style.setProperty($2e545d666ef3112d$export$8b4981022bd80a4e("pull_offset"), "".concat(Math.round(offset), "px"));
        (_b = containerRef.current) === null || _b === void 0 || _b.style.setProperty($2e545d666ef3112d$export$8b4981022bd80a4e("pull_opacity"), "".concat(pullOpacity.current));
    };
    var _useAnimation = $2e545d666ef3112d$export$9e2608686d4ad846(carouselRef, function(snapshot, rect, translate) {
        if (carouselRef.current && containerRect) return {
            keyframes: [
                {
                    transform: "translate(0, ".concat(snapshot.rect.y - rect.y + translate.y, "px)"),
                    opacity: snapshot.opacity
                },
                {
                    transform: "translate(0, 0)",
                    opacity: 1
                }
            ],
            duration: snapshot.duration,
            easing: animation.easing.fade
        };
        return undefined;
    }), preparePullAnimation = _useAnimation.prepareAnimation;
    var pull = function(offset, cancel) {
        if (closeOnPullUp || closeOnPullDown) {
            setPullOffset(offset);
            var duration = 0;
            if (carouselRef.current) {
                duration = animation.fade * (cancel ? 2 : 1);
                preparePullAnimation({
                    rect: carouselRef.current.getBoundingClientRect(),
                    opacity: pullOpacity.current,
                    duration: duration
                });
            }
            cleanupPullOffset(function() {
                setPullOffset(0);
                setSwipeState($2e545d666ef3112d$export$59f0048f451fc458.NONE);
            }, duration);
            setSwipeState($2e545d666ef3112d$export$59f0048f451fc458.ANIMATION);
            if (!cancel) close();
        }
    };
    var _useAnimation1 = $2e545d666ef3112d$export$9e2608686d4ad846(carouselRef, function(snapshot, rect, translate) {
        var _a;
        if (carouselRef.current && containerRect && ((_a = state.animation) === null || _a === void 0 ? void 0 : _a.duration)) {
            var parsedSpacing = $2e545d666ef3112d$export$7871fb532d320d99(carousel.spacing);
            var spacingValue = (parsedSpacing.percent ? parsedSpacing.percent * containerRect.width / 100 : parsedSpacing.pixel) || 0;
            return {
                keyframes: [
                    {
                        transform: "translate(".concat(rtl(state.globalIndex - snapshot.index) * (containerRect.width + spacingValue) + snapshot.rect.x - rect.x + translate.x, "px, 0)")
                    },
                    {
                        transform: "translate(0, 0)"
                    }
                ],
                duration: state.animation.duration,
                easing: state.animation.easing
            };
        }
        return undefined;
    }), prepareAnimation = _useAnimation1.prepareAnimation, isAnimationPlaying = _useAnimation1.isAnimationPlaying;
    var swipe = $2e545d666ef3112d$export$ee5b5d04074a389e(function(action) {
        var _a, _b;
        var currentSwipeOffset = action.offset || 0;
        var swipeDuration = !currentSwipeOffset ? (_a = animation.navigation) !== null && _a !== void 0 ? _a : animation.swipe : animation.swipe;
        var swipeEasing = !currentSwipeOffset && !isAnimationPlaying() ? animation.easing.navigation : animation.easing.swipe;
        var direction = action.direction;
        var count = (_b = action.count) !== null && _b !== void 0 ? _b : 1;
        var newSwipeState = $2e545d666ef3112d$export$59f0048f451fc458.ANIMATION;
        var newSwipeAnimationDuration = swipeDuration * count;
        if (!direction) {
            var containerWidth = containerRect === null || containerRect === void 0 ? void 0 : containerRect.width;
            var elapsedTime = action.duration || 0;
            var expectedTime = containerWidth ? swipeDuration / containerWidth * Math.abs(currentSwipeOffset) : swipeDuration;
            if (count !== 0) {
                if (elapsedTime < expectedTime) newSwipeAnimationDuration = newSwipeAnimationDuration / expectedTime * Math.max(elapsedTime, expectedTime / 5);
                else if (containerWidth) newSwipeAnimationDuration = swipeDuration / containerWidth * (containerWidth - Math.abs(currentSwipeOffset));
                direction = rtl(currentSwipeOffset) > 0 ? (0, $b17a7fd270a24b50$export$a007161537026955) : (0, $b17a7fd270a24b50$export$f1d7a854db833ed4);
            } else newSwipeAnimationDuration = swipeDuration / 2;
        }
        var increment = 0;
        if (direction === (0, $b17a7fd270a24b50$export$a007161537026955)) {
            if (isSwipeValid(rtl(1))) increment = -count;
            else {
                newSwipeState = $2e545d666ef3112d$export$59f0048f451fc458.NONE;
                newSwipeAnimationDuration = swipeDuration;
            }
        } else if (direction === (0, $b17a7fd270a24b50$export$f1d7a854db833ed4)) {
            if (isSwipeValid(rtl(-1))) increment = count;
            else {
                newSwipeState = $2e545d666ef3112d$export$59f0048f451fc458.NONE;
                newSwipeAnimationDuration = swipeDuration;
            }
        }
        newSwipeAnimationDuration = Math.round(newSwipeAnimationDuration);
        cleanupSwipeOffset(function() {
            setSwipeOffset(0);
            setSwipeState($2e545d666ef3112d$export$59f0048f451fc458.NONE);
        }, newSwipeAnimationDuration);
        if (carouselRef.current) prepareAnimation({
            rect: carouselRef.current.getBoundingClientRect(),
            index: state.globalIndex
        });
        setSwipeState(newSwipeState);
        publish((0, $b17a7fd270a24b50$export$c43bd1a4101c4078), {
            type: "swipe",
            increment: increment,
            duration: newSwipeAnimationDuration,
            easing: swipeEasing
        });
    });
    $eHaBZ.useEffect(function() {
        var _a, _b;
        if (((_a = state.animation) === null || _a === void 0 ? void 0 : _a.increment) && ((_b = state.animation) === null || _b === void 0 ? void 0 : _b.duration)) cleanupAnimationIncrement(function() {
            return dispatch({
                type: "swipe",
                increment: 0
            });
        }, state.animation.duration);
    }, [
        state.animation,
        dispatch,
        cleanupAnimationIncrement
    ]);
    var swipeParams = [
        subscribeSensors,
        isSwipeValid,
        (containerRect === null || containerRect === void 0 ? void 0 : containerRect.width) || 0,
        animation.swipe,
        function() {
            return setSwipeState($2e545d666ef3112d$export$59f0048f451fc458.SWIPE);
        },
        function(offset) {
            return setSwipeOffset(offset);
        },
        function(offset, duration) {
            return swipe({
                offset: offset,
                duration: duration,
                count: 1
            });
        },
        function(offset) {
            return swipe({
                offset: offset,
                count: 0
            });
        }
    ];
    var pullParams = [
        function() {
            if (closeOnPullDown) setSwipeState($2e545d666ef3112d$export$59f0048f451fc458.PULL);
        },
        function(offset) {
            return setPullOffset(offset);
        },
        function(offset) {
            return pull(offset);
        },
        function(offset) {
            return pull(offset, true);
        }
    ];
    $2e545d666ef3112d$export$abaee32ee49963c1.apply(void 0, [
        controller
    ].concat((0, $6zk1M._)(swipeParams), [
        closeOnPullUp,
        closeOnPullDown
    ], (0, $6zk1M._)(pullParams), [
        close
    ]));
    $2e545d666ef3112d$export$10506de8b6841445.apply(void 0, [
        swipeState
    ].concat((0, $6zk1M._)(swipeParams)));
    var focusOnMount = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        if (controller.focus && getOwnerDocument().querySelector(".".concat($2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$9d2e4856063e1a22)), " .").concat($2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssContainerPrefix())))) focus();
    });
    $eHaBZ.useEffect(focusOnMount, [
        focusOnMount
    ]);
    var onViewCallback = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        var _a;
        (_a = on.view) === null || _a === void 0 || _a.call(on, {
            index: state.currentIndex
        });
    });
    $eHaBZ.useEffect(onViewCallback, [
        state.globalIndex,
        onViewCallback
    ]);
    $eHaBZ.useEffect(function() {
        return $2e545d666ef3112d$export$de863c629cb9919d(subscribe((0, $b17a7fd270a24b50$export$a007161537026955), function(action) {
            return swipe((0, $lvTkn._)({
                direction: (0, $b17a7fd270a24b50$export$a007161537026955)
            }, action));
        }), subscribe((0, $b17a7fd270a24b50$export$f1d7a854db833ed4), function(action) {
            return swipe((0, $lvTkn._)({
                direction: (0, $b17a7fd270a24b50$export$f1d7a854db833ed4)
            }, action));
        }), subscribe((0, $b17a7fd270a24b50$export$c43bd1a4101c4078), function(action) {
            return dispatch(action);
        }));
    }, [
        subscribe,
        swipe,
        dispatch
    ]);
    var context = $eHaBZ.useMemo(function() {
        return {
            prev: prev,
            next: next,
            close: close,
            focus: focus,
            slideRect: containerRect ? $2e545d666ef3112d$export$7ff571008bce9900(containerRect, carousel.padding) : {
                width: 0,
                height: 0
            },
            containerRect: containerRect || {
                width: 0,
                height: 0
            },
            subscribeSensors: subscribeSensors,
            containerRef: containerRef,
            setCarouselRef: setCarouselRef,
            toolbarWidth: toolbarWidth,
            setToolbarWidth: setToolbarWidth
        };
    }, [
        prev,
        next,
        close,
        focus,
        subscribeSensors,
        containerRect,
        containerRef,
        setCarouselRef,
        toolbarWidth,
        setToolbarWidth,
        carousel.padding
    ]);
    $eHaBZ.useImperativeHandle(controller.ref, function() {
        return {
            prev: prev,
            next: next,
            close: close,
            focus: focus,
            getLightboxProps: getLightboxProps,
            getLightboxState: getLightboxState
        };
    }, [
        prev,
        next,
        close,
        focus,
        getLightboxProps,
        getLightboxState
    ]);
    var _obj;
    return $eHaBZ.createElement("div", (0, $lvTkn._)({
        ref: handleContainerRef,
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37($2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssContainerPrefix()), $2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$974a68ef150451f5))),
        style: (0, $lvTkn._)({}, swipeState === $2e545d666ef3112d$export$59f0048f451fc458.SWIPE ? (0, $khBmn._)({}, $2e545d666ef3112d$export$8b4981022bd80a4e("swipe_offset"), "".concat(Math.round(swipeOffset.current), "px")) : null, swipeState === $2e545d666ef3112d$export$59f0048f451fc458.PULL ? (_obj = {}, (0, $khBmn._)(_obj, $2e545d666ef3112d$export$8b4981022bd80a4e("pull_offset"), "".concat(Math.round(pullOffset.current), "px")), (0, $khBmn._)(_obj, $2e545d666ef3112d$export$8b4981022bd80a4e("pull_opacity"), "".concat(pullOpacity.current)), _obj) : null, controller.touchAction !== "none" ? (0, $khBmn._)({}, $2e545d666ef3112d$export$8b4981022bd80a4e("controller_touch_action"), controller.touchAction) : null, styles.container),
        tabIndex: -1
    }, registerSensors), containerRect && $eHaBZ.createElement($2e545d666ef3112d$export$e92ff191b0c59550.Provider, {
        value: context
    }, children, (_a = render.controls) === null || _a === void 0 ? void 0 : _a.call(render)));
}
var $2e545d666ef3112d$export$be59d34228c8ec8a = $2e545d666ef3112d$export$c5ba3739ffba980d((0, $b17a7fd270a24b50$export$b861c6f4d58b4c2f), $2e545d666ef3112d$export$bd0bf19f25da8474);
function $2e545d666ef3112d$var$cssPrefix$2(value) {
    return $2e545d666ef3112d$export$195c4126907dde97((0, $b17a7fd270a24b50$export$83fe3bee12eb51bb), value);
}
function $2e545d666ef3112d$var$cssSlidePrefix(value) {
    return $2e545d666ef3112d$export$195c4126907dde97((0, $b17a7fd270a24b50$export$8d922915837a38d3), value);
}
function $2e545d666ef3112d$var$CarouselSlide(param) {
    var slide = param.slide, offset = param.offset;
    var containerRef = $eHaBZ.useRef(null);
    var _useLightboxState = $2e545d666ef3112d$export$566121e2bbc52eec(), currentIndex = _useLightboxState.currentIndex, slides = _useLightboxState.slides;
    var _useController = $2e545d666ef3112d$export$e8c786024a2b0a79(), slideRect = _useController.slideRect, focus = _useController.focus;
    var _useLightboxProps = $2e545d666ef3112d$export$d930f3536e1c64f6(), render = _useLightboxProps.render, _useLightboxProps_carousel = _useLightboxProps.carousel, imageFit = _useLightboxProps_carousel.imageFit, imageProps = _useLightboxProps_carousel.imageProps, _useLightboxProps_on = _useLightboxProps.on, onClick = _useLightboxProps_on.click, _useLightboxProps_styles = _useLightboxProps.styles, style = _useLightboxProps_styles.slide, labels = _useLightboxProps.labels;
    var getOwnerDocument = $2e545d666ef3112d$export$c199d36c2862b6ed().getOwnerDocument;
    var offscreen = offset !== 0;
    $eHaBZ.useEffect(function() {
        var _a;
        if (offscreen && ((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(getOwnerDocument().activeElement))) focus();
    }, [
        offscreen,
        focus,
        getOwnerDocument
    ]);
    var renderSlide = function() {
        var _a, _b, _c, _d;
        var rendered = (_a = render.slide) === null || _a === void 0 ? void 0 : _a.call(render, {
            slide: slide,
            offset: offset,
            rect: slideRect
        });
        if (!rendered && $2e545d666ef3112d$export$55ec18c411514c07(slide)) rendered = $eHaBZ.createElement($2e545d666ef3112d$export$ef86b1d52c77b27b, {
            slide: slide,
            offset: offset,
            render: render,
            rect: slideRect,
            imageFit: imageFit,
            imageProps: imageProps,
            onClick: !offscreen ? function() {
                return onClick === null || onClick === void 0 ? void 0 : onClick({
                    index: currentIndex
                });
            } : undefined
        });
        return rendered ? $eHaBZ.createElement($eHaBZ.Fragment, null, (_b = render.slideHeader) === null || _b === void 0 ? void 0 : _b.call(render, {
            slide: slide
        }), ((_c = render.slideContainer) !== null && _c !== void 0 ? _c : function(param) {
            var children = param.children;
            return children;
        })({
            slide: slide,
            children: rendered
        }), (_d = render.slideFooter) === null || _d === void 0 ? void 0 : _d.call(render, {
            slide: slide
        })) : null;
    };
    return $eHaBZ.createElement("div", (0, $9Jpjh._)((0, $lvTkn._)({
        ref: containerRef,
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37($2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssSlidePrefix()), !offscreen && $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssSlidePrefix("current")), $2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$974a68ef150451f5)))
    }, $2e545d666ef3112d$export$9c64d01b28c1f747(offscreen)), {
        style: style,
        role: "group",
        "aria-roledescription": $2e545d666ef3112d$export$1c4d965eb6f65dfa(labels, "Slide"),
        "aria-label": $2e545d666ef3112d$export$77152303d9076b8(labels, slides, currentIndex + offset)
    }), renderSlide());
}
function $2e545d666ef3112d$var$Placeholder() {
    var style = $2e545d666ef3112d$export$d930f3536e1c64f6().styles.slide;
    return $eHaBZ.createElement("div", {
        className: $2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$8d922915837a38d3)),
        style: style
    });
}
function $2e545d666ef3112d$export$144901db2ea8e967(param) {
    var carousel = param.carousel, labels = param.labels;
    var _useLightboxState = $2e545d666ef3112d$export$566121e2bbc52eec(), slides = _useLightboxState.slides, currentIndex = _useLightboxState.currentIndex, globalIndex = _useLightboxState.globalIndex;
    var setCarouselRef = $2e545d666ef3112d$export$e8c786024a2b0a79().setCarouselRef;
    var _useA11yContext = $2e545d666ef3112d$export$3992c64d261ded5a(), autoPlaying = _useA11yContext.autoPlaying, focusWithin = _useA11yContext.focusWithin;
    var spacingValue = $2e545d666ef3112d$export$7871fb532d320d99(carousel.spacing);
    var paddingValue = $2e545d666ef3112d$export$7871fb532d320d99(carousel.padding);
    var preload = $2e545d666ef3112d$export$aab7f3145c728301(carousel, slides, 1);
    var items = [];
    if ($2e545d666ef3112d$export$883ece934910f98d(slides)) for(var index = currentIndex - preload; index <= currentIndex + preload; index += 1){
        var slide = $2e545d666ef3112d$export$cdfb855c5eb3bc84(slides, index);
        var key = globalIndex - currentIndex + index;
        var placeholder = carousel.finite && (index < 0 || index > slides.length - 1);
        items.push(!placeholder ? {
            key: [
                "".concat(key),
                $2e545d666ef3112d$export$b2184449b7659b5a(slide)
            ].filter(Boolean).join("|"),
            offset: index - currentIndex,
            slide: slide
        } : {
            key: key
        });
    }
    var _obj;
    return $eHaBZ.createElement("div", {
        ref: setCarouselRef,
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37($2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssPrefix$2()), items.length > 0 && $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssPrefix$2("with_slides"))),
        style: (_obj = {}, (0, $khBmn._)(_obj, "".concat($2e545d666ef3112d$export$8b4981022bd80a4e($2e545d666ef3112d$var$cssPrefix$2("slides_count"))), items.length), (0, $khBmn._)(_obj, "".concat($2e545d666ef3112d$export$8b4981022bd80a4e($2e545d666ef3112d$var$cssPrefix$2("spacing_px"))), spacingValue.pixel || 0), (0, $khBmn._)(_obj, "".concat($2e545d666ef3112d$export$8b4981022bd80a4e($2e545d666ef3112d$var$cssPrefix$2("spacing_percent"))), spacingValue.percent || 0), (0, $khBmn._)(_obj, "".concat($2e545d666ef3112d$export$8b4981022bd80a4e($2e545d666ef3112d$var$cssPrefix$2("padding_px"))), paddingValue.pixel || 0), (0, $khBmn._)(_obj, "".concat($2e545d666ef3112d$export$8b4981022bd80a4e($2e545d666ef3112d$var$cssPrefix$2("padding_percent"))), paddingValue.percent || 0), _obj),
        role: "region",
        "aria-live": autoPlaying && !focusWithin ? "off" : "polite",
        "aria-roledescription": $2e545d666ef3112d$export$1c4d965eb6f65dfa(labels, "Carousel"),
        "aria-label": $2e545d666ef3112d$export$1c4d965eb6f65dfa(labels, "Photo gallery")
    }, items.map(function(param) {
        var key = param.key, slide = param.slide, offset = param.offset;
        return slide ? $eHaBZ.createElement($2e545d666ef3112d$var$CarouselSlide, {
            key: key,
            slide: slide,
            offset: offset
        }) : $eHaBZ.createElement($2e545d666ef3112d$var$Placeholder, {
            key: key
        });
    }));
}
var $2e545d666ef3112d$export$9c087759a323a56c = $2e545d666ef3112d$export$c5ba3739ffba980d((0, $b17a7fd270a24b50$export$83fe3bee12eb51bb), $2e545d666ef3112d$export$144901db2ea8e967);
function $2e545d666ef3112d$export$e482f4662aebc4a0() {
    var carousel = $2e545d666ef3112d$export$d930f3536e1c64f6().carousel;
    var _useLightboxState = $2e545d666ef3112d$export$566121e2bbc52eec(), slides = _useLightboxState.slides, currentIndex = _useLightboxState.currentIndex;
    var prevDisabled = slides.length === 0 || carousel.finite && currentIndex === 0;
    var nextDisabled = slides.length === 0 || carousel.finite && currentIndex === slides.length - 1;
    return {
        prevDisabled: prevDisabled,
        nextDisabled: nextDisabled
    };
}
function $2e545d666ef3112d$export$4da28cf324280418(subscribeSensors) {
    var _a;
    var isRTL = $2e545d666ef3112d$export$81f015b3ec5d61cf();
    var publish = $2e545d666ef3112d$export$91a992459f6e0f07().publish;
    var animation = $2e545d666ef3112d$export$d930f3536e1c64f6().animation;
    var _useNavigationState = $2e545d666ef3112d$export$e482f4662aebc4a0(), prevDisabled = _useNavigationState.prevDisabled, nextDisabled = _useNavigationState.nextDisabled;
    var throttle = ((_a = animation.navigation) !== null && _a !== void 0 ? _a : animation.swipe) / 2;
    var prev = $2e545d666ef3112d$export$8b7b9481d6186f21(function() {
        return publish((0, $b17a7fd270a24b50$export$a007161537026955));
    }, throttle);
    var next = $2e545d666ef3112d$export$8b7b9481d6186f21(function() {
        return publish((0, $b17a7fd270a24b50$export$f1d7a854db833ed4));
    }, throttle);
    var handleKeyDown = $2e545d666ef3112d$export$ee5b5d04074a389e(function(event) {
        switch(event.key){
            case 0, $b17a7fd270a24b50$export$e8d60d9b5ceff7c0:
                publish((0, $b17a7fd270a24b50$export$493a596486210a21));
                break;
            case 0, $b17a7fd270a24b50$export$17dec1da9b0e2eb3:
                if (!(isRTL ? nextDisabled : prevDisabled)) (isRTL ? next : prev)();
                break;
            case 0, $b17a7fd270a24b50$export$91898c0e7e48903:
                if (!(isRTL ? prevDisabled : nextDisabled)) (isRTL ? prev : next)();
                break;
            default:
        }
    });
    $eHaBZ.useEffect(function() {
        return subscribeSensors((0, $b17a7fd270a24b50$export$1aba4f3521686ca9), handleKeyDown);
    }, [
        subscribeSensors,
        handleKeyDown
    ]);
}
function $2e545d666ef3112d$export$e2d1bd910e689283(param) {
    var label = param.label, icon = param.icon, renderIcon = param.renderIcon, action = param.action, onClick = param.onClick, disabled = param.disabled, style = param.style;
    return $eHaBZ.createElement($2e545d666ef3112d$export$c25acd513dcc8062, (0, $lvTkn._)({
        label: label,
        icon: icon,
        renderIcon: renderIcon,
        className: $2e545d666ef3112d$export$1283875077dc8f0a("navigation_".concat(action)),
        disabled: disabled,
        onClick: onClick,
        style: style
    }, $2e545d666ef3112d$export$2bd1c19440b9235c($2e545d666ef3112d$export$e8c786024a2b0a79().focus, disabled)));
}
function $2e545d666ef3112d$export$b8a61e5c71402559(param) {
    var _param_render = param.render, buttonPrev = _param_render.buttonPrev, buttonNext = _param_render.buttonNext, iconPrev = _param_render.iconPrev, iconNext = _param_render.iconNext, styles = param.styles;
    var _useController = $2e545d666ef3112d$export$e8c786024a2b0a79(), prev = _useController.prev, next = _useController.next, subscribeSensors = _useController.subscribeSensors;
    var _useNavigationState = $2e545d666ef3112d$export$e482f4662aebc4a0(), prevDisabled = _useNavigationState.prevDisabled, nextDisabled = _useNavigationState.nextDisabled;
    $2e545d666ef3112d$export$4da28cf324280418(subscribeSensors);
    return $eHaBZ.createElement($eHaBZ.Fragment, null, buttonPrev ? buttonPrev() : $eHaBZ.createElement($2e545d666ef3112d$export$e2d1bd910e689283, {
        label: "Previous",
        action: (0, $b17a7fd270a24b50$export$a007161537026955),
        icon: $2e545d666ef3112d$export$d05925e1c7f3f136,
        renderIcon: iconPrev,
        style: styles.navigationPrev,
        disabled: prevDisabled,
        onClick: prev
    }), buttonNext ? buttonNext() : $eHaBZ.createElement($2e545d666ef3112d$export$e2d1bd910e689283, {
        label: "Next",
        action: (0, $b17a7fd270a24b50$export$f1d7a854db833ed4),
        icon: $2e545d666ef3112d$export$3da0e0ec94bd4ce1,
        renderIcon: iconNext,
        style: styles.navigationNext,
        disabled: nextDisabled,
        onClick: next
    }));
}
var $2e545d666ef3112d$export$6c16e1ac15089858 = $2e545d666ef3112d$export$c5ba3739ffba980d((0, $b17a7fd270a24b50$export$607ce719f0ec9b98), $2e545d666ef3112d$export$b8a61e5c71402559);
var $2e545d666ef3112d$var$noScroll = $2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$b6426a00c33a0175));
var $2e545d666ef3112d$var$noScrollPadding = $2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$651541414233b476));
function $2e545d666ef3112d$var$isHTMLElement(element) {
    return "style" in element;
}
function $2e545d666ef3112d$var$padScrollbar(element, padding, rtl) {
    var styles = window.getComputedStyle(element);
    var property = rtl ? "padding-left" : "padding-right";
    var computedValue = rtl ? styles.paddingLeft : styles.paddingRight;
    var originalValue = element.style.getPropertyValue(property);
    element.style.setProperty(property, "".concat(($2e545d666ef3112d$export$5f87784a266e50a4(computedValue) || 0) + padding, "px"));
    return function() {
        if (originalValue) element.style.setProperty(property, originalValue);
        else element.style.removeProperty(property);
    };
}
function $2e545d666ef3112d$export$bbae9e931237726f(param) {
    var disabled = param.noScroll.disabled, children = param.children;
    var rtl = $2e545d666ef3112d$export$81f015b3ec5d61cf();
    var _useDocumentContext = $2e545d666ef3112d$export$c199d36c2862b6ed(), getOwnerDocument = _useDocumentContext.getOwnerDocument, getOwnerWindow = _useDocumentContext.getOwnerWindow;
    $eHaBZ.useEffect(function() {
        if (disabled) return function() {};
        var cleanup = [];
        var ownerWindow = getOwnerWindow();
        var _getOwnerDocument = getOwnerDocument(), body = _getOwnerDocument.body, documentElement = _getOwnerDocument.documentElement;
        var scrollbar = Math.round(ownerWindow.innerWidth - documentElement.clientWidth);
        if (scrollbar > 0) {
            cleanup.push($2e545d666ef3112d$var$padScrollbar(body, scrollbar, rtl));
            var elements = body.getElementsByTagName("*");
            for(var i = 0; i < elements.length; i += 1){
                var element = elements[i];
                if ($2e545d666ef3112d$var$isHTMLElement(element) && ownerWindow.getComputedStyle(element).getPropertyValue("position") === "fixed" && !element.classList.contains($2e545d666ef3112d$var$noScrollPadding)) cleanup.push($2e545d666ef3112d$var$padScrollbar(element, scrollbar, rtl));
            }
        }
        body.classList.add($2e545d666ef3112d$var$noScroll);
        return function() {
            body.classList.remove($2e545d666ef3112d$var$noScroll);
            cleanup.forEach(function(clean) {
                return clean();
            });
        };
    }, [
        rtl,
        disabled,
        getOwnerDocument,
        getOwnerWindow
    ]);
    return $eHaBZ.createElement($eHaBZ.Fragment, null, children);
}
var $2e545d666ef3112d$export$7ded5f1cd4840ad = $2e545d666ef3112d$export$c5ba3739ffba980d((0, $b17a7fd270a24b50$export$52cbc29cf5406ba8), $2e545d666ef3112d$export$bbae9e931237726f);
function $2e545d666ef3112d$var$cssPrefix$1(value) {
    return $2e545d666ef3112d$export$195c4126907dde97((0, $b17a7fd270a24b50$export$9d2e4856063e1a22), value);
}
function $2e545d666ef3112d$var$setAttribute(element, attribute, value) {
    var previousValue = element.getAttribute(attribute);
    element.setAttribute(attribute, value);
    return function() {
        if (previousValue) element.setAttribute(attribute, previousValue);
        else element.removeAttribute(attribute);
    };
}
function $2e545d666ef3112d$export$602eac185826482c(param) {
    var children = param.children, animation = param.animation, styles = param.styles, className = param.className, on = param.on, portal = param.portal, close = param.close, labels = param.labels;
    var _React_useState = (0, $21h22._)($eHaBZ.useState(false), 2), mounted = _React_useState[0], setMounted = _React_useState[1];
    var _React_useState1 = (0, $21h22._)($eHaBZ.useState(false), 2), visible = _React_useState1[0], setVisible = _React_useState1[1];
    var cleanup = $eHaBZ.useRef([]);
    var restoreFocus = $eHaBZ.useRef(null);
    var setTimeout = $2e545d666ef3112d$export$1bc7162631c81b3f().setTimeout;
    var subscribe = $2e545d666ef3112d$export$91a992459f6e0f07().subscribe;
    var reduceMotion = $2e545d666ef3112d$export$f3e625e1b2b31d60();
    var animationDuration = !reduceMotion ? animation.fade : 0;
    $eHaBZ.useEffect(function() {
        setMounted(true);
        return function() {
            setMounted(false);
            setVisible(false);
        };
    }, []);
    var handleCleanup = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        cleanup.current.forEach(function(clean) {
            return clean();
        });
        cleanup.current = [];
    });
    var handleClose = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        var _a;
        setVisible(false);
        handleCleanup();
        (_a = on.exiting) === null || _a === void 0 || _a.call(on);
        setTimeout(function() {
            var _a;
            (_a = on.exited) === null || _a === void 0 || _a.call(on);
            close();
        }, animationDuration);
    });
    $eHaBZ.useEffect(function() {
        return subscribe((0, $b17a7fd270a24b50$export$493a596486210a21), handleClose);
    }, [
        subscribe,
        handleClose
    ]);
    var handleEnter = $2e545d666ef3112d$export$ee5b5d04074a389e(function(node) {
        var _a, _b, _c;
        $2e545d666ef3112d$export$b7a864e1eaef9de5(node);
        setVisible(true);
        (_a = on.entering) === null || _a === void 0 || _a.call(on);
        var elements = (_c = (_b = node.parentNode) === null || _b === void 0 ? void 0 : _b.children) !== null && _c !== void 0 ? _c : [];
        for(var i = 0; i < elements.length; i += 1){
            var element = elements[i];
            if ([
                "TEMPLATE",
                "SCRIPT",
                "STYLE"
            ].indexOf(element.tagName) === -1 && element !== node) {
                cleanup.current.push($2e545d666ef3112d$var$setAttribute(element, "inert", ""));
                cleanup.current.push($2e545d666ef3112d$var$setAttribute(element, "aria-hidden", "true"));
            }
        }
        cleanup.current.push(function() {
            var _a, _b;
            (_b = (_a = restoreFocus.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 || _b.call(_a);
        });
        setTimeout(function() {
            var _a;
            (_a = on.entered) === null || _a === void 0 || _a.call(on);
        }, animationDuration);
    });
    var handleRef = $eHaBZ.useCallback(function(node) {
        if (node) handleEnter(node);
        else handleCleanup();
    }, [
        handleEnter,
        handleCleanup
    ]);
    return mounted ? (0, $8afcda7f6e55ccf7$exports.createPortal)($eHaBZ.createElement($2e545d666ef3112d$export$597a6f74cf288f82, {
        ref: handleRef,
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37(className, $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssPrefix$1()), $2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$651541414233b476)), visible && $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssPrefix$1("open"))),
        "aria-modal": true,
        role: "dialog",
        "aria-label": $2e545d666ef3112d$export$1c4d965eb6f65dfa(labels, "Lightbox"),
        style: (0, $lvTkn._)({}, animation.fade !== $2e545d666ef3112d$export$d626463445cef3e9.animation.fade ? (0, $khBmn._)({}, $2e545d666ef3112d$export$8b4981022bd80a4e("fade_animation_duration"), "".concat(animationDuration, "ms")) : null, animation.easing.fade !== $2e545d666ef3112d$export$d626463445cef3e9.animation.easing.fade ? (0, $khBmn._)({}, $2e545d666ef3112d$export$8b4981022bd80a4e("fade_animation_timing_function"), animation.easing.fade) : null, styles.root),
        onFocus: function(event) {
            if (!restoreFocus.current) restoreFocus.current = event.relatedTarget;
        }
    }, children), portal.root || document.body) : null;
}
var $2e545d666ef3112d$export$f2a0761442face5c = $2e545d666ef3112d$export$c5ba3739ffba980d((0, $b17a7fd270a24b50$export$9d2e4856063e1a22), $2e545d666ef3112d$export$602eac185826482c);
function $2e545d666ef3112d$export$be92b6f5f03c0fe9(param) {
    var children = param.children;
    return $eHaBZ.createElement($eHaBZ.Fragment, null, children);
}
var $2e545d666ef3112d$export$fa1081225b99a9f2 = $2e545d666ef3112d$export$c5ba3739ffba980d((0, $b17a7fd270a24b50$export$62f3c66ae8dab8a3), $2e545d666ef3112d$export$be92b6f5f03c0fe9);
function $2e545d666ef3112d$var$cssPrefix(value) {
    return $2e545d666ef3112d$export$195c4126907dde97((0, $b17a7fd270a24b50$export$5414719b40b8294f), value);
}
function $2e545d666ef3112d$export$4c260019440d418f(param) {
    var buttons = param.toolbar.buttons, _param_render = param.render, buttonClose = _param_render.buttonClose, iconClose = _param_render.iconClose, styles = param.styles;
    var _useController = $2e545d666ef3112d$export$e8c786024a2b0a79(), close = _useController.close, setToolbarWidth = _useController.setToolbarWidth;
    var _useContainerRect = $2e545d666ef3112d$export$b1d85de58d38d09d(), setContainerRef = _useContainerRect.setContainerRef, containerRect = _useContainerRect.containerRect;
    $2e545d666ef3112d$export$e5c5a5f917a5871c(function() {
        setToolbarWidth(containerRect === null || containerRect === void 0 ? void 0 : containerRect.width);
    }, [
        setToolbarWidth,
        containerRect === null || containerRect === void 0 ? void 0 : containerRect.width
    ]);
    var renderCloseButton = function() {
        if (buttonClose) return buttonClose();
        return $eHaBZ.createElement($2e545d666ef3112d$export$c25acd513dcc8062, {
            key: (0, $b17a7fd270a24b50$export$493a596486210a21),
            label: "Close",
            icon: $2e545d666ef3112d$export$cae179f078f4b4a4,
            renderIcon: iconClose,
            onClick: close
        });
    };
    return $eHaBZ.createElement("div", {
        ref: setContainerRef,
        style: styles.toolbar,
        className: $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssPrefix())
    }, buttons === null || buttons === void 0 ? void 0 : buttons.map(function(button) {
        return button === (0, $b17a7fd270a24b50$export$493a596486210a21) ? renderCloseButton() : button;
    }));
}
var $2e545d666ef3112d$export$d0a9743c06e42ce8 = $2e545d666ef3112d$export$c5ba3739ffba980d((0, $b17a7fd270a24b50$export$5414719b40b8294f), $2e545d666ef3112d$export$4c260019440d418f);
function $2e545d666ef3112d$var$renderNode(node, props) {
    var _a;
    return $eHaBZ.createElement(node.module.component, (0, $lvTkn._)({
        key: node.module.name
    }, props), (_a = node.children) === null || _a === void 0 ? void 0 : _a.map(function(child) {
        return $2e545d666ef3112d$var$renderNode(child, props);
    }));
}
function $2e545d666ef3112d$var$mergeAnimation(defaultAnimation) {
    var animation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var defaultAnimationEasing = defaultAnimation.easing, restDefaultAnimation = (0, $aRv4I._)(defaultAnimation, [
        "easing"
    ]);
    var easing = animation.easing, restAnimation = (0, $aRv4I._)(animation, [
        "easing"
    ]);
    return (0, $lvTkn._)({
        easing: (0, $lvTkn._)({}, defaultAnimationEasing, easing)
    }, restDefaultAnimation, restAnimation);
}
function $2e545d666ef3112d$export$7d2670a66155874b(_param) {
    var carousel = _param.carousel, animation = _param.animation, render = _param.render, toolbar = _param.toolbar, controller = _param.controller, noScroll = _param.noScroll, on = _param.on, plugins = _param.plugins, slides = _param.slides, index = _param.index, restProps = (0, $aRv4I._)(_param, [
        "carousel",
        "animation",
        "render",
        "toolbar",
        "controller",
        "noScroll",
        "on",
        "plugins",
        "slides",
        "index"
    ]);
    var defaultAnimation = $2e545d666ef3112d$export$d626463445cef3e9.animation, defaultCarousel = $2e545d666ef3112d$export$d626463445cef3e9.carousel, defaultRender = $2e545d666ef3112d$export$d626463445cef3e9.render, defaultToolbar = $2e545d666ef3112d$export$d626463445cef3e9.toolbar, defaultController = $2e545d666ef3112d$export$d626463445cef3e9.controller, defaultNoScroll = $2e545d666ef3112d$export$d626463445cef3e9.noScroll, defaultOn = $2e545d666ef3112d$export$d626463445cef3e9.on, defaultSlides = $2e545d666ef3112d$export$d626463445cef3e9.slides, defaultIndex = $2e545d666ef3112d$export$d626463445cef3e9.index, defaultPlugins = $2e545d666ef3112d$export$d626463445cef3e9.plugins, restDefaultProps = (0, $aRv4I._)($2e545d666ef3112d$export$d626463445cef3e9, [
        "animation",
        "carousel",
        "render",
        "toolbar",
        "controller",
        "noScroll",
        "on",
        "slides",
        "index",
        "plugins"
    ]);
    var _withPlugins = $2e545d666ef3112d$export$bc996c07eb970c78([
        $2e545d666ef3112d$export$270e7ba5936d3c48($2e545d666ef3112d$export$f2a0761442face5c, [
            $2e545d666ef3112d$export$270e7ba5936d3c48($2e545d666ef3112d$export$7ded5f1cd4840ad, [
                $2e545d666ef3112d$export$270e7ba5936d3c48($2e545d666ef3112d$export$be59d34228c8ec8a, [
                    $2e545d666ef3112d$export$270e7ba5936d3c48($2e545d666ef3112d$export$9c087759a323a56c),
                    $2e545d666ef3112d$export$270e7ba5936d3c48($2e545d666ef3112d$export$d0a9743c06e42ce8),
                    $2e545d666ef3112d$export$270e7ba5936d3c48($2e545d666ef3112d$export$6c16e1ac15089858)
                ])
            ])
        ])
    ], plugins || defaultPlugins), config = _withPlugins.config, augmentation = _withPlugins.augmentation;
    var props = augmentation((0, $lvTkn._)({
        animation: $2e545d666ef3112d$var$mergeAnimation(defaultAnimation, animation),
        carousel: (0, $lvTkn._)({}, defaultCarousel, carousel),
        render: (0, $lvTkn._)({}, defaultRender, render),
        toolbar: (0, $lvTkn._)({}, defaultToolbar, toolbar),
        controller: (0, $lvTkn._)({}, defaultController, controller),
        noScroll: (0, $lvTkn._)({}, defaultNoScroll, noScroll),
        on: (0, $lvTkn._)({}, defaultOn, on)
    }, restDefaultProps, restProps));
    if (!props.open) return null;
    return $eHaBZ.createElement($2e545d666ef3112d$export$7141a340a3dea601, (0, $lvTkn._)({}, props), $eHaBZ.createElement($2e545d666ef3112d$export$62d2e1d2e7609988, {
        slides: slides || defaultSlides,
        index: $2e545d666ef3112d$export$5f87784a266e50a4(index || defaultIndex)
    }, $eHaBZ.createElement($2e545d666ef3112d$export$9d9954f5885fa393, null, $eHaBZ.createElement($2e545d666ef3112d$export$686accdd53ac150f, null, $eHaBZ.createElement($2e545d666ef3112d$export$e41a845d3e53ea09, null, $2e545d666ef3112d$var$renderNode($2e545d666ef3112d$export$270e7ba5936d3c48($2e545d666ef3112d$export$fa1081225b99a9f2, config), props))))));
}


// TODO: do the search highlights client-side
function $bfe6f4dc29c37278$var$reHighlight(text) {
    return text.split(/<span class="found">(.+?)<\/span>/).map(function(n, i) {
        return i % 2 == 0 ? n : /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
            className: "found",
            children: n
        }, i);
    });
}
function $bfe6f4dc29c37278$var$setupLightbox(param) {
    var element = param.element, setSlides = param.setSlides, setSelectedPhotoIndex = param.setSelectedPhotoIndex;
    var images = element.querySelectorAll('a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"], a[href$=".jpg:large"], a[href$=".jpeg:large"], a[href$=".png:large"], a[href$=".gif:large"]');
    setSlides(Array.from(images).map(function(link, index) {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            setSelectedPhotoIndex(index);
        });
        return {
            src: link.getAttribute('href')
        };
    }));
}
function $bfe6f4dc29c37278$var$stopPropagation(event) {
    event.stopPropagation();
}
function $bfe6f4dc29c37278$var$forceLoadImages(content) {
    content.querySelectorAll('img').forEach(function(img) {
        img.setAttribute('src', img.getAttribute('data-selfoss-src'));
    });
}
// React will prevent the default action when it bubbles to our callbacks.
// Let’s stop bubbling for links.
// https://medium.com/peloton-engineering/onclick-wat-51331718ba9
function $bfe6f4dc29c37278$var$fixLinkBubbling(content) {
    content.querySelectorAll('a').forEach(function(a) {
        a.addEventListener('click', function(event) {
            event.stopPropagation();
        });
    });
}
// Prevent passing referrer info when opening a link.
function $bfe6f4dc29c37278$var$sanitizeContent(content) {
    content.querySelectorAll('a').forEach(function(a) {
        var oldRel = a.getAttribute('rel');
        a.setAttribute('rel', 'noreferrer' + (oldRel ? ' ' + oldRel : ''));
        // Ensure links inside item content are opened in new tab/window.
        a.setAttribute('target', '_blank');
    });
}
function $bfe6f4dc29c37278$var$handleKeyUp(event) {
    // emulate clicking when using keyboard
    if (event.keyCode === 13) {
        // ENTER key
        event.target.click();
        event.preventDefault();
        event.stopPropagation();
    }
}
function $bfe6f4dc29c37278$var$preventDefaultOnSmartphone(event) {
    // We want to use the whole title as action for opening/closing items
    // and smartphones have separate buttons for opening the article anyway.
    if (selfoss.isSmartphone()) event.preventDefault();
}
// Handle closing fullscreen on mobile
function $bfe6f4dc29c37278$var$closeFullScreen(param) {
    var event = param.event, navigate = param.navigate, location = param.location, entryId = param.entryId;
    event.preventDefault();
    event.stopPropagation();
    selfoss.entriesPage.setEntryExpanded(entryId, false);
    navigate((0, $0be080af3052783c$export$7f0beea2aa79e4fa)(location, {
        id: null
    }), {
        replace: true
    });
}
// show/hide entry
function $bfe6f4dc29c37278$var$handleClick(param) {
    var event = param.event, navigate = param.navigate, location = param.location, expanded = param.expanded, id = param.id, target = param.target;
    var expected = selfoss.isMobile() ? '.entry' : '.entry-title';
    if (target !== expected) return;
    event.preventDefault();
    event.stopPropagation();
    if (expanded) {
        selfoss.entriesPage.setSelectedEntry(id);
        selfoss.entriesPage.deactivateEntry(id);
        navigate((0, $0be080af3052783c$export$7f0beea2aa79e4fa)(location, {
            id: null
        }), {
            replace: true
        });
    } else {
        selfoss.entriesPage.activateEntry(id);
        navigate((0, $0be080af3052783c$export$7f0beea2aa79e4fa)(location, {
            id: id
        }), {
            replace: true
        });
    }
}
// load images
function $bfe6f4dc29c37278$var$loadImages(param) {
    var event = param.event, setImagesLoaded = param.setImagesLoaded, contentBlock = param.contentBlock;
    event.preventDefault();
    event.stopPropagation();
    $bfe6f4dc29c37278$var$forceLoadImages(contentBlock.current);
    setImagesLoaded(true);
}
// next item on tablet and smartphone
function $bfe6f4dc29c37278$var$openNext(event) {
    event.preventDefault();
    event.stopPropagation();
    // TODO: Figure out why it does not work when run immediately.
    requestAnimationFrame(function() {
        var _selfoss_entriesPage;
        (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.nextPrev((0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).NEXT, true);
    });
}
function $bfe6f4dc29c37278$var$ShareButton(param) {
    var label = param.label, icon = param.icon, item = param.item, action = param.action, _param_showLabel = param.showLabel, showLabel = _param_showLabel === void 0 ? true : _param_showLabel;
    var shareOnClick = (0, $eHaBZ.useCallback)(function(event) {
        event.preventDefault();
        event.stopPropagation();
        action({
            id: item.id,
            url: item.link,
            // TODO: remove HTML
            title: item.title
        });
    }, [
        item,
        action
    ]);
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
        type: "button",
        className: "entry-share",
        title: label,
        "aria-label": label,
        onClick: shareOnClick,
        children: [
            icon,
            " ",
            showLabel ? label : null
        ]
    });
}
$bfe6f4dc29c37278$var$ShareButton.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string.isRequired,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).element
    ]).isRequired,
    item: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    action: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    showLabel: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool
};
function $bfe6f4dc29c37278$var$ItemTag(param) {
    var tag = param.tag, color = param.color;
    var style = (0, $eHaBZ.useMemo)(function() {
        return {
            color: color.foreColor,
            backgroundColor: color.backColor
        };
    }, [
        color
    ]);
    var location = (0, $5XYIU.useLocation)();
    var link = (0, $eHaBZ.useMemo)(function() {
        return (0, $0be080af3052783c$export$d0bb2ab5375d1521)(location, {
            category: "tag-".concat(tag),
            id: null
        });
    }, [
        tag,
        location
    ]);
    var forceReload = (0, $0be080af3052783c$export$6bccca1b7088ecd7)();
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $5XYIU.Link), {
        className: "entry-tags-tag",
        style: style,
        to: link,
        onClick: $bfe6f4dc29c37278$var$preventDefaultOnSmartphone,
        state: forceReload,
        children: tag
    });
}
$bfe6f4dc29c37278$var$ItemTag.propTypes = {
    tag: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired
};
/**
 * Converts Date to a relative string.
 * When the date is too old, null is returned instead.
 * @param {Date} currentTime
 * @param {Date} datetime
 * @return {?String} relative time reference
 */ function $bfe6f4dc29c37278$var$datetimeRelative(currentTime, datetime) {
    var ageInseconds = (currentTime - datetime) / 1000;
    var ageInMinutes = ageInseconds / 60;
    var ageInHours = ageInMinutes / 60;
    var ageInDays = ageInHours / 24;
    if (ageInHours < 1) return selfoss.app._('minutes', [
        Math.round(ageInMinutes)
    ]);
    else if (ageInDays < 1) return selfoss.app._('hours', [
        Math.round(ageInHours)
    ]);
    else return null;
}
function $bfe6f4dc29c37278$export$2e2bcd8739ae039(param) {
    var currentTime = param.currentTime, item = param.item, selected = param.selected, expanded = param.expanded, setNavExpanded = param.setNavExpanded;
    var title = item.title, author = item.author, sourcetitle = item.sourcetitle;
    var configuration = (0, $eHaBZ.useContext)((0, $94046e75c3010f4f$export$326f6d1b69f1c06e));
    var shouldAutoLoadImages = !selfoss.isMobile() || configuration.loadImagesOnMobile;
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(shouldAutoLoadImages), 2), imagesLoaded = _useState[0], setImagesLoaded = _useState[1];
    var contentBlock = (0, $eHaBZ.useRef)(null);
    var location = (0, $5XYIU.useLocation)();
    var navigate = (0, $5XYIU.useNavigate)();
    var relDate = (0, $eHaBZ.useMemo)(function() {
        return $bfe6f4dc29c37278$var$datetimeRelative(currentTime, item.datetime);
    }, [
        currentTime,
        item.datetime
    ]);
    var previouslyExpanded = (0, $c020e53fc27b31fb$export$f6f3f74729fdd0b7)(expanded);
    var _useState1 = (0, $21h22._)((0, $eHaBZ.useState)([]), 2), slides = _useState1[0], setSlides = _useState1[1];
    var _useState2 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), selectedPhotoIndex = _useState2[0], setSelectedPhotoIndex = _useState2[1];
    var fullScreenTrap = (0, $eHaBZ.useRef)(null);
    // This should match scenarios where fullScreenTrap is set.
    var usingFocusTrap = expanded && selfoss.isSmartphone();
    (0, $eHaBZ.useEffect)(function() {
        // Handle entry becoming/ceasing to be expanded.
        var parent = document.querySelector('.entry[data-entry-id="'.concat(item.id, '"]'));
        if (expanded) {
            var firstExpansion = contentBlock.current.childElementCount === 0;
            if (firstExpansion) {
                contentBlock.current.innerHTML = item.content;
                $bfe6f4dc29c37278$var$sanitizeContent(contentBlock.current);
                selfoss.extensionPoints.processItemContents(contentBlock.current);
                // load images not on mobile devices
                if (shouldAutoLoadImages) $bfe6f4dc29c37278$var$forceLoadImages(contentBlock.current);
            }
            if (selfoss.isSmartphone()) {
                // save scroll position
                var scrollTop = window.scrollY;
                setNavExpanded(function(expanded) {
                    // hide nav
                    if (expanded) {
                        scrollTop = scrollTop - document.querySelector('#nav').getBoundingClientRect().height;
                        scrollTop = scrollTop < 0 ? 0 : scrollTop;
                        window.scrollTo({
                            top: scrollTop
                        });
                        return false;
                    }
                    return expanded;
                });
                // show fullscreen
                document.body.classList.add('fullscreen-mode');
                var trap = (0, $197853feae65c1a7$export$360440dfcba94c00)(parent);
                fullScreenTrap.current = trap;
                trap.activate();
                if (firstExpansion) $bfe6f4dc29c37278$var$fixLinkBubbling(contentBlock.current);
            } else {
                if (firstExpansion) // setup fancyBox image viewer
                $bfe6f4dc29c37278$var$setupLightbox({
                    element: contentBlock.current,
                    setSlides: setSlides,
                    setSelectedPhotoIndex: setSelectedPhotoIndex
                });
                // scroll to article header
                if (configuration.scrollToArticleHeader) parent.scrollIntoView();
                if (firstExpansion) // turn of column view if entry is too long
                requestAnimationFrame(function() {
                    // Delayed into next frame so that the entry is expanded when the height is being determined.
                    if (contentBlock.current.getBoundingClientRect().height > document.body.clientHeight) contentBlock.current.parentNode.classList.add('entry-content-nocolumns');
                });
            }
        } else {
            // No longer expanded.
            if (fullScreenTrap.current !== null) {
                fullScreenTrap.current.deactivate();
                fullScreenTrap.current = null;
            }
            document.body.classList.remove('fullscreen-mode');
        }
    }, [
        configuration,
        expanded,
        item.content,
        item.id,
        setNavExpanded
    ]);
    (0, $eHaBZ.useEffect)(function() {
        // Handle autoHideReadOnMobile setting.
        if (selfoss.isSmartphone() && !expanded && previouslyExpanded) {
            var autoHideReadOnMobile = configuration.autoHideReadOnMobile && item.unread == 1;
            if (autoHideReadOnMobile && item.unread != 1) selfoss.entriesPage.setEntries(function(entries) {
                return entries.filter(function(param) {
                    var id = param.id;
                    return id !== item.id;
                });
            });
        }
    }, [
        configuration,
        expanded,
        item.id,
        item.unread,
        previouslyExpanded
    ]);
    var entryOnClick = (0, $eHaBZ.useCallback)(function(event) {
        return $bfe6f4dc29c37278$var$handleClick({
            event: event,
            navigate: navigate,
            location: location,
            expanded: expanded,
            id: item.id,
            target: '.entry'
        });
    }, [
        navigate,
        location,
        expanded,
        item.id
    ]);
    var titleOnClick = (0, $eHaBZ.useCallback)(function(event) {
        return $bfe6f4dc29c37278$var$handleClick({
            event: event,
            navigate: navigate,
            location: location,
            expanded: expanded,
            id: item.id,
            target: '.entry-title'
        });
    }, [
        navigate,
        location,
        expanded,
        item.id
    ]);
    var starOnClick = (0, $eHaBZ.useCallback)(function(event) {
        event.preventDefault();
        event.stopPropagation();
        selfoss.entriesPage.markEntryStarred(item.id, item.starred != 1);
    }, [
        item
    ]);
    var markReadOnClick = (0, $eHaBZ.useCallback)(function(event) {
        event.preventDefault();
        event.stopPropagation();
        selfoss.entriesPage.markEntryRead(item.id, item.unread == 1);
    }, [
        item
    ]);
    var loadImagesOnClick = (0, $eHaBZ.useCallback)(function(event) {
        return $bfe6f4dc29c37278$var$loadImages({
            event: event,
            setImagesLoaded: setImagesLoaded,
            contentBlock: contentBlock
        });
    }, []);
    var closeOnClick = (0, $eHaBZ.useCallback)(function(event) {
        return $bfe6f4dc29c37278$var$closeFullScreen({
            event: event,
            navigate: navigate,
            location: location,
            entryId: item.id
        });
    }, [
        navigate,
        location,
        item.id
    ]);
    var titleHtml = (0, $eHaBZ.useMemo)(function() {
        return {
            __html: title ? title : selfoss.app._('no_title')
        };
    }, [
        title
    ]);
    var sourceLink = (0, $eHaBZ.useMemo)(function() {
        return (0, $0be080af3052783c$export$d0bb2ab5375d1521)(location, {
            category: "source-".concat(item.source),
            id: null
        });
    }, [
        item.source,
        location
    ]);
    var forceReload = (0, $0be080af3052783c$export$6bccca1b7088ecd7)();
    var canWrite = (0, $bd320d0e16baa5f3$export$b416b77cd328c02f)();
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    var sharers = (0, $8ee8a2a1e50ded87$export$aebedbd51beb48eb)({
        configuration: configuration,
        _: _
    });
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
        "data-entry-id": item.id,
        "data-entry-source": item.source,
        "data-entry-url": item.link,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
            entry: true,
            unread: item.unread == 1,
            expanded: expanded,
            selected: selected
        }),
        role: "article",
        "aria-modal": usingFocusTrap,
        onClick: entryOnClick,
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("a", {
                href: item.link,
                className: "entry-icon",
                tabIndex: "-1",
                rel: "noreferrer",
                "aria-hidden": "true",
                onClick: $bfe6f4dc29c37278$var$preventDefaultOnSmartphone,
                children: item.icon !== null && item.icon.trim().length > 0 && item.icon != '0' ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("img", {
                    src: "favicons/".concat(item.icon),
                    "aria-hidden": "true",
                    alt: ""
                }) : null
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("h3", {
                className: "entry-title",
                onClick: titleOnClick,
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                    className: "entry-title-link",
                    "aria-expanded": expanded,
                    "aria-current": selected,
                    role: "link",
                    tabIndex: "0",
                    onKeyUp: $bfe6f4dc29c37278$var$handleKeyUp,
                    dangerouslySetInnerHTML: titleHtml
                })
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                className: "entry-tags",
                children: Object.entries(item.tags).map(function(param) {
                    var _param = (0, $21h22._)(param, 2), tag = _param[0], color = _param[1];
                    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($bfe6f4dc29c37278$var$ItemTag, {
                        tag: tag,
                        color: color
                    }, tag);
                })
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $5XYIU.Link), {
                className: "entry-source",
                to: sourceLink,
                onClick: $bfe6f4dc29c37278$var$preventDefaultOnSmartphone,
                state: forceReload,
                children: $bfe6f4dc29c37278$var$reHighlight(sourcetitle)
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                className: "entry-separator",
                children: "\u2022"
            }),
            author !== null ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "entry-author",
                        children: author
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "entry-separator",
                        children: "\u2022"
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("a", {
                href: item.link,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                    'entry-datetime': true,
                    timestamped: relDate === null
                }),
                target: "_blank",
                rel: "noreferrer",
                onClick: $bfe6f4dc29c37278$var$preventDefaultOnSmartphone,
                children: relDate !== null ? relDate : item.datetime.toLocaleString()
            }),
            configuration.readingSpeed !== null ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "entry-separator",
                        children: "\u2022"
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "entry-readtime",
                        children: _('article_reading_time', [
                            Math.round(item.wordCount / configuration.readingSpeed)
                        ])
                    })
                ]
            }) : null,
            item.thumbnail && item.thumbnail.trim().length > 0 ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                    'entry-thumbnail': true,
                    'entry-thumbnail-always-visible': configuration.showThumbnails
                }),
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("a", {
                    href: item.link,
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("img", {
                        src: "thumbnails/".concat(item.thumbnail),
                        alt: item.strippedTitle
                    })
                })
            }) : null,
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                    'entry-content': true,
                    'entry-content-nocolumns': item.lengthWithoutTags < 500
                }),
                children: [
                    slides.length !== 0 && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2e545d666ef3112d$export$7d2670a66155874b), {
                        open: selectedPhotoIndex !== null,
                        index: selectedPhotoIndex,
                        close: function() {
                            return setSelectedPhotoIndex(null);
                        },
                        carousel: {
                            finite: true
                        },
                        controller: {
                            closeOnBackdropClick: true
                        },
                        on: {
                            entered: function() {
                                return selfoss.lightboxActive.update(true);
                            },
                            exited: function() {
                                return selfoss.lightboxActive.update(false);
                            }
                        },
                        slides: slides
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                        ref: contentBlock
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                        className: "entry-smartphone-share",
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", {
                            "aria-label": _('article_actions'),
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("a", {
                                        href: item.link,
                                        className: "entry-newwindow",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        accessKey: "o",
                                        onClick: $bfe6f4dc29c37278$var$stopPropagation,
                                        children: [
                                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                                                icon: $38e96a2b42b175e8$exports.faExternalLinkAlt
                                            }),
                                            ' ',
                                            _('open_window')
                                        ]
                                    })
                                }),
                                sharers.map(function(param) {
                                    var key = param.key, label = param.label, icon = param.icon, action = param.action;
                                    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($bfe6f4dc29c37278$var$ShareButton, {
                                            label: label,
                                            icon: icon,
                                            item: item,
                                            action: action
                                        })
                                    }, key);
                                }),
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                                        type: "button",
                                        accessKey: "n",
                                        className: "entry-next",
                                        onClick: $bfe6f4dc29c37278$var$openNext,
                                        children: [
                                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                                                icon: $67e9658d0f6c3ae3$exports.faArrowRight
                                            }),
                                            ' ',
                                            _('next')
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", {
                "aria-label": _('article_actions'),
                className: "entry-toolbar",
                children: [
                    canWrite && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                            accessKey: "a",
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                'entry-starr': true,
                                active: item.starred == 1
                            }),
                            onClick: starOnClick,
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                                    icon: item.starred == 1 ? $4e5ab4d00c078f68$exports.faStar : $de3818063bbfedbe$exports.faStar
                                }),
                                ' ',
                                item.starred == 1 ? _('unstar') : _('star')
                            ]
                        })
                    }),
                    canWrite && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                            accessKey: "u",
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                'entry-unread': true,
                                active: item.unread == 1
                            }),
                            onClick: markReadOnClick,
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                                    icon: item.unread == 1 ? $7214b407105f2291$exports.faCheckCircle : $60c3775e24ebf896$exports.faCheckCircle
                                }),
                                ' ',
                                item.unread == 1 ? _('mark') : _('unmark')
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("a", {
                            href: item.link,
                            className: "entry-newwindow",
                            target: "_blank",
                            rel: "noreferrer",
                            accessKey: "o",
                            onClick: $bfe6f4dc29c37278$var$stopPropagation,
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                                    icon: $38e96a2b42b175e8$exports.faExternalLinkAlt
                                }),
                                ' ',
                                _('open_window')
                            ]
                        })
                    }),
                    !imagesLoaded ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                            className: "entry-loadimages",
                            onClick: loadImagesOnClick,
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                                    icon: $7417e626c64fb3c5$exports.faArrowAltCircleDown
                                }),
                                ' ',
                                _('load_img')
                            ]
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                            type: "button",
                            accessKey: "n",
                            className: "entry-next",
                            onClick: $bfe6f4dc29c37278$var$openNext,
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                                    icon: $67e9658d0f6c3ae3$exports.faArrowRight
                                }),
                                " ",
                                _('next')
                            ]
                        })
                    }),
                    sharers.map(function(param) {
                        var key = param.key, label = param.label, icon = param.icon, action = param.action;
                        return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($bfe6f4dc29c37278$var$ShareButton, {
                                label: label,
                                icon: icon,
                                item: item,
                                action: action,
                                showLabel: false
                            })
                        }, key);
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                            accessKey: "c",
                            className: "entry-close",
                            onClick: closeOnClick,
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                                    icon: $ea95ad8a568dd277$exports.faTimesCircle
                                }),
                                ' ',
                                _('close_entry')
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
$bfe6f4dc29c37278$export$2e2bcd8739ae039.propTypes = {
    currentTime: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).instanceOf(Date).isRequired,
    item: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    selected: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    expanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};




var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");


function $8ef3cedac61156e9$var$safeDate(datetimeString) {
    var date = new Date(datetimeString);
    if (isNaN(date.valueOf())) throw new Error("Invalid date detected: \u201C".concat(datetimeString, "\u201D"));
    else return date;
}
function $8ef3cedac61156e9$export$8ce663b0c6b2535e(ids) {
    return $32ae13b741542474$export$299ba2dee77727e9('mark', {
        headers: {
            'content-type': 'application/json; charset=utf-8'
        },
        body: JSON.stringify(ids)
    }).promise.then(function(response) {
        return response.json();
    });
}
function $8ef3cedac61156e9$export$d11ee7cd6d3f95d4(id, starr) {
    return $32ae13b741542474$export$299ba2dee77727e9("".concat(starr ? 'starr' : 'unstarr', "/").concat(id)).promise;
}
function $8ef3cedac61156e9$export$bf7f2fce5c1cf636(id, read) {
    return $32ae13b741542474$export$299ba2dee77727e9("".concat(read ? 'unmark' : 'mark', "/").concat(id)).promise;
}
/**
 * Converts some values like dates in an entry into a objects.
 */ function $8ef3cedac61156e9$var$enrichEntry(entry) {
    return (0, $9Jpjh._)((0, $lvTkn._)({}, entry), {
        link: (0, $4c0cf5d996e33977$export$e8bacd2802a88316)(entry.link),
        datetime: $8ef3cedac61156e9$var$safeDate(entry.datetime),
        updatetime: entry.updatetime ? $8ef3cedac61156e9$var$safeDate(entry.updatetime) : entry.updatetime
    });
}
/**
 * Converts some values like dates in response into a objects.
 */ function $8ef3cedac61156e9$var$enrichItemsResponse(data) {
    var _data_entries, _data_newItems;
    return (0, $9Jpjh._)((0, $lvTkn._)({}, data), {
        lastUpdate: data.lastUpdate ? $8ef3cedac61156e9$var$safeDate(data.lastUpdate) : data.lastUpdate,
        // in getItems
        entries: (_data_entries = data.entries) === null || _data_entries === void 0 ? void 0 : _data_entries.map($8ef3cedac61156e9$var$enrichEntry),
        // in sync
        newItems: (_data_newItems = data.newItems) === null || _data_newItems === void 0 ? void 0 : _data_newItems.map($8ef3cedac61156e9$var$enrichEntry)
    });
}
function $8ef3cedac61156e9$export$d2f92acf417bbf5d(filter, abortController) {
    return $32ae13b741542474$export$3988ae62b71be9a3('', {
        body: $32ae13b741542474$export$92871f7982deaf9f((0, $9Jpjh._)((0, $lvTkn._)({}, filter), {
            fromDatetime: filter.fromDatetime ? filter.fromDatetime.toISOString() : filter.fromDatetime
        })),
        abortController: abortController
    }).promise.then(function(response) {
        return response.json();
    }).then($8ef3cedac61156e9$var$enrichItemsResponse);
}
function $8ef3cedac61156e9$export$92d6409d68f0739a(updatedStatuses, syncParams) {
    var params = (0, $9Jpjh._)((0, $lvTkn._)({}, syncParams), {
        updatedStatuses: syncParams.updatedStatuses ? syncParams.updatedStatuses.map(function(status) {
            return (0, $9Jpjh._)((0, $lvTkn._)({}, status), {
                datetime: status.datetime.toISOString()
            });
        }) : syncParams.updatedStatuses
    });
    if ('since' in params) params.since = params.since.toISOString();
    if ('itemsNotBefore' in params) params.itemsNotBefore = params.itemsNotBefore.toISOString();
    var _ajax_fetch = $32ae13b741542474$export$e7aa7bc5c1b3cfb3('items/sync', {
        method: updatedStatuses ? 'POST' : 'GET',
        body: $32ae13b741542474$export$92871f7982deaf9f(params)
    }), controller = _ajax_fetch.controller, promise = _ajax_fetch.promise;
    return {
        controller: controller,
        promise: promise.then(function(response) {
            return response.json();
        }).then($8ef3cedac61156e9$var$enrichItemsResponse)
    };
}













function $9b2cb125cea35be7$var$reloadList(param) {
    var fetchParams = param.fetchParams, abortController = param.abortController, navigate = param.navigate, _param_append = param.append, append = _param_append === void 0 ? false : _param_append, _param_waitForSync = param.waitForSync, waitForSync = _param_waitForSync === void 0 ? true : _param_waitForSync, configuration = param.configuration, _param_entryId = param.entryId, entryId = _param_entryId === void 0 ? null : _param_entryId, setLoadingState = param.setLoadingState;
    if (abortController.signal.aborted) return Promise.resolve();
    if (entryId && fetchParams.fromId === undefined) fetchParams = (0, $9Jpjh._)((0, $lvTkn._)({}, fetchParams), {
        extraIds: (0, $6zk1M._)(fetchParams.extraIds).concat([
            entryId
        ])
    });
    if (!append || fetchParams.type !== (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).NEWEST) selfoss.dbOffline.olderEntriesOnline = false;
    setLoadingState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING);
    var reload = function() {
        if (abortController.signal.aborted) return Promise.resolve();
        var reloader = selfoss.dbOffline.getEntries;
        // tag, source and search filtering not supported offline (yet?)
        if (fetchParams.tag || fetchParams.source || fetchParams.search) reloader = selfoss.dbOnline.getEntries;
        var forceLoadOnline = selfoss.dbOffline.olderEntriesOnline || selfoss.dbOffline.shouldLoadEntriesOnline;
        if (!selfoss.db.enableOffline.value || selfoss.isOnline() && forceLoadOnline) reloader = selfoss.dbOnline.getEntries;
        // Clean state when not just adding items.
        if (!append) {
            selfoss.entriesPage.setHasMore(false);
            selfoss.entriesPage.setExpandedEntries({});
            selfoss.entriesPage.setEntries([]);
            selfoss.entriesPage.setSelectedEntry(null);
        }
        setLoadingState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING);
        return reloader(fetchParams, abortController).then(function(param) {
            var entries = param.entries, hasMore = param.hasMore;
            if (abortController.signal.aborted) return;
            setLoadingState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
            selfoss.entriesPage.setHasMore(hasMore);
            if (append) selfoss.entriesPage.appendEntries(entries);
            else {
                selfoss.entriesPage.setExpandedEntries({});
                selfoss.entriesPage.setEntries(entries);
                // open selected entry only if entry was requested (i.e. if not streaming
                // more)
                if (entryId && fetchParams.fromId === undefined) {
                    var entry = document.querySelector('.entry[data-entry-id="'.concat(entryId, '"]'));
                    if (!entry) return;
                    selfoss.entriesPage.activateEntry(entryId);
                    // ensure scrolling to requested entry even if scrolling to article
                    // header is disabled
                    if (!configuration.scrollToArticleHeader) // needs to be delayed for some reason
                    requestAnimationFrame(function() {
                        entry.scrollIntoView();
                    });
                } else window.scrollTo({
                    top: 0
                });
            }
        }).catch(function(error) {
            if (abortController.signal.aborted) return;
            if (error instanceof (0, $0d06257c362dc1a1$export$65bd6083489bd8bb) && error.response.status === 403) {
                navigate('/sign/in', {
                    state: {
                        error: selfoss.app._('error_session_expired')
                    }
                });
                return;
            }
            setLoadingState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).FAILURE);
            selfoss.app.showError(selfoss.app._('error_loading') + ' ' + error.message);
        });
    };
    if (waitForSync && selfoss.dbOnline.syncing.promise) {
        selfoss.db.userWaiting = true;
        return selfoss.dbOnline.syncing.promise.finally(reload);
    } else return reload();
}
/**
 * Try to open the selected article using the preferred method.
 * @param {number} selected
 */ function $9b2cb125cea35be7$var$openSelectedArticle(selected) {
    var link = document.querySelector('.entry[data-entry-id="'.concat(selected, '"] .entry-datetime'));
    if (selfoss.config.openInBackgroundTab) {
        // In Chromium, this will just cause the tab to open in the foreground.
        // Appears to be disallowed by the pop-under prevention:
        // https://crbug.com/431335
        // https://crbug.com/487919
        var event = new MouseEvent('click', {
            ctrlKey: true
        });
        link.dispatchEvent(event);
    } else // open item in new window
    link.click();
}
// updates a source
function $9b2cb125cea35be7$var$handleRefreshSource(param) {
    var event = param.event, source = param.source, setLoadingState = param.setLoadingState, setNavExpanded = param.setNavExpanded, reload = param.reload;
    event.preventDefault();
    // show loading
    setLoadingState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING);
    return $b0e03640e062f6f9$export$c1f8f7c408fa54a(source).then(function() {
        // hide nav on smartphone
        setNavExpanded(false);
        // Fetch the new items and reload the list.
        // Will also clear the loading status.
        reload();
    }).catch(function(error) {
        setLoadingState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).FAILURE);
        alert(selfoss.app._('error_refreshing_source') + ' ' + error.message);
    });
}
function $9b2cb125cea35be7$export$66d62ccfdff1c843(param) {
    var entries = param.entries, hasMore = param.hasMore, loadingState = param.loadingState, setLoadingState = param.setLoadingState, selectedEntry = param.selectedEntry, expandedEntries = param.expandedEntries, setNavExpanded = param.setNavExpanded, navSourcesExpanded = param.navSourcesExpanded, reload = param.reload, setGlobalUnreadCount = param.setGlobalUnreadCount, unreadItemsCount = param.unreadItemsCount;
    var _params_category, _params_category1;
    var allowedToUpdate = (0, $bd320d0e16baa5f3$export$683005ba76038aff)();
    var allowedToWrite = (0, $bd320d0e16baa5f3$export$b416b77cd328c02f)();
    var configuration = (0, $eHaBZ.useContext)((0, $94046e75c3010f4f$export$326f6d1b69f1c06e));
    var location = (0, $5XYIU.useLocation)();
    var navigate = (0, $5XYIU.useNavigate)();
    var forceReload = (0, $c8aedc92b88eb948$export$7bcdf1c247ef07b1)();
    var searchText = (0, $eHaBZ.useMemo)(function() {
        var queryString = new URLSearchParams(location.search);
        var _queryString_get;
        return (_queryString_get = queryString.get('search')) !== null && _queryString_get !== void 0 ? _queryString_get : '';
    }, [
        location.search
    ]);
    var params = (0, $5XYIU.useParams)();
    var currentTag = ((_params_category = params.category) === null || _params_category === void 0 ? void 0 : _params_category.startsWith('tag-')) ? params.category.replace(/^tag-/, '') : null;
    var currentSource = ((_params_category1 = params.category) === null || _params_category1 === void 0 ? void 0 : _params_category1.startsWith('source-')) ? parseInt(params.category.replace(/^source-/, ''), 10) : null;
    // The offsets for pagination.
    // Clear them when URL changes, except for when only id changes since that happens when reading.
    var _useStateWithDeps = (0, $21h22._)((0, $52218fae2790199f$exports.useStateWithDeps)(undefined, [
        params.filter,
        currentTag,
        currentSource,
        searchText
    ]), 2), fromDatetime = _useStateWithDeps[0], setFromDatetime = _useStateWithDeps[1];
    var _useStateWithDeps1 = (0, $21h22._)((0, $52218fae2790199f$exports.useStateWithDeps)(undefined, [
        params.filter,
        currentTag,
        currentSource,
        searchText
    ]), 2), fromId = _useStateWithDeps1[0], setFromId = _useStateWithDeps1[1];
    // Cache the item id from initial URL so that we can fetch it
    // but do not re-fetch when the id in the URI changes later
    // since that happens when reading.
    var initialItemId = (0, $eHaBZ.useMemo)(function() {
        return parseInt(params.id, 10);
    }, [
        params.filter,
        currentTag,
        currentSource,
        searchText,
        forceReload
    ]);
    // Same for the state of navigation being expanded.
    // It is only passed to the API request as a part of optimization scheme
    // so there is no need for it to trigger refresh of the entries.
    var initialNavSourcesExpanded = (0, $eHaBZ.useMemo)(function() {
        return navSourcesExpanded;
    }, [
        params.filter,
        currentTag,
        currentSource,
        searchText
    ]);
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).INITIAL), 2), moreLoadingState = _useState[0], setMoreLoadingState = _useState[1];
    // Perform the scheduled reload.
    (0, $eHaBZ.useEffect)(function() {
        var append = fromId !== undefined || fromDatetime !== undefined;
        var abortController = new AbortController();
        $9b2cb125cea35be7$var$reloadList({
            // Object with parameters for GET /items and similar API calls
            // based on the current location.
            fetchParams: {
                type: params.filter,
                tag: currentTag,
                source: currentSource,
                extraIds: [],
                sourcesNav: initialNavSourcesExpanded,
                search: searchText,
                fromDatetime: fromDatetime,
                fromId: fromId
            },
            abortController: abortController,
            navigate: navigate,
            append: append,
            configuration: configuration,
            // We do not want to focus the entry on successive loads.
            entryId: append ? undefined : initialItemId,
            setLoadingState: append ? setMoreLoadingState : setLoadingState
        }).then(function() {
            if (currentTag !== null && !selfoss.db.isValidTag(currentTag)) selfoss.app.showError(selfoss.app._('error_unknown_tag') + ' ' + currentTag);
            if (currentSource !== null && !selfoss.db.isValidSource(currentSource)) selfoss.app.showError(selfoss.app._('error_unknown_source') + ' ' + currentSource);
        });
        return function() {
            abortController.abort();
        };
    }, [
        // navigate is intentionally omitted
        // to prevent reloading when path is replaced
        configuration,
        params.filter,
        currentTag,
        currentSource,
        initialNavSourcesExpanded,
        searchText,
        fromDatetime,
        fromId,
        initialItemId,
        setLoadingState,
        forceReload
    ]);
    (0, $eHaBZ.useEffect)(function() {
        // scroll load more
        var onScroll = function() {
            var streamMoreButton = document.querySelector('.stream-more');
            if (!streamMoreButton) return;
            var streamMoreButtonTop = window.scrollY + streamMoreButton.getBoundingClientRect().top;
            // When “More” button appears on the screen, click it.
            if (streamMoreButtonTop < document.body.clientHeight + window.scrollY) streamMoreButton.click();
        };
        if (hasMore && moreLoadingState !== (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING && configuration.autoStreamMore) {
            window.addEventListener('scroll', onScroll);
            return function() {
                window.removeEventListener('scroll', onScroll);
            };
        }
    }, [
        configuration,
        hasMore,
        moreLoadingState
    ]);
    (0, $eHaBZ.useEffect)(function() {
        // setup periodic server status sync
        var interval = window.setInterval(selfoss.db.sync, 60000);
        return function() {
            window.clearInterval(interval);
        };
    }, []);
    (0, $eHaBZ.useEffect)(function() {
        setGlobalUnreadCount(unreadItemsCount);
        return function() {
            setGlobalUnreadCount(null);
        };
    }, [
        setGlobalUnreadCount,
        unreadItemsCount
    ]);
    var isOnline = (0, $c020e53fc27b31fb$export$6feb6ada280bcdab)();
    var refreshOnClick = (0, $eHaBZ.useCallback)(function(event) {
        return $9b2cb125cea35be7$var$handleRefreshSource({
            event: event,
            source: currentSource,
            setLoadingState: setLoadingState,
            setNavExpanded: setNavExpanded,
            reload: reload
        });
    }, [
        currentSource,
        setLoadingState,
        setNavExpanded,
        reload
    ]);
    var moreOnClick = (0, $eHaBZ.useCallback)(function(event) {
        event.preventDefault();
        var lastEntry = entries[entries.length - 1];
        // Calculate offset.
        setFromDatetime(lastEntry ? lastEntry.datetime : undefined);
        setFromId(lastEntry ? lastEntry.id : undefined);
    }, [
        entries,
        setFromDatetime,
        setFromId
    ]);
    // Current time for calculating relative dates in items.
    var _useState1 = (0, $21h22._)((0, $eHaBZ.useState)(function() {
        return new Date();
    }), 2), currentTime = _useState1[0], setCurrentTime = _useState1[1];
    (0, $eHaBZ.useEffect)(function() {
        var tick = window.setInterval(function() {
            setCurrentTime(new Date());
        }, 60000);
        return function() {
            clearInterval(tick);
        };
    }, []);
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    if (loadingState === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING) return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $4e51d095a6eb2eac$export$84dbad74efe95918), {
        label: _('entries_loading')
    });
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
        children: [
            currentSource !== null && allowedToUpdate && isOnline ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                type: "button",
                className: "refresh-source",
                onClick: refreshOnClick,
                children: _('source_refresh')
            }) : null,
            currentSource !== null && allowedToWrite && isOnline ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $5XYIU.Link), {
                to: {
                    pathname: '/manage/sources',
                    hash: "#source-".concat(currentSource)
                },
                className: "entries-go-to-settings",
                children: _('source_go_to_settings')
            }) : null,
            entries.map(function(entry) {
                var _expandedEntries_entry_id;
                return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $bfe6f4dc29c37278$export$2e2bcd8739ae039), {
                    item: entry,
                    currentTime: currentTime,
                    selected: selectedEntry == entry.id,
                    expanded: (_expandedEntries_entry_id = expandedEntries[entry.id]) !== null && _expandedEntries_entry_id !== void 0 ? _expandedEntries_entry_id : false,
                    setNavExpanded: setNavExpanded
                }, entry.id);
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                id: "stream-buttons",
                children: [
                    loadingState === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS && entries.length === 0 ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("p", {
                        "aria-live": "assertive",
                        className: "stream-empty",
                        children: _('no_entries')
                    }) : null,
                    hasMore ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                            'stream-button': true,
                            'stream-more': true
                        }),
                        accessKey: "m",
                        "aria-label": _('more'),
                        onClick: moreLoadingState !== (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING ? moreOnClick : null,
                        children: moreLoadingState !== (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                            children: _('more')
                        }) : /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $4e51d095a6eb2eac$export$7f7cbe89f1eacd2), {
                            size: "3x",
                            label: _('entries_loading')
                        })
                    }) : null,
                    entries.length > 0 ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                        className: "stream-button mark-these-read",
                        "aria-label": _('markread'),
                        onClick: selfoss.entriesPage.markVisibleRead,
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                            children: _('markread')
                        })
                    }) : null,
                    loadingState == (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).FAILURE ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                        className: "stream-button stream-error",
                        "aria-live": "assertive",
                        "aria-label": _('streamerror'),
                        onClick: reload,
                        children: _('streamerror')
                    }) : null
                ]
            })
        ]
    });
}
$9b2cb125cea35be7$export$66d62ccfdff1c843.propTypes = {
    entries: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).array.isRequired,
    hasMore: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    loadingState: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOf(Object.values((0, $d2d3ee75176c5e4c$export$62aa48085237e36f))).isRequired,
    setLoadingState: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    selectedEntry: (0, (/*@__PURE__*/$parcel$interopDefault($cff7e9a474db95c7$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number).isRequired,
    expandedEntries: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool).isRequired,
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    navSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    reload: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    setGlobalUnreadCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    unreadItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired
};
var $9b2cb125cea35be7$var$initialState = {
    entries: [],
    hasMore: false,
    /**
     * Currently selected entry.
     * The id in the location.hash should imply the selected entry.
     * It will also be used for keyboard navigation (for finding previous/next).
     */ selectedEntry: null,
    expandedEntries: {},
    loadingState: (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).INITIAL
};
var $9b2cb125cea35be7$var$StateHolder = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $NBk0Y._)(StateHolder, _React_Component);
    function StateHolder(props) {
        (0, $gd0sY._)(this, StateHolder);
        var _this;
        _this = (0, $8xMIM._)(this, StateHolder, [
            props
        ]);
        _this.state = $9b2cb125cea35be7$var$initialState;
        _this.reload = _this.reload.bind(_this);
        _this.setLoadingState = _this.setLoadingState.bind(_this);
        _this.activateEntry = _this.activateEntry.bind(_this);
        _this.deactivateEntry = _this.deactivateEntry.bind(_this);
        _this.markVisibleRead = _this.markVisibleRead.bind(_this);
        _this.markEntryRead = _this.markEntryRead.bind(_this);
        _this.markEntryStarred = _this.markEntryStarred.bind(_this);
        _this.nextPrev = _this.nextPrev.bind(_this);
        _this.entryNav = _this.entryNav.bind(_this);
        _this.jumpToNext = _this.jumpToNext.bind(_this);
        _this.toggleSelectedStarred = _this.toggleSelectedStarred.bind(_this);
        _this.toggleSelectedRead = _this.toggleSelectedRead.bind(_this);
        _this.toggleSelectedExpanded = _this.toggleSelectedExpanded.bind(_this);
        _this.openSelectedTarget = _this.openSelectedTarget.bind(_this);
        _this.openSelectedTargetAndMarkRead = _this.openSelectedTargetAndMarkRead.bind(_this);
        _this.throw = _this.throw.bind(_this);
        return _this;
    }
    (0, $7cSld._)(StateHolder, [
        {
            key: "setEntries",
            value: function setEntries(entries) {
                if (typeof entries === 'function') this.setState(function(state) {
                    return {
                        entries: entries(state.entries)
                    };
                });
                else this.setState({
                    entries: entries
                });
            }
        },
        {
            key: "appendEntries",
            value: function appendEntries(extraEntries) {
                this.setEntries(function(entries) {
                    return (0, $6zk1M._)(entries).concat((0, $6zk1M._)(extraEntries));
                });
            }
        },
        {
            /**
     * Make the given entry currently selected one.
     * @param {number|function(number): number} id of entry to select, or a function that transforms a previous id into a new one
     */ key: "setSelectedEntry",
            value: function setSelectedEntry(selectedEntry) {
                if (typeof selectedEntry === 'function') this.setState(function(state) {
                    return {
                        selectedEntry: selectedEntry(state.selectedEntry)
                    };
                });
                else this.setState({
                    selectedEntry: selectedEntry
                });
            }
        },
        {
            /**
     * Get the currently selected entry.
     * @return {number}
     */ key: "getSelectedEntry",
            value: function getSelectedEntry() {
                return this.state.selectedEntry;
            }
        },
        {
            key: "setExpandedEntries",
            value: function setExpandedEntries(expandedEntries) {
                if (typeof expandedEntries === 'function') this.setState(function(state) {
                    return {
                        expandedEntries: expandedEntries(state.expandedEntries)
                    };
                });
                else this.setState({
                    expandedEntries: expandedEntries
                });
            }
        },
        {
            key: "setEntryExpanded",
            value: function setEntryExpanded(id, expand) {
                if (typeof expand === 'function') this.setExpandedEntries(function(oldEntries) {
                    var _oldEntries_id;
                    return (0, $9Jpjh._)((0, $lvTkn._)({}, oldEntries), (0, $khBmn._)({}, id, expand((_oldEntries_id = oldEntries[id]) !== null && _oldEntries_id !== void 0 ? _oldEntries_id : false)));
                });
                else this.setExpandedEntries(function(oldEntries) {
                    return (0, $9Jpjh._)((0, $lvTkn._)({}, oldEntries), (0, $khBmn._)({}, id, expand));
                });
            }
        },
        {
            /**
     * Collapse all expanded entries.
     */ key: "collapseAllEntries",
            value: function collapseAllEntries() {
                this.setExpandedEntries({});
            }
        },
        {
            /**
     * Is given entry expanded?
     * @param {number} id of entry to check
     * @return {bool} whether it is expanded
     */ key: "isEntryExpanded",
            value: function isEntryExpanded(entry) {
                var _this_state_expandedEntries_entry;
                return (_this_state_expandedEntries_entry = this.state.expandedEntries[entry]) !== null && _this_state_expandedEntries_entry !== void 0 ? _this_state_expandedEntries_entry : false;
            }
        },
        {
            /**
     * Toggle expanded state of given entry.
     * @param {number} id of entry to toggle
     */ key: "toggleEntryExpanded",
            value: function toggleEntryExpanded(entry) {
                if (!entry) return;
                this.setEntryExpanded(entry, function(expanded) {
                    return !(expanded !== null && expanded !== void 0 ? expanded : false);
                });
            }
        },
        {
            /**
     * Activate entry as if it were clicked.
     * This will open it, focus it and based on the settings, mark it as read.
     * @param {number} id of entry
     */ key: "activateEntry",
            value: function activateEntry(id) {
                if (this.props.configuration.autoCollapse) this.collapseAllEntries();
                this.setSelectedEntry(id);
                // show/hide (with toolbar)
                this.setEntryExpanded(id, true);
                // automark as read
                var entry = this.state.entries.find(function(entry) {
                    return id === entry.id;
                });
                var autoMarkAsRead = selfoss.isAllowedToWrite() && this.props.configuration.autoMarkAsRead && entry.unread == 1;
                if (autoMarkAsRead) this.markEntryRead(id, true);
            }
        },
        {
            /**
     * Deactivate entry, as if it were clicked.
     * This will close it and maybe something more.
     * @param {number} id of entry
     */ key: "deactivateEntry",
            value: function deactivateEntry(id) {
                this.setEntryExpanded(id, false);
            }
        },
        {
            key: "starEntryInView",
            value: function starEntryInView(id, starred) {
                this.setEntries(function(entries) {
                    return entries.map(function(entry) {
                        if (entry.id === id) return (0, $9Jpjh._)((0, $lvTkn._)({}, entry), {
                            starred: starred
                        });
                        else return entry;
                    });
                });
            }
        },
        {
            key: "markEntryInView",
            value: function markEntryInView(id, unread) {
                this.setEntries(function(entries) {
                    return entries.map(function(entry) {
                        if (entry.id === id) return (0, $9Jpjh._)((0, $lvTkn._)({}, entry), {
                            unread: unread
                        });
                        else return entry;
                    });
                });
            }
        },
        {
            key: "refreshEntryStatuses",
            value: function refreshEntryStatuses(entryStatuses) {
                var _this = this;
                this.state.entries.forEach(function(entry) {
                    var id = entry.id;
                    var newStatus = entryStatuses.find(function(entryStatus) {
                        return entryStatus.id == id;
                    });
                    if (newStatus) {
                        _this.starEntryInView(id, newStatus.starred);
                        _this.markEntryInView(id, newStatus.unread);
                    }
                });
            }
        },
        {
            key: "setHasMore",
            value: function setHasMore(hasMore) {
                if (typeof hasMore === 'function') this.setState(function(state) {
                    return {
                        hasMore: hasMore(state.hasMore)
                    };
                });
                else this.setState({
                    hasMore: hasMore
                });
            }
        },
        {
            key: "setLoadingState",
            value: function setLoadingState(loadingState) {
                if (typeof loadingState === 'function') this.setState(function(state) {
                    return {
                        loadingState: loadingState(state.loadingState)
                    };
                });
                else this.setState({
                    loadingState: loadingState
                });
            }
        },
        {
            key: "getActiveTag",
            value: function getActiveTag() {
                var _this_props_params;
                var category = (_this_props_params = this.props.params) === null || _this_props_params === void 0 ? void 0 : _this_props_params.category;
                if (!category) return null;
                return category.startsWith('tag-') ? category.replace(/^tag-/, '') : null;
            }
        },
        {
            key: "getActiveSource",
            value: function getActiveSource() {
                var _this_props_params;
                var category = (_this_props_params = this.props.params) === null || _this_props_params === void 0 ? void 0 : _this_props_params.category;
                if (!category) return null;
                return category.startsWith('source-') ? parseInt(category.replace(/^source-/, ''), 10) : null;
            }
        },
        {
            key: "getActiveFilter",
            value: function getActiveFilter() {
                var _this_props_params;
                return (_this_props_params = this.props.params) === null || _this_props_params === void 0 ? void 0 : _this_props_params.filter;
            }
        },
        {
            /**
     * Mark all visible items as read
     */ key: "markVisibleRead",
            value: function markVisibleRead() {
                var _this = this;
                var ids = [];
                var tagUnreadDiff = {};
                var sourceUnreadDiff = {};
                var markedEntries = this.state.entries.map(function(entry) {
                    if (!entry.unread) return entry;
                    ids.push(entry.id);
                    Object.keys(entry.tags).forEach(function(tag) {
                        if (Object.keys(tagUnreadDiff).includes(tag)) tagUnreadDiff[tag] += -1;
                        else tagUnreadDiff[tag] = -1;
                    });
                    var source = entry.source;
                    if (Object.keys(sourceUnreadDiff).includes(source.toString())) sourceUnreadDiff[source] += -1;
                    else sourceUnreadDiff[source] = -1;
                    return (0, $9Jpjh._)((0, $lvTkn._)({}, entry), {
                        unread: false
                    });
                });
                var oldEntries = this.state.entries;
                var hadMore = this.state.hasMore;
                // close opened entry and list
                this.setExpandedEntries({});
                this.props.setNavExpanded(false);
                if (this.props.params.filter === (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).UNREAD) markedEntries = [];
                this.setLoadingState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING);
                this.setEntries(markedEntries);
                // update statistics in main menu
                var updateStats = function(markRead) {
                    // update all unread counters
                    var unreadstats = selfoss.app.state.unreadItemsCount;
                    var diff = markRead ? -1 : 1;
                    selfoss.refreshUnread(unreadstats + diff * ids.length);
                    // update unread on tags and sources
                    if (markRead) selfoss.app.refreshTagSourceUnread(tagUnreadDiff, sourceUnreadDiff);
                    else // Diffs are negative by default.
                    selfoss.app.refreshTagSourceUnread(Object.fromEntries(Object.entries(tagUnreadDiff).map(function(param) {
                        var _param = (0, $21h22._)(param, 2), tag = _param[0], diff = _param[1];
                        return [
                            tag,
                            -1 * diff
                        ];
                    })), Object.fromEntries(Object.entries(sourceUnreadDiff).map(function(param) {
                        var _param = (0, $21h22._)(param, 2), source = _param[0], diff = _param[1];
                        return [
                            source,
                            -1 * diff
                        ];
                    })));
                };
                updateStats(true);
                if (selfoss.db.enableOffline.value) selfoss.dbOffline.entriesMark(ids, false);
                $8ef3cedac61156e9$export$8ce663b0c6b2535e(ids).then(function() {
                    _this.setLoadingState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
                }).catch(function(error) {
                    selfoss.handleAjaxError(error).then(function() {
                        var statuses = ids.map(function(id) {
                            return {
                                entryId: id,
                                name: 'unread',
                                value: false
                            };
                        });
                        selfoss.dbOffline.enqueueStatuses(statuses);
                    }).catch(function(error) {
                        if (error instanceof (0, $0d06257c362dc1a1$export$65bd6083489bd8bb) && error.response.status === 403) {
                            _this.props.navigate('/sign/in', {
                                state: {
                                    error: selfoss.app._('error_session_expired')
                                }
                            });
                            return;
                        }
                        _this.setLoadingState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
                        _this.setEntries(oldEntries);
                        updateStats(false);
                        _this.setHasMore(hadMore);
                        selfoss.app.showError(selfoss.app._('error_mark_items') + ' ' + error.message);
                    });
                });
            }
        },
        {
            /**
     * Requests for an entry to be marked read/unread in the model.
     * @param {number} id of entry to mark
     * @param {bool|'toggle'} true to mark read, false to mark unread
     */ key: "markEntryRead",
            value: function markEntryRead(id, markRead) {
                var _this = this;
                // only loggedin users
                if (!selfoss.isAllowedToWrite()) {
                    console.log('User not allowed to mark an entry (un)read.');
                    return;
                }
                var entry = this.state.entries.find(function(entry) {
                    return id === entry.id;
                });
                if (markRead === 'toggle') markRead = entry.unread;
                this.markEntryInView(id, !markRead);
                // update statistics in main menue and the currently active tag
                var updateStats = function(markRead) {
                    // update all unread counters
                    var unreadstats = selfoss.app.state.unreadItemsCount;
                    var diff = markRead ? -1 : 1;
                    selfoss.refreshUnread(unreadstats + diff);
                    // update unread on tags and sources
                    // Only a single instance of each tag per entry so we can just assign.
                    var entryTags = Object.fromEntries(Object.keys(entry.tags).map(function(tag) {
                        return [
                            tag,
                            diff
                        ];
                    }));
                    selfoss.app.refreshTagSourceUnread(entryTags, (0, $khBmn._)({}, entry.source, diff));
                };
                updateStats(markRead);
                if (selfoss.db.enableOffline.value) selfoss.dbOffline.entryMark(id, !markRead);
                $8ef3cedac61156e9$export$bf7f2fce5c1cf636(id, !markRead).then(function() {
                    selfoss.db.setOnline();
                }).catch(function(error) {
                    selfoss.handleAjaxError(error).then(function() {
                        selfoss.dbOffline.enqueueStatus(id, 'unread', !markRead);
                    }).catch(function(error) {
                        if (error instanceof (0, $0d06257c362dc1a1$export$65bd6083489bd8bb) && error.response.status === 403) {
                            _this.props.navigate('/sign/in', {
                                state: {
                                    error: selfoss.app._('error_session_expired')
                                }
                            });
                            return;
                        }
                        // rollback ui changes
                        _this.markEntryInView(id, markRead);
                        updateStats(!markRead);
                        selfoss.app.showError(selfoss.app._('error_mark_item') + ' ' + error.message);
                    });
                });
            }
        },
        {
            /**
     * Requests for an entry to be marked (un)starred in the model.
     * @param {number} id of entry to mark
     * @param {bool|'toggle'} true to mark starred, false to mark unstarred
     */ key: "markEntryStarred",
            value: function markEntryStarred(id, markStarred) {
                var _this = this;
                // only loggedin users
                if (!selfoss.isAllowedToWrite()) {
                    console.log('User not allowed to (un)star an entry.');
                    return;
                }
                if (markStarred === 'toggle') {
                    var entry = this.state.entries.find(function(entry) {
                        return id === entry.id;
                    });
                    markStarred = !entry.starred;
                }
                this.starEntryInView(id, markStarred);
                // update statistics in main menu
                var updateStats = function(markStarred) {
                    selfoss.app.setStarredItemsCount(function(starred) {
                        return starred + (markStarred ? 1 : -1);
                    });
                };
                updateStats(markStarred);
                if (selfoss.db.enableOffline.value) selfoss.dbOffline.entryStar(id, markStarred);
                $8ef3cedac61156e9$export$d11ee7cd6d3f95d4(id, markStarred).then(function() {
                    selfoss.db.setOnline();
                }).catch(function(error) {
                    selfoss.handleAjaxError(error).then(function() {
                        selfoss.dbOffline.enqueueStatus(id, 'starred', markStarred);
                    }).catch(function(error) {
                        if (error instanceof (0, $0d06257c362dc1a1$export$65bd6083489bd8bb) && error.response.status === 403) {
                            _this.props.navigate('/sign/in', {
                                state: {
                                    error: selfoss.app._('error_session_expired')
                                }
                            });
                            return;
                        }
                        // rollback ui changes
                        _this.starEntryInView(id, !markStarred);
                        updateStats(!markStarred);
                        selfoss.app.showError(selfoss.app._('error_star_item') + ' ' + error.message);
                    });
                });
            }
        },
        {
            key: "reload",
            value: function reload() {
                /**
         * HACK: A counter that is increased every time reload action (r key) is triggered.
         */ this.props.navigate((0, $0be080af3052783c$export$d0bb2ab5375d1521)(this.props.location, {
                    id: null
                }), {
                    replace: true,
                    state: (0, $0be080af3052783c$export$e64cf1b9b4b3aa56)(this.props.location)
                });
            }
        },
        {
            /**
     * get next/prev item
     * @param direction
     */ key: "nextPrev",
            value: function nextPrev(direction) {
                var open = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                if (direction != (0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).NEXT && direction != (0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).PREV) throw new Error('direction must be one of Direction.{PREV,NEXT}');
                // when there are no entries
                if (this.state.entries.length == 0) return;
                // select current
                var old = this.getSelectedEntry();
                var oldIndex = old !== null ? this.state.entries.findIndex(function(param) {
                    var id = param.id;
                    return id === old;
                }) : null;
                var current = null;
                // select next/prev entry and save it to "current"
                // if we would overflow, we stay on the old one
                if (direction == (0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).NEXT) {
                    if (old === null) current = this.state.entries[0].id;
                    else {
                        var nextIndex = oldIndex + 1;
                        if (nextIndex >= this.state.entries.length) {
                            var // attempt to load more
                            _document_querySelector;
                            current = old;
                            (_document_querySelector = document.querySelector('.stream-more')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.click();
                        } else current = this.state.entries[nextIndex].id;
                    }
                } else {
                    if (old === null) return;
                    else if (oldIndex <= 0) current = old;
                    else current = this.state.entries[oldIndex - 1].id;
                }
                if (old !== current) {
                    // remove active
                    this.deactivateEntry(old);
                    if (open) this.activateEntry(current);
                    else this.setSelectedEntry(current);
                    var currentElement = document.querySelector('.entry[data-entry-id="'.concat(current, '"]'));
                    // scroll to element
                    (0, $b625dc2dd2df76bd$export$d976747ecb966cea)(currentElement);
                    // focus the title link for better keyboard navigation
                    currentElement.querySelector('.entry-title-link').focus();
                }
            }
        },
        {
            /**
     * entry navigation (next/prev) with keys
     * @param direction
     */ key: "entryNav",
            value: function entryNav(direction) {
                if (direction != (0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).NEXT && direction != (0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).PREV) throw new Error('direction must be one of Direction.{PREV,NEXT}');
                var open = this.isEntryExpanded(this.getSelectedEntry());
                this.nextPrev(direction, open);
            }
        },
        {
            key: "jumpToNext",
            value: function jumpToNext() {
                var selected = this.getSelectedEntry();
                if (selected !== null && !this.isEntryExpanded(selected)) this.activateEntry(selected);
                else this.nextPrev((0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).NEXT, true);
            }
        },
        {
            key: "toggleSelectedStarred",
            value: function toggleSelectedStarred() {
                var selected = this.getSelectedEntry();
                if (selected !== null) this.markEntryStarred(selected, 'toggle');
            }
        },
        {
            key: "toggleSelectedRead",
            value: function toggleSelectedRead() {
                var selected = this.getSelectedEntry();
                if (selected !== null) this.markEntryRead(selected, 'toggle');
            }
        },
        {
            key: "toggleSelectedExpanded",
            value: function toggleSelectedExpanded() {
                this.toggleEntryExpanded(this.getSelectedEntry());
            }
        },
        {
            key: "openSelectedTarget",
            value: function openSelectedTarget() {
                var selected = this.getSelectedEntry();
                if (selected !== null) $9b2cb125cea35be7$var$openSelectedArticle(selected);
            }
        },
        {
            key: "openSelectedTargetAndMarkRead",
            value: function openSelectedTargetAndMarkRead() {
                var selected = this.getSelectedEntry();
                if (selected !== null) {
                    this.markEntryRead(selected, true);
                    $9b2cb125cea35be7$var$openSelectedArticle(selected);
                }
            }
        },
        {
            key: "throw",
            value: function _throw(direction) {
                var selected = this.getSelectedEntry();
                if (selected !== null) this.markEntryRead(selected, true);
                this.nextPrev(direction, true);
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($9b2cb125cea35be7$export$66d62ccfdff1c843, {
                    entries: this.state.entries,
                    selectedEntry: this.state.selectedEntry,
                    expandedEntries: this.state.expandedEntries,
                    hasMore: this.state.hasMore,
                    loadingState: this.state.loadingState,
                    setLoadingState: this.setLoadingState,
                    setNavExpanded: this.props.setNavExpanded,
                    navSourcesExpanded: this.props.navSourcesExpanded,
                    reload: this.reload,
                    setGlobalUnreadCount: this.props.setGlobalUnreadCount,
                    unreadItemsCount: this.props.unreadItemsCount
                });
            }
        }
    ]);
    return StateHolder;
}((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Component);
$9b2cb125cea35be7$var$StateHolder.propTypes = {
    configuration: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    location: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    navigate: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    params: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    navSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    setGlobalUnreadCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    unreadItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired
};
var $9b2cb125cea35be7$var$StateHolderOuter = /*#__PURE__*/ (0, $eHaBZ.forwardRef)(function StateHolderOuter(param, ref) {
    var configuration = param.configuration, setNavExpanded = param.setNavExpanded, navSourcesExpanded = param.navSourcesExpanded, setGlobalUnreadCount = param.setGlobalUnreadCount, unreadItemsCount = param.unreadItemsCount;
    var location = (0, $5XYIU.useLocation)();
    var navigate = (0, $5XYIU.useNavigate)();
    var params = (0, $5XYIU.useParams)();
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($9b2cb125cea35be7$var$StateHolder, {
        ref: ref,
        location: location,
        navigate: navigate,
        params: params,
        configuration: configuration,
        setNavExpanded: setNavExpanded,
        navSourcesExpanded: navSourcesExpanded,
        setGlobalUnreadCount: setGlobalUnreadCount,
        unreadItemsCount: unreadItemsCount
    });
});
$9b2cb125cea35be7$var$StateHolderOuter.propTypes = {
    configuration: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    navSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    setGlobalUnreadCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    unreadItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired
};
var $9b2cb125cea35be7$export$2e2bcd8739ae039 = $9b2cb125cea35be7$var$StateHolderOuter;




var $eHaBZ = parcelRequire("eHaBZ");





var $21h22 = parcelRequire("21h22");


var $eHaBZ = parcelRequire("eHaBZ");



var $5XYIU = parcelRequire("5XYIU");






function $5040dba436a03900$export$2e2bcd8739ae039(param) {
    var setNavExpanded = param.setNavExpanded, offlineState = param.offlineState, allItemsCount = param.allItemsCount, allItemsOfflineCount = param.allItemsOfflineCount, unreadItemsCount = param.unreadItemsCount, unreadItemsOfflineCount = param.unreadItemsOfflineCount, starredItemsCount = param.starredItemsCount, starredItemsOfflineCount = param.starredItemsOfflineCount;
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(true), 2), expanded = _useState[0], setExpanded = _useState[1];
    var params = (0, $0be080af3052783c$export$216385125ee84ae7)();
    var location = (0, $5XYIU.useLocation)();
    var toggleExpanded = (0, $eHaBZ.useCallback)(function() {
        return setExpanded(function(expanded) {
            return !expanded;
        });
    }, []);
    var collapseNav = (0, $eHaBZ.useCallback)(function() {
        return setNavExpanded(false);
    }, [
        setNavExpanded
    ]);
    var newestLink = (0, $eHaBZ.useMemo)(function() {
        return (0, $0be080af3052783c$export$d0bb2ab5375d1521)(location, {
            filter: (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).NEWEST,
            id: null
        });
    }, [
        location
    ]);
    var unreadLink = (0, $eHaBZ.useMemo)(function() {
        return (0, $0be080af3052783c$export$d0bb2ab5375d1521)(location, {
            filter: (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).UNREAD,
            id: null
        });
    }, [
        location
    ]);
    var starredLink = (0, $eHaBZ.useMemo)(function() {
        return (0, $0be080af3052783c$export$d0bb2ab5375d1521)(location, {
            filter: (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).STARRED,
            id: null
        });
    }, [
        location
    ]);
    var forceReload = (0, $0be080af3052783c$export$6bccca1b7088ecd7)();
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
        id: "nav-filter-wrapper",
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("h2", {
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                    type: "button",
                    id: "nav-filter-title",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                        'nav-section-toggle': true,
                        'nav-filter-collapsed': !expanded,
                        'nav-filter-expanded': expanded
                    }),
                    "aria-expanded": expanded,
                    onClick: toggleExpanded,
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                            icon: expanded ? $843ec70749747e2a$exports.faCaretDown : $809575f3b9653d01$exports.faCaretRight,
                            size: "lg",
                            fixedWidth: true
                        }),
                        ' ',
                        _('filter')
                    ]
                })
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $8929b96d30942b2d$export$78768a9af065a7b), {
                isOpen: expanded,
                className: "collapse-css-transition",
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", {
                    id: "nav-filter",
                    "aria-labelledby": "nav-filter-title",
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $5XYIU.Link), {
                                id: "nav-filter-newest",
                                to: newestLink,
                                state: forceReload,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                    'nav-filter-newest': true,
                                    active: (params === null || params === void 0 ? void 0 : params.filter) === (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).NEWEST
                                }),
                                onClick: collapseNav,
                                children: [
                                    _('newest'),
                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                            'offline-count': true,
                                            offline: offlineState,
                                            online: !offlineState,
                                            diff: allItemsCount !== allItemsOfflineCount && allItemsOfflineCount
                                        }),
                                        title: _('offline_count'),
                                        children: allItemsOfflineCount > 0 ? allItemsOfflineCount : ''
                                    }),
                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                        className: "count",
                                        title: _('online_count'),
                                        children: allItemsCount > 0 ? allItemsCount : ''
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $5XYIU.Link), {
                                id: "nav-filter-unread",
                                to: unreadLink,
                                state: forceReload,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                    'nav-filter-unread': true,
                                    active: (params === null || params === void 0 ? void 0 : params.filter) === (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).UNREAD
                                }),
                                onClick: collapseNav,
                                children: [
                                    _('unread'),
                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("span", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                            'unread-count': true,
                                            offline: offlineState,
                                            online: !offlineState,
                                            unread: unreadItemsCount > 0
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                                    'offline-count': true,
                                                    offline: offlineState,
                                                    online: !offlineState,
                                                    diff: unreadItemsCount !== unreadItemsOfflineCount && unreadItemsOfflineCount
                                                }),
                                                title: _('offline_count'),
                                                children: unreadItemsOfflineCount > 0 ? unreadItemsOfflineCount : ''
                                            }),
                                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                                className: "count",
                                                title: _('online_count'),
                                                children: unreadItemsCount > 0 ? unreadItemsCount : ''
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $5XYIU.Link), {
                                id: "nav-filter-starred",
                                to: starredLink,
                                state: forceReload,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                    'nav-filter-starred': true,
                                    active: (params === null || params === void 0 ? void 0 : params.filter) === (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).STARRED
                                }),
                                onClick: collapseNav,
                                children: [
                                    _('starred'),
                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                            'offline-count': true,
                                            offline: offlineState,
                                            online: !offlineState,
                                            diff: starredItemsCount !== starredItemsOfflineCount && starredItemsOfflineCount
                                        }),
                                        title: _('offline_count'),
                                        children: starredItemsOfflineCount > 0 ? starredItemsOfflineCount : ''
                                    }),
                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                        className: "count",
                                        title: _('online_count'),
                                        children: starredItemsCount > 0 ? starredItemsCount : ''
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
$5040dba436a03900$export$2e2bcd8739ae039.propTypes = {
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    offlineState: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    allItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    allItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    unreadItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    unreadItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    starredItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    starredItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired
};




var $eHaBZ = parcelRequire("eHaBZ");


var $5XYIU = parcelRequire("5XYIU");










function $a66ee1fb90186752$var$handleTitleClick(param) {
    var setExpanded = param.setExpanded, sourcesState = param.sourcesState, setSourcesState = param.setSourcesState, setSources = param.setSources;
    if (!selfoss.isOnline()) {
        console.log('Cannot toggle, not online.');
        return;
    }
    setExpanded(function(expanded) {
        if (!expanded && sourcesState === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).INITIAL) $b0e03640e062f6f9$export$432f698644f45d1().then(function(data) {
            setSources(data);
            setSourcesState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
        }).catch(function(error) {
            setSourcesState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).FAILURE);
            selfoss.app.showError(selfoss.app._('error_loading_stats') + ' ' + error.message);
        });
        return !expanded;
    });
}
function $a66ee1fb90186752$var$Source(param) {
    var source = param.source, active = param.active, collapseNav = param.collapseNav;
    var location = (0, $5XYIU.useLocation)();
    var link = (0, $eHaBZ.useMemo)(function() {
        return (0, $0be080af3052783c$export$d0bb2ab5375d1521)(location, {
            category: "source-".concat(source.id),
            id: null
        });
    }, [
        source.id,
        location
    ]);
    var forceReload = (0, $0be080af3052783c$export$6bccca1b7088ecd7)();
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
            read: source.unread === 0
        }),
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $5XYIU.Link), {
            to: link,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                active: active,
                unread: source.unread > 0
            }),
            onClick: collapseNav,
            state: forceReload,
            children: [
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                    className: "nav-source",
                    children: (0, $4c0cf5d996e33977$export$e8bacd2802a88316)(source.title)
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                    className: "unread",
                    children: source.unread > 0 ? source.unread : ''
                })
            ]
        })
    });
}
$a66ee1fb90186752$var$Source.propTypes = {
    source: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    collapseNav: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};
function $a66ee1fb90186752$export$2e2bcd8739ae039(param) {
    var setNavExpanded = param.setNavExpanded, navSourcesExpanded = param.navSourcesExpanded, setNavSourcesExpanded = param.setNavSourcesExpanded, sourcesState = param.sourcesState, setSourcesState = param.setSourcesState, sources = param.sources, setSources = param.setSources;
    var _params_category;
    var reallyExpanded = navSourcesExpanded && sourcesState === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS;
    var params = (0, $0be080af3052783c$export$216385125ee84ae7)();
    var currentSource = (params === null || params === void 0 ? void 0 : (_params_category = params.category) === null || _params_category === void 0 ? void 0 : _params_category.startsWith('source-')) ? parseInt(params.category.replace(/^source-/, ''), 10) : null;
    var toggleExpanded = (0, $eHaBZ.useCallback)(function() {
        return $a66ee1fb90186752$var$handleTitleClick({
            setExpanded: setNavSourcesExpanded,
            sourcesState: sourcesState,
            setSourcesState: setSourcesState,
            setSources: setSources
        });
    }, [
        setNavSourcesExpanded,
        sourcesState,
        setSourcesState,
        setSources
    ]);
    var collapseNav = (0, $eHaBZ.useCallback)(function() {
        return setNavExpanded(false);
    }, [
        setNavExpanded
    ]);
    var previousSourcesState = (0, $c020e53fc27b31fb$export$f6f3f74729fdd0b7)(sourcesState);
    (0, $eHaBZ.useEffect)(function() {
        if (previousSourcesState === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).INITIAL && sourcesState === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS) setNavSourcesExpanded(true);
    }, [
        previousSourcesState,
        sourcesState,
        setNavSourcesExpanded
    ]);
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("h2", {
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                    type: "button",
                    id: "nav-sources-title",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                        'nav-section-toggle': true,
                        'nav-sources-collapsed': !reallyExpanded,
                        'nav-sources-expanded': reallyExpanded
                    }),
                    "aria-expanded": reallyExpanded,
                    onClick: toggleExpanded,
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                            icon: navSourcesExpanded ? $843ec70749747e2a$exports.faCaretDown : $809575f3b9653d01$exports.faCaretRight,
                            size: "lg",
                            fixedWidth: true
                        }),
                        ' ',
                        _('sources')
                    ]
                })
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $8929b96d30942b2d$export$78768a9af065a7b), {
                isOpen: reallyExpanded,
                className: "collapse-css-transition",
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("ul", {
                    id: "nav-sources",
                    "aria-labelledby": "nav-sources-title",
                    children: sources.map(function(source) {
                        return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($a66ee1fb90186752$var$Source, {
                            source: source,
                            active: currentSource === source.id,
                            collapseNav: collapseNav
                        }, source.id);
                    })
                })
            })
        ]
    });
}
$a66ee1fb90186752$export$2e2bcd8739ae039.propTypes = {
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    navSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    setNavSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    sourcesState: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOf(Object.values((0, $d2d3ee75176c5e4c$export$62aa48085237e36f))).isRequired,
    setSourcesState: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    sources: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object).isRequired,
    setSources: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};



var $21h22 = parcelRequire("21h22");


var $eHaBZ = parcelRequire("eHaBZ");


var $5XYIU = parcelRequire("5XYIU");





// search button shows search input or executes search
function $4c0fa68710d48580$var$handleSubmit(param) {
    var active = param.active, setActive = param.setActive, searchField = param.searchField, searchText = param.searchText, navigate = param.navigate, location = param.location, setNavExpanded = param.setNavExpanded;
    if (!selfoss.isSmartphone() && !active) {
        setActive(true);
        searchField.current.focus();
        searchField.current.select();
        return;
    }
    navigate((0, $0be080af3052783c$export$7f0beea2aa79e4fa)(location, {
        search: searchText,
        id: null
    }));
    setActive(false);
    searchField.current.blur();
    setNavExpanded(false);
}
function $4c0fa68710d48580$var$handleFieldKeyUp(param) {
    var event = param.event, searchButton = param.searchButton, searchRemoveButton = param.searchRemoveButton;
    // keypress enter in search inputfield
    if (event.which == 13) searchButton.current.click();
    if (event.keyCode == 27) searchRemoveButton.current.click();
}
// remove button of search
function $4c0fa68710d48580$var$handleRemove(param) {
    var setActive = param.setActive, searchField = param.searchField, navigate = param.navigate, location = param.location;
    var queryString = new URLSearchParams(location.search);
    var oldTerm = queryString.get('search');
    setActive(false);
    if (oldTerm == '') {
        searchField.current.blur();
        return;
    }
    navigate((0, $0be080af3052783c$export$7f0beea2aa79e4fa)(location, {
        search: '',
        id: null
    }));
}
function $4c0fa68710d48580$export$2e2bcd8739ae039(param) {
    var setNavExpanded = param.setNavExpanded, offlineState = param.offlineState;
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), active = _useState[0], setActive = _useState[1];
    var searchField = (0, $eHaBZ.useRef)(null);
    var searchButton = (0, $eHaBZ.useRef)(null);
    var searchRemoveButton = (0, $eHaBZ.useRef)(null);
    var location = (0, $5XYIU.useLocation)();
    var navigate = (0, $5XYIU.useNavigate)();
    var queryString = new URLSearchParams(location.search);
    var _queryString_get;
    var oldTerm = (_queryString_get = queryString.get('search')) !== null && _queryString_get !== void 0 ? _queryString_get : '';
    var _useState1 = (0, $21h22._)((0, $eHaBZ.useState)(''), 2), searchText = _useState1[0], setSearchText = _useState1[1];
    (0, $eHaBZ.useEffect)(function() {
        // Update the search term when the query string changes.
        setSearchText(oldTerm);
    }, [
        oldTerm
    ]);
    var termOnKeyUp = (0, $eHaBZ.useCallback)(function(event) {
        return $4c0fa68710d48580$var$handleFieldKeyUp({
            event: event,
            searchButton: searchButton,
            searchRemoveButton: searchRemoveButton
        });
    }, []);
    var termOnChange = (0, $eHaBZ.useCallback)(function(event) {
        return setSearchText(event.target.value);
    }, []);
    var removeOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).useCallback(function() {
        return $4c0fa68710d48580$var$handleRemove({
            setActive: setActive,
            searchField: searchField,
            navigate: navigate,
            location: location
        });
    }, [
        navigate,
        location
    ]);
    var searchOnClick = (0, $eHaBZ.useCallback)(function() {
        return $4c0fa68710d48580$var$handleSubmit({
            active: active,
            setActive: setActive,
            searchField: searchField,
            searchText: searchText,
            navigate: navigate,
            location: location,
            setNavExpanded: setNavExpanded
        });
    }, [
        active,
        searchText,
        navigate,
        location,
        setNavExpanded
    ]);
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
        id: "search",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
            offline: offlineState,
            online: !offlineState,
            active: active
        }),
        role: "search",
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                "aria-label": _('search_label'),
                type: "search",
                id: "search-term",
                accessKey: "s",
                ref: searchField,
                value: searchText,
                onKeyUp: termOnKeyUp,
                onChange: termOnChange
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                id: "search-remove",
                title: _('searchremove'),
                accessKey: "h",
                "aria-label": _('searchremove'),
                onClick: removeOnClick,
                ref: searchRemoveButton,
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $6c06a95c587730ec$exports.faTimes
                })
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                id: "search-button",
                title: _('searchbutton'),
                "aria-label": _('searchbutton'),
                accessKey: "e",
                onClick: searchOnClick,
                ref: searchButton,
                children: [
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                        icon: $3d54bd244f4653d3$exports.faSearch
                    }),
                    ' ',
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "search-button-label",
                        children: _('searchbutton')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("hr", {})
        ]
    });
}
$4c0fa68710d48580$export$2e2bcd8739ae039.propTypes = {
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    offlineState: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired
};



var $21h22 = parcelRequire("21h22");


var $eHaBZ = parcelRequire("eHaBZ");



var $5XYIU = parcelRequire("5XYIU");





var $eHaBZ = parcelRequire("eHaBZ");



/**
 * Get dark OR bright color depending the color contrast.
 *
 * @param string hexColor color (hex) value
 * @param string darkColor dark color value
 * @param string brightColor bright color value
 *
 * @return string dark OR bright color value
 *
 * @see https://24ways.org/2010/calculating-color-contrast/
 */ function $8cbb75ae74525933$export$97e1e2675ab19423(hexColor) {
    var darkColor = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '#555', brightColor = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '#EEE';
    // Strip hash sign.
    var color = hexColor.substr(1);
    var r = parseInt(color.substr(0, 2), 16);
    var g = parseInt(color.substr(2, 2), 16);
    var b = parseInt(color.substr(4, 2), 16);
    var yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? darkColor : brightColor;
}




var $e097d983d6c2a48b$var$palette = [
    '#ffccc9',
    '#ffce93',
    '#fffc9e',
    '#ffffc7',
    '#9aff99',
    '#96fffb',
    '#cdffff',
    '#cbcefb',
    '#fffe65',
    '#cfcfcf',
    '#fd6864',
    '#fe996b',
    '#fcff2f',
    '#67fd9a',
    '#38fff8',
    '#68fdff',
    '#9698ed',
    '#c0c0c0',
    '#fe0000',
    '#f8a102',
    '#ffcc67',
    '#f8ff00',
    '#34ff34',
    '#68cbd0',
    '#34cdf9',
    '#6665cd',
    '#9b9b9b',
    '#cb0000',
    '#f56b00',
    '#ffcb2f',
    '#ffc702',
    '#32cb00',
    '#00d2cb',
    '#3166ff',
    '#6434fc',
    '#656565',
    '#9a0000',
    '#ce6301',
    '#cd9934',
    '#999903',
    '#009901',
    '#329a9d',
    '#3531ff',
    '#6200c9',
    '#343434',
    '#680100',
    '#963400',
    '#986536',
    '#646809',
    '#036400',
    '#34696d',
    '#00009b',
    '#303498',
    '#000000',
    '#330001',
    '#643403',
    '#663234',
    '#343300',
    '#013300',
    '#003532',
    '#010066',
    '#340096'
];
function $e097d983d6c2a48b$var$ColorButton(param) {
    var tag = param.tag, color = param.color;
    var style = (0, $eHaBZ.useMemo)(function() {
        return {
            backgroundColor: color,
            color: (0, $8cbb75ae74525933$export$97e1e2675ab19423)(color)
        };
    }, [
        color
    ]);
    var selected = color === tag.color;
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $196651884997e353$export$2ce376c2cc3355c8), {
        className: "popup-menu-item",
        value: color,
        style: style,
        children: selected ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
            icon: $0c96aa001209cff1$exports.faCheck
        }) : ' '
    });
}
$e097d983d6c2a48b$var$ColorButton.propTypes = {
    tag: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string.isRequired
};
var $e097d983d6c2a48b$var$preventDefault = function(event) {
    event.preventDefault();
    // Prevent closing navigation on mobile.
    event.stopPropagation();
};
function $e097d983d6c2a48b$export$2e2bcd8739ae039(param) {
    var tag = param.tag, onChange = param.onChange;
    var style = (0, $eHaBZ.useMemo)(function() {
        return {
            backgroundColor: tag.color
        };
    }, [
        tag.color
    ]);
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
        className: "color",
        onClick: $e097d983d6c2a48b$var$preventDefault,
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $afcad17a77b29a48$export$d9b273488cd8ce6f), {
            menuButton: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $7a4ada20cb42c4ac$export$266a769812832828), {
                className: "color-chooser-button",
                title: _('tag_change_color_button_title'),
                children: [
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "color-box",
                        style: style
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "visually-hidden",
                        children: _('tag_change_color_button_title')
                    })
                ]
            }),
            menuClassName: "color-chooser popup-menu",
            onItemClick: onChange,
            viewScroll: "auto",
            portal: true,
            children: [
                $e097d983d6c2a48b$var$palette.map(function(color) {
                    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($e097d983d6c2a48b$var$ColorButton, {
                        color: color,
                        tag: tag
                    }, color);
                }),
                !$e097d983d6c2a48b$var$palette.includes(tag.color) && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($e097d983d6c2a48b$var$ColorButton, {
                    color: tag.color,
                    tag: tag
                }, "custom")
            ]
        })
    });
}
$e097d983d6c2a48b$export$2e2bcd8739ae039.propTypes = {
    tag: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};







function $25d64656d90230de$var$Tag(param) {
    var tag = param.tag, active = param.active, collapseNav = param.collapseNav;
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    var tagName = tag !== null ? tag.tag : null;
    var colorChanged = (0, $eHaBZ.useCallback)(function(param) {
        var value = param.value;
        (0, $bcc58ea15e13e580$export$6f3c7c74c4b252bb)(tagName, value).then(function() {
            var _selfoss_entriesPage;
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.reload();
        }).catch(function(error) {
            selfoss.app.showError(selfoss.app._('error_saving_color') + ' ' + error.message);
        });
    }, [
        tagName
    ]);
    var category = tag === null ? 'all' : "tag-".concat(tag.tag);
    var location = (0, $5XYIU.useLocation)();
    var link = (0, $eHaBZ.useMemo)(function() {
        return (0, $0be080af3052783c$export$d0bb2ab5375d1521)(location, {
            category: category,
            id: null
        });
    }, [
        category,
        location
    ]);
    var forceReload = (0, $0be080af3052783c$export$6bccca1b7088ecd7)();
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
            read: tag !== null && tag.unread === 0
        }),
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $5XYIU.Link), {
            to: link,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                'nav-tags-all': tag === null,
                active: active
            }),
            onClick: collapseNav,
            state: forceReload,
            children: tag === null ? _('alltags') : /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "tag",
                        children: (0, $4c0cf5d996e33977$export$e8bacd2802a88316)(tag.tag)
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "unread",
                        children: tag.unread > 0 ? tag.unread : ''
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $e097d983d6c2a48b$export$2e2bcd8739ae039), {
                        tag: tag,
                        onChange: colorChanged
                    })
                ]
            })
        })
    });
}
$25d64656d90230de$var$Tag.propTypes = {
    tag: (0, (/*@__PURE__*/$parcel$interopDefault($cff7e9a474db95c7$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object).isRequired,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    collapseNav: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};
function $25d64656d90230de$export$2e2bcd8739ae039(param) {
    var setNavExpanded = param.setNavExpanded, tags = param.tags;
    var _params_category;
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(true), 2), expanded = _useState[0], setExpanded = _useState[1];
    var params = (0, $0be080af3052783c$export$216385125ee84ae7)();
    var currentAllTags = (params === null || params === void 0 ? void 0 : params.category) === 'all';
    var currentTag = (params === null || params === void 0 ? void 0 : (_params_category = params.category) === null || _params_category === void 0 ? void 0 : _params_category.startsWith('tag-')) ? params.category.replace(/^tag-/, '') : null;
    var toggleExpanded = (0, $eHaBZ.useCallback)(function() {
        return setExpanded(function(expanded) {
            return !expanded;
        });
    }, []);
    var collapseNav = (0, $eHaBZ.useCallback)(function() {
        return setNavExpanded(false);
    }, [
        setNavExpanded
    ]);
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("h2", {
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                    type: "button",
                    id: "nav-tags-title",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                        'nav-section-toggle': true,
                        'nav-tags-collapsed': !expanded,
                        'nav-tags-expanded': expanded
                    }),
                    "aria-expanded": expanded,
                    onClick: toggleExpanded,
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                            icon: expanded ? $843ec70749747e2a$exports.faCaretDown : $809575f3b9653d01$exports.faCaretRight,
                            size: "lg",
                            fixedWidth: true
                        }),
                        ' ',
                        _('tags')
                    ]
                })
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $8929b96d30942b2d$export$78768a9af065a7b), {
                isOpen: expanded,
                className: "collapse-css-transition",
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", {
                    id: "nav-tags",
                    "aria-labelledby": "nav-tags-title",
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($25d64656d90230de$var$Tag, {
                            tag: null,
                            active: currentAllTags,
                            collapseNav: collapseNav
                        }),
                        tags.map(function(tag) {
                            return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($25d64656d90230de$var$Tag, {
                                tag: tag,
                                active: currentTag === tag.tag,
                                collapseNav: collapseNav
                            }, tag.tag);
                        })
                    ]
                })
            })
        ]
    });
}
$25d64656d90230de$export$2e2bcd8739ae039.propTypes = {
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    tags: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object).isRequired
};



var $21h22 = parcelRequire("21h22");


var $eHaBZ = parcelRequire("eHaBZ");


var $5XYIU = parcelRequire("5XYIU");






function $8a7bf68b184288ce$var$handleReloadAll(param) {
    var reloadAll = param.reloadAll, setReloading = param.setReloading, setNavExpanded = param.setNavExpanded;
    setReloading(true);
    reloadAll().finally(function() {
        setNavExpanded(false);
        setReloading(false);
    });
}
function $8a7bf68b184288ce$var$handleLogOut(param) {
    var setNavExpanded = param.setNavExpanded;
    // only loggedin users
    if (!selfoss.hasSession() || !selfoss.isOnline()) return;
    selfoss.db.clear();
    selfoss.logout();
    setNavExpanded(false);
}
function $8a7bf68b184288ce$export$2e2bcd8739ae039(param) {
    var reloadAll = param.reloadAll, setNavExpanded = param.setNavExpanded;
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), reloading = _useState[0], setReloading = _useState[1];
    var forceReload = (0, $0be080af3052783c$export$6bccca1b7088ecd7)();
    var refreshOnClick = (0, $eHaBZ.useCallback)(function() {
        return $8a7bf68b184288ce$var$handleReloadAll({
            reloadAll: reloadAll,
            setReloading: setReloading,
            setNavExpanded: setNavExpanded
        });
    }, [
        reloadAll,
        setNavExpanded
    ]);
    var settingsOnClick = (0, $eHaBZ.useCallback)(function() {
        setNavExpanded(false);
    }, [
        setNavExpanded
    ]);
    var logoutOnClick = (0, $eHaBZ.useCallback)(function() {
        return $8a7bf68b184288ce$var$handleLogOut({
            setNavExpanded: setNavExpanded
        });
    }, [
        setNavExpanded
    ]);
    var isLoggedIn = (0, $bd320d0e16baa5f3$export$3b062b02b4537682)();
    var canRefreshAll = (0, $bd320d0e16baa5f3$export$683005ba76038aff)();
    var canVisitSettings = (0, $bd320d0e16baa5f3$export$b416b77cd328c02f)();
    var canLogOut = isLoggedIn;
    var configuration = (0, $eHaBZ.useContext)((0, $94046e75c3010f4f$export$326f6d1b69f1c06e));
    var canLogIn = !isLoggedIn && configuration.authEnabled;
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
        className: "nav-toolbar",
        children: [
            canRefreshAll && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                id: "nav-refresh",
                title: _('refreshbutton'),
                "aria-label": _('refreshbutton'),
                accessKey: "r",
                onClick: refreshOnClick,
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $468e6f5287149412$exports.faSyncAlt,
                    fixedWidth: true,
                    spin: reloading
                })
            }),
            canVisitSettings && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $5XYIU.Link), {
                id: "nav-settings",
                title: _('settingsbutton'),
                "aria-label": _('settingsbutton'),
                accessKey: "t",
                to: "/manage/sources",
                onClick: settingsOnClick,
                state: forceReload,
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $78546ca20d789f8c$exports.faCloudUploadAlt,
                    fixedWidth: true
                })
            }),
            canLogOut && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                id: "nav-logout",
                title: _('logoutbutton'),
                "aria-label": _('logoutbutton'),
                accessKey: "l",
                onClick: logoutOnClick,
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $17ddfe677f5b40f7$exports.faSignOutAlt,
                    fixedWidth: true
                })
            }),
            canLogIn && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $5XYIU.Link), {
                id: "nav-login",
                title: _('loginbutton'),
                "aria-label": _('loginbutton'),
                accessKey: "l",
                to: "/sign/in",
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                    icon: $5a270b3b7e6b7fa8$exports.faKey,
                    fixedWidth: true
                })
            })
        ]
    });
}
$8a7bf68b184288ce$export$2e2bcd8739ae039.propTypes = {
    reloadAll: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};







function $117ab31dd2c08da6$export$2e2bcd8739ae039(param) {
    var entriesPage = param.entriesPage, setNavExpanded = param.setNavExpanded, navSourcesExpanded = param.navSourcesExpanded, setNavSourcesExpanded = param.setNavSourcesExpanded, offlineState = param.offlineState, allItemsCount = param.allItemsCount, allItemsOfflineCount = param.allItemsOfflineCount, unreadItemsCount = param.unreadItemsCount, unreadItemsOfflineCount = param.unreadItemsOfflineCount, starredItemsCount = param.starredItemsCount, starredItemsOfflineCount = param.starredItemsOfflineCount, sourcesState = param.sourcesState, setSourcesState = param.setSourcesState, sources = param.sources, setSources = param.setSources, tags = param.tags, reloadAll = param.reloadAll;
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    var canWrite = (0, $bd320d0e16baa5f3$export$b416b77cd328c02f)();
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                id: "nav-logo"
            }),
            canWrite && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                accessKey: "a",
                id: "nav-mark",
                onClick: entriesPage !== null ? entriesPage.markVisibleRead : null,
                disabled: entriesPage === null,
                children: _('markread')
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $5040dba436a03900$export$2e2bcd8739ae039), {
                setNavExpanded: setNavExpanded,
                offlineState: offlineState,
                allItemsCount: allItemsCount,
                allItemsOfflineCount: allItemsOfflineCount,
                unreadItemsCount: unreadItemsCount,
                unreadItemsOfflineCount: unreadItemsOfflineCount,
                starredItemsCount: starredItemsCount,
                starredItemsOfflineCount: starredItemsOfflineCount
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                className: "separator",
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("hr", {})
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                    'nav-ts-wrapper': true,
                    offline: offlineState,
                    online: !offlineState
                }),
                children: [
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $25d64656d90230de$export$2e2bcd8739ae039), {
                        tags: tags,
                        setNavExpanded: setNavExpanded
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a66ee1fb90186752$export$2e2bcd8739ae039), {
                        setNavExpanded: setNavExpanded,
                        navSourcesExpanded: navSourcesExpanded,
                        setNavSourcesExpanded: setNavSourcesExpanded,
                        sourcesState: sourcesState,
                        setSourcesState: setSourcesState,
                        sources: sources,
                        setSources: setSources
                    })
                ]
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                    'nav-unavailable': true,
                    offline: offlineState,
                    online: !offlineState
                }),
                children: [
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("span", {
                        className: "fa-layers fa-2x",
                        children: [
                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                                icon: $37a500ad1dcc914a$exports.faWifi
                            }),
                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                                icon: $c0ffe79f8008445d$exports.faSlash
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("p", {
                        children: _('offline_navigation_unavailable')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                className: "separator",
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("hr", {})
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $4c0fa68710d48580$export$2e2bcd8739ae039), {
                setNavExpanded: setNavExpanded,
                offlineState: offlineState
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $8a7bf68b184288ce$export$2e2bcd8739ae039), {
                reloadAll: reloadAll,
                setNavExpanded: setNavExpanded
            })
        ]
    });
}
$117ab31dd2c08da6$export$2e2bcd8739ae039.propTypes = {
    entriesPage: (0, (/*@__PURE__*/$parcel$interopDefault($cff7e9a474db95c7$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).instanceOf((0, $9b2cb125cea35be7$export$2e2bcd8739ae039))).isRequired,
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    navSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    setNavSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    offlineState: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    allItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    allItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    unreadItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    unreadItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    starredItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    starredItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    sourcesState: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOf(Object.values((0, $d2d3ee75176c5e4c$export$62aa48085237e36f))).isRequired,
    setSourcesState: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    sources: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object).isRequired,
    setSources: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    tags: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object).isRequired,
    reloadAll: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};




var $eHaBZ = parcelRequire("eHaBZ");



var $5XYIU = parcelRequire("5XYIU");



function $3bebfa7a3ec2ab2e$var$splitTerm(term) {
    if (term == '') return [];
    else if (term.match(/^\/.+\/$/)) return [
        term
    ];
    var words = term.match(/"[^"]+"|\S+/g);
    for(var i = 0; i < words.length; i++)words[i] = words[i].replace(/"/g, '');
    return words;
}
function $3bebfa7a3ec2ab2e$var$joinTerm(words) {
    if (!words || words.length <= 0) return '';
    for(var i = 0; i < words.length; i++)if (words[i].indexOf(' ') >= 0) words[i] = '"' + words[i] + '"';
    return words.join(' ');
}
// remove search term
function $3bebfa7a3ec2ab2e$var$handleRemove(param) {
    var index = param.index, location = param.location, navigate = param.navigate, regexSearch = param.regexSearch;
    var newterm;
    if (regexSearch) newterm = '';
    else {
        var queryString = new URLSearchParams(location.search);
        var oldTerm = queryString.get('search');
        var termArray = $3bebfa7a3ec2ab2e$var$splitTerm(oldTerm);
        termArray.splice(index, 1);
        newterm = $3bebfa7a3ec2ab2e$var$joinTerm(termArray);
    }
    navigate((0, $0be080af3052783c$export$7f0beea2aa79e4fa)(location, {
        search: newterm,
        id: null
    }));
}
function $3bebfa7a3ec2ab2e$var$SearchWord(param) {
    var regexSearch = param.regexSearch, index = param.index, item = param.item;
    var location = (0, $5XYIU.useLocation)();
    var navigate = (0, $5XYIU.useNavigate)();
    var removeOnClick = (0, $eHaBZ.useCallback)(function() {
        return $3bebfa7a3ec2ab2e$var$handleRemove({
            index: index,
            location: location,
            navigate: navigate,
            regexSearch: regexSearch
        });
    }, [
        index,
        location,
        navigate,
        regexSearch
    ]);
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
        onClick: removeOnClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
            'regex-search-term': regexSearch
        }),
        children: [
            item,
            " ",
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                icon: $6c06a95c587730ec$exports.faTimes
            })
        ]
    });
}
$3bebfa7a3ec2ab2e$var$SearchWord.propTypes = {
    regexSearch: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    index: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    item: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string.isRequired
};
function $3bebfa7a3ec2ab2e$export$2e2bcd8739ae039() {
    var location = (0, $5XYIU.useLocation)();
    var searchText = (0, $eHaBZ.useMemo)(function() {
        var queryString = new URLSearchParams(location.search);
        var _queryString_get;
        return (_queryString_get = queryString.get('search')) !== null && _queryString_get !== void 0 ? _queryString_get : '';
    }, [
        location.search
    ]);
    var regexSearch = searchText.match(/^\/.+\/$/) !== null;
    var terms = regexSearch ? [
        searchText
    ] : $3bebfa7a3ec2ab2e$var$splitTerm(searchText);
    return terms.map(function(item, index) {
        return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($3bebfa7a3ec2ab2e$var$SearchWord, {
            index: index,
            item: item,
            regexSearch: regexSearch
        }, index);
    });
}



var $2bfPH = parcelRequire("2bfPH");
var $0efeac3f6dc93c13$var$t = [
    "Shift",
    "Meta",
    "Alt",
    "Control"
], $0efeac3f6dc93c13$var$e = "object" == (typeof navigator === "undefined" ? "undefined" : (0, $2bfPH._)(navigator)) ? navigator.platform : "", $0efeac3f6dc93c13$var$n = /Mac|iPod|iPhone|iPad/.test($0efeac3f6dc93c13$var$e), $0efeac3f6dc93c13$var$o = $0efeac3f6dc93c13$var$n ? "Meta" : "Control", $0efeac3f6dc93c13$var$r = "Win32" === $0efeac3f6dc93c13$var$e ? [
    "Control",
    "Alt"
] : $0efeac3f6dc93c13$var$n ? [
    "Alt"
] : [];
function $0efeac3f6dc93c13$var$i(t, e) {
    return "function" == typeof t.getModifierState && (t.getModifierState(e) || $0efeac3f6dc93c13$var$r.includes(e) && t.getModifierState("AltGraph"));
}
function $0efeac3f6dc93c13$export$d0b30d424c95c5e9(t) {
    return t.trim().split(" ").map(function(t) {
        var e = t.split(/\b\+/), n = e.pop(), r = n.match(/^\((.+)\)$/);
        return r && (n = new RegExp("^" + r[1] + "$")), [
            e = e.map(function(t) {
                return "$mod" === t ? $0efeac3f6dc93c13$var$o : t;
            }),
            n
        ];
    });
}
function $0efeac3f6dc93c13$export$5eab49042bbaa75(e, n) {
    var o = n[0], r = n[1];
    return !((r instanceof RegExp ? !r.test(e.key) && !r.test(e.code) : r.toUpperCase() !== e.key.toUpperCase() && r !== e.code) || o.find(function(t) {
        return !$0efeac3f6dc93c13$var$i(e, t);
    }) || $0efeac3f6dc93c13$var$t.find(function(t) {
        return !o.includes(t) && r !== t && $0efeac3f6dc93c13$var$i(e, t);
    }));
}
function $0efeac3f6dc93c13$export$a3db0ee43d16bb47(t, e) {
    var n;
    void 0 === e && (e = {});
    var o = null != (n = e.timeout) ? n : 1e3, r = Object.keys(t).map(function(e) {
        return [
            $0efeac3f6dc93c13$export$d0b30d424c95c5e9(e),
            t[e]
        ];
    }), c = new Map, f = null;
    return function(t) {
        t instanceof KeyboardEvent && (r.forEach(function(e) {
            var n = e[0], o = e[1], r = c.get(n) || n;
            $0efeac3f6dc93c13$export$5eab49042bbaa75(t, r[0]) ? r.length > 1 ? c.set(n, r.slice(1)) : (c.delete(n), o(t)) : $0efeac3f6dc93c13$var$i(t, t.key) || c.delete(n);
        }), f && clearTimeout(f), f = setTimeout(c.clear.bind(c), o));
    };
}
function $0efeac3f6dc93c13$export$6fc42dca60e28416(t, e, n) {
    var o = void 0 === n ? {} : n, r = o.event, i = void 0 === r ? "keydown" : r, a = o.capture, u = $0efeac3f6dc93c13$export$a3db0ee43d16bb47(e, {
        timeout: o.timeout
    });
    return t.addEventListener(i, u, a), function() {
        t.removeEventListener(i, u, a);
    };
}



/**
 * Decorates an event handler so that it only runs
 * when not interacting with an input field or lightbox.
 */ function $f81f2efad81fa28e$var$ignoreWhenInteracting(handler) {
    return function(event) {
        if (selfoss.lightboxActive.value) return;
        // Ignore shortcuts when on input elements.
        // https://github.com/jamiebuilds/tinykeys/issues/17
        var active = document.activeElement;
        var enteringText = active instanceof HTMLElement && (active.isContentEditable || active.tagName === 'INPUT' || active.tagName === 'TEXTAREA');
        if (!enteringText) return handler(event);
    };
}
function $f81f2efad81fa28e$export$2e2bcd8739ae039() {
    return (0, $0efeac3f6dc93c13$export$6fc42dca60e28416)(document, {
        // 'space': next article
        Space: $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.jumpToNext();
        }),
        // 'n': next article
        n: $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.nextPrev((0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).NEXT, false);
        }),
        // 'right cursor': next article
        ArrowRight: $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.entryNav((0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).NEXT);
        }),
        // 'j': next article
        j: $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.nextPrev((0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).NEXT, true);
        }),
        // 'shift+space': previous article
        'Shift+Space': $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.nextPrev((0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).PREV, true);
        }),
        // 'p': previous article
        p: $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.nextPrev((0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).PREV, false);
        }),
        // 'left': previous article
        ArrowLeft: $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.entryNav((0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).PREV);
        }),
        // 'k': previous article
        k: $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.nextPrev((0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).PREV, true);
        }),
        // 's': star/unstar
        s: $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.toggleSelectedStarred();
        }),
        // 'm': mark/unmark
        m: $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.toggleSelectedRead();
        }),
        // 'o': open/close entry
        o: $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.toggleSelectedExpanded();
        }),
        // 'Shift + o': close open entries
        'Shift+o': $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.collapseAllEntries();
        }),
        // 'v': open target
        v: $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.openSelectedTarget();
        }),
        // 'Shift + v': open target and mark read
        'Shift+v': $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.openSelectedTargetAndMarkRead();
        }),
        // 'r': Reload the current view
        r: $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.reload();
        }),
        // 'Shift + r': Refresh sources
        'Shift+r': $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            event.preventDefault();
            document.querySelector('#nav-refresh').click();
        }),
        // 'Control+m': mark all as read
        'Control+m': $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            event.preventDefault();
            document.querySelector('#nav-mark').click();
        }),
        // 't': throw (mark as read & open next)
        t: $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.throw((0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).NEXT);
        }),
        // throw (mark as read & open previous)
        'Shift+t': $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            var _selfoss_entriesPage;
            event.preventDefault();
            (_selfoss_entriesPage = selfoss.entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.throw((0, $b625dc2dd2df76bd$export$cacd6541cfeeb6c1).PREV);
        }),
        // 'Shift+n': switch to newest items overview / menu item
        'Shift+n': $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            event.preventDefault();
            document.querySelector('#nav-filter-newest').click();
        }),
        // 'Shift+u': switch to unread items overview / menu item
        'Shift+u': $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            event.preventDefault();
            document.querySelector('#nav-filter-unread').click();
        }),
        // 'Shift+s': switch to starred items overview / menu item
        'Shift+s': $f81f2efad81fa28e$var$ignoreWhenInteracting(function(event) {
            event.preventDefault();
            document.querySelector('#nav-filter-starred').click();
        })
    });
}









// Unfortunately we need to declare everything manually for Parcel to pick those up.
var $3109e67d2d012138$exports = {};
$3109e67d2d012138$exports = JSON.parse('{"lang_markread":"Marca com llegit","lang_filter":"Filtre","lang_newest":"Nous","lang_unread":"Per llegir","lang_starred":"Preferits","lang_online_count":"Elements disponibles al servidor","lang_offline_count":"Elements disponibles localment","lang_tags":"Etiquetes","lang_alltags":"Totes les etiquetes","lang_timestamp":"{0,date} {0,time}","lang_hours":"fa {0,plural,one {1 hora},other {# hores}}","lang_minutes":"fa {0,plural,one {1 minut},other {# minuts}}","lang_seconds":"fa {0,plural,one {1 segon},other {# segons}}","lang_days":"{0,plural,zero {avui},one {ahir},other {fa # dies}}","lang_star":"Preferit","lang_unstar":"Ja no ho prefereixo","lang_mark":"Marca com llegit","lang_unmark":"Marca com no llegit","lang_load_img":"Mostra les imatges","lang_open_window":"Obre","lang_next":"Seg\xfcent","lang_searchbutton":"Cerca","lang_searchremove":"Amaga la cerca","lang_refreshbutton":"Actualitza les fonts","lang_settingsbutton":"Configuraci\xf3","lang_logoutbutton":"Finalitza la sessi\xf3","lang_loginbutton":"Inicia una sessi\xf3","lang_sources":"Fonts","lang_source_add":"Afegeix una font","lang_source_opml":"o importa des d\'un fitxer opml o des del Google Reader (fins al 15 de juliol de 2013)","lang_source_export":"Exporta les fonts","lang_source_edit":"Edita","lang_source_filter":"Filtra","lang_source_delete":"Esborra","lang_source_warn":"Segur que voleu esborrar la font?","lang_source_new":"Nova font per desar","lang_source_title":"T\xedtol","lang_source_autotitle_hint":"Deixa en blanc per a obtindre el t\xedtol","lang_source_tags":"Etiquetes","lang_source_pwd_placeholder":"No ha canviat","lang_source_comma":"Separat per comes","lang_source_select":"Seleccioneu una font","lang_source_type":"Tipus","lang_source_save":"Desa","lang_source_cancel":"Cancel\xb7la","lang_source_saved":"Desat","lang_source_last_post":"\xdaltima entrada vista","lang_source_refresh":"Actualitza aquesta font","lang_no_entries":"No es van trobar entrades","lang_more":"M\xe9s","lang_login":"Inicia una sessi\xf3","lang_login_username":"Nom d\'usuari","lang_login_password":"Contrasenya","lang_login_invalid_credentials":"Nom d\'usuari o contrasenya incorrectes","lang_login_offline":"Emmagatzematge fora de l\xednia","lang_no_title":"Sense t\xedtol","lang_error":"S\'ha produ\xeft un error","lang_streamerror":"No hi ha cap element carregat. Es recarrega?","lang_reload_list":"Recarrega la llista","lang_sources_refreshed":"S\'han actualitzat les fonts","lang_app_update":"selfoss s\'ha actualitzat, torneu a carregar","lang_app_reload":"Recarrega","lang_error_session_expired":"La sessi\xf3 ha expirat","lang_error_add_source":"No s\'ha pogut afegir la font:","lang_error_delete_source":"No s\'ha pogut esborrar la font:","lang_error_load_tags":"No s\'han pogut carregar les etiquetes:","lang_error_unknown_tag":"Etiqueta desconeguda:","lang_error_unknown_source":"Id de font desconeguda:","lang_error_mark_items":"No s\'han pogut marcar tots els elements visibles:","lang_error_mark_item":"No s\'ha pogut marcar/desmarcar element:","lang_error_star_item":"No s\'ha pogut preferir/despreferir l\'element:","lang_error_logout":"No s\'ha pogut finalitzar la sessi\xf3:","lang_error_loading":"Error de c\xe0rrega:","lang_error_loading_stats":"No s\'han pogut carregar les estad\xedstiques de navegaci\xf3:","lang_error_saving_color":"No s\'ha pogut desar el nou color:","lang_error_refreshing_source":"No s\'han pogut refrescar fonts:","lang_error_sync":"No s\'han pogut sincronitzar els \xfaltims canvis del servidor:","lang_error_offline_storage":"Error d\'emmagatzematge fora de l\xednia: {0}. Recarregar pot ajudar. Es desactiva l\'\xfas fora de l\xednia per ara.","lang_error_invalid_subsection":"Subsecci\xf3 inv\xe0lida:","lang_search_label":"Terme de cerca","lang_article_actions":"Accions","lang_error_configuration":"No es pot carregar la configuraci\xf3.","lang_info_url_copied":"S\'ha copiat l\'URL al portaretalls.","lang_share_native_label":"Comparteix","lang_share_diaspora_label":"Comparteix a Diaspora","lang_share_twitter_label":"Comparteix al Twitter","lang_share_facebook_label":"Comparteix al Facebook","lang_share_pocket_label":"Desa a Pocket","lang_share_wallabag_label":"Desa a Wallabag","lang_share_wordpress_label":"Comparteix a WordPress","lang_share_mail_label":"Comparteix per correu electr\xf2nic","lang_share_copy_label":"Copia l\'enlla\xe7 al portaretalls","lang_error_share_native_abort":"No es pot compartir l\'element\u2014o no hi ha destinacions de compartici\xf3, o ho heu cancel\xb7lat.","lang_error_share_native":"No es pot compartir l\'element.","lang_close_entry":"Tanca","lang_error_unwritable_logs":"No es poden escriure els registres.","lang_error_check_system_logs":"S\'ha produ\xeft un error. Comproveu els registres del sistema.","lang_error_check_log_file":"S\'ha produ\xeft un error. Comprova el fitxer de registre \u201C{0}\u201D.","lang_offline_navigation_unavailable":"Canviar etiquetes i fonts no \xe9s disponible en el mode fora de l\xednia.","lang_error_offline_storage_not_available":"Emmagatzematge fora de l\xednia no disponible. Assegureu-vos que el navegador {0}suporta IndexedDB API{1}. Si utilitzeu un navegador basat en Google Chrome, que no estigueu utilitzant selfoss en mode inc\xf2gnit.","lang_error_edit_source":"No es pot desar els canvis a les fonts:","lang_article_reading_time":"{0} min lectura","lang_experimental":"Experimental","lang_source_menu":"M\xe9s accions","lang_source_browse":"Navega","lang_sources_leaving_unsaved_prompt":"Voleu deixar la configuraci\xf3 amb els canvis de font no desats?","lang_source_warn_cancel_dirty":"Vols descartar els canvis no desats?","lang_tag_change_color_button_title":"Canvia el color","lang_sources_loading":"S\'estan carregant les fonts\u2026","lang_source_deleting":"S\'est\xe0 suprimint la font\u2026","lang_source_params_loading":"S\'estan carregant els par\xe0metres\u2026","lang_no_sources":"No hi ha fonts configurades.","lang_source_saving":"S\'estan desant els canvis a la font\u2026","lang_source_go_to_settings":"Obre a la configuraci\xf3","lang_entries_loading":"S\'estan carregant les entrades\u2026","lang_login_in_progress":"S\'est\xe0 intentant iniciar sessi\xf3\u2026","lang_login_error_generic":"No s\'ha pogut iniciar sessi\xf3: {errorMessage}","lang_error_unauthorized":"Si us plau, {link_begin}inicieu sessi\xf3{link_end} per a continuar.","lang_share_mastodon_label":"Comparteix a Mastodon"}');


var $3f89fcb2517a5831$exports = {};
$3f89fcb2517a5831$exports = JSON.parse('{"lang_markread":"Ozna\u010Dit jako p\u0159e\u010Dten\xe9","lang_filter":"Zobrazovat","lang_newest":"Nejnov\u011Bj\u0161\xed","lang_unread":"Nep\u0159e\u010Dten\xe9","lang_starred":"Ozna\u010Den\xe9","lang_tags":"\u0160t\xedtky","lang_alltags":"V\u0161echny \u0161t\xedtky","lang_timestamp":"{0,date} {0,time}","lang_hours":"p\u0159ed {0,plural,one {1 hodinou},other {# hodinami}}","lang_minutes":"p\u0159ed {0,plural,one {1 minutou},other {# minutami}}","lang_seconds":"p\u0159ed {0,plural,one {chv\xedl\xed},other {# sekundami}}","lang_days":"{0,plural,zero {dnes},one {v\u010Dera},other {p\u0159ed # dny}}","lang_star":"Ozna\u010Dit","lang_unstar":"Odzna\u010Dit","lang_mark":"Ozna\u010Dit jako p\u0159e\u010Dten\xe9","lang_unmark":"Ozna\u010Dit jako nep\u0159e\u010Dten\xe9","lang_load_img":"Zobrazit obr\xe1zky","lang_open_window":"Otev\u0159\xedt","lang_next":"Dal\u0161\xed","lang_search_label":"Vyhled\xe1van\xfd text","lang_searchbutton":"Hledat","lang_searchremove":"Skr\xfdt hled\xe1n\xed","lang_refreshbutton":"Obnovit zdroje","lang_settingsbutton":"Nastaven\xed","lang_logoutbutton":"Odhl\xe1sit se","lang_loginbutton":"P\u0159ihl\xe1sit se","lang_sources":"Zdroje","lang_sources_loading":"Na\u010D\xedt\xe1n\xed zdroj\u016F\u2026","lang_no_sources":"Nejsou nastaveny \u017E\xe1dn\xe9 zdroje.","lang_source_add":"P\u0159idat zdroj","lang_source_opml":"nebo nahr\xe1t opml soubor","lang_source_export":"Export zdroj\u016F","lang_source_edit":"Upravit","lang_source_filter":"Filtr","lang_source_menu":"V\xedce akc\xed","lang_source_browse":"Prohl\xed\u017Eet","lang_source_delete":"Smazat","lang_source_warn":"Opravdu chcete tento zdroj smazat?","lang_source_deleting":"Maz\xe1n\xed zdroje\u2026","lang_source_warn_cancel_dirty":"Opravdu chcete zahodit neulo\u017Een\xe9 zm\u011Bny?","lang_source_new":"Nov\xfd neulo\u017Een\xfd zdroj","lang_source_title":"N\xe1zev","lang_source_autotitle_hint":"Pro automatick\xe9 vypln\u011Bn\xed ponechte pr\xe1zdn\xe9","lang_source_tags":"\u0160t\xedtky","lang_source_pwd_placeholder":"Beze zm\u011Bny","lang_source_comma":"Odd\u011Blen\xe9 \u010D\xe1rkou","lang_source_select":"Vyberte pros\xedm zdroj","lang_source_params_loading":"Na\u010D\xedt\xe1n\xed parametr\u016F\u2026","lang_source_type":"Typ","lang_source_save":"Ulo\u017Eit","lang_source_cancel":"Zru\u0161it","lang_source_saving":"Ukl\xe1d\xe1n\xed zm\u011Bn zdroje\u2026","lang_source_saved":"Ulo\u017Eeno","lang_source_last_post":"Posledn\xed p\u0159\xedsp\u011Bvek spat\u0159en","lang_source_refresh":"Obnovit tento zdroj","lang_source_go_to_settings":"Otev\u0159\xedt v\xa0nastaven\xed","lang_sources_leaving_unsaved_prompt":"Na str\xe1nce jsou neulo\u017Een\xe9 zm\u011Bny. Opravdu chcete opustit nastaven\xed?","lang_tag_change_color_button_title":"Zm\u011Bnit barvu","lang_entries_loading":"Na\u010D\xedt\xe1n\xed z\xe1znam\u016F\u2026","lang_no_entries":"\u017D\xe1dn\xfd z\xe1znam","lang_more":"V\xedce","lang_login":"P\u0159ihl\xe1sit","lang_login_in_progress":"P\u0159ihla\u0161ov\xe1n\xed\u2026","lang_login_username":"Jm\xe9no","lang_login_password":"Heslo","lang_login_invalid_credentials":"\u0160patn\xe9 jm\xe9no nebo heslo","lang_login_error_generic":"Pokus o p\u0159ihl\xe1\u0161en\xed selhal: {errorMessage}","lang_no_title":"Bez titulku","lang_error":"Nastala chyba","lang_error_unauthorized":"Pro pokra\u010Dov\xe1n\xed se pros\xedm {link_begin}p\u0159ihlaste{link_end}.","lang_error_check_log_file":"Nastala chyba, zkontrolujte pros\xedm z\xe1znamy v\xa0souboru \u201E{0}\u201C.","lang_error_check_system_logs":"Nastala chyba, zkontrolujte pros\xedm z\xe1znamy v\xa0opera\u010Dn\xedm syst\xe9mu.","lang_error_unwritable_logs":"Nebylo mo\u017En\xe9 zaznamenat chybu.","lang_streamerror":"Nena\u010Dteny \u017E\xe1dn\xe9 polo\u017Eky, zkusit znovu?","lang_reload_list":"Znovu na\u010D\xedst seznam","lang_sources_refreshed":"Zdroje byly obnoveny","lang_error_session_expired":"Va\u0161e sezen\xed vypr\u0161elo","lang_error_add_source":"Zdroj nemohl b\xfdt p\u0159id\xe1n:","lang_error_delete_source":"Zdroj nemohl b\xfdt smaz\xe1n:","lang_error_load_tags":"\u0160t\xedtky nemohly b\xfdt na\u010Dteny:","lang_error_unknown_tag":"Nezn\xe1m\xfd \u0161t\xedtek:","lang_error_unknown_source":"Nezn\xe1m\xe9 id zdroje:","lang_error_mark_items":"Nelze ozna\u010Dit v\u0161echny viditeln\xe9 zdroje:","lang_error_mark_item":"Nelze ozna\u010Dit polo\u017Eku za (ne)p\u0159e\u010Dtenou:","lang_error_star_item":"Nelze o(d)zna\u010Dit polo\u017Eku hv\u011Bzdi\u010Dkou:","lang_error_logout":"Odhl\xe1\u0161en\xed se nezda\u0159ilo:","lang_error_loading":"Chyba na\u010D\xedt\xe1n\xed:","lang_error_loading_stats":"Na\u010D\xedt\xe1n\xed statistik se nezda\u0159ilo:","lang_error_saving_color":"Nelze zm\u011Bnit barvu:","lang_error_refreshing_source":"Nelze obnovit zdroje:","lang_error_sync":"Synchronizace zm\u011Bn ze serveru selhala:","lang_error_invalid_subsection":"Podsekce neexistuje:","lang_online_count":"Polo\u017Eky dostupn\xe9 na serveru","lang_offline_count":"Polo\u017Eky jsou dostupn\xe9 v prohl\xed\u017Ee\u010Di","lang_offline_navigation_unavailable":"Offline re\u017Eim zat\xedm neumo\u017E\u0148uje p\u0159ep\xednat mezi \u0161t\xedtky a zdroji.","lang_login_offline":"Ukl\xe1dat data v prohl\xed\u017Ee\u010Di","lang_app_update":"selfoss byl aktualizov\xe1n, pros\xedm znovu na\u010Dt\u011Bte str\xe1nku","lang_app_reload":"Znovu na\u010D\xedst","lang_error_offline_storage":"Chyba lok\xe1ln\xedho \xfalo\u017Ei\u0161t\u011B: {0}. Mo\u017En\xe1 pom\u016F\u017Ee znovuna\u010Dten\xed str\xe1nky. Prozat\xedm bude ukl\xe1d\xe1n\xed vypnuto.","lang_article_actions":"Akce","lang_error_configuration":"Nelze na\u010D\xedst konfiguraci.","lang_share_native_label":"Sd\xedlet","lang_share_diaspora_label":"Sd\xedlet na Diaspo\u0159e","lang_share_twitter_label":"Sd\xedlet na Twitteru","lang_share_facebook_label":"Sd\xedlet na Facebooku","lang_share_pocket_label":"Ulo\u017Eit do Pocketu","lang_share_wallabag_label":"Ulo\u017Eit do Wallabagu","lang_share_wordpress_label":"Sd\xedlet na WordPressu","lang_share_mail_label":"Sd\xedlet e-mailem","lang_share_copy_label":"Zkop\xedrovat odkaz do schr\xe1nky","lang_info_url_copied":"URL zkop\xedrov\xe1na do schr\xe1nky.","lang_error_share_native_abort":"Nelze sd\xedlet polo\u017Eku: bu\u010F v\xe1\u0161 prohl\xed\u017Ee\u010D nepodporuje sd\xedlen\xed odkaz\u016F, nebo jste sd\xedlen\xed zru\u0161ili.","lang_error_share_native":"Nelze sd\xedlet polo\u017Eku.","lang_close_entry":"Zav\u0159\xedt","lang_article_reading_time":"{0} min \u010Dten\xed","lang_error_offline_storage_not_available":"Offline \xfalo\u017Ei\u0161t\u011B nen\xed dostupn\xe9. Ujist\u011Bte se, \u017Ee v\xe1\u0161 prohl\xed\u017Ee\u010D {0}podporuje rozhran\xed IndexedDB{1} a, pokud pou\u017E\xedv\xe1te prohl\xed\u017Ee\u010D zalo\u017Een\xfd na Google Chrome, \u017Ee nespou\u0161t\xedte selfoss v re\u017Eimu anonymn\xedho prohl\xed\u017Een\xed.","lang_error_edit_source":"Nelze ulo\u017Eit zm\u011Bny zdroje:","lang_experimental":"Experiment"}');


var $efc21f73bdbf3d30$exports = {};
$efc21f73bdbf3d30$exports = JSON.parse('{"lang_markread":"Alles gelesen","lang_newest":"Neueste","lang_unread":"Ungelesen","lang_starred":"Favoriten","lang_tags":"Markierungen","lang_alltags":"Alle Markierungen","lang_timestamp":"{0,date} {0,time}","lang_hours":"vor {0,plural,one {1 Stunde},other {# Stunden}}","lang_minutes":"vor {0,plural,one {1 Minute},other {# Minuten}}","lang_seconds":"{0,plural,one {Jetzt gerade},other {vor # Sekunden}}","lang_days":"{0,plural,zero {heute},one {gestern},other {vor # Tagen}}","lang_star":"behalten","lang_unstar":"vergessen","lang_mark":"als gelesen markieren","lang_unmark":"als ungelesen markieren","lang_load_img":"Zeige Bilder","lang_open_window":"\xf6ffnen","lang_next":"weiter","lang_searchbutton":"suchen","lang_refreshbutton":"Quellen aktualisieren","lang_settingsbutton":"Einstellungen","lang_logoutbutton":"Abmelden","lang_loginbutton":"Anmelden","lang_sources":"Quellen","lang_source_add":"Quelle hinzuf\xfcgen","lang_source_opml":"oder OPML-Datei oder Google Reader importieren","lang_source_export":"Quellen exportieren","lang_source_edit":"bearbeiten","lang_source_filter":"Filter","lang_source_delete":"l\xf6schen","lang_source_warn":"Wirklich diesen Feed entfernen?","lang_source_new":"Neue ungespeicherte Quelle","lang_source_title":"Titel","lang_source_autotitle_hint":"Leer lassen um automatisch Titel zu setzen","lang_source_tags":"Markierungen","lang_source_pwd_placeholder":"Nicht ge\xe4ndert","lang_source_comma":"Komma getrennt","lang_source_select":"Quelle ausw\xe4hlen","lang_source_type":"Typ","lang_source_save":"speichern","lang_source_cancel":"abbrechen","lang_source_saved":"gespeichert","lang_source_last_post":"Letzter gesehener Beitrag","lang_no_entries":"keine Eintr\xe4ge gefunden","lang_more":"mehr","lang_login":"Anmelden","lang_login_username":"Benutzername","lang_login_password":"Passwort","lang_no_title":"kein Titel","lang_error":"Ein Fehler ist aufgetreten","lang_filter":"Filter","lang_online_count":"Auf dem Server verf\xfcgbare Elemente","lang_offline_count":"Lokal verf\xfcgbare Artikel","lang_searchremove":"Suche ausblenden","lang_source_refresh":"Diese Quelle aktualisieren","lang_login_invalid_credentials":"Falscher Benutzername/Passwort","lang_login_offline":"Offline-Speicherung","lang_streamerror":"Keine Artikel geladen, neu laden?","lang_reload_list":"Liste neu laden","lang_sources_refreshed":"Quellen aktualisiert","lang_app_update":"selfoss wurde aktualisiert, bitte neu laden","lang_app_reload":"Neu laden","lang_error_session_expired":"Session abgelaufen","lang_error_add_source":"Die Quelle konnte nicht hinzugef\xfcgt werden:","lang_error_delete_source":"Die Quelle konnte nicht gel\xf6scht werden:","lang_error_load_tags":"Konnte Markierungen nicht laden:","lang_error_unknown_tag":"Unbekannte Markierung:","lang_error_unknown_source":"Unbekannte Quell-ID:","lang_error_mark_items":"Es k\xf6nnen nicht alle sichtbaren Elemente markiert werden:","lang_error_mark_item":"Das Markieren/Deaktivieren von Elementen ist nicht m\xf6glich:","lang_error_star_item":"Artikel kann nicht ge-sternt oder ent-sternt werden:","lang_error_logout":"Konnte nicht ausloggen:","lang_error_loading":"Ladefehler:","lang_error_loading_stats":"Nav-Statistiken k\xf6nnen nicht geladen werden:","lang_error_saving_color":"Neue Farbe kann nicht gespeichert werden:","lang_error_refreshing_source":"Quellen k\xf6nnen nicht aktualisiert werden:","lang_error_sync":"Letzte \xc4nderungen vom Server konnten nicht synchronisiert werden:","lang_error_offline_storage":"Offline-Speicherfehler: {0}. Neu laden k\xf6nnte helfen. Deaktiviere offline vorerst.","lang_error_invalid_subsection":"Ung\xfcltiger Unterabschnitt:","lang_search_label":"Suchbegriff","lang_article_actions":"Aktionen","lang_error_configuration":"Nicht m\xf6glich die Konfiguration zu laden.","lang_info_url_copied":"URL in die Zwischenablage kopiert.","lang_share_native_label":"teilen","lang_share_diaspora_label":"auf Diaspora teilen","lang_share_twitter_label":"auf Twitter teilen","lang_share_facebook_label":"auf Facebook teilen","lang_share_mastodon_label":"auf Mastodon teilen","lang_share_pocket_label":"in Pocket speichern","lang_share_wallabag_label":"in Wallabag speichern","lang_share_wordpress_label":"teile auf WordPress","lang_share_mail_label":"per E-Mail teilen","lang_share_copy_label":"Link in die Zwischenablage kopieren","lang_error_share_native_abort":"Es ist nicht m\xf6glich das Objekt zu teilen\u202F\u2013\u202Fentweder gibt es keine Ziele zum Teilen oder die Aktion wurde abgebrochen.","lang_error_share_native":"Es ist nicht m\xf6glich das Objekt zu teilen.","lang_close_entry":"Schlie\xdfen","lang_error_offline_storage_not_available":"Offline-Speicherung ist nicht verf\xfcgbar. Stelle sicher, dass dein Browser die {0}IndexedDB-API unterst\xfctzt{1} und, falls du einen Browser auf Grundlage von Google Chrome benutzt, dass du selfoss nicht im Incognito-Modus ausf\xfchrst.","lang_error_edit_source":"Konnte die \xc4nderungen an den Quellen nicht speichern:","lang_error_unwritable_logs":"Logdateien konnten nicht geschrieben werden.","lang_error_check_system_logs":"Ein Fehler ist aufgetreten, bitte die Systemlogs pr\xfcfen.","lang_error_check_log_file":"Es ist ein Fehler aufgetreten, bitte Protokolldatei \u201E{0}\u201C pr\xfcfen.","lang_offline_navigation_unavailable":"Markierungen und Quellen zu wechseln wird derzeit im Offline-Modus nicht unterst\xfctzt."}');


var $e8fba7b0a3114fd9$exports = {};
$e8fba7b0a3114fd9$exports = JSON.parse('{"lang_markread":"Mark as read","lang_filter":"Filter","lang_newest":"Newest","lang_unread":"Unread","lang_starred":"Starred","lang_online_count":"Items available on the server","lang_offline_count":"Items available locally","lang_offline_navigation_unavailable":"Switching tags and sources is currently not available in offline mode.","lang_tags":"Tags","lang_alltags":"All tags","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 hour},other {# hours}} ago","lang_minutes":"{0,plural,one {1 minute},other {# minutes}} ago","lang_seconds":"{0,plural,one {1 second},other {# seconds}} ago","lang_days":"{0,plural,zero {today},one {yesterday},other {# days ago}}","lang_star":"Star","lang_unstar":"Unstar","lang_mark":"Mark as read","lang_unmark":"Mark as unread","lang_load_img":"Show images","lang_open_window":"Open","lang_next":"Next","lang_share_native_label":"Share","lang_share_diaspora_label":"Share on Diaspora","lang_share_twitter_label":"Share on Twitter","lang_share_facebook_label":"Share on Facebook","lang_share_mastodon_label":"Share on Mastodon","lang_share_pocket_label":"Save to Pocket","lang_share_wallabag_label":"Save to Wallabag","lang_share_wordpress_label":"Share on WordPress","lang_share_mail_label":"Share using e-mail","lang_share_copy_label":"Copy link to clipboard","lang_search_label":"Search term","lang_searchbutton":"Search","lang_searchremove":"Hide search","lang_refreshbutton":"Refresh sources","lang_settingsbutton":"Settings","lang_logoutbutton":"Log out","lang_loginbutton":"Log in","lang_sources":"Sources","lang_sources_loading":"Loading sources\u2026","lang_no_sources":"No sources configured.","lang_source_add":"Add source","lang_source_opml":"or import an OPML file","lang_source_export":"Export sources","lang_source_edit":"Edit","lang_source_filter":"Filter","lang_source_menu":"More actions","lang_source_browse":"Browse","lang_source_delete":"Delete","lang_source_warn":"Really delete this source?","lang_source_deleting":"Deleting source\u2026","lang_source_warn_cancel_dirty":"Discard unsaved changes?","lang_source_new":"New unsaved source","lang_source_title":"Title","lang_source_autotitle_hint":"Leave empty to fetch title","lang_source_tags":"Tags","lang_source_pwd_placeholder":"Not changed","lang_source_comma":"Comma separated","lang_source_select":"Please select source","lang_source_params_loading":"Loading parameters\u2026","lang_source_type":"Type","lang_source_save":"Save","lang_source_cancel":"Cancel","lang_source_saving":"Saving source changes\u2026","lang_source_saved":"Saved","lang_source_last_post":"Last post seen","lang_source_refresh":"Refresh this source","lang_source_go_to_settings":"Open in settings","lang_sources_leaving_unsaved_prompt":"Leave settings with unsaved source changes?","lang_tag_change_color_button_title":"Change color","lang_entries_loading":"Loading entries\u2026","lang_no_entries":"No entries found","lang_more":"More","lang_login":"Log in","lang_login_in_progress":"Trying to log in\u2026","lang_login_username":"Username","lang_login_password":"Password","lang_login_invalid_credentials":"Wrong username/password","lang_login_error_generic":"Could not log in: {errorMessage}","lang_login_offline":"Offline storage","lang_no_title":"No title","lang_experimental":"Experimental","lang_error":"An error occurred","lang_error_unauthorized":"Please {link_begin}sign in{link_end} to continue.","lang_error_check_log_file":"An error occured, please check the log file \u201C{0}\u201D.","lang_error_check_system_logs":"An error occured, please check your system logs.","lang_error_unwritable_logs":"Unable to write logs.","lang_streamerror":"No items loaded, reload?","lang_reload_list":"Reload list","lang_sources_refreshed":"Sources refreshed","lang_app_update":"selfoss has been updated, please reload","lang_app_reload":"Reload","lang_error_session_expired":"Session expired","lang_error_add_source":"Could not add source:","lang_error_edit_source":"Could not save source changes:","lang_error_delete_source":"Could not delete source:","lang_error_load_tags":"Could not load tags:","lang_error_unknown_tag":"Unknown tag:","lang_error_unknown_source":"Unknown source ID:","lang_error_mark_items":"Cannot mark all visible items:","lang_error_mark_item":"Cannot mark/unmark item:","lang_error_star_item":"Cannot star/unstar item:","lang_error_logout":"Could not log out:","lang_error_loading":"Loading error:","lang_error_loading_stats":"Cannot load nav stats:","lang_error_saving_color":"Cannot save new color:","lang_error_refreshing_source":"Cannot refresh sources:","lang_error_sync":"Could not sync last changes from server:","lang_error_offline_storage":"Offline storage error: {0}. Reloading may help. Disabling offline for now.","lang_error_offline_storage_not_available":"Offline storage is not available. Make sure your web browser {0}supports IndexedDB API{1} and, if you are using Google Chrome based browser, that you are not running selfoss in incognito mode.","lang_error_invalid_subsection":"Invalid subsection:","lang_error_configuration":"Unable to load configuration.","lang_error_share_native_abort":"Unable to share item\u2014either there are no share targets, or you cancelled it.","lang_error_share_native":"Unable to share item.","lang_info_url_copied":"URL copied to clipboard.","lang_close_entry":"Close","lang_article_actions":"Actions","lang_article_reading_time":"{0} min read"}');


var $9bb1025262b0fb39$exports = {};
$9bb1025262b0fb39$exports = JSON.parse('{"lang_error_share_native_abort":"Unable to share item\u202F\u2013\u202Feither there are no share targets, or you cancelled it.","lang_error_saving_color":"Cannot save new colour:","lang_close_entry":"Close","lang_error_share_native":"Unable to share item.","lang_share_copy_label":"Copy link to clipboard","lang_share_mail_label":"Share using e-mail","lang_share_wordpress_label":"Share on WordPress","lang_share_wallabag_label":"Save to Wallabag","lang_share_pocket_label":"Save to Pocket","lang_share_facebook_label":"Share on Facebook","lang_share_twitter_label":"Share on Twitter","lang_share_diaspora_label":"Share on Diaspora","lang_share_native_label":"Share","lang_info_url_copied":"URL copied to clipboard.","lang_error_configuration":"Unable to load configuration.","lang_article_actions":"Actions","lang_search_label":"Search term","lang_error_invalid_subsection":"Invalid subsection:","lang_error_offline_storage":"Offline storage error: {0}. Reloading may help. Disabling offline for now.","lang_error_sync":"Could not sync last changes from server:","lang_error_refreshing_source":"Cannot refresh sources:","lang_error_loading_stats":"Cannot load nav stats:","lang_error_loading":"Loading error:","lang_error_logout":"Could not log out:","lang_error_star_item":"Cannot star/unstar item:","lang_error_mark_item":"Cannot mark/unmark item:","lang_error_mark_items":"Cannot mark all visible items:","lang_error_unknown_source":"Unknown source ID:","lang_error_unknown_tag":"Unknown tag:","lang_error_load_tags":"Could not load tags:","lang_error_delete_source":"Could not delete source:","lang_error_add_source":"Could not add source:","lang_error_session_expired":"Session expired","lang_app_reload":"Reload","lang_app_update":"selfoss has been updated, please reload","lang_sources_refreshed":"Sources refreshed","lang_reload_list":"Reload list","lang_streamerror":"No items loaded, reload?","lang_error":"An error occurred","lang_no_title":"No title","lang_login_offline":"Offline storage","lang_login_invalid_credentials":"Wrong username/password","lang_login_password":"Password","lang_login_username":"Username","lang_login":"Log in","lang_more":"More","lang_no_entries":"No entries found","lang_source_refresh":"Refresh this source","lang_source_last_post":"Last post seen","lang_source_saved":"Saved","lang_source_cancel":"Cancel","lang_source_save":"Save","lang_source_type":"Type","lang_source_select":"Please select source","lang_source_comma":"Comma separated","lang_source_pwd_placeholder":"Not changed","lang_source_tags":"Tags","lang_source_autotitle_hint":"Leave empty to fetch title","lang_source_title":"Title","lang_source_new":"New unsaved source","lang_source_warn":"Really delete this source?","lang_source_delete":"Delete","lang_source_filter":"Filter","lang_source_edit":"Edit","lang_source_export":"Export sources","lang_source_opml":"or import an OPML file","lang_source_add":"Add source","lang_sources":"Sources","lang_loginbutton":"Log in","lang_logoutbutton":"Log out","lang_settingsbutton":"Settings","lang_refreshbutton":"Refresh sources","lang_searchremove":"Hide search","lang_searchbutton":"Search","lang_next":"Next","lang_open_window":"Open","lang_load_img":"Show images","lang_unmark":"Mark as unread","lang_mark":"Mark as read","lang_unstar":"Unstar","lang_star":"Star","lang_days":"{0,plural,zero {today},one {yesterday},other {# days ago}}","lang_seconds":"{0,plural,one {1 second},other {# seconds}} ago","lang_minutes":"{0,plural,one {1 minute},other {# minutes}} ago","lang_hours":"{0,plural,one {1 hour},other {# hours}} ago","lang_timestamp":"{0,date} {0,time}","lang_alltags":"All tags","lang_tags":"Tags","lang_offline_count":"Items available locally","lang_online_count":"Items available on the server","lang_starred":"Starred","lang_unread":"Unread","lang_newest":"Newest","lang_filter":"Filter","lang_markread":"Mark as read","lang_error_offline_storage_not_available":"Offline storage is not available. Make sure your web browser {0}supports IndexedDB API{1} and, if you are using Google Chrome based browser, that you are not running selfoss in incognito mode.","lang_error_edit_source":"Could not save source changes:","lang_error_unwritable_logs":"Unable to write logs.","lang_error_check_system_logs":"An error occured, please check your system logs.","lang_error_check_log_file":"An error occured, please check the log file \u2018{0}\u2019.","lang_offline_navigation_unavailable":"Switching tags and sources is currently not available in offline mode.","lang_experimental":"Experimental","lang_entries_loading":"Loading entries\u2026","lang_login_in_progress":"Trying to log in\u2026","lang_login_error_generic":"Could not log in: {errorMessage}","lang_error_unauthorized":"Please {link_begin}sign in{link_end} to continue.","lang_no_sources":"No sources configured.","lang_source_menu":"More actions","lang_source_browse":"Browse","lang_source_params_loading":"Loading parameters\u2026","lang_sources_loading":"Loading sources\u2026","lang_source_deleting":"Deleting source\u2026","lang_source_saving":"Saving source changes\u2026","lang_source_go_to_settings":"Open in settings","lang_source_warn_cancel_dirty":"Discard unsaved changes?","lang_sources_leaving_unsaved_prompt":"Leave settings with unsaved source changes?","lang_tag_change_color_button_title":"Change colour","lang_article_reading_time":"{0} min read","lang_share_mastodon_label":"Share on Mastodon"}');


var $8ae9bc6f67c8887e$exports = {};
$8ae9bc6f67c8887e$exports = JSON.parse('{"lang_markread":"marcar como le\xeddo","lang_filter":"filtro","lang_newest":"nuevos","lang_unread":"no le\xeddos","lang_starred":"preferidos","lang_online_count":"Elementos disponibles en el servidor","lang_offline_count":"Elementos disponibles localmente","lang_tags":"Etiquetas","lang_alltags":"todas las etiquetas","lang_timestamp":"{0,date} {0,time}","lang_hours":"hace {0,plural,one {1 hora},other {# horas}}","lang_minutes":"hace {0,plural,one {1 minuto},other {# minutos}}","lang_seconds":"hace {0,plural,one {1 segundo},other {# segundos}}","lang_days":"{0,plural,zero {hoy},one {ayer},other {hace # d\xedas}}","lang_star":"preferido","lang_unstar":"ya no lo prefiero","lang_mark":"marcar como le\xeddo","lang_unmark":"marcar como no le\xeddo","lang_load_img":"cargar Im\xe1genes","lang_open_window":"abrir","lang_next":"siguiente","lang_searchbutton":"buscar","lang_searchremove":"ocultar b\xfasqueda","lang_refreshbutton":"actualizar fuentes","lang_settingsbutton":"configuraci\xf3n","lang_logoutbutton":"cerrar sesi\xf3n","lang_loginbutton":"iniciar sesi\xf3n","lang_sources":"Fuentes","lang_source_add":"agregar fuente","lang_source_opml":"o importar desde un archivo opml o desde Google Reader (Hasta el 15 de Julio de 2013)","lang_source_export":"exportar fuentes","lang_source_edit":"editar","lang_source_filter":"Filtrar","lang_source_delete":"borrar","lang_source_warn":"realmente desea borrar esta fuente?","lang_source_new":"nueva fuente sin guardar","lang_source_title":"Titulo","lang_source_autotitle_hint":"Dejar en blanco para obtener t\xedtulo","lang_source_tags":"Etiquetas","lang_source_pwd_placeholder":"no ha cambiado","lang_source_comma":"separado por comas","lang_source_select":"por favor seleccione una fuente","lang_source_type":"Tipo","lang_source_save":"Guardar","lang_source_cancel":"cancelar","lang_source_saved":"Guardado","lang_source_last_post":"\xdaltima entrada vista","lang_source_refresh":"Actualizar esta fuente","lang_no_entries":"No se encontraron entradas","lang_more":"m\xe1s","lang_login":"iniciar sesi\xf3n","lang_login_username":"usuario","lang_login_password":"contrase\xf1a","lang_login_invalid_credentials":"usuario/contrase\xf1a incorrectos","lang_login_offline":"Almacenaje fuera de l\xednea","lang_no_title":"sin t\xedtulo","lang_error":"ha ocurrido un error","lang_streamerror":"Ning\xfan elemento cargado, \xbfrecargar?","lang_reload_list":"Recargar lista","lang_sources_refreshed":"Las fuentes han sido refrescadas","lang_app_update":"selfoss ha sido actualizado, recargue","lang_app_reload":"Recargar","lang_error_session_expired":"La sesi\xf3n ha expirado","lang_error_add_source":"Error a\xf1adiendo fuente:","lang_error_delete_source":"Error borrando fuente:","lang_error_load_tags":"Error cargando etiquetas:","lang_error_unknown_tag":"Etiqueta desconocida:","lang_error_unknown_source":"Id de fuente desconocido:","lang_error_mark_items":"No se pudo marcar todos los elementos visibles:","lang_error_mark_item":"No se pudo marcar/desmarcar elemento:","lang_error_star_item":"No se pudo preferir/despreferir elemento:","lang_error_logout":"No se pudo registrar:","lang_error_loading":"Error cargando:","lang_error_loading_stats":"No se pudo cargar estad\xedsticas de navegaci\xf3n:","lang_error_saving_color":"No se pudo cargar nuevo color:","lang_error_refreshing_source":"No se pudo refrescar fuentes:","lang_error_sync":"No se pudo sincronizar los \xfaltimos cambios del servidor:","lang_error_offline_storage":"Error de almacenaje fuera de l\xednea: {0}. Recargar puede ayudar. Desactivando uso fuera de l\xednea por ahora.","lang_error_invalid_subsection":"Subsecci\xf3n inv\xe1lida:","lang_search_label":"Buscar t\xe9rmino","lang_article_actions":"Acciones","lang_error_configuration":"Imposible cargar configuraci\xf3n.","lang_info_url_copied":"URL copiada al portapapeles.","lang_share_native_label":"Compartir","lang_share_diaspora_label":"Compartir en Diaspora","lang_share_twitter_label":"Compartir en Twitter","lang_share_facebook_label":"Compartir en Facebook","lang_share_pocket_label":"Guardar en Pocket","lang_share_wallabag_label":"Guardar en Wallabag","lang_share_wordpress_label":"Compartir en WordPress","lang_share_mail_label":"Compartir por e-mail","lang_share_copy_label":"Copiar enlace al portapapeles","lang_error_share_native_abort":"Imposible compartir \xedtem-no hay objetivos que compartir, o has cancelado.","lang_error_share_native":"Imposible compartir \xedtem.","lang_close_entry":"Cerrar","lang_error_unwritable_logs":"Imposible escribir logs.","lang_error_check_system_logs":"Un error ha ocurido, por favor comprueba tus logs de sistema.","lang_error_check_log_file":"Un error ha ocurrido, por favor comprueba el fichero de log \u201C{0}\u201D.","lang_offline_navigation_unavailable":"Cambiar etiquetas y fuentes no est\xe1 disponible en el modo fuera de l\xednea.","lang_error_offline_storage_not_available":"Almacenaje fuera de l\xednea no est\xe1 disponible. Aseg\xfarese que su navegador {0}soporta IndexedDB API{1} y, si est\xe1 utilizando un navegador basado en Google Chrome, que no est\xe1 usando selfoss en modo inc\xf3gnito.","lang_error_edit_source":"No se pudo guardar los cambios en las fuentes:","lang_experimental":"Experimental","lang_article_reading_time":"{0} min lectura","lang_sources_loading":"Cargando fuentes\u2026","lang_source_warn_cancel_dirty":"\xbfDescartar los cambios no guardados?","lang_error_unauthorized":"Por favor, {link_begin}firme{link_end} para continuar.","lang_no_sources":"No hay fuentes configuradas.","lang_source_menu":"M\xe1s acciones","lang_source_browse":"Navegar","lang_source_deleting":"Borrando fuente\u2026","lang_source_params_loading":"Cargando par\xe1metros\u2026","lang_login_in_progress":"Intentando iniciar sesi\xf3n\u2026","lang_source_saving":"Guardando cambios en la fuente\u2026","lang_source_go_to_settings":"Abrir en los ajustes","lang_tag_change_color_button_title":"Cambiar el color","lang_entries_loading":"Cargando las entradas\u2026","lang_login_error_generic":"No se ha podido iniciar la sesi\xf3n: {errorMessage}","lang_sources_leaving_unsaved_prompt":"\xbfDejar la configuraci\xf3n con los cambios sin guardar?","lang_share_mastodon_label":"Compartir en Mastodon"}');


var $d225499964bebf2a$exports = {};
$d225499964bebf2a$exports = JSON.parse('{"lang_markread":"M\xe4rgi loetuks","lang_newest":"Uued","lang_unread":"Mitteloetud","lang_starred":"T\xe4rniga","lang_tags":"Sildid","lang_alltags":"K\xf5ik sildid","lang_timestamp":"lisatud {0,date} kell {0,time}","lang_hours":"lisatud {0,plural,one {1 tund},other {# tundi}} tagasi","lang_minutes":"lisatud {0,plural,one {1 minut},other {# minutit}} tagasi","lang_seconds":"lisatud {0,plural,one {1 sekund},other {# sekundit}} tagasi","lang_star":"Lisa t\xe4rn","lang_unstar":"Eemalda t\xe4rn","lang_mark":"M\xe4rgi loetuks","lang_unmark":"M\xe4rgi mitteloetuks","lang_load_img":"Laadi pildid","lang_open_window":"Ava","lang_searchbutton":"Otsi","lang_sources":"Tellimused","lang_source_add":"Lisa tellimus","lang_source_opml":"v\xf5i impordi opml-fail v\xf5i Google Reader","lang_source_export":"ekspordi tellimused","lang_source_edit":"Muuda","lang_source_delete":"Kustuta","lang_source_warn":"Kas t\xf5esti kustutame tellimuse?","lang_source_new":"Uus salvestamata tellimus","lang_source_title":"Nimi","lang_source_tags":"Sildid","lang_source_comma":"komaga eraldatud","lang_source_select":"Tellimuse allika liik","lang_source_type":"Liik","lang_source_save":"Salvesta","lang_source_cancel":"Loobu","lang_source_saved":"Salvestatud","lang_no_entries":"\xdchtki s\xfcndmust ei leitud","lang_more":"rohkem","lang_login":"Logi sisse","lang_login_username":"Kasutajanimi","lang_login_password":"Salas\xf5na","lang_no_title":"Nimeta","lang_settingsbutton":"Seadistused","lang_filter":"Filtreeri","lang_share_diaspora_label":"Jaga Diaspora vahendusel","lang_logoutbutton":"Logi v\xe4lja","lang_streamerror":"\xdchtegi kirjet pole laaditud, kas laadime uuesti?","lang_share_mastodon_label":"Jaga Mastodoni v\xf5rgus","lang_share_wordpress_label":"Jaga WordPressis","lang_share_native_label":"Jaga","lang_offline_navigation_unavailable":"Vallasre\u017Eiimis ei saa hetkel silte ja tellimusi vahetada.","lang_source_deleting":"Kustutame tellimuse\u2026","lang_error_edit_source":"Tellimuse muudatuste salvestamine ei \xf5nnestunud:","lang_login_in_progress":"Proovime sisselogida\u2026","lang_error_mark_items":"K\xf5ikide n\xe4htavate kirjete m\xe4rkimine ei \xf5nnestu:","lang_error_session_expired":"Sessioon on aegunud","lang_error_load_tags":"Siltide laadimine ei \xf5nnestunud:","lang_error_sync":"Viimaste muudatuste s\xfcnkroniseerimine serverist ei \xf5nnestu:","lang_error_share_native":"Kirje jagamine ei \xf5nnestu.","lang_close_entry":"Sulge","lang_sources_refreshed":"Tellimus on v\xe4rskendatud","lang_experimental":"Katselised seadistused","lang_reload_list":"Laadi loend uuesti","lang_error_add_source":"Tellimuse lisamine ei \xf5nnestunud:","lang_share_facebook_label":"Jaga Facebookis","lang_next":"J\xe4rgmine","lang_loginbutton":"Logi sisse","lang_share_wallabag_label":"Salvesta Wallabagi","lang_error_offline_storage_not_available":"Vallasre\u017Eiimis andmehoidla pole saadaval. Palun kontrolli, et sinu veebibrauser {0}toetab IndexedDB APIt{1} ja kui sa kasutad Google Chrome brauserit, siis sa ei vaata selfoss saiti privaatses re\u017Eiimis.","lang_error_invalid_subsection":"Vigane alaml\xf5ik:","lang_error_configuration":"Seadistuste laadimine ei \xf5nnestu.","lang_info_url_copied":"Aadress on kopeeritud l\xf5ikelauale.","lang_article_actions":"Tegevused","lang_article_reading_time":"Lugemiseks kulub {0} minutit","lang_online_count":"Serveris leidub kirjeid","lang_offline_count":"Kohalikus s\xfcsteemis leidub kirjeid","lang_searchremove":"Peida otsing","lang_source_filter":"Filtreeri","lang_source_autotitle_hint":"Nime automaatseks tuvastamiseks j\xe4ta t\xfchjaks","lang_source_pwd_placeholder":"Pole muudetud","lang_login_invalid_credentials":"Vale kasutajanimi ja/v\xf5i salas\xf5na","lang_refreshbutton":"V\xe4rskenda tellimusi","lang_source_last_post":"Viimane n\xe4htud postitus","lang_source_refresh":"V\xe4rskenda see tellimus","lang_login_offline":"Vallasre\u017Eiimis andmehoidla","lang_error":"Tekkis viga","lang_days":"lisatud {0,plural,zero {t\xe4na},one {eile},other {# p\xe4eva tagasi}}","lang_share_mail_label":"Jaga e-kirjaga","lang_share_copy_label":"Kopeeri link l\xf5ikelauale","lang_share_pocket_label":"Salvesta Pocketisse","lang_share_twitter_label":"Jaga Twitteris/X\'is","lang_search_label":"Otsingus\xf5na","lang_source_menu":"T\xe4iendavad toimingud","lang_source_browse":"Sirvi","lang_source_warn_cancel_dirty":"Kas j\xe4tame muudatused salvestamata?","lang_source_params_loading":"Laadime parameetreid\u2026","lang_source_saving":"Salvestame tellimuse muudatusi\u2026","lang_sources_loading":"Laadime tellimustest andmeid\u2026","lang_no_sources":"\xdchtegi tellimust pole seadistatud.","lang_source_go_to_settings":"Ava seadistustes","lang_sources_leaving_unsaved_prompt":"Kas soovid lahkuda seadistustest ja j\xe4tta tellimuse muudatused salvestamata?","lang_error_delete_source":"Tellimuse kustutamine ei \xf5nnestunud:","lang_error_unknown_source":"Tellimuse teadmata tunnus:","lang_error_refreshing_source":"Tellimuste v\xe4rskendamine ei \xf5nnestunud:","lang_tag_change_color_button_title":"Muuda v\xe4rvi","lang_entries_loading":"Laadime kirjeid\u2026","lang_login_error_generic":"Sisselogimine ei \xf5nnestunud: {errorMessage}","lang_error_unauthorized":"J\xe4tkamiseks palun {link_begin}logi sisse{link_end}.","lang_error_check_log_file":"Tekkis viga, palun vaata logifaili \u201E{0}\u201C.","lang_error_check_system_logs":"Tekkis viga, palun vaata s\xfcsteemi logifaile.","lang_error_unwritable_logs":"Logide salvestamine ei \xf5nnestu.","lang_app_update":"selfoss on uuendatud, palun laadi uuesti","lang_app_reload":"Laadi uuesti","lang_error_unknown_tag":"Tundmatu silt:","lang_error_mark_item":"Kirje m\xe4rkimine v\xf5i m\xe4rkimise eemaldamine ei \xf5nnestu:","lang_error_star_item":"Kirje t\xe4rniga m\xe4rkimine v\xf5i m\xe4rkimise eemaldamine ei \xf5nnestu:","lang_error_logout":"V\xe4ljalogimine ei \xf5nnestunud:","lang_error_loading":"Viga laadimisel:","lang_error_loading_stats":"Statistika laadimine ei \xf5nnestu:","lang_error_saving_color":"Uue v\xe4rvi salvestamine ei \xf5nnestu:","lang_error_offline_storage":"Vallasre\u017Eiimis andmehoidla viga: {0}. Uuesti laadimine v\xf5ib viga parandada. L\xfclitame vallasre\u017Eiimi esialgu v\xe4lja.","lang_error_share_native_abort":"Kirje jagamine ei \xf5nnestu - kas brauseris pole \xfchtegi jagamisviisi seadistatud v\xf5i katkestasid jagamise."}');


var $d319fa7db54d8a5e$exports = {};
$d319fa7db54d8a5e$exports = JSON.parse('{"lang_markread":"merkitse luetuiksi","lang_newest":"uusimmat","lang_unread":"lukemattomat","lang_starred":"t&auml;hdelliset","lang_tags":"Avainsanat","lang_alltags":"kaikki avainsanat","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 tunti},other {# tuntia}} sitten","lang_minutes":"{0,plural,one {1 minuutti},other {# minuuttia}} sitten","lang_seconds":"{0,plural,one {1 sekunti},other {# sekuntia}} sitten","lang_star":"t&auml;hti","lang_unstar":"t&auml;hti pois","lang_mark":"luetuksi","lang_unmark":"lukemattomaksi","lang_load_img":"lataa kuvat","lang_open_window":"avaa","lang_searchbutton":"etsi","lang_sources":"L&auml;hteet","lang_source_add":"lis&auml;&auml; l&auml;hde","lang_source_opml":"tai tuo opml-tiedosto tai google reader","lang_source_export":"vie l&auml;hteet","lang_source_edit":"muokkaa","lang_source_delete":"poista","lang_source_warn":"Haluatko varmasti poistaa t&auml;m&auml;n l&auml;hteen?","lang_source_new":"uusi tallentamaton l&auml;hde","lang_source_title":"Nimi","lang_source_tags":"Avainsanat","lang_source_comma":"avainsanat erotetaan pilkulla","lang_source_select":"valitse l&auml;hde","lang_source_type":"Tyyppi","lang_source_save":"tallenna","lang_source_cancel":"peruuta","lang_source_saved":"tallennettu","lang_no_entries":"merkint&ouml;j&auml; ei l&ouml;ydetty","lang_more":"lis&auml;&auml;","lang_login":"kirjaudu sis&auml;&auml;n","lang_login_username":"k&auml;ytt&auml;j&auml;tunnus","lang_login_password":"salasana","lang_no_title":"ei otsikkoa","lang_error_share_native_abort":"Kohteen jakaminen ep\xe4onnistui \u2013 joko jakamiskohteita ei ole tai peruutat sen.","lang_close_entry":"Sulje","lang_login_invalid_credentials":"V\xe4\xe4r\xe4 k\xe4ytt\xe4j\xe4nimi/salasana","lang_share_mail_label":"Jaa s\xe4hk\xf6postitse","lang_sources_refreshed":"L\xe4hteet virkistetty","lang_error_refreshing_source":"L\xe4hteit\xe4 ei voi virkist\xe4\xe4:","lang_source_refresh":"Virkist\xe4 t\xe4m\xe4 l\xe4hde","lang_refreshbutton":"Virkist\xe4 l\xe4hteet"}');


var $d0be492086bdc65a$exports = {};
$d0be492086bdc65a$exports = JSON.parse('{"lang_markread":"Marquer comme lu","lang_filter":"Filtrer","lang_newest":"Le plus r\xe9cent","lang_unread":"Non lu","lang_starred":"Favoris","lang_online_count":"Sur le serveur","lang_offline_count":"En local","lang_tags":"\xc9tiquettes","lang_alltags":"Toutes les \xe9tiquettes","lang_timestamp":"{0,date} {0,time}","lang_hours":"il y a {0,plural,one {1 heure},other {# heures}}","lang_minutes":"il y a {0,plural,one {1 minute},other {# minutes}}","lang_seconds":"il y a {0,plural,one {1 seconde},other {# secondes}}","lang_days":"{0,plural,zero {aujourd\u2019hui},one {hier},other {il y a # jours}}","lang_star":"Ajouter aux favoris","lang_unstar":"Supprimer des favoris","lang_mark":"Marquer comme lu","lang_unmark":"Marquer comme non lu","lang_load_img":"Afficher les images","lang_open_window":"Ouvrir","lang_next":"Suivant","lang_searchbutton":"Rechercher","lang_searchremove":"Masquer le champ de recherche","lang_refreshbutton":"Actualiser les sources","lang_settingsbutton":"Param\xe8tres","lang_logoutbutton":"Se d\xe9connecter","lang_loginbutton":"Se connecter","lang_sources":"Sources","lang_source_add":"Ajouter une source","lang_source_opml":"ou importer un fichier OPML ou Google Reader","lang_source_export":"Exporter les sources","lang_source_edit":"Modifier","lang_source_filter":"Filtre","lang_source_delete":"Supprimer","lang_source_warn":"Voulez-vous vraiment supprimer cette source ?","lang_source_new":"Nouvelle source non sauvegard\xe9e","lang_source_title":"Titre","lang_source_autotitle_hint":"Laisser vide pour r\xe9cup\xe9rer le titre","lang_source_tags":"\xc9tiquettes","lang_source_pwd_placeholder":"Mot de passe inchang\xe9","lang_source_comma":"S\xe9par\xe9s par une virgule","lang_source_select":"Veuillez s\xe9lectionner une source","lang_source_type":"Type","lang_source_save":"Enregistrer","lang_source_cancel":"Annuler","lang_source_saved":"Enregistr\xe9","lang_source_last_post":"Dernier \xe9l\xe9ment vu","lang_source_refresh":"Rafra\xeechir cette source","lang_no_entries":"Aucun article \xe0 consulter","lang_more":"Plus","lang_login":"Connexion","lang_login_username":"Identifiant","lang_login_password":"Mot de passe","lang_login_invalid_credentials":"Nom d\u2019utilisateur/Mot de passe incorrect","lang_login_offline":"Stockage hors-ligne","lang_no_title":"Sans titre","lang_error":"Une erreur est survenue","lang_streamerror":"Une erreur s\u2019est produite lors du chargement de la liste, essayer \xe0 nouveau\xa0?","lang_reload_list":"Recharger la liste","lang_sources_refreshed":"Sources actualis\xe9es","lang_app_update":"selfoss a \xe9t\xe9 mis \xe0 jour, merci de recharger","lang_app_reload":"Recharger","lang_error_session_expired":"Session expir\xe9e","lang_error_add_source":"Impossible d\'ajouter la source\xa0:","lang_error_delete_source":"Impossible de supprimer la source :","lang_error_load_tags":"Impossible de charger les \xe9tiquettes :","lang_error_unknown_tag":"Tag inconnu\xa0:","lang_error_unknown_source":"Identifiant de source inconnu\xa0:","lang_error_mark_items":"Impossible de marquer tous les \xe9l\xe9ments visibles\xa0:","lang_error_mark_item":"Erreur lors du marquage lu/non lu\xa0:","lang_error_star_item":"Erreur lors de l\u2019ajouter/suppression du favori\xa0:","lang_error_logout":"Impossible de se d\xe9connecter\xa0:","lang_error_loading":"Erreur de chargement\xa0:","lang_error_loading_stats":"Impossible de charger les statistiques de navigation\xa0:","lang_error_saving_color":"Impossible de sauvegarder une nouvelle couleur\xa0:","lang_error_refreshing_source":"Impossible de rafra\xeechir les sources\xa0:","lang_error_sync":"Impossible de synchroniser les derni\xe8res modifications du serveur\xa0:","lang_error_offline_storage":"Erreur stockage hors-ligne : {0}. Recharger la page pourrait aider. Le mode hors-ligne est d\xe9sactiv\xe9 pour le moment.","lang_error_invalid_subsection":"Sous-section erron\xe9e :","lang_search_label":"Terme de recherche","lang_article_actions":"Actions","lang_error_configuration":"Impossible de charger la configuration.","lang_info_url_copied":"URL copi\xe9e dans le presse-papiers.","lang_share_native_label":"Partager","lang_share_diaspora_label":"Partager sur Diaspora","lang_share_twitter_label":"Partager sur Twitter","lang_share_facebook_label":"Partager sur Facebook","lang_share_pocket_label":"Enregistrer dans Pocket","lang_share_wallabag_label":"Enregistrer dans Wallabag","lang_share_wordpress_label":"Partager sur WordPress","lang_share_mail_label":"Partager par courriel","lang_share_copy_label":"Copier le lien dans le presse-papiers","lang_error_share_native_abort":"Impossible de partager l\'\xe9l\xe9ment, soit il n\'y a pas de cible, soit vous avez annul\xe9 le partage.","lang_error_share_native":"Impossible de partager l\'\xe9l\xe9ment.","lang_close_entry":"Fermer","lang_error_unwritable_logs":"Impossible d\'\xe9crire les fichiers de journalisation.","lang_error_check_system_logs":"Une erreur est survenue. Veuillez consulter votre journalisation syst\xe8me.","lang_error_check_log_file":"Une erreur est survenue. Veuillez consulter le fichier \xab {0} \xbb.","lang_offline_navigation_unavailable":"Modifier les \xe9tiquettes et les sources n\'est pas possible hors ligne pour le moment.","lang_error_offline_storage_not_available":"Le stockage hors ligne n\u2019est pas disponible. Assurez-vous que votre navigateur Web {0}prend en charge l\u2019API IndexedDB{1} et, si vous utilisez un navigateur bas\xe9 sur Google Chrome, que vous n\u2019ex\xe9cutez pas selfoss en mode de navigation priv\xe9e.","lang_error_edit_source":"Impossible d\'enregistrer les modifications de la source\xa0:","lang_source_browse":"Naviguer","lang_no_sources":"Aucune source configur\xe9es.","lang_source_warn_cancel_dirty":"Annuler les changements non sauvegard\xe9s ?","lang_source_deleting":"Suppression de la source\u2026","lang_source_saving":"Sauvegarde des changements de la source\u2026","lang_entries_loading":"Chargement des entr\xe9es\u2026","lang_source_menu":"Plus d\'actions","lang_tag_change_color_button_title":"Changer la couleur","lang_sources_loading":"Chargement des sources\u2026","lang_source_go_to_settings":"Ouvrir dans les param\xe8tres","lang_sources_leaving_unsaved_prompt":"Quitter les param\xe8tres avec des changements sur la source non sauvegard\xe9s ?","lang_source_params_loading":"Chargement des param\xe8tres\u2026","lang_experimental":"Exp\xe9rimentale","lang_article_reading_time":"{0} min de lecture","lang_login_in_progress":"Tentative de connexion\u2026","lang_login_error_generic":"Connexion impossible : {errorMessage}","lang_error_unauthorized":"S\'il vous pla\xeet {link_begin}connectez-vous{link_end} pour continuer."}');


var $bb896106aaedaee8$exports = {};
$bb896106aaedaee8$exports = JSON.parse('{"lang_error_add_source":"Impossible d\'ajouter la source\u202F:","lang_streamerror":"Une erreur s\u2019est produite lors du chargement de la liste, essayer \xe0 nouveau?","lang_source_warn":"Voulez-vous vraiment supprimer cette source?","lang_sources":"Sources","lang_timestamp":"{0,date} {0,time}","lang_close_entry":"Fermer","lang_error_share_native":"Impossible de partager l\'\xe9l\xe9ment.","lang_error_share_native_abort":"Impossible de partager l\'\xe9l\xe9ment, soit il n\'y a pas de cible, soit vous avez annul\xe9 le partage.","lang_share_copy_label":"Copier le lien dans le presse-papiers","lang_share_mail_label":"Partager par courriel","lang_share_wordpress_label":"Partager sur WordPress","lang_share_wallabag_label":"Enregistrer dans Wallabag","lang_share_pocket_label":"Enregistrer dans Pocket","lang_share_facebook_label":"Partager sur Facebook","lang_share_twitter_label":"Partager sur Twitter","lang_share_diaspora_label":"Partager sur Diaspora","lang_share_native_label":"Partager","lang_info_url_copied":"URL copi\xe9e dans le presse-papiers.","lang_error_configuration":"Impossible de charger la configuration.","lang_article_actions":"Actions","lang_search_label":"Terme de recherche","lang_error_invalid_subsection":"Sous-section erron\xe9e :","lang_error_offline_storage":"Erreur stockage hors-ligne : {0}. Recharger la page pourrait aider. Le mode hors-ligne est d\xe9sactiv\xe9 pour le moment.","lang_error_sync":"Impossible de synchroniser les derni\xe8res modifications du serveur\xa0:","lang_error_refreshing_source":"Impossible de rafra\xeechir les sources\xa0:","lang_error_saving_color":"Impossible de sauvegarder une nouvelle couleur\xa0:","lang_error_loading_stats":"Impossible de charger les statistiques de navigation\xa0:","lang_error_loading":"Erreur de chargement\xa0:","lang_error_logout":"Impossible de se d\xe9connecter\xa0:","lang_error_star_item":"Erreur lors de l\u2019ajouter/suppression du favori\xa0:","lang_error_mark_item":"Erreur lors du marquage lu/non lu\xa0:","lang_error_mark_items":"Impossible de marquer tous les \xe9l\xe9ments visibles\xa0:","lang_error_unknown_source":"Identifiant de source inconnu\xa0:","lang_error_unknown_tag":"Tag inconnu\xa0:","lang_error_load_tags":"Impossible de charger les \xe9tiquettes :","lang_error_delete_source":"Impossible de supprimer la source :","lang_error_session_expired":"Session expir\xe9e","lang_app_reload":"Recharger","lang_app_update":"selfoss a \xe9t\xe9 mis \xe0 jour, merci de recharger","lang_sources_refreshed":"Sources actualis\xe9es","lang_reload_list":"Recharger la liste","lang_error":"Une erreur est survenue","lang_no_title":"Sans titre","lang_login_offline":"Stockage hors-ligne","lang_login_invalid_credentials":"Nom d\u2019utilisateur/Mot de passe incorrect","lang_login_password":"Mot de passe","lang_login_username":"Identifiant","lang_login":"Connexion","lang_more":"Plus","lang_no_entries":"Aucun article \xe0 consulter","lang_source_refresh":"Rafra\xeechir cette source","lang_source_last_post":"Dernier \xe9l\xe9ment vu","lang_source_saved":"Enregistr\xe9","lang_source_cancel":"Annuler","lang_source_save":"Enregistrer","lang_source_type":"Type","lang_source_select":"Veuillez s\xe9lectionner une source","lang_source_comma":"S\xe9par\xe9s par une virgule","lang_source_pwd_placeholder":"Mot de passe inchang\xe9","lang_source_tags":"\xc9tiquettes","lang_source_autotitle_hint":"Laisser vide pour r\xe9cup\xe9rer le titre","lang_source_title":"Titre","lang_source_new":"Nouvelle source non sauvegard\xe9e","lang_source_delete":"Supprimer","lang_source_filter":"Filtre","lang_source_edit":"Modifier","lang_source_export":"Exporter les sources","lang_source_opml":"ou importer un fichier OPML ou Google Reader","lang_source_add":"Ajouter une source","lang_loginbutton":"Se connecter","lang_logoutbutton":"Se d\xe9connecter","lang_settingsbutton":"Param\xe8tres","lang_refreshbutton":"Actualiser les sources","lang_searchremove":"Masquer le champ de recherche","lang_searchbutton":"Rechercher","lang_next":"Suivant","lang_open_window":"Ouvrir","lang_load_img":"Afficher les images","lang_unmark":"Marquer comme non lu","lang_mark":"Marquer comme lu","lang_unstar":"Supprimer des favoris","lang_star":"Ajouter aux favoris","lang_days":"{0,plural,zero {aujourd\u2019hui},one {hier},other {il y a # jours}}","lang_seconds":"il y a {0,plural,one {1 seconde},other {# secondes}}","lang_minutes":"il y a {0,plural,one {1 minute},other {# minutes}}","lang_hours":"il y a {0,plural,one {1 heure},other {# heures}}","lang_alltags":"Toutes les \xe9tiquettes","lang_tags":"\xc9tiquettes","lang_offline_count":"En local","lang_online_count":"Sur le serveur","lang_starred":"Favoris","lang_unread":"Non lu","lang_newest":"Le plus r\xe9cent","lang_filter":"Filtrer","lang_markread":"Marquer comme lu","lang_error_offline_storage_not_available":"Le stockage hors ligne n\u2019est pas disponible. Assurez-vous que votre navigateur Web {0}prend en charge l\u2019API IndexedDB{1} et, si vous utilisez un navigateur bas\xe9 sur Google Chrome, que vous n\u2019ex\xe9cutez pas selfoss en mode de navigation priv\xe9e.","lang_error_edit_source":"Impossible d\'enregistrer les modifications de la source :","lang_error_unwritable_logs":"Impossible d\'\xe9crire les fichiers de journalisation.","lang_error_check_system_logs":"Une erreur est survenue. Veuillez consulter votre journalisation syst\xe8me.","lang_error_check_log_file":"Une erreur est survenue. Veuillez consulter le fichier \xab {0}\xa0\xbb.","lang_offline_navigation_unavailable":"Modifier les \xe9tiquettes et les sources n\'est pas possible hors ligne pour le moment."}');


var $acbbfcabee63ed13$exports = {};
$acbbfcabee63ed13$exports = JSON.parse('{"lang_tags":"Etiquetas","lang_days":"{0,plural,zero {hoxe},one {onte},other {fai # d\xedas}}","lang_unmark":"Marcar como non lido","lang_share_pocket_label":"Gardar en Pocket","lang_no_entries":"Non se atoparon rexistros","lang_more":"M\xe1is","lang_filter":"Filtro","lang_online_count":"Elementos dispo\xf1ibles no servidor","lang_offline_count":"Elementos dispo\xf1ibles localmente","lang_timestamp":"{0,date} {0,time}","lang_hours":"fai {0,plural,one {1 hora},other {# horas}}","lang_minutes":"fai {0,plural,one {1 minuto},other {# minutos}}","lang_seconds":"fai {0,plural,one {1 segundo},other {# segundos}}","lang_share_wallabag_label":"Gardar en Wallabag","lang_share_wordpress_label":"Compartir en WordPress","lang_share_mail_label":"Compartir por email","lang_share_copy_label":"Copiar ligaz\xf3n o portapap\xe9is","lang_search_label":"Buscar termo","lang_searchbutton":"Procurar","lang_searchremove":"Agochar b\xfasqueda","lang_refreshbutton":"Actualizar as fontes","lang_settingsbutton":"Configuraci\xf3n","lang_logoutbutton":"Fechar a sesi\xf3n","lang_loginbutton":"Iniciar sesi\xf3n","lang_sources":"Fontes","lang_sources_loading":"Cargando as fontes\u2026","lang_no_sources":"Non hai fontes configuradas.","lang_source_add":"Engadir fonte","lang_source_opml":"ou importa dende un ficheiro OPML","lang_source_export":"Exportar fontes","lang_source_edit":"Editar","lang_source_filter":"Filtro","lang_source_menu":"M\xe1is acci\xf3ns","lang_source_browse":"Navegar","lang_source_delete":"Borrar","lang_source_warn":"Realmente queres borrar esta fonte?","lang_source_deleting":"Borrando a fonte\u2026","lang_source_warn_cancel_dirty":"Queres descargar os cambios non gardados?","lang_source_new":"Nova fonte sen gardar","lang_source_title":"T\xedtulo","lang_source_autotitle_hint":"Deixar en branco pra obter t\xedtulo","lang_source_type":"Tipo","lang_source_save":"Gardar","lang_source_cancel":"Cancelar","lang_source_saving":"Gardando cambios da fonte\u2026","lang_source_last_post":"\xdaltima entrada vista","lang_error_session_expired":"A sesi\xf3n expirou","lang_error_add_source":"Non se puido engadira a fonte:","lang_error_edit_source":"Non se puideron gardar os cambios as fontes:","lang_error_delete_source":"Erro borrando a fonte:","lang_error_load_tags":"Non se puideron cargar as etiquetas:","lang_error_unknown_tag":"Etiqueta desco\xf1ecida:","lang_error_unknown_source":"Id de fonte desco\xf1ecida:","lang_error_mark_items":"Non se puideron marcar todos os elementos visib\xe9is:","lang_error_mark_item":"Non se puido marcar/desmarcar elemento:","lang_error_star_item":"Non se puido marcar/desmarcar a estrela no elemento:","lang_error_logout":"Non se puido fechar a sesi\xf3n:","lang_error_loading":"Error cargando:","lang_error_loading_stats":"Non se puideron cargar as estat\xedsticas de navegaci\xf3n:","lang_error_saving_color":"Non se puido cargar a nova cor:","lang_error_refreshing_source":"Non se puideron refrescar as fontes:","lang_error_sync":"Non se puideron sincronizar os \xfaltimos cambios do servidor:","lang_error_offline_storage":"Error do almacenamento fora de li\xf1a: {0}. Recargar pode axudar. Desactivando uso fora de li\xf1a polo momento.","lang_share_twitter_label":"Compartir en Twitter","lang_error_offline_storage_not_available":"Almacenamento fora de li\xf1a non dispo\xf1\xedbel. Asegurase de que o seu navegador {0} soporta IndexedDB API{1} e, se est\xe1 utilizando un navegador baseado en Google Chrome, que non est\xe9 usando selfoss en modo inc\xf3gnito.","lang_error_invalid_subsection":"Subsecci\xf3n inv\xe1lida:","lang_error_configuration":"Non se puido cargar a configuraci\xf3n.","lang_error_share_native_abort":"Non se puido compartir o elemento, non tes onde compartilo ou cancel\xe1chelo.","lang_error_share_native":"Non se puido compartir o elemento.","lang_info_url_copied":"Copiouse a URL o portapap\xe9is.","lang_close_entry":"Fechar","lang_article_actions":"Acci\xf3ns","lang_article_reading_time":"{0} min lectura","lang_unread":"Non lidos","lang_offline_navigation_unavailable":"Cambiar etiquetas e fontes non est\xe1 dispo\xf1ible no modo fora de li\xf1a.","lang_source_go_to_settings":"Abrir a configuraci\xf3n","lang_login_in_progress":"Intentando iniciar sesi\xf3n\u2026","lang_markread":"Marcar como lido","lang_newest":"Novos","lang_alltags":"Todas as etiquetas","lang_source_saved":"Gardado","lang_source_refresh":"Actualizar esta fonte","lang_tag_change_color_button_title":"Cambiar a cor","lang_login":"Iniciar sesi\xf3n","lang_login_password":"Contrasinal","lang_sources_refreshed":"Actualizaronse as fontes","lang_star":"Marcar con estrela","lang_starred":"Con estrela","lang_unstar":"Quitar a estrela","lang_next":"Seguinte","lang_share_native_label":"Compartir","lang_share_diaspora_label":"Compartir en Diaspora","lang_share_facebook_label":"Compartir en Facebook","lang_source_comma":"Separado por comas","lang_mark":"Marcar como lido","lang_open_window":"Abrir","lang_load_img":"Cargar imaxes","lang_login_invalid_credentials":"Usuario/contrasinal incorrectos","lang_source_tags":"Etiquetas","lang_source_select":"Por favor, escolle unha fonte","lang_source_pwd_placeholder":"Non cambiou","lang_source_params_loading":"Estanse cargando os par\xe1metros\u2026","lang_sources_leaving_unsaved_prompt":"Queres deixar a configuraci\xf3n con cambios de fonte non gardados?","lang_login_username":"Usuario","lang_entries_loading":"Estanse cargando as entradas\u2026","lang_login_offline":"Almacenamento fora de li\xf1a","lang_error":"Ocurriu un erro","lang_error_check_system_logs":"Ocurriu un erro, por favor comproba os rexistros do sistema.","lang_error_unwritable_logs":"Non se puideron escribir os rexistros.","lang_no_title":"Sen t\xedtulo","lang_experimental":"Experimental","lang_error_check_log_file":"Produciuse un erro, por favor comproba o ficheiro de rexistro \\"{0}\\".","lang_streamerror":"Non hai elementos cargados, recargar?","lang_reload_list":"Recargar lista","lang_app_update":"Selfoss actualizouse, recargue","lang_app_reload":"Recargar","lang_error_unauthorized":"{link_begin}inicia sesi\xf3n{link_end} para continuar.","lang_login_error_generic":"Non se puido iniciar sesi\xf3n: {errorMessage}","lang_share_mastodon_label":"Comparte en Mastodon"}');


var $b6d92725827c8d30$exports = {};
$b6d92725827c8d30$exports = JSON.parse('{"lang_error_offline_storage_not_available":"\u05D4\u05D0\u05D7\u05E1\u05D5\u05DF \u05D4\u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF \u05D0\u05D9\u05E0\u05D5 \u05D6\u05DE\u05D9\u05DF. \u05E0\u05D0 \u05DC\u05D5\u05D5\u05D3\u05D0 \u05E9\u05D4\u05D3\u05E4\u05D3\u05E4\u05DF \u05E9\u05DC\u05DA {0}\u05EA\u05D5\u05DE\u05DA \u05D1\u05BEAPI \u05DE\u05E1\u05D5\u05D2 IndexedDB{1} \u05D5\u05D2\u05DD, \u05D0\u05DD \u05D4\u05D3\u05E4\u05D3\u05E4\u05DF \u05E9\u05DE\u05E9\u05DE\u05E9 \u05D0\u05D5\u05EA\u05DA \u05DE\u05D1\u05D5\u05E1\u05E1 Google Chrome, \u05E9\u05D6\u05D0\u05EA \u05D0\u05D9\u05E0\u05D4 \u05D2\u05DC\u05D9\u05E9\u05D4 \u05D1\u05E1\u05EA\u05E8.","lang_error_invalid_subsection":"\u05EA\u05EA\u05BE\u05E1\u05E2\u05D9\u05E3 \u05E9\u05D2\u05D5\u05D9:","lang_error_offline_storage":"\u05E9\u05D2\u05D9\u05D0\u05EA \u05D0\u05D7\u05E1\u05D5\u05DF \u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF: {0}. \u05D0\u05D5\u05DC\u05D9 \u05E8\u05E2\u05E0\u05D5\u05DF \u05D9\u05E2\u05D6\u05D5\u05E8. \u05D4\u05DE\u05E6\u05D1 \u05D4\u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF \u05DE\u05D5\u05E9\u05D1\u05EA \u05DB\u05E8\u05D2\u05E2.","lang_error_share_native_abort":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E9\u05EA\u05E3 \u05E4\u05E8\u05D9\u05D8 - \u05D0\u05D5 \u05E9\u05D0\u05D9\u05DF \u05D9\u05E2\u05D3 \u05DC\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D0\u05D5 \u05E9\u05D1\u05D9\u05D8\u05DC\u05EA.","lang_error_configuration":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D8\u05E2\u05D5\u05DF \u05D4\u05D2\u05D3\u05E8\u05D5\u05EA.","lang_error_share_native":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E9\u05EA\u05E3 \u05E4\u05E8\u05D9\u05D8.","lang_article_actions":"\u05E4\u05E2\u05D5\u05DC\u05D5\u05EA","lang_close_entry":"\u05E1\u05D2\u05D9\u05E8\u05D4","lang_info_url_copied":"\u05D4\u05DB\u05EA\u05D5\u05D1\u05EA \u05D4\u05D5\u05E2\u05EA\u05E7\u05D4 \u05DC\u05DC\u05D5\u05D7 \u05D4\u05D2\u05D6\u05D9\u05E8\u05D9\u05DD.","lang_error_sync":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E1\u05E0\u05DB\u05E8\u05DF \u05D0\u05EA \u05D4\u05E9\u05D9\u05E0\u05D5\u05D9\u05D9\u05DD \u05D4\u05D0\u05D7\u05E8\u05D5\u05E0\u05D9\u05DD \u05DE\u05D4\u05E9\u05E8\u05EA:","lang_error_refreshing_source":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E8\u05E2\u05E0\u05DF \u05DE\u05E7\u05D5\u05E8\u05D5\u05EA:","lang_error_saving_color":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E9\u05DE\u05D5\u05E8 \u05E6\u05D1\u05E2 \u05D7\u05D3\u05E9:","lang_error_loading_stats":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D8\u05E2\u05D5\u05DF \u05E1\u05D8\u05D8\u05D9\u05E1\u05D8\u05D9\u05E7\u05EA \u05E0\u05D9\u05D5\u05D5\u05D8:","lang_error_loading":"\u05E9\u05D2\u05D9\u05D0\u05EA \u05D8\u05E2\u05D9\u05E0\u05D4:","lang_error_logout":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E6\u05D0\u05EA:","lang_error_star_item":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E1\u05DE\u05DF \u05D1\u05DB\u05D5\u05DB\u05D1/\u05DC\u05D1\u05D8\u05DC \u05DB\u05D5\u05DB\u05D1 \u05E9\u05DC \u05E4\u05E8\u05D9\u05D8:","lang_error_mark_item":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E1\u05DE\u05DF/\u05DC\u05D1\u05D8\u05DC \u05E1\u05D9\u05DE\u05D5\u05DF \u05E9\u05DC \u05E4\u05E8\u05D9\u05D8:","lang_error_mark_items":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E1\u05DE\u05DF \u05D0\u05EA \u05DB\u05DC \u05D4\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05D4\u05D2\u05DC\u05D5\u05D9\u05D9\u05DD:","lang_error_unknown_source":"\u05DE\u05D6\u05D4\u05D4 \u05D4\u05DE\u05E7\u05D5\u05E8 \u05DC\u05D0 \u05D9\u05D3\u05D5\u05E2:","lang_error_unknown_tag":"\u05EA\u05D2\u05D9\u05EA \u05DC\u05D0 \u05D9\u05D3\u05D5\u05E2\u05D4:","lang_error_load_tags":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D8\u05E2\u05D5\u05DF \u05EA\u05D2\u05D9\u05D5\u05EA:","lang_error_delete_source":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05DE\u05D7\u05D5\u05E7 \u05DE\u05E7\u05D5\u05E8:","lang_error_edit_source":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E9\u05DE\u05D5\u05E8 \u05D0\u05EA \u05E9\u05D9\u05E0\u05D5\u05D9\u05D9 \u05D4\u05DE\u05E7\u05D5\u05E8:","lang_error_add_source":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05DE\u05E7\u05D5\u05E8:","lang_error_session_expired":"\u05EA\u05D5\u05E7\u05E3 \u05D4\u05D4\u05E4\u05E2\u05DC\u05D4 \u05E4\u05D2","lang_app_reload":"\u05E8\u05E2\u05E0\u05D5\u05DF","lang_app_update":"selfoss \u05D4\u05EA\u05E2\u05D3\u05DB\u05DF, \u05E0\u05D0 \u05DC\u05E8\u05E2\u05E0\u05DF","lang_sources_refreshed":"\u05D4\u05DE\u05E7\u05D5\u05E8\u05D5\u05EA \u05D4\u05EA\u05E8\u05E2\u05E0\u05E0\u05D5","lang_reload_list":"\u05DC\u05E8\u05E2\u05E0\u05DF \u05E8\u05E9\u05D9\u05DE\u05D4","lang_streamerror":"\u05DC\u05D0 \u05E0\u05D8\u05E2\u05E0\u05D5 \u05E4\u05E8\u05D9\u05D8\u05D9\u05DD, \u05DC\u05E8\u05E2\u05E0\u05DF?","lang_error_unwritable_logs":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05DB\u05EA\u05D5\u05D1 \u05D9\u05D5\u05DE\u05E0\u05D9\u05DD.","lang_error_check_system_logs":"\u05D0\u05D9\u05E8\u05E2\u05D4 \u05E9\u05D2\u05D9\u05D0\u05D4, \u05E0\u05D0 \u05DC\u05E2\u05D9\u05D9\u05DF \u05D1\u05D9\u05D5\u05DE\u05E0\u05D9 \u05D4\u05DE\u05E2\u05E8\u05DB\u05EA \u05E9\u05DC\u05DA.","lang_error_check_log_file":"\u05D0\u05D9\u05E8\u05E2\u05D4 \u05E9\u05D2\u05D9\u05D0\u05D4, \u05E0\u05D0 \u05DC\u05E2\u05D9\u05D9\u05DF \u05D1\u05E7\u05D5\u05D1\u05E5 \u05D4\u05D9\u05D5\u05DE\u05DF \u201E{0}\u201D.","lang_error":"\u05D0\u05D9\u05E8\u05E2\u05D4 \u05E9\u05D2\u05D9\u05D0\u05D4","lang_no_title":"\u05D0\u05D9\u05DF \u05DB\u05D5\u05EA\u05E8\u05EA","lang_login_offline":"\u05D0\u05D7\u05E1\u05D5\u05DF \u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF","lang_login_invalid_credentials":"\u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9/\u05E1\u05E1\u05DE\u05D4 \u05E9\u05D2\u05D5\u05D9\u05D9\u05DD","lang_login_password":"\u05E1\u05E1\u05DE\u05D4","lang_login_username":"\u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9","lang_login":"\u05DB\u05E0\u05D9\u05E1\u05D4","lang_more":"\u05E2\u05D5\u05D3","lang_no_entries":"\u05DC\u05D0 \u05E0\u05DE\u05E6\u05D0\u05D5 \u05E8\u05E9\u05D5\u05DE\u05D5\u05EA","lang_source_refresh":"\u05DC\u05E8\u05E2\u05E0\u05DF \u05D0\u05EA \u05D4\u05DE\u05E7\u05D5\u05E8 \u05D4\u05D6\u05D4","lang_source_last_post":"\u05D4\u05E8\u05E9\u05D5\u05DE\u05D4 \u05D4\u05D0\u05D7\u05E8\u05D5\u05E0\u05D4 \u05E9\u05E0\u05E8\u05D0\u05EA\u05D4","lang_source_saved":"\u05E0\u05E9\u05DE\u05E8","lang_source_cancel":"\u05D1\u05D9\u05D8\u05D5\u05DC","lang_source_save":"\u05E9\u05DE\u05D9\u05E8\u05D4","lang_source_type":"\u05E1\u05D5\u05D2","lang_source_select":"\u05E0\u05D0 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05DE\u05E7\u05D5\u05E8","lang_source_comma":"\u05E2\u05DD \u05D4\u05E4\u05E8\u05D3\u05D4 \u05D1\u05E4\u05E1\u05D9\u05E7\u05D9\u05DD","lang_source_pwd_placeholder":"\u05DC\u05D0 \u05D4\u05E9\u05EA\u05E0\u05D4","lang_source_tags":"\u05EA\u05D2\u05D9\u05D5\u05EA","lang_source_autotitle_hint":"\u05D9\u05E9 \u05DC\u05D4\u05E9\u05D0\u05D9\u05E8 \u05E8\u05D9\u05E7 \u05DB\u05D3\u05D9 \u05DC\u05E7\u05D1\u05DC \u05D0\u05EA \u05D4\u05DB\u05D5\u05EA\u05E8\u05EA","lang_source_title":"\u05DB\u05D5\u05EA\u05E8\u05EA","lang_source_new":"\u05DE\u05E7\u05D5\u05E8 \u05D7\u05D3\u05E9 \u05E9\u05DC\u05D0 \u05E0\u05E9\u05DE\u05E8","lang_source_warn":"\u05DC\u05DE\u05D7\u05D5\u05E7 \u05D0\u05EA \u05D4\u05DE\u05E7\u05D5\u05E8 \u05D4\u05D6\u05D4?","lang_source_delete":"\u05DE\u05D7\u05D9\u05E7\u05D4","lang_source_filter":"\u05DE\u05E1\u05E0\u05DF","lang_source_edit":"\u05E2\u05E8\u05D9\u05DB\u05D4","lang_source_export":"\u05D9\u05D9\u05E6\u05D5\u05D0 \u05DE\u05E7\u05D5\u05E8\u05D5\u05EA","lang_source_opml":"\u05D0\u05D5 \u05DC\u05D9\u05D9\u05D1\u05D0 \u05E7\u05D5\u05D1\u05E5 OPML","lang_source_add":"\u05D4\u05D5\u05E1\u05E4\u05EA \u05DE\u05E7\u05D5\u05E8","lang_sources":"\u05DE\u05E7\u05D5\u05E8\u05D5\u05EA","lang_loginbutton":"\u05DB\u05E0\u05D9\u05E1\u05D4","lang_logoutbutton":"\u05D9\u05E6\u05D9\u05D0\u05D4","lang_settingsbutton":"\u05D4\u05D2\u05D3\u05E8\u05D5\u05EA","lang_refreshbutton":"\u05DC\u05E8\u05E2\u05E0\u05DF \u05DE\u05E7\u05D5\u05E8\u05D5\u05EA","lang_searchremove":"\u05D4\u05E1\u05EA\u05E8\u05EA \u05D7\u05D9\u05E4\u05D5\u05E9","lang_searchbutton":"\u05D7\u05D9\u05E4\u05D5\u05E9","lang_search_label":"\u05D1\u05D9\u05D8\u05D5\u05D9 \u05DC\u05D7\u05D9\u05E4\u05D5\u05E9","lang_share_copy_label":"\u05D4\u05E2\u05EA\u05E7\u05EA \u05E7\u05D9\u05E9\u05D5\u05E8 \u05DC\u05DC\u05D5\u05D7 \u05D2\u05D6\u05D9\u05E8\u05D9\u05DD","lang_share_mail_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05D3\u05D5\u05D0\u05F4\u05DC","lang_share_wordpress_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05D5\u05D5\u05E8\u05D3\u05E4\u05E8\u05E1","lang_share_wallabag_label":"\u05E9\u05DE\u05D9\u05E8\u05D4 \u05D1\u05BEWallabag","lang_share_pocket_label":"\u05E9\u05DE\u05D9\u05E8\u05D4 \u05D1\u05BEPocket","lang_share_facebook_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05E4\u05D9\u05D9\u05E1\u05D1\u05D5\u05E7","lang_share_twitter_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05D8\u05D5\u05D5\u05D9\u05D8\u05E8","lang_share_diaspora_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05BEDiaspora","lang_share_native_label":"\u05E9\u05D9\u05EA\u05D5\u05E3","lang_next":"\u05D4\u05D1\u05D0","lang_open_window":"\u05E4\u05EA\u05D9\u05D7\u05D4","lang_load_img":"\u05D4\u05E6\u05D2\u05EA \u05EA\u05DE\u05D5\u05E0\u05D5\u05EA","lang_unmark":"\u05E1\u05D9\u05DE\u05D5\u05DF \u05E9\u05DC\u05D0 \u05E0\u05E7\u05E8\u05D0","lang_mark":"\u05E1\u05D9\u05DE\u05D5\u05DF \u05E9\u05E0\u05E7\u05E8\u05D0","lang_unstar":"\u05D1\u05D9\u05D8\u05D5\u05DC \u05DB\u05D5\u05DB\u05D1","lang_star":"\u05DC\u05E1\u05DE\u05DF \u05D1\u05DB\u05D5\u05DB\u05D1","lang_days":"{0,plural,zero {\u05D4\u05D9\u05D5\u05DD},one {\u05D0\u05EA\u05DE\u05D5\u05DC},two {\u05E9\u05DC\u05E9\u05D5\u05DD},other {\u05DC\u05E4\u05E0\u05D9 # \u05D9\u05DE\u05D9\u05DD}}","lang_seconds":"\u05DC\u05E4\u05E0\u05D9 {0,plural,one {\u05E9\u05E0\u05D9\u05D9\u05D4},other {# \u05E9\u05E0\u05D9\u05D5\u05EA}}","lang_minutes":"\u05DC\u05E4\u05E0\u05D9 {0,plural,one {\u05D3\u05E7\u05D4},other {# \u05D3\u05E7\u05D5\u05EA}}","lang_hours":"\u05DC\u05E4\u05E0\u05D9 {0,plural,one {\u05E9\u05E2\u05D4},two {\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD},other {# \u05E9\u05E2\u05D5\u05EA}}","lang_timestamp":"\u200E{0,date} {0,time}","lang_alltags":"\u05DB\u05DC \u05D4\u05EA\u05D2\u05D9\u05D5\u05EA","lang_tags":"\u05EA\u05D2\u05D9\u05D5\u05EA","lang_offline_navigation_unavailable":"\u05D4\u05D7\u05DC\u05E4\u05EA \u05EA\u05D2\u05D9\u05D5\u05EA \u05D5\u05DE\u05E7\u05D5\u05E8\u05D5\u05EA \u05D0\u05D9\u05E0\u05D4 \u05D6\u05DE\u05D9\u05E0\u05D4 \u05DB\u05E8\u05D2\u05E2 \u05D1\u05DE\u05E6\u05D1 \u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF.","lang_offline_count":"\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05D6\u05DE\u05D9\u05E0\u05D9\u05DD \u05DE\u05E7\u05D5\u05DE\u05D9\u05EA","lang_online_count":"\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05D6\u05DE\u05D9\u05E0\u05D9\u05DD \u05D1\u05E9\u05E8\u05EA","lang_starred":"\u05DE\u05E1\u05D5\u05DE\u05DF \u05D1\u05DB\u05D5\u05DB\u05D1","lang_unread":"\u05DC\u05D0 \u05E0\u05E7\u05E8\u05D0","lang_newest":"\u05D4\u05D7\u05D3\u05E9 \u05D1\u05D9\u05D5\u05EA\u05E8","lang_filter":"\u05DE\u05E1\u05E0\u05DF","lang_markread":"\u05E1\u05D9\u05DE\u05D5\u05DF \u05E9\u05E0\u05E7\u05E8\u05D0","lang_article_reading_time":"{0} \u05D3\u05E7\u05D5\u05EA \u05E7\u05E8\u05D9\u05D0\u05D4","lang_experimental":"\u05E0\u05D9\u05E1\u05D9\u05D5\u05E0\u05D9","lang_source_warn_cancel_dirty":"\u05DC\u05D4\u05E9\u05DC\u05D9\u05DA \u05D0\u05EA \u05D4\u05E9\u05D9\u05E0\u05D5\u05D9\u05D9\u05DD \u05E9\u05DC\u05D0 \u05E0\u05E9\u05DE\u05E8\u05D5?","lang_sources_leaving_unsaved_prompt":"\u05DC\u05E6\u05D0\u05EA \u05DE\u05D4\u05D4\u05D2\u05D3\u05E8\u05D5\u05EA \u05E2\u05DD \u05E9\u05D9\u05E0\u05D5\u05D9\u05D9\u05DD \u05D1\u05DE\u05E7\u05D5\u05E8 \u05E9\u05DC\u05D0 \u05E0\u05E9\u05DE\u05E8\u05D5?","lang_source_browse":"\u05E2\u05D9\u05D5\u05DF","lang_source_menu":"\u05E4\u05E2\u05D5\u05DC\u05D5\u05EA \u05E0\u05D5\u05E1\u05E4\u05D5\u05EA","lang_tag_change_color_button_title":"\u05D4\u05D7\u05DC\u05E4\u05EA \u05E6\u05D1\u05E2","lang_source_go_to_settings":"\u05E4\u05EA\u05D9\u05D7\u05D4 \u05D1\u05D4\u05D2\u05D3\u05E8\u05D5\u05EA","lang_sources_loading":"\u05D4\u05DE\u05E7\u05D5\u05E8\u05D5\u05EA \u05E0\u05D8\u05E2\u05E0\u05D9\u05DD\u2026","lang_no_sources":"\u05DC\u05D0 \u05D4\u05D5\u05D2\u05D3\u05E8\u05D5 \u05DE\u05E7\u05D5\u05E8\u05D5\u05EA.","lang_source_deleting":"\u05D4\u05DE\u05E7\u05D5\u05E8 \u05E0\u05DE\u05D7\u05E7\u2026","lang_source_params_loading":"\u05D4\u05DE\u05E9\u05EA\u05E0\u05D9\u05DD \u05E0\u05D8\u05E2\u05E0\u05D9\u05DD\u2026","lang_source_saving":"\u05D4\u05E9\u05D9\u05E0\u05D5\u05D9\u05D9\u05DD \u05DC\u05DE\u05E7\u05D5\u05E8 \u05E0\u05E9\u05DE\u05E8\u05D9\u05DD\u2026","lang_entries_loading":"\u05D4\u05E8\u05E9\u05D5\u05DE\u05D5\u05EA \u05E0\u05D8\u05E2\u05E0\u05D5\u05EA\u2026","lang_login_in_progress":"\u05DE\u05EA\u05D1\u05E6\u05E2 \u05E0\u05D9\u05E1\u05D9\u05D5\u05DF \u05DB\u05E0\u05D9\u05E1\u05D4\u2026","lang_error_unauthorized":"\u05E0\u05D0 {link_begin}\u05DC\u05D4\u05D9\u05DB\u05E0\u05E1{link_end} \u05DB\u05D3\u05D9 \u05DC\u05D4\u05DE\u05E9\u05D9\u05DA.","lang_login_error_generic":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05D9\u05DB\u05E0\u05E1: {errorMessage}","lang_share_mastodon_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05BEMastodon"}');


var $a93f0f568ed4bbb3$exports = {};
$a93f0f568ed4bbb3$exports = JSON.parse('{"lang_markread":"Mindet olvastam","lang_newest":"Legfrissebb","lang_unread":"Olvasatlan","lang_starred":"Megjel\xf6lt","lang_tags":"C\xedmk\xe9k","lang_alltags":"\xd6sszes c\xedmke","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 \xf3r\xe1ja},other {# \xf3r\xe1ja}}","lang_minutes":"{0,plural,one {1 perce},other {# perce}}","lang_seconds":"{0,plural,one {1 m\xe1sodperce},other {# m\xe1sodperce}}","lang_star":"Megjel\xf6lt","lang_unstar":"Jel\xf6letlen","lang_mark":"Olvasott","lang_unmark":"Olvasatlan","lang_load_img":"K\xe9pbet\xf6lt\xe9s","lang_open_window":"Megnyit\xe1s","lang_searchbutton":"Keres\xe9s","lang_sources":"H\xedrforr\xe1sok","lang_source_add":"\xdaj h\xedrforr\xe1s","lang_source_opml":"OPML-f\xe1jl import\xe1l\xe1sa","lang_source_export":"H\xedrforr\xe1sok export\xe1l\xe1sa","lang_source_edit":"M\xf3dos\xedt\xe1s","lang_source_delete":"T\xf6rl\xe9s","lang_source_warn":"Biztos t\xf6r\xf6lhet\u0151 a h\xedrforr\xe1s?","lang_source_new":"\xdaj h\xedrforr\xe1s","lang_source_title":"C\xedm","lang_source_tags":"C\xedmk\xe9k","lang_source_comma":"(vessz\u0151vel tagolva)","lang_source_select":"A t\xedpus kiv\xe1laszt\xe1sa","lang_source_type":"T\xedpus","lang_source_save":"Ment\xe9s","lang_source_cancel":"M\xe9gsem","lang_source_saved":"Mentve","lang_no_entries":"Nincs megjelen\xedthet\u0151 h\xedr.","lang_more":"Tov\xe1bbiak","lang_login":"Bejelentkez\xe9s","lang_login_username":"Felhaszn\xe1l\xf3n\xe9v","lang_login_password":"Jelsz\xf3","lang_no_title":"Nincs c\xedm","lang_filter":"Sz\u0171r\u0151","lang_online_count":"A kiszolg\xe1l\xf3n l\xe9v\u0151 h\xedrek sz\xe1ma","lang_offline_count":"A helyben t\xe1rolt h\xedrek sz\xe1ma","lang_error_session_expired":"A munkamenet lej\xe1rt.","lang_app_reload":"\xdajrat\xf6lt\xe9s","lang_sources_refreshed":"Az \xfaj h\xedrek keres\xe9se k\xe9sz.","lang_reload_list":"\xdajrat\xf6lt\xe9s","lang_error_unwritable_logs":"A napl\xf3 nem \xedrhat\xf3.","lang_error":"Hiba t\xf6rt\xe9nt","lang_source_pwd_placeholder":"V\xe1ltozatlan","lang_source_filter":"Sz\u0171r\u0151","lang_loginbutton":"Bejelentkez\xe9s","lang_logoutbutton":"Kijelentkez\xe9s","lang_close_entry":"Bez\xe1r\xe1s","lang_share_native_label":"Megoszt\xe1s","lang_error_load_tags":"Nem siker\xfclt bet\xf6lteni a c\xedmk\xe9ket:","lang_searchremove":"Keres\u0151panel elrejt\xe9se","lang_next":"K\xf6vetkez\u0151","lang_app_update":"A selfoss friss\xedtve lett, \xfajra kell t\xf6lteni az oldalt.","lang_error_offline_storage":"T\xe1rol\xf3hiba kapcsolat n\xe9lk\xfcli m\xf3dban: {0}. Az \xfajrat\xf6lt\xe9s seg\xedthet. A kapcsolat n\xe9lk\xfcli m\xf3d mostant\xf3l ki van kapcsolva.","lang_error_star_item":"Nem siker\xfclt m\xf3dos\xedtani a h\xedr megjel\xf6lts\xe9g\xe9t:","lang_days":"{0,plural,zero {ma},one {tegnap},other {# napja}}","lang_share_twitter_label":"Twitter-megoszt\xe1s","lang_share_mail_label":"Megoszt\xe1s e-mailben","lang_settingsbutton":"Be\xe1ll\xedt\xe1sok","lang_sources_loading":"H\xedrforr\xe1sok bet\xf6lt\xe9se\u2026","lang_tag_change_color_button_title":"Sz\xedn cser\xe9je","lang_entries_loading":"Bet\xf6lt\xe9s\u2026","lang_login_invalid_credentials":"Hib\xe1s felhaszn\xe1l\xf3n\xe9v vagy jelsz\xf3","lang_login_error_generic":"Sikertelen bejelentkez\xe9s: {errorMessage}","lang_login_offline":"Kapcsolat n\xe9lk\xfcli t\xe1rol\xf3","lang_experimental":"K\xeds\xe9rleti funkci\xf3","lang_error_saving_color":"Nem siker\xfclt menteni az \xfaj sz\xednt:","lang_error_sync":"Nem siker\xfclt szinkroniz\xe1lni a kiszolg\xe1l\xf3val:","lang_error_configuration":"Nem siker\xfclt beolvasni a be\xe1ll\xedt\xe1sokat.","lang_error_share_native_abort":"Nem siker\xfclt megosztani a h\xedrt \u2013 vagy nincsenek megoszt\xe1si c\xe9lok, vagy a m\u0171velet t\xf6r\xf6lve lett.","lang_error_refreshing_source":"Nem siker\xfclt \xfaj h\xedreket keresni:","lang_info_url_copied":"Az URL a v\xe1g\xf3lapra lett m\xe1solva.","lang_article_actions":"M\u0171veletek","lang_article_reading_time":"~{0} perc","lang_share_diaspora_label":"Diaspora-megoszt\xe1s","lang_share_facebook_label":"Facebook-megoszt\xe1s","lang_offline_navigation_unavailable":"A c\xedmk\xe9k \xe9s h\xedrforr\xe1sok m\xf3dos\xedt\xe1sa kapcsolat n\xe9lk\xfcli m\xf3dban jelenleg nem t\xe1mogatott.","lang_source_last_post":"Legut\xf3bbi h\xedr","lang_source_refresh":"\xdaj h\xedrek keres\xe9se","lang_source_go_to_settings":"Be\xe1ll\xedt\xe1sok","lang_sources_leaving_unsaved_prompt":"Nem minden v\xe1ltoz\xe1s lett elmentve. Biztos bez\xe1rhat\xf3 be\xe1ll\xedt\xf3fel\xfclet?","lang_error_share_native":"Nem siker\xfclt megosztani a h\xedrt.","lang_share_mastodon_label":"Mastodon-megoszt\xe1s","lang_share_pocket_label":"Pocket-ment\xe9s","lang_share_wallabag_label":"Wallabag-ment\xe9s","lang_share_wordpress_label":"WordPress-megoszt\xe1s","lang_share_copy_label":"Hivatkoz\xe1s m\xe1sol\xe1sa","lang_search_label":"Keres\u0151kifejez\xe9s","lang_refreshbutton":"\xdaj h\xedrek keres\xe9se","lang_no_sources":"Nincsenek megadva h\xedrforr\xe1sok.","lang_source_menu":"Tov\xe1bbi m\u0171veletek","lang_source_browse":"Megtekint\xe9s","lang_source_deleting":"A h\xedrforr\xe1s t\xf6rl\xe9se\u2026","lang_source_warn_cancel_dirty":"Bez\xe1r\xe1s ment\xe9s n\xe9lk\xfcl?","lang_source_autotitle_hint":"\xdcresen hagyva automatikus kit\xf6lt\xe9s","lang_source_params_loading":"Param\xe9terek bet\xf6lt\xe9se\u2026","lang_source_saving":"A v\xe1ltoz\xe1sok ment\xe9se\u2026","lang_login_in_progress":"Bejelentkez\xe9s\u2026","lang_error_unauthorized":"A folytat\xe1shoz {link_begin}bejelentkez\xe9s{link_end} sz\xfcks\xe9ges.","lang_error_check_log_file":"Hiba t\xf6rt\xe9nt, r\xe9szletek a napl\xf3f\xe1jlban: \u201E{0}\u201D.","lang_error_check_system_logs":"Hiba t\xf6rt\xe9nt, r\xe9szletek a rendszernapl\xf3ban.","lang_streamerror":"Nem t\xf6lt\u0151d\xf6tt le h\xedr. \xdajrat\xf6lt\xe9s?","lang_error_add_source":"Nem siker\xfclt hozz\xe1adni a h\xedrforr\xe1st:","lang_error_edit_source":"Nem siker\xfclt menteni a h\xedrforr\xe1s v\xe1ltoz\xe1sait:","lang_error_delete_source":"Nem siker\xfclt t\xf6r\xf6lni a h\xedrforr\xe1st:","lang_error_mark_items":"Nem siker\xfclt olvasottra \xe1ll\xedtani a megjelen\xedtett h\xedreket:","lang_error_unknown_tag":"Ismeretlen c\xedmke:","lang_error_unknown_source":"Ismeretlen h\xedrforr\xe1s-azonos\xedt\xf3:","lang_error_mark_item":"Nem siker\xfclt m\xf3dos\xedtani a h\xedr olvasotts\xe1g\xe1t:","lang_error_logout":"Nem siker\xfclt kijelentkezni:","lang_error_loading":"Bet\xf6lt\xe9si hiba:","lang_error_loading_stats":"Nem siker\xfclt bet\xf6lteni a b\xf6ng\xe9sz\xe9si statisztik\xe1t:","lang_error_offline_storage_not_available":"Nem \xe1ll rendelkez\xe9sre t\xe1rol\xf3 a kapcsolat n\xe9lk\xfcli m\xf3dhoz. Ellen\u0151rizni kell, hogy a b\xf6ng\xe9sz\u0151 t\xe1mogatja-e az {0}IndexedDB API{1}-t, illetve Google Chrome alap\xfa b\xf6ng\xe9sz\u0151ben a selfoss nem haszn\xe1lhat\xf3 inkognit\xf3 m\xf3dban.","lang_error_invalid_subsection":"\xc9rv\xe9nytelen aloldal:"}');


var $e1a0d6c367542bd9$exports = {};
$e1a0d6c367542bd9$exports = JSON.parse('{"lang_timestamp":"{0,date} {0,time}","lang_article_reading_time":"bacaan {0} menit","lang_article_actions":"Tindakan","lang_close_entry":"Tutup","lang_info_url_copied":"Alamat URL disalin ke papanklip.","lang_error_share_native":"Tidak dapat membagikan item.","lang_error_share_native_abort":"Tidak dapat membagikan item\u2014kemungkinan disana tidak ada target untuk dibagikan, atau Anda membatalkan hal tersebut.","lang_error_configuration":"Tidak dapat memuat konfigurasi.","lang_error_invalid_subsection":"Subbagian tidak valid:","lang_error_offline_storage_not_available":"Penyimpanan offline tidak tersedia. Pastikan peramban web Anda {0} mendukung DB API yang Terindeks {1} dan, jika Anda menggunakan peramban web Goggle Chrome, pastikan Anda tidak menjalankan selfoss di dalam mode incognito (rahasia).","lang_error_offline_storage":"Kesalahan penyimpanan offline: {0}. Memuat ulang mungkin dapat membantu. Menonaktifkan offline untuk saat ini.","lang_error_sync":"Tidak dapat mengsinkronisasi perubahan terakhir dari server:","lang_error_refreshing_source":"Tidak dapat menyegarkan sumber:","lang_error_saving_color":"Tidak dapat menyimpan warna baru:","lang_error_loading_stats":"Tidak dapat memuat statistik navigasi:","lang_error_loading":"Kesalahan dalam memuat:","lang_error_logout":"Tidak dapat keluar:","lang_error_star_item":"Tidak dapat bintangi/batal bintangi item:","lang_error_mark_item":"Tidak dapat menandai/hapus tanda item:","lang_error_mark_items":"Tidak dapat menandai semua item yang terlihat:","lang_error_unknown_source":"ID sumber tidak diketahui:","lang_error_unknown_tag":"Tag yang tidak diketahui:","lang_error_load_tags":"Tidak dapat memuat tag:","lang_error_delete_source":"Tidak dapat menghapus sumber:","lang_error_edit_source":"Tidak dapat menyimpan perubahan sumber:","lang_error_add_source":"Tidak dapat menambahkan sumber:","lang_error_session_expired":"Sesi kadaluarsa","lang_app_reload":"Muat ulang","lang_app_update":"selfoss telah diperbarui, silahkan muat ulang","lang_sources_refreshed":"Sumber telah disegarkan","lang_reload_list":"Muat ulang daftar","lang_streamerror":"Tidak ada item yang dimuat, muat ulang?","lang_error_unwritable_logs":"Tidak dapat menulis log.","lang_error_check_system_logs":"Sebuah kesalahan terjadi, silahkan periksa log sistem Anda.","lang_error_check_log_file":"Sebuah kesalahan terjadi, silahkan periksa berkas log \\"{0}\\".","lang_error":"Sebuah kesalahan terjadi","lang_experimental":"Eksperimental","lang_no_title":"Tidak ada judul","lang_login_offline":"Penyimpanan offline","lang_login_invalid_credentials":"Nama pengguna/kata sandi salah","lang_login_password":"Kata sandi","lang_login_username":"Nama pengguna","lang_login":"Masuk","lang_more":"Lebih banyak","lang_no_entries":"Tidak ada entri ditemukan","lang_source_refresh":"Segarkan sumber ini","lang_source_last_post":"Postingan terakhir yang dilihat","lang_source_cancel":"Batal","lang_source_saved":"Disimpan","lang_source_save":"Simpan","lang_source_type":"Jenis","lang_source_select":"Silahkan pilih sumber","lang_source_comma":"Dipisahkan oleh koma","lang_source_pwd_placeholder":"Tidak diubah","lang_source_tags":"Tag","lang_source_autotitle_hint":"Biarkan kosong untuk mengambil judul","lang_source_title":"Judul","lang_source_new":"Sumber baru yang belum disimpan","lang_source_warn":"Yakin ingin menghapus sumber ini?","lang_source_delete":"Hapus","lang_source_filter":"Saring","lang_source_edit":"Sunting","lang_source_export":"Ekspor sumber","lang_source_opml":"atau import sebuah berkas OPML","lang_source_add":"Tambahkan sumber","lang_sources":"Sumber","lang_loginbutton":"Masuk","lang_logoutbutton":"Keluar","lang_settingsbutton":"Pengaturan","lang_refreshbutton":"Segarkan sumber","lang_searchremove":"Sembunyikan pencarian","lang_searchbutton":"Cari","lang_search_label":"Cari istilah","lang_share_copy_label":"Salin tautan ke papanklip","lang_share_mail_label":"Bagikan menggunakan email","lang_share_wordpress_label":"Bagikan di WordPress","lang_share_wallabag_label":"Simpan ke Wallabag","lang_share_pocket_label":"Simpan ke Pocket","lang_share_facebook_label":"Bagikan di Facebook","lang_share_twitter_label":"Bagikan di Twitter","lang_share_diaspora_label":"Bagikan di Diaspora","lang_share_native_label":"Bagikan","lang_load_img":"Tampilkan gambar","lang_open_window":"Buka","lang_next":"Selanjutnya","lang_unmark":"Tandai sebagai belum dibaca","lang_mark":"Tandai sebagai telah dibaca","lang_unstar":"Batal Bintangi","lang_star":"Bintangi","lang_days":"{0,plural,zero {today},satu {yesterday},lainnya {# days ago}}","lang_seconds":"{0,plural,one {1 second},lainnya {# seconds}} lalu","lang_minutes":"{0,plural,one {1 minute},lainnya {# minutes}} lalu","lang_hours":"{0,plural,one {1 hour},lainnya {# hours}} lalu","lang_alltags":"Semua tag","lang_tags":"Tag","lang_offline_navigation_unavailable":"Menukar tag dan sumber saat ini tidak tersedia dalam mode offline.","lang_offline_count":"Item tersedia secara lokal","lang_online_count":"Item tersedia di server","lang_starred":"Dilihat","lang_unread":"Belum Dibaca","lang_newest":"Terbaru","lang_filter":"Saring","lang_markread":"Tandai sebagai telah dibaca","lang_entries_loading":"Memuat entri\u2026","lang_source_deleting":"Menghapus sumber\u2026","lang_source_saving":"Menyimpan perubahan sumber\u2026","lang_sources_leaving_unsaved_prompt":"Tinggalkan setelan dengan perubahan sumber yang belum disimpan?","lang_source_go_to_settings":"Buka pengaturan","lang_source_menu":"Tindakan lainnya","lang_login_in_progress":"Mencoba masuk\u2026","lang_source_browse":"Telusuri","lang_login_error_generic":"Tidak bisa masuk: {errorMessage}","lang_source_params_loading":"Memuat parameter\u2026","lang_share_mastodon_label":"Bagikan di Mastodon","lang_sources_loading":"Memuat sumber\u2026","lang_no_sources":"Tidak ada sumber yang dikonfigurasi.","lang_error_unauthorized":"Silakan {link_begin}masuk{link_end} untuk melanjutkan.","lang_source_warn_cancel_dirty":"Buang perubahan yang belum disimpan?","lang_tag_change_color_button_title":"Ubah warna"}');


var $d48d8cf661c7528d$exports = {};
$d48d8cf661c7528d$exports = JSON.parse('{"lang_markread":"Tutte lette","lang_newest":"Recenti","lang_unread":"Non lette","lang_starred":"Contrassegnate","lang_tags":"Etichette","lang_alltags":"Tutte le etichette","lang_timestamp":"{0,date} {0,time}","lang_days":"{0,plural,one {1 ora},other {# ore}} fa","lang_minutes":"{0,plural,one {1 minuto},other {# minuti}} fa","lang_seconds":"{0,plural,one {1 secondo},other {# secondi}} fa","lang_star":"Contrassegna","lang_unstar":"Togli contrassegno","lang_mark":"Segna come letta","lang_unmark":"Segna come non letta","lang_load_img":"Caricare le immagini","lang_open_window":"Apri","lang_searchbutton":"Ricerca","lang_sources":"Fonti","lang_source_add":"Aggiungi una fonte","lang_source_opml":"o importa un file OPML / Google reader","lang_source_export":"Esporta fonti","lang_source_edit":"modifica","lang_source_delete":"cancella","lang_source_warn":"Vuoi veramente eliminare questa fonte?","lang_source_new":"Nuova fonte","lang_source_title":"Titolo","lang_source_tags":"Etichette","lang_source_comma":"separate da una virgola","lang_source_select":"seleziona il tipo di fonte","lang_source_type":"Tipo","lang_source_save":"salva","lang_source_cancel":"annulla","lang_no_entries":"Nessuna pubblicazione","lang_more":"Caricare altre pubblicazioni","lang_login":"Accedi","lang_login_username":"Nome utente","lang_login_password":"Password","lang_no_title":"Senza titolo","lang_error_star_item":"Non \xe8 possibile contrassegnare/togliere il contrassegno per l\'elemento:","lang_error_mark_item":"Impossibile segnare l\'elemento come letto/non letto:","lang_article_actions":"Azioni","lang_close_entry":"Chiudi","lang_info_url_copied":"URL copiato negli appunti.","lang_error_share_native":"Impossibile condividere l\'elemento.","lang_error_share_native_abort":"Impossibile condividere l\'articolo\u202F\u2013\u202Fnon ci sono obiettivi di condivisione o l\'hai cancellato.","lang_error_configuration":"Impossibile caricare la configurazione.","lang_error_invalid_subsection":"Sottosezione non valida:","lang_error_offline_storage":"Errore di archiviazione offline: {0}. Il ricaricamento pu\xf2 aiutare. Disabilitazione la modalit\xe0 offline per ora.","lang_error_sync":"Impossibile sincronizzare le ultime modifiche dal server:","lang_error_refreshing_source":"Impossibile aggiornare le fonti:","lang_error_saving_color":"Impossibile salvare un nuovo colore:","lang_error_loading_stats":"Impossibile caricare le statistiche di navigazione:","lang_error_loading":"Errore di caricamento:","lang_error_logout":"Impossibile uscire:","lang_error_mark_items":"Impossibile contrassegnare tutti gli elementi visibili:","lang_error_unknown_source":"Identificazione della fonte sconosciuta:","lang_error_unknown_tag":"Etichetta sconosciuta:","lang_error_load_tags":"Impossibile caricare le etichette:","lang_error_delete_source":"Impossibile eliminare l\'origine:","lang_error_add_source":"Impossibile aggiungere la fonte:","lang_error_session_expired":"Sessione scaduta","lang_app_reload":"Ricarica","lang_app_update":"selfoss \xe8 stato aggiornato, si prega di ricaricare","lang_sources_refreshed":"Fonti aggiornate","lang_reload_list":"Ricarica l\'elenco","lang_streamerror":"Nessun elemento caricato, ricaricare?","lang_error":"Si \xe8 verificato un errore","lang_source_refresh":"Aggiorna questa fonte","lang_source_last_post":"Ultimo elemento visto","lang_source_saved":"Salvato","lang_source_pwd_placeholder":"Non cambiato","lang_source_autotitle_hint":"Lascia vuoto per recuperare il titolo","lang_source_filter":"Filtro","lang_loginbutton":"Accedi","lang_logoutbutton":"Esci","lang_settingsbutton":"Impostazioni","lang_refreshbutton":"Aggiorna le fonti","lang_searchremove":"Nascondi la ricerca","lang_search_label":"Termine di ricerca","lang_share_copy_label":"Copia il collegamento negli appunti","lang_share_wordpress_label":"Condividi su WordPress","lang_share_wallabag_label":"Salva in Wallabag","lang_share_pocket_label":"Salva in Pocket","lang_share_facebook_label":"Condividi su Facebook","lang_share_twitter_label":"Condividi su Twitter","lang_share_diaspora_label":"Condividi su Diaspora","lang_share_native_label":"Condividi","lang_next":"Avanti","lang_hours":"{0,plural,one {1 ora},other {# ore}} fa","lang_offline_count":"Elementi disponibili localmente","lang_online_count":"Articoli disponibili sul server","lang_filter":"Filtra","lang_share_mail_label":"Condividi via posta elettronica","lang_login_offline":"Archiviazione offline","lang_login_invalid_credentials":"Nome utente o password errato","lang_error_offline_storage_not_available":"Non \xe8 disponibile memoria offline. Assicurati che il tuo browser web {0} supporti IdexedDB API {1} e che tu non stia utilizzando la modalit\xe0 incognito su browser basati su Google Chrome.","lang_error_edit_source":"Impossibile salvare le modifiche alla fonte:","lang_error_unwritable_logs":"Impossibile scrivere i log.","lang_error_check_system_logs":"Si \xe8 verificato un errore, controlla i tuoi log di sistema.","lang_error_check_log_file":"Si \xe8 verificato un errore, controlla il file di log \xab{0}\xbb.","lang_offline_navigation_unavailable":"Al momento non \xe8 possibile modificare etichette e fonti nella modalit\xe0 fuori linea.","lang_article_reading_time":"{0} min letti","lang_experimental":"Sperimentale","lang_source_go_to_settings":"Apri nelle impostazioni","lang_sources_loading":"Caricamento delle fonti\u2026","lang_source_deleting":"Eliminazione della fonte\u2026","lang_source_browse":"Sfoglia","lang_source_params_loading":"Caricamento dei parametri\u2026","lang_no_sources":"Nessuna fonte configurata.","lang_source_warn_cancel_dirty":"Scartare le modifiche non salvate?","lang_source_menu":"Pi\xf9 azioni","lang_sources_leaving_unsaved_prompt":"Esci dalle impostazioni con delle modifiche della fonte non salvate?","lang_tag_change_color_button_title":"Cambia il colore","lang_entries_loading":"Caricamento delle pubblicazioni\u2026","lang_source_saving":"Salvataggio delle modifiche alla fonte\u2026","lang_error_unauthorized":"Per favore {link_begin} connettiti{link_end} per continuare.","lang_login_in_progress":"Tentativo di connessione\u2026","lang_login_error_generic":"Connessione impossibile: {errorMessage}"}');


var $f0732a5d7f7054ed$exports = {};
$f0732a5d7f7054ed$exports = JSON.parse('{"lang_markread":"\u65E2\u8AAD\u306B\u3059\u308B","lang_filter":"\u30D5\u30A3\u30EB\u30BF\u30FC","lang_newest":"\u65B0\u7740","lang_unread":"\u672A\u8AAD","lang_starred":"\u30B9\u30BF\u30FC","lang_tags":"\u30BF\u30B0","lang_alltags":"\u5168\u3066\u306E\u30BF\u30B0","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 \u6642\u9593},other {# \u6642\u9593}}\u524D","lang_minutes":"{0,plural,one {1 \u5206},other {# \u5206}}\u524D","lang_seconds":"{0,plural,one {1 \u79D2},other {# \u79D2}}\u524D","lang_days":"{0,plural,zero {\u4ECA\u65E5},one {\u6628\u65E5},other {# \u65E5\u524D}}","lang_star":"\u30B9\u30BF\u30FC\u3092\u3064\u3051\u308B","lang_unstar":"\u30B9\u30BF\u30FC\u3092\u5916\u3059","lang_mark":"\u65E2\u8AAD\u306B\u3059\u308B","lang_unmark":"\u672A\u8AAD\u306B\u3059\u308B","lang_load_img":"\u753B\u50CF\u3092\u8868\u793A","lang_open_window":"\u958B\u304F","lang_next":"\u6B21\u3078","lang_searchbutton":"\u691C\u7D22","lang_searchremove":"\u691C\u7D22\u3092\u975E\u8868\u793A","lang_refreshbutton":"\u30BD\u30FC\u30B9\u306E\u66F4\u65B0","lang_settingsbutton":"\u8A2D\u5B9A","lang_logoutbutton":"\u30ED\u30B0\u30A2\u30A6\u30C8","lang_loginbutton":"\u30ED\u30B0\u30A4\u30F3","lang_sources":"\u30BD\u30FC\u30B9","lang_source_add":"\u30BD\u30FC\u30B9\u3092\u8FFD\u52A0","lang_source_opml":"\u307E\u305F\u306F OPML \u30D5\u30A1\u30A4\u30EB\u3092\u30A4\u30F3\u30DD\u30FC\u30C8","lang_source_export":"\u30BD\u30FC\u30B9\u3092\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8","lang_source_edit":"\u7DE8\u96C6","lang_source_filter":"\u30D5\u30A3\u30EB\u30BF\u30FC","lang_source_delete":"\u524A\u9664","lang_source_warn":"\u3053\u306E\u30BD\u30FC\u30B9\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F","lang_source_new":"\u65B0\u3057\u3044\u672A\u4FDD\u5B58\u306E\u30BD\u30FC\u30B9","lang_source_title":"\u30BF\u30A4\u30C8\u30EB","lang_source_tags":"\u30BF\u30B0","lang_source_pwd_placeholder":"\u5909\u66F4\u3055\u308C\u3066\u3044\u307E\u305B\u3093","lang_source_comma":"\u30AB\u30F3\u30DE(,)\u533A\u5207\u308A","lang_source_select":"\u30BD\u30FC\u30B9\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044","lang_source_type":"\u30BF\u30A4\u30D7","lang_source_save":"\u4FDD\u5B58","lang_source_cancel":"\u30AD\u30E3\u30F3\u30BB\u30EB","lang_source_saved":"\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F","lang_source_last_post":"\u6700\u7D42\u53C2\u7167\u65E5","lang_source_refresh":"\u3053\u306E\u30BD\u30FC\u30B9\u3092\u66F4\u65B0","lang_no_entries":"\u8A18\u4E8B\u304C\u3042\u308A\u307E\u305B\u3093","lang_more":"\u3082\u3063\u3068\u898B\u308B","lang_login":"\u30ED\u30B0\u30A4\u30F3","lang_login_username":"\u30E6\u30FC\u30B6\u30FC\u540D","lang_login_password":"\u30D1\u30B9\u30EF\u30FC\u30C9","lang_no_title":"\u30BF\u30A4\u30C8\u30EB\u306A\u3057","lang_error":"\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F","lang_streamerror":"\u8A18\u4E8B\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u307E\u3059\u304B\uFF1F","lang_source_autotitle_hint":"\u7A7A\u306E\u307E\u307E\u306B\u3059\u308B\u3068\u30BF\u30A4\u30C8\u30EB\u3092\u53D6\u5F97\u3057\u307E\u3059","lang_login_invalid_credentials":"\u30E6\u30FC\u30B6\u30FC\u540D/\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u9593\u9055\u3063\u3066\u3044\u307E\u3059","lang_reload_list":"\u4E00\u89A7\u3092\u518D\u8AAD\u307F\u8FBC\u307F","lang_sources_refreshed":"\u30BD\u30FC\u30B9\u3092\u66F4\u65B0\u3057\u307E\u3057\u305F","lang_error_session_expired":"\u30BB\u30C3\u30B7\u30E7\u30F3\u304C\u671F\u9650\u5207\u308C\u3067\u3059","lang_error_add_source":"\u30BD\u30FC\u30B9\u3092\u8FFD\u52A0\u3067\u304D\u307E\u305B\u3093:","lang_error_delete_source":"\u30BD\u30FC\u30B9\u3092\u524A\u9664\u3067\u304D\u307E\u305B\u3093:","lang_error_load_tags":"\u30BF\u30B0\u3092\u8AAD\u307F\u8FBC\u307F\u3067\u304D\u307E\u305B\u3093:","lang_error_unknown_tag":"\u4E0D\u660E\u306A\u30BF\u30B0:","lang_error_unknown_source":"\u4E0D\u660E\u306A\u30BD\u30FC\u30B9ID:","lang_error_mark_items":"\u3059\u3079\u3066\u306E\u8868\u793A\u9805\u76EE\u3092\u30DE\u30FC\u30AF\u3067\u304D\u307E\u305B\u3093:","lang_error_mark_item":"\u9805\u76EE\u3092\u30DE\u30FC\u30AF/\u30DE\u30FC\u30AF\u89E3\u9664\u3067\u304D\u307E\u305B\u3093:","lang_error_star_item":"\u9805\u76EE\u3092\u30B9\u30BF\u30FC/\u30B9\u30BF\u30FC\u89E3\u9664\u3067\u304D\u307E\u305B\u3093:","lang_error_logout":"\u30ED\u30B0\u30A2\u30A6\u30C8\u3067\u304D\u307E\u305B\u3093:","lang_error_loading":"\u8AAD\u307F\u8FBC\u307F\u30A8\u30E9\u30FC:","lang_error_loading_stats":"NAV\u7D71\u8A08\u3092\u8AAD\u307F\u8FBC\u307F\u3067\u304D\u307E\u305B\u3093:","lang_error_saving_color":"\u65B0\u3057\u3044\u8272\u3092\u4FDD\u5B58\u3067\u304D\u307E\u305B\u3093:","lang_error_refreshing_source":"\u30BD\u30FC\u30B9\u3092\u66F4\u65B0\u3067\u304D\u307E\u305B\u3093:","lang_error_sync":"\u30B5\u30FC\u30D0\u304B\u3089\u6700\u5F8C\u306E\u5909\u66F4\u3092\u540C\u671F\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F:","lang_error_invalid_subsection":"\u4E0D\u6B63\u306A\u30B5\u30D6\u30BB\u30AF\u30B7\u30E7\u30F3:","lang_online_count":"\u30B5\u30FC\u30D0\u30FC\u3067\u5229\u7528\u53EF\u80FD\u306A\u9805\u76EE","lang_offline_count":"\u30ED\u30FC\u30AB\u30EB\u3067\u5229\u7528\u53EF\u80FD\u306A\u9805\u76EE","lang_login_offline":"\u30AA\u30D5\u30E9\u30A4\u30F3 \u30B9\u30C8\u30EC\u30FC\u30B8","lang_app_update":"selfoss \u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u3066\u304F\u3060\u3055\u3044","lang_app_reload":"\u518D\u8AAD\u307F\u8FBC\u307F","lang_error_offline_storage":"\u30AA\u30D5\u30E9\u30A4\u30F3 \u30B9\u30C8\u30EC\u30FC\u30B8 \u30A8\u30E9\u30FC: {0}\u3002 \u518D\u8AAD\u307F\u8FBC\u307F\u304C\u5F79\u7ACB\u3064\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002\u4ECA\u306E\u3068\u3053\u308D\u3001\u30AA\u30D5\u30E9\u30A4\u30F3\u3092\u7121\u52B9\u306B\u3057\u307E\u3059\u3002","lang_search_label":"\u691C\u7D22\u6761\u4EF6","lang_article_actions":"\u30A2\u30AF\u30B7\u30E7\u30F3","lang_error_configuration":"\u8A2D\u5B9A\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3002","lang_info_url_copied":"URL\u3092\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F\u3002","lang_article_reading_time":"{0} \u5206 \u8AAD\u307F\u307E\u3057\u305F","lang_source_menu":"\u305D\u306E\u4ED6\u306E\u30A2\u30AF\u30B7\u30E7\u30F3","lang_source_browse":"\u691C\u7D22","lang_source_warn_cancel_dirty":"\u4FDD\u5B58\u3055\u308C\u3066\u3044\u306A\u3044\u5909\u66F4\u3092\u7834\u68C4\u3057\u307E\u3059\u304B\uFF1F","lang_sources_leaving_unsaved_prompt":"\u30BD\u30FC\u30B9\u306E\u5909\u66F4\u3092\u4FDD\u5B58\u305B\u305A\u306B\u8A2D\u5B9A\u3092\u6B8B\u3057\u307E\u3059\u304B\uFF1F","lang_experimental":"\u8A66\u9A13\u7684","lang_error_check_system_logs":"\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u30B7\u30B9\u30C6\u30E0\u30ED\u30B0\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","lang_error_edit_source":"\u30BD\u30FC\u30B9\u306E\u5909\u66F4\u3092\u4FDD\u5B58\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\uFF1A","lang_error_share_native":"\u30A2\u30A4\u30C6\u30E0\u3092\u5171\u6709\u3067\u304D\u307E\u305B\u3093\u3002","lang_error_share_native_abort":"\u30A2\u30A4\u30C6\u30E0\u3092\u5171\u6709\u3067\u304D\u307E\u305B\u3093\u2014\u5171\u6709\u5148\u304C\u306A\u3044\u304B\u3001\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F\u3002","lang_share_pocket_label":"Pocket \u306B\u4FDD\u5B58","lang_share_twitter_label":"Twitter \u3067\u30B7\u30A7\u30A2","lang_close_entry":"\u9589\u3058\u308B","lang_share_facebook_label":"Facebook \u3067\u30B7\u30A7\u30A2","lang_offline_navigation_unavailable":"\u73FE\u5728\u3001\u30AA\u30D5\u30E9\u30A4\u30F3\u30E2\u30FC\u30C9\u3067\u306F\u30BF\u30B0\u3068\u30BD\u30FC\u30B9\u306E\u5207\u308A\u66FF\u3048\u304C\u3067\u304D\u307E\u305B\u3093\u3002","lang_share_diaspora_label":"Diaspora \u3067\u30B7\u30A7\u30A2","lang_share_wallabag_label":"Wallabag \u306B\u4FDD\u5B58","lang_share_copy_label":"\u30EA\u30F3\u30AF\u3092\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC","lang_error_check_log_file":"\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u30ED\u30B0\u30D5\u30A1\u30A4\u30EB\u300C{0}\u300D\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","lang_error_unwritable_logs":"\u30ED\u30B0\u3092\u66F8\u304D\u8FBC\u3081\u307E\u305B\u3093\u3002","lang_share_mail_label":"\u30E1\u30FC\u30EB\u3092\u4F7F\u7528\u3057\u3066\u5171\u6709","lang_share_native_label":"\u5171\u6709","lang_share_wordpress_label":"WordPress \u3067\u30B7\u30A7\u30A2","lang_error_offline_storage_not_available":"\u30AA\u30D5\u30E9\u30A4\u30F3\u30B9\u30C8\u30EC\u30FC\u30B8\u306F\u5229\u7528\u3067\u304D\u307E\u305B\u3093\u3002 Web\u30D6\u30E9\u30A6\u30B6 {0} \u304CIndexedDBAPI {1} \u3092\u30B5\u30DD\u30FC\u30C8\u3057\u3066\u3044\u308B\u3053\u3068\u3001\u304A\u3088\u3073 Google Chrome \u30D9\u30FC\u30B9\u306E\u30D6\u30E9\u30A6\u30B6\u3092\u4F7F\u7528\u3057\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u30B7\u30FC\u30AF\u30EC\u30C3\u30C8\u30E2\u30FC\u30C9\u3067 selfoss \u3092\u5B9F\u884C\u3057\u3066\u3044\u306A\u3044\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","lang_share_mastodon_label":"Mastodon \u3067\u30B7\u30A7\u30A2"}');


var $5170287447d26972$exports = {};
$5170287447d26972$exports = JSON.parse('{"lang_markread":"atz\u012Bm\u0113t k\u0101 izlas\u012Btu","lang_filter":"filtrs","lang_newest":"jaun\u0101kais","lang_unread":"neizlas\u012Bts","lang_starred":"ar zvaigzn\u012Bt\u0113m","lang_tags":"Birkas","lang_alltags":"visas birkas","lang_timestamp":"{0,date} {0,time}","lang_hours":"pirms {0,plural,one {1 stundas},other {# stund\u0101m}}","lang_minutes":"pirms {0,plural,one {1 min\u016Btes},other {# min\u016Bt\u0113m}}","lang_seconds":"pirms {0,plural,one {1 sekundes},other {# sekund\u0113m}}","lang_days":"{0,plural,zero {\u0161odien},one {vakardien},other {pirms # dien\u0101m}}","lang_star":"pievienot zvaigzn\u012Bti","lang_unstar":"no\u0146emt zvaigzn\u012Bti","lang_mark":"atz\u012Bm\u0113t k\u0101 izlas\u012Btu","lang_unmark":"atz\u012Bm\u0113t k\u0101 neizlas\u012Btu","lang_load_img":"iel\u0101d\u0113t bildes","lang_open_window":"atv\u0113rt","lang_next":"n\u0101kamais","lang_searchbutton":"mekl\u0113t","lang_searchremove":"sl\u0113pt mekl\u0113\u0161anu","lang_refreshbutton":"atsvaidzin\u0101t avotus","lang_settingsbutton":"iestat\u012Bjumi","lang_logoutbutton":"iziet","lang_loginbutton":"ieiet","lang_sources":"Avoti","lang_source_add":"pievienot avotu","lang_source_opml":"vai import\u0113t opml failu, vai google las\u012Bt\u0101ju","lang_source_export":"eksport\u0113t avotus","lang_source_edit":"labot","lang_source_filter":"Filtrs","lang_source_delete":"dz\u0113st","lang_source_warn":"Vai tie\u0161\u0101m v\u0113laties dz\u0113st \u0161o avotu?","lang_source_new":"nesaglab\u0101ts avots","lang_source_title":"Nosaukums","lang_source_tags":"Birkas","lang_source_pwd_placeholder":"nav main\u012Bjies","lang_source_comma":"atdal\u012Bt ar komatu","lang_source_select":"l\u016Bdzu izv\u0113lieties avotu","lang_source_type":"Tips","lang_source_save":"saglab\u0101t","lang_source_cancel":"atcelt","lang_source_saved":"saglab\u0101ts","lang_source_last_post":"P\u0113d\u0113j\u0101 zi\u0146a redz\u0113ta","lang_no_entries":"nav ierakstu","lang_more":"v\u0113l","lang_login":"ien\u0101kt","lang_login_username":"Lietot\u0101jv\u0101rds","lang_login_password":"Parole","lang_no_title":"nav nosaukuma","lang_error":"k\u013C\u016Bda","lang_streamerror":"Zi\u0146as nav iel\u0101d\u0113tas, p\u0101rl\u0101d\u0113t?"}');


var $7058dfe60927e7af$exports = {};
$7058dfe60927e7af$exports = JSON.parse('{"lang_markread":"Marker som lest","lang_newest":"Nyeste","lang_unread":"Ulest","lang_starred":"Stjernemerket","lang_tags":"Etiketter","lang_alltags":"Alle etiketter","lang_timestamp":"{0,date} {0,time}","lang_hours":"for {0,plural,one {\xe9n time},other {# timer}} ago","lang_minutes":"for {0,plural,one {ett minutt},other {# minutter}} ago","lang_seconds":"for {0,plural,one {ett sekund},other {# sekunder}} siden","lang_star":"Stjernemerk","lang_unstar":"Fjern stjerne","lang_mark":"Marker som lest","lang_unmark":"Marker som ulest","lang_load_img":"Vis bilder","lang_open_window":"\xc5pne","lang_searchbutton":"S\xf8k","lang_sources":"Kilder","lang_source_add":"Legg til kilde","lang_source_opml":"eller importer en OPML-fil","lang_source_export":"Eksporter kilder","lang_source_edit":"Endre","lang_source_delete":"Slett","lang_source_warn":"Vil du virkelig fjerne denne kilden?","lang_source_new":"Ny ulagret kilde","lang_source_title":"Tittel","lang_source_tags":"Etiketter","lang_source_comma":"Kommainndelt","lang_source_select":"Velg kilde","lang_source_type":"Type","lang_source_save":"Lagre","lang_source_cancel":"Avbryt","lang_source_saved":"Lagret","lang_no_entries":"Ingen data funnet","lang_more":"Mer","lang_login":"Logg inn","lang_login_username":"Brukernavn","lang_login_password":"Passord","lang_filter":"Filtrer","lang_days":"{0,plural,zero {i dag},one {i g\xe5r},other {# dager siden}}","lang_next":"Neste","lang_searchremove":"Skjul s\xf8k","lang_refreshbutton":"Gjenoppfrisk kilder","lang_settingsbutton":"Innstillinger","lang_logoutbutton":"Logg ut","lang_loginbutton":"Logg inn","lang_source_filter":"Filter","lang_source_autotitle_hint":"La st\xe5 tom for \xe5 hente tittel","lang_source_pwd_placeholder":"Ikke endret","lang_source_last_post":"Siste post sett","lang_source_refresh":"Gjenoppfrisk denne kilden","lang_login_invalid_credentials":"Feil brukernavn/passord","lang_no_title":"Ingen tittel","lang_error":"En feil inntraff","lang_streamerror":"Ingen elementer ble lastet inn, gjeninnlast?","lang_reload_list":"Gjeninnlast liste","lang_sources_refreshed":"Kilder gjeninnlastet","lang_error_session_expired":"\xd8kt utl\xf8pt","lang_error_add_source":"Kunne ikke legge til kilde:","lang_error_delete_source":"Kunne ikke slette kilde:","lang_error_load_tags":"Kunne ikke laste inn etiketter:","lang_error_unknown_tag":"Ukjent etikett:","lang_error_unknown_source":"Ukjent kilde-ID:","lang_error_mark_items":"Kan ikke merke alle synlige elementer:","lang_error_mark_item":"Kan ikke merke/oppheve merking av element:","lang_error_star_item":"Kan ikke stjernemerke/oppheve stjernemerking av element:","lang_error_logout":"Kunne ikke logge ut:","lang_error_loading":"Innlastingsfeil:","lang_error_loading_stats":"Kan ikke laste navigeringsstatistikk:","lang_error_saving_color":"Kan ikke lagre ny farge:","lang_error_refreshing_source":"Kan ikke gjenoppfriske kilder:","lang_error_sync":"Kunne ikke synkronisere siste endringer fra tjener:","lang_error_invalid_subsection":"Ugyldig underdel:","lang_online_count":"Elementer tilgjengelige p\xe5 tjeneren","lang_offline_count":"Elementer tilgjengelige lokalt","lang_login_offline":"Frakoblet lagring","lang_app_update":"selfoss har blitt oppdatert, last inn p\xe5 ny","lang_app_reload":"Gjeninnlast","lang_error_offline_storage":"Lagringsfeil for frakoblet lagring: {0}. Gjeninnlasting kan hjelpe. Skrur av frakoblet imens.","lang_search_label":"S\xf8ketekst","lang_article_actions":"Handlinger","lang_error_configuration":"Kunne ikke laste inn oppsett.","lang_info_url_copied":"Nettadresse kopiert til utklippstavle.","lang_share_native_label":"Del","lang_share_diaspora_label":"Del p\xe5 Diaspora","lang_share_twitter_label":"Del p\xe5 Twitter","lang_share_facebook_label":"Del p\xe5 Facebook","lang_share_pocket_label":"Del til Pocket","lang_share_wallabag_label":"Lagre p\xe5 Wallabag","lang_share_wordpress_label":"Lagre p\xe5 WordPress","lang_share_mail_label":"Del ved bruk av e-post","lang_share_copy_label":"Kopier lenke til utklippstavle","lang_error_share_native_abort":"Kunne ikke dele element, enten finnes det ingen delingsm\xe5l, eller du har avbrutt deling.","lang_error_share_native":"Kunne ikke dele element.","lang_close_entry":"Lukk","lang_error_unwritable_logs":"Kunne ikke loggf\xf8re.","lang_error_check_log_file":"En feil inntraff, sjekk loggfilen \u201C{0}\u201D.","lang_error_check_system_logs":"En feil inntraff, sjekk systemloggene dine.","lang_offline_navigation_unavailable":"\xc5 bytte etiketter og kilder st\xf8ttes forel\xf8pig ikke i frakoblet modus.","lang_error_offline_storage_not_available":"Frakoblet lager ikke tilgjengelig. S\xf8rg for at din nettleser {0}st\xf8tter IndexedDB-API-et{1}, samt at du ikke bruker incognito-modus i en Chrome-basert nettleser.","lang_error_edit_source":"Kunne ikke lagre kildeendringer:","lang_article_reading_time":"{0} min \xe5 lese","lang_experimental":"Eksperimentell","lang_sources_leaving_unsaved_prompt":"Forlat innstillinger med ulagrede kildeendringer?","lang_source_warn_cancel_dirty":"Forkast ulagrede endringer?"}');


var $51d8b37b1373d182$exports = {};
$51d8b37b1373d182$exports = JSON.parse("{\"lang_markread\":\"markeer gelezen\",\"lang_newest\":\"nieuwste\",\"lang_unread\":\"ongelezen\",\"lang_starred\":\"met ster\",\"lang_tags\":\"Tags\",\"lang_alltags\":\"alle tags\",\"lang_timestamp\":\"{0,date} {0,time}\",\"lang_hours\":\"{0,plural,one {1 hour},other {# uren}} geleden\",\"lang_minutes\":\"{0,plural,one {1 minute},other {# minuten}} geleden\",\"lang_seconds\":\"{0,plural,one {1 second},other {# seconden}} geleden\",\"lang_days\":\"{0,plural,zero {vandaag},one {gisteren},other {# dagen geleden}}\",\"lang_star\":\"ster\",\"lang_unstar\":\"ster verwijderen\",\"lang_mark\":\"gelezen\",\"lang_unmark\":\"ongelezen\",\"lang_load_img\":\"afbeeldingen tonen\",\"lang_open_window\":\"open\",\"lang_searchbutton\":\"zoeken\",\"lang_sources\":\"Bron\",\"lang_source_add\":\"bron toevoegen\",\"lang_source_opml\":\"of importeer opml bestand of google reader\",\"lang_source_export\":\"exporteer bronnen\",\"lang_source_edit\":\"wijzig\",\"lang_source_delete\":\"verwijder\",\"lang_source_warn\":\"bron echt verwijderen?\",\"lang_source_new\":\"nieuwe bron\",\"lang_source_title\":\"Titel\",\"lang_source_tags\":\"Tags\",\"lang_source_comma\":\"komma gescheiden\",\"lang_source_select\":\"selecteer een bron\",\"lang_source_type\":\"Soort\",\"lang_source_save\":\"opslaan\",\"lang_source_cancel\":\"annuleren\",\"lang_source_saved\":\"opgeslagen\",\"lang_source_last_post\":\"Meest recente artikel is gevonden\",\"lang_no_entries\":\"geen items gevonden\",\"lang_more\":\"meer\",\"lang_login\":\"inloggen\",\"lang_login_username\":\"gebruikersnaam\",\"lang_login_password\":\"wachtwoord\",\"lang_no_title\":\"geen titel\"}");


var $3d25a85d30cd5367$exports = {};
$3d25a85d30cd5367$exports = JSON.parse('{"lang_markread":"oznacz jako przeczytane","lang_filter":"filtr","lang_newest":"najnowsze","lang_unread":"nieprzeczytane","lang_starred":"z gwiazdk\u0105","lang_tags":"Tagi","lang_alltags":"wszystkie","lang_timestamp":"{0,date} {0,time}","lang_hours":"przed {0,plural,one {godzin\u0105},other {# godzinami}}","lang_minutes":"przed {0,plural,one {minut\u0105},other {# minutami}}","lang_seconds":"przed {0,plural,one {chwil\u0105},other {# sekundami}}","lang_days":"{0,plural,zero {dzisiaj},one {wczoraj},other {przejrzany # dni temu}}","lang_star":"oznacz gwiazdk\u0105","lang_unstar":"usu\u0144 gwiazdk\u0119","lang_mark":"oznacz jako przeczytane","lang_unmark":"oznacz jako nieprzeczytane","lang_load_img":"pobierz obrazy","lang_open_window":"otw\xf3rz","lang_next":"nast\u0119pny","lang_searchbutton":"szukaj","lang_searchremove":"ukryj wyszukiwanie","lang_refreshbutton":"od\u015Bwie\u017C","lang_settingsbutton":"opcje","lang_logoutbutton":"wyloguj","lang_loginbutton":"zaloguj","lang_sources":"\u0179r\xf3d\u0142a","lang_source_add":"dodaj \u017Ar\xf3d\u0142o","lang_source_opml":"lub zaimportuj plik OPML z Google Reader","lang_source_export":"eksportuj \u017Ar\xf3d\u0142a","lang_source_edit":"edytuj","lang_source_filter":"Filtr","lang_source_delete":"usu\u0144","lang_source_warn":"Czy na pewno chcesz usun\u0105\u0107 to \u017Ar\xf3d\u0142o?","lang_source_new":"nowe niezapisane \u017Ar\xf3d\u0142o","lang_source_title":"Tytu\u0142","lang_source_autotitle_hint":"Pozostaw puste, aby uzupe\u0142ni\u0107 automatycznie","lang_source_tags":"Tagi","lang_source_pwd_placeholder":"bez zmian","lang_source_comma":"rozdzielone przecinkami","lang_source_select":"prosz\u0119 wybra\u0107 typ \u017Ar\xf3d\u0142a","lang_source_type":"Typ","lang_source_save":"zapisz","lang_source_cancel":"anuluj","lang_source_saved":"zapisano","lang_source_last_post":"Ostatni artyku\u0142 zosta\u0142 przejrzany ","lang_source_refresh":"Od\u015Bwie\u017C to \u017Ar\xf3d\u0142o","lang_no_entries":"brak wpis\xf3w","lang_more":"wi\u0119cej","lang_login":"zaloguj","lang_login_username":"u\u017Cytkownik","lang_login_password":"has\u0142o","lang_login_invalid_credentials":"nieprawid\u0142owy login lub has\u0142o.","lang_no_title":"bez tytu\u0142u","lang_error":"wyst\u0105pi\u0142 b\u0142\u0105d","lang_streamerror":"Nie za\u0142adowano \u017Cadnych element\xf3w, od\u015Bwie\u017Cy\u0107?","lang_error_loading":"B\u0142\u0105d podczas \u0142adowania:","lang_experimental":"Eksperymentalny","lang_article_actions":"Dzia\u0142ania","lang_share_native_label":"Udost\u0119pnij","lang_source_browse":"Przegl\u0105daj","lang_app_reload":"Za\u0142aduj ponownie","lang_error_session_expired":"Sesja wygas\u0142a","lang_close_entry":"Zamknij","lang_sources_refreshed":"Od\u015Bwie\u017Cono \u017Ar\xf3d\u0142a","lang_error_unknown_tag":"Nieznany tag:"}');


var $b01b1dfd07b9091e$exports = {};
$b01b1dfd07b9091e$exports = JSON.parse('{"lang_share_mail_label":"Compartilhar usando correio eletr\xf4nico","lang_error":"um erro ocorreu","lang_no_title":"sem t\xedtulo","lang_login_password":"palavra-passe","lang_login_username":"utilizador","lang_login":"entrar","lang_more":"mais","lang_no_entries":"nenhum registo encontrado","lang_source_saved":"gravado","lang_source_cancel":"cancelar","lang_source_save":"gravar","lang_source_type":"Tipo","lang_source_select":"por favor, selecione a fonte","lang_source_comma":"separado por v\xedrgula","lang_source_tags":"Marcadores","lang_source_title":"T\xedtulo","lang_source_new":"nova fonte (n\xe3o salva)","lang_source_warn":"realmente deletar esta fonte?","lang_source_delete":"deletar","lang_source_filter":"Filtro","lang_source_edit":"editar","lang_source_export":"exportar fontes","lang_source_opml":"ou importar ficheiro opml ou google reader","lang_source_add":"adicionar fonte","lang_sources":"Fontes","lang_loginbutton":"entrar","lang_logoutbutton":"sair","lang_settingsbutton":"configura\xe7\xf5es","lang_refreshbutton":"atualizar fontes","lang_searchbutton":"procurar","lang_next":"pr\xf3ximo","lang_open_window":"abrir","lang_load_img":"carregar Imagens","lang_unmark":"marcar como n\xe3o lido","lang_mark":"marcar como lido","lang_unstar":"remover estrela","lang_star":"marcar com estrela","lang_seconds":"{0,plural,one {1 segundo},other {# segundos}} atr\xe1s","lang_minutes":"{0,plural,one {1 minuto},other {# minutos}} atr\xe1s","lang_hours":"{0,plural,one {1 hora},other {# horas}} atr\xe1s","lang_timestamp":"{0,date} {0,time}","lang_alltags":"todos os marcadores","lang_tags":"Marcadores","lang_starred":"com estrela","lang_unread":"n\xe3o lidos","lang_newest":"novos","lang_markread":"marcar como lido","lang_source_last_post":"\xdaltima postagem vista","lang_source_menu":"Mais a\xe7\xf5es","lang_offline_navigation_unavailable":"A troca de etiquetas e fontes n\xe3o est\xe1 atualmente dispon\xedvel em modo offline.","lang_offline_count":"Artigos dispon\xedveis localmente","lang_searchremove":"Ocultar busca","lang_share_diaspora_label":"Compartilhar na Di\xe1spora","lang_share_facebook_label":"Compartilhar no Facebook","lang_share_pocket_label":"Salvar no Pocket","lang_share_wallabag_label":"Salvar no Wallabag","lang_share_copy_label":"Copiar link para a \xe1rea de transfer\xeancia","lang_source_refresh":"Atualizar esta fonte","lang_share_native_label":"Compartilhar","lang_search_label":"Termo de pesquisa","lang_sources_leaving_unsaved_prompt":"Deixar configura\xe7\xf5es com altera\xe7\xf5es de fonte n\xe3o salvas?","lang_online_count":"Itens dispon\xedveis no servidor","lang_share_wordpress_label":"Compartilhar no WordPress","lang_source_autotitle_hint":"Deixe vazio para buscar t\xedtulo","lang_source_browse":"Navegar","lang_source_warn_cancel_dirty":"Descartar altera\xe7\xf5es n\xe3o salvas?","lang_filter":"Filtro","lang_share_twitter_label":"Compartilhe no Twitter","lang_tag_change_color_button_title":"Alterar a cor","lang_sources_loading":"Carregando fontes\u2026","lang_no_sources":"Nenhuma fonte configurada.","lang_source_deleting":"Excluindo fonte\u2026","lang_source_pwd_placeholder":"N\xe3o alterado","lang_source_params_loading":"Carregando par\xe2metros\u2026","lang_source_saving":"Salvar mudan\xe7as de fonte\u2026","lang_source_go_to_settings":"Abrir nas configura\xe7\xf5es","lang_entries_loading":"Carregando entradas\u2026","lang_login_in_progress":"Tentando fazer login\u2026"}');


var $f7917dde3df00ba4$exports = {};
$f7917dde3df00ba4$exports = JSON.parse('{"lang_markread":"marcar como lido","lang_newest":"novos","lang_unread":"n\xe3o lidos","lang_starred":"com estrela","lang_tags":"Marcadores","lang_alltags":"todos os marcadores","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 hora},other {# horas}} atr\xe1s","lang_minutes":"{0,plural,one {1 minuto},other {# minutos}} atr\xe1s","lang_seconds":"{0,plural,one {1 segundo},other {# segundos}} atr\xe1s","lang_star":"marcar com estrela","lang_unstar":"remover estrela","lang_mark":"marcar como lido","lang_unmark":"marcar como n\xe3o lido","lang_load_img":"carregar Imagens","lang_open_window":"abrir","lang_next":"pr\xf3ximo","lang_searchbutton":"procurar","lang_refreshbutton":"atualizar fontes","lang_settingsbutton":"configura\xe7\xf5es","lang_logoutbutton":"sair","lang_loginbutton":"entrar","lang_sources":"Fontes","lang_source_add":"adicionar fonte","lang_source_opml":"ou importar arquivo opml ou google reader","lang_source_export":"exportar fontes","lang_source_edit":"editar","lang_source_filter":"Filtro","lang_source_delete":"deletar","lang_source_warn":"realmente deletar esta fonte?","lang_source_new":"nova fonte (n\xe3o salva)","lang_source_title":"T\xedtulo","lang_source_tags":"Marcadores","lang_source_comma":"separado por v\xedrgula","lang_source_select":"por favor, selecione a fonte","lang_source_type":"Tipo","lang_source_save":"salvar","lang_source_cancel":"cancelar","lang_source_saved":"salvo","lang_no_entries":"nenhum registro encontrado","lang_more":"mais","lang_login":"entrar","lang_login_username":"usu\xe1rio","lang_login_password":"senha","lang_no_title":"sem t\xedtulo","lang_error":"um erro ocorreu","lang_share_mail_label":"Compartilhar usando correio eletr\xf4nico"}');


var $3e02282570dcf5ad$exports = {};
$3e02282570dcf5ad$exports = JSON.parse('{"lang_markread":"marcar sco leg\xec","lang_newest":"pli novas","lang_unread":"nunleg\xec","lang_starred":"cun staila","lang_tags":"Etichettas","lang_alltags":"tut las etichettas","lang_timestamp":"{0,date} {0,time}","lang_hours":"Avant {0,plural,one {1 ura},other {# uras}}","lang_minutes":"Avant {0,plural,one {1 minuta},other {# minutas}}","lang_seconds":"Avant {0,plural,one {1 secunda},other {# secundas}}","lang_star":"agiuntar staila","lang_unstar":"allontanar staila","lang_mark":"marcar sco leg\xec","lang_unmark":"marcar sco nunleg\xec","lang_load_img":"chargiar maletgs","lang_open_window":"avrir","lang_searchbutton":"tschertgar","lang_sources":"Funtaunas","lang_source_add":"agiuntar funtauna","lang_source_opml":"u importar ina datoteca opml u da google reader","lang_source_export":"exportar las funtaunas","lang_source_edit":"modifitgar","lang_source_delete":"stizzar","lang_source_warn":"propi stizzar questa funtauna?","lang_source_new":"nova funtauna betg memorisada","lang_source_title":"Titel","lang_source_tags":"Etichettas","lang_source_comma":"seper\xe0 entras commas","lang_source_select":"tscherna p.pl. la funtauna","lang_source_type":"Tip","lang_source_save":"memorisar","lang_source_cancel":"interrumper","lang_source_saved":"memoris\xe0","lang_no_entries":"chatt\xe0 naginas endataziuns","lang_more":"dapli","lang_login":"s\'annunziar","lang_login_username":"num d\'utilisader","lang_login_password":"pled-clav","lang_no_title":"nagin titel"}');


var $ee2b610e60c3d44b$exports = {};
$ee2b610e60c3d44b$exports = JSON.parse('{"lang_markread":"\u043F\u043E\u043C\u0435\u0442\u0438\u0442\u044C \u043A\u0430\u043A \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043D\u044B\u0435","lang_newest":"\u0441\u0432\u0435\u0436\u0438\u0435","lang_unread":"\u043D\u0435\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043D\u044B\u0435","lang_starred":"\u043E\u0442\u043C\u0435\u0447\u0435\u043D\u043D\u044B\u0435","lang_tags":"\u041C\u0435\u0442\u043A\u0438","lang_alltags":"\u0432\u0441\u0435 \u043C\u0435\u0442\u043A\u0438","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 \u0447\u0430\u0441},other {# \u0447\u0430\u0441\u043E\u0432}} \u043D\u0430\u0437\u0430\u0434","lang_minutes":"{0,plural,one {1 \u043C\u0438\u043D\u0443\u0442\u0443},other {# \u043C\u0438\u043D\u0443\u0442}} \u043D\u0430\u0437\u0430\u0434","lang_seconds":"{0,plural,one {1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443},other {# \u0441\u0435\u043A\u0443\u043D\u0434}} \u043D\u0430\u0437\u0430\u0434","lang_star":"\u043E\u0442\u043C\u0435\u0442\u0438\u0442\u044C","lang_unstar":"\u0441\u043D\u044F\u0442\u044C \u043E\u0442\u043C\u0435\u0442\u043A\u0443","lang_mark":"\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043E","lang_unmark":"\u043D\u0435 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043E","lang_load_img":"\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F","lang_open_window":"\u043E\u0442\u043A\u0440\u044B\u0442\u044C","lang_searchbutton":"\u041F\u043E\u0438\u0441\u043A","lang_sources":"\u0418\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0438","lang_source_add":"\u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A","lang_source_opml":"\u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0444\u0430\u0439\u043B OPML, \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440 \u0438\u0437 Google Reader","lang_source_export":"\u044D\u043A\u0441\u043F\u043E\u0440\u0442 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u043E\u0432","lang_source_edit":"\u043F\u0440\u0430\u0432\u0438\u0442\u044C","lang_source_delete":"\u0443\u0434\u0430\u043B\u0438\u0442\u044C","lang_source_warn":"\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A?","lang_source_new":"\u043D\u043E\u0432\u044B\u0439 \u043D\u0435\u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0439 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A","lang_source_title":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435","lang_source_tags":"\u041C\u0435\u0442\u043A\u0438","lang_source_comma":"\u0440\u0430\u0434\u0435\u043B\u044F\u0439\u0442\u0435 \u0437\u0430\u043F\u044F\u0442\u043E\u0439","lang_source_select":"\u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430","lang_source_type":"\u0422\u0438\u043F","lang_source_save":"\u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C","lang_source_cancel":"\u043E\u0442\u043C\u0435\u043D\u0430","lang_source_saved":"\u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043E","lang_no_entries":"\u0437\u0430\u043F\u0438\u0441\u0435\u0439 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E","lang_more":"\u0435\u0449\u0435","lang_login":"\u0432\u0445\u043E\u0434","lang_login_username":"\u0438\u043C\u044F","lang_login_password":"\u043F\u0430\u0440\u043E\u043B\u044C","lang_no_title":"\u0431\u0435\u0437 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F","lang_searchremove":"\u0421\u043A\u0440\u044B\u0442\u044C \u043F\u043E\u0438\u0441\u043A"}');


var $430ac65b39f56697$exports = {};
$430ac65b39f56697$exports = JSON.parse('{"lang_markread":"ozna\u010Di\u0165 ako pre\u010D\xedtan\xe9","lang_filter":"Zobrazova\u0165","lang_newest":"najnov\u0161ie","lang_unread":"nepre\u010D\xedtan\xe9","lang_starred":"ozna\u010Den\xe9","lang_tags":"Tagy","lang_alltags":"v\u0161etky tagy","lang_timestamp":"{0,date} {0,time}","lang_hours":"pred {0,plural,one {1 hodinou},other {# hodinami}}","lang_minutes":"pred {0,plural,one {1 min\xfatou},other {# min\xfatami}}","lang_seconds":"pred {0,plural,one {chv\xed\u013Eou},other {# sekundami}}","lang_star":"ozna\u010Di\u0165","lang_unstar":"odzna\u010Di\u0165","lang_mark":"ozna\u010Di\u0165 ako pre\u010D\xedtan\xe9","lang_unmark":"ozna\u010Di\u0165 ako nepr\u010D\xedtan\xe9","lang_load_img":"nahra\u0165 obr\xe1zky","lang_open_window":"otvori\u0165","lang_next":"\u010Fal\u0161ie","lang_searchbutton":"vyh\u013Eada\u0165","lang_searchremove":"skry\u0165 vyh\u013Ead\xe1vanie","lang_refreshbutton":"obnovi\u0165 zdroje","lang_settingsbutton":"nastavenia","lang_logoutbutton":"odhl\xe1si\u0165 sa","lang_loginbutton":"prihl\xe1si\u0165 sa","lang_sources":"Zdroje","lang_source_add":"prida\u0165 zdroj","lang_source_opml":"alebo nahra\u0165 opml s\xfabor","lang_source_export":"export zdrojov","lang_source_edit":"upravi\u0165","lang_source_filter":"Filter","lang_source_delete":"zmaza\u0165","lang_source_warn":"Naozaj chcete tento zdroj zmaza\u0165?","lang_source_new":"nov\xfd neulo\u017Een\xfd zdroj","lang_source_title":"N\xe1zov","lang_source_tags":"Tagy","lang_source_comma":"oddelen\xe9 \u010Diarkou","lang_source_select":"vyberte pros\xedm zdroj","lang_source_type":"Typ","lang_source_save":"ulo\u017Ei\u0165","lang_source_cancel":"zru\u0161i\u0165","lang_source_saved":"ulo\u017Een\xe9","lang_no_entries":"\u017Eiadny z\xe1znam","lang_more":"v\xedac","lang_login":"prihl\xe1si\u0165","lang_login_username":"meno","lang_login_password":"heslo","lang_no_title":"Bez titulku","lang_error":"nastala chyba"}');


var $7b91bdeeaf0bdb85$exports = {};
$7b91bdeeaf0bdb85$exports = JSON.parse('{"lang_markread":"Markera som l\xe4st","lang_newest":"Nyast","lang_unread":"Ol\xe4st","lang_starred":"Stj\xe4rnm\xe4rkt","lang_tags":"Taggar","lang_alltags":"Alla taggar","lang_timestamp":"{0,date} {0,time}","lang_hours":"f\xf6r {0,plural,one {1 timme},other {# timmar}} sedan","lang_minutes":"f\xf6r {0,plural,one {1 minut},other {# minuter}} sedan","lang_seconds":"f\xf6r {0,plural,one {1 sekund},other {# sekunder}} sedan","lang_days":"{0,plural,zero {idag},one {ig\xe5r},other {f\xf6r # dagar sedan}}","lang_star":"stj\xe4rna","lang_unstar":"utan stj\xe4rna","lang_mark":"markera som l\xe4st","lang_unmark":"markera som ol\xe4st","lang_load_img":"bilder","lang_open_window":"\xf6ppna","lang_searchbutton":"s\xf6k","lang_sources":"K\xe4lla","lang_source_add":"L\xe4gg till k\xe4lla","lang_source_opml":"eller importera fr\xe5n opml-fil eller Google Reader","lang_source_edit":"redigera","lang_source_delete":"ta bort","lang_source_warn":"Vill du verkligen ta bort denna k\xe4lla?","lang_source_new":"ny k\xe4lla","lang_source_title":"Titel","lang_source_tags":"Tagg","lang_source_comma":"kommaseparerad","lang_source_select":"v\xe4lj k\xe4lla","lang_source_type":"Typ","lang_source_save":"spara","lang_source_cancel":"avbryt","lang_source_saved":"sparad","lang_no_entries":"hittade inga inl\xe4gg","lang_more":"fler","lang_login":"Logga in","lang_login_username":"Anv\xe4ndarnamn","lang_login_password":"L\xf6senord","lang_source_last_post":"Senaste artikel visad","lang_filter":"Filter","lang_online_count":"Objekt tillg\xe4ngliga p\xe5 servern","lang_offline_count":"Objekt som \xe4r tillg\xe4ngliga lokalt","lang_next":"N\xe4sta","lang_searchremove":"D\xf6lj s\xf6k","lang_refreshbutton":"Uppdatera k\xe4llor","lang_settingsbutton":"Inst\xe4llningar","lang_logoutbutton":"Logga ut","lang_loginbutton":"Logga in","lang_source_export":"Exportera k\xe4llor","lang_source_filter":"Filter","lang_source_autotitle_hint":"L\xe4mna tomt f\xf6r att h\xe4mta titel","lang_source_pwd_placeholder":"Inte f\xf6r\xe4ndrad","lang_source_refresh":"Uppdatera den h\xe4r k\xe4llan","lang_login_invalid_credentials":"Fel anv\xe4ndarnamn/l\xf6senord","lang_login_offline":"Offline-lagring","lang_no_title":"Ingen titel","lang_error":"Ett fel uppstod","lang_streamerror":"Inga objekt laddade, ladda om?","lang_reload_list":"Ladda om listan","lang_sources_refreshed":"K\xe4llor uppdaterade","lang_app_update":"selfoss har uppdaterats, ladda om igen","lang_app_reload":"Ladda om","lang_error_session_expired":"Sessionen har g\xe5tt ut","lang_error_add_source":"Kunde inte l\xe4gga till k\xe4lla:","lang_error_delete_source":"Kunde inte ta bort k\xe4llan:","lang_error_load_tags":"Kunde inte ladda taggar:","lang_error_unknown_tag":"Ok\xe4nd tagg:","lang_error_unknown_source":"Ok\xe4nt k\xe4ll-ID:","lang_error_mark_items":"Kan inte markera alla synliga objekt:","lang_error_mark_item":"Kan inte markera/avmarkera objekt:","lang_error_star_item":"Kan inte stj\xe4rna/avstj\xe4rna objekt:","lang_error_logout":"Kunde inte logga in:","lang_error_loading":"Laddningsfel:","lang_error_loading_stats":"Kan inte ladda nav-statistik:","lang_error_saving_color":"Det g\xe5r inte att spara ny f\xe4rg:","lang_error_refreshing_source":"Kan inte uppdatera k\xe4llor:","lang_error_sync":"Kunde inte synkronisera senaste \xe4ndringarna fr\xe5n servern:","lang_error_offline_storage":"Offline-lagringsfel: {0}. Omladdning kan hj\xe4lpa. Inaktiverar offline f\xf6r tillf\xe4llet.","lang_error_invalid_subsection":"Ogiltigt underavsnitt:","lang_search_label":"S\xf6kterm","lang_article_actions":"\xc5tg\xe4rder","lang_error_configuration":"Det g\xe5r inte att ladda konfiguration.","lang_info_url_copied":"URL kopierad till urklipp.","lang_share_native_label":"Dela","lang_share_diaspora_label":"Dela p\xe5 Diaspora","lang_share_twitter_label":"Dela p\xe5 Twitter","lang_share_facebook_label":"Dela p\xe5 Facebook","lang_share_pocket_label":"Spara i Pocket","lang_share_wallabag_label":"Spara i Wallabag","lang_share_wordpress_label":"Dela p\xe5 WordPress","lang_share_mail_label":"Dela med e-post","lang_share_copy_label":"Kopiera l\xe4nk till urklipp","lang_error_share_native_abort":"Det g\xe5r inte att dela objektet - antingen finns det inga delningsm\xe5l eller s\xe5 avbr\xf6t du det.","lang_error_share_native":"Det g\xe5r inte att dela objektet.","lang_close_entry":"St\xe4ng","lang_experimental":"Experimentell","lang_error_unwritable_logs":"Det gick inte att skriva loggar.","lang_error_check_system_logs":"Ett fel uppstod. Kontrollera dina systemloggar.","lang_error_check_log_file":"Ett fel uppstod. Kontrollera loggfilen \u201C{0}\u201D.","lang_source_browse":"Bl\xe4ddra","lang_tag_change_color_button_title":"\xc4ndra f\xe4rg","lang_source_warn_cancel_dirty":"Kasta bort osparade \xe4ndringar?","lang_offline_navigation_unavailable":"Att byta taggar och k\xe4llor \xe4r f\xf6r n\xe4rvarande inte tillg\xe4ngligt i offlinel\xe4ge.","lang_sources_leaving_unsaved_prompt":"L\xe4mna inst\xe4llningar med osparade k\xe4ll\xe4ndringar?","lang_error_offline_storage_not_available":"Offlinelagring \xe4r inte tillg\xe4ngligt. Se till att din webbl\xe4sare {0}st\xf6djer IndexedDB API{1} och, om du anv\xe4nder en Google Chrome baserad webbl\xe4sare, att du inte k\xf6r selfoss i incognito l\xe4ge.","lang_error_edit_source":"Kunde inte spara k\xe4ll\xe4ndringar:","lang_source_menu":"Mer \xe5tg\xe4rder","lang_no_sources":"Inga k\xe4llor konfigurerade.","lang_source_deleting":"Raderar k\xe4lla\u2026","lang_login_error_generic":"Kunde inte logga in: {errorMessage}","lang_sources_loading":"Laddar k\xe4llor\u2026","lang_source_params_loading":"Laddar parametrar\u2026","lang_source_saving":"Sparar k\xe4ll\xe4ndringar\u2026","lang_source_go_to_settings":"\xd6ppna i inst\xe4llningar","lang_entries_loading":"L\xe4ser in poster\u2026","lang_login_in_progress":"F\xf6rs\xf6ker att logga in\u2026","lang_error_unauthorized":"V\xe4nligen {link_begin}logga in{link_end} f\xf6r att forts\xe4tta.","lang_article_reading_time":"{0}min l\xe4s","lang_share_mastodon_label":"Dela p\xe5 Mastodon"}');


var $4bf6b321c83cc414$exports = {};
$4bf6b321c83cc414$exports = JSON.parse('{"lang_offline_count":"\u0B89\u0BB3\u0BCD\u0BB3\u0B95\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD \u0B95\u0BBF\u0B9F\u0BC8\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B89\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0B9F\u0BBF\u0B95\u0BB3\u0BCD","lang_offline_navigation_unavailable":"\u0B95\u0BC1\u0BB1\u0BBF\u0B9A\u0BCD\u0B9A\u0BCA\u0BB1\u0BCD\u0B95\u0BB3\u0BCD \u0BAE\u0BB1\u0BCD\u0BB1\u0BC1\u0BAE\u0BCD \u0BAE\u0BC2\u0BB2\u0B99\u0BCD\u0B95\u0BB3\u0BC8 \u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0BC1\u0BB5\u0BA4\u0BC1 \u0BA4\u0BB1\u0BCD\u0BAA\u0BCB\u0BA4\u0BC1 \u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BBF\u0BB2\u0BCD\u0BB2\u0BBE\u0BA4 \u0BAA\u0BAF\u0BA9\u0BCD\u0BAE\u0BC1\u0BB1\u0BC8\u0BAF\u0BBF\u0BB2\u0BCD \u0B95\u0BBF\u0B9F\u0BC8\u0B95\u0BCD\u0B95\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8.","lang_tags":"\u0B95\u0BC1\u0BB1\u0BBF\u0B9A\u0BCD\u0B9A\u0BC6\u0BBE\u0BB1\u0BCD\u0B95\u0BB3\u0BCD","lang_alltags":"\u0B85\u0BA9\u0BC8\u0BA4\u0BCD\u0BA4\u0BC1 \u0B95\u0BC1\u0BB1\u0BBF\u0B9A\u0BCD\u0B9A\u0BCA\u0BB1\u0BCD\u0B95\u0BB3\u0BC1\u0BAE\u0BCD","lang_timestamp":"{0,date}-{0,time}","lang_days":"{0,plural,zero {\u0B87\u0BA9\u0BCD\u0BB1\u0BC1},one {\u0BA8\u0BC7\u0BB1\u0BCD\u0BB1\u0BC1},other {# \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1}}","lang_star":"\u0BB5\u0BBF\u0BA3\u0BCD\u0BAE\u0BC0\u0BA9\u0BCD \u0B87\u0B9F\u0BC1","lang_unstar":"\u0BB5\u0BBF\u0BA3\u0BCD\u0BAE\u0BC0\u0BA9\u0BCD \u0BA8\u0BC0\u0B95\u0BCD\u0B95\u0BC1","lang_mark":"\u0BAA\u0B9F\u0BBF\u0BA4\u0BCD\u0BA4\u0BAA\u0B9F\u0BBF \u0B95\u0BC1\u0BB1\u0BBF","lang_unmark":"\u0BAA\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BBE\u0BA4\u0BA4\u0BC1 \u0B8E\u0BA9\u0B95\u0BCD \u0B95\u0BC1\u0BB1\u0BBF","lang_load_img":"\u0BAA\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC8\u0B95\u0BCD \u0B95\u0BBE\u0B9F\u0BCD\u0B9F\u0BC1","lang_open_window":"\u0BA4\u0BBF\u0BB1","lang_next":"\u0B85\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BA4\u0BC1","lang_share_native_label":"\u0BAA\u0B99\u0BCD\u0B95\u0BC1","lang_share_diaspora_label":"\u0BAA\u0BC1\u0BB2\u0BAE\u0BCD\u0BAA\u0BC6\u0BAF\u0BB0\u0BCD\u0BA8\u0BCD\u0BA4\u0BCB\u0BB0\u0BBF\u0BB2\u0BCD \u0BAA\u0B95\u0BBF\u0BB0\u0BCD","lang_share_twitter_label":"\u0B95\u0BC0\u0B9A\u0BCD\u0B9A\u0B95\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD \u0BAA\u0B95\u0BBF\u0BB0\u0BCD","lang_share_facebook_label":"\u0BAE\u0BC1\u0B95\u0BA8\u0BC2\u0BB2\u0BBF\u0BB2\u0BCD \u0BAA\u0B95\u0BBF\u0BB0\u0BCD","lang_share_mastodon_label":"\u0B95\u0BC1\u0B9F\u0BCD\u0B9F\u0BC8\u0BAA\u0BCD \u0BAA\u0BB0\u0BC1\u0BA4\u0BCD\u0BA4\u0BBF\u0BAF\u0BBF\u0BB2\u0BCD \u0BAA\u0B95\u0BBF\u0BB0\u0BCD","lang_share_pocket_label":"\u0BAA\u0BC8\u0BAF\u0BBF\u0BB2\u0BCD \u0B9A\u0BC7\u0BAE\u0BBF","lang_share_wallabag_label":"\u0BB5\u0BBE\u0BB2\u0BAA\u0BBE\u0B95\u0BCD \u0B9A\u0BC7\u0BAE\u0BBF","lang_share_wordpress_label":"\u0B9A\u0BCA\u0BB2\u0BCD\u0B85\u0BB4\u0BC1\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD \u0BAA\u0B95\u0BBF\u0BB0\u0BCD","lang_share_mail_label":"\u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0B9E\u0BCD\u0B9A\u0BB2\u0BC8\u0BAA\u0BCD \u0BAA\u0BAF\u0BA9\u0BCD\u0BAA\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BBF \u0BAA\u0B95\u0BBF\u0BB0\u0BCD","lang_share_copy_label":"\u0B87\u0B9F\u0BC8\u0BA8\u0BBF\u0BB2\u0BC8\u0BAA\u0BCD\u0BAA\u0BB2\u0B95\u0BC8\u0B95\u0BCD\u0B95\u0BC1 \u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BC8 \u0BA8\u0B95\u0BB2\u0BC6\u0B9F\u0BC1","lang_search_label":"\u0BA4\u0BC7\u0B9F\u0BAE\u0BCD \u0B9A\u0BCA\u0BB2\u0BCD","lang_searchbutton":"\u0BA4\u0BC7\u0B9F\u0BC1","lang_searchremove":"\u0BA4\u0BC7\u0B9F\u0BB2\u0BC8 \u0BAE\u0BB1\u0BC8","lang_refreshbutton":"\u0BAE\u0BC2\u0BB2\u0B99\u0BCD\u0B95\u0BB3\u0BC8\u0BAA\u0BCD \u0BAA\u0BC1\u0BA4\u0BC1\u0BAA\u0BCD\u0BAA\u0BBF","lang_settingsbutton":"\u0B85\u0BAE\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD","lang_logoutbutton":"\u0BB5\u0BBF\u0B9F\u0BC1\u0BAA\u0BA4\u0BBF\u0B95\u0BC8","lang_loginbutton":"\u0BAA\u0BC1\u0B95\u0BC1\u0BAA\u0BA4\u0BBF\u0B95\u0BC8","lang_sources":"\u0BAE\u0BC2\u0BB2\u0B99\u0BCD\u0B95\u0BB3\u0BCD","lang_sources_loading":"\u0BAE\u0BC2\u0BB2\u0B99\u0BCD\u0B95\u0BB3\u0BC8 \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0B95\u0BBF\u0BB1\u0BA4\u0BC1\u2026","lang_no_sources":"\u0B8E\u0BA8\u0BCD\u0BA4 \u0BAE\u0BC2\u0BB2\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0BAE\u0BCD \u0B95\u0B9F\u0BCD\u0B9F\u0BAE\u0BC8\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8.","lang_source_add":"\u0BAE\u0BC2\u0BB2\u0BA4\u0BCD\u0BA4\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BB0\u0BCD","lang_source_opml":"\u0B85\u0BB2\u0BCD\u0BB2\u0BA4\u0BC1 \u0B92\u0BAA\u0BBF\u0B8E\u0BAE\u0BCD\u0B8E\u0BB2\u0BCD \u0B95\u0BCB\u0BAA\u0BCD\u0BAA\u0BC8 \u0B87\u0BB1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BA4\u0BBF \u0B9A\u0BC6\u0BAF\u0BCD","lang_source_export":"\u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0BAE\u0BA4\u0BBF \u0BAE\u0BC2\u0BB2\u0B99\u0BCD\u0B95\u0BB3\u0BCD","lang_source_edit":"\u0BA4\u0BC6\u0BBE\u0B95\u0BC1","lang_source_filter":"\u0BB5\u0B9F\u0BBF\u0BAA\u0BCD\u0BAA\u0BBF","lang_source_menu":"\u0BAE\u0BC7\u0BB2\u0BC1\u0BAE\u0BCD \u0B9A\u0BC6\u0BAF\u0BB2\u0BCD\u0B95\u0BB3\u0BCD","lang_source_browse":"\u0B89\u0BB2\u0BBE\u0BB5\u0BC1","lang_source_delete":"\u0BA8\u0BC0\u0B95\u0BCD\u0B95\u0BC1","lang_source_warn":"\u0B89\u0BA3\u0BCD\u0BAE\u0BC8\u0BAF\u0BBF\u0BB2\u0BCD \u0B87\u0BA8\u0BCD\u0BA4 \u0BAE\u0BC2\u0BB2\u0BA4\u0BCD\u0BA4\u0BC8 \u0BA8\u0BC0\u0B95\u0BCD\u0B95\u0BB5\u0BBE?","lang_source_deleting":"\u0BAE\u0BC2\u0BB2\u0BA4\u0BCD\u0BA4\u0BC8 \u0BA8\u0BC0\u0B95\u0BCD\u0B95\u0BC1\u0BA4\u0BB2\u0BCD\u2026","lang_source_warn_cancel_dirty":"\u0B9A\u0BC7\u0BAE\u0BBF\u0B95\u0BCD\u0B95\u0BBE\u0BA4 \u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0B99\u0BCD\u0B95\u0BB3\u0BC8 \u0BA8\u0BBF\u0BB0\u0BBE\u0B95\u0BB0\u0BBF\u0B95\u0BCD\u0B95\u0BB5\u0BBE?","lang_source_new":"\u0BAA\u0BC1\u0BA4\u0BBF\u0BAF \u0B9A\u0BC7\u0BAE\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BBE\u0BA4 \u0BAE\u0BC2\u0BB2","lang_source_title":"\u0BA4\u0BB2\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1","lang_source_autotitle_hint":"\u0BA4\u0BB2\u0BC8\u0BAA\u0BCD\u0BAA\u0BC8\u0BAA\u0BCD \u0BAA\u0BC6\u0BB1 \u0B95\u0BBE\u0BB2\u0BBF\u0BAF\u0BBE\u0B95 \u0BB5\u0BBF\u0B9F\u0BC1","lang_source_tags":"\u0B95\u0BC1\u0BB1\u0BBF\u0B9A\u0BCD\u0B9A\u0BC6\u0BBE\u0BB1\u0BCD\u0B95\u0BB3\u0BCD","lang_source_pwd_placeholder":"\u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0BAA\u0BCD\u0BAA\u0B9F\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8","lang_source_comma":"\u0B95\u0BBE\u0BB1\u0BCD\u0BAA\u0BC1\u0BB3\u0BCD\u0BB3\u0BBF\u0BAF\u0BBE\u0BB2\u0BCD \u0BAA\u0BBF\u0BB0\u0BBF\u0BA8\u0BCD\u0BA4\u0BA4\u0BC1","lang_source_select":"\u0BAE\u0BC2\u0BB2\u0BA4\u0BCD\u0BA4\u0BC8\u0BA4\u0BCD \u0BA4\u0BC7\u0BB0\u0BCD\u0BA8\u0BCD\u0BA4\u0BC6\u0B9F\u0BC1","lang_source_params_loading":"\u0B85\u0BB3\u0BB5\u0BC1\u0BB0\u0BC1\u0B95\u0BCD\u0B95\u0BB3\u0BC8 \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0B95\u0BBF\u0BB1\u0BA4\u0BC1\u2026","lang_source_type":"\u0BB5\u0B95\u0BC8","lang_source_save":"\u0B9A\u0BC7\u0BAE\u0BBF","lang_source_cancel":"\u0BA8\u0BC0\u0B95\u0BCD\u0B95\u0BB1\u0BB2\u0BCD","lang_source_saving":"\u0BAE\u0BC2\u0BB2 \u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0B99\u0BCD\u0B95\u0BB3\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BAE\u0BBF\u0B95\u0BCD\u0B95\u0BBF\u0BB1\u0BA4\u0BC1\u2026","lang_source_saved":"\u0B9A\u0BC7\u0BAE\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1","lang_source_last_post":"\u0B95\u0B9F\u0BC8\u0B9A\u0BBF \u0B87\u0B9F\u0BC1\u0B95\u0BC8 \u0BAA\u0BBE\u0BB0\u0BCD\u0BA4\u0BCD\u0BA4\u0BA4\u0BC1","lang_source_refresh":"\u0B87\u0BA8\u0BCD\u0BA4 \u0BAE\u0BC2\u0BB2\u0BA4\u0BCD\u0BA4\u0BC8\u0BAA\u0BCD \u0BAA\u0BC1\u0BA4\u0BC1\u0BAA\u0BCD\u0BAA\u0BBF","lang_source_go_to_settings":"\u0B85\u0BAE\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD \u0BA4\u0BBF\u0BB1","lang_sources_leaving_unsaved_prompt":"\u0B9A\u0BC7\u0BAE\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BBE\u0BA4 \u0BAE\u0BC2\u0BB2 \u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B9F\u0BA9\u0BCD \u0B85\u0BAE\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BC8 \u0BB5\u0BBF\u0B9F\u0BB2\u0BBE\u0BAE\u0BBE?","lang_tag_change_color_button_title":"\u0BA8\u0BBF\u0BB1\u0BA4\u0BCD\u0BA4\u0BC8 \u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0BC1","lang_entries_loading":"\u0B89\u0BB3\u0BCD\u0BB3\u0BC0\u0B9F\u0BC1\u0B95\u0BB3\u0BC8 \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0B95\u0BBF\u0BB1\u0BA4\u0BC1\u2026","lang_no_entries":"\u0B89\u0BB3\u0BCD\u0BB3\u0BC0\u0B9F\u0BC1\u0B95\u0BB3\u0BCD \u0B8E\u0BA4\u0BC1\u0BB5\u0BC1\u0BAE\u0BCD \u0B95\u0BBF\u0B9F\u0BC8\u0B95\u0BCD\u0B95\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8","lang_login_error_generic":"\u0B89\u0BB3\u0BCD\u0BA8\u0BC1\u0BB4\u0BC8\u0BAF \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8: {errorMessage}","lang_error_check_log_file":"\u0BAA\u0BBF\u0BB4\u0BC8 \u0B8F\u0BB1\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1, \u0BA4\u0BAF\u0BB5\u0BC1\u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BC1 \u201C{0}\u201D \u0BAA\u0BA4\u0BBF\u0BB5\u0BC1\u0B95\u0BCD \u0B95\u0BCB\u0BAA\u0BCD\u0BAA\u0BC8 \u0B9A\u0BB0\u0BBF\u0BAA\u0BBE\u0BB0\u0BCD.","lang_error_check_system_logs":"\u0BAA\u0BBF\u0BB4\u0BC8 \u0B8F\u0BB1\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1, \u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B95\u0BA3\u0BBF\u0BA9\u0BBF \u0BAA\u0BA4\u0BBF\u0BB5\u0BC1\u0B95\u0BB3\u0BC8\u0B9A\u0BCD \u0B9A\u0BB0\u0BBF\u0BAA\u0BBE\u0BB0\u0BCD.","lang_error_unwritable_logs":"\u0BAA\u0BA4\u0BBF\u0BB5\u0BC1\u0B95\u0BB3\u0BCD \u0B8E\u0BB4\u0BC1\u0BA4 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8.","lang_streamerror":"\u0B89\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0B9F\u0BBF\u0B95\u0BB3\u0BCD \u0B8F\u0BB1\u0BCD\u0BB1\u0BAA\u0BCD\u0BAA\u0B9F\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8, \u0BAE\u0BC0\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0BAE\u0BBE?","lang_reload_list":"\u0BAA\u0B9F\u0BCD\u0B9F\u0BBF\u0BAF\u0BB2\u0BCD \u0BAE\u0BC0\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1","lang_sources_refreshed":"\u0BAE\u0BC2\u0BB2\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0BAA\u0BC1\u0BA4\u0BC1\u0BAA\u0BCD\u0BAA\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1","lang_error_session_expired":"\u0B85\u0BAE\u0BB0\u0BCD\u0BB5\u0BC1 \u0B95\u0BBE\u0BB2\u0BBE\u0BB5\u0BA4\u0BBF\u0BAF\u0BBE\u0BA9\u0BA4\u0BC1","lang_error_add_source":"\u0BAE\u0BC2\u0BB2\u0BA4\u0BCD\u0BA4\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BB0\u0BCD\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8:","lang_error_edit_source":"\u0BAE\u0BC2\u0BB2 \u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0B99\u0BCD\u0B95\u0BB3\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BAE\u0BBF\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8:","lang_error_delete_source":"\u0BAE\u0BC2\u0BB2\u0BA4\u0BCD\u0BA4\u0BC8 \u0BA8\u0BC0\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8:","lang_error_load_tags":"\u0B95\u0BC1\u0BB1\u0BBF\u0B9A\u0BCD\u0B9A\u0BCA\u0BB1\u0BCD\u0B95\u0BB3\u0BC8 \u0B8F\u0BB1\u0BCD\u0BB1 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8:","lang_error_unknown_tag":"\u0BA4\u0BC6\u0BB0\u0BBF\u0BAF\u0BBE\u0BA4 \u0B95\u0BC1\u0BB1\u0BBF\u0B9A\u0BCD\u0B9A\u0BCA\u0BB2\u0BCD:","lang_error_sync":"\u0B9A\u0BC7\u0BB5\u0BC8\u0BAF\u0B95\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BBF\u0BB0\u0BC1\u0BA8\u0BCD\u0BA4\u0BC1 \u0B95\u0B9F\u0BC8\u0B9A\u0BBF \u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0B99\u0BCD\u0B95\u0BB3\u0BC8 \u0B92\u0BA4\u0BCD\u0BA4\u0BBF\u0B9A\u0BC8\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8:","lang_error_offline_storage":"\u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BBF\u0BB2\u0BCD\u0BB2\u0BBE\u0BA4 \u0B9A\u0BC7\u0BAE\u0BBF\u0BAA\u0BCD\u0BAA\u0B95 \u0BAA\u0BBF\u0BB4\u0BC8: {0}. \u0BAE\u0BC0\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0BB5\u0BA4\u0BC1 \u0B89\u0BA4\u0BB5\u0B95\u0BCD\u0B95\u0BC2\u0B9F\u0BC1\u0BAE\u0BCD. \u0B87\u0BAA\u0BCD\u0BAA\u0BCB\u0BA4\u0BC8\u0B95\u0BCD\u0B95\u0BC1 \u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BBF\u0BB2\u0BCD\u0BB2\u0BBE\u0BA4\u0BA4\u0BC8 \u0BAE\u0BC1\u0B9F\u0B95\u0BCD\u0B95\u0BC1\u0B95\u0BBF\u0BB1\u0BA4\u0BC1.","lang_markread":"\u0BAA\u0B9F\u0BBF\u0BA4\u0BCD\u0BA4\u0BAA\u0B9F\u0BBF \u0B95\u0BC1\u0BB1\u0BBF","lang_filter":"\u0BB5\u0B9F\u0BBF\u0BAA\u0BCD\u0BAA\u0BBF","lang_newest":"\u0BAA\u0BC1\u0BA4\u0BBF\u0BAF\u0BA4\u0BC1","lang_unread":"\u0BAA\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BBE\u0BA4\u0BA4\u0BC1","lang_starred":"\u0BB5\u0BBF\u0BA3\u0BCD\u0BAE\u0BC0\u0BA9\u0BCD \u0B87\u0B9F\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1","lang_online_count":"\u0B9A\u0BC7\u0BB5\u0BC8\u0BAF\u0B95\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD \u0B95\u0BBF\u0B9F\u0BC8\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B89\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0B9F\u0BBF\u0B95\u0BB3\u0BCD","lang_hours":"{0,plural,one {1 \u0BAE\u0BA3\u0BBF\u0BA8\u0BC7\u0BB0\u0BAE\u0BCD},other {# \u0BAE\u0BA3\u0BBF\u0BA8\u0BC7\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD}} \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1","lang_minutes":"{0,plural,one {1 \u0BA8\u0BBF\u0BAE\u0BC8\u0BAF\u0BAE\u0BCD},other {# \u0BA8\u0BBF\u0BAE\u0BC8\u0BAF\u0B99\u0BCD\u0B95\u0BB3\u0BCD}} \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1","lang_seconds":"{0,plural,one {1 \u0BA8\u0BCA\u0B9F\u0BBF},other {# \u0BA8\u0BCA\u0B9F\u0BBF\u0B95\u0BB3\u0BCD}} \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1","lang_more":"\u0BAE\u0BC7\u0BB2\u0BC1\u0BAE\u0BCD","lang_login":"\u0BAA\u0BC1\u0B95\u0BC1\u0BAA\u0BA4\u0BBF\u0B95\u0BC8","lang_login_in_progress":"\u0B89\u0BB3\u0BCD\u0BA8\u0BC1\u0BB4\u0BC8\u0BAF \u0BAE\u0BC1\u0BAF\u0BB1\u0BCD\u0B9A\u0BBF\u0B95\u0BCD\u0B95\u0BBF\u0BB1\u0BA4\u0BC1\u2026","lang_login_username":"\u0BAA\u0BAF\u0BA9\u0BB0\u0BCD\u0BAA\u0BC6\u0BAF\u0BB0\u0BCD","lang_login_password":"\u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BCA\u0BB2\u0BCD","lang_login_invalid_credentials":"\u0BA4\u0BB5\u0BB1\u0BBE\u0BA9 \u0BAA\u0BAF\u0BA9\u0BB0\u0BCD\u0BAA\u0BC6\u0BAF\u0BB0\u0BCD/\u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BCA\u0BB2\u0BCD","lang_login_offline":"\u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BBF\u0BB2\u0BCD\u0BB2\u0BBE\u0BA4 \u0B9A\u0BC7\u0BAE\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1","lang_no_title":"\u0BA4\u0BB2\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1 \u0B87\u0BB2\u0BCD\u0BB2\u0BC8","lang_experimental":"\u0B9A\u0BCB\u0BA4\u0BA9\u0BC8","lang_error":"\u0BAA\u0BBF\u0BB4\u0BC8 \u0B8F\u0BB1\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1","lang_error_unauthorized":"\u0BA4\u0BCA\u0B9F\u0BB0 {link_begin}\u0B89\u0BB3\u0BCD\u0BA8\u0BC1\u0BB4\u0BC8\u0B95{link_end}.","lang_app_update":"\u0B9A\u0BC6\u0BB2\u0BCD\u0BAA\u0BCB\u0B9A\u0BCD \u0BAA\u0BC1\u0BA4\u0BC1\u0BAA\u0BCD\u0BAA\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BC1\u0BB3\u0BCD\u0BB3\u0BA4\u0BC1, \u0BA4\u0BAF\u0BB5\u0BC1\u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BC1 \u0BAE\u0BC0\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1","lang_app_reload":"\u0BAE\u0BB1\u0BC1\u0B8F\u0BB1\u0BCD\u0BB1\u0BC1","lang_error_unknown_source":"\u0BA4\u0BC6\u0BB0\u0BBF\u0BAF\u0BBE\u0BA4 \u0BAE\u0BC2\u0BB2 \u0B85\u0B9F\u0BC8\u0BAF\u0BBE\u0BB3\u0BAE\u0BCD:","lang_error_mark_items":"\u0BAA\u0BC1\u0BB2\u0BAA\u0BCD\u0BAA\u0B9F\u0BC1\u0BAE\u0BCD \u0B85\u0BA9\u0BC8\u0BA4\u0BCD\u0BA4\u0BC1 \u0BAA\u0BCA\u0BB0\u0BC1\u0B9F\u0BCD\u0B95\u0BB3\u0BC8\u0BAF\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BBF\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BBE\u0BA4\u0BC1:","lang_error_mark_item":"\u0B89\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0B9F\u0BBF\u0BAF\u0BC8\u0B95\u0BCD \u0B95\u0BC1\u0BB1\u0BBF\u0B95\u0BCD\u0B95/\u0B95\u0BC1\u0BB1\u0BBF\u0BA8\u0BC0\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BBE\u0BA4\u0BC1:","lang_error_star_item":"\u0BB5\u0BBF\u0BA3\u0BCD\u0BAE\u0BC0\u0BA9\u0BCD \u0B87\u0B9F/\u0BA8\u0BC0\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BBE\u0BA4 \u0B89\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0B9F\u0BBF:","lang_error_logout":"\u0BB5\u0BC6\u0BB3\u0BBF\u0BAF\u0BC7\u0BB1 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8:","lang_error_loading":"\u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0BA4\u0BB2\u0BCD \u0BAA\u0BBF\u0BB4\u0BC8:","lang_error_loading_stats":"\u0BB5\u0BB4\u0BBF\u0B9A\u0BC6\u0BB2\u0BC1\u0BA4\u0BCD\u0BA4\u0BBF\u0BAF \u0BAA\u0BC1\u0BB3\u0BCD\u0BB3\u0BBF\u0BB5\u0BBF\u0BB5\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC8 \u0B8F\u0BB1\u0BCD\u0BB1 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BBE\u0BA4\u0BC1:","lang_error_saving_color":"\u0BAA\u0BC1\u0BA4\u0BBF\u0BAF \u0BB5\u0BA3\u0BCD\u0BA3\u0BA4\u0BCD\u0BA4\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BAE\u0BBF\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BBE\u0BA4\u0BC1:","lang_error_refreshing_source":"\u0BAE\u0BC2\u0BB2\u0B99\u0BCD\u0B95\u0BB3\u0BC8\u0BAA\u0BCD \u0BAA\u0BC1\u0BA4\u0BC1\u0BAA\u0BCD\u0BAA\u0BBF\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BBE\u0BA4\u0BC1:","lang_error_invalid_subsection":"\u0BA4\u0BB5\u0BB1\u0BBE\u0BA9 \u0BA4\u0BC1\u0BA3\u0BC8\u0BAA\u0B95\u0BC1\u0BA4\u0BBF:","lang_error_configuration":"\u0B89\u0BB3\u0BCD\u0BB3\u0BAE\u0BC8\u0BB5\u0BC8 \u0B8F\u0BB1\u0BCD\u0BB1 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8.","lang_error_share_native_abort":"\u0B89\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0B9F\u0BBF\u0BAF\u0BC8\u0BAA\u0BCD \u0BAA\u0B95\u0BBF\u0BB0 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8 -\u0BAA\u0B99\u0BCD\u0B95\u0BC1 \u0B87\u0BB2\u0B95\u0BCD\u0B95\u0BC1\u0B95\u0BB3\u0BCD \u0B87\u0BB2\u0BCD\u0BB2\u0BC8, \u0B85\u0BB2\u0BCD\u0BB2\u0BA4\u0BC1 \u0BA8\u0BC0\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B85\u0BA4\u0BC8\u0BA4\u0BCD \u0BA4\u0BB3\u0BCD\u0BB3\u0BC1\u0BAA\u0B9F\u0BBF \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BC0\u0BB0\u0BCD\u0B95\u0BB3\u0BCD.","lang_close_entry":"\u0BAE\u0BC2\u0B9F\u0BC1","lang_error_offline_storage_not_available":"\u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BBF\u0BB2\u0BCD\u0BB2\u0BBE\u0BA4 \u0B9A\u0BC7\u0BAE\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1 \u0B95\u0BBF\u0B9F\u0BC8\u0B95\u0BCD\u0B95\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8. \u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0BB5\u0BB2\u0BC8 \u0B89\u0BB2\u0BBE\u0BB5\u0BBF {0} \u0B85\u0B9F\u0BCD\u0B9F\u0BB5\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F \u0BA4\u0BB0\u0BB5\u0BC1\u0BA4\u0BCD\u0BA4\u0BB3\u0BAE\u0BCD \u0BAA\u0BA8\u0BBF\u0B87 {1} \u0B90 \u0B86\u0BA4\u0BB0\u0BBF\u0B95\u0BCD\u0B95\u0BBF\u0BB1\u0BA4\u0BC1 \u0B8E\u0BA9\u0BCD\u0BAA\u0BA4\u0BC8 \u0B89\u0BB1\u0BC1\u0BA4\u0BBF\u0BAA\u0BCD\u0BAA\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BBF\u0B95\u0BCD \u0B95\u0BCA\u0BB3\u0BCD\u0BB3\u0BC1\u0B99\u0BCD\u0B95\u0BB3\u0BCD, \u0BAE\u0BC7\u0BB2\u0BC1\u0BAE\u0BCD \u0BA8\u0BC0\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B95\u0BC2\u0B95\u0BBF\u0BB3\u0BCD \u0BA8\u0BBF\u0BB1\u0BAE\u0BBF \u0B85\u0B9F\u0BBF\u0BAA\u0BCD\u0BAA\u0B9F\u0BC8\u0BAF\u0BBF\u0BB2\u0BBE\u0BA9 \u0B89\u0BB2\u0BBE\u0BB5\u0BBF\u0BAF\u0BC8\u0BAA\u0BCD \u0BAA\u0BAF\u0BA9\u0BCD\u0BAA\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BC1\u0B95\u0BBF\u0BB1\u0BC0\u0BB0\u0BCD\u0B95\u0BB3\u0BCD \u0B8E\u0BA9\u0BCD\u0BB1\u0BBE\u0BB2\u0BCD, \u0BA8\u0BC0\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0BAE\u0BB1\u0BC8\u0BA8\u0BBF\u0BB2\u0BC8 \u0BAA\u0BAF\u0BA9\u0BCD\u0BAE\u0BC1\u0BB1\u0BC8\u0BAF\u0BBF\u0BB2\u0BCD \u0B9A\u0BC6\u0BB2\u0BCD\u0BAA\u0BCB\u0B9A\u0BC8 \u0B87\u0BAF\u0B95\u0BCD\u0B95\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8 \u0B8E\u0BA9\u0BCD\u0BAA\u0BA4\u0BC8 \u0B89\u0BB1\u0BC1\u0BA4\u0BBF\u0BAA\u0BCD\u0BAA\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BB5\u0BC1\u0BAE\u0BCD.","lang_error_share_native":"\u0B89\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0B9F\u0BBF\u0BAF\u0BC8\u0BAA\u0BCD \u0BAA\u0B95\u0BBF\u0BB0 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8.","lang_info_url_copied":"\u0BAE\u0BC1\u0B95\u0BB5\u0BB0\u0BBF \u0B87\u0B9F\u0BC8\u0BA8\u0BBF\u0BB2\u0BC8\u0BAA\u0BCD\u0BAA\u0BB2\u0B95\u0BC8\u0B95\u0BCD\u0B95\u0BC1 \u0BA8\u0B95\u0BB2\u0BC6\u0B9F\u0BC1\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1.","lang_article_actions":"\u0B9A\u0BC6\u0BAF\u0BB2\u0BCD\u0B95\u0BB3\u0BCD","lang_article_reading_time":"{0} \u0BA8\u0BBF\u0BAE\u0BC8\u0BAF\u0BAE\u0BCD \u0BAA\u0B9F\u0BBF\u0BA4\u0BCD\u0BA4\u0BA4\u0BC1"}');


var $64a33f7e6e987d4f$exports = {};
$64a33f7e6e987d4f$exports = JSON.parse('{"lang_markread":"Okundu olarak i\u015Faretle","lang_newest":"En yeni","lang_unread":"Okunmayan","lang_starred":"Y\u0131ld\u0131zlanan","lang_tags":"Etiketler","lang_alltags":"T\xfcm etiketler","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0, plural,other {#}} saat \xf6nce","lang_minutes":"{0, plural,other {#}} dakika \xf6nce","lang_seconds":"{0, plural,other {#}} saniye \xf6nce","lang_star":"Y\u0131ld\u0131z ekle","lang_unstar":"Y\u0131ld\u0131z kald\u0131r","lang_mark":"Okundu olarak i\u015Faretle","lang_unmark":"Okunmad\u0131 olarak i\u015Faretle","lang_load_img":"Resimleri g\xf6ster","lang_open_window":"A\xe7","lang_searchbutton":"Ara","lang_sources":"Kaynaklar","lang_source_add":"Kaynak ekle","lang_source_opml":"veya bir OPML dosyas\u0131n\u0131 i\xe7e aktar","lang_source_export":"Kaynaklar\u0131 d\u0131\u015Fa aktar","lang_source_edit":"D\xfczenle","lang_source_delete":"Sil","lang_source_warn":"Bu kaynak ger\xe7ekten silinsin mi?","lang_source_new":"Yeni kaydedilmemi\u015F kaynak","lang_source_title":"Ba\u015Fl\u0131k","lang_source_tags":"Etiketler","lang_source_comma":"Virg\xfclle ayr\u0131lm\u0131\u015F","lang_source_select":"L\xfctfen kaynak se\xe7in","lang_source_type":"T\xfcr","lang_source_save":"Kaydet","lang_source_cancel":"\u0130ptal","lang_source_saved":"Kaydedildi","lang_no_entries":"Yay\u0131n bulunmad\u0131","lang_more":"Daha fazla","lang_login":"Oturum a\xe7","lang_login_username":"Kullan\u0131c\u0131 ad\u0131","lang_login_password":"Parola","lang_no_title":"Ba\u015Fl\u0131k yok","lang_article_actions":"Eylemler","lang_close_entry":"Kapat","lang_info_url_copied":"URL panoya kopyaland\u0131.","lang_error_share_native":"\xd6ge payla\u015F\u0131lam\u0131yor.","lang_error_share_native_abort":"\xd6ge payla\u015F\u0131lam\u0131yor \u2014 ya hi\xe7 payla\u015F\u0131m hedefi yok ya da siz iptal ettiniz.","lang_error_configuration":"Yap\u0131land\u0131rma y\xfcklenemiyor.","lang_error_invalid_subsection":"Ge\xe7ersiz alt b\xf6l\xfcm:","lang_error_offline_storage_not_available":"\xc7evrim d\u0131\u015F\u0131 depolama kullan\u0131lam\u0131yor. Web taray\u0131c\u0131n\u0131z\u0131n {0}IndexedDB API\'sini{1} destekledi\u011Finden ve Google Chrome tabanl\u0131 bir taray\u0131c\u0131 kullan\u0131yorsan\u0131z selfoss\'u gizli modda \xe7al\u0131\u015Ft\u0131rmad\u0131\u011F\u0131n\u0131zdan emin olun.","lang_error_offline_storage":"\xc7evrim d\u0131\u015F\u0131 depolama hatas\u0131: {0}. Yeniden y\xfcklemek yard\u0131mc\u0131 olabilir. \xc7evrim d\u0131\u015F\u0131 \u015Fimdilik devre d\u0131\u015F\u0131 b\u0131rak\u0131l\u0131yor.","lang_error_sync":"Sunucudan son de\u011Fi\u015Fiklikler e\u015Fzamanlanamad\u0131:","lang_error_refreshing_source":"Kaynaklar yenilenemiyor:","lang_error_saving_color":"Yeni renk kaydedilemiyor:","lang_error_loading_stats":"G\xf6z atma istatistikleri y\xfcklenemiyor:","lang_error_loading":"Y\xfckleme hatas\u0131:","lang_error_logout":"Oturum kapat\u0131lamad\u0131:","lang_error_star_item":"\xd6geye y\u0131ld\u0131z eklenemiyor/y\u0131ld\u0131z\u0131 kald\u0131r\u0131lam\u0131yor:","lang_error_mark_item":"\xd6ge i\u015Faretlenemiyor/i\u015Fareti kald\u0131r\u0131lam\u0131yor:","lang_error_mark_items":"T\xfcm g\xf6r\xfcn\xfcr \xf6geler i\u015Faretlenemiyor:","lang_error_unknown_source":"Bilinmeyen kaynak kimli\u011Fi:","lang_error_unknown_tag":"Bilinmeyen etiket:","lang_error_load_tags":"Etiketler y\xfcklenemedi:","lang_error_delete_source":"Kaynak silinemedi:","lang_error_edit_source":"Kaynak de\u011Fi\u015Fiklikleri kaydedilemedi:","lang_error_add_source":"Kaynak eklenemedi:","lang_error_session_expired":"Oturumun s\xfcresi doldu","lang_app_reload":"Yeniden y\xfckle","lang_app_update":"selfoss g\xfcncellendi, l\xfctfen yeniden y\xfckleyin","lang_sources_refreshed":"Kaynaklar yenilendi","lang_reload_list":"Listeyi yeniden y\xfckle","lang_streamerror":"Hi\xe7bir \xf6ge y\xfcklenmedi, yeniden y\xfcklensin mi?","lang_error_unwritable_logs":"G\xfcnl\xfck yaz\u0131lam\u0131yor.","lang_error_check_system_logs":"Bir hata olu\u015Ftu, l\xfctfen sistem g\xfcnl\xfcklerinize bak\u0131n.","lang_error_check_log_file":"Bir hata olu\u015Ftu, l\xfctfen g\xfcnl\xfck dosyas\u0131na bak\u0131n \u201C{0}\u201D.","lang_error":"Bir hata olu\u015Ftu","lang_login_offline":"\xc7evrim d\u0131\u015F\u0131 depolama","lang_login_invalid_credentials":"Yanl\u0131\u015F kullan\u0131c\u0131 ad\u0131/parola","lang_source_refresh":"Bu kayna\u011F\u0131 yenile","lang_source_last_post":"G\xf6r\xfclen son g\xf6nderi","lang_source_pwd_placeholder":"De\u011Fi\u015Fmedi","lang_source_autotitle_hint":"Ba\u015Fl\u0131\u011F\u0131 almak i\xe7in bo\u015F b\u0131rak\u0131n","lang_source_filter":"Filtrele","lang_loginbutton":"Oturum a\xe7","lang_logoutbutton":"Oturumu kapat","lang_settingsbutton":"Ayarlar","lang_refreshbutton":"Kaynaklar\u0131 yenile","lang_searchremove":"Aramay\u0131 gizle","lang_search_label":"Arama terimi","lang_share_copy_label":"Ba\u011Flant\u0131y\u0131 panoya kopyala","lang_share_mail_label":"E-posta ile payla\u015F","lang_share_wordpress_label":"WordPress\'te payla\u015F","lang_share_wallabag_label":"Wallabag\'e kaydet","lang_share_pocket_label":"Pocket\'a kaydet","lang_share_facebook_label":"Facebook\'ta payla\u015F","lang_share_twitter_label":"Twitter\'da payla\u015F","lang_share_diaspora_label":"Diaspora\'da payla\u015F","lang_share_native_label":"Payla\u015F","lang_next":"Sonraki","lang_days":"{0,plural,zero {bug\xfcn},one {d\xfcn},other {# g\xfcn \xf6nce}}","lang_offline_navigation_unavailable":"Etiketleri ve kaynaklar\u0131 de\u011Fi\u015Ftirmek \u015Fu anda \xe7evrim d\u0131\u015F\u0131 modda kullan\u0131lam\u0131yor.","lang_offline_count":"Yerel olarak kullan\u0131labilen \xf6geler","lang_online_count":"Sunucuda bulunan \xf6geler","lang_filter":"Filtrele","lang_article_reading_time":"{0} dakika okuma","lang_experimental":"Deneysel","lang_source_warn_cancel_dirty":"Kaydedilmemi\u015F de\u011Fi\u015Fiklikler at\u0131ls\u0131n m\u0131?","lang_sources_leaving_unsaved_prompt":"Kaydedilmemi\u015F kaynak de\u011Fi\u015Fiklikleri olmas\u0131na ra\u011Fmen ayarlardan \xe7\u0131k\u0131ls\u0131n m\u0131?","lang_source_browse":"G\xf6z at","lang_source_menu":"Daha fazla eylem","lang_tag_change_color_button_title":"Rengi de\u011Fi\u015Ftir","lang_source_go_to_settings":"Ayarlarda a\xe7","lang_sources_loading":"Kaynaklar y\xfckleniyor\u2026","lang_no_sources":"Yap\u0131land\u0131r\u0131lan kaynak yok.","lang_entries_loading":"Yay\u0131nlar y\xfckleniyor\u2026","lang_source_deleting":"Kaynak siliniyor\u2026","lang_login_in_progress":"Oturum a\xe7maya \xe7al\u0131\u015F\u0131l\u0131yor\u2026","lang_source_params_loading":"Parametreler y\xfckleniyor\u2026","lang_source_saving":"Kaynak de\u011Fi\u015Fiklikleri kaydediliyor\u2026","lang_error_unauthorized":"Devam etmek i\xe7in l\xfctfen {link_begin}oturum a\xe7\u0131n{link_end}.","lang_login_error_generic":"Oturum a\xe7\u0131lamad\u0131: {errorMessage}","lang_share_mastodon_label":"Mastodon\'da payla\u015F"}');


var $563d7fbeeac49c6b$exports = {};
$563d7fbeeac49c6b$exports = JSON.parse('{"lang_markread":"\u041F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0438\u043C","lang_newest":"\u041D\u0430\u0439\u043D\u043E\u0432\u0456\u0448\u0456","lang_unread":"\u041D\u0435\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0456","lang_starred":"\u041F\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0456","lang_tags":"\u041C\u0456\u0442\u043A\u0438","lang_alltags":"\u0423\u0441\u0456 \u043C\u0456\u0442\u043A\u0438","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 \u0433\u043E\u0434\u0438\u043D\u0443},other {# \u0433\u043E\u0434\u0438\u043D\u0438}} \u0442\u043E\u043C\u0443","lang_minutes":"{0,plural,one {1 \u0445\u0432\u0438\u043B\u0438\u043D\u0443},other {# \u0445\u0432\u0438\u043B\u0438\u043D\u0438}} \u0442\u043E\u043C\u0443","lang_seconds":"{0,plural,one {1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443},other {# \u0441\u0435\u043A\u0443\u043D\u0434\u0438}} \u0442\u043E\u043C\u0443","lang_star":"\u041F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438","lang_unstar":"\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u043F\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F","lang_mark":"\u041F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0438\u043C","lang_unmark":"\u041F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u043D\u0435\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0438\u043C","lang_load_img":"\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F","lang_open_window":"\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438","lang_searchbutton":"\u041F\u043E\u0448\u0443\u043A","lang_sources":"\u0414\u0436\u0435\u0440\u0435\u043B\u0430","lang_source_add":"\u0414\u043E\u0434\u0430\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u043E","lang_source_opml":"\u0430\u0431\u043E \u0456\u043C\u043F\u043E\u0440\u0442\u0443\u0432\u0430\u0442\u0438 \u0437 OPML-\u0444\u0430\u0439\u043B\u0443","lang_source_export":"\u0435\u043A\u0441\u043F\u043E\u0440\u0442 \u0434\u0436\u0435\u0440\u0435\u043B","lang_source_edit":"\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438","lang_source_delete":"\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438","lang_source_warn":"\u0414\u0456\u0439\u0441\u043D\u043E \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0446\u0435 \u0434\u0436\u0435\u0440\u0435\u043B\u043E?","lang_source_new":"\u041D\u043E\u0432\u0435 \u043D\u0435 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0435 \u0434\u0436\u0435\u0440\u0435\u043B\u043E","lang_source_title":"\u041D\u0430\u0437\u0432\u0430","lang_source_tags":"\u041C\u0456\u0442\u043A\u0438","lang_source_comma":"\u0420\u043E\u0437\u0434\u0456\u043B\u0435\u043D\u0456 \u043A\u043E\u043C\u043E\u044E","lang_source_select":"\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u0438\u043F \u0434\u0436\u0435\u0440\u0435\u043B\u0430","lang_source_type":"\u0422\u0438\u043F","lang_source_save":"\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438","lang_source_cancel":"\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438","lang_source_saved":"\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E","lang_no_entries":"\u0417\u0430\u043F\u0438\u0441\u0456\u0432 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E","lang_more":"\u0429\u0435","lang_login":"\u0412\u0445\u0456\u0434","lang_login_username":"\u0406\u043C\'\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430","lang_login_password":"\u041F\u0430\u0440\u043E\u043B\u044C","lang_no_title":"\u0411\u0435\u0437 \u043D\u0430\u0437\u0432\u0438","lang_filter":"\u0424\u0456\u043B\u044C\u0442\u0440","lang_online_count":"\u0415\u043B\u0435\u043C\u0435\u043D\u0442\u0438, \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0456 \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0456","lang_offline_count":"\u0415\u043B\u0435\u043C\u0435\u043D\u0442\u0438, \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0456 \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u043E","lang_source_browse":"\u041E\u0433\u043B\u044F\u0434","lang_share_facebook_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u043D\u0430 Facebook","lang_error_check_log_file":"\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430, \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0444\u0430\u0439\u043B \u0436\u0443\u0440\u043D\u0430\u043B\u0443 \\"{0}\\".","lang_error_check_system_logs":"\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430, \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u0456 \u0436\u0443\u0440\u043D\u0430\u043B\u0438.","lang_error_unwritable_logs":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u0437\u0430\u043F\u0438\u0441\u0430\u0442\u0438 \u0436\u0443\u0440\u043D\u0430\u043B\u0438.","lang_streamerror":"\u0415\u043B\u0435\u043C\u0435\u043D\u0442\u0438 \u043D\u0435 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u0456, \u043F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438?","lang_error_edit_source":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0437\u043C\u0456\u043D\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u0430:","lang_error_mark_items":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u043F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u0432\u0441\u0456 \u0432\u0438\u0434\u0438\u043C\u0456 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438:","lang_error_star_item":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u043F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u0430\u0431\u043E \u0437\u043D\u044F\u0442\u0438 \u0437\u0456\u0440\u043E\u0447\u043A\u0443:","lang_error_logout":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0432\u0438\u0439\u0442\u0438:","lang_error_saving_color":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043A\u043E\u043B\u0456\u0440:","lang_error_sync":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0443\u0432\u0430\u0442\u0438 \u043E\u0441\u0442\u0430\u043D\u043D\u0456 \u0437\u043C\u0456\u043D\u0438 \u0437 \u0441\u0435\u0440\u0432\u0435\u0440\u0430:","lang_error_unknown_source":"\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0438\u0439 ID \u0434\u0436\u0435\u0440\u0435\u043B\u0430:","lang_error_load_tags":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043C\u0456\u0442\u043A\u0438:","lang_error_unknown_tag":"\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043C\u0456\u0442\u043A\u0430:","lang_error_refreshing_source":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u0430:","lang_error_mark_item":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u043F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438/\u0437\u043D\u044F\u0442\u0438 \u043F\u043E\u0437\u043D\u0430\u0447\u043A\u0443 \u0437 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0430:","lang_error_offline_storage":"\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0432 \u043E\u0444\u043B\u0430\u0439\u043D-\u0441\u0445\u043E\u0432\u0438\u0449\u0456: {0}. \u041F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043C\u043E\u0436\u0435 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0442\u0438. \u041D\u0430\u0440\u0430\u0437\u0456 \u0432\u0438\u043C\u0438\u043A\u0430\u0454\u0442\u044C\u0441\u044F \u043E\u0444\u043B\u0430\u0439\u043D.","lang_days":"{0,plural,zero {\u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456},one {\u0432\u0447\u043E\u0440\u0430},other {# \u0434\u043D\u0456\u0432 \u0442\u043E\u043C\u0443}}","lang_error_unauthorized":"\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, {link_begin}\u0443\u0432\u0456\u0439\u0434\u0456\u0442\u044C{link_end}, \u0449\u043E\u0431 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438.","lang_share_native_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F","lang_share_twitter_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u0432 Twitter","lang_share_mastodon_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u043D\u0430 Mastodon","lang_source_deleting":"\u0412\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u0434\u0436\u0435\u0440\u0435\u043B\u0430\u2026","lang_share_wordpress_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u043D\u0430 WordPress","lang_share_copy_label":"\u0421\u043A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0456\u043D\u0443","lang_search_label":"\u041F\u043E\u0448\u0443\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0442","lang_share_mail_label":"\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u0435-\u043F\u043E\u0448\u0442\u043E\u044E","lang_searchremove":"\u0421\u0445\u043E\u0432\u0430\u0442\u0438 \u043F\u043E\u0448\u0443\u043A","lang_logoutbutton":"\u0412\u0438\u0439\u0442\u0438","lang_settingsbutton":"\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F","lang_loginbutton":"\u0423\u0432\u0456\u0439\u0442\u0438","lang_no_sources":"\u0414\u0436\u0435\u0440\u0435\u043B\u0430 \u043D\u0435 \u043D\u0430\u043B\u0430\u0448\u0442\u043E\u0432\u0430\u043D\u0456.","lang_source_filter":"\u0424\u0456\u043B\u044C\u0442\u0440","lang_error_loading_stats":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043D\u0430\u0432\u0456\u0433\u0430\u0446\u0456\u0439\u043D\u0443 \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0443:","lang_source_menu":"\u0414\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0456 \u0434\u0456\u0457","lang_sources_leaving_unsaved_prompt":"\u041F\u043E\u043A\u0438\u043D\u0443\u0442\u0438 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0437 \u043D\u0435\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0438\u043C\u0438 \u0437\u043C\u0456\u043D\u0430\u043C\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u0430?","lang_login_error_generic":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0443\u0432\u0456\u0439\u0442\u0438: {errorMessage}","lang_experimental":"\u0415\u043A\u0441\u043F\u0435\u0440\u0438\u043C\u0435\u043D\u0442\u0430\u043B\u044C\u043D\u0456","lang_tag_change_color_button_title":"\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u043A\u043E\u043B\u0456\u0440","lang_login_in_progress":"\u0421\u043F\u0440\u043E\u0431\u0430 \u0443\u0432\u0456\u0439\u0442\u0438\u2026","lang_sources_refreshed":"\u0414\u0436\u0435\u0440\u0435\u043B\u0430 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u0456","lang_error":"\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430","lang_sources_loading":"\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0436\u0435\u0440\u0435\u043B\u2026","lang_login_invalid_credentials":"\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0435 \u0456\u043C\'\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430/\u043F\u0430\u0440\u043E\u043B\u044C","lang_error_loading":"\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u0456:","lang_source_last_post":"\u041E\u0441\u0442\u0430\u043D\u043D\u0456\u0439 \u043F\u043E\u0431\u0430\u0447\u0435\u043D\u0438\u0439 \u0434\u043E\u043F\u0438\u0441","lang_refreshbutton":"\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u0430","lang_share_diaspora_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u043D\u0430 Diaspora","lang_share_wallabag_label":"\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0443 Wallabag","lang_next":"\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439","lang_source_saving":"\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F \u0437\u043C\u0456\u043D \u0434\u0436\u0435\u0440\u0435\u043B\u0430\u2026","lang_entries_loading":"\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0437\u0430\u043F\u0438\u0441\u0456\u0432\u2026","lang_reload_list":"\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0441\u043F\u0438\u0441\u043E\u043A","lang_share_pocket_label":"\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0432 Pocket","lang_info_url_copied":"URL \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0456\u043D\u0443.","lang_offline_navigation_unavailable":"\u041F\u0435\u0440\u0435\u043C\u0438\u043A\u0430\u043D\u043D\u044F \u043C\u0456\u0442\u043E\u043A \u0456 \u0434\u0436\u0435\u0440\u0435\u043B \u043D\u0430\u0440\u0430\u0437\u0456 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0435 \u0432 \u0440\u0435\u0436\u0438\u043C\u0456 \u043E\u0444\u043B\u0430\u0439\u043D.","lang_source_warn_cancel_dirty":"\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u043D\u0435\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0456 \u0437\u043C\u0456\u043D\u0438?","lang_error_offline_storage_not_available":"\u041E\u0444\u043B\u0430\u0439\u043D-\u0441\u0445\u043E\u0432\u0438\u0449\u0435 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0435. \u041F\u0435\u0440\u0435\u043A\u043E\u043D\u0430\u0439\u0442\u0435\u0441\u044F, \u0449\u043E \u0432\u0430\u0448 \u0432\u0435\u0431\u0431\u0440\u0430\u0443\u0437\u0435\u0440 {0} \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u0443\u0454 API IndexedDB{1} \u0456, \u044F\u043A\u0449\u043E \u0432\u0438 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0454\u0442\u0435 \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u043D\u0430 \u0431\u0430\u0437\u0456 Google Chrome, \u0442\u043E \u0432\u0438 \u043D\u0435 \u0437\u0430\u0441\u0442\u043E\u0441\u043E\u0432\u0443\u0454\u0442\u0435 selfoss \u0432 \u0440\u0435\u0436\u0438\u043C\u0456 \u0456\u043D\u043A\u043E\u0433\u043D\u0456\u0442\u043E.","lang_error_invalid_subsection":"\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u043F\u0456\u0434\u0440\u043E\u0437\u0434\u0456\u043B:","lang_error_configuration":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043A\u043E\u043D\u0444\u0456\u0433\u0443\u0440\u0430\u0446\u0456\u044E.","lang_error_share_native_abort":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u043F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F - \u0430\u0431\u043E \u043D\u0435\u043C\u0430\u0454 \u0446\u0456\u043B\u0435\u0439, \u0430\u0431\u043E \u0432\u0438 \u0457\u0445 \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u043B\u0438.","lang_error_share_native":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u043F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F.","lang_close_entry":"\u0417\u0430\u043A\u0440\u0438\u0442\u0438","lang_article_actions":"\u0414\u0456\u0457","lang_article_reading_time":"{0} \u0445\u0432 \u0447\u0438\u0442\u0430\u043D\u043D\u044F","lang_source_autotitle_hint":"\u0417\u0430\u043B\u0438\u0448\u0442\u0435 \u043F\u043E\u0440\u043E\u0436\u043D\u0456\u043C, \u0449\u043E\u0431 \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u043D\u0430\u0437\u0432\u0443","lang_source_pwd_placeholder":"\u0411\u0435\u0437 \u0437\u043C\u0456\u043D","lang_source_params_loading":"\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0443\u0454\u043C\u043E \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0438\u2026","lang_source_refresh":"\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0446\u0435 \u0434\u0436\u0435\u0440\u0435\u043B\u043E","lang_source_go_to_settings":"\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0432 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F\u0445","lang_login_offline":"\u041E\u0444\u043B\u0430\u0439\u043D-\u0441\u0445\u043E\u0432\u0438\u0449\u0435","lang_app_update":"selfoss \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E, \u0431\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0442\u0435","lang_app_reload":"\u041F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438","lang_error_session_expired":"\u0421\u0435\u0430\u043D\u0441 \u0443\u0436\u0435 \u0437\u0430\u043A\u0456\u043D\u0447\u0438\u0432\u0441\u044F","lang_error_add_source":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0434\u043E\u0434\u0430\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u043E:","lang_error_delete_source":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u043E:"}');


var $94f63a341744b7b8$exports = {};
$94f63a341744b7b8$exports = JSON.parse('{"lang_markread":"\u5168\u90E8\u6807\u8BB0\u4E3A\u5DF2\u8BFB","lang_newest":"\u6700\u65B0\u6761\u76EE","lang_unread":"\u672A\u8BFB\u6761\u76EE","lang_starred":"\u52A0\u661F\u6807\u7684\u6761\u76EE","lang_tags":"\u6807\u7B7E","lang_alltags":"\u6240\u6709\u6807\u7B7E","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 \u5C0F\u65F6},other {# \u5C0F\u65F6}}\u524D","lang_minutes":"{0,plural,one {1 \u5206\u949F},other {# \u5206\u949F}}\u524D","lang_seconds":"{0,plural,one {1 \u79D2},other {# \u79D2}}\u524D","lang_days":"{0,plural,zero {\u4ECA\u5929},one {\u6628\u5929},other {# \u5929\u524D}}","lang_star":"\u52A0\u661F\u6807","lang_unstar":"\u53D6\u6D88\u661F\u6807","lang_mark":"\u6807\u8BB0\u4E3A\u5DF2\u8BFB","lang_unmark":"\u6807\u8BB0\u4E3A\u672A\u8BFB","lang_load_img":"\u52A0\u8F7D\u56FE\u7247","lang_open_window":"\u6253\u5F00","lang_searchbutton":"\u641C\u7D22","lang_sources":"\u6E90","lang_source_add":"\u6DFB\u52A0\u6E90","lang_source_opml":"\u6216\u5BFC\u5165 OPML \u6587\u4EF6/Google \u9605\u8BFB\u5668\u8BA2\u9605","lang_source_export":"\u5BFC\u51FA\u6E90","lang_source_edit":"\u7F16\u8F91","lang_source_delete":"\u5220\u9664","lang_source_warn":"\u786E\u8BA4\u8981\u5220\u9664\u8BE5\u6E90?","lang_source_new":"\u65B0\u7684\u6E90","lang_source_title":"\u6807\u9898","lang_source_tags":"\u6807\u7B7E","lang_source_comma":"\u4EE5\u9017\u53F7\u5206\u9694","lang_source_select":"\u8BF7\u9009\u62E9\u6E90","lang_source_type":"\u7C7B\u578B","lang_source_save":"\u4FDD\u5B58","lang_source_cancel":"\u53D6\u6D88","lang_source_saved":"\u5DF2\u4FDD\u5B58","lang_source_last_post":"\u66F4\u65B0\u4E8E","lang_no_entries":"\u6CA1\u6709\u6761\u76EE","lang_more":"\u66F4\u591A","lang_login":"\u767B\u5F55","lang_login_username":"\u7528\u6237\u540D","lang_login_password":"\u5BC6\u7801","lang_no_title":"\u65E0\u6807\u9898","lang_logoutbutton":"\u767B\u51FA","lang_loginbutton":"\u767B\u5F55","lang_error_logout":"\u4E0D\u80FD\u767B\u51FA\uFF1A","lang_settingsbutton":"\u8BBE\u7F6E","lang_app_reload":"\u518D\u542F\u52A8","lang_error_session_expired":"\u4F1A\u8BDD\u5DF2\u8FC7\u671F","lang_close_entry":"\u5173\u95ED","lang_error_sync":"\u65E0\u6CD5\u4ECE\u670D\u52A1\u5668\u540C\u6B65\u65B0\u7684\u66F4\u6539\uFF1A","lang_share_pocket_label":"\u4FDD\u5B58\u5230 Pocket","lang_searchremove":"\u9690\u85CF\u641C\u7D22","lang_error_share_native_abort":"\u65E0\u6CD5\u5206\u4EAB\u6761\u76EE - \u53EF\u80FD\u662F\u7F3A\u5C11\u5206\u4EAB\u5BF9\u8C61\u6216\u60A8\u5DF2\u53D6\u6D88\u5206\u4EAB\u3002","lang_error_mark_items":"\u65E0\u6CD5\u6807\u8BB0\u6240\u6709\u53EF\u89C1\u9879\u76EE\uFF1A","lang_share_twitter_label":"\u5206\u4EAB\u5230 Twitter","lang_share_wallabag_label":"\u4FDD\u5B58\u5230 Wallabag","lang_filter":"\u7B5B\u9009","lang_online_count":"\u670D\u52A1\u5668\u53EF\u7528\u7684\u6761\u76EE","lang_offline_navigation_unavailable":"\u79BB\u7EBF\u6A21\u5F0F\u4E0B\u6682\u65F6\u4E0D\u80FD\u5207\u6362\u6807\u7B7E\u548C\u6765\u6E90\u3002","lang_source_menu":"\u66F4\u591A\u64CD\u4F5C","lang_source_browse":"\u6D4F\u89C8","lang_offline_count":"\u672C\u5730\u53EF\u7528\u7684\u6761\u76EE","lang_next":"\u4E0B\u4E00\u4E2A","lang_share_native_label":"\u5206\u4EAB","lang_refreshbutton":"\u66F4\u65B0\u6570\u636E\u6E90","lang_share_diaspora_label":"\u5206\u4EAB\u5230 Diaspora","lang_share_wordpress_label":"\u5206\u4EAB\u5230 WordPress","lang_search_label":"\u641C\u7D22\u8BCD","lang_share_mail_label":"\u901A\u8FC7\u90AE\u4EF6\u5206\u4EAB","lang_source_warn_cancel_dirty":"\u4E22\u5F03\u672A\u4FDD\u5B58\u7684\u66F4\u6539\uFF1F","lang_share_copy_label":"\u590D\u5236\u94FE\u63A5\u5230\u526A\u5207\u677F","lang_source_filter":"\u7B5B\u9009","lang_share_facebook_label":"\u5206\u4EAB\u5230 Facebook","lang_tag_change_color_button_title":"\u66F4\u6539\u989C\u8272","lang_experimental":"\u8BD5\u9A8C\u6027\u7684","lang_login_invalid_credentials":"\u9519\u8BEF\u7684\u7528\u6237\u540D\u6216\u5BC6\u7801","lang_error_check_log_file":"\u53D1\u751F\u4E86\u4E00\u4E2A\u9519\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u65E5\u5FD7\u6587\u4EF6 \u201C{0}\u201D\u3002","lang_login_offline":"\u79BB\u7EBF\u5B58\u50A8","lang_error_unknown_source":"\u672A\u77E5\u6765\u6E90 ID\uFF1A","lang_error_mark_item":"\u65E0\u6CD5\u6807\u8BB0\u6216\u53D6\u6D88\u6807\u8BB0\uFF1A","lang_error_star_item":"\u65E0\u6CD5\u661F\u6807\u6216\u53D6\u6D88\u661F\u6807\uFF1A","lang_error_loading":"\u52A0\u8F7D\u9519\u8BEF\uFF1A","lang_article_reading_time":"{0} \u5206\u949F\u9605\u8BFB\u65F6\u957F","lang_sources_loading":"\u6570\u636E\u6E90\u52A0\u8F7D\u4E2D\u2026","lang_no_sources":"\u6570\u636E\u6E90\u672A\u914D\u7F6E\u3002","lang_source_deleting":"\u6B63\u5728\u5220\u9664\u6570\u636E\u6E90\u2026","lang_source_autotitle_hint":"\u7559\u7A7A\u4EE5\u81EA\u52A8\u586B\u5145\u6807\u9898","lang_source_pwd_placeholder":"\u6CA1\u6709\u6539\u53D8","lang_source_params_loading":"\u6B63\u5728\u52A0\u8F7D\u53C2\u6570\u2026","lang_source_saving":"\u6B63\u5728\u4FDD\u5B58\u6570\u636E\u6E90\u66F4\u6539\u2026","lang_source_refresh":"\u5237\u65B0\u6B64\u6570\u636E\u6E90","lang_source_go_to_settings":"\u5728\u8BBE\u7F6E\u4E2D\u6253\u5F00","lang_sources_leaving_unsaved_prompt":"\u4FDD\u7559\u672A\u4FDD\u5B58\u7684\u6570\u636E\u6E90\u66F4\u6539\uFF1F","lang_entries_loading":"\u52A0\u8F7D\u6761\u76EE\u4E2D\u2026","lang_login_in_progress":"\u5C1D\u8BD5\u767B\u5F55\u4E2D\u2026","lang_error":"\u53D1\u751F\u4E86\u4E00\u4E2A\u9519\u8BEF","lang_error_check_system_logs":"\u53D1\u751F\u4E86\u4E00\u4E2A\u9519\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u4F60\u7684\u7CFB\u7EDF\u65E5\u5FD7\u3002","lang_error_unwritable_logs":"\u65E0\u6CD5\u5199\u5165\u65E5\u5FD7\u3002","lang_streamerror":"\u6CA1\u6709\u52A0\u8F7D\u5230\u6761\u76EE\uFF0C\u91CD\u65B0\u52A0\u8F7D\uFF1F","lang_sources_refreshed":"\u6570\u636E\u6E90\u5DF2\u5237\u65B0","lang_app_update":"selfoss \u5DF2\u88AB\u66F4\u65B0\uFF0C\u8BF7\u91CD\u65B0\u52A0\u8F7D","lang_error_add_source":"\u65E0\u6CD5\u6DFB\u52A0\u6E90\uFF1A","lang_error_edit_source":"\u65E0\u6CD5\u4FDD\u5B58\u6E90\u66F4\u6539\uFF1A","lang_error_delete_source":"\u65E0\u6CD5\u5220\u9664\u6E90\uFF1A","lang_error_load_tags":"\u65E0\u6CD5\u52A0\u8F7D\u6807\u7B7E\uFF1A","lang_error_unknown_tag":"\u672A\u77E5\u7684\u6807\u7B7E\uFF1A","lang_error_loading_stats":"\u65E0\u6CD5\u52A0\u8F7D\u7EDF\u8BA1\u4FE1\u606F\uFF1A","lang_error_saving_color":"\u65E0\u6CD5\u4FDD\u5B58\u65B0\u989C\u8272\uFF1A","lang_error_refreshing_source":"\u65E0\u6CD5\u5237\u65B0\u6570\u636E\u6E90\uFF1A","lang_error_offline_storage":"\u79BB\u7EBF\u5B58\u50A8\u51FA\u9519\uFF1A{0} \uFF0C\u8BF7\u5C1D\u8BD5\u91CD\u65B0\u52A0\u8F7D\u3002\u79BB\u7EBF\u6A21\u5F0F\u5DF2\u88AB\u4E34\u65F6\u7981\u7528\u3002","lang_error_offline_storage_not_available":"\u79BB\u7EBF\u5B58\u50A8\u4E0D\u53EF\u7528\u3002\u786E\u4FDD\u60A8\u7684\u7F51\u7EDC\u6D4F\u89C8\u5668 {0} \u652F\u6301 IndexedDB API{1}\uFF0C\u5982\u679C\u60A8\u4F7F\u7528\u7684\u662F\u57FA\u4E8E Google Chrome \u7684\u6D4F\u89C8\u5668\uFF0C\u8BF7\u786E\u4FDD\u60A8\u6CA1\u6709\u5728\u9690\u8EAB\u6A21\u5F0F\u4E0B\u8FD0\u884C selfoss\u3002","lang_error_invalid_subsection":"\u65E0\u6548\u7684\u5C0F\u8282\uFF1A","lang_error_configuration":"\u65E0\u6CD5\u52A0\u8F7D\u914D\u7F6E\u3002","lang_info_url_copied":"URL \u5DF2\u590D\u5236\u5230\u526A\u8D34\u677F\u3002","lang_error_share_native":"\u65E0\u6CD5\u5206\u4EAB\u6761\u76EE\u3002","lang_article_actions":"\u52A8\u4F5C","lang_reload_list":"\u91CD\u65B0\u52A0\u8F7D\u5217\u8868","lang_login_error_generic":"\u65E0\u6CD5\u767B\u5F55: {errorMessage}","lang_error_unauthorized":"\u8BF7 {link_begin}\u767B\u5F55{link_end} \u4EE5\u7EE7\u7EED\u3002"}');


var $d97043994cabe9e3$exports = {};
$d97043994cabe9e3$exports = JSON.parse('{"lang_markread":"\u6A19\u8A18\u70BA\u5DF2\u8B80","lang_newest":"\u6700\u65B0","lang_unread":"\u672A\u8B80","lang_starred":"\u5DF2\u52A0\u661F\u6A19","lang_tags":"\u6A19\u7C64","lang_alltags":"\u6240\u6709\u6A19\u7C64","lang_timestamp":"{0,date} {0,time}","lang_hours":"{0,plural,one {1 \u5C0F\u6642},other {# \u5C0F\u6642}}\u524D","lang_minutes":"{0,plural,one {1 \u5206\u9418},other {# \u5206\u9418}}\u524D","lang_seconds":"{0,plural,one {1 \u79D2},other {# \u79D2}}\u524D","lang_days":"{0,plural,zero {\u4ECA\u5929},one {\u6628\u5929},other {# \u5929\u524D}}","lang_star":"\u52A0\u661F\u6A19","lang_unstar":"\u53D6\u6D88\u661F\u6A19","lang_mark":"\u6A19\u8A18\u70BA\u5DF2\u8B80","lang_unmark":"\u6A19\u8A18\u70BA\u672A\u8B80","lang_load_img":"\u986F\u793A\u5716\u7247","lang_open_window":"\u958B\u555F","lang_searchbutton":"\u641C\u5C0B","lang_sources":"\u4F86\u6E90","lang_source_add":"\u65B0\u589E\u4F86\u6E90","lang_source_opml":"\u6216\u532F\u5165\u4E00\u500B OPML \u6A94\u6848","lang_source_export":"\u532F\u51FA\u4F86\u6E90","lang_source_edit":"\u7DE8\u8F2F","lang_source_delete":"\u522A\u9664","lang_source_warn":"\u771F\u7684\u522A\u9664\u9019\u500B\u4F86\u6E90\u55CE\uFF1F","lang_source_new":"\u65B0\u7684\u672A\u5132\u5B58\u4F86\u6E90","lang_source_title":"\u6A19\u984C","lang_source_tags":"\u6A19\u7C64","lang_source_comma":"\u4EE5\u9017\u865F\u5206\u9694","lang_source_select":"\u8ACB\u9078\u64C7\u4F86\u6E90","lang_source_type":"\u985E\u578B","lang_source_save":"\u5132\u5B58","lang_source_cancel":"\u53D6\u6D88","lang_source_saved":"\u5DF2\u5132\u5B58","lang_source_last_post":"\u66F4\u65B0\u65BC","lang_no_entries":"\u627E\u4E0D\u5230\u689D\u76EE","lang_more":"\u66F4\u591A","lang_login":"\u767B\u5165","lang_login_username":"\u4F7F\u7528\u8005\u540D\u7A31","lang_login_password":"\u5BC6\u78BC","lang_no_title":"\u7121\u6A19\u984C","lang_error_saving_color":"\u7121\u6CD5\u5132\u5B58\u65B0\u984F\u8272\uFF1A","lang_error_share_native_abort":"\u7121\u6CD5\u5206\u4EAB\u9805\u76EE\u2014\u6C92\u6709\u5206\u4EAB\u76EE\u6A19\uFF0C\u6216\u8005\u4F60\u5DF2\u53D6\u6D88\u5B83\u3002","lang_article_actions":"\u52D5\u4F5C","lang_error_check_log_file":"\u767C\u751F\u932F\u8AA4\uFF0C\u8ACB\u6AA2\u67E5\u65E5\u8A8C\u6A94\u6848\u300C{0}\u300D\u3002","lang_filter":"\u904E\u6FFE\u5668","lang_share_diaspora_label":"\u5728 Diaspora \u4E0A\u5206\u4EAB","lang_error_add_source":"\u7121\u6CD5\u65B0\u589E\u4F86\u6E90\uFF1A","lang_share_copy_label":"\u8907\u88FD\u9023\u7D50\u81F3\u526A\u8CBC\u7C3F","lang_sources_refreshed":"\u4F86\u6E90\u5DF2\u91CD\u65B0\u6574\u7406","lang_app_reload":"\u91CD\u65B0\u8F09\u5165","lang_error_unknown_source":"\u672A\u77E5\u7684\u4F86\u6E90 ID\uFF1A","lang_error_mark_item":"\u7121\u6CD5\u6A19\u8A18\uFF0F\u53D6\u6D88\u6A19\u8A18\u9805\u76EE\uFF1A","lang_error_refreshing_source":"\u7121\u6CD5\u91CD\u65B0\u6574\u7406\u4F86\u6E90\uFF1A","lang_error_sync":"\u7121\u6CD5\u5F9E\u4F3A\u670D\u5668\u540C\u6B65\u6700\u5F8C\u7684\u8B8A\u66F4\uFF1A","lang_error_offline_storage_not_available":"\u96E2\u7DDA\u5132\u5B58\u4E0D\u53EF\u7528\u3002\u78BA\u4FDD\u4F60\u7684\u7DB2\u9801\u700F\u89BD\u5668{0}\u652F\u63F4 IndexedDB API{1}\uFF0C\u4E26\u4E14\u5982\u679C\u4F60\u6B63\u5728\u4F7F\u7528\u7684\u662F\u57FA\u65BC Google Chrome \u7684\u700F\u89BD\u5668\uFF0C\u8ACB\u78BA\u4FDD\u4F60\u6C92\u6709\u5728\u7121\u75D5\u6A21\u5F0F\u4E0B\u57F7\u884C selfoss\u3002","lang_error_invalid_subsection":"\u7121\u6548\u7684\u5C0F\u7BC0\uFF1A","lang_error_configuration":"\u7121\u6CD5\u8F09\u5165\u914D\u7F6E\u3002","lang_error_share_native":"\u7121\u6CD5\u5206\u4EAB\u9805\u76EE\u3002","lang_info_url_copied":"\u7DB2\u5740\u5DF2\u8907\u88FD\u81F3\u526A\u8CBC\u7C3F\u3002","lang_close_entry":"\u95DC\u9589","lang_online_count":"\u4F3A\u670D\u5668\u4E0A\u53EF\u7528\u7684\u9805\u76EE","lang_searchremove":"\u96B1\u85CF\u641C\u5C0B","lang_offline_count":"\u672C\u5730\u53EF\u7528\u7684\u9805\u76EE","lang_offline_navigation_unavailable":"\u76EE\u524D\u5728\u96E2\u7DDA\u6A21\u5F0F\u4E0B\u7121\u6CD5\u5207\u63DB\u6A19\u7C64\u548C\u4F86\u6E90\u3002","lang_settingsbutton":"\u8A2D\u5B9A","lang_logoutbutton":"\u767B\u51FA","lang_source_filter":"\u904E\u6FFE\u5668","lang_share_twitter_label":"\u5728 Twitter \u4E0A\u5206\u4EAB","lang_share_facebook_label":"\u5728 Facebook \u4E0A\u5206\u4EAB","lang_next":"\u4E0B\u4E00\u500B","lang_share_mastodon_label":"\u5728 Mastodon \u4E0A\u5206\u4EAB","lang_share_pocket_label":"\u5132\u5B58\u81F3 Pocket","lang_refreshbutton":"\u91CD\u65B0\u6574\u7406\u4F86\u6E90","lang_share_wallabag_label":"\u5132\u5B58\u81F3 Wallabag","lang_share_wordpress_label":"\u5728 WordPress \u4E0A\u5206\u4EAB","lang_share_mail_label":"\u4F7F\u7528\u96FB\u5B50\u90F5\u4EF6\u5206\u4EAB","lang_loginbutton":"\u767B\u5165","lang_source_autotitle_hint":"\u7559\u7A7A\u4EE5\u81EA\u52D5\u7372\u53D6\u6A19\u984C","lang_source_saving":"\u6B63\u5728\u5132\u5B58\u4F86\u6E90\u8B8A\u66F4\u2026","lang_source_pwd_placeholder":"\u6C92\u6709\u8B8A\u66F4","lang_source_go_to_settings":"\u5728\u8A2D\u5B9A\u4E2D\u958B\u555F","lang_source_refresh":"\u91CD\u65B0\u6574\u7406\u9019\u500B\u4F86\u6E90","lang_error_edit_source":"\u7121\u6CD5\u5132\u5B58\u4F86\u6E90\u8B8A\u66F4\uFF1A","lang_search_label":"\u641C\u5C0B\u8A5E\u8A9E","lang_login_invalid_credentials":"\u932F\u8AA4\u7684\u4F7F\u7528\u8005\u540D\u7A31\uFF0F\u5BC6\u78BC","lang_login_offline":"\u96E2\u7DDA\u5132\u5B58","lang_error":"\u767C\u751F\u932F\u8AA4","lang_streamerror":"\u6C92\u6709\u8F09\u5165\u4EFB\u4F55\u9805\u76EE\uFF0C\u91CD\u65B0\u8F09\u5165\u55CE\uFF1F","lang_reload_list":"\u91CD\u65B0\u8F09\u5165\u5217\u8868","lang_app_update":"selfoss \u5DF2\u66F4\u65B0\uFF0C\u8ACB\u91CD\u65B0\u8F09\u5165","lang_error_session_expired":"\u5DE5\u4F5C\u968E\u6BB5\u5DF2\u904E\u671F","lang_error_delete_source":"\u7121\u6CD5\u522A\u9664\u4F86\u6E90\uFF1A","lang_error_load_tags":"\u7121\u6CD5\u8F09\u5165\u6A19\u7C64\uFF1A","lang_error_unknown_tag":"\u672A\u77E5\u7684\u6A19\u7C64\uFF1A","lang_error_mark_items":"\u7121\u6CD5\u6A19\u8A18\u6240\u6709\u53EF\u898B\u9805\u76EE\uFF1A","lang_error_star_item":"\u7121\u6CD5\u52A0\u661F\u6A19\uFF0F\u53D6\u6D88\u661F\u6A19\u9805\u76EE\uFF1A","lang_error_logout":"\u7121\u6CD5\u767B\u51FA\uFF1A","lang_error_loading":"\u8F09\u5165\u932F\u8AA4\uFF1A","lang_error_loading_stats":"\u7121\u6CD5\u8F09\u5165\u5C0E\u822A\u7D71\u8A08\u8CC7\u6599\uFF1A","lang_error_offline_storage":"\u96E2\u7DDA\u5132\u5B58\u932F\u8AA4\uFF1A{0}\u3002\u91CD\u65B0\u8F09\u5165\u53EF\u80FD\u6703\u6709\u6240\u5E6B\u52A9\u3002\u66AB\u6642\u505C\u7528\u96E2\u7DDA\u529F\u80FD\u3002","lang_share_native_label":"\u5206\u4EAB","lang_sources_loading":"\u6B63\u5728\u8F09\u5165\u4F86\u6E90\u2026","lang_no_sources":"\u6C92\u6709\u5DF2\u914D\u7F6E\u7684\u4F86\u6E90\u3002","lang_source_menu":"\u66F4\u591A\u52D5\u4F5C","lang_source_browse":"\u700F\u89BD","lang_source_deleting":"\u6B63\u5728\u522A\u9664\u4F86\u6E90\u2026","lang_source_warn_cancel_dirty":"\u653E\u68C4\u672A\u5132\u5B58\u7684\u8B8A\u66F4\uFF1F","lang_source_params_loading":"\u6B63\u5728\u8F09\u5165\u53C3\u6578\u2026","lang_tag_change_color_button_title":"\u8B8A\u66F4\u984F\u8272","lang_entries_loading":"\u6B63\u5728\u8F09\u5165\u689D\u76EE\u2026","lang_login_in_progress":"\u6B63\u5728\u5617\u8A66\u767B\u5165\u2026","lang_login_error_generic":"\u7121\u6CD5\u767B\u5165\uFF1A{errorMessage}","lang_experimental":"\u5BE6\u9A57\u6027","lang_error_unauthorized":"\u8ACB{link_begin}\u767B\u5165{link_end}\u4EE5\u7E7C\u7E8C\u3002","lang_error_check_system_logs":"\u767C\u751F\u932F\u8AA4\uFF0C\u8ACB\u6AA2\u67E5\u4F60\u7684\u7CFB\u7D71\u65E5\u8A8C\u3002","lang_error_unwritable_logs":"\u7121\u6CD5\u5BEB\u5165\u65E5\u8A8C\u3002","lang_article_reading_time":"{0} \u5206\u9418\u95B1\u8B80","lang_sources_leaving_unsaved_prompt":"\u672A\u5132\u5B58\u4F86\u6E90\u8B8A\u66F4\uFF0C\u96E2\u958B\u8A2D\u5B9A\uFF1F"}');


var $8d9b32747b35afdf$export$2e2bcd8739ae039 = {
    ca: (0, (/*@__PURE__*/$parcel$interopDefault($3109e67d2d012138$exports))),
    cs: (0, (/*@__PURE__*/$parcel$interopDefault($3f89fcb2517a5831$exports))),
    de: (0, (/*@__PURE__*/$parcel$interopDefault($efc21f73bdbf3d30$exports))),
    en: (0, (/*@__PURE__*/$parcel$interopDefault($e8fba7b0a3114fd9$exports))),
    'en-GB': (0, (/*@__PURE__*/$parcel$interopDefault($9bb1025262b0fb39$exports))),
    es: (0, (/*@__PURE__*/$parcel$interopDefault($8ae9bc6f67c8887e$exports))),
    et: (0, (/*@__PURE__*/$parcel$interopDefault($d225499964bebf2a$exports))),
    fi: (0, (/*@__PURE__*/$parcel$interopDefault($d319fa7db54d8a5e$exports))),
    fr: (0, (/*@__PURE__*/$parcel$interopDefault($d0be492086bdc65a$exports))),
    'fr-CA': (0, (/*@__PURE__*/$parcel$interopDefault($bb896106aaedaee8$exports))),
    gl: (0, (/*@__PURE__*/$parcel$interopDefault($acbbfcabee63ed13$exports))),
    he: (0, (/*@__PURE__*/$parcel$interopDefault($b6d92725827c8d30$exports))),
    hu: (0, (/*@__PURE__*/$parcel$interopDefault($a93f0f568ed4bbb3$exports))),
    id: (0, (/*@__PURE__*/$parcel$interopDefault($e1a0d6c367542bd9$exports))),
    it: (0, (/*@__PURE__*/$parcel$interopDefault($d48d8cf661c7528d$exports))),
    ja: (0, (/*@__PURE__*/$parcel$interopDefault($f0732a5d7f7054ed$exports))),
    lv: (0, (/*@__PURE__*/$parcel$interopDefault($5170287447d26972$exports))),
    nb: (0, (/*@__PURE__*/$parcel$interopDefault($7058dfe60927e7af$exports))),
    nl: (0, (/*@__PURE__*/$parcel$interopDefault($51d8b37b1373d182$exports))),
    pl: (0, (/*@__PURE__*/$parcel$interopDefault($3d25a85d30cd5367$exports))),
    pt: (0, (/*@__PURE__*/$parcel$interopDefault($b01b1dfd07b9091e$exports))),
    'pt-BR': (0, (/*@__PURE__*/$parcel$interopDefault($f7917dde3df00ba4$exports))),
    rm: (0, (/*@__PURE__*/$parcel$interopDefault($3e02282570dcf5ad$exports))),
    ru: (0, (/*@__PURE__*/$parcel$interopDefault($ee2b610e60c3d44b$exports))),
    sk: (0, (/*@__PURE__*/$parcel$interopDefault($430ac65b39f56697$exports))),
    sv: (0, (/*@__PURE__*/$parcel$interopDefault($7b91bdeeaf0bdb85$exports))),
    ta: (0, (/*@__PURE__*/$parcel$interopDefault($4bf6b321c83cc414$exports))),
    tr: (0, (/*@__PURE__*/$parcel$interopDefault($64a33f7e6e987d4f$exports))),
    uk: (0, (/*@__PURE__*/$parcel$interopDefault($563d7fbeeac49c6b$exports))),
    'zh-CN': (0, (/*@__PURE__*/$parcel$interopDefault($94f63a341744b7b8$exports))),
    'zh-TW': (0, (/*@__PURE__*/$parcel$interopDefault($d97043994cabe9e3$exports)))
};



function $e66869f90d0f9f3a$var$handleNavToggle(param) {
    var event = param.event, setNavExpanded = param.setNavExpanded;
    event.preventDefault();
    // show hide navigation for mobile version
    setNavExpanded(function(expanded) {
        return !expanded;
    });
    window.scrollTo({
        top: 0
    });
}
function $e66869f90d0f9f3a$var$dismissMessage(event) {
    selfoss.app.setGlobalMessage(null);
    event.stopPropagation();
}
/**
 * Global message bar for showing errors/information at the top of the page.
 * It watches globalMessage and updates/shows/hides itself as necessary
 * when the value changes.
 */ function $e66869f90d0f9f3a$var$Message(param) {
    var message = param.message;
    // Whenever message changes, dismiss it after 15 seconds.
    (0, $eHaBZ.useEffect)(function() {
        if (message !== null) {
            var dismissTimeout = window.setTimeout(function() {
                selfoss.app.setGlobalMessage(null);
            }, 15000);
            return function() {
                // Destory previous timeout.
                window.clearTimeout(dismissTimeout);
            };
        }
    }, [
        message
    ]);
    return message !== null ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
        id: "message",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
            error: message.isError
        }),
        onClick: $e66869f90d0f9f3a$var$dismissMessage,
        children: [
            message.message,
            message.actions.map(function(param, index) {
                var label = param.label, callback = param.callback;
                return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                    type: "button",
                    onClick: callback,
                    children: label
                }, index);
            })
        ]
    }) : null;
}
$e66869f90d0f9f3a$var$Message.propTypes = {
    message: (0, (/*@__PURE__*/$parcel$interopDefault($cff7e9a474db95c7$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object).isRequired
};
function $e66869f90d0f9f3a$var$NotFound() {
    var location = (0, $5XYIU.useLocation)();
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("p", {
        children: _('error_invalid_subsection') + location.pathname
    });
}
function $e66869f90d0f9f3a$var$CheckAuthorization(param) {
    var isAllowed = param.isAllowed, returnLocation = param.returnLocation, _ = param._, children = param.children;
    var navigate = (0, $5XYIU.useNavigate)();
    var redirect = (0, $b61d1ee6783329c7$export$7f54fc3180508a52)(function() {
        navigate('/sign/in', {
            state: {
                returnLocation: returnLocation
            }
        });
    });
    (0, $eHaBZ.useEffect)(function() {
        if (!isAllowed) redirect();
    }, [
        isAllowed
    ]);
    if (!isAllowed) {
        var __split = (0, $21h22._)(_('error_unauthorized').split(/\{(?:link_begin|link_end)\}/), 3), preLink = __split[0], inLink = __split[1], postLink = __split[2];
        return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("p", {
            children: [
                preLink,
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $5XYIU.Link), {
                    to: "/sign/in",
                    children: inLink
                }),
                postLink
            ]
        });
    } else return children;
}
$e66869f90d0f9f3a$var$CheckAuthorization.propTypes = {
    isAllowed: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    returnLocation: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).string,
    _: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).any
};
function $e66869f90d0f9f3a$var$PureApp(param) {
    var navSourcesExpanded = param.navSourcesExpanded, setNavSourcesExpanded = param.setNavSourcesExpanded, offlineState = param.offlineState, allItemsCount = param.allItemsCount, allItemsOfflineCount = param.allItemsOfflineCount, unreadItemsCount = param.unreadItemsCount, unreadItemsOfflineCount = param.unreadItemsOfflineCount, starredItemsCount = param.starredItemsCount, starredItemsOfflineCount = param.starredItemsOfflineCount, globalMessage = param.globalMessage, sourcesState = param.sourcesState, setSourcesState = param.setSourcesState, sources = param.sources, setSources = param.setSources, tags = param.tags, reloadAll = param.reloadAll;
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), navExpanded = _useState[0], setNavExpanded = _useState[1];
    var smartphone = (0, $c8aedc92b88eb948$export$443718c44347a6b3)();
    var offlineEnabled = (0, $c8aedc92b88eb948$export$96b5b894afc1d2e3)(selfoss.db.enableOffline);
    var _useState1 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), entriesPage = _useState1[0], setEntriesPage = _useState1[1];
    var configuration = (0, $eHaBZ.useContext)((0, $94046e75c3010f4f$export$326f6d1b69f1c06e));
    (0, $eHaBZ.useEffect)(function() {
        // init shortcut handler
        var destroyShortcuts = (0, $f81f2efad81fa28e$export$2e2bcd8739ae039)();
        return function() {
            destroyShortcuts();
        };
    }, []);
    // TODO: move stuff that depends on this to the App.
    var navigate = (0, $5XYIU.useNavigate)();
    (0, $eHaBZ.useEffect)(function() {
        selfoss.navigate = navigate;
    }, [
        navigate
    ]);
    // Prepare path of the homepage for redirecting from /
    var homePagePath = configuration.homepage.split('/');
    if (!homePagePath[1]) homePagePath.push('all');
    var menuButtonOnClick = (0, $eHaBZ.useCallback)(function(event) {
        return $e66869f90d0f9f3a$var$handleNavToggle({
            event: event,
            setNavExpanded: setNavExpanded
        });
    }, []);
    var entriesRef = (0, $eHaBZ.useCallback)(function(entriesPage) {
        setEntriesPage(entriesPage);
        selfoss.entriesPage = entriesPage;
    }, []);
    var _useState2 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), title = _useState2[0], setTitle = _useState2[1];
    var _useState3 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), globalUnreadCount = _useState3[0], setGlobalUnreadCount = _useState3[1];
    (0, $eHaBZ.useEffect)(function() {
        document.title = (title !== null && title !== void 0 ? title : configuration.htmlTitle) + ((globalUnreadCount !== null && globalUnreadCount !== void 0 ? globalUnreadCount : 0) > 0 ? " (".concat(globalUnreadCount, ")") : '');
    }, [
        configuration,
        title,
        globalUnreadCount
    ]);
    var _ = (0, $eHaBZ.useContext)((0, $7e577f35f270614e$export$51216bcc3983e55d));
    var isAllowedToRead = (0, $bd320d0e16baa5f3$export$f5bdb3b3cec7f803)();
    var isAllowedToWrite = (0, $bd320d0e16baa5f3$export$b416b77cd328c02f)();
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).StrictMode, {
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($e66869f90d0f9f3a$var$Message, {
                message: globalMessage
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $5XYIU.Routes), {
                children: [
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $5XYIU.Route), {
                        path: "/sign/in",
                        element: /* menu open for smartphone */ /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                            id: "loginform",
                            role: "main",
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $374b9547e2738d1e$export$2e2bcd8739ae039), {
                                offlineEnabled: offlineEnabled
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $5XYIU.Route), {
                        path: "/password",
                        element: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($e66869f90d0f9f3a$var$CheckAuthorization, {
                            isAllowed: isAllowedToWrite,
                            returnLocation: "/password",
                            _: _,
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                                id: "hashpasswordbody",
                                role: "main",
                                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $ecbfc97fac1903d9$export$2e2bcd8739ae039), {
                                    setTitle: setTitle
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $5XYIU.Route), {
                        path: "/opml",
                        element: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($e66869f90d0f9f3a$var$CheckAuthorization, {
                            isAllowed: isAllowedToWrite,
                            returnLocation: "/opml",
                            _: _,
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("main", {
                                id: "opmlbody",
                                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $f343fb504b01a581$export$2e2bcd8739ae039), {
                                    setTitle: setTitle
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $5XYIU.Route), {
                        path: "*",
                        element: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)($e66869f90d0f9f3a$var$CheckAuthorization, {
                            isAllowed: isAllowedToRead,
                            _: _,
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                                    id: "nav-mobile",
                                    role: "navigation",
                                    children: [
                                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                                            id: "nav-mobile-logo",
                                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                                                id: "nav-mobile-count",
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                                    'unread-count': true,
                                                    offline: offlineState,
                                                    online: !offlineState,
                                                    unread: unreadItemsCount > 0
                                                }),
                                                children: [
                                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                                            'offline-count': true,
                                                            offline: offlineState,
                                                            online: !offlineState,
                                                            diff: unreadItemsCount !== unreadItemsOfflineCount && unreadItemsOfflineCount
                                                        }),
                                                        children: unreadItemsOfflineCount > 0 ? unreadItemsOfflineCount : ''
                                                    }),
                                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                                        className: "count",
                                                        children: unreadItemsCount
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                                            id: "nav-mobile-settings",
                                            accessKey: "t",
                                            "aria-label": _('settingsbutton'),
                                            onClick: menuButtonOnClick,
                                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2ca1a35d7f3a323d$export$2b9260d4a45c8710), {
                                                icon: $18f640b80ac26745$exports.faCog,
                                                size: "2x"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $8929b96d30942b2d$export$78768a9af065a7b), {
                                    isOpen: !smartphone || navExpanded,
                                    className: "collapse-css-transition",
                                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                                        id: "nav",
                                        role: "navigation",
                                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $117ab31dd2c08da6$export$2e2bcd8739ae039), {
                                            entriesPage: entriesPage,
                                            setNavExpanded: setNavExpanded,
                                            navSourcesExpanded: navSourcesExpanded,
                                            setNavSourcesExpanded: setNavSourcesExpanded,
                                            offlineState: offlineState,
                                            allItemsCount: allItemsCount,
                                            allItemsOfflineCount: allItemsOfflineCount,
                                            unreadItemsCount: unreadItemsCount,
                                            unreadItemsOfflineCount: unreadItemsOfflineCount,
                                            starredItemsCount: starredItemsCount,
                                            starredItemsOfflineCount: starredItemsOfflineCount,
                                            sourcesState: sourcesState,
                                            setSourcesState: setSourcesState,
                                            sources: sources,
                                            setSources: setSources,
                                            tags: tags,
                                            reloadAll: reloadAll
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("ul", {
                                    id: "search-list",
                                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $3bebfa7a3ec2ab2e$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                                    id: "content",
                                    role: "main",
                                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $5XYIU.Routes), {
                                        children: [
                                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $5XYIU.Route), {
                                                path: "/",
                                                element: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $5XYIU.Navigate), {
                                                    to: "/".concat(homePagePath.join('/')),
                                                    replace: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $5XYIU.Route), {
                                                path: "/:filter/:category/:id?",
                                                element: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($e66869f90d0f9f3a$var$EntriesFilter, {
                                                    entriesRef: entriesRef,
                                                    setNavExpanded: setNavExpanded,
                                                    configuration: configuration,
                                                    navSourcesExpanded: navSourcesExpanded,
                                                    unreadItemsCount: unreadItemsCount,
                                                    setGlobalUnreadCount: setGlobalUnreadCount
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $5XYIU.Route), {
                                                path: "/manage/sources/add?",
                                                element: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $160db82a87133f5d$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $5XYIU.Route), {
                                                path: "*",
                                                element: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($e66869f90d0f9f3a$var$NotFound, {})
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
$e66869f90d0f9f3a$var$PureApp.propTypes = {
    navSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    setNavSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    offlineState: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    allItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    allItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    unreadItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    unreadItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    starredItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    starredItemsOfflineCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired,
    globalMessage: (0, (/*@__PURE__*/$parcel$interopDefault($cff7e9a474db95c7$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object).isRequired,
    sourcesState: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).oneOf(Object.values((0, $d2d3ee75176c5e4c$export$62aa48085237e36f))).isRequired,
    setSourcesState: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    sources: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object).isRequired,
    setSources: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    tags: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object).isRequired,
    reloadAll: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired
};
// Work around for regex patterns not being supported
// https://github.com/remix-run/react-router/issues/8254
function $e66869f90d0f9f3a$var$EntriesFilter(param) {
    var entriesRef = param.entriesRef, setNavExpanded = param.setNavExpanded, configuration = param.configuration, navSourcesExpanded = param.navSourcesExpanded, unreadItemsCount = param.unreadItemsCount, setGlobalUnreadCount = param.setGlobalUnreadCount;
    var params = (0, $0be080af3052783c$export$216385125ee84ae7)();
    if (params === null) return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($e66869f90d0f9f3a$var$NotFound, {});
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $9b2cb125cea35be7$export$2e2bcd8739ae039), {
        ref: entriesRef,
        setNavExpanded: setNavExpanded,
        configuration: configuration,
        navSourcesExpanded: navSourcesExpanded,
        unreadItemsCount: unreadItemsCount,
        setGlobalUnreadCount: setGlobalUnreadCount
    });
}
$e66869f90d0f9f3a$var$EntriesFilter.propTypes = {
    entriesRef: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    configuration: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired,
    setNavExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    navSourcesExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).bool.isRequired,
    setGlobalUnreadCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).func.isRequired,
    unreadItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).number.isRequired
};
var $e66869f90d0f9f3a$export$86fbec116b87613f = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $NBk0Y._)(App, _React_Component);
    function App(props) {
        (0, $gd0sY._)(this, App);
        var _this;
        _this = (0, $8xMIM._)(this, App, [
            props
        ]);
        _this.state = {
            /**
             * tag repository
             */ tags: [],
            tagsState: (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).INITIAL,
            /**
             * source repository
             */ sources: [],
            sourcesState: (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).INITIAL,
            /**
             * true when sources in the sidebar are expanded
             * and we should fetch info about them in API requests.
             */ navSourcesExpanded: false,
            /**
             * whether off-line mode is enabled
             */ offlineState: false,
            /**
             * number of unread items
             */ unreadItemsCount: 0,
            /**
             * number of unread items available offline
             */ unreadItemsOfflineCount: 0,
            /**
             * number of starred items
             */ starredItemsCount: 0,
            /**
             * number of starred items available offline
             */ starredItemsOfflineCount: 0,
            /**
             * number of all items
             */ allItemsCount: 0,
            /**
             * number of all items available offline
             */ allItemsOfflineCount: 0,
            /**
             * Global message popup.
             * @var ?Object.{message: string, actions: Array.<Object.{label: string, callback: function>}, isError: bool}
             */ globalMessage: null
        };
        _this._ = _this._.bind(_this);
        _this.setTags = _this.setTags.bind(_this);
        _this.setTagsState = _this.setTagsState.bind(_this);
        _this.setSources = _this.setSources.bind(_this);
        _this.setSourcesState = _this.setSourcesState.bind(_this);
        _this.setOfflineState = _this.setOfflineState.bind(_this);
        _this.setNavSourcesExpanded = _this.setNavSourcesExpanded.bind(_this);
        _this.setUnreadItemsCount = _this.setUnreadItemsCount.bind(_this);
        _this.setUnreadItemsOfflineCount = _this.setUnreadItemsOfflineCount.bind(_this);
        _this.setStarredItemsCount = _this.setStarredItemsCount.bind(_this);
        _this.setStarredItemsOfflineCount = _this.setStarredItemsOfflineCount.bind(_this);
        _this.setAllItemsCount = _this.setAllItemsCount.bind(_this);
        _this.setAllItemsOfflineCount = _this.setAllItemsOfflineCount.bind(_this);
        _this.setGlobalMessage = _this.setGlobalMessage.bind(_this);
        _this.reloadAll = _this.reloadAll.bind(_this);
        return _this;
    }
    (0, $7cSld._)(App, [
        {
            key: "setTags",
            value: function setTags(tags) {
                if (typeof tags === 'function') this.setState(function(state) {
                    return {
                        tags: tags(state.tags)
                    };
                });
                else this.setState({
                    tags: tags
                });
            }
        },
        {
            key: "setTagsState",
            value: function setTagsState(tagsState) {
                if (typeof tagsState === 'function') this.setState(function(state) {
                    return {
                        tagsState: tagsState(state.tagsState)
                    };
                });
                else this.setState({
                    tagsState: tagsState
                });
            }
        },
        {
            key: "setSources",
            value: function setSources(sources) {
                if (typeof sources === 'function') this.setState(function(state) {
                    return {
                        sources: sources(state.sources)
                    };
                });
                else this.setState({
                    sources: sources
                });
            }
        },
        {
            key: "setSourcesState",
            value: function setSourcesState(sourcesState) {
                if (typeof sourcesState === 'function') this.setState(function(state) {
                    return {
                        sourcesState: sourcesState(state.sourcesState)
                    };
                });
                else this.setState({
                    sourcesState: sourcesState
                });
            }
        },
        {
            key: "setOfflineState",
            value: function setOfflineState(offlineState) {
                if (typeof offlineState === 'function') this.setState(function(state) {
                    return {
                        offlineState: offlineState(state.offlineState)
                    };
                });
                else this.setState({
                    offlineState: offlineState
                });
            }
        },
        {
            key: "setNavSourcesExpanded",
            value: function setNavSourcesExpanded(navSourcesExpanded) {
                if (typeof navSourcesExpanded === 'function') this.setState(function(state) {
                    return {
                        navSourcesExpanded: navSourcesExpanded(state.navSourcesExpanded)
                    };
                });
                else this.setState({
                    navSourcesExpanded: navSourcesExpanded
                });
            }
        },
        {
            key: "setUnreadItemsCount",
            value: function setUnreadItemsCount(unreadItemsCount) {
                if (typeof unreadItemsCount === 'function') this.setState(function(state) {
                    return {
                        unreadItemsCount: unreadItemsCount(state.unreadItemsCount)
                    };
                });
                else this.setState({
                    unreadItemsCount: unreadItemsCount
                });
            }
        },
        {
            key: "setUnreadItemsOfflineCount",
            value: function setUnreadItemsOfflineCount(unreadItemsOfflineCount) {
                if (typeof unreadItemsOfflineCount === 'function') this.setState(function(state) {
                    return {
                        unreadItemsOfflineCount: unreadItemsOfflineCount(state.unreadItemsOfflineCount)
                    };
                });
                else this.setState({
                    unreadItemsOfflineCount: unreadItemsOfflineCount
                });
            }
        },
        {
            key: "setStarredItemsCount",
            value: function setStarredItemsCount(starredItemsCount) {
                if (typeof starredItemsCount === 'function') this.setState(function(state) {
                    return {
                        starredItemsCount: starredItemsCount(state.starredItemsCount)
                    };
                });
                else this.setState({
                    starredItemsCount: starredItemsCount
                });
            }
        },
        {
            key: "setStarredItemsOfflineCount",
            value: function setStarredItemsOfflineCount(starredItemsOfflineCount) {
                if (typeof starredItemsOfflineCount === 'function') this.setState(function(state) {
                    return {
                        starredItemsOfflineCount: starredItemsOfflineCount(state.starredItemsOfflineCount)
                    };
                });
                else this.setState({
                    starredItemsOfflineCount: starredItemsOfflineCount
                });
            }
        },
        {
            key: "setAllItemsCount",
            value: function setAllItemsCount(allItemsCount) {
                if (typeof allItemsCount === 'function') this.setState(function(state) {
                    return {
                        allItemsCount: allItemsCount(state.allItemsCount)
                    };
                });
                else this.setState({
                    allItemsCount: allItemsCount
                });
            }
        },
        {
            key: "setAllItemsOfflineCount",
            value: function setAllItemsOfflineCount(allItemsOfflineCount) {
                if (typeof allItemsOfflineCount === 'function') this.setState(function(state) {
                    return {
                        allItemsOfflineCount: allItemsOfflineCount(state.allItemsOfflineCount)
                    };
                });
                else this.setState({
                    allItemsOfflineCount: allItemsOfflineCount
                });
            }
        },
        {
            key: "setGlobalMessage",
            value: function setGlobalMessage(globalMessage) {
                if (typeof globalMessage === 'function') this.setState(function(state) {
                    return {
                        globalMessage: globalMessage(state.globalMessage)
                    };
                });
                else this.setState({
                    globalMessage: globalMessage
                });
            }
        },
        {
            /**
     * Triggers fetching news from all sources.
     * @return Promise<undefined>
     */ key: "reloadAll",
            value: function reloadAll() {
                var _this = this;
                if (!selfoss.isOnline()) return Promise.resolve();
                return $b0e03640e062f6f9$export$c5eb18431f66026b().then(function() {
                    // probe stats and prompt reload to the user
                    selfoss.dbOnline.sync().then(function() {
                        if (_this.state.unreadItemsCount > 0) _this.showMessage(_this._('sources_refreshed'), [
                            {
                                label: _this._('reload_list'),
                                callback: function() {
                                    document.querySelector('#nav-filter-unread').click();
                                }
                            }
                        ]);
                    });
                }).catch(function(error) {
                    _this.showError(_this._('error_refreshing_source') + ' ' + error.message);
                });
            }
        },
        {
            /**
     * Obtain a localized message for given key, substituting placeholders for values, when given.
     * @param string key
     * @param ?array parameters
     * @return string
     */ key: "_",
            value: function _(identifier, params) {
                var fallbackLanguage = 'en';
                var langKey = "lang_".concat(identifier);
                var preferredLanguage = this.props.configuration.language;
                // locale auto-detection
                if (preferredLanguage === null) {
                    if ('languages' in navigator) preferredLanguage = navigator.languages.find(function(lang) {
                        return Object.keys((0, $8d9b32747b35afdf$export$2e2bcd8739ae039)).includes(lang);
                    });
                }
                if (!Object.keys((0, $8d9b32747b35afdf$export$2e2bcd8739ae039)).includes(preferredLanguage)) preferredLanguage = fallbackLanguage;
                var translated = (0, $8d9b32747b35afdf$export$2e2bcd8739ae039)[preferredLanguage][langKey] || (0, $8d9b32747b35afdf$export$2e2bcd8739ae039)[fallbackLanguage][langKey] || "#untranslated:".concat(identifier);
                if (params) translated = (0, $7e577f35f270614e$export$e51161e9fbfde80e)(translated, params);
                return translated;
            }
        },
        {
            /**
     * Show error message in the message bar in the UI.
     *
     * @param {string} message
     * @return void
     */ key: "showError",
            value: function showError(message) {
                this.showMessage(message, [], true);
            }
        },
        {
            /**
     * Show message in the message bar in the UI.
     *
     * @param {string} message
     * @param {Array.<Object.{label: string, callback: function>} actions
     * @param {bool} isError
     * @return void
     */ key: "showMessage",
            value: function showMessage(message) {
                var actions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], isError = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                this.setGlobalMessage({
                    message: message,
                    actions: actions,
                    isError: isError
                });
            }
        },
        {
            key: "notifyNewVersion",
            value: function notifyNewVersion(cb) {
                if (!cb) cb = function() {
                    window.location.reload();
                };
                this.showMessage(this._('app_update'), [
                    {
                        label: this._('app_reload'),
                        callback: cb
                    }
                ]);
            }
        },
        {
            key: "refreshTagSourceUnread",
            value: function refreshTagSourceUnread(tagCounts, sourceCounts) {
                var diff = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                this.setTags(function(tags) {
                    return tags.map(function(tag) {
                        if (!(tag.tag in tagCounts)) return tag;
                        var unread;
                        if (diff) unread = tag.unread + tagCounts[tag.tag];
                        else unread = tagCounts[tag.tag];
                        return (0, $9Jpjh._)((0, $lvTkn._)({}, tag), {
                            unread: unread
                        });
                    });
                });
                this.setSources(function(sources) {
                    return sources.map(function(source) {
                        if (!(source.id in sourceCounts)) return source;
                        var unread;
                        if (diff) unread = source.unread + sourceCounts[source.id];
                        else unread = sourceCounts[source.id];
                        return (0, $9Jpjh._)((0, $lvTkn._)({}, source), {
                            unread: unread
                        });
                    });
                });
            }
        },
        {
            key: "refreshOfflineCounts",
            value: function refreshOfflineCounts(offlineCounts) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(offlineCounts)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $21h22._)(_step.value, 2), kind = _step_value[0], newCount = _step_value[1];
                        if (newCount === 'keep') continue;
                        if (kind === 'unread') this.setUnreadItemsOfflineCount(newCount);
                        else if (kind === 'starred') this.setStarredItemsOfflineCount(newCount);
                        else if (kind === 'newest') this.setAllItemsOfflineCount(newCount);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $94046e75c3010f4f$export$326f6d1b69f1c06e).Provider, {
                    value: this.props.configuration,
                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $7e577f35f270614e$export$51216bcc3983e55d).Provider, {
                        value: this._,
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($e66869f90d0f9f3a$var$PureApp, {
                            navSourcesExpanded: this.state.navSourcesExpanded,
                            setNavSourcesExpanded: this.setNavSourcesExpanded,
                            offlineState: this.state.offlineState,
                            allItemsCount: this.state.allItemsCount,
                            allItemsOfflineCount: this.state.allItemsOfflineCount,
                            unreadItemsCount: this.state.unreadItemsCount,
                            unreadItemsOfflineCount: this.state.unreadItemsOfflineCount,
                            starredItemsCount: this.state.starredItemsCount,
                            starredItemsOfflineCount: this.state.starredItemsOfflineCount,
                            globalMessage: this.state.globalMessage,
                            sourcesState: this.state.sourcesState,
                            setSourcesState: this.setSourcesState,
                            sources: this.state.sources,
                            setSources: this.setSources,
                            tags: this.state.tags,
                            reloadAll: this.reloadAll
                        })
                    })
                });
            }
        }
    ]);
    return App;
}((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Component);
$e66869f90d0f9f3a$export$86fbec116b87613f.propTypes = {
    configuration: (0, (/*@__PURE__*/$parcel$interopDefault($35e9123a2e6f4e90$exports))).object.isRequired
};
function $e66869f90d0f9f3a$export$4e373c34abfa8c68(param) {
    var basePath = param.basePath, appRef = param.appRef, configuration = param.configuration;
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $5XYIU.BrowserRouter), {
        basename: basePath,
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($e66869f90d0f9f3a$export$86fbec116b87613f, {
            ref: appRef,
            configuration: configuration
        })
    });
}


var $05095a02f7e131ba$exports = {};
$05095a02f7e131ba$exports = $parcel$resolve("ktkk8");


/**
 * base javascript application
 *
 * @package    public_js
 * @copyright  Copyright (c) Tobias Zeising (http://www.aditu.de)
 * @license    GPLv3 (https://www.gnu.org/licenses/gpl-3.0.html)
 */ var $b40329ab00dcedb3$var$selfoss = {
    /**
     * The main App component.
     * @var App
     */ app: null,
    /**
     * React component for entries page.
     */ entriesPage: null,
    serviceWorkerInitialized: false,
    /**
     * Whether lightbox is open.
     */ lightboxActive: new (0, $e721f0b5888adce1$export$8fa6ce44b7b131e9)(false),
    init: /**
     * initialize application
     */ function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var storedConfig, oldConfiguration, configurationToUse, configuration;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Load off-line mode enabledness.
                        $b40329ab00dcedb3$var$selfoss.db.enableOffline.update(window.localStorage.getItem('enableOffline') === 'true');
                        // Ignore stored config when off-line mode is disabled, since it is likely stale.
                        storedConfig = $b40329ab00dcedb3$var$selfoss.db.enableOffline.value ? localStorage.getItem('configuration') : null;
                        oldConfiguration = null;
                        try {
                            oldConfiguration = storedConfig !== null ? JSON.parse(storedConfig) : null;
                        } catch (e) {
                        // We will try to obtain a new configuration anyway.
                        }
                        // Fall back to the last cached config on failure.
                        configurationToUse = oldConfiguration;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            7,
                            11
                        ]);
                        return [
                            4,
                            (0, $5be8e377f991f791$export$1d2e6bc0307ffd89)()
                        ];
                    case 2:
                        configuration = _state.sent().configuration;
                        configurationToUse = configuration;
                        if (!('caches' in window && 'serviceWorker' in navigator)) return [
                            3,
                            6
                        ];
                        if (!(oldConfiguration === null || oldConfiguration.userCss !== configuration.userCss)) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            caches.delete('userCss')
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        if (!(oldConfiguration === null || oldConfiguration.userJs !== configuration.userJs)) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            caches.delete('userJs')
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            3,
                            11
                        ];
                    case 7:
                        if (!configurationToUse) return [
                            3,
                            9
                        ];
                        return [
                            4,
                            $b40329ab00dcedb3$var$selfoss.initMain(configurationToUse)
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            10
                        ];
                    case 9:
                        // TODO: Add a more proper error page
                        document.body.innerHTML = $b40329ab00dcedb3$var$selfoss.app._('error_configuration');
                        _state.label = 10;
                    case 10:
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        })();
    },
    initMain: function(configuration) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var feedLink, link, script;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                $b40329ab00dcedb3$var$selfoss.config = configuration;
                if ($b40329ab00dcedb3$var$selfoss.db.enableOffline.value) $b40329ab00dcedb3$var$selfoss.setupServiceWorker();
                if (configuration.language !== null) document.documentElement.setAttribute('lang', configuration.language);
                document.querySelector('meta[name="application-name"]').setAttribute('content', configuration.htmlTitle);
                feedLink = document.createElement('link');
                feedLink.setAttribute('rel', 'alternate');
                feedLink.setAttribute('type', 'application/rss+xml');
                feedLink.setAttribute('title', 'RSS Feed');
                feedLink.setAttribute('href', 'feed');
                document.head.appendChild(feedLink);
                if (configuration.userCss !== null) {
                    link = document.createElement('link');
                    link.setAttribute('rel', 'stylesheet');
                    link.setAttribute('href', "user.css?v=".concat(configuration.userCss));
                    document.head.appendChild(link);
                }
                if (configuration.userJs !== null) {
                    script = document.createElement('script');
                    script.setAttribute('src', "user.js?v=".concat(configuration.userJs));
                    document.body.appendChild(script);
                }
                // init offline if supported
                $b40329ab00dcedb3$var$selfoss.dbOffline.init();
                if (configuration.authEnabled) $b40329ab00dcedb3$var$selfoss.loggedin.update(window.localStorage.getItem('onlineSession') == 'true');
                $b40329ab00dcedb3$var$selfoss.attachApp(configuration);
                return [
                    2
                ];
            });
        })();
    },
    /**
     * Create basic DOM structure of the page.
     */ attachApp: function(configuration) {
        var _document_getElementById;
        (_document_getElementById = document.getElementById('js-loading-message')) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.remove();
        var mainUi = document.createElement('div');
        document.body.appendChild(mainUi);
        mainUi.classList.add('app-toplevel');
        // BrowserRouter expects no slash at the end.
        var basePath = new URL(document.baseURI).pathname.replace(/\/$/, '');
        var root = (0, $59e7dcc9c52865c1$export$882461b6382ed46c)(mainUi);
        root.render((0, $e66869f90d0f9f3a$export$4e373c34abfa8c68)({
            basePath: basePath,
            appRef: function(app) {
                $b40329ab00dcedb3$var$selfoss.app = app;
            },
            configuration: configuration
        }));
    },
    loggedin: new (0, $e721f0b5888adce1$export$8fa6ce44b7b131e9)(false),
    setSession: function() {
        window.localStorage.setItem('onlineSession', true);
        $b40329ab00dcedb3$var$selfoss.loggedin.update(true);
    },
    clearSession: function() {
        window.localStorage.removeItem('onlineSession');
        $b40329ab00dcedb3$var$selfoss.loggedin.update(false);
    },
    hasSession: function() {
        return $b40329ab00dcedb3$var$selfoss.loggedin.value;
    },
    /**
     * Try to log in using given credentials
     * @return Promise<undefined>
     */ login: function(param) {
        var configuration = param.configuration, username = param.username, password = param.password, enableOffline = param.enableOffline;
        $b40329ab00dcedb3$var$selfoss.db.enableOffline.update(enableOffline);
        window.localStorage.setItem('enableOffline', $b40329ab00dcedb3$var$selfoss.db.enableOffline.value);
        if (!$b40329ab00dcedb3$var$selfoss.db.enableOffline.value) $b40329ab00dcedb3$var$selfoss.db.clear();
        var credentials = {
            username: username,
            password: password
        };
        return (0, $5be8e377f991f791$export$596d806903d1f59e)(credentials).then(function() {
            $b40329ab00dcedb3$var$selfoss.setSession();
            // init offline if supported and not inited yet
            $b40329ab00dcedb3$var$selfoss.dbOffline.init();
            if ((!$b40329ab00dcedb3$var$selfoss.db.storage || $b40329ab00dcedb3$var$selfoss.db.broken) && $b40329ab00dcedb3$var$selfoss.db.enableOffline.value) {
                // Initialize database in offline mode when it has not been initialized yet or it got broken.
                $b40329ab00dcedb3$var$selfoss.dbOffline.init();
                // Store config for off-line use.
                localStorage.setItem('configuration', JSON.stringify(configuration));
                // Cache user files manually since service worker is not aware of them.
                if ('caches' in window && 'serviceWorker' in navigator) {
                    caches.open('userCss').then(function(cache) {
                        return cache.add("user.css?v=".concat(configuration.userCss));
                    });
                    caches.open('userJs').then(function(cache) {
                        return cache.add("user.js?v=".concat(configuration.userJs));
                    });
                }
                $b40329ab00dcedb3$var$selfoss.setupServiceWorker();
            }
        });
    },
    setupServiceWorker: function() {
        if (!('serviceWorker' in navigator) || $b40329ab00dcedb3$var$selfoss.serviceWorkerInitialized) return;
        $b40329ab00dcedb3$var$selfoss.serviceWorkerInitialized = true;
        navigator.serviceWorker.addEventListener('controllerchange', function() {
            window.location.reload();
        });
        navigator.serviceWorker.register($05095a02f7e131ba$exports).then(function(reg) {
            $b40329ab00dcedb3$var$selfoss.listenWaitingSW(reg, function(reg) {
                $b40329ab00dcedb3$var$selfoss.app.notifyNewVersion(function() {
                    if (reg.waiting) reg.waiting.postMessage('skipWaiting');
                });
            });
        });
    },
    logout: function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1Mz1E._)(function() {
            var error;
            return (0, $6PS3Z.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $b40329ab00dcedb3$var$selfoss.clearSession();
                        $b40329ab00dcedb3$var$selfoss.db.clear(); // will not work after a failure, since storage is nulled
                        window.localStorage.clear();
                        if ('serviceWorker' in navigator) {
                            if ('caches' in window) caches.keys().then(function(keys) {
                                return keys.forEach(function(key) {
                                    return caches.delete(key);
                                });
                            });
                            navigator.serviceWorker.getRegistrations().then(function(registrations) {
                                registrations.forEach(function(reg) {
                                    reg.unregister();
                                });
                            });
                            $b40329ab00dcedb3$var$selfoss.serviceWorkerInitialized = false;
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, $5be8e377f991f791$export$a0973bcfe11b05c9)()
                        ];
                    case 2:
                        _state.sent();
                        if (!$b40329ab00dcedb3$var$selfoss.config.publicMode) $b40329ab00dcedb3$var$selfoss.navigate('/sign/in');
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        $b40329ab00dcedb3$var$selfoss.app.showError($b40329ab00dcedb3$var$selfoss.app._('error_logout') + ' ' + error.message);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    },
    /**
     * Checks whether the current user is allowed to perform read operations.
     *
     * @returns {boolean}
     */ isAllowedToRead: function() {
        return $b40329ab00dcedb3$var$selfoss.hasSession() || !$b40329ab00dcedb3$var$selfoss.config.authEnabled || $b40329ab00dcedb3$var$selfoss.config.publicMode;
    },
    /**
     * Checks whether the current user is allowed to perform update-tier operations.
     *
     * @returns {boolean}
     */ isAllowedToUpdate: function() {
        return $b40329ab00dcedb3$var$selfoss.hasSession() || !$b40329ab00dcedb3$var$selfoss.config.authEnabled || $b40329ab00dcedb3$var$selfoss.config.allowPublicUpdate;
    },
    /**
     * Checks whether the current user is allowed to perform write operations.
     *
     * @returns {boolean}
     */ isAllowedToWrite: function() {
        return $b40329ab00dcedb3$var$selfoss.hasSession() || !$b40329ab00dcedb3$var$selfoss.config.authEnabled;
    },
    /**
     * Checks whether the current user is allowed to perform write operations.
     *
     * @returns {boolean}
     */ isOnline: function() {
        return $b40329ab00dcedb3$var$selfoss.db.online;
    },
    /**
     * indicates whether a mobile device is host
     *
     * @return true if device resolution smaller equals 1024
     */ isMobile: function() {
        // first check useragent
        if (/iPhone|iPod|iPad|Android|BlackBerry/.test(navigator.userAgent)) return true;
        // otherwise check resolution
        return $b40329ab00dcedb3$var$selfoss.isTablet() || $b40329ab00dcedb3$var$selfoss.isSmartphone();
    },
    /**
     * indicates whether a tablet is the device or not
     *
     * @return true if device resolution smaller equals 1024
     */ isTablet: function() {
        if (document.body.clientWidth <= 1024) return true;
        return false;
    },
    /**
     * indicates whether a tablet is the device or not
     *
     * @return true if device resolution smaller equals 1024
     */ isSmartphone: function() {
        if (document.body.clientWidth <= 640) return true;
        return false;
    },
    /**
     * Override these functions to customize selfoss behaviour.
     */ extensionPoints: {
        /**
         * Called when an article is first expanded.
         * @param {HTMLElement} HTML element containing the article contents
         */ processItemContents: function() {}
    },
    /**
     * refresh stats.
     *
     * @return void
     * @param {Number} new all stats
     * @param {Number} new unread stats
     * @param {Number} new starred stats
     */ refreshStats: function(all, unread, starred) {
        $b40329ab00dcedb3$var$selfoss.app.setAllItemsCount(all);
        $b40329ab00dcedb3$var$selfoss.app.setStarredItemsCount(starred);
        $b40329ab00dcedb3$var$selfoss.refreshUnread(unread);
    },
    /**
     * refresh unread stats.
     *
     * @return void
     * @param {Number} new unread stats
     */ refreshUnread: function(unread) {
        $b40329ab00dcedb3$var$selfoss.app.setUnreadItemsCount(unread);
    },
    /**
     * refresh current tags.
     *
     * @return void
     */ reloadTags: function() {
        $b40329ab00dcedb3$var$selfoss.app.setTagsState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).LOADING);
        (0, $bcc58ea15e13e580$export$c36f611d5eb39a7)().then(function(data) {
            $b40329ab00dcedb3$var$selfoss.app.setTags(data);
            $b40329ab00dcedb3$var$selfoss.app.setTagsState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
        }).catch(function(error) {
            $b40329ab00dcedb3$var$selfoss.app.setTagsState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).FAILURE);
            $b40329ab00dcedb3$var$selfoss.app.showError($b40329ab00dcedb3$var$selfoss.app._('error_load_tags') + ' ' + error.message);
        });
    },
    handleAjaxError: function(error) {
        var tryOffline = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var _error_response;
        if (!(error instanceof (0, $0d06257c362dc1a1$export$65bd6083489bd8bb) || error instanceof (0, $0d06257c362dc1a1$export$66d311bf29d5c89c))) return Promise.reject(error);
        var httpCode = (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) || 0;
        if (tryOffline && httpCode != 403) return $b40329ab00dcedb3$var$selfoss.db.setOffline();
        else return Promise.reject(error);
    },
    listenWaitingSW: function(reg, callback) {
        var awaitStateChange = function() {
            reg.installing.addEventListener('statechange', function(event) {
                if (event.target.state === 'installed') callback(reg);
            });
        };
        if (!reg) return;
        else if (reg.waiting) return callback(reg);
        else if (reg.installing) {
            awaitStateChange();
            reg.addEventListener('updatefound', awaitStateChange);
        }
    },
    // Include helpers for user scripts.
    ajax: $32ae13b741542474$exports
};
var $b40329ab00dcedb3$export$2e2bcd8739ae039 = $b40329ab00dcedb3$var$selfoss;



var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");




(0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline = {
    syncing: {
        promise: null,
        request: null,
        resolve: null,
        reject: null
    },
    statsDirty: false,
    firstSync: true,
    _syncBegin: function() {
        if (!(0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.promise) {
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.promise = new Promise(function(resolve, reject) {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.resolve = resolve;
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.reject = reject;
                var monitor = window.setInterval(function() {
                    var stopChecking = false;
                    if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.promise) {
                        if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.userWaiting) {
                            // reject if user has been waiting for more than 10s,
                            // this means that connectivity is bad: user will get
                            // local content and server request will continue in
                            // the background.
                            reject();
                            stopChecking = true;
                        }
                    } else stopChecking = true;
                    if (stopChecking) window.clearInterval(monitor);
                }, 10000);
            });
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.promise.finally(function() {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.promise = null;
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.userWaiting = false;
            });
        }
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.promise;
    },
    _syncDone: function() {
        var success = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.promise) {
            if (success) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.resolve();
            else {
                var request = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.request;
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.reject();
                if (request) request.controller.abort();
            }
        }
    },
    /**
     * sync server status.
     *
     * @return Promise
     */ sync: function(updatedStatuses, chained) {
        if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.promise && !chained) {
            if (updatedStatuses) // Ensure the status queue is not cleared and gets sync'ed at
            // next sync.
            return Promise.reject();
            else return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.promise;
        }
        var syncing = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline._syncBegin();
        var getStatuses = true;
        if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.lastUpdate === null || (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.firstSync) {
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.lastUpdate = new Date(0);
            getStatuses = undefined;
        }
        var syncParams = {
            since: (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.lastUpdate,
            tags: true,
            sources: (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.state.navSourcesExpanded || undefined,
            itemsStatuses: getStatuses
        };
        if (updatedStatuses && updatedStatuses.length > 0) syncParams.updatedStatuses = updatedStatuses;
        if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.enableOffline.value) {
            syncParams.itemsSinceId = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.lastItemId;
            syncParams.itemsNotBefore = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newestGCedEntry;
            syncParams.itemsHowMany = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).config.itemsPerPage;
        }
        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.statsDirty = false;
        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.request = $8ef3cedac61156e9$export$92d6409d68f0739a(updatedStatuses, syncParams);
        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.request.promise.then(function(data) {
            var _selfoss_entriesPage;
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.setOnline();
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.lastSync = Date.now();
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.firstSync = false;
            var dataDate = data.lastUpdate;
            var storing = false;
            if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.enableOffline.value) {
                if ('newItems' in data) {
                    var maxId = 0;
                    data.newItems.forEach(function(item) {
                        maxId = Math.max(item.id, maxId);
                    });
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newerEntriesMissing = 'lastId' in data && data.lastId > (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.lastItemId && data.lastId > maxId;
                    storing = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newerEntriesMissing;
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.shouldLoadEntriesOnline = 'lastId' in data && data.lastId - (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.lastItemId > 2 * (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).config.itemsPerPage;
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.storeEntries(data.newItems).then(function() {
                        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.storeLastUpdate(dataDate);
                        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline._syncDone();
                    });
                }
                if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newerEntriesMissing || (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.needsSync) // There are still new items to fetch
                // or statuses to send
                syncing.then(function() {
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.sendNewStatuses();
                });
                if ('itemUpdates' in data) // refresh entry statuses in db and dequeue queued
                // statuses but do not calculate stats as they are taken
                // directly from the server as provided.
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.storeEntryStatuses(data.itemUpdates, true, false).then(function() {
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.storeLastUpdate(dataDate);
                });
                if ('stats' in data) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.storeStats(data.stats);
            }
            if (!(0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.statsDirty && 'stats' in data) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).refreshStats(data.stats.total, data.stats.unread, data.stats.starred);
            if ('tags' in data) {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.setTags(data.tags);
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.setTagsState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
            }
            if ('sources' in data) {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.setSources(data.sources);
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.setSourcesState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
            }
            if ('stats' in data && data.stats.unread > 0 && (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).entriesPage && ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).entriesPage.state.entries.length === 0 || (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).entriesPage.state.entries.loadingState === (0, $d2d3ee75176c5e4c$export$62aa48085237e36f).FAILURE)) (_selfoss_entriesPage = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.reload();
            else {
                if ('itemUpdates' in data) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).entriesPage.refreshEntryStatuses(data.itemUpdates);
                if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).entriesPage && (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).entriesPage.getActiveFilter() === (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).UNREAD) {
                    var unreadCount = 'stats' in data ? data.stats.unread : (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.state.unreadItemsCount;
                    if (unreadCount > (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).entriesPage.state.entries.filter(function(param) {
                        var unread = param.unread;
                        return unread == 1;
                    }).length) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).entriesPage.setHasMore(true);
                }
            }
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.lastUpdate = dataDate;
            if (!storing) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline._syncDone();
        }).catch(function(error) {
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline._syncDone(false);
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).handleAjaxError(error).catch(function(error) {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.showError((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app._('error_sync') + ' ' + error.message);
            });
        }).finally(function() {
            if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.promise) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.syncing.request = null;
        });
        return syncing;
    },
    /**
     * refresh current items.
     *
     * @return void
     */ getEntries: function(fetchParams, abortController) {
        return $8ef3cedac61156e9$export$d2f92acf417bbf5d((0, $9Jpjh._)((0, $lvTkn._)({}, fetchParams), {
            itemsPerPage: (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).config.itemsPerPage
        }), abortController).then(function(data) {
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.setOnline();
            if (!(0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.enableOffline.value) {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.lastSync = Date.now();
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.lastUpdate = data.lastUpdate;
            }
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).refreshStats(data.all, data.unread, data.starred);
            // update tags
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.setTags(data.tags);
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.setTagsState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
            if (typeof data.sources !== 'undefined' && (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.state.navSourcesExpanded) {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.setSources(data.sources);
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.setSourcesState((0, $d2d3ee75176c5e4c$export$62aa48085237e36f).SUCCESS);
            }
            return {
                entries: data.entries,
                hasMore: data.hasMore
            };
        }).catch(function(error) {
            if (error.name === 'AbortError') return;
            return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).handleAjaxError(error).then(function() {
                return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.getEntries(fetchParams);
            });
        });
    }
};



var $21h22 = parcelRequire("21h22");

var $6zk1M = parcelRequire("6zk1M");


/*
 * Dexie.js - a minimalistic wrapper for IndexedDB
 * ===============================================
 *
 * By David Fahlander, david.fahlander@gmail.com
 *
 * Version 4.2.1, Sat Oct 04 2025
 *
 * https://dexie.org
 *
 * Apache License Version 2.0, January 2004, http://www.apache.org/licenses/
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ 
var $2bfPH = parcelRequire("2bfPH");
var $bc26ee8cec700381$var$extendStatics = function extendStatics1(d, b) {
    $bc26ee8cec700381$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $bc26ee8cec700381$var$extendStatics(d, b);
};
function $bc26ee8cec700381$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $bc26ee8cec700381$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $bc26ee8cec700381$var$__assign = function __assign1() {
    $bc26ee8cec700381$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bc26ee8cec700381$var$__assign.apply(this, arguments);
};
function $bc26ee8cec700381$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var $bc26ee8cec700381$var$_global = typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
var $bc26ee8cec700381$var$keys = Object.keys;
var $bc26ee8cec700381$var$isArray = Array.isArray;
if (typeof Promise !== 'undefined' && !$bc26ee8cec700381$var$_global.Promise) $bc26ee8cec700381$var$_global.Promise = Promise;
function $bc26ee8cec700381$var$extend(obj, extension) {
    if ((typeof extension === "undefined" ? "undefined" : (0, $2bfPH._)(extension)) !== 'object') return obj;
    $bc26ee8cec700381$var$keys(extension).forEach(function(key) {
        obj[key] = extension[key];
    });
    return obj;
}
var $bc26ee8cec700381$var$getProto = Object.getPrototypeOf;
var $bc26ee8cec700381$var$_hasOwn = {}.hasOwnProperty;
function $bc26ee8cec700381$var$hasOwn(obj, prop) {
    return $bc26ee8cec700381$var$_hasOwn.call(obj, prop);
}
function $bc26ee8cec700381$var$props(proto, extension) {
    if (typeof extension === 'function') extension = extension($bc26ee8cec700381$var$getProto(proto));
    (typeof Reflect === "undefined" ? $bc26ee8cec700381$var$keys : Reflect.ownKeys)(extension).forEach(function(key) {
        $bc26ee8cec700381$var$setProp(proto, key, extension[key]);
    });
}
var $bc26ee8cec700381$var$defineProperty = Object.defineProperty;
function $bc26ee8cec700381$var$setProp(obj, prop, functionOrGetSet, options) {
    $bc26ee8cec700381$var$defineProperty(obj, prop, $bc26ee8cec700381$var$extend(functionOrGetSet && $bc26ee8cec700381$var$hasOwn(functionOrGetSet, "get") && typeof functionOrGetSet.get === 'function' ? {
        get: functionOrGetSet.get,
        set: functionOrGetSet.set,
        configurable: true
    } : {
        value: functionOrGetSet,
        configurable: true,
        writable: true
    }, options));
}
function $bc26ee8cec700381$var$derive(Child) {
    return {
        from: function from(Parent) {
            Child.prototype = Object.create(Parent.prototype);
            $bc26ee8cec700381$var$setProp(Child.prototype, "constructor", Child);
            return {
                extend: $bc26ee8cec700381$var$props.bind(null, Child.prototype)
            };
        }
    };
}
var $bc26ee8cec700381$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
function $bc26ee8cec700381$var$getPropertyDescriptor(obj, prop) {
    var pd = $bc26ee8cec700381$var$getOwnPropertyDescriptor(obj, prop);
    var proto;
    return pd || (proto = $bc26ee8cec700381$var$getProto(obj)) && $bc26ee8cec700381$var$getPropertyDescriptor(proto, prop);
}
var $bc26ee8cec700381$var$_slice = [].slice;
function $bc26ee8cec700381$var$slice(args, start, end) {
    return $bc26ee8cec700381$var$_slice.call(args, start, end);
}
function $bc26ee8cec700381$var$override(origFunc, overridedFactory) {
    return overridedFactory(origFunc);
}
function $bc26ee8cec700381$var$assert(b) {
    if (!b) throw new Error("Assertion Failed");
}
function $bc26ee8cec700381$var$asap$1(fn) {
    if ($bc26ee8cec700381$var$_global.setImmediate) setImmediate(fn);
    else setTimeout(fn, 0);
}
function $bc26ee8cec700381$var$arrayToObject(array, extractor) {
    return array.reduce(function(result, item, i) {
        var nameAndValue = extractor(item, i);
        if (nameAndValue) result[nameAndValue[0]] = nameAndValue[1];
        return result;
    }, {});
}
function $bc26ee8cec700381$var$getByKeyPath(obj, keyPath) {
    if (typeof keyPath === 'string' && $bc26ee8cec700381$var$hasOwn(obj, keyPath)) return obj[keyPath];
    if (!keyPath) return obj;
    if (typeof keyPath !== 'string') {
        var rv = [];
        for(var i = 0, l = keyPath.length; i < l; ++i){
            var val = $bc26ee8cec700381$var$getByKeyPath(obj, keyPath[i]);
            rv.push(val);
        }
        return rv;
    }
    var period = keyPath.indexOf('.');
    if (period !== -1) {
        var innerObj = obj[keyPath.substr(0, period)];
        return innerObj == null ? undefined : $bc26ee8cec700381$var$getByKeyPath(innerObj, keyPath.substr(period + 1));
    }
    return undefined;
}
function $bc26ee8cec700381$var$setByKeyPath(obj, keyPath, value) {
    if (!obj || keyPath === undefined) return;
    if ('isFrozen' in Object && Object.isFrozen(obj)) return;
    if (typeof keyPath !== 'string' && 'length' in keyPath) {
        $bc26ee8cec700381$var$assert(typeof value !== 'string' && 'length' in value);
        for(var i = 0, l = keyPath.length; i < l; ++i)$bc26ee8cec700381$var$setByKeyPath(obj, keyPath[i], value[i]);
    } else {
        var period = keyPath.indexOf('.');
        if (period !== -1) {
            var currentKeyPath = keyPath.substr(0, period);
            var remainingKeyPath = keyPath.substr(period + 1);
            if (remainingKeyPath === "") {
                if (value === undefined) {
                    if ($bc26ee8cec700381$var$isArray(obj) && !isNaN(parseInt(currentKeyPath))) obj.splice(currentKeyPath, 1);
                    else delete obj[currentKeyPath];
                } else obj[currentKeyPath] = value;
            } else {
                var innerObj = obj[currentKeyPath];
                if (!innerObj || !$bc26ee8cec700381$var$hasOwn(obj, currentKeyPath)) innerObj = obj[currentKeyPath] = {};
                $bc26ee8cec700381$var$setByKeyPath(innerObj, remainingKeyPath, value);
            }
        } else if (value === undefined) {
            if ($bc26ee8cec700381$var$isArray(obj) && !isNaN(parseInt(keyPath))) obj.splice(keyPath, 1);
            else delete obj[keyPath];
        } else obj[keyPath] = value;
    }
}
function $bc26ee8cec700381$var$delByKeyPath(obj, keyPath) {
    if (typeof keyPath === 'string') $bc26ee8cec700381$var$setByKeyPath(obj, keyPath, undefined);
    else if ('length' in keyPath) [].map.call(keyPath, function(kp) {
        $bc26ee8cec700381$var$setByKeyPath(obj, kp, undefined);
    });
}
function $bc26ee8cec700381$var$shallowClone(obj) {
    var rv = {};
    for(var m in obj)if ($bc26ee8cec700381$var$hasOwn(obj, m)) rv[m] = obj[m];
    return rv;
}
var $bc26ee8cec700381$var$concat = [].concat;
function $bc26ee8cec700381$var$flatten(a) {
    return $bc26ee8cec700381$var$concat.apply([], a);
}
var $bc26ee8cec700381$var$intrinsicTypeNames = "BigUint64Array,BigInt64Array,Array,Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,FileSystemDirectoryHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey".split(',').concat($bc26ee8cec700381$var$flatten([
    8,
    16,
    32,
    64
].map(function(num) {
    return [
        "Int",
        "Uint",
        "Float"
    ].map(function(t) {
        return t + num + "Array";
    });
}))).filter(function(t) {
    return $bc26ee8cec700381$var$_global[t];
});
var $bc26ee8cec700381$var$intrinsicTypes = new Set($bc26ee8cec700381$var$intrinsicTypeNames.map(function(t) {
    return $bc26ee8cec700381$var$_global[t];
}));
function $bc26ee8cec700381$var$cloneSimpleObjectTree(o) {
    var rv = {};
    for(var k in o)if ($bc26ee8cec700381$var$hasOwn(o, k)) {
        var v = o[k];
        rv[k] = !v || (typeof v === "undefined" ? "undefined" : (0, $2bfPH._)(v)) !== 'object' || $bc26ee8cec700381$var$intrinsicTypes.has(v.constructor) ? v : $bc26ee8cec700381$var$cloneSimpleObjectTree(v);
    }
    return rv;
}
function $bc26ee8cec700381$var$objectIsEmpty(o) {
    for(var k in o)if ($bc26ee8cec700381$var$hasOwn(o, k)) return false;
    return true;
}
var $bc26ee8cec700381$var$circularRefs = null;
function $bc26ee8cec700381$var$deepClone(any) {
    $bc26ee8cec700381$var$circularRefs = new WeakMap();
    var rv = $bc26ee8cec700381$var$innerDeepClone(any);
    $bc26ee8cec700381$var$circularRefs = null;
    return rv;
}
function $bc26ee8cec700381$var$innerDeepClone(x) {
    if (!x || (typeof x === "undefined" ? "undefined" : (0, $2bfPH._)(x)) !== 'object') return x;
    var rv = $bc26ee8cec700381$var$circularRefs.get(x);
    if (rv) return rv;
    if ($bc26ee8cec700381$var$isArray(x)) {
        rv = [];
        $bc26ee8cec700381$var$circularRefs.set(x, rv);
        for(var i = 0, l = x.length; i < l; ++i)rv.push($bc26ee8cec700381$var$innerDeepClone(x[i]));
    } else if ($bc26ee8cec700381$var$intrinsicTypes.has(x.constructor)) rv = x;
    else {
        var proto = $bc26ee8cec700381$var$getProto(x);
        rv = proto === Object.prototype ? {} : Object.create(proto);
        $bc26ee8cec700381$var$circularRefs.set(x, rv);
        for(var prop in x)if ($bc26ee8cec700381$var$hasOwn(x, prop)) rv[prop] = $bc26ee8cec700381$var$innerDeepClone(x[prop]);
    }
    return rv;
}
var $bc26ee8cec700381$var$toString = {}.toString;
function $bc26ee8cec700381$var$toStringTag(o) {
    return $bc26ee8cec700381$var$toString.call(o).slice(8, -1);
}
var $bc26ee8cec700381$var$iteratorSymbol = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
var $bc26ee8cec700381$var$getIteratorOf = (typeof $bc26ee8cec700381$var$iteratorSymbol === "undefined" ? "undefined" : (0, $2bfPH._)($bc26ee8cec700381$var$iteratorSymbol)) === "symbol" ? function getIteratorOf(x) {
    var i;
    return x != null && (i = x[$bc26ee8cec700381$var$iteratorSymbol]) && i.apply(x);
} : function() {
    return null;
};
function $bc26ee8cec700381$var$delArrayItem(a, x) {
    var i = a.indexOf(x);
    if (i >= 0) a.splice(i, 1);
    return i >= 0;
}
var $bc26ee8cec700381$var$NO_CHAR_ARRAY = {};
function $bc26ee8cec700381$var$getArrayOf(arrayLike) {
    var i, a, x, it;
    if (arguments.length === 1) {
        if ($bc26ee8cec700381$var$isArray(arrayLike)) return arrayLike.slice();
        if (this === $bc26ee8cec700381$var$NO_CHAR_ARRAY && typeof arrayLike === 'string') return [
            arrayLike
        ];
        if (it = $bc26ee8cec700381$var$getIteratorOf(arrayLike)) {
            a = [];
            while(x = it.next(), !x.done)a.push(x.value);
            return a;
        }
        if (arrayLike == null) return [
            arrayLike
        ];
        i = arrayLike.length;
        if (typeof i === 'number') {
            a = new Array(i);
            while(i--)a[i] = arrayLike[i];
            return a;
        }
        return [
            arrayLike
        ];
    }
    i = arguments.length;
    a = new Array(i);
    while(i--)a[i] = arguments[i];
    return a;
}
var $bc26ee8cec700381$var$isAsyncFunction = typeof Symbol !== 'undefined' ? function isAsyncFunction(fn) {
    return fn[Symbol.toStringTag] === 'AsyncFunction';
} : function() {
    return false;
};
var $bc26ee8cec700381$var$dexieErrorNames = [
    'Modify',
    'Bulk',
    'OpenFailed',
    'VersionChange',
    'Schema',
    'Upgrade',
    'InvalidTable',
    'MissingAPI',
    'NoSuchDatabase',
    'InvalidArgument',
    'SubTransaction',
    'Unsupported',
    'Internal',
    'DatabaseClosed',
    'PrematureCommit',
    'ForeignAwait'
];
var $bc26ee8cec700381$var$idbDomErrorNames = [
    'Unknown',
    'Constraint',
    'Data',
    'TransactionInactive',
    'ReadOnly',
    'Version',
    'NotFound',
    'InvalidState',
    'InvalidAccess',
    'Abort',
    'Timeout',
    'QuotaExceeded',
    'Syntax',
    'DataClone'
];
var $bc26ee8cec700381$var$errorList = $bc26ee8cec700381$var$dexieErrorNames.concat($bc26ee8cec700381$var$idbDomErrorNames);
var $bc26ee8cec700381$var$defaultTexts = {
    VersionChanged: "Database version changed by other database connection",
    DatabaseClosed: "Database has been closed",
    Abort: "Transaction aborted",
    TransactionInactive: "Transaction has already completed or failed",
    MissingAPI: "IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb"
};
function $bc26ee8cec700381$var$DexieError(name, msg) {
    this.name = name;
    this.message = msg;
}
$bc26ee8cec700381$var$derive($bc26ee8cec700381$var$DexieError).from(Error).extend({
    toString: function toString() {
        return this.name + ": " + this.message;
    }
});
function $bc26ee8cec700381$var$getMultiErrorMessage(msg, failures) {
    return msg + ". Errors: " + Object.keys(failures).map(function(key) {
        return failures[key].toString();
    }).filter(function(v, i, s) {
        return s.indexOf(v) === i;
    }).join('\n');
}
function $bc26ee8cec700381$var$ModifyError(msg, failures, successCount, failedKeys) {
    this.failures = failures;
    this.failedKeys = failedKeys;
    this.successCount = successCount;
    this.message = $bc26ee8cec700381$var$getMultiErrorMessage(msg, failures);
}
$bc26ee8cec700381$var$derive($bc26ee8cec700381$var$ModifyError).from($bc26ee8cec700381$var$DexieError);
function $bc26ee8cec700381$var$BulkError(msg, failures) {
    this.name = "BulkError";
    this.failures = Object.keys(failures).map(function(pos) {
        return failures[pos];
    });
    this.failuresByPos = failures;
    this.message = $bc26ee8cec700381$var$getMultiErrorMessage(msg, this.failures);
}
$bc26ee8cec700381$var$derive($bc26ee8cec700381$var$BulkError).from($bc26ee8cec700381$var$DexieError);
var $bc26ee8cec700381$var$errnames = $bc26ee8cec700381$var$errorList.reduce(function(obj, name) {
    return obj[name] = name + "Error", obj;
}, {});
var $bc26ee8cec700381$var$BaseException = $bc26ee8cec700381$var$DexieError;
var $bc26ee8cec700381$var$exceptions = $bc26ee8cec700381$var$errorList.reduce(function(obj, name) {
    var fullName = name + "Error";
    function DexieError(msgOrInner, inner) {
        this.name = fullName;
        if (!msgOrInner) {
            this.message = $bc26ee8cec700381$var$defaultTexts[name] || fullName;
            this.inner = null;
        } else if (typeof msgOrInner === 'string') {
            this.message = "".concat(msgOrInner).concat(!inner ? '' : '\n ' + inner);
            this.inner = inner || null;
        } else if ((typeof msgOrInner === "undefined" ? "undefined" : (0, $2bfPH._)(msgOrInner)) === 'object') {
            this.message = "".concat(msgOrInner.name, " ").concat(msgOrInner.message);
            this.inner = msgOrInner;
        }
    }
    $bc26ee8cec700381$var$derive(DexieError).from($bc26ee8cec700381$var$BaseException);
    obj[name] = DexieError;
    return obj;
}, {});
$bc26ee8cec700381$var$exceptions.Syntax = SyntaxError;
$bc26ee8cec700381$var$exceptions.Type = TypeError;
$bc26ee8cec700381$var$exceptions.Range = RangeError;
var $bc26ee8cec700381$var$exceptionMap = $bc26ee8cec700381$var$idbDomErrorNames.reduce(function(obj, name) {
    obj[name + "Error"] = $bc26ee8cec700381$var$exceptions[name];
    return obj;
}, {});
function $bc26ee8cec700381$var$mapError(domError, message) {
    if (!domError || domError instanceof $bc26ee8cec700381$var$DexieError || domError instanceof TypeError || domError instanceof SyntaxError || !domError.name || !$bc26ee8cec700381$var$exceptionMap[domError.name]) return domError;
    var rv = new $bc26ee8cec700381$var$exceptionMap[domError.name](message || domError.message, domError);
    if ("stack" in domError) $bc26ee8cec700381$var$setProp(rv, "stack", {
        get: function get() {
            return this.inner.stack;
        }
    });
    return rv;
}
var $bc26ee8cec700381$var$fullNameExceptions = $bc26ee8cec700381$var$errorList.reduce(function(obj, name) {
    if ([
        "Syntax",
        "Type",
        "Range"
    ].indexOf(name) === -1) obj[name + "Error"] = $bc26ee8cec700381$var$exceptions[name];
    return obj;
}, {});
$bc26ee8cec700381$var$fullNameExceptions.ModifyError = $bc26ee8cec700381$var$ModifyError;
$bc26ee8cec700381$var$fullNameExceptions.DexieError = $bc26ee8cec700381$var$DexieError;
$bc26ee8cec700381$var$fullNameExceptions.BulkError = $bc26ee8cec700381$var$BulkError;
function $bc26ee8cec700381$var$nop() {}
function $bc26ee8cec700381$var$mirror(val) {
    return val;
}
function $bc26ee8cec700381$var$pureFunctionChain(f1, f2) {
    if (f1 == null || f1 === $bc26ee8cec700381$var$mirror) return f2;
    return function(val) {
        return f2(f1(val));
    };
}
function $bc26ee8cec700381$var$callBoth(on1, on2) {
    return function() {
        on1.apply(this, arguments);
        on2.apply(this, arguments);
    };
}
function $bc26ee8cec700381$var$hookCreatingChain(f1, f2) {
    if (f1 === $bc26ee8cec700381$var$nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res !== undefined) arguments[0] = res;
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $bc26ee8cec700381$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $bc26ee8cec700381$var$callBoth(onerror, this.onerror) : onerror;
        return res2 !== undefined ? res2 : res;
    };
}
function $bc26ee8cec700381$var$hookDeletingChain(f1, f2) {
    if (f1 === $bc26ee8cec700381$var$nop) return f2;
    return function() {
        f1.apply(this, arguments);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = this.onerror = null;
        f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $bc26ee8cec700381$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $bc26ee8cec700381$var$callBoth(onerror, this.onerror) : onerror;
    };
}
function $bc26ee8cec700381$var$hookUpdatingChain(f1, f2) {
    if (f1 === $bc26ee8cec700381$var$nop) return f2;
    return function(modifications) {
        var res = f1.apply(this, arguments);
        $bc26ee8cec700381$var$extend(modifications, res);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $bc26ee8cec700381$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $bc26ee8cec700381$var$callBoth(onerror, this.onerror) : onerror;
        return res === undefined ? res2 === undefined ? undefined : res2 : $bc26ee8cec700381$var$extend(res, res2);
    };
}
function $bc26ee8cec700381$var$reverseStoppableEventChain(f1, f2) {
    if (f1 === $bc26ee8cec700381$var$nop) return f2;
    return function() {
        if (f2.apply(this, arguments) === false) return false;
        return f1.apply(this, arguments);
    };
}
function $bc26ee8cec700381$var$promisableChain(f1, f2) {
    if (f1 === $bc26ee8cec700381$var$nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res && typeof res.then === 'function') {
            var thiz = this, i = arguments.length, args = new Array(i);
            while(i--)args[i] = arguments[i];
            return res.then(function() {
                return f2.apply(thiz, args);
            });
        }
        return f2.apply(this, arguments);
    };
}
var $bc26ee8cec700381$var$debug = typeof location !== 'undefined' && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
function $bc26ee8cec700381$var$setDebug(value, filter) {
    $bc26ee8cec700381$var$debug = value;
}
var $bc26ee8cec700381$var$INTERNAL = {};
var $bc26ee8cec700381$var$ZONE_ECHO_LIMIT = 100, $bc26ee8cec700381$var$_a$1 = typeof Promise === 'undefined' ? [] : function() {
    var globalP = Promise.resolve();
    if (typeof crypto === 'undefined' || !crypto.subtle) return [
        globalP,
        $bc26ee8cec700381$var$getProto(globalP),
        globalP
    ];
    var nativeP = crypto.subtle.digest("SHA-512", new Uint8Array([
        0
    ]));
    return [
        nativeP,
        $bc26ee8cec700381$var$getProto(nativeP),
        globalP
    ];
}(), $bc26ee8cec700381$var$resolvedNativePromise = $bc26ee8cec700381$var$_a$1[0], $bc26ee8cec700381$var$nativePromiseProto = $bc26ee8cec700381$var$_a$1[1], $bc26ee8cec700381$var$resolvedGlobalPromise = $bc26ee8cec700381$var$_a$1[2], $bc26ee8cec700381$var$nativePromiseThen = $bc26ee8cec700381$var$nativePromiseProto && $bc26ee8cec700381$var$nativePromiseProto.then;
var $bc26ee8cec700381$var$NativePromise = $bc26ee8cec700381$var$resolvedNativePromise && $bc26ee8cec700381$var$resolvedNativePromise.constructor;
var $bc26ee8cec700381$var$patchGlobalPromise = !!$bc26ee8cec700381$var$resolvedGlobalPromise;
function $bc26ee8cec700381$var$schedulePhysicalTick() {
    queueMicrotask($bc26ee8cec700381$var$physicalTick);
}
var $bc26ee8cec700381$var$asap = function asap(callback, args) {
    $bc26ee8cec700381$var$microtickQueue.push([
        callback,
        args
    ]);
    if ($bc26ee8cec700381$var$needsNewPhysicalTick) {
        $bc26ee8cec700381$var$schedulePhysicalTick();
        $bc26ee8cec700381$var$needsNewPhysicalTick = false;
    }
};
var $bc26ee8cec700381$var$isOutsideMicroTick = true, $bc26ee8cec700381$var$needsNewPhysicalTick = true, $bc26ee8cec700381$var$unhandledErrors = [], $bc26ee8cec700381$var$rejectingErrors = [], $bc26ee8cec700381$var$rejectionMapper = $bc26ee8cec700381$var$mirror;
var $bc26ee8cec700381$var$globalPSD = {
    id: 'global',
    global: true,
    ref: 0,
    unhandleds: [],
    onunhandled: $bc26ee8cec700381$var$nop,
    pgp: false,
    env: {},
    finalize: $bc26ee8cec700381$var$nop
};
var $bc26ee8cec700381$var$PSD = $bc26ee8cec700381$var$globalPSD;
var $bc26ee8cec700381$var$microtickQueue = [];
var $bc26ee8cec700381$var$numScheduledCalls = 0;
var $bc26ee8cec700381$var$tickFinalizers = [];
function $bc26ee8cec700381$var$DexiePromise(fn) {
    if ((0, $2bfPH._)(this) !== 'object') throw new TypeError('Promises must be constructed via new');
    this._listeners = [];
    this._lib = false;
    var psd = this._PSD = $bc26ee8cec700381$var$PSD;
    if (typeof fn !== 'function') {
        if (fn !== $bc26ee8cec700381$var$INTERNAL) throw new TypeError('Not a function');
        this._state = arguments[1];
        this._value = arguments[2];
        if (this._state === false) $bc26ee8cec700381$var$handleRejection(this, this._value);
        return;
    }
    this._state = null;
    this._value = null;
    ++psd.ref;
    $bc26ee8cec700381$var$executePromiseTask(this, fn);
}
var $bc26ee8cec700381$var$thenProp = {
    get: function get() {
        var psd = $bc26ee8cec700381$var$PSD, microTaskId = $bc26ee8cec700381$var$totalEchoes;
        function then(onFulfilled, onRejected) {
            var _this = this;
            var possibleAwait = !psd.global && (psd !== $bc26ee8cec700381$var$PSD || microTaskId !== $bc26ee8cec700381$var$totalEchoes);
            var cleanup = possibleAwait && !$bc26ee8cec700381$var$decrementExpectedAwaits();
            var rv = new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
                $bc26ee8cec700381$var$propagateToListener(_this, new $bc26ee8cec700381$var$Listener($bc26ee8cec700381$var$nativeAwaitCompatibleWrap(onFulfilled, psd, possibleAwait, cleanup), $bc26ee8cec700381$var$nativeAwaitCompatibleWrap(onRejected, psd, possibleAwait, cleanup), resolve, reject, psd));
            });
            if (this._consoleTask) rv._consoleTask = this._consoleTask;
            return rv;
        }
        then.prototype = $bc26ee8cec700381$var$INTERNAL;
        return then;
    },
    set: function set(value) {
        $bc26ee8cec700381$var$setProp(this, 'then', value && value.prototype === $bc26ee8cec700381$var$INTERNAL ? $bc26ee8cec700381$var$thenProp : {
            get: function get() {
                return value;
            },
            set: $bc26ee8cec700381$var$thenProp.set
        });
    }
};
$bc26ee8cec700381$var$props($bc26ee8cec700381$var$DexiePromise.prototype, {
    then: $bc26ee8cec700381$var$thenProp,
    _then: function _then(onFulfilled, onRejected) {
        $bc26ee8cec700381$var$propagateToListener(this, new $bc26ee8cec700381$var$Listener(null, null, onFulfilled, onRejected, $bc26ee8cec700381$var$PSD));
    },
    catch: function _catch(onRejected) {
        if (arguments.length === 1) return this.then(null, onRejected);
        var type = arguments[0], handler = arguments[1];
        return typeof type === 'function' ? this.then(null, function(err) {
            return err instanceof type ? handler(err) : $bc26ee8cec700381$var$PromiseReject(err);
        }) : this.then(null, function(err) {
            return err && err.name === type ? handler(err) : $bc26ee8cec700381$var$PromiseReject(err);
        });
    },
    finally: function _finally(onFinally) {
        return this.then(function(value) {
            return $bc26ee8cec700381$var$DexiePromise.resolve(onFinally()).then(function() {
                return value;
            });
        }, function(err) {
            return $bc26ee8cec700381$var$DexiePromise.resolve(onFinally()).then(function() {
                return $bc26ee8cec700381$var$PromiseReject(err);
            });
        });
    },
    timeout: function timeout(ms, msg) {
        var _this = this;
        return ms < Infinity ? new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
            var handle = setTimeout(function() {
                return reject(new $bc26ee8cec700381$var$exceptions.Timeout(msg));
            }, ms);
            _this.then(resolve, reject).finally(clearTimeout.bind(null, handle));
        }) : this;
    }
});
if (typeof Symbol !== 'undefined' && Symbol.toStringTag) $bc26ee8cec700381$var$setProp($bc26ee8cec700381$var$DexiePromise.prototype, Symbol.toStringTag, 'Dexie.Promise');
$bc26ee8cec700381$var$globalPSD.env = $bc26ee8cec700381$var$snapShot();
function $bc26ee8cec700381$var$Listener(onFulfilled, onRejected, resolve, reject, zone) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.resolve = resolve;
    this.reject = reject;
    this.psd = zone;
}
$bc26ee8cec700381$var$props($bc26ee8cec700381$var$DexiePromise, {
    all: function all() {
        var values = $bc26ee8cec700381$var$getArrayOf.apply(null, arguments).map($bc26ee8cec700381$var$onPossibleParallellAsync);
        return new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
            if (values.length === 0) resolve([]);
            var remaining = values.length;
            values.forEach(function(a, i) {
                return $bc26ee8cec700381$var$DexiePromise.resolve(a).then(function(x) {
                    values[i] = x;
                    if (!--remaining) resolve(values);
                }, reject);
            });
        });
    },
    resolve: function resolve(value) {
        if (value instanceof $bc26ee8cec700381$var$DexiePromise) return value;
        if (value && typeof value.then === 'function') return new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
            value.then(resolve, reject);
        });
        var rv = new $bc26ee8cec700381$var$DexiePromise($bc26ee8cec700381$var$INTERNAL, true, value);
        return rv;
    },
    reject: $bc26ee8cec700381$var$PromiseReject,
    race: function race() {
        var values = $bc26ee8cec700381$var$getArrayOf.apply(null, arguments).map($bc26ee8cec700381$var$onPossibleParallellAsync);
        return new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
            values.map(function(value) {
                return $bc26ee8cec700381$var$DexiePromise.resolve(value).then(resolve, reject);
            });
        });
    },
    PSD: {
        get: function get() {
            return $bc26ee8cec700381$var$PSD;
        },
        set: function set(value) {
            return $bc26ee8cec700381$var$PSD = value;
        }
    },
    totalEchoes: {
        get: function get() {
            return $bc26ee8cec700381$var$totalEchoes;
        }
    },
    newPSD: $bc26ee8cec700381$var$newScope,
    usePSD: $bc26ee8cec700381$var$usePSD,
    scheduler: {
        get: function get() {
            return $bc26ee8cec700381$var$asap;
        },
        set: function set(value) {
            $bc26ee8cec700381$var$asap = value;
        }
    },
    rejectionMapper: {
        get: function get() {
            return $bc26ee8cec700381$var$rejectionMapper;
        },
        set: function set(value) {
            $bc26ee8cec700381$var$rejectionMapper = value;
        }
    },
    follow: function follow(fn, zoneProps) {
        return new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
            return $bc26ee8cec700381$var$newScope(function(resolve, reject) {
                var psd = $bc26ee8cec700381$var$PSD;
                psd.unhandleds = [];
                psd.onunhandled = reject;
                psd.finalize = $bc26ee8cec700381$var$callBoth(function() {
                    var _this = this;
                    $bc26ee8cec700381$var$run_at_end_of_this_or_next_physical_tick(function() {
                        _this.unhandleds.length === 0 ? resolve() : reject(_this.unhandleds[0]);
                    });
                }, psd.finalize);
                fn();
            }, zoneProps, resolve, reject);
        });
    }
});
if ($bc26ee8cec700381$var$NativePromise) {
    if ($bc26ee8cec700381$var$NativePromise.allSettled) $bc26ee8cec700381$var$setProp($bc26ee8cec700381$var$DexiePromise, "allSettled", function() {
        var possiblePromises = $bc26ee8cec700381$var$getArrayOf.apply(null, arguments).map($bc26ee8cec700381$var$onPossibleParallellAsync);
        return new $bc26ee8cec700381$var$DexiePromise(function(resolve) {
            if (possiblePromises.length === 0) resolve([]);
            var remaining = possiblePromises.length;
            var results = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return $bc26ee8cec700381$var$DexiePromise.resolve(p).then(function(value) {
                    return results[i] = {
                        status: "fulfilled",
                        value: value
                    };
                }, function(reason) {
                    return results[i] = {
                        status: "rejected",
                        reason: reason
                    };
                }).then(function() {
                    return --remaining || resolve(results);
                });
            });
        });
    });
    if ($bc26ee8cec700381$var$NativePromise.any && typeof AggregateError !== 'undefined') $bc26ee8cec700381$var$setProp($bc26ee8cec700381$var$DexiePromise, "any", function() {
        var possiblePromises = $bc26ee8cec700381$var$getArrayOf.apply(null, arguments).map($bc26ee8cec700381$var$onPossibleParallellAsync);
        return new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
            if (possiblePromises.length === 0) reject(new AggregateError([]));
            var remaining = possiblePromises.length;
            var failures = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return $bc26ee8cec700381$var$DexiePromise.resolve(p).then(function(value) {
                    return resolve(value);
                }, function(failure) {
                    failures[i] = failure;
                    if (!--remaining) reject(new AggregateError(failures));
                });
            });
        });
    });
    if ($bc26ee8cec700381$var$NativePromise.withResolvers) $bc26ee8cec700381$var$DexiePromise.withResolvers = $bc26ee8cec700381$var$NativePromise.withResolvers;
}
function $bc26ee8cec700381$var$executePromiseTask(promise, fn) {
    try {
        fn(function(value) {
            if (promise._state !== null) return;
            if (value === promise) throw new TypeError('A promise cannot be resolved with itself.');
            var shouldExecuteTick = promise._lib && $bc26ee8cec700381$var$beginMicroTickScope();
            if (value && typeof value.then === 'function') $bc26ee8cec700381$var$executePromiseTask(promise, function(resolve, reject) {
                value instanceof $bc26ee8cec700381$var$DexiePromise ? value._then(resolve, reject) : value.then(resolve, reject);
            });
            else {
                promise._state = true;
                promise._value = value;
                $bc26ee8cec700381$var$propagateAllListeners(promise);
            }
            if (shouldExecuteTick) $bc26ee8cec700381$var$endMicroTickScope();
        }, $bc26ee8cec700381$var$handleRejection.bind(null, promise));
    } catch (ex) {
        $bc26ee8cec700381$var$handleRejection(promise, ex);
    }
}
function $bc26ee8cec700381$var$handleRejection(promise, reason) {
    $bc26ee8cec700381$var$rejectingErrors.push(reason);
    if (promise._state !== null) return;
    var shouldExecuteTick = promise._lib && $bc26ee8cec700381$var$beginMicroTickScope();
    reason = $bc26ee8cec700381$var$rejectionMapper(reason);
    promise._state = false;
    promise._value = reason;
    $bc26ee8cec700381$var$addPossiblyUnhandledError(promise);
    $bc26ee8cec700381$var$propagateAllListeners(promise);
    if (shouldExecuteTick) $bc26ee8cec700381$var$endMicroTickScope();
}
function $bc26ee8cec700381$var$propagateAllListeners(promise) {
    var listeners = promise._listeners;
    promise._listeners = [];
    for(var i = 0, len = listeners.length; i < len; ++i)$bc26ee8cec700381$var$propagateToListener(promise, listeners[i]);
    var psd = promise._PSD;
    --psd.ref || psd.finalize();
    if ($bc26ee8cec700381$var$numScheduledCalls === 0) {
        ++$bc26ee8cec700381$var$numScheduledCalls;
        $bc26ee8cec700381$var$asap(function() {
            if (--$bc26ee8cec700381$var$numScheduledCalls === 0) $bc26ee8cec700381$var$finalizePhysicalTick();
        }, []);
    }
}
function $bc26ee8cec700381$var$propagateToListener(promise, listener) {
    if (promise._state === null) {
        promise._listeners.push(listener);
        return;
    }
    var cb = promise._state ? listener.onFulfilled : listener.onRejected;
    if (cb === null) return (promise._state ? listener.resolve : listener.reject)(promise._value);
    ++listener.psd.ref;
    ++$bc26ee8cec700381$var$numScheduledCalls;
    $bc26ee8cec700381$var$asap($bc26ee8cec700381$var$callListener, [
        cb,
        promise,
        listener
    ]);
}
function $bc26ee8cec700381$var$callListener(cb, promise, listener) {
    try {
        var ret, value = promise._value;
        if (!promise._state && $bc26ee8cec700381$var$rejectingErrors.length) $bc26ee8cec700381$var$rejectingErrors = [];
        ret = $bc26ee8cec700381$var$debug && promise._consoleTask ? promise._consoleTask.run(function() {
            return cb(value);
        }) : cb(value);
        if (!promise._state && $bc26ee8cec700381$var$rejectingErrors.indexOf(value) === -1) $bc26ee8cec700381$var$markErrorAsHandled(promise);
        listener.resolve(ret);
    } catch (e) {
        listener.reject(e);
    } finally{
        if (--$bc26ee8cec700381$var$numScheduledCalls === 0) $bc26ee8cec700381$var$finalizePhysicalTick();
        --listener.psd.ref || listener.psd.finalize();
    }
}
function $bc26ee8cec700381$var$physicalTick() {
    $bc26ee8cec700381$var$usePSD($bc26ee8cec700381$var$globalPSD, function() {
        $bc26ee8cec700381$var$beginMicroTickScope() && $bc26ee8cec700381$var$endMicroTickScope();
    });
}
function $bc26ee8cec700381$var$beginMicroTickScope() {
    var wasRootExec = $bc26ee8cec700381$var$isOutsideMicroTick;
    $bc26ee8cec700381$var$isOutsideMicroTick = false;
    $bc26ee8cec700381$var$needsNewPhysicalTick = false;
    return wasRootExec;
}
function $bc26ee8cec700381$var$endMicroTickScope() {
    var callbacks, i, l;
    do while($bc26ee8cec700381$var$microtickQueue.length > 0){
        callbacks = $bc26ee8cec700381$var$microtickQueue;
        $bc26ee8cec700381$var$microtickQueue = [];
        l = callbacks.length;
        for(i = 0; i < l; ++i){
            var item = callbacks[i];
            item[0].apply(null, item[1]);
        }
    }
    while ($bc26ee8cec700381$var$microtickQueue.length > 0);
    $bc26ee8cec700381$var$isOutsideMicroTick = true;
    $bc26ee8cec700381$var$needsNewPhysicalTick = true;
}
function $bc26ee8cec700381$var$finalizePhysicalTick() {
    var unhandledErrs = $bc26ee8cec700381$var$unhandledErrors;
    $bc26ee8cec700381$var$unhandledErrors = [];
    unhandledErrs.forEach(function(p) {
        p._PSD.onunhandled.call(null, p._value, p);
    });
    var finalizers = $bc26ee8cec700381$var$tickFinalizers.slice(0);
    var i = finalizers.length;
    while(i)finalizers[--i]();
}
function $bc26ee8cec700381$var$run_at_end_of_this_or_next_physical_tick(fn) {
    function finalizer() {
        fn();
        $bc26ee8cec700381$var$tickFinalizers.splice($bc26ee8cec700381$var$tickFinalizers.indexOf(finalizer), 1);
    }
    $bc26ee8cec700381$var$tickFinalizers.push(finalizer);
    ++$bc26ee8cec700381$var$numScheduledCalls;
    $bc26ee8cec700381$var$asap(function() {
        if (--$bc26ee8cec700381$var$numScheduledCalls === 0) $bc26ee8cec700381$var$finalizePhysicalTick();
    }, []);
}
function $bc26ee8cec700381$var$addPossiblyUnhandledError(promise) {
    if (!$bc26ee8cec700381$var$unhandledErrors.some(function(p) {
        return p._value === promise._value;
    })) $bc26ee8cec700381$var$unhandledErrors.push(promise);
}
function $bc26ee8cec700381$var$markErrorAsHandled(promise) {
    var i = $bc26ee8cec700381$var$unhandledErrors.length;
    while(i)if ($bc26ee8cec700381$var$unhandledErrors[--i]._value === promise._value) {
        $bc26ee8cec700381$var$unhandledErrors.splice(i, 1);
        return;
    }
}
function $bc26ee8cec700381$var$PromiseReject(reason) {
    return new $bc26ee8cec700381$var$DexiePromise($bc26ee8cec700381$var$INTERNAL, false, reason);
}
function $bc26ee8cec700381$var$wrap(fn, errorCatcher) {
    var psd = $bc26ee8cec700381$var$PSD;
    return function() {
        var wasRootExec = $bc26ee8cec700381$var$beginMicroTickScope(), outerScope = $bc26ee8cec700381$var$PSD;
        try {
            $bc26ee8cec700381$var$switchToZone(psd, true);
            return fn.apply(this, arguments);
        } catch (e) {
            errorCatcher && errorCatcher(e);
        } finally{
            $bc26ee8cec700381$var$switchToZone(outerScope, false);
            if (wasRootExec) $bc26ee8cec700381$var$endMicroTickScope();
        }
    };
}
var $bc26ee8cec700381$var$task = {
    awaits: 0,
    echoes: 0,
    id: 0
};
var $bc26ee8cec700381$var$taskCounter = 0;
var $bc26ee8cec700381$var$zoneStack = [];
var $bc26ee8cec700381$var$zoneEchoes = 0;
var $bc26ee8cec700381$var$totalEchoes = 0;
var $bc26ee8cec700381$var$zone_id_counter = 0;
function $bc26ee8cec700381$var$newScope(fn, props, a1, a2) {
    var parent = $bc26ee8cec700381$var$PSD, psd = Object.create(parent);
    psd.parent = parent;
    psd.ref = 0;
    psd.global = false;
    psd.id = ++$bc26ee8cec700381$var$zone_id_counter;
    $bc26ee8cec700381$var$globalPSD.env;
    psd.env = $bc26ee8cec700381$var$patchGlobalPromise ? {
        Promise: $bc26ee8cec700381$var$DexiePromise,
        PromiseProp: {
            value: $bc26ee8cec700381$var$DexiePromise,
            configurable: true,
            writable: true
        },
        all: $bc26ee8cec700381$var$DexiePromise.all,
        race: $bc26ee8cec700381$var$DexiePromise.race,
        allSettled: $bc26ee8cec700381$var$DexiePromise.allSettled,
        any: $bc26ee8cec700381$var$DexiePromise.any,
        resolve: $bc26ee8cec700381$var$DexiePromise.resolve,
        reject: $bc26ee8cec700381$var$DexiePromise.reject
    } : {};
    if (props) $bc26ee8cec700381$var$extend(psd, props);
    ++parent.ref;
    psd.finalize = function() {
        --this.parent.ref || this.parent.finalize();
    };
    var rv = $bc26ee8cec700381$var$usePSD(psd, fn, a1, a2);
    if (psd.ref === 0) psd.finalize();
    return rv;
}
function $bc26ee8cec700381$var$incrementExpectedAwaits() {
    if (!$bc26ee8cec700381$var$task.id) $bc26ee8cec700381$var$task.id = ++$bc26ee8cec700381$var$taskCounter;
    ++$bc26ee8cec700381$var$task.awaits;
    $bc26ee8cec700381$var$task.echoes += $bc26ee8cec700381$var$ZONE_ECHO_LIMIT;
    return $bc26ee8cec700381$var$task.id;
}
function $bc26ee8cec700381$var$decrementExpectedAwaits() {
    if (!$bc26ee8cec700381$var$task.awaits) return false;
    if (--$bc26ee8cec700381$var$task.awaits === 0) $bc26ee8cec700381$var$task.id = 0;
    $bc26ee8cec700381$var$task.echoes = $bc26ee8cec700381$var$task.awaits * $bc26ee8cec700381$var$ZONE_ECHO_LIMIT;
    return true;
}
if (('' + $bc26ee8cec700381$var$nativePromiseThen).indexOf('[native code]') === -1) $bc26ee8cec700381$var$incrementExpectedAwaits = $bc26ee8cec700381$var$decrementExpectedAwaits = $bc26ee8cec700381$var$nop;
function $bc26ee8cec700381$var$onPossibleParallellAsync(possiblePromise) {
    if ($bc26ee8cec700381$var$task.echoes && possiblePromise && possiblePromise.constructor === $bc26ee8cec700381$var$NativePromise) {
        $bc26ee8cec700381$var$incrementExpectedAwaits();
        return possiblePromise.then(function(x) {
            $bc26ee8cec700381$var$decrementExpectedAwaits();
            return x;
        }, function(e) {
            $bc26ee8cec700381$var$decrementExpectedAwaits();
            return $bc26ee8cec700381$var$rejection(e);
        });
    }
    return possiblePromise;
}
function $bc26ee8cec700381$var$zoneEnterEcho(targetZone) {
    ++$bc26ee8cec700381$var$totalEchoes;
    if (!$bc26ee8cec700381$var$task.echoes || --$bc26ee8cec700381$var$task.echoes === 0) $bc26ee8cec700381$var$task.echoes = $bc26ee8cec700381$var$task.awaits = $bc26ee8cec700381$var$task.id = 0;
    $bc26ee8cec700381$var$zoneStack.push($bc26ee8cec700381$var$PSD);
    $bc26ee8cec700381$var$switchToZone(targetZone, true);
}
function $bc26ee8cec700381$var$zoneLeaveEcho() {
    var zone = $bc26ee8cec700381$var$zoneStack[$bc26ee8cec700381$var$zoneStack.length - 1];
    $bc26ee8cec700381$var$zoneStack.pop();
    $bc26ee8cec700381$var$switchToZone(zone, false);
}
function $bc26ee8cec700381$var$switchToZone(targetZone, bEnteringZone) {
    var currentZone = $bc26ee8cec700381$var$PSD;
    if (bEnteringZone ? $bc26ee8cec700381$var$task.echoes && (!$bc26ee8cec700381$var$zoneEchoes++ || targetZone !== $bc26ee8cec700381$var$PSD) : $bc26ee8cec700381$var$zoneEchoes && (!--$bc26ee8cec700381$var$zoneEchoes || targetZone !== $bc26ee8cec700381$var$PSD)) queueMicrotask(bEnteringZone ? $bc26ee8cec700381$var$zoneEnterEcho.bind(null, targetZone) : $bc26ee8cec700381$var$zoneLeaveEcho);
    if (targetZone === $bc26ee8cec700381$var$PSD) return;
    $bc26ee8cec700381$var$PSD = targetZone;
    if (currentZone === $bc26ee8cec700381$var$globalPSD) $bc26ee8cec700381$var$globalPSD.env = $bc26ee8cec700381$var$snapShot();
    if ($bc26ee8cec700381$var$patchGlobalPromise) {
        var GlobalPromise = $bc26ee8cec700381$var$globalPSD.env.Promise;
        var targetEnv = targetZone.env;
        if (currentZone.global || targetZone.global) {
            Object.defineProperty($bc26ee8cec700381$var$_global, 'Promise', targetEnv.PromiseProp);
            GlobalPromise.all = targetEnv.all;
            GlobalPromise.race = targetEnv.race;
            GlobalPromise.resolve = targetEnv.resolve;
            GlobalPromise.reject = targetEnv.reject;
            if (targetEnv.allSettled) GlobalPromise.allSettled = targetEnv.allSettled;
            if (targetEnv.any) GlobalPromise.any = targetEnv.any;
        }
    }
}
function $bc26ee8cec700381$var$snapShot() {
    var GlobalPromise = $bc26ee8cec700381$var$_global.Promise;
    return $bc26ee8cec700381$var$patchGlobalPromise ? {
        Promise: GlobalPromise,
        PromiseProp: Object.getOwnPropertyDescriptor($bc26ee8cec700381$var$_global, "Promise"),
        all: GlobalPromise.all,
        race: GlobalPromise.race,
        allSettled: GlobalPromise.allSettled,
        any: GlobalPromise.any,
        resolve: GlobalPromise.resolve,
        reject: GlobalPromise.reject
    } : {};
}
function $bc26ee8cec700381$var$usePSD(psd, fn, a1, a2, a3) {
    var outerScope = $bc26ee8cec700381$var$PSD;
    try {
        $bc26ee8cec700381$var$switchToZone(psd, true);
        return fn(a1, a2, a3);
    } finally{
        $bc26ee8cec700381$var$switchToZone(outerScope, false);
    }
}
function $bc26ee8cec700381$var$nativeAwaitCompatibleWrap(fn, zone, possibleAwait, cleanup) {
    return typeof fn !== 'function' ? fn : function() {
        var outerZone = $bc26ee8cec700381$var$PSD;
        if (possibleAwait) $bc26ee8cec700381$var$incrementExpectedAwaits();
        $bc26ee8cec700381$var$switchToZone(zone, true);
        try {
            return fn.apply(this, arguments);
        } finally{
            $bc26ee8cec700381$var$switchToZone(outerZone, false);
            if (cleanup) queueMicrotask($bc26ee8cec700381$var$decrementExpectedAwaits);
        }
    };
}
function $bc26ee8cec700381$var$execInGlobalContext(cb) {
    if (Promise === $bc26ee8cec700381$var$NativePromise && $bc26ee8cec700381$var$task.echoes === 0) {
        if ($bc26ee8cec700381$var$zoneEchoes === 0) cb();
        else enqueueNativeMicroTask(cb);
    } else setTimeout(cb, 0);
}
var $bc26ee8cec700381$var$rejection = $bc26ee8cec700381$var$DexiePromise.reject;
function $bc26ee8cec700381$var$tempTransaction(db, mode, storeNames, fn) {
    if (!db.idbdb || !db._state.openComplete && !$bc26ee8cec700381$var$PSD.letThrough && !db._vip) {
        if (db._state.openComplete) return $bc26ee8cec700381$var$rejection(new $bc26ee8cec700381$var$exceptions.DatabaseClosed(db._state.dbOpenError));
        if (!db._state.isBeingOpened) {
            if (!db._state.autoOpen) return $bc26ee8cec700381$var$rejection(new $bc26ee8cec700381$var$exceptions.DatabaseClosed());
            db.open().catch($bc26ee8cec700381$var$nop);
        }
        return db._state.dbReadyPromise.then(function() {
            return $bc26ee8cec700381$var$tempTransaction(db, mode, storeNames, fn);
        });
    } else {
        var trans = db._createTransaction(mode, storeNames, db._dbSchema);
        try {
            trans.create();
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === $bc26ee8cec700381$var$errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn('Dexie: Need to reopen db');
                db.close({
                    disableAutoOpen: false
                });
                return db.open().then(function() {
                    return $bc26ee8cec700381$var$tempTransaction(db, mode, storeNames, fn);
                });
            }
            return $bc26ee8cec700381$var$rejection(ex);
        }
        return trans._promise(mode, function(resolve, reject) {
            return $bc26ee8cec700381$var$newScope(function() {
                $bc26ee8cec700381$var$PSD.trans = trans;
                return fn(resolve, reject, trans);
            });
        }).then(function(result) {
            if (mode === 'readwrite') try {
                trans.idbtrans.commit();
            } catch (_a) {}
            return mode === 'readonly' ? result : trans._completion.then(function() {
                return result;
            });
        });
    }
}
var $bc26ee8cec700381$var$DEXIE_VERSION = '4.2.1';
var $bc26ee8cec700381$var$maxString = String.fromCharCode(65535);
var $bc26ee8cec700381$var$minKey = -Infinity;
var $bc26ee8cec700381$var$INVALID_KEY_ARGUMENT = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.";
var $bc26ee8cec700381$var$STRING_EXPECTED = "String expected.";
var $bc26ee8cec700381$var$connections = [];
var $bc26ee8cec700381$var$DBNAMES_DB = '__dbnames';
var $bc26ee8cec700381$var$READONLY = 'readonly';
var $bc26ee8cec700381$var$READWRITE = 'readwrite';
function $bc26ee8cec700381$var$combine(filter1, filter2) {
    return filter1 ? filter2 ? function() {
        return filter1.apply(this, arguments) && filter2.apply(this, arguments);
    } : filter1 : filter2;
}
var $bc26ee8cec700381$var$AnyRange = {
    type: 3,
    lower: -Infinity,
    lowerOpen: false,
    upper: [
        []
    ],
    upperOpen: false
};
function $bc26ee8cec700381$var$workaroundForUndefinedPrimKey(keyPath) {
    return typeof keyPath === "string" && !/\./.test(keyPath) ? function(obj) {
        if (obj[keyPath] === undefined && keyPath in obj) {
            obj = $bc26ee8cec700381$var$deepClone(obj);
            delete obj[keyPath];
        }
        return obj;
    } : function(obj) {
        return obj;
    };
}
function $bc26ee8cec700381$export$bc644a473284d944() {
    throw $bc26ee8cec700381$var$exceptions.Type("Entity instances must never be new:ed. Instances are generated by the framework bypassing the constructor.");
}
function $bc26ee8cec700381$export$6154dcdb7d23e37b(a, b) {
    try {
        var ta = $bc26ee8cec700381$var$type(a);
        var tb = $bc26ee8cec700381$var$type(b);
        if (ta !== tb) {
            if (ta === 'Array') return 1;
            if (tb === 'Array') return -1;
            if (ta === 'binary') return 1;
            if (tb === 'binary') return -1;
            if (ta === 'string') return 1;
            if (tb === 'string') return -1;
            if (ta === 'Date') return 1;
            if (tb !== 'Date') return NaN;
            return -1;
        }
        switch(ta){
            case 'number':
            case 'Date':
            case 'string':
                return a > b ? 1 : a < b ? -1 : 0;
            case 'binary':
                return $bc26ee8cec700381$var$compareUint8Arrays($bc26ee8cec700381$var$getUint8Array(a), $bc26ee8cec700381$var$getUint8Array(b));
            case 'Array':
                return $bc26ee8cec700381$var$compareArrays(a, b);
        }
    } catch (_a) {}
    return NaN;
}
function $bc26ee8cec700381$var$compareArrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        var res = $bc26ee8cec700381$export$6154dcdb7d23e37b(a[i], b[i]);
        if (res !== 0) return res;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function $bc26ee8cec700381$var$compareUint8Arrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        if (a[i] !== b[i]) return a[i] < b[i] ? -1 : 1;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function $bc26ee8cec700381$var$type(x) {
    var t = typeof x === "undefined" ? "undefined" : (0, $2bfPH._)(x);
    if (t !== 'object') return t;
    if (ArrayBuffer.isView(x)) return 'binary';
    var tsTag = $bc26ee8cec700381$var$toStringTag(x);
    return tsTag === 'ArrayBuffer' ? 'binary' : tsTag;
}
function $bc26ee8cec700381$var$getUint8Array(a) {
    if (a instanceof Uint8Array) return a;
    if (ArrayBuffer.isView(a)) return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    return new Uint8Array(a);
}
function $bc26ee8cec700381$var$builtInDeletionTrigger(table, keys, res) {
    var yProps = table.schema.yProps;
    if (!yProps) return res;
    if (keys && res.numFailures > 0) keys = keys.filter(function(_, i) {
        return !res.failures[i];
    });
    return Promise.all(yProps.map(function(_a) {
        var updatesTable = _a.updatesTable;
        return keys ? table.db.table(updatesTable).where('k').anyOf(keys).delete() : table.db.table(updatesTable).clear();
    })).then(function() {
        return res;
    });
}
var $bc26ee8cec700381$export$4118fdb20badc28d = function() {
    function PropModification(spec) {
        this["@@propmod"] = spec;
    }
    PropModification.prototype.execute = function(value) {
        var _a;
        var spec = this["@@propmod"];
        if (spec.add !== undefined) {
            var term = spec.add;
            if ($bc26ee8cec700381$var$isArray(term)) return $bc26ee8cec700381$var$__spreadArray($bc26ee8cec700381$var$__spreadArray([], $bc26ee8cec700381$var$isArray(value) ? value : [], true), term, true).sort();
            if (typeof term === 'number') return (Number(value) || 0) + term;
            if ((typeof term === "undefined" ? "undefined" : (0, $2bfPH._)(term)) === 'bigint') try {
                return BigInt(value) + term;
            } catch (_b) {
                return BigInt(0) + term;
            }
            throw new TypeError("Invalid term ".concat(term));
        }
        if (spec.remove !== undefined) {
            var subtrahend_1 = spec.remove;
            if ($bc26ee8cec700381$var$isArray(subtrahend_1)) return $bc26ee8cec700381$var$isArray(value) ? value.filter(function(item) {
                return !subtrahend_1.includes(item);
            }).sort() : [];
            if (typeof subtrahend_1 === 'number') return Number(value) - subtrahend_1;
            if ((typeof subtrahend_1 === "undefined" ? "undefined" : (0, $2bfPH._)(subtrahend_1)) === 'bigint') try {
                return BigInt(value) - subtrahend_1;
            } catch (_c) {
                return BigInt(0) - subtrahend_1;
            }
            throw new TypeError("Invalid subtrahend ".concat(subtrahend_1));
        }
        var prefixToReplace = (_a = spec.replacePrefix) === null || _a === void 0 ? void 0 : _a[0];
        if (prefixToReplace && typeof value === 'string' && value.startsWith(prefixToReplace)) return spec.replacePrefix[1] + value.substring(prefixToReplace.length);
        return value;
    };
    return PropModification;
}();
function $bc26ee8cec700381$var$applyUpdateSpec(obj, changes) {
    var keyPaths = $bc26ee8cec700381$var$keys(changes);
    var numKeys = keyPaths.length;
    var anythingModified = false;
    for(var i = 0; i < numKeys; ++i){
        var keyPath = keyPaths[i];
        var value = changes[keyPath];
        var origValue = $bc26ee8cec700381$var$getByKeyPath(obj, keyPath);
        if (value instanceof $bc26ee8cec700381$export$4118fdb20badc28d) {
            $bc26ee8cec700381$var$setByKeyPath(obj, keyPath, value.execute(origValue));
            anythingModified = true;
        } else if (origValue !== value) {
            $bc26ee8cec700381$var$setByKeyPath(obj, keyPath, value);
            anythingModified = true;
        }
    }
    return anythingModified;
}
var $bc26ee8cec700381$var$Table = function() {
    function Table() {}
    Table.prototype._trans = function(mode, fn, writeLocked) {
        var trans = this._tx || $bc26ee8cec700381$var$PSD.trans;
        var tableName = this.name;
        var task = $bc26ee8cec700381$var$debug && typeof console !== 'undefined' && console.createTask && console.createTask("Dexie: ".concat(mode === 'readonly' ? 'read' : 'write', " ").concat(this.name));
        function checkTableInTransaction(resolve, reject, trans) {
            if (!trans.schema[tableName]) throw new $bc26ee8cec700381$var$exceptions.NotFound("Table " + tableName + " not part of transaction");
            return fn(trans.idbtrans, trans);
        }
        var wasRootExec = $bc26ee8cec700381$var$beginMicroTickScope();
        try {
            var p = trans && trans.db._novip === this.db._novip ? trans === $bc26ee8cec700381$var$PSD.trans ? trans._promise(mode, checkTableInTransaction, writeLocked) : $bc26ee8cec700381$var$newScope(function() {
                return trans._promise(mode, checkTableInTransaction, writeLocked);
            }, {
                trans: trans,
                transless: $bc26ee8cec700381$var$PSD.transless || $bc26ee8cec700381$var$PSD
            }) : $bc26ee8cec700381$var$tempTransaction(this.db, mode, [
                this.name
            ], checkTableInTransaction);
            if (task) {
                p._consoleTask = task;
                p = p.catch(function(err) {
                    console.trace(err);
                    return $bc26ee8cec700381$var$rejection(err);
                });
            }
            return p;
        } finally{
            if (wasRootExec) $bc26ee8cec700381$var$endMicroTickScope();
        }
    };
    Table.prototype.get = function(keyOrCrit, cb) {
        var _this = this;
        if (keyOrCrit && keyOrCrit.constructor === Object) return this.where(keyOrCrit).first(cb);
        if (keyOrCrit == null) return $bc26ee8cec700381$var$rejection(new $bc26ee8cec700381$var$exceptions.Type("Invalid argument to Table.get()"));
        return this._trans('readonly', function(trans) {
            return _this.core.get({
                trans: trans,
                key: keyOrCrit
            }).then(function(res) {
                return _this.hook.reading.fire(res);
            });
        }).then(cb);
    };
    Table.prototype.where = function(indexOrCrit) {
        if (typeof indexOrCrit === 'string') return new this.db.WhereClause(this, indexOrCrit);
        if ($bc26ee8cec700381$var$isArray(indexOrCrit)) return new this.db.WhereClause(this, "[".concat(indexOrCrit.join('+'), "]"));
        var keyPaths = $bc26ee8cec700381$var$keys(indexOrCrit);
        if (keyPaths.length === 1) return this.where(keyPaths[0]).equals(indexOrCrit[keyPaths[0]]);
        var compoundIndex = this.schema.indexes.concat(this.schema.primKey).filter(function(ix) {
            if (ix.compound && keyPaths.every(function(keyPath) {
                return ix.keyPath.indexOf(keyPath) >= 0;
            })) {
                for(var i = 0; i < keyPaths.length; ++i){
                    if (keyPaths.indexOf(ix.keyPath[i]) === -1) return false;
                }
                return true;
            }
            return false;
        }).sort(function(a, b) {
            return a.keyPath.length - b.keyPath.length;
        })[0];
        if (compoundIndex && this.db._maxKey !== $bc26ee8cec700381$var$maxString) {
            var keyPathsInValidOrder = compoundIndex.keyPath.slice(0, keyPaths.length);
            return this.where(keyPathsInValidOrder).equals(keyPathsInValidOrder.map(function(kp) {
                return indexOrCrit[kp];
            }));
        }
        if (!compoundIndex && $bc26ee8cec700381$var$debug) console.warn("The query ".concat(JSON.stringify(indexOrCrit), " on ").concat(this.name, " would benefit from a ") + "compound index [".concat(keyPaths.join('+'), "]"));
        var idxByName = this.schema.idxByName;
        function equals(a, b) {
            return $bc26ee8cec700381$export$6154dcdb7d23e37b(a, b) === 0;
        }
        var _a = keyPaths.reduce(function(_a, keyPath) {
            var prevIndex = _a[0], prevFilterFn = _a[1];
            var index = idxByName[keyPath];
            var value = indexOrCrit[keyPath];
            return [
                prevIndex || index,
                prevIndex || !index ? $bc26ee8cec700381$var$combine(prevFilterFn, index && index.multi ? function(x) {
                    var prop = $bc26ee8cec700381$var$getByKeyPath(x, keyPath);
                    return $bc26ee8cec700381$var$isArray(prop) && prop.some(function(item) {
                        return equals(value, item);
                    });
                } : function(x) {
                    return equals(value, $bc26ee8cec700381$var$getByKeyPath(x, keyPath));
                }) : prevFilterFn
            ];
        }, [
            null,
            null
        ]), idx = _a[0], filterFunction = _a[1];
        return idx ? this.where(idx.name).equals(indexOrCrit[idx.keyPath]).filter(filterFunction) : compoundIndex ? this.filter(filterFunction) : this.where(keyPaths).equals('');
    };
    Table.prototype.filter = function(filterFunction) {
        return this.toCollection().and(filterFunction);
    };
    Table.prototype.count = function(thenShortcut) {
        return this.toCollection().count(thenShortcut);
    };
    Table.prototype.offset = function(offset) {
        return this.toCollection().offset(offset);
    };
    Table.prototype.limit = function(numRows) {
        return this.toCollection().limit(numRows);
    };
    Table.prototype.each = function(callback) {
        return this.toCollection().each(callback);
    };
    Table.prototype.toArray = function(thenShortcut) {
        return this.toCollection().toArray(thenShortcut);
    };
    Table.prototype.toCollection = function() {
        return new this.db.Collection(new this.db.WhereClause(this));
    };
    Table.prototype.orderBy = function(index) {
        return new this.db.Collection(new this.db.WhereClause(this, $bc26ee8cec700381$var$isArray(index) ? "[".concat(index.join('+'), "]") : index));
    };
    Table.prototype.reverse = function() {
        return this.toCollection().reverse();
    };
    Table.prototype.mapToClass = function(constructor) {
        var _a = this, db = _a.db, tableName = _a.name;
        this.schema.mappedClass = constructor;
        if (constructor.prototype instanceof $bc26ee8cec700381$export$bc644a473284d944) constructor = function(_super) {
            $bc26ee8cec700381$var$__extends(class_1, _super);
            function class_1() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(class_1.prototype, "db", {
                get: function get() {
                    return db;
                },
                enumerable: false,
                configurable: true
            });
            class_1.prototype.table = function() {
                return tableName;
            };
            return class_1;
        }(constructor);
        var inheritedProps = new Set();
        for(var proto = constructor.prototype; proto; proto = $bc26ee8cec700381$var$getProto(proto))Object.getOwnPropertyNames(proto).forEach(function(propName) {
            return inheritedProps.add(propName);
        });
        var readHook = function readHook(obj) {
            if (!obj) return obj;
            var res = Object.create(constructor.prototype);
            for(var m in obj)if (!inheritedProps.has(m)) try {
                res[m] = obj[m];
            } catch (_) {}
            return res;
        };
        if (this.schema.readHook) this.hook.reading.unsubscribe(this.schema.readHook);
        this.schema.readHook = readHook;
        this.hook("reading", readHook);
        return constructor;
    };
    Table.prototype.defineClass = function() {
        function Class(content) {
            $bc26ee8cec700381$var$extend(this, content);
        }
        return this.mapToClass(Class);
    };
    Table.prototype.add = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = $bc26ee8cec700381$var$workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'add',
                keys: key != null ? [
                    key
                ] : null,
                values: [
                    objToAdd
                ]
            });
        }).then(function(res) {
            return res.numFailures ? $bc26ee8cec700381$var$DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                $bc26ee8cec700381$var$setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.upsert = function(key, modifications) {
        var _this = this;
        var keyPath = this.schema.primKey.keyPath;
        return this._trans('readwrite', function(trans) {
            return _this.core.get({
                trans: trans,
                key: key
            }).then(function(existing) {
                var obj = existing !== null && existing !== void 0 ? existing : {};
                $bc26ee8cec700381$var$applyUpdateSpec(obj, modifications);
                if (keyPath) $bc26ee8cec700381$var$setByKeyPath(obj, keyPath, key);
                return _this.core.mutate({
                    trans: trans,
                    type: 'put',
                    values: [
                        obj
                    ],
                    keys: [
                        key
                    ],
                    upsert: true,
                    updates: {
                        keys: [
                            key
                        ],
                        changeSpecs: [
                            modifications
                        ]
                    }
                }).then(function(res) {
                    return res.numFailures ? $bc26ee8cec700381$var$DexiePromise.reject(res.failures[0]) : !!existing;
                });
            });
        });
    };
    Table.prototype.update = function(keyOrObject, modifications) {
        if ((typeof keyOrObject === "undefined" ? "undefined" : (0, $2bfPH._)(keyOrObject)) === 'object' && !$bc26ee8cec700381$var$isArray(keyOrObject)) {
            var key = $bc26ee8cec700381$var$getByKeyPath(keyOrObject, this.schema.primKey.keyPath);
            if (key === undefined) return $bc26ee8cec700381$var$rejection(new $bc26ee8cec700381$var$exceptions.InvalidArgument("Given object does not contain its primary key"));
            return this.where(":id").equals(key).modify(modifications);
        } else return this.where(":id").equals(keyOrObject).modify(modifications);
    };
    Table.prototype.put = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = $bc26ee8cec700381$var$workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'put',
                values: [
                    objToAdd
                ],
                keys: key != null ? [
                    key
                ] : null
            });
        }).then(function(res) {
            return res.numFailures ? $bc26ee8cec700381$var$DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                $bc26ee8cec700381$var$setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.delete = function(key) {
        var _this = this;
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'delete',
                keys: [
                    key
                ]
            }).then(function(res) {
                return $bc26ee8cec700381$var$builtInDeletionTrigger(_this, [
                    key
                ], res);
            }).then(function(res) {
                return res.numFailures ? $bc26ee8cec700381$var$DexiePromise.reject(res.failures[0]) : undefined;
            });
        });
    };
    Table.prototype.clear = function() {
        var _this = this;
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'deleteRange',
                range: $bc26ee8cec700381$var$AnyRange
            }).then(function(res) {
                return $bc26ee8cec700381$var$builtInDeletionTrigger(_this, null, res);
            });
        }).then(function(res) {
            return res.numFailures ? $bc26ee8cec700381$var$DexiePromise.reject(res.failures[0]) : undefined;
        });
    };
    Table.prototype.bulkGet = function(keys) {
        var _this = this;
        return this._trans('readonly', function(trans) {
            return _this.core.getMany({
                keys: keys,
                trans: trans
            }).then(function(result) {
                return result.map(function(res) {
                    return _this.hook.reading.fire(res);
                });
            });
        });
    };
    Table.prototype.bulkAdd = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans('readwrite', function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new $bc26ee8cec700381$var$exceptions.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new $bc26ee8cec700381$var$exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToAdd = keyPath && auto ? objects.map($bc26ee8cec700381$var$workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: 'add',
                keys: keys,
                values: objectsToAdd,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new $bc26ee8cec700381$var$BulkError("".concat(_this.name, ".bulkAdd(): ").concat(numFailures, " of ").concat(numObjects, " operations failed"), failures);
            });
        });
    };
    Table.prototype.bulkPut = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans('readwrite', function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new $bc26ee8cec700381$var$exceptions.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new $bc26ee8cec700381$var$exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToPut = keyPath && auto ? objects.map($bc26ee8cec700381$var$workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: 'put',
                keys: keys,
                values: objectsToPut,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new $bc26ee8cec700381$var$BulkError("".concat(_this.name, ".bulkPut(): ").concat(numFailures, " of ").concat(numObjects, " operations failed"), failures);
            });
        });
    };
    Table.prototype.bulkUpdate = function(keysAndChanges) {
        var _this = this;
        var coreTable = this.core;
        var keys = keysAndChanges.map(function(entry) {
            return entry.key;
        });
        var changeSpecs = keysAndChanges.map(function(entry) {
            return entry.changes;
        });
        var offsetMap = [];
        return this._trans('readwrite', function(trans) {
            return coreTable.getMany({
                trans: trans,
                keys: keys,
                cache: 'clone'
            }).then(function(objs) {
                var resultKeys = [];
                var resultObjs = [];
                keysAndChanges.forEach(function(_a, idx) {
                    var key = _a.key, changes = _a.changes;
                    var obj = objs[idx];
                    if (obj) {
                        for(var _i = 0, _b = Object.keys(changes); _i < _b.length; _i++){
                            var keyPath = _b[_i];
                            var value = changes[keyPath];
                            if (keyPath === _this.schema.primKey.keyPath) {
                                if ($bc26ee8cec700381$export$6154dcdb7d23e37b(value, key) !== 0) throw new $bc26ee8cec700381$var$exceptions.Constraint("Cannot update primary key in bulkUpdate()");
                            } else $bc26ee8cec700381$var$setByKeyPath(obj, keyPath, value);
                        }
                        offsetMap.push(idx);
                        resultKeys.push(key);
                        resultObjs.push(obj);
                    }
                });
                var numEntries = resultKeys.length;
                return coreTable.mutate({
                    trans: trans,
                    type: 'put',
                    keys: resultKeys,
                    values: resultObjs,
                    updates: {
                        keys: keys,
                        changeSpecs: changeSpecs
                    }
                }).then(function(_a) {
                    var numFailures = _a.numFailures, failures = _a.failures;
                    if (numFailures === 0) return numEntries;
                    for(var _i = 0, _b = Object.keys(failures); _i < _b.length; _i++){
                        var offset = _b[_i];
                        var mappedOffset = offsetMap[Number(offset)];
                        if (mappedOffset != null) {
                            var failure = failures[offset];
                            delete failures[offset];
                            failures[mappedOffset] = failure;
                        }
                    }
                    throw new $bc26ee8cec700381$var$BulkError("".concat(_this.name, ".bulkUpdate(): ").concat(numFailures, " of ").concat(numEntries, " operations failed"), failures);
                });
            });
        });
    };
    Table.prototype.bulkDelete = function(keys) {
        var _this = this;
        var numKeys = keys.length;
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'delete',
                keys: keys
            }).then(function(res) {
                return $bc26ee8cec700381$var$builtInDeletionTrigger(_this, keys, res);
            });
        }).then(function(_a) {
            var numFailures = _a.numFailures, lastResult = _a.lastResult, failures = _a.failures;
            if (numFailures === 0) return lastResult;
            throw new $bc26ee8cec700381$var$BulkError("".concat(_this.name, ".bulkDelete(): ").concat(numFailures, " of ").concat(numKeys, " operations failed"), failures);
        });
    };
    return Table;
}();
function $bc26ee8cec700381$var$Events(ctx) {
    var evs = {};
    var rv = function rv(eventName, subscriber) {
        if (subscriber) {
            var i = arguments.length, args = new Array(i - 1);
            while(--i)args[i - 1] = arguments[i];
            evs[eventName].subscribe.apply(null, args);
            return ctx;
        } else if (typeof eventName === 'string') return evs[eventName];
    };
    rv.addEventType = add;
    for(var i = 1, l = arguments.length; i < l; ++i)add(arguments[i]);
    return rv;
    function add(eventName, chainFunction, defaultFunction) {
        if ((typeof eventName === "undefined" ? "undefined" : (0, $2bfPH._)(eventName)) === 'object') return addConfiguredEvents(eventName);
        if (!chainFunction) chainFunction = $bc26ee8cec700381$var$reverseStoppableEventChain;
        if (!defaultFunction) defaultFunction = $bc26ee8cec700381$var$nop;
        var context = {
            subscribers: [],
            fire: defaultFunction,
            subscribe: function subscribe(cb) {
                if (context.subscribers.indexOf(cb) === -1) {
                    context.subscribers.push(cb);
                    context.fire = chainFunction(context.fire, cb);
                }
            },
            unsubscribe: function unsubscribe(cb) {
                context.subscribers = context.subscribers.filter(function(fn) {
                    return fn !== cb;
                });
                context.fire = context.subscribers.reduce(chainFunction, defaultFunction);
            }
        };
        evs[eventName] = rv[eventName] = context;
        return context;
    }
    function addConfiguredEvents(cfg) {
        $bc26ee8cec700381$var$keys(cfg).forEach(function(eventName) {
            var args = cfg[eventName];
            if ($bc26ee8cec700381$var$isArray(args)) add(eventName, cfg[eventName][0], cfg[eventName][1]);
            else if (args === 'asap') var context = add(eventName, $bc26ee8cec700381$var$mirror, function fire() {
                var i = arguments.length, args = new Array(i);
                while(i--)args[i] = arguments[i];
                context.subscribers.forEach(function(fn) {
                    $bc26ee8cec700381$var$asap$1(function fireEvent() {
                        fn.apply(null, args);
                    });
                });
            });
            else throw new $bc26ee8cec700381$var$exceptions.InvalidArgument("Invalid event config");
        });
    }
}
function $bc26ee8cec700381$var$makeClassConstructor(prototype, constructor) {
    $bc26ee8cec700381$var$derive(constructor).from({
        prototype: prototype
    });
    return constructor;
}
function $bc26ee8cec700381$var$createTableConstructor(db) {
    return $bc26ee8cec700381$var$makeClassConstructor($bc26ee8cec700381$var$Table.prototype, function Table(name, tableSchema, trans) {
        this.db = db;
        this._tx = trans;
        this.name = name;
        this.schema = tableSchema;
        this.hook = db._allTables[name] ? db._allTables[name].hook : $bc26ee8cec700381$var$Events(null, {
            "creating": [
                $bc26ee8cec700381$var$hookCreatingChain,
                $bc26ee8cec700381$var$nop
            ],
            "reading": [
                $bc26ee8cec700381$var$pureFunctionChain,
                $bc26ee8cec700381$var$mirror
            ],
            "updating": [
                $bc26ee8cec700381$var$hookUpdatingChain,
                $bc26ee8cec700381$var$nop
            ],
            "deleting": [
                $bc26ee8cec700381$var$hookDeletingChain,
                $bc26ee8cec700381$var$nop
            ]
        });
    });
}
function $bc26ee8cec700381$var$isPlainKeyRange(ctx, ignoreLimitFilter) {
    return !(ctx.filter || ctx.algorithm || ctx.or) && (ignoreLimitFilter ? ctx.justLimit : !ctx.replayFilter);
}
function $bc26ee8cec700381$var$addFilter(ctx, fn) {
    ctx.filter = $bc26ee8cec700381$var$combine(ctx.filter, fn);
}
function $bc26ee8cec700381$var$addReplayFilter(ctx, factory, isLimitFilter) {
    var curr = ctx.replayFilter;
    ctx.replayFilter = curr ? function() {
        return $bc26ee8cec700381$var$combine(curr(), factory());
    } : factory;
    ctx.justLimit = isLimitFilter && !curr;
}
function $bc26ee8cec700381$var$addMatchFilter(ctx, fn) {
    ctx.isMatch = $bc26ee8cec700381$var$combine(ctx.isMatch, fn);
}
function $bc26ee8cec700381$var$getIndexOrStore(ctx, coreSchema) {
    if (ctx.isPrimKey) return coreSchema.primaryKey;
    var index = coreSchema.getIndexByKeyPath(ctx.index);
    if (!index) throw new $bc26ee8cec700381$var$exceptions.Schema("KeyPath " + ctx.index + " on object store " + coreSchema.name + " is not indexed");
    return index;
}
function $bc26ee8cec700381$var$openCursor(ctx, coreTable, trans) {
    var index = $bc26ee8cec700381$var$getIndexOrStore(ctx, coreTable.schema);
    return coreTable.openCursor({
        trans: trans,
        values: !ctx.keysOnly,
        reverse: ctx.dir === 'prev',
        unique: !!ctx.unique,
        query: {
            index: index,
            range: ctx.range
        }
    });
}
function $bc26ee8cec700381$var$iter(ctx, fn, coreTrans, coreTable) {
    var filter = ctx.replayFilter ? $bc26ee8cec700381$var$combine(ctx.filter, ctx.replayFilter()) : ctx.filter;
    if (!ctx.or) return $bc26ee8cec700381$var$iterate($bc26ee8cec700381$var$openCursor(ctx, coreTable, coreTrans), $bc26ee8cec700381$var$combine(ctx.algorithm, filter), fn, !ctx.keysOnly && ctx.valueMapper);
    else {
        var set_1 = {};
        var union = function union(item, cursor, advance) {
            if (!filter || filter(cursor, advance, function(result) {
                return cursor.stop(result);
            }, function(err) {
                return cursor.fail(err);
            })) {
                var primaryKey = cursor.primaryKey;
                var key = '' + primaryKey;
                if (key === '[object ArrayBuffer]') key = '' + new Uint8Array(primaryKey);
                if (!$bc26ee8cec700381$var$hasOwn(set_1, key)) {
                    set_1[key] = true;
                    fn(item, cursor, advance);
                }
            }
        };
        return Promise.all([
            ctx.or._iterate(union, coreTrans),
            $bc26ee8cec700381$var$iterate($bc26ee8cec700381$var$openCursor(ctx, coreTable, coreTrans), ctx.algorithm, union, !ctx.keysOnly && ctx.valueMapper)
        ]);
    }
}
function $bc26ee8cec700381$var$iterate(cursorPromise, filter, fn, valueMapper) {
    var mappedFn = valueMapper ? function mappedFn(x, c, a) {
        return fn(valueMapper(x), c, a);
    } : fn;
    var wrappedFn = $bc26ee8cec700381$var$wrap(mappedFn);
    return cursorPromise.then(function(cursor) {
        if (cursor) return cursor.start(function() {
            var c = function c() {
                return cursor.continue();
            };
            if (!filter || filter(cursor, function(advancer) {
                return c = advancer;
            }, function(val) {
                cursor.stop(val);
                c = $bc26ee8cec700381$var$nop;
            }, function(e) {
                cursor.fail(e);
                c = $bc26ee8cec700381$var$nop;
            })) wrappedFn(cursor.value, cursor, function(advancer) {
                return c = advancer;
            });
            c();
        });
    });
}
var $bc26ee8cec700381$var$Collection = function() {
    function Collection() {}
    Collection.prototype._read = function(fn, cb) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, $bc26ee8cec700381$var$rejection.bind(null, ctx.error)) : ctx.table._trans('readonly', fn).then(cb);
    };
    Collection.prototype._write = function(fn) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, $bc26ee8cec700381$var$rejection.bind(null, ctx.error)) : ctx.table._trans('readwrite', fn, "locked");
    };
    Collection.prototype._addAlgorithm = function(fn) {
        var ctx = this._ctx;
        ctx.algorithm = $bc26ee8cec700381$var$combine(ctx.algorithm, fn);
    };
    Collection.prototype._iterate = function(fn, coreTrans) {
        return $bc26ee8cec700381$var$iter(this._ctx, fn, coreTrans, this._ctx.table.core);
    };
    Collection.prototype.clone = function(props) {
        var rv = Object.create(this.constructor.prototype), ctx = Object.create(this._ctx);
        if (props) $bc26ee8cec700381$var$extend(ctx, props);
        rv._ctx = ctx;
        return rv;
    };
    Collection.prototype.raw = function() {
        this._ctx.valueMapper = null;
        return this;
    };
    Collection.prototype.each = function(fn) {
        var ctx = this._ctx;
        return this._read(function(trans) {
            return $bc26ee8cec700381$var$iter(ctx, fn, trans, ctx.table.core);
        });
    };
    Collection.prototype.count = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            var coreTable = ctx.table.core;
            if ($bc26ee8cec700381$var$isPlainKeyRange(ctx, true)) return coreTable.count({
                trans: trans,
                query: {
                    index: $bc26ee8cec700381$var$getIndexOrStore(ctx, coreTable.schema),
                    range: ctx.range
                }
            }).then(function(count) {
                return Math.min(count, ctx.limit);
            });
            else {
                var count = 0;
                return $bc26ee8cec700381$var$iter(ctx, function() {
                    ++count;
                    return false;
                }, trans, coreTable).then(function() {
                    return count;
                });
            }
        }).then(cb);
    };
    Collection.prototype.sortBy = function(keyPath, cb) {
        var parts = keyPath.split('.').reverse(), lastPart = parts[0], lastIndex = parts.length - 1;
        function getval(obj, i) {
            if (i) return getval(obj[parts[i]], i - 1);
            return obj[lastPart];
        }
        var order = this._ctx.dir === "next" ? 1 : -1;
        function sorter(a, b) {
            var aVal = getval(a, lastIndex), bVal = getval(b, lastIndex);
            return $bc26ee8cec700381$export$6154dcdb7d23e37b(aVal, bVal) * order;
        }
        return this.toArray(function(a) {
            return a.sort(sorter);
        }).then(cb);
    };
    Collection.prototype.toArray = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            if (ctx.dir === 'next' && $bc26ee8cec700381$var$isPlainKeyRange(ctx, true) && ctx.limit > 0) {
                var valueMapper_1 = ctx.valueMapper;
                var index = $bc26ee8cec700381$var$getIndexOrStore(ctx, ctx.table.core.schema);
                return ctx.table.core.query({
                    trans: trans,
                    limit: ctx.limit,
                    values: true,
                    query: {
                        index: index,
                        range: ctx.range
                    }
                }).then(function(_a) {
                    var result = _a.result;
                    return valueMapper_1 ? result.map(valueMapper_1) : result;
                });
            } else {
                var a_1 = [];
                return $bc26ee8cec700381$var$iter(ctx, function(item) {
                    return a_1.push(item);
                }, trans, ctx.table.core).then(function() {
                    return a_1;
                });
            }
        }, cb);
    };
    Collection.prototype.offset = function(offset) {
        var ctx = this._ctx;
        if (offset <= 0) return this;
        ctx.offset += offset;
        if ($bc26ee8cec700381$var$isPlainKeyRange(ctx)) $bc26ee8cec700381$var$addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function(cursor, advance) {
                if (offsetLeft === 0) return true;
                if (offsetLeft === 1) {
                    --offsetLeft;
                    return false;
                }
                advance(function() {
                    cursor.advance(offsetLeft);
                    offsetLeft = 0;
                });
                return false;
            };
        });
        else $bc26ee8cec700381$var$addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function() {
                return --offsetLeft < 0;
            };
        });
        return this;
    };
    Collection.prototype.limit = function(numRows) {
        this._ctx.limit = Math.min(this._ctx.limit, numRows);
        $bc26ee8cec700381$var$addReplayFilter(this._ctx, function() {
            var rowsLeft = numRows;
            return function(cursor, advance, resolve) {
                if (--rowsLeft <= 0) advance(resolve);
                return rowsLeft >= 0;
            };
        }, true);
        return this;
    };
    Collection.prototype.until = function(filterFunction, bIncludeStopEntry) {
        $bc26ee8cec700381$var$addFilter(this._ctx, function(cursor, advance, resolve) {
            if (filterFunction(cursor.value)) {
                advance(resolve);
                return bIncludeStopEntry;
            } else return true;
        });
        return this;
    };
    Collection.prototype.first = function(cb) {
        return this.limit(1).toArray(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.last = function(cb) {
        return this.reverse().first(cb);
    };
    Collection.prototype.filter = function(filterFunction) {
        $bc26ee8cec700381$var$addFilter(this._ctx, function(cursor) {
            return filterFunction(cursor.value);
        });
        $bc26ee8cec700381$var$addMatchFilter(this._ctx, filterFunction);
        return this;
    };
    Collection.prototype.and = function(filter) {
        return this.filter(filter);
    };
    Collection.prototype.or = function(indexName) {
        return new this.db.WhereClause(this._ctx.table, indexName, this);
    };
    Collection.prototype.reverse = function() {
        this._ctx.dir = this._ctx.dir === "prev" ? "next" : "prev";
        if (this._ondirectionchange) this._ondirectionchange(this._ctx.dir);
        return this;
    };
    Collection.prototype.desc = function() {
        return this.reverse();
    };
    Collection.prototype.eachKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.key, cursor);
        });
    };
    Collection.prototype.eachUniqueKey = function(cb) {
        this._ctx.unique = "unique";
        return this.eachKey(cb);
    };
    Collection.prototype.eachPrimaryKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.primaryKey, cursor);
        });
    };
    Collection.prototype.keys = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.key);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.primaryKeys = function(cb) {
        var ctx = this._ctx;
        if (ctx.dir === 'next' && $bc26ee8cec700381$var$isPlainKeyRange(ctx, true) && ctx.limit > 0) return this._read(function(trans) {
            var index = $bc26ee8cec700381$var$getIndexOrStore(ctx, ctx.table.core.schema);
            return ctx.table.core.query({
                trans: trans,
                values: false,
                limit: ctx.limit,
                query: {
                    index: index,
                    range: ctx.range
                }
            });
        }).then(function(_a) {
            var result = _a.result;
            return result;
        }).then(cb);
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.primaryKey);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.uniqueKeys = function(cb) {
        this._ctx.unique = "unique";
        return this.keys(cb);
    };
    Collection.prototype.firstKey = function(cb) {
        return this.limit(1).keys(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.lastKey = function(cb) {
        return this.reverse().firstKey(cb);
    };
    Collection.prototype.distinct = function() {
        var ctx = this._ctx, idx = ctx.index && ctx.table.schema.idxByName[ctx.index];
        if (!idx || !idx.multi) return this;
        var set = {};
        $bc26ee8cec700381$var$addFilter(this._ctx, function(cursor) {
            var strKey = cursor.primaryKey.toString();
            var found = $bc26ee8cec700381$var$hasOwn(set, strKey);
            set[strKey] = true;
            return !found;
        });
        return this;
    };
    Collection.prototype.modify = function(changes) {
        var _this = this;
        var ctx = this._ctx;
        return this._write(function(trans) {
            var modifyer;
            if (typeof changes === 'function') modifyer = changes;
            else modifyer = function modifyer(item) {
                return $bc26ee8cec700381$var$applyUpdateSpec(item, changes);
            };
            var coreTable = ctx.table.core;
            var _a = coreTable.schema.primaryKey, outbound = _a.outbound, extractKey = _a.extractKey;
            var limit = 200;
            var modifyChunkSize = _this.db._options.modifyChunkSize;
            if (modifyChunkSize) {
                if ((typeof modifyChunkSize === "undefined" ? "undefined" : (0, $2bfPH._)(modifyChunkSize)) == 'object') limit = modifyChunkSize[coreTable.name] || modifyChunkSize['*'] || 200;
                else limit = modifyChunkSize;
            }
            var totalFailures = [];
            var successCount = 0;
            var failedKeys = [];
            var applyMutateResult = function applyMutateResult(expectedCount, res) {
                var failures = res.failures, numFailures = res.numFailures;
                successCount += expectedCount - numFailures;
                for(var _i = 0, _a = $bc26ee8cec700381$var$keys(failures); _i < _a.length; _i++){
                    var pos = _a[_i];
                    totalFailures.push(failures[pos]);
                }
            };
            var isUnconditionalDelete = changes === $bc26ee8cec700381$var$deleteCallback;
            return _this.clone().primaryKeys().then(function(keys) {
                var criteria = $bc26ee8cec700381$var$isPlainKeyRange(ctx) && ctx.limit === Infinity && (typeof changes !== 'function' || isUnconditionalDelete) && {
                    index: ctx.index,
                    range: ctx.range
                };
                var nextChunk = function nextChunk1(offset) {
                    var count = Math.min(limit, keys.length - offset);
                    var keysInChunk = keys.slice(offset, offset + count);
                    return (isUnconditionalDelete ? Promise.resolve([]) : coreTable.getMany({
                        trans: trans,
                        keys: keysInChunk,
                        cache: "immutable"
                    })).then(function(values) {
                        var addValues = [];
                        var putValues = [];
                        var putKeys = outbound ? [] : null;
                        var deleteKeys = isUnconditionalDelete ? keysInChunk : [];
                        if (!isUnconditionalDelete) for(var i = 0; i < count; ++i){
                            var origValue = values[i];
                            var ctx_1 = {
                                value: $bc26ee8cec700381$var$deepClone(origValue),
                                primKey: keys[offset + i]
                            };
                            if (modifyer.call(ctx_1, ctx_1.value, ctx_1) !== false) {
                                if (ctx_1.value == null) deleteKeys.push(keys[offset + i]);
                                else if (!outbound && $bc26ee8cec700381$export$6154dcdb7d23e37b(extractKey(origValue), extractKey(ctx_1.value)) !== 0) {
                                    deleteKeys.push(keys[offset + i]);
                                    addValues.push(ctx_1.value);
                                } else {
                                    putValues.push(ctx_1.value);
                                    if (outbound) putKeys.push(keys[offset + i]);
                                }
                            }
                        }
                        return Promise.resolve(addValues.length > 0 && coreTable.mutate({
                            trans: trans,
                            type: 'add',
                            values: addValues
                        }).then(function(res) {
                            for(var pos in res.failures)deleteKeys.splice(parseInt(pos), 1);
                            applyMutateResult(addValues.length, res);
                        })).then(function() {
                            return (putValues.length > 0 || criteria && (typeof changes === "undefined" ? "undefined" : (0, $2bfPH._)(changes)) === 'object') && coreTable.mutate({
                                trans: trans,
                                type: 'put',
                                keys: putKeys,
                                values: putValues,
                                criteria: criteria,
                                changeSpec: typeof changes !== 'function' && changes,
                                isAdditionalChunk: offset > 0
                            }).then(function(res) {
                                return applyMutateResult(putValues.length, res);
                            });
                        }).then(function() {
                            return (deleteKeys.length > 0 || criteria && isUnconditionalDelete) && coreTable.mutate({
                                trans: trans,
                                type: 'delete',
                                keys: deleteKeys,
                                criteria: criteria,
                                isAdditionalChunk: offset > 0
                            }).then(function(res) {
                                return $bc26ee8cec700381$var$builtInDeletionTrigger(ctx.table, deleteKeys, res);
                            }).then(function(res) {
                                return applyMutateResult(deleteKeys.length, res);
                            });
                        }).then(function() {
                            return keys.length > offset + count && nextChunk(offset + limit);
                        });
                    });
                };
                return nextChunk(0).then(function() {
                    if (totalFailures.length > 0) throw new $bc26ee8cec700381$var$ModifyError("Error modifying one or more objects", totalFailures, successCount, failedKeys);
                    return keys.length;
                });
            });
        });
    };
    Collection.prototype.delete = function() {
        var ctx = this._ctx, range = ctx.range;
        if ($bc26ee8cec700381$var$isPlainKeyRange(ctx) && !ctx.table.schema.yProps && (ctx.isPrimKey || range.type === 3)) return this._write(function(trans) {
            var primaryKey = ctx.table.core.schema.primaryKey;
            var coreRange = range;
            return ctx.table.core.count({
                trans: trans,
                query: {
                    index: primaryKey,
                    range: coreRange
                }
            }).then(function(count) {
                return ctx.table.core.mutate({
                    trans: trans,
                    type: 'deleteRange',
                    range: coreRange
                }).then(function(_a) {
                    var failures = _a.failures, numFailures = _a.numFailures;
                    if (numFailures) throw new $bc26ee8cec700381$var$ModifyError("Could not delete some values", Object.keys(failures).map(function(pos) {
                        return failures[pos];
                    }), count - numFailures);
                    return count - numFailures;
                });
            });
        });
        return this.modify($bc26ee8cec700381$var$deleteCallback);
    };
    return Collection;
}();
var $bc26ee8cec700381$var$deleteCallback = function deleteCallback(value, ctx) {
    return ctx.value = null;
};
function $bc26ee8cec700381$var$createCollectionConstructor(db) {
    return $bc26ee8cec700381$var$makeClassConstructor($bc26ee8cec700381$var$Collection.prototype, function Collection(whereClause, keyRangeGenerator) {
        this.db = db;
        var keyRange = $bc26ee8cec700381$var$AnyRange, error = null;
        if (keyRangeGenerator) try {
            keyRange = keyRangeGenerator();
        } catch (ex) {
            error = ex;
        }
        var whereCtx = whereClause._ctx;
        var table = whereCtx.table;
        var readingHook = table.hook.reading.fire;
        this._ctx = {
            table: table,
            index: whereCtx.index,
            isPrimKey: !whereCtx.index || table.schema.primKey.keyPath && whereCtx.index === table.schema.primKey.name,
            range: keyRange,
            keysOnly: false,
            dir: "next",
            unique: "",
            algorithm: null,
            filter: null,
            replayFilter: null,
            justLimit: true,
            isMatch: null,
            offset: 0,
            limit: Infinity,
            error: error,
            or: whereCtx.or,
            valueMapper: readingHook !== $bc26ee8cec700381$var$mirror ? readingHook : null
        };
    });
}
function $bc26ee8cec700381$var$simpleCompare(a, b) {
    return a < b ? -1 : a === b ? 0 : 1;
}
function $bc26ee8cec700381$var$simpleCompareReverse(a, b) {
    return a > b ? -1 : a === b ? 0 : 1;
}
function $bc26ee8cec700381$var$fail(collectionOrWhereClause, err, T) {
    var collection = collectionOrWhereClause instanceof $bc26ee8cec700381$var$WhereClause ? new collectionOrWhereClause.Collection(collectionOrWhereClause) : collectionOrWhereClause;
    collection._ctx.error = T ? new T(err) : new TypeError(err);
    return collection;
}
function $bc26ee8cec700381$var$emptyCollection(whereClause) {
    return new whereClause.Collection(whereClause, function() {
        return $bc26ee8cec700381$var$rangeEqual("");
    }).limit(0);
}
function $bc26ee8cec700381$var$upperFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toUpperCase();
    } : function(s) {
        return s.toLowerCase();
    };
}
function $bc26ee8cec700381$var$lowerFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toLowerCase();
    } : function(s) {
        return s.toUpperCase();
    };
}
function $bc26ee8cec700381$var$nextCasing(key, lowerKey, upperNeedle, lowerNeedle, cmp, dir) {
    var length = Math.min(key.length, lowerNeedle.length);
    var llp = -1;
    for(var i = 0; i < length; ++i){
        var lwrKeyChar = lowerKey[i];
        if (lwrKeyChar !== lowerNeedle[i]) {
            if (cmp(key[i], upperNeedle[i]) < 0) return key.substr(0, i) + upperNeedle[i] + upperNeedle.substr(i + 1);
            if (cmp(key[i], lowerNeedle[i]) < 0) return key.substr(0, i) + lowerNeedle[i] + upperNeedle.substr(i + 1);
            if (llp >= 0) return key.substr(0, llp) + lowerKey[llp] + upperNeedle.substr(llp + 1);
            return null;
        }
        if (cmp(key[i], lwrKeyChar) < 0) llp = i;
    }
    if (length < lowerNeedle.length && dir === "next") return key + upperNeedle.substr(key.length);
    if (length < key.length && dir === "prev") return key.substr(0, upperNeedle.length);
    return llp < 0 ? null : key.substr(0, llp) + lowerNeedle[llp] + upperNeedle.substr(llp + 1);
}
function $bc26ee8cec700381$var$addIgnoreCaseAlgorithm(whereClause, match, needles, suffix) {
    var upper, lower, compare, upperNeedles, lowerNeedles, direction, nextKeySuffix, needlesLen = needles.length;
    if (!needles.every(function(s) {
        return typeof s === 'string';
    })) return $bc26ee8cec700381$var$fail(whereClause, $bc26ee8cec700381$var$STRING_EXPECTED);
    function initDirection(dir) {
        upper = $bc26ee8cec700381$var$upperFactory(dir);
        lower = $bc26ee8cec700381$var$lowerFactory(dir);
        compare = dir === "next" ? $bc26ee8cec700381$var$simpleCompare : $bc26ee8cec700381$var$simpleCompareReverse;
        var needleBounds = needles.map(function(needle) {
            return {
                lower: lower(needle),
                upper: upper(needle)
            };
        }).sort(function(a, b) {
            return compare(a.lower, b.lower);
        });
        upperNeedles = needleBounds.map(function(nb) {
            return nb.upper;
        });
        lowerNeedles = needleBounds.map(function(nb) {
            return nb.lower;
        });
        direction = dir;
        nextKeySuffix = dir === "next" ? "" : suffix;
    }
    initDirection("next");
    var c = new whereClause.Collection(whereClause, function() {
        return $bc26ee8cec700381$var$createRange(upperNeedles[0], lowerNeedles[needlesLen - 1] + suffix);
    });
    c._ondirectionchange = function(direction) {
        initDirection(direction);
    };
    var firstPossibleNeedle = 0;
    c._addAlgorithm(function(cursor, advance, resolve) {
        var key = cursor.key;
        if (typeof key !== 'string') return false;
        var lowerKey = lower(key);
        if (match(lowerKey, lowerNeedles, firstPossibleNeedle)) return true;
        else {
            var lowestPossibleCasing = null;
            for(var i = firstPossibleNeedle; i < needlesLen; ++i){
                var casing = $bc26ee8cec700381$var$nextCasing(key, lowerKey, upperNeedles[i], lowerNeedles[i], compare, direction);
                if (casing === null && lowestPossibleCasing === null) firstPossibleNeedle = i + 1;
                else if (lowestPossibleCasing === null || compare(lowestPossibleCasing, casing) > 0) lowestPossibleCasing = casing;
            }
            if (lowestPossibleCasing !== null) advance(function() {
                cursor.continue(lowestPossibleCasing + nextKeySuffix);
            });
            else advance(resolve);
            return false;
        }
    });
    return c;
}
function $bc26ee8cec700381$var$createRange(lower, upper, lowerOpen, upperOpen) {
    return {
        type: 2,
        lower: lower,
        upper: upper,
        lowerOpen: lowerOpen,
        upperOpen: upperOpen
    };
}
function $bc26ee8cec700381$var$rangeEqual(value) {
    return {
        type: 1,
        lower: value,
        upper: value
    };
}
var $bc26ee8cec700381$var$WhereClause = function() {
    function WhereClause() {}
    Object.defineProperty(WhereClause.prototype, "Collection", {
        get: function get() {
            return this._ctx.table.db.Collection;
        },
        enumerable: false,
        configurable: true
    });
    WhereClause.prototype.between = function(lower, upper, includeLower, includeUpper) {
        includeLower = includeLower !== false;
        includeUpper = includeUpper === true;
        try {
            if (this._cmp(lower, upper) > 0 || this._cmp(lower, upper) === 0 && (includeLower || includeUpper) && !(includeLower && includeUpper)) return $bc26ee8cec700381$var$emptyCollection(this);
            return new this.Collection(this, function() {
                return $bc26ee8cec700381$var$createRange(lower, upper, !includeLower, !includeUpper);
            });
        } catch (e) {
            return $bc26ee8cec700381$var$fail(this, $bc26ee8cec700381$var$INVALID_KEY_ARGUMENT);
        }
    };
    WhereClause.prototype.equals = function(value) {
        if (value == null) return $bc26ee8cec700381$var$fail(this, $bc26ee8cec700381$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $bc26ee8cec700381$var$rangeEqual(value);
        });
    };
    WhereClause.prototype.above = function(value) {
        if (value == null) return $bc26ee8cec700381$var$fail(this, $bc26ee8cec700381$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $bc26ee8cec700381$var$createRange(value, undefined, true);
        });
    };
    WhereClause.prototype.aboveOrEqual = function(value) {
        if (value == null) return $bc26ee8cec700381$var$fail(this, $bc26ee8cec700381$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $bc26ee8cec700381$var$createRange(value, undefined, false);
        });
    };
    WhereClause.prototype.below = function(value) {
        if (value == null) return $bc26ee8cec700381$var$fail(this, $bc26ee8cec700381$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $bc26ee8cec700381$var$createRange(undefined, value, false, true);
        });
    };
    WhereClause.prototype.belowOrEqual = function(value) {
        if (value == null) return $bc26ee8cec700381$var$fail(this, $bc26ee8cec700381$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $bc26ee8cec700381$var$createRange(undefined, value);
        });
    };
    WhereClause.prototype.startsWith = function(str) {
        if (typeof str !== 'string') return $bc26ee8cec700381$var$fail(this, $bc26ee8cec700381$var$STRING_EXPECTED);
        return this.between(str, str + $bc26ee8cec700381$var$maxString, true, true);
    };
    WhereClause.prototype.startsWithIgnoreCase = function(str) {
        if (str === "") return this.startsWith(str);
        return $bc26ee8cec700381$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return x.indexOf(a[0]) === 0;
        }, [
            str
        ], $bc26ee8cec700381$var$maxString);
    };
    WhereClause.prototype.equalsIgnoreCase = function(str) {
        return $bc26ee8cec700381$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return x === a[0];
        }, [
            str
        ], "");
    };
    WhereClause.prototype.anyOfIgnoreCase = function() {
        var set = $bc26ee8cec700381$var$getArrayOf.apply($bc26ee8cec700381$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return $bc26ee8cec700381$var$emptyCollection(this);
        return $bc26ee8cec700381$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.indexOf(x) !== -1;
        }, set, "");
    };
    WhereClause.prototype.startsWithAnyOfIgnoreCase = function() {
        var set = $bc26ee8cec700381$var$getArrayOf.apply($bc26ee8cec700381$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return $bc26ee8cec700381$var$emptyCollection(this);
        return $bc26ee8cec700381$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.some(function(n) {
                return x.indexOf(n) === 0;
            });
        }, set, $bc26ee8cec700381$var$maxString);
    };
    WhereClause.prototype.anyOf = function() {
        var _this = this;
        var set = $bc26ee8cec700381$var$getArrayOf.apply($bc26ee8cec700381$var$NO_CHAR_ARRAY, arguments);
        var compare = this._cmp;
        try {
            set.sort(compare);
        } catch (e) {
            return $bc26ee8cec700381$var$fail(this, $bc26ee8cec700381$var$INVALID_KEY_ARGUMENT);
        }
        if (set.length === 0) return $bc26ee8cec700381$var$emptyCollection(this);
        var c = new this.Collection(this, function() {
            return $bc26ee8cec700381$var$createRange(set[0], set[set.length - 1]);
        });
        c._ondirectionchange = function(direction) {
            compare = direction === "next" ? _this._ascending : _this._descending;
            set.sort(compare);
        };
        var i = 0;
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(compare(key, set[i]) > 0){
                ++i;
                if (i === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (compare(key, set[i]) === 0) return true;
            else {
                advance(function() {
                    cursor.continue(set[i]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.notEqual = function(value) {
        return this.inAnyRange([
            [
                $bc26ee8cec700381$var$minKey,
                value
            ],
            [
                value,
                this.db._maxKey
            ]
        ], {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.noneOf = function() {
        var set = $bc26ee8cec700381$var$getArrayOf.apply($bc26ee8cec700381$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return new this.Collection(this);
        try {
            set.sort(this._ascending);
        } catch (e) {
            return $bc26ee8cec700381$var$fail(this, $bc26ee8cec700381$var$INVALID_KEY_ARGUMENT);
        }
        var ranges = set.reduce(function(res, val) {
            return res ? res.concat([
                [
                    res[res.length - 1][1],
                    val
                ]
            ]) : [
                [
                    $bc26ee8cec700381$var$minKey,
                    val
                ]
            ];
        }, null);
        ranges.push([
            set[set.length - 1],
            this.db._maxKey
        ]);
        return this.inAnyRange(ranges, {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.inAnyRange = function(ranges, options) {
        var _this = this;
        var _$cmp = this._cmp, ascending = this._ascending, descending = this._descending, min = this._min, max = this._max;
        if (ranges.length === 0) return $bc26ee8cec700381$var$emptyCollection(this);
        if (!ranges.every(function(range) {
            return range[0] !== undefined && range[1] !== undefined && ascending(range[0], range[1]) <= 0;
        })) return $bc26ee8cec700381$var$fail(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", $bc26ee8cec700381$var$exceptions.InvalidArgument);
        var includeLowers = !options || options.includeLowers !== false;
        var includeUppers = options && options.includeUppers === true;
        function addRange(ranges, newRange) {
            var i = 0, l = ranges.length;
            for(; i < l; ++i){
                var range = ranges[i];
                if (_$cmp(newRange[0], range[1]) < 0 && _$cmp(newRange[1], range[0]) > 0) {
                    range[0] = min(range[0], newRange[0]);
                    range[1] = max(range[1], newRange[1]);
                    break;
                }
            }
            if (i === l) ranges.push(newRange);
            return ranges;
        }
        var sortDirection = ascending;
        function rangeSorter(a, b) {
            return sortDirection(a[0], b[0]);
        }
        var set;
        try {
            set = ranges.reduce(addRange, []);
            set.sort(rangeSorter);
        } catch (ex) {
            return $bc26ee8cec700381$var$fail(this, $bc26ee8cec700381$var$INVALID_KEY_ARGUMENT);
        }
        var rangePos = 0;
        var keyIsBeyondCurrentEntry = includeUppers ? function keyIsBeyondCurrentEntry(key) {
            return ascending(key, set[rangePos][1]) > 0;
        } : function(key) {
            return ascending(key, set[rangePos][1]) >= 0;
        };
        var keyIsBeforeCurrentEntry = includeLowers ? function keyIsBeforeCurrentEntry(key) {
            return descending(key, set[rangePos][0]) > 0;
        } : function(key) {
            return descending(key, set[rangePos][0]) >= 0;
        };
        function keyWithinCurrentRange(key) {
            return !keyIsBeyondCurrentEntry(key) && !keyIsBeforeCurrentEntry(key);
        }
        var checkKey = keyIsBeyondCurrentEntry;
        var c = new this.Collection(this, function() {
            return $bc26ee8cec700381$var$createRange(set[0][0], set[set.length - 1][1], !includeLowers, !includeUppers);
        });
        c._ondirectionchange = function(direction) {
            if (direction === "next") {
                checkKey = keyIsBeyondCurrentEntry;
                sortDirection = ascending;
            } else {
                checkKey = keyIsBeforeCurrentEntry;
                sortDirection = descending;
            }
            set.sort(rangeSorter);
        };
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(checkKey(key)){
                ++rangePos;
                if (rangePos === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (keyWithinCurrentRange(key)) return true;
            else if (_this._cmp(key, set[rangePos][1]) === 0 || _this._cmp(key, set[rangePos][0]) === 0) return false;
            else {
                advance(function() {
                    if (sortDirection === ascending) cursor.continue(set[rangePos][0]);
                    else cursor.continue(set[rangePos][1]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.startsWithAnyOf = function() {
        var set = $bc26ee8cec700381$var$getArrayOf.apply($bc26ee8cec700381$var$NO_CHAR_ARRAY, arguments);
        if (!set.every(function(s) {
            return typeof s === 'string';
        })) return $bc26ee8cec700381$var$fail(this, "startsWithAnyOf() only works with strings");
        if (set.length === 0) return $bc26ee8cec700381$var$emptyCollection(this);
        return this.inAnyRange(set.map(function(str) {
            return [
                str,
                str + $bc26ee8cec700381$var$maxString
            ];
        }));
    };
    return WhereClause;
}();
function $bc26ee8cec700381$var$createWhereClauseConstructor(db) {
    return $bc26ee8cec700381$var$makeClassConstructor($bc26ee8cec700381$var$WhereClause.prototype, function WhereClause(table, index, orCollection) {
        this.db = db;
        this._ctx = {
            table: table,
            index: index === ":id" ? null : index,
            or: orCollection
        };
        this._cmp = this._ascending = $bc26ee8cec700381$export$6154dcdb7d23e37b;
        this._descending = function(a, b) {
            return $bc26ee8cec700381$export$6154dcdb7d23e37b(b, a);
        };
        this._max = function(a, b) {
            return $bc26ee8cec700381$export$6154dcdb7d23e37b(a, b) > 0 ? a : b;
        };
        this._min = function(a, b) {
            return $bc26ee8cec700381$export$6154dcdb7d23e37b(a, b) < 0 ? a : b;
        };
        this._IDBKeyRange = db._deps.IDBKeyRange;
        if (!this._IDBKeyRange) throw new $bc26ee8cec700381$var$exceptions.MissingAPI();
    });
}
function $bc26ee8cec700381$var$eventRejectHandler(reject) {
    return $bc26ee8cec700381$var$wrap(function(event) {
        $bc26ee8cec700381$var$preventDefault(event);
        reject(event.target.error);
        return false;
    });
}
function $bc26ee8cec700381$var$preventDefault(event) {
    if (event.stopPropagation) event.stopPropagation();
    if (event.preventDefault) event.preventDefault();
}
var $bc26ee8cec700381$var$DEXIE_STORAGE_MUTATED_EVENT_NAME = 'storagemutated';
var $bc26ee8cec700381$var$STORAGE_MUTATED_DOM_EVENT_NAME = 'x-storagemutated-1';
var $bc26ee8cec700381$var$globalEvents = $bc26ee8cec700381$var$Events(null, $bc26ee8cec700381$var$DEXIE_STORAGE_MUTATED_EVENT_NAME);
var $bc26ee8cec700381$var$Transaction = function() {
    function Transaction() {}
    Transaction.prototype._lock = function() {
        $bc26ee8cec700381$var$assert(!$bc26ee8cec700381$var$PSD.global);
        ++this._reculock;
        if (this._reculock === 1 && !$bc26ee8cec700381$var$PSD.global) $bc26ee8cec700381$var$PSD.lockOwnerFor = this;
        return this;
    };
    Transaction.prototype._unlock = function() {
        $bc26ee8cec700381$var$assert(!$bc26ee8cec700381$var$PSD.global);
        if (--this._reculock === 0) {
            if (!$bc26ee8cec700381$var$PSD.global) $bc26ee8cec700381$var$PSD.lockOwnerFor = null;
            while(this._blockedFuncs.length > 0 && !this._locked()){
                var fnAndPSD = this._blockedFuncs.shift();
                try {
                    $bc26ee8cec700381$var$usePSD(fnAndPSD[1], fnAndPSD[0]);
                } catch (e) {}
            }
        }
        return this;
    };
    Transaction.prototype._locked = function() {
        return this._reculock && $bc26ee8cec700381$var$PSD.lockOwnerFor !== this;
    };
    Transaction.prototype.create = function(idbtrans) {
        var _this = this;
        if (!this.mode) return this;
        var idbdb = this.db.idbdb;
        var dbOpenError = this.db._state.dbOpenError;
        $bc26ee8cec700381$var$assert(!this.idbtrans);
        if (!idbtrans && !idbdb) switch(dbOpenError && dbOpenError.name){
            case "DatabaseClosedError":
                throw new $bc26ee8cec700381$var$exceptions.DatabaseClosed(dbOpenError);
            case "MissingAPIError":
                throw new $bc26ee8cec700381$var$exceptions.MissingAPI(dbOpenError.message, dbOpenError);
            default:
                throw new $bc26ee8cec700381$var$exceptions.OpenFailed(dbOpenError);
        }
        if (!this.active) throw new $bc26ee8cec700381$var$exceptions.TransactionInactive();
        $bc26ee8cec700381$var$assert(this._completion._state === null);
        idbtrans = this.idbtrans = idbtrans || (this.db.core ? this.db.core.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }) : idbdb.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }));
        idbtrans.onerror = $bc26ee8cec700381$var$wrap(function(ev) {
            $bc26ee8cec700381$var$preventDefault(ev);
            _this._reject(idbtrans.error);
        });
        idbtrans.onabort = $bc26ee8cec700381$var$wrap(function(ev) {
            $bc26ee8cec700381$var$preventDefault(ev);
            _this.active && _this._reject(new $bc26ee8cec700381$var$exceptions.Abort(idbtrans.error));
            _this.active = false;
            _this.on("abort").fire(ev);
        });
        idbtrans.oncomplete = $bc26ee8cec700381$var$wrap(function() {
            _this.active = false;
            _this._resolve();
            if ('mutatedParts' in idbtrans) $bc26ee8cec700381$var$globalEvents.storagemutated.fire(idbtrans["mutatedParts"]);
        });
        return this;
    };
    Transaction.prototype._promise = function(mode, fn, bWriteLock) {
        var _this = this;
        if (mode === 'readwrite' && this.mode !== 'readwrite') return $bc26ee8cec700381$var$rejection(new $bc26ee8cec700381$var$exceptions.ReadOnly("Transaction is readonly"));
        if (!this.active) return $bc26ee8cec700381$var$rejection(new $bc26ee8cec700381$var$exceptions.TransactionInactive());
        if (this._locked()) return new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
            _this._blockedFuncs.push([
                function() {
                    _this._promise(mode, fn, bWriteLock).then(resolve, reject);
                },
                $bc26ee8cec700381$var$PSD
            ]);
        });
        else if (bWriteLock) return $bc26ee8cec700381$var$newScope(function() {
            var p = new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
                _this._lock();
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p.finally(function() {
                return _this._unlock();
            });
            p._lib = true;
            return p;
        });
        else {
            var p = new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p._lib = true;
            return p;
        }
    };
    Transaction.prototype._root = function() {
        return this.parent ? this.parent._root() : this;
    };
    Transaction.prototype.waitFor = function(promiseLike) {
        var root = this._root();
        var promise = $bc26ee8cec700381$var$DexiePromise.resolve(promiseLike);
        if (root._waitingFor) root._waitingFor = root._waitingFor.then(function() {
            return promise;
        });
        else {
            root._waitingFor = promise;
            root._waitingQueue = [];
            var store = root.idbtrans.objectStore(root.storeNames[0]);
            (function spin() {
                ++root._spinCount;
                while(root._waitingQueue.length)root._waitingQueue.shift()();
                if (root._waitingFor) store.get(-Infinity).onsuccess = spin;
            })();
        }
        var currentWaitPromise = root._waitingFor;
        return new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
            promise.then(function(res) {
                return root._waitingQueue.push($bc26ee8cec700381$var$wrap(resolve.bind(null, res)));
            }, function(err) {
                return root._waitingQueue.push($bc26ee8cec700381$var$wrap(reject.bind(null, err)));
            }).finally(function() {
                if (root._waitingFor === currentWaitPromise) root._waitingFor = null;
            });
        });
    };
    Transaction.prototype.abort = function() {
        if (this.active) {
            this.active = false;
            if (this.idbtrans) this.idbtrans.abort();
            this._reject(new $bc26ee8cec700381$var$exceptions.Abort());
        }
    };
    Transaction.prototype.table = function(tableName) {
        var memoizedTables = this._memoizedTables || (this._memoizedTables = {});
        if ($bc26ee8cec700381$var$hasOwn(memoizedTables, tableName)) return memoizedTables[tableName];
        var tableSchema = this.schema[tableName];
        if (!tableSchema) throw new $bc26ee8cec700381$var$exceptions.NotFound("Table " + tableName + " not part of transaction");
        var transactionBoundTable = new this.db.Table(tableName, tableSchema, this);
        transactionBoundTable.core = this.db.core.table(tableName);
        memoizedTables[tableName] = transactionBoundTable;
        return transactionBoundTable;
    };
    return Transaction;
}();
function $bc26ee8cec700381$var$createTransactionConstructor(db) {
    return $bc26ee8cec700381$var$makeClassConstructor($bc26ee8cec700381$var$Transaction.prototype, function Transaction(mode, storeNames, dbschema, chromeTransactionDurability, parent) {
        var _this = this;
        if (mode !== 'readonly') storeNames.forEach(function(storeName) {
            var _a;
            var yProps = (_a = dbschema[storeName]) === null || _a === void 0 ? void 0 : _a.yProps;
            if (yProps) storeNames = storeNames.concat(yProps.map(function(p) {
                return p.updatesTable;
            }));
        });
        this.db = db;
        this.mode = mode;
        this.storeNames = storeNames;
        this.schema = dbschema;
        this.chromeTransactionDurability = chromeTransactionDurability;
        this.idbtrans = null;
        this.on = $bc26ee8cec700381$var$Events(this, "complete", "error", "abort");
        this.parent = parent || null;
        this.active = true;
        this._reculock = 0;
        this._blockedFuncs = [];
        this._resolve = null;
        this._reject = null;
        this._waitingFor = null;
        this._waitingQueue = null;
        this._spinCount = 0;
        this._completion = new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
        this._completion.then(function() {
            _this.active = false;
            _this.on.complete.fire();
        }, function(e) {
            var wasActive = _this.active;
            _this.active = false;
            _this.on.error.fire(e);
            _this.parent ? _this.parent._reject(e) : wasActive && _this.idbtrans && _this.idbtrans.abort();
            return $bc26ee8cec700381$var$rejection(e);
        });
    });
}
function $bc26ee8cec700381$var$createIndexSpec(name, keyPath, unique, multi, auto, compound, isPrimKey, type) {
    return {
        name: name,
        keyPath: keyPath,
        unique: unique,
        multi: multi,
        auto: auto,
        compound: compound,
        src: (unique && !isPrimKey ? '&' : '') + (multi ? '*' : '') + (auto ? "++" : "") + $bc26ee8cec700381$var$nameFromKeyPath(keyPath),
        type: type
    };
}
function $bc26ee8cec700381$var$nameFromKeyPath(keyPath) {
    return typeof keyPath === 'string' ? keyPath : keyPath ? '[' + [].join.call(keyPath, '+') + ']' : "";
}
function $bc26ee8cec700381$var$createTableSchema(name, primKey, indexes) {
    return {
        name: name,
        primKey: primKey,
        indexes: indexes,
        mappedClass: null,
        idxByName: $bc26ee8cec700381$var$arrayToObject(indexes, function(index) {
            return [
                index.name,
                index
            ];
        })
    };
}
function $bc26ee8cec700381$var$safariMultiStoreFix(storeNames) {
    return storeNames.length === 1 ? storeNames[0] : storeNames;
}
var $bc26ee8cec700381$var$getMaxKey = function getMaxKey1(IdbKeyRange) {
    try {
        IdbKeyRange.only([
            []
        ]);
        $bc26ee8cec700381$var$getMaxKey = function getMaxKey() {
            return [
                []
            ];
        };
        return [
            []
        ];
    } catch (e) {
        $bc26ee8cec700381$var$getMaxKey = function getMaxKey() {
            return $bc26ee8cec700381$var$maxString;
        };
        return $bc26ee8cec700381$var$maxString;
    }
};
function $bc26ee8cec700381$var$getKeyExtractor(keyPath) {
    if (keyPath == null) return function() {
        return undefined;
    };
    else if (typeof keyPath === 'string') return $bc26ee8cec700381$var$getSinglePathKeyExtractor(keyPath);
    else return function(obj) {
        return $bc26ee8cec700381$var$getByKeyPath(obj, keyPath);
    };
}
function $bc26ee8cec700381$var$getSinglePathKeyExtractor(keyPath) {
    var split = keyPath.split('.');
    if (split.length === 1) return function(obj) {
        return obj[keyPath];
    };
    else return function(obj) {
        return $bc26ee8cec700381$var$getByKeyPath(obj, keyPath);
    };
}
function $bc26ee8cec700381$var$arrayify(arrayLike) {
    return [].slice.call(arrayLike);
}
var $bc26ee8cec700381$var$_id_counter = 0;
function $bc26ee8cec700381$var$getKeyPathAlias(keyPath) {
    return keyPath == null ? ":id" : typeof keyPath === 'string' ? keyPath : "[".concat(keyPath.join('+'), "]");
}
function $bc26ee8cec700381$var$createDBCore(db, IdbKeyRange, tmpTrans) {
    function extractSchema(db, trans) {
        var tables = $bc26ee8cec700381$var$arrayify(db.objectStoreNames);
        return {
            schema: {
                name: db.name,
                tables: tables.map(function(table) {
                    return trans.objectStore(table);
                }).map(function(store) {
                    var keyPath = store.keyPath, autoIncrement = store.autoIncrement;
                    var compound = $bc26ee8cec700381$var$isArray(keyPath);
                    var outbound = keyPath == null;
                    var indexByKeyPath = {};
                    var result = {
                        name: store.name,
                        primaryKey: {
                            name: null,
                            isPrimaryKey: true,
                            outbound: outbound,
                            compound: compound,
                            keyPath: keyPath,
                            autoIncrement: autoIncrement,
                            unique: true,
                            extractKey: $bc26ee8cec700381$var$getKeyExtractor(keyPath)
                        },
                        indexes: $bc26ee8cec700381$var$arrayify(store.indexNames).map(function(indexName) {
                            return store.index(indexName);
                        }).map(function(index) {
                            var name = index.name, unique = index.unique, multiEntry = index.multiEntry, keyPath = index.keyPath;
                            var compound = $bc26ee8cec700381$var$isArray(keyPath);
                            var result = {
                                name: name,
                                compound: compound,
                                keyPath: keyPath,
                                unique: unique,
                                multiEntry: multiEntry,
                                extractKey: $bc26ee8cec700381$var$getKeyExtractor(keyPath)
                            };
                            indexByKeyPath[$bc26ee8cec700381$var$getKeyPathAlias(keyPath)] = result;
                            return result;
                        }),
                        getIndexByKeyPath: function getIndexByKeyPath(keyPath) {
                            return indexByKeyPath[$bc26ee8cec700381$var$getKeyPathAlias(keyPath)];
                        }
                    };
                    indexByKeyPath[":id"] = result.primaryKey;
                    if (keyPath != null) indexByKeyPath[$bc26ee8cec700381$var$getKeyPathAlias(keyPath)] = result.primaryKey;
                    return result;
                })
            },
            hasGetAll: tables.length > 0 && 'getAll' in trans.objectStore(tables[0]) && !(typeof navigator !== 'undefined' && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604)
        };
    }
    function makeIDBKeyRange(range) {
        if (range.type === 3) return null;
        if (range.type === 4) throw new Error("Cannot convert never type to IDBKeyRange");
        var lower = range.lower, upper = range.upper, lowerOpen = range.lowerOpen, upperOpen = range.upperOpen;
        var idbRange = lower === undefined ? upper === undefined ? null : IdbKeyRange.upperBound(upper, !!upperOpen) : upper === undefined ? IdbKeyRange.lowerBound(lower, !!lowerOpen) : IdbKeyRange.bound(lower, upper, !!lowerOpen, !!upperOpen);
        return idbRange;
    }
    function createDbCoreTable(tableSchema) {
        var tableName = tableSchema.name;
        function mutate(_a) {
            var trans = _a.trans, type = _a.type, keys = _a.keys, values = _a.values, range = _a.range;
            return new Promise(function(resolve, reject) {
                resolve = $bc26ee8cec700381$var$wrap(resolve);
                var store = trans.objectStore(tableName);
                var outbound = store.keyPath == null;
                var isAddOrPut = type === "put" || type === "add";
                if (!isAddOrPut && type !== 'delete' && type !== 'deleteRange') throw new Error("Invalid operation type: " + type);
                var length = (keys || values || {
                    length: 1
                }).length;
                if (keys && values && keys.length !== values.length) throw new Error("Given keys array must have same length as given values array.");
                if (length === 0) return resolve({
                    numFailures: 0,
                    failures: {},
                    results: [],
                    lastResult: undefined
                });
                var req;
                var reqs = [];
                var failures = [];
                var numFailures = 0;
                var errorHandler = function errorHandler(event) {
                    ++numFailures;
                    $bc26ee8cec700381$var$preventDefault(event);
                };
                if (type === 'deleteRange') {
                    if (range.type === 4) return resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: [],
                        lastResult: undefined
                    });
                    if (range.type === 3) reqs.push(req = store.clear());
                    else reqs.push(req = store.delete(makeIDBKeyRange(range)));
                } else {
                    var _$_a = isAddOrPut ? outbound ? [
                        values,
                        keys
                    ] : [
                        values,
                        null
                    ] : [
                        keys,
                        null
                    ], args1 = _$_a[0], args2 = _$_a[1];
                    if (isAddOrPut) for(var i = 0; i < length; ++i){
                        reqs.push(req = args2 && args2[i] !== undefined ? store[type](args1[i], args2[i]) : store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                    else for(var i = 0; i < length; ++i){
                        reqs.push(req = store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                }
                var done = function done(event) {
                    var lastResult = event.target.result;
                    reqs.forEach(function(req, i) {
                        return req.error != null && (failures[i] = req.error);
                    });
                    resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: type === "delete" ? keys : reqs.map(function(req) {
                            return req.result;
                        }),
                        lastResult: lastResult
                    });
                };
                req.onerror = function(event) {
                    errorHandler(event);
                    done(event);
                };
                req.onsuccess = done;
            });
        }
        function openCursor(_a) {
            var trans = _a.trans, values = _a.values, _$query = _a.query, reverse = _a.reverse, unique = _a.unique;
            return new Promise(function(resolve, reject) {
                resolve = $bc26ee8cec700381$var$wrap(resolve);
                var index = _$query.index, range = _$query.range;
                var store = trans.objectStore(tableName);
                var source = index.isPrimaryKey ? store : store.index(index.name);
                var direction = reverse ? unique ? "prevunique" : "prev" : unique ? "nextunique" : "next";
                var req = values || !('openKeyCursor' in source) ? source.openCursor(makeIDBKeyRange(range), direction) : source.openKeyCursor(makeIDBKeyRange(range), direction);
                req.onerror = $bc26ee8cec700381$var$eventRejectHandler(reject);
                req.onsuccess = $bc26ee8cec700381$var$wrap(function(ev) {
                    var cursor = req.result;
                    if (!cursor) {
                        resolve(null);
                        return;
                    }
                    cursor.___id = ++$bc26ee8cec700381$var$_id_counter;
                    cursor.done = false;
                    var _cursorContinue = cursor.continue.bind(cursor);
                    var _cursorContinuePrimaryKey = cursor.continuePrimaryKey;
                    if (_cursorContinuePrimaryKey) _cursorContinuePrimaryKey = _cursorContinuePrimaryKey.bind(cursor);
                    var _cursorAdvance = cursor.advance.bind(cursor);
                    var doThrowCursorIsNotStarted = function doThrowCursorIsNotStarted() {
                        throw new Error("Cursor not started");
                    };
                    var doThrowCursorIsStopped = function doThrowCursorIsStopped() {
                        throw new Error("Cursor not stopped");
                    };
                    cursor.trans = trans;
                    cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsNotStarted;
                    cursor.fail = $bc26ee8cec700381$var$wrap(reject);
                    cursor.next = function() {
                        var _this = this;
                        var gotOne = 1;
                        return this.start(function() {
                            return gotOne-- ? _this.continue() : _this.stop();
                        }).then(function() {
                            return _this;
                        });
                    };
                    cursor.start = function(callback) {
                        var iterationPromise = new Promise(function(resolveIteration, rejectIteration) {
                            resolveIteration = $bc26ee8cec700381$var$wrap(resolveIteration);
                            req.onerror = $bc26ee8cec700381$var$eventRejectHandler(rejectIteration);
                            cursor.fail = rejectIteration;
                            cursor.stop = function(value) {
                                cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsStopped;
                                resolveIteration(value);
                            };
                        });
                        var guardedCallback = function guardedCallback() {
                            if (req.result) try {
                                callback();
                            } catch (err) {
                                cursor.fail(err);
                            }
                            else {
                                cursor.done = true;
                                cursor.start = function() {
                                    throw new Error("Cursor behind last entry");
                                };
                                cursor.stop();
                            }
                        };
                        req.onsuccess = $bc26ee8cec700381$var$wrap(function(ev) {
                            req.onsuccess = guardedCallback;
                            guardedCallback();
                        });
                        cursor.continue = _cursorContinue;
                        cursor.continuePrimaryKey = _cursorContinuePrimaryKey;
                        cursor.advance = _cursorAdvance;
                        guardedCallback();
                        return iterationPromise;
                    };
                    resolve(cursor);
                }, reject);
            });
        }
        function query(hasGetAll) {
            return function(request) {
                return new Promise(function(resolve, reject) {
                    resolve = $bc26ee8cec700381$var$wrap(resolve);
                    var trans = request.trans, values = request.values, limit = request.limit, _$query = request.query;
                    var nonInfinitLimit = limit === Infinity ? undefined : limit;
                    var index = _$query.index, range = _$query.range;
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    if (limit === 0) return resolve({
                        result: []
                    });
                    if (hasGetAll) {
                        var req = values ? source.getAll(idbKeyRange, nonInfinitLimit) : source.getAllKeys(idbKeyRange, nonInfinitLimit);
                        req.onsuccess = function(event) {
                            return resolve({
                                result: event.target.result
                            });
                        };
                        req.onerror = $bc26ee8cec700381$var$eventRejectHandler(reject);
                    } else {
                        var count_1 = 0;
                        var req_1 = values || !('openKeyCursor' in source) ? source.openCursor(idbKeyRange) : source.openKeyCursor(idbKeyRange);
                        var result_1 = [];
                        req_1.onsuccess = function(event) {
                            var cursor = req_1.result;
                            if (!cursor) return resolve({
                                result: result_1
                            });
                            result_1.push(values ? cursor.value : cursor.primaryKey);
                            if (++count_1 === limit) return resolve({
                                result: result_1
                            });
                            cursor.continue();
                        };
                        req_1.onerror = $bc26ee8cec700381$var$eventRejectHandler(reject);
                    }
                });
            };
        }
        return {
            name: tableName,
            schema: tableSchema,
            mutate: mutate,
            getMany: function getMany(_a) {
                var trans = _a.trans, keys = _a.keys;
                return new Promise(function(resolve, reject) {
                    resolve = $bc26ee8cec700381$var$wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var length = keys.length;
                    var result = new Array(length);
                    var keyCount = 0;
                    var callbackCount = 0;
                    var req;
                    var successHandler = function successHandler(event) {
                        var req = event.target;
                        result[req._pos] = req.result;
                        if (++callbackCount === keyCount) resolve(result);
                    };
                    var errorHandler = $bc26ee8cec700381$var$eventRejectHandler(reject);
                    for(var i = 0; i < length; ++i){
                        var key = keys[i];
                        if (key != null) {
                            req = store.get(keys[i]);
                            req._pos = i;
                            req.onsuccess = successHandler;
                            req.onerror = errorHandler;
                            ++keyCount;
                        }
                    }
                    if (keyCount === 0) resolve(result);
                });
            },
            get: function get(_a) {
                var trans = _a.trans, key = _a.key;
                return new Promise(function(resolve, reject) {
                    resolve = $bc26ee8cec700381$var$wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var req = store.get(key);
                    req.onsuccess = function(event) {
                        return resolve(event.target.result);
                    };
                    req.onerror = $bc26ee8cec700381$var$eventRejectHandler(reject);
                });
            },
            query: query(hasGetAll),
            openCursor: openCursor,
            count: function count(_a) {
                var _$query = _a.query, trans = _a.trans;
                var index = _$query.index, range = _$query.range;
                return new Promise(function(resolve, reject) {
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    var req = idbKeyRange ? source.count(idbKeyRange) : source.count();
                    req.onsuccess = $bc26ee8cec700381$var$wrap(function(ev) {
                        return resolve(ev.target.result);
                    });
                    req.onerror = $bc26ee8cec700381$var$eventRejectHandler(reject);
                });
            }
        };
    }
    var _a = extractSchema(db, tmpTrans), schema = _a.schema, hasGetAll = _a.hasGetAll;
    var tables = schema.tables.map(function(tableSchema) {
        return createDbCoreTable(tableSchema);
    });
    var tableMap = {};
    tables.forEach(function(table) {
        return tableMap[table.name] = table;
    });
    return {
        stack: "dbcore",
        transaction: db.transaction.bind(db),
        table: function table(name) {
            var result = tableMap[name];
            if (!result) throw new Error("Table '".concat(name, "' not found"));
            return tableMap[name];
        },
        MIN_KEY: -Infinity,
        MAX_KEY: $bc26ee8cec700381$var$getMaxKey(IdbKeyRange),
        schema: schema
    };
}
function $bc26ee8cec700381$var$createMiddlewareStack(stackImpl, middlewares) {
    return middlewares.reduce(function(down, _a) {
        var create = _a.create;
        return $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, down), create(down));
    }, stackImpl);
}
function $bc26ee8cec700381$var$createMiddlewareStacks(middlewares, idbdb, _a, tmpTrans) {
    var IDBKeyRange = _a.IDBKeyRange;
    _a.indexedDB;
    var dbcore = $bc26ee8cec700381$var$createMiddlewareStack($bc26ee8cec700381$var$createDBCore(idbdb, IDBKeyRange, tmpTrans), middlewares.dbcore);
    return {
        dbcore: dbcore
    };
}
function $bc26ee8cec700381$var$generateMiddlewareStacks(db, tmpTrans) {
    var idbdb = tmpTrans.db;
    var stacks = $bc26ee8cec700381$var$createMiddlewareStacks(db._middlewares, idbdb, db._deps, tmpTrans);
    db.core = stacks.dbcore;
    db.tables.forEach(function(table) {
        var tableName = table.name;
        if (db.core.schema.tables.some(function(tbl) {
            return tbl.name === tableName;
        })) {
            table.core = db.core.table(tableName);
            if (db[tableName] instanceof db.Table) db[tableName].core = table.core;
        }
    });
}
function $bc26ee8cec700381$var$setApiOnPlace(db, objs, tableNames, dbschema) {
    tableNames.forEach(function(tableName) {
        var schema = dbschema[tableName];
        objs.forEach(function(obj) {
            var propDesc = $bc26ee8cec700381$var$getPropertyDescriptor(obj, tableName);
            if (!propDesc || "value" in propDesc && propDesc.value === undefined) {
                if (obj === db.Transaction.prototype || obj instanceof db.Transaction) $bc26ee8cec700381$var$setProp(obj, tableName, {
                    get: function get() {
                        return this.table(tableName);
                    },
                    set: function set(value) {
                        $bc26ee8cec700381$var$defineProperty(this, tableName, {
                            value: value,
                            writable: true,
                            configurable: true,
                            enumerable: true
                        });
                    }
                });
                else obj[tableName] = new db.Table(tableName, schema);
            }
        });
    });
}
function $bc26ee8cec700381$var$removeTablesApi(db, objs) {
    objs.forEach(function(obj) {
        for(var key in obj)if (obj[key] instanceof db.Table) delete obj[key];
    });
}
function $bc26ee8cec700381$var$lowerVersionFirst(a, b) {
    return a._cfg.version - b._cfg.version;
}
function $bc26ee8cec700381$var$runUpgraders(db, oldVersion, idbUpgradeTrans, reject) {
    var globalSchema = db._dbSchema;
    if (idbUpgradeTrans.objectStoreNames.contains('$meta') && !globalSchema.$meta) {
        globalSchema.$meta = $bc26ee8cec700381$var$createTableSchema("$meta", $bc26ee8cec700381$var$parseIndexSyntax("")[0], []);
        db._storeNames.push('$meta');
    }
    var trans = db._createTransaction('readwrite', db._storeNames, globalSchema);
    trans.create(idbUpgradeTrans);
    trans._completion.catch(reject);
    var rejectTransaction = trans._reject.bind(trans);
    var transless = $bc26ee8cec700381$var$PSD.transless || $bc26ee8cec700381$var$PSD;
    $bc26ee8cec700381$var$newScope(function() {
        $bc26ee8cec700381$var$PSD.trans = trans;
        $bc26ee8cec700381$var$PSD.transless = transless;
        if (oldVersion === 0) {
            $bc26ee8cec700381$var$keys(globalSchema).forEach(function(tableName) {
                $bc26ee8cec700381$var$createTable(idbUpgradeTrans, tableName, globalSchema[tableName].primKey, globalSchema[tableName].indexes);
            });
            $bc26ee8cec700381$var$generateMiddlewareStacks(db, idbUpgradeTrans);
            $bc26ee8cec700381$var$DexiePromise.follow(function() {
                return db.on.populate.fire(trans);
            }).catch(rejectTransaction);
        } else {
            $bc26ee8cec700381$var$generateMiddlewareStacks(db, idbUpgradeTrans);
            return $bc26ee8cec700381$var$getExistingVersion(db, trans, oldVersion).then(function(oldVersion) {
                return $bc26ee8cec700381$var$updateTablesAndIndexes(db, oldVersion, trans, idbUpgradeTrans);
            }).catch(rejectTransaction);
        }
    });
}
function $bc26ee8cec700381$var$patchCurrentVersion(db, idbUpgradeTrans) {
    $bc26ee8cec700381$var$createMissingTables(db._dbSchema, idbUpgradeTrans);
    if (idbUpgradeTrans.db.version % 10 === 0 && !idbUpgradeTrans.objectStoreNames.contains('$meta')) idbUpgradeTrans.db.createObjectStore('$meta').add(Math.ceil(idbUpgradeTrans.db.version / 10 - 1), 'version');
    var globalSchema = $bc26ee8cec700381$var$buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
    $bc26ee8cec700381$var$adjustToExistingIndexNames(db, db._dbSchema, idbUpgradeTrans);
    var diff = $bc26ee8cec700381$var$getSchemaDiff(globalSchema, db._dbSchema);
    var _loop_1 = function _loop_1(tableChange) {
        if (tableChange.change.length || tableChange.recreate) {
            console.warn("Unable to patch indexes of table ".concat(tableChange.name, " because it has changes on the type of index or primary key."));
            return {
                value: void 0
            };
        }
        var store = idbUpgradeTrans.objectStore(tableChange.name);
        tableChange.add.forEach(function(idx) {
            if ($bc26ee8cec700381$var$debug) console.debug("Dexie upgrade patch: Creating missing index ".concat(tableChange.name, ".").concat(idx.src));
            $bc26ee8cec700381$var$addIndex(store, idx);
        });
    };
    for(var _i = 0, _a = diff.change; _i < _a.length; _i++){
        var tableChange = _a[_i];
        var state_1 = _loop_1(tableChange);
        if ((typeof state_1 === "undefined" ? "undefined" : (0, $2bfPH._)(state_1)) === "object") return state_1.value;
    }
}
function $bc26ee8cec700381$var$getExistingVersion(db, trans, oldVersion) {
    if (trans.storeNames.includes('$meta')) return trans.table('$meta').get('version').then(function(metaVersion) {
        return metaVersion != null ? metaVersion : oldVersion;
    });
    else return $bc26ee8cec700381$var$DexiePromise.resolve(oldVersion);
}
function $bc26ee8cec700381$var$updateTablesAndIndexes(db, oldVersion, trans, idbUpgradeTrans) {
    var queue = [];
    var versions = db._versions;
    var globalSchema = db._dbSchema = $bc26ee8cec700381$var$buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
    var versToRun = versions.filter(function(v) {
        return v._cfg.version >= oldVersion;
    });
    if (versToRun.length === 0) return $bc26ee8cec700381$var$DexiePromise.resolve();
    versToRun.forEach(function(version) {
        queue.push(function() {
            var oldSchema = globalSchema;
            var newSchema = version._cfg.dbschema;
            $bc26ee8cec700381$var$adjustToExistingIndexNames(db, oldSchema, idbUpgradeTrans);
            $bc26ee8cec700381$var$adjustToExistingIndexNames(db, newSchema, idbUpgradeTrans);
            globalSchema = db._dbSchema = newSchema;
            var diff = $bc26ee8cec700381$var$getSchemaDiff(oldSchema, newSchema);
            diff.add.forEach(function(tuple) {
                $bc26ee8cec700381$var$createTable(idbUpgradeTrans, tuple[0], tuple[1].primKey, tuple[1].indexes);
            });
            diff.change.forEach(function(change) {
                if (change.recreate) throw new $bc26ee8cec700381$var$exceptions.Upgrade("Not yet support for changing primary key");
                else {
                    var store_1 = idbUpgradeTrans.objectStore(change.name);
                    change.add.forEach(function(idx) {
                        return $bc26ee8cec700381$var$addIndex(store_1, idx);
                    });
                    change.change.forEach(function(idx) {
                        store_1.deleteIndex(idx.name);
                        $bc26ee8cec700381$var$addIndex(store_1, idx);
                    });
                    change.del.forEach(function(idxName) {
                        return store_1.deleteIndex(idxName);
                    });
                }
            });
            var contentUpgrade = version._cfg.contentUpgrade;
            if (contentUpgrade && version._cfg.version > oldVersion) {
                $bc26ee8cec700381$var$generateMiddlewareStacks(db, idbUpgradeTrans);
                trans._memoizedTables = {};
                var upgradeSchema_1 = $bc26ee8cec700381$var$shallowClone(newSchema);
                diff.del.forEach(function(table) {
                    upgradeSchema_1[table] = oldSchema[table];
                });
                $bc26ee8cec700381$var$removeTablesApi(db, [
                    db.Transaction.prototype
                ]);
                $bc26ee8cec700381$var$setApiOnPlace(db, [
                    db.Transaction.prototype
                ], $bc26ee8cec700381$var$keys(upgradeSchema_1), upgradeSchema_1);
                trans.schema = upgradeSchema_1;
                var contentUpgradeIsAsync_1 = $bc26ee8cec700381$var$isAsyncFunction(contentUpgrade);
                if (contentUpgradeIsAsync_1) $bc26ee8cec700381$var$incrementExpectedAwaits();
                var returnValue_1;
                var promiseFollowed = $bc26ee8cec700381$var$DexiePromise.follow(function() {
                    returnValue_1 = contentUpgrade(trans);
                    if (returnValue_1) {
                        if (contentUpgradeIsAsync_1) {
                            var decrementor = $bc26ee8cec700381$var$decrementExpectedAwaits.bind(null, null);
                            returnValue_1.then(decrementor, decrementor);
                        }
                    }
                });
                return returnValue_1 && typeof returnValue_1.then === 'function' ? $bc26ee8cec700381$var$DexiePromise.resolve(returnValue_1) : promiseFollowed.then(function() {
                    return returnValue_1;
                });
            }
        });
        queue.push(function(idbtrans) {
            var newSchema = version._cfg.dbschema;
            $bc26ee8cec700381$var$deleteRemovedTables(newSchema, idbtrans);
            $bc26ee8cec700381$var$removeTablesApi(db, [
                db.Transaction.prototype
            ]);
            $bc26ee8cec700381$var$setApiOnPlace(db, [
                db.Transaction.prototype
            ], db._storeNames, db._dbSchema);
            trans.schema = db._dbSchema;
        });
        queue.push(function(idbtrans) {
            if (db.idbdb.objectStoreNames.contains('$meta')) {
                if (Math.ceil(db.idbdb.version / 10) === version._cfg.version) {
                    db.idbdb.deleteObjectStore('$meta');
                    delete db._dbSchema.$meta;
                    db._storeNames = db._storeNames.filter(function(name) {
                        return name !== '$meta';
                    });
                } else idbtrans.objectStore('$meta').put(version._cfg.version, 'version');
            }
        });
    });
    function runQueue() {
        return queue.length ? $bc26ee8cec700381$var$DexiePromise.resolve(queue.shift()(trans.idbtrans)).then(runQueue) : $bc26ee8cec700381$var$DexiePromise.resolve();
    }
    return runQueue().then(function() {
        $bc26ee8cec700381$var$createMissingTables(globalSchema, idbUpgradeTrans);
    });
}
function $bc26ee8cec700381$var$getSchemaDiff(oldSchema, newSchema) {
    var diff = {
        del: [],
        add: [],
        change: []
    };
    var table;
    for(table in oldSchema)if (!newSchema[table]) diff.del.push(table);
    for(table in newSchema){
        var oldDef = oldSchema[table], newDef = newSchema[table];
        if (!oldDef) diff.add.push([
            table,
            newDef
        ]);
        else {
            var change = {
                name: table,
                def: newDef,
                recreate: false,
                del: [],
                add: [],
                change: []
            };
            if ('' + (oldDef.primKey.keyPath || '') !== '' + (newDef.primKey.keyPath || '') || oldDef.primKey.auto !== newDef.primKey.auto) {
                change.recreate = true;
                diff.change.push(change);
            } else {
                var oldIndexes = oldDef.idxByName;
                var newIndexes = newDef.idxByName;
                var idxName = void 0;
                for(idxName in oldIndexes)if (!newIndexes[idxName]) change.del.push(idxName);
                for(idxName in newIndexes){
                    var oldIdx = oldIndexes[idxName], newIdx = newIndexes[idxName];
                    if (!oldIdx) change.add.push(newIdx);
                    else if (oldIdx.src !== newIdx.src) change.change.push(newIdx);
                }
                if (change.del.length > 0 || change.add.length > 0 || change.change.length > 0) diff.change.push(change);
            }
        }
    }
    return diff;
}
function $bc26ee8cec700381$var$createTable(idbtrans, tableName, primKey, indexes) {
    var store = idbtrans.db.createObjectStore(tableName, primKey.keyPath ? {
        keyPath: primKey.keyPath,
        autoIncrement: primKey.auto
    } : {
        autoIncrement: primKey.auto
    });
    indexes.forEach(function(idx) {
        return $bc26ee8cec700381$var$addIndex(store, idx);
    });
    return store;
}
function $bc26ee8cec700381$var$createMissingTables(newSchema, idbtrans) {
    $bc26ee8cec700381$var$keys(newSchema).forEach(function(tableName) {
        if (!idbtrans.db.objectStoreNames.contains(tableName)) {
            if ($bc26ee8cec700381$var$debug) console.debug('Dexie: Creating missing table', tableName);
            $bc26ee8cec700381$var$createTable(idbtrans, tableName, newSchema[tableName].primKey, newSchema[tableName].indexes);
        }
    });
}
function $bc26ee8cec700381$var$deleteRemovedTables(newSchema, idbtrans) {
    [].slice.call(idbtrans.db.objectStoreNames).forEach(function(storeName) {
        return newSchema[storeName] == null && idbtrans.db.deleteObjectStore(storeName);
    });
}
function $bc26ee8cec700381$var$addIndex(store, idx) {
    store.createIndex(idx.name, idx.keyPath, {
        unique: idx.unique,
        multiEntry: idx.multi
    });
}
function $bc26ee8cec700381$var$buildGlobalSchema(db, idbdb, tmpTrans) {
    var globalSchema = {};
    var dbStoreNames = $bc26ee8cec700381$var$slice(idbdb.objectStoreNames, 0);
    dbStoreNames.forEach(function(storeName) {
        var store = tmpTrans.objectStore(storeName);
        var keyPath = store.keyPath;
        var primKey = $bc26ee8cec700381$var$createIndexSpec($bc26ee8cec700381$var$nameFromKeyPath(keyPath), keyPath || "", true, false, !!store.autoIncrement, keyPath && typeof keyPath !== "string", true);
        var indexes = [];
        for(var j = 0; j < store.indexNames.length; ++j){
            var idbindex = store.index(store.indexNames[j]);
            keyPath = idbindex.keyPath;
            var index = $bc26ee8cec700381$var$createIndexSpec(idbindex.name, keyPath, !!idbindex.unique, !!idbindex.multiEntry, false, keyPath && typeof keyPath !== "string", false);
            indexes.push(index);
        }
        globalSchema[storeName] = $bc26ee8cec700381$var$createTableSchema(storeName, primKey, indexes);
    });
    return globalSchema;
}
function $bc26ee8cec700381$var$readGlobalSchema(db, idbdb, tmpTrans) {
    db.verno = idbdb.version / 10;
    var globalSchema = db._dbSchema = $bc26ee8cec700381$var$buildGlobalSchema(db, idbdb, tmpTrans);
    db._storeNames = $bc26ee8cec700381$var$slice(idbdb.objectStoreNames, 0);
    $bc26ee8cec700381$var$setApiOnPlace(db, [
        db._allTables
    ], $bc26ee8cec700381$var$keys(globalSchema), globalSchema);
}
function $bc26ee8cec700381$var$verifyInstalledSchema(db, tmpTrans) {
    var installedSchema = $bc26ee8cec700381$var$buildGlobalSchema(db, db.idbdb, tmpTrans);
    var diff = $bc26ee8cec700381$var$getSchemaDiff(installedSchema, db._dbSchema);
    return !(diff.add.length || diff.change.some(function(ch) {
        return ch.add.length || ch.change.length;
    }));
}
function $bc26ee8cec700381$var$adjustToExistingIndexNames(db, schema, idbtrans) {
    var storeNames = idbtrans.db.objectStoreNames;
    for(var i = 0; i < storeNames.length; ++i){
        var storeName = storeNames[i];
        var store = idbtrans.objectStore(storeName);
        db._hasGetAll = 'getAll' in store;
        for(var j = 0; j < store.indexNames.length; ++j){
            var indexName = store.indexNames[j];
            var keyPath = store.index(indexName).keyPath;
            var dexieName = typeof keyPath === 'string' ? keyPath : "[" + $bc26ee8cec700381$var$slice(keyPath).join('+') + "]";
            if (schema[storeName]) {
                var indexSpec = schema[storeName].idxByName[dexieName];
                if (indexSpec) {
                    indexSpec.name = indexName;
                    delete schema[storeName].idxByName[dexieName];
                    schema[storeName].idxByName[indexName] = indexSpec;
                }
            }
        }
    }
    if (typeof navigator !== 'undefined' && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && $bc26ee8cec700381$var$_global.WorkerGlobalScope && $bc26ee8cec700381$var$_global instanceof $bc26ee8cec700381$var$_global.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604) db._hasGetAll = false;
}
function $bc26ee8cec700381$var$parseIndexSyntax(primKeyAndIndexes) {
    return primKeyAndIndexes.split(',').map(function(index, indexNum) {
        var _a;
        var typeSplit = index.split(':');
        var type = (_a = typeSplit[1]) === null || _a === void 0 ? void 0 : _a.trim();
        index = typeSplit[0].trim();
        var name = index.replace(/([&*]|\+\+)/g, "");
        var keyPath = /^\[/.test(name) ? name.match(/^\[(.*)\]$/)[1].split('+') : name;
        return $bc26ee8cec700381$var$createIndexSpec(name, keyPath || null, /\&/.test(index), /\*/.test(index), /\+\+/.test(index), $bc26ee8cec700381$var$isArray(keyPath), indexNum === 0, type);
    });
}
var $bc26ee8cec700381$var$Version = function() {
    function Version() {}
    Version.prototype._createTableSchema = function(name, primKey, indexes) {
        return $bc26ee8cec700381$var$createTableSchema(name, primKey, indexes);
    };
    Version.prototype._parseIndexSyntax = function(primKeyAndIndexes) {
        return $bc26ee8cec700381$var$parseIndexSyntax(primKeyAndIndexes);
    };
    Version.prototype._parseStoresSpec = function(stores, outSchema) {
        var _this = this;
        $bc26ee8cec700381$var$keys(stores).forEach(function(tableName) {
            if (stores[tableName] !== null) {
                var indexes = _this._parseIndexSyntax(stores[tableName]);
                var primKey = indexes.shift();
                if (!primKey) throw new $bc26ee8cec700381$var$exceptions.Schema('Invalid schema for table ' + tableName + ': ' + stores[tableName]);
                primKey.unique = true;
                if (primKey.multi) throw new $bc26ee8cec700381$var$exceptions.Schema('Primary key cannot be multiEntry*');
                indexes.forEach(function(idx) {
                    if (idx.auto) throw new $bc26ee8cec700381$var$exceptions.Schema('Only primary key can be marked as autoIncrement (++)');
                    if (!idx.keyPath) throw new $bc26ee8cec700381$var$exceptions.Schema('Index must have a name and cannot be an empty string');
                });
                var tblSchema = _this._createTableSchema(tableName, primKey, indexes);
                outSchema[tableName] = tblSchema;
            }
        });
    };
    Version.prototype.stores = function(stores) {
        var db = this.db;
        this._cfg.storesSource = this._cfg.storesSource ? $bc26ee8cec700381$var$extend(this._cfg.storesSource, stores) : stores;
        var versions = db._versions;
        var storesSpec = {};
        var dbschema = {};
        versions.forEach(function(version) {
            $bc26ee8cec700381$var$extend(storesSpec, version._cfg.storesSource);
            dbschema = version._cfg.dbschema = {};
            version._parseStoresSpec(storesSpec, dbschema);
        });
        db._dbSchema = dbschema;
        $bc26ee8cec700381$var$removeTablesApi(db, [
            db._allTables,
            db,
            db.Transaction.prototype
        ]);
        $bc26ee8cec700381$var$setApiOnPlace(db, [
            db._allTables,
            db,
            db.Transaction.prototype,
            this._cfg.tables
        ], $bc26ee8cec700381$var$keys(dbschema), dbschema);
        db._storeNames = $bc26ee8cec700381$var$keys(dbschema);
        return this;
    };
    Version.prototype.upgrade = function(upgradeFunction) {
        this._cfg.contentUpgrade = $bc26ee8cec700381$var$promisableChain(this._cfg.contentUpgrade || $bc26ee8cec700381$var$nop, upgradeFunction);
        return this;
    };
    return Version;
}();
function $bc26ee8cec700381$var$createVersionConstructor(db) {
    return $bc26ee8cec700381$var$makeClassConstructor($bc26ee8cec700381$var$Version.prototype, function Version(versionNumber) {
        this.db = db;
        this._cfg = {
            version: versionNumber,
            storesSource: null,
            dbschema: {},
            tables: {},
            contentUpgrade: null
        };
    });
}
function $bc26ee8cec700381$var$getDbNamesTable(indexedDB1, IDBKeyRange) {
    var dbNamesDB = indexedDB1["_dbNamesDB"];
    if (!dbNamesDB) {
        dbNamesDB = indexedDB1["_dbNamesDB"] = new $bc26ee8cec700381$export$4ece27d405df7279($bc26ee8cec700381$var$DBNAMES_DB, {
            addons: [],
            indexedDB: indexedDB1,
            IDBKeyRange: IDBKeyRange
        });
        dbNamesDB.version(1).stores({
            dbnames: "name"
        });
    }
    return dbNamesDB.table("dbnames");
}
function $bc26ee8cec700381$var$hasDatabasesNative(indexedDB1) {
    return indexedDB1 && typeof indexedDB1.databases === "function";
}
function $bc26ee8cec700381$var$getDatabaseNames(_a) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    return $bc26ee8cec700381$var$hasDatabasesNative(indexedDB1) ? Promise.resolve(indexedDB1.databases()).then(function(infos) {
        return infos.map(function(info) {
            return info.name;
        }).filter(function(name) {
            return name !== $bc26ee8cec700381$var$DBNAMES_DB;
        });
    }) : $bc26ee8cec700381$var$getDbNamesTable(indexedDB1, IDBKeyRange).toCollection().primaryKeys();
}
function $bc26ee8cec700381$var$_onDatabaseCreated(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !$bc26ee8cec700381$var$hasDatabasesNative(indexedDB1) && name !== $bc26ee8cec700381$var$DBNAMES_DB && $bc26ee8cec700381$var$getDbNamesTable(indexedDB1, IDBKeyRange).put({
        name: name
    }).catch($bc26ee8cec700381$var$nop);
}
function $bc26ee8cec700381$var$_onDatabaseDeleted(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !$bc26ee8cec700381$var$hasDatabasesNative(indexedDB1) && name !== $bc26ee8cec700381$var$DBNAMES_DB && $bc26ee8cec700381$var$getDbNamesTable(indexedDB1, IDBKeyRange).delete(name).catch($bc26ee8cec700381$var$nop);
}
function $bc26ee8cec700381$var$vip(fn) {
    return $bc26ee8cec700381$var$newScope(function() {
        $bc26ee8cec700381$var$PSD.letThrough = true;
        return fn();
    });
}
function $bc26ee8cec700381$var$idbReady() {
    var isSafari = !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent);
    if (!isSafari || !indexedDB.databases) return Promise.resolve();
    var intervalId;
    return new Promise(function(resolve) {
        var tryIdb = function tryIdb() {
            return indexedDB.databases().finally(resolve);
        };
        intervalId = setInterval(tryIdb, 100);
        tryIdb();
    }).finally(function() {
        return clearInterval(intervalId);
    });
}
var $bc26ee8cec700381$var$_a;
function $bc26ee8cec700381$var$isEmptyRange(node) {
    return !("from" in node);
}
var $bc26ee8cec700381$export$34cb5241245008dd = function RangeSet1(fromOrTree, to) {
    if (this) $bc26ee8cec700381$var$extend(this, arguments.length ? {
        d: 1,
        from: fromOrTree,
        to: arguments.length > 1 ? to : fromOrTree
    } : {
        d: 0
    });
    else {
        var rv = new $bc26ee8cec700381$export$34cb5241245008dd();
        if (fromOrTree && "d" in fromOrTree) $bc26ee8cec700381$var$extend(rv, fromOrTree);
        return rv;
    }
};
$bc26ee8cec700381$var$props($bc26ee8cec700381$export$34cb5241245008dd.prototype, ($bc26ee8cec700381$var$_a = {
    add: function add(rangeSet) {
        $bc26ee8cec700381$export$4876cc3130d3f820(this, rangeSet);
        return this;
    },
    addKey: function addKey(key) {
        $bc26ee8cec700381$var$addRange(this, key, key);
        return this;
    },
    addKeys: function addKeys(keys) {
        var _this = this;
        keys.forEach(function(key) {
            return $bc26ee8cec700381$var$addRange(_this, key, key);
        });
        return this;
    },
    hasKey: function hasKey(key) {
        var node = $bc26ee8cec700381$var$getRangeSetIterator(this).next(key).value;
        return node && $bc26ee8cec700381$export$6154dcdb7d23e37b(node.from, key) <= 0 && $bc26ee8cec700381$export$6154dcdb7d23e37b(node.to, key) >= 0;
    }
}, $bc26ee8cec700381$var$_a[$bc26ee8cec700381$var$iteratorSymbol] = function() {
    return $bc26ee8cec700381$var$getRangeSetIterator(this);
}, $bc26ee8cec700381$var$_a));
function $bc26ee8cec700381$var$addRange(target, from, to) {
    var diff = $bc26ee8cec700381$export$6154dcdb7d23e37b(from, to);
    if (isNaN(diff)) return;
    if (diff > 0) throw RangeError();
    if ($bc26ee8cec700381$var$isEmptyRange(target)) return $bc26ee8cec700381$var$extend(target, {
        from: from,
        to: to,
        d: 1
    });
    var left = target.l;
    var right = target.r;
    if ($bc26ee8cec700381$export$6154dcdb7d23e37b(to, target.from) < 0) {
        left ? $bc26ee8cec700381$var$addRange(left, from, to) : target.l = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return $bc26ee8cec700381$var$rebalance(target);
    }
    if ($bc26ee8cec700381$export$6154dcdb7d23e37b(from, target.to) > 0) {
        right ? $bc26ee8cec700381$var$addRange(right, from, to) : target.r = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return $bc26ee8cec700381$var$rebalance(target);
    }
    if ($bc26ee8cec700381$export$6154dcdb7d23e37b(from, target.from) < 0) {
        target.from = from;
        target.l = null;
        target.d = right ? right.d + 1 : 1;
    }
    if ($bc26ee8cec700381$export$6154dcdb7d23e37b(to, target.to) > 0) {
        target.to = to;
        target.r = null;
        target.d = target.l ? target.l.d + 1 : 1;
    }
    var rightWasCutOff = !target.r;
    if (left && !target.l) $bc26ee8cec700381$export$4876cc3130d3f820(target, left);
    if (right && rightWasCutOff) $bc26ee8cec700381$export$4876cc3130d3f820(target, right);
}
function $bc26ee8cec700381$export$4876cc3130d3f820(target, newSet) {
    function _addRangeSet(target, _a) {
        var from = _a.from, to = _a.to, l = _a.l, r = _a.r;
        $bc26ee8cec700381$var$addRange(target, from, to);
        if (l) _addRangeSet(target, l);
        if (r) _addRangeSet(target, r);
    }
    if (!$bc26ee8cec700381$var$isEmptyRange(newSet)) _addRangeSet(target, newSet);
}
function $bc26ee8cec700381$export$8f43b23b5d8de905(rangeSet1, rangeSet2) {
    var i1 = $bc26ee8cec700381$var$getRangeSetIterator(rangeSet2);
    var nextResult1 = i1.next();
    if (nextResult1.done) return false;
    var a = nextResult1.value;
    var i2 = $bc26ee8cec700381$var$getRangeSetIterator(rangeSet1);
    var nextResult2 = i2.next(a.from);
    var b = nextResult2.value;
    while(!nextResult1.done && !nextResult2.done){
        if ($bc26ee8cec700381$export$6154dcdb7d23e37b(b.from, a.to) <= 0 && $bc26ee8cec700381$export$6154dcdb7d23e37b(b.to, a.from) >= 0) return true;
        $bc26ee8cec700381$export$6154dcdb7d23e37b(a.from, b.from) < 0 ? a = (nextResult1 = i1.next(b.from)).value : b = (nextResult2 = i2.next(a.from)).value;
    }
    return false;
}
function $bc26ee8cec700381$var$getRangeSetIterator(node) {
    var state = $bc26ee8cec700381$var$isEmptyRange(node) ? null : {
        s: 0,
        n: node
    };
    return {
        next: function next(key) {
            var keyProvided = arguments.length > 0;
            while(state)switch(state.s){
                case 0:
                    state.s = 1;
                    if (keyProvided) while(state.n.l && $bc26ee8cec700381$export$6154dcdb7d23e37b(key, state.n.from) < 0)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                    else while(state.n.l)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                case 1:
                    state.s = 2;
                    if (!keyProvided || $bc26ee8cec700381$export$6154dcdb7d23e37b(key, state.n.to) <= 0) return {
                        value: state.n,
                        done: false
                    };
                case 2:
                    if (state.n.r) {
                        state.s = 3;
                        state = {
                            up: state,
                            n: state.n.r,
                            s: 0
                        };
                        continue;
                    }
                case 3:
                    state = state.up;
            }
            return {
                done: true
            };
        }
    };
}
function $bc26ee8cec700381$var$rebalance(target) {
    var _a, _b;
    var diff = (((_a = target.r) === null || _a === void 0 ? void 0 : _a.d) || 0) - (((_b = target.l) === null || _b === void 0 ? void 0 : _b.d) || 0);
    var r = diff > 1 ? "r" : diff < -1 ? "l" : "";
    if (r) {
        var l = r === "r" ? "l" : "r";
        var rootClone = $bc26ee8cec700381$var$__assign({}, target);
        var oldRootRight = target[r];
        target.from = oldRootRight.from;
        target.to = oldRootRight.to;
        target[r] = oldRootRight[r];
        rootClone[r] = oldRootRight[l];
        target[l] = rootClone;
        rootClone.d = $bc26ee8cec700381$var$computeDepth(rootClone);
    }
    target.d = $bc26ee8cec700381$var$computeDepth(target);
}
function $bc26ee8cec700381$var$computeDepth(_a) {
    var r = _a.r, l = _a.l;
    return (r ? l ? Math.max(r.d, l.d) : r.d : l ? l.d : 0) + 1;
}
function $bc26ee8cec700381$var$extendObservabilitySet(target, newSet) {
    $bc26ee8cec700381$var$keys(newSet).forEach(function(part) {
        if (target[part]) $bc26ee8cec700381$export$4876cc3130d3f820(target[part], newSet[part]);
        else target[part] = $bc26ee8cec700381$var$cloneSimpleObjectTree(newSet[part]);
    });
    return target;
}
function $bc26ee8cec700381$var$obsSetsOverlap(os1, os2) {
    return os1.all || os2.all || Object.keys(os1).some(function(key) {
        return os2[key] && $bc26ee8cec700381$export$8f43b23b5d8de905(os2[key], os1[key]);
    });
}
var $bc26ee8cec700381$var$cache = {};
var $bc26ee8cec700381$var$unsignaledParts = {};
var $bc26ee8cec700381$var$isTaskEnqueued = false;
function $bc26ee8cec700381$var$signalSubscribersLazily(part, optimistic) {
    $bc26ee8cec700381$var$extendObservabilitySet($bc26ee8cec700381$var$unsignaledParts, part);
    if (!$bc26ee8cec700381$var$isTaskEnqueued) {
        $bc26ee8cec700381$var$isTaskEnqueued = true;
        setTimeout(function() {
            $bc26ee8cec700381$var$isTaskEnqueued = false;
            var parts = $bc26ee8cec700381$var$unsignaledParts;
            $bc26ee8cec700381$var$unsignaledParts = {};
            $bc26ee8cec700381$var$signalSubscribersNow(parts, false);
        }, 0);
    }
}
function $bc26ee8cec700381$var$signalSubscribersNow(updatedParts, deleteAffectedCacheEntries) {
    if (deleteAffectedCacheEntries === void 0) deleteAffectedCacheEntries = false;
    var queriesToSignal = new Set();
    if (updatedParts.all) for(var _i = 0, _a = Object.values($bc26ee8cec700381$var$cache); _i < _a.length; _i++){
        var tblCache = _a[_i];
        $bc26ee8cec700381$var$collectTableSubscribers(tblCache, updatedParts, queriesToSignal, deleteAffectedCacheEntries);
    }
    else for(var key in updatedParts){
        var parts = /^idb\:\/\/(.*)\/(.*)\//.exec(key);
        if (parts) {
            var dbName = parts[1], tableName = parts[2];
            var tblCache = $bc26ee8cec700381$var$cache["idb://".concat(dbName, "/").concat(tableName)];
            if (tblCache) $bc26ee8cec700381$var$collectTableSubscribers(tblCache, updatedParts, queriesToSignal, deleteAffectedCacheEntries);
        }
    }
    queriesToSignal.forEach(function(requery) {
        return requery();
    });
}
function $bc26ee8cec700381$var$collectTableSubscribers(tblCache, updatedParts, outQueriesToSignal, deleteAffectedCacheEntries) {
    var updatedEntryLists = [];
    for(var _i = 0, _a = Object.entries(tblCache.queries.query); _i < _a.length; _i++){
        var _b = _a[_i], indexName = _b[0], entries = _b[1];
        var filteredEntries = [];
        for(var _c = 0, entries_1 = entries; _c < entries_1.length; _c++){
            var entry = entries_1[_c];
            if ($bc26ee8cec700381$var$obsSetsOverlap(updatedParts, entry.obsSet)) entry.subscribers.forEach(function(requery) {
                return outQueriesToSignal.add(requery);
            });
            else if (deleteAffectedCacheEntries) filteredEntries.push(entry);
        }
        if (deleteAffectedCacheEntries) updatedEntryLists.push([
            indexName,
            filteredEntries
        ]);
    }
    if (deleteAffectedCacheEntries) for(var _d = 0, updatedEntryLists_1 = updatedEntryLists; _d < updatedEntryLists_1.length; _d++){
        var _e = updatedEntryLists_1[_d], indexName = _e[0], filteredEntries = _e[1];
        tblCache.queries.query[indexName] = filteredEntries;
    }
}
function $bc26ee8cec700381$var$dexieOpen(db) {
    var state = db._state;
    var indexedDB1 = db._deps.indexedDB;
    if (state.isBeingOpened || db.idbdb) return state.dbReadyPromise.then(function() {
        return state.dbOpenError ? $bc26ee8cec700381$var$rejection(state.dbOpenError) : db;
    });
    state.isBeingOpened = true;
    state.dbOpenError = null;
    state.openComplete = false;
    var openCanceller = state.openCanceller;
    var nativeVerToOpen = Math.round(db.verno * 10);
    var schemaPatchMode = false;
    function throwIfCancelled() {
        if (state.openCanceller !== openCanceller) throw new $bc26ee8cec700381$var$exceptions.DatabaseClosed('db.open() was cancelled');
    }
    var resolveDbReady = state.dbReadyResolve, upgradeTransaction = null, wasCreated = false;
    var tryOpenDB = function tryOpenDB1() {
        return new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
            throwIfCancelled();
            if (!indexedDB1) throw new $bc26ee8cec700381$var$exceptions.MissingAPI();
            var dbName = db.name;
            var req = state.autoSchema || !nativeVerToOpen ? indexedDB1.open(dbName) : indexedDB1.open(dbName, nativeVerToOpen);
            if (!req) throw new $bc26ee8cec700381$var$exceptions.MissingAPI();
            req.onerror = $bc26ee8cec700381$var$eventRejectHandler(reject);
            req.onblocked = $bc26ee8cec700381$var$wrap(db._fireOnBlocked);
            req.onupgradeneeded = $bc26ee8cec700381$var$wrap(function(e) {
                upgradeTransaction = req.transaction;
                if (state.autoSchema && !db._options.allowEmptyDB) {
                    req.onerror = $bc26ee8cec700381$var$preventDefault;
                    upgradeTransaction.abort();
                    req.result.close();
                    var delreq = indexedDB1.deleteDatabase(dbName);
                    delreq.onsuccess = delreq.onerror = $bc26ee8cec700381$var$wrap(function() {
                        reject(new $bc26ee8cec700381$var$exceptions.NoSuchDatabase("Database ".concat(dbName, " doesnt exist")));
                    });
                } else {
                    upgradeTransaction.onerror = $bc26ee8cec700381$var$eventRejectHandler(reject);
                    var oldVer = e.oldVersion > Math.pow(2, 62) ? 0 : e.oldVersion;
                    wasCreated = oldVer < 1;
                    db.idbdb = req.result;
                    if (schemaPatchMode) $bc26ee8cec700381$var$patchCurrentVersion(db, upgradeTransaction);
                    $bc26ee8cec700381$var$runUpgraders(db, oldVer / 10, upgradeTransaction, reject);
                }
            }, reject);
            req.onsuccess = $bc26ee8cec700381$var$wrap(function() {
                upgradeTransaction = null;
                var idbdb = db.idbdb = req.result;
                var objectStoreNames = $bc26ee8cec700381$var$slice(idbdb.objectStoreNames);
                if (objectStoreNames.length > 0) try {
                    var tmpTrans = idbdb.transaction($bc26ee8cec700381$var$safariMultiStoreFix(objectStoreNames), 'readonly');
                    if (state.autoSchema) $bc26ee8cec700381$var$readGlobalSchema(db, idbdb, tmpTrans);
                    else {
                        $bc26ee8cec700381$var$adjustToExistingIndexNames(db, db._dbSchema, tmpTrans);
                        if (!$bc26ee8cec700381$var$verifyInstalledSchema(db, tmpTrans) && !schemaPatchMode) {
                            console.warn("Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Dexie will add missing parts and increment native version number to workaround this.");
                            idbdb.close();
                            nativeVerToOpen = idbdb.version + 1;
                            schemaPatchMode = true;
                            return resolve(tryOpenDB());
                        }
                    }
                    $bc26ee8cec700381$var$generateMiddlewareStacks(db, tmpTrans);
                } catch (e) {}
                $bc26ee8cec700381$var$connections.push(db);
                idbdb.onversionchange = $bc26ee8cec700381$var$wrap(function(ev) {
                    state.vcFired = true;
                    db.on("versionchange").fire(ev);
                });
                idbdb.onclose = $bc26ee8cec700381$var$wrap(function() {
                    db.close({
                        disableAutoOpen: false
                    });
                });
                if (wasCreated) $bc26ee8cec700381$var$_onDatabaseCreated(db._deps, dbName);
                resolve();
            }, reject);
        }).catch(function(err) {
            switch(err === null || err === void 0 ? void 0 : err.name){
                case "UnknownError":
                    if (state.PR1398_maxLoop > 0) {
                        state.PR1398_maxLoop--;
                        console.warn('Dexie: Workaround for Chrome UnknownError on open()');
                        return tryOpenDB();
                    }
                    break;
                case "VersionError":
                    if (nativeVerToOpen > 0) {
                        nativeVerToOpen = 0;
                        return tryOpenDB();
                    }
                    break;
            }
            return $bc26ee8cec700381$var$DexiePromise.reject(err);
        });
    };
    return $bc26ee8cec700381$var$DexiePromise.race([
        openCanceller,
        (typeof navigator === 'undefined' ? $bc26ee8cec700381$var$DexiePromise.resolve() : $bc26ee8cec700381$var$idbReady()).then(tryOpenDB)
    ]).then(function() {
        throwIfCancelled();
        state.onReadyBeingFired = [];
        return $bc26ee8cec700381$var$DexiePromise.resolve($bc26ee8cec700381$var$vip(function() {
            return db.on.ready.fire(db.vip);
        })).then(function fireRemainders() {
            if (state.onReadyBeingFired.length > 0) {
                var remainders_1 = state.onReadyBeingFired.reduce($bc26ee8cec700381$var$promisableChain, $bc26ee8cec700381$var$nop);
                state.onReadyBeingFired = [];
                return $bc26ee8cec700381$var$DexiePromise.resolve($bc26ee8cec700381$var$vip(function() {
                    return remainders_1(db.vip);
                })).then(fireRemainders);
            }
        });
    }).finally(function() {
        if (state.openCanceller === openCanceller) {
            state.onReadyBeingFired = null;
            state.isBeingOpened = false;
        }
    }).catch(function(err) {
        state.dbOpenError = err;
        try {
            upgradeTransaction && upgradeTransaction.abort();
        } catch (_a) {}
        if (openCanceller === state.openCanceller) db._close();
        return $bc26ee8cec700381$var$rejection(err);
    }).finally(function() {
        state.openComplete = true;
        resolveDbReady();
    }).then(function() {
        if (wasCreated) {
            var everything_1 = {};
            db.tables.forEach(function(table) {
                table.schema.indexes.forEach(function(idx) {
                    if (idx.name) everything_1["idb://".concat(db.name, "/").concat(table.name, "/").concat(idx.name)] = new $bc26ee8cec700381$export$34cb5241245008dd(-Infinity, [
                        [
                            []
                        ]
                    ]);
                });
                everything_1["idb://".concat(db.name, "/").concat(table.name, "/")] = everything_1["idb://".concat(db.name, "/").concat(table.name, "/:dels")] = new $bc26ee8cec700381$export$34cb5241245008dd(-Infinity, [
                    [
                        []
                    ]
                ]);
            });
            $bc26ee8cec700381$var$globalEvents($bc26ee8cec700381$var$DEXIE_STORAGE_MUTATED_EVENT_NAME).fire(everything_1);
            $bc26ee8cec700381$var$signalSubscribersNow(everything_1, true);
        }
        return db;
    });
}
function $bc26ee8cec700381$var$awaitIterator(iterator) {
    var callNext = function callNext(result) {
        return iterator.next(result);
    }, doThrow = function doThrow(error) {
        return iterator.throw(error);
    }, onSuccess = step(callNext), onError = step(doThrow);
    function step(getNext) {
        return function(val) {
            var next = getNext(val), value = next.value;
            return next.done ? value : !value || typeof value.then !== 'function' ? $bc26ee8cec700381$var$isArray(value) ? Promise.all(value).then(onSuccess, onError) : onSuccess(value) : value.then(onSuccess, onError);
        };
    }
    return step(callNext)();
}
function $bc26ee8cec700381$var$extractTransactionArgs(mode, _tableArgs_, scopeFunc) {
    var i = arguments.length;
    if (i < 2) throw new $bc26ee8cec700381$var$exceptions.InvalidArgument("Too few arguments");
    var args = new Array(i - 1);
    while(--i)args[i - 1] = arguments[i];
    scopeFunc = args.pop();
    var tables = $bc26ee8cec700381$var$flatten(args);
    return [
        mode,
        tables,
        scopeFunc
    ];
}
function $bc26ee8cec700381$var$enterTransactionScope(db, mode, storeNames, parentTransaction, scopeFunc) {
    return $bc26ee8cec700381$var$DexiePromise.resolve().then(function() {
        var transless = $bc26ee8cec700381$var$PSD.transless || $bc26ee8cec700381$var$PSD;
        var trans = db._createTransaction(mode, storeNames, db._dbSchema, parentTransaction);
        trans.explicit = true;
        var zoneProps = {
            trans: trans,
            transless: transless
        };
        if (parentTransaction) trans.idbtrans = parentTransaction.idbtrans;
        else try {
            trans.create();
            trans.idbtrans._explicit = true;
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === $bc26ee8cec700381$var$errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn('Dexie: Need to reopen db');
                db.close({
                    disableAutoOpen: false
                });
                return db.open().then(function() {
                    return $bc26ee8cec700381$var$enterTransactionScope(db, mode, storeNames, null, scopeFunc);
                });
            }
            return $bc26ee8cec700381$var$rejection(ex);
        }
        var scopeFuncIsAsync = $bc26ee8cec700381$var$isAsyncFunction(scopeFunc);
        if (scopeFuncIsAsync) $bc26ee8cec700381$var$incrementExpectedAwaits();
        var returnValue;
        var promiseFollowed = $bc26ee8cec700381$var$DexiePromise.follow(function() {
            returnValue = scopeFunc.call(trans, trans);
            if (returnValue) {
                if (scopeFuncIsAsync) {
                    var decrementor = $bc26ee8cec700381$var$decrementExpectedAwaits.bind(null, null);
                    returnValue.then(decrementor, decrementor);
                } else if (typeof returnValue.next === 'function' && typeof returnValue.throw === 'function') returnValue = $bc26ee8cec700381$var$awaitIterator(returnValue);
            }
        }, zoneProps);
        return (returnValue && typeof returnValue.then === 'function' ? $bc26ee8cec700381$var$DexiePromise.resolve(returnValue).then(function(x) {
            return trans.active ? x : $bc26ee8cec700381$var$rejection(new $bc26ee8cec700381$var$exceptions.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"));
        }) : promiseFollowed.then(function() {
            return returnValue;
        })).then(function(x) {
            if (parentTransaction) trans._resolve();
            return trans._completion.then(function() {
                return x;
            });
        }).catch(function(e) {
            trans._reject(e);
            return $bc26ee8cec700381$var$rejection(e);
        });
    });
}
function $bc26ee8cec700381$var$pad(a, value, count) {
    var result = $bc26ee8cec700381$var$isArray(a) ? a.slice() : [
        a
    ];
    for(var i = 0; i < count; ++i)result.push(value);
    return result;
}
function $bc26ee8cec700381$var$createVirtualIndexMiddleware(down) {
    return $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, down), {
        table: function table(tableName) {
            var table = down.table(tableName);
            var schema = table.schema;
            var indexLookup = {};
            var allVirtualIndexes = [];
            function addVirtualIndexes(keyPath, keyTail, lowLevelIndex) {
                var keyPathAlias = $bc26ee8cec700381$var$getKeyPathAlias(keyPath);
                var indexList = indexLookup[keyPathAlias] = indexLookup[keyPathAlias] || [];
                var keyLength = keyPath == null ? 0 : typeof keyPath === 'string' ? 1 : keyPath.length;
                var isVirtual = keyTail > 0;
                var virtualIndex = $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, lowLevelIndex), {
                    name: isVirtual ? "".concat(keyPathAlias, "(virtual-from:").concat(lowLevelIndex.name, ")") : lowLevelIndex.name,
                    lowLevelIndex: lowLevelIndex,
                    isVirtual: isVirtual,
                    keyTail: keyTail,
                    keyLength: keyLength,
                    extractKey: $bc26ee8cec700381$var$getKeyExtractor(keyPath),
                    unique: !isVirtual && lowLevelIndex.unique
                });
                indexList.push(virtualIndex);
                if (!virtualIndex.isPrimaryKey) allVirtualIndexes.push(virtualIndex);
                if (keyLength > 1) {
                    var virtualKeyPath = keyLength === 2 ? keyPath[0] : keyPath.slice(0, keyLength - 1);
                    addVirtualIndexes(virtualKeyPath, keyTail + 1, lowLevelIndex);
                }
                indexList.sort(function(a, b) {
                    return a.keyTail - b.keyTail;
                });
                return virtualIndex;
            }
            var primaryKey = addVirtualIndexes(schema.primaryKey.keyPath, 0, schema.primaryKey);
            indexLookup[":id"] = [
                primaryKey
            ];
            for(var _i = 0, _a = schema.indexes; _i < _a.length; _i++){
                var index = _a[_i];
                addVirtualIndexes(index.keyPath, 0, index);
            }
            function findBestIndex(keyPath) {
                var result = indexLookup[$bc26ee8cec700381$var$getKeyPathAlias(keyPath)];
                return result && result[0];
            }
            function translateRange(range, keyTail) {
                return {
                    type: range.type === 1 ? 2 : range.type,
                    lower: $bc26ee8cec700381$var$pad(range.lower, range.lowerOpen ? down.MAX_KEY : down.MIN_KEY, keyTail),
                    lowerOpen: true,
                    upper: $bc26ee8cec700381$var$pad(range.upper, range.upperOpen ? down.MIN_KEY : down.MAX_KEY, keyTail),
                    upperOpen: true
                };
            }
            function translateRequest(req) {
                var index = req.query.index;
                return index.isVirtual ? $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, req), {
                    query: {
                        index: index.lowLevelIndex,
                        range: translateRange(req.query.range, index.keyTail)
                    }
                }) : req;
            }
            var result = $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, table), {
                schema: $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, schema), {
                    primaryKey: primaryKey,
                    indexes: allVirtualIndexes,
                    getIndexByKeyPath: findBestIndex
                }),
                count: function count(req) {
                    return table.count(translateRequest(req));
                },
                query: function query(req) {
                    return table.query(translateRequest(req));
                },
                openCursor: function openCursor(req) {
                    var _a = req.query.index, keyTail = _a.keyTail, isVirtual = _a.isVirtual, keyLength = _a.keyLength;
                    if (!isVirtual) return table.openCursor(req);
                    function createVirtualCursor(cursor) {
                        function _continue(key) {
                            key != null ? cursor.continue($bc26ee8cec700381$var$pad(key, req.reverse ? down.MAX_KEY : down.MIN_KEY, keyTail)) : req.unique ? cursor.continue(cursor.key.slice(0, keyLength).concat(req.reverse ? down.MIN_KEY : down.MAX_KEY, keyTail)) : cursor.continue();
                        }
                        var virtualCursor = Object.create(cursor, {
                            continue: {
                                value: _continue
                            },
                            continuePrimaryKey: {
                                value: function value(key, primaryKey) {
                                    cursor.continuePrimaryKey($bc26ee8cec700381$var$pad(key, down.MAX_KEY, keyTail), primaryKey);
                                }
                            },
                            primaryKey: {
                                get: function get() {
                                    return cursor.primaryKey;
                                }
                            },
                            key: {
                                get: function get() {
                                    var key = cursor.key;
                                    return keyLength === 1 ? key[0] : key.slice(0, keyLength);
                                }
                            },
                            value: {
                                get: function get() {
                                    return cursor.value;
                                }
                            }
                        });
                        return virtualCursor;
                    }
                    return table.openCursor(translateRequest(req)).then(function(cursor) {
                        return cursor && createVirtualCursor(cursor);
                    });
                }
            });
            return result;
        }
    });
}
var $bc26ee8cec700381$var$virtualIndexMiddleware = {
    stack: "dbcore",
    name: "VirtualIndexMiddleware",
    level: 1,
    create: $bc26ee8cec700381$var$createVirtualIndexMiddleware
};
function $bc26ee8cec700381$var$getObjectDiff(a, b, rv, prfx) {
    rv = rv || {};
    prfx = prfx || '';
    $bc26ee8cec700381$var$keys(a).forEach(function(prop) {
        if (!$bc26ee8cec700381$var$hasOwn(b, prop)) rv[prfx + prop] = undefined;
        else {
            var ap = a[prop], bp = b[prop];
            if ((typeof ap === "undefined" ? "undefined" : (0, $2bfPH._)(ap)) === 'object' && (typeof bp === "undefined" ? "undefined" : (0, $2bfPH._)(bp)) === 'object' && ap && bp) {
                var apTypeName = $bc26ee8cec700381$var$toStringTag(ap);
                var bpTypeName = $bc26ee8cec700381$var$toStringTag(bp);
                if (apTypeName !== bpTypeName) rv[prfx + prop] = b[prop];
                else if (apTypeName === 'Object') $bc26ee8cec700381$var$getObjectDiff(ap, bp, rv, prfx + prop + '.');
                else if (ap !== bp) rv[prfx + prop] = b[prop];
            } else if (ap !== bp) rv[prfx + prop] = b[prop];
        }
    });
    $bc26ee8cec700381$var$keys(b).forEach(function(prop) {
        if (!$bc26ee8cec700381$var$hasOwn(a, prop)) rv[prfx + prop] = b[prop];
    });
    return rv;
}
function $bc26ee8cec700381$var$getEffectiveKeys(primaryKey, req) {
    if (req.type === 'delete') return req.keys;
    return req.keys || req.values.map(primaryKey.extractKey);
}
var $bc26ee8cec700381$var$hooksMiddleware = {
    stack: "dbcore",
    name: "HooksMiddleware",
    level: 2,
    create: function create(downCore) {
        return $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, downCore), {
            table: function table(tableName) {
                var downTable = downCore.table(tableName);
                var primaryKey = downTable.schema.primaryKey;
                var tableMiddleware = $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, downTable), {
                    mutate: function mutate(req) {
                        var dxTrans = $bc26ee8cec700381$var$PSD.trans;
                        var _a = dxTrans.table(tableName).hook, deleting = _a.deleting, creating = _a.creating, updating = _a.updating;
                        switch(req.type){
                            case 'add':
                                if (creating.fire === $bc26ee8cec700381$var$nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case 'put':
                                if (creating.fire === $bc26ee8cec700381$var$nop && updating.fire === $bc26ee8cec700381$var$nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case 'delete':
                                if (deleting.fire === $bc26ee8cec700381$var$nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case 'deleteRange':
                                if (deleting.fire === $bc26ee8cec700381$var$nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return deleteRange(req);
                                }, true);
                        }
                        return downTable.mutate(req);
                        function addPutOrDelete(req) {
                            var dxTrans = $bc26ee8cec700381$var$PSD.trans;
                            var keys = req.keys || $bc26ee8cec700381$var$getEffectiveKeys(primaryKey, req);
                            if (!keys) throw new Error("Keys missing");
                            req = req.type === 'add' || req.type === 'put' ? $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, req), {
                                keys: keys
                            }) : $bc26ee8cec700381$var$__assign({}, req);
                            if (req.type !== 'delete') req.values = $bc26ee8cec700381$var$__spreadArray([], req.values, true);
                            if (req.keys) req.keys = $bc26ee8cec700381$var$__spreadArray([], req.keys, true);
                            return $bc26ee8cec700381$var$getExistingValues(downTable, req, keys).then(function(existingValues) {
                                var contexts = keys.map(function(key, i) {
                                    var existingValue = existingValues[i];
                                    var ctx = {
                                        onerror: null,
                                        onsuccess: null
                                    };
                                    if (req.type === 'delete') deleting.fire.call(ctx, key, existingValue, dxTrans);
                                    else if (req.type === 'add' || existingValue === undefined) {
                                        var generatedPrimaryKey = creating.fire.call(ctx, key, req.values[i], dxTrans);
                                        if (key == null && generatedPrimaryKey != null) {
                                            key = generatedPrimaryKey;
                                            req.keys[i] = key;
                                            if (!primaryKey.outbound) $bc26ee8cec700381$var$setByKeyPath(req.values[i], primaryKey.keyPath, key);
                                        }
                                    } else {
                                        var objectDiff = $bc26ee8cec700381$var$getObjectDiff(existingValue, req.values[i]);
                                        var additionalChanges_1 = updating.fire.call(ctx, objectDiff, key, existingValue, dxTrans);
                                        if (additionalChanges_1) {
                                            var requestedValue_1 = req.values[i];
                                            Object.keys(additionalChanges_1).forEach(function(keyPath) {
                                                if ($bc26ee8cec700381$var$hasOwn(requestedValue_1, keyPath)) requestedValue_1[keyPath] = additionalChanges_1[keyPath];
                                                else $bc26ee8cec700381$var$setByKeyPath(requestedValue_1, keyPath, additionalChanges_1[keyPath]);
                                            });
                                        }
                                    }
                                    return ctx;
                                });
                                return downTable.mutate(req).then(function(_a) {
                                    var failures = _a.failures, results = _a.results, numFailures = _a.numFailures, lastResult = _a.lastResult;
                                    for(var i = 0; i < keys.length; ++i){
                                        var primKey = results ? results[i] : keys[i];
                                        var ctx = contexts[i];
                                        if (primKey == null) ctx.onerror && ctx.onerror(failures[i]);
                                        else ctx.onsuccess && ctx.onsuccess(req.type === 'put' && existingValues[i] ? req.values[i] : primKey);
                                    }
                                    return {
                                        failures: failures,
                                        results: results,
                                        numFailures: numFailures,
                                        lastResult: lastResult
                                    };
                                }).catch(function(error) {
                                    contexts.forEach(function(ctx) {
                                        return ctx.onerror && ctx.onerror(error);
                                    });
                                    return Promise.reject(error);
                                });
                            });
                        }
                        function deleteRange(req) {
                            return deleteNextChunk(req.trans, req.range, 10000);
                        }
                        function deleteNextChunk(trans, range, limit) {
                            return downTable.query({
                                trans: trans,
                                values: false,
                                query: {
                                    index: primaryKey,
                                    range: range
                                },
                                limit: limit
                            }).then(function(_a) {
                                var result = _a.result;
                                return addPutOrDelete({
                                    type: 'delete',
                                    keys: result,
                                    trans: trans
                                }).then(function(res) {
                                    if (res.numFailures > 0) return Promise.reject(res.failures[0]);
                                    if (result.length < limit) return {
                                        failures: [],
                                        numFailures: 0,
                                        lastResult: undefined
                                    };
                                    else return deleteNextChunk(trans, $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, range), {
                                        lower: result[result.length - 1],
                                        lowerOpen: true
                                    }), limit);
                                });
                            });
                        }
                    }
                });
                return tableMiddleware;
            }
        });
    }
};
function $bc26ee8cec700381$var$getExistingValues(table, req, effectiveKeys) {
    return req.type === "add" ? Promise.resolve([]) : table.getMany({
        trans: req.trans,
        keys: effectiveKeys,
        cache: "immutable"
    });
}
function $bc26ee8cec700381$var$getFromTransactionCache(keys, cache, clone) {
    try {
        if (!cache) return null;
        if (cache.keys.length < keys.length) return null;
        var result = [];
        for(var i = 0, j = 0; i < cache.keys.length && j < keys.length; ++i){
            if ($bc26ee8cec700381$export$6154dcdb7d23e37b(cache.keys[i], keys[j]) !== 0) continue;
            result.push(clone ? $bc26ee8cec700381$var$deepClone(cache.values[i]) : cache.values[i]);
            ++j;
        }
        return result.length === keys.length ? result : null;
    } catch (_a) {
        return null;
    }
}
var $bc26ee8cec700381$var$cacheExistingValuesMiddleware = {
    stack: "dbcore",
    level: -1,
    create: function create(core) {
        return {
            table: function table(tableName) {
                var table = core.table(tableName);
                return $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, table), {
                    getMany: function getMany(req) {
                        if (!req.cache) return table.getMany(req);
                        var cachedResult = $bc26ee8cec700381$var$getFromTransactionCache(req.keys, req.trans["_cache"], req.cache === "clone");
                        if (cachedResult) return $bc26ee8cec700381$var$DexiePromise.resolve(cachedResult);
                        return table.getMany(req).then(function(res) {
                            req.trans["_cache"] = {
                                keys: req.keys,
                                values: req.cache === "clone" ? $bc26ee8cec700381$var$deepClone(res) : res
                            };
                            return res;
                        });
                    },
                    mutate: function mutate(req) {
                        if (req.type !== "add") req.trans["_cache"] = null;
                        return table.mutate(req);
                    }
                });
            }
        };
    }
};
function $bc26ee8cec700381$var$isCachableContext(ctx, table) {
    return ctx.trans.mode === 'readonly' && !!ctx.subscr && !ctx.trans.explicit && ctx.trans.db._options.cache !== 'disabled' && !table.schema.primaryKey.outbound;
}
function $bc26ee8cec700381$var$isCachableRequest(type, req) {
    switch(type){
        case 'query':
            return req.values && !req.unique;
        case 'get':
            return false;
        case 'getMany':
            return false;
        case 'count':
            return false;
        case 'openCursor':
            return false;
    }
}
var $bc26ee8cec700381$var$observabilityMiddleware = {
    stack: "dbcore",
    level: 0,
    name: "Observability",
    create: function create(core) {
        var dbName = core.schema.name;
        var FULL_RANGE = new $bc26ee8cec700381$export$34cb5241245008dd(core.MIN_KEY, core.MAX_KEY);
        return $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, core), {
            transaction: function transaction(stores, mode, options) {
                if ($bc26ee8cec700381$var$PSD.subscr && mode !== 'readonly') throw new $bc26ee8cec700381$var$exceptions.ReadOnly("Readwrite transaction in liveQuery context. Querier source: ".concat($bc26ee8cec700381$var$PSD.querier));
                return core.transaction(stores, mode, options);
            },
            table: function table(tableName) {
                var table = core.table(tableName);
                var schema = table.schema;
                var primaryKey = schema.primaryKey, indexes = schema.indexes;
                var extractKey = primaryKey.extractKey, outbound = primaryKey.outbound;
                var indexesWithAutoIncPK = primaryKey.autoIncrement && indexes.filter(function(index) {
                    return index.compound && index.keyPath.includes(primaryKey.keyPath);
                });
                var tableClone = $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, table), {
                    mutate: function mutate(req) {
                        var _a, _b;
                        var trans = req.trans;
                        var mutatedParts = req.mutatedParts || (req.mutatedParts = {});
                        var getRangeSet = function getRangeSet(indexName) {
                            var part = "idb://".concat(dbName, "/").concat(tableName, "/").concat(indexName);
                            return mutatedParts[part] || (mutatedParts[part] = new $bc26ee8cec700381$export$34cb5241245008dd());
                        };
                        var pkRangeSet = getRangeSet("");
                        var delsRangeSet = getRangeSet(":dels");
                        var type = req.type;
                        var _c = req.type === "deleteRange" ? [
                            req.range
                        ] : req.type === "delete" ? [
                            req.keys
                        ] : req.values.length < 50 ? [
                            $bc26ee8cec700381$var$getEffectiveKeys(primaryKey, req).filter(function(id) {
                                return id;
                            }),
                            req.values
                        ] : [], keys = _c[0], newObjs = _c[1];
                        var oldCache = req.trans["_cache"];
                        if ($bc26ee8cec700381$var$isArray(keys)) {
                            pkRangeSet.addKeys(keys);
                            var oldObjs = type === 'delete' || keys.length === newObjs.length ? $bc26ee8cec700381$var$getFromTransactionCache(keys, oldCache) : null;
                            if (!oldObjs) delsRangeSet.addKeys(keys);
                            if (oldObjs || newObjs) $bc26ee8cec700381$var$trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs);
                        } else if (keys) {
                            var range = {
                                from: (_a = keys.lower) !== null && _a !== void 0 ? _a : core.MIN_KEY,
                                to: (_b = keys.upper) !== null && _b !== void 0 ? _b : core.MAX_KEY
                            };
                            delsRangeSet.add(range);
                            pkRangeSet.add(range);
                        } else {
                            pkRangeSet.add(FULL_RANGE);
                            delsRangeSet.add(FULL_RANGE);
                            schema.indexes.forEach(function(idx) {
                                return getRangeSet(idx.name).add(FULL_RANGE);
                            });
                        }
                        return table.mutate(req).then(function(res) {
                            if (keys && (req.type === 'add' || req.type === 'put')) {
                                pkRangeSet.addKeys(res.results);
                                if (indexesWithAutoIncPK) indexesWithAutoIncPK.forEach(function(idx) {
                                    var idxVals = req.values.map(function(v) {
                                        return idx.extractKey(v);
                                    });
                                    var pkPos = idx.keyPath.findIndex(function(prop) {
                                        return prop === primaryKey.keyPath;
                                    });
                                    for(var i = 0, len = res.results.length; i < len; ++i)idxVals[i][pkPos] = res.results[i];
                                    getRangeSet(idx.name).addKeys(idxVals);
                                });
                            }
                            trans.mutatedParts = $bc26ee8cec700381$var$extendObservabilitySet(trans.mutatedParts || {}, mutatedParts);
                            return res;
                        });
                    }
                });
                var getRange = function getRange(_a) {
                    var _b, _c;
                    var _d = _a.query, index = _d.index, range = _d.range;
                    return [
                        index,
                        new $bc26ee8cec700381$export$34cb5241245008dd((_b = range.lower) !== null && _b !== void 0 ? _b : core.MIN_KEY, (_c = range.upper) !== null && _c !== void 0 ? _c : core.MAX_KEY)
                    ];
                };
                var readSubscribers = {
                    get: function get(req) {
                        return [
                            primaryKey,
                            new $bc26ee8cec700381$export$34cb5241245008dd(req.key)
                        ];
                    },
                    getMany: function getMany(req) {
                        return [
                            primaryKey,
                            new $bc26ee8cec700381$export$34cb5241245008dd().addKeys(req.keys)
                        ];
                    },
                    count: getRange,
                    query: getRange,
                    openCursor: getRange
                };
                $bc26ee8cec700381$var$keys(readSubscribers).forEach(function(method) {
                    tableClone[method] = function(req) {
                        var subscr = $bc26ee8cec700381$var$PSD.subscr;
                        var isLiveQuery = !!subscr;
                        var cachable = $bc26ee8cec700381$var$isCachableContext($bc26ee8cec700381$var$PSD, table) && $bc26ee8cec700381$var$isCachableRequest(method, req);
                        var obsSet = cachable ? req.obsSet = {} : subscr;
                        if (isLiveQuery) {
                            var getRangeSet = function getRangeSet(indexName) {
                                var part = "idb://".concat(dbName, "/").concat(tableName, "/").concat(indexName);
                                return obsSet[part] || (obsSet[part] = new $bc26ee8cec700381$export$34cb5241245008dd());
                            };
                            var pkRangeSet_1 = getRangeSet("");
                            var delsRangeSet_1 = getRangeSet(":dels");
                            var _a = readSubscribers[method](req), queriedIndex = _a[0], queriedRanges = _a[1];
                            if (method === 'query' && queriedIndex.isPrimaryKey && !req.values) delsRangeSet_1.add(queriedRanges);
                            else getRangeSet(queriedIndex.name || "").add(queriedRanges);
                            if (!queriedIndex.isPrimaryKey) {
                                if (method === "count") delsRangeSet_1.add(FULL_RANGE);
                                else {
                                    var keysPromise_1 = method === "query" && outbound && req.values && table.query($bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, req), {
                                        values: false
                                    }));
                                    return table[method].apply(this, arguments).then(function(res) {
                                        if (method === "query") {
                                            if (outbound && req.values) return keysPromise_1.then(function(_a) {
                                                var resultingKeys = _a.result;
                                                pkRangeSet_1.addKeys(resultingKeys);
                                                return res;
                                            });
                                            var pKeys = req.values ? res.result.map(extractKey) : res.result;
                                            if (req.values) pkRangeSet_1.addKeys(pKeys);
                                            else delsRangeSet_1.addKeys(pKeys);
                                        } else if (method === "openCursor") {
                                            var cursor_1 = res;
                                            var wantValues_1 = req.values;
                                            return cursor_1 && Object.create(cursor_1, {
                                                key: {
                                                    get: function get() {
                                                        delsRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.key;
                                                    }
                                                },
                                                primaryKey: {
                                                    get: function get() {
                                                        var pkey = cursor_1.primaryKey;
                                                        delsRangeSet_1.addKey(pkey);
                                                        return pkey;
                                                    }
                                                },
                                                value: {
                                                    get: function get() {
                                                        wantValues_1 && pkRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.value;
                                                    }
                                                }
                                            });
                                        }
                                        return res;
                                    });
                                }
                            }
                        }
                        return table[method].apply(this, arguments);
                    };
                });
                return tableClone;
            }
        });
    }
};
function $bc26ee8cec700381$var$trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs) {
    function addAffectedIndex(ix) {
        var rangeSet = getRangeSet(ix.name || "");
        function extractKey(obj) {
            return obj != null ? ix.extractKey(obj) : null;
        }
        var addKeyOrKeys = function addKeyOrKeys(key) {
            return ix.multiEntry && $bc26ee8cec700381$var$isArray(key) ? key.forEach(function(key) {
                return rangeSet.addKey(key);
            }) : rangeSet.addKey(key);
        };
        (oldObjs || newObjs).forEach(function(_, i) {
            var oldKey = oldObjs && extractKey(oldObjs[i]);
            var newKey = newObjs && extractKey(newObjs[i]);
            if ($bc26ee8cec700381$export$6154dcdb7d23e37b(oldKey, newKey) !== 0) {
                if (oldKey != null) addKeyOrKeys(oldKey);
                if (newKey != null) addKeyOrKeys(newKey);
            }
        });
    }
    schema.indexes.forEach(addAffectedIndex);
}
function $bc26ee8cec700381$var$adjustOptimisticFromFailures(tblCache, req, res) {
    if (res.numFailures === 0) return req;
    if (req.type === 'deleteRange') return null;
    var numBulkOps = req.keys ? req.keys.length : 'values' in req && req.values ? req.values.length : 1;
    if (res.numFailures === numBulkOps) return null;
    var clone = $bc26ee8cec700381$var$__assign({}, req);
    if ($bc26ee8cec700381$var$isArray(clone.keys)) clone.keys = clone.keys.filter(function(_, i) {
        return !(i in res.failures);
    });
    if ('values' in clone && $bc26ee8cec700381$var$isArray(clone.values)) clone.values = clone.values.filter(function(_, i) {
        return !(i in res.failures);
    });
    return clone;
}
function $bc26ee8cec700381$var$isAboveLower(key, range) {
    return range.lower === undefined ? true : range.lowerOpen ? $bc26ee8cec700381$export$6154dcdb7d23e37b(key, range.lower) > 0 : $bc26ee8cec700381$export$6154dcdb7d23e37b(key, range.lower) >= 0;
}
function $bc26ee8cec700381$var$isBelowUpper(key, range) {
    return range.upper === undefined ? true : range.upperOpen ? $bc26ee8cec700381$export$6154dcdb7d23e37b(key, range.upper) < 0 : $bc26ee8cec700381$export$6154dcdb7d23e37b(key, range.upper) <= 0;
}
function $bc26ee8cec700381$var$isWithinRange(key, range) {
    return $bc26ee8cec700381$var$isAboveLower(key, range) && $bc26ee8cec700381$var$isBelowUpper(key, range);
}
function $bc26ee8cec700381$var$applyOptimisticOps(result, req, ops, table, cacheEntry, immutable) {
    if (!ops || ops.length === 0) return result;
    var index = req.query.index;
    var multiEntry = index.multiEntry;
    var queryRange = req.query.range;
    var primaryKey = table.schema.primaryKey;
    var extractPrimKey = primaryKey.extractKey;
    var extractIndex = index.extractKey;
    var extractLowLevelIndex = (index.lowLevelIndex || index).extractKey;
    var finalResult = ops.reduce(function(result, op) {
        var modifedResult = result;
        var includedValues = [];
        if (op.type === 'add' || op.type === 'put') {
            var includedPKs = new $bc26ee8cec700381$export$34cb5241245008dd();
            for(var i = op.values.length - 1; i >= 0; --i){
                var value = op.values[i];
                var pk = extractPrimKey(value);
                if (includedPKs.hasKey(pk)) continue;
                var key = extractIndex(value);
                if (multiEntry && $bc26ee8cec700381$var$isArray(key) ? key.some(function(k) {
                    return $bc26ee8cec700381$var$isWithinRange(k, queryRange);
                }) : $bc26ee8cec700381$var$isWithinRange(key, queryRange)) {
                    includedPKs.addKey(pk);
                    includedValues.push(value);
                }
            }
        }
        switch(op.type){
            case 'add':
                var existingKeys_1 = new $bc26ee8cec700381$export$34cb5241245008dd().addKeys(req.values ? result.map(function(v) {
                    return extractPrimKey(v);
                }) : result);
                modifedResult = result.concat(req.values ? includedValues.filter(function(v) {
                    var key = extractPrimKey(v);
                    if (existingKeys_1.hasKey(key)) return false;
                    existingKeys_1.addKey(key);
                    return true;
                }) : includedValues.map(function(v) {
                    return extractPrimKey(v);
                }).filter(function(k) {
                    if (existingKeys_1.hasKey(k)) return false;
                    existingKeys_1.addKey(k);
                    return true;
                }));
                break;
            case 'put':
                var keySet_1 = new $bc26ee8cec700381$export$34cb5241245008dd().addKeys(op.values.map(function(v) {
                    return extractPrimKey(v);
                }));
                modifedResult = result.filter(function(item) {
                    return !keySet_1.hasKey(req.values ? extractPrimKey(item) : item);
                }).concat(req.values ? includedValues : includedValues.map(function(v) {
                    return extractPrimKey(v);
                }));
                break;
            case 'delete':
                var keysToDelete_1 = new $bc26ee8cec700381$export$34cb5241245008dd().addKeys(op.keys);
                modifedResult = result.filter(function(item) {
                    return !keysToDelete_1.hasKey(req.values ? extractPrimKey(item) : item);
                });
                break;
            case 'deleteRange':
                var range_1 = op.range;
                modifedResult = result.filter(function(item) {
                    return !$bc26ee8cec700381$var$isWithinRange(extractPrimKey(item), range_1);
                });
                break;
        }
        return modifedResult;
    }, result);
    if (finalResult === result) return result;
    finalResult.sort(function(a, b) {
        return $bc26ee8cec700381$export$6154dcdb7d23e37b(extractLowLevelIndex(a), extractLowLevelIndex(b)) || $bc26ee8cec700381$export$6154dcdb7d23e37b(extractPrimKey(a), extractPrimKey(b));
    });
    if (req.limit && req.limit < Infinity) {
        if (finalResult.length > req.limit) finalResult.length = req.limit;
        else if (result.length === req.limit && finalResult.length < req.limit) cacheEntry.dirty = true;
    }
    return immutable ? Object.freeze(finalResult) : finalResult;
}
function $bc26ee8cec700381$var$areRangesEqual(r1, r2) {
    return $bc26ee8cec700381$export$6154dcdb7d23e37b(r1.lower, r2.lower) === 0 && $bc26ee8cec700381$export$6154dcdb7d23e37b(r1.upper, r2.upper) === 0 && !!r1.lowerOpen === !!r2.lowerOpen && !!r1.upperOpen === !!r2.upperOpen;
}
function $bc26ee8cec700381$var$compareLowers(lower1, lower2, lowerOpen1, lowerOpen2) {
    if (lower1 === undefined) return lower2 !== undefined ? -1 : 0;
    if (lower2 === undefined) return 1;
    var c = $bc26ee8cec700381$export$6154dcdb7d23e37b(lower1, lower2);
    if (c === 0) {
        if (lowerOpen1 && lowerOpen2) return 0;
        if (lowerOpen1) return 1;
        if (lowerOpen2) return -1;
    }
    return c;
}
function $bc26ee8cec700381$var$compareUppers(upper1, upper2, upperOpen1, upperOpen2) {
    if (upper1 === undefined) return upper2 !== undefined ? 1 : 0;
    if (upper2 === undefined) return -1;
    var c = $bc26ee8cec700381$export$6154dcdb7d23e37b(upper1, upper2);
    if (c === 0) {
        if (upperOpen1 && upperOpen2) return 0;
        if (upperOpen1) return -1;
        if (upperOpen2) return 1;
    }
    return c;
}
function $bc26ee8cec700381$var$isSuperRange(r1, r2) {
    return $bc26ee8cec700381$var$compareLowers(r1.lower, r2.lower, r1.lowerOpen, r2.lowerOpen) <= 0 && $bc26ee8cec700381$var$compareUppers(r1.upper, r2.upper, r1.upperOpen, r2.upperOpen) >= 0;
}
function $bc26ee8cec700381$var$findCompatibleQuery(dbName, tableName, type, req) {
    var tblCache = $bc26ee8cec700381$var$cache["idb://".concat(dbName, "/").concat(tableName)];
    if (!tblCache) return [];
    var queries = tblCache.queries[type];
    if (!queries) return [
        null,
        false,
        tblCache,
        null
    ];
    var indexName = req.query ? req.query.index.name : null;
    var entries = queries[indexName || ''];
    if (!entries) return [
        null,
        false,
        tblCache,
        null
    ];
    switch(type){
        case 'query':
            var equalEntry = entries.find(function(entry) {
                return entry.req.limit === req.limit && entry.req.values === req.values && $bc26ee8cec700381$var$areRangesEqual(entry.req.query.range, req.query.range);
            });
            if (equalEntry) return [
                equalEntry,
                true,
                tblCache,
                entries
            ];
            var superEntry = entries.find(function(entry) {
                var limit = 'limit' in entry.req ? entry.req.limit : Infinity;
                return limit >= req.limit && (req.values ? entry.req.values : true) && $bc26ee8cec700381$var$isSuperRange(entry.req.query.range, req.query.range);
            });
            return [
                superEntry,
                false,
                tblCache,
                entries
            ];
        case 'count':
            var countQuery = entries.find(function(entry) {
                return $bc26ee8cec700381$var$areRangesEqual(entry.req.query.range, req.query.range);
            });
            return [
                countQuery,
                !!countQuery,
                tblCache,
                entries
            ];
    }
}
function $bc26ee8cec700381$var$subscribeToCacheEntry(cacheEntry, container, requery, signal) {
    cacheEntry.subscribers.add(requery);
    signal.addEventListener("abort", function() {
        cacheEntry.subscribers.delete(requery);
        if (cacheEntry.subscribers.size === 0) $bc26ee8cec700381$var$enqueForDeletion(cacheEntry, container);
    });
}
function $bc26ee8cec700381$var$enqueForDeletion(cacheEntry, container) {
    setTimeout(function() {
        if (cacheEntry.subscribers.size === 0) $bc26ee8cec700381$var$delArrayItem(container, cacheEntry);
    }, 3000);
}
var $bc26ee8cec700381$var$cacheMiddleware = {
    stack: 'dbcore',
    level: 0,
    name: 'Cache',
    create: function create(core) {
        var dbName = core.schema.name;
        var coreMW = $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, core), {
            transaction: function transaction(stores, mode, options) {
                var idbtrans = core.transaction(stores, mode, options);
                if (mode === 'readwrite') {
                    var ac_1 = new AbortController();
                    var signal = ac_1.signal;
                    var endTransaction = function endTransaction(wasCommitted) {
                        return function() {
                            ac_1.abort();
                            if (mode === 'readwrite') {
                                var affectedSubscribers_1 = new Set();
                                for(var _i = 0, stores_1 = stores; _i < stores_1.length; _i++){
                                    var storeName = stores_1[_i];
                                    var tblCache = $bc26ee8cec700381$var$cache["idb://".concat(dbName, "/").concat(storeName)];
                                    if (tblCache) {
                                        var table = core.table(storeName);
                                        var ops = tblCache.optimisticOps.filter(function(op) {
                                            return op.trans === idbtrans;
                                        });
                                        if (idbtrans._explicit && wasCommitted && idbtrans.mutatedParts) for(var _a = 0, _b = Object.values(tblCache.queries.query); _a < _b.length; _a++){
                                            var entries = _b[_a];
                                            for(var _c = 0, _d = entries.slice(); _c < _d.length; _c++){
                                                var entry = _d[_c];
                                                if ($bc26ee8cec700381$var$obsSetsOverlap(entry.obsSet, idbtrans.mutatedParts)) {
                                                    $bc26ee8cec700381$var$delArrayItem(entries, entry);
                                                    entry.subscribers.forEach(function(requery) {
                                                        return affectedSubscribers_1.add(requery);
                                                    });
                                                }
                                            }
                                        }
                                        else if (ops.length > 0) {
                                            tblCache.optimisticOps = tblCache.optimisticOps.filter(function(op) {
                                                return op.trans !== idbtrans;
                                            });
                                            for(var _e = 0, _f = Object.values(tblCache.queries.query); _e < _f.length; _e++){
                                                var entries = _f[_e];
                                                for(var _g = 0, _h = entries.slice(); _g < _h.length; _g++){
                                                    var entry = _h[_g];
                                                    if (entry.res != null && idbtrans.mutatedParts) {
                                                        if (wasCommitted && !entry.dirty) {
                                                            var freezeResults = Object.isFrozen(entry.res);
                                                            var modRes = $bc26ee8cec700381$var$applyOptimisticOps(entry.res, entry.req, ops, table, entry, freezeResults);
                                                            if (entry.dirty) {
                                                                $bc26ee8cec700381$var$delArrayItem(entries, entry);
                                                                entry.subscribers.forEach(function(requery) {
                                                                    return affectedSubscribers_1.add(requery);
                                                                });
                                                            } else if (modRes !== entry.res) {
                                                                entry.res = modRes;
                                                                entry.promise = $bc26ee8cec700381$var$DexiePromise.resolve({
                                                                    result: modRes
                                                                });
                                                            }
                                                        } else {
                                                            if (entry.dirty) $bc26ee8cec700381$var$delArrayItem(entries, entry);
                                                            entry.subscribers.forEach(function(requery) {
                                                                return affectedSubscribers_1.add(requery);
                                                            });
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                affectedSubscribers_1.forEach(function(requery) {
                                    return requery();
                                });
                            }
                        };
                    };
                    idbtrans.addEventListener('abort', endTransaction(false), {
                        signal: signal
                    });
                    idbtrans.addEventListener('error', endTransaction(false), {
                        signal: signal
                    });
                    idbtrans.addEventListener('complete', endTransaction(true), {
                        signal: signal
                    });
                }
                return idbtrans;
            },
            table: function table(tableName) {
                var downTable = core.table(tableName);
                var primKey = downTable.schema.primaryKey;
                var tableMW = $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, downTable), {
                    mutate: function mutate(req) {
                        var trans = $bc26ee8cec700381$var$PSD.trans;
                        if (primKey.outbound || trans.db._options.cache === 'disabled' || trans.explicit || trans.idbtrans.mode !== 'readwrite') return downTable.mutate(req);
                        var tblCache = $bc26ee8cec700381$var$cache["idb://".concat(dbName, "/").concat(tableName)];
                        if (!tblCache) return downTable.mutate(req);
                        var promise = downTable.mutate(req);
                        if ((req.type === 'add' || req.type === 'put') && (req.values.length >= 50 || $bc26ee8cec700381$var$getEffectiveKeys(primKey, req).some(function(key) {
                            return key == null;
                        }))) promise.then(function(res) {
                            var reqWithResolvedKeys = $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, req), {
                                values: req.values.map(function(value, i) {
                                    var _a;
                                    if (res.failures[i]) return value;
                                    var valueWithKey = ((_a = primKey.keyPath) === null || _a === void 0 ? void 0 : _a.includes('.')) ? $bc26ee8cec700381$var$deepClone(value) : $bc26ee8cec700381$var$__assign({}, value);
                                    $bc26ee8cec700381$var$setByKeyPath(valueWithKey, primKey.keyPath, res.results[i]);
                                    return valueWithKey;
                                })
                            });
                            var adjustedReq = $bc26ee8cec700381$var$adjustOptimisticFromFailures(tblCache, reqWithResolvedKeys, res);
                            tblCache.optimisticOps.push(adjustedReq);
                            queueMicrotask(function() {
                                return req.mutatedParts && $bc26ee8cec700381$var$signalSubscribersLazily(req.mutatedParts);
                            });
                        });
                        else {
                            tblCache.optimisticOps.push(req);
                            req.mutatedParts && $bc26ee8cec700381$var$signalSubscribersLazily(req.mutatedParts);
                            promise.then(function(res) {
                                if (res.numFailures > 0) {
                                    $bc26ee8cec700381$var$delArrayItem(tblCache.optimisticOps, req);
                                    var adjustedReq = $bc26ee8cec700381$var$adjustOptimisticFromFailures(tblCache, req, res);
                                    if (adjustedReq) tblCache.optimisticOps.push(adjustedReq);
                                    req.mutatedParts && $bc26ee8cec700381$var$signalSubscribersLazily(req.mutatedParts);
                                }
                            });
                            promise.catch(function() {
                                $bc26ee8cec700381$var$delArrayItem(tblCache.optimisticOps, req);
                                req.mutatedParts && $bc26ee8cec700381$var$signalSubscribersLazily(req.mutatedParts);
                            });
                        }
                        return promise;
                    },
                    query: function query(req) {
                        var _a;
                        if (!$bc26ee8cec700381$var$isCachableContext($bc26ee8cec700381$var$PSD, downTable) || !$bc26ee8cec700381$var$isCachableRequest("query", req)) return downTable.query(req);
                        var freezeResults = ((_a = $bc26ee8cec700381$var$PSD.trans) === null || _a === void 0 ? void 0 : _a.db._options.cache) === 'immutable';
                        var _b = $bc26ee8cec700381$var$PSD, requery = _b.requery, signal = _b.signal;
                        var _c = $bc26ee8cec700381$var$findCompatibleQuery(dbName, tableName, 'query', req), cacheEntry = _c[0], exactMatch = _c[1], tblCache = _c[2], container = _c[3];
                        if (cacheEntry && exactMatch) cacheEntry.obsSet = req.obsSet;
                        else {
                            var promise = downTable.query(req).then(function(res) {
                                var result = res.result;
                                if (cacheEntry) cacheEntry.res = result;
                                if (freezeResults) {
                                    for(var i = 0, l = result.length; i < l; ++i)Object.freeze(result[i]);
                                    Object.freeze(result);
                                } else res.result = $bc26ee8cec700381$var$deepClone(result);
                                return res;
                            }).catch(function(error) {
                                if (container && cacheEntry) $bc26ee8cec700381$var$delArrayItem(container, cacheEntry);
                                return Promise.reject(error);
                            });
                            cacheEntry = {
                                obsSet: req.obsSet,
                                promise: promise,
                                subscribers: new Set(),
                                type: 'query',
                                req: req,
                                dirty: false
                            };
                            if (container) container.push(cacheEntry);
                            else {
                                container = [
                                    cacheEntry
                                ];
                                if (!tblCache) tblCache = $bc26ee8cec700381$var$cache["idb://".concat(dbName, "/").concat(tableName)] = {
                                    queries: {
                                        query: {},
                                        count: {}
                                    },
                                    objs: new Map(),
                                    optimisticOps: [],
                                    unsignaledParts: {}
                                };
                                tblCache.queries.query[req.query.index.name || ''] = container;
                            }
                        }
                        $bc26ee8cec700381$var$subscribeToCacheEntry(cacheEntry, container, requery, signal);
                        return cacheEntry.promise.then(function(res) {
                            return {
                                result: $bc26ee8cec700381$var$applyOptimisticOps(res.result, req, tblCache === null || tblCache === void 0 ? void 0 : tblCache.optimisticOps, downTable, cacheEntry, freezeResults)
                            };
                        });
                    }
                });
                return tableMW;
            }
        });
        return coreMW;
    }
};
function $bc26ee8cec700381$var$vipify(target, vipDb) {
    return new Proxy(target, {
        get: function get(target, prop, receiver) {
            if (prop === 'db') return vipDb;
            return Reflect.get(target, prop, receiver);
        }
    });
}
var $bc26ee8cec700381$export$4ece27d405df7279 = function() {
    function Dexie(name, options) {
        var _this = this;
        this._middlewares = {};
        this.verno = 0;
        var deps = Dexie.dependencies;
        this._options = options = $bc26ee8cec700381$var$__assign({
            addons: Dexie.addons,
            autoOpen: true,
            indexedDB: deps.indexedDB,
            IDBKeyRange: deps.IDBKeyRange,
            cache: 'cloned'
        }, options);
        this._deps = {
            indexedDB: options.indexedDB,
            IDBKeyRange: options.IDBKeyRange
        };
        var addons = options.addons;
        this._dbSchema = {};
        this._versions = [];
        this._storeNames = [];
        this._allTables = {};
        this.idbdb = null;
        this._novip = this;
        var state = {
            dbOpenError: null,
            isBeingOpened: false,
            onReadyBeingFired: null,
            openComplete: false,
            dbReadyResolve: $bc26ee8cec700381$var$nop,
            dbReadyPromise: null,
            cancelOpen: $bc26ee8cec700381$var$nop,
            openCanceller: null,
            autoSchema: true,
            PR1398_maxLoop: 3,
            autoOpen: options.autoOpen
        };
        state.dbReadyPromise = new $bc26ee8cec700381$var$DexiePromise(function(resolve) {
            state.dbReadyResolve = resolve;
        });
        state.openCanceller = new $bc26ee8cec700381$var$DexiePromise(function(_, reject) {
            state.cancelOpen = reject;
        });
        this._state = state;
        this.name = name;
        this.on = $bc26ee8cec700381$var$Events(this, "populate", "blocked", "versionchange", "close", {
            ready: [
                $bc26ee8cec700381$var$promisableChain,
                $bc26ee8cec700381$var$nop
            ]
        });
        this.once = function(event, callback) {
            var fn = function fn1() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                _this.on(event).unsubscribe(fn);
                callback.apply(_this, args);
            };
            return _this.on(event, fn);
        };
        this.on.ready.subscribe = $bc26ee8cec700381$var$override(this.on.ready.subscribe, function(subscribe) {
            return function(subscriber, bSticky) {
                Dexie.vip(function() {
                    var state = _this._state;
                    if (state.openComplete) {
                        if (!state.dbOpenError) $bc26ee8cec700381$var$DexiePromise.resolve().then(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else if (state.onReadyBeingFired) {
                        state.onReadyBeingFired.push(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else {
                        subscribe(subscriber);
                        var db_1 = _this;
                        if (!bSticky) subscribe(function unsubscribe() {
                            db_1.on.ready.unsubscribe(subscriber);
                            db_1.on.ready.unsubscribe(unsubscribe);
                        });
                    }
                });
            };
        });
        this.Collection = $bc26ee8cec700381$var$createCollectionConstructor(this);
        this.Table = $bc26ee8cec700381$var$createTableConstructor(this);
        this.Transaction = $bc26ee8cec700381$var$createTransactionConstructor(this);
        this.Version = $bc26ee8cec700381$var$createVersionConstructor(this);
        this.WhereClause = $bc26ee8cec700381$var$createWhereClauseConstructor(this);
        this.on("versionchange", function(ev) {
            if (ev.newVersion > 0) console.warn("Another connection wants to upgrade database '".concat(_this.name, "'. Closing db now to resume the upgrade."));
            else console.warn("Another connection wants to delete database '".concat(_this.name, "'. Closing db now to resume the delete request."));
            _this.close({
                disableAutoOpen: false
            });
        });
        this.on("blocked", function(ev) {
            if (!ev.newVersion || ev.newVersion < ev.oldVersion) console.warn("Dexie.delete('".concat(_this.name, "') was blocked"));
            else console.warn("Upgrade '".concat(_this.name, "' blocked by other connection holding version ").concat(ev.oldVersion / 10));
        });
        this._maxKey = $bc26ee8cec700381$var$getMaxKey(options.IDBKeyRange);
        this._createTransaction = function(mode, storeNames, dbschema, parentTransaction) {
            return new _this.Transaction(mode, storeNames, dbschema, _this._options.chromeTransactionDurability, parentTransaction);
        };
        this._fireOnBlocked = function(ev) {
            _this.on("blocked").fire(ev);
            $bc26ee8cec700381$var$connections.filter(function(c) {
                return c.name === _this.name && c !== _this && !c._state.vcFired;
            }).map(function(c) {
                return c.on("versionchange").fire(ev);
            });
        };
        this.use($bc26ee8cec700381$var$cacheExistingValuesMiddleware);
        this.use($bc26ee8cec700381$var$cacheMiddleware);
        this.use($bc26ee8cec700381$var$observabilityMiddleware);
        this.use($bc26ee8cec700381$var$virtualIndexMiddleware);
        this.use($bc26ee8cec700381$var$hooksMiddleware);
        var vipDB = new Proxy(this, {
            get: function get(_, prop, receiver) {
                if (prop === '_vip') return true;
                if (prop === 'table') return function(tableName) {
                    return $bc26ee8cec700381$var$vipify(_this.table(tableName), vipDB);
                };
                var rv = Reflect.get(_, prop, receiver);
                if (rv instanceof $bc26ee8cec700381$var$Table) return $bc26ee8cec700381$var$vipify(rv, vipDB);
                if (prop === 'tables') return rv.map(function(t) {
                    return $bc26ee8cec700381$var$vipify(t, vipDB);
                });
                if (prop === '_createTransaction') return function() {
                    var tx = rv.apply(this, arguments);
                    return $bc26ee8cec700381$var$vipify(tx, vipDB);
                };
                return rv;
            }
        });
        this.vip = vipDB;
        addons.forEach(function(addon) {
            return addon(_this);
        });
    }
    Dexie.prototype.version = function(versionNumber) {
        if (isNaN(versionNumber) || versionNumber < 0.1) throw new $bc26ee8cec700381$var$exceptions.Type("Given version is not a positive number");
        versionNumber = Math.round(versionNumber * 10) / 10;
        if (this.idbdb || this._state.isBeingOpened) throw new $bc26ee8cec700381$var$exceptions.Schema("Cannot add version when database is open");
        this.verno = Math.max(this.verno, versionNumber);
        var versions = this._versions;
        var versionInstance = versions.filter(function(v) {
            return v._cfg.version === versionNumber;
        })[0];
        if (versionInstance) return versionInstance;
        versionInstance = new this.Version(versionNumber);
        versions.push(versionInstance);
        versions.sort($bc26ee8cec700381$var$lowerVersionFirst);
        versionInstance.stores({});
        this._state.autoSchema = false;
        return versionInstance;
    };
    Dexie.prototype._whenReady = function(fn) {
        var _this = this;
        return this.idbdb && (this._state.openComplete || $bc26ee8cec700381$var$PSD.letThrough || this._vip) ? fn() : new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
            if (_this._state.openComplete) return reject(new $bc26ee8cec700381$var$exceptions.DatabaseClosed(_this._state.dbOpenError));
            if (!_this._state.isBeingOpened) {
                if (!_this._state.autoOpen) {
                    reject(new $bc26ee8cec700381$var$exceptions.DatabaseClosed());
                    return;
                }
                _this.open().catch($bc26ee8cec700381$var$nop);
            }
            _this._state.dbReadyPromise.then(resolve, reject);
        }).then(fn);
    };
    Dexie.prototype.use = function(_a) {
        var stack = _a.stack, create = _a.create, level = _a.level, name = _a.name;
        if (name) this.unuse({
            stack: stack,
            name: name
        });
        var middlewares = this._middlewares[stack] || (this._middlewares[stack] = []);
        middlewares.push({
            stack: stack,
            create: create,
            level: level == null ? 10 : level,
            name: name
        });
        middlewares.sort(function(a, b) {
            return a.level - b.level;
        });
        return this;
    };
    Dexie.prototype.unuse = function(_a) {
        var stack = _a.stack, name = _a.name, create = _a.create;
        if (stack && this._middlewares[stack]) this._middlewares[stack] = this._middlewares[stack].filter(function(mw) {
            return create ? mw.create !== create : name ? mw.name !== name : false;
        });
        return this;
    };
    Dexie.prototype.open = function() {
        var _this = this;
        return $bc26ee8cec700381$var$usePSD($bc26ee8cec700381$var$globalPSD, function() {
            return $bc26ee8cec700381$var$dexieOpen(_this);
        });
    };
    Dexie.prototype._close = function() {
        this.on.close.fire(new CustomEvent('close'));
        var state = this._state;
        var idx = $bc26ee8cec700381$var$connections.indexOf(this);
        if (idx >= 0) $bc26ee8cec700381$var$connections.splice(idx, 1);
        if (this.idbdb) {
            try {
                this.idbdb.close();
            } catch (e) {}
            this.idbdb = null;
        }
        if (!state.isBeingOpened) {
            state.dbReadyPromise = new $bc26ee8cec700381$var$DexiePromise(function(resolve) {
                state.dbReadyResolve = resolve;
            });
            state.openCanceller = new $bc26ee8cec700381$var$DexiePromise(function(_, reject) {
                state.cancelOpen = reject;
            });
        }
    };
    Dexie.prototype.close = function(_a) {
        var _b = _a === void 0 ? {
            disableAutoOpen: true
        } : _a, disableAutoOpen = _b.disableAutoOpen;
        var state = this._state;
        if (disableAutoOpen) {
            if (state.isBeingOpened) state.cancelOpen(new $bc26ee8cec700381$var$exceptions.DatabaseClosed());
            this._close();
            state.autoOpen = false;
            state.dbOpenError = new $bc26ee8cec700381$var$exceptions.DatabaseClosed();
        } else {
            this._close();
            state.autoOpen = this._options.autoOpen || state.isBeingOpened;
            state.openComplete = false;
            state.dbOpenError = null;
        }
    };
    Dexie.prototype.delete = function(closeOptions) {
        var _this = this;
        if (closeOptions === void 0) closeOptions = {
            disableAutoOpen: true
        };
        var hasInvalidArguments = arguments.length > 0 && (0, $2bfPH._)(arguments[0]) !== 'object';
        var state = this._state;
        return new $bc26ee8cec700381$var$DexiePromise(function(resolve, reject) {
            var doDelete = function doDelete() {
                _this.close(closeOptions);
                var req = _this._deps.indexedDB.deleteDatabase(_this.name);
                req.onsuccess = $bc26ee8cec700381$var$wrap(function() {
                    $bc26ee8cec700381$var$_onDatabaseDeleted(_this._deps, _this.name);
                    resolve();
                });
                req.onerror = $bc26ee8cec700381$var$eventRejectHandler(reject);
                req.onblocked = _this._fireOnBlocked;
            };
            if (hasInvalidArguments) throw new $bc26ee8cec700381$var$exceptions.InvalidArgument("Invalid closeOptions argument to db.delete()");
            if (state.isBeingOpened) state.dbReadyPromise.then(doDelete);
            else doDelete();
        });
    };
    Dexie.prototype.backendDB = function() {
        return this.idbdb;
    };
    Dexie.prototype.isOpen = function() {
        return this.idbdb !== null;
    };
    Dexie.prototype.hasBeenClosed = function() {
        var dbOpenError = this._state.dbOpenError;
        return dbOpenError && dbOpenError.name === 'DatabaseClosed';
    };
    Dexie.prototype.hasFailed = function() {
        return this._state.dbOpenError !== null;
    };
    Dexie.prototype.dynamicallyOpened = function() {
        return this._state.autoSchema;
    };
    Object.defineProperty(Dexie.prototype, "tables", {
        get: function get() {
            var _this = this;
            return $bc26ee8cec700381$var$keys(this._allTables).map(function(name) {
                return _this._allTables[name];
            });
        },
        enumerable: false,
        configurable: true
    });
    Dexie.prototype.transaction = function() {
        var args = $bc26ee8cec700381$var$extractTransactionArgs.apply(this, arguments);
        return this._transaction.apply(this, args);
    };
    Dexie.prototype._transaction = function(mode, tables, scopeFunc) {
        var _this = this;
        var parentTransaction = $bc26ee8cec700381$var$PSD.trans;
        if (!parentTransaction || parentTransaction.db !== this || mode.indexOf('!') !== -1) parentTransaction = null;
        var onlyIfCompatible = mode.indexOf('?') !== -1;
        mode = mode.replace('!', '').replace('?', '');
        var idbMode, storeNames;
        try {
            storeNames = tables.map(function(table) {
                var storeName = table instanceof _this.Table ? table.name : table;
                if (typeof storeName !== 'string') throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
                return storeName;
            });
            if (mode == "r" || mode === $bc26ee8cec700381$var$READONLY) idbMode = $bc26ee8cec700381$var$READONLY;
            else if (mode == "rw" || mode == $bc26ee8cec700381$var$READWRITE) idbMode = $bc26ee8cec700381$var$READWRITE;
            else throw new $bc26ee8cec700381$var$exceptions.InvalidArgument("Invalid transaction mode: " + mode);
            if (parentTransaction) {
                if (parentTransaction.mode === $bc26ee8cec700381$var$READONLY && idbMode === $bc26ee8cec700381$var$READWRITE) {
                    if (onlyIfCompatible) parentTransaction = null;
                    else throw new $bc26ee8cec700381$var$exceptions.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
                }
                if (parentTransaction) storeNames.forEach(function(storeName) {
                    if (parentTransaction && parentTransaction.storeNames.indexOf(storeName) === -1) {
                        if (onlyIfCompatible) parentTransaction = null;
                        else throw new $bc26ee8cec700381$var$exceptions.SubTransaction("Table " + storeName + " not included in parent transaction.");
                    }
                });
                if (onlyIfCompatible && parentTransaction && !parentTransaction.active) parentTransaction = null;
            }
        } catch (e) {
            return parentTransaction ? parentTransaction._promise(null, function(_, reject) {
                reject(e);
            }) : $bc26ee8cec700381$var$rejection(e);
        }
        var enterTransaction = $bc26ee8cec700381$var$enterTransactionScope.bind(null, this, idbMode, storeNames, parentTransaction, scopeFunc);
        return parentTransaction ? parentTransaction._promise(idbMode, enterTransaction, "lock") : $bc26ee8cec700381$var$PSD.trans ? $bc26ee8cec700381$var$usePSD($bc26ee8cec700381$var$PSD.transless, function() {
            return _this._whenReady(enterTransaction);
        }) : this._whenReady(enterTransaction);
    };
    Dexie.prototype.table = function(tableName) {
        if (!$bc26ee8cec700381$var$hasOwn(this._allTables, tableName)) throw new $bc26ee8cec700381$var$exceptions.InvalidTable("Table ".concat(tableName, " does not exist"));
        return this._allTables[tableName];
    };
    return Dexie;
}();
var $bc26ee8cec700381$var$symbolObservable = typeof Symbol !== "undefined" && "observable" in Symbol ? Symbol.observable : "@@observable";
var $bc26ee8cec700381$var$Observable = function() {
    function Observable(subscribe) {
        this._subscribe = subscribe;
    }
    Observable.prototype.subscribe = function(x, error, complete) {
        return this._subscribe(!x || typeof x === "function" ? {
            next: x,
            error: error,
            complete: complete
        } : x);
    };
    Observable.prototype[$bc26ee8cec700381$var$symbolObservable] = function() {
        return this;
    };
    return Observable;
}();
var $bc26ee8cec700381$var$domDeps;
try {
    $bc26ee8cec700381$var$domDeps = {
        indexedDB: $bc26ee8cec700381$var$_global.indexedDB || $bc26ee8cec700381$var$_global.mozIndexedDB || $bc26ee8cec700381$var$_global.webkitIndexedDB || $bc26ee8cec700381$var$_global.msIndexedDB,
        IDBKeyRange: $bc26ee8cec700381$var$_global.IDBKeyRange || $bc26ee8cec700381$var$_global.webkitIDBKeyRange
    };
} catch (e) {
    $bc26ee8cec700381$var$domDeps = {
        indexedDB: null,
        IDBKeyRange: null
    };
}
function $bc26ee8cec700381$export$6a9705d8f6f38796(querier) {
    var hasValue = false;
    var currentValue;
    var observable = new $bc26ee8cec700381$var$Observable(function(observer) {
        var scopeFuncIsAsync = $bc26ee8cec700381$var$isAsyncFunction(querier);
        function execute(ctx) {
            var wasRootExec = $bc26ee8cec700381$var$beginMicroTickScope();
            try {
                if (scopeFuncIsAsync) $bc26ee8cec700381$var$incrementExpectedAwaits();
                var rv = $bc26ee8cec700381$var$newScope(querier, ctx);
                if (scopeFuncIsAsync) rv = rv.finally($bc26ee8cec700381$var$decrementExpectedAwaits);
                return rv;
            } finally{
                wasRootExec && $bc26ee8cec700381$var$endMicroTickScope();
            }
        }
        var closed = false;
        var abortController;
        var accumMuts = {};
        var currentObs = {};
        var subscription = {
            get closed () {
                return closed;
            },
            unsubscribe: function unsubscribe() {
                if (closed) return;
                closed = true;
                if (abortController) abortController.abort();
                if (startedListening) $bc26ee8cec700381$var$globalEvents.storagemutated.unsubscribe(mutationListener);
            }
        };
        observer.start && observer.start(subscription);
        var startedListening = false;
        var doQuery = function doQuery() {
            return $bc26ee8cec700381$var$execInGlobalContext(_doQuery);
        };
        function shouldNotify() {
            return $bc26ee8cec700381$var$obsSetsOverlap(currentObs, accumMuts);
        }
        var mutationListener = function mutationListener(parts) {
            $bc26ee8cec700381$var$extendObservabilitySet(accumMuts, parts);
            if (shouldNotify()) doQuery();
        };
        var _doQuery = function _doQuery() {
            if (closed || !$bc26ee8cec700381$var$domDeps.indexedDB) return;
            accumMuts = {};
            var subscr = {};
            if (abortController) abortController.abort();
            abortController = new AbortController();
            var ctx = {
                subscr: subscr,
                signal: abortController.signal,
                requery: doQuery,
                querier: querier,
                trans: null
            };
            var ret = execute(ctx);
            Promise.resolve(ret).then(function(result) {
                hasValue = true;
                currentValue = result;
                if (closed || ctx.signal.aborted) return;
                accumMuts = {};
                currentObs = subscr;
                if (!$bc26ee8cec700381$var$objectIsEmpty(currentObs) && !startedListening) {
                    $bc26ee8cec700381$var$globalEvents($bc26ee8cec700381$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, mutationListener);
                    startedListening = true;
                }
                $bc26ee8cec700381$var$execInGlobalContext(function() {
                    return !closed && observer.next && observer.next(result);
                });
            }, function(err) {
                hasValue = false;
                if (![
                    'DatabaseClosedError',
                    'AbortError'
                ].includes(err === null || err === void 0 ? void 0 : err.name)) {
                    if (!closed) $bc26ee8cec700381$var$execInGlobalContext(function() {
                        if (closed) return;
                        observer.error && observer.error(err);
                    });
                }
            });
        };
        setTimeout(doQuery, 0);
        return subscription;
    });
    observable.hasValue = function() {
        return hasValue;
    };
    observable.getValue = function() {
        return currentValue;
    };
    return observable;
}
var $bc26ee8cec700381$var$Dexie = $bc26ee8cec700381$export$4ece27d405df7279;
$bc26ee8cec700381$var$props($bc26ee8cec700381$var$Dexie, $bc26ee8cec700381$var$__assign($bc26ee8cec700381$var$__assign({}, $bc26ee8cec700381$var$fullNameExceptions), {
    delete: function _delete(databaseName) {
        var db = new $bc26ee8cec700381$var$Dexie(databaseName, {
            addons: []
        });
        return db.delete();
    },
    exists: function exists(name) {
        return new $bc26ee8cec700381$var$Dexie(name, {
            addons: []
        }).open().then(function(db) {
            db.close();
            return true;
        }).catch('NoSuchDatabaseError', function() {
            return false;
        });
    },
    getDatabaseNames: function getDatabaseNames1(cb) {
        try {
            return $bc26ee8cec700381$var$getDatabaseNames($bc26ee8cec700381$var$Dexie.dependencies).then(cb);
        } catch (_a) {
            return $bc26ee8cec700381$var$rejection(new $bc26ee8cec700381$var$exceptions.MissingAPI());
        }
    },
    defineClass: function defineClass() {
        function Class(content) {
            $bc26ee8cec700381$var$extend(this, content);
        }
        return Class;
    },
    ignoreTransaction: function ignoreTransaction(scopeFunc) {
        return $bc26ee8cec700381$var$PSD.trans ? $bc26ee8cec700381$var$usePSD($bc26ee8cec700381$var$PSD.transless, scopeFunc) : scopeFunc();
    },
    vip: $bc26ee8cec700381$var$vip,
    async: function async(generatorFn) {
        return function() {
            try {
                var rv = $bc26ee8cec700381$var$awaitIterator(generatorFn.apply(this, arguments));
                if (!rv || typeof rv.then !== 'function') return $bc26ee8cec700381$var$DexiePromise.resolve(rv);
                return rv;
            } catch (e) {
                return $bc26ee8cec700381$var$rejection(e);
            }
        };
    },
    spawn: function spawn(generatorFn, args, thiz) {
        try {
            var rv = $bc26ee8cec700381$var$awaitIterator(generatorFn.apply(thiz, args || []));
            if (!rv || typeof rv.then !== 'function') return $bc26ee8cec700381$var$DexiePromise.resolve(rv);
            return rv;
        } catch (e) {
            return $bc26ee8cec700381$var$rejection(e);
        }
    },
    currentTransaction: {
        get: function get() {
            return $bc26ee8cec700381$var$PSD.trans || null;
        }
    },
    waitFor: function waitFor(promiseOrFunction, optionalTimeout) {
        var promise = $bc26ee8cec700381$var$DexiePromise.resolve(typeof promiseOrFunction === 'function' ? $bc26ee8cec700381$var$Dexie.ignoreTransaction(promiseOrFunction) : promiseOrFunction).timeout(optionalTimeout || 60000);
        return $bc26ee8cec700381$var$PSD.trans ? $bc26ee8cec700381$var$PSD.trans.waitFor(promise) : promise;
    },
    Promise: $bc26ee8cec700381$var$DexiePromise,
    debug: {
        get: function get() {
            return $bc26ee8cec700381$var$debug;
        },
        set: function set(value) {
            $bc26ee8cec700381$var$setDebug(value);
        }
    },
    derive: $bc26ee8cec700381$var$derive,
    extend: $bc26ee8cec700381$var$extend,
    props: $bc26ee8cec700381$var$props,
    override: $bc26ee8cec700381$var$override,
    Events: $bc26ee8cec700381$var$Events,
    on: $bc26ee8cec700381$var$globalEvents,
    liveQuery: $bc26ee8cec700381$export$6a9705d8f6f38796,
    extendObservabilitySet: $bc26ee8cec700381$var$extendObservabilitySet,
    getByKeyPath: $bc26ee8cec700381$var$getByKeyPath,
    setByKeyPath: $bc26ee8cec700381$var$setByKeyPath,
    delByKeyPath: $bc26ee8cec700381$var$delByKeyPath,
    shallowClone: $bc26ee8cec700381$var$shallowClone,
    deepClone: $bc26ee8cec700381$var$deepClone,
    getObjectDiff: $bc26ee8cec700381$var$getObjectDiff,
    cmp: $bc26ee8cec700381$export$6154dcdb7d23e37b,
    asap: $bc26ee8cec700381$var$asap$1,
    minKey: $bc26ee8cec700381$var$minKey,
    addons: [],
    connections: $bc26ee8cec700381$var$connections,
    errnames: $bc26ee8cec700381$var$errnames,
    dependencies: $bc26ee8cec700381$var$domDeps,
    cache: $bc26ee8cec700381$var$cache,
    semVer: $bc26ee8cec700381$var$DEXIE_VERSION,
    version: $bc26ee8cec700381$var$DEXIE_VERSION.split('.').map(function(n) {
        return parseInt(n);
    }).reduce(function(p, c, i) {
        return p + c / Math.pow(10, i * 2);
    })
}));
$bc26ee8cec700381$var$Dexie.maxKey = $bc26ee8cec700381$var$getMaxKey($bc26ee8cec700381$var$Dexie.dependencies.IDBKeyRange);
if (typeof dispatchEvent !== 'undefined' && typeof addEventListener !== 'undefined') {
    $bc26ee8cec700381$var$globalEvents($bc26ee8cec700381$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(updatedParts) {
        if (!$bc26ee8cec700381$var$propagatingLocally) {
            var event_1;
            event_1 = new CustomEvent($bc26ee8cec700381$var$STORAGE_MUTATED_DOM_EVENT_NAME, {
                detail: updatedParts
            });
            $bc26ee8cec700381$var$propagatingLocally = true;
            dispatchEvent(event_1);
            $bc26ee8cec700381$var$propagatingLocally = false;
        }
    });
    addEventListener($bc26ee8cec700381$var$STORAGE_MUTATED_DOM_EVENT_NAME, function(_a) {
        var detail = _a.detail;
        if (!$bc26ee8cec700381$var$propagatingLocally) $bc26ee8cec700381$var$propagateLocally(detail);
    });
}
function $bc26ee8cec700381$var$propagateLocally(updateParts) {
    var wasMe = $bc26ee8cec700381$var$propagatingLocally;
    try {
        $bc26ee8cec700381$var$propagatingLocally = true;
        $bc26ee8cec700381$var$globalEvents.storagemutated.fire(updateParts);
        $bc26ee8cec700381$var$signalSubscribersNow(updateParts, true);
    } finally{
        $bc26ee8cec700381$var$propagatingLocally = wasMe;
    }
}
var $bc26ee8cec700381$var$propagatingLocally = false;
var $bc26ee8cec700381$var$bc;
var $bc26ee8cec700381$var$createBC = function createBC() {};
if (typeof BroadcastChannel !== 'undefined') {
    $bc26ee8cec700381$var$createBC = function createBC() {
        $bc26ee8cec700381$var$bc = new BroadcastChannel($bc26ee8cec700381$var$STORAGE_MUTATED_DOM_EVENT_NAME);
        $bc26ee8cec700381$var$bc.onmessage = function(ev) {
            return ev.data && $bc26ee8cec700381$var$propagateLocally(ev.data);
        };
    };
    $bc26ee8cec700381$var$createBC();
    if (typeof $bc26ee8cec700381$var$bc.unref === 'function') $bc26ee8cec700381$var$bc.unref();
    $bc26ee8cec700381$var$globalEvents($bc26ee8cec700381$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
        if (!$bc26ee8cec700381$var$propagatingLocally) $bc26ee8cec700381$var$bc.postMessage(changedParts);
    });
}
if (typeof addEventListener !== 'undefined') {
    addEventListener('pagehide', function(event) {
        if (!$bc26ee8cec700381$export$4ece27d405df7279.disableBfCache && event.persisted) {
            if ($bc26ee8cec700381$var$debug) console.debug('Dexie: handling persisted pagehide');
            $bc26ee8cec700381$var$bc === null || $bc26ee8cec700381$var$bc === void 0 || $bc26ee8cec700381$var$bc.close();
            for(var _i = 0, connections_1 = $bc26ee8cec700381$var$connections; _i < connections_1.length; _i++){
                var db = connections_1[_i];
                db.close({
                    disableAutoOpen: false
                });
            }
        }
    });
    addEventListener('pageshow', function(event) {
        if (!$bc26ee8cec700381$export$4ece27d405df7279.disableBfCache && event.persisted) {
            if ($bc26ee8cec700381$var$debug) console.debug('Dexie: handling persisted pageshow');
            $bc26ee8cec700381$var$createBC();
            $bc26ee8cec700381$var$propagateLocally({
                all: new $bc26ee8cec700381$export$34cb5241245008dd(-Infinity, [
                    []
                ])
            });
        }
    });
}
function $bc26ee8cec700381$export$e16d8520af44a096(value) {
    return new $bc26ee8cec700381$export$4118fdb20badc28d({
        add: value
    });
}
function $bc26ee8cec700381$export$cd7f480d6b8286c3(value) {
    return new $bc26ee8cec700381$export$4118fdb20badc28d({
        remove: value
    });
}
function $bc26ee8cec700381$export$22ef8700548ec20(a, b) {
    return new $bc26ee8cec700381$export$4118fdb20badc28d({
        replacePrefix: [
            a,
            b
        ]
    });
}
$bc26ee8cec700381$var$DexiePromise.rejectionMapper = $bc26ee8cec700381$var$mapError;
$bc26ee8cec700381$var$setDebug($bc26ee8cec700381$var$debug);



var $b93468b624d05ce0$var$ENTRY_STATUS_NAMES = [
    'unread',
    'starred'
];
(0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline = {
    /** @var Date the datetime of the newest garbage collected entry, i.e. deleted because not of interest. */ newestGCedEntry: null,
    offlineDays: 10,
    lastItemId: null,
    newerEntriesMissing: false,
    shouldLoadEntriesOnline: false,
    olderEntriesOnline: false,
    _tr: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _selfoss_db_storage;
        return (_selfoss_db_storage = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage).transaction.apply(_selfoss_db_storage, (0, $6zk1M._)(args)).catch(function(error) {
            var _selfoss_entries;
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.showError((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app._('error_offline_storage', [
                error.message
            ]));
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.broken = true;
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.enableOffline.update(false);
            (_selfoss_entries = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).entries) === null || _selfoss_entries === void 0 ? void 0 : _selfoss_entries.reload();
            // If this is a QuotaExceededError, garbage collect more
            // entries and hope it helps.
            if (error.name === (0, $bc26ee8cec700381$export$4ece27d405df7279).errnames.QuotaExceeded) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.GCEntries(true);
            return Promise.reject(error);
        });
    },
    init: function() {
        if (!(0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.enableOffline.value || (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage) return;
        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.broken = false;
        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage = new (0, $bc26ee8cec700381$export$4ece27d405df7279)('selfoss');
        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.version(1).stores({
            entries: '&id,*datetime,[datetime+id]',
            statusq: '++id,*entryId',
            stamps: '&name,datetime',
            stats: '&name',
            tags: '&name',
            sources: '&id'
        });
        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.on('populate', function() {
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stats.add({
                name: 'unread',
                value: 0
            });
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stats.add({
                name: 'starred',
                value: 0
            });
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stats.add({
                name: 'total',
                value: 0
            });
        });
        // retrieve last update stats in offline db
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline._tr('r', [
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries,
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stamps
        ], function() {
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline._memLastItemId();
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stamps.get('lastItemsUpdate', function(stamp) {
                if (stamp) {
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.lastUpdate = stamp.datetime;
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.firstSync = false;
                } else (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.shouldLoadEntriesOnline = true;
            });
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stamps.get('newestGCedEntry', function(stamp) {
                if (stamp) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newestGCedEntry = stamp.datetime;
                var limit = new Date(Date.now() - 259200000);
                if (!stamp || (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newestGCedEntry < limit) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newestGCedEntry = new Date(Date.now() - 86400000);
            });
        }).then(function() {
            var offlineDays = window.localStorage.getItem('offlineDays');
            if (offlineDays !== null) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.offlineDays = parseInt(offlineDays);
            // The newest garbage collected entry is either what's already
            // in the offline db or if more recent the entry older than
            // offlineDays ago.
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newestGCedEntry = new Date(Math.max((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newestGCedEntry, Date.now() - (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.offlineDays * 86400000));
            window.addEventListener('online', function() {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.tryOnline();
            });
            window.addEventListener('offline', function() {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.setOffline().catch(function(error) {
                    if (error instanceof (0, $0d06257c362dc1a1$export$1871035840b7f83a)) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.showError((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app._('error_offline_storage_not_available', [
                        '<a href="https://caniuse.com/#feat=indexeddb">',
                        '</a>'
                    ]));
                    else throw error;
                });
            });
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.setOfflineState(false);
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.tryOnline().then(function() {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).reloadTags();
            });
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.reloadOnlineStats();
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.refreshStats();
        }).catch(function() {
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.broken = true;
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.enableOffline.update(false);
        });
    },
    _memLastItemId: function() {
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries.orderBy('id').reverse().first(function(entry) {
            if (entry) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.lastItemId = entry.id;
            else (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.lastItemId = 0;
        });
    },
    storeEntries: function(entries) {
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline._tr('rw', [
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries,
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stamps
        ], function() {
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.GCEntries();
            // store entries offline
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries.bulkPut(entries).then(function() {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline._memLastItemId();
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.refreshStats();
            });
        });
    },
    GCEntries: function() {
        var more = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        if (more) {
            // We need to garbage collect more, as the browser storage limit
            // seems to be exceeded: decrease the amount of days entries are
            // kept offline.
            var keptDays = Math.floor((new Date() - (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newestGCedEntry) / 86400000);
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.offlineDays = Math.max(Math.min(keptDays - 1, (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.offlineDays - 1), 0);
            window.localStorage.setItem('offlineDays', (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.offlineDays);
        }
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.transaction('rw', (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries, (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stamps, function() {
            // cleanup and remember when
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stamps.get('lastCleanup', function(stamp) {
                // Cleanup once a day or once after db reset
                if (!stamp || more || stamp && Date.now() - stamp.datetime > 86400000) {
                    // Cleanup items older than offlineDays days, not of
                    // interest.
                    var limit = new Date(Date.now() - (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.offlineDays * 86400000);
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries.where('datetime').below(limit).filter(function(entry) {
                        return !entry.unread && !entry.starred;
                    }).each(function(entry) {
                        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries.delete(entry.id);
                        if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newestGCedEntry < entry.datetime) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newestGCedEntry = entry.datetime;
                    }).then(function() {
                        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stamps.bulkPut([
                            {
                                name: 'lastCleanup',
                                datetime: new Date()
                            },
                            {
                                name: 'newestGCedEntry',
                                datetime: (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newestGCedEntry
                            }
                        ]);
                    });
                }
            });
        });
    },
    storeStats: function(stats) {
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline._tr('rw', [
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stats
        ], function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(stats)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $21h22._)(_step.value, 2), name = _step_value[0], value = _step_value[1];
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stats.put({
                        name: name,
                        value: value
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
    },
    storeLastUpdate: function(lastUpdate) {
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline._tr('rw', [
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stamps
        ], function() {
            if (lastUpdate) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stamps.put({
                name: 'lastItemsUpdate',
                datetime: lastUpdate
            });
        });
    },
    getEntries: function(fetchParams) {
        var hasMore = false;
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline._tr('r', [
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries
        ], function() {
            var howMany = 0;
            var ascOrder = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).config.unreadOrder === 'asc' && fetchParams.type === (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).UNREAD;
            var entries = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries.orderBy('[datetime+id]');
            if (!ascOrder) entries = entries.reverse();
            var fromDatetime = fetchParams.fromDatetime;
            var fromId = fetchParams.fromId;
            var seek = fromDatetime && fromId;
            var alwaysInDb = fetchParams.type === (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).STARRED || fetchParams.type === (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).UNREAD;
            return entries.filter(function(entry) {
                var keepEntry = false;
                if (fetchParams.extraIds.includes(entry.id)) return true;
                if (fetchParams.type === (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).STARRED) keepEntry = entry.starred;
                else if (fetchParams.type === (0, $c311f30f92964d8a$export$c67e46de1ec7dfa6).UNREAD) keepEntry = entry.unread;
                else keepEntry = true;
                // seek pagination
                if (seek) {
                    if (ascOrder) keepEntry && (keepEntry = entry.datetime > fromDatetime || entry.datetime.getTime() == fromDatetime.getTime() && entry.id > fromId);
                    else keepEntry && (keepEntry = entry.datetime < fromDatetime || entry.datetime.getTime() == fromDatetime.getTime() && entry.id < fromId);
                }
                return keepEntry;
            }).until(function(entry) {
                howMany += 1;
                if (!ascOrder && !alwaysInDb && entry.datetime < (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.newestGCedEntry) {
                    // the offline db is missing older entries, the next
                    // seek will have to find them online.
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.olderEntriesOnline = true;
                    hasMore = true;
                    return true; // stop iteration
                }
                // stop iteration if enough entries have been shown
                // go one further to assess if has more
                if (howMany >= (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).config.itemsPerPage + 1) {
                    hasMore = true;
                    return true;
                }
                return false;
            });
        }).then(function(entriesCollection) {
            return entriesCollection.toArray();
        }).then(function(entries) {
            return {
                entries: entries,
                hasMore: hasMore
            };
        });
    },
    reloadOnlineStats: function() {
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline._tr('r', [
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stats
        ], function() {
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stats.toArray(function(stats) {
                var newStats = {};
                stats.forEach(function(stat) {
                    newStats[stat.name] = stat.value;
                });
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).refreshStats(newStats.total, newStats.unread, newStats.starred);
            });
        });
    },
    refreshStats: function() {
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline._tr('r', [
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries
        ], function() {
            var offlineCounts = {
                newest: 0,
                unread: 0,
                starred: 0
            };
            // IDBKeyRange does not support boolean indexes, so we need to
            // iterate over all the entries.
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries.each(function(entry) {
                offlineCounts.newest = offlineCounts.newest + 1;
                if (entry.unread) offlineCounts.unread = offlineCounts.unread + 1;
                if (entry.starred) offlineCounts.starred = offlineCounts.starred + 1;
            }).then(function() {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.refreshOfflineCounts(offlineCounts);
            });
        });
    },
    enqueueStatuses: function(statuses) {
        if (statuses) (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.needsSync = true;
        var d = new Date();
        var newQueuedStatuses = statuses.map(function(newStatus) {
            return {
                entryId: parseInt(newStatus.entryId),
                name: newStatus.name,
                value: newStatus.value,
                datetime: d
            };
        });
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline._tr('rw', [
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.statusq
        ], function() {
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.statusq.bulkAdd(newQueuedStatuses);
        });
    },
    enqueueStatus: function(entryId, statusName, statusValue) {
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.enqueueStatuses([
            {
                entryId: entryId,
                name: statusName,
                value: statusValue
            }
        ]);
    },
    sendNewStatuses: function() {
        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.statusq.toArray().then(function(statuses) {
            return statuses.map(function(s) {
                var statusUpdate = {
                    id: s.entryId,
                    datetime: s.datetime
                };
                statusUpdate[s.name] = s.value;
                return statusUpdate;
            });
        }).then(function(statuses) {
            var s = statuses.length > 0 ? statuses : undefined;
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.sync(s, true).then(function() {
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.needsSync = false;
            });
        });
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline._syncBegin();
    },
    storeEntryStatuses: function(itemStatuses) {
        var dequeue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, updateStats = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline._tr('rw', [
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries,
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stats,
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.statusq
        ], function() {
            var statsDiff = {};
            // update entries statuses
            itemStatuses.forEach(function(itemStatus) {
                var newStatus = {};
                $b93468b624d05ce0$var$ENTRY_STATUS_NAMES.forEach(function(statusName) {
                    if (statusName in itemStatus) {
                        statsDiff[statusName] = 0;
                        newStatus[statusName] = itemStatus[statusName];
                        if (updateStats) {
                            if (itemStatus[statusName]) statsDiff[statusName]++;
                            else statsDiff[statusName]--;
                        }
                    }
                });
                var id = parseInt(itemStatus.id);
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries.get(id).then(function() {
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.entries.update(id, newStatus);
                }, function() {
                    // the key was not found, the status of an entry
                    // missing in db was updated, request sync.
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.needsSync = true;
                });
                if (dequeue) // status update from server, remove from status queue
                (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.statusq.where('entryId').equals(id).delete();
            });
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (updateStats) try {
                var _loop = function() {
                    var _step_value = (0, $21h22._)(_step.value, 2), name = _step_value[0], value = _step_value[1];
                    (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stats.get(name, function(stat) {
                        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.stats.put({
                            name: name,
                            value: stat.value + value
                        });
                    });
                };
                for(var _iterator = Object.entries(statsDiff)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }).then((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.refreshStats);
    },
    entriesMark: function(itemIds, unread) {
        (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.statsDirty = true;
        var newStatuses = itemIds.map(function(itemId) {
            return {
                id: itemId,
                unread: unread
            };
        });
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.storeEntryStatuses(newStatuses);
    },
    entryMark: function(itemId, unread) {
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.entriesMark([
            itemId
        ], unread);
    },
    entryStar: function(itemId, starred) {
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.storeEntryStatuses([
            {
                id: itemId,
                starred: starred
            }
        ]);
    }
};


/**
 * db functions: client data repository (and offline storage)
 *
 * db is a dispatcher class and holds the logic for deciding whether selfoss
 * is running online with access to the server or offline.
 *
 * dbOnline contains AJAX calls that provide access to the server db.
 *
 * dbOffline is the entry point for the offline database held in the client.
 */ 


(0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db = {
    /** When an error occurs we disable the offline mode and mark the database as broken so it can be retried. */ broken: false,
    storage: null,
    online: true,
    enableOffline: new (0, $e721f0b5888adce1$export$8fa6ce44b7b131e9)(window.localStorage.getItem('enableOffline') === 'true'),
    userWaiting: true,
    /**
     * last db timestamp known client side
     */ lastUpdate: null,
    setOnline: function() {
        if (!(0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.online) {
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.online = true;
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.sync();
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).reloadTags();
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.setOfflineState(false);
        }
    },
    tryOnline: function() {
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.sync(true);
    },
    setOffline: function() {
        if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage && !(0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.broken) {
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline._syncDone(false);
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.online = false;
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.setOfflineState(true);
            return Promise.resolve();
        } else {
            var err = new (0, $0d06257c362dc1a1$export$1871035840b7f83a)();
            return Promise.reject(err);
        }
    },
    clear: function() {
        if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage) {
            window.localStorage.removeItem('offlineDays');
            var clearing = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage.delete();
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.storage = null;
            (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.lastUpdate = null;
            return clearing;
        } else return Promise.resolve();
    },
    isValidTag: function(name) {
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.state.tags.length === 0 || (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.state.tags.find(function(tag) {
            return tag.tag === name;
        }) !== undefined;
    },
    isValidSource: function(id) {
        return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.state.sources.length === 0 || (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).app.state.sources.find(function(source) {
            return source.id === id;
        }) !== undefined;
    },
    lastSync: null,
    sync: function() {
        var force = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var lastUpdateIsOld = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.lastUpdate === null || (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.lastSync === null || Date.now() - (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.lastSync > 300000;
        var shouldSync = force || (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.needsSync || lastUpdateIsOld;
        if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).isAllowedToRead() && (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).isOnline() && shouldSync) {
            if ((0, $b40329ab00dcedb3$export$2e2bcd8739ae039).db.enableOffline.value) return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOffline.sendNewStatuses();
            else return (0, $b40329ab00dcedb3$export$2e2bcd8739ae039).dbOnline.sync();
        } else return Promise.resolve(); // ensure any chained function runs
    }
};


(0, $b40329ab00dcedb3$export$2e2bcd8739ae039).init();
// make selfoss available in console for debugging
window.selfoss = (0, $b40329ab00dcedb3$export$2e2bcd8739ae039);

})();
//# sourceMappingURL=client.5319a950.js.map
